/* tslint:disable */
export const iconList = [
  {
    id: "4F013652-22DE-48CF-886B-A0FB995E8B41",
    name: "access-point",
    codepoint: "F002",
    aliases: ["wireless"],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M4.93,4.93C3.12,6.74 2,9.24 2,12C2,14.76 3.12,17.26 4.93,19.07L6.34,17.66C4.89,16.22 4,14.22 4,12C4,9.79 4.89,7.78 6.34,6.34L4.93,4.93M19.07,4.93L17.66,6.34C19.11,7.78 20,9.79 20,12C20,14.22 19.11,16.22 17.66,17.66L19.07,19.07C20.88,17.26 22,14.76 22,12C22,9.24 20.88,6.74 19.07,4.93M7.76,7.76C6.67,8.85 6,10.35 6,12C6,13.65 6.67,15.15 7.76,16.24L9.17,14.83C8.45,14.11 8,13.11 8,12C8,10.89 8.45,9.89 9.17,9.17L7.76,7.76M16.24,7.76L14.83,9.17C15.55,9.89 16,10.89 16,12C16,13.11 15.55,14.11 14.83,14.83L16.24,16.24C17.33,15.15 18,13.65 18,12C18,10.35 17.33,8.85 16.24,7.76M12,10C10.9,10 10,10.9 10,12C10,13.1 10.9,14 12,14C13.1,14 14,13.1 14,12C14,10.9 13.1,10 12,10Z",
  },
  {
    id: "06048943-9EE5-4FE2-91D7-7DA162E55203",
    name: "access-point-network",
    codepoint: "F003",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M4.93,2.93C3.12,4.74 2,7.24 2,10C2,12.76 3.12,15.26 4.93,17.07L6.34,15.66C4.89,14.22 4,12.22 4,10C4,7.79 4.89,5.78 6.34,4.34L4.93,2.93M19.07,2.93L17.66,4.34C19.11,5.78 20,7.79 20,10C20,12.22 19.11,14.22 17.66,15.66L19.07,17.07C20.88,15.26 22,12.76 22,10C22,7.24 20.88,4.74 19.07,2.93M7.76,5.76C6.67,6.85 6,8.35 6,10C6,11.65 6.67,13.15 7.76,14.24L9.17,12.83C8.45,12.11 8,11.11 8,10C8,8.89 8.45,7.89 9.17,7.17L7.76,5.76M16.24,5.76L14.83,7.17C15.55,7.89 16,8.89 16,10C16,11.11 15.55,12.11 14.83,12.83L16.24,14.24C17.33,13.15 18,11.65 18,10C18,8.35 17.33,6.85 16.24,5.76M12,8C10.9,8 10,8.9 10,10C10,11.1 10.9,12 12,12C13.1,12 14,11.1 14,10C14,8.9 13.1,8 12,8M11,14V18H10C9.45,18 9,18.45 9,19H2V21H9C9,21.55 9.45,22 10,22H14C14.55,22 15,21.55 15,21H22V19H15C15,18.45 14.55,18 14,18H13V14H11Z",
  },
  {
    id: "E76EC23F-AB71-49B3-9173-841544527A20",
    name: "account",
    codepoint: "F004",
    aliases: ["person", "user"],
    tags: ["Account / User", "Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M12,4C14.21,4 16,5.79 16,8C16,10.21 14.21,12 12,12C9.79,12 8,10.21 8,8C8,5.79 9.79,4 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z",
  },
  {
    id: "3D869F3A-8C3E-4ECB-829E-7785230FA680",
    name: "account-alert",
    codepoint: "F005",
    aliases: ["user-alert", "account-warning", "user-warning"],
    tags: ["Account / User"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M10,4C12.21,4 14,5.79 14,8C14,10.21 12.21,12 10,12C7.79,12 6,10.21 6,8C6,5.79 7.79,4 10,4M10,14C14.42,14 18,15.79 18,18V20H2V18C2,15.79 5.58,14 10,14M20,12V7H22V12H20M20,16V14H22V16H20Z",
  },
  {
    id: "474D0A31-E56A-4780-9417-DCF8D9A38830",
    name: "account-box",
    codepoint: "F006",
    aliases: ["selfie", "user-box"],
    tags: ["Account / User"],
    author: "Google",
    version: "1.5.54",
    path: "M6,17C6,15 10,13.9 12,13.9C14,13.9 18,15 18,17V18H6M15,9C15,10.66 13.66,12 12,12C10.34,12 9,10.66 9,9C9,7.34 10.34,6 12,6C13.66,6 15,7.34 15,9M3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3H5C3.89,3 3,3.9 3,5Z",
  },
  {
    id: "D612088F-9D2A-424A-9403-046993A3EB14",
    name: "account-box-multiple",
    codepoint: "F933",
    aliases: ["switch-account", "user-box-multiple"],
    tags: [],
    author: "Google",
    version: "2.4.85",
    path: "M4,6H2V20C2,21.1 2.9,22 4,22H18V20H4V6M20,2C21.1,2 22,2.9 22,4V16C22,17.1 21.1,18 20,18H8C6.9,18 6,17.1 6,16V4C6,2.9 6.9,2 8,2H20M17,7C17,5.34 15.66,4 14,4C12.34,4 11,5.34 11,7C11,8.66 12.34,10 14,10C15.66,10 17,8.66 17,7M8,15V16H20V15C20,13 16,11.9 14,11.9C12,11.9 8,13 8,15Z",
  },
  {
    id: "537261C5-1AF6-478F-A8BA-4349865D9C1C",
    name: "account-box-outline",
    codepoint: "F007",
    aliases: ["selfie-outline", "user-box-outline", "portrait"],
    tags: ["Account / User"],
    author: "Google",
    version: "1.5.54",
    path: "M19,19H5V5H19M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3M16.5,16.25C16.5,14.75 13.5,14 12,14C10.5,14 7.5,14.75 7.5,16.25V17H16.5M12,12.25C13.24,12.25 14.25,11.24 14.25,10C14.25,8.76 13.24,7.75 12,7.75C10.76,7.75 9.75,8.76 9.75,10C9.75,11.24 10.76,12.25 12,12.25Z",
  },
  {
    id: "F3C76352-A033-4969-BBC4-99E2BEE84FAE",
    name: "account-check",
    codepoint: "F008",
    aliases: ["user-check"],
    tags: ["Account / User"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M9,5C10.93,5 12.5,6.57 12.5,8.5C12.5,10.43 10.93,12 9,12C7.07,12 5.5,10.43 5.5,8.5C5.5,6.57 7.07,5 9,5M9,13.75C12.87,13.75 16,15.32 16,17.25V19H2V17.25C2,15.32 5.13,13.75 9,13.75M17,12.66L14.25,9.66L15.41,8.5L17,10.09L20.59,6.5L21.75,7.91L17,12.66Z",
  },
  {
    id: "1D7E8F31-998D-442A-80E6-EBB8DFA8CBA2",
    name: "account-circle",
    codepoint: "F009",
    aliases: ["user-circle"],
    tags: ["Account / User"],
    author: "Google",
    version: "1.5.54",
    path: "M12,19.2C9.5,19.2 7.29,17.92 6,16C6.03,14 10,12.9 12,12.9C14,12.9 17.97,14 18,16C16.71,17.92 14.5,19.2 12,19.2M12,5C13.66,5 15,6.34 15,8C15,9.66 13.66,11 12,11C10.34,11 9,9.66 9,8C9,6.34 10.34,5 12,5M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.47 17.5,2 12,2Z",
  },
  {
    id: "A6964E10-1CF0-41FA-BDCA-A77C9C6F30AF",
    name: "account-convert",
    codepoint: "F00A",
    aliases: ["user-convert"],
    tags: ["Account / User"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M7.5,21.5L8.85,20.16L12.66,23.97L12,24C5.71,24 0.56,19.16 0.05,13H1.55C1.91,16.76 4.25,19.94 7.5,21.5M16.5,2.5L15.15,3.84L11.34,0.03L12,0C18.29,0 23.44,4.84 23.95,11H22.45C22.09,7.24 19.75,4.07 16.5,2.5M6,17C6,15 10,13.9 12,13.9C14,13.9 18,15 18,17V18H6V17M15,9C15,10.66 13.66,12 12,12C10.34,12 9,10.66 9,9C9,7.34 10.34,6 12,6C13.66,6 15,7.34 15,9Z",
  },
  {
    id: "66271DF7-FF11-4998-9C03-F096CE407E4C",
    name: "account-edit",
    codepoint: "F6BB",
    aliases: ["user-edit"],
    tags: ["Account / User"],
    author: "Michael Richins",
    version: "1.8.36",
    path: "M21.7,13.35L20.7,14.35L18.65,12.3L19.65,11.3C19.86,11.09 20.21,11.09 20.42,11.3L21.7,12.58C21.91,12.79 21.91,13.14 21.7,13.35M12,18.94L18.06,12.88L20.11,14.93L14.06,21H12V18.94M12,14C7.58,14 4,15.79 4,18V20H10V18.11L14,14.11C13.34,14.03 12.67,14 12,14M12,4C9.79,4 8,5.79 8,8C8,10.21 9.79,12 12,12C14.21,12 16,10.21 16,8C16,5.79 14.21,4 12,4Z",
  },
  {
    id: "7B8F1133-B47B-46C0-AAC0-FD87F06B038D",
    name: "account-group",
    codepoint: "F848",
    aliases: ["user-group"],
    tags: ["Account / User"],
    author: "GreenTurtwig",
    version: "2.1.99",
    path: "M12,6C10.34,6 9,7.34 9,9C9,10.66 10.34,12 12,12C13.66,12 15,10.66 15,9C15,7.34 13.66,6 12,6M6,8.17C4.62,8.17 3.5,9.29 3.5,10.67C3.5,12.05 4.62,13.17 6,13.17C6.88,13.17 7.65,12.71 8.09,12.03C7.42,11.18 7,10.15 7,9C7,8.8 7,8.6 7.04,8.4C6.72,8.25 6.37,8.17 6,8.17M18,8.17C17.63,8.17 17.28,8.25 16.96,8.4C17,8.6 17,8.8 17,9C17,10.15 16.58,11.18 15.91,12.03C16.35,12.71 17.12,13.17 18,13.17C19.38,13.17 20.5,12.05 20.5,10.67C20.5,9.29 19.38,8.17 18,8.17M12,14C10,14 6,15 6,17V19H18V17C18,15 14,14 12,14M4.67,14.97C3,15.26 1,16.04 1,17.33V19H4V17C4,16.22 4.29,15.53 4.67,14.97M19.33,14.97C19.71,15.53 20,16.22 20,17V19H23V17.33C23,16.04 21,15.26 19.33,14.97Z",
  },
  {
    id: "15C54239-5327-4962-95CD-721512C6B27F",
    name: "account-heart",
    codepoint: "F898",
    aliases: ["user-heart"],
    tags: ["Account / User"],
    author: "Michael Irigoyen",
    version: "2.2.43",
    path: "M15,14C12.3,14 7,15.3 7,18V20H23V18C23,15.3 17.7,14 15,14M15,12C17.21,12 19,10.21 19,8C19,5.79 17.21,4 15,4C12.79,4 11,5.79 11,8C11,10.21 12.79,12 15,12M5,15L4.4,14.5C2.4,12.6 1,11.4 1,9.9C1,8.7 2,7.7 3.2,7.7C3.9,7.7 4.6,8 5,8.5C5.4,8 6.1,7.7 6.8,7.7C8,7.7 9,8.6 9,9.9C9,11.4 7.6,12.6 5.6,14.5L5,15Z",
  },
  {
    id: "645E04E6-A328-45DD-9B22-03E2296837B1",
    name: "account-key",
    codepoint: "F00B",
    aliases: ["user-key"],
    tags: ["Account / User"],
    author: "REJack",
    version: "1.5.54",
    path: "M11,10V12H10V14H8V12H5.83C5.42,13.17 4.31,14 3,14C1.34,14 0,12.66 0,11C0,9.34 1.34,8 3,8C4.31,8 5.42,8.83 5.83,10H11M3,10C2.45,10 2,10.45 2,11C2,11.55 2.45,12 3,12C3.55,12 4,11.55 4,11C4,10.45 3.55,10 3,10M16,14C18.67,14 24,15.34 24,18V20H8V18C8,15.34 13.33,14 16,14M16,12C13.79,12 12,10.21 12,8C12,5.79 13.79,4 16,4C18.21,4 20,5.79 20,8C20,10.21 18.21,12 16,12Z",
  },
  {
    id: "9CF96408-1A24-4040-AD04-011183CC9ABC",
    name: "account-minus",
    codepoint: "F00D",
    aliases: ["user-minus"],
    tags: ["Account / User"],
    author: "REJack",
    version: "1.5.54",
    path: "M15,14C12.33,14 7,15.33 7,18V20H23V18C23,15.33 17.67,14 15,14M1,10V12H9V10M15,12C17.21,12 19,10.21 19,8C19,5.79 17.21,4 15,4C12.79,4 11,5.79 11,8C11,10.21 12.79,12 15,12Z",
  },
  {
    id: "A8C2EE6C-31B9-4D51-B941-8128FDD77A96",
    name: "account-multiple",
    codepoint: "F00E",
    aliases: ["people", "user-multiple", "group"],
    tags: ["Account / User"],
    author: "Google",
    version: "1.5.54",
    path: "M16,13C15.71,13 15.38,13 15.03,13.05C16.19,13.89 17,15 17,16.5V19H23V16.5C23,14.17 18.33,13 16,13M8,13C5.67,13 1,14.17 1,16.5V19H15V16.5C15,14.17 10.33,13 8,13M8,11C9.66,11 11,9.66 11,8C11,6.34 9.66,5 8,5C6.34,5 5,6.34 5,8C5,9.66 6.34,11 8,11M16,11C17.66,11 19,9.66 19,8C19,6.34 17.66,5 16,5C14.34,5 13,6.34 13,8C13,9.66 14.34,11 16,11Z",
  },
  {
    id: "3B3E2DF7-1E21-476A-8473-7F1EAA514D1F",
    name: "account-multiple-check",
    codepoint: "F8C4",
    aliases: ["user-multiple-check"],
    tags: ["Account / User"],
    author: "Roberto Graham",
    version: "2.3.50",
    path: "M22.59,7.92L23.75,9.33L19,14.08L16.25,11.08L17.41,9.92L19,11.5L22.59,7.92M6,5C7.66,5 9,6.34 9,8C9,9.66 7.66,11 6,11C4.34,11 3,9.66 3,8C3,6.34 4.34,5 6,5M11,5C12.66,5 14,6.34 14,8C14,9.66 12.66,11 11,11C10.68,11 10.37,10.95 10.08,10.85C10.65,10.04 11,9.06 11,8C11,6.94 10.65,5.95 10.08,5.14C10.37,5.05 10.68,5 11,5M6,13C8,13 12,14 12,16V18H0V16C0,14 4,13 6,13M12.62,13.16C14.63,13.5 17,14.46 17,16V18H14V16C14,14.82 13.45,13.88 12.62,13.16Z",
  },
  {
    id: "BD31FA9F-EC76-44E9-A9F3-A85F83045D78",
    name: "account-multiple-minus",
    codepoint: "F5D3",
    aliases: ["user-multiple-minus"],
    tags: ["Account / User"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M13,13C11,13 7,14 7,16V18H19V16C19,14 15,13 13,13M19.62,13.16C20.45,13.88 21,14.82 21,16V18H24V16C24,14.46 21.63,13.5 19.62,13.16M13,11C14.66,11 16,9.66 16,8C16,6.34 14.66,5 13,5C11.34,5 10,6.34 10,8C10,9.66 11.34,11 13,11M18,11C19.66,11 21,9.66 21,8C21,6.34 19.66,5 18,5C17.68,5 17.37,5.05 17.08,5.14C17.65,5.95 18,6.94 18,8C18,9.06 17.65,10.04 17.08,10.85C17.37,10.95 17.68,11 18,11M8,10H0V12H8V10Z",
  },
  {
    id: "30C6B7FE-4496-4961-B36F-E0FBC4F2696E",
    name: "account-multiple-outline",
    codepoint: "F00F",
    aliases: ["user-multiple-outline", "people-outline"],
    tags: ["Account / User"],
    author: "Google",
    version: "1.5.54",
    path: "M16.5,6.5C17.6,6.5 18.5,7.4 18.5,8.5C18.5,9.6 17.6,10.5 16.5,10.5C15.4,10.5 14.5,9.6 14.5,8.5C14.5,7.4 15.4,6.5 16.5,6.5M16.5,12C18.43,12 20,10.43 20,8.5C20,6.57 18.43,5 16.5,5C14.57,5 13,6.57 13,8.5C13,10.43 14.57,12 16.5,12M7.5,6.5C8.6,6.5 9.5,7.4 9.5,8.5C9.5,9.6 8.6,10.5 7.5,10.5C6.4,10.5 5.5,9.6 5.5,8.5C5.5,7.4 6.4,6.5 7.5,6.5M7.5,12C9.43,12 11,10.43 11,8.5C11,6.57 9.43,5 7.5,5C5.57,5 4,6.57 4,8.5C4,10.43 5.57,12 7.5,12M21.5,17.5H14V16.25C14,15.79 13.8,15.39 13.5,15.03C14.36,14.73 15.44,14.5 16.5,14.5C18.94,14.5 21.5,15.71 21.5,16.25M12.5,17.5H2.5V16.25C2.5,15.71 5.06,14.5 7.5,14.5C9.94,14.5 12.5,15.71 12.5,16.25M16.5,13C15.3,13 13.43,13.34 12,14C10.57,13.33 8.7,13 7.5,13C5.33,13 1,14.08 1,16.25V19H23V16.25C23,14.08 18.67,13 16.5,13Z",
  },
  {
    id: "047F8AC1-524D-4077-BCEB-434FE1C50C8B",
    name: "account-multiple-plus",
    codepoint: "F010",
    aliases: ["user-multiple-plus", "group-add"],
    tags: ["Account / User"],
    author: "Google",
    version: "1.5.54",
    path: "M13,13C11,13 7,14 7,16V18H19V16C19,14 15,13 13,13M19.62,13.16C20.45,13.88 21,14.82 21,16V18H24V16C24,14.46 21.63,13.5 19.62,13.16M13,11C14.66,11 16,9.66 16,8C16,6.34 14.66,5 13,5C11.34,5 10,6.34 10,8C10,9.66 11.34,11 13,11M18,11C19.66,11 21,9.66 21,8C21,6.34 19.66,5 18,5C17.68,5 17.37,5.05 17.08,5.14C17.65,5.95 18,6.94 18,8C18,9.06 17.65,10.04 17.08,10.85C17.37,10.95 17.68,11 18,11M8,10H5V7H3V10H0V12H3V15H5V12H8V10Z",
  },
  {
    id: "AFF0AB6B-616A-4C18-8E28-EE8067224EED",
    name: "account-multiple-plus-outline",
    codepoint: "F7FF",
    aliases: ["group-add-outline", "user-multiple-plus-outline"],
    tags: ["Account / User"],
    author: "GreenTurtwig",
    version: "2.1.19",
    path: "M13.5,5C11.57,5 10,6.57 10,8.5C10,10.43 11.57,12 13.5,12C14.25,12 14.94,11.76 15.5,11.36C16.07,11.76 16.76,12 17.5,12C19.43,12 21,10.43 21,8.5C21,6.57 19.43,5 17.5,5C16.76,5 16.08,5.25 15.5,5.65C14.95,5.24 14.25,5 13.5,5M13.5,6.5C14.6,6.5 15.5,7.4 15.5,8.5C15.5,9.6 14.6,10.5 13.5,10.5C12.4,10.5 11.5,9.6 11.5,8.5C11.5,7.4 12.4,6.5 13.5,6.5M17.5,6.5C18.6,6.5 19.5,7.4 19.5,8.5C19.5,9.6 18.6,10.5 17.5,10.5C17.14,10.5 16.81,10.4 16.5,10.23C16.82,9.72 17,9.13 17,8.5C17,7.87 16.82,7.28 16.5,6.77C16.81,6.6 17.14,6.5 17.5,6.5M3,8V11H0V13H3V16H5V13H8V11H5V8H3M13.5,13C11.33,13 7,14.08 7,16.25V19H24V16.25C24,14.08 19.67,13 17.5,13C16.95,13 16.25,13.08 15.5,13.22C14.78,13.08 14.07,13 13.5,13M13.5,14.5C15.94,14.5 18.5,15.71 18.5,16.25V17.5H8.5V16.25C8.5,15.71 11.06,14.5 13.5,14.5M19.08,14.66C20.93,15 22.5,15.83 22.5,16.25V17.5H20V16.25C20,15.63 19.64,15.1 19.08,14.66Z",
  },
  {
    id: "8F49C741-4ED8-4DD3-A22E-310C039EDDA6",
    name: "account-network",
    codepoint: "F011",
    aliases: ["user-network"],
    tags: ["Account / User"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M13,16V18H14C14.55,18 15,18.45 15,19H22V21H15C15,21.55 14.55,22 14,22H10C9.45,22 9,21.55 9,21H2V19H9C9,18.45 9.45,18 10,18H11V16H5V14.5C5,12.57 8.13,11 12,11C15.87,11 19,12.57 19,14.5V16H13M12,2C13.93,2 15.5,3.57 15.5,5.5C15.5,7.43 13.93,9 12,9C10.07,9 8.5,7.43 8.5,5.5C8.5,3.57 10.07,2 12,2Z",
  },
  {
    id: "2306EFC9-3375-4D03-A631-A32BD72075EC",
    name: "account-off",
    codepoint: "F012",
    aliases: ["user-off"],
    tags: ["Account / User"],
    author: "Cody",
    version: "1.5.54",
    path: "M12,4C14.21,4 16,5.79 16,8C16,9.95 14.6,11.58 12.75,11.93L8.07,7.25C8.42,5.4 10.05,4 12,4M12.28,14L18.28,20L20,21.72L18.73,23L15.73,20H4V18C4,16.16 6.5,14.61 9.87,14.14L2.78,7.05L4.05,5.78L12.28,14M20,18V19.18L15.14,14.32C18,14.93 20,16.35 20,18Z",
  },
  {
    id: "79ECAAC6-71DC-406C-A9B7-57C5F0BAA9E0",
    name: "account-outline",
    codepoint: "F013",
    aliases: ["user-outline", "perm-identity", "person-outline"],
    tags: ["Account / User"],
    author: "Google",
    version: "1.5.54",
    path: "M12,13C9.33,13 4,14.33 4,17V20H20V17C20,14.33 14.67,13 12,13M12,4C9.79,4 8,5.79 8,8C8,10.21 9.79,12 12,12C14.21,12 16,10.21 16,8C16,5.79 14.21,4 12,4M12,14.9C14.97,14.9 18.1,16.36 18.1,17V18.1H5.9V17C5.9,16.36 9,14.9 12,14.9M12,5.9C13.16,5.9 14.1,6.84 14.1,8C14.1,9.16 13.16,10.1 12,10.1C10.84,10.1 9.9,9.16 9.9,8C9.9,6.84 10.84,5.9 12,5.9Z",
  },
  {
    id: "66556BA4-6B65-4ED9-B813-AD33CA8C2CCF",
    name: "account-plus",
    codepoint: "F014",
    aliases: ["register", "user-plus", "person-add"],
    tags: ["Account / User", "Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M15,14C12.33,14 7,15.33 7,18V20H23V18C23,15.33 17.67,14 15,14M6,10V7H4V10H1V12H4V15H6V12H9V10M15,12C17.21,12 19,10.21 19,8C19,5.79 17.21,4 15,4C12.79,4 11,5.79 11,8C11,10.21 12.79,12 15,12Z",
  },
  {
    id: "1095C7C6-C264-4415-BD6D-A2078242477E",
    name: "account-plus-outline",
    codepoint: "F800",
    aliases: ["person-add-outline", "register-outline", "user-plus-outline"],
    tags: ["Account / User"],
    author: "GreenTurtwig",
    version: "2.1.19",
    path: "M15,4C12.79,4 11,5.79 11,8C11,10.21 12.79,12 15,12C17.21,12 19,10.21 19,8C19,5.79 17.21,4 15,4M15,5.9C16.16,5.9 17.1,6.84 17.1,8C17.1,9.16 16.16,10.1 15,10.1C13.84,10.1 12.9,9.16 12.9,8C12.9,6.84 13.84,5.9 15,5.9M4,7V10H1V12H4V15H6V12H9V10H6V7H4M15,13C12.33,13 7,14.33 7,17V20H23V17C23,14.33 17.67,13 15,13M15,14.9C17.97,14.9 21.1,16.36 21.1,17V18.1H8.9V17C8.9,16.36 12,14.9 15,14.9Z",
  },
  {
    id: "0A1FDBBB-9E1C-480E-BC1D-725778D0851B",
    name: "account-remove",
    codepoint: "F015",
    aliases: ["user-remove"],
    tags: ["Account / User"],
    author: "REJack",
    version: "1.5.54",
    path: "M15,14C17.67,14 23,15.33 23,18V20H7V18C7,15.33 12.33,14 15,14M15,12C12.79,12 11,10.21 11,8C11,5.79 12.79,4 15,4C17.21,4 19,5.79 19,8C19,10.21 17.21,12 15,12M5,9.59L7.12,7.46L8.54,8.88L6.41,11L8.54,13.12L7.12,14.54L5,12.41L2.88,14.54L1.46,13.12L3.59,11L1.46,8.88L2.88,7.46L5,9.59Z",
  },
  {
    id: "48E9C474-C544-4868-9966-C3A8D7808FCA",
    name: "account-search",
    codepoint: "F016",
    aliases: ["user-search"],
    tags: ["Account / User"],
    author: "GreenTurtwig",
    version: "1.5.54",
    path: "M15.5,12C18,12 20,14 20,16.5C20,17.38 19.75,18.21 19.31,18.9L22.39,22L21,23.39L17.88,20.32C17.19,20.75 16.37,21 15.5,21C13,21 11,19 11,16.5C11,14 13,12 15.5,12M15.5,14C14.12,14 13,15.12 13,16.5C13,17.88 14.12,19 15.5,19C16.88,19 18,17.88 18,16.5C18,15.12 16.88,14 15.5,14M10,4C12.21,4 14,5.79 14,8C14,8.91 13.69,9.75 13.18,10.43C12.32,10.75 11.55,11.26 10.91,11.9L10,12C7.79,12 6,10.21 6,8C6,5.79 7.79,4 10,4M2,20V18C2,15.88 5.31,14.14 9.5,14C9.18,14.78 9,15.62 9,16.5C9,17.79 9.38,19 10,20H2Z",
  },
  {
    id: "F6808872-4EB9-43AF-BD74-BDA6861E1862",
    name: "account-search-outline",
    codepoint: "F934",
    aliases: ["user-search-outline"],
    tags: ["Account / User"],
    author: "GreenTurtwig",
    version: "2.4.85",
    path: "M10,13C9.65,13.59 9.36,14.24 9.19,14.93C6.5,15.16 3.9,16.42 3.9,17V18.1H9.2C9.37,18.78 9.65,19.42 10,20H2V17C2,14.34 7.33,13 10,13M10,4C12.21,4 14,5.79 14,8C14,8.91 13.69,9.75 13.18,10.43C12.32,10.75 11.55,11.26 10.91,11.9L10,12C7.79,12 6,10.21 6,8C6,5.79 7.79,4 10,4M10,5.9C8.84,5.9 7.9,6.84 7.9,8C7.9,9.16 8.84,10.1 10,10.1C11.16,10.1 12.1,9.16 12.1,8C12.1,6.84 11.16,5.9 10,5.9M15.5,12C18,12 20,14 20,16.5C20,17.38 19.75,18.21 19.31,18.9L22.39,22L21,23.39L17.88,20.32C17.19,20.75 16.37,21 15.5,21C13,21 11,19 11,16.5C11,14 13,12 15.5,12M15.5,14C14.12,14 13,15.12 13,16.5C13,17.88 14.12,19 15.5,19C16.88,19 18,17.88 18,16.5C18,15.12 16.88,14 15.5,14Z",
  },
  {
    id: "A975CEEA-FDFD-49A2-A618-E74A3FF87A63",
    name: "account-settings",
    codepoint: "F630",
    aliases: ["user-settings"],
    tags: ["Account / User", "Settings"],
    author: "Austin Andrews",
    version: "1.6.50",
    path: "M12,4C14.21,4 16,5.79 16,8C16,10.21 14.21,12 12,12C9.79,12 8,10.21 8,8C8,5.79 9.79,4 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14M7,22H9V24H7V22M11,22H13V24H11V22M15,22H17V24H15V22Z",
  },
  {
    id: "1E04960E-FFFE-439D-A5FD-C51E7291DA6F",
    name: "account-star",
    codepoint: "F017",
    aliases: ["user-star"],
    tags: ["Account / User"],
    author: "REJack",
    version: "1.5.54",
    path: "M15,14C12.33,14 7,15.33 7,18V20H23V18C23,15.33 17.67,14 15,14M15,12C17.21,12 19,10.21 19,8C19,5.79 17.21,4 15,4C12.79,4 11,5.79 11,8C11,10.21 12.79,12 15,12M5,13.28L7.45,14.77L6.8,11.96L9,10.08L6.11,9.83L5,7.19L3.87,9.83L1,10.08L3.18,11.96L2.5,14.77L5,13.28Z",
  },
  {
    id: "FC4F4C4D-83C2-493F-9606-CA80E44BFEF8",
    name: "account-switch",
    codepoint: "F019",
    aliases: ["user-switch"],
    tags: ["Account / User"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M16,9C18.33,9 23,10.17 23,12.5V15H17V12.5C17,11 16.19,9.89 15.04,9.05L16,9M8,9C10.33,9 15,10.17 15,12.5V15H1V12.5C1,10.17 5.67,9 8,9M8,7C6.34,7 5,5.66 5,4C5,2.34 6.34,1 8,1C9.66,1 11,2.34 11,4C11,5.66 9.66,7 8,7M16,7C14.34,7 13,5.66 13,4C13,2.34 14.34,1 16,1C17.66,1 19,2.34 19,4C19,5.66 17.66,7 16,7M9,16.75V19H15V16.75L18.25,20L15,23.25V21H9V23.25L5.75,20L9,16.75Z",
  },
  {
    id: "3334E19F-962D-45B4-BE11-F009E1192165",
    name: "adjust",
    codepoint: "F01A",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M15,12C15,13.66 13.66,15 12,15C10.34,15 9,13.66 9,12C9,10.34 10.34,9 12,9C13.66,9 15,10.34 15,12Z",
  },
  {
    id: "839928F4-21EA-472B-94A0-C7DFBD6C263A",
    name: "adobe",
    codepoint: "F935",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Contributors",
    version: "2.4.85",
    path: "M14.58,3H22V19.67L14.58,3M9.42,3H2V19.67L9.42,3M12,9.17L16.67,19.67H13.5L12.17,16.33H8.75L12,9.17Z",
  },
  {
    id: "FACEA69B-49F0-4588-BDEC-693965AD4649",
    name: "air-conditioner",
    codepoint: "F01B",
    aliases: ["ac-unit"],
    tags: ["Home Automation"],
    author: "Cody",
    version: "1.5.54",
    path: "M6.59,0.66C8.93,-1.15 11.47,1.06 12.04,4.5C12.47,4.5 12.89,4.62 13.27,4.84C13.79,4.24 14.25,3.42 14.07,2.5C13.65,0.35 16.06,-1.39 18.35,1.58C20.16,3.92 17.95,6.46 14.5,7.03C14.5,7.46 14.39,7.89 14.16,8.27C14.76,8.78 15.58,9.24 16.5,9.06C18.63,8.64 20.38,11.04 17.41,13.34C15.07,15.15 12.53,12.94 11.96,9.5C11.53,9.5 11.11,9.37 10.74,9.15C10.22,9.75 9.75,10.58 9.93,11.5C10.35,13.64 7.94,15.39 5.65,12.42C3.83,10.07 6.05,7.53 9.5,6.97C9.5,6.54 9.63,6.12 9.85,5.74C9.25,5.23 8.43,4.76 7.5,4.94C5.37,5.36 3.62,2.96 6.59,0.66M5,16H7C8.1,16 9,16.9 9,18V24H7V22H5V24H3V18C3,16.9 3.9,16 5,16M5,18V20H7V18H5M12.93,16H15L12.07,24H10L12.93,16M18,16H21V18H18V22H21V24H18C16.9,24 16,23.1 16,22V18C16,16.9 16.9,16 18,16Z",
  },
  {
    id: "3E1D81B2-7DF1-4AAF-9598-4995B8D8E5CC",
    name: "airballoon",
    codepoint: "F01C",
    aliases: ["hot-air-balloon"],
    tags: ["Transportation + Other", "Transportation + Flying"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M11,23C9.9,23 9,22.1 9,21V19H15V21C15,22.1 14.1,23 13,23H11M12,1C12.71,1 13.39,1.09 14.05,1.26C15.22,2.83 16,5.71 16,9C16,11.28 15.62,13.37 15,16C15,17.1 14.1,18 13,18H11C9.9,18 9,17.1 9,16C8.38,13.37 8,11.28 8,9C8,5.71 8.78,2.83 9.95,1.26C10.61,1.09 11.29,1 12,1M20,8C20,11.18 18.15,15.92 15.46,17.21C16.41,15.39 17,11.83 17,9C17,6.17 16.41,3.61 15.46,1.79C18.15,3.08 20,4.82 20,8M4,8C4,4.82 5.85,3.08 8.54,1.79C7.59,3.61 7,6.17 7,9C7,11.83 7.59,15.39 8.54,17.21C5.85,15.92 4,11.18 4,8Z",
  },
  {
    id: "5AE3D483-1E1C-49DE-92FF-21C6B93FD52F",
    name: "airplane",
    codepoint: "F01D",
    aliases: ["aeroplane", "airplanemode-active", "flight", "local-airport"],
    tags: ["Transportation + Flying", "Navigation"],
    author: "Google",
    version: "1.5.54",
    path: "M21,16V14L13,9V3.5C13,2.67 12.33,2 11.5,2C10.67,2 10,2.67 10,3.5V9L2,14V16L10,13.5V19L8,20.5V22L11.5,21L15,22V20.5L13,19V13.5L21,16Z",
  },
  {
    id: "634EE7E8-8280-4CF1-B642-0921E740B6DB",
    name: "airplane-landing",
    codepoint: "F5D4",
    aliases: ["aeroplane-landing", "flight-land"],
    tags: ["Transportation + Flying"],
    author: "Google",
    version: "1.5.54",
    path: "M2.5,19H21.5V21H2.5V19M9.68,13.27L14.03,14.43L19.34,15.85C20.14,16.06 20.96,15.59 21.18,14.79C21.39,14 20.92,13.17 20.12,12.95L14.81,11.53L12.05,2.5L10.12,2V10.28L5.15,8.95L4.22,6.63L2.77,6.24V11.41L4.37,11.84L9.68,13.27Z",
  },
  {
    id: "D2D1D38E-ABE7-47B6-9405-DC6BDBA1C335",
    name: "airplane-off",
    codepoint: "F01E",
    aliases: ["aeroplane-off", "airplanemode-inactive"],
    tags: ["Transportation + Flying"],
    author: "Google",
    version: "1.5.54",
    path: "M3.15,5.27L8.13,10.26L2.15,14V16L10.15,13.5V19L8.15,20.5V22L11.65,21L15.15,22V20.5L13.15,19V15.27L18.87,21L20.15,19.73L4.42,4M13.15,9V3.5C13.15,2.67 12.48,2 11.65,2C10.82,2 10.15,2.67 10.15,3.5V7.18L17.97,15L21.15,16V14L13.15,9Z",
  },
  {
    id: "2B9BB7A1-A94B-4D24-8308-5599504317C2",
    name: "airplane-takeoff",
    codepoint: "F5D5",
    aliases: ["aeroplane-takeoff", "flight-takeoff"],
    tags: ["Transportation + Flying"],
    author: "Google",
    version: "1.5.54",
    path: "M2.5,19H21.5V21H2.5V19M22.07,9.64C21.86,8.84 21.03,8.36 20.23,8.58L14.92,10L8,3.57L6.09,4.08L10.23,11.25L5.26,12.58L3.29,11.04L1.84,11.43L3.66,14.59L4.43,15.92L6.03,15.5L11.34,14.07L15.69,12.91L21,11.5C21.81,11.26 22.28,10.44 22.07,9.64Z",
  },
  {
    id: "62C9DAA4-6718-44A9-BCD3-2401D96BE1E7",
    name: "airport",
    codepoint: "F84A",
    aliases: [],
    tags: ["Places", "Transportation + Flying"],
    author: "Michael Irigoyen",
    version: "2.1.99",
    path: "M14.97,5.92C14.83,5.41 14.3,5.1 13.79,5.24L10.39,6.15L5.95,2.03L4.72,2.36L7.38,6.95L4.19,7.8L2.93,6.82L2,7.07L3.66,9.95L14.28,7.11C14.8,6.96 15.1,6.43 14.97,5.92M21,10L20,12H15L14,10L15,9H17V7H18V9H20L21,10M22,20V22H2V20H15V13H20V20H22Z",
  },
  {
    id: "9A1AAF33-6F36-4987-9E8C-798E34D919A9",
    name: "alarm",
    codepoint: "F020",
    aliases: ["access-alarms"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M12,20C8.13,20 5,16.87 5,13C5,9.13 8.13,6 12,6C15.87,6 19,9.13 19,13C19,16.87 15.87,20 12,20M12,4C7.03,4 3,8.03 3,13C3,17.97 7.03,22 12,22C16.97,22 21,17.97 21,13C21,8.03 16.97,4 12,4M12.5,8H11V14L15.75,16.85L16.5,15.62L12.5,13.25V8M7.88,3.39L6.6,1.86L2,5.71L3.29,7.24L7.88,3.39M22,5.72L17.4,1.86L16.11,3.39L20.71,7.25L22,5.72Z",
  },
  {
    id: "02423F51-52A3-4F45-8373-05CA8E8D57B7",
    name: "alarm-bell",
    codepoint: "F78D",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.0.46",
    path: "M15,18.66V22H5V18.66C8.09,20.45 11.91,20.45 15,18.66M22,4C22,2.9 21.1,2 20,2C19.69,2 19.39,2.07 19.12,2.21C18.82,2.36 18.56,2.58 18.36,2.85C17.72,3.75 17.94,5 18.85,5.64C19.18,5.87 19.59,6 20,6C20.08,6 20.16,6 20.24,6C21.97,10.43 20.66,15.46 17,18.5C16.68,18.75 16.35,19 16,19.22V21H17V19.74C20.14,17.5 22,13.86 22,10C22,8.5 21.72,7 21.17,5.62C21.69,5.24 22,4.64 22,4M18,10C18,14.42 14.42,18 10,18C5.58,18 2,14.42 2,10C2,5.58 5.58,2 10,2C14.42,2 18,5.58 18,10Z",
  },
  {
    id: "6DCCA48F-E413-4C45-BFE5-8E3C8BE61A4E",
    name: "alarm-check",
    codepoint: "F021",
    aliases: ["alarm-on"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M10.54,14.53L8.41,12.4L7.35,13.46L10.53,16.64L16.53,10.64L15.47,9.58L10.54,14.53M12,20C8.13,20 5,16.87 5,13C5,9.13 8.13,6 12,6C15.87,6 19,9.13 19,13C19,16.87 15.87,20 12,20M12,4C7.03,4 3,8.03 3,13C3,17.97 7.03,22 12,22C16.97,22 21,17.97 21,13C21,8.03 16.97,4 12,4M7.88,3.39L6.6,1.86L2,5.71L3.29,7.24L7.88,3.39M22,5.72L17.4,1.86L16.11,3.39L20.71,7.25L22,5.72Z",
  },
  {
    id: "B6D88F9D-A85A-4943-A61C-7D33FB0EBF4F",
    name: "alarm-light",
    codepoint: "F78E",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.0.46",
    path: "M6,6.9L3.87,4.78L5.28,3.37L7.4,5.5L6,6.9M13,1V4H11V1H13M20.13,4.78L18,6.9L16.6,5.5L18.72,3.37L20.13,4.78M4.5,10.5V12.5H1.5V10.5H4.5M19.5,10.5H22.5V12.5H19.5V10.5M6,20H18C19.1,20 20,20.9 20,22H4C4,20.9 4.9,20 6,20M12,5C15.31,5 18,7.69 18,11V19H6V11C6,7.69 8.69,5 12,5Z",
  },
  {
    id: "67D410AB-495A-41BD-B9D8-20A7DFBBF623",
    name: "alarm-multiple",
    codepoint: "F022",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M9.29,3.25L5.16,6.72L4,5.34L8.14,1.87L9.29,3.25M22,5.35L20.84,6.73L16.7,3.25L17.86,1.87L22,5.35M13,4C17.42,4 21,7.58 21,12C21,16.42 17.42,20 13,20C8.58,20 5,16.42 5,12C5,7.58 8.58,4 13,4M13,6C9.69,6 7,8.69 7,12C7,15.31 9.69,18 13,18C16.31,18 19,15.31 19,12C19,8.69 16.31,6 13,6M12,7.5H13.5V12.03L16.72,13.5L16.1,14.86L12,13V7.5M1,14C1,11.5 2.13,9.3 3.91,7.83C3.33,9.1 3,10.5 3,12L3.06,13.13L3,14C3,16.28 4.27,18.26 6.14,19.28C7.44,20.5 9.07,21.39 10.89,21.78C10.28,21.92 9.65,22 9,22C4.58,22 1,18.42 1,14Z",
  },
  {
    id: "DD224DD6-9A65-47AB-8838-90FE346A7768",
    name: "alarm-off",
    codepoint: "F023",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M8,3.28L6.6,1.86L5.74,2.57L7.16,4M16.47,18.39C15.26,19.39 13.7,20 12,20C8.13,20 5,16.87 5,13C5,11.3 5.61,9.74 6.61,8.53M2.92,2.29L1.65,3.57L3,4.9L1.87,5.83L3.29,7.25L4.4,6.31L5.2,7.11C3.83,8.69 3,10.75 3,13C3,17.97 7.03,22 12,22C14.25,22 16.31,21.17 17.89,19.8L20.09,22L21.36,20.73L3.89,3.27L2.92,2.29M22,5.72L17.4,1.86L16.11,3.39L20.71,7.25L22,5.72M12,6C15.87,6 19,9.13 19,13C19,13.84 18.84,14.65 18.57,15.4L20.09,16.92C20.67,15.73 21,14.41 21,13C21,8.03 16.97,4 12,4C10.59,4 9.27,4.33 8.08,4.91L9.6,6.43C10.35,6.16 11.16,6 12,6Z",
  },
  {
    id: "6D93F44C-83F7-4446-A5CD-E4135C8644D7",
    name: "alarm-plus",
    codepoint: "F024",
    aliases: ["add-alarm"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M13,9H11V12H8V14H11V17H13V14H16V12H13M12,20C8.13,20 5,16.87 5,13C5,9.13 8.13,6 12,6C15.87,6 19,9.13 19,13C19,16.87 15.87,20 12,20M12,4C7.03,4 3,8.03 3,13C3,17.97 7.03,22 12,22C16.97,22 21,17.97 21,13C21,8.03 16.97,4 12,4M22,5.72L17.4,1.86L16.11,3.39L20.71,7.25M7.88,3.39L6.6,1.86L2,5.71L3.29,7.24L7.88,3.39Z",
  },
  {
    id: "28F85724-265B-4C24-9975-DDDF788A99E5",
    name: "alarm-snooze",
    codepoint: "F68D",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.7.12",
    path: "M7.88,3.39L6.6,1.86L2,5.71L3.29,7.24L7.88,3.39M22,5.72L17.4,1.86L16.11,3.39L20.71,7.25L22,5.72M12,4C7.03,4 3,8.03 3,13C3,17.97 7.03,22 12,22C16.97,22 21,17.97 21,13C21,8.03 16.97,4 12,4M12,20C8.13,20 5,16.87 5,13C5,9.13 8.13,6 12,6C15.87,6 19,9.13 19,13C19,16.87 15.87,20 12,20M9,11H12.63L9,15.2V17H15V15H11.37L15,10.8V9H9V11Z",
  },
  {
    id: "8529D611-F581-4808-95BE-271FB1A6C2FD",
    name: "album",
    codepoint: "F025",
    aliases: ["vinyl", "record"],
    tags: ["Audio"],
    author: "Google",
    version: "1.5.54",
    path: "M12,11C11.45,11 11,11.45 11,12C11,12.55 11.45,13 12,13C12.55,13 13,12.55 13,12C13,11.45 12.55,11 12,11M12,16.5C9.5,16.5 7.5,14.5 7.5,12C7.5,9.5 9.5,7.5 12,7.5C14.5,7.5 16.5,9.5 16.5,12C16.5,14.5 14.5,16.5 12,16.5M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z",
  },
  {
    id: "9FF7DF3F-D575-433B-9C9A-69C58363C186",
    name: "alert",
    codepoint: "F026",
    aliases: ["warning", "report-problem"],
    tags: ["Alert / Error"],
    author: "Google",
    version: "1.5.54",
    path: "M13,14H11V10H13M13,18H11V16H13M1,21H23L12,2L1,21Z",
  },
  {
    id: "7B5D47A1-5658-4169-94C7-0C41E7179DD2",
    name: "alert-box",
    codepoint: "F027",
    aliases: ["warning-box"],
    tags: ["Alert / Error"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3M13,13V7H11V13H13M13,17V15H11V17H13Z",
  },
  {
    id: "C7EDD5B7-95D4-4D83-A4E3-95D8A16A4887",
    name: "alert-circle",
    codepoint: "F028",
    aliases: ["warning-circle", "error"],
    tags: ["Alert / Error"],
    author: "Google",
    version: "1.5.54",
    path: "M13,13H11V7H13M13,17H11V15H13M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z",
  },
  {
    id: "0F4002B4-3C3D-43C4-939F-A998B2C59177",
    name: "alert-circle-outline",
    codepoint: "F5D6",
    aliases: ["warning-circle-outline", "error-outline"],
    tags: ["Alert / Error"],
    author: "Google",
    version: "1.5.54",
    path: "M11,15H13V17H11V15M11,7H13V13H11V7M12,2C6.47,2 2,6.5 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20Z",
  },
  {
    id: "B4866C08-2DAE-4B0A-8942-E057094B3C76",
    name: "alert-decagram",
    codepoint: "F6BC",
    aliases: ["new-releases", "warning-decagram"],
    tags: ["Alert / Error"],
    author: "Google",
    version: "1.8.36",
    path: "M23,12L20.56,9.22L20.9,5.54L17.29,4.72L15.4,1.54L12,3L8.6,1.54L6.71,4.72L3.1,5.53L3.44,9.21L1,12L3.44,14.78L3.1,18.47L6.71,19.29L8.6,22.47L12,21L15.4,22.46L17.29,19.28L20.9,18.46L20.56,14.78L23,12M13,17H11V15H13V17M13,13H11V7H13V13Z",
  },
  {
    id: "9BC1A338-CD03-4D39-BE46-E9DE5EE51A2F",
    name: "alert-octagon",
    codepoint: "F029",
    aliases: ["warning-octagon", "report"],
    tags: ["Alert / Error"],
    author: "Google",
    version: "1.5.54",
    path: "M13,13H11V7H13M12,17.3C11.28,17.3 10.7,16.72 10.7,16C10.7,15.28 11.28,14.7 12,14.7C12.72,14.7 13.3,15.28 13.3,16C13.3,16.72 12.72,17.3 12,17.3M15.73,3H8.27L3,8.27V15.73L8.27,21H15.73L21,15.73V8.27L15.73,3Z",
  },
  {
    id: "124F37BE-27F6-4524-9655-A18D28E91CA6",
    name: "alert-octagram",
    codepoint: "F766",
    aliases: ["warning-octagram"],
    tags: ["Alert / Error"],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M2.2,16.06L3.88,12L2.2,7.94L6.26,6.26L7.94,2.2L12,3.88L16.06,2.2L17.74,6.26L21.8,7.94L20.12,12L21.8,16.06L17.74,17.74L16.06,21.8L12,20.12L7.94,21.8L6.26,17.74L2.2,16.06M13,17V15H11V17H13M13,13V7H11V13H13Z",
  },
  {
    id: "4E574535-954C-42F5-BE5B-DF3716DB7C5A",
    name: "alert-outline",
    codepoint: "F02A",
    aliases: ["warning-outline"],
    tags: ["Alert / Error"],
    author: "Cody",
    version: "1.5.54",
    path: "M12,2L1,21H23M12,6L19.53,19H4.47M11,10V14H13V10M11,16V18H13V16",
  },
  {
    id: "CD43AC33-8EE0-42BE-A7E0-3CCB31D8C5D3",
    name: "alien",
    codepoint: "F899",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "2.2.43",
    path: "M12,3C16.97,3 21,6.58 21,11C21,15.42 15,21 12,21C9,21 3,15.42 3,11C3,6.58 7.03,3 12,3M10.31,10.93C9.29,9.29 7.47,8.58 6.25,9.34C5.03,10.1 4.87,12.05 5.89,13.69C6.92,15.33 8.74,16.04 9.96,15.28C11.18,14.5 11.33,12.57 10.31,10.93M13.69,10.93C12.67,12.57 12.82,14.5 14.04,15.28C15.26,16.04 17.08,15.33 18.11,13.69C19.13,12.05 18.97,10.1 17.75,9.34C16.53,8.58 14.71,9.29 13.69,10.93M12,17.75C10,17.75 9.5,17 9.5,17C9.5,17.03 10,19 12,19C14,19 14.5,17 14.5,17C14.5,17 14,17.75 12,17.75Z",
  },
  {
    id: "5596E6E7-916E-4870-9346-5D46BC86C0D5",
    name: "all-inclusive",
    codepoint: "F6BD",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.8.36",
    path: "M18.6,6.62C17.16,6.62 15.8,7.18 14.83,8.15L7.8,14.39C7.16,15.03 6.31,15.38 5.4,15.38C3.53,15.38 2,13.87 2,12C2,10.13 3.53,8.62 5.4,8.62C6.31,8.62 7.16,8.97 7.84,9.65L8.97,10.65L10.5,9.31L9.22,8.2C8.2,7.18 6.84,6.62 5.4,6.62C2.42,6.62 0,9.04 0,12C0,14.96 2.42,17.38 5.4,17.38C6.84,17.38 8.2,16.82 9.17,15.85L16.2,9.61C16.84,8.97 17.69,8.62 18.6,8.62C20.47,8.62 22,10.13 22,12C22,13.87 20.47,15.38 18.6,15.38C17.7,15.38 16.84,15.03 16.16,14.35L15,13.34L13.5,14.68L14.78,15.8C15.8,16.81 17.15,17.37 18.6,17.37C21.58,17.37 24,14.96 24,12C24,9 21.58,6.62 18.6,6.62Z",
  },
  {
    id: "0B93DD30-B279-4997-BD6D-AC86E29D34CA",
    name: "alpha",
    codepoint: "F02B",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M18.08,17.8C17.62,17.93 17.21,18 16.85,18C15.65,18 14.84,17.12 14.43,15.35H14.38C13.39,17.26 12,18.21 10.25,18.21C8.94,18.21 7.89,17.72 7.1,16.73C6.31,15.74 5.92,14.5 5.92,13C5.92,11.25 6.37,9.85 7.26,8.76C8.15,7.67 9.36,7.12 10.89,7.12C11.71,7.12 12.45,7.35 13.09,7.8C13.73,8.26 14.22,8.9 14.56,9.73H14.6L15.31,7.33H17.87L15.73,12.65C15.97,13.89 16.22,14.74 16.5,15.19C16.74,15.64 17.08,15.87 17.5,15.87C17.74,15.87 17.93,15.83 18.1,15.76L18.08,17.8M13.82,12.56C13.61,11.43 13.27,10.55 12.81,9.95C12.36,9.34 11.81,9.04 11.18,9.04C10.36,9.04 9.7,9.41 9.21,10.14C8.72,10.88 8.5,11.79 8.5,12.86C8.5,13.84 8.69,14.65 9.12,15.31C9.54,15.97 10.11,16.29 10.82,16.29C11.42,16.29 11.97,16 12.46,15.45C12.96,14.88 13.37,14.05 13.7,12.96L13.82,12.56Z",
  },
  {
    id: "EAD8BAC5-EE7C-4553-9316-F45094CF9C7A",
    name: "alphabetical",
    codepoint: "F02C",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M6,11C7.1,11 8,11.9 8,13V17H4C2.9,17 2,16.1 2,15V13C2,11.9 2.9,11 4,11H6M4,13V15H6V13H4M20,13V15H22V17H20C18.9,17 18,16.1 18,15V13C18,11.9 18.9,11 20,11H22V13H20M12,7V11H14C15.1,11 16,11.9 16,13V15C16,16.1 15.1,17 14,17H12C10.9,17 10,16.1 10,15V7H12M12,15H14V13H12V15Z",
  },
  {
    id: "1F7A2F31-3549-4F3C-A95E-E7356033A601",
    name: "altimeter",
    codepoint: "F5D7",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M7,3V5H17V3H7M9,7V9H15V7H9M2,7.96V16.04L6.03,12L2,7.96M22.03,7.96L18,12L22.03,16.04V7.96M7,11V13H17V11H7M9,15V17H15V15H9M7,19V21H17V19H7Z",
  },
  {
    id: "9AE6BA3C-694B-47D5-99C3-7D063228F053",
    name: "amazon",
    codepoint: "F02D",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M15.93,17.09C15.75,17.25 15.5,17.26 15.3,17.15C14.41,16.41 14.25,16.07 13.76,15.36C12.29,16.86 11.25,17.31 9.34,17.31C7.09,17.31 5.33,15.92 5.33,13.14C5.33,10.96 6.5,9.5 8.19,8.76C9.65,8.12 11.68,8 13.23,7.83V7.5C13.23,6.84 13.28,6.09 12.9,5.54C12.58,5.05 11.95,4.84 11.4,4.84C10.38,4.84 9.47,5.37 9.25,6.45C9.2,6.69 9,6.93 8.78,6.94L6.18,6.66C5.96,6.61 5.72,6.44 5.78,6.1C6.38,2.95 9.23,2 11.78,2C13.08,2 14.78,2.35 15.81,3.33C17.11,4.55 17,6.18 17,7.95V12.12C17,13.37 17.5,13.93 18,14.6C18.17,14.85 18.21,15.14 18,15.31L15.94,17.09H15.93M13.23,10.56V10C11.29,10 9.24,10.39 9.24,12.67C9.24,13.83 9.85,14.62 10.87,14.62C11.63,14.62 12.3,14.15 12.73,13.4C13.25,12.47 13.23,11.6 13.23,10.56M20.16,19.54C18,21.14 14.82,22 12.1,22C8.29,22 4.85,20.59 2.25,18.24C2.05,18.06 2.23,17.81 2.5,17.95C5.28,19.58 8.75,20.56 12.33,20.56C14.74,20.56 17.4,20.06 19.84,19.03C20.21,18.87 20.5,19.27 20.16,19.54M21.07,18.5C20.79,18.14 19.22,18.33 18.5,18.42C18.31,18.44 18.28,18.26 18.47,18.12C19.71,17.24 21.76,17.5 22,17.79C22.24,18.09 21.93,20.14 20.76,21.11C20.58,21.27 20.41,21.18 20.5,21C20.76,20.33 21.35,18.86 21.07,18.5Z",
  },
  {
    id: "DD3492E1-1F83-4E41-8BA9-9E6A1380D235",
    name: "amazon-alexa",
    codepoint: "F8C5",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Contributors",
    version: "2.3.50",
    path: "M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M10.43,21.87V19.91C10.43,19.22 10,18.57 9.35,18.3C6.91,17.26 5.17,14.83 5.17,12C5.17,8.26 8.22,5.17 12,5.17C15.78,5.17 18.83,8.26 18.83,12C18.83,16.43 15.39,20.61 10.43,21.87Z",
  },
  {
    id: "B0DB559B-A9D4-473A-AF6D-C72559CCC9D9",
    name: "ambulance",
    codepoint: "F02F",
    aliases: [],
    tags: ["Transportation + Road", "Medical / Hospital"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M18,18.5C18.83,18.5 19.5,17.83 19.5,17C19.5,16.17 18.83,15.5 18,15.5C17.17,15.5 16.5,16.17 16.5,17C16.5,17.83 17.17,18.5 18,18.5M19.5,9.5H17V12H21.46L19.5,9.5M6,18.5C6.83,18.5 7.5,17.83 7.5,17C7.5,16.17 6.83,15.5 6,15.5C5.17,15.5 4.5,16.17 4.5,17C4.5,17.83 5.17,18.5 6,18.5M20,8L23,12V17H21C21,18.66 19.66,20 18,20C16.34,20 15,18.66 15,17H9C9,18.66 7.66,20 6,20C4.34,20 3,18.66 3,17H1V6C1,4.89 1.89,4 3,4H17V8H20M8,6V9H5V11H8V14H10V11H13V9H10V6H8Z",
  },
  {
    id: "4A952C8C-7A6F-4028-A974-48E4DCE299CF",
    name: "amplifier",
    codepoint: "F030",
    aliases: [],
    tags: ["Home Automation"],
    author: "Christopher Schreiner",
    version: "1.5.54",
    path: "M10,2H14C14.55,2 15,2.45 15,3H21V21H19C19,21.55 18.55,22 18,22C17.45,22 17,21.55 17,21H7C7,21.55 6.55,22 6,22C5.45,22 5,21.55 5,21H3V3H9C9,2.45 9.45,2 10,2M5,5V9H19V5H5M7,6C7.55,6 8,6.45 8,7C8,7.55 7.55,8 7,8C6.45,8 6,7.55 6,7C6,6.45 6.45,6 7,6M12,6H14V7H12V6M15,6H16V8H15V6M17,6H18V8H17V6M12,11C9.79,11 8,12.79 8,15C8,17.21 9.79,19 12,19C14.21,19 16,17.21 16,15C16,12.79 14.21,11 12,11M10,6C10.55,6 11,6.45 11,7C11,7.55 10.55,8 10,8C9.45,8 9,7.55 9,7C9,6.45 9.45,6 10,6Z",
  },
  {
    id: "8A3C8CCE-D798-446B-A283-90129AD847C9",
    name: "anchor",
    codepoint: "F031",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M12,2C10.34,2 9,3.34 9,5C9,6.27 9.8,7.4 11,7.83V10H8V12H11V18.92C9.16,18.63 7.53,17.57 6.53,16H8V14H3V19H5V17.3C6.58,19.61 9.2,21 12,21C14.8,21 17.42,19.61 19,17.31V19H21V14H16V16H17.46C16.46,17.56 14.83,18.63 13,18.92V12H16V10H13V7.82C14.2,7.4 15,6.27 15,5C15,3.34 13.66,2 12,2M12,4C12.55,4 13,4.45 13,5C13,5.55 12.55,6 12,6C11.45,6 11,5.55 11,5C11,4.45 11.45,4 12,4Z",
  },
  {
    id: "4633B767-FF29-411D-8C04-69057C6B65B2",
    name: "android",
    codepoint: "F032",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Google",
    version: "1.5.54",
    path: "M15,5H14V4H15M10,5H9V4H10M15.53,2.16L16.84,0.85C17.03,0.66 17.03,0.34 16.84,0.14C16.64,-0.05 16.32,-0.05 16.13,0.14L14.65,1.62C13.85,1.23 12.95,1 12,1C11.04,1 10.14,1.23 9.34,1.63L7.85,0.14C7.66,-0.05 7.34,-0.05 7.15,0.14C6.95,0.34 6.95,0.66 7.15,0.85L8.46,2.16C6.97,3.26 6,5 6,7H18C18,5 17,3.25 15.53,2.16M20.5,8C19.67,8 19,8.67 19,9.5V16.5C19,17.33 19.67,18 20.5,18C21.33,18 22,17.33 22,16.5V9.5C22,8.67 21.33,8 20.5,8M3.5,8C2.67,8 2,8.67 2,9.5V16.5C2,17.33 2.67,18 3.5,18C4.33,18 5,17.33 5,16.5V9.5C5,8.67 4.33,8 3.5,8M6,18C6,18.55 6.45,19 7,19H8V22.5C8,23.33 8.67,24 9.5,24C10.33,24 11,23.33 11,22.5V19H13V22.5C13,23.33 13.67,24 14.5,24C15.33,24 16,23.33 16,22.5V19H17C17.55,19 18,18.55 18,18V8H6V18Z",
  },
  {
    id: "F9923FF1-E31E-4C03-BBB7-438704CF3909",
    name: "android-debug-bridge",
    codepoint: "F033",
    aliases: ["adb"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M15,9C14.45,9 14,8.55 14,8C14,7.45 14.45,7 15,7C15.55,7 16,7.45 16,8C16,8.55 15.55,9 15,9M9,9C8.45,9 8,8.55 8,8C8,7.45 8.45,7 9,7C9.55,7 10,7.45 10,8C10,8.55 9.55,9 9,9M16.12,4.37L18.22,2.27L17.4,1.44L15.09,3.75C14.16,3.28 13.11,3 12,3C10.88,3 9.84,3.28 8.91,3.75L6.6,1.44L5.78,2.27L7.88,4.37C6.14,5.64 5,7.68 5,10V11H19V10C19,7.68 17.86,5.64 16.12,4.37M5,16C5,19.86 8.13,23 12,23C15.87,23 19,19.87 19,16V12H5V16Z",
  },
  {
    id: "B156B15D-86F9-40E0-8B8E-421F78BE5509",
    name: "android-studio",
    codepoint: "F034",
    aliases: ["math-compass-variant"],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M11,2H13V4H13.5C14.33,4 15,4.67 15,5.5V9L14.56,9.44L16.2,12.28C17.31,11.19 18,9.68 18,8H20C20,10.42 18.93,12.59 17.23,14.06L20.37,19.5L20.5,21.72L18.63,20.5L15.56,15.17C14.5,15.7 13.28,16 12,16C10.72,16 9.5,15.7 8.44,15.17L5.37,20.5L3.5,21.72L3.63,19.5L9.44,9.44L9,9V5.5C9,4.67 9.67,4 10.5,4H11V2M9.44,13.43C10.22,13.8 11.09,14 12,14C12.91,14 13.78,13.8 14.56,13.43L13.1,10.9H13.09C12.47,11.5 11.53,11.5 10.91,10.9H10.9L9.44,13.43M12,6C11.45,6 11,6.45 11,7C11,7.55 11.45,8 12,8C12.55,8 13,7.55 13,7C13,6.45 12.55,6 12,6Z",
  },
  {
    id: "B4A236B3-E14B-4A64-8EDD-A48128013388",
    name: "angle-acute",
    codepoint: "F936",
    aliases: [],
    tags: [],
    author: "JapanYoshi",
    version: "2.4.85",
    path: "M20,19H4.09L14.18,4.43L15.82,5.57L11.28,12.13C12.89,12.96 14,14.62 14,16.54C14,16.7 14,16.85 13.97,17H20V19M7.91,17H11.96C12,16.85 12,16.7 12,16.54C12,15.28 11.24,14.22 10.14,13.78L7.91,17Z",
  },
  {
    id: "7A6B88D9-B385-4A6B-84C8-8280456944E4",
    name: "angle-obtuse",
    codepoint: "F937",
    aliases: [],
    tags: [],
    author: "JapanYoshi",
    version: "2.4.85",
    path: "M21,19H9.31L4.07,5.36L5.93,4.64L8.96,12.5C9.5,12.29 10.09,12.17 10.71,12.17V12.17C13.38,12.17 15.56,14.34 15.58,17H21V19M10.69,17H13.58C13.56,15.42 12.3,14.17 10.71,14.17C10.34,14.17 10,14.24 9.67,14.36L10.69,17Z",
  },
  {
    id: "77550809-9FBB-4283-BA57-7C48AB2B86C0",
    name: "angle-right",
    codepoint: "F938",
    aliases: [],
    tags: [],
    author: "JapanYoshi",
    version: "2.4.85",
    path: "M5,4H7V11H13V17H20V19H5V4M7,17H11V13H7V17Z",
  },
  {
    id: "549F8173-7E91-411F-9ECF-D04D2B64B386",
    name: "angular",
    codepoint: "F6B1",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.7.22",
    path: "M12,2.5L20.84,5.65L19.5,17.35L12,21.5L4.5,17.35L3.16,5.65L12,2.5M12,4.6L6.47,17H8.53L9.64,14.22H14.34L15.45,17H17.5L12,4.6M13.62,12.5H10.39L12,8.63L13.62,12.5Z",
  },
  {
    id: "8A82CBEA-C1B3-40C2-96C2-DED8D83DA446",
    name: "angularjs",
    codepoint: "F6BE",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.8.36",
    path: "M12,2.5L20.84,5.65L19.5,17.35L12,21.5L4.5,17.35L3.16,5.65L12,2.5M12,4.5L5,7L6.08,16.22L12,19.5L17.92,16.22L19,7L12,4.5M12,5.72L16.58,16H14.87L13.94,13.72H10.04L9.12,16H7.41L12,5.72M13.34,12.3L12,9.07L10.66,12.3H13.34Z",
  },
  {
    id: "4FE8F135-8FF9-427B-8857-122FBB0A300A",
    name: "animation",
    codepoint: "F5D8",
    aliases: ["auto-awesome-motion"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M4,2C2.89,2 2,2.89 2,4V14H4V4H14V2H4M8,6C6.89,6 6,6.89 6,8V18H8V8H18V6H8M12,10C10.89,10 10,10.89 10,12V20C10,21.11 10.89,22 12,22H20C21.11,22 22,21.11 22,20V12C22,10.89 21.11,10 20,10H12Z",
  },
  {
    id: "093AE881-42E2-46B9-B833-894DDC2FE368",
    name: "animation-play",
    codepoint: "F939",
    aliases: [],
    tags: [],
    author: "Google",
    version: "2.4.85",
    path: "M4,2H14V4H4V14H2V4C2,2.89 2.89,2 4,2M8,6H18V8H8V18H6V8C6,6.89 6.89,6 8,6M12,10H20C21.11,10 22,10.89 22,12V20C22,21.11 21.11,22 20,22H12C10.89,22 10,21.11 10,20V12C10,10.89 10.89,10 12,10M14,12V20L20,16L14,12Z",
  },
  {
    id: "C72FF17B-D0E1-4641-9802-B6BA993D5910",
    name: "anvil",
    codepoint: "F89A",
    aliases: [],
    tags: [],
    author: "Nick",
    version: "2.2.43",
    path: "M9,5V10C13.03,12.47 8.44,14.97 6,16V19H21V16C14.59,13.27 17.47,9 22,8V5H9M2,6C2.81,8.13 4.42,9.5 7,10V6H2Z",
  },
  {
    id: "2829275C-A01C-42CD-A195-447629791D04",
    name: "apple",
    codepoint: "F035",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Jay Zawrotny",
    version: "1.5.54",
    path: "M18.71,19.5C17.88,20.74 17,21.95 15.66,21.97C14.32,22 13.89,21.18 12.37,21.18C10.84,21.18 10.37,21.95 9.1,22C7.79,22.05 6.8,20.68 5.96,19.47C4.25,17 2.94,12.45 4.7,9.39C5.57,7.87 7.13,6.91 8.82,6.88C10.1,6.86 11.32,7.75 12.11,7.75C12.89,7.75 14.37,6.68 15.92,6.84C16.57,6.87 18.39,7.1 19.56,8.82C19.47,8.88 17.39,10.1 17.41,12.63C17.44,15.65 20.06,16.66 20.09,16.67C20.06,16.74 19.67,18.11 18.71,19.5M13,3.5C13.73,2.67 14.94,2.04 15.94,2C16.07,3.17 15.6,4.35 14.9,5.19C14.21,6.04 13.07,6.7 11.95,6.61C11.8,5.46 12.36,4.26 13,3.5Z",
  },
  {
    id: "FAEC5B00-46A8-49AD-87DA-765891B9E387",
    name: "apple-finder",
    codepoint: "F036",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M4,4H11.89C12.46,2.91 13.13,1.88 13.93,1L15.04,2.11C14.61,2.7 14.23,3.34 13.89,4H20C21.1,4 22,4.9 22,6V19C22,20.1 21.1,21 20,21H14.93L15.26,22.23L13.43,22.95L12.93,21H4C2.9,21 2,20.1 2,19V6C2,4.9 2.9,4 4,4M4,6V19H12.54C12.5,18.67 12.44,18.34 12.4,18C12.27,18 12.13,18 12,18C9.25,18 6.78,17.5 5.13,16.76L6.04,15.12C7,15.64 9.17,16 12,16C12.08,16 12.16,16 12.24,16C12.21,15.33 12.22,14.66 12.27,14H9C9,14 9.4,9.97 11,6H4M20,19V6H13C12.1,8.22 11.58,10.46 11.3,12H14.17C14,13.28 13.97,14.62 14.06,15.93C15.87,15.8 17.25,15.5 17.96,15.12L18.87,16.76C17.69,17.3 16.1,17.7 14.29,17.89C14.35,18.27 14.41,18.64 14.5,19H20M6,8H8V11H6V8M16,8H18V11H16V8Z",
  },
  {
    id: "BDB8AF3D-28BD-4FF2-AED0-36108C1B0543",
    name: "apple-icloud",
    codepoint: "F038",
    aliases: ["apple-mobileme"],
    tags: ["Brand / Logo"],
    author: "Jay Zawrotny",
    version: "1.5.54",
    path: "M22,15.04C22,17.23 20.24,19 18.07,19H5.93C3.76,19 2,17.23 2,15.04C2,13.07 3.43,11.44 5.31,11.14C5.28,11 5.27,10.86 5.27,10.71C5.27,9.33 6.38,8.2 7.76,8.2C8.37,8.2 8.94,8.43 9.37,8.8C10.14,7.05 11.13,5.44 13.91,5.44C17.28,5.44 18.87,8.06 18.87,10.83C18.87,10.94 18.87,11.06 18.86,11.17C20.65,11.54 22,13.13 22,15.04Z",
  },
  {
    id: "9B0B7248-3416-4D43-9CE1-13D70949EAA1",
    name: "apple-ios",
    codepoint: "F037",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Google",
    version: "1.5.54",
    path: "M20,9V7H16C14.9,7 14,7.9 14,9V11C14,12.1 14.9,13 16,13H18V15H14V17H18C19.1,17 20,16.1 20,15V13C20,11.9 19.1,11 18,11H16V9M11,15H9V9H11M11,7H9C7.9,7 7,7.9 7,9V15C7,16.1 7.9,17 9,17H11C12.1,17 13,16.1 13,15V9C13,7.9 12.1,7 11,7M4,17H6V11H4M4,9H6V7H4V9Z",
  },
  {
    id: "070FF4A9-7726-4682-8ABD-AC1800B8D83E",
    name: "apple-keyboard-caps",
    codepoint: "F632",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.6.50",
    path: "M15,14V8H17.17L12,2.83L6.83,8H9V14H15M12,0L22,10H17V16H7V10H2L12,0M7,18H17V24H7V18M15,20H9V22H15V20Z",
  },
  {
    id: "03043022-A59D-4E31-B385-E6D94D3D9B92",
    name: "apple-keyboard-command",
    codepoint: "F633",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.6.50",
    path: "M6,2C8.21,2 10,3.79 10,6V8H14V6C14,3.79 15.79,2 18,2C20.21,2 22,3.79 22,6C22,8.21 20.21,10 18,10H16V14H18C20.21,14 22,15.79 22,18C22,20.21 20.21,22 18,22C15.79,22 14,20.21 14,18V16H10V18C10,20.21 8.21,22 6,22C3.79,22 2,20.21 2,18C2,15.79 3.79,14 6,14H8V10H6C3.79,10 2,8.21 2,6C2,3.79 3.79,2 6,2M16,18C16,19.1 16.9,20 18,20C19.1,20 20,19.1 20,18C20,16.9 19.1,16 18,16H16V18M14,10H10V14H14V10M6,16C4.9,16 4,16.9 4,18C4,19.1 4.9,20 6,20C7.1,20 8,19.1 8,18V16H6M8,6C8,4.9 7.1,4 6,4C4.9,4 4,4.9 4,6C4,7.1 4.9,8 6,8H8V6M18,8C19.1,8 20,7.1 20,6C20,4.9 19.1,4 18,4C16.9,4 16,4.9 16,6V8H18Z",
  },
  {
    id: "F24769F6-25C3-4244-8C64-13A514E7CAAD",
    name: "apple-keyboard-control",
    codepoint: "F634",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.6.50",
    path: "M19.78,11.78L18.36,13.19L12,6.83L5.64,13.19L4.22,11.78L12,4L19.78,11.78Z",
  },
  {
    id: "C06A94E2-9606-484B-BC0D-D0B9A2FBA76F",
    name: "apple-keyboard-option",
    codepoint: "F635",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.6.50",
    path: "M3,4H9.11L16.15,18H21V20H14.88L7.84,6H3V4M14,4H21V6H14V4Z",
  },
  {
    id: "5AF5B660-DDD5-446A-8AC9-102776DBBBC9",
    name: "apple-keyboard-shift",
    codepoint: "F636",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.6.50",
    path: "M15,18V12H17.17L12,6.83L6.83,12H9V18H15M12,4L22,14H17V20H7V14H2L12,4Z",
  },
  {
    id: "F79DE68B-BB98-41F7-9B5D-69C8926AB9B0",
    name: "apple-safari",
    codepoint: "F039",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M12,4C7.58,4 4,7.58 4,12C4,14.09 4.8,16 6.11,17.41L9.88,9.88L17.41,6.11C16,4.8 14.09,4 12,4M12,20C16.42,20 20,16.42 20,12C20,9.91 19.2,8 17.89,6.59L14.12,14.12L6.59,17.89C8,19.2 9.91,20 12,20M12,12L11.23,11.23L9.7,14.3L12.77,12.77L12,12M12,17.5H13V19H12V17.5M15.88,15.89L16.59,15.18L17.65,16.24L16.94,16.95L15.88,15.89M17.5,12V11H19V12H17.5M12,6.5H11V5H12V6.5M8.12,8.11L7.41,8.82L6.35,7.76L7.06,7.05L8.12,8.11M6.5,12V13H5V12H6.5Z",
  },
  {
    id: "55C0C50F-9F4D-44C4-A84B-C79F645A8604",
    name: "application",
    codepoint: "F614",
    aliases: ["web-asset"],
    tags: [],
    author: "Austin Andrews",
    version: "1.6.50",
    path: "M19,4C20.11,4 21,4.9 21,6V18C21,19.1 20.1,20 19,20H5C3.89,20 3,19.1 3,18V6C3,4.9 3.9,4 5,4H19M19,18V8H5V18H19Z",
  },
  {
    id: "7F5B9650-26E7-4A88-A6D1-2C338778651D",
    name: "apps",
    codepoint: "F03B",
    aliases: [],
    tags: ["View"],
    author: "Google",
    version: "1.5.54",
    path: "M16,20H20V16H16M16,14H20V10H16M10,8H14V4H10M16,8H20V4H16M10,14H14V10H10M4,14H8V10H4M4,20H8V16H4M10,20H14V16H10M4,8H8V4H4V8Z",
  },
  {
    id: "B7F8E18D-C18D-4EA1-BABE-BE0E48BDCF2D",
    name: "arch",
    codepoint: "F8C6",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Contributors",
    version: "2.3.50",
    path: "M12,2C11.11,4.18 10.57,5.61 9.58,7.73C10.19,8.37 10.93,9.12 12.14,9.97C10.84,9.43 9.95,8.9 9.29,8.34C8,11 6.03,14.75 2,22C5.17,20.17 7.63,19.04 9.92,18.61C9.82,18.19 9.76,17.73 9.77,17.25V17.15C9.82,15.12 10.88,13.56 12.13,13.67C13.38,13.77 14.35,15.5 14.3,17.54C14.29,17.92 14.25,18.29 14.18,18.63C16.44,19.07 18.87,20.19 22,22C21.38,20.86 20.83,19.84 20.31,18.87C19.5,18.23 18.61,17.39 16.85,16.5C18.06,16.8 18.93,17.16 19.61,17.57C14.26,7.62 13.83,6.3 12,2Z",
  },
  {
    id: "9C2AD144-9997-4169-983C-879DCCD62760",
    name: "archive",
    codepoint: "F03C",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M3,3H21V7H3V3M4,8H20V21H4V8M9.5,11C9.22,11 9,11.22 9,11.5V13H15V11.5C15,11.22 14.78,11 14.5,11H9.5Z",
  },
  {
    id: "7F57A003-5F4E-46CF-9099-51B8D05381F8",
    name: "arrange-bring-forward",
    codepoint: "F03D",
    aliases: [],
    tags: ["Arrange"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M2,2H16V16H2V2M22,8V22H8V18H10V20H20V10H18V8H22Z",
  },
  {
    id: "679C0678-9688-49FD-BA71-BED740A09267",
    name: "arrange-bring-to-front",
    codepoint: "F03E",
    aliases: [],
    tags: ["Arrange"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M2,2H11V6H9V4H4V9H6V11H2V2M22,13V22H13V18H15V20H20V15H18V13H22M8,8H16V16H8V8Z",
  },
  {
    id: "677B1C90-BB0B-4F73-8EEA-D6E8FA709A6D",
    name: "arrange-send-backward",
    codepoint: "F03F",
    aliases: [],
    tags: ["Arrange"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M2,2H16V16H2V2M22,8V22H8V18H18V8H22M4,4V14H14V4H4Z",
  },
  {
    id: "86145497-4CAA-41D6-A14E-0DD3FEE7721E",
    name: "arrange-send-to-back",
    codepoint: "F040",
    aliases: [],
    tags: ["Arrange"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M2,2H11V11H2V2M9,4H4V9H9V4M22,13V22H13V13H22M15,20H20V15H15V20M16,8V11H13V8H16M11,16H8V13H11V16Z",
  },
  {
    id: "5540E986-54E7-4FBF-A62F-9937B9E4F78D",
    name: "arrow-all",
    codepoint: "F041",
    aliases: [],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M13,11H18L16.5,9.5L17.92,8.08L21.84,12L17.92,15.92L16.5,14.5L18,13H13V18L14.5,16.5L15.92,17.92L12,21.84L8.08,17.92L9.5,16.5L11,18V13H6L7.5,14.5L6.08,15.92L2.16,12L6.08,8.08L7.5,9.5L6,11H11V6L9.5,7.5L8.08,6.08L12,2.16L15.92,6.08L14.5,7.5L13,6V11Z",
  },
  {
    id: "25DD11B1-DE14-49E3-A54F-B01DCC45798D",
    name: "arrow-bottom-left",
    codepoint: "F042",
    aliases: [],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M19,6.41L17.59,5L7,15.59V9H5V19H15V17H8.41L19,6.41Z",
  },
  {
    id: "B34E6142-64AF-43FE-A565-2FAEEA35B800",
    name: "arrow-bottom-left-bold-outline",
    codepoint: "F9B6",
    aliases: [],
    tags: [],
    author: "Michael Irigoyen",
    version: "2.5.94",
    path: "M18.36,19.78H4.22V5.64L8.47,9.88L14.12,4.22L19.78,9.88L14.12,15.54L18.36,19.78M6.34,17.66H13.41L11.29,15.54L16.95,9.88L14.12,7.05L8.46,12.71L6.34,10.59V17.66Z",
  },
  {
    id: "73858F0F-F08D-4D54-A3C1-54E794E9C097",
    name: "arrow-bottom-left-thick",
    codepoint: "F9B7",
    aliases: [],
    tags: [],
    author: "Michael Irigoyen",
    version: "2.5.94",
    path: "M15.5,5.69L18.31,8.5L11.94,14.89H16.89V18.31H5.69V7.11H9.12V12.06L15.5,5.69Z",
  },
  {
    id: "F7CB7031-655F-43BE-9165-F6C2CEC047B4",
    name: "arrow-bottom-right",
    codepoint: "F043",
    aliases: [],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M5,6.41L6.41,5L17,15.59V9H19V19H9V17H15.59L5,6.41Z",
  },
  {
    id: "ABD34714-B566-4EDF-B876-93BFB6D254CB",
    name: "arrow-bottom-right-bold-outline",
    codepoint: "F9B8",
    aliases: [],
    tags: [],
    author: "Michael Irigoyen",
    version: "2.5.94",
    path: "M9.88,15.54L4.22,9.88L9.88,4.22L15.54,9.88L19.78,5.64V19.78H5.64L9.88,15.54M17.66,10.59L15.54,12.71L9.88,7.05L7.05,9.88L12.71,15.54L10.59,17.66H17.66V10.59Z",
  },
  {
    id: "01AD77CD-8F92-4E32-A752-387203BC9FF8",
    name: "arrow-bottom-right-thick",
    codepoint: "F9B9",
    aliases: [],
    tags: [],
    author: "Michael Irigoyen",
    version: "2.5.94",
    path: "M14.89,12.06V7.11H18.31V18.31H7.11V14.89H12.06L5.69,8.5L8.5,5.69L14.89,12.06Z",
  },
  {
    id: "86BB43B4-910B-4174-8455-661875054171",
    name: "arrow-collapse",
    codepoint: "F615",
    aliases: ["arrow-compress"],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.6.50",
    path: "M19.5,3.09L15,7.59V4H13V11H20V9H16.41L20.91,4.5L19.5,3.09M4,13V15H7.59L3.09,19.5L4.5,20.91L9,16.41V20H11V13H4Z",
  },
  {
    id: "54364780-8F31-4B23-8085-ABE21EA55926",
    name: "arrow-collapse-all",
    codepoint: "F044",
    aliases: ["arrow-compress-all"],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M19.5,3.09L20.91,4.5L16.41,9H20V11H13V4H15V7.59L19.5,3.09M20.91,19.5L19.5,20.91L15,16.41V20H13V13H20V15H16.41L20.91,19.5M4.5,3.09L9,7.59V4H11V11H4V9H7.59L3.09,4.5L4.5,3.09M3.09,19.5L7.59,15H4V13H11V20H9V16.41L4.5,20.91L3.09,19.5Z",
  },
  {
    id: "9989309E-22E1-46F6-B710-6717D1C5EA11",
    name: "arrow-collapse-down",
    codepoint: "F791",
    aliases: ["arrow-compress-down"],
    tags: ["Arrow"],
    author: "Michael Richins",
    version: "2.0.46",
    path: "M19.92,12.08L12,20L4.08,12.08L5.5,10.67L11,16.17V2H13V16.17L18.5,10.66L19.92,12.08M12,20H2V22H22V20H12Z",
  },
  {
    id: "56953ABE-D834-4DC6-A44B-87A3BF1181BA",
    name: "arrow-collapse-horizontal",
    codepoint: "F84B",
    aliases: [],
    tags: ["Arrow"],
    author: "Google",
    version: "2.1.99",
    path: "M13,20V4H15.03V20H13M10,20V4H12.03V20H10M5,8L9.03,12L5,16V13H2V11H5V8M20,16L16,12L20,8V11H23V13H20V16Z",
  },
  {
    id: "9F794864-D790-48F3-A8B4-31AEC3BB17FD",
    name: "arrow-collapse-left",
    codepoint: "F792",
    aliases: ["arrow-compress-left"],
    tags: ["Arrow"],
    author: "Michael Richins",
    version: "2.0.46",
    path: "M11.92,19.92L4,12L11.92,4.08L13.33,5.5L7.83,11H22V13H7.83L13.34,18.5L11.92,19.92M4,12V2H2V22H4V12Z",
  },
  {
    id: "FFED25A5-FD40-4274-9EE3-6B26F5C03584",
    name: "arrow-collapse-right",
    codepoint: "F793",
    aliases: ["arrow-compress-right"],
    tags: ["Arrow"],
    author: "Michael Richins",
    version: "2.0.46",
    path: "M12.08,4.08L20,12L12.08,19.92L10.67,18.5L16.17,13H2V11H16.17L10.67,5.5L12.08,4.08M20,12V22H22V2H20V12Z",
  },
  {
    id: "1E02D94D-6931-4CB8-8836-5276B076D811",
    name: "arrow-collapse-up",
    codepoint: "F794",
    aliases: ["arrow-compress-up"],
    tags: ["Arrow"],
    author: "Michael Richins",
    version: "2.0.46",
    path: "M4.08,11.92L12,4L19.92,11.92L18.5,13.33L13,7.83V22H11V7.83L5.5,13.33L4.08,11.92M12,4H22V2H2V4H12Z",
  },
  {
    id: "1D7700E7-2963-479F-81E1-910E2566894F",
    name: "arrow-collapse-vertical",
    codepoint: "F84C",
    aliases: ["compress"],
    tags: ["Arrow"],
    author: "Google",
    version: "2.1.99",
    path: "M4,12H20V14H4V12M4,9H20V11H4V9M16,4L12,8L8,4H11V1H13V4H16M8,19L12,15L16,19H13V22H11V19H8Z",
  },
  {
    id: "61D65F86-CEB6-4CCC-8B88-00A4D0AD37C4",
    name: "arrow-decision",
    codepoint: "F9BA",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.5.94",
    path: "M11,5H8L12,1L16,5H13V9.43C12.25,9.89 11.58,10.46 11,11.12V5M22,11L18,7V10C14.39,9.85 11.31,12.57 11,16.17C9.44,16.72 8.62,18.44 9.17,20C9.72,21.56 11.44,22.38 13,21.83C14.56,21.27 15.38,19.56 14.83,18C14.53,17.14 13.85,16.47 13,16.17C13.47,12.17 17.47,11.97 17.95,11.97V14.97L22,11M10.63,11.59C9.3,10.57 7.67,10 6,10V7L2,11L6,15V12C7.34,12.03 8.63,12.5 9.64,13.4C9.89,12.76 10.22,12.15 10.63,11.59Z",
  },
  {
    id: "B115DB5B-AAF9-4C39-BC44-9E573E3154A1",
    name: "arrow-decision-auto",
    codepoint: "F9BB",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.5.94",
    path: "M12,5H9L13,1L17,5H14V9.43C13.25,9.89 12.58,10.46 12,11.12V5M10.4,15H8.5L7.8,13H4.6L3.9,15H2L5.2,6H7.2L10.4,15M7.35,11.65L6.2,8L5.05,11.65H7.35M23,11L19,7V10C15.39,9.85 12.31,12.57 12,16.17C10.44,16.72 9.62,18.44 10.17,20C10.72,21.56 12.44,22.38 14,21.83C15.56,21.27 16.38,19.56 15.83,18C15.53,17.14 14.85,16.47 14,16.17C14.47,12.17 18.47,11.97 18.95,11.97V14.97L23,11Z",
  },
  {
    id: "FA34CDF8-9B5D-40D2-97D5-00F41438A185",
    name: "arrow-decision-auto-outline",
    codepoint: "F9BC",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.5.94",
    path: "M19,15V12C18.5,12 14.5,12.16 14.05,16.2C15.61,16.75 16.43,18.47 15.88,20.03C15.33,21.59 13.61,22.41 12.05,21.86C10.5,21.3 9.67,19.59 10.22,18.03C10.5,17.17 11.2,16.5 12.05,16.2C12.34,12.61 15.4,9.88 19,10V7L23,11L19,15M14,19C14,18.45 13.55,18 13,18C12.45,18 12,18.45 12,19C12,19.55 12.45,20 13,20C13.55,20 14,19.55 14,19M12,11.12C12.58,10.46 13.25,9.89 14,9.43V5H17L13,1L9,5H12V11.12M7.2,6H5.2L2,15H3.9L4.6,13H7.8L8.5,15H10.4L7.2,6M5.05,11.65L6.2,8L7.35,11.65H5.05Z",
  },
  {
    id: "7731818A-2C14-4B22-8758-9C7604BA6F3B",
    name: "arrow-decision-outline",
    codepoint: "F9BD",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.5.94",
    path: "M9.64,13.4C8.63,12.5 7.34,12.03 6,12V15L2,11L6,7V10C7.67,10 9.3,10.57 10.63,11.59C10.22,12.15 9.89,12.76 9.64,13.4M18,15V12C17.5,12 13.5,12.16 13.05,16.2C14.61,16.75 15.43,18.47 14.88,20.03C14.33,21.59 12.61,22.41 11.05,21.86C9.5,21.3 8.67,19.59 9.22,18.03C9.5,17.17 10.2,16.5 11.05,16.2C11.34,12.61 14.4,9.88 18,10V7L22,11L18,15M13,19C13,18.45 12.55,18 12,18C11.45,18 11,18.45 11,19C11,19.55 11.45,20 12,20C12.55,20 13,19.55 13,19M11,11.12C11.58,10.46 12.25,9.89 13,9.43V5H16L12,1L8,5H11V11.12Z",
  },
  {
    id: "3821BF79-5857-47BE-84E3-A100B7247535",
    name: "arrow-down",
    codepoint: "F045",
    aliases: ["arrow-downward"],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M11,4H13V16L18.5,10.5L19.92,11.92L12,19.84L4.08,11.92L5.5,10.5L11,16V4Z",
  },
  {
    id: "CA8684F7-5654-4AE0-9840-9C3AD9611D19",
    name: "arrow-down-bold",
    codepoint: "F72D",
    aliases: [],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M9,4H15V12H19.84L12,19.84L4.16,12H9V4Z",
  },
  {
    id: "545DF72E-705C-46AC-BABE-94F6C304CFAB",
    name: "arrow-down-bold-box",
    codepoint: "F72E",
    aliases: [],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3M12,17L17,12H14V8H10V12H7L12,17Z",
  },
  {
    id: "2D68AA5F-ACA1-45AA-873B-AD077377E698",
    name: "arrow-down-bold-box-outline",
    codepoint: "F72F",
    aliases: [],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M12,17L7,12H10V8H14V12H17L12,17M5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3M5,5V19H19V5H5Z",
  },
  {
    id: "E4AFC38F-01B3-452D-BDD7-A08EA66D53FA",
    name: "arrow-down-bold-circle",
    codepoint: "F047",
    aliases: [],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M12,17L17,12H14V8H10V12H7L12,17Z",
  },
  {
    id: "1DA60E82-C1F0-449C-8157-7014A7C9E749",
    name: "arrow-down-bold-circle-outline",
    codepoint: "F048",
    aliases: [],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,17L7,12H10V8H14V12H17L12,17M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M12,4C7.58,4 4,7.58 4,12C4,16.42 7.58,20 12,20C16.42,20 20,16.42 20,12C20,7.58 16.42,4 12,4Z",
  },
  {
    id: "1F47DB52-28B0-40B7-836F-F6F2C58F2412",
    name: "arrow-down-bold-hexagon-outline",
    codepoint: "F049",
    aliases: [],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,17L7,12H10V8H14V12H17L12,17M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5M12,4.15L5,8.09V15.91L12,19.85L19,15.91V8.09L12,4.15Z",
  },
  {
    id: "517A69FA-E66C-469C-908F-E0CD723EBE8A",
    name: "arrow-down-bold-outline",
    codepoint: "F9BE",
    aliases: [],
    tags: [],
    author: "Michael Irigoyen",
    version: "2.5.94",
    path: "M22,11L12,21L2,11H8V3H16V11H22M12,18L17,13H14V5H10V13H7L12,18Z",
  },
  {
    id: "04449961-F211-4FB7-BD87-EDA5F828B41D",
    name: "arrow-down-box",
    codepoint: "F6BF",
    aliases: [],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.8.36",
    path: "M3,5C3,3.9 3.9,3 5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.89,21 3,20.1 3,19V5M11,6V14.5L7.5,11L6.08,12.42L12,18.34L17.92,12.42L16.5,11L13,14.5V6H11Z",
  },
  {
    id: "34BD0C0B-AF54-4BFC-A539-35D67612C4AC",
    name: "arrow-down-drop-circle",
    codepoint: "F04A",
    aliases: ["arrow-drop-down-circle"],
    tags: ["Arrow"],
    author: "Google",
    version: "1.5.54",
    path: "M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M7,10L12,15L17,10H7Z",
  },
  {
    id: "65BE2EE5-23A5-49F8-A7A2-AEDD25C9C661",
    name: "arrow-down-drop-circle-outline",
    codepoint: "F04B",
    aliases: [],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4M7,10L12,15L17,10H7Z",
  },
  {
    id: "E345145F-AD51-4B6F-8F7B-EC22C34E4E89",
    name: "arrow-down-thick",
    codepoint: "F046",
    aliases: [],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M10,4H14V13L17.5,9.5L19.92,11.92L12,19.84L4.08,11.92L6.5,9.5L10,13V4Z",
  },
  {
    id: "F75C0670-7074-4756-BF30-7840D1C47E09",
    name: "arrow-expand",
    codepoint: "F616",
    aliases: [],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.6.50",
    path: "M10,21V19H6.41L10.91,14.5L9.5,13.09L5,17.59V14H3V21H10M14.5,10.91L19,6.41V10H21V3H14V5H17.59L13.09,9.5L14.5,10.91Z",
  },
  {
    id: "14842517-5BC4-49B6-86F2-8D6DC8870786",
    name: "arrow-expand-all",
    codepoint: "F04C",
    aliases: [],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M9.5,13.09L10.91,14.5L6.41,19H10V21H3V14H5V17.59L9.5,13.09M10.91,9.5L9.5,10.91L5,6.41V10H3V3H10V5H6.41L10.91,9.5M14.5,13.09L19,17.59V14H21V21H14V19H17.59L13.09,14.5L14.5,13.09M13.09,9.5L17.59,5H14V3H21V10H19V6.41L14.5,10.91L13.09,9.5Z",
  },
  {
    id: "2338FC6A-1234-4A1F-AF6D-CFD45C92A2DF",
    name: "arrow-expand-down",
    codepoint: "F795",
    aliases: [],
    tags: ["Arrow"],
    author: "Michael Richins",
    version: "2.0.46",
    path: "M22,4V2H2V4H11V18.17L5.5,12.67L4.08,14.08L12,22L19.92,14.08L18.5,12.67L13,18.17V4H22Z",
  },
  {
    id: "B48C3976-1304-4E32-9D69-0062A48018FB",
    name: "arrow-expand-horizontal",
    codepoint: "F84D",
    aliases: [],
    tags: ["Arrow"],
    author: "Google",
    version: "2.1.99",
    path: "M9,11H15V8L19,12L15,16V13H9V16L5,12L9,8V11M2,20V4H4V20H2M20,20V4H22V20H20Z",
  },
  {
    id: "FDF3C8E5-7AD6-4428-90EC-9426E56B5478",
    name: "arrow-expand-left",
    codepoint: "F796",
    aliases: [],
    tags: ["Arrow"],
    author: "Michael Richins",
    version: "2.0.46",
    path: "M20,22H22V2H20V11H5.83L11.33,5.5L9.92,4.08L2,12L9.92,19.92L11.33,18.5L5.83,13H20V22Z",
  },
  {
    id: "FF7885EC-2A34-4149-A4F8-626135606D7F",
    name: "arrow-expand-right",
    codepoint: "F797",
    aliases: [],
    tags: ["Arrow"],
    author: "Michael Richins",
    version: "2.0.46",
    path: "M4,2H2V22H4V13H18.17L12.67,18.5L14.08,19.92L22,12L14.08,4.08L12.67,5.5L18.17,11H4V2Z",
  },
  {
    id: "C13A62FF-DCC7-40DA-9326-C7FA77E4610F",
    name: "arrow-expand-up",
    codepoint: "F798",
    aliases: [],
    tags: ["Arrow"],
    author: "Michael Richins",
    version: "2.0.46",
    path: "M2,20V22H22V20H13V5.83L18.5,11.33L19.92,9.92L12,2L4.08,9.92L5.5,11.33L11,5.83V20H2Z",
  },
  {
    id: "3B6EC96B-24CB-4CCE-AE9F-AA1787987C63",
    name: "arrow-expand-vertical",
    codepoint: "F84E",
    aliases: [],
    tags: ["Arrow"],
    author: "Google",
    version: "2.1.99",
    path: "M13,9V15H16L12,19L8,15H11V9H8L12,5L16,9H13M4,2H20V4H4V2M4,20H20V22H4V20Z",
  },
  {
    id: "C21995A9-094F-4EA8-9127-BA0506B240A6",
    name: "arrow-left",
    codepoint: "F04D",
    aliases: ["arrow-back"],
    tags: ["Arrow"],
    author: "Google",
    version: "1.5.54",
    path: "M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z",
  },
  {
    id: "E990CF7B-A7D8-444E-99FE-24930ABF2FA6",
    name: "arrow-left-bold",
    codepoint: "F730",
    aliases: [],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M20,9V15H12V19.84L4.16,12L12,4.16V9H20Z",
  },
  {
    id: "B7333E10-D6D6-4F86-A163-3A486C0B839D",
    name: "arrow-left-bold-box",
    codepoint: "F731",
    aliases: [],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3H19C20.1,3 21,3.9 21,5M7,12L12,17V14H16V10H12V7L7,12Z",
  },
  {
    id: "E95F06DD-DD66-4CD1-AAAC-AAA870CE6AC7",
    name: "arrow-left-bold-box-outline",
    codepoint: "F732",
    aliases: [],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M7,12L12,7V10H16V14H12V17L7,12M21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3H19C20.1,3 21,3.9 21,5M19,5H5V19H19V5Z",
  },
  {
    id: "D40EF576-5116-4176-9F9D-C9E491517321",
    name: "arrow-left-bold-circle",
    codepoint: "F04F",
    aliases: [],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2C17.52,2 22,6.48 22,12M7,12L12,17V14H16V10H12V7L7,12Z",
  },
  {
    id: "E5ED912C-8075-477C-B62B-60184A436F2C",
    name: "arrow-left-bold-circle-outline",
    codepoint: "F050",
    aliases: [],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M7,12L12,7V10H16V14H12V17L7,12M22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2C17.52,2 22,6.48 22,12M20,12C20,7.58 16.42,4 12,4C7.58,4 4,7.58 4,12C4,16.42 7.58,20 12,20C16.42,20 20,16.42 20,12Z",
  },
  {
    id: "5B274371-4B53-4E82-9CE3-42EADBDCCF92",
    name: "arrow-left-bold-hexagon-outline",
    codepoint: "F051",
    aliases: [],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M7,12L12,7V10H16V14H12V17L7,12M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5M12,4.15L5,8.09V15.91L12,19.85L19,15.91V8.09L12,4.15Z",
  },
  {
    id: "F88B9364-AE49-4AF6-A891-E20068064832",
    name: "arrow-left-bold-outline",
    codepoint: "F9BF",
    aliases: [],
    tags: [],
    author: "Michael Irigoyen",
    version: "2.5.94",
    path: "M13,22L3,12L13,2V8H21V16H13V22M6,12L11,17V14H19V10H11V7L6,12Z",
  },
  {
    id: "67481609-631A-45C8-AB97-679B3D95F9FB",
    name: "arrow-left-box",
    codepoint: "F6C0",
    aliases: [],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.8.36",
    path: "M19,3C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.89 3.9,3 5,3H19M18,11H9.5L13,7.5L11.58,6.08L5.66,12L11.58,17.92L13,16.5L9.5,13H18V11Z",
  },
  {
    id: "199C908D-09C4-47C6-968A-74582AC4AF26",
    name: "arrow-left-drop-circle",
    codepoint: "F052",
    aliases: [],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2C17.52,2 22,6.48 22,12M14,7L9,12L14,17V7Z",
  },
  {
    id: "37B06F58-3BD0-413F-B86D-2EFD008B3D69",
    name: "arrow-left-drop-circle-outline",
    codepoint: "F053",
    aliases: [],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M22,12C22,6.48 17.52,2 12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12M20,12C20,16.42 16.42,20 12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12M14,7L9,12L14,17V7Z",
  },
  {
    id: "341A3007-7214-4634-924D-1FFEA455AD5E",
    name: "arrow-left-right-bold-outline",
    codepoint: "F9C0",
    aliases: [],
    tags: [],
    author: "Michael Irigoyen",
    version: "2.5.94",
    path: "M14,16V22L24,12L14,2V8H10V2L0,12L10,22V16H14M8,14V17L3,12L8,7V10H16V7L21,12L16,17V14H8Z",
  },
  {
    id: "FA880DCB-AC6F-4C9C-9B6D-6E8236272C31",
    name: "arrow-left-thick",
    codepoint: "F04E",
    aliases: [],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M20,10V14H11L14.5,17.5L12.08,19.92L4.16,12L12.08,4.08L14.5,6.5L11,10H20Z",
  },
  {
    id: "05F25B05-A6D6-4863-8B21-6969E10329CF",
    name: "arrow-right",
    codepoint: "F054",
    aliases: ["arrow-forward"],
    tags: ["Arrow"],
    author: "Google",
    version: "1.5.54",
    path: "M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z",
  },
  {
    id: "8C7A25B6-878E-4BDB-A5B7-2927257E1B7D",
    name: "arrow-right-bold",
    codepoint: "F733",
    aliases: [],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M4,15V9H12V4.16L19.84,12L12,19.84V15H4Z",
  },
  {
    id: "7225998A-DEF1-40C6-A05C-FA4119A643D9",
    name: "arrow-right-bold-box",
    codepoint: "F734",
    aliases: [],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M3,19V5C3,3.9 3.9,3 5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19M17,12L12,7V10H8V14H12V17L17,12Z",
  },
  {
    id: "1830D607-FDD5-4CC1-8D74-2A92C16B9E51",
    name: "arrow-right-bold-box-outline",
    codepoint: "F735",
    aliases: [],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M17,12L12,17V14H8V10H12V7L17,12M3,19V5C3,3.9 3.9,3 5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19M5,19H19V5H5V19Z",
  },
  {
    id: "AF178779-F8E7-4F77-A9D1-A4675713C440",
    name: "arrow-right-bold-circle",
    codepoint: "F056",
    aliases: [],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M2,12C2,6.48 6.48,2 12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12M17,12L12,7V10H8V14H12V17L17,12Z",
  },
  {
    id: "8B60DF03-2440-4D73-98DE-A8666666864E",
    name: "arrow-right-bold-circle-outline",
    codepoint: "F057",
    aliases: [],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M17,12L12,17V14H8V10H12V7L17,12M2,12C2,6.48 6.48,2 12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12M4,12C4,16.42 7.58,20 12,20C16.42,20 20,16.42 20,12C20,7.58 16.42,4 12,4C7.58,4 4,7.58 4,12Z",
  },
  {
    id: "1EAE1304-ED67-4607-A5C3-833B9CF7D943",
    name: "arrow-right-bold-hexagon-outline",
    codepoint: "F058",
    aliases: [],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M17,12L12,17V14H8V10H12V7L17,12M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5M12,4.15L5,8.09V15.91L12,19.85L19,15.91V8.09L12,4.15Z",
  },
  {
    id: "86D895A6-8B2C-4757-A2CC-C506B402C2BB",
    name: "arrow-right-bold-outline",
    codepoint: "F9C1",
    aliases: [],
    tags: [],
    author: "Michael Irigoyen",
    version: "2.5.94",
    path: "M11,16H3V8H11V2L21,12L11,22V16M13,7V10H5V14H13V17L18,12L13,7Z",
  },
  {
    id: "8BA08E5C-7ED5-49E2-BDDE-1F1425C9FE1A",
    name: "arrow-right-box",
    codepoint: "F6C1",
    aliases: [],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.8.36",
    path: "M5,21C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3H19C20.1,3 21,3.9 21,5V19C21,20.11 20.1,21 19,21H5M6,13H14.5L11,16.5L12.42,17.92L18.34,12L12.42,6.08L11,7.5L14.5,11H6V13Z",
  },
  {
    id: "39AEA4FF-B65C-4368-B582-98108E3F9F06",
    name: "arrow-right-drop-circle",
    codepoint: "F059",
    aliases: [],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M2,12C2,6.48 6.48,2 12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12M10,17L15,12L10,7V17Z",
  },
  {
    id: "1E7109A9-3178-4B5E-87A9-CD1054B38BE9",
    name: "arrow-right-drop-circle-outline",
    codepoint: "F05A",
    aliases: [],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2C6.48,2 2,6.48 2,12M4,12C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20C7.58,20 4,16.42 4,12M10,17L15,12L10,7V17Z",
  },
  {
    id: "9F7385FB-733C-4C1F-AC88-684BE98F381B",
    name: "arrow-right-thick",
    codepoint: "F055",
    aliases: [],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M4,10V14H13L9.5,17.5L11.92,19.92L19.84,12L11.92,4.08L9.5,6.5L13,10H4Z",
  },
  {
    id: "ED7981BC-0B25-4657-BB7C-FB14A3D91D99",
    name: "arrow-split-horizontal",
    codepoint: "F93A",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.4.85",
    path: "M8,18H11V15H2V13H22V15H13V18H16L12,22L8,18M12,2L8,6H11V9H2V11H22V9H13V6H16L12,2Z",
  },
  {
    id: "7234382E-CB5D-4EB3-8BA2-0C50BC2171DB",
    name: "arrow-split-vertical",
    codepoint: "F93B",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.4.85",
    path: "M18,16V13H15V22H13V2H15V11H18V8L22,12L18,16M2,12L6,16V13H9V22H11V2H9V11H6V8L2,12Z",
  },
  {
    id: "DD1AC44D-81B8-42EF-8714-7E7D29F2BC3F",
    name: "arrow-top-left",
    codepoint: "F05B",
    aliases: [],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M19,17.59L17.59,19L7,8.41V15H5V5H15V7H8.41L19,17.59Z",
  },
  {
    id: "4D43349E-EF13-4BB1-9684-0CEDE55DE9DE",
    name: "arrow-top-left-bold-outline",
    codepoint: "F9C2",
    aliases: [],
    tags: [],
    author: "Michael Irigoyen",
    version: "2.5.94",
    path: "M14.12,8.46L19.78,14.12L14.12,19.78L8.46,14.12L4.22,18.36V4.22H18.36L14.12,8.46M6.34,13.41L8.46,11.29L14.12,16.95L16.95,14.12L11.29,8.47L13.41,6.34H6.34V13.41Z",
  },
  {
    id: "D1D2B0DA-2EAD-451B-A9D9-B4C52E16FEDC",
    name: "arrow-top-left-thick",
    codepoint: "F9C3",
    aliases: [],
    tags: [],
    author: "Michael Irigoyen",
    version: "2.5.94",
    path: "M9.12,11.94V16.89H5.69V5.69H16.89V9.12H11.94L18.31,15.5L15.5,18.31L9.12,11.94Z",
  },
  {
    id: "27AB7B33-64F3-49A5-8082-CA7B465152A9",
    name: "arrow-top-right",
    codepoint: "F05C",
    aliases: [],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M5,17.59L15.59,7H9V5H19V15H17V8.41L6.41,19L5,17.59Z",
  },
  {
    id: "D6A6FF61-6566-4C1D-BBCC-30E00B0655DD",
    name: "arrow-top-right-bold-outline",
    codepoint: "F9C4",
    aliases: [],
    tags: [],
    author: "Michael Irigoyen",
    version: "2.5.94",
    path: "M5.64,4.22H19.78V18.36L15.54,14.12L9.88,19.78L4.22,14.12L9.88,8.46L5.64,4.22M17.66,6.34H10.59L12.71,8.46L7.05,14.12L9.88,16.95L15.54,11.29L17.66,13.41V6.34H17.66Z",
  },
  {
    id: "37C83BAE-6330-4E45-A976-3E2642997035",
    name: "arrow-top-right-thick",
    codepoint: "F9C5",
    aliases: [],
    tags: [],
    author: "Michael Irigoyen",
    version: "2.5.94",
    path: "M8.5,18.31L5.69,15.5L12.06,9.12H7.11V5.69H18.31V16.89H14.89V11.94L8.5,18.31Z",
  },
  {
    id: "3AF49B97-A909-4961-9FBB-82C60D7CC773",
    name: "arrow-up",
    codepoint: "F05D",
    aliases: ["arrow-upward"],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M13,20H11V8L5.5,13.5L4.08,12.08L12,4.16L19.92,12.08L18.5,13.5L13,8V20Z",
  },
  {
    id: "36199A40-CCCB-44B9-A6B0-73F7315E5716",
    name: "arrow-up-bold",
    codepoint: "F736",
    aliases: [],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M15,20H9V12H4.16L12,4.16L19.84,12H15V20Z",
  },
  {
    id: "062452EE-7669-4C36-85E6-A85BBA735348",
    name: "arrow-up-bold-box",
    codepoint: "F737",
    aliases: [],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21M12,7L7,12H10V16H14V12H17L12,7Z",
  },
  {
    id: "5386BD1B-8959-4312-8739-5B08021F319D",
    name: "arrow-up-bold-box-outline",
    codepoint: "F738",
    aliases: [],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M12,7L17,12H14V16H10V12H7L12,7M19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21M19,19V5H5V19H19Z",
  },
  {
    id: "D6719240-C87E-4185-B694-1EA5FFC94F4E",
    name: "arrow-up-bold-circle",
    codepoint: "F05F",
    aliases: [],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22M12,7L7,12H10V16H14V12H17L12,7Z",
  },
  {
    id: "3337B267-94EC-426B-ABC9-5842F75B13B1",
    name: "arrow-up-bold-circle-outline",
    codepoint: "F060",
    aliases: [],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,7L17,12H14V16H10V12H7L12,7M12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22M12,20C16.42,20 20,16.42 20,12C20,7.58 16.42,4 12,4C7.58,4 4,7.58 4,12C4,16.42 7.58,20 12,20Z",
  },
  {
    id: "7C3BD067-49AB-41C8-9091-FBD2D533045E",
    name: "arrow-up-bold-hexagon-outline",
    codepoint: "F061",
    aliases: [],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,7L17,12H14V16H10V12H7L12,7M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5M12,4.15L5,8.09V15.91L12,19.85L19,15.91V8.09L12,4.15Z",
  },
  {
    id: "664AA4B5-DD9C-40AD-A69E-3CD314025AD3",
    name: "arrow-up-bold-outline",
    codepoint: "F9C6",
    aliases: [],
    tags: [],
    author: "Michael Irigoyen",
    version: "2.5.94",
    path: "M16,13V21H8V13H2L12,3L22,13H16M7,11H10V19H14V11H17L12,6L7,11Z",
  },
  {
    id: "82958DF7-5F5F-4470-BFB4-4389937B4D29",
    name: "arrow-up-box",
    codepoint: "F6C2",
    aliases: [],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.8.36",
    path: "M21,19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3H19C20.11,3 21,3.9 21,5V19M13,18V9.5L16.5,13L17.92,11.58L12,5.66L6.08,11.58L7.5,13L11,9.5V18H13Z",
  },
  {
    id: "1F1BE05B-E67A-4646-A8B3-08423BD58673",
    name: "arrow-up-down-bold-outline",
    codepoint: "F9C7",
    aliases: [],
    tags: [],
    author: "Michael Irigoyen",
    version: "2.5.94",
    path: "M16,10H22L12,0L2,10H8V14H2L12,24L22,14H16V10M14,16H17L12,21L7,16H10V8H7L12,3L17,8H14V16Z",
  },
  {
    id: "73B211DB-05CF-4025-B035-AD03454C47A6",
    name: "arrow-up-drop-circle",
    codepoint: "F062",
    aliases: [],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22M17,14L12,9L7,14H17Z",
  },
  {
    id: "42277E7D-D87A-4DE9-982B-37E6A8AE4E70",
    name: "arrow-up-drop-circle-outline",
    codepoint: "F063",
    aliases: [],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22M12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20M17,14L12,9L7,14H17Z",
  },
  {
    id: "4EDBF232-461F-4F4C-82BB-64A89BA08405",
    name: "arrow-up-thick",
    codepoint: "F05E",
    aliases: [],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M14,20H10V11L6.5,14.5L4.08,12.08L12,4.16L19.92,12.08L17.5,14.5L14,11V20Z",
  },
  {
    id: "0C612FE5-D7CC-44F3-945A-4BD15A7E39BA",
    name: "assistant",
    codepoint: "F064",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M19,2H5C3.9,2 3,2.9 3,4V18C3,19.1 3.9,20 5,20H9L12,23L15,20H19C20.1,20 21,19.1 21,18V4C21,2.9 20.1,2 19,2M13.88,12.88L12,17L10.12,12.88L6,11L10.12,9.12L12,5L13.88,9.12L18,11",
  },
  {
    id: "E8C373FE-4258-4341-B52A-E33D9A484968",
    name: "asterisk",
    codepoint: "F6C3",
    aliases: [],
    tags: [],
    author: "Michael Irigoyen",
    version: "1.8.36",
    path: "M10,2H14L13.21,9.91L19.66,5.27L21.66,8.73L14.42,12L21.66,15.27L19.66,18.73L13.21,14.09L14,22H10L10.79,14.09L4.34,18.73L2.34,15.27L9.58,12L2.34,8.73L4.34,5.27L10.79,9.91L10,2Z",
  },
  {
    id: "9FC24609-9C8B-4DBA-A473-F5EFAFCC90DF",
    name: "at",
    codepoint: "F065",
    aliases: ["alternate-email"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M12,15C12.81,15 13.5,14.7 14.11,14.11C14.7,13.5 15,12.81 15,12C15,11.19 14.7,10.5 14.11,9.89C13.5,9.3 12.81,9 12,9C11.19,9 10.5,9.3 9.89,9.89C9.3,10.5 9,11.19 9,12C9,12.81 9.3,13.5 9.89,14.11C10.5,14.7 11.19,15 12,15M12,2C14.75,2 17.1,3 19.05,4.95C21,6.9 22,9.25 22,12V13.45C22,14.45 21.65,15.3 21,16C20.3,16.67 19.5,17 18.5,17C17.3,17 16.31,16.5 15.56,15.5C14.56,16.5 13.38,17 12,17C10.63,17 9.45,16.5 8.46,15.54C7.5,14.55 7,13.38 7,12C7,10.63 7.5,9.45 8.46,8.46C9.45,7.5 10.63,7 12,7C13.38,7 14.55,7.5 15.54,8.46C16.5,9.45 17,10.63 17,12V13.45C17,13.86 17.16,14.22 17.46,14.53C17.76,14.84 18.11,15 18.5,15C18.92,15 19.27,14.84 19.57,14.53C19.87,14.22 20,13.86 20,13.45V12C20,9.81 19.23,7.93 17.65,6.35C16.07,4.77 14.19,4 12,4C9.81,4 7.93,4.77 6.35,6.35C4.77,7.93 4,9.81 4,12C4,14.19 4.77,16.07 6.35,17.65C7.93,19.23 9.81,20 12,20H17V22H12C9.25,22 6.9,21 4.95,19.05C3,17.1 2,14.75 2,12C2,9.25 3,6.9 4.95,4.95C6.9,3 9.25,2 12,2Z",
  },
  {
    id: "25806C84-E41E-43A7-93AF-EA4ABACA982E",
    name: "atlassian",
    codepoint: "F803",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Michael Richins",
    version: "2.1.19",
    path: "M7.93,11.24C7.74,11 7.38,10.94 7.13,11.13C7.06,11.19 7,11.26 6.96,11.34L2.06,21.15C1.91,21.44 2.03,21.79 2.32,21.94C2.4,22 2.5,22 2.59,22H9.41C9.63,22 9.84,21.88 9.94,21.68C11.41,18.63 10.5,14 7.93,11.24M11.53,2.31C9.05,6.14 8.76,11 10.77,15.09L14.06,21.68C14.17,21.88 14.37,22 14.59,22H21.41C21.74,22 22,21.74 22,21.41C22,21.32 22,21.23 21.94,21.15C21.94,21.15 12.76,2.77 12.5,2.31C12.39,2.04 12.06,1.92 11.78,2.06C11.67,2.11 11.58,2.2 11.53,2.31Z",
  },
  {
    id: "C366C8B8-44FB-481E-88F2-AE0C3B1E8C74",
    name: "atom",
    codepoint: "F767",
    aliases: [],
    tags: ["Science"],
    author: "Roberto Graham",
    version: "1.9.32",
    path: "M12,11C12.55,11 13,11.45 13,12C13,12.55 12.55,13 12,13C11.45,13 11,12.55 11,12C11,11.45 11.45,11 12,11M4.22,4.22C5.65,2.79 8.75,3.43 12,5.56C15.25,3.43 18.35,2.79 19.78,4.22C21.21,5.65 20.57,8.75 18.44,12C20.57,15.25 21.21,18.35 19.78,19.78C18.35,21.21 15.25,20.57 12,18.44C8.75,20.57 5.65,21.21 4.22,19.78C2.79,18.35 3.43,15.25 5.56,12C3.43,8.75 2.79,5.65 4.22,4.22M15.54,8.46C16.15,9.08 16.71,9.71 17.23,10.34C18.61,8.21 19.11,6.38 18.36,5.64C17.62,4.89 15.79,5.39 13.66,6.77C14.29,7.29 14.92,7.85 15.54,8.46M8.46,15.54C7.85,14.92 7.29,14.29 6.77,13.66C5.39,15.79 4.89,17.62 5.64,18.36C6.38,19.11 8.21,18.61 10.34,17.23C9.71,16.71 9.08,16.15 8.46,15.54M5.64,5.64C4.89,6.38 5.39,8.21 6.77,10.34C7.29,9.71 7.85,9.08 8.46,8.46C9.08,7.85 9.71,7.29 10.34,6.77C8.21,5.39 6.38,4.89 5.64,5.64M9.88,14.12C10.58,14.82 11.3,15.46 12,16.03C12.7,15.46 13.42,14.82 14.12,14.12C14.82,13.42 15.46,12.7 16.03,12C15.46,11.3 14.82,10.58 14.12,9.88C13.42,9.18 12.7,8.54 12,7.97C11.3,8.54 10.58,9.18 9.88,9.88C9.18,10.58 8.54,11.3 7.97,12C8.54,12.7 9.18,13.42 9.88,14.12M18.36,18.36C19.11,17.62 18.61,15.79 17.23,13.66C16.71,14.29 16.15,14.92 15.54,15.54C14.92,16.15 14.29,16.71 13.66,17.23C15.79,18.61 17.62,19.11 18.36,18.36Z",
  },
  {
    id: "E3C20B38-A6D3-4EF0-817D-863B25E555BA",
    name: "attachment",
    codepoint: "F066",
    aliases: ["paperclip-horizontal"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M7.5,18C4.46,18 2,15.54 2,12.5C2,9.46 4.46,7 7.5,7H18C20.21,7 22,8.79 22,11C22,13.21 20.21,15 18,15H9.5C8.12,15 7,13.88 7,12.5C7,11.12 8.12,10 9.5,10H17V11.5H9.5C8.95,11.5 8.5,11.95 8.5,12.5C8.5,13.05 8.95,13.5 9.5,13.5H18C19.38,13.5 20.5,12.38 20.5,11C20.5,9.62 19.38,8.5 18,8.5H7.5C5.29,8.5 3.5,10.29 3.5,12.5C3.5,14.71 5.29,16.5 7.5,16.5H17V18H7.5Z",
  },
  {
    id: "79CBF0E5-365C-466B-B162-2EBD1531F182",
    name: "audio-video",
    codepoint: "F93C",
    aliases: [],
    tags: ["Home Automation"],
    author: "Michael Richins",
    version: "2.4.85",
    path: "M20,7H4C2.9,7 2,7.9 2,9V15C2,16.1 2.9,17 4,17H5V18C5,18.6 5.4,19 6,19H8C8.6,19 9,18.6 9,18V17H15V18C15,18.6 15.4,19 16,19H18C18.6,19 19,18.6 19,18V17H20C21.1,17 22,16.1 22,15V9C22,7.9 21.1,7 20,7M14,12H4V10H14V12M18,13C16.9,13 16,12.1 16,11C16,9.9 16.9,9 18,9C19.1,9 20,9.9 20,11C20,12.1 19.1,13 18,13M6,15H4V14H6V15M10,15H8V14H10V15M14,15H12V14H14V15Z",
  },
  {
    id: "FC29D627-D661-4F31-9BEC-2F4BE355DFE7",
    name: "augmented-reality",
    codepoint: "F84F",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "2.1.99",
    path: "M5,3C3.89,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3H5M7.75,9H9.25L11,15H9.5L9.21,14H7.79L7.5,15H6L7.75,9M13,9H16.5C17.35,9 18,9.65 18,10.5V11.5C18,12.1 17.6,12.65 17.1,12.9L18,15H16.5L15.65,13H14.5V15H13V9M14.5,10.5V11.5H16.5V10.5H14.5M8.5,11.57L8.23,12.5H8.77L8.5,11.57Z",
  },
  {
    id: "FAAFAACC-4E0D-4688-B583-FC88A782A9B6",
    name: "auto-fix",
    codepoint: "F068",
    aliases: ["magic", "wand", "auto-fix-high"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M7.5,5.6L5,7L6.4,4.5L5,2L7.5,3.4L10,2L8.6,4.5L10,7L7.5,5.6M19.5,15.4L22,14L20.6,16.5L22,19L19.5,17.6L17,19L18.4,16.5L17,14L19.5,15.4M22,2L20.6,4.5L22,7L19.5,5.6L17,7L18.4,4.5L17,2L19.5,3.4L22,2M13.34,12.78L15.78,10.34L13.66,8.22L11.22,10.66L13.34,12.78M14.37,7.29L16.71,9.63C17.1,10 17.1,10.65 16.71,11.04L5.04,22.71C4.65,23.1 4,23.1 3.63,22.71L1.29,20.37C0.9,20 0.9,19.35 1.29,18.96L12.96,7.29C13.35,6.9 14,6.9 14.37,7.29Z",
  },
  {
    id: "3DEAD47C-90B3-485E-943C-CE2D70C85154",
    name: "auto-upload",
    codepoint: "F069",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M5.35,12.65L6.5,9L7.65,12.65M5.5,7L2.3,16H4.2L4.9,14H8.1L8.8,16H10.7L7.5,7M11,20H22V18H11M14,16H19V11H22L16.5,5.5L11,11H14V16Z",
  },
  {
    id: "00598C19-1255-479D-914A-1AADFDBC4868",
    name: "autorenew",
    codepoint: "F06A",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M12,6V9L16,5L12,1V4C7.58,4 4,7.58 4,12C4,13.57 4.46,15.03 5.24,16.26L6.7,14.8C6.25,13.97 6,13 6,12C6,8.69 8.69,6 12,6M18.76,7.74L17.3,9.2C17.74,10.04 18,11 18,12C18,15.31 15.31,18 12,18V15L8,19L12,23V20C16.42,20 20,16.42 20,12C20,10.43 19.54,8.97 18.76,7.74Z",
  },
  {
    id: "A118E3CD-FF18-48FD-B26C-B4A48641E4C5",
    name: "av-timer",
    codepoint: "F06B",
    aliases: [],
    tags: ["Date / Time"],
    author: "Google",
    version: "1.5.54",
    path: "M11,17C11,17.55 11.45,18 12,18C12.55,18 13,17.55 13,17C13,16.45 12.55,16 12,16C11.45,16 11,16.45 11,17M11,3V7H13V5.08C16.39,5.57 19,8.47 19,12C19,15.87 15.87,19 12,19C8.13,19 5,15.87 5,12C5,10.32 5.59,8.78 6.58,7.58L12,13L13.41,11.59L6.61,4.79V4.81C4.42,6.45 3,9.05 3,12C3,16.97 7.03,21 12,21C16.97,21 21,16.97 21,12C21,7.03 16.97,3 12,3M18,12C18,11.45 17.55,11 17,11C16.45,11 16,11.45 16,12C16,12.55 16.45,13 17,13C17.55,13 18,12.55 18,12M6,12C6,12.55 6.45,13 7,13C7.55,13 8,12.55 8,12C8,11.45 7.55,11 7,11C6.45,11 6,11.45 6,12Z",
  },
  {
    id: "B6119C36-82C4-4C6F-98D5-B339A73C837E",
    name: "axe",
    codepoint: "F8C7",
    aliases: [],
    tags: ["Hardware / Tools"],
    author: "Nick",
    version: "2.3.50",
    path: "M12,2L22,8C22,12 20,14 16,15L13,10L9,6L12,2M4.11,19.84L2.12,18.33L9.19,9L11,10.81L4.11,19.84Z",
  },
  {
    id: "2CD51EFC-51B6-4323-B1EA-429EB58BFF7F",
    name: "baby",
    codepoint: "F06C",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M18.5,4C19.88,4 21,5.12 21,6.5C21,7.88 19.88,9 18.5,9C17.12,9 16,7.88 16,6.5C16,5.12 17.12,4 18.5,4M4.5,20C3.67,20 3,19.33 3,18.5C3,17.67 3.67,17 4.5,17H11.5C12.33,17 13,17.67 13,18.5C13,19.33 12.33,20 11.5,20H4.5M16.09,19L14.69,15H11L6.75,10.75C6.75,10.75 9,8.25 12.5,8.25C15.5,8.25 15.85,9.25 16.06,9.87L18.92,18C19.2,18.78 18.78,19.64 18,19.92C17.22,20.19 16.36,19.78 16.09,19Z",
  },
  {
    id: "FA711E97-6083-45AA-9C92-FCCDABC57D37",
    name: "baby-buggy",
    codepoint: "F68E",
    aliases: ["child-friendly"],
    tags: [],
    author: "Google",
    version: "1.7.12",
    path: "M13,2V10H21C21,5.58 17.42,2 13,2M19.32,15.89C20.37,14.54 21,12.84 21,11H6.44L5.5,9H2V11H4.22C4.22,11 6.11,15.07 6.34,15.42C5.24,16 4.5,17.17 4.5,18.5C4.5,20.43 6.07,22 8,22C9.76,22 11.22,20.7 11.46,19H13.54C13.78,20.7 15.24,22 17,22C18.93,22 20.5,20.43 20.5,18.5C20.5,17.46 20.04,16.53 19.32,15.89M8,20C7.17,20 6.5,19.33 6.5,18.5C6.5,17.67 7.17,17 8,17C8.83,17 9.5,17.67 9.5,18.5C9.5,19.33 8.83,20 8,20M17,20C16.17,20 15.5,19.33 15.5,18.5C15.5,17.67 16.17,17 17,17C17.83,17 18.5,17.67 18.5,18.5C18.5,19.33 17.83,20 17,20Z",
  },
  {
    id: "5A5BC824-220B-4998-883A-0E57FB2AB75F",
    name: "backburger",
    codepoint: "F06D",
    aliases: ["hamburger-menu-back"],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M5,13L9,17L7.6,18.42L1.18,12L7.6,5.58L9,7L5,11H21V13H5M21,6V8H11V6H21M21,16V18H11V16H21Z",
  },
  {
    id: "2AAC06E6-8ABD-418B-B9A4-8554B62D7C04",
    name: "backspace",
    codepoint: "F06E",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M22,3H7C6.31,3 5.77,3.35 5.41,3.88L0,12L5.41,20.11C5.77,20.64 6.31,21 7,21H22C23.1,21 24,20.1 24,19V5C24,3.9 23.1,3 22,3M19,15.59L17.59,17L14,13.41L10.41,17L9,15.59L12.59,12L9,8.41L10.41,7L14,10.59L17.59,7L19,8.41L15.41,12",
  },
  {
    id: "36F8C2B4-C82C-4546-AFFC-601ECA54A603",
    name: "backup-restore",
    codepoint: "F06F",
    aliases: ["settings-backup-restore"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M12,3C7.03,3 3,7.03 3,12H0L4,16L8,12H5C5,8.13 8.13,5 12,5C15.87,5 19,8.13 19,12C19,15.87 15.87,19 12,19C10.5,19 9.09,18.5 7.94,17.7L6.5,19.14C8.04,20.3 9.94,21 12,21C16.97,21 21,16.97 21,12C21,7.03 16.97,3 12,3M14,12C14,10.9 13.1,10 12,10C10.9,10 10,10.9 10,12C10,13.1 10.9,14 12,14C13.1,14 14,13.1 14,12Z",
  },
  {
    id: "AF478988-12FA-460A-AE5B-01536D6D5B97",
    name: "badminton",
    codepoint: "F850",
    aliases: ["shuttlecock"],
    tags: ["Sport"],
    author: "Nick",
    version: "2.1.99",
    path: "M12.3,2C11.33,2.03 10.58,2.84 10.61,3.8C10.62,4.04 10.67,4.27 10.77,4.5L11.06,5.14V5.14C11.1,5.27 11.03,5.41 10.89,5.45C10.8,5.5 10.7,5.45 10.63,5.37L10.21,4.82C9.88,4.4 9.38,4.14 8.85,4.13C7.88,4.11 7.08,4.88 7.06,5.84C7.05,6.26 7.19,6.66 7.45,7L7.87,7.5H7.88C7.96,7.63 7.93,7.79 7.82,7.87C7.73,7.94 7.61,7.94 7.53,7.87L7,7.45C6.66,7.19 6.25,7.05 5.84,7.06C4.88,7.08 4.11,7.88 4.13,8.85C4.14,9.38 4.4,9.88 4.82,10.21L5.39,10.65C5.5,10.75 5.5,10.91 5.38,11C5.31,11.07 5.21,11.09 5.12,11.05H5.11L4.5,10.77C4.27,10.68 4.04,10.62 3.8,10.61C2.84,10.58 2.03,11.34 2,12.31C2,13.03 2.4,13.69 3.06,13.97L14.45,19.04L19.04,14.45L13.97,3.06C13.69,2.39 13,1.97 12.3,2M13.13,6.1C13.55,6.09 13.93,6.33 14.09,6.71L17.14,13.55L13.19,9.61L12.26,7.5C11.96,6.87 12.42,6.12 13.13,6.1M9.85,8.85C10.12,8.85 10.37,8.95 10.56,9.15L15.37,13.96C15.77,14.34 15.78,14.97 15.4,15.37C15,15.77 14.38,15.78 13.96,15.37L9.15,10.56C8.75,10.18 8.74,9.54 9.13,9.15C9.32,8.95 9.58,8.85 9.85,8.85M7.13,12.17C7.26,12.17 7.4,12.21 7.5,12.26L9.63,13.2L13.57,17.14L6.71,14.09C5.69,13.65 6.03,12.14 7.13,12.17M20.28,16.04L16.04,20.28L16.89,21.13C17.65,21.88 18.75,22.17 19.78,21.9C20.81,21.62 21.62,20.81 21.9,19.78C22.17,18.75 21.88,17.65 21.13,16.89L20.28,16.04Z",
  },
  {
    id: "27AB71F3-1EFD-484F-8E63-C1E4C694E392",
    name: "ballot",
    codepoint: "F9C8",
    aliases: [],
    tags: [],
    author: "Google",
    version: "2.5.94",
    path: "M13,9.5H18V7.5H13V9.5M13,16.5H18V14.5H13V16.5M19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21M6,11H11V6H6V11M7,7H10V10H7V7M6,18H11V13H6V18M7,14H10V17H7V14Z",
  },
  {
    id: "B9CDE0FA-F96A-413C-9BFD-DAB4DBC3DDE3",
    name: "ballot-outline",
    codepoint: "F9C9",
    aliases: [],
    tags: [],
    author: "Google",
    version: "2.5.94",
    path: "M13,7.5H18V9.5H13V7.5M13,14.5H18V16.5H13V14.5M19,3C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3H19M19,19V5H5V19H19M11,6V11H6V6H11M10,10V7H7V10H10M11,13V18H6V13H11M10,17V14H7V17H10Z",
  },
  {
    id: "38278159-AC2C-433A-9335-95B05C1F6F56",
    name: "bandcamp",
    codepoint: "F674",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.7.12",
    path: "M22,6L15.5,18H2L8.5,6H22Z",
  },
  {
    id: "FE08919F-CFFC-4A25-994C-CEDEB299908B",
    name: "bank",
    codepoint: "F070",
    aliases: ["account-balance"],
    tags: ["Banking", "Places"],
    author: "Google",
    version: "1.5.54",
    path: "M11.5,1L2,6V8H21V6M16,10V17H19V10M2,22H21V19H2M10,10V17H13V10M4,10V17H7V10H4Z",
  },
  {
    id: "5231CD58-9C30-40A8-993C-A24C6B70F6B8",
    name: "barcode",
    codepoint: "F071",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M2,6H4V18H2V6M5,6H6V18H5V6M7,6H10V18H7V6M11,6H12V18H11V6M14,6H16V18H14V6M17,6H20V18H17V6M21,6H22V18H21V6Z",
  },
  {
    id: "40365CB0-4664-4648-8C51-2E6E20A0D096",
    name: "barcode-scan",
    codepoint: "F072",
    aliases: ["barcode-scanner"],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M4,6H6V18H4V6M7,6H8V18H7V6M9,6H12V18H9V6M13,6H14V18H13V6M16,6H18V18H16V6M19,6H20V18H19V6M2,4V8H0V4C0,2.9 0.9,2 2,2H6V4H2M22,2C23.1,2 24,2.9 24,4V8H22V4H18V2H22M2,16V20H6V22H2C0.9,22 0,21.1 0,20V16H2M22,20V16H24V20C24,21.1 23.1,22 22,22H18V20H22Z",
  },
  {
    id: "5126A5A7-ECBC-49FC-BBC6-1703DCACF5E4",
    name: "barley",
    codepoint: "F073",
    aliases: ["grain"],
    tags: ["Agriculture", "Food / Drink"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M7.33,18.33C6.5,17.17 6.5,15.83 6.5,14.5C8.17,15.5 9.83,16.5 10.67,17.67L11,18.23V15.95C9.5,15.05 8.08,14.13 7.33,13.08C6.5,11.92 6.5,10.58 6.5,9.25C8.17,10.25 9.83,11.25 10.67,12.42L11,13V10.7C9.5,9.8 8.08,8.88 7.33,7.83C6.5,6.67 6.5,5.33 6.5,4C8.17,5 9.83,6 10.67,7.17C10.77,7.31 10.86,7.46 10.94,7.62C10.77,7 10.66,6.42 10.65,5.82C10.64,4.31 11.3,2.76 11.96,1.21C12.65,2.69 13.34,4.18 13.35,5.69C13.36,6.32 13.25,6.96 13.07,7.59C13.15,7.45 13.23,7.31 13.33,7.17C14.17,6 15.83,5 17.5,4C17.5,5.33 17.5,6.67 16.67,7.83C15.92,8.88 14.5,9.8 13,10.7V13L13.33,12.42C14.17,11.25 15.83,10.25 17.5,9.25C17.5,10.58 17.5,11.92 16.67,13.08C15.92,14.13 14.5,15.05 13,15.95V18.23L13.33,17.67C14.17,16.5 15.83,15.5 17.5,14.5C17.5,15.83 17.5,17.17 16.67,18.33C15.92,19.38 14.5,20.3 13,21.2V23H11V21.2C9.5,20.3 8.08,19.38 7.33,18.33Z",
  },
  {
    id: "CD3098D2-892F-49F5-9FA7-1A5FDC53A15C",
    name: "barrel",
    codepoint: "F074",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M18,19H19V21H5V19H6V13H5V11H6V5H5V3H19V5H18V11H19V13H18V19M9,13C9,14.66 10.34,16 12,16C13.66,16 15,14.66 15,13C15,11 12,7.63 12,7.63C12,7.63 9,11 9,13Z",
  },
  {
    id: "EDAC5CB7-39B3-4DAD-89ED-38D7EA914211",
    name: "baseball",
    codepoint: "F851",
    aliases: [],
    tags: ["Sport"],
    author: "Nick",
    version: "2.1.99",
    path: "M12,2C9.5,2 7.25,2.9 5.5,4.4C6,4.81 6.41,5.27 6.8,5.76L7.89,5.13L8.89,6.87L7.89,7.44C8.45,8.53 8.82,9.73 8.95,11H10V12L10,13H8.95C8.82,14.27 8.45,15.47 7.89,16.56L8.89,17.13L7.89,18.87L6.8,18.24C6.41,18.73 6,19.19 5.5,19.6C7.25,21.1 9.5,22 12,22C14.5,22 16.75,21.1 18.5,19.6C18,19.19 17.59,18.73 17.19,18.24L16.11,18.87L15.11,17.13L16.11,16.55C15.55,15.47 15.18,14.27 15.05,13H14V11H15.05C15.18,9.73 15.55,8.53 16.11,7.45L15.11,6.87L16.11,5.13L17.19,5.76C17.59,5.27 18,4.81 18.5,4.4C16.75,2.9 14.5,2 12,2M4.12,5.85C2.79,7.55 2,9.68 2,12C2,14.32 2.79,16.45 4.12,18.15C4.46,17.87 4.76,17.55 5.05,17.22L4.43,16.87L5.43,15.13L6.16,15.56C6.55,14.77 6.82,13.91 6.93,13H6V12L6,11H6.93C6.82,10.09 6.55,9.23 6.16,8.44L5.43,8.87L4.43,7.13L5.05,6.78C4.76,6.45 4.46,6.13 4.12,5.85M19.88,5.85C19.54,6.13 19.24,6.45 18.95,6.78L19.57,7.13L18.57,8.87L17.84,8.44C17.45,9.23 17.18,10.09 17.07,11H18V13H17.07C17.18,13.91 17.45,14.77 17.84,15.56L18.57,15.13L19.57,16.87L18.95,17.22C19.24,17.55 19.54,17.87 19.88,18.15C21.21,16.45 22,14.32 22,12C22,9.68 21.21,7.55 19.88,5.85Z",
  },
  {
    id: "20D31EB1-5C7F-4597-9B42-80E08E0192F8",
    name: "baseball-bat",
    codepoint: "F852",
    aliases: [],
    tags: ["Sport"],
    author: "Nick",
    version: "2.1.99",
    path: "M20,2C19.72,2 19.5,2.11 19.29,2.29L9.79,11.79C9.75,11.83 9.72,11.87 7.23,15.35L4,18.59L3.71,18.29C3.5,18.1 3.26,18 3,18C2.44,18 2,18.44 2,19C2,19.26 2.1,19.5 2.29,19.71L4.29,21.71C4.68,22.11 5.31,22.12 5.71,21.74C6.11,21.35 6.12,20.72 5.71,20.29L5.41,20L8.64,16.77L12.21,14.21L21.71,4.71C22.1,4.32 22.1,3.68 21.71,3.29L20.71,2.29C20.5,2.1 20.26,2 20,2M18.5,13C17.12,13 16,14.12 16,15.5C16,16.88 17.12,18 18.5,18C19.88,18 21,16.88 21,15.5C21,14.12 19.88,13 18.5,13Z",
  },
  {
    id: "4E334FE9-DF93-469A-B7D7-AC88BBF25D84",
    name: "basket",
    codepoint: "F076",
    aliases: ["shopping-basket"],
    tags: ["Shopping"],
    author: "Google",
    version: "1.5.54",
    path: "M5.5,21C4.72,21 4.04,20.55 3.71,19.9V19.9L1.1,10.44L1,10C1,9.45 1.45,9 2,9H6.58L11.18,2.43C11.36,2.17 11.66,2 12,2C12.34,2 12.65,2.17 12.83,2.44L17.42,9H22C22.55,9 23,9.45 23,10L22.96,10.29L20.29,19.9C19.96,20.55 19.28,21 18.5,21H5.5M12,4.74L9,9H15L12,4.74M12,13C10.9,13 10,13.9 10,15C10,16.1 10.9,17 12,17C13.1,17 14,16.1 14,15C14,13.9 13.1,13 12,13Z",
  },
  {
    id: "9B7DC550-62F9-4FB0-9B21-0379AA925A19",
    name: "basket-fill",
    codepoint: "F077",
    aliases: [],
    tags: ["Shopping"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M3,2H6V5H3V2M6,7H9V10H6V7M8,2H11V5H8V2M17,11L12,6H15V2H19V6H22L17,11M7.5,22C6.72,22 6.04,21.55 5.71,20.9V20.9L3.1,13.44L3,13C3,12.45 3.45,12 4,12H20C20.55,12 21,12.45 21,13L20.96,13.29L18.29,20.9C17.96,21.55 17.28,22 16.5,22H7.5M7.61,20H16.39L18.57,14H5.42L7.61,20Z",
  },
  {
    id: "D46B98B3-4045-4EAD-A26E-659195B5CC65",
    name: "basket-unfill",
    codepoint: "F078",
    aliases: [],
    tags: ["Shopping"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M3,10H6V7H3V10M5,5H8V2H5V5M8,10H11V7H8V10M17,1L12,6H15V10H19V6H22L17,1M7.5,22C6.72,22 6.04,21.55 5.71,20.9V20.9L3.1,13.44L3,13C3,12.45 3.45,12 4,12H20C20.55,12 21,12.45 21,13L20.96,13.29L18.29,20.9C17.96,21.55 17.28,22 16.5,22H7.5M7.61,20H16.39L18.57,14H5.42L7.61,20Z",
  },
  {
    id: "FD797202-9EF1-407E-A290-97C014B8F37E",
    name: "basketball",
    codepoint: "F805",
    aliases: ["youtube-sports"],
    tags: ["Sport"],
    author: "Google",
    version: "2.1.19",
    path: "M2.34,14.63C2.94,14.41 3.56,14.3 4.22,14.3C5.56,14.3 6.73,14.72 7.73,15.56L4.59,18.7C3.53,17.5 2.78,16.13 2.34,14.63M15.56,9.8C17.53,11.27 19.66,11.63 21.94,10.88C21.97,11.09 22,11.47 22,12C22,13.03 21.75,14.18 21.28,15.45C20.81,16.71 20.23,17.73 19.55,18.5L13.22,12.19L15.56,9.8M8.77,16.64C9.83,18.17 10.05,19.84 9.42,21.66C8,21.25 6.73,20.61 5.67,19.73L8.77,16.64M12.19,13.22L18.5,19.55C16.33,21.45 13.78,22.25 10.88,21.94C11.09,21.28 11.2,20.56 11.2,19.78C11.2,19.16 11.06,18.43 10.78,17.6C10.5,16.77 10.17,16.09 9.8,15.56L12.19,13.22M8.81,14.5C7.88,13.67 6.8,13.15 5.58,12.91C4.36,12.68 3.19,12.75 2.06,13.13C2.03,12.91 2,12.53 2,12C2,10.97 2.25,9.82 2.72,8.55C3.19,7.29 3.77,6.27 4.45,5.5L11.11,12.19L8.81,14.5M15.56,7.73C14.22,6.08 13.91,4.28 14.63,2.34C15.25,2.5 15.96,2.8 16.76,3.26C17.55,3.71 18.2,4.16 18.7,4.59L15.56,7.73M21.66,9.38C21.06,9.59 20.44,9.7 19.78,9.7C18.69,9.7 17.64,9.38 16.64,8.72L19.73,5.67C20.61,6.77 21.25,8 21.66,9.38M12.19,11.11L5.5,4.45C7.67,2.55 10.22,1.75 13.13,2.06C12.91,2.72 12.8,3.44 12.8,4.22C12.8,4.94 12.96,5.75 13.29,6.66C13.62,7.56 14,8.28 14.5,8.81L12.19,11.11Z",
  },
  {
    id: "C12D919F-7D0D-4355-8109-912BA37154B5",
    name: "battery",
    codepoint: "F079",
    aliases: ["battery-full", "battery-std", "battery-100"],
    tags: ["Battery", "Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M16.67,4H15V2H9V4H7.33C6.6,4 6,4.6 6,5.33V20.67C6,21.4 6.6,22 7.33,22H16.67C17.4,22 18,21.4 18,20.67V5.33C18,4.6 17.4,4 16.67,4Z",
  },
  {
    id: "D753B56C-E806-4F17-B2A0-EBC4B4B78D19",
    name: "battery-10",
    codepoint: "F07A",
    aliases: [],
    tags: ["Battery", "Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M16,18H8V6H16M16.67,4H15V2H9V4H7.33C6.6,4 6,4.6 6,5.33V20.67C6,21.4 6.6,22 7.33,22H16.67C17.4,22 18,21.4 18,20.67V5.33C18,4.6 17.4,4 16.67,4Z",
  },
  {
    id: "9C8DAC10-97C6-476E-8122-25D7709F7AF6",
    name: "battery-10-bluetooth",
    codepoint: "F93D",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "2.4.85",
    path: "M5,2V4H3.33C2.6,4 2,4.6 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33C14,4.6 13.4,4 12.67,4H11V2H5M4,6H12V18H4V6M19,8V11.79L16.71,9.5L16,10.21L18.79,13L16,15.79L16.71,16.5L19,14.21V18H19.5L22.35,15.14L20.21,13L22.35,10.85L19.5,8H19M20,9.91L20.94,10.85L20,11.79V9.91M20,14.21L20.94,15.14L20,16.08V14.21Z",
  },
  {
    id: "95AEB324-9D57-4D27-B463-0C8077C04E24",
    name: "battery-20",
    codepoint: "F07B",
    aliases: [],
    tags: ["Battery", "Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M16,17H8V6H16M16.67,4H15V2H9V4H7.33C6.6,4 6,4.6 6,5.33V20.67C6,21.4 6.6,22 7.33,22H16.67C17.4,22 18,21.4 18,20.67V5.33C18,4.6 17.4,4 16.67,4Z",
  },
  {
    id: "9BA1E9FB-BB6A-447E-9F35-615CCC81CD81",
    name: "battery-20-bluetooth",
    codepoint: "F93E",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "2.4.85",
    path: "M5,2V4H3.33C2.6,4 2,4.6 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33C14,4.6 13.4,4 12.67,4H11V2H5M4,6H12V17H4V6M19,8V11.79L16.71,9.5L16,10.21L18.79,13L16,15.79L16.71,16.5L19,14.21V18H19.5L22.35,15.14L20.21,13L22.35,10.85L19.5,8H19M20,9.91L20.94,10.85L20,11.79V9.91M20,14.21L20.94,15.14L20,16.08V14.21Z",
  },
  {
    id: "970E1F42-4594-42CD-BB4E-6F5CBDBF5D21",
    name: "battery-30",
    codepoint: "F07C",
    aliases: [],
    tags: ["Battery", "Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M16,15H8V6H16M16.67,4H15V2H9V4H7.33C6.6,4 6,4.6 6,5.33V20.67C6,21.4 6.6,22 7.33,22H16.67C17.4,22 18,21.4 18,20.67V5.33C18,4.6 17.4,4 16.67,4Z",
  },
  {
    id: "6128BD10-A4CD-440E-BF98-151777783110",
    name: "battery-30-bluetooth",
    codepoint: "F93F",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "2.4.85",
    path: "M5,2V4H3.33C2.6,4 2,4.6 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33C14,4.6 13.4,4 12.67,4H11V2H5M4,6H12V15H4V6M19,8V11.79L16.71,9.5L16,10.21L18.79,13L16,15.79L16.71,16.5L19,14.21V18H19.5L22.35,15.14L20.21,13L22.35,10.85L19.5,8H19M20,9.91L20.94,10.85L20,11.79V9.91M20,14.21L20.94,15.14L20,16.08V14.21Z",
  },
  {
    id: "EE290FAF-A1D6-4A0D-8BBA-8DD2455AFB82",
    name: "battery-40",
    codepoint: "F07D",
    aliases: [],
    tags: ["Battery", "Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M16,14H8V6H16M16.67,4H15V2H9V4H7.33C6.6,4 6,4.6 6,5.33V20.67C6,21.4 6.6,22 7.33,22H16.67C17.4,22 18,21.4 18,20.67V5.33C18,4.6 17.4,4 16.67,4Z",
  },
  {
    id: "058D5094-AB60-4412-8C71-6CF4A56784A6",
    name: "battery-40-bluetooth",
    codepoint: "F940",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "2.4.85",
    path: "M5,2V4H3.33C2.6,4 2,4.6 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33C14,4.6 13.4,4 12.67,4H11V2H5M4,6H12V14H4V6M19,8V11.79L16.71,9.5L16,10.21L18.79,13L16,15.79L16.71,16.5L19,14.21V18H19.5L22.35,15.14L20.21,13L22.35,10.85L19.5,8H19M20,9.91L20.94,10.85L20,11.79V9.91M20,14.21L20.94,15.14L20,16.08V14.21Z",
  },
  {
    id: "A79598F9-7FDF-46A2-9F8D-1DBD6BAB1A1D",
    name: "battery-50",
    codepoint: "F07E",
    aliases: [],
    tags: ["Battery", "Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M16,13H8V6H16M16.67,4H15V2H9V4H7.33C6.6,4 6,4.6 6,5.33V20.67C6,21.4 6.6,22 7.33,22H16.67C17.4,22 18,21.4 18,20.67V5.33C18,4.6 17.4,4 16.67,4Z",
  },
  {
    id: "313BE145-A7FB-4620-915C-4B2298C70EA1",
    name: "battery-50-bluetooth",
    codepoint: "F941",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "2.4.85",
    path: "M5,2V4H3.33C2.6,4 2,4.6 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33C14,4.6 13.4,4 12.67,4H11V2H5M4,6H12V13H4V6M19,8V11.79L16.71,9.5L16,10.21L18.79,13L16,15.79L16.71,16.5L19,14.21V18H19.5L22.35,15.14L20.21,13L22.35,10.85L19.5,8H19M20,9.91L20.94,10.85L20,11.79V9.91M20,14.21L20.94,15.14L20,16.08V14.21Z",
  },
  {
    id: "B6EB700B-9288-474C-9A5C-C269680BFC5F",
    name: "battery-60",
    codepoint: "F07F",
    aliases: [],
    tags: ["Battery", "Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M16,12H8V6H16M16.67,4H15V2H9V4H7.33C6.6,4 6,4.6 6,5.33V20.67C6,21.4 6.6,22 7.33,22H16.67C17.4,22 18,21.4 18,20.67V5.33C18,4.6 17.4,4 16.67,4Z",
  },
  {
    id: "B422BB57-AC2D-43C2-B7A0-67160D90519E",
    name: "battery-60-bluetooth",
    codepoint: "F942",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "2.4.85",
    path: "M5,2V4H3.33C2.6,4 2,4.6 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33C14,4.6 13.4,4 12.67,4H11V2H5M4,6H12V12H4V6M19,8V11.79L16.71,9.5L16,10.21L18.79,13L16,15.79L16.71,16.5L19,14.21V18H19.5L22.35,15.14L20.21,13L22.35,10.85L19.5,8H19M20,9.91L20.94,10.85L20,11.79V9.91M20,14.21L20.94,15.14L20,16.08V14.21Z",
  },
  {
    id: "5DC968CB-1DC2-42B1-96E2-80AC6B23BB9C",
    name: "battery-70",
    codepoint: "F080",
    aliases: [],
    tags: ["Battery", "Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M16,10H8V6H16M16.67,4H15V2H9V4H7.33C6.6,4 6,4.6 6,5.33V20.67C6,21.4 6.6,22 7.33,22H16.67C17.4,22 18,21.4 18,20.67V5.33C18,4.6 17.4,4 16.67,4Z",
  },
  {
    id: "426481A7-5387-4385-9D2D-BEB1BCF5900D",
    name: "battery-70-bluetooth",
    codepoint: "F943",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "2.4.85",
    path: "M5,2V4H3.33C2.6,4 2,4.6 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33C14,4.6 13.4,4 12.67,4H11V2H5M4,6H12V10H4V6M19,8V11.79L16.71,9.5L16,10.21L18.79,13L16,15.79L16.71,16.5L19,14.21V18H19.5L22.35,15.14L20.21,13L22.35,10.85L19.5,8H19M20,9.91L20.94,10.85L20,11.79V9.91M20,14.21L20.94,15.14L20,16.08V14.21Z",
  },
  {
    id: "54485D0C-49B3-424D-8283-4CE90E16F88D",
    name: "battery-80",
    codepoint: "F081",
    aliases: [],
    tags: ["Battery", "Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M16,9H8V6H16M16.67,4H15V2H9V4H7.33C6.6,4 6,4.6 6,5.33V20.67C6,21.4 6.6,22 7.33,22H16.67C17.4,22 18,21.4 18,20.67V5.33C18,4.6 17.4,4 16.67,4Z",
  },
  {
    id: "176EE56B-73A9-44C7-94FF-90C11A48127E",
    name: "battery-80-bluetooth",
    codepoint: "F944",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "2.4.85",
    path: "M5,2V4H3.33C2.6,4 2,4.6 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33C14,4.6 13.4,4 12.67,4H11V2H5M4,6H12V9H4V6M19,8V11.79L16.71,9.5L16,10.21L18.79,13L16,15.79L16.71,16.5L19,14.21V18H19.5L22.35,15.14L20.21,13L22.35,10.85L19.5,8H19M20,9.91L20.94,10.85L20,11.79V9.91M20,14.21L20.94,15.14L20,16.08V14.21Z",
  },
  {
    id: "58205285-7EAA-400A-A8E5-A9373E7D986A",
    name: "battery-90",
    codepoint: "F082",
    aliases: [],
    tags: ["Battery", "Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M16,8H8V6H16M16.67,4H15V2H9V4H7.33C6.6,4 6,4.6 6,5.33V20.67C6,21.4 6.6,22 7.33,22H16.67C17.4,22 18,21.4 18,20.67V5.33C18,4.6 17.4,4 16.67,4Z",
  },
  {
    id: "AEB32E6B-7E3D-4C3A-AE1A-96C63868E208",
    name: "battery-90-bluetooth",
    codepoint: "F945",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "2.4.85",
    path: "M5,2V4H3.33C2.6,4 2,4.6 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33C14,4.6 13.4,4 12.67,4H11V2H5M4,6H12V8H4V6M19,8V11.79L16.71,9.5L16,10.21L18.79,13L16,15.79L16.71,16.5L19,14.21V18H19.5L22.35,15.14L20.21,13L22.35,10.85L19.5,8H19M20,9.91L20.94,10.85L20,11.79V9.91M20,14.21L20.94,15.14L20,16.08V14.21Z",
  },
  {
    id: "ABFAD078-0E10-4293-94AD-16871B75E51F",
    name: "battery-alert",
    codepoint: "F083",
    aliases: ["battery-warning"],
    tags: ["Battery", "Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M13,14H11V9H13M13,18H11V16H13M16.67,4H15V2H9V4H7.33C6.6,4 6,4.6 6,5.33V20.67C6,21.4 6.6,22 7.33,22H16.67C17.4,22 18,21.4 18,20.67V5.33C18,4.6 17.4,4 16.67,4Z",
  },
  {
    id: "7C1C81FB-9E38-4220-B225-460056043383",
    name: "battery-alert-bluetooth",
    codepoint: "F946",
    aliases: ["battery-warning-bluetooth"],
    tags: [],
    author: "GreenTurtwig",
    version: "2.4.85",
    path: "M5,2V4H3.33C2.6,4 2,4.6 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33C14,4.6 13.4,4 12.67,4H11V2H5M19,8V11.79L16.71,9.5L16,10.21L18.79,13L16,15.79L16.71,16.5L19,14.21V18H19.5L22.35,15.14L20.21,13L22.35,10.85L19.5,8H19M7,9H9V14H7V9M20,9.91L20.94,10.85L20,11.79V9.91M20,14.21L20.94,15.14L20,16.08V14.21M7,16H9V18H7V16Z",
  },
  {
    id: "3DB7EA89-8F0C-40DA-B45A-E5B588F2CC01",
    name: "battery-bluetooth",
    codepoint: "F947",
    aliases: ["battery-bluetooth-100", "battery-bluetooth-full"],
    tags: [],
    author: "GreenTurtwig",
    version: "2.4.85",
    path: "M5,2V4H3.33C2.6,4 2,4.6 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33C14,4.6 13.4,4 12.67,4H11V2H5M19,8V11.79L16.71,9.5L16,10.21L18.79,13L16,15.79L16.71,16.5L19,14.21V18H19.5L22.35,15.14L20.21,13L22.35,10.85L19.5,8H19M20,9.91L20.94,10.85L20,11.79V9.91M20,14.21L20.94,15.14L20,16.08V14.21Z",
  },
  {
    id: "910BCFA6-ED67-48A5-97EB-BA61969629E9",
    name: "battery-bluetooth-variant",
    codepoint: "F948",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "2.4.85",
    path: "M9,2V4H7.33C6.6,4 6,4.6 6,5.33V20.67C6,21.4 6.6,22 7.33,22H16.67C17.4,22 18,21.4 18,20.67V5.33C18,4.6 17.4,4 16.67,4H15V2H9M11.83,8H12.33L15.18,10.85L13.04,13L15.17,15.14L12.33,18H11.83V14.21L9.54,16.5L8.83,15.79L11.62,13L8.83,10.21L9.54,9.5L11.83,11.79V8M12.83,9.91V11.79L13.77,10.85L12.83,9.91M12.83,14.21V16.08L13.77,15.14L12.83,14.21Z",
  },
  {
    id: "F365ACF3-9453-4516-B592-AECD72AB7433",
    name: "battery-charging",
    codepoint: "F084",
    aliases: ["battery-charging-full"],
    tags: ["Battery", "Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M16.67,4H15V2H9V4H7.33C6.6,4 6,4.6 6,5.33V20.66C6,21.4 6.6,22 7.33,22H16.66C17.4,22 18,21.4 18,20.67V5.33C18,4.6 17.4,4 16.67,4M11,20V14.5H9L13,7V12.5H15",
  },
  {
    id: "EBDD7C45-CE9F-4503-9CE4-0682E4E8E6BF",
    name: "battery-charging-10",
    codepoint: "F89B",
    aliases: [],
    tags: [],
    author: "Google",
    version: "2.2.43",
    path: "M23.05,11H20.05V4L15.05,14H18.05V22M12,18H4L4.05,6H12.05M12.72,4H11.05V2H5.05V4H3.38C2.65,4 2.05,4.6 2.05,5.33V20.67C2.05,21.4 2.65,22 3.38,22H12.72C13.45,22 14.05,21.4 14.05,20.67V5.33C14.05,4.6 13.45,4 12.72,4Z",
  },
  {
    id: "C1379E5C-2335-4C37-9A73-EE54D6747512",
    name: "battery-charging-100",
    codepoint: "F085",
    aliases: [],
    tags: ["Battery", "Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M23,11H20V4L15,14H18V22M12.67,4H11V2H5V4H3.33C2.6,4 2,4.6 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33C14,4.6 13.4,4 12.67,4Z",
  },
  {
    id: "3E25E8BE-5097-4414-A7E4-9CDF02CD4F84",
    name: "battery-charging-20",
    codepoint: "F086",
    aliases: [],
    tags: ["Battery", "Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M23.05,11H20.05V4L15.05,14H18.05V22M12.05,17H4.05V6H12.05M12.72,4H11.05V2H5.05V4H3.38C2.65,4 2.05,4.6 2.05,5.33V20.67C2.05,21.4 2.65,22 3.38,22H12.72C13.45,22 14.05,21.4 14.05,20.67V5.33C14.05,4.6 13.45,4 12.72,4Z",
  },
  {
    id: "04D00269-7E8F-40D1-BFC4-36A01720260B",
    name: "battery-charging-30",
    codepoint: "F087",
    aliases: [],
    tags: ["Battery", "Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M12,15H4V6H12M12.67,4H11V2H5V4H3.33C2.6,4 2,4.6 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33C14,4.6 13.4,4 12.67,4M23,11H20V4L15,14H18V22L23,11Z",
  },
  {
    id: "D40803B3-43CB-4680-A7BD-56CC83ED54B8",
    name: "battery-charging-40",
    codepoint: "F088",
    aliases: [],
    tags: ["Battery", "Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M23,11H20V4L15,14H18V22M12,13H4V6H12M12.67,4H11V2H5V4H3.33C2.6,4 2,4.6 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33C14,4.6 13.4,4 12.67,4Z",
  },
  {
    id: "1681D3BD-4990-4571-87B0-1C846DC8D600",
    name: "battery-charging-50",
    codepoint: "F89C",
    aliases: [],
    tags: [],
    author: "Google",
    version: "2.2.43",
    path: "M23,11H20V4L15,14H18V22M12,13H4V6H12M12.67,4H11V2H5V4H3.33C2.6,4 2,4.6 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33C14,4.6 13.4,4 12.67,4Z",
  },
  {
    id: "23E8809B-FB62-4573-83CF-9C33E980FD41",
    name: "battery-charging-60",
    codepoint: "F089",
    aliases: [],
    tags: ["Battery", "Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M12,11H4V6H12M12.67,4H11V2H5V4H3.33C2.6,4 2,4.6 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33C14,4.6 13.4,4 12.67,4M23,11H20V4L15,14H18V22L23,11Z",
  },
  {
    id: "C8C75ED1-4B80-42A7-B590-DA3BE7567E86",
    name: "battery-charging-70",
    codepoint: "F89D",
    aliases: [],
    tags: [],
    author: "Google",
    version: "2.2.43",
    path: "M12,10H4V6H12M12.67,4H11V2H5V4H3.33C2.6,4 2,4.6 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33C14,4.6 13.4,4 12.67,4M23,11H20V4L15,14H18V22L23,11Z",
  },
  {
    id: "20455031-CCDD-40F8-A7A4-5E1F9E55F20E",
    name: "battery-charging-80",
    codepoint: "F08A",
    aliases: [],
    tags: ["Battery", "Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M23,11H20V4L15,14H18V22M12,9H4V6H12M12.67,4H11V2H5V4H3.33C2.6,4 2,4.6 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33C14,4.6 13.4,4 12.67,4Z",
  },
  {
    id: "0EC45F7B-7A0A-43AD-ABD3-10E4209659C0",
    name: "battery-charging-90",
    codepoint: "F08B",
    aliases: [],
    tags: ["Battery", "Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M23,11H20V4L15,14H18V22M12,8H4V6H12M12.67,4H11V2H5V4H3.33C2.6,4 2,4.6 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33C14,4.6 13.4,4 12.67,4Z",
  },
  {
    id: "A057A8D0-A442-4948-B2BF-63CECE073AF5",
    name: "battery-charging-outline",
    codepoint: "F89E",
    aliases: [],
    tags: [],
    author: "Google",
    version: "2.2.43",
    path: "M23.05,11H20.05V4L15.05,14H18.05V22M12,20H4L4.05,6H12.05M12.72,4H11.05V2H5.05V4H3.38C2.65,4 2.05,4.6 2.05,5.33V20.67C2.05,21.4 2.65,22 3.38,22H12.72C13.45,22 14.05,21.4 14.05,20.67V5.33C14.05,4.6 13.45,4 12.72,4Z",
  },
  {
    id: "60EEA5B6-8070-482D-ABE3-54A9D2A80875",
    name: "battery-charging-wireless",
    codepoint: "F806",
    aliases: [
      "battery-charging-wireless-full",
      "battery-charging-wireless-100",
    ],
    tags: ["Battery", "Home Automation"],
    author: "Michael Richins",
    version: "2.1.19",
    path: "M13,4H11V2H5V4H3C2.45,4 2,4.45 2,5V21C2,21.55 2.45,22 3,22H13C13.55,22 14,21.55 14,21V5C14,4.45 13.55,4 13,4M20.07,4.93L18.66,6.34C21.79,9.46 21.79,14.53 18.66,17.66L20.07,19.07C23.97,15.17 23.97,8.84 20.07,4.93M17.24,7.76L15.83,9.17C17.39,10.73 17.39,13.26 15.83,14.83L17.24,16.24C19.58,13.9 19.58,10.1 17.24,7.76Z",
  },
  {
    id: "5D2990D5-D3D4-4E8F-AED8-B90CE6164068",
    name: "battery-charging-wireless-10",
    codepoint: "F807",
    aliases: [],
    tags: ["Battery", "Home Automation"],
    author: "Michael Richins",
    version: "2.1.19",
    path: "M20.07,4.93L18.66,6.34C21.79,9.46 21.79,14.53 18.66,17.66L20.07,19.07C23.97,15.17 23.97,8.84 20.07,4.93M17.24,7.76L15.83,9.17C17.39,10.73 17.39,13.26 15.83,14.83L17.24,16.24C19.58,13.9 19.58,10.1 17.24,7.76M13,4H11V2H5V4H3C2.45,4 2,4.45 2,5V21C2,21.55 2.45,22 3,22H13C13.55,22 14,21.55 14,21V5C14,4.45 13.55,4 13,4M12,18.5H4V6H12V18.5Z",
  },
  {
    id: "5C194C6F-8CFE-4F1A-AFD3-11D7E8CB89B4",
    name: "battery-charging-wireless-20",
    codepoint: "F808",
    aliases: [],
    tags: ["Battery", "Home Automation"],
    author: "Michael Richins",
    version: "2.1.19",
    path: "M20.07,4.93L18.66,6.34C21.79,9.46 21.79,14.53 18.66,17.66L20.07,19.07C23.97,15.17 23.97,8.84 20.07,4.93M17.24,7.76L15.83,9.17C17.39,10.73 17.39,13.26 15.83,14.83L17.24,16.24C19.58,13.9 19.58,10.1 17.24,7.76M13,4H11V2H5V4H3C2.45,4 2,4.45 2,5V21C2,21.55 2.45,22 3,22H13C13.55,22 14,21.55 14,21V5C14,4.45 13.55,4 13,4M12,17H4V6H12V17Z",
  },
  {
    id: "567818F9-23C0-41C4-A3BD-2BA37F8BFF29",
    name: "battery-charging-wireless-30",
    codepoint: "F809",
    aliases: [],
    tags: ["Battery", "Home Automation"],
    author: "Michael Richins",
    version: "2.1.19",
    path: "M20.07,4.93L18.66,6.34C21.79,9.46 21.79,14.53 18.66,17.66L20.07,19.07C23.97,15.17 23.97,8.84 20.07,4.93M17.24,7.76L15.83,9.17C17.39,10.73 17.39,13.26 15.83,14.83L17.24,16.24C19.58,13.9 19.58,10.1 17.24,7.76M13,4H11V2H5V4H3C2.45,4 2,4.45 2,5V21C2,21.55 2.45,22 3,22H13C13.55,22 14,21.55 14,21V5C14,4.45 13.55,4 13,4M12,16H4V6H12V16Z",
  },
  {
    id: "1ABBC4EA-32D6-4FBA-AA00-E19707123AE5",
    name: "battery-charging-wireless-40",
    codepoint: "F80A",
    aliases: [],
    tags: ["Battery", "Home Automation"],
    author: "Michael Richins",
    version: "2.1.19",
    path: "M20.07,4.93L18.66,6.34C21.79,9.46 21.79,14.53 18.66,17.66L20.07,19.07C23.97,15.17 23.97,8.84 20.07,4.93M17.24,7.76L15.83,9.17C17.39,10.73 17.39,13.26 15.83,14.83L17.24,16.24C19.58,13.9 19.58,10.1 17.24,7.76M13,4H11V2H5V4H3C2.45,4 2,4.45 2,5V21C2,21.55 2.45,22 3,22H13C13.55,22 14,21.55 14,21V5C14,4.45 13.55,4 13,4M12,14.5H4V6H12V14.5Z",
  },
  {
    id: "9BC0DBFF-A3F6-4061-B6E1-685880D6B653",
    name: "battery-charging-wireless-50",
    codepoint: "F80B",
    aliases: [],
    tags: ["Battery", "Home Automation"],
    author: "Michael Richins",
    version: "2.1.19",
    path: "M20.07,4.93L18.66,6.34C21.79,9.46 21.79,14.53 18.66,17.66L20.07,19.07C23.97,15.17 23.97,8.84 20.07,4.93M17.24,7.76L15.83,9.17C17.39,10.73 17.39,13.26 15.83,14.83L17.24,16.24C19.58,13.9 19.58,10.1 17.24,7.76M13,4H11V2H5V4H3C2.45,4 2,4.45 2,5V21C2,21.55 2.45,22 3,22H13C13.55,22 14,21.55 14,21V5C14,4.45 13.55,4 13,4M12,13H4V6H12V13Z",
  },
  {
    id: "F09D15A6-1E87-488C-9F75-24EC677E72FF",
    name: "battery-charging-wireless-60",
    codepoint: "F80C",
    aliases: [],
    tags: ["Battery", "Home Automation"],
    author: "Michael Richins",
    version: "2.1.19",
    path: "M20.07,4.93L18.66,6.34C21.79,9.46 21.79,14.53 18.66,17.66L20.07,19.07C23.97,15.17 23.97,8.84 20.07,4.93M17.24,7.76L15.83,9.17C17.39,10.73 17.39,13.26 15.83,14.83L17.24,16.24C19.58,13.9 19.58,10.1 17.24,7.76M13,4H11V2H5V4H3C2.45,4 2,4.45 2,5V21C2,21.55 2.45,22 3,22H13C13.55,22 14,21.55 14,21V5C14,4.45 13.55,4 13,4M12,11.6H4V6H12V11.6Z",
  },
  {
    id: "45966E8F-2801-4ED6-970F-12D9FD6C6290",
    name: "battery-charging-wireless-70",
    codepoint: "F80D",
    aliases: [],
    tags: ["Battery", "Home Automation"],
    author: "Michael Richins",
    version: "2.1.19",
    path: "M20.07,4.93L18.66,6.34C21.79,9.46 21.79,14.53 18.66,17.66L20.07,19.07C23.97,15.17 23.97,8.84 20.07,4.93M17.24,7.76L15.83,9.17C17.39,10.73 17.39,13.26 15.83,14.83L17.24,16.24C19.58,13.9 19.58,10.1 17.24,7.76M13,4H11V2H5V4H3C2.45,4 2,4.45 2,5V21C2,21.55 2.45,22 3,22H13C13.55,22 14,21.55 14,21V5C14,4.45 13.55,4 13,4M12,10H4V6H12V10Z",
  },
  {
    id: "EB5E0801-60FA-4DD3-8709-2A6F0AC9C3ED",
    name: "battery-charging-wireless-80",
    codepoint: "F80E",
    aliases: [],
    tags: ["Battery", "Home Automation"],
    author: "Michael Richins",
    version: "2.1.19",
    path: "M20.07,4.93L18.66,6.34C21.79,9.46 21.79,14.53 18.66,17.66L20.07,19.07C23.97,15.17 23.97,8.84 20.07,4.93M17.24,7.76L15.83,9.17C17.39,10.73 17.39,13.26 15.83,14.83L17.24,16.24C19.58,13.9 19.58,10.1 17.24,7.76M13,4H11V2H5V4H3C2.45,4 2,4.45 2,5V21C2,21.55 2.45,22 3,22H13C13.55,22 14,21.55 14,21V5C14,4.45 13.55,4 13,4M12,9H4V6H12V9Z",
  },
  {
    id: "E8C0AC60-D7AB-4FA3-9596-CE002E798180",
    name: "battery-charging-wireless-90",
    codepoint: "F80F",
    aliases: [],
    tags: ["Battery", "Home Automation"],
    author: "Michael Richins",
    version: "2.1.19",
    path: "M20.07,4.93L18.66,6.34C21.79,9.46 21.79,14.53 18.66,17.66L20.07,19.07C23.97,15.17 23.97,8.84 20.07,4.93M17.24,7.76L15.83,9.17C17.39,10.73 17.39,13.26 15.83,14.83L17.24,16.24C19.58,13.9 19.58,10.1 17.24,7.76M13,4H11V2H5V4H3C2.45,4 2,4.45 2,5V21C2,21.55 2.45,22 3,22H13C13.55,22 14,21.55 14,21V5C14,4.45 13.55,4 13,4M12,7.5H4V6H12V7.5Z",
  },
  {
    id: "F835E187-444F-43B8-A057-9915F1388A87",
    name: "battery-charging-wireless-alert",
    codepoint: "F810",
    aliases: ["battery-charging-wireless-warning"],
    tags: ["Battery", "Home Automation"],
    author: "Michael Richins",
    version: "2.1.19",
    path: "M13,4H11V2H5V4H3C2.45,4 2,4.45 2,5V21C2,21.55 2.45,22 3,22H13C13.55,22 14,21.55 14,21V5C14,4.45 13.55,4 13,4M9,18H7V16H9V18M9,14H7V9H9V14M20.07,4.93L18.66,6.34C21.79,9.46 21.79,14.53 18.66,17.66L20.07,19.07C23.97,15.17 23.97,8.84 20.07,4.93M17.24,7.76L15.83,9.17C17.39,10.73 17.39,13.26 15.83,14.83L17.24,16.24C19.58,13.9 19.58,10.1 17.24,7.76Z",
  },
  {
    id: "4AFDE54E-1A6D-4F7F-BD0D-AB67FB0F12CC",
    name: "battery-charging-wireless-outline",
    codepoint: "F811",
    aliases: ["battery-charging-wireless-empty", "battery-charging-wireless-0"],
    tags: ["Battery", "Home Automation"],
    author: "Michael Richins",
    version: "2.1.19",
    path: "M20.07,4.93L18.66,6.34C21.79,9.46 21.79,14.53 18.66,17.66L20.07,19.07C23.97,15.17 23.97,8.84 20.07,4.93M17.24,7.76L15.83,9.17C17.39,10.73 17.39,13.26 15.83,14.83L17.24,16.24C19.58,13.9 19.58,10.1 17.24,7.76M13,4H11V2H5V4H3C2.45,4 2,4.45 2,5V21C2,21.55 2.45,22 3,22H13C13.55,22 14,21.55 14,21V5C14,4.45 13.55,4 13,4M12,20H4V6H12V20Z",
  },
  {
    id: "15E0E37E-564A-40D5-9D4A-948C932C8E52",
    name: "battery-minus",
    codepoint: "F08C",
    aliases: [],
    tags: ["Battery", "Home Automation"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M16.67,4C17.4,4 18,4.6 18,5.33V20.67C18,21.4 17.4,22 16.67,22H7.33C6.6,22 6,21.4 6,20.67V5.33C6,4.6 6.6,4 7.33,4H9V2H15V4H16.67M8,12V14H16V12",
  },
  {
    id: "447DBB2A-31ED-4856-A7A2-A61BF0780C7B",
    name: "battery-negative",
    codepoint: "F08D",
    aliases: [],
    tags: ["Battery", "Home Automation"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M11.67,4C12.4,4 13,4.6 13,5.33V20.67C13,21.4 12.4,22 11.67,22H2.33C1.6,22 1,21.4 1,20.67V5.33C1,4.6 1.6,4 2.33,4H4V2H10V4H11.67M15,12H23V14H15V12M3,13H11V6H3V13Z",
  },
  {
    id: "925B02B4-CA05-4545-A4E3-421F8412DA37",
    name: "battery-outline",
    codepoint: "F08E",
    aliases: ["battery-0", "battery-empty"],
    tags: ["Battery", "Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M16,20H8V6H16M16.67,4H15V2H9V4H7.33C6.6,4 6,4.6 6,5.33V20.67C6,21.4 6.6,22 7.33,22H16.67C17.4,22 18,21.4 18,20.67V5.33C18,4.6 17.4,4 16.67,4Z",
  },
  {
    id: "A4BD7F0D-E95C-413C-B853-435A53854844",
    name: "battery-plus",
    codepoint: "F08F",
    aliases: ["battery-saver"],
    tags: ["Battery", "Home Automation"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M16.67,4C17.4,4 18,4.6 18,5.33V20.67C18,21.4 17.4,22 16.67,22H7.33C6.6,22 6,21.4 6,20.67V5.33C6,4.6 6.6,4 7.33,4H9V2H15V4H16.67M16,14V12H13V9H11V12H8V14H11V17H13V14H16Z",
  },
  {
    id: "195F51E4-5B02-4BE3-B407-4B7FC1445F18",
    name: "battery-positive",
    codepoint: "F090",
    aliases: [],
    tags: ["Battery", "Home Automation"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M11.67,4C12.4,4 13,4.6 13,5.33V20.67C13,21.4 12.4,22 11.67,22H2.33C1.6,22 1,21.4 1,20.67V5.33C1,4.6 1.6,4 2.33,4H4V2H10V4H11.67M23,14H20V17H18V14H15V12H18V9H20V12H23V14M3,13H11V6H3V13Z",
  },
  {
    id: "80257130-A38B-4BC1-B194-2EB16048D763",
    name: "battery-unknown",
    codepoint: "F091",
    aliases: [],
    tags: ["Battery", "Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M15.07,12.25L14.17,13.17C13.63,13.71 13.25,14.18 13.09,15H11.05C11.16,14.1 11.56,13.28 12.17,12.67L13.41,11.41C13.78,11.05 14,10.55 14,10C14,8.89 13.1,8 12,8C10.9,8 10,8.9 10,10H8C8,7.79 9.79,6 12,6C14.21,6 16,7.79 16,10C16,10.88 15.64,11.68 15.07,12.25M13,19H11V17H13M16.67,4H15V2H9V4H7.33C6.6,4 6,4.6 6,5.33V20.66C6,21.4 6.6,22 7.33,22H16.67C17.4,22 18,21.4 18,20.66V5.33C18,4.59 17.4,4 16.67,4Z",
  },
  {
    id: "B30963B2-893D-43F8-9EFD-918DCB654B75",
    name: "battery-unknown-bluetooth",
    codepoint: "F949",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "2.4.85",
    path: "M5,2V4H3.33C2.6,4 2,4.6 2,5.33V20.66C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.66V5.33C14,4.59 13.4,4 12.67,4H11V2H5M8,6C10.21,6 12,7.79 12,10C12,10.88 11.64,11.68 11.07,12.25L10.17,13.17C9.63,13.71 9.25,14.18 9.09,15H7.05C7.16,14.1 7.56,13.28 8.17,12.67L9.41,11.41C9.78,11.05 10,10.55 10,10C10,8.89 9.1,8 8,8C6.9,8 6,8.9 6,10H4C4,7.79 5.79,6 8,6M19,8V11.79L16.71,9.5L16,10.21L18.79,13L16,15.79L16.71,16.5L19,14.21V18H19.5L22.35,15.14L20.21,13L22.35,10.85L19.5,8H19M20,9.91L20.94,10.85L20,11.79V9.91M20,14.21L20.94,15.14L20,16.08V14.21M7,17H9V19H7V17Z",
  },
  {
    id: "FB1FEB37-FA9B-40BF-A7EC-B4A1690E6B77",
    name: "beach",
    codepoint: "F092",
    aliases: ["parasol"],
    tags: ["Places"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M15,18.54C17.13,18.21 19.5,18 22,18V22H5C5,21.35 8.2,19.86 13,18.9V12.4C12.16,12.65 11.45,13.21 11,13.95C10.39,12.93 9.27,12.25 8,12.25C6.73,12.25 5.61,12.93 5,13.95C5.03,10.37 8.5,7.43 13,7.04V7C13,6.45 13.45,6 14,6C14.55,6 15,6.45 15,7V7.04C19.5,7.43 22.96,10.37 23,13.95C22.39,12.93 21.27,12.25 20,12.25C18.73,12.25 17.61,12.93 17,13.95C16.55,13.21 15.84,12.65 15,12.39V18.54M7,2C7,4.76 4.76,7 2,7V2H7Z",
  },
  {
    id: "95E06F22-3EA5-448F-B260-E555C1DCD18E",
    name: "beaker",
    codepoint: "F68F",
    aliases: [],
    tags: ["Science"],
    author: "Cody",
    version: "1.7.12",
    path: "M3,3H21V5C19.9,5 19,5.9 19,7V19C19,20.1 18.1,21 17,21H7C5.9,21 5,20.1 5,19V7C5,5.9 4.1,5 3,5V3M7,5V7H12V8H7V9H10V10H7V11H10V12H7V13H12V14H7V15H10V16H7V19H17V5H7Z",
  },
  {
    id: "15DC169E-459C-4EDB-BF8F-3E1D4F34B2BF",
    name: "bed-empty",
    codepoint: "F89F",
    aliases: [],
    tags: ["Home Automation"],
    author: "GreenTurtwig",
    version: "2.2.43",
    path: "M19,7H5V14H3V5H1V20H3V17H21V20H23V11C23,8.79 21.21,7 19,7",
  },
  {
    id: "9D9A73D2-0780-4141-95A3-CDFE21E6D4D6",
    name: "beer",
    codepoint: "F098",
    aliases: [],
    tags: ["Food / Drink"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M4,2H19L17,22H6L4,2M6.2,4L7.8,20H8.8L7.43,6.34C8.5,6 9.89,5.89 11,7C12.56,8.56 15.33,7.69 16.5,7.23L16.8,4H6.2Z",
  },
  {
    id: "45fea174-07db-11e4-bf19-842b2b6cfe1b",
    name: "bell",
    codepoint: "F09A",
    aliases: ["notifications"],
    tags: ["Notification", "Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M12,22C13.1,22 14,21.1 14,20H10C10,21.1 10.9,22 12,22M18,16V11C18,7.93 16.36,5.36 13.5,4.68V4C13.5,3.17 12.83,2.5 12,2.5C11.17,2.5 10.5,3.17 10.5,4V4.68C7.63,5.36 6,7.92 6,11V16L4,18V19H20V18L18,16Z",
  },
  {
    id: "69686D8F-75FE-4091-9061-88DB64D95C01",
    name: "bell-off",
    codepoint: "F09B",
    aliases: ["notifications-off"],
    tags: ["Notification"],
    author: "Google",
    version: "1.5.54",
    path: "M20,18.69L7.84,6.14L5.27,3.5L4,4.76L6.8,7.56V7.57C6.28,8.56 6,9.73 6,11V16L4,18V19H17.73L19.73,21L21,19.72L20,18.69M12,22C13.11,22 14,21.11 14,20H10C10,21.11 10.89,22 12,22M18,14.68V11C18,7.92 16.36,5.36 13.5,4.68V4C13.5,3.17 12.83,2.5 12,2.5C11.17,2.5 10.5,3.17 10.5,4V4.68C10.35,4.71 10.21,4.76 10.08,4.8C10,4.83 9.88,4.87 9.78,4.91L9.75,4.92C9.5,5 9.29,5.12 9.06,5.24L18,14.68Z",
  },
  {
    id: "70A190E9-6F1D-40DB-81D4-C9516949DF0B",
    name: "bell-outline",
    codepoint: "F09C",
    aliases: ["notifications-none"],
    tags: ["Notification"],
    author: "Google",
    version: "1.5.54",
    path: "M16,17H7V10.5C7,8 9,6 11.5,6C14,6 16,8 16,10.5M18,16V10.5C18,7.43 15.86,4.86 13,4.18V3.5C13,2.67 12.33,2 11.5,2C10.67,2 10,2.67 10,3.5V4.18C7.13,4.86 5,7.43 5,10.5V16L3,18V19H20V18M11.5,22C12.6,22 13.5,21.1 13.5,20H9.5C9.5,21.1 10.4,22 11.5,22Z",
  },
  {
    id: "FC07FF46-2FD1-4E4E-8D35-BADDEEB5F531",
    name: "bell-plus",
    codepoint: "F09D",
    aliases: ["add-alert"],
    tags: ["Notification"],
    author: "Google",
    version: "1.5.54",
    path: "M10,21C10,22.11 10.9,23 12,23C13.1,23 14,22.1 14,21M18.88,16.82V11C18.88,7.75 16.63,5.03 13.59,4.31V3.59C13.59,2.71 12.88,2 12,2C11.12,2 10.41,2.71 10.41,3.59V4.31C7.37,5.03 5.12,7.75 5.12,11V16.82L3,18.94V20H21V18.94M16,13H13V16H11V13H8V11H11V8H13V11H16",
  },
  {
    id: "CD75C484-B1AD-492B-8CAA-9F002398C3CA",
    name: "bell-ring",
    codepoint: "F09E",
    aliases: ["notifications-active"],
    tags: ["Notification"],
    author: "Google",
    version: "1.5.54",
    path: "M11.5,22C11.64,22 11.77,22 11.9,21.96C12.55,21.82 13.09,21.38 13.34,20.78C13.44,20.54 13.5,20.27 13.5,20H9.5C9.5,21.1 10.4,22 11.5,22M18,10.5C18,7.43 15.86,4.86 13,4.18V3.5C13,2.67 12.33,2 11.5,2C10.67,2 10,2.67 10,3.5V4.18C7.13,4.86 5,7.43 5,10.5V16L3,18V19H20V18L18,16M19.97,10H21.97C21.82,6.79 20.24,3.97 17.85,2.15L16.42,3.58C18.46,5 19.82,7.35 19.97,10M6.58,3.58L5.15,2.15C2.76,3.97 1.18,6.79 1,10H3C3.18,7.35 4.54,5 6.58,3.58Z",
  },
  {
    id: "EE7DADC1-CF66-4922-B0C9-9B8F753514F9",
    name: "bell-ring-outline",
    codepoint: "F09F",
    aliases: [],
    tags: ["Notification"],
    author: "Google",
    version: "1.5.54",
    path: "M16,17V10.5C16,8 14,6 11.5,6C9,6 7,8 7,10.5V17H16M18,16L20,18V19H3V18L5,16V10.5C5,7.43 7.13,4.86 10,4.18V3.5C10,2.67 10.67,2 11.5,2C12.33,2 13,2.67 13,3.5V4.18C15.86,4.86 18,7.43 18,10.5V16M11.5,22C10.4,22 9.5,21.1 9.5,20H13.5C13.5,21.1 12.6,22 11.5,22M19.97,10C19.82,7.35 18.46,5 16.42,3.58L17.85,2.15C20.24,3.97 21.82,6.79 21.97,10H19.97M6.58,3.58C4.54,5 3.18,7.35 3,10H1C1.18,6.79 2.76,3.97 5.15,2.15L6.58,3.58Z",
  },
  {
    id: "43BD9E91-2044-4B80-AF87-2FC810C42A1B",
    name: "bell-sleep",
    codepoint: "F0A0",
    aliases: ["notifications-paused"],
    tags: ["Notification"],
    author: "Google",
    version: "1.5.54",
    path: "M14,9.8L11.2,13.2H14V15H9V13.2L11.8,9.8H9V8H14M18,16V10.5C18,7.43 15.86,4.86 13,4.18V3.5C13,2.67 12.33,2 11.5,2C10.67,2 10,2.67 10,3.5V4.18C7.13,4.86 5,7.43 5,10.5V16L3,18V19H20V18M11.5,22C12.6,22 13.5,21.1 13.5,20H9.5C9.5,21.1 10.4,22 11.5,22Z",
  },
  {
    id: "4F83A19F-BAB5-4894-AC5A-B288AFD592DC",
    name: "beta",
    codepoint: "F0A1",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M9.23,17.59V23.12H6.88V6.72C6.88,5.27 7.31,4.13 8.16,3.28C9,2.43 10.17,2 11.61,2C13,2 14.07,2.34 14.87,3C15.66,3.68 16.05,4.62 16.05,5.81C16.05,6.63 15.79,7.4 15.27,8.11C14.75,8.82 14.08,9.31 13.25,9.58V9.62C14.5,9.82 15.47,10.27 16.13,11C16.79,11.71 17.12,12.62 17.12,13.74C17.12,15.06 16.66,16.14 15.75,16.97C14.83,17.8 13.63,18.21 12.13,18.21C11.07,18.21 10.1,18 9.23,17.59M10.72,10.75V8.83C11.59,8.72 12.3,8.4 12.87,7.86C13.43,7.31 13.71,6.7 13.71,6C13.71,4.62 13,3.92 11.6,3.92C10.84,3.92 10.25,4.16 9.84,4.65C9.43,5.14 9.23,5.82 9.23,6.71V15.5C10.14,16.03 11.03,16.29 11.89,16.29C12.73,16.29 13.39,16.07 13.86,15.64C14.33,15.2 14.56,14.58 14.56,13.79C14.56,12 13.28,11 10.72,10.75Z",
  },
  {
    id: "5FA9C13A-087C-452E-966F-4C2FCE336C68",
    name: "betamax",
    codepoint: "F9CA",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "2.5.94",
    path: "M4,5C2.9,5 2,5.9 2,7V17C2,18.1 2.9,19 4,19H20C21.1,19 22,18.1 22,17V7C22,5.9 21.1,5 20,5H4M8,9C10.21,9 12,10.79 12,13C12,15.21 10.21,17 8,17C5.79,17 4,15.21 4,13C4,10.79 5.79,9 8,9M13,9H20V17H13V9M8,11C6.9,11 6,11.9 6,13C6,14.1 6.9,15 8,15C9.1,15 10,14.1 10,13C10,11.9 9.1,11 8,11Z",
  },
  {
    id: "627C7FF1-BCAD-4741-966E-7CED73B35DC2",
    name: "bike",
    codepoint: "F0A3",
    aliases: ["bicycle", "cycling", "directions-bike"],
    tags: ["Transportation + Other", "Sport"],
    author: "Google",
    version: "1.5.54",
    path: "M5,20.5C3.07,20.5 1.5,18.93 1.5,17C1.5,15.07 3.07,13.5 5,13.5C6.93,13.5 8.5,15.07 8.5,17C8.5,18.93 6.93,20.5 5,20.5M5,12C2.24,12 0,14.24 0,17C0,19.76 2.24,22 5,22C7.76,22 10,19.76 10,17C10,14.24 7.76,12 5,12M14.8,10H19V8.2H15.8L13.86,4.93C13.57,4.43 13,4.1 12.4,4.1C11.93,4.1 11.5,4.29 11.2,4.6L7.5,8.29C7.19,8.6 7,9 7,9.5C7,10.13 7.33,10.66 7.85,10.97L11.2,13V18H13V11.5L10.75,9.85L13.07,7.5M19,20.5C17.07,20.5 15.5,18.93 15.5,17C15.5,15.07 17.07,13.5 19,13.5C20.93,13.5 22.5,15.07 22.5,17C22.5,18.93 20.93,20.5 19,20.5M19,12C16.24,12 14,14.24 14,17C14,19.76 16.24,22 19,22C21.76,22 24,19.76 24,17C24,14.24 21.76,12 19,12M16,4.8C17,4.8 17.8,4 17.8,3C17.8,2 17,1.2 16,1.2C15,1.2 14.2,2 14.2,3C14.2,4 15,4.8 16,4.8Z",
  },
  {
    id: "75806AA4-294B-4A0A-8BDB-FC4CABCA1768",
    name: "binoculars",
    codepoint: "F0A5",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M11,6H13V13H11V6M9,20C9,20.55 8.55,21 8,21H5C4.45,21 4,20.55 4,20V15L6,6H10V13C10,13.55 9.55,14 9,14V20M10,5H7V3H10V5M15,20V14C14.45,14 14,13.55 14,13V6H18L20,15V20C20,20.55 19.55,21 19,21H16C15.45,21 15,20.55 15,20M14,5V3H17V5H14Z",
  },
  {
    id: "F5D76655-0F6E-4FF2-AC74-CC3A235B7FC6",
    name: "bio",
    codepoint: "F0A6",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M17,12H20C21.1,12 22,12.9 22,14V17C22,18.1 21.1,19 20,19H17C15.9,19 15,18.1 15,17V14C15,12.9 15.9,12 17,12M17,14V17H20V14H17M2,7H7C8.1,7 9,7.9 9,9V11C9,12.1 8.1,13 7,13C8.1,13 9,13.9 9,15V17C9,18.1 8.1,19 7,19H2V13L2,7M4,9V12H7V9H4M4,17H7V14H4V17M11,13H13V19H11V13M11,9H13V11H11V9Z",
  },
  {
    id: "96BDE572-9D10-47D0-919F-68EB6CD3DFA9",
    name: "biohazard",
    codepoint: "F0A7",
    aliases: [],
    tags: ["Science"],
    author: "Yasmina Lembachar",
    version: "1.5.54",
    path: "M23,16.06C23,16.29 23,16.5 22.96,16.7C22.78,14.14 20.64,12.11 18,12.11C17.63,12.11 17.27,12.16 16.92,12.23C16.96,12.5 17,12.73 17,13C17,15.35 15.31,17.32 13.07,17.81C13.42,20.05 15.31,21.79 17.65,21.96C17.43,22 17.22,22 17,22C14.92,22 13.07,20.94 12,19.34C10.93,20.94 9.09,22 7,22C6.78,22 6.57,22 6.35,21.96C8.69,21.79 10.57,20.06 10.93,17.81C8.68,17.32 7,15.35 7,13C7,12.73 7.04,12.5 7.07,12.23C6.73,12.16 6.37,12.11 6,12.11C3.36,12.11 1.22,14.14 1.03,16.7C1,16.5 1,16.29 1,16.06C1,12.85 3.59,10.24 6.81,10.14C6.3,9.27 6,8.25 6,7.17C6,4.94 7.23,3 9.06,2C7.81,2.9 7,4.34 7,6C7,7.35 7.56,8.59 8.47,9.5C9.38,8.59 10.62,8.04 12,8.04C13.37,8.04 14.62,8.59 15.5,9.5C16.43,8.59 17,7.35 17,6C17,4.34 16.18,2.9 14.94,2C16.77,3 18,4.94 18,7.17C18,8.25 17.7,9.27 17.19,10.14C20.42,10.24 23,12.85 23,16.06M9.27,10.11C10.05,10.62 11,10.92 12,10.92C13,10.92 13.95,10.62 14.73,10.11C14,9.45 13.06,9.03 12,9.03C10.94,9.03 10,9.45 9.27,10.11M12,14.47C12.82,14.47 13.5,13.8 13.5,13C13.5,12.17 12.83,11.5 12,11.5C11.17,11.5 10.5,12.17 10.5,13C10.5,13.8 11.17,14.47 12,14.47M10.97,16.79C10.87,14.9 9.71,13.29 8.05,12.55C8.03,12.7 8,12.84 8,13C8,14.82 9.27,16.34 10.97,16.79M15.96,12.55C14.29,13.29 13.12,14.9 13,16.79C14.73,16.34 16,14.82 16,13C16,12.84 15.97,12.7 15.96,12.55Z",
  },
  {
    id: "B48BB714-F66F-4D86-9864-051DB90AE197",
    name: "bitbucket",
    codepoint: "F0A8",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Kateryna Porshnieva",
    version: "1.5.54",
    path: "M21.43,2C21.79,2.07 22.03,2.42 22,2.82L21.12,8.7L19.27,21.4C19.2,21.75 18.95,22 18.63,22H5.37C5.05,22 4.8,21.75 4.73,21.4L2.88,8.7L2,2.82C1.97,2.42 2.21,2.07 2.57,2H21.43M14.08,15.26L15.1,8.7H8.9L9.92,15.26H14.08Z",
  },
  {
    id: "9C8A35A5-86B5-4B10-BEE9-93CDFAF15B9C",
    name: "bitcoin",
    codepoint: "F812",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "2.1.19",
    path: "M4.5,5H8V2H10V5H11.5V2H13.5V5C19,5 19,11 16,11.25C20,11 21,19 13.5,19V22H11.5V19H10V22H8V19H4.5L5,17H6C6.55,17 7,16.55 7,16V8C7,7.45 6.55,7 6,7H4.5V5M10,7V11C10,11 14.5,11.25 14.5,9C14.5,6.75 10,7 10,7M10,12.5V17C10,17 15.5,17 15.5,14.75C15.5,12.5 10,12.5 10,12.5Z",
  },
  {
    id: "1F233821-5ED4-4CB3-8933-9A16C05D7AC9",
    name: "black-mesa",
    codepoint: "F0A9",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M12,4C7.58,4 4,7.58 4,12C4,14.39 5.05,16.53 6.71,18H9V12H17L19.15,15.59C19.69,14.5 20,13.29 20,12C20,7.58 16.42,4 12,4Z",
  },
  {
    id: "F365BC90-C8EC-4A5C-99FB-C2ED27B5593A",
    name: "blender",
    codepoint: "F0AB",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Christopher Schreiner",
    version: "1.5.54",
    path: "M8,3C8,3.34 8.17,3.69 8.5,3.88L12,6H2.5C1.67,6 1,6.67 1,7.5C1,8.33 1.67,9 2.5,9H8.41L2,13C1.16,13.5 1,14.22 1,15C1,16 1.77,17 3,17C3.69,17 4.39,16.5 5,16L7,14.38C7.2,18.62 10.71,22 15,22C19.42,22 23,18.42 23,14C23,11.08 21.43,8.5 19.09,7.13C19.06,7.11 19.03,7.08 19,7.06C19,7.06 18.92,7 18.86,6.97C15.76,4.88 13.03,3.72 9.55,2.13C9.34,2.04 9.16,2 9,2C8.4,2 8,2.46 8,3M15,9C17.76,9 20,11.24 20,14C20,16.76 17.76,19 15,19C12.24,19 10,16.76 10,14C10,11.24 12.24,9 15,9M15,10.5C13.07,10.5 11.5,12.07 11.5,14C11.5,15.93 13.07,17.5 15,17.5C16.93,17.5 18.5,15.93 18.5,14C18.5,12.07 16.93,10.5 15,10.5Z",
  },
  {
    id: "926ACBEB-C5F6-4EF4-829E-E0B05501DDD6",
    name: "blinds",
    codepoint: "F0AC",
    aliases: [],
    tags: ["Home Automation"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M3,2H21C21.55,2 22,2.45 22,3V5C22,5.55 21.55,6 21,6H20V13C20,13.55 19.55,14 19,14H13V16.17C14.17,16.58 15,17.69 15,19C15,20.66 13.66,22 12,22C10.34,22 9,20.66 9,19C9,17.69 9.83,16.58 11,16.17V14H5C4.45,14 4,13.55 4,13V6H3C2.45,6 2,5.55 2,5V3C2,2.45 2.45,2 3,2M12,18C11.45,18 11,18.45 11,19C11,19.55 11.45,20 12,20C12.55,20 13,19.55 13,19C13,18.45 12.55,18 12,18Z",
  },
  {
    id: "5832B598-DAAA-4497-B995-CF940A1C7F20",
    name: "block-helper",
    codepoint: "F0AD",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,0C18.63,0 24,5.37 24,12C24,18.63 18.63,24 12,24C5.37,24 0,18.63 0,12C0,5.37 5.37,0 12,0M12,2C6.48,2 2,6.48 2,12C2,14.4 2.85,16.6 4.26,18.33L18.33,4.26C16.6,2.85 14.4,2 12,2M12,22C17.52,22 22,17.52 22,12C22,9.6 21.15,7.4 19.74,5.67L5.67,19.74C7.4,21.15 9.6,22 12,22Z",
  },
  {
    id: "AAF23976-7C9D-4AFA-BE25-CCD225A95EEA",
    name: "blogger",
    codepoint: "F0AE",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Google",
    version: "1.5.54",
    path: "M14,13H9.95C9.4,13 8.95,13.45 8.95,14C8.95,14.55 9.4,15 9.95,15H14C14.55,15 15,14.55 15,14C15,13.45 14.55,13 14,13M9.95,10H12.55C13.1,10 13.55,9.55 13.55,9C13.55,8.45 13.1,8 12.55,8H9.95C9.4,8 8.95,8.45 8.95,9C8.95,9.55 9.4,10 9.95,10M16,9V10C16,10.55 16.45,11 17,11C17.55,11 18,11.45 18,12V15C18,16.66 16.66,18 15,18H9C7.34,18 6,16.66 6,15V8C6,6.34 7.34,5 9,5H13C14.66,5 16,6.34 16,8M20,2H4C2.89,2 2,2.89 2,4V20C2,21.1 2.9,22 4,22H20C21.1,22 22,21.1 22,20V4C22,2.89 21.1,2 20,2Z",
  },
  {
    id: "7CBB03E7-EAC6-44C2-8C28-A78728F8BB7B",
    name: "bluetooth",
    codepoint: "F0AF",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M14.88,16.29L13,18.17V14.41M13,5.83L14.88,7.71L13,9.58M17.71,7.71L12,2H11V9.58L6.41,5L5,6.41L10.59,12L5,17.58L6.41,19L11,14.41V22H12L17.71,16.29L13.41,12L17.71,7.71Z",
  },
  {
    id: "6639774A-9027-4D20-AE57-24C78EF41141",
    name: "bluetooth-audio",
    codepoint: "F0B0",
    aliases: ["bluetooth-searching"],
    tags: ["Audio"],
    author: "Google",
    version: "1.5.54",
    path: "M12.88,16.29L11,18.17V14.41M11,5.83L12.88,7.71L11,9.58M15.71,7.71L10,2H9V9.58L4.41,5L3,6.41L8.59,12L3,17.58L4.41,19L9,14.41V22H10L15.71,16.29L11.41,12M19.53,6.71L18.26,8C18.89,9.18 19.25,10.55 19.25,12C19.25,13.45 18.89,14.82 18.26,16L19.46,17.22C20.43,15.68 21,13.87 21,11.91C21,10 20.46,8.23 19.53,6.71M14.24,12L16.56,14.33C16.84,13.6 17,12.82 17,12C17,11.18 16.84,10.4 16.57,9.68L14.24,12Z",
  },
  {
    id: "1E123F41-EA93-4085-8446-88F50C501A6F",
    name: "bluetooth-connect",
    codepoint: "F0B1",
    aliases: ["bluetooth-connected"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M19,10L17,12L19,14L21,12M14.88,16.29L13,18.17V14.41M13,5.83L14.88,7.71L13,9.58M17.71,7.71L12,2H11V9.58L6.41,5L5,6.41L10.59,12L5,17.58L6.41,19L11,14.41V22H12L17.71,16.29L13.41,12M7,12L5,10L3,12L5,14L7,12Z",
  },
  {
    id: "CEB015C9-455E-4551-A898-7A992658CF72",
    name: "bluetooth-off",
    codepoint: "F0B2",
    aliases: ["bluetooth-disabled"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M13,5.83L14.88,7.71L13.28,9.31L14.69,10.72L17.71,7.7L12,2H11V7.03L13,9.03M5.41,4L4,5.41L10.59,12L5,17.59L6.41,19L11,14.41V22H12L16.29,17.71L18.59,20L20,18.59M13,18.17V14.41L14.88,16.29",
  },
  {
    id: "E5DEA4AB-58E1-45CF-81EF-1A98594C5884",
    name: "bluetooth-settings",
    codepoint: "F0B3",
    aliases: ["settings-bluetooth"],
    tags: ["Settings"],
    author: "Google",
    version: "1.5.54",
    path: "M14.88,14.29L13,16.17V12.41L14.88,14.29M13,3.83L14.88,5.71L13,7.59M17.71,5.71L12,0H11V7.59L6.41,3L5,4.41L10.59,10L5,15.59L6.41,17L11,12.41V20H12L17.71,14.29L13.41,10L17.71,5.71M15,24H17V22H15M7,24H9V22H7M11,24H13V22H11V24Z",
  },
  {
    id: "A0D9FDB0-B6D8-43F9-A418-01B78336C84C",
    name: "bluetooth-transfer",
    codepoint: "F0B4",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M14.71,7.71L10.41,12L14.71,16.29L9,22H8V14.41L3.41,19L2,17.59L7.59,12L2,6.41L3.41,5L8,9.59V2H9L14.71,7.71M10,5.83V9.59L11.88,7.71L10,5.83M11.88,16.29L10,14.41V18.17L11.88,16.29M22,8H20V11H18V8H16L19,4L22,8M22,16L19,20L16,16H18V13H20V16H22Z",
  },
  {
    id: "FAFCB184-2AAD-4E83-924F-1C37F1EDF956",
    name: "blur",
    codepoint: "F0B5",
    aliases: ["blur-on"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M14,8.5C13.17,8.5 12.5,9.17 12.5,10C12.5,10.83 13.17,11.5 14,11.5C14.83,11.5 15.5,10.83 15.5,10C15.5,9.17 14.83,8.5 14,8.5M14,12.5C13.17,12.5 12.5,13.17 12.5,14C12.5,14.83 13.17,15.5 14,15.5C14.83,15.5 15.5,14.83 15.5,14C15.5,13.17 14.83,12.5 14,12.5M10,17C9.45,17 9,17.45 9,18C9,18.55 9.45,19 10,19C10.55,19 11,18.55 11,18C11,17.45 10.55,17 10,17M10,8.5C9.17,8.5 8.5,9.17 8.5,10C8.5,10.83 9.17,11.5 10,11.5C10.83,11.5 11.5,10.83 11.5,10C11.5,9.17 10.83,8.5 10,8.5M14,20.5C13.72,20.5 13.5,20.72 13.5,21C13.5,21.28 13.72,21.5 14,21.5C14.28,21.5 14.5,21.28 14.5,21C14.5,20.72 14.28,20.5 14,20.5M14,17C13.45,17 13,17.45 13,18C13,18.55 13.45,19 14,19C14.55,19 15,18.55 15,18C15,17.45 14.55,17 14,17M21,13.5C20.72,13.5 20.5,13.72 20.5,14C20.5,14.28 20.72,14.5 21,14.5C21.28,14.5 21.5,14.28 21.5,14C21.5,13.72 21.28,13.5 21,13.5M18,5C17.45,5 17,5.45 17,6C17,6.55 17.45,7 18,7C18.55,7 19,6.55 19,6C19,5.45 18.55,5 18,5M18,9C17.45,9 17,9.45 17,10C17,10.55 17.45,11 18,11C18.55,11 19,10.55 19,10C19,9.45 18.55,9 18,9M18,17C17.45,17 17,17.45 17,18C17,18.55 17.45,19 18,19C18.55,19 19,18.55 19,18C19,17.45 18.55,17 18,17M18,13C17.45,13 17,13.45 17,14C17,14.55 17.45,15 18,15C18.55,15 19,14.55 19,14C19,13.45 18.55,13 18,13M10,12.5C9.17,12.5 8.5,13.17 8.5,14C8.5,14.83 9.17,15.5 10,15.5C10.83,15.5 11.5,14.83 11.5,14C11.5,13.17 10.83,12.5 10,12.5M10,7C10.55,7 11,6.55 11,6C11,5.45 10.55,5 10,5C9.45,5 9,5.45 9,6C9,6.55 9.45,7 10,7M10,3.5C10.28,3.5 10.5,3.28 10.5,3C10.5,2.72 10.28,2.5 10,2.5C9.72,2.5 9.5,2.72 9.5,3C9.5,3.28 9.72,3.5 10,3.5M10,20.5C9.72,20.5 9.5,20.72 9.5,21C9.5,21.28 9.72,21.5 10,21.5C10.28,21.5 10.5,21.28 10.5,21C10.5,20.72 10.28,20.5 10,20.5M3,13.5C2.72,13.5 2.5,13.72 2.5,14C2.5,14.28 2.72,14.5 3,14.5C3.28,14.5 3.5,14.28 3.5,14C3.5,13.72 3.28,13.5 3,13.5M14,3.5C14.28,3.5 14.5,3.28 14.5,3C14.5,2.72 14.28,2.5 14,2.5C13.72,2.5 13.5,2.72 13.5,3C13.5,3.28 13.72,3.5 14,3.5M14,7C14.55,7 15,6.55 15,6C15,5.45 14.55,5 14,5C13.45,5 13,5.45 13,6C13,6.55 13.45,7 14,7M21,10.5C21.28,10.5 21.5,10.28 21.5,10C21.5,9.72 21.28,9.5 21,9.5C20.72,9.5 20.5,9.72 20.5,10C20.5,10.28 20.72,10.5 21,10.5M6,5C5.45,5 5,5.45 5,6C5,6.55 5.45,7 6,7C6.55,7 7,6.55 7,6C7,5.45 6.55,5 6,5M3,9.5C2.72,9.5 2.5,9.72 2.5,10C2.5,10.28 2.72,10.5 3,10.5C3.28,10.5 3.5,10.28 3.5,10C3.5,9.72 3.28,9.5 3,9.5M6,9C5.45,9 5,9.45 5,10C5,10.55 5.45,11 6,11C6.55,11 7,10.55 7,10C7,9.45 6.55,9 6,9M6,17C5.45,17 5,17.45 5,18C5,18.55 5.45,19 6,19C6.55,19 7,18.55 7,18C7,17.45 6.55,17 6,17M6,13C5.45,13 5,13.45 5,14C5,14.55 5.45,15 6,15C6.55,15 7,14.55 7,14C7,13.45 6.55,13 6,13Z",
  },
  {
    id: "B23B281D-C753-468E-A0D1-79C2963346C8",
    name: "blur-linear",
    codepoint: "F0B6",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M13,17C13.55,17 14,16.55 14,16C14,15.45 13.55,15 13,15C12.45,15 12,15.45 12,16C12,16.55 12.45,17 13,17M13,13C13.55,13 14,12.55 14,12C14,11.45 13.55,11 13,11C12.45,11 12,11.45 12,12C12,12.55 12.45,13 13,13M13,9C13.55,9 14,8.55 14,8C14,7.45 13.55,7 13,7C12.45,7 12,7.45 12,8C12,8.55 12.45,9 13,9M17,12.5C17.28,12.5 17.5,12.28 17.5,12C17.5,11.72 17.28,11.5 17,11.5C16.72,11.5 16.5,11.72 16.5,12C16.5,12.28 16.72,12.5 17,12.5M17,8.5C17.28,8.5 17.5,8.28 17.5,8C17.5,7.72 17.28,7.5 17,7.5C16.72,7.5 16.5,7.72 16.5,8C16.5,8.28 16.72,8.5 17,8.5M3,3V5H21V3M17,16.5C17.28,16.5 17.5,16.28 17.5,16C17.5,15.72 17.28,15.5 17,15.5C16.72,15.5 16.5,15.72 16.5,16C16.5,16.28 16.72,16.5 17,16.5M9,17C9.55,17 10,16.55 10,16C10,15.45 9.55,15 9,15C8.45,15 8,15.45 8,16C8,16.55 8.45,17 9,17M5,13.5C5.83,13.5 6.5,12.83 6.5,12C6.5,11.17 5.83,10.5 5,10.5C4.17,10.5 3.5,11.17 3.5,12C3.5,12.83 4.17,13.5 5,13.5M5,9.5C5.83,9.5 6.5,8.83 6.5,8C6.5,7.17 5.83,6.5 5,6.5C4.17,6.5 3.5,7.17 3.5,8C3.5,8.83 4.17,9.5 5,9.5M3,21H21V19H3M9,9C9.55,9 10,8.55 10,8C10,7.45 9.55,7 9,7C8.45,7 8,7.45 8,8C8,8.55 8.45,9 9,9M9,13C9.55,13 10,12.55 10,12C10,11.45 9.55,11 9,11C8.45,11 8,11.45 8,12C8,12.55 8.45,13 9,13M5,17.5C5.83,17.5 6.5,16.83 6.5,16C6.5,15.17 5.83,14.5 5,14.5C4.17,14.5 3.5,15.17 3.5,16C3.5,16.83 4.17,17.5 5,17.5Z",
  },
  {
    id: "4F541CC2-7659-4230-A307-6E5D515C529B",
    name: "blur-off",
    codepoint: "F0B7",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M3,13.5C2.72,13.5 2.5,13.72 2.5,14C2.5,14.28 2.72,14.5 3,14.5C3.28,14.5 3.5,14.28 3.5,14C3.5,13.72 3.28,13.5 3,13.5M6,17C5.45,17 5,17.45 5,18C5,18.55 5.45,19 6,19C6.55,19 7,18.55 7,18C7,17.45 6.55,17 6,17M10,20.5C9.72,20.5 9.5,20.72 9.5,21C9.5,21.28 9.72,21.5 10,21.5C10.28,21.5 10.5,21.28 10.5,21C10.5,20.72 10.28,20.5 10,20.5M3,9.5C2.72,9.5 2.5,9.72 2.5,10C2.5,10.28 2.72,10.5 3,10.5C3.28,10.5 3.5,10.28 3.5,10C3.5,9.72 3.28,9.5 3,9.5M6,13C5.45,13 5,13.45 5,14C5,14.55 5.45,15 6,15C6.55,15 7,14.55 7,14C7,13.45 6.55,13 6,13M21,13.5C20.72,13.5 20.5,13.72 20.5,14C20.5,14.28 20.72,14.5 21,14.5C21.28,14.5 21.5,14.28 21.5,14C21.5,13.72 21.28,13.5 21,13.5M10,17C9.45,17 9,17.45 9,18C9,18.55 9.45,19 10,19C10.55,19 11,18.55 11,18C11,17.45 10.55,17 10,17M2.5,5.27L6.28,9.05L6,9C5.45,9 5,9.45 5,10C5,10.55 5.45,11 6,11C6.55,11 7,10.55 7,10C7,9.9 6.97,9.81 6.94,9.72L9.75,12.53C9.04,12.64 8.5,13.26 8.5,14C8.5,14.83 9.17,15.5 10,15.5C10.74,15.5 11.36,14.96 11.47,14.25L14.28,17.06C14.19,17.03 14.1,17 14,17C13.45,17 13,17.45 13,18C13,18.55 13.45,19 14,19C14.55,19 15,18.55 15,18C15,17.9 14.97,17.81 14.94,17.72L18.72,21.5L20,20.23L3.77,4L2.5,5.27M14,20.5C13.72,20.5 13.5,20.72 13.5,21C13.5,21.28 13.72,21.5 14,21.5C14.28,21.5 14.5,21.28 14.5,21C14.5,20.72 14.28,20.5 14,20.5M18,7C18.55,7 19,6.55 19,6C19,5.45 18.55,5 18,5C17.45,5 17,5.45 17,6C17,6.55 17.45,7 18,7M18,11C18.55,11 19,10.55 19,10C19,9.45 18.55,9 18,9C17.45,9 17,9.45 17,10C17,10.55 17.45,11 18,11M18,15C18.55,15 19,14.55 19,14C19,13.45 18.55,13 18,13C17.45,13 17,13.45 17,14C17,14.55 17.45,15 18,15M10,7C10.55,7 11,6.55 11,6C11,5.45 10.55,5 10,5C9.45,5 9,5.45 9,6C9,6.55 9.45,7 10,7M21,10.5C21.28,10.5 21.5,10.28 21.5,10C21.5,9.72 21.28,9.5 21,9.5C20.72,9.5 20.5,9.72 20.5,10C20.5,10.28 20.72,10.5 21,10.5M10,3.5C10.28,3.5 10.5,3.28 10.5,3C10.5,2.72 10.28,2.5 10,2.5C9.72,2.5 9.5,2.72 9.5,3C9.5,3.28 9.72,3.5 10,3.5M14,3.5C14.28,3.5 14.5,3.28 14.5,3C14.5,2.72 14.28,2.5 14,2.5C13.72,2.5 13.5,2.72 13.5,3C13.5,3.28 13.72,3.5 14,3.5M13.8,11.5H14C14.83,11.5 15.5,10.83 15.5,10C15.5,9.17 14.83,8.5 14,8.5C13.17,8.5 12.5,9.17 12.5,10V10.2C12.61,10.87 13.13,11.39 13.8,11.5M14,7C14.55,7 15,6.55 15,6C15,5.45 14.55,5 14,5C13.45,5 13,5.45 13,6C13,6.55 13.45,7 14,7Z",
  },
  {
    id: "29F42A3B-BCD5-45BA-9B87-35F97FE9438D",
    name: "blur-radial",
    codepoint: "F0B8",
    aliases: ["blur-circular"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M14,13C13.45,13 13,13.45 13,14C13,14.55 13.45,15 14,15C14.55,15 15,14.55 15,14C15,13.45 14.55,13 14,13M14,16.5C13.72,16.5 13.5,16.72 13.5,17C13.5,17.28 13.72,17.5 14,17.5C14.28,17.5 14.5,17.28 14.5,17C14.5,16.72 14.28,16.5 14,16.5M12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M17,9.5C16.72,9.5 16.5,9.72 16.5,10C16.5,10.28 16.72,10.5 17,10.5C17.28,10.5 17.5,10.28 17.5,10C17.5,9.72 17.28,9.5 17,9.5M17,13.5C16.72,13.5 16.5,13.72 16.5,14C16.5,14.28 16.72,14.5 17,14.5C17.28,14.5 17.5,14.28 17.5,14C17.5,13.72 17.28,13.5 17,13.5M14,7.5C14.28,7.5 14.5,7.28 14.5,7C14.5,6.72 14.28,6.5 14,6.5C13.72,6.5 13.5,6.72 13.5,7C13.5,7.28 13.72,7.5 14,7.5M14,9C13.45,9 13,9.45 13,10C13,10.55 13.45,11 14,11C14.55,11 15,10.55 15,10C15,9.45 14.55,9 14,9M10,7.5C10.28,7.5 10.5,7.28 10.5,7C10.5,6.72 10.28,6.5 10,6.5C9.72,6.5 9.5,6.72 9.5,7C9.5,7.28 9.72,7.5 10,7.5M7,13.5C6.72,13.5 6.5,13.72 6.5,14C6.5,14.28 6.72,14.5 7,14.5C7.28,14.5 7.5,14.28 7.5,14C7.5,13.72 7.28,13.5 7,13.5M10,16.5C9.72,16.5 9.5,16.72 9.5,17C9.5,17.28 9.72,17.5 10,17.5C10.28,17.5 10.5,17.28 10.5,17C10.5,16.72 10.28,16.5 10,16.5M7,9.5C6.72,9.5 6.5,9.72 6.5,10C6.5,10.28 6.72,10.5 7,10.5C7.28,10.5 7.5,10.28 7.5,10C7.5,9.72 7.28,9.5 7,9.5M10,13C9.45,13 9,13.45 9,14C9,14.55 9.45,15 10,15C10.55,15 11,14.55 11,14C11,13.45 10.55,13 10,13M10,9C9.45,9 9,9.45 9,10C9,10.55 9.45,11 10,11C10.55,11 11,10.55 11,10C11,9.45 10.55,9 10,9Z",
  },
  {
    id: "7DC40C3F-3733-48AF-94C7-5454FB849A49",
    name: "bomb",
    codepoint: "F690",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.7.12",
    path: "M11.25,6C11.25,4.21 12.71,2.75 14.5,2.75C16.29,2.75 17.75,4.21 17.75,6C17.75,6.42 18.08,6.75 18.5,6.75C18.92,6.75 19.25,6.42 19.25,6V5.25H20.75V6C20.75,7.24 19.74,8.25 18.5,8.25C17.26,8.25 16.25,7.24 16.25,6C16.25,5.03 15.47,4.25 14.5,4.25C13.53,4.25 12.75,5.03 12.75,6H14V7.29C16.89,8.15 19,10.83 19,14C19,17.87 15.87,21 12,21C8.13,21 5,17.87 5,14C5,10.83 7.11,8.15 10,7.29V6H11.25M22,6H24V7H22V6M19,4V2H20V4H19M20.91,4.38L22.33,2.96L23.04,3.67L21.62,5.09L20.91,4.38Z",
  },
  {
    id: "DEC98F6C-E85D-400C-87CD-6AE692583838",
    name: "bomb-off",
    codepoint: "F6C4",
    aliases: [],
    tags: [],
    author: "Roberto Graham",
    version: "1.8.36",
    path: "M14.5,2.75C12.7,2.75 11.25,4.2 11.25,6H10V7.29C9.31,7.5 8.67,7.81 8.08,8.2L17.79,17.91C18.58,16.76 19,15.39 19,14C19,10.83 16.89,8.15 14,7.29V6H12.75C12.75,5.03 13.53,4.25 14.5,4.25C15.47,4.25 16.25,5.03 16.25,6C16.25,7.24 17.26,8.25 18.5,8.25C19.74,8.25 20.74,7.24 20.74,6V5.25H19.25V6C19.25,6.42 18.91,6.75 18.5,6.75C18.08,6.75 17.75,6.42 17.75,6C17.75,4.2 16.29,2.75 14.5,2.75M3.41,6.36L2,7.77L5.55,11.32C5.2,12.14 5,13.04 5,14C5,17.86 8.13,21 12,21C12.92,21 13.83,20.81 14.68,20.45L18.23,24L19.64,22.59L3.41,6.36Z",
  },
  {
    id: "7FCD9594-B235-45D5-8504-A41F251FD50E",
    name: "bone",
    codepoint: "F0B9",
    aliases: [],
    tags: ["Animal"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M8,14C8,15.66 6.66,17 5,17C3.34,17 2,15.66 2,14C2,13.23 2.29,12.53 2.76,12C2.29,11.47 2,10.77 2,10C2,8.34 3.34,7 5,7C6.66,7 8,8.34 8,10C9.33,10.08 10.67,10.17 12,10.17C13.33,10.17 14.67,10.08 16,10C16,8.34 17.34,7 19,7C20.66,7 22,8.34 22,10C22,10.77 21.71,11.47 21.24,12C21.71,12.53 22,13.23 22,14C22,15.66 20.66,17 19,17C17.34,17 16,15.66 16,14C14.67,13.92 13.33,13.83 12,13.83C10.67,13.83 9.33,13.92 8,14Z",
  },
  {
    id: "FFF82791-D12F-4643-8128-71CF5FE38C9B",
    name: "book",
    codepoint: "F0BA",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M18,22C19.1,22 20,21.1 20,20V4C20,2.89 19.1,2 18,2H12V9L9.5,7.5L7,9V2H6C4.9,2 4,2.9 4,4V20C4,21.1 4.9,22 6,22H18Z",
  },
  {
    id: "7367B5F0-8155-4F3D-9C7E-BFDF677442D8",
    name: "book-minus",
    codepoint: "F5D9",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M18,22H6C4.9,22 4,21.1 4,20V4C4,2.89 4.9,2 6,2H7V9L9.5,7.5L12,9V2H18C19.1,2 20,2.9 20,4V20C20,21.1 19.1,22 18,22M18,18V16H12V18H18Z",
  },
  {
    id: "637C4988-5432-4F5E-ADD5-EBDC397D0622",
    name: "book-multiple",
    codepoint: "F0BB",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M19,18H9C7.9,18 7,17.1 7,16V4C7,2.9 7.9,2 9,2H10V7L12,5.5L14,7V2H19C20.1,2 21,2.9 21,4V16C21,17.1 20.1,18 19,18M17,20V22H5C3.9,22 3,21.1 3,20V6H5V20H17Z",
  },
  {
    id: "7EFAD89C-D84E-41F0-A8A4-F72AC8DB470C",
    name: "book-open",
    codepoint: "F0BD",
    aliases: ["chrome-reader-mode"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M13,12H20V13.5H13M13,9.5H20V11H13M13,14.5H20V16H13M21,4H3C1.9,4 1,4.9 1,6V19C1,20.1 1.9,21 3,21H21C22.1,21 23,20.1 23,19V6C23,4.9 22.1,4 21,4M21,19H12V6H21",
  },
  {
    id: "113421A1-241F-4479-B22B-5F56EFD63D4C",
    name: "book-open-page-variant",
    codepoint: "F5DA",
    aliases: ["auto-stories"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M19,2L14,6.5V17.5L19,13V2M6.5,5C4.55,5 2.45,5.4 1,6.5V21.16C1,21.41 1.25,21.66 1.5,21.66C1.6,21.66 1.65,21.59 1.75,21.59C3.1,20.94 5.05,20.5 6.5,20.5C8.45,20.5 10.55,20.9 12,22C13.35,21.15 15.8,20.5 17.5,20.5C19.15,20.5 20.85,20.81 22.25,21.56C22.35,21.61 22.4,21.59 22.5,21.59C22.75,21.59 23,21.34 23,21.09V6.5C22.4,6.05 21.75,5.75 21,5.5V7.5L21,13V19C19.9,18.65 18.7,18.5 17.5,18.5C15.8,18.5 13.35,19.15 12,20V13L12,8.5V6.5C10.55,5.4 8.45,5 6.5,5V5Z",
  },
  {
    id: "08C8BAF9-6B91-458D-BE03-F6A7AABEA2AB",
    name: "book-open-variant",
    codepoint: "F0BE",
    aliases: ["import-contacts"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M21,5C19.89,4.65 18.67,4.5 17.5,4.5C15.55,4.5 13.45,4.9 12,6C10.55,4.9 8.45,4.5 6.5,4.5C4.55,4.5 2.45,4.9 1,6V20.65C1,20.9 1.25,21.15 1.5,21.15C1.6,21.15 1.65,21.1 1.75,21.1C3.1,20.45 5.05,20 6.5,20C8.45,20 10.55,20.4 12,21.5C13.35,20.65 15.8,20 17.5,20C19.15,20 20.85,20.3 22.25,21.05C22.35,21.1 22.4,21.1 22.5,21.1C22.75,21.1 23,20.85 23,20.6V6C22.4,5.55 21.75,5.25 21,5M21,18.5C19.9,18.15 18.7,18 17.5,18C15.8,18 13.35,18.65 12,19.5V8C13.35,7.15 15.8,6.5 17.5,6.5C18.7,6.5 19.9,6.65 21,7V18.5Z",
  },
  {
    id: "3C49BDB2-C3A3-4E0C-9314-19FE66414A5B",
    name: "book-plus",
    codepoint: "F5DB",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M18,22H6C4.9,22 4,21.1 4,20V4C4,2.89 4.9,2 6,2H7V9L9.5,7.5L12,9V2H18C19.1,2 20,2.9 20,4V20C20,21.1 19.1,22 18,22M14,20H16V18H18V16H16V14H14V16H12V18H14V20Z",
  },
  {
    id: "1B9F45CE-CA39-4ACF-8961-4B4B56D6F94A",
    name: "book-variant",
    codepoint: "F0BF",
    aliases: ["class"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M6,4H11V12L8.5,10.5L6,12M18,2H6C4.9,2 4,2.9 4,4V20C4,21.1 4.9,22 6,22H18C19.1,22 20,21.1 20,20V4C20,2.9 19.1,2 18,2Z",
  },
  {
    id: "690787DD-F7B0-4D32-A668-32657D3A3AE8",
    name: "bookmark",
    codepoint: "F0C0",
    aliases: ["turned-in"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M17,3H7C5.9,3 5,3.9 5,5V21L12,18L19,21V5C19,3.89 18.1,3 17,3Z",
  },
  {
    id: "65F155F1-7A9F-49AF-B570-FD6D24553CE5",
    name: "bookmark-check",
    codepoint: "F0C1",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M17,3C18.1,3 19,3.9 19,5V21L12,18L5,21V5C5,3.89 5.9,3 7,3H17M11,14L17.25,7.76L15.84,6.34L11,11.18L8.41,8.59L7,10L11,14Z",
  },
  {
    id: "AB2B19C4-5114-4D8A-A2EB-4E112B43F383",
    name: "bookmark-minus",
    codepoint: "F9CB",
    aliases: [],
    tags: [],
    author: "Michael Irigoyen",
    version: "2.5.94",
    path: "M17,3H7C5.9,3 5,3.9 5,5V21L12,18L19,21V5C19,3.9 18.1,3 17,3M15,11H9V9H15V11Z",
  },
  {
    id: "491E1C5C-650E-41BB-9D44-8F8F2474B657",
    name: "bookmark-minus-outline",
    codepoint: "F9CC",
    aliases: [],
    tags: [],
    author: "Michael Irigoyen",
    version: "2.5.94",
    path: "M9,11V9H15V11H9M19,5V21L12,18L5,21V5C5,3.89 5.9,3 7,3H17C18.11,3 19,3.9 19,5M17,5H7V18L12,15.82L17,18V5Z",
  },
  {
    id: "DF4ECEB8-EF5C-4ACC-BC7D-B4FEEE75D17D",
    name: "bookmark-music",
    codepoint: "F0C2",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M17,3C18.1,3 19,3.9 19,5V21L12,18L5,21V5C5,3.89 5.9,3 7,3H17M11,11C9.9,11 9,11.9 9,13C9,14.1 9.9,15 11,15C12.1,15 13,14.1 13,13V8H16V6H12V11.27C11.71,11.1 11.36,11 11,11Z",
  },
  {
    id: "CE74B9A9-5962-4127-ACBE-A1AD4F130A2F",
    name: "bookmark-off",
    codepoint: "F9CD",
    aliases: [],
    tags: [],
    author: "Michael Irigoyen",
    version: "2.5.94",
    path: "M20,20.72L18.73,22L16.78,20.05L12,18L5,21V8.27L2,5.27L3.28,4L20,20.72M19,17.16V5C19,3.89 18.1,3 17,3H7C6.41,3 5.89,3.27 5.5,3.68L19,17.16Z",
  },
  {
    id: "998B6488-F375-4297-9941-6D8ADC4E7F3C",
    name: "bookmark-off-outline",
    codepoint: "F9CE",
    aliases: [],
    tags: [],
    author: "Michael Irigoyen",
    version: "2.5.94",
    path: "M3.28,4L2,5.27L5,8.27V21L12,18L16.78,20.05L18.73,22L20,20.72L3.28,4M7,18V10.27L13,16.25L12,15.82L7,18M7,5.16L5.5,3.67C5.88,3.26 6.41,3 7,3H17C18.1,3 19,3.9 19,5V17.16L17,15.16V5H7V5.16Z",
  },
  {
    id: "0EB6BB85-4BE2-4608-BABF-2EF135D420A7",
    name: "bookmark-outline",
    codepoint: "F0C3",
    aliases: ["bookmark-border", "turned-in-not"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M17,18L12,15.82L7,18V5H17M17,3H7C5.9,3 5,3.9 5,5V21L12,18L19,21V5C19,3.89 18.1,3 17,3Z",
  },
  {
    id: "596822BD-8373-402C-9D27-C341405F55F9",
    name: "bookmark-plus",
    codepoint: "F0C5",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M17,3C18.1,3 19,3.9 19,5V21L12,18L5,21V5C5,3.89 5.9,3 7,3H17M11,7V9H9V11H11V13H13V11H15V9H13V7H11Z",
  },
  {
    id: "DB2B7624-66CB-4E7E-A65F-4CEE8870C6CC",
    name: "bookmark-plus-outline",
    codepoint: "F0C4",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M17,18V5H7V18L12,15.82L17,18M17,3C18.1,3 19,3.9 19,5V21L12,18L5,21V5C5,3.89 5.9,3 7,3H17M11,7H13V9H15V11H13V13H11V11H9V9H11V7Z",
  },
  {
    id: "89594C9C-18ED-45EA-A3AC-A91B570D1541",
    name: "bookmark-remove",
    codepoint: "F0C6",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M17,3C18.1,3 19,3.9 19,5V21L12,18L5,21V5C5,3.89 5.9,3 7,3H17M8.17,8.58L10.59,11L8.17,13.41L9.59,14.83L12,12.41L14.41,14.83L15.83,13.41L13.41,11L15.83,8.58L14.41,7.17L12,9.58L9.59,7.17L8.17,8.58Z",
  },
  {
    id: "DAA06443-AE25-4881-BC62-8033C4420B8E",
    name: "boombox",
    codepoint: "F5DC",
    aliases: [],
    tags: ["Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M7,5L5,7V8H3C2.45,8 2,8.45 2,9V17C2,17.55 2.45,18 3,18H21C21.55,18 22,17.55 22,17V9C22,8.45 21.55,8 21,8H19V7L17,5H7M7,7H17V8H7V7M11,9H13C13.28,9 13.5,9.22 13.5,9.5C13.5,9.78 13.28,10 13,10H11C10.72,10 10.5,9.78 10.5,9.5C10.5,9.22 10.72,9 11,9M7.5,10.5C9.16,10.5 10.5,11.84 10.5,13.5C10.5,15.16 9.16,16.5 7.5,16.5C5.84,16.5 4.5,15.16 4.5,13.5C4.5,11.84 5.84,10.5 7.5,10.5M16.5,10.5C18.16,10.5 19.5,11.84 19.5,13.5C19.5,15.16 18.16,16.5 16.5,16.5C14.84,16.5 13.5,15.16 13.5,13.5C13.5,11.84 14.84,10.5 16.5,10.5M7.5,12C6.67,12 6,12.67 6,13.5C6,14.33 6.67,15 7.5,15C8.33,15 9,14.33 9,13.5C9,12.67 8.33,12 7.5,12M16.5,12C15.67,12 15,12.67 15,13.5C15,14.33 15.67,15 16.5,15C17.33,15 18,14.33 18,13.5C18,12.67 17.33,12 16.5,12Z",
  },
  {
    id: "9DAC7258-AB2D-49E4-98A9-E84A5E3E474B",
    name: "bootstrap",
    codepoint: "F6C5",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.8.36",
    path: "M3,5C3,3.9 3.9,3 5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.89,21 3,20.1 3,19V5M7.5,6V18H12.5C14.75,18 16.5,16.75 16.5,14.5C16.5,12.5 14.77,11.5 13.25,11.5C14.77,11.5 16,10.27 16,8.75C16,7.23 14.27,6 12.75,6H7.5M10,11V8H11.5C12.33,8 13,8.67 13,9.5C13,10.33 12.33,11 11.5,11H10M10,13H12C12.83,13 13.5,13.67 13.5,14.5C13.5,15.33 12.83,16 12,16H10V13Z",
  },
  {
    id: "A3D0E8B6-96B3-4281-B31C-0DDFD729903B",
    name: "border-all",
    codepoint: "F0C7",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Google",
    version: "1.5.54",
    path: "M19,11H13V5H19M19,19H13V13H19M11,11H5V5H11M11,19H5V13H11M3,21H21V3H3V21Z",
  },
  {
    id: "AD3DDFBC-21FE-4D6E-AE09-E9EB7D289459",
    name: "border-all-variant",
    codepoint: "F8A0",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "2.2.43",
    path: "M3,21V3H21V21H3M5,5V19H19V5H5Z",
  },
  {
    id: "9441B8BD-25C8-4F46-AFD4-6B2DA0C4A599",
    name: "border-bottom",
    codepoint: "F0C8",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Google",
    version: "1.5.54",
    path: "M5,15H3V17H5M3,21H21V19H3M5,11H3V13H5M19,9H21V7H19M19,5H21V3H19M5,7H3V9H5M19,17H21V15H19M19,13H21V11H19M17,3H15V5H17M13,3H11V5H13M17,11H15V13H17M13,7H11V9H13M5,3H3V5H5M13,11H11V13H13M9,3H7V5H9M13,15H11V17H13M9,11H7V13H9V11Z",
  },
  {
    id: "29792687-63C3-41A6-8182-CF829969BD48",
    name: "border-bottom-variant",
    codepoint: "F8A1",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "2.2.43",
    path: "M5,15H3V17H5M3,21H21V19H3M5,11H3V13H5M19,9H21V7H19M19,5H21V3H19M5,7H3V9H5M19,17H21V15H19M19,13H21V11H19M17,3H15V5H17M13,3H11V5H13M5,3H3V5H5M9,3H7V5H9",
  },
  {
    id: "CCD99C36-5D88-4696-8193-56F11C4B20A7",
    name: "border-color",
    codepoint: "F0C9",
    aliases: ["border-colour"],
    tags: ["Color"],
    author: "Google",
    version: "1.5.54",
    path: "M20.71,4.04C21.1,3.65 21.1,3 20.71,2.63L18.37,0.29C18,-0.1 17.35,-0.1 16.96,0.29L15,2.25L18.75,6M17.75,7L14,3.25L4,13.25V17H7.75L17.75,7Z",
  },
  {
    id: "0F804E73-90EF-4175-984D-603698F0AF09",
    name: "border-horizontal",
    codepoint: "F0CA",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Google",
    version: "1.5.54",
    path: "M19,21H21V19H19M15,21H17V19H15M11,17H13V15H11M19,9H21V7H19M19,5H21V3H19M3,13H21V11H3M11,21H13V19H11M19,17H21V15H19M13,3H11V5H13M13,7H11V9H13M17,3H15V5H17M9,3H7V5H9M5,3H3V5H5M7,21H9V19H7M3,17H5V15H3M5,7H3V9H5M3,21H5V19H3V21Z",
  },
  {
    id: "F7471447-8501-40A6-9FFB-AB353B55AA89",
    name: "border-inside",
    codepoint: "F0CB",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Google",
    version: "1.5.54",
    path: "M19,17H21V15H19M19,21H21V19H19M13,3H11V11H3V13H11V21H13V13H21V11H13M15,21H17V19H15M19,5H21V3H19M19,9H21V7H19M17,3H15V5H17M5,3H3V5H5M9,3H7V5H9M3,17H5V15H3M5,7H3V9H5M7,21H9V19H7M3,21H5V19H3V21Z",
  },
  {
    id: "6B8A1379-9497-4B1B-A8CF-51CB1AD67757",
    name: "border-left",
    codepoint: "F0CC",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Google",
    version: "1.5.54",
    path: "M15,5H17V3H15M15,13H17V11H15M19,21H21V19H19M19,13H21V11H19M19,5H21V3H19M19,17H21V15H19M15,21H17V19H15M19,9H21V7H19M3,21H5V3H3M7,13H9V11H7M7,5H9V3H7M7,21H9V19H7M11,13H13V11H11M11,9H13V7H11M11,5H13V3H11M11,17H13V15H11M11,21H13V19H11V21Z",
  },
  {
    id: "063FAD96-7055-4D1E-8E50-B9288BB9D0B0",
    name: "border-left-variant",
    codepoint: "F8A2",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "2.2.43",
    path: "M15,5H17V3H15M19,21H21V19H19M19,13H21V11H19M19,5H21V3H19M19,17H21V15H19M15,21H17V19H15M19,9H21V7H19M3,21H5V3H3M7,5H9V3H7M7,21H9V19H7M11,5H13V3H11M11,21H13V19H11V21Z",
  },
  {
    id: "F6333BD9-AC00-428D-B8A8-FA3B9187487F",
    name: "border-none",
    codepoint: "F0CD",
    aliases: ["border-clear"],
    tags: ["Text / Content / Format"],
    author: "Google",
    version: "1.5.54",
    path: "M15,5H17V3H15M15,13H17V11H15M15,21H17V19H15M11,5H13V3H11M19,5H21V3H19M11,9H13V7H11M19,9H21V7H19M19,21H21V19H19M19,13H21V11H19M19,17H21V15H19M11,13H13V11H11M3,5H5V3H3M3,9H5V7H3M3,13H5V11H3M3,17H5V15H3M3,21H5V19H3M11,21H13V19H11M11,17H13V15H11M7,21H9V19H7M7,13H9V11H7M7,5H9V3H7V5Z",
  },
  {
    id: "C8EC415C-81DE-4399-AEAB-FE102959F619",
    name: "border-none-variant",
    codepoint: "F8A3",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "2.2.43",
    path: "M15,5H17V3H15M15,21H17V19H15M11,5H13V3H11M19,5H21V3H19M19,9H21V7H19M19,21H21V19H19M19,13H21V11H19M19,17H21V15H19M3,5H5V3H3M3,9H5V7H3M3,13H5V11H3M3,17H5V15H3M3,21H5V19H3M11,21H13V19H11M7,21H9V19H7M7,5H9V3H7V5Z",
  },
  {
    id: "F8EA9B00-82F1-4DE8-B8B5-0A71B934C44D",
    name: "border-outside",
    codepoint: "F0CE",
    aliases: ["border-outer"],
    tags: ["Text / Content / Format"],
    author: "Google",
    version: "1.5.54",
    path: "M9,11H7V13H9M13,15H11V17H13M19,19H5V5H19M3,21H21V3H3M17,11H15V13H17M13,11H11V13H13M13,7H11V9H13V7Z",
  },
  {
    id: "BC67506B-CAE4-4EDA-B0C8-614436AFDCBF",
    name: "border-right",
    codepoint: "F0CF",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Google",
    version: "1.5.54",
    path: "M11,9H13V7H11M11,5H13V3H11M11,13H13V11H11M15,5H17V3H15M15,21H17V19H15M19,21H21V3H19M15,13H17V11H15M11,17H13V15H11M3,9H5V7H3M3,17H5V15H3M3,13H5V11H3M11,21H13V19H11M3,21H5V19H3M7,13H9V11H7M7,5H9V3H7M3,5H5V3H3M7,21H9V19H7V21Z",
  },
  {
    id: "6284DA6C-DB95-4747-BB40-DE69D5970C5B",
    name: "border-right-variant",
    codepoint: "F8A4",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "2.2.43",
    path: "M11,5H13V3H11M15,5H17V3H15M15,21H17V19H15M19,21H21V3H19M3,9H5V7H3M3,17H5V15H3M3,13H5V11H3M11,21H13V19H11M3,21H5V19H3M7,5H9V3H7M3,5H5V3H3M7,21H9V19H7V21Z",
  },
  {
    id: "5A750E96-F9A0-4C38-B601-8BA770E89E01",
    name: "border-style",
    codepoint: "F0D0",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Google",
    version: "1.5.54",
    path: "M15,21H17V19H15M19,21H21V19H19M7,21H9V19H7M11,21H13V19H11M19,17H21V15H19M19,13H21V11H19M3,3V21H5V5H21V3M19,9H21V7H19",
  },
  {
    id: "AE703F65-F8D5-43B9-9B6B-B5966260E799",
    name: "border-top",
    codepoint: "F0D1",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Google",
    version: "1.5.54",
    path: "M15,13H17V11H15M19,21H21V19H19M11,9H13V7H11M15,21H17V19H15M19,17H21V15H19M3,5H21V3H3M19,13H21V11H19M19,9H21V7H19M11,17H13V15H11M3,9H5V7H3M3,13H5V11H3M3,21H5V19H3M3,17H5V15H3M11,21H13V19H11M11,13H13V11H11M7,13H9V11H7M7,21H9V19H7V21Z",
  },
  {
    id: "E9426CB0-FC83-40AA-B429-F55AD3F72E47",
    name: "border-top-variant",
    codepoint: "F8A5",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "2.2.43",
    path: "M19,21H21V19H19M15,21H17V19H15M19,17H21V15H19M3,5H21V3H3M19,13H21V11H19M19,9H21V7H19M3,9H5V7H3M3,13H5V11H3M3,21H5V19H3M3,17H5V15H3M11,21H13V19H11M7,21H9V19H7V21Z",
  },
  {
    id: "540E7940-BA85-4EED-BEAB-C50CEF348D50",
    name: "border-vertical",
    codepoint: "F0D2",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Google",
    version: "1.5.54",
    path: "M15,13H17V11H15M15,21H17V19H15M15,5H17V3H15M19,9H21V7H19M19,5H21V3H19M19,13H21V11H19M19,21H21V19H19M11,21H13V3H11M19,17H21V15H19M7,5H9V3H7M3,17H5V15H3M3,21H5V19H3M3,13H5V11H3M7,13H9V11H7M7,21H9V19H7M3,5H5V3H3M3,9H5V7H3V9Z",
  },
  {
    id: "E27EBD86-D80B-473B-BEAB-A22005475F38",
    name: "bottle-wine",
    codepoint: "F853",
    aliases: [],
    tags: [],
    author: "James Coyle",
    version: "2.1.99",
    path: "M10,22C9.45,22 9,21.55 9,21V11C9,9 10,7.25 11,7V2.5C11,2.22 11.22,2 11.5,2H12.5C12.78,2 13,2.22 13,2.5V7C14,7.25 15,9 15,11V21C15,21.55 14.55,22 14,22H10Z",
  },
  {
    id: "741B300C-06EF-459D-BB3E-95DB8E21194E",
    name: "bow-tie",
    codepoint: "F677",
    aliases: [],
    tags: ["Clothing"],
    author: "Thomas Hunsaker",
    version: "1.7.12",
    path: "M15,14L21,17V7L15,10V14M9,14L3,17V7L9,10V14M10,10H14V14H10V10Z",
  },
  {
    id: "95E70948-C85D-41AC-887C-62752FBA7B6B",
    name: "bowl",
    codepoint: "F617",
    aliases: [],
    tags: ["Food / Drink"],
    author: "Austin Andrews",
    version: "1.6.50",
    path: "M22,15C22,18.87 18.87,22 15,22H9C5.13,22 2,18.87 2,15V12H15.58L20.3,4.44L22,5.5L17.94,12H22V15Z",
  },
  {
    id: "0CAB5DF9-E4A7-418D-B317-E792FF2DF8D1",
    name: "bowling",
    codepoint: "F0D3",
    aliases: [],
    tags: ["Sport"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M12.5,11C11.67,11 11,11.67 11,12.5C11,13.33 11.67,14 12.5,14C13.33,14 14,13.33 14,12.5C14,11.67 13.33,11 12.5,11M12,5C10.9,5 10,5.9 10,7C10,8.1 10.9,9 12,9C13.1,9 14,8.1 14,7C14,5.9 13.1,5 12,5M5.93,8.5C5.38,9.45 5.71,10.67 6.66,11.22C7.62,11.78 8.84,11.45 9.4,10.5C9.95,9.53 9.62,8.31 8.66,7.76C7.71,7.21 6.5,7.53 5.93,8.5Z",
  },
  {
    id: "1E6B8A9E-921F-4695-B1CA-0A87AC157E88",
    name: "box",
    codepoint: "F0D4",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M15.39,14.04V14.04C15.39,12.62 14.24,11.47 12.82,11.47C11.41,11.47 10.26,12.62 10.26,14.04V14.04C10.26,15.45 11.41,16.6 12.82,16.6C14.24,16.6 15.39,15.45 15.39,14.04M17.1,14.04C17.1,16.4 15.18,18.31 12.82,18.31C11.19,18.31 9.77,17.39 9.05,16.04C8.33,17.39 6.91,18.31 5.28,18.31C2.94,18.31 1.04,16.43 1,14.11V14.11H1V7H1V7C1,6.56 1.39,6.18 1.86,6.18C2.33,6.18 2.7,6.56 2.71,7V7H2.71V10.62C3.43,10.08 4.32,9.76 5.28,9.76C6.91,9.76 8.33,10.68 9.05,12.03C9.77,10.68 11.19,9.76 12.82,9.76C15.18,9.76 17.1,11.68 17.1,14.04V14.04M7.84,14.04V14.04C7.84,12.62 6.69,11.47 5.28,11.47C3.86,11.47 2.71,12.62 2.71,14.04V14.04C2.71,15.45 3.86,16.6 5.28,16.6C6.69,16.6 7.84,15.45 7.84,14.04M22.84,16.96V16.96C22.95,17.12 23,17.3 23,17.47C23,17.73 22.88,18 22.66,18.15C22.5,18.26 22.33,18.32 22.15,18.32C21.9,18.32 21.65,18.21 21.5,18L19.59,15.47L17.7,18V18C17.53,18.21 17.28,18.32 17.03,18.32C16.85,18.32 16.67,18.26 16.5,18.15C16.29,18 16.17,17.72 16.17,17.46C16.17,17.29 16.23,17.11 16.33,16.96V16.96H16.33V16.96L18.5,14.04L16.33,11.11V11.11H16.33V11.11C16.22,10.96 16.17,10.79 16.17,10.61C16.17,10.35 16.29,10.1 16.5,9.93C16.89,9.65 17.41,9.72 17.7,10.09V10.09L19.59,12.61L21.5,10.09C21.76,9.72 22.29,9.65 22.66,9.93C22.89,10.1 23,10.36 23,10.63C23,10.8 22.95,10.97 22.84,11.11V11.11H22.84V11.11L20.66,14.04L22.84,16.96V16.96H22.84Z",
  },
  {
    id: "A4C51C21-DEB0-4247-AEA3-B5F454641BDC",
    name: "box-cutter",
    codepoint: "F0D5",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M7.22,11.91C6.89,12.24 6.71,12.65 6.66,13.08L12.17,15.44L20.66,6.96C21.44,6.17 21.44,4.91 20.66,4.13L19.24,2.71C18.46,1.93 17.2,1.93 16.41,2.71L7.22,11.91M5,16V21.75L10.81,16.53L5.81,14.53L5,16M17.12,4.83C17.5,4.44 18.15,4.44 18.54,4.83C18.93,5.23 18.93,5.86 18.54,6.25C18.15,6.64 17.5,6.64 17.12,6.25C16.73,5.86 16.73,5.23 17.12,4.83Z",
  },
  {
    id: "9DBE04CB-C425-4556-9046-15CBD88C866B",
    name: "box-shadow",
    codepoint: "F637",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.6.50",
    path: "M3,3H18V18H3V3M19,19H21V21H19V19M19,16H21V18H19V16M19,13H21V15H19V13M19,10H21V12H19V10M19,7H21V9H19V7M16,19H18V21H16V19M13,19H15V21H13V19M10,19H12V21H10V19M7,19H9V21H7V19Z",
  },
  {
    id: "3B62C43D-F1BC-45AB-AB68-B1B854009FD8",
    name: "braille",
    codepoint: "F9CF",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.5.94",
    path: "M7,8C7,7.45 7.45,7 8,7C8.55,7 9,7.45 9,8V12.47L10.21,12.6L15.15,14.79C15.67,15.03 16,15.56 16,16.14V20.5C15.97,21.32 15.32,21.97 14.5,22H8C7.62,22 7.26,21.85 7,21.57L2.1,17.37L2.84,16.6C3.03,16.39 3.3,16.28 3.58,16.28H3.8L7,18V8M19.5,2C18.67,2 18,2.67 18,3.5C18,4.33 18.67,5 19.5,5C20.33,5 21,4.33 21,3.5C21,2.67 20.33,2 19.5,2M19.5,7C18.67,7 18,7.67 18,8.5C18,9.33 18.67,10 19.5,10C20.33,10 21,9.33 21,8.5C21,7.67 20.33,7 19.5,7M14.5,7C13.67,7 13,7.67 13,8.5C13,9.33 13.67,10 14.5,10C15.33,10 16,9.33 16,8.5C16,7.67 15.33,7 14.5,7M19.5,12C18.67,12 18,12.67 18,13.5C18,14.33 18.67,15 19.5,15C20.33,15 21,14.33 21,13.5C21,12.67 20.33,12 19.5,12Z",
  },
  {
    id: "8EC09BCA-7C35-4FAB-9000-4A7795CC0930",
    name: "brain",
    codepoint: "F9D0",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.5.94",
    path: "M21.33,12.91C21.42,14.46 20.71,15.95 19.44,16.86L20.21,18.35C20.44,18.8 20.47,19.33 20.27,19.8C20.08,20.27 19.69,20.64 19.21,20.8L18.42,21.05C18.25,21.11 18.06,21.14 17.88,21.14C17.37,21.14 16.89,20.91 16.56,20.5L14.44,18C13.55,17.85 12.71,17.47 12,16.9C11.5,17.05 11,17.13 10.5,17.13C9.62,17.13 8.74,16.86 8,16.34C7.47,16.5 6.93,16.57 6.38,16.56C5.59,16.57 4.81,16.41 4.08,16.11C2.65,15.47 1.7,14.07 1.65,12.5C1.57,11.78 1.69,11.05 2,10.39C1.71,9.64 1.68,8.82 1.93,8.06C2.3,7.11 3,6.32 3.87,5.82C4.45,4.13 6.08,3 7.87,3.12C9.47,1.62 11.92,1.46 13.7,2.75C14.12,2.64 14.56,2.58 15,2.58C16.36,2.55 17.65,3.15 18.5,4.22C20.54,4.75 22,6.57 22.08,8.69C22.13,9.8 21.83,10.89 21.22,11.82C21.29,12.18 21.33,12.54 21.33,12.91M16.33,11.5C16.9,11.57 17.35,12 17.35,12.57C17.35,13.12 16.9,13.57 16.35,13.57H15.72C15.4,14.47 14.84,15.26 14.1,15.86C14.35,15.95 14.61,16 14.87,16.07C20,16 19.4,12.87 19.4,12.82C19.34,11.39 18.14,10.27 16.71,10.33C16.16,10.33 15.71,9.88 15.71,9.33C15.71,8.78 16.16,8.33 16.71,8.33C17.94,8.36 19.12,8.82 20.04,9.63C20.09,9.34 20.12,9.04 20.12,8.74C20.06,7.5 19.5,6.42 17.25,6.21C16,3.25 12.85,4.89 12.85,5.81V5.81C12.82,6.04 13.06,6.53 13.1,6.56C13.65,6.56 14.1,7.01 14.1,7.56C14.1,8.11 13.65,8.56 13.1,8.56V8.56C12.57,8.54 12.07,8.34 11.67,8C11.19,8.31 10.64,8.5 10.07,8.56V8.56C9.5,8.61 9.03,8.21 9,7.66C8.92,7.1 9.33,6.61 9.88,6.56C10.04,6.54 10.82,6.42 10.82,5.79V5.79C10.82,5.13 11.07,4.5 11.5,4C10.58,3.75 9.59,4.08 8.59,5.29C6.75,5 6,5.25 5.45,7.2C4.5,7.67 4,8 3.78,9C4.86,8.78 5.97,8.87 7,9.25C7.5,9.44 7.78,10 7.59,10.54C7.4,11.06 6.82,11.32 6.3,11.13C5.57,10.81 4.75,10.79 4,11.07C3.68,11.34 3.68,11.9 3.68,12.34C3.68,13.08 4.05,13.77 4.68,14.17C5.21,14.44 5.8,14.58 6.39,14.57C6.24,14.31 6.11,14.04 6,13.76C5.81,13.22 6.1,12.63 6.64,12.44C7.18,12.25 7.77,12.54 7.96,13.08C8.36,14.22 9.38,15 10.58,15.13C11.95,15.06 13.17,14.25 13.77,13C14,11.62 15.11,11.5 16.33,11.5M18.33,18.97L17.71,17.67L17,17.83L18,19.08L18.33,18.97M13.68,10.36C13.7,9.83 13.3,9.38 12.77,9.33C12.06,9.29 11.37,9.53 10.84,10C10.27,10.58 9.97,11.38 10,12.19C10,12.74 10.45,13.19 11,13.19C11.57,13.19 12,12.74 12,12.19C12,11.92 12.07,11.65 12.23,11.43C12.35,11.33 12.5,11.28 12.66,11.28C13.21,11.31 13.68,10.9 13.68,10.36Z",
  },
  {
    id: "9FD9D8F0-D777-4B33-9CF7-E32FD8C25655",
    name: "bridge",
    codepoint: "F618",
    aliases: [],
    tags: ["Places"],
    author: "Austin Andrews",
    version: "1.6.50",
    path: "M7,14V10.91C6.28,10.58 5.61,10.18 5,9.71V14H7M5,18H3V16H1V14H3V7H5V8.43C6.8,10 9.27,11 12,11C14.73,11 17.2,10 19,8.43V7H21V14H23V16H21V18H19V16H5V18M17,10.91V14H19V9.71C18.39,10.18 17.72,10.58 17,10.91M16,14V11.32C15.36,11.55 14.69,11.72 14,11.84V14H16M13,14V11.96L12,12L11,11.96V14H13M10,14V11.84C9.31,11.72 8.64,11.55 8,11.32V14H10Z",
  },
  {
    id: "15A9F4A5-3EB6-443C-8283-547A077CB0C4",
    name: "briefcase",
    codepoint: "F0D6",
    aliases: ["work"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M10,2H14C15.1,2 16,2.9 16,4V6H20C21.1,6 22,6.9 22,8V19C22,20.1 21.1,21 20,21H4C2.89,21 2,20.1 2,19V8C2,6.89 2.89,6 4,6H8V4C8,2.89 8.89,2 10,2M14,6V4H10V6H14Z",
  },
  {
    id: "4182182E-F79B-4153-B652-2A4B4AC231E1",
    name: "briefcase-check",
    codepoint: "F0D7",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M10,2H14C15.1,2 16,2.9 16,4V6H20C21.1,6 22,6.9 22,8V19C22,20.1 21.1,21 20,21H4C2.9,21 2,20.1 2,19V8C2,6.9 2.9,6 4,6H8V4C8,2.9 8.9,2 10,2M14,6V4H10V6H14M10.5,17.5L17.09,10.91L15.68,9.5L10.5,14.67L8.41,12.59L7,14L10.5,17.5Z",
  },
  {
    id: "D4705E48-0920-451E-BFF3-2DA1BBA5C21D",
    name: "briefcase-download",
    codepoint: "F0D8",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M10,2H14C15.1,2 16,2.9 16,4V6H20C21.1,6 22,6.9 22,8V19C22,20.1 21.1,21 20,21H4C2.89,21 2,20.1 2,19V8C2,6.89 2.89,6 4,6H8V4C8,2.89 8.89,2 10,2M14,6V4H10V6H14M12,19L17,14H14V10H10V14H7L12,19Z",
  },
  {
    id: "1E7F3689-287C-40DC-B0DD-CF65987E9B53",
    name: "briefcase-outline",
    codepoint: "F813",
    aliases: [],
    tags: [],
    author: "Google",
    version: "2.1.19",
    path: "M20,6C20.58,6 21.05,6.2 21.42,6.59C21.8,7 22,7.45 22,8V19C22,19.55 21.8,20 21.42,20.41C21.05,20.8 20.58,21 20,21H4C3.42,21 2.95,20.8 2.58,20.41C2.2,20 2,19.55 2,19V8C2,7.45 2.2,7 2.58,6.59C2.95,6.2 3.42,6 4,6H8V4C8,3.42 8.2,2.95 8.58,2.58C8.95,2.2 9.42,2 10,2H14C14.58,2 15.05,2.2 15.42,2.58C15.8,2.95 16,3.42 16,4V6H20M4,8V19H20V8H4M14,6V4H10V6H14Z",
  },
  {
    id: "3D48B9FF-A060-47DA-809E-32D5ED68CA64",
    name: "briefcase-upload",
    codepoint: "F0D9",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M10,2H14C15.1,2 16,2.9 16,4V6H20C21.1,6 22,6.9 22,8V19C22,20.1 21.1,21 20,21H4C2.89,21 2,20.1 2,19V8C2,6.89 2.89,6 4,6H8V4C8,2.89 8.89,2 10,2M14,6V4H10V6H14M12,9L7,14H10V18H14V14H17L12,9Z",
  },
  {
    id: "B3FF12D1-1C76-4E1D-BAD0-468E424BADA7",
    name: "brightness-1",
    codepoint: "F0DA",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2Z",
  },
  {
    id: "FAEBEE4C-295C-475F-AE7D-11CFA4688017",
    name: "brightness-2",
    codepoint: "F0DB",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M10,2C8.18,2 6.47,2.5 5,3.35C8,5.08 10,8.3 10,12C10,15.7 8,18.92 5,20.65C6.47,21.5 8.18,22 10,22C15.52,22 20,17.52 20,12C20,6.48 15.52,2 10,2Z",
  },
  {
    id: "825E1BB2-1E01-4E6E-9CF0-04412FDECDA6",
    name: "brightness-3",
    codepoint: "F0DC",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M9,2C7.95,2 6.95,2.16 6,2.46C10.06,3.73 13,7.5 13,12C13,16.5 10.06,20.27 6,21.54C6.95,21.84 7.95,22 9,22C14.52,22 19,17.52 19,12C19,6.48 14.52,2 9,2Z",
  },
  {
    id: "10EC7F50-BDC1-45C4-A6D2-2CB5FB4DE902",
    name: "brightness-4",
    codepoint: "F0DD",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M12,18C11.11,18 10.26,17.8 9.5,17.45C11.56,16.5 13,14.42 13,12C13,9.58 11.56,7.5 9.5,6.55C10.26,6.2 11.11,6 12,6C15.31,6 18,8.69 18,12C18,15.31 15.31,18 12,18M20,8.69V4H15.31L12,0.69L8.69,4H4V8.69L0.69,12L4,15.31V20H8.69L12,23.31L15.31,20H20V15.31L23.31,12L20,8.69Z",
  },
  {
    id: "17314413-99ED-480C-B739-8572B6AE5477",
    name: "brightness-5",
    codepoint: "F0DE",
    aliases: ["brightness-low"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M12,18C8.69,18 6,15.31 6,12C6,8.69 8.69,6 12,6C15.31,6 18,8.69 18,12C18,15.31 15.31,18 12,18M20,15.31L23.31,12L20,8.69V4H15.31L12,0.69L8.69,4H4V8.69L0.69,12L4,15.31V20H8.69L12,23.31L15.31,20H20V15.31Z",
  },
  {
    id: "34818392-81EE-4210-8F86-9C448596C912",
    name: "brightness-6",
    codepoint: "F0DF",
    aliases: ["brightness-medium"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M12,18V6C15.31,6 18,8.69 18,12C18,15.31 15.31,18 12,18M20,15.31L23.31,12L20,8.69V4H15.31L12,0.69L8.69,4H4V8.69L0.69,12L4,15.31V20H8.69L12,23.31L15.31,20H20V15.31Z",
  },
  {
    id: "014CCAA3-4B30-4C3D-921C-078A078A5198",
    name: "brightness-7",
    codepoint: "F0E0",
    aliases: ["brightness-high"],
    tags: ["Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M12,8C9.79,8 8,9.79 8,12C8,14.21 9.79,16 12,16C14.21,16 16,14.21 16,12C16,9.79 14.21,8 12,8M12,18C8.69,18 6,15.31 6,12C6,8.69 8.69,6 12,6C15.31,6 18,8.69 18,12C18,15.31 15.31,18 12,18M20,8.69V4H15.31L12,0.69L8.69,4H4V8.69L0.69,12L4,15.31V20H8.69L12,23.31L15.31,20H20V15.31L23.31,12L20,8.69Z",
  },
  {
    id: "6E47CC3B-6D95-4311-A8DD-7B50AC24781C",
    name: "brightness-auto",
    codepoint: "F0E1",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M14.3,16L13.6,14H10.4L9.7,16H7.8L11,7H13L16.2,16H14.3M20,8.69V4H15.31L12,0.69L8.69,4H4V8.69L0.69,12L4,15.31V20H8.69L12,23.31L15.31,20H20V15.31L23.31,12L20,8.69M10.85,12.65H13.15L12,9L10.85,12.65Z",
  },
  {
    id: "8159ED8F-4D1C-4845-8297-0FE41260D199",
    name: "broom",
    codepoint: "F0E2",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M19.36,2.72L20.78,4.14L15.06,9.85C16.13,11.39 16.28,13.24 15.38,14.44L9.06,8.12C10.26,7.22 12.11,7.37 13.65,8.44L19.36,2.72M5.93,17.57C3.92,15.56 2.69,13.16 2.35,10.92L7.23,8.83L14.67,16.27L12.58,21.15C10.34,20.81 7.94,19.58 5.93,17.57Z",
  },
  {
    id: "B5C72984-BCCF-4729-A7D3-2A07D5794014",
    name: "brush",
    codepoint: "F0E3",
    aliases: ["paintbrush"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M20.71,4.63L19.37,3.29C19,2.9 18.35,2.9 17.96,3.29L9,12.25L11.75,15L20.71,6.04C21.1,5.65 21.1,5 20.71,4.63M7,14C5.34,14 4,15.34 4,17C4,18.31 2.84,19 2,19C2.92,20.22 4.5,21 6,21C8.21,21 10,19.21 10,17C10,15.34 8.66,14 7,14Z",
  },
  {
    id: "18A94F7F-1BC5-48EC-9CAF-6D2D663287DC",
    name: "buddhism",
    codepoint: "F94A",
    aliases: ["dharmachakra", "dharma-wheel", "religion-buddhist"],
    tags: ["Religion"],
    author: "Nick",
    version: "2.4.85",
    path: "M11,2V3C9.27,3.2 7.69,3.9 6.4,4.94L5.64,4.18L4.22,5.6L5,6.35C3.9,7.68 3.21,9.3 3,11H2V13H3C3.21,14.68 3.9,16.26 5,17.56L4.22,18.32L5.64,19.74L6.39,19C7.71,20.07 9.3,20.77 11,21V22H13V21C14.69,20.77 16.29,20.07 17.6,19L18.36,19.74L19.78,18.32L19,17.57C20.1,16.27 20.79,14.68 21,13H22V11H21C20.79,9.3 20.1,7.69 19,6.36L19.78,5.6L18.36,4.18L17.61,4.94C16.29,3.87 14.69,3.2 13,3V2H11M11,5V8L10,8.5L7.81,6.35C8.72,5.67 9.81,5.17 11,5M13,5C14.16,5.18 15.26,5.64 16.2,6.35L14,8.5L13,8V5M6.4,7.76L8.5,10L8,11H5C5.16,9.84 5.7,8.7 6.39,7.75L6.4,7.76M17.6,7.76C18.33,8.71 18.81,9.82 19,11H16L15.5,10L17.61,7.76H17.6M12,10C13.12,10 14,10.88 14,12C14,13.12 13.12,14 12,14C10.88,14 10,13.12 10,12C10,10.88 10.88,10 12,10M5,13H8L8.57,14L6.39,16.15C5.67,15.24 5.19,14.16 5,13V13M16,13H19C18.81,14.15 18.33,15.24 17.61,16.16L15.5,14L16,13M10,15.5L11,16V19C9.83,18.8 8.73,18.31 7.8,17.57L10,15.5M14,15.5L16.19,17.57C15.28,18.25 14.19,18.83 13,19V16L14,15.5Z",
  },
  {
    id: "FBD11E2A-7F1F-4CE2-B17D-B3623D4FEA43",
    name: "buffer",
    codepoint: "F619",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.6.50",
    path: "M12.6,2.86C15.27,4.1 18,5.39 20.66,6.63C20.81,6.7 21,6.75 21,6.95C21,7.15 20.81,7.19 20.66,7.26C18,8.5 15.3,9.77 12.62,11C12.21,11.21 11.79,11.21 11.38,11C8.69,9.76 6,8.5 3.32,7.25C3.18,7.19 3,7.14 3,6.94C3,6.76 3.18,6.71 3.31,6.65C6,5.39 8.74,4.1 11.44,2.85C11.73,2.72 12.3,2.73 12.6,2.86M12,21.15C11.8,21.15 11.66,21.07 11.38,20.97C8.69,19.73 6,18.47 3.33,17.22C3.19,17.15 3,17.11 3,16.9C3,16.7 3.19,16.66 3.34,16.59C3.78,16.38 4.23,16.17 4.67,15.96C5.12,15.76 5.56,15.76 6,15.97C7.79,16.8 9.57,17.63 11.35,18.46C11.79,18.67 12.23,18.66 12.67,18.46C14.45,17.62 16.23,16.79 18,15.96C18.44,15.76 18.87,15.75 19.29,15.95C19.77,16.16 20.24,16.39 20.71,16.61C20.78,16.64 20.85,16.68 20.91,16.73C21.04,16.83 21.04,17 20.91,17.08C20.83,17.14 20.74,17.19 20.65,17.23C18,18.5 15.33,19.72 12.66,20.95C12.46,21.05 12.19,21.15 12,21.15M12,16.17C11.9,16.17 11.55,16.07 11.36,16C8.68,14.74 6,13.5 3.34,12.24C3.2,12.18 3,12.13 3,11.93C3,11.72 3.2,11.68 3.35,11.61C3.8,11.39 4.25,11.18 4.7,10.97C5.13,10.78 5.56,10.78 6,11C7.78,11.82 9.58,12.66 11.38,13.5C11.79,13.69 12.21,13.69 12.63,13.5C14.43,12.65 16.23,11.81 18.04,10.97C18.45,10.78 18.87,10.78 19.29,10.97C19.76,11.19 20.24,11.41 20.71,11.63C20.77,11.66 20.84,11.69 20.9,11.74C21.04,11.85 21.04,12 20.89,12.12C20.84,12.16 20.77,12.19 20.71,12.22C18,13.5 15.31,14.75 12.61,16C12.42,16.09 12.08,16.17 12,16.17Z",
  },
  {
    id: "09A131FB-EE06-49B8-80C3-49B294BCA612",
    name: "bug",
    codepoint: "F0E4",
    aliases: ["bug-report"],
    tags: ["Nature"],
    author: "Google",
    version: "1.5.54",
    path: "M14,12H10V10H14M14,16H10V14H14M20,8H17.19C16.74,7.22 16.12,6.55 15.37,6.04L17,4.41L15.59,3L13.42,5.17C12.96,5.06 12.5,5 12,5C11.5,5 11.04,5.06 10.59,5.17L8.41,3L7,4.41L8.62,6.04C7.88,6.55 7.26,7.22 6.81,8H4V10H6.09C6.04,10.33 6,10.66 6,11V12H4V14H6V15C6,15.34 6.04,15.67 6.09,16H4V18H6.81C7.85,19.79 9.78,21 12,21C14.22,21 16.15,19.79 17.19,18H20V16H17.91C17.96,15.67 18,15.34 18,15V14H20V12H18V11C18,10.66 17.96,10.33 17.91,10H20V8Z",
  },
  {
    id: "094C9BF2-9EEE-434C-9CA9-8280FBDFBEF7",
    name: "bulletin-board",
    codepoint: "F0E5",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M12.04,2.5L9.53,5H14.53L12.04,2.5M4,7V20H20V7H4M12,0L17,5V5H20C21.1,5 22,5.9 22,7V20C22,21.1 21.1,22 20,22H4C2.9,22 2,21.1 2,20V7C2,5.9 2.9,5 4,5H7V5L12,0M7,18V14H12V18H7M14,17V10H18V17H14M6,12V9H11V12H6Z",
  },
  {
    id: "A5D2E199-03A1-4C23-9C63-954D63DEBEB4",
    name: "bullhorn",
    codepoint: "F0E6",
    aliases: ["announcement", "megaphone"],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M16,12V16C16,16.55 15.55,17 15,17C14.83,17 14.67,17 14.06,16.5C13.44,16 12.39,15 11.31,14.5C10.31,14.04 9.28,14 8.26,14L9.47,17.32L9.5,17.5C9.5,17.78 9.28,18 9,18H7C6.78,18 6.59,17.86 6.53,17.66L5.19,14H5C4.45,14 4,13.55 4,13C2.9,13 2,12.1 2,11C2,9.9 2.9,9 4,9C4,8.45 4.45,8 5,8H8C9.11,8 10.22,8 11.31,7.5C12.39,7 13.44,6 14.06,5.5C14.67,5 14.83,5 15,5C15.55,5 16,5.45 16,6V10C16.55,10 17,10.45 17,11C17,11.55 16.55,12 16,12M21,11C21,12.38 20.44,13.63 19.54,14.54L18.12,13.12C18.66,12.58 19,11.83 19,11C19,10.17 18.66,9.42 18.12,8.88L19.54,7.46C20.44,8.37 21,9.62 21,11Z",
  },
  {
    id: "ED26BD4D-ACDB-45DC-A0DA-18ECA3B2008E",
    name: "bullseye",
    codepoint: "F5DD",
    aliases: ["target"],
    tags: ["Sport"],
    author: "Cody",
    version: "1.5.54",
    path: "M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4M12,6C8.69,6 6,8.69 6,12C6,15.31 8.69,18 12,18C15.31,18 18,15.31 18,12C18,8.69 15.31,6 12,6M12,8C14.21,8 16,9.79 16,12C16,14.21 14.21,16 12,16C9.79,16 8,14.21 8,12C8,9.79 9.79,8 12,8M12,10C10.9,10 10,10.9 10,12C10,13.1 10.9,14 12,14C13.1,14 14,13.1 14,12C14,10.9 13.1,10 12,10Z",
  },
  {
    id: "FAC8D1F3-C466-41F3-B3BF-A08519BBC909",
    name: "bullseye-arrow",
    codepoint: "F8C8",
    aliases: ["target-arrow"],
    tags: ["Sport"],
    author: "Cody",
    version: "2.3.50",
    path: "M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,10.84 21.79,9.69 21.39,8.61L19.79,10.21C19.93,10.8 20,11.4 20,12C20,16.42 16.42,20 12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C12.6,4 13.2,4.07 13.79,4.21L15.4,2.6C14.31,2.21 13.16,2 12,2M19,2L15,6V7.5L12.45,10.05C12.3,10 12.15,10 12,10C10.9,10 10,10.9 10,12C10,13.1 10.9,14 12,14C13.1,14 14,13.1 14,12C14,11.85 14,11.7 13.95,11.55L16.5,9H18L22,5H19V2M12,6C8.69,6 6,8.69 6,12C6,15.31 8.69,18 12,18C15.31,18 18,15.31 18,12H16C16,14.21 14.21,16 12,16C9.79,16 8,14.21 8,12C8,9.79 9.79,8 12,8V6Z",
  },
  {
    id: "F6516F38-B29E-4CC9-A7E2-706817121D45",
    name: "bus",
    codepoint: "F0E7",
    aliases: ["directions-bus"],
    tags: ["Navigation", "Transportation + Road"],
    author: "Google",
    version: "1.5.54",
    path: "M18,11H6V6H18M16.5,17C15.67,17 15,16.33 15,15.5C15,14.67 15.67,14 16.5,14C17.33,14 18,14.67 18,15.5C18,16.33 17.33,17 16.5,17M7.5,17C6.67,17 6,16.33 6,15.5C6,14.67 6.67,14 7.5,14C8.33,14 9,14.67 9,15.5C9,16.33 8.33,17 7.5,17M4,16C4,16.88 4.39,17.67 5,18.22V20C5,20.55 5.45,21 6,21H7C7.55,21 8,20.55 8,20V19H16V20C16,20.55 16.45,21 17,21H18C18.55,21 19,20.55 19,20V18.22C19.61,17.67 20,16.88 20,16V6C20,2.5 16.42,2 12,2C7.58,2 4,2.5 4,6V16Z",
  },
  {
    id: "44D15383-D6D2-46CC-A977-7921DA98C7E8",
    name: "bus-articulated-end",
    codepoint: "F79B",
    aliases: [],
    tags: ["Transportation + Road"],
    author: "GreenTurtwig",
    version: "2.0.46",
    path: "M21.5,6L20,7.5L21.5,9L20,10.5L21.5,12L20,13.5L21.5,15H12.5C12.5,16.66 11.16,18 9.5,18C7.84,18 6.5,16.66 6.5,15H2.5V8C2.5,6.89 3.39,6 4.5,6H21.5M18.5,7.5H15V10H18.5V7.5M13.5,7.5H9.5V10H13.5V7.5M8,7.5H4V10H8V7.5M9.5,13.5C8.67,13.5 8,14.17 8,15C8,15.83 8.67,16.5 9.5,16.5C10.33,16.5 11,15.83 11,15C11,14.17 10.33,13.5 9.5,13.5Z",
  },
  {
    id: "5C34E429-3B80-46CD-8DC8-44D5D9769682",
    name: "bus-articulated-front",
    codepoint: "F79C",
    aliases: [],
    tags: ["Transportation + Road"],
    author: "GreenTurtwig",
    version: "2.0.46",
    path: "M1,6L2.5,7.5L1,9L2.5,10.5L1,12L2.5,13.5L1,15H3C3,16.66 4.34,18 6,18C7.66,18 9,16.66 9,15H15C15,16.66 16.34,18 18,18C19.66,18 21,16.66 21,15H23V8C23,6.89 22.11,6 21,6H1M4,7.5H6.5V10H4V7.5M8,7.5H12V10H8V7.5M13.5,7.5H17.5V10H13.5V7.5M19,7.5H21.5V13L19,11V7.5M6,13.5C6.83,13.5 7.5,14.17 7.5,15C7.5,15.83 6.83,16.5 6,16.5C5.17,16.5 4.5,15.83 4.5,15C4.5,14.17 5.17,13.5 6,13.5M18,13.5C18.83,13.5 19.5,14.17 19.5,15C19.5,15.83 18.83,16.5 18,16.5C17.17,16.5 16.5,15.83 16.5,15C16.5,14.17 17.17,13.5 18,13.5Z",
  },
  {
    id: "B37694EA-F48B-4F48-ACF1-0E48FB334473",
    name: "bus-clock",
    codepoint: "F8C9",
    aliases: ["departure-board"],
    tags: ["Date / Time"],
    author: "Google",
    version: "2.3.50",
    path: "M16.5,4V8.25L19.36,9.94L18.61,11.16L15,9V4H16.5M16,13C17.36,13 18.54,12.5 19.5,11.53C20.5,10.56 21,9.39 21,8C21,6.64 20.5,5.46 19.5,4.5C18.54,3.5 17.36,3 16,3C14.61,3 13.44,3.5 12.47,4.5C11.5,5.46 11,6.64 11,8C11,9.39 11.5,10.56 12.47,11.53C13.44,12.5 14.61,13 16,13M13.5,19C13.94,19 14.3,18.84 14.58,18.54C14.86,18.24 15,17.89 15,17.5C15,17.08 14.86,16.73 14.58,16.43C14.3,16.13 13.94,16 13.5,16C13.06,16 12.7,16.13 12.42,16.43C12.14,16.73 12,17.08 12,17.5C12,17.89 12.14,18.24 12.42,18.54C12.7,18.84 13.06,19 13.5,19M3,13H11.11C9.7,11.64 9,10 9,8H3V13M4.5,19C4.94,19 5.3,18.84 5.58,18.54C5.86,18.24 6,17.89 6,17.5C6,17.08 5.86,16.73 5.58,16.43C5.3,16.13 4.94,16 4.5,16C4.06,16 3.7,16.13 3.42,16.43C3.14,16.73 3,17.08 3,17.5C3,17.89 3.14,18.24 3.42,18.54C3.7,18.84 4.06,19 4.5,19M16,1C17.92,1 19.58,1.67 20.95,3.05C22.33,4.42 23,6.08 23,8C23,9.77 22.44,11.29 21.28,12.59C20.13,13.88 18.7,14.66 17,14.91V18C17,18.84 16.67,19.58 16,20.2V22C16,22.27 15.89,22.5 15.7,22.71C15.5,22.91 15.28,23 15,23H14C13.73,23 13.5,22.91 13.29,22.71C13.09,22.5 13,22.27 13,22V21H5V22C5,22.27 4.91,22.5 4.71,22.71C4.5,22.91 4.27,23 4,23H3C2.72,23 2.5,22.91 2.3,22.71C2.11,22.5 2,22.27 2,22V20.2C1.33,19.58 1,18.84 1,18V8C1,6.42 1.67,5.35 3.05,4.8C4.42,4.26 6.41,4 9,4C9.13,4 9.33,4 9.61,4C9.89,4 10.09,4.03 10.22,4.03C11.63,2 13.55,1 16,1Z",
  },
  {
    id: "1F4327A8-1E93-4490-B992-C9D04DFFB144",
    name: "bus-double-decker",
    codepoint: "F79D",
    aliases: [],
    tags: ["Transportation + Road"],
    author: "GreenTurtwig",
    version: "2.0.46",
    path: "M3,4C1.89,4 1,4.89 1,6V17H3C3,18.66 4.34,20 6,20C7.66,20 9,18.66 9,17H15C15,18.66 16.34,20 18,20C19.66,20 21,18.66 21,17H23V14C23,12.89 22.11,12 21,12H19V9.5H23V6C23,4.89 22.11,4 21,4H3M2.5,5.5H6.5V8H2.5V5.5M8,5.5H12V8H8V5.5M13.5,5.5H17.5V8H13.5V5.5M19,5.5H21.5V8H19V5.5M13.5,9.5H17.5V12H13.5V9.5M2.5,9.5H6.5V12H2.5V9.5M8,9.5H12V12H8V9.5M6,15.5C6.83,15.5 7.5,16.17 7.5,17C7.5,17.83 6.83,18.5 6,18.5C5.17,18.5 4.5,17.83 4.5,17C4.5,16.17 5.17,15.5 6,15.5M18,15.5C18.83,15.5 19.5,16.17 19.5,17C19.5,17.83 18.83,18.5 18,18.5C17.17,18.5 16.5,17.83 16.5,17C16.5,16.17 17.17,15.5 18,15.5Z",
  },
  {
    id: "774EC563-DF29-498C-8270-ABB051396687",
    name: "bus-school",
    codepoint: "F79E",
    aliases: [],
    tags: ["Transportation + Road"],
    author: "GreenTurtwig",
    version: "2.0.46",
    path: "M3,6C1.89,6 1,6.89 1,8V15H3C3,16.66 4.34,18 6,18C7.66,18 9,16.66 9,15H15C15,16.66 16.34,18 18,18C19.66,18 21,16.66 21,15H23V12C23,10.89 22.11,10 21,10H19V8C19,6.89 18.11,6 17,6H3M13.5,7.5H17.5V10H13.5V7.5M2.5,7.5H6.5V10H2.5V7.5M8,7.5H12V10H8V7.5M6,13.5C6.83,13.5 7.5,14.17 7.5,15C7.5,15.83 6.83,16.5 6,16.5C5.17,16.5 4.5,15.83 4.5,15C4.5,14.17 5.17,13.5 6,13.5M18,13.5C18.83,13.5 19.5,14.17 19.5,15C19.5,15.83 18.83,16.5 18,16.5C17.17,16.5 16.5,15.83 16.5,15C16.5,14.17 17.17,13.5 18,13.5Z",
  },
  {
    id: "D944705B-8F7B-441F-8753-6E51E4378D7D",
    name: "bus-side",
    codepoint: "F79F",
    aliases: [],
    tags: ["Transportation + Road"],
    author: "GreenTurtwig",
    version: "2.0.46",
    path: "M3,6C1.89,6 1,6.89 1,8V15H3C3,16.66 4.34,18 6,18C7.66,18 9,16.66 9,15H15C15,16.66 16.34,18 18,18C19.66,18 21,16.66 21,15H23V8C23,6.89 22.11,6 21,6H3M2.5,7.5H6.5V10H2.5V7.5M8,7.5H12V10H8V7.5M13.5,7.5H17.5V10H13.5V7.5M19,7.5H21.5V13L19,11V7.5M6,13.5C6.83,13.5 7.5,14.17 7.5,15C7.5,15.83 6.83,16.5 6,16.5C5.17,16.5 4.5,15.83 4.5,15C4.5,14.17 5.17,13.5 6,13.5M18,13.5C18.83,13.5 19.5,14.17 19.5,15C19.5,15.83 18.83,16.5 18,16.5C17.17,16.5 16.5,15.83 16.5,15C16.5,14.17 17.17,13.5 18,13.5Z",
  },
  {
    id: "7DFE345F-A336-43BC-89BE-18FE3C902BFC",
    name: "cached",
    codepoint: "F0E8",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M19,8L15,12H18C18,15.31 15.31,18 12,18C11,18 10.03,17.75 9.2,17.3L7.74,18.76C8.97,19.54 10.43,20 12,20C16.42,20 20,16.42 20,12H23M6,12C6,8.69 8.69,6 12,6C13,6 13.97,6.25 14.8,6.7L16.26,5.24C15.03,4.46 13.57,4 12,4C7.58,4 4,7.58 4,12H1L5,16L9,12",
  },
  {
    id: "E5BFDCE4-1033-4062-9677-94B95E028B6E",
    name: "cake",
    codepoint: "F0E9",
    aliases: [],
    tags: ["Holiday", "Food / Drink"],
    author: "Google",
    version: "1.5.54",
    path: "M11.5,0.5C12,0.75 13,2.4 13,3.5C13,4.6 12.33,5 11.5,5C10.67,5 10,4.85 10,3.75C10,2.65 11,2 11.5,0.5M18.5,9C21,9 23,11 23,13.5C23,15.06 22.21,16.43 21,17.24V23H12L3,23V17.24C1.79,16.43 1,15.06 1,13.5C1,11 3,9 5.5,9H10V6H13V9H18.5M12,16C13.38,16 14.5,14.88 14.5,13.5H16C16,14.88 17.12,16 18.5,16C19.88,16 21,14.88 21,13.5C21,12.12 19.88,11 18.5,11H5.5C4.12,11 3,12.12 3,13.5C3,14.88 4.12,16 5.5,16C6.88,16 8,14.88 8,13.5H9.5C9.5,14.88 10.62,16 12,16Z",
  },
  {
    id: "934C9B6C-0DA5-4D71-9283-C960ED537D02",
    name: "cake-layered",
    codepoint: "F0EA",
    aliases: [],
    tags: ["Holiday", "Food / Drink"],
    author: "Google",
    version: "1.5.54",
    path: "M21,21V17C21,15.89 20.1,15 19,15H18V12C18,10.89 17.1,10 16,10H13V8H11V10H8C6.89,10 6,10.89 6,12V15H5C3.89,15 3,15.89 3,17V21H1V23H23V21M12,7C13.1,7 14,6.1 14,5C14,4.62 13.9,4.27 13.71,3.97L12,1L10.28,3.97C10.1,4.27 10,4.62 10,5C10,6.1 10.9,7 12,7Z",
  },
  {
    id: "2F9E87A6-B7DB-48B1-9528-C8A941FBC3AF",
    name: "cake-variant",
    codepoint: "F0EB",
    aliases: [],
    tags: ["Holiday", "Food / Drink"],
    author: "Google",
    version: "1.5.54",
    path: "M12,6C13.11,6 14,5.1 14,4C14,3.62 13.9,3.27 13.71,2.97L12,0L10.29,2.97C10.1,3.27 10,3.62 10,4C10,5.1 10.9,6 12,6M16.6,16L15.53,14.92L14.45,16C13.15,17.29 10.87,17.3 9.56,16L8.5,14.92L7.4,16C6.75,16.64 5.88,17 4.96,17C4.23,17 3.56,16.77 3,16.39V21C3,21.55 3.45,22 4,22H20C20.55,22 21,21.55 21,21V16.39C20.44,16.77 19.77,17 19.04,17C18.12,17 17.25,16.64 16.6,16M18,9H13V7H11V9H6C4.34,9 3,10.34 3,12V13.54C3,14.62 3.88,15.5 4.96,15.5C5.5,15.5 6,15.3 6.34,14.93L8.5,12.8L10.61,14.93C11.35,15.67 12.64,15.67 13.38,14.93L15.5,12.8L17.65,14.93C18,15.3 18.5,15.5 19.03,15.5C20.11,15.5 21,14.62 21,13.54V12C21,10.34 19.66,9 18,9Z",
  },
  {
    id: "3E9895C8-BCCB-464C-ACF1-CCA86113DA37",
    name: "calculator",
    codepoint: "F0EC",
    aliases: [],
    tags: ["Math"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M7,2H17C18.1,2 19,2.9 19,4V20C19,21.1 18.1,22 17,22H7C5.9,22 5,21.1 5,20V4C5,2.9 5.9,2 7,2M7,4V8H17V4H7M7,10V12H9V10H7M11,10V12H13V10H11M15,10V12H17V10H15M7,14V16H9V14H7M11,14V16H13V14H11M15,14V16H17V14H15M7,18V20H9V18H7M11,18V20H13V18H11M15,18V20H17V18H15Z",
  },
  {
    id: "23C8742A-612C-4C55-B184-2A0ABB387746",
    name: "calendar",
    codepoint: "F0ED",
    aliases: ["event", "insert-invitation"],
    tags: ["Date / Time"],
    author: "Google",
    version: "1.5.54",
    path: "M19,19H5V8H19M16,1V3H8V1H6V3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3H18V1M17,12H12V17H17V12Z",
  },
  {
    id: "57984F1A-6CA5-4928-B221-466C0CC11562",
    name: "calendar-blank",
    codepoint: "F0EE",
    aliases: ["calendar-today"],
    tags: ["Date / Time"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M19,19H5V8H19M16,1V3H8V1H6V3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3H18V1",
  },
  {
    id: "62008F88-6B17-4277-9155-B596476629A1",
    name: "calendar-check",
    codepoint: "F0EF",
    aliases: ["event-available", "calendar-task"],
    tags: ["Date / Time"],
    author: "Google",
    version: "1.5.54",
    path: "M19,19H5V8H19M19,3H18V1H16V3H8V1H6V3H5C3.89,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3M16.53,11.06L15.47,10L10.59,14.88L8.47,12.76L7.41,13.82L10.59,17L16.53,11.06Z",
  },
  {
    id: "921F6084-24E6-4D62-8BF9-9258D8FADE8E",
    name: "calendar-clock",
    codepoint: "F0F0",
    aliases: ["event-clock", "event-time", "calendar-time"],
    tags: ["Date / Time"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M15,13H16.5V15.82L18.94,17.23L18.19,18.53L15,16.69V13M19,8H5V19H9.67C9.24,18.09 9,17.07 9,16C9,12.13 12.13,9 16,9C17.07,9 18.09,9.24 19,9.67V8M5,21C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H6V1H8V3H16V1H18V3H19C20.1,3 21,3.9 21,5V11.1C22.24,12.36 23,14.09 23,16C23,19.87 19.87,23 16,23C14.09,23 12.36,22.24 11.1,21H5M16,11.15C13.32,11.15 11.15,13.32 11.15,16C11.15,18.68 13.32,20.85 16,20.85C18.68,20.85 20.85,18.68 20.85,16C20.85,13.32 18.68,11.15 16,11.15Z",
  },
  {
    id: "2976EA1B-60A3-46FB-97E2-95BB74B0DD22",
    name: "calendar-edit",
    codepoint: "F8A6",
    aliases: ["event-edit"],
    tags: ["Date / Time"],
    author: "Michael Richins",
    version: "2.2.43",
    path: "M19,3H18V1H16V3H8V1H6V3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H10V19H5V8H19V9H21V5C21,3.9 20.1,3 19,3M21.7,13.35L20.7,14.35L18.65,12.35L19.65,11.35C19.85,11.14 20.19,11.13 20.42,11.35L21.7,12.63C21.89,12.83 21.89,13.15 21.7,13.35M12,18.94L18.07,12.88L20.12,14.88L14.06,21H12V18.94Z",
  },
  {
    id: "EF6AC5FE-7E6E-47AC-B5D8-E802CBB94E3B",
    name: "calendar-heart",
    codepoint: "F9D1",
    aliases: ["event-heart"],
    tags: [],
    author: "Austin Andrews",
    version: "2.5.94",
    path: "M19,20V9H5V20H19M16,2H18V4H19C20.1,4 21,4.9 21,6V20C21,21.1 20.1,22 19,22H5C3.9,22 3,21.1 3,20V6C3,4.9 3.9,4 5,4H6V2H8V4H16V2M12,18.17L11.42,17.64C9.36,15.77 8,14.54 8,13.03C8,11.8 8.97,10.83 10.2,10.83C10.9,10.83 11.56,11.15 12,11.66C12.44,11.15 13.1,10.83 13.8,10.83C15.03,10.83 16,11.8 16,13.03C16,14.54 14.64,15.77 12.58,17.64L12,18.17Z",
  },
  {
    id: "F4851A5B-6F19-4C18-9A13-4BF2617FF0E0",
    name: "calendar-multiple",
    codepoint: "F0F1",
    aliases: ["event-multiple"],
    tags: ["Date / Time"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M21,17V8H7V17H21M21,3C22.1,3 23,3.9 23,5V17C23,18.1 22.1,19 21,19H7C5.89,19 5,18.1 5,17V5C5,3.9 5.9,3 7,3H8V1H10V3H18V1H20V3H21M3,21H17V23H3C1.89,23 1,22.1 1,21V9H3V21M19,15H15V11H19V15Z",
  },
  {
    id: "7329D294-805D-4843-AB03-B87C661C296A",
    name: "calendar-multiple-check",
    codepoint: "F0F2",
    aliases: ["event-multiple-check"],
    tags: ["Date / Time"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M21,17V8H7V17H21M21,3C22.1,3 23,3.9 23,5V17C23,18.1 22.1,19 21,19H7C5.89,19 5,18.1 5,17V5C5,3.9 5.9,3 7,3H8V1H10V3H18V1H20V3H21M17.53,11.06L13.09,15.5L10.41,12.82L11.47,11.76L13.09,13.38L16.47,10L17.53,11.06M3,21H17V23H3C1.89,23 1,22.1 1,21V9H3V21Z",
  },
  {
    id: "34AFE807-D724-4A5A-A3FE-910928179BE8",
    name: "calendar-plus",
    codepoint: "F0F3",
    aliases: ["event-plus"],
    tags: ["Date / Time"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M19,19V7H5V19H19M16,1H18V3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H6V1H8V3H16V1M11,9H13V12H16V14H13V17H11V14H8V12H11V9Z",
  },
  {
    id: "1A7293FC-E6E7-4C86-8919-32D0C5F60B08",
    name: "calendar-question",
    codepoint: "F691",
    aliases: ["calendar-rsvp", "event-question"],
    tags: ["Date / Time"],
    author: "Cody",
    version: "1.7.12",
    path: "M6,1V3H5C3.89,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3H18V1H16V3H8V1H6M5,8H19V19H5V8M12.19,9C11.32,9 10.62,9.2 10.08,9.59C9.56,10 9.3,10.57 9.31,11.36L9.32,11.39H11.25C11.26,11.09 11.35,10.86 11.53,10.7C11.71,10.55 11.93,10.47 12.19,10.47C12.5,10.47 12.76,10.57 12.94,10.75C13.12,10.94 13.2,11.2 13.2,11.5C13.2,11.82 13.13,12.09 12.97,12.32C12.83,12.55 12.62,12.75 12.36,12.91C11.85,13.25 11.5,13.55 11.31,13.82C11.11,14.08 11,14.5 11,15H13C13,14.69 13.04,14.44 13.13,14.26C13.22,14.08 13.39,13.9 13.64,13.74C14.09,13.5 14.46,13.21 14.75,12.81C15.04,12.41 15.19,12 15.19,11.5C15.19,10.74 14.92,10.13 14.38,9.68C13.85,9.23 13.12,9 12.19,9M11,16V18H13V16H11Z",
  },
  {
    id: "740D7A91-7492-4922-96C7-A719E2BCD62A",
    name: "calendar-range",
    codepoint: "F678",
    aliases: ["date-range", "calendar-week", "event-range"],
    tags: ["Date / Time"],
    author: "Google",
    version: "1.7.12",
    path: "M9,10H7V12H9V10M13,10H11V12H13V10M17,10H15V12H17V10M19,3H18V1H16V3H8V1H6V3H5C3.89,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3M19,19H5V8H19V19Z",
  },
  {
    id: "2FAF3098-4BD1-4C70-94A8-F75E1EA54F49",
    name: "calendar-remove",
    codepoint: "F0F4",
    aliases: ["event-busy"],
    tags: ["Date / Time"],
    author: "Google",
    version: "1.5.54",
    path: "M19,19H5V8H19M19,3H18V1H16V3H8V1H6V3H5C3.89,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3M9.31,17L11.75,14.56L14.19,17L15.25,15.94L12.81,13.5L15.25,11.06L14.19,10L11.75,12.44L9.31,10L8.25,11.06L10.69,13.5L8.25,15.94L9.31,17Z",
  },
  {
    id: "1C61A1FD-56B6-41F1-B677-84D32425225A",
    name: "calendar-search",
    codepoint: "F94B",
    aliases: ["event-search"],
    tags: ["Date / Time"],
    author: "GreenTurtwig",
    version: "2.4.85",
    path: "M15.5,12C18,12 20,14 20,16.5C20,17.38 19.75,18.21 19.31,18.9L22.39,22L21,23.39L17.88,20.32C17.19,20.75 16.37,21 15.5,21C13,21 11,19 11,16.5C11,14 13,12 15.5,12M15.5,14C14.12,14 13,15.12 13,16.5C13,17.88 14.12,19 15.5,19C16.88,19 18,17.88 18,16.5C18,15.12 16.88,14 15.5,14M19,8H5V19H9.5C9.81,19.75 10.26,20.42 10.81,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H6V1H8V3H16V1H18V3H19C20.1,3 21,3.9 21,5V13.03C20.5,12.22 19.8,11.54 19,11V8Z",
  },
  {
    id: "96505BCC-D522-45A6-A642-85F1B4248FAA",
    name: "calendar-star",
    codepoint: "F9D2",
    aliases: ["event-star"],
    tags: [],
    author: "Michael Richins",
    version: "2.5.94",
    path: "M19,20H5V9H19M16,2V4H8V2H6V4H5C3.9,4 3,4.9 3,6V20C3,21.1 3.9,22 5,22H19C20.1,22 21,21.1 21,20V6C21,4.9 20.1,4 19,4H18V2M10.88,13H7.27L10.19,15.11L9.08,18.56L12,16.43L14.92,18.56L13.8,15.12L16.72,13H13.12L12,9.56L10.88,13Z",
  },
  {
    id: "1A873476-B82D-4E23-BF19-897F0A0C0B93",
    name: "calendar-text",
    codepoint: "F0F5",
    aliases: ["event-note"],
    tags: ["Date / Time"],
    author: "Google",
    version: "1.5.54",
    path: "M14,14H7V16H14M19,19H5V8H19M19,3H18V1H16V3H8V1H6V3H5C3.89,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3M17,10H7V12H17V10Z",
  },
  {
    id: "A566BA98-D35A-443F-AD31-0D31EF0B85EC",
    name: "calendar-today",
    codepoint: "F0F6",
    aliases: ["calendar-day"],
    tags: ["Date / Time"],
    author: "Google",
    version: "1.5.54",
    path: "M7,10H12V15H7M19,19H5V8H19M19,3H18V1H16V3H8V1H6V3H5C3.89,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3Z",
  },
  {
    id: "B5ACE913-DBF1-4E73-BFE5-BB86F0EBF76E",
    name: "call-made",
    codepoint: "F0F7",
    aliases: [],
    tags: ["Cellphone / Phone"],
    author: "Google",
    version: "1.5.54",
    path: "M9,5V7H15.59L4,18.59L5.41,20L17,8.41V15H19V5",
  },
  {
    id: "8BEE5A5E-EC0A-4FC5-96BE-7F8C2A2EE52F",
    name: "call-merge",
    codepoint: "F0F8",
    aliases: ["merge-type"],
    tags: ["Cellphone / Phone"],
    author: "Google",
    version: "1.5.54",
    path: "M17,20.41L18.41,19L15,15.59L13.59,17M7.5,8H11V13.59L5.59,19L7,20.41L13,14.41V8H16.5L12,3.5",
  },
  {
    id: "CA2546B9-70B0-4E1A-B646-17163B0C76E4",
    name: "call-missed",
    codepoint: "F0F9",
    aliases: [],
    tags: ["Cellphone / Phone"],
    author: "Google",
    version: "1.5.54",
    path: "M19.59,7L12,14.59L6.41,9H11V7H3V15H5V10.41L12,17.41L21,8.41",
  },
  {
    id: "008CD0E5-C47B-44FB-AF43-A1221C527056",
    name: "call-received",
    codepoint: "F0FA",
    aliases: [],
    tags: ["Cellphone / Phone"],
    author: "Google",
    version: "1.5.54",
    path: "M20,5.41L18.59,4L7,15.59V9H5V19H15V17H8.41",
  },
  {
    id: "790BCBB6-8B08-4AEC-A322-99F584BB394B",
    name: "call-split",
    codepoint: "F0FB",
    aliases: [],
    tags: ["Cellphone / Phone"],
    author: "Google",
    version: "1.5.54",
    path: "M14,4L16.29,6.29L13.41,9.17L14.83,10.59L17.71,7.71L20,10V4M10,4H4V10L6.29,7.71L11,12.41V20H13V11.59L7.71,6.29",
  },
  {
    id: "BE1C767B-C032-487C-AB85-E2E960C9A89D",
    name: "camcorder-off",
    codepoint: "F0FF",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M3.27,2L2,3.27L4.73,6H4C3.45,6 3,6.45 3,7V17C3,17.55 3.45,18 4,18H16C16.2,18 16.39,17.92 16.54,17.82L19.73,21L21,19.73M21,6.5L17,10.5V7C17,6.45 16.55,6 16,6H9.82L21,17.18V6.5Z",
  },
  {
    id: "236D9E8E-E38C-4EA9-9539-0E8B1447003A",
    name: "camera",
    codepoint: "F100",
    aliases: ["photography", "camera-alt", "local-see", "photo-camera"],
    tags: ["Photography", "Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M4,4H7L9,2H15L17,4H20C21.1,4 22,4.9 22,6V18C22,19.1 21.1,20 20,20H4C2.9,20 2,19.1 2,18V6C2,4.9 2.9,4 4,4M12,7C9.24,7 7,9.24 7,12C7,14.76 9.24,17 12,17C14.76,17 17,14.76 17,12C17,9.24 14.76,7 12,7M12,9C13.66,9 15,10.34 15,12C15,13.66 13.66,15 12,15C10.34,15 9,13.66 9,12C9,10.34 10.34,9 12,9Z",
  },
  {
    id: "E6F67D5D-0EED-450C-B39F-75D37E9B63CA",
    name: "camera-account",
    codepoint: "F8CA",
    aliases: ["camera-user"],
    tags: ["Account / User"],
    author: "Google",
    version: "2.3.50",
    path: "M4,5H7L9,3H15L17,5H20C21.1,5 22,5.9 22,7V19C22,20.1 21.1,21 20,21H4C2.9,21 2,20.1 2,19V7C2,5.9 2.9,5 4,5M16,17V16C16,14.67 13.33,14 12,14C10.67,14 8,14.67 8,16V17H16M12,9C10.9,9 10,9.9 10,11C10,12.1 10.9,13 12,13C13.1,13 14,12.1 14,11C14,9.9 13.1,9 12,9Z",
  },
  {
    id: "4FCD7DBE-6B4C-41DB-BDD8-40ED820EC7F1",
    name: "camera-burst",
    codepoint: "F692",
    aliases: ["burst-mode"],
    tags: ["Photography"],
    author: "Google",
    version: "1.7.12",
    path: "M1,5H3V19H1V5M5,5H7V19H5V5M22,5H10C9.45,5 9,5.45 9,6V18C9,18.55 9.45,19 10,19H22C22.55,19 23,18.55 23,18V6C23,5.45 22.55,5 22,5M11,17L13.5,13.85L15.29,16L17.79,12.78L21,17H11Z",
  },
  {
    id: "45456446-14D9-49F2-8842-93BAF8233F47",
    name: "camera-enhance",
    codepoint: "F101",
    aliases: [],
    tags: ["Photography"],
    author: "Google",
    version: "1.5.54",
    path: "M9,3L7.17,5H4C2.9,5 2,5.9 2,7V19C2,20.1 2.9,21 4,21H20C21.1,21 22,20.1 22,19V7C22,5.9 21.1,5 20,5H16.83L15,3M12,18C9.24,18 7,15.76 7,13C7,10.24 9.24,8 12,8C14.76,8 17,10.24 17,13C17,15.76 14.76,18 12,18M12,17L13.25,14.25L16,13L13.25,11.75L12,9L10.75,11.75L8,13L10.75,14.25",
  },
  {
    id: "574F4B2D-70FE-41E3-AFB4-EC1E2AB897AB",
    name: "camera-front",
    codepoint: "F102",
    aliases: [],
    tags: ["Photography"],
    author: "Google",
    version: "1.5.54",
    path: "M7,2H17V12.5C17,10.83 13.67,10 12,10C10.33,10 7,10.83 7,12.5M17,0H7C5.9,0 5,0.9 5,2V16C5,17.1 5.9,18 7,18H17C18.1,18 19,17.1 19,16V2C19,0.9 18.1,0 17,0M12,8C13.1,8 14,7.1 14,6C14,4.9 13.1,4 12,4C10.9,4 10,4.9 10,6C10,7.1 10.9,8 12,8M14,20V22H19V20M10,20H5V22H10V24L13,21L10,18V20Z",
  },
  {
    id: "2C6477B5-AA9E-4EDD-A73A-79F2ED5E5F2A",
    name: "camera-front-variant",
    codepoint: "F103",
    aliases: [],
    tags: ["Photography"],
    author: "Google",
    version: "1.5.54",
    path: "M6,0H18C19.1,0 20,0.9 20,2V22C20,23.1 19.1,24 18,24H6C4.9,24 4,23.1 4,22V2C4,0.9 4.9,0 6,0M12,6C13.66,6 15,7.34 15,9C15,10.66 13.66,12 12,12C10.34,12 9,10.66 9,9C9,7.34 10.34,6 12,6M11,1V3H13V1H11M6,4V16.5C6,15.12 8.69,14 12,14C15.31,14 18,15.12 18,16.5V4H6M13,18H9V20H13V22L16,19L13,16V18Z",
  },
  {
    id: "B4EDBFFC-CF00-45F3-93A7-6ADD45108FEE",
    name: "camera-gopro",
    codepoint: "F7A0",
    aliases: [],
    tags: ["Photography", "Device / Tech"],
    author: "Michael Richins",
    version: "2.0.46",
    path: "M20,5H15C13.9,5 13,5.9 13,7V12C13,13.1 13.9,14 15,14H20C21.1,14 22,13.1 22,12V7C22,5.9 21.1,5 20,5M17.5,12.5C15.84,12.5 14.5,11.16 14.5,9.5C14.5,7.84 15.84,6.5 17.5,6.5C19.16,6.5 20.5,7.84 20.5,9.5C20.5,11.16 19.16,12.5 17.5,12.5M17.5,11C16.67,11 16,10.33 16,9.5C16,8.67 16.67,8 17.5,8C18.33,8 19,8.67 19,9.5C19,10.33 18.33,11 17.5,11M12,15V5H4C2.9,5 2,5.9 2,7V17C2,18.1 2.9,19 4,19H20C21.1,19 22,18.1 22,17V15H12M10,12H4V7H10V12Z",
  },
  {
    id: "3399CF92-5E35-4C1A-A796-FB641666AB63",
    name: "camera-image",
    codepoint: "F8CB",
    aliases: [],
    tags: [],
    author: "Google",
    version: "2.3.50",
    path: "M4,5H7L9,3H15L17,5H20C21.1,5 22,5.9 22,7V19C22,20.1 21.1,21 20,21H4C2.9,21 2,20.1 2,19V7C2,5.9 2.9,5 4,5M13.09,9.45L11.05,12.18L12.6,14.25L11.73,14.91L9.27,11.64L6,16H18L13.09,9.45Z",
  },
  {
    id: "E011977B-432E-470C-A4F6-9C7A4F8BB519",
    name: "camera-iris",
    codepoint: "F104",
    aliases: [],
    tags: ["Photography"],
    author: "Google",
    version: "1.5.54",
    path: "M13.73,15L9.83,21.76C10.53,21.91 11.25,22 12,22C14.4,22 16.6,21.15 18.32,19.75L14.66,13.4M2.46,15C3.38,17.92 5.61,20.26 8.45,21.34L12.12,15M8.54,12L4.64,5.25C3,7 2,9.39 2,12C2,12.68 2.07,13.35 2.2,14H9.69M21.8,10H14.31L14.6,10.5L19.36,18.75C21,16.97 22,14.6 22,12C22,11.31 21.93,10.64 21.8,10M21.54,9C20.62,6.07 18.39,3.74 15.55,2.66L11.88,9M9.4,10.5L14.17,2.24C13.47,2.09 12.75,2 12,2C9.6,2 7.4,2.84 5.68,4.25L9.34,10.6L9.4,10.5Z",
  },
  {
    id: "D178034B-0B93-40F5-BBF1-D28B25A86647",
    name: "camera-metering-center",
    codepoint: "F7A1",
    aliases: ["camera-metering-centre"],
    tags: ["Photography"],
    author: "Andy Martinez",
    version: "2.0.46",
    path: "M4,4H20C21.1,4 22,4.9 22,6V18C22,19.1 21.1,20 20,20H4C2.9,20 2,19.1 2,18V6C2,4.9 2.9,4 4,4M4,6V18H20V6H4M12,10.5C12.83,10.5 13.5,11.17 13.5,12C13.5,12.83 12.83,13.5 12,13.5C11.17,13.5 10.5,12.83 10.5,12C10.5,11.17 11.17,10.5 12,10.5M12,7.5C14.14,7.5 15.93,9 16.39,11H14.83C14.42,9.83 13.31,9 12,9C10.69,9 9.58,9.83 9.17,11H7.61C8.07,9 9.86,7.5 12,7.5M12,16.5C9.86,16.5 8.07,15 7.61,13H9.17C9.58,14.17 10.69,15 12,15C13.31,15 14.42,14.17 14.83,13H16.39C15.93,15 14.14,16.5 12,16.5Z",
  },
  {
    id: "700D143A-8347-4A79-9EF8-844E1B436524",
    name: "camera-metering-matrix",
    codepoint: "F7A2",
    aliases: [],
    tags: ["Photography"],
    author: "Andy Martinez",
    version: "2.0.46",
    path: "M4,4H20C21.1,4 22,4.9 22,6V18C22,19.1 21.1,20 20,20H4C2.9,20 2,19.1 2,18V6C2,4.9 2.9,4 4,4M4,6V18H20V6H4M5.5,7.5H11V9.17C10.15,9.47 9.47,10.15 9.17,11H5.5V7.5M18.5,7.5V11H14.83C14.53,10.15 13.85,9.47 13,9.17V7.5H18.5M18.5,16.5H13V14.83C13.85,14.53 14.53,13.85 14.83,13H18.5V16.5M5.5,16.5V13H9.17C9.47,13.85 10.15,14.53 11,14.83V16.5H5.5M12,10.5C12.83,10.5 13.5,11.17 13.5,12C13.5,12.83 12.83,13.5 12,13.5C11.17,13.5 10.5,12.83 10.5,12C10.5,11.17 11.17,10.5 12,10.5Z",
  },
  {
    id: "EA33D5EE-5E13-4D82-A552-C3B16772926F",
    name: "camera-metering-partial",
    codepoint: "F7A3",
    aliases: [],
    tags: ["Photography"],
    author: "Andy Martinez",
    version: "2.0.46",
    path: "M4,4H20C21.1,4 22,4.9 22,6V18C22,19.1 21.1,20 20,20H4C2.9,20 2,19.1 2,18V6C2,4.9 2.9,4 4,4M4,6V18H20V6H4M12,7.5C14.14,7.5 15.93,9 16.39,11H14.83C14.42,9.83 13.31,9 12,9C10.69,9 9.58,9.83 9.17,11H7.61C8.07,9 9.86,7.5 12,7.5M12,16.5C9.86,16.5 8.07,15 7.61,13H9.17C9.58,14.17 10.69,15 12,15C13.31,15 14.42,14.17 14.83,13H16.39C15.93,15 14.14,16.5 12,16.5Z",
  },
  {
    id: "C1313085-6C7F-4D60-A278-A39361B57DA9",
    name: "camera-metering-spot",
    codepoint: "F7A4",
    aliases: [],
    tags: ["Photography"],
    author: "Andy Martinez",
    version: "2.0.46",
    path: "M4,4H20C21.1,4 22,4.9 22,6V18C22,19.1 21.1,20 20,20H4C2.9,20 2,19.1 2,18V6C2,4.9 2.9,4 4,4M4,6V18H20V6H4M12,10.5C12.83,10.5 13.5,11.17 13.5,12C13.5,12.83 12.83,13.5 12,13.5C11.17,13.5 10.5,12.83 10.5,12C10.5,11.17 11.17,10.5 12,10.5Z",
  },
  {
    id: "461A25B1-59F6-49F1-A917-BED92315AA63",
    name: "camera-off",
    codepoint: "F5DF",
    aliases: [],
    tags: ["Photography"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M1.2,4.47L2.5,3.2L20,20.72L18.73,22L16.73,20H4C2.9,20 2,19.1 2,18V6C2,5.78 2.04,5.57 2.1,5.37L1.2,4.47M7,4L9,2H15L17,4H20C21.1,4 22,4.9 22,6V18C22,18.6 21.74,19.13 21.32,19.5L16.33,14.5C16.76,13.77 17,12.91 17,12C17,9.24 14.76,7 12,7C11.09,7 10.23,7.24 9.5,7.67L5.82,4H7M7,12C7,14.76 9.24,17 12,17C12.5,17 13.03,16.92 13.5,16.77L11.72,15C10.29,14.85 9.15,13.71 9,12.28L7.23,10.5C7.08,10.97 7,11.5 7,12M12,9C13.66,9 15,10.34 15,12C15,12.35 14.94,12.69 14.83,13L11,9.17C11.31,9.06 11.65,9 12,9Z",
  },
  {
    id: "B58A0D5C-B137-42DD-A43B-8DD296D7684A",
    name: "camera-party-mode",
    codepoint: "F105",
    aliases: [],
    tags: ["Photography"],
    author: "Google",
    version: "1.5.54",
    path: "M12,17C10.37,17 8.94,16.21 8,15H12C13.66,15 15,13.66 15,12C15,11.65 14.93,11.31 14.82,11H16.9C16.96,11.32 17,11.66 17,12C17,14.76 14.76,17 12,17M12,7C13.63,7 15.06,7.79 16,9H12C10.34,9 9,10.34 9,12C9,12.35 9.07,12.68 9.18,13H7.1C7.03,12.68 7,12.34 7,12C7,9.24 9.24,7 12,7M20,4H16.83L15,2H9L7.17,4H4C2.9,4 2,4.9 2,6V18C2,19.1 2.9,20 4,20H20C21.1,20 22,19.1 22,18V6C22,4.89 21.1,4 20,4Z",
  },
  {
    id: "B4CA0FB9-D119-426C-9043-16D90F5086B8",
    name: "camera-rear",
    codepoint: "F106",
    aliases: [],
    tags: ["Photography"],
    author: "Google",
    version: "1.5.54",
    path: "M12,6C10.89,6 10,5.1 10,4C10,2.9 10.9,2 12,2C13.09,2 14,2.9 14,4C14,5.1 13.1,6 12,6M17,0H7C5.9,0 5,0.9 5,2V16C5,17.1 5.9,18 7,18H17C18.1,18 19,17.1 19,16V2C19,0.9 18.1,0 17,0M14,20V22H19V20M10,20H5V22H10V24L13,21L10,18V20Z",
  },
  {
    id: "B7DB5F20-5D64-4096-959F-60BB040B320F",
    name: "camera-rear-variant",
    codepoint: "F107",
    aliases: [],
    tags: ["Photography"],
    author: "Google",
    version: "1.5.54",
    path: "M6,0H18C19.1,0 20,0.9 20,2V22C20,23.1 19.1,24 18,24H6C4.9,24 4,23.1 4,22V2C4,0.9 4.9,0 6,0M12,2C10.9,2 10,2.9 10,4C10,5.1 10.9,6 12,6C13.1,6 14,5.1 14,4C14,2.9 13.1,2 12,2M13,18H9V20H13V22L16,19L13,16V18Z",
  },
  {
    id: "68BB6884-5CEA-4B2A-8F22-46B6A98CDA75",
    name: "camera-switch",
    codepoint: "F108",
    aliases: ["switch-camera"],
    tags: ["Photography"],
    author: "Google",
    version: "1.5.54",
    path: "M15,15.5V13H9V15.5L5.5,12L9,8.5V11H15V8.5L18.5,12M20,4H16.83L15,2H9L7.17,4H4C2.9,4 2,4.9 2,6V18C2,19.1 2.9,20 4,20H20C21.1,20 22,19.1 22,18V6C22,4.89 21.1,4 20,4Z",
  },
  {
    id: "6A8FC2AF-724C-46A2-9F04-C34E7D658679",
    name: "camera-timer",
    codepoint: "F109",
    aliases: [],
    tags: ["Date / Time", "Photography"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M4.94,6.35C4.55,5.96 4.55,5.32 4.94,4.93C5.33,4.54 5.96,4.54 6.35,4.93L13.07,10.31L13.42,10.59C14.2,11.37 14.2,12.64 13.42,13.42C12.64,14.2 11.37,14.2 10.59,13.42L10.31,13.07L4.94,6.35M12,20C16.42,20 20,16.42 20,12C20,9.79 19.1,7.79 17.66,6.34L19.07,4.93C20.88,6.74 22,9.24 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12H4C4,16.42 7.58,20 12,20M12,1C13.1,1 14,1.9 14,3C14,4.1 13.1,5 12,5C10.9,5 10,4.1 10,3C10,1.9 10.9,1 12,1Z",
  },
  {
    id: "02F70DD2-E16E-43FD-9C2A-267C965E3919",
    name: "cancel",
    codepoint: "F739",
    aliases: ["prohibited", "ban", "do-not-disturb-alt"],
    tags: [],
    author: "Google",
    version: "1.9.32",
    path: "M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M12,4C7.58,4 4,7.58 4,12C4,13.85 4.63,15.55 5.68,16.91L16.91,5.68C15.55,4.63 13.85,4 12,4M12,20C16.42,20 20,16.42 20,12C20,10.15 19.37,8.45 18.32,7.09L7.09,18.32C8.45,19.37 10.15,20 12,20Z",
  },
  {
    id: "4FB0AA38-406A-4877-8B0C-15C7ED95F22C",
    name: "candle",
    codepoint: "F5E2",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M12.5,2C10.84,2 9.5,5.34 9.5,7C9.5,8.66 10.84,10 12.5,10C14.16,10 15.5,8.66 15.5,7C15.5,5.34 14.16,2 12.5,2M12.5,6.5C13.05,6.5 13.5,6.95 13.5,7.5C13.5,8.05 13.05,8.5 12.5,8.5C11.95,8.5 11.5,8.05 11.5,7.5C11.5,6.95 11.95,6.5 12.5,6.5M10,11C9.45,11 9,11.45 9,12V20H7C6.45,20 6,19.55 6,19V18C6,17.45 5.55,17 5,17C4.45,17 4,17.45 4,18V19C4,20.66 5.34,22 7,22H19C19.55,22 20,21.55 20,21C20,20.45 19.55,20 19,20H16V12C16,11.45 15.55,11 15,11H10Z",
  },
  {
    id: "8CAC723B-0FF5-493B-A3A2-5772FDE46A0F",
    name: "candycane",
    codepoint: "F10A",
    aliases: [],
    tags: ["Holiday", "Food / Drink"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M10,10C10,11.1 9.1,12 8,12C6.9,12 6,11.1 6,10V8C6,7.37 6.1,6.77 6.27,6.2L10,9.93V10M12,2C12.74,2 13.44,2.13 14.09,2.38L11.97,6C11.14,6 10.44,6.5 10.15,7.25L7.24,4.34C8.34,2.92 10.06,2 12,2M17.76,6.31L14,10.07V8C14,7.62 13.9,7.27 13.72,6.97L15.83,3.38C16.74,4.13 17.42,5.15 17.76,6.31M18,13.09L14,17.09V12.9L18,8.9V13.09M18,20C18,21.1 17.1,22 16,22C14.9,22 14,21.1 14,20V19.91L18,15.91V20Z",
  },
  {
    id: "4C2DC909-0C3F-431F-A37B-5B66C9F33E37",
    name: "cannabis",
    codepoint: "F7A5",
    aliases: [],
    tags: ["Nature", "Medical / Hospital"],
    author: "Austin Andrews",
    version: "2.0.46",
    path: "M11.5,22V17.35C11,18.13 10,19.09 8.03,19.81C8.03,19.81 8.53,18.1 9.94,16.95C8.64,17.23 6.68,17.19 4,16C4,16 6.47,14.59 9.28,14.97C7.69,14 5.7,12.08 4.17,8.11C4.17,8.11 8.67,9.34 10.91,13.14C8.88,8.24 12,2 12,2C14.43,7.47 13.91,11.1 13.12,13.1C15.37,9.33 19.83,8.11 19.83,8.11C18.3,12.08 16.31,14 14.72,14.97C17.53,14.59 20,16 20,16C17.32,17.19 15.36,17.23 14.06,16.95C15.47,18.1 15.97,19.81 15.97,19.81C14,19.09 13,18.13 12.5,17.35V22H11.5Z",
  },
  {
    id: "FCF4FF57-4547-4C11-A20A-3D26252780EC",
    name: "car",
    codepoint: "F10B",
    aliases: ["directions-car", "drive-eta", "time-to-leave"],
    tags: ["Transportation + Road", "Navigation"],
    author: "Google",
    version: "1.5.54",
    path: "M5,11L6.5,6.5H17.5L19,11M17.5,16C16.67,16 16,15.33 16,14.5C16,13.67 16.67,13 17.5,13C18.33,13 19,13.67 19,14.5C19,15.33 18.33,16 17.5,16M6.5,16C5.67,16 5,15.33 5,14.5C5,13.67 5.67,13 6.5,13C7.33,13 8,13.67 8,14.5C8,15.33 7.33,16 6.5,16M18.92,6C18.72,5.42 18.16,5 17.5,5H6.5C5.84,5 5.28,5.42 5.08,6L3,12V20C3,20.55 3.45,21 4,21H5C5.55,21 6,20.55 6,20V19H18V20C18,20.55 18.45,21 19,21H20C20.55,21 21,20.55 21,20V12L18.92,6Z",
  },
  {
    id: "4AF128D8-1E70-4396-BB5A-F96A7D0F9BCB",
    name: "car-battery",
    codepoint: "F10C",
    aliases: [],
    tags: ["Battery"],
    author: "Cody",
    version: "1.5.54",
    path: "M4,3V6H1V20H23V6H20V3H14V6H10V3H4M3,8H21V18H3V8M15,10V12H13V14H15V16H17V14H19V12H17V10H15M5,12V14H11V12H5Z",
  },
  {
    id: "8C8468C7-8A41-42A1-8C33-4AAE55FF9E2A",
    name: "car-connected",
    codepoint: "F10D",
    aliases: [],
    tags: ["Transportation + Road"],
    author: "Cody",
    version: "1.5.54",
    path: "M5,14H19L17.5,9.5H6.5L5,14M17.5,19C18.33,19 19,18.33 19,17.5C19,16.67 18.33,16 17.5,16C16.67,16 16,16.67 16,17.5C16,18.33 16.67,19 17.5,19M6.5,19C7.33,19 8,18.33 8,17.5C8,16.67 7.33,16 6.5,16C5.67,16 5,16.67 5,17.5C5,18.33 5.67,19 6.5,19M18.92,9L21,15V23C21,23.55 20.55,24 20,24H19C18.45,24 18,23.55 18,23V22H6V23C6,23.55 5.55,24 5,24H4C3.45,24 3,23.55 3,23V15L5.08,9C5.28,8.42 5.85,8 6.5,8H17.5C18.15,8 18.72,8.42 18.92,9M12,0C14.12,0 16.15,0.86 17.65,2.35L16.23,3.77C15.11,2.65 13.58,2 12,2C10.42,2 8.89,2.65 7.77,3.77L6.36,2.35C7.85,0.86 9.88,0 12,0M12,4C13.06,4 14.07,4.44 14.82,5.18L13.4,6.6C13.03,6.23 12.53,6 12,6C11.5,6 10.97,6.23 10.6,6.6L9.18,5.18C9.93,4.44 10.94,4 12,4Z",
  },
  {
    id: "D7E88B5B-B6F3-4C55-AE93-39A78593B351",
    name: "car-convertible",
    codepoint: "F7A6",
    aliases: [],
    tags: ["Transportation + Road"],
    author: "GreenTurtwig",
    version: "2.0.46",
    path: "M16,6L15,6.75L17.5,10H13.5V8.5H12V10H3C1.89,10 1,10.89 1,12V15H3C3,16.66 4.34,18 6,18C7.66,18 9,16.66 9,15H15C15,16.66 16.34,18 18,18C19.66,18 21,16.66 21,15H23V12C23,10.89 22.11,10 21,10H19L16,6M6,13.5C6.83,13.5 7.5,14.17 7.5,15C7.5,15.83 6.83,16.5 6,16.5C5.17,16.5 4.5,15.83 4.5,15C4.5,14.17 5.17,13.5 6,13.5M18,13.5C18.83,13.5 19.5,14.17 19.5,15C19.5,15.83 18.83,16.5 18,16.5C17.17,16.5 16.5,15.83 16.5,15C16.5,14.17 17.17,13.5 18,13.5Z",
  },
  {
    id: "90BBBADD-0FCD-4147-9D6E-5DAFCACF2B0B",
    name: "car-estate",
    codepoint: "F7A7",
    aliases: [],
    tags: ["Transportation + Road"],
    author: "GreenTurtwig",
    version: "2.0.46",
    path: "M3,6H16L19,10H21C22.11,10 23,10.89 23,12V15H21C21,16.66 19.66,18 18,18C16.34,18 15,16.66 15,15H9C9,16.66 7.66,18 6,18C4.34,18 3,16.66 3,15H1V8C1,6.89 1.89,6 3,6M2.5,7.5V10H10.5V7.5H2.5M12,7.5V10H17.14L15.25,7.5H12M6,13.5C5.17,13.5 4.5,14.17 4.5,15C4.5,15.83 5.17,16.5 6,16.5C6.83,16.5 7.5,15.83 7.5,15C7.5,14.17 6.83,13.5 6,13.5M18,13.5C17.17,13.5 16.5,14.17 16.5,15C16.5,15.83 17.17,16.5 18,16.5C18.83,16.5 19.5,15.83 19.5,15C19.5,14.17 18.83,13.5 18,13.5Z",
  },
  {
    id: "21A2527E-9AC0-4FFA-84CB-246608BEB91D",
    name: "car-hatchback",
    codepoint: "F7A8",
    aliases: [],
    tags: ["Transportation + Road"],
    author: "GreenTurtwig",
    version: "2.0.46",
    path: "M16,6H6L1,12V15H3C3,16.66 4.34,18 6,18C7.66,18 9,16.66 9,15H15C15,16.66 16.34,18 18,18C19.66,18 21,16.66 21,15H23V12C23,10.89 22.11,10 21,10H19L16,6M6.5,7.5H10.5V10H4.5L6.5,7.5M12,7.5H15.5L17.46,10H12V7.5M6,13.5C6.83,13.5 7.5,14.17 7.5,15C7.5,15.83 6.83,16.5 6,16.5C5.17,16.5 4.5,15.83 4.5,15C4.5,14.17 5.17,13.5 6,13.5M18,13.5C18.83,13.5 19.5,14.17 19.5,15C19.5,15.83 18.83,16.5 18,16.5C17.17,16.5 16.5,15.83 16.5,15C16.5,14.17 17.17,13.5 18,13.5Z",
  },
  {
    id: "43758944-946B-4883-A77C-F6F28F175920",
    name: "car-limousine",
    codepoint: "F8CC",
    aliases: [],
    tags: ["Transportation + Road"],
    author: "GreenTurtwig",
    version: "2.3.50",
    path: "M1,6L2.5,7.5L1,9L2.5,10.5L1,12L2.5,13.5L1,15H15C15,16.66 16.34,18 18,18C19.66,18 21,16.66 21,15H23V12C23,10.89 22.11,10 21,10H19L16,6H1M4.62,7.5H10.5V10H4.12L3.12,9L4.62,7.5M12,7.5H15.5L17.46,10H12V7.5M18,13.5C18.83,13.5 19.5,14.17 19.5,15C19.5,15.83 18.83,16.5 18,16.5C17.17,16.5 16.5,15.83 16.5,15C16.5,14.17 17.17,13.5 18,13.5Z",
  },
  {
    id: "76BB371D-335C-4F53-A439-2A681778C6BC",
    name: "car-pickup",
    codepoint: "F7A9",
    aliases: [],
    tags: ["Transportation + Road"],
    author: "GreenTurtwig",
    version: "2.0.46",
    path: "M16,6H10.5V10H1V15H3C3,16.66 4.34,18 6,18C7.66,18 9,16.66 9,15H15C15,16.66 16.34,18 18,18C19.66,18 21,16.66 21,15H23V12C23,10.89 22.11,10 21,10H19L16,6M12,7.5H15.5L17.46,10H12V7.5M6,13.5C6.83,13.5 7.5,14.17 7.5,15C7.5,15.83 6.83,16.5 6,16.5C5.17,16.5 4.5,15.83 4.5,15C4.5,14.17 5.17,13.5 6,13.5M18,13.5C18.83,13.5 19.5,14.17 19.5,15C19.5,15.83 18.83,16.5 18,16.5C17.17,16.5 16.5,15.83 16.5,15C16.5,14.17 17.17,13.5 18,13.5Z",
  },
  {
    id: "CB49A868-3317-4445-BFED-13CB6533000E",
    name: "car-side",
    codepoint: "F7AA",
    aliases: [],
    tags: ["Transportation + Road"],
    author: "GreenTurtwig",
    version: "2.0.46",
    path: "M16,6L19,10H21C22.11,10 23,10.89 23,12V15H21C21,16.66 19.66,18 18,18C16.34,18 15,16.66 15,15H9C9,16.66 7.66,18 6,18C4.34,18 3,16.66 3,15H1V12C1,10.89 1.89,10 3,10L6,6H16M10.5,7.5H6.75L4.86,10H10.5V7.5M12,7.5V10H17.14L15.25,7.5H12M6,13.5C5.17,13.5 4.5,14.17 4.5,15C4.5,15.83 5.17,16.5 6,16.5C6.83,16.5 7.5,15.83 7.5,15C7.5,14.17 6.83,13.5 6,13.5M18,13.5C17.17,13.5 16.5,14.17 16.5,15C16.5,15.83 17.17,16.5 18,16.5C18.83,16.5 19.5,15.83 19.5,15C19.5,14.17 18.83,13.5 18,13.5Z",
  },
  {
    id: "97F5ED58-F2AB-40AC-A882-4A90DB5D2018",
    name: "car-sports",
    codepoint: "F7AB",
    aliases: [],
    tags: ["Transportation + Road"],
    author: "GreenTurtwig",
    version: "2.0.46",
    path: "M12,8.5H7L4,11H3C1.89,11 1,11.89 1,13V16H3.17C3.6,17.2 4.73,18 6,18C7.27,18 8.4,17.2 8.82,16H15.17C15.6,17.2 16.73,18 18,18C19.27,18 20.4,17.2 20.82,16H23V15C23,13.89 21.97,13.53 21,13L12,8.5M5.25,12L7.5,10H11.5L15.5,12H5.25M6,13.5C6.83,13.5 7.5,14.17 7.5,15C7.5,15.83 6.83,16.5 6,16.5C5.17,16.5 4.5,15.83 4.5,15C4.5,14.17 5.17,13.5 6,13.5M18,13.5C18.83,13.5 19.5,14.17 19.5,15C19.5,15.83 18.83,16.5 18,16.5C17.17,16.5 16.5,15.83 16.5,15C16.5,14.17 17.17,13.5 18,13.5Z",
  },
  {
    id: "95E617D7-9A48-458E-96C5-A8CBBEF3A852",
    name: "car-wash",
    codepoint: "F10E",
    aliases: ["local-car-wash"],
    tags: ["Transportation + Road", "Places"],
    author: "Google",
    version: "1.5.54",
    path: "M5,13L6.5,8.5H17.5L19,13M17.5,18C16.67,18 16,17.33 16,16.5C16,15.67 16.67,15 17.5,15C18.33,15 19,15.67 19,16.5C19,17.33 18.33,18 17.5,18M6.5,18C5.67,18 5,17.33 5,16.5C5,15.67 5.67,15 6.5,15C7.33,15 8,15.67 8,16.5C8,17.33 7.33,18 6.5,18M18.92,8C18.72,7.42 18.16,7 17.5,7H6.5C5.84,7 5.28,7.42 5.08,8L3,14V22C3,22.55 3.45,23 4,23H5C5.55,23 6,22.55 6,22V21H18V22C18,22.55 18.45,23 19,23H20C20.55,23 21,22.55 21,22V14M7,5C7.83,5 8.5,4.33 8.5,3.5C8.5,2.5 7,0.8 7,0.8C7,0.8 5.5,2.5 5.5,3.5C5.5,4.33 6.17,5 7,5M12,5C12.83,5 13.5,4.33 13.5,3.5C13.5,2.5 12,0.8 12,0.8C12,0.8 10.5,2.5 10.5,3.5C10.5,4.33 11.17,5 12,5M17,5C17.83,5 18.5,4.33 18.5,3.5C18.5,2.5 17,0.8 17,0.8C17,0.8 15.5,2.5 15.5,3.5C15.5,4.33 16.17,5 17,5Z",
  },
  {
    id: "2E5B9249-0FFB-48D0-8A61-2019FD9ED32F",
    name: "caravan",
    codepoint: "F7AC",
    aliases: [],
    tags: ["Transportation + Road", "Home Automation"],
    author: "GreenTurtwig",
    version: "2.0.46",
    path: "M5,7C3.9,7 3,7.9 3,9V15C3,16.1 3.9,17 5,17H7C7,18.66 8.34,20 10,20C11.66,20 13,18.66 13,17H21V15H19V9C19,7.9 18.1,7 17,7H5M5,9H10V12H5V9M13,9H17V12H13V9M10,16C10.55,16 11,16.45 11,17C11,17.55 10.55,18 10,18C9.45,18 9,17.55 9,17C9,16.45 9.45,16 10,16Z",
  },
  {
    id: "7E04A92C-1DC5-4A5F-84B0-57A50545EBE4",
    name: "cards",
    codepoint: "F638",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.6.50",
    path: "M21.47,4.35L20.13,3.79V12.82L22.56,6.96C22.97,5.94 22.5,4.77 21.47,4.35M1.97,8.05L6.93,20C7.24,20.77 7.97,21.24 8.74,21.26C9,21.26 9.27,21.21 9.53,21.1L16.9,18.05C17.65,17.74 18.11,17 18.13,16.26C18.14,16 18.09,15.71 18,15.45L13,3.5C12.71,2.73 11.97,2.26 11.19,2.25C10.93,2.25 10.67,2.31 10.42,2.4L3.06,5.45C2.04,5.87 1.55,7.04 1.97,8.05M18.12,4.25C18.12,3.15 17.22,2.25 16.12,2.25H14.67L18.12,10.59",
  },
  {
    id: "FD5114FD-37CB-4346-BC73-58E1EED49CF3",
    name: "cards-club",
    codepoint: "F8CD",
    aliases: ["suit-clubs"],
    tags: [],
    author: "Nick",
    version: "2.3.50",
    path: "M12,2C14.3,2 16.3,4 16.3,6.2C16.21,8.77 14.34,9.83 14.04,10C15.04,9.5 16.5,9.5 16.5,9.5C19,9.5 21,11.3 21,13.8C21,16.3 19,18 16.5,18C16.5,18 15,18 13,17C13,17 12.7,19 15,22H9C11.3,19 11,17 11,17C9,18 7.5,18 7.5,18C5,18 3,16.3 3,13.8C3,11.3 5,9.5 7.5,9.5C7.5,9.5 8.96,9.5 9.96,10C9.66,9.83 7.79,8.77 7.7,6.2C7.7,4 9.7,2 12,2Z",
  },
  {
    id: "0934FB0D-8585-4064-989F-054E52D16FDB",
    name: "cards-diamond",
    codepoint: "F8CE",
    aliases: ["suit-diamonds"],
    tags: [],
    author: "Nick",
    version: "2.3.50",
    path: "M19,12L12,22L5,12L12,2",
  },
  {
    id: "152E7662-6FDD-478C-A945-68F6B04CB073",
    name: "cards-heart",
    codepoint: "F8CF",
    aliases: ["suit-hearts"],
    tags: [],
    author: "Nick",
    version: "2.3.50",
    path: "M12,21.35L10.55,20.03C5.4,15.36 2,12.27 2,8.5C2,5.41 4.42,3 7.5,3C9.24,3 10.91,3.81 12,5.08C13.09,3.81 14.76,3 16.5,3C19.58,3 22,5.41 22,8.5C22,12.27 18.6,15.36 13.45,20.03L12,21.35Z",
  },
  {
    id: "BB07EFB4-5078-47BA-B441-93D4957AF7F9",
    name: "cards-outline",
    codepoint: "F639",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.6.50",
    path: "M11.19,2.25C10.93,2.25 10.67,2.31 10.42,2.4L3.06,5.45C2.04,5.87 1.55,7.04 1.97,8.05L6.93,20C7.24,20.77 7.97,21.23 8.74,21.25C9,21.25 9.27,21.22 9.53,21.1L16.9,18.05C17.65,17.74 18.11,17 18.13,16.25C18.14,16 18.09,15.71 18,15.45L13,3.5C12.71,2.73 11.97,2.26 11.19,2.25M14.67,2.25L18.12,10.6V4.25C18.12,3.15 17.22,2.25 16.12,2.25M20.13,3.79V12.82L22.56,6.96C22.97,5.94 22.5,4.78 21.47,4.36M11.19,4.22L16.17,16.24L8.78,19.3L3.8,7.29",
  },
  {
    id: "C388C342-49AA-4577-A968-12BD804E5A8E",
    name: "cards-playing-outline",
    codepoint: "F63A",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.6.50",
    path: "M11.19,2.25C11.97,2.26 12.71,2.73 13,3.5L18,15.45C18.09,15.71 18.14,16 18.13,16.25C18.11,17 17.65,17.74 16.9,18.05L9.53,21.1C9.27,21.22 9,21.25 8.74,21.25C7.97,21.23 7.24,20.77 6.93,20L1.97,8.05C1.55,7.04 2.04,5.87 3.06,5.45L10.42,2.4C10.67,2.31 10.93,2.25 11.19,2.25M14.67,2.25H16.12C17.22,2.25 18.12,3.15 18.12,4.25V10.6L14.67,2.25M20.13,3.79L21.47,4.36C22.5,4.78 22.97,5.94 22.56,6.96L20.13,12.82V3.79M11.19,4.22L3.8,7.29L8.77,19.3L16.17,16.24L11.19,4.22M8.65,8.54L11.88,10.95L11.44,14.96L8.21,12.54L8.65,8.54Z",
  },
  {
    id: "B2DEB97A-B08E-4E10-8E24-A4AF2CF98C74",
    name: "cards-spade",
    codepoint: "F8D0",
    aliases: ["suit-spades"],
    tags: [],
    author: "Nick",
    version: "2.3.50",
    path: "M12,2C9,7 4,9 4,14C4,16 6,18 8,18C9,18 10,18 11,17C11,17 11.32,19 9,22H15C13,19 13,17 13,17C14,18 15,18 16,18C18,18 20,16 20,14C20,9 15,7 12,2Z",
  },
  {
    id: "A000BD20-147F-43FB-AD99-08AE6BA2E80B",
    name: "cards-variant",
    codepoint: "F6C6",
    aliases: [],
    tags: [],
    author: "Case Sandberg",
    version: "1.8.36",
    path: "M5,2H19C19.55,2 20,2.45 20,3V13C20,13.55 19.55,14 19,14H5C4.45,14 4,13.55 4,13V3C4,2.45 4.45,2 5,2M6,4V12H18V4H6M20,17C20,17.55 19.55,18 19,18H5C4.45,18 4,17.55 4,17V16H20V17M20,21C20,21.55 19.55,22 19,22H5C4.45,22 4,21.55 4,21V20H20V21Z",
  },
  {
    id: "6BD10A61-9A45-4A5A-ABEF-404135975917",
    name: "carrot",
    codepoint: "F10F",
    aliases: [],
    tags: ["Agriculture", "Food / Drink"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M16,10L15.8,11H13.5C13.22,11 13,11.22 13,11.5C13,11.78 13.22,12 13.5,12H15.6L14.6,17H12.5C12.22,17 12,17.22 12,17.5C12,17.78 12.22,18 12.5,18H14.4L14,20C14,21.1 13.1,22 12,22C10.9,22 10,21.1 10,20L9,15H10.5C10.78,15 11,14.78 11,14.5C11,14.22 10.78,14 10.5,14H8.8L8,10C8,8.8 8.93,7.77 10.29,7.29L8.9,5.28C8.59,4.82 8.7,4.2 9.16,3.89C9.61,3.57 10.23,3.69 10.55,4.14L11,4.8V3C11,2.45 11.45,2 12,2C12.55,2 13,2.45 13,3V5.28L14.5,3.54C14.83,3.12 15.47,3.07 15.89,3.43C16.31,3.78 16.36,4.41 16,4.84L13.87,7.35C15.14,7.85 16,8.85 16,10Z",
  },
  {
    id: "97563623-CF1C-43AE-87D8-DF54802D442B",
    name: "cart",
    codepoint: "F110",
    aliases: ["trolley", "local-grocery-store", "shopping-cart"],
    tags: ["Shopping"],
    author: "Google",
    version: "1.5.54",
    path: "M17,18C15.89,18 15,18.89 15,20C15,21.1 15.9,22 17,22C18.1,22 19,21.1 19,20C19,18.89 18.1,18 17,18M1,2V4H3L6.6,11.59L5.24,14.04C5.09,14.32 5,14.65 5,15C5,16.1 5.9,17 7,17H19V15H7.42C7.28,15 7.17,14.89 7.17,14.75C7.17,14.7 7.18,14.66 7.2,14.63L8.1,13H15.55C16.3,13 16.96,12.58 17.3,11.97L20.88,5.5C20.95,5.34 21,5.17 21,5C21,4.45 20.55,4 20,4H5.21L4.27,2M7,18C5.89,18 5,18.89 5,20C5,21.1 5.9,22 7,22C8.1,22 9,21.1 9,20C9,18.89 8.1,18 7,18Z",
  },
  {
    id: "05455801-C523-420A-A961-868ABA3DF636",
    name: "cart-off",
    codepoint: "F66B",
    aliases: ["trolley-off", "remove-shopping-cart"],
    tags: ["Shopping"],
    author: "Google",
    version: "1.6.50",
    path: "M22.73,22.73L1.27,1.27L0,2.54L4.39,6.93L6.6,11.59L5.25,14.04C5.09,14.32 5,14.65 5,15C5,16.1 5.9,17 7,17H14.46L15.84,18.38C15.34,18.74 15,19.33 15,20C15,21.1 15.9,22 17,22C17.67,22 18.26,21.67 18.62,21.16L21.46,24L22.73,22.73M7.42,15C7.28,15 7.17,14.89 7.17,14.75L7.2,14.63L8.1,13H10.46L12.46,15H7.42M15.55,13C16.3,13 16.96,12.59 17.3,11.97L20.88,5.5C20.96,5.34 21,5.17 21,5C21,4.45 20.55,4 20,4H6.54L15.55,13M7,18C5.9,18 5,18.9 5,20C5,21.1 5.9,22 7,22C8.1,22 9,21.1 9,20C9,18.9 8.1,18 7,18Z",
  },
  {
    id: "F290ABB0-4CD2-4C45-B543-E3AEBA1FE358",
    name: "cart-outline",
    codepoint: "F111",
    aliases: ["trolley-outline"],
    tags: ["Shopping"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M17,18C18.1,18 19,18.9 19,20C19,21.1 18.1,22 17,22C15.89,22 15,21.1 15,20C15,18.89 15.89,18 17,18M1,2H4.27L5.21,4H20C20.55,4 21,4.45 21,5C21,5.17 20.95,5.34 20.88,5.5L17.3,11.97C16.96,12.58 16.3,13 15.55,13H8.1L7.2,14.63L7.17,14.75C7.17,14.89 7.28,15 7.42,15H19V17H7C5.89,17 5,16.1 5,15C5,14.65 5.09,14.32 5.24,14.04L6.6,11.59L3,4H1V2M7,18C8.1,18 9,18.9 9,20C9,21.1 8.1,22 7,22C5.89,22 5,21.1 5,20C5,18.89 5.89,18 7,18M16,11L18.78,6H6.14L8.5,11H16Z",
  },
  {
    id: "2BF13245-A7BF-49EC-8EB0-CA10F7AF11B2",
    name: "cart-plus",
    codepoint: "F112",
    aliases: ["trolley-plus", "add-shopping-cart"],
    tags: ["Shopping"],
    author: "Google",
    version: "1.5.54",
    path: "M11,9H13V6H16V4H13V1H11V4H8V6H11M7,18C5.9,18 5,18.9 5,20C5,21.1 5.9,22 7,22C8.1,22 9,21.1 9,20C9,18.9 8.1,18 7,18M17,18C15.9,18 15,18.9 15,20C15,21.1 15.9,22 17,22C18.1,22 19,21.1 19,20C19,18.9 18.1,18 17,18M7.17,14.75L7.2,14.63L8.1,13H15.55C16.3,13 16.96,12.59 17.3,11.97L21.16,4.96L19.42,4H19.41L18.31,6L15.55,11H8.53L8.4,10.73L6.16,6L5.21,4L4.27,2H1V4H3L6.6,11.59L5.25,14.04C5.09,14.32 5,14.65 5,15C5,16.1 5.9,17 7,17H19V15H7.42C7.29,15 7.17,14.89 7.17,14.75Z",
  },
  {
    id: "250BE86F-4D41-4F22-AECD-DD8A2533DA62",
    name: "case-sensitive-alt",
    codepoint: "F113",
    aliases: [],
    tags: [],
    author: "Doug C. Hardester",
    version: "1.5.54",
    path: "M20,14C20,12.5 19.5,12 18,12H16V11C16,10 16,10 14,10V15.4L14,19H16L18,19C19.5,19 20,18.47 20,17V14M12,12C12,10.5 11.47,10 10,10H6C4.5,10 4,10.5 4,12V19H6V16H10V19H12V12M10,7H14V5H10V7M22,9V20C22,21.11 21.11,22 20,22H4C2.9,22 2,21.1 2,20V9C2,7.89 2.89,7 4,7H8V5L10,3H14L16,5V7H20C21.1,7 22,7.9 22,9H22M16,17H18V14H16V17M6,12H10V14H6V12Z",
  },
  {
    id: "59956D81-BF6B-4DCA-ABAD-A890412F22F1",
    name: "cash",
    codepoint: "F114",
    aliases: [],
    tags: ["Currency", "Banking"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M3,6H21V18H3V6M12,9C13.66,9 15,10.34 15,12C15,13.66 13.66,15 12,15C10.34,15 9,13.66 9,12C9,10.34 10.34,9 12,9M7,8C7,9.1 6.1,10 5,10V14C6.1,14 7,14.9 7,16H17C17,14.9 17.9,14 19,14V10C17.9,10 17,9.1 17,8H7Z",
  },
  {
    id: "18E513D3-5D34-4A4B-B600-D7173CB30DDA",
    name: "cash-100",
    codepoint: "F115",
    aliases: [],
    tags: ["Currency", "Banking"],
    author: "Google",
    version: "1.5.54",
    path: "M2,5H22V20H2V5M20,18V7H4V18H20M17,8C17,9.1 17.9,10 19,10V15C17.9,15 17,15.9 17,17H7C7,15.9 6.1,15 5,15V10C6.1,10 7,9.1 7,8H17M17,13V12C17,10.9 16.33,10 15.5,10C14.67,10 14,10.9 14,12V13C14,14.1 14.67,15 15.5,15C16.33,15 17,14.1 17,13M15.5,11C15.78,11 16,11.22 16,11.5V13.5C16,13.78 15.78,14 15.5,14C15.22,14 15,13.78 15,13.5V11.5C15,11.22 15.22,11 15.5,11M13,13V12C13,10.9 12.33,10 11.5,10C10.67,10 10,10.9 10,12V13C10,14.1 10.67,15 11.5,15C12.33,15 13,14.1 13,13M11.5,11C11.78,11 12,11.22 12,11.5V13.5C12,13.78 11.78,14 11.5,14C11.22,14 11,13.78 11,13.5V11.5C11,11.22 11.22,11 11.5,11M8,15H9V10H8L7,10.5V11.5L8,11V15Z",
  },
  {
    id: "80D4170E-FDA3-40D0-9B05-1020D5FCA817",
    name: "cash-multiple",
    codepoint: "F116",
    aliases: [],
    tags: ["Currency", "Banking"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M5,6H23V18H5V6M14,9C15.66,9 17,10.34 17,12C17,13.66 15.66,15 14,15C12.34,15 11,13.66 11,12C11,10.34 12.34,9 14,9M9,8C9,9.1 8.1,10 7,10V14C8.1,14 9,14.9 9,16H19C19,14.9 19.9,14 21,14V10C19.9,10 19,9.1 19,8H9M1,10H3V20H19V22H1V10Z",
  },
  {
    id: "219B8956-E48B-4D11-9257-422E563955DB",
    name: "cash-usd",
    codepoint: "F117",
    aliases: ["local-atm"],
    tags: ["Currency", "Banking"],
    author: "Google",
    version: "1.5.54",
    path: "M20,18H4V6H20M20,4H4C2.89,4 2,4.89 2,6V18C2,19.1 2.9,20 4,20H20C21.1,20 22,19.1 22,18V6C22,4.89 21.1,4 20,4M11,17H13V16H14C14.55,16 15,15.55 15,15V12C15,11.45 14.55,11 14,11H11V10H15V8H13V7H11V8H10C9.45,8 9,8.45 9,9V12C9,12.55 9.45,13 10,13H13V14H9V16H11V17Z",
  },
  {
    id: "EF35081A-EABF-4C6B-B858-7F2177B60F95",
    name: "cassette",
    codepoint: "F9D3",
    aliases: ["tape"],
    tags: [],
    author: "GreenTurtwig",
    version: "2.5.94",
    path: "M4,5C2.9,5 2,5.9 2,7V17C2,18.1 2.9,19 4,19H6L7,17H17L18,19H20C21.1,19 22,18.1 22,17V7C22,5.9 21.1,5 20,5H4M6.5,10C7.33,10 8,10.67 8,11.5C8,12.33 7.33,13 6.5,13C5.67,13 5,12.33 5,11.5C5,10.67 5.67,10 6.5,10M9,10H15V13H9V10M17.5,10C18.33,10 19,10.67 19,11.5C19,12.33 18.33,13 17.5,13C16.67,13 16,12.33 16,11.5C16,10.67 16.67,10 17.5,10Z",
  },
  {
    id: "996A1644-29FB-4221-9225-FD5CF8AAD5CE",
    name: "cast",
    codepoint: "F118",
    aliases: [],
    tags: ["Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M1,10V12C5.97,12 10,16.03 10,21H12C12,14.92 7.07,10 1,10M1,14V16C3.76,16 6,18.24 6,21H8C8,17.13 4.87,14 1,14M1,18V21H4C4,19.34 2.66,18 1,18M21,3H3C1.89,3 1,3.89 1,5V8H3V5H21V19H14V21H21C22.1,21 23,20.1 23,19V5C23,3.89 22.1,3 21,3Z",
  },
  {
    id: "80EC7FF6-03C0-4D61-8858-D2D94426D2DE",
    name: "cast-connected",
    codepoint: "F119",
    aliases: [],
    tags: ["Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M21,3H3C1.89,3 1,3.89 1,5V8H3V5H21V19H14V21H21C22.1,21 23,20.1 23,19V5C23,3.89 22.1,3 21,3M1,10V12C5.97,12 10,16.03 10,21H12C12,14.92 7.07,10 1,10M19,7H5V8.63C8.96,9.91 12.09,13.04 13.37,17H19M1,14V16C3.76,16 6,18.24 6,21H8C8,17.13 4.87,14 1,14M1,18V21H4C4,19.34 2.66,18 1,18Z",
  },
  {
    id: "F6AC6C9C-C82B-48C0-84AB-BEE76FC7BB5B",
    name: "cast-off",
    codepoint: "F789",
    aliases: [],
    tags: ["Home Automation"],
    author: "Cody",
    version: "1.9.32",
    path: "M1.6,1.27L0.25,2.75L1.41,3.8C1.16,4.13 1,4.55 1,5V8H3V5.23L18.2,19H14V21H20.41L22.31,22.72L23.65,21.24M6.5,3L8.7,5H21V16.14L23,17.95V5C23,3.89 22.1,3 21,3M1,10V12C5.97,12 10,16.03 10,21H12C12,14.92 7.08,10 1,10M1,14V16C3.76,16 6,18.24 6,21H8C8,17.13 4.87,14 1,14M1,18V21H4C4,19.34 2.66,18 1,18Z",
  },
  {
    id: "53FF9F06-A3F7-4B04-9D54-207FE8B56B8E",
    name: "castle",
    codepoint: "F11A",
    aliases: [],
    tags: ["Places"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M2,13H4V15H6V13H8V15H10V13H12V15H14V10L17,7V1H19L23,3L19,5V7L22,10V22H11V19C11,17.9 10.1,17 9,17C7.9,17 7,17.9 7,19V22H2V13M18,10C17.45,10 17,10.54 17,11.2V13H19V11.2C19,10.54 18.55,10 18,10Z",
  },
  {
    id: "5D3A753E-1FA9-42F4-8A71-E686A36D1CB6",
    name: "cat",
    codepoint: "F11B",
    aliases: [],
    tags: ["Animal"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,8L10.67,8.09C9.81,7.07 7.4,4.5 5,4.5C5,4.5 3.03,7.46 4.96,11.41C4.41,12.24 4.07,12.67 4,13.66L2.07,13.95L2.28,14.93L4.04,14.67L4.18,15.38L2.61,16.32L3.08,17.21L4.53,16.32C5.68,18.76 8.59,20 12,20C15.41,20 18.32,18.76 19.47,16.32L20.92,17.21L21.39,16.32L19.82,15.38L19.96,14.67L21.72,14.93L21.93,13.95L20,13.66C19.93,12.67 19.59,12.24 19.04,11.41C20.97,7.46 19,4.5 19,4.5C16.6,4.5 14.19,7.07 13.33,8.09L12,8M9,11C9.55,11 10,11.45 10,12C10,12.55 9.55,13 9,13C8.45,13 8,12.55 8,12C8,11.45 8.45,11 9,11M15,11C15.55,11 16,11.45 16,12C16,12.55 15.55,13 15,13C14.45,13 14,12.55 14,12C14,11.45 14.45,11 15,11M11,14H13L12.3,15.39C12.5,16.03 13.06,16.5 13.75,16.5C14.58,16.5 15.25,15.83 15.25,15H15.75C15.75,16.1 14.85,17 13.75,17C13,17 12.35,16.59 12,16V16H12C11.65,16.59 11,17 10.25,17C9.15,17 8.25,16.1 8.25,15H8.75C8.75,15.83 9.42,16.5 10.25,16.5C10.94,16.5 11.5,16.03 11.7,15.39L11,14Z",
  },
  {
    id: "04FF8A0D-0B5F-426B-ABAF-001EAC16559F",
    name: "cctv",
    codepoint: "F7AD",
    aliases: ["closed-circuit-television", "security-camera"],
    tags: ["Home Automation"],
    author: "Roberto Graham",
    version: "2.0.46",
    path: "M18.15,4.94C17.77,4.91 17.37,5 17,5.2L8.35,10.2C7.39,10.76 7.07,12 7.62,12.94L9.12,15.53C9.67,16.5 10.89,16.82 11.85,16.27L13.65,15.23C13.92,15.69 14.32,16.06 14.81,16.27V18.04C14.81,19.13 15.7,20 16.81,20H22V18.04H16.81V16.27C17.72,15.87 18.31,14.97 18.31,14C18.31,13.54 18.19,13.11 17.97,12.73L20.5,11.27C21.47,10.71 21.8,9.5 21.24,8.53L19.74,5.94C19.4,5.34 18.79,5 18.15,4.94M6.22,13.17L2,13.87L2.75,15.17L4.75,18.63L5.5,19.93L8.22,16.63L6.22,13.17Z",
  },
  {
    id: "C45A21A3-671C-4B1A-B405-D625ECA93C11",
    name: "ceiling-light",
    codepoint: "F768",
    aliases: [],
    tags: ["Home Automation"],
    author: "GreenTurtwig",
    version: "1.9.32",
    path: "M8,9H11V4H13V9H16L20,17H4L8,9M14,18C14,19.1 13.1,20 12,20C10.9,20 10,19.1 10,18H14Z",
  },
  {
    id: "8898488F-1BE6-40A0-84B7-1C0832AA4754",
    name: "cellphone",
    codepoint: "F11C",
    aliases: [
      "mobile-phone",
      "smartphone",
      "stay-current-portrait",
      "stay-primary-portrait",
    ],
    tags: ["Cellphone / Phone", "Device / Tech"],
    author: "Google",
    version: "1.5.54",
    path: "M17,19H7V5H17M17,1H7C5.89,1 5,1.89 5,3V21C5,22.1 5.9,23 7,23H17C18.1,23 19,22.1 19,21V3C19,1.89 18.1,1 17,1Z",
  },
  {
    id: "C633DDA7-FB93-4041-98C2-92117B970114",
    name: "cellphone-android",
    codepoint: "F11D",
    aliases: ["mobile-phone-android", "smartphone-android"],
    tags: ["Cellphone / Phone", "Device / Tech"],
    author: "Google",
    version: "1.5.54",
    path: "M17.25,18H6.75V4H17.25M14,21H10V20H14M16,1H8C6.34,1 5,2.34 5,4V20C5,21.66 6.34,23 8,23H16C17.66,23 19,21.66 19,20V4C19,2.34 17.66,1 16,1Z",
  },
  {
    id: "04D5C9C6-6CE4-4D2E-A759-07933F9B7932",
    name: "cellphone-arrow-down",
    codepoint: "F9D4",
    aliases: [
      "cellphone-system-update",
      "mobile-phone-arrow-down",
      "smartphone-arrow-down",
    ],
    tags: ["Cellphone / Phone"],
    author: "Google",
    version: "2.5.94",
    path: "M17,1H7C5.9,1 5,1.9 5,3V21C5,22.1 5.9,23 7,23H17C18.1,23 19,22.1 19,21V3C19,1.9 18.1,1 17,1M17,19H7V5H17V19M16,13H13V8H11V13H8L12,17L16,13Z",
  },
  {
    id: "E22A55C0-983F-499E-8B43-4A66DB278B4E",
    name: "cellphone-basic",
    codepoint: "F11E",
    aliases: ["mobile-phone-basic"],
    tags: ["Cellphone / Phone"],
    author: "Cody",
    version: "1.5.54",
    path: "M15,2C14.45,2 14,2.45 14,3V6H10C8.89,6 8,6.89 8,8V20C8,21.11 8.89,22 10,22H15C16.11,22 17,21.11 17,20V8C17,7.26 16.6,6.62 16,6.28V3C16,2.45 15.55,2 15,2M10,8H15V13H10V8M10,15H11V16H10V15M12,15H13V16H12V15M14,15H15V16H14V15M10,17H11V18H10V17M12,17H13V18H12V17M14,17H15V18H14V17M10,19H11V20H10V19M12,19H13V20H12V19M14,19H15V20H14V19Z",
  },
  {
    id: "4FBBF196-CF97-436B-A3E6-A08D695E6986",
    name: "cellphone-dock",
    codepoint: "F11F",
    aliases: ["mobile-phone-dock", "smartphone-dock"],
    tags: ["Cellphone / Phone"],
    author: "Google",
    version: "1.5.54",
    path: "M16,15H8V5H16M16,1H8C6.89,1 6,1.89 6,3V17C6,18.1 6.9,19 8,19H16C17.1,19 18,18.1 18,17V3C18,1.89 17.1,1 16,1M8,23H16V21H8V23Z",
  },
  {
    id: "EC642A5A-34A2-4E29-85F1-60ACAA546FB1",
    name: "cellphone-erase",
    codepoint: "F94C",
    aliases: ["phonelink-erase", "mobile-phone-erase", "smartphone-erase"],
    tags: ["Cellphone / Phone"],
    author: "Google",
    version: "2.4.85",
    path: "M11,8.2L10,7.2L6,11.2L2,7.2L1,8.2L5,12.2L1,16.2L2,17.2L6,13.2L10,17.2L11,16.2L7,12.2L11,8.2M17,1H7C5.9,1 5,1.9 5,3V6H7V4H17V20H7V18H5V21C5,22.1 5.9,23 7,23H17C18.1,23 19,22.1 19,21V3C19,1.9 18.1,1 17,1Z",
  },
  {
    id: "8B1B6ED1-8AA5-4888-8477-B122FB236E1D",
    name: "cellphone-iphone",
    codepoint: "F120",
    aliases: ["mobile-phone-iphone", "smartphone-iphone"],
    tags: ["Cellphone / Phone", "Device / Tech"],
    author: "Google",
    version: "1.5.54",
    path: "M16,18H7V4H16M11.5,22C10.67,22 10,21.33 10,20.5C10,19.67 10.67,19 11.5,19C12.33,19 13,19.67 13,20.5C13,21.33 12.33,22 11.5,22M15.5,1H7.5C6.12,1 5,2.12 5,3.5V20.5C5,21.88 6.12,23 7.5,23H15.5C16.88,23 18,21.88 18,20.5V3.5C18,2.12 16.88,1 15.5,1Z",
  },
  {
    id: "29BA2DA3-CED6-4D52-92EF-D9152F63B7AB",
    name: "cellphone-key",
    codepoint: "F94D",
    aliases: ["mobile-phone-key", "smartphone-key"],
    tags: ["Cellphone / Phone"],
    author: "GreenTurtwig",
    version: "2.4.85",
    path: "M7,1C5.9,1 5,1.9 5,3V7H7V4H17V20H7V17H5V21C5,22.1 5.9,23 7,23H17C18.1,23 19,22.1 19,21V3C19,1.9 18.1,1 17,1H7M6,9C4.34,9 3,10.34 3,12C3,13.66 4.34,15 6,15C7.31,15 8.42,14.17 8.83,13H11V15H13V13H14V11H8.83C8.42,9.83 7.31,9 6,9M6,11C6.55,11 7,11.45 7,12C7,12.55 6.55,13 6,13C5.45,13 5,12.55 5,12C5,11.45 5.45,11 6,11Z",
  },
  {
    id: "E29A590D-51B8-471B-B23B-E0A41046EDA6",
    name: "cellphone-link",
    codepoint: "F121",
    aliases: ["mobile-phone-link", "smartphone-link", "devices"],
    tags: ["Cellphone / Phone"],
    author: "Google",
    version: "1.5.54",
    path: "M22,17H18V10H22M23,8H17C16.45,8 16,8.45 16,9V19C16,19.55 16.45,20 17,20H23C23.55,20 24,19.55 24,19V9C24,8.45 23.55,8 23,8M4,6H22V4H4C2.9,4 2,4.9 2,6V17H0V20H14V17H4V6Z",
  },
  {
    id: "7E4265ED-151D-45CE-BDD2-08B6028B6006",
    name: "cellphone-link-off",
    codepoint: "F122",
    aliases: ["mobile-phone-link-off", "smartphone-link-off", "phonelink-off"],
    tags: ["Cellphone / Phone"],
    author: "Google",
    version: "1.5.54",
    path: "M23,8H17C16.45,8 16,8.45 16,9V13.18L18,15.18V10H22V17H19.82L22.82,20H23C23.55,20 24,19.55 24,19V9C24,8.45 23.55,8 23,8M4,6.27L14.73,17H4V6.27M1.92,1.65L0.65,2.92L2.47,4.74C2.18,5.08 2,5.5 2,6V17H0V20H17.73L20.08,22.35L21.35,21.08L3.89,3.62L1.92,1.65M22,6V4H6.82L8.82,6H22Z",
  },
  {
    id: "2261E999-4B3A-4540-BB30-B4C130137916",
    name: "cellphone-lock",
    codepoint: "F94E",
    aliases: ["phonelink-lock", "mobile-phone-lock", "smartphone-lock"],
    tags: ["Cellphone / Phone"],
    author: "Google",
    version: "2.4.85",
    path: "M17,1H7C5.9,1 5,1.9 5,3V6H7V4H17V20H7V18H5V21C5,22.1 5.9,23 7,23H17C18.1,23 19,22.1 19,21V3C19,1.9 18.1,1 17,1M8.8,11V9.5C8.8,8.1 7.4,7 6,7C4.6,7 3.2,8.1 3.2,9.5V11C2.6,11 2,11.6 2,12.2V15.7C2,16.4 2.6,17 3.2,17H8.7C9.4,17 10,16.4 10,15.8V12.3C10,11.6 9.4,11 8.8,11M7.5,11H4.5V9.5C4.5,8.7 5.2,8.2 6,8.2C6.8,8.2 7.5,8.7 7.5,9.5V11Z",
  },
  {
    id: "4C511E7E-D658-493D-B34B-B73A4DEE8FF9",
    name: "cellphone-message",
    codepoint: "F8D2",
    aliases: ["mobile-phone-message", "smartphone-message"],
    tags: ["Cellphone / Phone"],
    author: "Austin Andrews",
    version: "2.3.50",
    path: "M11,17V7H4V17H11M11,3C12.1,3 13,3.9 13,5V19C13,20.1 12.1,21 11,21H4C2.89,21 2,20.1 2,19V5C2,3.9 2.9,3 4,3H11M16.5,3H21.5C22.33,3 23,3.67 23,4.5V7.5C23,8.33 22.33,9 21.5,9H18L15,12V9L15,4.5C15,3.67 15.67,3 16.5,3Z",
  },
  {
    id: "2AD1736A-2142-4E3D-BA70-9CF8584C366D",
    name: "cellphone-off",
    codepoint: "F94F",
    aliases: ["mobile-phone-off", "smartphone-off", "mobile-off"],
    tags: ["Cellphone / Phone"],
    author: "Google",
    version: "2.4.85",
    path: "M2.38,1.73L1.11,3L5,6.89V21C5,22.1 5.9,23 7,23H17C18.1,23 19,22.1 19,21V20.89L20.84,22.73L22.11,21.46M17,19H7V8.89L17,18.89V19M17,5V13.8L19,15.8V3C19,1.9 18.1,1 17,1H7C6.28,1 5.6,1.37 5.24,2L8.24,5H17Z",
  },
  {
    id: "F5D685BD-7BA8-4F4C-8701-06F1B1E57064",
    name: "cellphone-sound",
    codepoint: "F951",
    aliases: ["phonelink-ring", "mobile-phone-sound", "smartphone-sound"],
    tags: ["Cellphone / Phone"],
    author: "Google",
    version: "2.4.85",
    path: "M19.1,8.7C20.9,10.5 20.9,13.3 19.1,15.2L20.1,16.2C22.6,13.9 22.6,10.1 20.1,7.7L19.1,8.7M18,9.8L17,10.8C17.5,11.5 17.5,12.4 17,13.1L18,14.1C19.2,12.9 19.2,11.1 18,9.8M14,1H4C2.9,1 2,1.9 2,3V21C2,22.1 2.9,23 4,23H14C15.1,23 16,22.1 16,21V3C16,1.9 15.1,1 14,1M14,20H4V4H14V20Z",
  },
  {
    id: "D89FFCD9-0592-4760-98C9-5EDDA77826F5",
    name: "cellphone-text",
    codepoint: "F8D1",
    aliases: ["mobile-phone-text", "smartphone-text"],
    tags: ["Cellphone / Phone"],
    author: "Austin Andrews",
    version: "2.3.50",
    path: "M17,19V5H7V19H17M17,1C18.1,1 19,1.9 19,3V21C19,22.1 18.1,23 17,23H7C5.89,23 5,22.1 5,21V3C5,1.89 5.89,1 7,1H17M9,7H15V9H9V7M9,11H13V13H9V11Z",
  },
  {
    id: "071CA76A-0ED5-42CD-9BE9-46AFA9D5459E",
    name: "cellphone-wireless",
    codepoint: "F814",
    aliases: ["mobile-phone-wireless", "smartphone-wireless"],
    tags: ["Cellphone / Phone"],
    author: "Contributors",
    version: "2.1.19",
    path: "M20.07,4.93C21.88,6.74 23,9.24 23,12C23,14.76 21.88,17.26 20.07,19.07L18.66,17.66C20.11,16.22 21,14.22 21,12C21,9.79 20.11,7.78 18.66,6.34L20.07,4.93M17.24,7.76C18.33,8.85 19,10.35 19,12C19,13.65 18.33,15.15 17.24,16.24L15.83,14.83C16.55,14.11 17,13.11 17,12C17,10.89 16.55,9.89 15.83,9.17L17.24,7.76M13,10C14.1,10 15,10.9 15,12C15,13.1 14.1,14 13,14C11.9,14 11,13.1 11,12C11,10.9 11.9,10 13,10M11.5,1C12.88,1 14,2.12 14,3.5V8H12V4H3V19H12V16H14V20.5C14,21.88 12.88,23 11.5,23H3.5C2.12,23 1,21.88 1,20.5V3.5C1,2.12 2.12,1 3.5,1H11.5Z",
  },
  {
    id: "2DBEB397-D80B-445D-A11E-7B8362CFBEF4",
    name: "certificate",
    codepoint: "F124",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M4,3C2.89,3 2,3.89 2,5V15C2,16.1 2.9,17 4,17H12V22L15,19L18,22V17H20C21.1,17 22,16.1 22,15V8L22,6V5C22,3.9 21.1,3 20,3H16V3H4M12,5L15,7L18,5V8.5L21,10L18,11.5V15L15,13L12,15V11.5L9,10L12,8.5V5M4,5H9V7H4V5M4,9H7V11H4V9M4,13H9V15H4V13Z",
  },
  {
    id: "47FCC651-522C-4786-B518-91A03A721A90",
    name: "chair-school",
    codepoint: "F125",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M22,5V7H17L13.53,12H16V14H14.46L18.17,22H15.97L15.04,20H6.38L5.35,22H3.1L7.23,14H7C6.55,14 6.17,13.7 6.04,13.3L2.87,3.84L3.82,3.5C4.34,3.34 4.91,3.63 5.08,4.15L7.72,12H12.1L15.57,7H12V5H22M9.5,14L7.42,18H14.11L12.26,14H9.5Z",
  },
  {
    id: "98939E5B-1528-4A2F-B35A-C37C60C75D93",
    name: "chart-arc",
    codepoint: "F126",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M16.18,19.6L14.17,16.12C15.15,15.4 15.83,14.28 15.97,13H20C19.83,15.76 18.35,18.16 16.18,19.6M13,7.03V3C17.3,3.26 20.74,6.7 21,11H16.97C16.74,8.91 15.09,7.26 13,7.03M7,12.5C7,13.14 7.13,13.75 7.38,14.3L3.9,16.31C3.32,15.16 3,13.87 3,12.5C3,7.97 6.54,4.27 11,4V8.03C8.75,8.28 7,10.18 7,12.5M11.5,21C8.53,21 5.92,19.5 4.4,17.18L7.88,15.17C8.7,16.28 10,17 11.5,17C12.14,17 12.75,16.87 13.3,16.62L15.31,20.1C14.16,20.68 12.87,21 11.5,21Z",
  },
  {
    id: "00654F5E-1B8B-4BD7-933B-0BD65B2C9BAC",
    name: "chart-areaspline",
    codepoint: "F127",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M17.45,15.18L22,7.31V19L22,21H2V3H4V15.54L9.5,6L16,9.78L20.24,2.45L21.97,3.45L16.74,12.5L10.23,8.75L4.31,19H6.57L10.96,11.44L17.45,15.18Z",
  },
  {
    id: "85D4DC49-5359-4867-A5D1-52C44699387F",
    name: "chart-bar",
    codepoint: "F128",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M22,21H2V3H4V19H6V10H10V19H12V6H16V19H18V14H22V21Z",
  },
  {
    id: "FAA40519-5517-44DF-AF2E-30D07874BEB7",
    name: "chart-bar-stacked",
    codepoint: "F769",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M22,21H2V3H4V19H6V17H10V19H12V16H16V19H18V17H22V21M18,14H22V16H18V14M12,6H16V9H12V6M16,15H12V10H16V15M6,10H10V12H6V10M10,16H6V13H10V16Z",
  },
  {
    id: "9D79A433-CF5A-45A2-971F-4FBF72DB9821",
    name: "chart-bubble",
    codepoint: "F5E3",
    aliases: ["bubble-chart"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M7.2,11.2C8.97,11.2 10.4,12.63 10.4,14.4C10.4,16.17 8.97,17.6 7.2,17.6C5.43,17.6 4,16.17 4,14.4C4,12.63 5.43,11.2 7.2,11.2M14.8,16C15.9,16 16.8,16.9 16.8,18C16.8,19.1 15.9,20 14.8,20C13.7,20 12.8,19.1 12.8,18C12.8,16.9 13.7,16 14.8,16M15.2,4C17.85,4 20,6.15 20,8.8C20,11.45 17.85,13.6 15.2,13.6C12.55,13.6 10.4,11.45 10.4,8.8C10.4,6.15 12.55,4 15.2,4Z",
  },
  {
    id: "C7BED6AB-8D91-42EC-A22F-D4B922B0EB14",
    name: "chart-donut",
    codepoint: "F7AE",
    aliases: ["chart-doughnut", "data-usage"],
    tags: [],
    author: "Google",
    version: "2.0.46",
    path: "M13,2.05V5.08C16.39,5.57 19,8.47 19,12C19,12.9 18.82,13.75 18.5,14.54L21.12,16.07C21.68,14.83 22,13.45 22,12C22,6.82 18.05,2.55 13,2.05M12,19C8.13,19 5,15.87 5,12C5,8.47 7.61,5.57 11,5.08V2.05C5.94,2.55 2,6.81 2,12C2,17.52 6.48,22 12,22C15.3,22 18.23,20.39 20.05,17.91L17.45,16.38C16.17,18 14.21,19 12,19Z",
  },
  {
    id: "FE9CBE2A-4D6F-4A1F-B817-26607BB9561B",
    name: "chart-donut-variant",
    codepoint: "F7AF",
    aliases: ["chart-doughnut-variant"],
    tags: [],
    author: "Austin Andrews",
    version: "2.0.46",
    path: "M13,2.05C18.05,2.55 22,6.82 22,12C22,13.45 21.68,14.83 21.12,16.07L18.5,14.54C18.82,13.75 19,12.9 19,12C19,8.47 16.39,5.57 13,5.08V2.05M12,19C14.21,19 16.17,18 17.45,16.38L20.05,17.91C18.23,20.39 15.3,22 12,22C6.47,22 2,17.5 2,12C2,6.81 5.94,2.55 11,2.05V5.08C7.61,5.57 5,8.47 5,12C5,15.87 8.13,19 12,19M12,6C15.31,6 18,8.69 18,12C18,14.97 15.84,17.44 13,17.92V14.83C14.17,14.42 15,13.31 15,12C15,10.34 13.66,9 12,9L11.45,9.05L9.91,6.38C10.56,6.13 11.26,6 12,6M6,12C6,10.14 6.85,8.5 8.18,7.38L9.72,10.05C9.27,10.57 9,11.26 9,12C9,13.31 9.83,14.42 11,14.83V17.92C8.16,17.44 6,14.97 6,12Z",
  },
  {
    id: "A2839B3A-760A-4061-80CA-41B3FA5817E0",
    name: "chart-gantt",
    codepoint: "F66C",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.6.50",
    path: "M2,5H10V2H12V22H10V18H6V15H10V13H4V10H10V8H2V5M14,5H17V8H14V5M14,10H19V13H14V10M14,15H22V18H14V15Z",
  },
  {
    id: "8DCC14D7-057F-4DA4-89B2-B26D6B6F0C00",
    name: "chart-histogram",
    codepoint: "F129",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M3,3H5V13H9V7H13V11H17V15H21V21H3V3Z",
  },
  {
    id: "D996574D-5B42-47C5-91D6-F86555C2FBC5",
    name: "chart-line",
    codepoint: "F12A",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M16,11.78L20.24,4.45L21.97,5.45L16.74,14.5L10.23,10.75L5.46,19H22V21H2V3H4V17.54L9.5,8L16,11.78Z",
  },
  {
    id: "B53C0CF7-F923-409F-91C3-420513E44231",
    name: "chart-line-stacked",
    codepoint: "F76A",
    aliases: [],
    tags: [],
    author: "JapanYoshi",
    version: "1.9.32",
    path: "M17.45,15.18L22,6.81V19L22,21H2V3H4V15.54L4,19H4.31L6,19H6.57L10.96,11.44L17.45,15.18M22,3L21.97,3.45L17,11L10,6L6,12V3H22Z",
  },
  {
    id: "2FAF8E0B-5AB4-4914-A0A1-CECFFAF85427",
    name: "chart-line-variant",
    codepoint: "F7B0",
    aliases: ["show-chart"],
    tags: [],
    author: "Google",
    version: "2.0.46",
    path: "M3.5,18.5L9.5,12.5L13.5,16.5L22,6.92L20.59,5.5L13.5,13.5L9.5,9.5L2,17L3.5,18.5Z",
  },
  {
    id: "746FB7AE-B8AC-4356-8B79-D95F54B410D7",
    name: "chart-multiline",
    codepoint: "F8D3",
    aliases: [],
    tags: [],
    author: "Google",
    version: "2.3.50",
    path: "M22,6.92L20.59,5.5L17.74,8.72C15.68,6.4 12.83,5 9.61,5C6.72,5 4.07,6.16 2,8L3.42,9.42C5.12,7.93 7.27,7 9.61,7C12.35,7 14.7,8.26 16.38,10.24L13.5,13.5L9.5,9.5L2,17L3.5,18.5L9.5,12.5L13.5,16.5L17.55,11.93C18.3,13.28 18.8,14.83 19,16.5H21C20.78,14.18 20.05,12.09 18.96,10.34L22,6.92Z",
  },
  {
    id: "9C6B53C5-698B-4428-9738-A6700BF8698C",
    name: "chart-pie",
    codepoint: "F12B",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M21,11H13V3C17.42,3 21,6.58 21,11M19,13C19,15.78 17.58,18.23 15.43,19.67L11.58,13H19M11,21C8.22,21 5.77,19.58 4.33,17.43L10.82,13.68L14.56,20.17C13.5,20.7 12.28,21 11,21M3,13C3,8.58 6.58,5 11,5V12.42L3.83,16.56C3.3,15.5 3,14.28 3,13Z",
  },
  {
    id: "922A0C03-C46D-45E7-8B44-9D53F1292360",
    name: "chart-timeline",
    codepoint: "F66E",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.6.50",
    path: "M2,2H4V20H22V22H2V2M7,10H17V13H7V10M11,15H21V18H11V15M6,4H22V8H20V6H8V8H6V4Z",
  },
  {
    id: "F789CE44-7EA3-4E97-88FB-BEC22EB2030C",
    name: "check",
    codepoint: "F12C",
    aliases: ["tick", "done"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z",
  },
  {
    id: "48BA3B7B-1EF7-4160-A0BB-54EBCF999A13",
    name: "check-all",
    codepoint: "F12D",
    aliases: ["tick-all", "done-all", "check-multiple"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M0.41,13.41L6,19L7.41,17.58L1.83,12M22.24,5.58L11.66,16.17L7.5,12L6.07,13.41L11.66,19L23.66,7M18,7L16.59,5.58L10.24,11.93L11.66,13.34L18,7Z",
  },
  {
    id: "93D7B6DC-17D2-4A2B-B787-79E2E8BEF304",
    name: "check-circle",
    codepoint: "F5E0",
    aliases: ["tick-circle"],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M11,16.5L18,9.5L16.59,8.09L11,13.67L7.91,10.59L6.5,12L11,16.5Z",
  },
  {
    id: "F609EE7E-AAB4-4CE7-A002-D0F7ECF89609",
    name: "check-circle-outline",
    codepoint: "F5E1",
    aliases: ["tick-circle-outline"],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M12,4C7.58,4 4,7.58 4,12C4,16.42 7.58,20 12,20C16.42,20 20,16.42 20,12C20,7.58 16.42,4 12,4M11,16.5L6.5,12L7.91,10.59L11,13.67L16.59,8.09L18,9.5L11,16.5Z",
  },
  {
    id: "38BFE155-0352-4907-A578-B5D0D7F5B78D",
    name: "check-outline",
    codepoint: "F854",
    aliases: ["done-outline", "tick-outline"],
    tags: [],
    author: "Google",
    version: "2.1.99",
    path: "M19.78,2.2L24,6.42L8.44,22L0,13.55L4.22,9.33L8.44,13.55L19.78,2.2M19.78,5L8.44,16.36L4.22,12.19L2.81,13.55L8.44,19.17L21.19,6.42L19.78,5Z",
  },
  {
    id: "2B75FE22-5209-4DF8-B16A-B6F74272337B",
    name: "checkbox-blank",
    codepoint: "F12E",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3Z",
  },
  {
    id: "F031DE59-CC30-47BF-B689-BC993893B03A",
    name: "checkbox-blank-circle",
    codepoint: "F12F",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z",
  },
  {
    id: "7C094780-770D-44B6-981C-C701784192D6",
    name: "checkbox-blank-circle-outline",
    codepoint: "F130",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z",
  },
  {
    id: "C7D0E43D-6393-429B-BDCE-B522419B7B3D",
    name: "checkbox-blank-outline",
    codepoint: "F131",
    aliases: ["check-box-outline-blank"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3M19,5V19H5V5H19Z",
  },
  {
    id: "EFD12742-D508-4531-A9A4-EDCF3148C748",
    name: "checkbox-intermediate",
    codepoint: "F855",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.1.99",
    path: "M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3M19,19H5V5H19V19M17,17H7V7H17V17Z",
  },
  {
    id: "C3E50D88-07AB-491F-B21E-9AA11A1E5886",
    name: "checkbox-marked",
    codepoint: "F132",
    aliases: ["check-box"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M10,17L5,12L6.41,10.58L10,14.17L17.59,6.58L19,8M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3Z",
  },
  {
    id: "4336ADDD-7A8E-46E7-A886-3873CCCFD3DA",
    name: "checkbox-marked-circle",
    codepoint: "F133",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M10,17L5,12L6.41,10.58L10,14.17L17.59,6.58L19,8M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z",
  },
  {
    id: "7DC53566-5640-4124-A2C2-5070D7FBA591",
    name: "checkbox-marked-circle-outline",
    codepoint: "F134",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M20,12C20,16.42 16.42,20 12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C12.76,4 13.5,4.11 14.2,4.31L15.77,2.74C14.61,2.26 13.34,2 12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z",
  },
  {
    id: "AB384DA7-C0DA-4A68-96EA-FC54BF0EDED1",
    name: "checkbox-marked-outline",
    codepoint: "F135",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M19,19H5V5H15V3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V11H19M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z",
  },
  {
    id: "2B01AE9D-AFA4-4CDA-82BD-21076D27C006",
    name: "checkbox-multiple-blank",
    codepoint: "F136",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M22,16C22,17.1 21.1,18 20,18H8C6.89,18 6,17.1 6,16V4C6,2.89 6.89,2 8,2H20C21.1,2 22,2.9 22,4V16M16,20V22H4C2.9,22 2,21.1 2,20V7H4V20H16Z",
  },
  {
    id: "0AE5C836-2A43-4706-81C5-5053A73B9CAA",
    name: "checkbox-multiple-blank-circle",
    codepoint: "F63B",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.6.50",
    path: "M14,2C9.58,2 6,5.58 6,10C6,14.42 9.58,18 14,18C18.42,18 22,14.42 22,10C22,5.58 18.42,2 14,2M4.93,5.82C3.08,7.34 2,9.61 2,12C2,16.42 5.58,20 10,20C10.64,20 11.27,19.92 11.88,19.77C10.12,19.38 8.5,18.5 7.17,17.29C5.22,16.25 4,14.21 4,12C4,11.7 4.03,11.41 4.07,11.11C4.03,10.74 4,10.37 4,10C4,8.56 4.32,7.13 4.93,5.82Z",
  },
  {
    id: "CCBAD6F8-5D3D-420A-94AF-CC85AA12397E",
    name: "checkbox-multiple-blank-circle-outline",
    codepoint: "F63C",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.6.50",
    path: "M14,2C9.58,2 6,5.58 6,10C6,14.42 9.58,18 14,18C18.42,18 22,14.42 22,10C22,5.58 18.42,2 14,2M14,4C17.32,4 20,6.69 20,10C20,13.32 17.32,16 14,16C10.69,16 8,13.31 8,10C8,6.69 10.69,4 14,4M4.93,5.82C3.08,7.34 2,9.61 2,12C2,16.42 5.58,20 10,20C10.64,20 11.27,19.92 11.88,19.77C10.12,19.38 8.5,18.5 7.17,17.29C5.22,16.25 4,14.21 4,12C4,11.7 4.03,11.41 4.07,11.11C4.03,10.74 4,10.37 4,10C4,8.56 4.32,7.13 4.93,5.82Z",
  },
  {
    id: "CA74F33C-3AEE-4EA9-93B4-643099DFD92D",
    name: "checkbox-multiple-blank-outline",
    codepoint: "F137",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M20,16V4H8V16H20M22,16C22,17.1 21.1,18 20,18H8C6.89,18 6,17.1 6,16V4C6,2.89 6.89,2 8,2H20C21.1,2 22,2.9 22,4V16M16,20V22H4C2.9,22 2,21.1 2,20V7H4V20H16Z",
  },
  {
    id: "4F160BFE-433B-49D1-B2DC-E7F71AF7070B",
    name: "checkbox-multiple-marked",
    codepoint: "F138",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M22,16C22,17.1 21.1,18 20,18H8C6.89,18 6,17.1 6,16V4C6,2.89 6.89,2 8,2H20C21.1,2 22,2.9 22,4V16M16,20V22H4C2.9,22 2,21.1 2,20V7H4V20H16M13,14L20,7L18.59,5.59L13,11.17L9.91,8.09L8.5,9.5L13,14Z",
  },
  {
    id: "85C35F15-1AC0-407B-BCBF-AD79B6E6DDEA",
    name: "checkbox-multiple-marked-circle",
    codepoint: "F63D",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.6.50",
    path: "M14,2C9.58,2 6,5.58 6,10C6,14.42 9.58,18 14,18C18.42,18 22,14.42 22,10C22,5.58 18.42,2 14,2M4.93,5.82C3.08,7.34 2,9.61 2,12C2,16.42 5.58,20 10,20C10.64,20 11.27,19.92 11.88,19.77C10.12,19.38 8.5,18.5 7.17,17.29C5.22,16.25 4,14.21 4,12C4,11.7 4.03,11.41 4.07,11.11C4.03,10.74 4,10.37 4,10C4,8.56 4.32,7.13 4.93,5.82M18.09,6.08L19.5,7.5L13,14L9.21,10.21L10.63,8.79L13,11.17",
  },
  {
    id: "5158D0E3-0E77-4CC3-A9A4-727825812D00",
    name: "checkbox-multiple-marked-circle-outline",
    codepoint: "F63E",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.6.50",
    path: "M14,2C9.58,2 6,5.58 6,10C6,14.42 9.58,18 14,18C18.42,18 22,14.42 22,10H20C20,13.32 17.32,16 14,16C10.69,16 8,13.31 8,10C8,6.69 10.69,4 14,4C14.43,4 14.86,4.05 15.27,4.14L16.88,2.54C15.96,2.18 15,2 14,2M20.59,3.58L14,10.17L11.62,7.79L10.21,9.21L14,13L22,5M4.93,5.82C3.08,7.34 2,9.61 2,12C2,16.42 5.58,20 10,20C10.64,20 11.27,19.92 11.88,19.77C10.12,19.38 8.5,18.5 7.17,17.29C5.22,16.25 4,14.21 4,12C4,11.7 4.03,11.41 4.07,11.11C4.03,10.74 4,10.37 4,10C4,8.56 4.32,7.13 4.93,5.82Z",
  },
  {
    id: "16BECBE7-BD8E-4301-B5CB-5EE534FBDAD3",
    name: "checkbox-multiple-marked-outline",
    codepoint: "F139",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M20,16V10H22V16C22,17.1 21.1,18 20,18H8C6.89,18 6,17.1 6,16V4C6,2.89 6.89,2 8,2H16V4H8V16H20M10.91,7.08L14,10.17L20.59,3.58L22,5L14,13L9.5,8.5L10.91,7.08M16,20V22H4C2.9,22 2,21.1 2,20V7H4V20H16Z",
  },
  {
    id: "A5F7D4AF-C7A3-4F38-B21B-B9F3E68770DE",
    name: "checkerboard",
    codepoint: "F13A",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M3,3H21V21H3V3M5,5V12H12V19H19V12H12V5H5Z",
  },
  {
    id: "7916D1CB-2F73-4C27-8A6B-B14D593F8F59",
    name: "chemical-weapon",
    codepoint: "F13B",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M11,7.83C9.83,7.42 9,6.3 9,5C9,3.34 10.34,2 12,2C13.66,2 15,3.34 15,5C15,6.31 14.16,7.42 13,7.83V10.64C12.68,10.55 12.35,10.5 12,10.5C11.65,10.5 11.32,10.55 11,10.64V7.83M18.3,21.1C17.16,20.45 16.62,19.18 16.84,17.96L14.4,16.55C14.88,16.09 15.24,15.5 15.4,14.82L17.84,16.23C18.78,15.42 20.16,15.26 21.29,15.91C22.73,16.74 23.22,18.57 22.39,20C21.56,21.44 19.73,21.93 18.3,21.1M2.7,15.9C3.83,15.25 5.21,15.42 6.15,16.22L8.6,14.81C8.76,15.5 9.11,16.08 9.6,16.54L7.15,17.95C7.38,19.17 6.83,20.45 5.7,21.1C4.26,21.93 2.43,21.44 1.6,20C0.77,18.57 1.26,16.73 2.7,15.9M14,14C14,15.1 13.1,16 12,16C10.89,16 10,15.1 10,14C10,12.9 10.9,12 12,12C13.11,12 14,12.9 14,14M17,14L16.97,14.57L15.5,13.71C15.4,12.64 14.83,11.71 14,11.12V9.41C15.77,10.19 17,11.95 17,14M14.97,18.03C14.14,18.64 13.11,19 12,19C10.89,19 9.86,18.64 9.03,18L10.5,17.17C10.96,17.38 11.47,17.5 12,17.5C12.53,17.5 13.03,17.38 13.5,17.17L14.97,18.03M7.03,14.56L7,14C7,11.95 8.23,10.19 10,9.42V11.13C9.17,11.71 8.6,12.64 8.5,13.7L7.03,14.56Z",
  },
  {
    id: "3B0E25CE-ADB0-4601-BFBD-87C7B6D63E7F",
    name: "chess-bishop",
    codepoint: "F85B",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.1.99",
    path: "M19,22H5V20H19V22M17.16,8.26C18.22,9.63 18.86,11.28 19,13C19,15.76 15.87,18 12,18C8.13,18 5,15.76 5,13C5,10.62 7.33,6.39 10.46,5.27C10.16,4.91 10,4.46 10,4C10,2.9 10.9,2 12,2C13.1,2 14,2.9 14,4C14,4.46 13.84,4.91 13.54,5.27C14.4,5.6 15.18,6.1 15.84,6.74L11.29,11.29L12.71,12.71L17.16,8.26Z",
  },
  {
    id: "073FDF74-5305-45AB-8AC3-42A0FE6BBF9C",
    name: "chess-king",
    codepoint: "F856",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.1.99",
    path: "M19,22H5V20H19V22M17,10C15.58,10 14.26,10.77 13.55,12H13V7H16V5H13V2H11V5H8V7H11V12H10.45C9.35,10.09 6.9,9.43 5,10.54C3.07,11.64 2.42,14.09 3.5,16C4.24,17.24 5.57,18 7,18H17C19.21,18 21,16.21 21,14C21,11.79 19.21,10 17,10Z",
  },
  {
    id: "99D5E230-2040-4811-BEF1-17B867DA5F75",
    name: "chess-knight",
    codepoint: "F857",
    aliases: ["chess-horse"],
    tags: [],
    author: "Michael Richins",
    version: "2.1.99",
    path: "M19,22H5V20H19V22M13,2V2C11.75,2 10.58,2.62 9.89,3.66L7,8L9,10L11.06,8.63C11.5,8.32 12.14,8.44 12.45,8.9C12.47,8.93 12.5,8.96 12.5,9V9C12.8,9.59 12.69,10.3 12.22,10.77L7.42,15.57C6.87,16.13 6.87,17.03 7.43,17.58C7.69,17.84 8.05,18 8.42,18H17V6C17,3.79 15.21,2 13,2Z",
  },
  {
    id: "EDF049A9-1170-411B-923E-D19BD5EADB92",
    name: "chess-pawn",
    codepoint: "F858",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.1.99",
    path: "M19,22H5V20H19V22M16,18L13.2,7.74C14.72,7.07 15.41,5.31 14.74,3.79C14.08,2.27 12.31,1.58 10.79,2.25C9.27,2.91 8.58,4.68 9.25,6.2C9.55,6.89 10.1,7.44 10.79,7.74L8,18H16Z",
  },
  {
    id: "0B9D0593-D546-4DDD-AEB1-289943FB12AE",
    name: "chess-queen",
    codepoint: "F859",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.1.99",
    path: "M18,3C19.1,3 20,3.9 20,5C20,5.81 19.5,6.5 18.83,6.82L17,13.15V18H7V13.15L5.17,6.82C4.5,6.5 4,5.81 4,5C4,3.9 4.9,3 6,3C7.1,3 8,3.9 8,5C8,5.5 7.82,5.95 7.5,6.3L10.3,9.35L10.83,5.62C10.33,5.26 10,4.67 10,4C10,2.9 10.9,2 12,2C13.1,2 14,2.9 14,4C14,4.67 13.67,5.26 13.17,5.62L13.7,9.35L16.47,6.29C16.18,5.94 16,5.5 16,5C16,3.9 16.9,3 18,3M5,20H19V22H5V20Z",
  },
  {
    id: "D1FA251F-4332-4BA9-8742-F194C0B0BF28",
    name: "chess-rook",
    codepoint: "F85A",
    aliases: ["chess-castle"],
    tags: [],
    author: "Michael Richins",
    version: "2.1.99",
    path: "M5,20H19V22H5V20M17,2V5H15V2H13V5H11V2H9V5H7V2H5V8H7V18H17V8H19V2H17Z",
  },
  {
    id: "74ACC301-AA62-492B-92C1-8021BDD89A02",
    name: "chevron-double-down",
    codepoint: "F13C",
    aliases: [],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M16.59,5.59L18,7L12,13L6,7L7.41,5.59L12,10.17L16.59,5.59M16.59,11.59L18,13L12,19L6,13L7.41,11.59L12,16.17L16.59,11.59Z",
  },
  {
    id: "76350FC3-7629-4247-9D09-8AB9AF9BC6CF",
    name: "chevron-double-left",
    codepoint: "F13D",
    aliases: [],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M18.41,7.41L17,6L11,12L17,18L18.41,16.59L13.83,12L18.41,7.41M12.41,7.41L11,6L5,12L11,18L12.41,16.59L7.83,12L12.41,7.41Z",
  },
  {
    id: "E4B5D36C-A663-4D53-BE18-09393497556F",
    name: "chevron-double-right",
    codepoint: "F13E",
    aliases: [],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M5.59,7.41L7,6L13,12L7,18L5.59,16.59L10.17,12L5.59,7.41M11.59,7.41L13,6L19,12L13,18L11.59,16.59L16.17,12L11.59,7.41Z",
  },
  {
    id: "53D302C9-3A0D-4104-967E-21D174E3C0B2",
    name: "chevron-double-up",
    codepoint: "F13F",
    aliases: [],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M7.41,18.41L6,17L12,11L18,17L16.59,18.41L12,13.83L7.41,18.41M7.41,12.41L6,11L12,5L18,11L16.59,12.41L12,7.83L7.41,12.41Z",
  },
  {
    id: "84FE90C1-076D-4EA1-B56F-4C2582A39AC3",
    name: "chevron-down",
    codepoint: "F140",
    aliases: ["expand-more", "keyboard-arrow-down"],
    tags: ["Arrow"],
    author: "Google",
    version: "1.5.54",
    path: "M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z",
  },
  {
    id: "E2EFD734-594F-40ED-A263-3DFBB8E1B381",
    name: "chevron-down-box",
    codepoint: "F9D5",
    aliases: [],
    tags: [],
    author: "Michael Irigoyen",
    version: "2.5.94",
    path: "M19,3H5C3.9,3 3,3.9 3,5V19C3,20.11 3.9,21 5,21H19C20.11,21 21,20.11 21,19V5C21,3.9 20.1,3 19,3M12,15.71L6,9.71L7.41,8.29L12,12.88L16.59,8.29L18,9.71L12,15.71Z",
  },
  {
    id: "D299D24D-E65D-4A1F-953B-0AC936D25C58",
    name: "chevron-down-box-outline",
    codepoint: "F9D6",
    aliases: [],
    tags: [],
    author: "Michael Irigoyen",
    version: "2.5.94",
    path: "M19,3H5C3.9,3 3,3.9 3,5V19C3,20.11 3.9,21 5,21H19C20.11,21 21,20.11 21,19V5C21,3.9 20.1,3 19,3M19,19H5V5H19V19M7.41,8.29L12,12.88L16.59,8.29L18,9.71L12,15.71L6,9.71L7.41,8.29Z",
  },
  {
    id: "CF5607F2-4106-4D47-8FE6-B8F5A16E6D98",
    name: "chevron-left",
    codepoint: "F141",
    aliases: ["keyboard-arrow-left", "navigate-before"],
    tags: ["Arrow"],
    author: "Google",
    version: "1.5.54",
    path: "M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z",
  },
  {
    id: "7DC0F3E7-2E3F-49BD-874D-B17250FBA187",
    name: "chevron-left-box",
    codepoint: "F9D7",
    aliases: [],
    tags: [],
    author: "Michael Irigoyen",
    version: "2.5.94",
    path: "M19,3H5C3.9,3 3,3.9 3,5V19C3,20.11 3.9,21 5,21H19C20.11,21 21,20.11 21,19V5C21,3.9 20.1,3 19,3M15.71,16.59L14.29,18L8.29,12L14.29,6L15.71,7.41L11.12,12L15.71,16.59Z",
  },
  {
    id: "22B3AE2E-C625-4325-8FBE-A98AC004CEE6",
    name: "chevron-left-box-outline",
    codepoint: "F9D8",
    aliases: [],
    tags: [],
    author: "Michael Irigoyen",
    version: "2.5.94",
    path: "M19,3H5C3.9,3 3,3.9 3,5V19C3,20.11 3.9,21 5,21H19C20.11,21 21,20.11 21,19V5C21,3.9 20.1,3 19,3M19,19H5V5H19V19M15.71,7.41L11.12,12L15.71,16.59L14.29,18L8.29,12L14.29,6L15.71,7.41Z",
  },
  {
    id: "A6D25AD4-462B-4185-B739-FBFCD3ACF3C3",
    name: "chevron-right",
    codepoint: "F142",
    aliases: ["keyboard-arrow-right", "navigate-next"],
    tags: ["Arrow"],
    author: "Google",
    version: "1.5.54",
    path: "M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z",
  },
  {
    id: "D9C230F8-C44C-4CE7-8DEF-891A531A1619",
    name: "chevron-right-box",
    codepoint: "F9D9",
    aliases: [],
    tags: [],
    author: "Michael Irigoyen",
    version: "2.5.94",
    path: "M19,3H5C3.9,3 3,3.9 3,5V19C3,20.11 3.9,21 5,21H19C20.11,21 21,20.11 21,19V5C21,3.9 20.1,3 19,3M9.71,18L8.29,16.59L12.88,12L8.29,7.41L9.71,6L15.71,12L9.71,18Z",
  },
  {
    id: "E96D0BE5-31CA-4C47-B91A-B8FB9FCB5D15",
    name: "chevron-right-box-outline",
    codepoint: "F9DA",
    aliases: [],
    tags: [],
    author: "Michael Irigoyen",
    version: "2.5.94",
    path: "M19,3H5C3.9,3 3,3.9 3,5V19C3,20.11 3.9,21 5,21H19C20.11,21 21,20.11 21,19V5C21,3.9 20.1,3 19,3M19,19H5V5H19V19M8.29,16.59L12.88,12L8.29,7.41L9.71,6L15.71,12L9.71,18L8.29,16.59Z",
  },
  {
    id: "AECCC94F-C38A-4A97-879E-ACD09F89169A",
    name: "chevron-up",
    codepoint: "F143",
    aliases: ["expand-less", "keyboard-arrow-up"],
    tags: ["Arrow"],
    author: "Google",
    version: "1.5.54",
    path: "M7.41,15.41L12,10.83L16.59,15.41L18,14L12,8L6,14L7.41,15.41Z",
  },
  {
    id: "C721C684-43CC-4B3B-B91A-A574D5215FF3",
    name: "chevron-up-box",
    codepoint: "F9DB",
    aliases: [],
    tags: [],
    author: "Michael Irigoyen",
    version: "2.5.94",
    path: "M19,3H5C3.9,3 3,3.9 3,5V19C3,20.11 3.9,21 5,21H19C20.11,21 21,20.11 21,19V5C21,3.9 20.1,3 19,3M16.59,15.71L12,11.12L7.41,15.71L6,14.29L12,8.29L18,14.29L16.59,15.71Z",
  },
  {
    id: "7660602A-34FB-4A1A-818B-A086CA1783BD",
    name: "chevron-up-box-outline",
    codepoint: "F9DC",
    aliases: [],
    tags: [],
    author: "Michael Irigoyen",
    version: "2.5.94",
    path: "M19,3H5C3.9,3 3,3.9 3,5V19C3,20.11 3.9,21 5,21H19C20.11,21 21,20.11 21,19V5C21,3.9 20.1,3 19,3M19,19H5V5H19V19M16.59,15.71L12,11.12L7.41,15.71L6,14.29L12,8.29L18,14.29L16.59,15.71Z",
  },
  {
    id: "E868226C-7BE8-4A22-8A9A-8E040004016A",
    name: "chili-hot",
    codepoint: "F7B1",
    aliases: ["chilli-hot"],
    tags: ["Food / Drink"],
    author: "Andy Martinez",
    version: "2.0.46",
    path: "M17.75,9L18.95,8.24C19.58,8.58 20,9.24 20,10V21.75C20,21.75 12,20 12,11V10C12,9.27 12.39,8.63 12.97,8.28L14.43,9L16,8L17.75,9M14,2C15.53,2 16.8,3.15 17,4.64C18,4.93 18.81,5.67 19.22,6.63L17.75,7.5L16,6.5L14.43,7.5L12.76,6.67C13.15,5.72 13.95,5 14.94,4.66C14.8,4.28 14.43,4 14,4V2M10,10C10,18 13.63,19.84 16,21.75C16,21.75 8,20 8,11V10C8,9.27 8.39,8.63 8.97,8.28L10.3,8.94C10.11,9.25 10,9.61 10,10M10.43,7.5L8.76,6.67C9.15,5.72 9.95,5 10.94,4.66C10.8,4.28 10.43,4 10,4V2C10.77,2 11.47,2.29 12,2.76V4C12.43,4 12.8,4.28 12.94,4.66C11.95,5 11.15,5.72 10.43,7.5M6,10C6,18 9.63,19.84 12,21.75C12,21.75 4,20 4,11V10C4,9.27 4.39,8.63 4.97,8.28L6.3,8.94C6.11,9.25 6,9.61 6,10M6.43,7.5L4.76,6.67C5.15,5.72 5.95,5 6.94,4.66C6.8,4.28 6.43,4 6,4V2C6.77,2 7.47,2.29 8,2.76V4C8.43,4 8.8,4.28 8.94,4.66C7.95,5 7.15,5.72 6.43,7.5Z",
  },
  {
    id: "C9DA0BF5-09DD-46A9-AE62-1612B26F0BB1",
    name: "chili-medium",
    codepoint: "F7B2",
    aliases: ["chilli-medium"],
    tags: ["Food / Drink"],
    author: "Andy Martinez",
    version: "2.0.46",
    path: "M15.75,9L16.95,8.24C17.58,8.58 18,9.24 18,10V21.75C18,21.75 10,20 10,11V10C10,9.27 10.39,8.63 10.97,8.28L12.43,9L14,8L15.75,9M12,2C13.53,2 14.8,3.15 15,4.64C16,4.93 16.81,5.67 17.22,6.63L15.75,7.5L14,6.5L12.43,7.5L10.76,6.67C11.15,5.72 11.95,5 12.94,4.66C12.8,4.28 12.43,4 12,4V2M8,10C8,18 11.63,19.84 14,21.75C14,21.75 6,20 6,11V10C6,9.27 6.39,8.63 6.97,8.28L8.3,8.94C8.11,9.25 8,9.61 8,10M8.43,7.5L6.76,6.67C7.15,5.72 7.95,5 8.94,4.66C8.8,4.28 8.43,4 8,4V2C8.77,2 9.47,2.29 10,2.76V4C10.43,4 10.8,4.28 10.94,4.66C9.95,5 9.15,5.72 8.43,7.5Z",
  },
  {
    id: "3CE5B420-F103-47EA-800C-A4D145B89508",
    name: "chili-mild",
    codepoint: "F7B3",
    aliases: ["chilli-mild"],
    tags: ["Food / Drink"],
    author: "Andy Martinez",
    version: "2.0.46",
    path: "M13.75,9L14.95,8.24C15.58,8.58 16,9.24 16,10V21.75C16,21.75 8,20 8,11V10C8,9.27 8.39,8.63 8.97,8.28L10.43,9L12,8L13.75,9M10,2C11.53,2 12.8,3.15 13,4.64C14,4.93 14.81,5.67 15.22,6.63L13.75,7.5L12,6.5L10.43,7.5L8.76,6.67C9.15,5.72 9.95,5 10.94,4.66C10.8,4.28 10.43,4 10,4V2Z",
  },
  {
    id: "A535271B-1114-44AD-9D9D-1984905026FF",
    name: "chip",
    codepoint: "F61A",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.6.50",
    path: "M6,4H18V5H21V7H18V9H21V11H18V13H21V15H18V17H21V19H18V20H6V19H3V17H6V15H3V13H6V11H3V9H6V7H3V5H6V4M11,15V18H12V15H11M13,15V18H14V15H13M15,15V18H16V15H15Z",
  },
  {
    id: "5644CD16-FA4D-4F68-8DAC-996169C778E1",
    name: "christianity",
    codepoint: "F952",
    aliases: ["religion-christian", "cross"],
    tags: ["Religion"],
    author: "Nick",
    version: "2.4.85",
    path: "M10.5,2H13.5V8H19V11H13.5V22H10.5V11H5V8H10.5V2Z",
  },
  {
    id: "82E4FDFE-C9C8-4087-ABCC-DF51F760379A",
    name: "church",
    codepoint: "F144",
    aliases: [],
    tags: ["Religion", "Places"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M11,2H13V4H15V6H13V9.4L22,13V15L20,14.2V22H14V17C14,15.9 13.1,15 12,15C10.9,15 10,15.9 10,17V22H4V14.2L2,15V13L11,9.4V6H9V4H11V2M6,20H8V15L7,14L6,15V20M16,20H18V15L17,14L16,15V20Z",
  },
  {
    id: "59803983-F6CE-4D40-B83C-36D42C9464A9",
    name: "circle",
    codepoint: "F764",
    aliases: ["lens"],
    tags: ["Shape"],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z",
  },
  {
    id: "7C0E615F-A0DC-4689-A094-4E59D27675B3",
    name: "circle-edit-outline",
    codepoint: "F8D4",
    aliases: [],
    tags: [],
    author: "Google",
    version: "2.3.50",
    path: "M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12H20C20,16.42 16.42,20 12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4V2M18.78,3C18.61,3 18.43,3.07 18.3,3.2L17.08,4.41L19.58,6.91L20.8,5.7C21.06,5.44 21.06,5 20.8,4.75L19.25,3.2C19.12,3.07 18.95,3 18.78,3M16.37,5.12L9,12.5V15H11.5L18.87,7.62L16.37,5.12Z",
  },
  {
    id: "AB8D0574-712C-4403-A5A5-51E16C081605",
    name: "circle-medium",
    codepoint: "F9DD",
    aliases: [],
    tags: [],
    author: "Michael Irigoyen",
    version: "2.5.94",
    path: "M12,8C9.79,8 8,9.79 8,12C8,14.21 9.79,16 12,16C14.21,16 16,14.21 16,12C16,9.79 14.21,8 12,8Z",
  },
  {
    id: "00E1BEF8-DD84-4DCE-BE3C-8AA411DCE5FD",
    name: "circle-outline",
    codepoint: "F765",
    aliases: [],
    tags: ["Shape"],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z",
  },
  {
    id: "0EA34D8C-1A02-4A92-8293-991702ABD065",
    name: "circle-small",
    codepoint: "F9DE",
    aliases: [],
    tags: [],
    author: "Michael Irigoyen",
    version: "2.5.94",
    path: "M12,10C10.9,10 10,10.9 10,12C10,13.11 10.9,14 12,14C13.11,14 14,13.11 14,12C14,10.9 13.1,10 12,10Z",
  },
  {
    id: "5A5AC571-1818-45D0-8259-A9177DBED615",
    name: "city",
    codepoint: "F146",
    aliases: ["location-city"],
    tags: ["Places"],
    author: "Google",
    version: "1.5.54",
    path: "M19,15H17V13H19M19,19H17V17H19M13,7H11V5H13M13,11H11V9H13M13,15H11V13H13M13,19H11V17H13M7,11H5V9H7M7,15H5V13H7M7,19H5V17H7M15,11V5L12,2L9,5V7H3V21H21V11H15Z",
  },
  {
    id: "423D4239-D8DC-4D8B-9365-9D51E2A0FDF7",
    name: "clipboard",
    codepoint: "F147",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3M12,3C12.55,3 13,3.45 13,4C13,4.55 12.55,5 12,5C11.45,5 11,4.55 11,4C11,3.45 11.45,3 12,3",
  },
  {
    id: "C45D118E-4FFA-42E5-A18B-B8A7B58BF42F",
    name: "clipboard-account",
    codepoint: "F148",
    aliases: ["clipboard-user", "assignment-ind"],
    tags: ["Account / User"],
    author: "Google",
    version: "1.5.54",
    path: "M18,19H6V17.6C6,15.6 10,14.5 12,14.5C14,14.5 18,15.6 18,17.6M12,7C13.66,7 15,8.34 15,10C15,11.66 13.66,13 12,13C10.34,13 9,11.66 9,10C9,8.34 10.34,7 12,7M12,3C12.55,3 13,3.45 13,4C13,4.55 12.55,5 12,5C11.45,5 11,4.55 11,4C11,3.45 11.45,3 12,3M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3Z",
  },
  {
    id: "57AC4C5E-B2AB-42B5-9826-BCFEACCB2E7C",
    name: "clipboard-alert",
    codepoint: "F149",
    aliases: ["clipboard-warning", "assignment-late"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M12,5C11.45,5 11,4.55 11,4C11,3.45 11.45,3 12,3C12.55,3 13,3.45 13,4C13,4.55 12.55,5 12,5M13,14H11V8H13M13,18H11V16H13M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3Z",
  },
  {
    id: "863E0318-495E-437A-B22B-3C1274D108E6",
    name: "clipboard-arrow-down",
    codepoint: "F14A",
    aliases: ["assignment-returned"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M12,18L7,13H10V9H14V13H17M12,3C12.55,3 13,3.45 13,4C13,4.55 12.55,5 12,5C11.45,5 11,4.55 11,4C11,3.45 11.45,3 12,3M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3Z",
  },
  {
    id: "1D6DD9E5-61EA-40E6-A19A-EF4BA71B0FC0",
    name: "clipboard-arrow-left",
    codepoint: "F14B",
    aliases: ["assignment-return"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M16,15H12V18L7,13L12,8V11H16M12,3C12.55,3 13,3.45 13,4C13,4.55 12.55,5 12,5C11.45,5 11,4.55 11,4C11,3.45 11.45,3 12,3M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3Z",
  },
  {
    id: "2FA574EF-C285-465F-A254-868506FA4273",
    name: "clipboard-check",
    codepoint: "F14C",
    aliases: ["assignment-turned-in"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M10,17L6,13L7.41,11.59L10,14.17L16.59,7.58L18,9M12,3C12.55,3 13,3.45 13,4C13,4.55 12.55,5 12,5C11.45,5 11,4.55 11,4C11,3.45 11.45,3 12,3M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3Z",
  },
  {
    id: "6A0DFB73-2DBF-4D3C-8C6B-2B4758B11782",
    name: "clipboard-check-outline",
    codepoint: "F8A7",
    aliases: [],
    tags: [],
    author: "James Coyle",
    version: "2.2.43",
    path: "M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3M12,3C12.55,3 13,3.45 13,4C13,4.55 12.55,5 12,5C11.45,5 11,4.55 11,4C11,3.45 11.45,3 12,3M7,7H17V5H19V19H5V5H7V7M7.5,13.5L9,12L11,14L15.5,9.5L17,11L11,17L7.5,13.5Z",
  },
  {
    id: "5A450EF8-D2F0-4F32-8D10-A606DD847E19",
    name: "clipboard-flow",
    codepoint: "F6C7",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "1.8.36",
    path: "M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3M12,3C12.55,3 13,3.45 13,4C13,4.55 12.55,5 12,5C11.45,5 11,4.55 11,4C11,3.45 11.45,3 12,3M15,19L11,15H14V8H16V15H19L15,19M10,16H8V9H5L9,5L13,9H10V16",
  },
  {
    id: "54F34575-7348-4032-B072-EC8F9A6C843D",
    name: "clipboard-outline",
    codepoint: "F14D",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3M12,3C12.55,3 13,3.45 13,4C13,4.55 12.55,5 12,5C11.45,5 11,4.55 11,4C11,3.45 11.45,3 12,3M7,7H17V5H19V19H5V5H7V7Z",
  },
  {
    id: "A5AA9DEA-AAAE-4C79-965F-6828F823E2CD",
    name: "clipboard-plus",
    codepoint: "F750",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3M12,3C12.55,3 13,3.45 13,4C13,4.55 12.55,5 12,5C11.45,5 11,4.55 11,4C11,3.45 11.45,3 12,3M13,12H16V14H13V17H11V14H8V12H11V9H13V12Z",
  },
  {
    id: "8E3D93CC-DE0A-4828-AC9A-9A6CFD932978",
    name: "clipboard-pulse",
    codepoint: "F85C",
    aliases: [],
    tags: ["Medical / Hospital"],
    author: "Cody",
    version: "2.1.99",
    path: "M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3M12,3C12.55,3 13,3.45 13,4C13,4.55 12.55,5 12,5C11.45,5 11,4.55 11,4C11,3.45 11.45,3 12,3M5,13.46H7.17L10.5,7.08L11.44,14.05L13.93,10.86L16.53,13.46H19V15H15.89L14.07,13.21L10.38,17.92L9.62,12.15L8.11,15H5V13.46Z",
  },
  {
    id: "8D6CA1DD-35D6-4E8E-BDA0-6192728A24C4",
    name: "clipboard-pulse-outline",
    codepoint: "F85D",
    aliases: [],
    tags: ["Medical / Hospital"],
    author: "Cody",
    version: "2.1.99",
    path: "M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3M12,3C12.55,3 13,3.45 13,4C13,4.55 12.55,5 12,5C11.45,5 11,4.55 11,4C11,3.45 11.45,3 12,3M5,15H8.11L9.62,12.15L10.38,17.92L14.07,13.21L15.89,15H19V19H5V15M19,13.46H16.53L13.93,10.86L11.44,14.05L10.5,7.08L7.17,13.46H5V5H7V6H17V5H19V6L19,13.46Z",
  },
  {
    id: "81453216-6EC0-4751-82A4-BFFF63B922FC",
    name: "clipboard-text",
    codepoint: "F14E",
    aliases: ["assignment"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M17,9H7V7H17M17,13H7V11H17M14,17H7V15H14M12,3C12.55,3 13,3.45 13,4C13,4.55 12.55,5 12,5C11.45,5 11,4.55 11,4C11,3.45 11.45,3 12,3M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3Z",
  },
  {
    id: "6B346FB6-F563-4AC4-B769-06A143B42152",
    name: "clippy",
    codepoint: "F14F",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M15,15.5C15,16.88 13.88,18 12.5,18C11.12,18 10,16.88 10,15.5V13.75C10,13.34 10.34,13 10.75,13C11.16,13 11.5,13.34 11.5,13.75V15.5C11.5,16.05 11.95,16.5 12.5,16.5C13.05,16.5 13.5,16.05 13.5,15.5V11.89C12.63,11.61 12,10.87 12,10C12,8.9 13,8 14.25,8C15.5,8 16.5,8.9 16.5,10C16.5,10.87 15.87,11.61 15,11.89V15.5M8.25,8C9.5,8 10.5,8.9 10.5,10C10.5,10.87 9.87,11.61 9,11.89V17.25C9,19.04 10.46,20.5 12.25,20.5C14.04,20.5 15.5,19.04 15.5,17.25V13.75C15.5,13.34 15.84,13 16.25,13C16.66,13 17,13.34 17,13.75V17.25C17,19.87 14.87,22 12.25,22C9.63,22 7.5,19.87 7.5,17.25V11.89C6.63,11.61 6,10.87 6,10C6,8.9 7,8 8.25,8M10.06,6.13L9.63,7.59C9.22,7.37 8.75,7.25 8.25,7.25C7.34,7.25 6.53,7.65 6.03,8.27L4.83,7.37C5.46,6.57 6.41,6 7.5,5.81V5.75C7.5,3.68 9.18,2 11.25,2C13.32,2 15,3.68 15,5.75V5.81C16.09,6 17.04,6.57 17.67,7.37L16.47,8.27C15.97,7.65 15.16,7.25 14.25,7.25C13.75,7.25 13.28,7.37 12.87,7.59L12.44,6.13C12.77,6 13.13,5.87 13.5,5.81V5.75C13.5,4.5 12.5,3.5 11.25,3.5C10,3.5 9,4.5 9,5.75V5.81C9.37,5.87 9.73,6 10.06,6.13M14.25,9.25C13.7,9.25 13.25,9.59 13.25,10C13.25,10.41 13.7,10.75 14.25,10.75C14.8,10.75 15.25,10.41 15.25,10C15.25,9.59 14.8,9.25 14.25,9.25M8.25,9.25C7.7,9.25 7.25,9.59 7.25,10C7.25,10.41 7.7,10.75 8.25,10.75C8.8,10.75 9.25,10.41 9.25,10C9.25,9.59 8.8,9.25 8.25,9.25Z",
  },
  {
    id: "90E7BBD9-12C3-4339-94DE-99A049C8D4B1",
    name: "clock",
    codepoint: "F953",
    aliases: ["watch-later"],
    tags: ["Date / Time"],
    author: "Google",
    version: "2.4.85",
    path: "M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M16.2,16.2L11,13V7H12.5V12.2L17,14.9L16.2,16.2Z",
  },
  {
    id: "A4250284-2784-405C-A62F-E6C546D66777",
    name: "clock-alert",
    codepoint: "F954",
    aliases: ["clock-warning"],
    tags: ["Date / Time"],
    author: "Cody",
    version: "2.4.85",
    path: "M12,2C16.46,2 20.26,4.95 21.54,9H18V20C16.33,21.25 14.25,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M16.2,16.2L17,14.9L12.5,12.2V7H11V13L16.2,16.2M20,11H22V18H20V11M20,20H22V22H20V20Z",
  },
  {
    id: "CB400FB2-95E5-4420-B579-80DCA5C0F8B0",
    name: "clock-alert-outline",
    codepoint: "F5CE",
    aliases: ["clock-warning"],
    tags: ["Date / Time"],
    author: "Cody",
    version: "1.5.54",
    path: "M12,2C6.47,2 2,6.5 2,12C2,17.52 6.48,22 12,22C14.25,22 16.33,21.24 18,20V17.28C16.53,18.94 14.39,20 12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C15.36,4 18.23,6.07 19.41,9H21.54C20.27,4.94 16.5,2 12,2M11,7V13L16.25,16.15L17,14.92L12.5,12.25V7H11M20,11V18H22V11H20M20,20V22H22V20H20Z",
  },
  {
    id: "F7F5CA75-E8B5-45E1-B0BA-040F225D877D",
    name: "clock-end",
    codepoint: "F151",
    aliases: [],
    tags: ["Date / Time"],
    author: "Cody",
    version: "1.5.54",
    path: "M12,1C8.14,1 5,4.14 5,8C5,11.87 8.13,15 12,15C15.86,15 19,11.87 19,8C19,4.14 15.86,1 12,1M12,3.15C14.67,3.15 16.85,5.32 16.85,8C16.85,10.68 14.67,12.85 12,12.85C9.32,12.85 7.15,10.68 7.15,8C7.15,5.32 9.32,3.15 12,3.15M11,5V8.69L14.19,10.53L14.94,9.23L12.5,7.82V5M15,16V19H3V21H15V24L19,20M19,20V24H21V16H19",
  },
  {
    id: "111210EB-0EF4-4DCB-ABBD-6A75F15EEB44",
    name: "clock-fast",
    codepoint: "F152",
    aliases: [],
    tags: ["Date / Time"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M15,4C19.42,4 23,7.58 23,12C23,16.42 19.42,20 15,20C10.58,20 7,16.42 7,12C7,7.58 10.58,4 15,4M15,6C11.69,6 9,8.69 9,12C9,15.31 11.69,18 15,18C18.31,18 21,15.31 21,12C21,8.69 18.31,6 15,6M14,8H15.5V11.78L17.83,14.11L16.77,15.17L14,12.4V8M2,18C1.45,18 1,17.55 1,17C1,16.45 1.45,16 2,16H5.83C6.14,16.71 6.54,17.38 7,18H2M3,13C2.45,13 2,12.55 2,12C2,11.45 2.45,11 3,11H5.05L5,12L5.05,13H3M4,8C3.45,8 3,7.55 3,7C3,6.45 3.45,6 4,6H7C6.54,6.62 6.14,7.29 5.83,8H4Z",
  },
  {
    id: "6483D8DB-4170-4104-8A69-40D28401EF4C",
    name: "clock-in",
    codepoint: "F153",
    aliases: [],
    tags: ["Date / Time"],
    author: "Cody",
    version: "1.5.54",
    path: "M2.21,0.79L0.79,2.21L4.8,6.21L3,8H8V3L6.21,4.8M12,8C8.14,8 5,11.13 5,15C5,18.87 8.13,22 12,22C15.86,22 19,18.87 19,15C19,11.13 15.87,8 12,8M12,10.15C14.67,10.15 16.85,12.32 16.85,15C16.85,17.68 14.68,19.85 12,19.85C9.32,19.85 7.15,17.68 7.15,15C7.15,12.32 9.32,10.15 12,10.15M11,12V15.69L14.19,17.53L14.94,16.23L12.5,14.82V12",
  },
  {
    id: "7C3F10AF-CB56-4A35-B22A-C833D5C823A3",
    name: "clock-out",
    codepoint: "F154",
    aliases: [],
    tags: ["Date / Time"],
    author: "Cody",
    version: "1.5.54",
    path: "M18,1L19.8,2.79L15.79,6.79L17.21,8.21L21.21,4.21L23,6V1M12,8C8.14,8 5,11.13 5,15C5,18.87 8.13,22 12,22C15.86,22 19,18.87 19,15C19,11.13 15.87,8 12,8M12,10.15C14.67,10.15 16.85,12.32 16.85,15C16.85,17.68 14.68,19.85 12,19.85C9.32,19.85 7.15,17.68 7.15,15C7.15,12.32 9.32,10.15 12,10.15M11,12V15.69L14.19,17.53L14.94,16.23L12.5,14.82V12",
  },
  {
    id: "E3A4F70D-92EF-4115-BBB3-3BE68A788F5D",
    name: "clock-outline",
    codepoint: "F150",
    aliases: ["access-time", "query-builder", "schedule"],
    tags: ["Date / Time"],
    author: "Google",
    version: "1.5.54",
    path: "M12,20C16.42,20 20,16.42 20,12C20,7.58 16.42,4 12,4C7.58,4 4,7.58 4,12C4,16.42 7.58,20 12,20M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.47,22 2,17.5 2,12C2,6.48 6.48,2 12,2M12.5,7V12.25L17,14.92L16.25,16.15L11,13V7H12.5Z",
  },
  {
    id: "85A4435A-CDCF-42BC-8F2C-B46EDF8820BD",
    name: "clock-start",
    codepoint: "F155",
    aliases: [],
    tags: ["Date / Time"],
    author: "Cody",
    version: "1.5.54",
    path: "M12,1C8.14,1 5,4.14 5,8C5,11.87 8.13,15 12,15C15.86,15 19,11.87 19,8C19,4.14 15.86,1 12,1M12,3.15C14.67,3.15 16.85,5.32 16.85,8C16.85,10.68 14.67,12.85 12,12.85C9.32,12.85 7.15,10.68 7.15,8C7.15,5.32 9.32,3.15 12,3.15M11,5V8.69L14.19,10.53L14.94,9.23L12.5,7.82V5M4,16V24H6V21H18V24L22,20L18,16V19H6V16",
  },
  {
    id: "FEA26660-7D6A-4C2A-9F13-7AE125FBA543",
    name: "close",
    codepoint: "F156",
    aliases: ["clear"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z",
  },
  {
    id: "0823D18B-529A-4B7E-8090-A913399A3D5E",
    name: "close-box",
    codepoint: "F157",
    aliases: [],
    tags: [],
    author: "Gabriel",
    version: "1.5.54",
    path: "M19,3H16.3H7.7H5C3.9,3 3,3.9 3,5V7.7V16.4V19C3,20.1 3.9,21 5,21H7.7H16.4H19C20.1,21 21,20.1 21,19V16.3V7.7V5C21,3.9 20.1,3 19,3M15.6,17L12,13.4L8.4,17L7,15.6L10.6,12L7,8.4L8.4,7L12,10.6L15.6,7L17,8.4L13.4,12L17,15.6L15.6,17Z",
  },
  {
    id: "05B8E566-B224-4ECC-AE70-2BF8BE90C82A",
    name: "close-box-outline",
    codepoint: "F158",
    aliases: [],
    tags: [],
    author: "Gabriel",
    version: "1.5.54",
    path: "M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3M19,19H5V5H19V19M17,8.4L13.4,12L17,15.6L15.6,17L12,13.4L8.4,17L7,15.6L10.6,12L7,8.4L8.4,7L12,10.6L15.6,7L17,8.4Z",
  },
  {
    id: "DC0E1491-A8A0-4563-ACEC-C795D96602A7",
    name: "close-circle",
    codepoint: "F159",
    aliases: ["remove-circle", "cancel"],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z",
  },
  {
    id: "EA41E6BB-A176-4E0E-896A-36F9FA5AA62F",
    name: "close-circle-outline",
    codepoint: "F15A",
    aliases: ["highlight-off"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2C6.47,2 2,6.47 2,12C2,17.53 6.47,22 12,22C17.53,22 22,17.53 22,12C22,6.47 17.53,2 12,2M14.59,8L12,10.59L9.41,8L8,9.41L10.59,12L8,14.59L9.41,16L12,13.41L14.59,16L16,14.59L13.41,12L16,9.41L14.59,8Z",
  },
  {
    id: "4043C369-E619-47E9-9363-E5E9C43457FB",
    name: "close-network",
    codepoint: "F15B",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M14.59,6L12,8.59L9.41,6L8,7.41L10.59,10L8,12.59L9.41,14L12,11.41L14.59,14L16,12.59L13.41,10L16,7.41L14.59,6M17,3C18.1,3 19,3.9 19,5V15C19,16.1 18.1,17 17,17H13V19H14C14.55,19 15,19.45 15,20H22V22H15C15,22.55 14.55,23 14,23H10C9.45,23 9,22.55 9,22H2V20H9C9,19.45 9.45,19 10,19H11V17H7C5.89,17 5,16.1 5,15V5C5,3.9 5.9,3 7,3H17Z",
  },
  {
    id: "BA7E9F56-A5F5-4BEE-8934-90CA070A6029",
    name: "close-octagon",
    codepoint: "F15C",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M8.27,3L3,8.27V15.73L8.27,21H15.73L21,15.73V8.27L15.73,3M8.41,7L12,10.59L15.59,7L17,8.41L13.41,12L17,15.59L15.59,17L12,13.41L8.41,17L7,15.59L10.59,12L7,8.41",
  },
  {
    id: "9676C4C3-D8C3-44A6-A447-59A56A15DA34",
    name: "close-octagon-outline",
    codepoint: "F15D",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M8.27,3L3,8.27V15.73L8.27,21H15.73C17.5,19.24 21,15.73 21,15.73V8.27L15.73,3M9.1,5H14.9L19,9.1V14.9L14.9,19H9.1L5,14.9V9.1M9.12,7.71L7.71,9.12L10.59,12L7.71,14.88L9.12,16.29L12,13.41L14.88,16.29L16.29,14.88L13.41,12L16.29,9.12L14.88,7.71L12,10.59",
  },
  {
    id: "2FEE0020-4271-487C-897D-75529B20C4C6",
    name: "close-outline",
    codepoint: "F6C8",
    aliases: [],
    tags: [],
    author: "Michael Irigoyen",
    version: "1.8.36",
    path: "M3,16.74L7.76,12L3,7.26L7.26,3L12,7.76L16.74,3L21,7.26L16.24,12L21,16.74L16.74,21L12,16.24L7.26,21L3,16.74M12,13.41L16.74,18.16L18.16,16.74L13.41,12L18.16,7.26L16.74,5.84L12,10.59L7.26,5.84L5.84,7.26L10.59,12L5.84,16.74L7.26,18.16L12,13.41Z",
  },
  {
    id: "5367B460-F7E5-46C5-A4F5-40B339BF9DAD",
    name: "closed-caption",
    codepoint: "F15E",
    aliases: ["cc"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M18,11H16.5V10.5H14.5V13.5H16.5V13H18V14C18,14.55 17.55,15 17,15H14C13.45,15 13,14.55 13,14V10C13,9.45 13.45,9 14,9H17C17.55,9 18,9.45 18,10M11,11H9.5V10.5H7.5V13.5H9.5V13H11V14C11,14.55 10.55,15 10,15H7C6.45,15 6,14.55 6,14V10C6,9.45 6.45,9 7,9H10C10.55,9 11,9.45 11,10M19,4H5C3.89,4 3,4.89 3,6V18C3,19.1 3.9,20 5,20H19C20.1,20 21,19.1 21,18V6C21,4.89 20.1,4 19,4Z",
  },
  {
    id: "CF07C502-388E-4A65-BD89-FACCFD00C245",
    name: "cloud",
    codepoint: "F15F",
    aliases: ["wb-cloudy"],
    tags: ["Cloud", "Weather"],
    author: "Google",
    version: "1.5.54",
    path: "M19.35,10.03C18.67,6.59 15.64,4 12,4C9.11,4 6.6,5.64 5.35,8.03C2.34,8.36 0,10.9 0,14C0,17.31 2.69,20 6,20H19C21.76,20 24,17.76 24,15C24,12.36 21.95,10.22 19.35,10.03Z",
  },
  {
    id: "4ACCBA06-78DB-492F-98F6-08AEE743744A",
    name: "cloud-alert",
    codepoint: "F9DF",
    aliases: ["cloud-warning"],
    tags: [],
    author: "Contributors",
    version: "2.5.94",
    path: "M19,20H6C2.71,20 0,17.29 0,14C0,10.9 2.34,8.36 5.35,8.03C6.6,5.64 9.11,4 12,4C15.64,4 18.67,6.59 19.35,10.03C21.95,10.22 24,12.36 24,15C24,17.74 21.74,20 19,20M11,15V17H13V15H11M11,13H13V8H11V13Z",
  },
  {
    id: "6ED02FDD-323E-4004-9D7B-336F2402DF8E",
    name: "cloud-braces",
    codepoint: "F7B4",
    aliases: ["cloud-json"],
    tags: ["Cloud"],
    author: "Andy Martinez",
    version: "2.0.46",
    path: "M6,20C2.69,20 0,17.31 0,14C0,10.91 2.34,8.36 5.35,8.04C6.6,5.64 9.11,4 12,4C15.63,4 18.66,6.58 19.35,10C21.95,10.19 24,12.36 24,15C24,17.76 21.76,20 19,20H6M18.5,12H18C17.45,12 17,11.55 17,11V10C17,8.9 16.1,8 15,8H13.5V10H15V11C15,12.1 15.9,13 17,13C15.9,13 15,13.9 15,15V16H13.5V18H15C16.1,18 17,17.1 17,16V15C17,14.45 17.45,14 18,14H18.5V12M5.5,12V14H6C6.55,14 7,14.45 7,15V16C7,17.1 7.9,18 9,18H10.5V16H9V15C9,13.9 8.1,13 7,13C8.1,13 9,12.1 9,11V10H10.5V8H9C7.9,8 7,8.9 7,10V11C7,11.55 6.55,12 6,12H5.5Z",
  },
  {
    id: "5B607B90-B492-43AD-A5B0-4AC800A9F7DA",
    name: "cloud-check",
    codepoint: "F160",
    aliases: ["cloud-done"],
    tags: ["Cloud"],
    author: "Google",
    version: "1.5.54",
    path: "M10,17L6.5,13.5L7.91,12.08L10,14.17L15.18,9L16.59,10.41M19.35,10.03C18.67,6.59 15.64,4 12,4C9.11,4 6.6,5.64 5.35,8.03C2.34,8.36 0,10.9 0,14C0,17.31 2.69,20 6,20H19C21.76,20 24,17.76 24,15C24,12.36 21.95,10.22 19.35,10.03Z",
  },
  {
    id: "06BCD41B-8BFF-43C0-88A1-69F262C51C5F",
    name: "cloud-circle",
    codepoint: "F161",
    aliases: [],
    tags: ["Cloud"],
    author: "Google",
    version: "1.5.54",
    path: "M16.5,16H8C6.34,16 5,14.66 5,13C5,11.34 6.34,10 8,10C8.05,10 8.09,10 8.14,10C8.58,8.28 10.13,7 12,7C14.21,7 16,8.79 16,11H16.5C17.88,11 19,12.12 19,13.5C19,14.88 17.88,16 16.5,16M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z",
  },
  {
    id: "D8C49CD8-61B2-4F34-A4B8-543396B4A610",
    name: "cloud-download",
    codepoint: "F162",
    aliases: [],
    tags: ["Cloud"],
    author: "Google",
    version: "1.5.54",
    path: "M17,13L12,18L7,13H10V9H14V13M19.35,10.03C18.67,6.59 15.64,4 12,4C9.11,4 6.6,5.64 5.35,8.03C2.34,8.36 0,10.9 0,14C0,17.31 2.69,20 6,20H19C21.76,20 24,17.76 24,15C24,12.36 21.95,10.22 19.35,10.03Z",
  },
  {
    id: "E19C3062-FFE5-441C-91C8-B1792E3AA3CA",
    name: "cloud-off-outline",
    codepoint: "F164",
    aliases: [],
    tags: ["Cloud"],
    author: "Google",
    version: "1.5.54",
    path: "M7.73,10L15.73,18H6C3.79,18 2,16.21 2,14C2,11.79 3.79,10 6,10M3,5.27L5.75,8C2.56,8.15 0,10.77 0,14C0,17.31 2.69,20 6,20H17.73L19.73,22L21,20.73L4.27,4M19.35,10.03C18.67,6.59 15.64,4 12,4C10.5,4 9.15,4.43 8,5.17L9.45,6.63C10.21,6.23 11.08,6 12,6C15.04,6 17.5,8.46 17.5,11.5V12H19C20.66,12 22,13.34 22,15C22,16.13 21.36,17.11 20.44,17.62L21.89,19.07C23.16,18.16 24,16.68 24,15C24,12.36 21.95,10.22 19.35,10.03Z",
  },
  {
    id: "6EBE020D-405B-4E36-8B47-CAC6FAF1166C",
    name: "cloud-outline",
    codepoint: "F163",
    aliases: ["cloud-queue"],
    tags: ["Cloud"],
    author: "Google",
    version: "1.5.54",
    path: "M19,18H6C3.79,18 2,16.21 2,14C2,11.79 3.79,10 6,10H6.71C7.37,7.69 9.5,6 12,6C15.04,6 17.5,8.46 17.5,11.5V12H19C20.66,12 22,13.34 22,15C22,16.66 20.66,18 19,18M19.35,10.03C18.67,6.59 15.64,4 12,4C9.11,4 6.6,5.64 5.35,8.03C2.34,8.36 0,10.9 0,14C0,17.31 2.69,20 6,20H19C21.76,20 24,17.76 24,15C24,12.36 21.95,10.22 19.35,10.03Z",
  },
  {
    id: "DB32F759-BA18-488B-9260-9A38529BE7A8",
    name: "cloud-print",
    codepoint: "F165",
    aliases: [],
    tags: ["Cloud", "Printer", "Home Automation"],
    author: "Cody",
    version: "1.5.54",
    path: "M12,2C9.11,2 6.6,3.64 5.35,6.04C2.34,6.36 0,8.91 0,12C0,15.31 2.69,18 6,18V22H18V18H19C21.76,18 24,15.76 24,13C24,10.36 21.95,8.22 19.35,8.04C18.67,4.59 15.64,2 12,2M8,13H16V20H8V13M9,14V15H15V14H9M9,16V17H15V16H9M9,18V19H15V18H9Z",
  },
  {
    id: "7B3F8F72-1F4B-429A-B969-8E42ADBBD3E1",
    name: "cloud-print-outline",
    codepoint: "F166",
    aliases: [],
    tags: ["Cloud", "Printer", "Home Automation"],
    author: "Cody",
    version: "1.5.54",
    path: "M19,16C20.66,16 22,14.66 22,13C22,11.34 20.66,10 19,10H17.5V9.5C17.5,6.46 15.04,4 12,4C9.5,4 7.37,5.69 6.71,8H6C3.79,8 2,9.79 2,12C2,14.21 3.79,16 6,16V11H18V16H19M19.36,8.04C21.95,8.22 24,10.36 24,13C24,15.76 21.76,18 19,18H18V22H6V18C2.69,18 0,15.31 0,12C0,8.91 2.34,6.36 5.35,6.04C6.6,3.64 9.11,2 12,2C15.64,2 18.67,4.6 19.36,8.04M8,13V20H16V13H8M9,18H15V19H9V18M15,17H9V16H15V17M9,14H15V15H9V14Z",
  },
  {
    id: "BF384FFB-7E5D-4C2E-ADC5-4BEEAF61A81C",
    name: "cloud-search",
    codepoint: "F955",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.4.85",
    path: "M15.5,12C18,12 20,14 20,16.5C20,17.38 19.75,18.21 19.31,18.9L22.39,22L21,23.39L17.88,20.32C17.19,20.75 16.37,21 15.5,21C13,21 11,19 11,16.5C11,14 13,12 15.5,12M15.5,14C14.12,14 13,15.12 13,16.5C13,17.88 14.12,19 15.5,19C16.88,19 18,17.88 18,16.5C18,15.12 16.88,14 15.5,14M19.35,8.03C21.95,8.22 24,10.36 24,13C24,14.64 23.21,16.1 22,17V16.5C22,12.91 19.09,10 15.5,10C11.91,10 9,12.91 9,16.5C9,17 9.06,17.5 9.17,18H6C2.69,18 0,15.31 0,12C0,8.9 2.34,6.36 5.35,6.03C6.6,3.64 9.11,2 12,2C15.64,2 18.67,4.59 19.35,8.03Z",
  },
  {
    id: "5C72BE2A-A04D-4B36-9390-024C5A1214D9",
    name: "cloud-search-outline",
    codepoint: "F956",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.4.85",
    path: "M15.5,12C18,12 20,14 20,16.5C20,17.38 19.75,18.21 19.31,18.9L22.39,22L21,23.39L17.88,20.32C17.19,20.75 16.37,21 15.5,21C13,21 11,19 11,16.5C11,14 13,12 15.5,12M15.5,14C14.12,14 13,15.12 13,16.5C13,17.88 14.12,19 15.5,19C16.88,19 18,17.88 18,16.5C18,15.12 16.88,14 15.5,14M22,13C22,11.34 20.66,10 19,10H17.5V9.5C17.5,6.46 15.04,4 12,4C9.5,4 7.37,5.69 6.71,8H6C3.79,8 2,9.79 2,12C2,14.21 3.79,16 6,16H9V16.5C9,17 9.06,17.5 9.17,18H6C2.69,18 0,15.31 0,12C0,8.9 2.34,6.36 5.35,6.04C6.6,3.64 9.11,2 12,2C15.64,2 18.67,4.59 19.36,8.04C21.95,8.22 24,10.36 24,13C24,14.65 23.21,16.1 22,17V16.5C22,15.77 21.88,15.06 21.65,14.4C21.87,14 22,13.5 22,13Z",
  },
  {
    id: "BEA2DB85-AD43-4208-8F5E-5029997B23B7",
    name: "cloud-sync",
    codepoint: "F63F",
    aliases: [],
    tags: ["Cloud"],
    author: "Cody",
    version: "1.6.50",
    path: "M12,4C15.64,4 18.67,6.59 19.35,10.04C21.95,10.22 24,12.36 24,15C24,17.76 21.76,20 19,20H6C2.69,20 0,17.31 0,14C0,10.91 2.34,8.36 5.35,8.04C6.6,5.64 9.11,4 12,4M7.5,9.69C6.06,11.5 6.2,14.06 7.82,15.68C8.66,16.5 9.81,17 11,17V18.86L13.83,16.04L11,13.21V15C10.34,15 9.7,14.74 9.23,14.27C8.39,13.43 8.26,12.11 8.92,11.12L7.5,9.69M9.17,8.97L10.62,10.42L12,11.79V10C12.66,10 13.3,10.26 13.77,10.73C14.61,11.57 14.74,12.89 14.08,13.88L15.5,15.31C16.94,13.5 16.8,10.94 15.18,9.32C14.34,8.5 13.19,8 12,8V6.14L9.17,8.97Z",
  },
  {
    id: "AE3A5033-BA77-4E82-BFD0-4C23275B602F",
    name: "cloud-tags",
    codepoint: "F7B5",
    aliases: ["cloud-xml"],
    tags: ["Cloud"],
    author: "Andy Martinez",
    version: "2.0.46",
    path: "M6,20C2.69,20 0,17.31 0,14C0,10.91 2.34,8.36 5.35,8.04C6.6,5.64 9.11,4 12,4C15.63,4 18.66,6.58 19.35,10C21.95,10.19 24,12.36 24,15C24,17.76 21.76,20 19,20H6M9.09,8.4L4.5,13L9.09,17.6L10.5,16.18L7.32,13L10.5,9.82L9.09,8.4M14.91,8.4L13.5,9.82L16.68,13L13.5,16.18L14.91,17.6L19.5,13L14.91,8.4Z",
  },
  {
    id: "BB4F16F6-B596-4725-8831-A794321542EB",
    name: "cloud-upload",
    codepoint: "F167",
    aliases: ["backup"],
    tags: ["Cloud"],
    author: "Google",
    version: "1.5.54",
    path: "M14,13V17H10V13H7L12,8L17,13M19.35,10.03C18.67,6.59 15.64,4 12,4C9.11,4 6.6,5.64 5.35,8.03C2.34,8.36 0,10.9 0,14C0,17.31 2.69,20 6,20H19C21.76,20 24,17.76 24,15C24,12.36 21.95,10.22 19.35,10.03Z",
  },
  {
    id: "0B70716D-3C56-43F1-85D4-B264C05DCC32",
    name: "clover",
    codepoint: "F815",
    aliases: ["luck"],
    tags: ["Nature"],
    author: "Michael Richins",
    version: "2.1.19",
    path: "M12,11.18C15.3,8.18 17,6.64 17,4.69C17,3.19 15.75,2 14.25,2C13.39,2 12.57,2.36 12,3C11.43,2.36 10.61,2 9.69,2C8.19,2 7,3.25 7,4.75C7,6.64 8.7,8.18 12,11.18M11.18,12C8.18,8.7 6.64,7 4.69,7C3.19,7 2,8.25 2,9.75C2,10.61 2.36,11.43 3,12C2.36,12.57 2,13.39 2,14.31C2,15.81 3.25,17 4.75,17C6.64,17 8.18,15.3 11.18,12M12.83,12C15.82,15.3 17.36,17 19.31,17C20.81,17 22,15.75 22,14.25C22,13.39 21.64,12.57 21,12C21.64,11.43 22,10.61 22,9.69C22,8.19 20.75,7 19.25,7C17.36,7 15.82,8.7 12.83,12M12,12.82C8.7,15.82 7,17.36 7,19.31C7,20.81 8.25,22 9.75,22C10.61,22 11.43,21.64 12,21C12.57,21.64 13.39,22 14.31,22C15.81,22 17,20.75 17,19.25C17,17.36 15.3,15.82 12,12.82Z",
  },
  {
    id: "04020C45-A5ED-4D33-A7BD-AE986516C0DE",
    name: "code-array",
    codepoint: "F168",
    aliases: [],
    tags: ["Developer / Languages"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M3,5C3,3.9 3.9,3 5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.89,21 3,20.1 3,19V5M6,6V18H10V16H8V8H10V6H6M16,16H14V18H18V6H14V8H16V16Z",
  },
  {
    id: "1F6661BC-6538-4EF0-92B5-46EFAE5E0C77",
    name: "code-braces",
    codepoint: "F169",
    aliases: [],
    tags: ["Developer / Languages"],
    author: "Cody",
    version: "1.5.54",
    path: "M8,3C6.9,3 6,3.9 6,5V9C6,10.1 5.1,11 4,11H3V13H4C5.1,13 6,13.9 6,15V19C6,20.1 6.9,21 8,21H10V19H8V14C8,12.9 7.1,12 6,12C7.1,12 8,11.1 8,10V5H10V3M16,3C17.1,3 18,3.9 18,5V9C18,10.1 18.9,11 20,11H21V13H20C18.9,13 18,13.9 18,15V19C18,20.1 17.1,21 16,21H14V19H16V14C16,12.9 16.9,12 18,12C16.9,12 16,11.1 16,10V5H14V3H16Z",
  },
  {
    id: "C08498C1-E43B-4E79-817C-121AD2827689",
    name: "code-brackets",
    codepoint: "F16A",
    aliases: [],
    tags: ["Developer / Languages"],
    author: "Cody",
    version: "1.5.54",
    path: "M15,4V6H18V18H15V20H20V4M4,4V20H9V18H6V6H9V4H4Z",
  },
  {
    id: "16C07036-EE56-4447-8495-EB2FAD143072",
    name: "code-equal",
    codepoint: "F16B",
    aliases: [],
    tags: ["Developer / Languages"],
    author: "Cody",
    version: "1.5.54",
    path: "M6,13H11V15H6M13,13H18V15H13M13,9H18V11H13M6,9H11V11H6M5,3C3.89,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3H5Z",
  },
  {
    id: "2C70B20E-4B20-4CF6-8775-339C1184E032",
    name: "code-greater-than",
    codepoint: "F16C",
    aliases: [],
    tags: ["Developer / Languages"],
    author: "Cody",
    version: "1.5.54",
    path: "M10.41,7.41L15,12L10.41,16.6L9,15.18L12.18,12L9,8.82M5,3C3.89,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3H5Z",
  },
  {
    id: "3C9D2060-53C2-4D66-BE38-C46EE87D8D46",
    name: "code-greater-than-or-equal",
    codepoint: "F16D",
    aliases: [],
    tags: ["Developer / Languages"],
    author: "Cody",
    version: "1.5.54",
    path: "M13,13H18V15H13M13,9H18V11H13M6.91,7.41L11.5,12L6.91,16.6L5.5,15.18L8.68,12L5.5,8.82M5,3C3.89,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3H5Z",
  },
  {
    id: "92266B3A-6EC4-4CE7-9904-2A793B2A4084",
    name: "code-less-than",
    codepoint: "F16E",
    aliases: [],
    tags: ["Developer / Languages"],
    author: "Cody",
    version: "1.5.54",
    path: "M13.59,7.41L9,12L13.59,16.6L15,15.18L11.82,12L15,8.82M19,3C20.11,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3H19Z",
  },
  {
    id: "3D003F4A-7BCB-4946-AE70-CCAA2B7D5B10",
    name: "code-less-than-or-equal",
    codepoint: "F16F",
    aliases: [],
    tags: ["Developer / Languages"],
    author: "Cody",
    version: "1.5.54",
    path: "M13,13H18V15H13M13,9H18V11H13M10.09,7.41L11.5,8.82L8.32,12L11.5,15.18L10.09,16.6L5.5,12M5,3C3.89,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3H5Z",
  },
  {
    id: "1A01458F-59E8-4AF9-B398-8058900EE85F",
    name: "code-not-equal",
    codepoint: "F170",
    aliases: [],
    tags: ["Developer / Languages"],
    author: "Cody",
    version: "1.5.54",
    path: "M6,15H8V17H6M11,13H18V15H11M11,9H18V11H11M6,7H8V13H6M5,3C3.89,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3H5Z",
  },
  {
    id: "05E12366-E7AA-46B9-8D6E-3664EBD34BB3",
    name: "code-not-equal-variant",
    codepoint: "F171",
    aliases: [],
    tags: ["Developer / Languages"],
    author: "Cody",
    version: "1.5.54",
    path: "M11,6.5V9.33L8.33,12L11,14.67V17.5L5.5,12M13,6.43L18.57,12L13,17.57V14.74L15.74,12L13,9.26M5,3C3.89,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3H5Z",
  },
  {
    id: "A4E1DE1B-754D-4884-9902-8D5DDE2182B0",
    name: "code-parentheses",
    codepoint: "F172",
    aliases: [],
    tags: ["Developer / Languages"],
    author: "Cody",
    version: "1.5.54",
    path: "M17.62,3C19.13,5.27 20,8.55 20,12C20,15.44 19.13,18.72 17.62,21L16,19.96C17.26,18.07 18,15.13 18,12C18,8.87 17.26,5.92 16,4.03L17.62,3M6.38,3L8,4.04C6.74,5.92 6,8.87 6,12C6,15.13 6.74,18.08 8,19.96L6.38,21C4.87,18.73 4,15.45 4,12C4,8.55 4.87,5.27 6.38,3Z",
  },
  {
    id: "76686B91-00D8-4ADD-A502-8D1788C9C17B",
    name: "code-string",
    codepoint: "F173",
    aliases: [],
    tags: ["Developer / Languages"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M3,5C3,3.9 3.9,3 5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.89,21 3,20.1 3,19V5M12.5,11H11.5C10.67,11 10,10.33 10,9.5C10,8.67 10.67,8 11.5,8H12.5C13.33,8 14,8.67 14,9.5H16C16,7.57 14.43,6 12.5,6H11.5C9.57,6 8,7.57 8,9.5C8,11.43 9.57,13 11.5,13H12.5C13.33,13 14,13.67 14,14.5C14,15.33 13.33,16 12.5,16H11.5C10.67,16 10,15.33 10,14.5H8C8,16.43 9.57,18 11.5,18H12.5C14.43,18 16,16.43 16,14.5C16,12.57 14.43,11 12.5,11Z",
  },
  {
    id: "609A0AB0-05EE-4824-BD40-A4E78F4A74D3",
    name: "code-tags",
    codepoint: "F174",
    aliases: [],
    tags: ["Developer / Languages"],
    author: "Google",
    version: "1.5.54",
    path: "M14.6,16.6L19.2,12L14.6,7.4L16,6L22,12L16,18L14.6,16.6M9.4,16.6L4.8,12L9.4,7.4L8,6L2,12L8,18L9.4,16.6Z",
  },
  {
    id: "7F098441-8B1D-4FB1-88EC-95726397BA7C",
    name: "code-tags-check",
    codepoint: "F693",
    aliases: [],
    tags: ["Developer / Languages"],
    author: "Cody",
    version: "1.7.12",
    path: "M6.59,3.41L2,8L6.59,12.6L8,11.18L4.82,8L8,4.82L6.59,3.41M12.41,3.41L11,4.82L14.18,8L11,11.18L12.41,12.6L17,8L12.41,3.41M21.59,11.59L13.5,19.68L9.83,16L8.42,17.41L13.5,22.5L23,13L21.59,11.59Z",
  },
  {
    id: "FB9F6D89-8A07-407E-AD97-AAEF0E022585",
    name: "codepen",
    codepoint: "F175",
    aliases: [],
    tags: ["Brand / Logo", "Developer / Languages"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M15.09,12L12,14.08V14.09L8.91,12L12,9.92V9.92L15.09,12M12,2C11.84,2 11.68,2.06 11.53,2.15L2.5,8.11C2.27,8.22 2.09,8.43 2,8.67V14.92C2,15.33 2,15.33 2.15,15.53L11.53,21.86C11.67,21.96 11.84,22 12,22C12.16,22 12.33,21.95 12.47,21.85L21.85,15.5C22,15.33 22,15.33 22,14.92V8.67C21.91,8.42 21.73,8.22 21.5,8.1L12.47,2.15C12.32,2.05 12.16,2 12,2M16.58,13L19.59,15.04L12.83,19.6V15.53L16.58,13M19.69,8.9L16.58,11L12.83,8.47V4.38L19.69,8.9M20.33,10.47V13.53L18.07,12L20.33,10.47M7.42,13L11.17,15.54V19.6L4.41,15.04L7.42,13M4.31,8.9L11.17,4.39V8.5L7.42,11L4.31,8.9M3.67,10.5L5.93,12L3.67,13.54V10.5Z",
  },
  {
    id: "C95D04C5-F5EE-411A-88F7-A9872B2B4021",
    name: "coffee",
    codepoint: "F176",
    aliases: ["tea", "cup", "free-breakfast", "local-cafe"],
    tags: ["Food / Drink"],
    author: "Google",
    version: "1.5.54",
    path: "M2,21H20V19H2M20,8H18V5H20M20,3H4V13C4,15.21 5.79,17 8,17H14C16.21,17 18,15.21 18,13V10H20C21.1,10 22,9.1 22,8V5C22,3.89 21.1,3 20,3Z",
  },
  {
    id: "8994C73B-937C-4541-AAFF-6FA2CE0573DF",
    name: "coffee-outline",
    codepoint: "F6C9",
    aliases: ["tea-outline", "cup-outline"],
    tags: ["Food / Drink"],
    author: "Case Sandberg",
    version: "1.8.36",
    path: "M2,21V19H20V21H2M20,8V5H18V8H20M20,3C21.1,3 22,3.9 22,5V8C22,9.1 21.1,10 20,10H18V13C18,15.21 16.21,17 14,17H8C5.79,17 4,15.21 4,13V3H20M16,5H6V13C6,14.1 6.9,15 8,15H14C15.1,15 16,14.1 16,13V5Z",
  },
  {
    id: "8093CDE7-C795-4415-94C6-2EF40ED6D057",
    name: "coffee-to-go",
    codepoint: "F177",
    aliases: [],
    tags: ["Food / Drink"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M3,19V17H17L15.26,15.24L16.67,13.83L20.84,18L16.67,22.17L15.26,20.76L17,19H3M17,8V5H15V8H17M17,3C18.11,3 19,3.9 19,5V8C19,9.11 18.11,10 17,10H15V11C15,13.21 13.21,15 11,15H7C4.79,15 3,13.21 3,11V3H17Z",
  },
  {
    id: "2EF56130-ECE9-4432-B59E-36F646DE1C86",
    name: "cogs",
    codepoint: "F8D5",
    aliases: ["manufacturing"],
    tags: ["Settings"],
    author: "Google",
    version: "2.3.50",
    path: "M15.9,18.45C17.25,18.45 18.35,17.35 18.35,16C18.35,14.65 17.25,13.55 15.9,13.55C14.54,13.55 13.45,14.65 13.45,16C13.45,17.35 14.54,18.45 15.9,18.45M21.1,16.68L22.58,17.84C22.71,17.95 22.75,18.13 22.66,18.29L21.26,20.71C21.17,20.86 21,20.92 20.83,20.86L19.09,20.16C18.73,20.44 18.33,20.67 17.91,20.85L17.64,22.7C17.62,22.87 17.47,23 17.3,23H14.5C14.32,23 14.18,22.87 14.15,22.7L13.89,20.85C13.46,20.67 13.07,20.44 12.71,20.16L10.96,20.86C10.81,20.92 10.62,20.86 10.54,20.71L9.14,18.29C9.05,18.13 9.09,17.95 9.22,17.84L10.7,16.68L10.65,16L10.7,15.31L9.22,14.16C9.09,14.05 9.05,13.86 9.14,13.71L10.54,11.29C10.62,11.13 10.81,11.07 10.96,11.13L12.71,11.84C13.07,11.56 13.46,11.32 13.89,11.15L14.15,9.29C14.18,9.13 14.32,9 14.5,9H17.3C17.47,9 17.62,9.13 17.64,9.29L17.91,11.15C18.33,11.32 18.73,11.56 19.09,11.84L20.83,11.13C21,11.07 21.17,11.13 21.26,11.29L22.66,13.71C22.75,13.86 22.71,14.05 22.58,14.16L21.1,15.31L21.15,16L21.1,16.68M6.69,8.07C7.56,8.07 8.26,7.37 8.26,6.5C8.26,5.63 7.56,4.92 6.69,4.92C5.82,4.92 5.11,5.63 5.11,6.5C5.11,7.37 5.82,8.07 6.69,8.07M10.03,6.94L11,7.68C11.07,7.75 11.09,7.87 11.03,7.97L10.13,9.53C10.08,9.63 9.96,9.67 9.86,9.63L8.74,9.18L8,9.62L7.81,10.81C7.79,10.92 7.7,11 7.59,11H5.79C5.67,11 5.58,10.92 5.56,10.81L5.4,9.62L4.64,9.18L3.5,9.63C3.41,9.67 3.3,9.63 3.24,9.53L2.34,7.97C2.28,7.87 2.31,7.75 2.39,7.68L3.34,6.94L3.31,6.5L3.34,6.06L2.39,5.32C2.31,5.25 2.28,5.13 2.34,5.03L3.24,3.47C3.3,3.37 3.41,3.33 3.5,3.37L4.63,3.82L5.4,3.38L5.56,2.19C5.58,2.08 5.67,2 5.79,2H7.59C7.7,2 7.79,2.08 7.81,2.19L8,3.38L8.74,3.82L9.86,3.37C9.96,3.33 10.08,3.37 10.13,3.47L11.03,5.03C11.09,5.13 11.07,5.25 11,5.32L10.03,6.06L10.06,6.5L10.03,6.94Z",
  },
  {
    id: "8FD44CCD-5073-4C73-98BE-139F777F6E94",
    name: "collage",
    codepoint: "F640",
    aliases: ["auto-awesome-mosaic"],
    tags: [],
    author: "Google",
    version: "1.6.50",
    path: "M5,3C3.89,3 3,3.89 3,5V19C3,20.11 3.89,21 5,21H11V3M13,3V11H21V5C21,3.89 20.11,3 19,3M13,13V21H19C20.11,21 21,20.11 21,19V13",
  },
  {
    id: "F27490D2-F7BE-4B35-83E6-40D1F7247755",
    name: "color-helper",
    codepoint: "F179",
    aliases: ["colour-helper"],
    tags: ["Text / Content / Format", "Color"],
    author: "Google",
    version: "1.5.54",
    path: "M0,24H24V20H0V24Z",
  },
  {
    id: "B42FD735-27ED-47EC-887B-F5108774E6BC",
    name: "comment",
    codepoint: "F17A",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M9,22C8.45,22 8,21.55 8,21V18H4C2.9,18 2,17.1 2,16V4C2,2.89 2.9,2 4,2H20C21.1,2 22,2.9 22,4V16C22,17.1 21.1,18 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9Z",
  },
  {
    id: "E0D4328B-7A71-46E7-804B-DFC3753BEDF6",
    name: "comment-account",
    codepoint: "F17B",
    aliases: ["comment-user"],
    tags: ["Account / User"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M9,22C8.45,22 8,21.55 8,21V18H4C2.9,18 2,17.1 2,16V4C2,2.89 2.9,2 4,2H20C21.1,2 22,2.9 22,4V16C22,17.1 21.1,18 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9M16,14V13C16,11.67 13.33,11 12,11C10.67,11 8,11.67 8,13V14H16M12,6C10.9,6 10,6.9 10,8C10,9.1 10.9,10 12,10C13.1,10 14,9.1 14,8C14,6.9 13.1,6 12,6Z",
  },
  {
    id: "18A9FFE4-B768-4A8F-BD55-778C8E8C41FC",
    name: "comment-account-outline",
    codepoint: "F17C",
    aliases: ["comment-user-outline"],
    tags: ["Account / User"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M9,22C8.45,22 8,21.55 8,21V18H4C2.9,18 2,17.1 2,16V4C2,2.89 2.9,2 4,2H20C21.1,2 22,2.9 22,4V16C22,17.1 21.1,18 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9M10,16V19.08L13.08,16H20V4H4V16H10M16,14H8V13C8,11.67 10.67,11 12,11C13.33,11 16,11.67 16,13V14M12,6C13.1,6 14,6.9 14,8C14,9.1 13.1,10 12,10C10.9,10 10,9.1 10,8C10,6.9 10.9,6 12,6Z",
  },
  {
    id: "04CF8C3D-0D65-41CA-8D0D-53DD7EAB25B8",
    name: "comment-alert",
    codepoint: "F17D",
    aliases: ["comment-warning"],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M9,22C8.45,22 8,21.55 8,21V18H4C2.9,18 2,17.1 2,16V4C2,2.89 2.9,2 4,2H20C21.1,2 22,2.9 22,4V16C22,17.1 21.1,18 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9M13,10V6H11V10H13M13,14V12H11V14H13Z",
  },
  {
    id: "CBAD69A4-A6FF-4A8A-AA85-B5962910106E",
    name: "comment-alert-outline",
    codepoint: "F17E",
    aliases: ["comment-warning-outline"],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M9,22C8.45,22 8,21.55 8,21V18H4C2.9,18 2,17.1 2,16V4C2,2.89 2.9,2 4,2H20C21.1,2 22,2.9 22,4V16C22,17.1 21.1,18 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9M10,16V19.08L13.08,16H20V4H4V16H10M13,10H11V6H13V10M13,14H11V12H13V14Z",
  },
  {
    id: "AECA1A18-D8EA-4130-B33C-86D608E030BB",
    name: "comment-arrow-left",
    codepoint: "F9E0",
    aliases: ["comment-previous"],
    tags: [],
    author: "Michael Irigoyen",
    version: "2.5.94",
    path: "M9,22C8.45,22 8,21.55 8,21V18H4C2.9,18 2,17.1 2,16V4C2,2.89 2.9,2 4,2H20C21.11,2 22,2.9 22,4V16C22,17.11 21.11,18 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22H9M16.17,11.12V9.05H11.53L13.33,7.25L12.09,6L8,10.09L12.09,14.17L13.33,12.92L11.53,11.12H16.17Z",
  },
  {
    id: "192F008B-D02E-4C2A-A43F-058A19E41D30",
    name: "comment-arrow-left-outline",
    codepoint: "F9E1",
    aliases: ["comment-previous-outline"],
    tags: [],
    author: "Michael Irigoyen",
    version: "2.5.94",
    path: "M4,2C2.9,2 2,2.9 2,4V16C2,17.11 2.9,18 4,18H8V21C8,21.55 8.45,22 9,22H9.5V22C9.75,22 10,21.9 10.2,21.71L13.9,18H20C21.11,18 22,17.11 22,16V4C22,2.89 21.1,2 20,2H4M4,4H20V16H13.08L10,19.08V16H4V4M16.17,11.12V9.05H11.53L13.33,7.25L12.09,6L8,10.09L12.09,14.17L13.33,12.92L11.53,11.12H16.17Z",
  },
  {
    id: "256DE915-25D5-4777-AA1A-A432ABB6E039",
    name: "comment-arrow-right",
    codepoint: "F9E2",
    aliases: ["comment-next"],
    tags: [],
    author: "Michael Irigoyen",
    version: "2.5.94",
    path: "M9,22C8.45,22 8,21.55 8,21V18H4C2.9,18 2,17.1 2,16V4C2,2.89 2.9,2 4,2H20C21.11,2 22,2.9 22,4V16C22,17.11 21.11,18 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22H9M8,9.05V11.12H12.64L10.84,12.92L12.09,14.17L16.17,10.08L12.09,6L10.84,7.25L12.64,9.05H8Z",
  },
  {
    id: "E34BA65C-995B-4E2F-A40E-8833E55187FC",
    name: "comment-arrow-right-outline",
    codepoint: "F9E3",
    aliases: ["comment-next-outline"],
    tags: [],
    author: "Michael Irigoyen",
    version: "2.5.94",
    path: "M4,2C2.9,2 2,2.9 2,4V16C2,17.11 2.9,18 4,18H8V21C8,21.55 8.45,22 9,22H9.5V22C9.75,22 10,21.9 10.2,21.71L13.9,18H20C21.11,18 22,17.11 22,16V4C22,2.89 21.1,2 20,2H4M4,4H20V16H13.08L10,19.08V16H4V4M8,9.05V11.12H12.64L10.84,12.92L12.09,14.17L16.17,10.08L12.09,6L10.84,7.25L12.64,9.05H8Z",
  },
  {
    id: "5D2CEEF1-3F19-4AD2-8965-13DB365B0013",
    name: "comment-check",
    codepoint: "F17F",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M9,22C8.45,22 8,21.55 8,21V18H4C2.9,18 2,17.1 2,16V4C2,2.89 2.9,2 4,2H20C21.1,2 22,2.9 22,4V16C22,17.1 21.1,18 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9M10,15L18,7L16.59,5.58L10,12.17L7.41,9.59L6,11L10,15Z",
  },
  {
    id: "D9BBEE92-5775-4364-8ECD-89C0872BE79F",
    name: "comment-check-outline",
    codepoint: "F180",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M9,22C8.45,22 8,21.55 8,21V18H4C2.9,18 2,17.1 2,16V4C2,2.89 2.9,2 4,2H20C21.1,2 22,2.9 22,4V16C22,17.1 21.1,18 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9M10,16V19.08L13.08,16H20V4H4V16H10M16.5,8L11,13.5L7.5,10L8.91,8.59L11,10.67L15.09,6.59L16.5,8Z",
  },
  {
    id: "63AC824E-16A4-4FBE-A6DF-588DEBCA47C1",
    name: "comment-multiple",
    codepoint: "F85E",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.1.99",
    path: "M12,23C11.45,23 11,22.55 11,22V19H7C5.9,19 5,18.1 5,17V7C5,5.9 5.9,5 7,5H21C22.1,5 23,5.9 23,7V17C23,18.1 22.1,19 21,19H16.9L13.2,22.71C13,22.89 12.76,23 12.5,23H12M3,15H1V3C1,1.9 1.9,1 3,1H19V3H3V15Z",
  },
  {
    id: "A5FAC5DC-088F-485C-A885-FBBEEC70B352",
    name: "comment-multiple-outline",
    codepoint: "F181",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,23C11.45,23 11,22.55 11,22V19H7C5.9,19 5,18.1 5,17V7C5,5.89 5.9,5 7,5H21C22.1,5 23,5.9 23,7V17C23,18.1 22.1,19 21,19H16.9L13.2,22.71C13,22.9 12.75,23 12.5,23V23H12M13,17V20.08L16.08,17H21V7H7V17H13M3,15H1V3C1,1.9 1.9,1 3,1H19V3H3V15Z",
  },
  {
    id: "B1A0A26E-3E9C-4718-8A26-2837A981D9B5",
    name: "comment-outline",
    codepoint: "F182",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M9,22C8.45,22 8,21.55 8,21V18H4C2.9,18 2,17.1 2,16V4C2,2.89 2.9,2 4,2H20C21.1,2 22,2.9 22,4V16C22,17.1 21.1,18 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9M10,16V19.08L13.08,16H20V4H4V16H10Z",
  },
  {
    id: "6C595408-3938-4111-9566-7149810D4A73",
    name: "comment-plus",
    codepoint: "F9E4",
    aliases: [],
    tags: [],
    author: "Peter Noble",
    version: "2.5.94",
    path: "M9,22C8.45,22 8,21.55 8,21V18H4C2.9,18 2,17.1 2,16V4C2,2.89 2.9,2 4,2H20C21.1,2 22,2.9 22,4V16C22,17.1 21.1,18 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22H9M11,6V9H8V11H11V14H13V11H16V9H13V6H11Z",
  },
  {
    id: "813C3AFA-56D8-472B-8C1C-C365AC752663",
    name: "comment-plus-outline",
    codepoint: "F183",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M9,22C8.45,22 8,21.55 8,21V18H4C2.9,18 2,17.1 2,16V4C2,2.89 2.9,2 4,2H20C21.1,2 22,2.9 22,4V16C22,17.1 21.1,18 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9M10,16V19.08L13.08,16H20V4H4V16H10M11,6H13V9H16V11H13V14H11V11H8V9H11V6Z",
  },
  {
    id: "D07698E0-AB53-4E7A-9C25-9A25D1D5CDA9",
    name: "comment-processing",
    codepoint: "F184",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M9,22C8.45,22 8,21.55 8,21V18H4C2.9,18 2,17.1 2,16V4C2,2.89 2.9,2 4,2H20C21.1,2 22,2.9 22,4V16C22,17.1 21.1,18 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9M17,11V9H15V11H17M13,11V9H11V11H13M9,11V9H7V11H9Z",
  },
  {
    id: "0CDF5E61-25C4-4E30-8E16-32E4E7EDE705",
    name: "comment-processing-outline",
    codepoint: "F185",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M9,22C8.45,22 8,21.55 8,21V18H4C2.9,18 2,17.1 2,16V4C2,2.89 2.9,2 4,2H20C21.1,2 22,2.9 22,4V16C22,17.1 21.1,18 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9M10,16V19.08L13.08,16H20V4H4V16H10M17,11H15V9H17V11M13,11H11V9H13V11M9,11H7V9H9V11Z",
  },
  {
    id: "49412CCB-C5F6-460F-A2DB-76BCCB668BCC",
    name: "comment-question",
    codepoint: "F816",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "2.1.19",
    path: "M4,2H20C21.1,2 22,2.9 22,4V16C22,17.1 21.1,18 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9C8.45,22 8,21.55 8,21V18H4C2.9,18 2,17.1 2,16V4C2,2.89 2.9,2 4,2M12.19,5.5C11.3,5.5 10.59,5.68 10.05,6.04C9.5,6.4 9.22,7 9.27,7.69H11.24C11.24,7.41 11.34,7.2 11.5,7.06C11.7,6.92 11.92,6.85 12.19,6.85C12.5,6.85 12.77,6.93 12.95,7.11C13.13,7.28 13.22,7.5 13.22,7.8C13.22,8.08 13.14,8.33 13,8.54C12.83,8.76 12.62,8.94 12.36,9.08C11.84,9.4 11.5,9.68 11.29,9.92C11.1,10.16 11,10.5 11,11H13C13,10.72 13.05,10.5 13.14,10.32C13.23,10.15 13.4,10 13.66,9.85C14.12,9.64 14.5,9.36 14.79,9C15.08,8.63 15.23,8.24 15.23,7.8C15.23,7.1 14.96,6.54 14.42,6.12C13.88,5.71 13.13,5.5 12.19,5.5M11,12V14H13V12H11Z",
  },
  {
    id: "7BD335A6-C4A7-48F1-B04F-F1457B7B1F20",
    name: "comment-question-outline",
    codepoint: "F186",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M4,2C2.9,2 2,2.9 2,4V16C2,17.1 2.9,18 4,18H8V21C8,21.55 8.45,22 9,22H9.5V22C9.75,22 10,21.9 10.2,21.71L13.9,18H20C21.1,18 22,17.1 22,16V4C22,2.89 21.1,2 20,2H4M4,4H20V16H13.08L10,19.08V16H4V4M12.19,5.5C11.3,5.5 10.59,5.68 10.05,6.04C9.5,6.4 9.22,7 9.27,7.69C0.21,7.69 6.57,7.69 11.24,7.69C11.24,7.41 11.34,7.2 11.5,7.06C11.7,6.92 11.92,6.85 12.19,6.85C12.5,6.85 12.77,6.93 12.95,7.11C13.13,7.28 13.22,7.5 13.22,7.8C13.22,8.08 13.14,8.33 13,8.54C12.83,8.76 12.62,8.94 12.36,9.08C11.84,9.4 11.5,9.68 11.29,9.92C11.1,10.16 11,10.5 11,11H13C13,10.72 13.05,10.5 13.14,10.32C13.23,10.15 13.4,10 13.66,9.85C14.12,9.64 14.5,9.36 14.79,9C15.08,8.63 15.23,8.24 15.23,7.8C15.23,7.1 14.96,6.54 14.42,6.12C13.88,5.71 13.13,5.5 12.19,5.5M11,12V14H13V12H11Z",
  },
  {
    id: "834998BB-D7F4-41F3-86B8-5EE5631B524A",
    name: "comment-remove",
    codepoint: "F5DE",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M9,22C8.45,22 8,21.55 8,21V18H4C2.9,18 2,17.1 2,16V4C2,2.89 2.9,2 4,2H20C21.1,2 22,2.9 22,4V16C22,17.1 21.1,18 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9M9.41,6L8,7.41L10.59,10L8,12.59L9.41,14L12,11.41L14.59,14L16,12.59L13.41,10L16,7.41L14.59,6L12,8.59L9.41,6Z",
  },
  {
    id: "520544E5-1693-4084-BB9C-B6FA70204B2C",
    name: "comment-remove-outline",
    codepoint: "F187",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M9,22C8.45,22 8,21.55 8,21V18H4C2.9,18 2,17.1 2,16V4C2,2.89 2.9,2 4,2H20C21.1,2 22,2.9 22,4V16C22,17.1 21.1,18 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9M10,16V19.08L13.08,16H20V4H4V16H10M9.41,6L12,8.59L14.59,6L16,7.41L13.41,10L16,12.59L14.59,14L12,11.41L9.41,14L8,12.59L10.59,10L8,7.41L9.41,6Z",
  },
  {
    id: "483321DB-C7E5-4E48-B739-8500F6153446",
    name: "comment-text",
    codepoint: "F188",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M9,22C8.45,22 8,21.55 8,21V18H4C2.9,18 2,17.1 2,16V4C2,2.89 2.9,2 4,2H20C21.1,2 22,2.9 22,4V16C22,17.1 21.1,18 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9M5,5V7H19V5H5M5,9V11H13V9H5M5,13V15H15V13H5Z",
  },
  {
    id: "88EDEE2E-AB1B-4287-A082-E3B139F8E69A",
    name: "comment-text-multiple",
    codepoint: "F85F",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.1.99",
    path: "M3,15H1V3C1,1.9 1.9,1 3,1H19V3H3V15M12,23C11.45,23 11,22.55 11,22V19H7C5.9,19 5,18.1 5,17V7C5,5.9 5.9,5 7,5H21C22.1,5 23,5.9 23,7V17C23,18.1 22.1,19 21,19H16.9L13.2,22.71C13,22.89 12.76,23 12.5,23H12M9,9V11H19V9H9M9,13V15H17V13H9Z",
  },
  {
    id: "B7CBD1E2-9677-4D9B-B7BD-CA5493920BE6",
    name: "comment-text-multiple-outline",
    codepoint: "F860",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.1.99",
    path: "M12,23C11.45,23 11,22.55 11,22V19H7C5.9,19 5,18.1 5,17V7C5,5.9 5.9,5 7,5H21C22.1,5 23,5.9 23,7V17C23,18.1 22.1,19 21,19H16.9L13.2,22.71C13,22.89 12.76,23 12.5,23H12M13,17V20.08L16.08,17H21V7H7V17H13M3,15H1V3C1,1.9 1.9,1 3,1H19V3H3V15M9,9H19V11H9V9M9,13H17V15H9V13Z",
  },
  {
    id: "3D9E4543-670E-4434-8C82-3A80122ED4EE",
    name: "comment-text-outline",
    codepoint: "F189",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M9,22C8.45,22 8,21.55 8,21V18H4C2.9,18 2,17.1 2,16V4C2,2.89 2.9,2 4,2H20C21.1,2 22,2.9 22,4V16C22,17.1 21.1,18 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9M10,16V19.08L13.08,16H20V4H4V16H10M6,7H18V9H6V7M6,11H15V13H6V11Z",
  },
  {
    id: "A9786B48-6664-4170-B56C-6F2868D5000D",
    name: "compare",
    codepoint: "F18A",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M19,3H14V5H19V18L14,12V21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3M10,18H5L10,12M10,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H10V23H12V1H10V3Z",
  },
  {
    id: "8FE64B61-0FD6-4056-9A4F-E62408CE70FE",
    name: "compass",
    codepoint: "F18B",
    aliases: ["explore"],
    tags: ["Navigation"],
    author: "Google",
    version: "1.5.54",
    path: "M14.19,14.19L6,18L9.81,9.81L18,6M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M12,10.9C11.39,10.9 10.9,11.39 10.9,12C10.9,12.61 11.39,13.1 12,13.1C12.61,13.1 13.1,12.61 13.1,12C13.1,11.39 12.61,10.9 12,10.9Z",
  },
  {
    id: "EDA6D9AB-4AAE-4080-A1D3-78762666D7B1",
    name: "compass-outline",
    codepoint: "F18C",
    aliases: [],
    tags: ["Navigation"],
    author: "Gabriel",
    version: "1.5.54",
    path: "M7,17L10.2,10.2L17,7L13.8,13.8L7,17M12,11.1C11.5,11.1 11.1,11.5 11.1,12C11.1,12.5 11.5,12.9 12,12.9C12.5,12.9 12.9,12.5 12.9,12C12.9,11.5 12.5,11.1 12,11.1M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M12,4C7.58,4 4,7.58 4,12C4,16.42 7.58,20 12,20C16.42,20 20,16.42 20,12C20,7.58 16.42,4 12,4Z",
  },
  {
    id: "DCD0A183-A5DC-43BD-BC48-8FFF0CA0FA9C",
    name: "console",
    codepoint: "F18D",
    aliases: ["terminal"],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M20,19V7H4V19H20M20,3C21.1,3 22,3.9 22,5V19C22,20.1 21.1,21 20,21H4C2.9,21 2,20.1 2,19V5C2,3.89 2.9,3 4,3H20M13,17V15H18V17H13M9.58,13L5.57,9H8.4L11.7,12.3C12.09,12.69 12.09,13.33 11.7,13.72L8.42,17H5.59L9.58,13Z",
  },
  {
    id: "D6FF21C5-201A-43E0-B8AF-276A6BED653A",
    name: "console-line",
    codepoint: "F7B6",
    aliases: ["terminal-line"],
    tags: [],
    author: "Austin Andrews",
    version: "2.0.46",
    path: "M13,19V16H21V19H13M8.5,13L2.47,7H6.71L11.67,11.95C12.25,12.54 12.25,13.5 11.67,14.07L6.74,19H2.5L8.5,13Z",
  },
  {
    id: "19A41CF5-CA4E-411C-8C34-14895B4B90DD",
    name: "console-network",
    codepoint: "F8A8",
    aliases: ["terminal-network"],
    tags: [],
    author: "Michael Richins",
    version: "2.2.43",
    path: "M17,2C18.1,2 19,2.9 19,4V14C19,15.1 18.1,16 17,16H13V18H14C14.55,18 15,18.45 15,19H22V21H15C15,21.55 14.55,22 14,22H10C9.45,22 9,21.55 9,21H2V19H9C9,18.45 9.45,18 10,18H11V16H7C5.9,16 5,15.1 5,14V4C5,2.9 5.9,2 7,2H17M7,6L11,10L7,14H9.85L13.13,10.72C13.5,10.33 13.5,9.7 13.13,9.3L9.83,6H7M17,12H14V14H17V12Z",
  },
  {
    id: "5A68EA78-9792-4223-808D-17E5205765E6",
    name: "contacts",
    codepoint: "F6CA",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.8.36",
    path: "M20,0H4V2H20V0M4,24H20V22H4V24M20,4H4C2.9,4 2,4.9 2,6V18C2,19.1 2.9,20 4,20H20C21.1,20 22,19.1 22,18V6C22,4.9 21.1,4 20,4M12,6.75C13.24,6.75 14.25,7.76 14.25,9C14.25,10.24 13.24,11.25 12,11.25C10.76,11.25 9.75,10.24 9.75,9C9.75,7.76 10.76,6.75 12,6.75M17,17H7V15.5C7,13.83 10.33,13 12,13C13.67,13 17,13.83 17,15.5V17Z",
  },
  {
    id: "2B3B8FC2-C8AB-40AF-9B3F-AFFC93482676",
    name: "content-copy",
    codepoint: "F18F",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M19,21H8V7H19M19,5H8C6.9,5 6,5.9 6,7V21C6,22.1 6.9,23 8,23H19C20.1,23 21,22.1 21,21V7C21,5.9 20.1,5 19,5M16,1H4C2.9,1 2,1.9 2,3V17H4V3H16V1Z",
  },
  {
    id: "D4028362-37C3-4EED-BE0B-C78927C3F55D",
    name: "content-cut",
    codepoint: "F190",
    aliases: ["scissors", "clip"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M19,3L13,9L15,11L22,4V3M12,12.5C11.72,12.5 11.5,12.28 11.5,12C11.5,11.72 11.72,11.5 12,11.5C12.28,11.5 12.5,11.72 12.5,12C12.5,12.28 12.28,12.5 12,12.5M6,20C4.9,20 4,19.1 4,18C4,16.89 4.9,16 6,16C7.1,16 8,16.9 8,18C8,19.11 7.1,20 6,20M6,8C4.9,8 4,7.1 4,6C4,4.89 4.9,4 6,4C7.1,4 8,4.9 8,6C8,7.11 7.1,8 6,8M9.64,7.64C9.87,7.14 10,6.59 10,6C10,3.79 8.21,2 6,2C3.79,2 2,3.79 2,6C2,8.21 3.79,10 6,10C6.59,10 7.14,9.87 7.64,9.64L10,12L7.64,14.36C7.14,14.13 6.59,14 6,14C3.79,14 2,15.79 2,18C2,20.21 3.79,22 6,22C8.21,22 10,20.21 10,18C10,17.41 9.87,16.86 9.64,16.36L12,14L19,21H22V20L9.64,7.64Z",
  },
  {
    id: "B1A86989-2CB4-47DC-BC93-67A077792F72",
    name: "content-duplicate",
    codepoint: "F191",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M11,17H4C2.9,17 2,16.1 2,15V3C2,1.9 2.9,1 4,1H16V3H4V15H11V13L15,16L11,19V17M19,21V7H8V13H6V7C6,5.9 6.9,5 8,5H19C20.1,5 21,5.9 21,7V21C21,22.1 20.1,23 19,23H8C6.9,23 6,22.1 6,21V19H8V21H19Z",
  },
  {
    id: "75856C98-A0D6-4C78-A323-BD170B6E6094",
    name: "content-paste",
    codepoint: "F192",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M19,20H5V4H7V7H17V4H19M12,2C12.55,2 13,2.45 13,3C13,3.55 12.55,4 12,4C11.45,4 11,3.55 11,3C11,2.45 11.45,2 12,2M19,2H14.82C14.4,0.84 13.3,0 12,0C10.7,0 9.6,0.84 9.18,2H5C3.9,2 3,2.9 3,4V20C3,21.1 3.9,22 5,22H19C20.1,22 21,21.1 21,20V4C21,2.9 20.1,2 19,2Z",
  },
  {
    id: "29F946C0-CA58-4287-AF0B-964961E5CC2C",
    name: "content-save",
    codepoint: "F193",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M15,9H5V5H15M12,19C10.34,19 9,17.66 9,16C9,14.34 10.34,13 12,13C13.66,13 15,14.34 15,16C15,17.66 13.66,19 12,19M17,3H5C3.89,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V7L17,3Z",
  },
  {
    id: "B9BE7889-D858-41A1-AB4E-9C58325261E9",
    name: "content-save-all",
    codepoint: "F194",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M17,7V3H7V7H17M14,17C15.66,17 17,15.66 17,14C17,12.34 15.66,11 14,11C12.34,11 11,12.34 11,14C11,15.66 12.34,17 14,17M19,1L23,5V17C23,18.1 22.1,19 21,19H7C5.89,19 5,18.1 5,17V3C5,1.9 5.9,1 7,1H19M1,7H3V21H17V23H3C1.9,23 1,22.1 1,21V7Z",
  },
  {
    id: "707F4114-BD2F-4601-82C4-CFB6B2D2F359",
    name: "content-save-outline",
    codepoint: "F817",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "2.1.19",
    path: "M15,5V9H5V19H9.35C8.5,18.27 8,17.19 8,16C8,13.79 9.79,12 12,12C14.21,12 16,13.79 16,16C16,17.19 15.5,18.27 14.65,19H19V7.83L16.17,5H15M5,7H13V5H5V7M17,3L21,7V19C21,20.1 20.1,21 19,21H5C3.89,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3H17M12,14C10.9,14 10,14.9 10,16C10,17.1 10.9,18 12,18C13.1,18 14,17.1 14,16C14,14.9 13.1,14 12,14Z",
  },
  {
    id: "67E755F6-209A-41EF-98C5-423739A3AC10",
    name: "content-save-settings",
    codepoint: "F61B",
    aliases: [],
    tags: ["Settings"],
    author: "Cody",
    version: "1.6.50",
    path: "M15,8V4H5V8H15M12,18C13.66,18 15,16.66 15,15C15,13.34 13.66,12 12,12C10.34,12 9,13.34 9,15C9,16.66 10.34,18 12,18M17,2L21,6V18C21,19.1 20.1,20 19,20H5C3.89,20 3,19.1 3,18V4C3,2.9 3.9,2 5,2H17M11,22H13V24H11V22M7,22H9V24H7V22M15,22H17V24H15V22Z",
  },
  {
    id: "B50D388A-4647-4780-83E7-2C5AD8375FB9",
    name: "contrast",
    codepoint: "F195",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M4.38,20.9C3.78,20.71 3.3,20.23 3.1,19.63L19.63,3.1C20.23,3.3 20.71,3.78 20.9,4.38L4.38,20.9M20,16V18H13V16H20M3,6H6V3H8V6H11V8H8V11H6V8H3V6Z",
  },
  {
    id: "B7FCC914-C6E9-4919-8574-F0161C2CF28D",
    name: "contrast-box",
    codepoint: "F196",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M17,15.5H12V17H17M19,19H5L19,5M5.5,7.5H7.5V5.5H9V7.5H11V9H9V11H7.5V9H5.5M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3Z",
  },
  {
    id: "A7CBFD5D-FDFD-4202-A290-840219A79F2F",
    name: "contrast-circle",
    codepoint: "F197",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M12,20C9.79,20 7.79,19.1 6.34,17.66L17.66,6.34C19.1,7.79 20,9.79 20,12C20,16.42 16.42,20 12,20M6,8H8V6H9.5V8H11.5V9.5H9.5V11.5H8V9.5H6M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M12,16H17V14.5H12V16Z",
  },
  {
    id: "8E3FB537-B293-41A6-B6C5-B2BE927091F5",
    name: "cookie",
    codepoint: "F198",
    aliases: [],
    tags: ["Food / Drink"],
    author: "Google",
    version: "1.5.54",
    path: "M12,3C7.03,3 3,7.03 3,12C3,16.97 7.03,21 12,21C16.97,21 21,16.97 21,12C21,11.5 20.96,11 20.87,10.5C20.6,10 20,10 20,10H18V9C18,8 17,8 17,8H15V7C15,6 14,6 14,6H13V4C13,3 12,3 12,3M9.5,6C10.33,6 11,6.67 11,7.5C11,8.33 10.33,9 9.5,9C8.67,9 8,8.33 8,7.5C8,6.67 8.67,6 9.5,6M6.5,10C7.33,10 8,10.67 8,11.5C8,12.33 7.33,13 6.5,13C5.67,13 5,12.33 5,11.5C5,10.67 5.67,10 6.5,10M11.5,11C12.33,11 13,11.67 13,12.5C13,13.33 12.33,14 11.5,14C10.67,14 10,13.33 10,12.5C10,11.67 10.67,11 11.5,11M16.5,13C17.33,13 18,13.67 18,14.5C18,15.33 17.33,16 16.5,16H16.5C15.67,16 15,15.33 15,14.5H15C15,13.67 15.67,13 16.5,13M11,16C11.83,16 12.5,16.67 12.5,17.5C12.5,18.33 11.83,19 11,19C10.17,19 9.5,18.33 9.5,17.5C9.5,16.67 10.17,16 11,16Z",
  },
  {
    id: "34B43A77-9873-4723-AA65-45D42992748E",
    name: "copyright",
    codepoint: "F5E6",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M10.08,10.86C10.13,10.53 10.24,10.24 10.38,10C10.5,9.74 10.72,9.53 10.97,9.37C11.21,9.22 11.5,9.15 11.88,9.14C12.11,9.15 12.32,9.19 12.5,9.27C12.71,9.36 12.89,9.5 13.03,9.63C13.17,9.78 13.28,9.96 13.37,10.16C13.46,10.36 13.5,10.58 13.5,10.8H15.3C15.28,10.33 15.19,9.9 15,9.5C14.85,9.12 14.62,8.78 14.32,8.5C14,8.22 13.66,8 13.24,7.84C12.82,7.68 12.36,7.61 11.85,7.61C11.2,7.61 10.63,7.72 10.15,7.95C9.67,8.18 9.27,8.5 8.95,8.87C8.63,9.26 8.39,9.71 8.24,10.23C8.09,10.75 8,11.29 8,11.87V12.14C8,12.72 8.08,13.26 8.23,13.78C8.38,14.3 8.62,14.75 8.94,15.13C9.26,15.5 9.66,15.82 10.14,16.04C10.62,16.26 11.19,16.38 11.84,16.38C12.31,16.38 12.75,16.3 13.16,16.15C13.57,16 13.93,15.79 14.24,15.5C14.55,15.25 14.8,14.94 15,14.58C15.16,14.22 15.27,13.84 15.28,13.43H13.5C13.5,13.64 13.43,13.83 13.34,14C13.25,14.19 13.13,14.34 13,14.47C12.83,14.6 12.66,14.7 12.46,14.77C12.27,14.84 12.07,14.86 11.86,14.87C11.5,14.86 11.2,14.79 10.97,14.64C10.72,14.5 10.5,14.27 10.38,14C10.24,13.77 10.13,13.47 10.08,13.14C10.03,12.81 10,12.47 10,12.14V11.87C10,11.5 10.03,11.19 10.08,10.86M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20Z",
  },
  {
    id: "C3F97D60-41A7-49A3-A8B7-C63D724B12FF",
    name: "cordova",
    codepoint: "F957",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Contributors",
    version: "2.4.85",
    path: "M20.18,21.55H16.94L17.17,18.82H15.58L15.35,21.55H8.65L8.42,18.82H6.83L7.06,21.55H3.82L2,9.73L6.55,2.45H17.45L22,9.73L20.18,21.55M16.55,6.09H13.62L13.82,7.45H10.18L10.38,6.09H7.45L5.64,9.73L6.55,17H17.45L18.36,9.73L16.55,6.09M14.95,14.59C14.7,14.59 14.5,13.83 14.5,12.9C14.5,11.96 14.7,11.2 14.95,11.2C15.21,11.2 15.41,11.96 15.41,12.9C15.41,13.83 15.21,14.59 14.95,14.59M9.22,14.73C8.96,14.73 8.76,13.97 8.76,13.04C8.76,12.1 8.96,11.35 9.22,11.35C9.47,11.35 9.67,12.1 9.67,13.04C9.67,13.97 9.47,14.73 9.22,14.73Z",
  },
  {
    id: "B49614ED-B7AB-4123-BD9C-B50CE119C76C",
    name: "corn",
    codepoint: "F7B7",
    aliases: [],
    tags: ["Agriculture", "Food / Drink"],
    author: "Thomas Hunsaker",
    version: "2.0.46",
    path: "M11,12H8.82C9.62,12.5 10.35,13.07 11,13.68V12M7,11C7.27,5.88 9.37,2 12,2C14.66,2 16.77,5.94 17,11.12C18.5,10.43 20.17,10 22,10C16.25,12.57 18.25,22 12,22C6,22 7.93,12.57 2,10C3.82,10 5.5,10.4 7,11M11,11V9H8.24L8.03,11H11M11,8V6H9.05C8.8,6.6 8.6,7.27 8.43,8H11M11,5V3.3C10.45,3.63 9.95,4.22 9.5,5H11M12,3V5H13V6H12V8H14V9H12V11H15V12H12V14H14V15H12.23C13.42,16.45 14.15,18 14.32,19.23C15.31,17.56 15.96,14.84 16,11.76C15.94,7 14.13,3 12,3Z",
  },
  {
    id: "F789F2E4-022E-4A5A-B548-30D21BC3A7F6",
    name: "counter",
    codepoint: "F199",
    aliases: [],
    tags: [],
    author: "Christopher Schreiner",
    version: "1.5.54",
    path: "M4,4H20C21.1,4 22,4.9 22,6V18C22,19.1 21.1,20 20,20H4C2.9,20 2,19.1 2,18V6C2,4.9 2.9,4 4,4M4,6V18H11V6H4M20,18V6H18.76C19,6.54 18.95,7.07 18.95,7.13C18.88,7.8 18.41,8.5 18.24,8.75L15.91,11.3L19.23,11.28L19.24,12.5L14.04,12.47L14,11.47C14,11.47 17.05,8.24 17.2,7.95C17.34,7.67 17.91,6 16.5,6C15.27,6.05 15.41,7.3 15.41,7.3L13.87,7.31C13.87,7.31 13.88,6.65 14.25,6H13V18H15.58L15.57,17.14L16.54,17.13C16.54,17.13 17.45,16.97 17.46,16.08C17.5,15.08 16.65,15.08 16.5,15.08C16.37,15.08 15.43,15.13 15.43,15.95H13.91C13.91,15.95 13.95,13.89 16.5,13.89C19.1,13.89 18.96,15.91 18.96,15.91C18.96,15.91 19,17.16 17.85,17.63L18.37,18H20M8.92,16H7.42V10.2L5.62,10.76V9.53L8.76,8.41H8.92V16Z",
  },
  {
    id: "1D459B7E-A98C-4E02-929B-FA0BA329B97F",
    name: "cow",
    codepoint: "F19A",
    aliases: [],
    tags: ["Animal", "Agriculture"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M10.5,18C10.78,18 11,18.22 11,18.5C11,18.78 10.78,19 10.5,19C10.22,19 10,18.78 10,18.5C10,18.22 10.22,18 10.5,18M13.5,18C13.78,18 14,18.22 14,18.5C14,18.78 13.78,19 13.5,19C13.22,19 13,18.78 13,18.5C13,18.22 13.22,18 13.5,18M10,11C10.55,11 11,11.45 11,12C11,12.55 10.55,13 10,13C9.45,13 9,12.55 9,12C9,11.45 9.45,11 10,11M14,11C14.55,11 15,11.45 15,12C15,12.55 14.55,13 14,13C13.45,13 13,12.55 13,12C13,11.45 13.45,11 14,11M18,18C18,20.21 15.31,22 12,22C8.69,22 6,20.21 6,18C6,17.1 6.45,16.27 7.2,15.6C6.45,14.6 6,13.35 6,12L6.12,10.78C5.58,10.93 4.93,10.93 4.4,10.78C3.38,10.5 1.84,9.35 2.07,8.55C2.3,7.75 4.21,7.6 5.23,7.9C5.82,8.07 6.45,8.5 6.82,8.96L7.39,8.15C6.79,7.05 7,4 10,3L9.91,3.14V3.14C9.63,3.58 8.91,4.97 9.67,6.47C10.39,6.17 11.17,6 12,6C12.83,6 13.61,6.17 14.33,6.47C15.09,4.97 14.37,3.58 14.09,3.14L14,3C17,4 17.21,7.05 16.61,8.15L17.18,8.96C17.55,8.5 18.18,8.07 18.77,7.9C19.79,7.6 21.7,7.75 21.93,8.55C22.16,9.35 20.62,10.5 19.6,10.78C19.07,10.93 18.42,10.93 17.88,10.78L18,12C18,13.35 17.55,14.6 16.8,15.6C17.55,16.27 18,17.1 18,18M12,16C9.79,16 8,16.9 8,18C8,19.1 9.79,20 12,20C14.21,20 16,19.1 16,18C16,16.9 14.21,16 12,16M12,14C13.12,14 14.17,14.21 15.07,14.56C15.65,13.87 16,13 16,12C16,9.79 14.21,8 12,8C9.79,8 8,9.79 8,12C8,13 8.35,13.87 8.93,14.56C9.83,14.21 10.88,14 12,14M14.09,3.14V3.14Z",
  },
  {
    id: "8C0FE6E3-3D82-4FCA-9CCC-73CA8C5299D1",
    name: "crane",
    codepoint: "F861",
    aliases: [],
    tags: [],
    author: "Michael Irigoyen",
    version: "2.1.99",
    path: "M20,6V5C20,4.45 19.55,4 19,4H9V3H6V4H5V6H6V15H5V13H3V15H2V17H3V21H5V17H10V21H12V19.92L12,17H13V15H12V13H10V15H9V6H17V10.62C16.53,10.79 16.19,11.23 16.19,11.76C16.19,12.2 16.43,12.6 16.8,12.82V14H17.42C17.76,14 18.03,14.28 18.03,14.62C18.03,14.96 17.76,15.24 17.42,15.24C17.2,15.24 17,15.12 16.89,14.93C16.71,14.64 16.34,14.54 16.05,14.71C15.75,14.87 15.65,15.25 15.82,15.55C16.15,16.11 16.76,16.47 17.42,16.47C18.43,16.47 19.26,15.64 19.26,14.62C19.26,13.84 18.76,13.14 18.03,12.88V12.82C18.41,12.6 18.65,12.2 18.65,11.76C18.65,11.3 18.38,10.91 18,10.7V6H20M8,13.66L7,14.66V13.24L8,12.24V13.66M8,10.71L7,11.71V10.29L8,9.29V10.71M7,8.71V7.29L8,6.29V7.71L7,8.71Z",
  },
  {
    id: "598B7931-3DF8-4CFA-A6E6-80550CA31372",
    name: "creation",
    codepoint: "F1C9",
    aliases: ["auto-awesome"],
    tags: [],
    author: "Google",
    version: "1.7.12",
    path: "M19,1L17.74,3.75L15,5L17.74,6.26L19,9L20.25,6.26L23,5L20.25,3.75M9,4L6.5,9.5L1,12L6.5,14.5L9,20L11.5,14.5L17,12L11.5,9.5M19,15L17.74,17.74L15,19L17.74,20.25L19,23L20.25,20.25L23,19L20.25,17.74",
  },
  {
    id: "A121DBBB-C9E6-4534-AA7B-F59496787BD2",
    name: "credit-card",
    codepoint: "F19B",
    aliases: ["payment"],
    tags: ["Shopping", "Banking"],
    author: "Google",
    version: "1.5.54",
    path: "M20,8H4V6H20M20,18H4V12H20M20,4H4C2.89,4 2,4.89 2,6V18C2,19.1 2.9,20 4,20H20C21.1,20 22,19.1 22,18V6C22,4.89 21.1,4 20,4Z",
  },
  {
    id: "D7C8ADB6-B7C9-4653-9EA7-EB98552304BA",
    name: "credit-card-multiple",
    codepoint: "F19C",
    aliases: [],
    tags: ["Banking"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M21,8V6H7V8H21M21,16V11H7V16H21M21,4C22.1,4 23,4.9 23,6V16C23,17.1 22.1,18 21,18H7C5.89,18 5,17.1 5,16V6C5,4.89 5.89,4 7,4H21M3,20H18V22H3C1.9,22 1,21.1 1,20V9H3V20Z",
  },
  {
    id: "CD527CB6-15F0-41BF-BF50-2BCB8B6C769F",
    name: "credit-card-off",
    codepoint: "F5E4",
    aliases: [],
    tags: ["Banking"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M0.93,4.2L2.21,2.93L20,20.72L18.73,22L16.73,20H4C2.89,20 2,19.1 2,18V6C2,5.78 2.04,5.57 2.11,5.38L0.93,4.2M20,8V6H7.82L5.82,4H20C21.1,4 22,4.9 22,6V18C22,18.6 21.74,19.13 21.32,19.5L19.82,18H20V12H13.82L9.82,8H20M4,8H4.73L4,7.27V8M4,12V18H14.73L8.73,12H4Z",
  },
  {
    id: "FA914D65-0F2C-463D-A54F-9B0DE9FBEED3",
    name: "credit-card-plus",
    codepoint: "F675",
    aliases: [],
    tags: ["Banking"],
    author: "Austin Andrews",
    version: "1.7.12",
    path: "M21,18H24V20H21V23H19V20H16V18H19V15H21V18M19,8V6H3V8H19M19,12H3V18H14V20H3C1.89,20 1,19.1 1,18V6C1,4.89 1.89,4 3,4H19C20.1,4 21,4.9 21,6V13H19V12Z",
  },
  {
    id: "CF494E4E-F1FC-411D-87FD-933CC17EE08C",
    name: "credit-card-scan",
    codepoint: "F19D",
    aliases: [],
    tags: ["Banking"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M2,4H6V2H2C0.9,2 0,2.9 0,4V8H2V4M22,2H18V4H22V8H24V4C24,2.9 23.1,2 22,2M2,16H0V20C0,21.1 0.9,22 2,22H6V20H2V16M22,20H18V22H22C23.1,22 24,21.1 24,20V16H22V20M4,8V16C4,17.1 4.9,18 6,18H18C19.1,18 20,17.1 20,16V8C20,6.9 19.1,6 18,6H6C4.9,6 4,6.9 4,8M6,16V12H18V16H6M18,8V10H6V8H18Z",
  },
  {
    id: "8EF337DF-4858-4BC2-8C48-BD0911AF0FEB",
    name: "credit-card-settings",
    codepoint: "F8D6",
    aliases: ["payment-settings"],
    tags: ["Banking", "Settings"],
    author: "Peter Noble",
    version: "2.3.50",
    path: "M20,8H4V6H20M20,18H4V12H20M20,4H4C2.89,4 2,4.89 2,6V18C2,19.1 2.9,20 4,20H20C21.1,20 22,19.1 22,18V6C22,4.89 21.1,4 20,4M7,22H9V24H7V22M11,22H13V24H11V22M15,22H17V24H15V22Z",
  },
  {
    id: "FA68ACCA-389F-453E-B886-FF3DAFE10530",
    name: "crop",
    codepoint: "F19E",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M7,17V1H5V5H1V7H5V17C5,18.1 5.9,19 7,19H17V23H19V19H23V17M17,15H19V7C19,5.89 18.1,5 17,5H9V7H17V15Z",
  },
  {
    id: "17AB799B-F531-4800-A7DE-23C5D95238F4",
    name: "crop-free",
    codepoint: "F19F",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M19,3H15V5H19V9H21V5C21,3.89 20.1,3 19,3M19,19H15V21H19C20.1,21 21,20.1 21,19V15H19M5,15H3V19C3,20.1 3.9,21 5,21H9V19H5M3,5V9H5V5H9V3H5C3.9,3 3,3.9 3,5Z",
  },
  {
    id: "DE641C3F-FEF6-4764-A276-F6FECFE031DA",
    name: "crop-landscape",
    codepoint: "F1A0",
    aliases: ["crop-5-4"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M19,17H5V7H19M19,5H5C3.9,5 3,5.9 3,7V17C3,18.1 3.9,19 5,19H19C20.1,19 21,18.1 21,17V7C21,5.89 20.1,5 19,5Z",
  },
  {
    id: "02E45E84-72D2-4FE1-BF98-6A9521E31A8A",
    name: "crop-portrait",
    codepoint: "F1A1",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M17,19H7V5H17M17,3H7C5.9,3 5,3.9 5,5V19C5,20.1 5.9,21 7,21H17C18.1,21 19,20.1 19,19V5C19,3.89 18.1,3 17,3Z",
  },
  {
    id: "03774672-2612-4A56-9E32-69060B32B94C",
    name: "crop-rotate",
    codepoint: "F695",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.7.12",
    path: "M7.47,21.5C4.2,19.93 1.86,16.76 1.5,13H0C0.5,19.16 5.66,24 11.95,24C12.18,24 12.39,24 12.61,23.97L8.8,20.15L7.47,21.5M12.05,0C11.82,0 11.61,0 11.39,0.04L15.2,3.85L16.53,2.5C19.8,4.07 22.14,7.24 22.5,11H24C23.5,4.84 18.34,0 12.05,0M16,14H18V8C18,6.89 17.1,6 16,6H10V8H16V14M8,16V4H6V6H4V8H6V16C6,17.1 6.9,18 8,18H16V20H18V18H20V16H8Z",
  },
  {
    id: "72BA6354-04A5-4BE9-A84C-843B9441164E",
    name: "crop-square",
    codepoint: "F1A2",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M18,18H6V6H18M18,4H6C4.9,4 4,4.9 4,6V18C4,19.1 4.9,20 6,20H18C19.1,20 20,19.1 20,18V6C20,4.89 19.1,4 18,4Z",
  },
  {
    id: "33845FDE-0003-4780-8DC9-07FC29D46599",
    name: "crosshairs",
    codepoint: "F1A3",
    aliases: ["gps-not-fixed", "location-searching"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M3.05,13H1V11H3.05C3.5,6.83 6.83,3.5 11,3.05V1H13V3.05C17.17,3.5 20.5,6.83 20.95,11H23V13H20.95C20.5,17.17 17.17,20.5 13,20.95V23H11V20.95C6.83,20.5 3.5,17.17 3.05,13M12,5C8.13,5 5,8.13 5,12C5,15.87 8.13,19 12,19C15.87,19 19,15.87 19,12C19,8.13 15.87,5 12,5Z",
  },
  {
    id: "D3A1EC2E-98D5-46B6-BF33-DECBBAACEFBE",
    name: "crosshairs-gps",
    codepoint: "F1A4",
    aliases: ["gps-fixed", "my-location"],
    tags: ["Navigation"],
    author: "Google",
    version: "1.5.54",
    path: "M12,8C14.21,8 16,9.79 16,12C16,14.21 14.21,16 12,16C9.79,16 8,14.21 8,12C8,9.79 9.79,8 12,8M3.05,13H1V11H3.05C3.5,6.83 6.83,3.5 11,3.05V1H13V3.05C17.17,3.5 20.5,6.83 20.95,11H23V13H20.95C20.5,17.17 17.17,20.5 13,20.95V23H11V20.95C6.83,20.5 3.5,17.17 3.05,13M12,5C8.13,5 5,8.13 5,12C5,15.87 8.13,19 12,19C15.87,19 19,15.87 19,12C19,8.13 15.87,5 12,5Z",
  },
  {
    id: "266349FD-1B26-4BCD-A682-D25C4469B682",
    name: "crown",
    codepoint: "F1A5",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M5,16L3,5L8.5,12L12,5L15.5,12L21,5L19,16H5M19,19C19,19.55 18.55,20 18,20H6C5.45,20 5,19.55 5,19V18H19V19Z",
  },
  {
    id: "803712F9-6CAD-47C9-8B54-08B134949FB3",
    name: "cryengine",
    codepoint: "F958",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Contributors",
    version: "2.4.85",
    path: "M23.03,12.4M23.03,12.5V12.5C23,13 20.91,15.23 17.82,16.24C14.05,17.5 7.97,17.03 7.97,12.3C7.97,10.08 9.78,8.27 12,8.27C14.25,8.27 16.05,10.09 16.05,12.31C16.05,13.39 15.58,14.44 14.87,15.18C15.54,15.17 17.94,15 20.21,13.12C20.46,12.88 20.62,12.68 20.69,12.55C20.71,12.5 20.74,12.46 20.73,12.4C20.73,11.92 18.12,8.19 12.72,7.12C19.22,7.46 23,11.32 23.03,12.4V12.5H23.03M12,10C10.74,10 9.71,11.04 9.71,12.3C9.71,13.57 10.74,14.59 12,14.59C13.27,14.59 14.29,13.57 14.29,12.3C14.29,11.04 13.27,10 12,10M3.31,12.34C3.31,12.34 3.31,12.31 3.31,12.42V12.42C3.41,12.94 4.82,15.41 10.28,16.88C3.96,16.37 1.12,13.28 1.04,12.42H1.03C1.03,12.31 1.03,12.36 1.03,12.35C1.03,11.5 4.96,7.58 10.92,7.15C6.14,8.26 3.31,11.87 3.31,12.34V12.34Z",
  },
  {
    id: "64E19922-572B-41F8-9139-BE6CBC8A0F80",
    name: "cube",
    codepoint: "F1A6",
    aliases: [],
    tags: ["Shape"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5M12,4.15L6.04,7.5L12,10.85L17.96,7.5L12,4.15Z",
  },
  {
    id: "11B7F7B5-8813-48DE-9469-B1159355DDC3",
    name: "cube-outline",
    codepoint: "F1A7",
    aliases: [],
    tags: ["Shape"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5M12,4.15L6.04,7.5L12,10.85L17.96,7.5L12,4.15M5,15.91L11,19.29V12.58L5,9.21V15.91M19,15.91V9.21L13,12.58V19.29L19,15.91Z",
  },
  {
    id: "F0726D57-782C-44E8-A404-336480FC9E7B",
    name: "cube-send",
    codepoint: "F1A8",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M16,4L9,8.04V15.96L16,20L23,15.96V8.04M16,6.31L19.8,8.5L16,10.69L12.21,8.5M0,7V9H7V7M11,10.11L15,12.42V17.11L11,14.81M21,10.11V14.81L17,17.11V12.42M2,11V13H7V11M4,15V17H7V15",
  },
  {
    id: "A22472A9-D83E-4234-AAF0-F60AFB7C57DB",
    name: "cube-unfolded",
    codepoint: "F1A9",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M6,9V4H13V9H23V16H18V21H11V16H1V9H6M16,16H13V19H16V16M8,9H11V6H8V9M6,14V11H3V14H6M18,11V14H21V11H18M13,11V14H16V11H13M8,11V14H11V11H8Z",
  },
  {
    id: "D5DA2C54-C8D0-469F-99A9-C8DB9D3A6F15",
    name: "cup",
    codepoint: "F1AA",
    aliases: [],
    tags: ["Food / Drink"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M18.32,8H5.67L5.23,4H18.77M3,2L5,20.23C5.13,21.23 5.97,22 7,22H17C18,22 18.87,21.23 19,20.23L21,2H3Z",
  },
  {
    id: "FD336A31-52C0-41AF-A0F3-BA475DEA1A54",
    name: "cup-off",
    codepoint: "F5E5",
    aliases: [],
    tags: ["Food / Drink"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M1,4.27L2.28,3L21,21.72L19.73,23L18.27,21.54C17.93,21.83 17.5,22 17,22H7C5.97,22 5.13,21.23 5,20.23L3.53,6.8L1,4.27M18.32,8L18.77,4H5.82L3.82,2H21L19.29,17.47L9.82,8H18.32Z",
  },
  {
    id: "AC4AD054-775A-4D59-BF92-A57A6A952607",
    name: "cup-water",
    codepoint: "F1AB",
    aliases: ["local-drink"],
    tags: ["Food / Drink"],
    author: "Google",
    version: "1.5.54",
    path: "M18.32,8H5.67L5.23,4H18.77M12,19C10.34,19 9,17.66 9,16C9,14 12,10.6 12,10.6C12,10.6 15,14 15,16C15,17.66 13.66,19 12,19M3,2L5,20.23C5.13,21.23 5.97,22 7,22H17C18,22 18.87,21.23 19,20.23L21,2H3Z",
  },
  {
    id: "CF09105E-AB0E-4393-ADCC-4E6DFC513C9C",
    name: "cupcake",
    codepoint: "F959",
    aliases: [],
    tags: ["Food / Drink"],
    author: "Nick",
    version: "2.4.85",
    path: "M12,1.5C13.38,1.5 14.5,2.62 14.5,4C14.5,5.38 13.38,6.5 12,6.5C10.62,6.5 9.5,5.38 9.5,4C9.5,2.62 10.62,1.5 12,1.5M15.87,5C18,5 20,7 20,9C22.7,9 22.7,13 20,13H4C1.3,13 1.3,9 4,9C4,7 6,5 8.13,5C8.57,6.73 10.14,8 12,8C13.86,8 15.43,6.73 15.87,5M5,15H8L9,22H7L5,15M10,15H14L13,22H11L10,15M16,15H19L17,22H15L16,15Z",
  },
  {
    id: "75F948EB-5A9C-4F7A-9841-2B93AC222605",
    name: "curling",
    codepoint: "F862",
    aliases: [],
    tags: ["Sport"],
    author: "Nick",
    version: "2.1.99",
    path: "M10,3V5C12.5,5 13.9,5.05 14.72,5.41C15.26,5.65 15.73,6.21 16.25,7H5V9H19.62L18.89,7.55C17.86,5.5 16.96,4.22 15.53,3.59C14.1,2.95 12.5,3 10,3M6,11C3.78,11 2,12.78 2,15V18C2,20.22 3.78,22 6,22H18C20.22,22 22,20.22 22,18V15C22,12.78 20.22,11 18,11H6Z",
  },
  {
    id: "FB0C738C-21DE-4643-9B5D-690CE7AAEAEE",
    name: "currency-bdt",
    codepoint: "F863",
    aliases: ["taka", "bangladeshi-taka"],
    tags: ["Banking", "Currency"],
    author: "Michael Richins",
    version: "2.1.99",
    path: "M18.09,10.5V9H9.59V4.5C9.59,3.67 8.92,3 8.09,3C7.26,3 6.59,3.67 6.59,4.5C6.59,5.33 7.26,6 8.09,6V9H5.09V10.5H8.09V16.7C8.09,19.06 10,20.97 12.34,21C14.68,20.96 16.54,19.04 16.5,16.7C16.5,15.11 15.75,13.61 14.5,12.62C14.28,12.44 14.05,12.28 13.8,12.15C13.58,12.05 13.34,12 13.1,12C12.39,12 11.74,12.39 11.39,13C11.2,13.3 11.1,13.65 11.1,14C11.11,15.1 12,16 13.11,16C13.73,16 14.31,15.69 14.69,15.2C14.9,15.67 15,16.18 15,16.7C15.04,18.2 13.86,19.45 12.34,19.5C10.81,19.5 9.58,18.23 9.59,16.7V10.5H18.09Z",
  },
  {
    id: "CCAF9A48-2989-47C7-B4A5-1CF424A339CC",
    name: "currency-btc",
    codepoint: "F1AC",
    aliases: ["bitcoin"],
    tags: ["Currency", "Brand / Logo"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M6,4H8V2H10V4H12V2H14V4.03C16.25,4.28 18,6.18 18,8.5C18,9.8 17.45,11 16.56,11.8C17.73,12.61 18.5,13.97 18.5,15.5C18.5,18 16.5,20 14,20V22H12V20H10V22H8V20H6L6.5,18H8V6H6V4M10,13V18H14C15.38,18 16.5,16.88 16.5,15.5C16.5,14.12 15.38,13 14,13H10M10,6V11H13.5C14.88,11 16,9.88 16,8.5C16,7.12 14.88,6 13.5,6H13.5L10,6Z",
  },
  {
    id: "0F5809A3-18DD-4B42-9A7E-B35B65EF3751",
    name: "currency-cny",
    codepoint: "F7B9",
    aliases: ["yuan", "renminbi"],
    tags: ["Currency", "Banking"],
    author: "JapanYoshi",
    version: "2.0.46",
    path: "M11,21V16H6V14H11V13.71L10.16,12H6V10H9.19L5.77,3H8L12,11.2L16,3H18.23L14.81,10H18V12H13.84L13,13.71V14H18V16H13V21H11Z",
  },
  {
    id: "222B8F14-2217-4FC1-8940-AC1CF8AB150B",
    name: "currency-eth",
    codepoint: "F7BA",
    aliases: ["ethereum", "xi"],
    tags: ["Currency", "Brand / Logo"],
    author: "Peter Noble",
    version: "2.0.46",
    path: "M6,5H18V7H6M7,11H17V13H7M5.5,17H18.5V19H5.5",
  },
  {
    id: "94C667B3-E2EB-428D-B422-751C234CCF44",
    name: "currency-eur",
    codepoint: "F1AD",
    aliases: ["euro", "euro-symbol"],
    tags: ["Currency", "Banking"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M7.07,11L7,12L7.07,13H17.35L16.5,15H7.67C8.8,17.36 11.21,19 14,19C16.23,19 18.22,17.96 19.5,16.33V19.12C18,20.3 16.07,21 14,21C10.08,21 6.75,18.5 5.5,15H2L3,13H5.05L5,12L5.05,11H2L3,9H5.5C6.75,5.5 10.08,3 14,3C16.5,3 18.8,4.04 20.43,5.71L19.57,7.75C18.29,6.08 16.27,5 14,5C11.21,5 8.8,6.64 7.67,9H19.04L18.19,11H7.07Z",
  },
  {
    id: "F9BD830F-EBB6-45A4-A576-0DEC27084A95",
    name: "currency-gbp",
    codepoint: "F1AE",
    aliases: ["pound", "sterling"],
    tags: ["Currency", "Banking"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M6.5,21V19.75C7.44,19.29 8.24,18.57 8.81,17.7C9.38,16.83 9.67,15.85 9.68,14.75L9.66,13.77L9.57,13H7V11H9.4C9.25,10.17 9.16,9.31 9.13,8.25C9.16,6.61 9.64,5.33 10.58,4.41C11.5,3.5 12.77,3 14.32,3C15.03,3 15.64,3.07 16.13,3.2C16.63,3.32 17,3.47 17.31,3.65L16.76,5.39C16.5,5.25 16.19,5.12 15.79,5C15.38,4.9 14.89,4.85 14.32,4.84C13.25,4.86 12.5,5.19 12,5.83C11.5,6.46 11.29,7.28 11.3,8.28L11.4,9.77L11.6,11H15.5V13H11.79C11.88,14 11.84,15 11.65,15.96C11.35,17.16 10.74,18.18 9.83,19H18V21H6.5Z",
  },
  {
    id: "AB8EAA72-9A34-4F87-937A-9A8FDEFA1FEF",
    name: "currency-inr",
    codepoint: "F1AF",
    aliases: ["rupee"],
    tags: ["Currency", "Banking"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M8,3H18L17,5H13.74C14.22,5.58 14.58,6.26 14.79,7H18L17,9H15C14.75,11.57 12.74,13.63 10.2,13.96V14H9.5L15.5,21H13L7,14V12H9.5V12C11.26,12 12.72,10.7 12.96,9H7L8,7H12.66C12.1,5.82 10.9,5 9.5,5H7L8,3Z",
  },
  {
    id: "639A8D4C-086C-4038-A569-F9387E851262",
    name: "currency-jpy",
    codepoint: "F7BB",
    aliases: ["yen"],
    tags: ["Currency", "Banking"],
    author: "JapanYoshi",
    version: "2.0.46",
    path: "M11,21V16H6V14H11V13.71L10.16,12H6V10H9.19L5.77,3H8L12,11.2L16,3H18.23L14.81,10H18V12H13.84L13,13.71V14H18V16H13V21H11Z",
  },
  {
    id: "72750D9E-229F-4D77-B1CB-9C2C0FD12335",
    name: "currency-krw",
    codepoint: "F7BC",
    aliases: ["won"],
    tags: ["Currency", "Banking"],
    author: "JapanYoshi",
    version: "2.0.46",
    path: "M2,3H4L5.33,9H9.33L10.67,3H13.33L14.67,9H18.67L20,3H22L20.67,9H22V11H20.22L19.78,13H22V15H19.33L18,21H15.33L14,15H10L8.67,21H6L4.67,15H2V13H4.22L3.78,11H2V9H3.33L2,3M13.11,11H10.89L10.44,13H13.56L13.11,11M7.33,18L8,15H6.67L7.33,18M8.89,11H5.78L6.22,13H8.44L8.89,11M16.67,18L17.33,15H16L16.67,18M18.22,11H15.11L15.56,13H17.78L18.22,11M12,6L11.33,9H12.67L12,6Z",
  },
  {
    id: "FDA284E5-BF4A-47DC-B68F-255E07DB89CF",
    name: "currency-kzt",
    codepoint: "F864",
    aliases: ["kazakhstani-tenge"],
    tags: ["Banking", "Currency"],
    author: "Augustin Ursu",
    version: "2.1.99",
    path: "M5,3H19V5H5V3M5,6H19V8H13V21H11V8H5V6Z",
  },
  {
    id: "2F091499-4472-423E-A0C5-8C96CDDE1ABF",
    name: "currency-ngn",
    codepoint: "F1B0",
    aliases: ["naira"],
    tags: ["Currency", "Banking"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M4,9H6V3H8L11.42,9H16V3H18V9H20V11H18V13H20V15H18V21H16L12.57,15H8V21H6V15H4V13H6V11H4V9M8,9H9.13L8,7.03V9M8,11V13H11.42L10.28,11H8M16,17V15H14.85L16,17M12.56,11L13.71,13H16V11H12.56Z",
  },
  {
    id: "734CB783-C788-4F5E-BB90-BFBF4E3C22DC",
    name: "currency-php",
    codepoint: "F9E5",
    aliases: ["philippine-peso"],
    tags: [],
    author: "Michael Richins",
    version: "2.5.94",
    path: "M5,2V6H3V8H5V10H3V12H5V22H7V16H13C15.7,16 18.16,14.44 19.32,12H22V10H19.92C20.03,9.34 20.03,8.66 19.92,8H22V6H19.32C18.16,3.56 15.7,2 13,2M7,4H13C14.57,4 16.06,4.74 17,6H7V4M13,14H7V12H17C16.06,13.26 14.57,14 13,14M18,9C18,9.34 17.96,9.67 17.9,10H7V8H17.9C17.96,8.33 18,8.66 18,9Z",
  },
  {
    id: "57057EA1-1BA7-49F3-A8C7-51AF633DED68",
    name: "currency-rub",
    codepoint: "F1B1",
    aliases: ["ruble"],
    tags: ["Currency", "Banking"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M6,10H7V3H14.5C17,3 19,5 19,7.5C19,10 17,12 14.5,12H9V14H15V16H9V21H7V16H6V14H7V12H6V10M14.5,5H9V10H14.5C15.88,10 17,8.88 17,7.5C17,6.12 15.88,5 14.5,5Z",
  },
  {
    id: "17CFE8D4-18D7-4414-B8EE-244D5A8FF791",
    name: "currency-sign",
    codepoint: "F7BD",
    aliases: ["currency-scarab"],
    tags: ["Currency", "Banking"],
    author: "Michael Richins",
    version: "2.0.46",
    path: "M22,12C22,9.86 21.29,7.78 20,6.07L22,4.07L19.94,1.94L17.94,3.94C14.4,1.36 9.59,1.38 6.07,4L4.07,2L1.94,4.06L3.94,6.06C1.36,9.6 1.38,14.41 4,17.93L2,19.93L4.12,22.05L6.12,20.05C9.65,22.65 14.45,22.65 18,20.05L20,22.05L22.1,19.93L20.1,17.93C21.35,16.21 22,14.13 22,12M12,19C8.13,19 5,15.87 5,12C5,8.13 8.13,5 12,5C15.87,5 19,8.13 19,12C19,15.87 15.87,19 12,19Z",
  },
  {
    id: "94DAFCB6-FA70-4DAE-B3DF-A107031F81E8",
    name: "currency-try",
    codepoint: "F1B2",
    aliases: ["lira"],
    tags: ["Currency", "Banking"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M19,12C19,16.97 14.97,21 10,21H8V12.77L5,13.87V11.74L8,10.64V8.87L5,9.96V7.84L8,6.74V3H10V6L15,4.2V6.32L10,8.14V9.92L15,8.1V10.23L10,12.05V19C13.87,19 17,15.87 17,12H19Z",
  },
  {
    id: "E0103EBC-20BF-48EA-BC8F-BEF04BF2A581",
    name: "currency-twd",
    codepoint: "F7BE",
    aliases: ["new-taiwan-dollar"],
    tags: ["Currency", "Banking"],
    author: "JapanYoshi",
    version: "2.0.46",
    path: "M3,11H21V13H15V19H21V21H15C13.9,21 13,20.1 13,19V13H10.35L5.73,21L4,20L8.04,13H3V11M5,3H19V5H5V3Z",
  },
  {
    id: "3FA4946C-029B-42D3-AA31-3D607FB4A2F1",
    name: "currency-usd",
    codepoint: "F1B3",
    aliases: ["attach-money"],
    tags: ["Currency", "Banking"],
    author: "Google",
    version: "1.5.54",
    path: "M7,15H9C9,16.08 10.37,17 12,17C13.63,17 15,16.08 15,15C15,13.9 13.96,13.5 11.76,12.97C9.64,12.44 7,11.78 7,9C7,7.21 8.47,5.69 10.5,5.18V3H13.5V5.18C15.53,5.69 17,7.21 17,9H15C15,7.92 13.63,7 12,7C10.37,7 9,7.92 9,9C9,10.1 10.04,10.5 12.24,11.03C14.36,11.56 17,12.22 17,15C17,16.79 15.53,18.31 13.5,18.82V21H10.5V18.82C8.47,18.31 7,16.79 7,15Z",
  },
  {
    id: "5E9D35E4-9487-4A9B-9D4B-E1BBCA52AE0C",
    name: "currency-usd-off",
    codepoint: "F679",
    aliases: ["money-off"],
    tags: ["Currency", "Banking"],
    author: "Google",
    version: "1.7.12",
    path: "M3,4.27L4.28,3L21,19.72L19.73,21L16.06,17.33C15.44,18 14.54,18.55 13.5,18.82V21H10.5V18.82C8.47,18.31 7,16.79 7,15H9C9,16.08 10.37,17 12,17C13.13,17 14.14,16.56 14.65,15.92L11.68,12.95C9.58,12.42 7,11.75 7,9C7,8.77 7,8.55 7.07,8.34L3,4.27M10.5,5.18V3H13.5V5.18C15.53,5.69 17,7.21 17,9H15C15,7.92 13.63,7 12,7C11.63,7 11.28,7.05 10.95,7.13L9.4,5.58L10.5,5.18Z",
  },
  {
    id: "2099C23C-E6F6-4C9B-AA3C-49A693E73E2E",
    name: "current-ac",
    codepoint: "F95A",
    aliases: ["alternating-current"],
    tags: [],
    author: "Nick",
    version: "2.4.85",
    path: "M16.5,21C13.5,21 12.31,16.76 11.05,12.28C10.14,9.04 9,5 7.5,5C4.11,5 4,11.93 4,12H2C2,11.63 2.06,3 7.5,3C10.5,3 11.71,7.25 12.97,11.74C13.83,14.8 15,19 16.5,19C19.94,19 20.03,12.07 20.03,12H22.03C22.03,12.37 21.97,21 16.5,21Z",
  },
  {
    id: "2A23AD1A-C4F1-47B1-B482-05836097CE51",
    name: "current-dc",
    codepoint: "F95B",
    aliases: ["direct-current"],
    tags: [],
    author: "Nick",
    version: "2.4.85",
    path: "M2,9V11H22V9H2M2,13V15H6V13H2M10,13V15H14V13H10M18,13V15H22V13H18Z",
  },
  {
    id: "2B463003-089D-47DE-97F7-434F16A4735B",
    name: "cursor-default",
    codepoint: "F1B4",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M13.64,21.97C13.14,22.21 12.54,22 12.31,21.5L10.13,16.76L7.62,18.78C7.45,18.92 7.24,19 7,19C6.45,19 6,18.55 6,18V3C6,2.45 6.45,2 7,2C7.24,2 7.47,2.09 7.64,2.23L7.65,2.22L19.14,11.86C19.57,12.22 19.62,12.85 19.27,13.27C19.12,13.45 18.91,13.57 18.7,13.61L15.54,14.23L17.74,18.96C18,19.46 17.76,20.05 17.26,20.28L13.64,21.97Z",
  },
  {
    id: "E6A56AAF-22C5-4DAE-9E97-184501755DF5",
    name: "cursor-default-outline",
    codepoint: "F1B5",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M10.07,14.27C10.57,14.03 11.16,14.25 11.4,14.75L13.7,19.74L15.5,18.89L13.19,13.91C12.95,13.41 13.17,12.81 13.67,12.58L13.95,12.5L16.25,12.05L8,5.12V15.9L9.82,14.43L10.07,14.27M13.64,21.97C13.14,22.21 12.54,22 12.31,21.5L10.13,16.76L7.62,18.78C7.45,18.92 7.24,19 7,19C6.45,19 6,18.55 6,18V3C6,2.45 6.45,2 7,2C7.24,2 7.47,2.09 7.64,2.23L7.65,2.22L19.14,11.86C19.57,12.22 19.62,12.85 19.27,13.27C19.12,13.45 18.91,13.57 18.7,13.61L15.54,14.23L17.74,18.96C18,19.46 17.76,20.05 17.26,20.28L13.64,21.97Z",
  },
  {
    id: "EDAD5377-8923-4D6C-AC12-CBDC6C78DC7F",
    name: "cursor-move",
    codepoint: "F1B6",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M13,6V11H18V7.75L22.25,12L18,16.25V13H13V18H16.25L12,22.25L7.75,18H11V13H6V16.25L1.75,12L6,7.75V11H11V6H7.75L12,1.75L16.25,6H13Z",
  },
  {
    id: "B5465B23-729A-405E-9155-486A36D8135F",
    name: "cursor-pointer",
    codepoint: "F1B7",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M10,2C11.1,2 12,2.9 12,4V8.5C12,8.5 14,8.25 14,9.25C14,9.25 16,9 16,10C16,10 18,9.75 18,10.75C18,10.75 20,10.5 20,11.5V15C20,16 17,21 17,22H9C9,22 7,15 4,13C4,13 3,7 8,12V4C8,2.9 8.9,2 10,2Z",
  },
  {
    id: "76C56C15-C2A3-4042-95C7-F143A3B58765",
    name: "cursor-text",
    codepoint: "F5E7",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M13,19C13,19.55 13.45,20 14,20H16V22H13.5C12.95,22 12,21.55 12,21C12,21.55 11.05,22 10.5,22H8V20H10C10.55,20 11,19.55 11,19V5C11,4.45 10.55,4 10,4H8V2H10.5C11.05,2 12,2.45 12,3C12,2.45 12.95,2 13.5,2H16V4H14C13.45,4 13,4.45 13,5V19Z",
  },
  {
    id: "C8FC48A7-AE19-4BD8-B57E-14B76D93937B",
    name: "database",
    codepoint: "F1B8",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M12,3C7.58,3 4,4.79 4,7C4,9.21 7.58,11 12,11C16.42,11 20,9.21 20,7C20,4.79 16.42,3 12,3M4,9V12C4,14.21 7.58,16 12,16C16.42,16 20,14.21 20,12V9C20,11.21 16.42,13 12,13C7.58,13 4,11.21 4,9M4,14V17C4,19.21 7.58,21 12,21C16.42,21 20,19.21 20,17V14C20,16.21 16.42,18 12,18C7.58,18 4,16.21 4,14Z",
  },
  {
    id: "6E50F0F8-1116-4090-9468-54B2CE8FBB19",
    name: "database-export",
    codepoint: "F95D",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.4.85",
    path: "M14.22,19L17.05,16.17L14.93,14H22V21.07L19.88,19L17.05,21.83L14.22,19M11.39,19L12.39,18H12C7.58,18 4,16.21 4,14V17C4,19.21 7.58,21 12,21C12.47,21 12.93,21 13.38,20.94L11.39,19M17.29,12H20V9C20,10.2 19,11.27 17.29,12M4,9V12C4,14.21 7.58,16 12,16C12.67,16 13.34,15.96 14,15.87L11.07,13C7.09,12.74 4,11.05 4,9M12,3C7.58,3 4,4.79 4,7C4,9.21 7.58,11 12,11C16.42,11 20,9.21 20,7C20,4.79 16.42,3 12,3Z",
  },
  {
    id: "733A4C8A-FAA5-42BE-882E-98EC734E8493",
    name: "database-import",
    codepoint: "F95C",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.4.85",
    path: "M17.05,14.22L19.88,17.05L22,14.93V22H14.93L17.05,19.88L14.22,17.05L17.05,14.22M12.33,18H12C7.58,18 4,16.21 4,14V17C4,19.21 7.58,21 12,21C12.39,21 12.77,21 13.14,21L14.22,19.92L12.33,18M17.54,11.89L19.29,13.64C19.73,13.21 20,12.62 20,12V9C20,10.13 19.06,11.16 17.54,11.88V11.89M4,9V12C4,14.21 7.58,16 12,16H12.45L16,12.47C14.7,12.83 13.35,13 12,13C7.58,13 4,11.21 4,9M12,3C7.58,3 4,4.79 4,7C4,9.21 7.58,11 12,11C16.42,11 20,9.21 20,7C20,4.79 16.42,3 12,3Z",
  },
  {
    id: "31CE0431-ABF2-4650-8439-515C0E9012CD",
    name: "database-minus",
    codepoint: "F1B9",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M9,3C4.58,3 1,4.79 1,7C1,9.21 4.58,11 9,11C13.42,11 17,9.21 17,7C17,4.79 13.42,3 9,3M1,9V12C1,14.21 4.58,16 9,16C13.42,16 17,14.21 17,12V9C17,11.21 13.42,13 9,13C4.58,13 1,11.21 1,9M1,14V17C1,19.21 4.58,21 9,21C10.41,21 11.79,20.81 13,20.46V17.46C11.79,17.81 10.41,18 9,18C4.58,18 1,16.21 1,14M15,17V19H23V17",
  },
  {
    id: "940D2514-B309-4CE0-A2E4-D02121415CA3",
    name: "database-plus",
    codepoint: "F1BA",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M9,3C4.58,3 1,4.79 1,7C1,9.21 4.58,11 9,11C13.42,11 17,9.21 17,7C17,4.79 13.42,3 9,3M1,9V12C1,14.21 4.58,16 9,16C13.42,16 17,14.21 17,12V9C17,11.21 13.42,13 9,13C4.58,13 1,11.21 1,9M1,14V17C1,19.21 4.58,21 9,21C10.41,21 11.79,20.81 13,20.46V17.46C11.79,17.81 10.41,18 9,18C4.58,18 1,16.21 1,14M18,14V17H15V19H18V22H20V19H23V17H20V14",
  },
  {
    id: "58E36A40-053B-42EB-8879-9CB0948B58D4",
    name: "database-search",
    codepoint: "F865",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "2.1.99",
    path: "M18.68,12.32C16.92,10.56 14.07,10.57 12.32,12.33C10.56,14.09 10.56,16.94 12.32,18.69C13.81,20.17 16.11,20.43 17.89,19.32L21,22.39L22.39,21L19.3,17.89C20.43,16.12 20.17,13.8 18.68,12.32M17.27,17.27C16.29,18.25 14.71,18.24 13.73,17.27C12.76,16.29 12.76,14.71 13.74,13.73C14.71,12.76 16.29,12.76 17.27,13.73C18.24,14.71 18.24,16.29 17.27,17.27M10.9,20.1C10.25,19.44 9.74,18.65 9.42,17.78C6.27,17.25 4,15.76 4,14V17C4,19.21 7.58,21 12,21V21C11.6,20.74 11.23,20.44 10.9,20.1M4,9V12C4,13.68 6.07,15.12 9,15.7C9,15.63 9,15.57 9,15.5C9,14.57 9.2,13.65 9.58,12.81C6.34,12.3 4,10.79 4,9M12,3C7.58,3 4,4.79 4,7C4,9 7,10.68 10.85,11H10.9C12.1,9.74 13.76,9 15.5,9C16.41,9 17.31,9.19 18.14,9.56C19.17,9.09 19.87,8.12 20,7C20,4.79 16.42,3 12,3Z",
  },
  {
    id: "309A4ABA-E450-437D-8AD1-EE6A850D421B",
    name: "death-star",
    codepoint: "F8D7",
    aliases: [],
    tags: [],
    author: "Colton Wiscombe",
    version: "2.3.50",
    path: "M2.05,13H21.95C21.45,18.05 17.19,22 12,22C6.82,22 2.55,18.05 2.05,13M21.95,11H2.05C2.55,5.95 6.82,2 12,2C17.18,2 21.45,5.95 21.95,11M12,6.75C12,5.37 10.88,4.25 9.5,4.25C8.12,4.25 7,5.37 7,6.75C7,8.13 8.12,9.25 9.5,9.25C10.88,9.25 12,8.13 12,6.75Z",
  },
  {
    id: "51D35A62-F308-48B6-B471-D58CFE4CD6BC",
    name: "death-star-variant",
    codepoint: "F8D8",
    aliases: [],
    tags: [],
    author: "Colton Wiscombe",
    version: "2.3.50",
    path: "M2.05,13H21.94C21.88,13.69 21.74,14.36 21.54,15H14V17H17V19H15V21H12.5V22C12.33,22 12.17,22 12,22C6.82,22 2.55,18.05 2.05,13M21.94,11H2.05C2.55,5.95 6.82,2 12,2C13.62,2 15.15,2.39 16.5,3.08V5H18.5V7H20V9H21.54C21.74,9.64 21.88,10.31 21.94,11M12,6.75C12,5.37 10.88,4.25 9.5,4.25C8.12,4.25 7,5.37 7,6.75C7,8.13 8.12,9.25 9.5,9.25C10.88,9.25 12,8.13 12,6.75Z",
  },
  {
    id: "250883A1-65B8-4092-9B92-C9BD810ADB5A",
    name: "debian",
    codepoint: "F8D9",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Contributors",
    version: "2.3.50",
    path: "M18.5,10.57L18.3,10.94C18.56,10.16 18.41,9.31 18.45,8.57L18.38,8.55C18.31,6.7 16.71,4.73 15.29,4.07C14.06,3.5 12.17,3.4 11.3,3.83C11.42,3.72 11.9,3.68 11.75,3.6C10.38,3.73 10.69,4.07 9.64,4.34C9.35,4.62 10.5,4.12 9.87,4.5C9.31,4.63 9.05,4.38 8.22,5.24C8.29,5.36 8.75,4.89 8.37,5.36C7.58,5.27 5.89,7.16 5.53,7.78L5.72,7.82C5.41,8.59 5,9.08 4.95,9.54C4.87,10.68 4.5,12.75 5.03,13.39L4.97,13.92L5.2,14.37L5.08,14.38C5.66,16.21 5.7,14.42 6.47,16.32C6.36,16.28 6.24,16.24 6.08,16C6.06,16.19 6.32,16.69 6.62,17.08L6.5,17.22C6.66,17.53 6.82,17.6 6.93,17.71C6.3,17.36 7.5,18.84 7.63,19.03L7.73,18.86C7.71,19.1 7.9,19.42 8.26,19.87L8.56,19.86C8.69,20.1 9.14,20.54 9.41,20.56L9.23,20.8C9.92,21 9.56,21.09 10.41,21.39L10.24,21.09C10.67,21.46 10.8,21.79 11.41,22.07C12.26,22.37 12.37,22.25 13.23,22.5C12.5,22.5 11.64,22.5 11.06,22.28C7.1,21.21 3.5,16.56 3.74,11.78C3.68,10.81 3.84,9.6 3.68,9.36C3.9,8.62 4.16,7.72 4.69,6.65C4.65,6.58 4.78,6.86 5.05,6.41C5.21,6.05 5.34,5.66 5.55,5.31L5.65,5.28C5.76,4.67 7.08,3.73 7.5,3.26V3.44C8.36,2.63 9.9,2.09 10.76,1.71C10.53,1.96 11.27,1.68 11.8,1.65L11.31,1.93C11.94,1.77 11.91,2 12.56,1.9C12.33,1.93 12.06,2 12.1,2.06C12.82,2.14 12.94,1.84 13.61,2.06L13.56,1.86C14.5,2.2 14.69,2.14 15.7,2.68C16.06,2.69 16.1,2.46 16.63,2.68C16.73,2.84 16.61,2.87 17.27,3.27C17.34,3.24 17.14,3.05 17,2.9C18.3,3.61 19.75,5.12 20.18,6.74C19.77,6 20.14,7.13 20,7.07C20.18,7.56 20.33,8.07 20.43,8.6C20.31,8.17 20.04,7.12 19.57,6.45C19.54,6.88 18.97,6.15 19.28,7.11C19.5,7.45 19.33,6.76 19.62,7.36C19.62,7.65 19.73,7.94 19.8,8.31C19.7,8.29 19.58,7.9 19.5,8C19.6,8.5 19.77,8.72 19.83,8.76C19.8,8.84 19.71,8.68 19.71,9C19.75,9.74 19.92,9.43 20,9.46C19.91,9.83 19.59,10.25 19.75,10.88L19.55,10.32C19.5,10.85 19.66,10.95 19.42,11.6C19.6,11 19.58,10.5 19.41,10.75C19.5,11.57 18.76,12.2 18.83,12.73L18.62,12.44C18.05,13.27 18.61,12.89 18.22,13.5C18.36,13.27 18.15,13.42 18.33,13.14C18.21,13.15 17.78,13.67 17.39,13.97C15.85,15.2 14,15.37 12.24,14.7H12.23C12.24,14.66 12.23,14.61 12.11,14.53C10.6,13.38 9.71,12.4 10,10.12C10.25,9.95 10.31,9 10.84,8.67C11.16,7.96 12.12,7.31 13.15,7.29C14.2,7.23 15.09,7.85 15.54,8.43C14.72,7.68 13.4,7.45 12.26,8C11.11,8.53 10.42,9.8 10.5,11.07C10.56,11 10.6,11.05 10.62,10.89C10.59,13.36 13.28,15.17 15.22,14.26L15.25,14.31C16.03,14.09 15.93,13.92 16.44,13.56C16.4,13.65 16.1,13.86 16.28,13.86C16.53,13.8 17.31,13.07 17.7,12.73C17.87,12.35 17.6,12.5 17.85,12.04L18.15,11.89C18.32,11.41 18.5,11.14 18.5,10.57",
  },
  {
    id: "316468B3-C3F6-4A7B-B7B2-061E5C35FFE9",
    name: "debug-step-into",
    codepoint: "F1BB",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,22C10.9,22 10,21.1 10,20C10,18.9 10.9,18 12,18C13.1,18 14,18.9 14,20C14,21.1 13.1,22 12,22M13,2V13L17.5,8.5L18.92,9.92L12,16.84L5.08,9.92L6.5,8.5L11,13V2H13Z",
  },
  {
    id: "08B9B3C7-BB6B-4110-ACEC-3BB947FFCFBA",
    name: "debug-step-out",
    codepoint: "F1BC",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,22C10.9,22 10,21.1 10,20C10,18.9 10.9,18 12,18C13.1,18 14,18.9 14,20C14,21.1 13.1,22 12,22M13,16H11V6L6.5,10.5L5.08,9.08L12,2.16L18.92,9.08L17.5,10.5L13,6V16Z",
  },
  {
    id: "8242E7C8-1400-476D-AC27-DCA7B6292C70",
    name: "debug-step-over",
    codepoint: "F1BD",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,14C13.1,14 14,14.9 14,16C14,17.1 13.1,18 12,18C10.9,18 10,17.1 10,16C10,14.9 10.9,14 12,14M23.46,8.86L21.87,15.75L15,14.16L18.8,11.78C17.39,9.5 14.87,8 12,8C8.05,8 4.77,10.86 4.12,14.63L2.15,14.28C2.96,9.58 7.06,6 12,6C15.58,6 18.73,7.89 20.5,10.72L23.46,8.86Z",
  },
  {
    id: "DA734DBD-1239-4E30-B688-ADF6A9D222D0",
    name: "decagram",
    codepoint: "F76B",
    aliases: [],
    tags: ["Shape"],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M23,12L20.56,9.22L20.9,5.54L17.29,4.72L15.4,1.54L12,3L8.6,1.54L6.71,4.72L3.1,5.53L3.44,9.21L1,12L3.44,14.78L3.1,18.47L6.71,19.29L8.6,22.47L12,21L15.4,22.46L17.29,19.28L20.9,18.46L20.56,14.78L23,12Z",
  },
  {
    id: "5F4B9A38-F090-4FA3-A138-1F758A9D446E",
    name: "decagram-outline",
    codepoint: "F76C",
    aliases: [],
    tags: ["Shape"],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M23,12L20.56,14.78L20.9,18.46L17.29,19.28L15.4,22.46L12,21L8.6,22.47L6.71,19.29L3.1,18.47L3.44,14.78L1,12L3.44,9.21L3.1,5.53L6.71,4.72L8.6,1.54L12,3L15.4,1.54L17.29,4.72L20.9,5.54L20.56,9.22L23,12M20.33,12L18.5,9.89L18.74,7.1L16,6.5L14.58,4.07L12,5.18L9.42,4.07L8,6.5L5.26,7.09L5.5,9.88L3.67,12L5.5,14.1L5.26,16.9L8,17.5L9.42,19.93L12,18.81L14.58,19.92L16,17.5L18.74,16.89L18.5,14.1L20.33,12Z",
  },
  {
    id: "3A6FCF00-DE3C-4CD7-BF06-1D26E37E0C47",
    name: "decimal-decrease",
    codepoint: "F1BE",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M12,17L15,20V18H21V16H15V14L12,17M9,5C10.66,5 12,6.34 12,8V11C12,12.66 10.66,14 9,14C7.34,14 6,12.66 6,11V8C6,6.34 7.34,5 9,5M9,7C8.45,7 8,7.45 8,8V11C8,11.55 8.45,12 9,12C9.55,12 10,11.55 10,11V8C10,7.45 9.55,7 9,7M4,12C4.55,12 5,12.45 5,13C5,13.55 4.55,14 4,14C3.45,14 3,13.55 3,13C3,12.45 3.45,12 4,12Z",
  },
  {
    id: "E99CB4D3-330D-493C-9C6B-FD43B27522FD",
    name: "decimal-increase",
    codepoint: "F1BF",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M22,17L19,20V18H13V16H19V14L22,17M9,5C10.66,5 12,6.34 12,8V11C12,12.66 10.66,14 9,14C7.34,14 6,12.66 6,11V8C6,6.34 7.34,5 9,5M9,7C8.45,7 8,7.45 8,8V11C8,11.55 8.45,12 9,12C9.55,12 10,11.55 10,11V8C10,7.45 9.55,7 9,7M16,5C17.66,5 19,6.34 19,8V11C19,12.66 17.66,14 16,14C14.34,14 13,12.66 13,11V8C13,6.34 14.34,5 16,5M16,7C15.45,7 15,7.45 15,8V11C15,11.55 15.45,12 16,12C16.55,12 17,11.55 17,11V8C17,7.45 16.55,7 16,7M4,12C4.55,12 5,12.45 5,13C5,13.55 4.55,14 4,14C3.45,14 3,13.55 3,13C3,12.45 3.45,12 4,12Z",
  },
  {
    id: "71CD492D-A1E8-4A7A-961A-51DA30952BAD",
    name: "delete",
    codepoint: "F1C0",
    aliases: [
      "trash",
      "bin",
      "rubbish",
      "garbage",
      "rubbish-bin",
      "trash-can",
      "garbage-can",
    ],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19C6,20.1 6.9,21 8,21H16C17.1,21 18,20.1 18,19V7H6V19Z",
  },
  {
    id: "1158F80B-E934-4E74-A4C6-7750BDCC409E",
    name: "delete-circle",
    codepoint: "F682",
    aliases: ["trash-circle", "bin-circle"],
    tags: [],
    author: "Austin Andrews",
    version: "1.7.12",
    path: "M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M17,7H14.5L13.5,6H10.5L9.5,7H7V9H17V7M9,18H15C15.55,18 16,17.55 16,17V10H8V17C8,17.55 8.45,18 9,18Z",
  },
  {
    id: "E39FB607-9058-4C00-840C-AF666F372071",
    name: "delete-empty",
    codepoint: "F6CB",
    aliases: [
      "trash-empty",
      "bin-empty",
      "rubbish-empty",
      "rubbish-bin-empty",
      "trash-can-empty",
      "garbage-empty",
      "garbage-can-empty",
    ],
    tags: [],
    author: "Austin Andrews",
    version: "1.8.36",
    path: "M20.37,8.91L19.37,10.64L7.24,3.64L8.24,1.91L11.28,3.66L12.64,3.29L16.97,5.79L17.34,7.16L20.37,8.91M6,19V7H11.07L18,11V19C18,20.1 17.1,21 16,21H8C6.9,21 6,20.1 6,19Z",
  },
  {
    id: "52AFD546-8C5D-4E77-8D83-D4D058A742FE",
    name: "delete-forever",
    codepoint: "F5E8",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M6,19C6,20.1 6.9,21 8,21H16C17.1,21 18,20.1 18,19V7H6V19M8.46,11.88L9.87,10.47L12,12.59L14.12,10.47L15.53,11.88L13.41,14L15.53,16.12L14.12,17.53L12,15.41L9.88,17.53L8.47,16.12L10.59,14L8.46,11.88M15.5,4L14.5,3H9.5L8.5,4H5V6H19V4H15.5Z",
  },
  {
    id: "59ADF7EF-9F3E-4957-A789-95788D13B9E4",
    name: "delete-outline",
    codepoint: "F9E6",
    aliases: [
      "garbage-outline",
      "bin-outline",
      "rubbish-outline",
      "garbage-can-outline",
      "rubbish-bin-outline",
      "trash-outline",
      "trash-can-outline",
    ],
    tags: [],
    author: "Google",
    version: "2.5.94",
    path: "M6,19C6,20.1 6.9,21 8,21H16C17.1,21 18,20.1 18,19V7H6V19M8,9H16V19H8V9M15.5,4L14.5,3H9.5L8.5,4H5V6H19V4H15.5Z",
  },
  {
    id: "7837B9B7-2A6F-42E3-894D-C40D0080FB7B",
    name: "delete-restore",
    codepoint: "F818",
    aliases: ["trash-restore", "bin-restore", "restore-from-trash"],
    tags: [],
    author: "Google",
    version: "2.1.19",
    path: "M14,14H16L12,10L8,14H10V18H14V14M6,7H18V19C18,19.5 17.8,20 17.39,20.39C17,20.8 16.5,21 16,21H8C7.5,21 7,20.8 6.61,20.39C6.2,20 6,19.5 6,19V7M19,4V6H5V4H8.5L9.5,3H14.5L15.5,4H19Z",
  },
  {
    id: "3B3D514C-AFC3-4D04-91EA-E18F03BB494A",
    name: "delete-sweep",
    codepoint: "F5E9",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M15,16H19V18H15V16M15,8H22V10H15V8M15,12H21V14H15V12M3,18C3,19.1 3.9,20 5,20H11C12.1,20 13,19.1 13,18V8H3V18M14,5H11L10,4H6L5,5H2V7H14V5Z",
  },
  {
    id: "DC3862AC-6945-4104-9F15-50BD46D13705",
    name: "delete-variant",
    codepoint: "F1C1",
    aliases: ["trash-variant", "bin-variant"],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M21.03,3L18,20.31C17.83,21.27 17,22 16,22H8C7,22 6.17,21.27 6,20.31L2.97,3H21.03M5.36,5L8,20H16L18.64,5H5.36M9,18V14H13V18H9M13,13.18L9.82,10L13,6.82L16.18,10L13,13.18Z",
  },
  {
    id: "D4B29470-8EE3-4ED8-BB01-6C942CE7E748",
    name: "delta",
    codepoint: "F1C2",
    aliases: ["change-history"],
    tags: ["Math"],
    author: "Google",
    version: "1.5.54",
    path: "M12,7.77L18.39,18H5.61L12,7.77M12,4L2,20H22",
  },
  {
    id: "80459D13-2662-4F47-AB31-F6A2B84C8DEB",
    name: "desk-lamp",
    codepoint: "F95E",
    aliases: [],
    tags: [],
    author: "Contributors",
    version: "2.4.85",
    path: "M10.85,2L9.18,4.5L10.32,5.25L7.14,10C7.1,10 7.05,10 7,10C5.9,10 5,10.9 5,12C5,12.94 5.66,13.75 6.58,13.95L10.62,20H7V22H17V20H13L8.53,13.28C8.83,12.92 9,12.47 9,12C9,11.7 8.93,11.4 8.8,11.13L12,6.37C11.78,8.05 12.75,9.89 14.45,11L18.89,4.37C17.2,3.24 15.12,3.04 13.65,3.87L10.85,2M18.33,7L16.67,9.5C17.35,9.95 18.29,9.77 18.75,9.08C19.21,8.39 19,7.46 18.33,7Z",
  },
  {
    id: "C05777DC-F874-4231-B9EB-5675C808F7BB",
    name: "deskphone",
    codepoint: "F1C3",
    aliases: [],
    tags: ["Cellphone / Phone"],
    author: "Chris Litherland",
    version: "1.5.54",
    path: "M5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3M15,5V19H19V5H15M5,5V9H13V5H5M5,11V13H7V11H5M8,11V13H10V11H8M11,11V13H13V11H11M5,14V16H7V14H5M8,14V16H10V14H8M11,14V16H13V14H11M11,17V19H13V17H11M8,17V19H10V17H8M5,17V19H7V17H5Z",
  },
  {
    id: "40B89929-0709-461F-8C7A-ED94CDDCC4AC",
    name: "desktop-classic",
    codepoint: "F7BF",
    aliases: ["computer-classic"],
    tags: ["Device / Tech", "Home Automation"],
    author: "GreenTurtwig",
    version: "2.0.46",
    path: "M6,2C4.89,2 4,2.89 4,4V12C4,13.11 4.89,14 6,14H18C19.11,14 20,13.11 20,12V4C20,2.89 19.11,2 18,2H6M6,4H18V12H6V4M4,15C2.89,15 2,15.89 2,17V20C2,21.11 2.89,22 4,22H20C21.11,22 22,21.11 22,20V17C22,15.89 21.11,15 20,15H4M8,17H20V20H8V17M9,17.75V19.25H13V17.75H9M15,17.75V19.25H19V17.75H15Z",
  },
  {
    id: "4B4C339D-D581-44A3-95DE-4254CC42AC8D",
    name: "desktop-mac",
    codepoint: "F1C4",
    aliases: [],
    tags: ["Device / Tech", "Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M21,14H3V4H21M21,2H3C1.89,2 1,2.89 1,4V16C1,17.1 1.9,18 3,18H10L8,21V22H16V21L14,18H21C22.1,18 23,17.1 23,16V4C23,2.89 22.1,2 21,2Z",
  },
  {
    id: "A3CC4F14-35C0-421B-A818-9B8E4E852522",
    name: "desktop-mac-dashboard",
    codepoint: "F9E7",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.5.94",
    path: "M21,14V4H3V14H21M21,2C22.1,2 23,2.9 23,4V16C23,17.1 22.1,18 21,18H14L16,21V22H8V21L10,18H3C1.89,18 1,17.1 1,16V4C1,2.89 1.89,2 3,2H21M4,5H15V10H4V5M16,5H20V7H16V5M20,8V13H16V8H20M4,11H9V13H4V11M10,11H15V13H10V11Z",
  },
  {
    id: "362BCE24-8F91-491A-8EE8-BD08C296511A",
    name: "desktop-tower",
    codepoint: "F1C5",
    aliases: [],
    tags: ["Device / Tech", "Home Automation"],
    author: "Chris Litherland",
    version: "1.5.54",
    path: "M8,2H16C17.1,2 18,2.9 18,4V20C18,21.1 17.1,22 16,22H8C6.9,22 6,21.1 6,20V4C6,2.9 6.9,2 8,2M8,4V6H16V4H8M16,8H8V10H16V8M16,18H14V20H16V18Z",
  },
  {
    id: "21A2819F-3B97-49D0-A588-30CF7B8915F5",
    name: "details",
    codepoint: "F1C6",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M6.38,6H17.63L12,16L6.38,6M3,4L12,20L21,4H3Z",
  },
  {
    id: "7D1C43A0-CDE0-416B-A1A9-1CD07F930284",
    name: "developer-board",
    codepoint: "F696",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.7.12",
    path: "M22,9V7H20V5C20,3.9 19.1,3 18,3H4C2.9,3 2,3.9 2,5V19C2,20.1 2.9,21 4,21H18C19.1,21 20,20.1 20,19V17H22V15H20V13H22V11H20V9H22M18,19H4V5H18V19M6,13H11V17H6V13M12,7H16V10H12V7M6,7H11V12H6V7M12,11H16V17H12V11Z",
  },
  {
    id: "ECD72042-9BA7-4C24-A740-7F538B443302",
    name: "deviantart",
    codepoint: "F1C7",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M6,6H12L14,2H18V6L14.5,13H18V18H12L10,22H6V18L9.5,11H6V6Z",
  },
  {
    id: "B732FAD7-93A7-478E-810F-835069DE6EDB",
    name: "dialpad",
    codepoint: "F61C",
    aliases: ["keypad"],
    tags: [],
    author: "Google",
    version: "1.6.50",
    path: "M12,19C10.9,19 10,19.9 10,21C10,22.1 10.9,23 12,23C13.1,23 14,22.1 14,21C14,19.9 13.1,19 12,19M6,1C4.9,1 4,1.9 4,3C4,4.1 4.9,5 6,5C7.1,5 8,4.1 8,3C8,1.9 7.1,1 6,1M6,7C4.9,7 4,7.9 4,9C4,10.1 4.9,11 6,11C7.1,11 8,10.1 8,9C8,7.9 7.1,7 6,7M6,13C4.9,13 4,13.9 4,15C4,16.1 4.9,17 6,17C7.1,17 8,16.1 8,15C8,13.9 7.1,13 6,13M18,5C19.1,5 20,4.1 20,3C20,1.9 19.1,1 18,1C16.9,1 16,1.9 16,3C16,4.1 16.9,5 18,5M12,13C10.9,13 10,13.9 10,15C10,16.1 10.9,17 12,17C13.1,17 14,16.1 14,15C14,13.9 13.1,13 12,13M18,13C16.9,13 16,13.9 16,15C16,16.1 16.9,17 18,17C19.1,17 20,16.1 20,15C20,13.9 19.1,13 18,13M18,7C16.9,7 16,7.9 16,9C16,10.1 16.9,11 18,11C19.1,11 20,10.1 20,9C20,7.9 19.1,7 18,7M12,7C10.9,7 10,7.9 10,9C10,10.1 10.9,11 12,11C13.1,11 14,10.1 14,9C14,7.9 13.1,7 12,7M12,1C10.9,1 10,1.9 10,3C10,4.1 10.9,5 12,5C13.1,5 14,4.1 14,3C14,1.9 13.1,1 12,1Z",
  },
  {
    id: "7AEA1B64-9B6D-4D55-91F8-05BA1BF3BF89",
    name: "diamond",
    codepoint: "F1C8",
    aliases: ["jewel"],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M16,9H19L14,16M10,9H14L12,17M5,9H8L10,16M15,4H17L19,7H16M11,4H13L14,7H10M7,4H9L8,7H5M6,2L2,8L12,22L22,8L18,2H6Z",
  },
  {
    id: "F8E5E9B6-9953-46F8-84DC-CFBB11DEFFB7",
    name: "dice-1",
    codepoint: "F1CA",
    aliases: ["die-1", "dice-one"],
    tags: [],
    author: "Yasmina Lembachar",
    version: "1.5.54",
    path: "M5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3M12,10C10.9,10 10,10.9 10,12C10,13.1 10.9,14 12,14C13.1,14 14,13.1 14,12C14,10.9 13.1,10 12,10Z",
  },
  {
    id: "07927207-23B1-4A93-BB8A-E6B5F41B919A",
    name: "dice-2",
    codepoint: "F1CB",
    aliases: ["die-2", "dice-two"],
    tags: [],
    author: "Yasmina Lembachar",
    version: "1.5.54",
    path: "M5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3M7,5C5.9,5 5,5.9 5,7C5,8.1 5.9,9 7,9C8.1,9 9,8.1 9,7C9,5.9 8.1,5 7,5M17,15C15.9,15 15,15.9 15,17C15,18.1 15.9,19 17,19C18.1,19 19,18.1 19,17C19,15.9 18.1,15 17,15Z",
  },
  {
    id: "2948109E-F9DA-4306-8247-665CC05BDB21",
    name: "dice-3",
    codepoint: "F1CC",
    aliases: ["die-3", "dice-three"],
    tags: [],
    author: "Yasmina Lembachar",
    version: "1.5.54",
    path: "M5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3M12,10C10.9,10 10,10.9 10,12C10,13.1 10.9,14 12,14C13.1,14 14,13.1 14,12C14,10.9 13.1,10 12,10M7,5C5.9,5 5,5.9 5,7C5,8.1 5.9,9 7,9C8.1,9 9,8.1 9,7C9,5.9 8.1,5 7,5M17,15C15.9,15 15,15.9 15,17C15,18.1 15.9,19 17,19C18.1,19 19,18.1 19,17C19,15.9 18.1,15 17,15Z",
  },
  {
    id: "F7FA1307-CC98-4B93-B42A-533F1F6E851C",
    name: "dice-4",
    codepoint: "F1CD",
    aliases: ["die-4", "dice-four"],
    tags: [],
    author: "Yasmina Lembachar",
    version: "1.5.54",
    path: "M5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3M7,5C5.9,5 5,5.9 5,7C5,8.1 5.9,9 7,9C8.1,9 9,8.1 9,7C9,5.9 8.1,5 7,5M17,15C15.9,15 15,15.9 15,17C15,18.1 15.9,19 17,19C18.1,19 19,18.1 19,17C19,15.9 18.1,15 17,15M17,5C15.9,5 15,5.9 15,7C15,8.1 15.9,9 17,9C18.1,9 19,8.1 19,7C19,5.9 18.1,5 17,5M7,15C5.9,15 5,15.9 5,17C5,18.1 5.9,19 7,19C8.1,19 9,18.1 9,17C9,15.9 8.1,15 7,15Z",
  },
  {
    id: "9B9F7FE0-5AA9-4B5F-B865-D7F21C1382AF",
    name: "dice-5",
    codepoint: "F1CE",
    aliases: ["die-5", "dice-five"],
    tags: [],
    author: "Yasmina Lembachar",
    version: "1.5.54",
    path: "M5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3M7,5C5.9,5 5,5.9 5,7C5,8.1 5.9,9 7,9C8.1,9 9,8.1 9,7C9,5.9 8.1,5 7,5M17,15C15.9,15 15,15.9 15,17C15,18.1 15.9,19 17,19C18.1,19 19,18.1 19,17C19,15.9 18.1,15 17,15M17,5C15.9,5 15,5.9 15,7C15,8.1 15.9,9 17,9C18.1,9 19,8.1 19,7C19,5.9 18.1,5 17,5M12,10C10.9,10 10,10.9 10,12C10,13.1 10.9,14 12,14C13.1,14 14,13.1 14,12C14,10.9 13.1,10 12,10M7,15C5.9,15 5,15.9 5,17C5,18.1 5.9,19 7,19C8.1,19 9,18.1 9,17C9,15.9 8.1,15 7,15Z",
  },
  {
    id: "015F173B-CA59-4125-8F19-925ED108BE07",
    name: "dice-6",
    codepoint: "F1CF",
    aliases: ["die-6", "dice-six"],
    tags: [],
    author: "Yasmina Lembachar",
    version: "1.5.54",
    path: "M5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3M7,5C5.9,5 5,5.9 5,7C5,8.1 5.9,9 7,9C8.1,9 9,8.1 9,7C9,5.9 8.1,5 7,5M17,15C15.9,15 15,15.9 15,17C15,18.1 15.9,19 17,19C18.1,19 19,18.1 19,17C19,15.9 18.1,15 17,15M17,10C15.9,10 15,10.9 15,12C15,13.1 15.9,14 17,14C18.1,14 19,13.1 19,12C19,10.9 18.1,10 17,10M17,5C15.9,5 15,5.9 15,7C15,8.1 15.9,9 17,9C18.1,9 19,8.1 19,7C19,5.9 18.1,5 17,5M7,10C5.9,10 5,10.9 5,12C5,13.1 5.9,14 7,14C8.1,14 9,13.1 9,12C9,10.9 8.1,10 7,10M7,15C5.9,15 5,15.9 5,17C5,18.1 5.9,19 7,19C8.1,19 9,18.1 9,17C9,15.9 8.1,15 7,15Z",
  },
  {
    id: "47BB1E5C-0CCD-4A50-B1EF-2437411217C0",
    name: "dice-d10",
    codepoint: "F76E",
    aliases: ["die-d10"],
    tags: [],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M21.5,10.8C22.1,11.5 22.1,12.5 21.5,13.2L13.2,21.5C12.5,22.2 11.5,22.2 10.8,21.5L2.5,13.2C1.8,12.5 1.8,11.5 2.5,10.8L10.8,2.5C11.5,1.8 12.5,1.8 13.2,2.5L21.5,10.8M20.3,12L12,3.7L3.7,12L12,20.3L20.3,12M10.38,15.79H8.88V10L7.08,10.55V9.32L10.22,8.2H10.38V15.79M13.93,8C15.35,8 16.5,9.15 16.5,10.57V13.21C16.5,14.63 15.35,15.78 13.93,15.78C12.5,15.78 11.36,14.63 11.36,13.21V10.57C11.36,9.15 12.51,8 13.93,8M13.92,9.44C13.33,9.44 12.86,9.91 12.86,10.5V13.27C12.86,13.86 13.33,14.33 13.92,14.33C14.5,14.33 15,13.85 15,13.27V10.5C15,9.91 14.5,9.44 13.92,9.44Z",
  },
  {
    id: "E27CCA75-CE3E-4C7D-81AA-D3A1391A819E",
    name: "dice-d12",
    codepoint: "F866",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.1.99",
    path: "M12,2L1.5,9.64L5.5,22H18.5L22.5,9.64L12,2M17,20H7L3.85,10.4L12,4.47L20.15,10.4L17,20M17,15.75V17H11.66V15.91C11.66,15.91 15.23,12.45 15.23,11.4C15.23,10.12 14.18,10.25 14.18,10.25C13.5,10.3 13,10.87 13,11.55H11.44C11.5,10.09 12.72,8.94 14.27,9C16.74,9 16.77,10.85 16.77,11.3C16.77,13.07 13.58,15.77 13.58,15.77L17,15.75M10.5,17H8.89V10.89L7,11.47V10.19L10.31,9H10.5V17Z",
  },
  {
    id: "926FAA94-AB58-44AA-916C-66AF56A5BCCF",
    name: "dice-d20",
    codepoint: "F5EA",
    aliases: ["die-d20"],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5M12,4.15L5,8.09V15.91L12,19.85L19,15.91V8.09L12,4.15M14.93,8.27C16.35,8.27 17.5,9.42 17.5,10.84V13.5C17.5,14.9 16.35,16.05 14.93,16.05C13.5,16.05 12.36,14.9 12.36,13.5V10.84C12.36,9.42 13.51,8.27 14.93,8.27M14.92,9.71C14.34,9.71 13.86,10.18 13.86,10.77V13.53C13.86,14.12 14.34,14.6 14.92,14.6C15.5,14.6 16,14.12 16,13.53V10.77C16,10.18 15.5,9.71 14.92,9.71M11.45,14.76V15.96L6.31,15.93V14.91C6.31,14.91 9.74,11.58 9.75,10.57C9.75,9.33 8.73,9.46 8.73,9.46C8.73,9.46 7.75,9.5 7.64,10.71L6.14,10.76C6.14,10.76 6.18,8.26 8.83,8.26C11.2,8.26 11.23,10.04 11.23,10.5C11.23,12.18 8.15,14.77 8.15,14.77L11.45,14.76Z",
  },
  {
    id: "DCC141FA-CA87-48E1-969D-BB010C973DD5",
    name: "dice-d4",
    codepoint: "F5EB",
    aliases: ["die-d4"],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M13.43,15.15H14.29V16.36H13.43V18H11.92V16.36H8.82L8.75,15.41L11.91,10.42H13.43V15.15M10.25,15.15H11.92V12.47L10.25,15.15M22,21H2C1.64,21 1.31,20.81 1.13,20.5C0.95,20.18 0.96,19.79 1.15,19.5L11.15,3C11.5,2.38 12.5,2.38 12.86,3L22.86,19.5C23.04,19.79 23.05,20.18 22.87,20.5C22.69,20.81 22.36,21 22,21M3.78,19H20.23L12,5.43L3.78,19Z",
  },
  {
    id: "A0F00FDF-6648-475B-819B-29E4C0769FFA",
    name: "dice-d6",
    codepoint: "F5EC",
    aliases: ["die-d6"],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3M5,5V19H19V5H5M13.39,9.53C10.89,9.5 10.86,11.53 10.86,11.53C10.86,11.53 11.41,10.87 12.53,10.87C13.19,10.87 14.5,11.45 14.55,13.41C14.61,15.47 12.77,16 12.77,16C12.77,16 9.27,16.86 9.3,12.66C9.33,7.94 13.39,8.33 13.39,8.33V9.53M11.95,12.1C11.21,12 10.83,12.78 10.83,12.78L10.85,13.5C10.85,14.27 11.39,14.83 12,14.83C12.61,14.83 13.05,14.27 13.05,13.5C13.05,12.73 12.56,12.1 11.95,12.1Z",
  },
  {
    id: "64967BE6-CAAF-4F28-BF55-C5451D4E8B94",
    name: "dice-d8",
    codepoint: "F5ED",
    aliases: ["die-d8"],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,8.25C13.31,8.25 14.38,9.2 14.38,10.38C14.38,11.07 14,11.68 13.44,12.07C14.14,12.46 14.6,13.13 14.6,13.9C14.6,15.12 13.44,16.1 12,16.1C10.56,16.1 9.4,15.12 9.4,13.9C9.4,13.13 9.86,12.46 10.56,12.07C10,11.68 9.63,11.07 9.63,10.38C9.63,9.2 10.69,8.25 12,8.25M12,12.65C11.39,12.65 10.9,13.14 10.9,13.75C10.9,14.36 11.39,14.85 12,14.85C12.61,14.85 13.1,14.36 13.1,13.75C13.1,13.14 12.61,12.65 12,12.65M12,9.5C11.5,9.5 11.1,9.95 11.1,10.5C11.1,11.05 11.5,11.5 12,11.5C12.5,11.5 12.9,11.05 12.9,10.5C12.9,9.95 12.5,9.5 12,9.5M21.54,10.8C22.14,11.5 22.14,12.5 21.54,13.2L13.24,21.5C12.54,22.2 11.54,22.2 10.84,21.5L2.54,13.2C1.84,12.5 1.84,11.5 2.54,10.8L10.84,2.5C11.54,1.8 12.54,1.8 13.24,2.5L21.54,10.8M20.34,12L12.04,3.7L3.74,12L12.04,20.3L20.34,12Z",
  },
  {
    id: "8C9D5084-1B34-4AB9-BE23-E44B03AE85E5",
    name: "dice-multiple",
    codepoint: "F76D",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "1.9.32",
    path: "M19.78,3H11.22C10.55,3 10,3.55 10,4.22V8H16V14H19.78C20.45,14 21,13.45 21,12.78V4.22C21,3.55 20.45,3 19.78,3M12.44,6.67C11.76,6.67 11.21,6.12 11.21,5.44C11.21,4.76 11.76,4.21 12.44,4.21C13.12,4.21 13.67,4.76 13.67,5.44C13.67,6.12 13.12,6.67 12.44,6.67M18.56,12.78C17.88,12.79 17.33,12.24 17.32,11.56C17.31,10.88 17.86,10.33 18.54,10.32C19.22,10.31 19.77,10.86 19.78,11.56C19.77,12.23 19.23,12.77 18.56,12.78M18.56,6.67C17.88,6.68 17.33,6.13 17.32,5.45C17.31,4.77 17.86,4.22 18.54,4.21C19.22,4.2 19.77,4.75 19.78,5.44C19.78,6.12 19.24,6.66 18.56,6.67M4.22,10H12.78C13.45,10 14,10.55 14,11.22V19.78C14,20.45 13.45,21 12.78,21H4.22C3.55,21 3,20.45 3,19.78V11.22C3,10.55 3.55,10 4.22,10M8.5,14.28C7.83,14.28 7.28,14.83 7.28,15.5C7.28,16.17 7.83,16.72 8.5,16.72C9.17,16.72 9.72,16.17 9.72,15.5C9.72,14.83 9.17,14.28 8.5,14.28M5.44,11.22C4.77,11.22 4.22,11.77 4.22,12.44C4.22,13.11 4.77,13.66 5.44,13.66C6.11,13.66 6.66,13.11 6.66,12.44V12.44C6.66,11.77 6.11,11.22 5.44,11.22M11.55,17.33C10.88,17.33 10.33,17.88 10.33,18.55C10.33,19.22 10.88,19.77 11.55,19.77C12.22,19.77 12.77,19.22 12.77,18.55H12.77C12.77,17.88 12.23,17.34 11.56,17.33H11.55Z",
  },
  {
    id: "2356EE38-11BE-44B1-BAD9-D74ECE86F8E7",
    name: "dip-switch",
    codepoint: "F7C0",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "2.0.46",
    path: "M3,4H7C7.55,4 8,4.45 8,5V19C8,19.55 7.55,20 7,20H3C2.45,20 2,19.55 2,19V5C2,4.45 2.45,4 3,4M10,4H14C14.55,4 15,4.45 15,5V19C15,19.55 14.55,20 14,20H10C9.45,20 9,19.55 9,19V5C9,4.45 9.45,4 10,4M17,4H21C21.55,4 22,4.45 22,5V19C22,19.55 21.55,20 21,20H17C16.45,20 16,19.55 16,19V5C16,4.45 16.45,4 17,4M4,18H6V13H4V18M11,11H13V6H11V11M18,18H20V13H18V18Z",
  },
  {
    id: "4C84603B-BEB6-4282-B6CE-D9AD3C098627",
    name: "directions",
    codepoint: "F1D0",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M14,14.5V12H10V15H8V11C8,10.45 8.45,10 9,10H14V7.5L17.5,11M21.71,11.29L12.71,2.29H12.7C12.31,1.9 11.68,1.9 11.29,2.29L2.29,11.29C1.9,11.68 1.9,12.32 2.29,12.71L11.29,21.71C11.68,22.09 12.31,22.1 12.71,21.71L21.71,12.71C22.1,12.32 22.1,11.68 21.71,11.29Z",
  },
  {
    id: "8F53DAC3-E72D-473E-ABD1-AC1849EB660A",
    name: "directions-fork",
    codepoint: "F641",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.6.50",
    path: "M3,4V12.5L6,9.5L9,13C10,14 10,15 10,15V21H14V14C14,14 14,13 13.47,12C12.94,11 12,10 12,10L9,6.58L11.5,4M18,4L13.54,8.47L14,9C14,9 14.93,10 15.47,11C15.68,11.4 15.8,11.79 15.87,12.13L21,7",
  },
  {
    id: "95CEA0DD-5123-4FFA-B906-E6C55766030D",
    name: "disc",
    codepoint: "F5EE",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M12,14C10.89,14 10,13.1 10,12C10,10.89 10.89,10 12,10C13.11,10 14,10.89 14,12C14,13.1 13.1,14 12,14M12,4C7.58,4 4,7.58 4,12C4,16.42 7.58,20 12,20C16.42,20 20,16.42 20,12C20,7.58 16.42,4 12,4Z",
  },
  {
    id: "63A41E0F-CCDB-42F8-848B-F64AA94F9BDF",
    name: "disc-alert",
    codepoint: "F1D1",
    aliases: ["disc-full"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M10,14C8.89,14 8,13.1 8,12C8,10.89 8.89,10 10,10C11.1,10 12,10.9 12,12C12,13.1 11.1,14 10,14M10,4C5.58,4 2,7.58 2,12C2,16.42 5.58,20 10,20C14.42,20 18,16.42 18,12C18,7.58 14.42,4 10,4M20,12H22V7H20M20,16H22V14H20V16Z",
  },
  {
    id: "DA84CDD7-3881-4DE0-8CEB-51F1BD086A3A",
    name: "disc-player",
    codepoint: "F95F",
    aliases: [],
    tags: ["Home Automation"],
    author: "Austin Andrews",
    version: "2.4.85",
    path: "M14.5,10.37C15.54,10.37 16.38,9.53 16.38,8.5C16.38,7.46 15.54,6.63 14.5,6.63C13.46,6.63 12.63,7.46 12.63,8.5C12.63,9.53 13.47,10.37 14.5,10.37M14.5,1C18.64,1 22,4.36 22,8.5C22,10.67 21.08,12.63 19.6,14H9.4C7.93,12.63 7,10.67 7,8.5C7,4.35 10.36,1 14.5,1M6,21V22H4V21H2V15H22V21H20V22H18V21H6M4,18V19H13V18H4M15,17V19H17V17H15M19,17C18.45,17 18,17.45 18,18C18,18.55 18.45,19 19,19C19.55,19 20,18.55 20,18C20,17.45 19.55,17 19,17Z",
  },
  {
    id: "2C23A3F9-54C7-4C7F-8C2F-182A4F75F894",
    name: "discord",
    codepoint: "F66F",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.6.50",
    path: "M22,24L16.75,19L17.38,21H4.5C3.12,21 2,19.88 2,18.5V3.5C2,2.12 3.12,1 4.5,1H19.5C20.88,1 22,2.12 22,3.5V24M12,6.8C9.32,6.8 7.44,7.95 7.44,7.95C8.47,7.03 10.27,6.5 10.27,6.5L10.1,6.33C8.41,6.36 6.88,7.53 6.88,7.53C5.16,11.12 5.27,14.22 5.27,14.22C6.67,16.03 8.75,15.9 8.75,15.9L9.46,15C8.21,14.73 7.42,13.62 7.42,13.62C7.42,13.62 9.3,14.9 12,14.9C14.7,14.9 16.58,13.62 16.58,13.62C16.58,13.62 15.79,14.73 14.54,15L15.25,15.9C15.25,15.9 17.33,16.03 18.73,14.22C18.73,14.22 18.84,11.12 17.12,7.53C17.12,7.53 15.59,6.36 13.9,6.33L13.73,6.5C13.73,6.5 15.53,7.03 16.56,7.95C16.56,7.95 14.68,6.8 12,6.8M9.93,10.59C10.58,10.59 11.11,11.16 11.1,11.86C11.1,12.55 10.58,13.13 9.93,13.13C9.29,13.13 8.77,12.55 8.77,11.86C8.77,11.16 9.28,10.59 9.93,10.59M14.1,10.59C14.75,10.59 15.27,11.16 15.27,11.86C15.27,12.55 14.75,13.13 14.1,13.13C13.46,13.13 12.94,12.55 12.94,11.86C12.94,11.16 13.45,10.59 14.1,10.59Z",
  },
  {
    id: "28670432-3B76-43FC-B879-558B338F1E1F",
    name: "disqus",
    codepoint: "F1D2",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12.08,22C9.63,22 7.39,21.11 5.66,19.63L1.41,20.21L3.05,16.15C2.5,14.88 2.16,13.5 2.16,12C2.16,6.5 6.6,2 12.08,2C17.56,2 22,6.5 22,12C22,17.5 17.56,22 12.08,22M17.5,11.97V11.94C17.5,9.06 15.46,7 11.95,7H8.16V17H11.9C15.43,17 17.5,14.86 17.5,11.97M12,14.54H10.89V9.46H12C13.62,9.46 14.7,10.39 14.7,12V12C14.7,13.63 13.62,14.54 12,14.54Z",
  },
  {
    id: "66BF0ABD-9688-49F1-B260-382B15D53432",
    name: "disqus-outline",
    codepoint: "F1D3",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Gabriel",
    version: "1.5.54",
    path: "M11.9,14.5H10.8V9.5H11.9C13.5,9.5 14.6,10.4 14.6,12C14.6,13.6 13.5,14.5 11.9,14.5M11.9,7H8.1V17H11.8C15.3,17 17.4,14.9 17.4,12V12C17.4,9.1 15.4,7 11.9,7M12,20C10.1,20 8.3,19.3 6.9,18.1L6.2,17.5L4.5,17.7L5.2,16.1L4.9,15.3C4.4,14.2 4.2,13.1 4.2,11.9C4.2,7.5 7.8,3.9 12.1,3.9C16.4,3.9 19.9,7.6 19.9,12C19.9,16.4 16.3,20 12,20M12,2C6.5,2 2.1,6.5 2.1,12C2.1,13.5 2.4,14.9 3,16.2L1.4,20.3L5.7,19.7C7.4,21.2 9.7,22.1 12.1,22.1C17.6,22.1 22,17.6 22,12.1C22,6.6 17.5,2 12,2Z",
  },
  {
    id: "FB313489-5EA3-4F07-ABA4-F84995D7DD13",
    name: "division",
    codepoint: "F1D4",
    aliases: [],
    tags: ["Math"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M19,13H5V11H19V13M12,5C13.1,5 14,5.9 14,7C14,8.1 13.1,9 12,9C10.9,9 10,8.1 10,7C10,5.9 10.9,5 12,5M12,15C13.1,15 14,15.9 14,17C14,18.1 13.1,19 12,19C10.9,19 10,18.1 10,17C10,15.9 10.9,15 12,15Z",
  },
  {
    id: "1A0BABA0-5F5E-45ED-A4BB-DCBD569F6E43",
    name: "division-box",
    codepoint: "F1D5",
    aliases: [],
    tags: ["Math"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M17,13V11H7V13H17M19,3C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H19M12,7C11.45,7 11,7.45 11,8C11,8.55 11.45,9 12,9C12.55,9 13,8.55 13,8C13,7.45 12.55,7 12,7M12,15C11.45,15 11,15.45 11,16C11,16.55 11.45,17 12,17C12.55,17 13,16.55 13,16C13,15.45 12.55,15 12,15Z",
  },
  {
    id: "2C726E7E-53C8-410C-82F4-FE5DE9EF4BC1",
    name: "dna",
    codepoint: "F683",
    aliases: ["helix"],
    tags: ["Science"],
    author: "JapanYoshi",
    version: "1.7.12",
    path: "M4,2H6V4C6,5.44 6.68,6.61 7.88,7.78C8.74,8.61 9.89,9.41 11.09,10.2L9.26,11.39C8.27,10.72 7.31,10 6.5,9.21C5.07,7.82 4,6.1 4,4V2M18,2H20V4C20,6.1 18.93,7.82 17.5,9.21C16.09,10.59 14.29,11.73 12.54,12.84C10.79,13.96 9.09,15.05 7.88,16.22C6.68,17.39 6,18.56 6,20V22H4V20C4,17.9 5.07,16.18 6.5,14.79C7.91,13.41 9.71,12.27 11.46,11.16C13.21,10.04 14.91,8.95 16.12,7.78C17.32,6.61 18,5.44 18,4V2M14.74,12.61C15.73,13.28 16.69,14 17.5,14.79C18.93,16.18 20,17.9 20,20V22H18V20C18,18.56 17.32,17.39 16.12,16.22C15.26,15.39 14.11,14.59 12.91,13.8L14.74,12.61M7,3H17V4L16.94,4.5H7.06L7,4V3M7.68,6H16.32C16.08,6.34 15.8,6.69 15.42,7.06L14.91,7.5H9.07L8.58,7.06C8.2,6.69 7.92,6.34 7.68,6M9.09,16.5H14.93L15.42,16.94C15.8,17.31 16.08,17.66 16.32,18H7.68C7.92,17.66 8.2,17.31 8.58,16.94L9.09,16.5M7.06,19.5H16.94L17,20V21H7V20L7.06,19.5Z",
  },
  {
    id: "D4A20191-F5B8-4323-A0A8-F4C15A86A83B",
    name: "dns",
    codepoint: "F1D6",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M7,9C5.9,9 5,8.1 5,7C5,5.9 5.9,5 7,5C8.1,5 9,5.9 9,7C9,8.1 8.1,9 7,9M20,3H4C3.45,3 3,3.45 3,4V10C3,10.55 3.45,11 4,11H20C20.55,11 21,10.55 21,10V4C21,3.45 20.55,3 20,3M7,19C5.9,19 5,18.1 5,17C5,15.9 5.9,15 7,15C8.1,15 9,15.9 9,17C9,18.1 8.1,19 7,19M20,13H4C3.45,13 3,13.45 3,14V20C3,20.55 3.45,21 4,21H20C20.55,21 21,20.55 21,20V14C21,13.45 20.55,13 20,13Z",
  },
  {
    id: "F33DB278-2B2B-4731-9FDD-6D053EC2CBAB",
    name: "do-not-disturb",
    codepoint: "F697",
    aliases: ["no-entry"],
    tags: [],
    author: "Google",
    version: "1.7.12",
    path: "M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M17,13H7V11H17V13Z",
  },
  {
    id: "092B5CD3-BB99-492C-9784-4BE71B0C7F5B",
    name: "do-not-disturb-off",
    codepoint: "F698",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.7.12",
    path: "M17,11V13H15.54L20.22,17.68C21.34,16.07 22,14.11 22,12C22,6.48 17.52,2 12,2C9.89,2 7.93,2.66 6.32,3.78L13.54,11H17M2.27,2.27L1,3.54L3.78,6.32C2.66,7.93 2,9.89 2,12C2,17.52 6.48,22 12,22C14.11,22 16.07,21.34 17.68,20.22L20.46,23L21.73,21.73L2.27,2.27M7,13V11H8.46L10.46,13H7Z",
  },
  {
    id: "8EE88381-B350-4C63-B26D-F340FE54D668",
    name: "docker",
    codepoint: "F867",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Contributors",
    version: "2.1.99",
    path: "M2.2,9.76H4.44V11.94H2.2V9.76H2.2M4.95,9.76H7.2V11.94H4.95V9.76H4.95M4.95,6.96H7.2V9.14H4.95V6.96M7.71,9.76H9.95V11.94H7.71V9.76H7.71M7.71,6.96H9.95V9.14H7.71V6.96M10.46,9.76H12.71V11.94H10.46V9.76H10.46M10.46,6.96H12.71V9.14H10.46V6.96M13.22,9.76H15.46V11.94H13.22V9.76H13.22M10.46,4.16H12.71V6.34H10.46V4.16M5.33,15.09C5.68,15.09 5.96,15.36 5.96,15.7C5.96,16.03 5.68,16.31 5.33,16.31C5,16.31 4.71,16.03 4.71,15.7C4.71,15.36 5,15.09 5.33,15.09M22.69,10.89V10.89L23,11.06L22.84,11.37C22.2,12.58 20.87,12.95 19.57,12.89C17.62,17.6 13.37,19.84 8.23,19.84C5.57,19.84 3.13,18.87 1.74,16.58L1.72,16.54L1.5,16.14C1.05,15.13 0.89,14.03 1,12.92L1.03,12.59H15.8C16.33,12.59 16.87,12.5 17.36,12.34L18.12,12C17.81,11.6 17.64,11.09 17.6,10.59C17.53,9.91 17.67,9 18.15,8.5L18.39,8.22L18.67,8.44C19.38,9 19.97,9.77 20.08,10.65C20.93,10.41 21.94,10.46 22.69,10.89M5.34,16.85V16.85C6,16.85 6.5,16.33 6.5,15.7C6.5,15.06 6,14.54 5.33,14.54C4.68,14.54 4.15,15.06 4.15,15.7C4.15,16.34 4.68,16.85 5.34,16.85Z",
  },
  {
    id: "FE71CD75-B2E7-49A5-B00B-732BACB52F6F",
    name: "dolby",
    codepoint: "F6B2",
    aliases: [],
    tags: ["Audio", "Brand / Logo", "Home Automation"],
    author: "Michael Richins",
    version: "1.7.22",
    path: "M2,5V19H22V5H2M6,17H4V7H6C8.86,7.09 11.1,9.33 11,12C11.1,14.67 8.86,16.91 6,17M20,17H18C15.14,16.91 12.9,14.67 13,12C12.9,9.33 15.14,7.09 18,7H20V17Z",
  },
  {
    id: "CA264BA4-62A9-4823-A172-22DD413A6CF5",
    name: "domain",
    codepoint: "F1D7",
    aliases: ["building", "company", "business"],
    tags: ["Places"],
    author: "Google",
    version: "1.5.54",
    path: "M18,15H16V17H18M18,11H16V13H18M20,19H12V17H14V15H12V13H14V11H12V9H20M10,7H8V5H10M10,11H8V9H10M10,15H8V13H10M10,19H8V17H10M6,7H4V5H6M6,11H4V9H6M6,15H4V13H6M6,19H4V17H6M12,7V3H2V21H22V7H12Z",
  },
  {
    id: "7027E5FC-228D-4E32-B2BB-02287E94D132",
    name: "donkey",
    codepoint: "F7C1",
    aliases: [],
    tags: ["Animal"],
    author: "Contributors",
    version: "2.0.46",
    path: "M21.34,10.35L21.27,10.28L21.18,10.19L18,7V6C18,5.72 17.78,5.5 17.5,5.5C17.36,5.5 17.22,5.56 17.13,5.66L13.46,9H7C6.32,9 5.69,9.35 5.32,9.92L2.62,12.59C2.29,13.04 2.39,13.66 2.84,14C3.18,14.24 3.65,14.25 4,14L5,13.07V19H8V15H13V19H16V13.83C16,13.3 16.21,12.79 16.59,12.42L18,11L20,12V12C20.15,12.08 20.32,12.13 20.5,12.13C21.1,12.11 21.59,11.61 21.58,11C21.57,10.76 21.5,10.53 21.34,10.35Z",
  },
  {
    id: "858F8782-5001-4950-96F2-65032091A847",
    name: "door",
    codepoint: "F819",
    aliases: [],
    tags: ["Home Automation"],
    author: "JapanYoshi",
    version: "2.1.19",
    path: "M8,3C6.89,3 6,3.89 6,5V21H18V5C18,3.89 17.11,3 16,3H8M8,5H16V19H8V5M13,11V13H15V11H13Z",
  },
  {
    id: "DFE96305-5114-4F53-AB08-08F99F37C2FE",
    name: "door-closed",
    codepoint: "F81A",
    aliases: [],
    tags: ["Home Automation"],
    author: "JapanYoshi",
    version: "2.1.19",
    path: "M16,11H18V13H16V11M12,3H19C20.11,3 21,3.89 21,5V19H22V21H2V19H10V5C10,3.89 10.89,3 12,3M12,5V19H19V5H12Z",
  },
  {
    id: "A64D06DE-1EE4-400F-9E17-2B5D319475A3",
    name: "door-open",
    codepoint: "F81B",
    aliases: [],
    tags: ["Home Automation"],
    author: "JapanYoshi",
    version: "2.1.19",
    path: "M12,3C10.89,3 10,3.89 10,5H3V19H2V21H22V19H21V5C21,3.89 20.11,3 19,3H12M12,5H19V19H12V5M5,11H7V13H5V11Z",
  },
  {
    id: "63848BB0-8CBA-491A-9D3A-5964BAA67CC2",
    name: "doorbell-video",
    codepoint: "F868",
    aliases: [],
    tags: ["Home Automation"],
    author: "GreenTurtwig",
    version: "2.1.99",
    path: "M7.97,2C6.86,2 6,2.88 6,4V19.92C6,21.03 6.86,21.91 7.97,21.91H15.94C17.04,21.91 17.93,21.03 17.93,19.92V4C17.93,2.88 17.04,2 15.94,2H7.97M11.95,5.5C12.78,5.5 13.45,6.15 13.45,6.97C13.45,7.8 12.78,8.47 11.95,8.47C11.13,8.47 10.46,7.8 10.46,6.97C10.46,6.15 11.13,5.5 11.95,5.5M7.97,9.96H15.94V19.92H7.97V9.96M12,13C10.9,13 10,13.87 10,14.97C10,16.07 10.9,16.97 12,16.97C13.1,16.97 14,16.07 14,14.97C14,13.87 13.1,13 12,13Z",
  },
  {
    id: "9156AFAA-25BB-4E97-9EC8-BB9BE9AF60B0",
    name: "dots-horizontal",
    codepoint: "F1D8",
    aliases: ["more", "ellipsis-horizontal", "more-horiz"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M16,12C16,10.9 16.9,10 18,10C19.1,10 20,10.9 20,12C20,13.1 19.1,14 18,14C16.9,14 16,13.1 16,12M10,12C10,10.9 10.9,10 12,10C13.1,10 14,10.9 14,12C14,13.1 13.1,14 12,14C10.9,14 10,13.1 10,12M4,12C4,10.9 4.9,10 6,10C7.1,10 8,10.9 8,12C8,13.1 7.1,14 6,14C4.9,14 4,13.1 4,12Z",
  },
  {
    id: "2ED6A664-DAE9-427C-8810-496C331C9BE0",
    name: "dots-horizontal-circle",
    codepoint: "F7C2",
    aliases: ["ellipsis-horizontal-circle", "more-circle"],
    tags: [],
    author: "Contributors",
    version: "2.0.46",
    path: "M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M12,10.5C11.17,10.5 10.5,11.17 10.5,12C10.5,12.83 11.17,13.5 12,13.5C12.83,13.5 13.5,12.83 13.5,12C13.5,11.17 12.83,10.5 12,10.5M6.5,10.5C5.67,10.5 5,11.17 5,12C5,12.83 5.67,13.5 6.5,13.5C7.33,13.5 8,12.83 8,12C8,11.17 7.33,10.5 6.5,10.5M17.5,10.5C16.67,10.5 16,11.17 16,12C16,12.83 16.67,13.5 17.5,13.5C18.33,13.5 19,12.83 19,12C19,11.17 18.33,10.5 17.5,10.5Z",
  },
  {
    id: "5D70B3D1-8407-42C9-A3C1-42EE68FF18F3",
    name: "dots-vertical",
    codepoint: "F1D9",
    aliases: ["ellipsis-vertical", "more-vert"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M12,16C13.1,16 14,16.9 14,18C14,19.1 13.1,20 12,20C10.9,20 10,19.1 10,18C10,16.9 10.9,16 12,16M12,10C13.1,10 14,10.9 14,12C14,13.1 13.1,14 12,14C10.9,14 10,13.1 10,12C10,10.9 10.9,10 12,10M12,4C13.1,4 14,4.9 14,6C14,7.1 13.1,8 12,8C10.9,8 10,7.1 10,6C10,4.9 10.9,4 12,4Z",
  },
  {
    id: "5D23E65D-271A-463B-972F-E8524E76E6D7",
    name: "dots-vertical-circle",
    codepoint: "F7C3",
    aliases: ["ellipsis-vertical-circle"],
    tags: [],
    author: "Contributors",
    version: "2.0.46",
    path: "M2,12C2,6.48 6.48,2 12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12M10.5,12C10.5,12.83 11.17,13.5 12,13.5C12.83,13.5 13.5,12.83 13.5,12C13.5,11.17 12.83,10.5 12,10.5C11.17,10.5 10.5,11.17 10.5,12M10.5,17.5C10.5,18.33 11.17,19 12,19C12.83,19 13.5,18.33 13.5,17.5C13.5,16.67 12.83,16 12,16C11.17,16 10.5,16.67 10.5,17.5M10.5,6.5C10.5,7.33 11.17,8 12,8C12.83,8 13.5,7.33 13.5,6.5C13.5,5.67 12.83,5 12,5C11.17,5 10.5,5.67 10.5,6.5Z",
  },
  {
    id: "FF8D4F38-8A77-4FDD-8C6D-D17F6A44516D",
    name: "douban",
    codepoint: "F699",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Michael Richins",
    version: "1.7.12",
    path: "M20,6H4V4H20V6M20,18V20H4V18H7.33L6.26,14H5V8H19V14H17.74L16.67,18H20M7,12H17V10H7V12M9.4,18H14.6L15.67,14H8.33L9.4,18Z",
  },
  {
    id: "704F7397-0E85-4213-8D76-FE156DF1795F",
    name: "download",
    codepoint: "F1DA",
    aliases: ["file-download", "get-app"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z",
  },
  {
    id: "EEECC393-B78C-43DE-BDA4-F31DACA25F56",
    name: "download-multiple",
    codepoint: "F9E8",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "2.5.94",
    path: "M9,1V7H5L12,14L19,7H15V1H9M5,16V18H19V16H5M5,20V22H19V20H5Z",
  },
  {
    id: "8DD93DC3-060D-4CB3-AB41-8A1A5243BFFD",
    name: "download-network",
    codepoint: "F6F3",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.8.36",
    path: "M17,3C18.1,3 19,3.9 19,5V15C19,16.1 18.1,17 17,17H13V19H14C14.55,19 15,19.45 15,20H22V22H15C15,22.55 14.55,23 14,23H10C9.45,23 9,22.55 9,22H2V20H9C9,19.45 9.45,19 10,19H11V17H7C5.89,17 5,16.1 5,15V5C5,3.9 5.9,3 7,3H17M12,14.5L16.5,10H13V6H11V10H7.5L12,14.5Z",
  },
  {
    id: "2366C232-208F-4A03-9FC9-D9C8C52622CA",
    name: "drag",
    codepoint: "F1DB",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M7,19V17H9V19H7M11,19V17H13V19H11M15,19V17H17V19H15M7,15V13H9V15H7M11,15V13H13V15H11M15,15V13H17V15H15M7,11V9H9V11H7M11,11V9H13V11H11M15,11V9H17V11H15M7,7V5H9V7H7M11,7V5H13V7H11M15,7V5H17V7H15Z",
  },
  {
    id: "544A0702-E7DC-4E1F-9A6E-8785AA3048D8",
    name: "drag-horizontal",
    codepoint: "F1DC",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M3,15V13H5V15H3M3,11V9H5V11H3M7,15V13H9V15H7M7,11V9H9V11H7M11,15V13H13V15H11M11,11V9H13V11H11M15,15V13H17V15H15M15,11V9H17V11H15M19,15V13H21V15H19M19,11V9H21V11H19Z",
  },
  {
    id: "4B8D8E9B-547D-4DE3-B8E1-5023867EF965",
    name: "drag-vertical",
    codepoint: "F1DD",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M9,3H11V5H9V3M13,3H15V5H13V3M9,7H11V9H9V7M13,7H15V9H13V7M9,11H11V13H9V11M13,11H15V13H13V11M9,15H11V17H9V15M13,15H15V17H13V15M9,19H11V21H9V19M13,19H15V21H13V19Z",
  },
  {
    id: "E8557F02-8241-47FB-B546-402947A5818C",
    name: "drawing",
    codepoint: "F1DE",
    aliases: [],
    tags: ["Drawing / Art", "Shape"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M8.5,3C11.54,3 14,5.46 14,8.5C14,9.83 13.53,11.05 12.74,12H21V21H12V12.74C11.05,13.53 9.83,14 8.5,14C5.46,14 3,11.54 3,8.5C3,5.46 5.46,3 8.5,3Z",
  },
  {
    id: "BF9750EC-EB85-4670-A4DE-4808729249B5",
    name: "drawing-box",
    codepoint: "F1DF",
    aliases: [],
    tags: ["Drawing / Art", "Shape"],
    author: "Google",
    version: "1.5.54",
    path: "M18,18H12V12.21C11.34,12.82 10.47,13.2 9.5,13.2C7.46,13.2 5.8,11.54 5.8,9.5C5.8,7.46 7.46,5.8 9.5,5.8C11.54,5.8 13.2,7.46 13.2,9.5C13.2,10.47 12.82,11.34 12.21,12H18M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3Z",
  },
  {
    id: "B6A0EC44-BDF3-4001-ABBF-51E0F2522BD3",
    name: "drone",
    codepoint: "F1E2",
    aliases: [],
    tags: ["Transportation + Flying"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M22,11H21L20,9H13.75L16,12.5H14L10.75,9H4C3.45,9 2,8.55 2,8C2,7.45 3.5,5.5 5.5,5.5C7.5,5.5 7.67,6.5 9,7H21C21.55,7 22,7.45 22,8V9L22,11M10.75,6.5L14,3H16L13.75,6.5H10.75M18,11V9.5H19.75L19,11H18M3,19C2.45,19 2,18.55 2,18C2,17.45 2.45,17 3,17C5.21,17 7,18.79 7,21C7,21.55 6.55,22 6,22C5.45,22 5,21.55 5,21C5,19.9 4.1,19 3,19M11,21C11,21.55 10.55,22 10,22C9.45,22 9,21.55 9,21C9,17.69 6.31,15 3,15C2.45,15 2,14.55 2,14C2,13.45 2.45,13 3,13C7.42,13 11,16.58 11,21Z",
  },
  {
    id: "C8E22510-9369-4C7C-B598-8799DB9FE2A2",
    name: "dropbox",
    codepoint: "F1E3",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,14.56L16.35,18.16L18.2,16.95V18.3L12,22L5.82,18.3V16.95L7.68,18.16L12,14.56M7.68,2.5L12,6.09L16.32,2.5L22.5,6.5L18.23,9.94L22.5,13.36L16.32,17.39L12,13.78L7.68,17.39L1.5,13.36L5.77,9.94L1.5,6.5L7.68,2.5M12,13.68L18.13,9.94L12,6.19L5.87,9.94L12,13.68Z",
  },
  {
    id: "5FCCAA35-0339-4B8F-984A-D4112C3277C1",
    name: "drupal",
    codepoint: "F1E4",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Kateryna Porshnieva",
    version: "1.5.54",
    path: "M20.47,14.65C20.47,15.29 20.25,16.36 19.83,17.1C19.4,17.85 19.08,18.06 18.44,18.06C17.7,17.95 16.31,15.82 15.36,15.72C14.18,15.72 11.73,18.17 9.71,18.17C8.54,18.17 8.11,17.95 7.79,17.74C7.15,17.31 6.94,16.67 6.94,15.82C6.94,14.22 8.43,12.84 10.24,12.84C12.59,12.84 14.18,15.18 15.36,15.08C16.31,15.08 18.23,13.16 19.19,13.16C20.15,12.95 20.47,14 20.47,14.65M16.63,5.28C15.57,4.64 14.61,4.32 13.54,3.68C12.91,3.25 12.05,2.3 11.31,1.44C11,2.83 10.78,3.36 10.24,3.79C9.18,4.53 8.64,4.85 7.69,5.28C6.94,5.7 3,8.05 3,13.16C3,18.27 7.37,22 12.05,22C16.85,22 21,18.5 21,13.27C21.21,8.05 17.27,5.7 16.63,5.28Z",
  },
  {
    id: "74F300CC-D7A5-45AF-A946-B219E82F8997",
    name: "duck",
    codepoint: "F1E5",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M8.5,5C7.67,5 7,5.67 7,6.5C7,7.33 7.67,8 8.5,8C9.33,8 10,7.33 10,6.5C10,5.67 9.33,5 8.5,5M10,2C12.76,2 15,4.24 15,7C15,8.7 14.15,10.2 12.86,11.1C14.44,11.25 16.22,11.61 18,12.5C21,14 22,12 22,12C22,12 21,21 15,21H9C9,21 4,21 4,16C4,13 7,12 6,10C2,10 2,6.5 2,6.5C3,7 4.24,7 5,6.65C5.19,4.05 7.36,2 10,2Z",
  },
  {
    id: "E792948B-8E66-49B5-83E7-8CDF1ECE6C5D",
    name: "dumbbell",
    codepoint: "F1E6",
    aliases: ["weights"],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M4.22,14.12L3.5,13.41C2.73,12.63 2.73,11.37 3.5,10.59C4.3,9.8 5.56,9.8 6.34,10.59L8.92,13.16L13.16,8.92L10.59,6.34C9.8,5.56 9.8,4.3 10.59,3.5C11.37,2.73 12.63,2.73 13.41,3.5L14.12,4.22L19.78,9.88L20.5,10.59C21.27,11.37 21.27,12.63 20.5,13.41C19.7,14.2 18.44,14.2 17.66,13.41L15.08,10.84L10.84,15.08L13.41,17.66C14.2,18.44 14.2,19.7 13.41,20.5C12.63,21.27 11.37,21.27 10.59,20.5L9.88,19.78L4.22,14.12M3.16,19.42L4.22,18.36L2.81,16.95C2.42,16.56 2.42,15.93 2.81,15.54C3.2,15.15 3.83,15.15 4.22,15.54L8.46,19.78C8.85,20.17 8.85,20.8 8.46,21.19C8.07,21.58 7.44,21.58 7.05,21.19L5.64,19.78L4.58,20.84L3.16,19.42M19.42,3.16L20.84,4.58L19.78,5.64L21.19,7.05C21.58,7.44 21.58,8.07 21.19,8.46C20.8,8.86 20.17,8.86 19.78,8.46L15.54,4.22C15.15,3.83 15.15,3.2 15.54,2.81C15.93,2.42 16.56,2.42 16.95,2.81L18.36,4.22L19.42,3.16Z",
  },
  {
    id: "9F02DA93-0C4D-4A77-8F6B-E4220480AB55",
    name: "ear-hearing",
    codepoint: "F7C4",
    aliases: [],
    tags: [],
    author: "Google",
    version: "2.0.46",
    path: "M17,20C16.71,20 16.44,19.94 16.24,19.85C15.53,19.5 15.03,18.97 14.53,17.47C14,15.91 13.06,15.18 12.14,14.47C11.35,13.86 10.53,13.23 9.82,11.94C9.29,11 9,9.93 9,9C9,6.2 11.2,4 14,4C16.8,4 19,6.2 19,9H21C21,5.07 17.93,2 14,2C10.07,2 7,5.07 7,9C7,10.26 7.38,11.65 8.07,12.9C9,14.55 10.05,15.38 10.92,16.05C11.73,16.67 12.31,17.12 12.63,18.1C13.23,19.92 14,20.94 15.36,21.65C15.87,21.88 16.43,22 17,22C19.21,22 21,20.21 21,18H19C19,19.1 18.1,20 17,20M7.64,2.64L6.22,1.22C4.23,3.21 3,5.96 3,9C3,12.04 4.23,14.79 6.22,16.78L7.63,15.37C6,13.74 5,11.5 5,9C5,6.5 6,4.26 7.64,2.64M11.5,9C11.5,10.38 12.62,11.5 14,11.5C15.38,11.5 16.5,10.38 16.5,9C16.5,7.62 15.38,6.5 14,6.5C12.62,6.5 11.5,7.62 11.5,9Z",
  },
  {
    id: "0D1618BF-A3AD-4B4A-92EA-5DBF93BF7625",
    name: "earth",
    codepoint: "F1E7",
    aliases: ["globe", "public", "planet"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M17.9,17.39C17.64,16.59 16.89,16 16,16H15V13C15,12.45 14.55,12 14,12H8V10H10C10.55,10 11,9.55 11,9V7H13C14.1,7 15,6.1 15,5V4.59C17.93,5.77 20,8.64 20,12C20,14.08 19.2,15.97 17.9,17.39M11,19.93C7.05,19.44 4,16.08 4,12C4,11.38 4.08,10.78 4.21,10.21L9,15V16C9,17.1 9.9,18 11,18M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z",
  },
  {
    id: "3F4C3330-49D5-4F2B-8FCC-A3448BEF521E",
    name: "earth-box",
    codepoint: "F6CC",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "1.8.36",
    path: "M5,3C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3H5M15.78,5H19V17.18C18.74,16.38 17.69,15.79 16.8,15.79H15.8V12.79C15.8,12.24 15.35,11.79 14.8,11.79H8.8V9.79H10.8C11.35,9.79 11.8,9.34 11.8,8.79V6.79H13.8C14.83,6.79 15.67,6 15.78,5M5,10.29L9.8,14.79V15.79C9.8,16.9 10.7,17.79 11.8,17.79V19H5V10.29Z",
  },
  {
    id: "CAE8B8BC-E89F-49C3-8178-6F09ACED1FC3",
    name: "earth-box-off",
    codepoint: "F6CD",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "1.8.36",
    path: "M23,4.27L21,6.27V19C21,20.1 20.1,21 19,21H6.27L4.27,23L3,21.72L21.72,3L23,4.27M5,3H19.18L17.18,5H15.78C15.67,6 14.83,6.79 13.8,6.79H11.8V8.79C11.8,9.35 11.35,9.79 10.8,9.79H8.8V11.79H10.38L8.55,13.62L5,10.29V17.18L3,19.18V5C3,3.89 3.89,3 5,3M11.8,19V17.79C11.17,17.79 10.6,17.5 10.23,17.04L8.27,19H11.8M15.8,12.79V15.79H16.8C17.69,15.79 18.74,16.38 19,17.18V8.27L15.33,11.94C15.61,12.12 15.8,12.43 15.8,12.79Z",
  },
  {
    id: "519E0041-FD5F-4DAD-96A4-BED1EDE9A20B",
    name: "earth-off",
    codepoint: "F1E8",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M22,5.27L20.5,6.75C21.46,8.28 22,10.07 22,12C22,17.52 17.52,22 12,22C10.08,22 8.28,21.46 6.75,20.5L5.27,22L4,20.72L20.72,4L22,5.27M17.9,17.39C19.2,15.97 20,14.08 20,12C20,10.63 19.66,9.34 19.05,8.22L14.83,12.44C14.94,12.6 15,12.79 15,13V16H16C16.89,16 17.64,16.59 17.9,17.39M11,19.93V18C10.5,18 10.07,17.83 9.73,17.54L8.22,19.05C9.07,19.5 10,19.8 11,19.93M15,4.59V5C15,6.1 14.1,7 13,7H11V9C11,9.55 10.55,10 10,10H8V12H10.18L8.09,14.09L4.21,10.21C4.08,10.78 4,11.38 4,12C4,13.74 4.56,15.36 5.5,16.67L4.08,18.1C2.77,16.41 2,14.3 2,12C2,6.48 6.48,2 12,2C14.3,2 16.41,2.77 18.1,4.08L16.67,5.5C16.16,5.14 15.6,4.83 15,4.59Z",
  },
  {
    id: "589595AF-C8FF-451B-A623-2A22D0D2A181",
    name: "eight-track",
    codepoint: "F9E9",
    aliases: ["8-track"],
    tags: [],
    author: "GreenTurtwig",
    version: "2.5.94",
    path: "M7,2L5,5V16L6,20C6.27,21.07 6.9,22 8,22H16C17.1,22 18,21.1 18,20L19,16V5L17,2H15V3H13V2H7M7,6H17V16H7V6Z",
  },
  {
    id: "4B57E9DF-354F-460D-9551-65C0DB55D788",
    name: "eject",
    codepoint: "F1EA",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M12,5L5.33,15H18.67M5,17H19V19H5V17Z",
  },
  {
    id: "0332819B-1686-4375-86E9-0866AE19C2BF",
    name: "elephant",
    codepoint: "F7C5",
    aliases: [],
    tags: ["Animal"],
    author: "Contributors",
    version: "2.0.46",
    path: "M19.5,15.5C19.5,15.78 19.28,16 19,16C18.72,16 18.5,15.78 18.5,15.5V8.5C18.5,6.57 16.43,5 14.5,5H6C3.79,5 2,6.79 2,9V19H6V15H11V19H15V14.5C15,14.22 15.22,14 15.5,14C15.78,14 16,14.22 16,14.5V16C16,17.66 17.34,19 19,19C20.66,19 22,17.66 22,16V14H19.5V15.5Z",
  },
  {
    id: "6057DE08-41EC-4DE6-9ACC-7FB5AF3D4536",
    name: "elevation-decline",
    codepoint: "F1EB",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M21,21H3V11.25L9.45,15L13.22,12.8L21,17.29V21M3,8.94V6.75L9.45,10.5L13.22,8.3L21,12.79V15L13.22,10.5L9.45,12.67L3,8.94Z",
  },
  {
    id: "CEFE04E6-CBE8-4DDD-BCF2-F445579B68FE",
    name: "elevation-rise",
    codepoint: "F1EC",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M3,21V17.29L10.78,12.8L14.55,15L21,11.25V21H3M21,8.94L14.55,12.67L10.78,10.5L3,15V12.79L10.78,8.3L14.55,10.5L21,6.75V8.94Z",
  },
  {
    id: "8A9045D4-D6AC-4660-8C55-D622156A1B8C",
    name: "elevator",
    codepoint: "F1ED",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M7,2L11,6H8V10H6V6H3L7,2M17,10L13,6H16V2H18V6H21L17,10M7,12H17C18.1,12 19,12.9 19,14V20C19,21.1 18.1,22 17,22H7C5.9,22 5,21.1 5,20V14C5,12.9 5.9,12 7,12M7,14V20H17V14H7Z",
  },
  {
    id: "14AAE073-8399-4D67-9F7E-8E9424328681",
    name: "email",
    codepoint: "F1EE",
    aliases: ["local-post-office", "mail", "markunread", "envelope"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M20,8L12,13L4,8V6L12,11L20,6M20,4H4C2.89,4 2,4.89 2,6V18C2,19.1 2.9,20 4,20H20C21.1,20 22,19.1 22,18V6C22,4.89 21.1,4 20,4Z",
  },
  {
    id: "8031577D-2528-4278-9F7B-93BD5DED18E3",
    name: "email-alert",
    codepoint: "F6CE",
    aliases: ["email-warning", "envelope-alert", "envelope-warning"],
    tags: [],
    author: "Austin Andrews",
    version: "1.8.36",
    path: "M16,9V7L10,11L4,7V9L10,13L16,9M16,5C17.1,5 18,5.9 18,7V16C18,17.1 17.1,18 16,18H4C2.89,18 2,17.1 2,16V7C2,5.9 2.9,5 4,5H16M20,12V7H22V12H20M20,16V14H22V16H20Z",
  },
  {
    id: "1E550A45-9D97-4918-9DEC-F536EC5C7A1C",
    name: "email-open",
    codepoint: "F1EF",
    aliases: ["drafts", "envelope-open"],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M4,8L12,13L20,8V8L12,3L4,8V8M22,8V18C22,19.1 21.1,20 20,20H4C2.9,20 2,19.1 2,18V8C2,7.27 2.39,6.64 2.97,6.29L12,0.64L21.03,6.29C21.61,6.64 22,7.27 22,8Z",
  },
  {
    id: "4F7B4311-FC6B-463D-A2A3-760554AF144E",
    name: "email-open-outline",
    codepoint: "F5EF",
    aliases: ["envelope-open-outline"],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,15.36L4,10.36V18H20V10.36L12,15.36M4,8L12,13L20,8V8L12,3L4,8V8M22,8V18C22,19.1 21.1,20 20,20H4C2.9,20 2,19.1 2,18V8C2,7.27 2.39,6.64 2.97,6.29L12,0.64L21.03,6.29C21.61,6.64 22,7.27 22,8Z",
  },
  {
    id: "53CE3621-DBCC-45E8-B105-2BEA7493CCA0",
    name: "email-outline",
    codepoint: "F1F0",
    aliases: ["mail-outline", "envelope-outline"],
    tags: [],
    author: "Gabriel",
    version: "1.5.54",
    path: "M4,4H20C21.1,4 22,4.9 22,6V18C22,19.1 21.1,20 20,20H4C2.89,20 2,19.1 2,18V6C2,4.89 2.89,4 4,4M12,11L20,6H4L12,11M4,18H20V8.37L12,13.36L4,8.37V18Z",
  },
  {
    id: "910E199F-4A9F-473A-90A9-F69C05BD67F1",
    name: "email-plus",
    codepoint: "F9EA",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "2.5.94",
    path: "M3,4C1.89,4 1,4.89 1,6V18C1,19.1 1.9,20 3,20H14.09C14.03,19.67 14,19.34 14,19C14,15.69 16.69,13 20,13C20.34,13 20.67,13.03 21,13.09V6C21,4.89 20.1,4 19,4H3M3,6L11,11L19,6V8L11,13L3,8V6M19,15V18H16V20H19V23H21V20H24V18H21V15H19Z",
  },
  {
    id: "156DF0DC-6BDA-4204-BDDB-5FA69911CDDB",
    name: "email-plus-outline",
    codepoint: "F9EB",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "2.5.94",
    path: "M3,4C1.89,4 1,4.89 1,6V18C1,19.1 1.9,20 3,20H14V18H3V8.37L11,13.36L19,8.37V13H21V6C21,4.9 20.1,4 19,4H3M3,6H19L11,11L3,6M19,15V18H16V20H19V23H21V20H24V18H21V15H19Z",
  },
  {
    id: "AE2AF6F2-9E5A-4949-901F-0B5F599428C7",
    name: "email-search",
    codepoint: "F960",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "2.4.85",
    path: "M3,4H19C20.1,4 21,4.9 21,6V10.82C20,9.85 18.7,9.23 17.31,9.06L19,8V6L11,11L3,6V8L10.62,12.76C10.21,13.62 10,14.55 10,15.5C10,17.18 10.65,18.79 11.81,20H3C1.9,20 1,19.1 1,18V6C1,4.89 1.89,4 3,4M16.5,11C19,11 21,13 21,15.5C21,16.38 20.75,17.21 20.31,17.9L23.39,21L22,22.39L18.88,19.32C18.19,19.75 17.37,20 16.5,20C14,20 12,18 12,15.5C12,13 14,11 16.5,11M16.5,13C15.12,13 14,14.12 14,15.5C14,16.88 15.12,18 16.5,18C17.88,18 19,16.88 19,15.5C19,14.12 17.88,13 16.5,13Z",
  },
  {
    id: "3BC4A964-0137-4E75-B25E-7F01EDFEE1A8",
    name: "email-search-outline",
    codepoint: "F961",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "2.4.85",
    path: "M3,4H19C20.1,4 21,4.9 21,6V10.82C20.42,10.26 19.74,9.81 19,9.5V8.37L17.78,9.13C17.36,9.04 16.93,9 16.5,9C13.86,9 11.5,10.6 10.5,13.04L3,8.37V18H10.5C10.81,18.74 11.26,19.42 11.81,20H3C1.89,20 1,19.1 1,18V6C1,4.89 1.89,4 3,4M3,6L11,11L19,6H3M16.5,11C19,11 21,13 21,15.5C21,16.38 20.75,17.21 20.31,17.9L23.39,21L22,22.39L18.88,19.32C18.19,19.75 17.37,20 16.5,20C14,20 12,18 12,15.5C12,13 14,11 16.5,11M16.5,13C15.12,13 14,14.12 14,15.5C14,16.88 15.12,18 16.5,18C17.88,18 19,16.88 19,15.5C19,14.12 17.88,13 16.5,13Z",
  },
  {
    id: "80BB05EB-8F75-4205-9952-60B09204A9F6",
    name: "email-variant",
    codepoint: "F5F0",
    aliases: ["envelope-variant"],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,13L2,6.76V6C2,4.89 2.89,4 4,4H20C21.1,4 22,4.9 22,6V6.75L12,13M22,18C22,19.1 21.1,20 20,20H4C2.89,20 2,19.1 2,18V9.11L4,10.36V18H20V10.36L22,9.11V18Z",
  },
  {
    id: "7CACE4E9-A4B1-461E-A8E5-8032C22E86A1",
    name: "emby",
    codepoint: "F6B3",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Christopher Schreiner",
    version: "1.7.22",
    path: "M11,2L6,7L7,8L2,13L7,18L8,17L13,22L18,17L17,16L22,11L17,6L16,7L11,2M10,8.5L16,12L10,15.5V8.5Z",
  },
  {
    id: "69AAECAA-0B17-4C53-8345-4F172B7FEF50",
    name: "emoticon",
    codepoint: "F1F2",
    aliases: [
      "smiley",
      "insert-emoticon",
      "mood",
      "sentiment-very-satisfied",
      "tag-faces",
    ],
    tags: ["Emoji"],
    author: "Google",
    version: "1.5.54",
    path: "M12,17.5C14.33,17.5 16.3,16.04 17.11,14H6.89C7.69,16.04 9.67,17.5 12,17.5M8.5,11C9.33,11 10,10.33 10,9.5C10,8.67 9.33,8 8.5,8C7.67,8 7,8.67 7,9.5C7,10.33 7.67,11 8.5,11M15.5,11C16.33,11 17,10.33 17,9.5C17,8.67 16.33,8 15.5,8C14.67,8 14,8.67 14,9.5C14,10.33 14.67,11 15.5,11M12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20M12,2C6.47,2 2,6.5 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z",
  },
  {
    id: "62BB1B4E-67AC-4DFE-B37C-65D0F04F71D0",
    name: "emoticon-cool",
    codepoint: "F1F3",
    aliases: ["smiley-cool"],
    tags: ["Emoji"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M19,10C19,11.38 16.88,12.5 15.5,12.5C14.12,12.5 12.75,11.38 12.75,10H11.25C11.25,11.38 9.88,12.5 8.5,12.5C7.12,12.5 5,11.38 5,10H4.25C4.09,10.64 4,11.31 4,12C4,16.42 7.58,20 12,20C16.42,20 20,16.42 20,12C20,11.31 19.91,10.64 19.75,10H19M12,4C9.04,4 6.45,5.61 5.07,8H18.93C17.55,5.61 14.96,4 12,4M22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2C17.52,2 22,6.48 22,12M12,17.23C10.25,17.23 8.71,16.5 7.81,15.42L9.23,14C9.68,14.72 10.75,15.23 12,15.23C13.25,15.23 14.32,14.72 14.77,14L16.19,15.42C15.29,16.5 13.75,17.23 12,17.23Z",
  },
  {
    id: "47AD308C-C9D8-43DB-8E92-B0FB02B906CF",
    name: "emoticon-dead",
    codepoint: "F69A",
    aliases: ["smiley-dead"],
    tags: ["Emoji"],
    author: "Google",
    version: "1.7.12",
    path: "M12,2C6.47,2 2,6.47 2,12C2,17.53 6.47,22 12,22C17.52,22 22,17.52 22,12C22,6.47 17.5,2 12,2M12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20M16.18,7.76L15.12,8.82L14.06,7.76L13,8.82L14.06,9.88L13,10.94L14.06,12L15.12,10.94L16.18,12L17.24,10.94L16.18,9.88L17.24,8.82L16.18,7.76M7.82,12L8.88,10.94L9.94,12L11,10.94L9.94,9.88L11,8.82L9.94,7.76L8.88,8.82L7.82,7.76L6.76,8.82L7.82,9.88L6.76,10.94L7.82,12M12,14C9.67,14 7.69,15.46 6.89,17.5H17.11C16.31,15.46 14.33,14 12,14Z",
  },
  {
    id: "916B1319-9E91-48C0-AD65-B21B599D8FCA",
    name: "emoticon-devil",
    codepoint: "F1F4",
    aliases: ["smiley-devil"],
    tags: ["Emoji"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M1.5,2.09C2.4,3 3.87,3.73 5.69,4.25C7.41,2.84 9.61,2 12,2C14.39,2 16.59,2.84 18.31,4.25C20.13,3.73 21.6,3 22.5,2.09C22.47,3.72 21.65,5.21 20.28,6.4C21.37,8 22,9.92 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,9.92 2.63,8 3.72,6.4C2.35,5.21 1.53,3.72 1.5,2.09M20,12C20,7.58 16.42,4 12,4C7.58,4 4,7.58 4,12C4,16.42 7.58,20 12,20C16.42,20 20,16.42 20,12M10.5,10C10.5,10.8 9.8,11.5 9,11.5C8.2,11.5 7.5,10.8 7.5,10V8.5L10.5,10M16.5,10C16.5,10.8 15.8,11.5 15,11.5C14.2,11.5 13.5,10.8 13.5,10L16.5,8.5V10M12,17.23C10.25,17.23 8.71,16.5 7.81,15.42L9.23,14C9.68,14.72 10.75,15.23 12,15.23C13.25,15.23 14.32,14.72 14.77,14L16.19,15.42C15.29,16.5 13.75,17.23 12,17.23Z",
  },
  {
    id: "828FF1EE-1B9B-4407-A45B-A071FA938158",
    name: "emoticon-excited",
    codepoint: "F69B",
    aliases: ["smiley-excited"],
    tags: ["Emoji"],
    author: "Google",
    version: "1.7.12",
    path: "M12,2C6.47,2 2,6.47 2,12C2,17.53 6.47,22 12,22C17.52,22 22,17.52 22,12C22,6.47 17.5,2 12,2M12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20M13,9.94L14.06,11L15.12,9.94L16.18,11L17.24,9.94L15.12,7.82L13,9.94M8.88,9.94L9.94,11L11,9.94L8.88,7.82L6.76,9.94L7.82,11L8.88,9.94M12,17.5C14.33,17.5 16.31,16.04 17.11,14H6.89C7.69,16.04 9.67,17.5 12,17.5Z",
  },
  {
    id: "F51C2659-3EE9-471C-A919-190D3C1A9681",
    name: "emoticon-happy",
    codepoint: "F1F5",
    aliases: ["smiley-happy"],
    tags: ["Emoji"],
    author: "Gabriel",
    version: "1.5.54",
    path: "M20,12C20,7.58 16.42,4 12,4C7.58,4 4,7.58 4,12C4,16.42 7.58,20 12,20C16.42,20 20,16.42 20,12M22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2C17.52,2 22,6.48 22,12M10,9.5C10,10.3 9.3,11 8.5,11C7.7,11 7,10.3 7,9.5C7,8.7 7.7,8 8.5,8C9.3,8 10,8.7 10,9.5M17,9.5C17,10.3 16.3,11 15.5,11C14.7,11 14,10.3 14,9.5C14,8.7 14.7,8 15.5,8C16.3,8 17,8.7 17,9.5M12,17.23C10.25,17.23 8.71,16.5 7.81,15.42L9.23,14C9.68,14.72 10.75,15.23 12,15.23C13.25,15.23 14.32,14.72 14.77,14L16.19,15.42C15.29,16.5 13.75,17.23 12,17.23Z",
  },
  {
    id: "17F30B32-37E2-41BB-876C-70E568D04623",
    name: "emoticon-neutral",
    codepoint: "F1F6",
    aliases: ["smiley-neutral"],
    tags: ["Emoji"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M8.5,11C7.67,11 7,10.33 7,9.5C7,8.67 7.67,8 8.5,8C9.33,8 10,8.67 10,9.5C10,10.33 9.33,11 8.5,11M15.5,11C14.67,11 14,10.33 14,9.5C14,8.67 14.67,8 15.5,8C16.33,8 17,8.67 17,9.5C17,10.33 16.33,11 15.5,11M12,20C16.42,20 20,16.42 20,12C20,7.58 16.42,4 12,4C7.58,4 4,7.58 4,12C4,16.42 7.58,20 12,20M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.47,22 2,17.5 2,12C2,6.48 6.48,2 12,2M9,14H15C15.55,14 16,14.45 16,15C16,15.55 15.55,16 15,16H9C8.45,16 8,15.55 8,15C8,14.45 8.45,14 9,14Z",
  },
  {
    id: "968319FB-0E94-4F04-A6D8-9E71DF200E1F",
    name: "emoticon-poop",
    codepoint: "F1F7",
    aliases: ["smiley-poop"],
    tags: ["Emoji"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M11.36,2C11.15,2 10.87,2.12 10.57,2.32C10,2.7 8.85,3.9 8.4,5.1C8.06,6 8.05,6.82 8.19,7.43C7.63,7.53 7.22,7.71 7.06,7.78C6.55,8 5.47,8.96 5.37,10.45C5.34,10.97 5.41,11.5 5.57,12C4.91,12.19 4.53,12.43 4.5,12.44C4.18,12.56 3.65,12.93 3.5,13.13C3.15,13.53 2.92,14 2.79,14.5C2.5,15.59 2.6,16.83 3.13,17.83C3.42,18.39 3.82,19 4.26,19.43C5.7,20.91 8.18,21.47 10.14,21.79C12.53,22.19 15.03,22.05 17.26,21.13C20.61,19.74 21.5,17.5 21.64,16.89C21.93,15.5 21.57,14.19 21.42,13.87C21.2,13.41 20.84,12.94 20.25,12.64C19.85,12.39 19.5,12.26 19.24,12.2C19.5,11.25 19.13,10.5 18.62,9.94C17.85,9.12 17.06,9 17.06,9V9C17.32,8.5 17.42,7.9 17.28,7.32C17.12,6.61 16.73,6.16 16.22,5.86C15.7,5.55 15.06,5.4 14.4,5.28C14.08,5.22 12.75,5.03 12.2,4.27C11.75,3.65 11.74,2.53 11.62,2.2C11.57,2.07 11.5,2 11.36,2M16,9.61C16.07,9.61 16.13,9.62 16.19,9.62C17.62,9.78 18.64,11.16 18.47,12.69C18.3,14.22 17,15.34 15.57,15.18V15.18C14.14,15 13.12,13.65 13.29,12.11C13.45,10.66 14.64,9.56 16,9.61M8.62,9.61C9.95,9.65 11.06,10.78 11.16,12.21C11.28,13.75 10.21,15.08 8.78,15.19H8.77C7.34,15.3 6.08,14.14 5.96,12.6V12.6C5.85,11.06 6.92,9.73 8.35,9.62V9.62C8.44,9.61 8.53,9.61 8.62,9.61M8.64,11.31C8.6,11.31 8.57,11.31 8.53,11.32C7.97,11.39 7.57,11.9 7.64,12.45C7.7,13 8.21,13.39 8.77,13.32C9.33,13.25 9.73,12.74 9.67,12.19C9.61,11.67 9.15,11.3 8.64,11.31M15.94,11.33C15.42,11.35 15,11.75 14.96,12.28C14.92,12.83 15.35,13.31 15.91,13.34C16.5,13.38 16.96,12.95 17,12.4C17.04,11.84 16.61,11.36 16.05,11.33C16,11.33 16,11.33 15.94,11.33M8.71,16.15C9,16.14 9.26,16.23 9.5,16.28C10.68,16.5 11.7,16.53 12.19,16.53C12.68,16.53 13.69,16.5 14.86,16.28C15.27,16.2 15.74,16.03 16.11,16.28C16.59,16.6 16.24,17.75 15.5,18.53C15.04,19 13.97,19.91 12.19,19.91C10.41,19.91 9.33,19 8.88,18.53C8.14,17.75 7.79,16.6 8.26,16.28C8.4,16.19 8.55,16.15 8.71,16.15Z",
  },
  {
    id: "6D8A3A11-7A90-424C-82A6-93C455379743",
    name: "emoticon-sad",
    codepoint: "F1F8",
    aliases: ["smiley-sad"],
    tags: ["Emoji"],
    author: "Gabriel",
    version: "1.5.54",
    path: "M20,12C20,7.58 16.42,4 12,4C7.58,4 4,7.58 4,12C4,16.42 7.58,20 12,20C16.42,20 20,16.42 20,12M22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2C17.52,2 22,6.48 22,12M15.5,8C16.3,8 17,8.7 17,9.5C17,10.3 16.3,11 15.5,11C14.7,11 14,10.3 14,9.5C14,8.7 14.7,8 15.5,8M10,9.5C10,10.3 9.3,11 8.5,11C7.7,11 7,10.3 7,9.5C7,8.7 7.7,8 8.5,8C9.3,8 10,8.7 10,9.5M12,14C13.75,14 15.29,14.72 16.19,15.81L14.77,17.23C14.32,16.5 13.25,16 12,16C10.75,16 9.68,16.5 9.23,17.23L7.81,15.81C8.71,14.72 10.25,14 12,14Z",
  },
  {
    id: "57288378-59EE-4705-ACD5-3B424ACA70C1",
    name: "emoticon-tongue",
    codepoint: "F1F9",
    aliases: ["smiley-tongue"],
    tags: ["Emoji"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M9,8C10.1,8 11,8.9 11,10C11,10.36 10.9,10.71 10.73,11C10.39,10.4 9.74,10 9,10C8.26,10 7.61,10.4 7.27,11C7.1,10.71 7,10.36 7,10C7,8.9 7.9,8 9,8M15,8C16.1,8 17,8.9 17,10C17,10.36 16.9,10.71 16.73,11C16.39,10.4 15.74,10 15,10C14.26,10 13.61,10.4 13.27,11C13.1,10.71 13,10.36 13,10C13,8.9 13.9,8 15,8M12,20C16.42,20 20,16.42 20,12C20,7.58 16.42,4 12,4C7.58,4 4,7.58 4,12C4,16.42 7.58,20 12,20M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.47,22 2,17.5 2,12C2,6.48 6.48,2 12,2M9,13H15C15.55,13 16,13.45 16,14C16,14.55 15.55,15 15,15C15,17 14.1,18 13,18C11.9,18 11,17 11,15H9C8.45,15 8,14.55 8,14C8,13.45 8.45,13 9,13Z",
  },
  {
    id: "290CA835-F009-4630-87D3-D4515E1F5527",
    name: "engine",
    codepoint: "F1FA",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M7,4V6H10V8H7L5,10V13H3V10H1V18H3V15H5V18H8L10,20H18V16H20V19H23V9H20V12H18V8H12V6H15V4H7Z",
  },
  {
    id: "75A5F242-D136-49B9-9DFF-25F0631743A7",
    name: "engine-outline",
    codepoint: "F1FB",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M8,10H16V18H11L9,16H7V11M7,4V6H10V8H7L5,10V13H3V10H1V18H3V15H5V18H8L10,20H18V16H20V19H23V9H20V12H18V8H12V6H15V4H7Z",
  },
  {
    id: "119DD58E-769B-47C2-9AB8-1671DEC4FE4A",
    name: "equal",
    codepoint: "F1FC",
    aliases: [],
    tags: ["Math"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M19,10H5V8H19V10M19,16H5V14H19V16Z",
  },
  {
    id: "F98CD2ED-FD62-414E-9116-94BA99713526",
    name: "equal-box",
    codepoint: "F1FD",
    aliases: [],
    tags: ["Math"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M17,16V14H7V16H17M19,3C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H19M17,10V8H7V10H17Z",
  },
  {
    id: "758CA292-BBF5-4C08-BCBD-88B7A84C8BC6",
    name: "eraser",
    codepoint: "F1FE",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M16.24,3.56L21.19,8.5C21.97,9.29 21.97,10.55 21.19,11.34L12,20.53C10.44,22.09 7.91,22.09 6.34,20.53L2.81,17C2.03,16.21 2.03,14.95 2.81,14.16L13.41,3.56C14.2,2.78 15.46,2.78 16.24,3.56M4.22,15.58L7.76,19.11C8.54,19.9 9.8,19.9 10.59,19.11L14.12,15.58L9.17,10.63L4.22,15.58Z",
  },
  {
    id: "8E45C70B-EE1A-48AE-B97F-204F1958E788",
    name: "eraser-variant",
    codepoint: "F642",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.6.50",
    path: "M15.14,3C14.63,3 14.12,3.2 13.73,3.59L2.59,14.73C1.81,15.5 1.81,16.77 2.59,17.56L5.03,20H12.69L21.41,11.27C22.2,10.5 22.2,9.23 21.41,8.44L16.56,3.59C16.17,3.2 15.65,3 15.14,3M17,18L15,20H22V18",
  },
  {
    id: "2DB352CF-8F2F-43FD-BCA0-675F7C9D298C",
    name: "escalator",
    codepoint: "F1FF",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M20,8H18.95L6.95,20H4C2.9,20 2,19.1 2,18C2,16.9 2.9,16 4,16H5.29L7,14.29V10C7,9.45 7.45,9 8,9H9C9.55,9 10,9.45 10,10V11.29L17.29,4H20C21.1,4 22,4.9 22,6C22,7.1 21.1,8 20,8M8.5,5C9.33,5 10,5.67 10,6.5C10,7.33 9.33,8 8.5,8C7.67,8 7,7.33 7,6.5C7,5.67 7.67,5 8.5,5Z",
  },
  {
    id: "D59C885E-233F-4472-AB8C-00C41F96134E",
    name: "ethereum",
    codepoint: "F869",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "GreenTurtwig",
    version: "2.1.99",
    path: "M12,1.75L5.75,12.25L12,16L18.25,12.25L12,1.75M5.75,13.5L12,22.25L18.25,13.5L12,17.25L5.75,13.5Z",
  },
  {
    id: "3AB3C243-0FD3-4903-A6EA-B0B29ABFAD6C",
    name: "ethernet",
    codepoint: "F200",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M7,15H9V18H11V15H13V18H15V15H17V18H19V9H15V6H9V9H5V18H7V15M4.38,3H19.63C20.94,3 22,4.06 22,5.38V19.63C22,20.94 20.94,22 19.63,22H4.38C3.06,22 2,20.94 2,19.63V5.38C2,4.06 3.06,3 4.38,3Z",
  },
  {
    id: "FC900F32-A228-4E42-9E09-EA7CCDEC08F2",
    name: "ethernet-cable",
    codepoint: "F201",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M11,3V7H13V3H11M8,4V11H16V4H14V8H10V4H8M10,12V22H14V12H10Z",
  },
  {
    id: "79E1B678-8458-4750-9EE0-C5CE7E57E9F1",
    name: "ethernet-cable-off",
    codepoint: "F202",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M11,3H13V7H11V3M8,4H10V8H14V4H16V11H12.82L8,6.18V4M20,20.72L18.73,22L14,17.27V22H10V13.27L2,5.27L3.28,4L20,20.72Z",
  },
  {
    id: "7C859DE1-16F6-4EF2-9097-A1D0C14CC3A2",
    name: "ev-station",
    codepoint: "F5F1",
    aliases: [],
    tags: ["Places"],
    author: "Google",
    version: "1.5.54",
    path: "M19.77,7.23L19.78,7.22L16.06,3.5L15,4.56L17.11,6.67C16.17,7.03 15.5,7.93 15.5,9C15.5,10.38 16.62,11.5 18,11.5C18.36,11.5 18.69,11.42 19,11.29V18.5C19,19.05 18.55,19.5 18,19.5C17.45,19.5 17,19.05 17,18.5V14C17,12.9 16.1,12 15,12H14V5C14,3.9 13.1,3 12,3H6C4.9,3 4,3.9 4,5V21H14V13.5H15.5V18.5C15.5,19.88 16.62,21 18,21C19.38,21 20.5,19.88 20.5,18.5V9C20.5,8.31 20.22,7.68 19.77,7.23M18,10C17.45,10 17,9.55 17,9C17,8.45 17.45,8 18,8C18.55,8 19,8.45 19,9C19,9.55 18.55,10 18,10M8,18V13.5H6L10,6V11H12L8,18Z",
  },
  {
    id: "193F4AB4-12B2-4E3C-965F-284967A7F736",
    name: "evernote",
    codepoint: "F204",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M15.09,11.63C15.09,11.63 15.28,10.35 16,10.35C16.76,10.35 17.78,12.06 17.78,12.06C17.78,12.06 15.46,11.63 15.09,11.63M19,4.69C18.64,4.09 16.83,3.41 15.89,3.41C14.96,3.41 13.5,3.41 13.5,3.41C13.5,3.41 12.7,2 10.88,2C9.05,2 9.17,2.81 9.17,3.5V6.32L8.34,7.19H4.5C4.5,7.19 3.44,7.91 3.44,9.44C3.44,11 3.92,16.35 7.13,16.85C10.93,17.43 11.58,15.67 11.58,15.46C11.58,14.56 11.6,13.21 11.6,13.21C11.6,13.21 12.71,15.33 14.39,15.33C16.07,15.33 17.04,16.3 17.04,17.29C17.04,18.28 17.04,19.13 17.04,19.13C17.04,19.13 17,20.28 16,20.28C15,20.28 13.89,20.28 13.89,20.28C13.89,20.28 13.2,19.74 13.2,19C13.2,18.25 13.53,18.05 13.93,18.05C14.32,18.05 14.65,18.09 14.65,18.09V16.53C14.65,16.53 11.47,16.5 11.47,18.94C11.47,21.37 13.13,22 14.46,22C15.8,22 16.63,22 16.63,22C16.63,22 20.56,21.5 20.56,13.75C20.56,6 19.33,5.28 19,4.69M7.5,6.31H4.26L8.32,2.22V5.5L7.5,6.31Z",
  },
  {
    id: "06E68A9B-2ED4-4697-82A2-02F1FA342D55",
    name: "exclamation",
    codepoint: "F205",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M11,4.5H13V15.5H11V4.5M13,17.5V19.5H11V17.5H13Z",
  },
  {
    id: "DD2BE6C6-A15C-44D4-807A-C29DE965CF22",
    name: "exit-to-app",
    codepoint: "F206",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M19,3H5C3.89,3 3,3.89 3,5V9H5V5H19V19H5V15H3V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3M10.08,15.58L11.5,17L16.5,12L11.5,7L10.08,8.41L12.67,11H3V13H12.67L10.08,15.58Z",
  },
  {
    id: "E26684D6-5292-4B09-98A9-C6C416FD236D",
    name: "exponent",
    codepoint: "F962",
    aliases: [],
    tags: [],
    author: "Nick",
    version: "2.4.85",
    path: "M15.38,3L17.77,8.75C17.55,9.68 17.27,10.32 17,10.7C16.67,11.18 16.44,11.25 16.19,11.25V12.75C16.94,12.75 17.74,12.35 18.24,11.56C19.87,8.94 22,3 22,3H20.38L18.69,7.05L17,3H15.38M3.42,8.59L2,10L6.79,14.79L2,19.59L3.41,21L8.21,16.21L13,21L14.41,19.59L9.62,14.79L14.41,10L13,8.59L8.21,13.38L3.41,8.59H3.42Z",
  },
  {
    id: "F061DE5C-F495-4EDF-BD16-DAD6B07605BC",
    name: "exponent-box",
    codepoint: "F963",
    aliases: [],
    tags: [],
    author: "Nick",
    version: "2.4.85",
    path: "M5,3C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3H5M13.76,6H15.39L16.5,8.6L17.59,6H19.24C19.24,6 17.5,10.57 16.46,12.32C16.08,12.89 15.35,13.27 14.5,13.25V11.75C14.96,11.76 15.25,11.5 15.5,11.13C15.61,11 15.68,10.8 15.74,10.64L13.76,6M6.41,9.59L9.21,12.38L12,9.59L13.41,11L10.62,13.79L13.41,16.59L12,18L9.21,15.21L6.41,18L5,16.59L7.79,13.79L5,11L6.41,9.59Z",
  },
  {
    id: "670C2CEA-D9B1-4126-89F4-C881D032F3AD",
    name: "export",
    codepoint: "F207",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M23,12L19,8V11H10V13H19V16M1,18V6C1,4.89 1.9,4 3,4H15C16.1,4 17,4.9 17,6V9H15V6H3V18H15V15H17V18C17,19.1 16.1,20 15,20H3C1.9,20 1,19.1 1,18Z",
  },
  {
    id: "3C2B7DF3-97FE-4EC4-B6A9-69A75FB26B67",
    name: "eye",
    codepoint: "F208",
    aliases: ["show", "visibility", "remove-red-eye"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M12,9C10.34,9 9,10.34 9,12C9,13.66 10.34,15 12,15C13.66,15 15,13.66 15,12C15,10.34 13.66,9 12,9M12,17C9.24,17 7,14.76 7,12C7,9.24 9.24,7 12,7C14.76,7 17,9.24 17,12C17,14.76 14.76,17 12,17M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5C17,19.5 21.27,16.39 23,12C21.27,7.61 17,4.5 12,4.5Z",
  },
  {
    id: "4D1385CF-1389-43D3-BD88-A83018434FB6",
    name: "eye-off",
    codepoint: "F209",
    aliases: ["hide", "visibility-off"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M11.83,9L15,12.16C15,12.11 15,12.05 15,12C15,10.34 13.66,9 12,9C11.94,9 11.89,9 11.83,9M7.53,9.8L9.08,11.35C9.03,11.56 9,11.77 9,12C9,13.66 10.34,15 12,15C12.22,15 12.44,14.97 12.65,14.92L14.2,16.47C13.53,16.8 12.79,17 12,17C9.24,17 7,14.76 7,12C7,11.21 7.2,10.47 7.53,9.8M2,4.27L4.28,6.55L4.73,7C3.08,8.3 1.78,10 1,12C2.73,16.39 7,19.5 12,19.5C13.55,19.5 15.03,19.2 16.38,18.66L16.81,19.08L19.73,22L21,20.73L3.27,3M12,7C14.76,7 17,9.24 17,12C17,12.64 16.87,13.26 16.64,13.82L19.57,16.75C21.07,15.5 22.27,13.86 23,12C21.27,7.61 17,4.5 12,4.5C10.6,4.5 9.26,4.75 8,5.2L10.17,7.35C10.74,7.13 11.35,7 12,7Z",
  },
  {
    id: "D88D00BE-0B70-40F5-AFD0-51C65DE8D674",
    name: "eye-off-outline",
    codepoint: "F6D0",
    aliases: ["hide-outline", "visibility-off-outline"],
    tags: [],
    author: "Austin Andrews",
    version: "1.8.36",
    path: "M2,5.27L3.28,4L20,20.72L18.73,22L15.65,18.92C14.5,19.3 13.28,19.5 12,19.5C7,19.5 2.73,16.39 1,12C1.69,10.24 2.79,8.69 4.19,7.46L2,5.27M12,9C13.66,9 15,10.34 15,12C15,12.35 14.94,12.69 14.83,13L11,9.17C11.31,9.06 11.65,9 12,9M12,4.5C17,4.5 21.27,7.61 23,12C22.18,14.08 20.79,15.88 19,17.19L17.58,15.76C18.94,14.82 20.06,13.54 20.82,12C19.17,8.64 15.76,6.5 12,6.5C10.91,6.5 9.84,6.68 8.84,7L7.3,5.47C8.74,4.85 10.33,4.5 12,4.5M3.18,12C4.83,15.36 8.24,17.5 12,17.5C12.69,17.5 13.37,17.43 14,17.29L11.72,15C10.29,14.85 9.15,13.71 9,12.28L5.6,8.87C4.61,9.72 3.78,10.78 3.18,12Z",
  },
  {
    id: "F2AA59FA-23F6-4FE8-A52A-AEC674A9E864",
    name: "eye-outline",
    codepoint: "F6CF",
    aliases: ["show-outline", "visibility-outline"],
    tags: [],
    author: "Austin Andrews",
    version: "1.8.36",
    path: "M12,9C13.66,9 15,10.34 15,12C15,13.66 13.66,15 12,15C10.34,15 9,13.66 9,12C9,10.34 10.34,9 12,9M12,4.5C17,4.5 21.27,7.61 23,12C21.27,16.39 17,19.5 12,19.5C7,19.5 2.73,16.39 1,12C2.73,7.61 7,4.5 12,4.5M3.18,12C4.83,15.36 8.24,17.5 12,17.5C15.76,17.5 19.17,15.36 20.82,12C19.17,8.64 15.76,6.5 12,6.5C8.24,6.5 4.83,8.64 3.18,12Z",
  },
  {
    id: "644FD0C7-1B46-48D8-A410-FDA22E63BFCF",
    name: "eye-plus",
    codepoint: "F86A",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "2.1.99",
    path: "M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5C12.36,19.5 12.72,19.5 13.08,19.45C13.03,19.13 13,18.82 13,18.5C13,17.94 13.08,17.38 13.24,16.84C12.83,16.94 12.42,17 12,17C9.24,17 7,14.76 7,12C7,9.24 9.24,7 12,7C14.76,7 17,9.24 17,12C17,12.29 16.97,12.59 16.92,12.88C17.58,12.63 18.29,12.5 19,12.5C20.17,12.5 21.31,12.84 22.29,13.5C22.56,13 22.8,12.5 23,12C21.27,7.61 17,4.5 12,4.5M12,9C10.34,9 9,10.34 9,12C9,13.66 10.34,15 12,15C13.66,15 15,13.66 15,12C15,10.34 13.66,9 12,9M18,14.5V17.5H15V19.5H18V22.5H20V19.5H23V17.5H20V14.5H18Z",
  },
  {
    id: "C82BEE88-7AAC-4F8D-9A8A-4B0C7CCDF216",
    name: "eye-plus-outline",
    codepoint: "F86B",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "2.1.99",
    path: "M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5C12.36,19.5 12.72,19.5 13.08,19.45C13.03,19.13 13,18.82 13,18.5C13,18.14 13.04,17.78 13.1,17.42C12.74,17.46 12.37,17.5 12,17.5C8.24,17.5 4.83,15.36 3.18,12C4.83,8.64 8.24,6.5 12,6.5C15.76,6.5 19.17,8.64 20.82,12C20.7,12.24 20.56,12.45 20.43,12.68C21.09,12.84 21.72,13.11 22.29,13.5C22.56,13 22.8,12.5 23,12C21.27,7.61 17,4.5 12,4.5M12,9C10.34,9 9,10.34 9,12C9,13.66 10.34,15 12,15C13.66,15 15,13.66 15,12C15,10.34 13.66,9 12,9M18,14.5V17.5H15V19.5H18V22.5H20V19.5H23V17.5H20V14.5H18Z",
  },
  {
    id: "1155E86D-5CA5-4CC0-B089-23DFFC1A3DDD",
    name: "eye-settings",
    codepoint: "F86C",
    aliases: [],
    tags: ["Settings"],
    author: "Michael Richins",
    version: "2.1.99",
    path: "M12,9C10.34,9 9,10.34 9,12C9,13.66 10.34,15 12,15C13.66,15 15,13.66 15,12C15,10.34 13.66,9 12,9M12,17C9.24,17 7,14.76 7,12C7,9.24 9.24,7 12,7C14.76,7 17,9.24 17,12C17,14.76 14.76,17 12,17M12,4.5C7.14,4.5 2.78,7.5 1,12C3.39,18.08 10.25,21.06 16.33,18.67C19.38,17.47 21.8,15.06 23,12C21.22,7.5 16.86,4.5 12,4.5M7,22H9V24H7V22M11,22H13V24H11V22M15,22H17V24H15V22Z",
  },
  {
    id: "45112AC7-F34D-40E8-8C37-D8660B7017E9",
    name: "eye-settings-outline",
    codepoint: "F86D",
    aliases: [],
    tags: ["Settings"],
    author: "Michael Richins",
    version: "2.1.99",
    path: "M12,9C13.66,9 15,10.34 15,12C15,13.66 13.66,15 12,15C10.34,15 9,13.66 9,12C9,10.34 10.34,9 12,9M12,4.5C16.86,4.5 21.22,7.5 23,12C20.61,18.08 13.75,21.06 7.67,18.67C4.62,17.47 2.2,15.06 1,12C2.78,7.5 7.14,4.5 12,4.5M3.18,12C5.56,16.87 11.45,18.89 16.32,16.5C18.28,15.54 19.86,13.96 20.82,12C18.44,7.13 12.55,5.11 7.68,7.5C5.72,8.46 4.14,10.04 3.18,12M9,22H7V24H9V22M13,22H11V24H13V22M17,22H15V24H17V22Z",
  },
  {
    id: "89350468-16D8-4F39-AA78-C3E00EE8FB2C",
    name: "eyedropper",
    codepoint: "F20A",
    aliases: [],
    tags: ["Color"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M19.35,11.72L17.22,13.85L15.81,12.43L8.1,20.14L3.5,22L2,20.5L3.86,15.9L11.57,8.19L10.15,6.78L12.28,4.65L19.35,11.72M16.76,3C17.93,1.83 19.83,1.83 21,3C22.17,4.17 22.17,6.07 21,7.24L19.08,9.16L14.84,4.92L16.76,3M5.56,17.03L4.5,19.5L6.97,18.44L14.4,11L13,9.6L5.56,17.03Z",
  },
  {
    id: "24A1E7A8-D8A4-4216-B467-72C144972358",
    name: "eyedropper-variant",
    codepoint: "F20B",
    aliases: ["colorize", "colourise"],
    tags: ["Color"],
    author: "Google",
    version: "1.5.54",
    path: "M6.92,19L5,17.08L13.06,9L15,10.94M20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L13.84,6.41L11.91,4.5L10.5,5.91L11.92,7.33L3,16.25V21H7.75L16.67,12.08L18.09,13.5L19.5,12.09L17.58,10.17L20.7,7.05C21.1,6.65 21.1,6 20.71,5.63Z",
  },
  {
    id: "D41E7F40-FF48-422F-A64B-4908C6C10F00",
    name: "face",
    codepoint: "F643",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.6.50",
    path: "M9,11.75C8.31,11.75 7.75,12.31 7.75,13C7.75,13.69 8.31,14.25 9,14.25C9.69,14.25 10.25,13.69 10.25,13C10.25,12.31 9.69,11.75 9,11.75M15,11.75C14.31,11.75 13.75,12.31 13.75,13C13.75,13.69 14.31,14.25 15,14.25C15.69,14.25 16.25,13.69 16.25,13C16.25,12.31 15.69,11.75 15,11.75M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M12,20C7.59,20 4,16.41 4,12C4,11.71 4,11.42 4.05,11.14C6.41,10.09 8.28,8.16 9.26,5.77C11.07,8.33 14.05,10 17.42,10C18.2,10 18.95,9.91 19.67,9.74C19.88,10.45 20,11.21 20,12C20,16.41 16.41,20 12,20Z",
  },
  {
    id: "97E9CDDB-45B3-4592-8E1F-0DB66E16E1A3",
    name: "face-profile",
    codepoint: "F644",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.6.50",
    path: "M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M12,8.39C13.57,9.4 15.42,10 17.42,10C18.2,10 18.95,9.91 19.67,9.74C19.88,10.45 20,11.21 20,12C20,16.41 16.41,20 12,20C9,20 6.39,18.34 5,15.89L6.75,14V13C6.75,12.31 7.31,11.75 8,11.75C8.69,11.75 9.25,12.31 9.25,13V14H12M16,11.75C15.31,11.75 14.75,12.31 14.75,13C14.75,13.69 15.31,14.25 16,14.25C16.69,14.25 17.25,13.69 17.25,13C17.25,12.31 16.69,11.75 16,11.75Z",
  },
  {
    id: "95CC9E46-A553-42B3-B44E-2E88DB13C1E1",
    name: "facebook",
    codepoint: "F20C",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M17,2V2H17V6H15C14.31,6 14,6.81 14,7.5V10H14L17,10V14H14V22H10V14H7V10H10V6C10,3.79 11.79,2 14,2H17Z",
  },
  {
    id: "1989DA16-DAA9-4C95-A61F-BA512FE5592D",
    name: "facebook-messenger",
    codepoint: "F20E",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Yasmina Lembachar",
    version: "1.5.54",
    path: "M12,2C6.5,2 2,6.14 2,11.25C2,14.13 3.42,16.7 5.65,18.4L5.71,22L9.16,20.12L9.13,20.11C10.04,20.36 11,20.5 12,20.5C17.5,20.5 22,16.36 22,11.25C22,6.14 17.5,2 12,2M13.03,14.41L10.54,11.78L5.5,14.41L10.88,8.78L13.46,11.25L18.31,8.78L13.03,14.41Z",
  },
  {
    id: "B74F1DE6-5DEC-4866-AEED-DE85FE09C52F",
    name: "factory",
    codepoint: "F20F",
    aliases: ["industrial"],
    tags: ["Places"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M4,18V20H8V18H4M4,14V16H14V14H4M10,18V20H14V18H10M16,14V16H20V14H16M16,18V20H20V18H16M2,22V8L7,12V8L12,12V8L17,12L18,2H21L22,12V22H2Z",
  },
  {
    id: "2606F8A3-AFD7-41EB-BD2D-C3546FEADB2F",
    name: "fan",
    codepoint: "F210",
    aliases: [],
    tags: ["Home Automation"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,11C11.45,11 11,11.45 11,12C11,12.55 11.45,13 12,13C12.55,13 13,12.55 13,12C13,11.45 12.55,11 12,11M12.5,2C17,2 17.11,5.57 14.75,6.75C13.76,7.24 13.32,8.29 13.13,9.22C13.61,9.42 14.03,9.73 14.35,10.13C18.05,8.13 22.03,8.92 22.03,12.5C22.03,17 18.46,17.1 17.28,14.73C16.78,13.74 15.72,13.3 14.79,13.11C14.59,13.59 14.28,14 13.88,14.34C15.87,18.03 15.08,22 11.5,22C7,22 6.91,18.42 9.27,17.24C10.25,16.75 10.69,15.71 10.89,14.79C10.4,14.59 9.97,14.27 9.65,13.87C5.96,15.85 2,15.07 2,11.5C2,7 5.56,6.89 6.74,9.26C7.24,10.25 8.29,10.68 9.22,10.87C9.41,10.39 9.73,9.97 10.14,9.65C8.15,5.96 8.94,2 12.5,2Z",
  },
  {
    id: "BB761A30-6F3C-484D-A0C9-501972F544AB",
    name: "fan-off",
    codepoint: "F81C",
    aliases: [],
    tags: ["Home Automation"],
    author: "GreenTurtwig",
    version: "2.1.19",
    path: "M12.5,2C9.64,2 8.57,4.55 9.29,7.47L15,13.16C15.87,13.37 16.81,13.81 17.28,14.73C18.46,17.1 22.03,17 22.03,12.5C22.03,8.92 18.05,8.13 14.35,10.13C14.03,9.73 13.61,9.42 13.13,9.22C13.32,8.29 13.76,7.24 14.75,6.75C17.11,5.57 17,2 12.5,2M3.28,4L2,5.27L4.47,7.73C3.22,7.74 2,8.87 2,11.5C2,15.07 5.96,15.85 9.65,13.87C9.97,14.27 10.4,14.59 10.89,14.79C10.69,15.71 10.25,16.75 9.27,17.24C6.91,18.42 7,22 11.5,22C13.8,22 14.94,20.36 14.94,18.21L18.73,22L20,20.72L3.28,4Z",
  },
  {
    id: "98B9D071-70A9-422B-BCC1-55DC4C2E0744",
    name: "fast-forward",
    codepoint: "F211",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M13,6V18L21.5,12M4,18L12.5,12L4,6V18Z",
  },
  {
    id: "05435BA8-4BB4-4581-A2BA-D2D7679B831F",
    name: "fast-forward-outline",
    codepoint: "F6D1",
    aliases: [],
    tags: [],
    author: "Michael Irigoyen",
    version: "1.8.36",
    path: "M15,9.9L18,12L15,14.1V9.9M6,9.9L9,12L6,14.1V9.9M13,6V18L21.5,12L13,6M4,6V18L12.5,12L4,6Z",
  },
  {
    id: "2C398569-5DBF-4405-AF73-6F5CA629AEE1",
    name: "fax",
    codepoint: "F212",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M11,6H16V8H11V6M8,9V3H19V9C20.66,9 22,10.34 22,12V18H19V21H8V18H7V9H8M10,5V9H17V5H10M10,15V19H17V15H10M19,11C18.45,11 18,11.45 18,12C18,12.55 18.45,13 19,13C19.55,13 20,12.55 20,12C20,11.45 19.55,11 19,11M4,9H5C5.55,9 6,9.45 6,10V17C6,17.55 5.55,18 5,18H4C2.9,18 2,17.1 2,16V11C2,9.9 2.9,9 4,9Z",
  },
  {
    id: "A0C975EA-A25D-4882-96DE-39CB72DAC2CA",
    name: "feather",
    codepoint: "F6D2",
    aliases: [],
    tags: ["Nature"],
    author: "Cody",
    version: "1.8.36",
    path: "M22,2C22,2 14.36,1.63 8.34,9.88C3.72,16.21 2,22 2,22L3.94,21C5.38,18.5 6.13,17.47 7.54,16C10.07,16.74 12.71,16.65 15,14C13,13.44 11.4,13.57 9.04,13.81C11.69,12 13.5,11.6 16,12L17,10C15.2,9.66 14,9.63 12.22,10.04C14.19,8.65 15.56,7.87 18,8L19.21,6.07C17.65,5.96 16.71,6.13 14.92,6.57C16.53,5.11 18,4.45 20.14,4.32C20.14,4.32 21.19,2.43 22,2Z",
  },
  {
    id: "15F2366C-5930-4473-B298-A5B952F07D59",
    name: "fedora",
    codepoint: "F8DA",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Contributors",
    version: "2.3.50",
    path: "M12,2C6.48,2 2,6.48 2,12V19.73C2,21 3,22 4.27,22H12C17.53,22 22,17.5 22,12C22,6.48 17.52,2 12,2M14.94,4.37C15.33,4.37 15.61,4.42 15.97,4.5C16.5,4.65 16.94,5.08 16.94,5.59C16.94,6.2 16.5,6.65 15.83,6.65C15.5,6.65 15.4,6.59 14.94,6.59C13.57,6.59 12.46,7.69 12.46,9.06V11.21C12.46,11.41 12.62,11.56 12.81,11.56H14.44C15.04,11.56 15.53,12.05 15.53,12.65C15.53,13.27 15.04,13.75 14.42,13.75H12.46V16.23C12.46,18.83 10.36,20.93 7.77,20.93C7.37,20.93 7.09,20.88 6.73,20.79C6.2,20.65 5.76,20.21 5.76,19.71C5.76,19.1 6.21,18.65 6.87,18.65C7.19,18.65 7.3,18.71 7.77,18.71C9.13,18.71 10.24,17.61 10.24,16.24V14.09C10.24,13.89 10.09,13.74 9.89,13.74H8.27C7.66,13.74 7.17,13.25 7.17,12.65C7.17,12.03 7.66,11.55 8.28,11.55H10.24V9.06C10.24,6.47 12.34,4.37 14.94,4.37V4.37Z",
  },
  {
    id: "F138AC6A-406B-4EB0-BB85-0FDB5415B6F8",
    name: "ferry",
    codepoint: "F213",
    aliases: [
      "cargo-ship",
      "boat",
      "ship",
      "directions-boat",
      "directions-ferry",
    ],
    tags: ["Transportation + Water", "Navigation"],
    author: "Google",
    version: "1.5.54",
    path: "M6,6H18V9.96L12,8L6,9.96M3.94,19H4C5.6,19 7,18.12 8,17C9,18.12 10.4,19 12,19C13.6,19 15,18.12 16,17C17,18.12 18.4,19 20,19H20.05L21.95,12.31C22.03,12.06 22,11.78 21.89,11.54C21.76,11.3 21.55,11.12 21.29,11.04L20,10.62V6C20,4.89 19.1,4 18,4H15V1H9V4H6C4.9,4 4,4.9 4,6V10.62L2.71,11.04C2.45,11.12 2.24,11.3 2.11,11.54C2,11.78 1.97,12.06 2.05,12.31M20,21C18.61,21 17.22,20.53 16,19.67C13.56,21.38 10.44,21.38 8,19.67C6.78,20.53 5.39,21 4,21H2V23H4C5.37,23 6.74,22.65 8,22C10.5,23.3 13.5,23.3 16,22C17.26,22.65 18.62,23 20,23H22V21H20Z",
  },
  {
    id: "BFF59001-B52D-47E6-A217-C9095F81C3B8",
    name: "file",
    codepoint: "F214",
    aliases: ["insert-drive-file", "draft"],
    tags: ["Files / Folders"],
    author: "Google",
    version: "1.5.54",
    path: "M13,9V3.5L18.5,9M6,2C4.89,2 4,2.89 4,4V20C4,21.1 4.9,22 6,22H18C19.1,22 20,21.1 20,20V8L14,2H6Z",
  },
  {
    id: "94A8A0E0-B69E-4099-A32E-34B83449AFBC",
    name: "file-account",
    codepoint: "F73A",
    aliases: ["file-user"],
    tags: ["Account / User", "Files / Folders"],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M13,9H18.5L13,3.5V9M6,2H14L20,8V20C20,21.1 19.1,22 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M14,20V19C14,17.67 11.33,17 10,17C8.67,17 6,17.67 6,19V20H14M10,12C8.9,12 8,12.9 8,14C8,15.1 8.9,16 10,16C11.1,16 12,15.1 12,14C12,12.9 11.1,12 10,12Z",
  },
  {
    id: "303BB890-634F-405C-B77C-4AC831BCAEC4",
    name: "file-chart",
    codepoint: "F215",
    aliases: ["file-report"],
    tags: ["Files / Folders"],
    author: "Cody",
    version: "1.5.54",
    path: "M13,9H18.5L13,3.5V9M6,2H14L20,8V20C20,21.1 19.1,22 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M7,20H9V14H7V20M11,20H13V12H11V20M15,20H17V16H15V20Z",
  },
  {
    id: "9E66E6CF-74AD-4DB5-953B-DC135B4AD44C",
    name: "file-check",
    codepoint: "F216",
    aliases: [],
    tags: ["Files / Folders"],
    author: "Cody",
    version: "1.5.54",
    path: "M13,9H18.5L13,3.5V9M6,2H14L20,8V20C20,21.1 19.1,22 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M10.45,18.46L15.2,13.71L14.03,12.3L10.45,15.88L8.86,14.3L7.7,15.46L10.45,18.46Z",
  },
  {
    id: "452A53B0-3718-4483-ABB0-2897EBE97312",
    name: "file-cloud",
    codepoint: "F217",
    aliases: [],
    tags: ["Cloud", "Files / Folders"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M13,9H18.5L13,3.5V9M6,2H14L20,8V20C20,21.1 19.1,22 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M15.68,15C15.34,13.3 13.82,12 12,12C10.55,12 9.3,12.82 8.68,14C7.17,14.18 6,15.45 6,17C6,18.66 7.34,20 9,20H15.5C16.88,20 18,18.88 18,17.5C18,16.18 16.97,15.11 15.68,15Z",
  },
  {
    id: "2169C66B-967F-4AB4-9123-A8A2C6129D6C",
    name: "file-compare",
    codepoint: "F8A9",
    aliases: [],
    tags: ["Files / Folders"],
    author: "Michael Irigoyen",
    version: "2.2.43",
    path: "M10,18H6V16H10V18M10,14H6V12H10V14M10,1V2H6C4.89,2 4,2.89 4,4V20C4,21.1 4.9,22 6,22H10V23H12V1H10M20,8V20C20,21.11 19.11,22 18,22H14V20H18V11H14V9H18.5L14,4.5V2L20,8M16,14H14V12H16V14M16,18H14V16H16V18Z",
  },
  {
    id: "46650D6B-318F-4202-AB77-79A113EC77AA",
    name: "file-delimited",
    codepoint: "F218",
    aliases: ["file-csv"],
    tags: ["Files / Folders"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M13,9H18.5L13,3.5V9M6,2H14L20,8V20C20,21.1 19.1,22 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M14,15V11H10V15H12.3C12.6,17 12,18 9.7,19.38L10.85,20.2C13,19 14,16 14,15Z",
  },
  {
    id: "B8F65B26-E57F-4879-852E-D894E4ACAB65",
    name: "file-document",
    codepoint: "F219",
    aliases: [],
    tags: ["Files / Folders"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M13,9H18.5L13,3.5V9M6,2H14L20,8V20C20,21.1 19.1,22 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M15,18V16H6V18H15M18,14V12H6V14H18Z",
  },
  {
    id: "E12AE178-0546-4CD3-81F6-BD1F17AA50EE",
    name: "file-document-box-outline",
    codepoint: "F9EC",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "2.5.94",
    path: "M5,3C3.89,3 3,3.89 3,5V19C3,20.11 3.89,21 5,21H19C20.11,21 21,20.11 21,19V5C21,3.89 20.11,3 19,3H5M5,5H19V19H5V5M7,7V9H17V7H7M7,11V13H17V11H7M7,15V17H14V15H7Z",
  },
  {
    id: "5CB4D11F-6B3A-465D-A2CD-F4172AD287B0",
    name: "file-document-outline",
    codepoint: "F9ED",
    aliases: [],
    tags: [],
    author: "Google",
    version: "2.5.94",
    path: "M6,2C4.9,2 4,2.9 4,4V20C4,21.1 4.9,22 6,22H18C19.1,22 20,21.1 20,20V8L14,2H6M6,4H13V9H18V20H6V4M8,12V14H16V12H8M8,16V18H13V16H8Z",
  },
  {
    id: "305DC085-34BD-4CC1-8943-E8A3B64FD110",
    name: "file-download",
    codepoint: "F964",
    aliases: [],
    tags: ["Files / Folders"],
    author: "Michael Irigoyen",
    version: "2.4.85",
    path: "M14,2H6C4.89,2 4,2.89 4,4V20C4,21.11 4.89,22 6,22H18C19.11,22 20,21.11 20,20V8L14,2M12,19L8.11,15.11H10.44V12H13.56V15.11H15.89L12,19M13,9V3.5L18.5,9H13Z",
  },
  {
    id: "50DFA593-C997-41BD-B77E-2468649E2C1B",
    name: "file-download-outline",
    codepoint: "F965",
    aliases: [],
    tags: ["Files / Folders"],
    author: "Michael Irigoyen",
    version: "2.4.85",
    path: "M13,9H18.5L13,3.5V9M6,2H14L20,8V20C20,21.11 19.11,22 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M11,4H6V20H11L18,20V11H11V4M12,19L15.89,15.11H13.56V12H10.45V15.11H8.11L12,19Z",
  },
  {
    id: "C3AADE94-4136-4D8E-8DFE-9AA7C88EE5D5",
    name: "file-excel",
    codepoint: "F21B",
    aliases: [],
    tags: ["Files / Folders"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M6,2H14L20,8V20C20,21.1 19.1,22 18,22H6C4.9,22 4,21.1 4,20V4C4,2.9 4.9,2 6,2M13,3.5V9H18.5L13,3.5M17,11H13V13H14L12,14.67L10,13H11V11H7V13H8L11,15.5L8,18H7V20H11V18H10L12,16.33L14,18H13V20H17V18H16L13,15.5L16,13H17V11Z",
  },
  {
    id: "A2FE83DC-3544-4D13-85BD-2C54CDC1A460",
    name: "file-excel-box",
    codepoint: "F21C",
    aliases: [],
    tags: ["Files / Folders"],
    author: "Google",
    version: "1.5.54",
    path: "M16.2,17H14.2L12,13.2L9.8,17H7.8L11,12L7.8,7H9.8L12,10.8L14.2,7H16.2L13,12M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3Z",
  },
  {
    id: "5693BB52-A00A-45E6-8DDD-C84FE3D9D440",
    name: "file-export",
    codepoint: "F21D",
    aliases: [],
    tags: ["Files / Folders"],
    author: "Cody",
    version: "1.5.54",
    path: "M6,2C4.89,2 4,2.9 4,4V20C4,21.1 4.9,22 6,22H18C19.1,22 20,21.1 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35",
  },
  {
    id: "A9D2E13D-A9F6-48AC-9998-22756DA6C709",
    name: "file-find",
    codepoint: "F21E",
    aliases: ["print-preview", "find-in-page"],
    tags: ["Files / Folders"],
    author: "Google",
    version: "1.5.54",
    path: "M9,13C9,14.66 10.34,16 12,16C13.66,16 15,14.66 15,13C15,11.34 13.66,10 12,10C10.34,10 9,11.34 9,13M20,19.59V8L14,2H6C4.9,2 4,2.9 4,4V20C4,21.1 4.9,22 6,22H18C18.45,22 18.85,21.85 19.19,21.6L14.76,17.17C13.96,17.69 13,18 12,18C9.24,18 7,15.76 7,13C7,10.24 9.24,8 12,8C14.76,8 17,10.24 17,13C17,14 16.69,14.96 16.17,15.75L20,19.59Z",
  },
  {
    id: "22033CAF-C8AF-4C33-9FCD-9D6FC4EE7EAF",
    name: "file-hidden",
    codepoint: "F613",
    aliases: [],
    tags: ["Files / Folders"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M13,9H14V11H11V7H13V9M18.5,9L16.38,6.88L17.63,5.63L20,8V10H18V11H15V9H18.5M13,3.5V2H12V4H13V6H11V4H9V2H8V4H6V5H4V4C4,2.89 4.89,2 6,2H14L16.36,4.36L15.11,5.61L13,3.5M20,20C20,21.1 19.1,22 18,22H16V20H18V19H20V20M18,15H20V18H18V15M12,22V20H15V22H12M8,22V20H11V22H8M6,22C4.89,22 4,21.1 4,20V18H6V20H7V22H6M4,14H6V17H4V14M4,10H6V13H4V10M18,11H20V14H18V11M4,6H6V9H4V6Z",
  },
  {
    id: "2318EAB3-F03A-40C3-A245-668B244A9AC1",
    name: "file-image",
    codepoint: "F21F",
    aliases: [],
    tags: ["Files / Folders"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M13,9H18.5L13,3.5V9M6,2H14L20,8V20C20,21.1 19.1,22 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M6,20H15L18,20V12L14,16L12,14L6,20M8,9C6.9,9 6,9.9 6,11C6,12.1 6.9,13 8,13C9.1,13 10,12.1 10,11C10,9.9 9.1,9 8,9Z",
  },
  {
    id: "1294020B-960A-4390-916F-BF8118A6E7C6",
    name: "file-import",
    codepoint: "F220",
    aliases: [],
    tags: ["Files / Folders"],
    author: "Cody",
    version: "1.5.54",
    path: "M6,2C4.89,2 4,2.9 4,4V20C4,21.1 4.9,22 6,22H18C19.1,22 20,21.1 20,20V8L14,2M13,3.5L18.5,9H13M10.05,11.22L12.88,14.05L15,11.93V19H7.93L10.05,16.88L7.22,14.05",
  },
  {
    id: "1D017133-E895-4103-98C1-E90D26126003",
    name: "file-lock",
    codepoint: "F221",
    aliases: [],
    tags: ["Lock", "Files / Folders"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M6,2C4.89,2 4,2.9 4,4V20C4,21.1 4.9,22 6,22H18C19.1,22 20,21.1 20,20V8L14,2H6M13,3.5L18.5,9H13V3.5M12,11C13.66,11 15,12.34 15,14V15H16V19H8V15H9V14C9,12.36 10.34,11 12,11M12,13C11.45,13 11,13.45 11,14V15H13V14C13,13.47 12.55,13 12,13Z",
  },
  {
    id: "7696AF65-B943-4BA3-94DB-5E85077F7BA9",
    name: "file-multiple",
    codepoint: "F222",
    aliases: [],
    tags: ["Files / Folders"],
    author: "Cody",
    version: "1.5.54",
    path: "M15,7H20.5L15,1.5V7M8,0H16L22,6V18C22,19.1 21.1,20 20,20H8C6.89,20 6,19.1 6,18V2C6,0.9 6.9,0 8,0M4,4V22H20V24H4C2.9,24 2,23.1 2,22V4H4Z",
  },
  {
    id: "C6CD26A5-C5F6-4C5D-AF2C-919E8ED4166C",
    name: "file-music",
    codepoint: "F223",
    aliases: [],
    tags: ["Files / Folders"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M13,9H18.5L13,3.5V9M6,2H14L20,8V20C20,21.1 19.1,22 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M9,16C7.9,16 7,16.9 7,18C7,19.1 7.9,20 9,20C10.1,20 11,19.1 11,18V13H14V11H10V16.27C9.71,16.1 9.36,16 9,16Z",
  },
  {
    id: "36FCB7D4-D7DE-4B44-BD28-53615689D2C6",
    name: "file-outline",
    codepoint: "F224",
    aliases: [],
    tags: ["Files / Folders"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M13,9H18.5L13,3.5V9M6,2H14L20,8V20C20,21.1 19.1,22 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M11,4H6V20H11L18,20V11H11V4Z",
  },
  {
    id: "D5A23F56-0398-40EF-8B0D-640CD1F39669",
    name: "file-pdf",
    codepoint: "F225",
    aliases: [],
    tags: ["Files / Folders"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M14,9H19.5L14,3.5V9M7,2H15L21,8V20C21,21.1 20.1,22 19,22H7C5.89,22 5,21.1 5,20V4C5,2.9 5.9,2 7,2M11.93,12.44C12.34,13.34 12.86,14.08 13.46,14.59L13.87,14.91C13,15.07 11.8,15.35 10.53,15.84V15.84L10.42,15.88L10.92,14.84C11.37,13.97 11.7,13.18 11.93,12.44M18.41,16.25C18.59,16.07 18.68,15.84 18.69,15.59C18.72,15.39 18.67,15.2 18.57,15.04C18.28,14.57 17.53,14.35 16.29,14.35L15,14.42L14.13,13.84C13.5,13.32 12.93,12.41 12.53,11.28L12.57,11.14C12.9,9.81 13.21,8.2 12.55,7.54C12.39,7.38 12.17,7.3 11.94,7.3H11.7C11.33,7.3 11,7.69 10.91,8.07C10.54,9.4 10.76,10.13 11.13,11.34V11.35C10.88,12.23 10.56,13.25 10.05,14.28L9.09,16.08L8.2,16.57C7,17.32 6.43,18.16 6.32,18.69C6.28,18.88 6.3,19.05 6.37,19.23L6.4,19.28L6.88,19.59L7.32,19.7C8.13,19.7 9.05,18.75 10.29,16.63L10.47,16.56C11.5,16.23 12.78,16 14.5,15.81C15.53,16.32 16.74,16.55 17.5,16.55C17.94,16.55 18.24,16.44 18.41,16.25M18,15.54L18.09,15.65C18.08,15.75 18.05,15.76 18,15.78H17.96L17.77,15.8C17.31,15.8 16.6,15.61 15.87,15.29C15.96,15.19 16,15.19 16.1,15.19C17.5,15.19 17.9,15.44 18,15.54M8.83,17C8.18,18.19 7.59,18.85 7.14,19C7.19,18.62 7.64,17.96 8.35,17.31L8.83,17M11.85,10.09C11.62,9.19 11.61,8.46 11.78,8.04L11.85,7.92L12,7.97C12.17,8.21 12.19,8.53 12.09,9.07L12.06,9.23L11.9,10.05L11.85,10.09Z",
  },
  {
    id: "C09B20B5-3650-4F36-AC40-540ACE36EB6E",
    name: "file-pdf-box",
    codepoint: "F226",
    aliases: [],
    tags: ["Files / Folders"],
    author: "Google",
    version: "1.5.54",
    path: "M11.43,10.94C11.2,11.68 10.87,12.47 10.42,13.34C10.22,13.72 10,14.08 9.92,14.38L10.03,14.34V14.34C11.3,13.85 12.5,13.57 13.37,13.41C13.22,13.31 13.08,13.2 12.96,13.09C12.36,12.58 11.84,11.84 11.43,10.94M17.91,14.75C17.74,14.94 17.44,15.05 17,15.05C16.24,15.05 15,14.82 14,14.31C12.28,14.5 11,14.73 9.97,15.06C9.92,15.08 9.86,15.1 9.79,15.13C8.55,17.25 7.63,18.2 6.82,18.2C6.66,18.2 6.5,18.16 6.38,18.09L5.9,17.78L5.87,17.73C5.8,17.55 5.78,17.38 5.82,17.19C5.93,16.66 6.5,15.82 7.7,15.07C7.89,14.93 8.19,14.77 8.59,14.58C8.89,14.06 9.21,13.45 9.55,12.78C10.06,11.75 10.38,10.73 10.63,9.85V9.84C10.26,8.63 10.04,7.9 10.41,6.57C10.5,6.19 10.83,5.8 11.2,5.8H11.44C11.67,5.8 11.89,5.88 12.05,6.04C12.71,6.7 12.4,8.31 12.07,9.64C12.05,9.7 12.04,9.75 12.03,9.78C12.43,10.91 13,11.82 13.63,12.34C13.89,12.54 14.18,12.74 14.5,12.92C14.95,12.87 15.38,12.85 15.79,12.85C17.03,12.85 17.78,13.07 18.07,13.54C18.17,13.7 18.22,13.89 18.19,14.09C18.18,14.34 18.09,14.57 17.91,14.75M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3M17.5,14.04C17.4,13.94 17,13.69 15.6,13.69C15.53,13.69 15.46,13.69 15.37,13.79C16.1,14.11 16.81,14.3 17.27,14.3C17.34,14.3 17.4,14.29 17.46,14.28H17.5C17.55,14.26 17.58,14.25 17.59,14.15C17.57,14.12 17.55,14.08 17.5,14.04M8.33,15.5C8.12,15.62 7.95,15.73 7.85,15.81C7.14,16.46 6.69,17.12 6.64,17.5C7.09,17.35 7.68,16.69 8.33,15.5M11.35,8.59L11.4,8.55C11.47,8.23 11.5,7.95 11.56,7.73L11.59,7.57C11.69,7 11.67,6.71 11.5,6.47L11.35,6.42C11.33,6.45 11.3,6.5 11.28,6.54C11.11,6.96 11.12,7.69 11.35,8.59Z",
  },
  {
    id: "267C5350-A0FC-4683-9FA1-30CD64AAA7E5",
    name: "file-percent",
    codepoint: "F81D",
    aliases: [],
    tags: ["Files / Folders"],
    author: "Michael Richins",
    version: "2.1.19",
    path: "M14,2L20,8V20C20,21.1 19.1,22 18,22H6C4.9,22 4,21.1 4,20V4C4,2.9 4.9,2 6,2H14M7.37,20L15,12.35L13.65,11L6,18.65L7.37,20M13,9H18.5L13,3.5V9M7.5,11C6.67,11 6,11.67 6,12.5C6,13.33 6.67,14 7.5,14C8.33,14 9,13.33 9,12.5C9,11.67 8.33,11 7.5,11M13.5,17C12.67,17 12,17.67 12,18.5C12,19.33 12.67,20 13.5,20C14.33,20 15,19.33 15,18.5C15,17.67 14.33,17 13.5,17Z",
  },
  {
    id: "9C42F83F-4C75-4E0A-A1C2-F10FA032E495",
    name: "file-plus",
    codepoint: "F751",
    aliases: ["note-add"],
    tags: ["Files / Folders"],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M13,9H18.5L13,3.5V9M6,2H14L20,8V20C20,21.1 19.1,22 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M11,15V12H9V15H6V17H9V20H11V17H14V15H11Z",
  },
  {
    id: "62D44147-9B6F-4B4A-A06B-1AF92C2E7F3E",
    name: "file-powerpoint",
    codepoint: "F227",
    aliases: [],
    tags: ["Files / Folders"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M6,2H14L20,8V20C20,21.1 19.1,22 18,22H6C4.9,22 4,21.1 4,20V4C4,2.9 4.9,2 6,2M13,3.5V9H18.5L13,3.5M8,11V13H9V19H8V20H12V19H11V17H13C14.66,17 16,15.66 16,14C16,12.34 14.66,11 13,11H8M13,13C13.55,13 14,13.45 14,14C14,14.55 13.55,15 13,15H11V13H13Z",
  },
  {
    id: "2C917F0E-C35E-45B2-9E60-0C3D7C2630CF",
    name: "file-powerpoint-box",
    codepoint: "F228",
    aliases: [],
    tags: ["Files / Folders"],
    author: "Google",
    version: "1.5.54",
    path: "M9.8,13.4H12.3C13.8,13.4 14.46,13.12 15.1,12.58C15.74,12.03 16,11.25 16,10.23C16,9.26 15.75,8.5 15.1,7.88C14.45,7.29 13.83,7 12.3,7H8V17H9.8V13.4M19,3C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.89 3.9,3 5,3H19M9.8,12V8.4H12.1C12.76,8.4 13.27,8.65 13.6,9C13.93,9.35 14.1,9.72 14.1,10.24C14.1,10.8 13.92,11.19 13.6,11.5C13.28,11.81 12.9,12 12.22,12H9.8Z",
  },
  {
    id: "A7F6B3BE-8D61-4AF3-BBFC-15A795254F6A",
    name: "file-presentation-box",
    codepoint: "F229",
    aliases: [],
    tags: ["Files / Folders"],
    author: "Google",
    version: "1.5.54",
    path: "M19,16H5V8H19M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3Z",
  },
  {
    id: "C5EBED58-BD25-4E0C-AEB8-C6316B88B620",
    name: "file-question",
    codepoint: "F86E",
    aliases: [],
    tags: ["Files / Folders"],
    author: "GreenTurtwig",
    version: "2.1.99",
    path: "M6,2C4.89,2 4,2.89 4,4V20C4,21.1 4.9,22 6,22H18C19.1,22 20,21.1 20,20V8L14,2H6M13,3.5L18.5,9H13V3.5M12,11C13.66,11 15,12.34 15,14C15,15.88 12.75,16.06 12.75,17.75H11.25C11.25,15.31 13.5,15.5 13.5,14C13.5,13.17 12.83,12.5 12,12.5C11.17,12.5 10.5,13.17 10.5,14H9C9,12.34 10.34,11 12,11M11.25,18.5H12.75V20H11.25V18.5Z",
  },
  {
    id: "EE0E5547-D368-43CB-8BDD-7F3774985BEF",
    name: "file-restore",
    codepoint: "F670",
    aliases: ["restore-page"],
    tags: ["Files / Folders"],
    author: "Google",
    version: "1.6.50",
    path: "M14,2H6C4.9,2 4,2.9 4,4V20C4,21.1 4.9,22 6,22H18C19.1,22 20,21.1 20,20V8L14,2M12,18C9.95,18 8.19,16.76 7.42,15H9.13C9.76,15.9 10.81,16.5 12,16.5C13.93,16.5 15.5,14.93 15.5,13C15.5,11.07 13.93,9.5 12,9.5C10.65,9.5 9.5,10.28 8.9,11.4L10.5,13H6.5V9L7.8,10.3C8.69,8.92 10.23,8 12,8C14.76,8 17,10.24 17,13C17,15.76 14.76,18 12,18Z",
  },
  {
    id: "CEB97477-6633-4486-BDD4-9E7D7C747805",
    name: "file-send",
    codepoint: "F22A",
    aliases: [],
    tags: ["Files / Folders"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M14,2H6C4.89,2 4,2.89 4,4V20C4,21.1 4.9,22 6,22H18C19.1,22 20,21.1 20,20V8L14,2M12.54,19.37V17.37H8.54V15.38H12.54V13.38L15.54,16.38L12.54,19.37M13,9V3.5L18.5,9H13Z",
  },
  {
    id: "FE2B1AE3-7158-473B-B1EE-45FB9CAE1137",
    name: "file-tree",
    codepoint: "F645",
    aliases: ["subtasks"],
    tags: ["Files / Folders"],
    author: "Kai Faust",
    version: "1.6.50",
    path: "M3,3H9V7H3V3M15,10H21V14H15V10M15,17H21V21H15V17M13,13H7V18H13V20H7L5,20V9H7V11H13V13Z",
  },
  {
    id: "5CCC54A4-04AF-4241-80AB-177C8365A905",
    name: "file-undo",
    codepoint: "F8DB",
    aliases: ["file-revert", "file-discard"],
    tags: ["Files / Folders"],
    author: "Michael Richins",
    version: "2.3.50",
    path: "M13,9H18.5L13,3.5V9M6,2H14L20,8V20C20,21.1 19.1,22 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M12.16,14.31C10.6,14.31 9.19,14.89 8.11,15.83L6,13.72V19H11.28L9.15,16.88C9.97,16.2 11,15.78 12.16,15.78C14.23,15.78 16,17.13 16.61,19L18,18.54C17.19,16.09 14.88,14.31 12.16,14.31Z",
  },
  {
    id: "7BEB068A-898D-43FF-AAA6-BC239FBA74F2",
    name: "file-video",
    codepoint: "F22B",
    aliases: [],
    tags: ["Video / Movie", "Files / Folders"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M13,9H18.5L13,3.5V9M6,2H14L20,8V20C20,21.1 19.1,22 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M17,19V13L14,15.2V13H7V19H14V16.8L17,19Z",
  },
  {
    id: "05004893-1DB7-4A34-AC50-D4B46133A603",
    name: "file-word",
    codepoint: "F22C",
    aliases: [],
    tags: ["Files / Folders"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M6,2H14L20,8V20C20,21.1 19.1,22 18,22H6C4.9,22 4,21.1 4,20V4C4,2.9 4.9,2 6,2M13,3.5V9H18.5L13,3.5M7,13L8.5,20H10.5L12,17L13.5,20H15.5L17,13H18V11H14V13H15L14.1,17.2L13,15V15H11V15L9.9,17.2L9,13H10V11H6V13H7Z",
  },
  {
    id: "AE6B9B24-DD1E-4896-B385-8DBB9D21C9E7",
    name: "file-word-box",
    codepoint: "F22D",
    aliases: [],
    tags: ["Files / Folders"],
    author: "Google",
    version: "1.5.54",
    path: "M15.5,17H14L12,9.5L10,17H8.5L6.1,7H7.8L9.34,14.5L11.3,7H12.7L14.67,14.5L16.2,7H17.9M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3Z",
  },
  {
    id: "2EFEE436-9663-4C09-AD65-6727A0ED2AFD",
    name: "film",
    codepoint: "F22F",
    aliases: ["camera-roll"],
    tags: ["Photography", "Video / Movie"],
    author: "Google",
    version: "1.5.54",
    path: "M3.5,3H5V1.8C5,1.36 5.36,1 5.8,1H10.2C10.64,1 11,1.36 11,1.8V3H12.5C13.33,3 14,3.67 14,4.5V5H22V20H14V20.5C14,21.33 13.33,22 12.5,22H3.5C2.67,22 2,21.33 2,20.5V4.5C2,3.67 2.67,3 3.5,3M18,7V9H20V7H18M14,7V9H16V7H14M10,7V9H12V7H10M14,16V18H16V16H14M18,16V18H20V16H18M10,16V18H12V16H10Z",
  },
  {
    id: "10A06B6D-A551-425C-B084-DA3F2239DFA1",
    name: "filmstrip",
    codepoint: "F230",
    aliases: ["local-movies", "theaters"],
    tags: ["Video / Movie"],
    author: "Google",
    version: "1.5.54",
    path: "M18,9H16V7H18M18,13H16V11H18M18,17H16V15H18M8,9H6V7H8M8,13H6V11H8M8,17H6V15H8M18,3V5H16V3H8V5H6V3H4V21H6V19H8V21H16V19H18V21H20V3H18Z",
  },
  {
    id: "CB040E6C-85FD-4C09-9ACD-C41EE5FB770E",
    name: "filmstrip-off",
    codepoint: "F231",
    aliases: [],
    tags: ["Video / Movie"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M1,4.27L2.28,3L21,21.72L19.73,23L16,19.27V21H8V19H6V21H4V7.27L1,4.27M18,9V7H16V9H18M18,13V11H16V13H18M18,15H16.82L6.82,5H8V3H16V5H18V3H20V18.18L18,16.18V15M8,13V11.27L7.73,11H6V13H8M8,17V15H6V17H8M6,3V4.18L4.82,3H6Z",
  },
  {
    id: "39CAC4E6-CC95-42C8-94E9-E29089F1E91E",
    name: "filter",
    codepoint: "F232",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M14,12V19.88C14.04,20.18 13.94,20.5 13.71,20.71C13.32,21.1 12.69,21.1 12.3,20.71L10.29,18.7C10.06,18.47 9.96,18.16 10,17.87V12H9.97L4.21,4.62C3.87,4.19 3.95,3.56 4.38,3.22C4.57,3.08 4.78,3 5,3V3H19V3C19.22,3 19.43,3.08 19.62,3.22C20.05,3.56 20.13,4.19 19.79,4.62L14.03,12H14Z",
  },
  {
    id: "524BE3DE-F5C8-4E2E-A329-8480136DCBDB",
    name: "filter-outline",
    codepoint: "F233",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M15,19.88C15.04,20.18 14.94,20.5 14.71,20.71C14.32,21.1 13.69,21.1 13.3,20.71L9.29,16.7C9.06,16.47 8.96,16.16 9,15.87V10.75L4.21,4.62C3.87,4.19 3.95,3.56 4.38,3.22C4.57,3.08 4.78,3 5,3V3H19V3C19.22,3 19.43,3.08 19.62,3.22C20.05,3.56 20.13,4.19 19.79,4.62L15,10.75V19.88M7.04,5L11,10.06V15.58L13,17.58V10.05L16.96,5H7.04Z",
  },
  {
    id: "F0D392A7-69A4-4301-8E3B-46A8FC7C3DF9",
    name: "filter-remove",
    codepoint: "F234",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M14.76,20.83L17.6,18L14.76,15.17L16.17,13.76L19,16.57L21.83,13.76L23.24,15.17L20.43,18L23.24,20.83L21.83,22.24L19,19.4L16.17,22.24L14.76,20.83M12,12V19.88C12.04,20.18 11.94,20.5 11.71,20.71C11.32,21.1 10.69,21.1 10.3,20.71L8.29,18.7C8.06,18.47 7.96,18.16 8,17.87V12H7.97L2.21,4.62C1.87,4.19 1.95,3.56 2.38,3.22C2.57,3.08 2.78,3 3,3V3H17V3C17.22,3 17.43,3.08 17.62,3.22C18.05,3.56 18.13,4.19 17.79,4.62L12.03,12H12Z",
  },
  {
    id: "C6DD0143-A7E3-464D-B0AC-F97E5C51F74C",
    name: "filter-remove-outline",
    codepoint: "F235",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M14.73,20.83L17.58,18L14.73,15.17L16.15,13.76L19,16.57L21.8,13.76L23.22,15.17L20.41,18L23.22,20.83L21.8,22.24L19,19.4L16.15,22.24L14.73,20.83M13,19.88C13.04,20.18 12.94,20.5 12.71,20.71C12.32,21.1 11.69,21.1 11.3,20.71L7.29,16.7C7.06,16.47 6.96,16.16 7,15.87V10.75L2.21,4.62C1.87,4.19 1.95,3.56 2.38,3.22C2.57,3.08 2.78,3 3,3V3H17V3C17.22,3 17.43,3.08 17.62,3.22C18.05,3.56 18.13,4.19 17.79,4.62L13,10.75V19.88M5.04,5L9,10.06V15.58L11,17.58V10.05L14.96,5H5.04Z",
  },
  {
    id: "AECECEA4-9E56-4B4B-ACD6-2C85AB09788A",
    name: "filter-variant",
    codepoint: "F236",
    aliases: ["filter-list"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M6,13H18V11H6M3,6V8H21V6M10,18H14V16H10V18Z",
  },
  {
    id: "C39421CD-2A2D-4D92-B59B-69D70A328DF4",
    name: "finance",
    codepoint: "F81E",
    aliases: ["chart-finance"],
    tags: ["Banking"],
    author: "Google",
    version: "2.1.19",
    path: "M3,13H7V23H3V13M10,14H14V23H10V14M17,9H21V23H17V9M17,1H21V5H20V3.06L11.97,11.09L8,7.12L3.4,11.72L2.34,10.66L8,5L11.97,8.97L18.94,2H17V1Z",
  },
  {
    id: "D093813C-B59B-42BD-B6C7-B451FA51E87E",
    name: "find-replace",
    codepoint: "F6D3",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.8.36",
    path: "M11,6C12.38,6 13.63,6.56 14.54,7.46L12,10H18V4L15.95,6.05C14.68,4.78 12.93,4 11,4C7.47,4 4.57,6.61 4.08,10H6.1C6.56,7.72 8.58,6 11,6M16.64,15.14C17.3,14.24 17.76,13.17 17.92,12H15.9C15.44,14.28 13.42,16 11,16C9.62,16 8.37,15.44 7.46,14.54L10,12H4V18L6.05,15.95C7.32,17.22 9.07,18 11,18C12.55,18 14,17.5 15.14,16.64L20,21.5L21.5,20L16.64,15.14Z",
  },
  {
    id: "F71C897D-9858-40AE-8DB4-253CE675D823",
    name: "fingerprint",
    codepoint: "F237",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M17.81,4.47C17.73,4.47 17.65,4.45 17.58,4.41C15.66,3.42 14,3 12,3C10.03,3 8.15,3.47 6.44,4.41C6.2,4.54 5.9,4.45 5.76,4.21C5.63,3.97 5.72,3.66 5.96,3.53C7.82,2.5 9.86,2 12,2C14.14,2 16,2.47 18.04,3.5C18.29,3.65 18.38,3.95 18.25,4.19C18.16,4.37 18,4.47 17.81,4.47M3.5,9.72C3.4,9.72 3.3,9.69 3.21,9.63C3,9.47 2.93,9.16 3.09,8.93C4.08,7.53 5.34,6.43 6.84,5.66C10,4.04 14,4.03 17.15,5.65C18.65,6.42 19.91,7.5 20.9,8.9C21.06,9.12 21,9.44 20.78,9.6C20.55,9.76 20.24,9.71 20.08,9.5C19.18,8.22 18.04,7.23 16.69,6.54C13.82,5.07 10.15,5.07 7.29,6.55C5.93,7.25 4.79,8.25 3.89,9.5C3.81,9.65 3.66,9.72 3.5,9.72M9.75,21.79C9.62,21.79 9.5,21.74 9.4,21.64C8.53,20.77 8.06,20.21 7.39,19C6.7,17.77 6.34,16.27 6.34,14.66C6.34,11.69 8.88,9.27 12,9.27C15.12,9.27 17.66,11.69 17.66,14.66C17.66,14.94 17.44,15.16 17.16,15.16C16.88,15.16 16.66,14.94 16.66,14.66C16.66,12.24 14.57,10.27 12,10.27C9.43,10.27 7.34,12.24 7.34,14.66C7.34,16.1 7.66,17.43 8.27,18.5C8.91,19.66 9.35,20.15 10.12,20.93C10.31,21.13 10.31,21.44 10.12,21.64C10,21.74 9.88,21.79 9.75,21.79M16.92,19.94C15.73,19.94 14.68,19.64 13.82,19.05C12.33,18.04 11.44,16.4 11.44,14.66C11.44,14.38 11.66,14.16 11.94,14.16C12.22,14.16 12.44,14.38 12.44,14.66C12.44,16.07 13.16,17.4 14.38,18.22C15.09,18.7 15.92,18.93 16.92,18.93C17.16,18.93 17.56,18.9 17.96,18.83C18.23,18.78 18.5,18.96 18.54,19.24C18.59,19.5 18.41,19.77 18.13,19.82C17.56,19.93 17.06,19.94 16.92,19.94M14.91,22C14.87,22 14.82,22 14.78,22C13.19,21.54 12.15,20.95 11.06,19.88C9.66,18.5 8.89,16.64 8.89,14.66C8.89,13.04 10.27,11.72 11.97,11.72C13.67,11.72 15.05,13.04 15.05,14.66C15.05,15.73 16,16.6 17.13,16.6C18.28,16.6 19.21,15.73 19.21,14.66C19.21,10.89 15.96,7.83 11.96,7.83C9.12,7.83 6.5,9.41 5.35,11.86C4.96,12.67 4.76,13.62 4.76,14.66C4.76,15.44 4.83,16.67 5.43,18.27C5.53,18.53 5.4,18.82 5.14,18.91C4.88,19 4.59,18.87 4.5,18.62C4,17.31 3.77,16 3.77,14.66C3.77,13.46 4,12.37 4.45,11.42C5.78,8.63 8.73,6.82 11.96,6.82C16.5,6.82 20.21,10.33 20.21,14.65C20.21,16.27 18.83,17.59 17.13,17.59C15.43,17.59 14.05,16.27 14.05,14.65C14.05,13.58 13.12,12.71 11.97,12.71C10.82,12.71 9.89,13.58 9.89,14.65C9.89,16.36 10.55,17.96 11.76,19.16C12.71,20.1 13.62,20.62 15.03,21C15.3,21.08 15.45,21.36 15.38,21.62C15.33,21.85 15.12,22 14.91,22Z",
  },
  {
    id: "5259DBA5-B2FB-4112-B1F2-5DC17002205C",
    name: "fire",
    codepoint: "F238",
    aliases: ["whatshot"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M11.71,19C9.93,19 8.5,17.59 8.5,15.86C8.5,14.24 9.53,13.1 11.3,12.74C13.07,12.38 14.9,11.53 15.92,10.16C16.31,11.45 16.5,12.81 16.5,14.2C16.5,16.84 14.36,19 11.71,19M13.5,0.67C13.5,0.67 14.24,3.32 14.24,5.47C14.24,7.53 12.89,9.2 10.83,9.2C8.76,9.2 7.2,7.53 7.2,5.47L7.23,5.1C5.21,7.5 4,10.61 4,14C4,18.42 7.58,22 12,22C16.42,22 20,18.42 20,14C20,8.6 17.41,3.8 13.5,0.67Z",
  },
  {
    id: "1C8EC9A6-0545-4A59-B9F8-5E498E40529D",
    name: "fire-truck",
    codepoint: "F8AA",
    aliases: ["fire-engine"],
    tags: [],
    author: "Nick",
    version: "2.2.43",
    path: "M17.04,2C16.85,2 16.66,2.04 16.5,2.14L5.59,8.5H9.55L17.5,3.86C18,3.58 18.13,2.97 17.85,2.5C17.68,2.2 17.38,2 17.04,2M16,8V10H3C1.9,10 1,10.9 1,12H2V15H1V19H3C3,20.66 4.34,22 6,22C7.66,22 9,20.66 9,19H15C15,20.66 16.34,22 18,22C19.66,22 21,20.66 21,19H23V12.5L19.5,8H16M18,9.5H19L21.5,12.5V13.5H18V9.5M4,12H7V15H4V12M9,12H12V15H9V12M14,12H16V15H14V12M6,17.5C6.83,17.5 7.5,18.17 7.5,19C7.5,19.83 6.83,20.5 6,20.5C5.17,20.5 4.5,19.83 4.5,19C4.5,18.17 5.17,17.5 6,17.5M18,17.5C18.83,17.5 19.5,18.17 19.5,19C19.5,19.83 18.83,20.5 18,20.5C17.17,20.5 16.5,19.83 16.5,19C16.5,18.17 17.17,17.5 18,17.5Z",
  },
  {
    id: "3A3D9EFD-ABA4-444F-9CB5-A2D8C1322B2C",
    name: "firebase",
    codepoint: "F966",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Google",
    version: "2.4.85",
    path: "M20,18.69L12.7,22.74C12.2,23 11.7,23 11.2,22.74L4,18.69L17.05,5.54L17.4,5.44C17.7,5.44 17.87,5.57 17.9,5.84L20,18.69M9.35,5.74L4.8,13.29L6.7,1.34C6.73,1.07 6.9,0.94 7.2,0.94C7.4,0.94 7.53,1 7.6,1.19L9.75,5.14L9.35,5.74M13.85,7L4.3,16.59L11.55,4.29C11.65,4.09 11.8,4 12,4C12.2,4 12.33,4.09 12.4,4.29L13.85,7Z",
  },
  {
    id: "2A7EE574-62BE-4000-B8D8-B601C29D2960",
    name: "firefox",
    codepoint: "F239",
    aliases: ["mozilla-firefox"],
    tags: ["Brand / Logo"],
    author: "Chris Litherland",
    version: "1.5.54",
    path: "M21,11.7C21,11.3 20.9,10.7 20.8,10.3C20.5,8.6 19.6,7.1 18.5,5.9C18.3,5.6 17.9,5.3 17.5,5C16.4,4.1 15.1,3.5 13.6,3.2C10.6,2.7 7.6,3.7 5.6,5.8C5.6,5.8 5.6,5.7 5.6,5.7C5.5,5.5 5.5,5.5 5.4,5.5C5.4,5.5 5.4,5.5 5.4,5.5C5.3,5.3 5.3,5.2 5.2,5.1C5.2,5.1 5.2,5.1 5.2,5.1C5.2,4.9 5.1,4.7 5.1,4.5C4.8,4.6 4.8,4.9 4.7,5.1C4.7,5.1 4.7,5.1 4.7,5.1C4.5,5.3 4.3,5.6 4.3,5.9C4.3,5.9 4.3,5.9 4.3,5.9C4.2,6.1 4,7 4.2,7.1C4.2,7.1 4.2,7.1 4.3,7.1C4.3,7.2 4.3,7.3 4.3,7.4C4.1,7.6 4,7.7 4,7.8C3.7,8.4 3.4,8.9 3.3,9.5C3.3,9.7 3.3,9.8 3.3,9.9C3.3,9.9 3.3,9.9 3.3,9.9C3.3,9.9 3.3,9.8 3.3,9.8C3.1,10 3.1,10.3 3,10.5C3.1,10.5 3.1,10.4 3.2,10.4C2.7,13 3.4,15.7 5,17.7C7.4,20.6 11.5,21.8 15.1,20.5C18.6,19.2 21,15.8 21,12C21,11.9 21,11.8 21,11.7M13.5,4.1C15,4.4 16.4,5.1 17.5,6.1C17.6,6.2 17.7,6.4 17.7,6.4C17.4,6.1 16.7,5.6 16.3,5.8C16.4,6.1 17.6,7.6 17.7,7.7C17.7,7.7 18,9 18.1,9.1C18.1,9.1 18.1,9.1 18.1,9.1C18.1,9.1 18.1,9.1 18.1,9.1C18.1,9.3 17.4,11.9 17.4,12.3C17.4,12.4 16.5,14.2 16.6,14.2C16.3,14.9 16,14.9 15.9,15C15.8,15 15.2,15.2 14.5,15.4C13.9,15.5 13.2,15.7 12.7,15.6C12.4,15.6 12,15.6 11.7,15.4C11.6,15.3 10.8,14.9 10.6,14.8C10.3,14.7 10.1,14.5 9.9,14.3C10.2,14.3 10.8,14.3 11,14.3C11.6,14.2 14.2,13.3 14.1,12.9C14.1,12.6 13.6,12.4 13.4,12.2C13.1,12.1 11.9,12.3 11.4,12.5C11.4,12.5 9.5,12 9,11.6C9,11.5 8.9,10.9 8.9,10.8C8.8,10.7 9.2,10.4 9.2,10.4C9.2,10.4 10.2,9.4 10.2,9.3C10.4,9.3 10.6,9.1 10.7,9C10.6,9 10.8,8.9 11.1,8.7C11.1,8.7 11.1,8.7 11.1,8.7C11.4,8.5 11.6,8.5 11.6,8.2C11.6,8.2 12.1,7.3 11.5,7.4C11.5,7.4 10.6,7.3 10.3,7.3C10,7.5 9.9,7.4 9.6,7.3C9.6,7.3 9.4,7.1 9.4,7C9.5,6.8 10.2,5.3 10.5,5.2C10.3,4.8 9.3,5.1 9.1,5.4C9.1,5.4 8.3,6 7.9,6.1C7.9,6.1 7.9,6.1 7.9,6.1C7.9,6 7.4,5.9 6.9,5.9C8.7,4.4 11.1,3.7 13.5,4.1Z",
  },
  {
    id: "91D8C321-95BC-4AC6-9B3E-D38D457BFF75",
    name: "fish",
    codepoint: "F23A",
    aliases: [],
    tags: ["Animal", "Food / Drink"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,20L12.76,17C9.5,16.79 6.59,15.4 5.75,13.58C5.66,14.06 5.53,14.5 5.33,14.83C4.67,16 3.33,16 2,16C3.1,16 3.5,14.43 3.5,12.5C3.5,10.57 3.1,9 2,9C3.33,9 4.67,9 5.33,10.17C5.53,10.5 5.66,10.94 5.75,11.42C6.4,10 8.32,8.85 10.66,8.32L9,5C11,5 13,5 14.33,5.67C15.46,6.23 16.11,7.27 16.69,8.38C19.61,9.08 22,10.66 22,12.5C22,14.38 19.5,16 16.5,16.66C15.67,17.76 14.86,18.78 14.17,19.33C13.33,20 12.67,20 12,20M17,11C16.45,11 16,11.45 16,12C16,12.55 16.45,13 17,13C17.55,13 18,12.55 18,12C18,11.45 17.55,11 17,11Z",
  },
  {
    id: "55271063-77EF-43FA-917C-657E57135A24",
    name: "flag",
    codepoint: "F23B",
    aliases: ["assistant-photo"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M14.4,6L14,4H5V21H7V14H12.6L13,16H20V6H14.4Z",
  },
  {
    id: "B7386AC8-4DBF-4948-AD45-49234A8A019B",
    name: "flag-checkered",
    codepoint: "F23C",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M14.4,6H20V16H13L12.6,14H7V21H5V4H14L14.4,6M14,14H16V12H18V10H16V8H14V10L13,8V6H11V8H9V6H7V8H9V10H7V12H9V10H11V12H13V10L14,12V14M11,10V8H13V10H11M14,10H16V12H14V10Z",
  },
  {
    id: "3C0BD546-A778-4BDC-A30A-A627D61CBA47",
    name: "flag-outline",
    codepoint: "F23D",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M14.5,6H20V16H13L12.5,14H7V21H5V4H14L14.5,6M7,6V12H13L13.5,14H18V8H14L13.5,6H7Z",
  },
  {
    id: "3E14D0C4-25AA-405E-89A7-37E9A224BA93",
    name: "flag-triangle",
    codepoint: "F23F",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M7,2H9V22H7V2M19,9L11,14.6V3.4L19,9Z",
  },
  {
    id: "9A9DB93D-CE2E-4887-B648-9C70E1922092",
    name: "flag-variant",
    codepoint: "F240",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M6,3C6.55,3 7,3.45 7,4V4.88C8.06,4.44 9.5,4 11,4C14,4 14,6 16,6C19,6 20,4 20,4V12C20,12 19,14 16,14C13,14 13,12 11,12C8,12 7,14 7,14V21H5V4C5,3.45 5.45,3 6,3Z",
  },
  {
    id: "756B772A-F638-48EB-918C-2FA4237C7767",
    name: "flag-variant-outline",
    codepoint: "F23E",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M6,3C6.55,3 7,3.45 7,4V4.88C8.06,4.44 9.5,4 11,4C14,4 14,6 16,6C19,6 20,4 20,4V12C20,12 19,14 16,14C13,14 13,12 11,12C8,12 7,14 7,14V21H5V4C5,3.45 5.45,3 6,3M7,7.25V11.5C7,11.5 9,10 11,10C13,10 14,12 16,12C18,12 18,11 18,11V7.5C18,7.5 17,8 16,8C14,8 13,6 11,6C9,6 7,7.25 7,7.25Z",
  },
  {
    id: "EF3D6923-793B-410C-B349-90A6A338F06C",
    name: "flash",
    codepoint: "F241",
    aliases: ["lightning-bolt", "flash-on", "electricity"],
    tags: ["Weather"],
    author: "Google",
    version: "1.5.54",
    path: "M7,2V13H10V22L17,10H13L17,2H7Z",
  },
  {
    id: "D3251831-8AEF-420A-9AA8-2BA0A0621538",
    name: "flash-auto",
    codepoint: "F242",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M16.85,7.65L18,4L19.15,7.65M19,2H17L13.8,11H15.7L16.4,9H19.6L20.3,11H22.2M3,2V14H6V23L13,11H9L13,2H3Z",
  },
  {
    id: "F055DA49-5992-4DDC-8C71-E5D331520DEA",
    name: "flash-circle",
    codepoint: "F81F",
    aliases: ["amp", "offline-bolt", "lightning-bolt-circle"],
    tags: [],
    author: "Google",
    version: "2.1.19",
    path: "M11.5,20L16.36,10.27H13V4L8,13.73H11.5V20M12,2C14.75,2 17.1,3 19.05,4.95C21,6.9 22,9.25 22,12C22,14.75 21,17.1 19.05,19.05C17.1,21 14.75,22 12,22C9.25,22 6.9,21 4.95,19.05C3,17.1 2,14.75 2,12C2,9.25 3,6.9 4.95,4.95C6.9,3 9.25,2 12,2Z",
  },
  {
    id: "A6D1B09D-EDB0-4241-B42D-E56052A070DE",
    name: "flash-off",
    codepoint: "F243",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M17,10H13L17,2H7V4.18L15.46,12.64M3.27,3L2,4.27L7,9.27V13H10V22L13.58,15.86L17.73,20L19,18.73L3.27,3Z",
  },
  {
    id: "088BF56F-9281-43DB-879E-EB5158428EB7",
    name: "flash-outline",
    codepoint: "F6D4",
    aliases: ["lightning-bolt-outline"],
    tags: ["Weather"],
    author: "Michael Irigoyen",
    version: "1.8.36",
    path: "M7,2H17L13.5,9H17L10,22V14H7V2M9,4V12H12V14.66L14,11H10.24L13.76,4H9Z",
  },
  {
    id: "C25CEF12-DF9C-45A4-8399-3102B79BDF14",
    name: "flash-red-eye",
    codepoint: "F67A",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.7.12",
    path: "M16,5C15.44,5 15,5.44 15,6C15,6.56 15.44,7 16,7C16.56,7 17,6.56 17,6C17,5.44 16.56,5 16,5M16,2C13.27,2 10.94,3.66 10,6C10.94,8.34 13.27,10 16,10C18.73,10 21.06,8.34 22,6C21.06,3.66 18.73,2 16,2M16,3.5C17.38,3.5 18.5,4.62 18.5,6C18.5,7.38 17.38,8.5 16,8.5C14.62,8.5 13.5,7.38 13.5,6C13.5,4.62 14.62,3.5 16,3.5M3,2V14H6V23L13,11H9L10.12,8.5C9.44,7.76 8.88,6.93 8.5,6C9.19,4.29 10.5,2.88 12.11,2H3Z",
  },
  {
    id: "0EC7CDC8-86F4-4C72-AC2E-1DEDB196043F",
    name: "flashlight",
    codepoint: "F244",
    aliases: ["torch"],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M9,10L6,5H18L15,10H9M18,4H6V2H18V4M9,22V11H15V22H9M12,13C11.45,13 11,13.45 11,14C11,14.55 11.45,15 12,15C12.55,15 13,14.55 13,14C13,13.45 12.55,13 12,13Z",
  },
  {
    id: "043DEA8B-1F5B-49CE-BC9F-AA3FC802A58A",
    name: "flashlight-off",
    codepoint: "F245",
    aliases: ["torch-off"],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M2,5.27L3.28,4L20,20.72L18.73,22L15,18.27V22H9V12.27L2,5.27M18,5L15,10H11.82L6.82,5H18M18,4H6V2H18V4M15,11V13.18L12.82,11H15Z",
  },
  {
    id: "5E171637-949C-4091-9A6E-1A56C1DC8347",
    name: "flask",
    codepoint: "F093",
    aliases: [],
    tags: ["Science"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M6,22C4.34,22 3,20.66 3,19C3,18.4 3.18,17.84 3.5,17.37L9,7.81V6C8.45,6 8,5.55 8,5V4C8,2.9 8.9,2 10,2H14C15.1,2 16,2.9 16,4V5C16,5.55 15.55,6 15,6V7.81L20.5,17.37C20.82,17.84 21,18.4 21,19C21,20.66 19.66,22 18,22H6M5,19C5,19.55 5.45,20 6,20H18C18.55,20 19,19.55 19,19C19,18.79 18.93,18.59 18.82,18.43L16.53,14.47L14,17L8.93,11.93L5.18,18.43C5.07,18.59 5,18.79 5,19M13,10C12.45,10 12,10.45 12,11C12,11.55 12.45,12 13,12C13.55,12 14,11.55 14,11C14,10.45 13.55,10 13,10Z",
  },
  {
    id: "D036C297-DB1B-42F5-A856-13EEBDB48613",
    name: "flask-empty",
    codepoint: "F094",
    aliases: [],
    tags: ["Science"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M6,22C4.34,22 3,20.66 3,19C3,18.4 3.18,17.84 3.5,17.37L9,7.81V6C8.45,6 8,5.55 8,5V4C8,2.9 8.9,2 10,2H14C15.1,2 16,2.9 16,4V5C16,5.55 15.55,6 15,6V7.81L20.5,17.37C20.82,17.84 21,18.4 21,19C21,20.66 19.66,22 18,22H6Z",
  },
  {
    id: "E9FFE6A9-C641-47BE-988B-A94B34A90CED",
    name: "flask-empty-outline",
    codepoint: "F095",
    aliases: [],
    tags: ["Science"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M5,19C5,19.55 5.45,20 6,20H18C18.55,20 19,19.55 19,19C19,18.79 18.93,18.59 18.82,18.43L13,8.35V4H11V8.35L5.18,18.43C5.07,18.59 5,18.79 5,19M6,22C4.34,22 3,20.66 3,19C3,18.4 3.18,17.84 3.5,17.37L9,7.81V6C8.45,6 8,5.55 8,5V4C8,2.9 8.9,2 10,2H14C15.1,2 16,2.9 16,4V5C16,5.55 15.55,6 15,6V7.81L20.5,17.37C20.82,17.84 21,18.4 21,19C21,20.66 19.66,22 18,22H6Z",
  },
  {
    id: "14C068EE-90AC-42DA-AA1E-D24F74EE7263",
    name: "flask-outline",
    codepoint: "F096",
    aliases: [],
    tags: ["Science"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M5,19C5,19.55 5.45,20 6,20H18C18.55,20 19,19.55 19,19C19,18.79 18.93,18.59 18.82,18.43L13,8.35V4H11V8.35L5.18,18.43C5.07,18.59 5,18.79 5,19M6,22C4.34,22 3,20.66 3,19C3,18.4 3.18,17.84 3.5,17.37L9,7.81V6C8.45,6 8,5.55 8,5V4C8,2.9 8.9,2 10,2H14C15.1,2 16,2.9 16,4V5C16,5.55 15.55,6 15,6V7.81L20.5,17.37C20.82,17.84 21,18.4 21,19C21,20.66 19.66,22 18,22H6M13,16L14.34,14.66L16.27,18H7.73L10.39,13.39L13,16M12.5,12C12.78,12 13,12.22 13,12.5C13,12.78 12.78,13 12.5,13C12.22,13 12,12.78 12,12.5C12,12.22 12.22,12 12.5,12Z",
  },
  {
    id: "F9DD0BF3-1CF8-456E-A542-2D22131A5761",
    name: "flip-to-back",
    codepoint: "F247",
    aliases: [],
    tags: ["Arrange"],
    author: "Google",
    version: "1.5.54",
    path: "M15,17H17V15H15M15,5H17V3H15M5,7H3V19C3,20.1 3.9,21 5,21H17V19H5M19,17C20.1,17 21,16.1 21,15H19M19,9H21V7H19M19,13H21V11H19M9,17V15H7C7,16.1 7.9,17 9,17M13,3H11V5H13M19,3V5H21C21,3.89 20.1,3 19,3M13,15H11V17H13M9,3C7.89,3 7,3.89 7,5H9M9,11H7V13H9M9,7H7V9H9V7Z",
  },
  {
    id: "6CEAE4F9-F6CB-4DA8-A25C-1F41494C6DD5",
    name: "flip-to-front",
    codepoint: "F248",
    aliases: [],
    tags: ["Arrange"],
    author: "Google",
    version: "1.5.54",
    path: "M7,21H9V19H7M11,21H13V19H11M19,15H9V5H19M19,3H9C7.89,3 7,3.89 7,5V15C7,16.1 7.9,17 9,17H14L18,17H19C20.1,17 21,16.1 21,15V5C21,3.89 20.1,3 19,3M15,21H17V19H15M3,9H5V7H3M5,21V19H3C3,20.1 3.9,21 5,21M3,17H5V15H3M3,13H5V11H3V13Z",
  },
  {
    id: "BEF1218E-7AF7-45F9-930E-915791D51EDC",
    name: "floor-lamp",
    codepoint: "F8DC",
    aliases: [],
    tags: ["Home Automation"],
    author: "GreenTurtwig",
    version: "2.3.50",
    path: "M15,2L17,9H7L9,2M11,10H13V20H16V22H8V20H11V10Z",
  },
  {
    id: "131D3C5D-880D-486B-A041-039B1F1E5284",
    name: "floor-plan",
    codepoint: "F820",
    aliases: [],
    tags: ["Home Automation"],
    author: "Contributors",
    version: "2.1.19",
    path: "M10,5V10H9V5H5V13H9V12H10V17H9V14H5V19H12V17H13V19H19V17H21V21H3V3H21V15H19V10H13V15H12V9H19V5H10Z",
  },
  {
    id: "B4AC5BF4-AF66-4DC5-9743-F62A80489149",
    name: "floppy",
    codepoint: "F249",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M5,3C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5.5L18.5,3H17V9C17,9.55 16.55,10 16,10H8C7.45,10 7,9.55 7,9V3H5M12,4V9H15V4H12M7,12H17C17.55,12 18,12.45 18,13V19H6V13C6,12.45 6.45,12 7,12Z",
  },
  {
    id: "8A4453F7-03E3-4F10-B93F-3213645300F8",
    name: "floppy-variant",
    codepoint: "F9EE",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "2.5.94",
    path: "M3,3V21H21V3H3M12,10C13.1,10 14,10.9 14,12C14,13.1 13.1,14 12,14C10.9,14 10,13.1 10,12C10,10.9 10.9,10 12,10M12,15C12.55,15 13,15.45 13,16V19C13,19.55 12.55,20 12,20C11.45,20 11,19.55 11,19V16C11,15.45 11.45,15 12,15Z",
  },
  {
    id: "D73BB486-A112-48C1-A4EE-993825164C43",
    name: "flower",
    codepoint: "F24A",
    aliases: ["local-florist"],
    tags: ["Nature"],
    author: "Google",
    version: "1.5.54",
    path: "M3,13C3,17.97 7.03,22 12,22C12,17 7.97,13 3,13M12,5.5C13.38,5.5 14.5,6.62 14.5,8C14.5,9.38 13.38,10.5 12,10.5C10.62,10.5 9.5,9.38 9.5,8C9.5,6.62 10.62,5.5 12,5.5M5.6,10.25C5.6,11.63 6.72,12.75 8.1,12.75C8.63,12.75 9.12,12.58 9.5,12.31C9.5,12.37 9.5,12.43 9.5,12.5C9.5,13.88 10.62,15 12,15C13.38,15 14.5,13.88 14.5,12.5C14.5,12.43 14.5,12.37 14.5,12.31C14.88,12.58 15.37,12.75 15.9,12.75C17.28,12.75 18.4,11.63 18.4,10.25C18.4,9.25 17.81,8.4 16.97,8C17.81,7.6 18.4,6.74 18.4,5.75C18.4,4.37 17.28,3.25 15.9,3.25C15.37,3.25 14.88,3.41 14.5,3.69C14.5,3.63 14.5,3.56 14.5,3.5C14.5,2.12 13.38,1 12,1C10.62,1 9.5,2.12 9.5,3.5C9.5,3.56 9.5,3.63 9.5,3.69C9.12,3.41 8.63,3.25 8.1,3.25C6.72,3.25 5.6,4.37 5.6,5.75C5.6,6.74 6.19,7.6 7.03,8C6.19,8.4 5.6,9.25 5.6,10.25M12,22C16.97,22 21,17.97 21,13C16,13 12,17 12,22Z",
  },
  {
    id: "0BF283D1-7C12-4E5F-B136-558BE534AC8D",
    name: "flower-outline",
    codepoint: "F9EF",
    aliases: ["local-florist-outline"],
    tags: [],
    author: "Google",
    version: "2.5.94",
    path: "M8.66,13.07C6.92,13.07 5.5,11.66 5.5,9.93C5.5,9.22 5.76,8.54 6.19,8C5.77,7.46 5.5,6.78 5.5,6.07C5.5,4.34 6.93,2.93 8.66,2.93L9.09,2.96C9.56,1.81 10.69,1 12,1C13.31,1 14.44,1.81 14.91,2.96L15.34,2.93C17.07,2.93 18.5,4.34 18.5,6.07C18.5,6.78 18.24,7.46 17.81,8C18.23,8.54 18.5,9.22 18.5,9.93C18.5,11.66 17.07,13.07 15.34,13.07L14.91,13.04C14.44,14.19 13.31,15 12,15C10.69,15 9.56,14.19 9.09,13.04L8.66,13.07M12,13C12.62,13 13.12,12.5 13.14,11.9L13.03,10.81C12.71,10.93 12.36,11 12,11C11.64,11 11.3,10.93 11,10.81L10.86,11.9C10.88,12.5 11.38,13 12,13M15.34,11.07C15.97,11.07 16.5,10.56 16.5,9.92C16.5,9.5 16.23,9.08 15.83,8.89L14.95,8.47C14.83,9.21 14.44,9.85 13.89,10.3L14.7,10.87C14.88,11 15.1,11.07 15.34,11.07M14.69,5.13L13.87,5.69C14.43,6.14 14.82,6.78 14.94,7.5L15.82,7.1C16.23,6.9 16.5,6.5 16.5,6.07C16.5,5.44 15.97,4.93 15.34,4.93C15.11,4.93 14.89,5 14.69,5.13M12,3C11.38,3 10.88,3.5 10.86,4.1L11,5.19C11.3,5.07 11.64,5 12,5C12.36,5 12.71,5.07 13.03,5.19L13.14,4.1C13.12,3.5 12.62,3 12,3M8.66,4.93C8.03,4.93 7.5,5.44 7.5,6.07C7.5,6.5 7.77,6.9 8.17,7.1L9.05,7.5C9.17,6.78 9.56,6.14 10.11,5.69L9.3,5.13C9.12,5 8.9,4.93 8.66,4.93M8.17,8.9C7.77,9.1 7.5,9.5 7.5,9.92C7.5,10.55 8.03,11.06 8.66,11.06C8.89,11.06 9.11,11 9.31,10.86L10.12,10.31C9.56,9.86 9.17,9.22 9.05,8.5L8.17,8.9M12,22C7.03,22 3,17.97 3,13C7.97,13 12,17.03 12,22C12,17.03 16.03,13 21,13C21,17.97 16.97,22 12,22M14.44,19.56C16.34,18.85 17.85,17.34 18.56,15.44C16.66,16.14 15.15,17.66 14.44,19.56M5.44,15.44C6.15,17.34 7.66,18.85 9.56,19.56C8.86,17.66 7.34,16.15 5.44,15.44Z",
  },
  {
    id: "4CD0F242-7779-4B61-B13C-876236FE92B4",
    name: "flower-tulip",
    codepoint: "F9F0",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.5.94",
    path: "M3,13C3,17.97 7.03,22 12,22C12,17.03 7.97,13 3,13M12,22C16.97,22 21,17.97 21,13C16.03,13 12,17.03 12,22M18,3V8C18,11.31 15.31,14 12,14C8.69,14 6,11.31 6,8V3C6.74,3 7.47,3.12 8.16,3.39C8.71,3.62 9.2,3.96 9.61,4.39L12,2L14.39,4.39C14.8,3.96 15.29,3.62 15.84,3.39C16.53,3.12 17.26,3 18,3Z",
  },
  {
    id: "D6449362-3D4B-42FB-BD25-020B104B4602",
    name: "flower-tulip-outline",
    codepoint: "F9F1",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.5.94",
    path: "M3,13C3,17.97 7.03,22 12,22C12,17.03 7.97,13 3,13M5.44,15.44C7.35,16.15 8.85,17.65 9.56,19.56C7.65,18.85 6.15,17.35 5.44,15.44M12,22C16.97,22 21,17.97 21,13C16.03,13 12,17.03 12,22M14.42,19.57C15.11,17.64 16.64,16.11 18.57,15.42C17.86,17.34 16.34,18.86 14.42,19.57M12,14C15.31,14 18,11.31 18,8V3C17.26,3 16.53,3.12 15.84,3.39C15.29,3.62 14.8,3.96 14.39,4.39L12,2L9.61,4.39C9.2,3.96 8.71,3.62 8.16,3.39C7.47,3.12 6.74,3 6,3V8C6,11.31 8.69,14 12,14M8,5.61L9.57,7.26L12,4.83L14.43,7.26L16,5.61V8C16,10.21 14.21,12 12,12C9.79,12 8,10.21 8,8V5.61Z",
  },
  {
    id: "9D8C1CEE-19BE-4B0B-85CC-DEB829F9F045",
    name: "folder",
    codepoint: "F24B",
    aliases: [],
    tags: ["Files / Folders"],
    author: "Google",
    version: "1.5.54",
    path: "M10,4H4C2.89,4 2,4.89 2,6V18C2,19.1 2.9,20 4,20H20C21.1,20 22,19.1 22,18V8C22,6.89 21.1,6 20,6H12L10,4Z",
  },
  {
    id: "0C56278E-06DE-4D32-BA08-C78F3EB572CC",
    name: "folder-account",
    codepoint: "F24C",
    aliases: ["folder-user", "folder-shared"],
    tags: ["Account / User"],
    author: "Google",
    version: "1.5.54",
    path: "M19,17H11V16C11,14.67 13.67,14 15,14C16.33,14 19,14.67 19,16M15,9C16.1,9 17,9.9 17,11C17,12.1 16.1,13 15,13C13.9,13 13,12.1 13,11C13,9.89 13.9,9 15,9M20,6H12L10,4H4C2.89,4 2,4.89 2,6V18C2,19.1 2.9,20 4,20H20C21.1,20 22,19.1 22,18V8C22,6.89 21.1,6 20,6Z",
  },
  {
    id: "E10E0982-353D-484A-886B-30D343261422",
    name: "folder-download",
    codepoint: "F24D",
    aliases: [],
    tags: ["Files / Folders"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M20,6C21.1,6 22,6.9 22,8V18C22,19.1 21.1,20 20,20H4C2.89,20 2,19.1 2,18V6C2,4.89 2.89,4 4,4H10L12,6H20M19.25,13H16V9H14V13H10.75L15,17.25",
  },
  {
    id: "1C40CBC9-118F-4145-B0A5-B10007870272",
    name: "folder-edit",
    codepoint: "F8DD",
    aliases: [],
    tags: ["Files / Folders"],
    author: "GreenTurtwig",
    version: "2.3.50",
    path: "M3,4C1.89,4 1,4.89 1,6V18C1,19.1 1.9,20 3,20H11V18.11L21,8.11V8C21,6.89 20.1,6 19,6H11L9,4H3M21.04,11.13C20.9,11.13 20.76,11.19 20.65,11.3L19.65,12.3L21.7,14.35L22.7,13.35C22.92,13.14 22.92,12.79 22.7,12.58L21.42,11.3C21.31,11.19 21.18,11.13 21.04,11.13M19.07,12.88L13,18.94V21H15.06L21.12,14.93L19.07,12.88Z",
  },
  {
    id: "B8ACEEFF-E80A-42A9-BCAE-A804D47D8929",
    name: "folder-google-drive",
    codepoint: "F24E",
    aliases: ["folder-mydrive"],
    tags: ["Files / Folders"],
    author: "Google",
    version: "1.5.54",
    path: "M13.75,9H16.14L19,14H16.05L13.5,9.46M18.3,17H12.75L14.15,14.5H19.27L19.53,14.96M11.5,17L10.4,14.86L13.24,9.9L14.74,12.56L12.25,17M20,6H12L10,4H4C2.89,4 2,4.89 2,6V18C2,19.1 2.9,20 4,20H20C21.1,20 22,19.1 22,18V8C22,6.89 21.1,6 20,6Z",
  },
  {
    id: "726DE98D-9BA1-4E73-8632-FF3F3768A3B3",
    name: "folder-image",
    codepoint: "F24F",
    aliases: [],
    tags: ["Files / Folders"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M5,17L9.5,11L13,15.5L15.5,12.5L19,17M20,6H12L10,4H4C2.9,4 2,4.9 2,6V18C2,19.1 2.9,20 4,20H20C21.1,20 22,19.1 22,18V8C22,6.9 21.1,6 20,6Z",
  },
  {
    id: "30D99FD0-397C-49B6-A5CE-B9D6CFD7E66E",
    name: "folder-key",
    codepoint: "F8AB",
    aliases: [],
    tags: ["Files / Folders"],
    author: "Cody",
    version: "2.2.43",
    path: "M4,4C2.9,4 2,4.9 2,6V18C2,19.1 2.9,20 4,20H20C21.1,20 22,19.1 22,18V8C22,6.9 21.1,6 20,6H12L10,4M11,10C12.31,10 13.42,10.84 13.83,12H19V14H18V16H16V14H13.83C13.42,15.17 12.31,16 11,16C9.34,16 8,14.66 8,13C8,11.34 9.34,10 11,10M11,12C10.45,12 10,12.45 10,13C10,13.56 10.45,14 11,14C11.55,14 12,13.55 12,13C12,12.45 11.55,12 11,12Z",
  },
  {
    id: "0C6934F1-2CC9-4689-B388-B3F2A78E026A",
    name: "folder-key-network",
    codepoint: "F8AC",
    aliases: [],
    tags: ["Files / Folders"],
    author: "Cody",
    version: "2.2.43",
    path: "M6,4C4.89,4 4,4.89 4,6V14C4,15.1 4.9,16 6,16H11V18H10C9.45,18 9,18.45 9,19H2V21H9C9,21.55 9.45,22 10,22H14C14.55,22 15,21.55 15,21H22V19H15C15,18.45 14.55,18 14,18H13V16H18C19.1,16 20,15.1 20,14V8C20,6.9 19.1,6 18,6H12L10,4H6M9,8C10.31,8 11.42,8.83 11.83,10H17V12H16V14H14V12H11.83C11.42,13.17 10.31,14 9,14C7.34,14 6,12.66 6,11C6,9.34 7.34,8 9,8M9,10C8.45,10 8,10.45 8,11C8,11.56 8.45,12 9,12C9.55,12 10,11.55 10,11C10,10.45 9.55,10 9,10Z",
  },
  {
    id: "FABB67CE-5F69-4D45-95B9-02D7BFC9EABD",
    name: "folder-lock",
    codepoint: "F250",
    aliases: [],
    tags: ["Lock", "Files / Folders"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M20,6C21.1,6 22,6.9 22,8V18C22,19.1 21.1,20 20,20H4C2.89,20 2,19.1 2,18V6C2,4.89 2.89,4 4,4H10L12,6H20M19,17V13H18V12C18,10.34 16.66,9 15,9C13.34,9 12,10.34 12,12V13H11V17H19M15,11C15.55,11 16,11.45 16,12V13H14V12C14,11.45 14.45,11 15,11Z",
  },
  {
    id: "F89AD3B3-DD09-44F7-81A7-0433ECD44A8F",
    name: "folder-lock-open",
    codepoint: "F251",
    aliases: [],
    tags: ["Lock", "Files / Folders"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M20,6C21.1,6 22,6.9 22,8V18C22,19.1 21.1,20 20,20H4C2.89,20 2,19.1 2,18V6C2,4.89 2.89,4 4,4H10L12,6H20M19,17V13H18L16,13H14V11C14,10.45 14.45,10 15,10C15.55,10 16,10.45 16,11H18C18,9.34 16.66,8 15,8C13.34,8 12,9.34 12,11V13H11V17H19Z",
  },
  {
    id: "B7AD0302-5738-4474-9679-AC118E566A7E",
    name: "folder-move",
    codepoint: "F252",
    aliases: [],
    tags: ["Files / Folders"],
    author: "Google",
    version: "1.5.54",
    path: "M14,18V15H10V11H14V8L19,13M20,6H12L10,4H4C2.89,4 2,4.89 2,6V18C2,19.1 2.9,20 4,20H20C21.1,20 22,19.1 22,18V8C22,6.89 21.1,6 20,6Z",
  },
  {
    id: "7116841C-C243-4A44-8C68-267048AAF939",
    name: "folder-multiple",
    codepoint: "F253",
    aliases: [],
    tags: ["Files / Folders"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M22,4H14L12,2H6C4.9,2 4,2.9 4,4V16C4,17.1 4.9,18 6,18H22C23.1,18 24,17.1 24,16V6C24,4.9 23.1,4 22,4M2,6H0V11H0V20C0,21.1 0.9,22 2,22H20V20H2V6Z",
  },
  {
    id: "29BE785E-BAAB-4824-A0BF-6892D8027B1E",
    name: "folder-multiple-image",
    codepoint: "F254",
    aliases: ["perm-media"],
    tags: ["Files / Folders"],
    author: "Google",
    version: "1.5.54",
    path: "M7,15L11.5,9L15,13.5L17.5,10.5L21,15M22,4H14L12,2H6C4.9,2 4,2.9 4,4V16C4,17.1 4.9,18 6,18H22C23.1,18 24,17.1 24,16V6C24,4.9 23.1,4 22,4M2,6H0V11H0V20C0,21.1 0.9,22 2,22H20V20H2V6Z",
  },
  {
    id: "F91AD38D-33E3-46A4-83BC-17B671750D6C",
    name: "folder-multiple-outline",
    codepoint: "F255",
    aliases: [],
    tags: ["Files / Folders"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M22,4C23.1,4 24,4.9 24,6V16C24,17.1 23.1,18 22,18H6C4.9,18 4,17.1 4,16V4C4,2.9 4.9,2 6,2H12L14,4H22M2,6V20H20V22H2C0.9,22 0,21.1 0,20V11H0V6H2M6,6V16H22V6H6Z",
  },
  {
    id: "7C4EED9D-D897-4B8C-9C0B-FE9A9D820A2D",
    name: "folder-network",
    codepoint: "F86F",
    aliases: [],
    tags: ["Files / Folders"],
    author: "Cody",
    version: "2.1.99",
    path: "M3,14V4C3,2.9 3.9,2 5,2H11L13,4H19C20.1,4 21,4.9 21,6V14C21,15.1 20.1,16 19,16H13V18H14C14.55,18 15,18.45 15,19H22V21H15C15,21.55 14.55,22 14,22H10C9.45,22 9,21.55 9,21H2V19H9C9,18.45 9.45,18 10,18H11V16H5C3.9,16 3,15.1 3,14Z",
  },
  {
    id: "7BBC57AE-0EBA-4198-8B85-5082A38522DE",
    name: "folder-open",
    codepoint: "F76F",
    aliases: [],
    tags: ["Files / Folders"],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M19,20H4C2.89,20 2,19.1 2,18V6C2,4.89 2.89,4 4,4H10L12,6H19C20.1,6 21,6.9 21,8H21L4,8V18L6.14,10H23.21L20.93,18.5C20.7,19.37 19.92,20 19,20Z",
  },
  {
    id: "0524FF60-B273-4675-9B69-043730244645",
    name: "folder-outline",
    codepoint: "F256",
    aliases: ["folder-open"],
    tags: ["Files / Folders"],
    author: "Google",
    version: "1.5.54",
    path: "M20,18H4V8H20M20,6H12L10,4H4C2.89,4 2,4.89 2,6V18C2,19.1 2.9,20 4,20H20C21.1,20 22,19.1 22,18V8C22,6.89 21.1,6 20,6Z",
  },
  {
    id: "BAE32170-6509-4D1F-A6A5-A2FD1A0C679B",
    name: "folder-plus",
    codepoint: "F257",
    aliases: ["create-new-folder"],
    tags: ["Files / Folders"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M10,4L12,6H20C21.1,6 22,6.9 22,8V18C22,19.1 21.1,20 20,20H4C2.89,20 2,19.1 2,18V6C2,4.89 2.89,4 4,4H10M15,9V12H12V14H15V17H17V14H20V12H17V9H15Z",
  },
  {
    id: "3FF41316-69DC-4913-A299-84206E12FE42",
    name: "folder-remove",
    codepoint: "F258",
    aliases: [],
    tags: ["Files / Folders"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M10,4L12,6H20C21.1,6 22,6.9 22,8V18C22,19.1 21.1,20 20,20H4C2.89,20 2,19.1 2,18V6C2,4.89 2.89,4 4,4H10M12.46,10.88L14.59,13L12.46,15.12L13.88,16.54L16,14.41L18.12,16.54L19.54,15.12L17.41,13L19.54,10.88L18.12,9.46L16,11.59L13.88,9.46L12.46,10.88Z",
  },
  {
    id: "8F02F34C-2C77-43BF-BF20-5EDCA4C37A85",
    name: "folder-search",
    codepoint: "F967",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "2.4.85",
    path: "M16.5,12C19,12 21,14 21,16.5C21,17.38 20.75,18.21 20.31,18.9L23.39,22L22,23.39L18.88,20.32C18.19,20.75 17.37,21 16.5,21C14,21 12,19 12,16.5C12,14 14,12 16.5,12M16.5,14C15.12,14 14,15.12 14,16.5C14,17.88 15.12,19 16.5,19C17.88,19 19,17.88 19,16.5C19,15.12 17.88,14 16.5,14M9,4L11,6H19C20.1,6 21,6.9 21,8V11.81C19.83,10.69 18.25,10 16.5,10C12.91,10 10,12.91 10,16.5C10,17.79 10.37,19 11,20H3C1.89,20 1,19.1 1,18V6C1,4.89 1.89,4 3,4H9Z",
  },
  {
    id: "05CF7DE7-1D45-45C3-9BCC-363735A36550",
    name: "folder-search-outline",
    codepoint: "F968",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "2.4.85",
    path: "M16.5,12C19,12 21,14 21,16.5C21,17.38 20.75,18.21 20.31,18.9L23.39,22L22,23.39L18.88,20.32C18.19,20.75 17.37,21 16.5,21C14,21 12,19 12,16.5C12,14 14,12 16.5,12M16.5,14C15.12,14 14,15.12 14,16.5C14,17.88 15.12,19 16.5,19C17.88,19 19,17.88 19,16.5C19,15.12 17.88,14 16.5,14M19,8H3V18H10.17C10.34,18.72 10.63,19.39 11,20H3C1.89,20 1,19.1 1,18V6C1,4.89 1.89,4 3,4H9L11,6H19C20.1,6 21,6.9 21,8V11.81C20.42,11.26 19.75,10.81 19,10.5V8Z",
  },
  {
    id: "58C8B00C-897C-4381-9AD2-33B754B96865",
    name: "folder-star",
    codepoint: "F69C",
    aliases: ["folder-special"],
    tags: ["Files / Folders"],
    author: "Google",
    version: "1.7.12",
    path: "M20,6H12L10,4H4C2.9,4 2,4.9 2,6V18C2,19.1 2.9,20 4,20H20C21.1,20 22,19.1 22,18V8C22,6.9 21.1,6 20,6M17.94,17L15,15.28L12.06,17L12.84,13.67L10.25,11.43L13.66,11.14L15,8L16.34,11.14L19.75,11.43L17.16,13.67L17.94,17Z",
  },
  {
    id: "9F84EC25-D8C7-4BB0-B39F-E71919F4EE6D",
    name: "folder-upload",
    codepoint: "F259",
    aliases: [],
    tags: ["Files / Folders"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M20,6C21.1,6 22,6.9 22,8V18C22,19.1 21.1,20 20,20H4C2.9,20 2,19.1 2,18V6C2,4.9 2.9,4 4,4H10L12,6H20M10.75,13H14V17H16V13H19.25L15,8.75",
  },
  {
    id: "0D7EBC60-1884-41C7-B37E-E0EED68E896E",
    name: "font-awesome",
    codepoint: "F03A",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M6,3C7.38,3 8.5,4.12 8.5,5.5C8.5,6.53 7.88,7.41 7,7.79V8.66C8.11,8.36 9.72,8 11,8C12.15,8 12.89,8.22 13.54,8.42C14.13,8.6 14.65,8.75 15.5,8.75C17.13,8.75 18.4,8.18 18.54,8.11C18.68,8.04 18.84,8 19,8C19.55,8 20,8.45 20,9V17C20,17.38 19.79,17.72 19.45,17.89C19.38,17.93 17.71,18.75 15.5,18.75C14.39,18.75 13.45,18.55 12.54,18.35C11.69,18.17 10.89,18 10,18C8.85,18 7.67,18.39 7,18.66V22H5V7.79C4.12,7.41 3.5,6.53 3.5,5.5C3.5,4.12 4.62,3 6,3Z",
  },
  {
    id: "140954DE-20F5-4A8B-BFC3-DB8E49922AF3",
    name: "food",
    codepoint: "F25A",
    aliases: [],
    tags: ["Food / Drink"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M15.5,21L14,8H16.23L15.1,3.46L16.84,3L18.09,8H22L20.5,21H15.5M5,11H10C11.66,11 13,12.34 13,14H2C2,12.34 3.34,11 5,11M13,18C13,19.66 11.66,21 10,21H5C3.34,21 2,19.66 2,18H13M3,15H8L9.5,16.5L11,15H12C12.55,15 13,15.45 13,16C13,16.55 12.55,17 12,17H3C2.45,17 2,16.55 2,16C2,15.45 2.45,15 3,15Z",
  },
  {
    id: "D5B1A45F-8C43-4E3B-8E75-09EAF1984021",
    name: "food-apple",
    codepoint: "F25B",
    aliases: [],
    tags: ["Food / Drink", "Food / Drink"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M20,10C22,13 17,22 15,22C13,22 13,21 12,21C11,21 11,22 9,22C7,22 2,13 4,10C6,7 9,7 11,8V5C5.38,8.07 4.11,3.78 4.11,3.78C4.11,3.78 6.77,0.19 11,5V3H13V8C15,7 18,7 20,10Z",
  },
  {
    id: "28363B2E-72C8-481E-B702-7DE52F72717C",
    name: "food-croissant",
    codepoint: "F7C7",
    aliases: [],
    tags: ["Food / Drink"],
    author: "Alex Efremo",
    version: "2.0.46",
    path: "M22,19L19,17L22,15V19M15,15L19,9L22,13L18,16L15,15M5,17L2,19V15L5,17M9,15L6,16L2,13L5,9L9,15M14,6L18,8L13,15H11L6,8L10,6H14Z",
  },
  {
    id: "4CE93EC4-0938-4CB2-AB0E-0DCA0AF27B91",
    name: "food-fork-drink",
    codepoint: "F5F2",
    aliases: [],
    tags: ["Food / Drink"],
    author: "Google",
    version: "1.5.54",
    path: "M3,3C2.45,3 2,3.45 2,4V8L2,9.5C2,11.19 3.03,12.63 4.5,13.22V19.5C4.5,20.33 5.17,21 6,21C6.83,21 7.5,20.33 7.5,19.5V13.22C8.97,12.63 10,11.19 10,9.5V8L10,4C10,3.45 9.55,3 9,3C8.45,3 8,3.45 8,4V8C8,8.28 7.78,8.5 7.5,8.5C7.22,8.5 7,8.28 7,8V4C7,3.45 6.55,3 6,3C5.45,3 5,3.45 5,4V8C5,8.28 4.78,8.5 4.5,8.5C4.22,8.5 4,8.28 4,8V4C4,3.45 3.55,3 3,3M19.88,3C19.75,3 19.62,3.09 19.5,3.16L16,5.25V9H12V11H13L14,21H20L21,11H22V9H18V6.34L20.5,4.84C21,4.56 21.13,4 20.84,3.5C20.63,3.14 20.26,2.95 19.88,3Z",
  },
  {
    id: "3731F58E-CAEA-4B54-87A6-7F4E039F2B31",
    name: "food-off",
    codepoint: "F5F3",
    aliases: [],
    tags: ["Food / Drink"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M2,5.27L3.28,4L21,21.72L19.73,23L17.73,21H15.5L15.21,18.5L12.97,16.24C12.86,16.68 12.47,17 12,17H3C2.45,17 2,16.55 2,16C2,15.45 2.45,15 3,15H8L9.5,16.5L11,15H11.73L10.73,14H2C2,12.34 3.34,11 5,11H7.73L2,5.27M14,8H16.23L15.1,3.46L16.84,3L18.09,8H22L20.74,18.92L14.54,12.72L14,8M13,18C13,19.66 11.66,21 10,21H5C3.34,21 2,19.66 2,18H13Z",
  },
  {
    id: "1D25DDEC-2656-4729-BEBD-BB17F972DD09",
    name: "food-variant",
    codepoint: "F25C",
    aliases: [],
    tags: ["Food / Drink"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M22,18C22,20.21 20.21,22 18,22H15C12.79,22 11,20.21 11,18V16H17.79L20.55,11.23L22.11,12.13L19.87,16H22V18M9,22H2C2,19 2,16 2.33,12.83C2.6,10.3 3.08,7.66 3.6,5H3V3H4L7,3H8V5H7.4C7.92,7.66 8.4,10.3 8.67,12.83C9,16 9,19 9,22Z",
  },
  {
    id: "3C0488C6-E807-401D-9689-7770550EC2E7",
    name: "football",
    codepoint: "F25D",
    aliases: ["football-american"],
    tags: ["Sport"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M7.5,7.5C9.17,5.87 11.29,4.69 13.37,4.18C15.46,3.67 17.5,3.83 18.6,4C19.71,4.15 19.87,4.31 20.03,5.41C20.18,6.5 20.33,8.55 19.82,10.63C19.31,12.71 18.13,14.83 16.5,16.5C14.83,18.13 12.71,19.31 10.63,19.82C8.55,20.33 6.5,20.18 5.41,20.03C4.31,19.87 4.15,19.71 4,18.6C3.83,17.5 3.67,15.46 4.18,13.37C4.69,11.29 5.87,9.17 7.5,7.5M7.3,15.79L8.21,16.7L9.42,15.5L10.63,16.7L11.54,15.79L10.34,14.58L12,12.91L13.21,14.12L14.12,13.21L12.91,12L14.58,10.34L15.79,11.54L16.7,10.63L15.5,9.42L16.7,8.21L15.79,7.3L14.58,8.5L13.37,7.3L12.46,8.21L13.66,9.42L12,11.09L10.79,9.88L9.88,10.79L11.09,12L9.42,13.66L8.21,12.46L7.3,13.37L8.5,14.58L7.3,15.79Z",
  },
  {
    id: "97B1FB51-7C30-4B83-AEED-95700B38F65F",
    name: "football-australian",
    codepoint: "F25E",
    aliases: [],
    tags: ["Sport"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M7.5,7.5C9.17,5.87 11.29,4.69 13.37,4.18C18,3 21,6 19.82,10.63C19.31,12.71 18.13,14.83 16.5,16.5C14.83,18.13 12.71,19.31 10.63,19.82C6,21 3,18 4.18,13.37C4.69,11.29 5.87,9.17 7.5,7.5M10.62,11.26L10.26,11.62L12.38,13.74L12.74,13.38L10.62,11.26M11.62,10.26L11.26,10.62L13.38,12.74L13.74,12.38L11.62,10.26M9.62,12.26L9.26,12.62L11.38,14.74L11.74,14.38L9.62,12.26M12.63,9.28L12.28,9.63L14.4,11.75L14.75,11.4L12.63,9.28M8.63,13.28L8.28,13.63L10.4,15.75L10.75,15.4L8.63,13.28M13.63,8.28L13.28,8.63L15.4,10.75L15.75,10.4L13.63,8.28Z",
  },
  {
    id: "8F719D4B-9A91-46E1-81B0-00C23AA0D313",
    name: "football-helmet",
    codepoint: "F25F",
    aliases: [],
    tags: ["Sport"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M13.5,12C12.67,12 12,12.67 12,13.5C12,14.33 12.67,15 13.5,15C14.33,15 15,14.33 15,13.5C15,12.67 14.33,12 13.5,12M13.5,3C18.19,3 22,6.58 22,11C22,12.62 22,14 21.09,16C17,16 16,20 12.5,20C10.32,20 9.27,18.28 9.05,16H9L8.24,16L6.96,20.3C6.81,20.79 6.33,21.08 5.84,21H3C2.45,21 2,20.55 2,20C2,19.45 2.45,19 3,19V16C2.45,16 2,15.55 2,15C2,14.45 2.45,14 3,14H6.75L7.23,12.39C6.72,12.14 6.13,12 5.5,12H5.07L5,11C5,6.58 8.81,3 13.5,3M5,16V19H5.26L6.15,16H5Z",
  },
  {
    id: "9CB941AF-8C23-4201-B891-A23521B011CD",
    name: "forklift",
    codepoint: "F7C8",
    aliases: [],
    tags: ["Transportation + Road"],
    author: "GreenTurtwig",
    version: "2.0.46",
    path: "M6,4V11H4C2.89,11 2,11.89 2,13V17C2,18.66 3.34,20 5,20C6.66,20 8,18.66 8,17H10C10,18.66 11.34,20 13,20C14.66,20 16,18.66 16,17V13L12,4H6M17,5V19H22V17.5H18.5V5H17M7.5,5.5H11.2L14.5,13H7.5V5.5M5,15.5C5.83,15.5 6.5,16.17 6.5,17C6.5,17.83 5.83,18.5 5,18.5C4.17,18.5 3.5,17.83 3.5,17C3.5,16.17 4.17,15.5 5,15.5M13,15.5C13.83,15.5 14.5,16.17 14.5,17C14.5,17.83 13.83,18.5 13,18.5C12.17,18.5 11.5,17.83 11.5,17C11.5,16.17 12.17,15.5 13,15.5Z",
  },
  {
    id: "CF22AACF-228D-4C3A-9BE7-D5DE853A0139",
    name: "format-align-bottom",
    codepoint: "F752",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M13,9L15.5,6.5L16.92,7.92L12,12.84L7.08,7.92L8.5,6.5L11,9V3H13V9M3,15H21V17H3V15M3,19H13V21H3V19Z",
  },
  {
    id: "9B295DCA-8352-407E-84F1-34890975D010",
    name: "format-align-center",
    codepoint: "F260",
    aliases: ["format-align-centre"],
    tags: ["Text / Content / Format"],
    author: "Google",
    version: "1.5.54",
    path: "M3,3H21V5H3V3M7,7H17V9H7V7M3,11H21V13H3V11M7,15H17V17H7V15M3,19H21V21H3V19Z",
  },
  {
    id: "521B67DD-EC96-4B1D-B884-BE155D850F85",
    name: "format-align-justify",
    codepoint: "F261",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Google",
    version: "1.5.54",
    path: "M3,3H21V5H3V3M3,7H21V9H3V7M3,11H21V13H3V11M3,15H21V17H3V15M3,19H21V21H3V19Z",
  },
  {
    id: "56F0424F-3D53-486E-BC4C-0738457ACBA8",
    name: "format-align-left",
    codepoint: "F262",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Google",
    version: "1.5.54",
    path: "M3,3H21V5H3V3M3,7H15V9H3V7M3,11H21V13H3V11M3,15H15V17H3V15M3,19H21V21H3V19Z",
  },
  {
    id: "59384E78-B7EF-4BDA-B537-35E537C00130",
    name: "format-align-middle",
    codepoint: "F753",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M13,6L15,4L16.42,5.42L12,9.84L7.58,5.42L9,4L11,6V2H13V6M3,11H21V13H3V11M13,18V22H11V18L9,20L7.58,18.58L12,14.16L16.42,18.58L15,20L13,18Z",
  },
  {
    id: "7289388F-3768-4833-B282-0662FD9B9A73",
    name: "format-align-right",
    codepoint: "F263",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Google",
    version: "1.5.54",
    path: "M3,3H21V5H3V3M9,7H21V9H9V7M3,11H21V13H3V11M9,15H21V17H9V15M3,19H21V21H3V19Z",
  },
  {
    id: "71140AD8-A0A6-45DD-9414-5DB2FBC875F1",
    name: "format-align-top",
    codepoint: "F754",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M13,15L15.5,17.5L16.92,16.08L12,11.16L7.08,16.08L8.5,17.5L11,15V21H13V15M3,3H21V5H3V3M3,7H13V9H3V7Z",
  },
  {
    id: "591A45AB-511C-4791-957C-303186C666AA",
    name: "format-annotation-plus",
    codepoint: "F646",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Kai Faust",
    version: "1.6.50",
    path: "M8.5,7H10.5L16,21H13.6L12.5,18H6.3L5.2,21H3L8.5,7M7.1,16H11.9L9.5,9.7L7.1,16M22,5V7H19V10H17V7H14V5H17V2H19V5H22Z",
  },
  {
    id: "2107C153-0FEC-4171-8602-6549ACABA768",
    name: "format-bold",
    codepoint: "F264",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Google",
    version: "1.5.54",
    path: "M13.5,15.5H10V12.5H13.5C14.33,12.5 15,13.17 15,14C15,14.83 14.33,15.5 13.5,15.5M10,6.5H13C13.83,6.5 14.5,7.17 14.5,8C14.5,8.83 13.83,9.5 13,9.5H10M15.6,10.79C16.57,10.11 17.25,9 17.25,8C17.25,5.74 15.5,4 13.25,4H7V18H14.04C16.14,18 17.75,16.3 17.75,14.21C17.75,12.69 16.89,11.39 15.6,10.79Z",
  },
  {
    id: "D5213C5D-AC53-40A5-BBCC-C8B3F849D6B4",
    name: "format-clear",
    codepoint: "F265",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Google",
    version: "1.5.54",
    path: "M6,5V5.18L8.82,8H11.22L10.5,9.68L12.6,11.78L14.21,8H20V5H6M3.27,5L2,6.27L8.97,13.24L6.5,19H9.5L11.07,15.34L16.73,21L18,19.73L3.55,5.27L3.27,5Z",
  },
  {
    id: "C4E2DE69-EC92-490F-814A-5D8A20E7E595",
    name: "format-color-fill",
    codepoint: "F266",
    aliases: ["format-colour-fill"],
    tags: ["Text / Content / Format", "Color"],
    author: "Google",
    version: "1.5.54",
    path: "M19,11.5C19,11.5 17,13.67 17,15C17,16.1 17.9,17 19,17C20.1,17 21,16.1 21,15C21,13.67 19,11.5 19,11.5M5.21,10L10,5.21L14.79,10M16.56,8.94L7.62,0L6.21,1.41L8.59,3.79L3.44,8.94C2.85,9.5 2.85,10.47 3.44,11.06L8.94,16.56C9.23,16.85 9.62,17 10,17C10.38,17 10.77,16.85 11.06,16.56L16.56,11.06C17.15,10.47 17.15,9.5 16.56,8.94Z",
  },
  {
    id: "D28EF658-3CE7-4F5B-99B3-50F60F5B0BA0",
    name: "format-color-text",
    codepoint: "F69D",
    aliases: ["format-colour-text"],
    tags: ["Text / Content / Format", "Color"],
    author: "Google",
    version: "1.7.12",
    path: "M9.62,12L12,5.67L14.37,12M11,3L5.5,17H7.75L8.87,14H15.12L16.25,17H18.5L13,3H11Z",
  },
  {
    id: "FB93EA15-A9E8-432C-BC34-419DDCE44E3B",
    name: "format-columns",
    codepoint: "F8DE",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Peter Noble",
    version: "2.3.50",
    path: "M3,3H11V5H3V3M13,3H21V5H13V3M3,7H11V9H3V7M13,7H21V9H13V7M3,11H11V13H3V11M13,11H21V13H13V11M3,15H11V17H3V15M13,15H21V17H13V15M3,19H11V21H3V19M13,19H21V21H13V19Z",
  },
  {
    id: "3BC78F10-A7C3-4F15-9328-138E35CFC259",
    name: "format-float-center",
    codepoint: "F267",
    aliases: ["format-float-centre"],
    tags: ["Text / Content / Format"],
    author: "Andreas Gohr",
    version: "1.5.54",
    path: "M9,7H15V13H9V7M3,3H21V5H3V3M3,15H21V17H3V15M3,19H17V21H3V19Z",
  },
  {
    id: "E595D32A-5108-4E9A-BF98-52DEFC1A50EE",
    name: "format-float-left",
    codepoint: "F268",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Andreas Gohr",
    version: "1.5.54",
    path: "M3,7H9V13H3V7M3,3H21V5H3V3M21,7V9H11V7H21M21,11V13H11V11H21M3,15H17V17H3V15M3,19H21V21H3V19Z",
  },
  {
    id: "22DE1517-7E6C-43B9-B0E1-F3EDAEFE6398",
    name: "format-float-none",
    codepoint: "F269",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Andreas Gohr",
    version: "1.5.54",
    path: "M3,7H9V13H3V7M3,3H21V5H3V3M21,11V13H11V11H21M3,15H17V17H3V15M3,19H21V21H3V19Z",
  },
  {
    id: "8F5AF64B-3A3D-449C-9FCC-374EAF6D523C",
    name: "format-float-right",
    codepoint: "F26A",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Andreas Gohr",
    version: "1.5.54",
    path: "M15,7H21V13H15V7M3,3H21V5H3V3M13,7V9H3V7H13M9,11V13H3V11H9M3,15H17V17H3V15M3,19H21V21H3V19Z",
  },
  {
    id: "C7D57EF8-207C-48F9-953A-EAFB03308A1E",
    name: "format-font",
    codepoint: "F6D5",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "JapanYoshi",
    version: "1.8.36",
    path: "M17,8H20V20H21V21H17V20H18V17H14L12.5,20H14V21H10V20H11L17,8M18,9L14.5,16H18V9M5,3H10C11.11,3 12,3.89 12,5V16H9V11H6V16H3V5C3,3.89 3.89,3 5,3M6,5V9H9V5H6Z",
  },
  {
    id: "4FA696A5-8843-4E3F-B9BF-5BCF5B6C4D2C",
    name: "format-font-size-decrease",
    codepoint: "F9F2",
    aliases: [],
    tags: [],
    author: "Michael Irigoyen",
    version: "2.5.94",
    path: "M5.12,14L7.5,7.67L9.87,14M6.5,5L1,19H3.25L4.37,16H10.62L11.75,19H14L8.5,5H6.5M18,17L23,11.93L21.59,10.5L19,13.1V7H17V13.1L14.41,10.5L13,11.93L18,17Z",
  },
  {
    id: "934DCE7F-D2A8-40F5-B945-A35DBD3F207B",
    name: "format-font-size-increase",
    codepoint: "F9F3",
    aliases: [],
    tags: [],
    author: "Michael Irigoyen",
    version: "2.5.94",
    path: "M5.12,14L7.5,7.67L9.87,14M6.5,5L1,19H3.25L4.37,16H10.62L11.75,19H14L8.5,5H6.5M18,7L13,12.07L14.41,13.5L17,10.9V17H19V10.9L21.59,13.5L23,12.07L18,7Z",
  },
  {
    id: "F64E046B-8690-4ACF-90F7-98896159BB34",
    name: "format-header-1",
    codepoint: "F26B",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M3,4H5V10H9V4H11V18H9V12H5V18H3V4M14,18V16H16V6.31L13.5,7.75V5.44L16,4H18V16H20V18H14Z",
  },
  {
    id: "00E2A358-A6A9-493C-BFC2-A259AA0092CF",
    name: "format-header-2",
    codepoint: "F26C",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M3,4H5V10H9V4H11V18H9V12H5V18H3V4M21,18H15C13.9,18 13,17.1 13,16C13,15.47 13.2,15 13.54,14.64L18.41,9.41C18.78,9.05 19,8.55 19,8C19,6.9 18.1,6 17,6C15.9,6 15,6.9 15,8H13C13,5.79 14.79,4 17,4C19.21,4 21,5.79 21,8C21,9.1 20.55,10.1 19.83,10.83L15,16H21V18Z",
  },
  {
    id: "EE76BE9D-B10D-43C8-9B5A-746BE228C344",
    name: "format-header-3",
    codepoint: "F26D",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M3,4H5V10H9V4H11V18H9V12H5V18H3V4M15,4H19C20.1,4 21,4.9 21,6V16C21,17.1 20.1,18 19,18H15C13.9,18 13,17.1 13,16V15H15V16H19V12H15V10H19V6H15V7H13V6C13,4.9 13.9,4 15,4Z",
  },
  {
    id: "CC669D6C-53AD-43C2-A660-EFF783847D6F",
    name: "format-header-4",
    codepoint: "F26E",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M3,4H5V10H9V4H11V18H9V12H5V18H3V4M18,18V13H13V11L18,4H20V11H21V13H20V18H18M18,11V7.42L15.45,11H18Z",
  },
  {
    id: "FFC1FF08-CEFF-4623-B715-4731CDEF27D4",
    name: "format-header-5",
    codepoint: "F26F",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M3,4H5V10H9V4H11V18H9V12H5V18H3V4M15,4H20V6H15V10H17C19.21,10 21,11.79 21,14C21,16.21 19.21,18 17,18H15C13.9,18 13,17.1 13,16V15H15V16H17C18.1,16 19,15.1 19,14C19,12.9 18.1,12 17,12H15C13.9,12 13,11.1 13,10V6C13,4.9 13.9,4 15,4Z",
  },
  {
    id: "854D0158-05E0-47A7-8E6E-2F66DCD415EE",
    name: "format-header-6",
    codepoint: "F270",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M3,4H5V10H9V4H11V18H9V12H5V18H3V4M15,4H19C20.1,4 21,4.9 21,6V7H19V6H15V10H19C20.1,10 21,10.9 21,12V16C21,17.1 20.1,18 19,18H15C13.9,18 13,17.1 13,16V6C13,4.9 13.9,4 15,4M15,12V16H19V12H15Z",
  },
  {
    id: "CF17BB12-9537-4F2E-9E88-3E1DE3D0DCE6",
    name: "format-header-decrease",
    codepoint: "F271",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Andreas Gohr",
    version: "1.5.54",
    path: "M4,4H6V10H10V4H12V18H10V12H6V18H4V4M20.42,7.41L16.83,11L20.42,14.59L19,16L14,11L19,6L20.42,7.41Z",
  },
  {
    id: "99554AA1-419F-420F-9AEB-0826D411B420",
    name: "format-header-equal",
    codepoint: "F272",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Andreas Gohr",
    version: "1.5.54",
    path: "M4,4H6V10H10V4H12V18H10V12H6V18H4V4M14,10V8H21V10H14M14,12H21V14H14V12Z",
  },
  {
    id: "20BCC8DA-F055-46B0-9C27-68791E3BA80E",
    name: "format-header-increase",
    codepoint: "F273",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Andreas Gohr",
    version: "1.5.54",
    path: "M4,4H6V10H10V4H12V18H10V12H6V18H4V4M14.59,7.41L18.17,11L14.59,14.59L16,16L21,11L16,6L14.59,7.41Z",
  },
  {
    id: "C632F7EE-B560-4FAA-802E-968DAB3EA979",
    name: "format-header-pound",
    codepoint: "F274",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M3,4H5V10H9V4H11V18H9V12H5V18H3V4M13,8H15.31L15.63,5H17.63L17.31,8H19.31L19.63,5H21.63L21.31,8H23V10H21.1L20.9,12H23V14H20.69L20.37,17H18.37L18.69,14H16.69L16.37,17H14.37L14.69,14H13V12H14.9L15.1,10H13V8M17.1,10L16.9,12H18.9L19.1,10H17.1Z",
  },
  {
    id: "83EE24A9-9D1A-45AA-B4CD-F75F1174F0EB",
    name: "format-horizontal-align-center",
    codepoint: "F61E",
    aliases: ["format-horizontal-align-centre"],
    tags: ["Text / Content / Format"],
    author: "Austin Andrews",
    version: "1.6.50",
    path: "M19,16V13H23V11H19V8L15,12L19,16M5,8V11H1V13H5V16L9,12L5,8M11,20H13V4H11V20Z",
  },
  {
    id: "AEA5545F-4C74-4A14-8F9E-92CC258216AD",
    name: "format-horizontal-align-left",
    codepoint: "F61F",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Austin Andrews",
    version: "1.6.50",
    path: "M11,16V13H21V11H11V8L7,12L11,16M3,20H5V4H3V20Z",
  },
  {
    id: "7EFCB642-F9B5-41C8-B2CF-2566C6AC45C2",
    name: "format-horizontal-align-right",
    codepoint: "F620",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Austin Andrews",
    version: "1.6.50",
    path: "M13,8V11H3V13H13V16L17,12L13,8M19,20H21V4H19V20Z",
  },
  {
    id: "148FD97C-E3C6-4E41-87B8-488036159CC6",
    name: "format-indent-decrease",
    codepoint: "F275",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Google",
    version: "1.5.54",
    path: "M11,13H21V11H11M11,9H21V7H11M3,3V5H21V3M3,21H21V19H3M3,12L7,16V8M11,17H21V15H11V17Z",
  },
  {
    id: "18B9F49B-7A69-4E93-AEA6-8CB30F22E100",
    name: "format-indent-increase",
    codepoint: "F276",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Google",
    version: "1.5.54",
    path: "M11,13H21V11H11M11,9H21V7H11M3,3V5H21V3M11,17H21V15H11M3,8V16L7,12M3,21H21V19H3V21Z",
  },
  {
    id: "F766C5E3-1BBB-4ADE-9D33-170A223DB6F9",
    name: "format-italic",
    codepoint: "F277",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Google",
    version: "1.5.54",
    path: "M10,4V7H12.21L8.79,15H6V18H14V15H11.79L15.21,7H18V4H10Z",
  },
  {
    id: "24F69EED-721D-48A1-BA3C-3C1657B65C04",
    name: "format-line-spacing",
    codepoint: "F278",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Google",
    version: "1.5.54",
    path: "M10,13H22V11H10M10,19H22V17H10M10,7H22V5H10M6,7H8.5L5,3.5L1.5,7H4V17H1.5L5,20.5L8.5,17H6V7Z",
  },
  {
    id: "2E9CEB4F-7C1F-4572-9A8E-830A3258407A",
    name: "format-line-style",
    codepoint: "F5C8",
    aliases: [],
    tags: ["Text / Content / Format", "Drawing / Art"],
    author: "Google",
    version: "1.5.54",
    path: "M3,16H8V14H3V16M9.5,16H14.5V14H9.5V16M16,16H21V14H16V16M3,20H5V18H3V20M7,20H9V18H7V20M11,20H13V18H11V20M15,20H17V18H15V20M19,20H21V18H19V20M3,12H11V10H3V12M13,12H21V10H13V12M3,4V8H21V4H3Z",
  },
  {
    id: "1BA8A6A0-348E-4268-B02B-6708E1E30373",
    name: "format-line-weight",
    codepoint: "F5C9",
    aliases: [],
    tags: ["Text / Content / Format", "Drawing / Art"],
    author: "Google",
    version: "1.5.54",
    path: "M3,17H21V15H3V17M3,20H21V19H3V20M3,13H21V10H3V13M3,4V8H21V4H3Z",
  },
  {
    id: "2FBAE8A7-BAC7-44C8-85DC-EB458871BF29",
    name: "format-list-bulleted",
    codepoint: "F279",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Google",
    version: "1.5.54",
    path: "M7,5H21V7H7V5M7,13V11H21V13H7M4,4.5C4.83,4.5 5.5,5.17 5.5,6C5.5,6.83 4.83,7.5 4,7.5C3.17,7.5 2.5,6.83 2.5,6C2.5,5.17 3.17,4.5 4,4.5M4,10.5C4.83,10.5 5.5,11.17 5.5,12C5.5,12.83 4.83,13.5 4,13.5C3.17,13.5 2.5,12.83 2.5,12C2.5,11.17 3.17,10.5 4,10.5M7,19V17H21V19H7M4,16.5C4.83,16.5 5.5,17.17 5.5,18C5.5,18.83 4.83,19.5 4,19.5C3.17,19.5 2.5,18.83 2.5,18C2.5,17.17 3.17,16.5 4,16.5Z",
  },
  {
    id: "535ABAF7-65D8-4CAB-A3B0-D5B732B6C36F",
    name: "format-list-bulleted-type",
    codepoint: "F27A",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M5,9.5L7.5,14H2.5L5,9.5M3,4H7V8H3V4M5,20C6.1,20 7,19.1 7,18C7,16.9 6.1,16 5,16C3.9,16 3,16.9 3,18C3,19.1 3.9,20 5,20M9,5V7H21V5H9M9,19H21V17H9V19M9,13H21V11H9V13Z",
  },
  {
    id: "45A8DC8E-AD79-4205-AC8B-4BCC17B6F465",
    name: "format-list-checkbox",
    codepoint: "F969",
    aliases: [],
    tags: [],
    author: "Google",
    version: "2.4.85",
    path: "M21,19V17H8V19H21M21,13V11H8V13H21M8,7H21V5H8V7M4,5V7H6V5H4M3,5C3,4.45 3.45,4 4,4H6C6.55,4 7,4.45 7,5V7C7,7.55 6.55,8 6,8H4C3.45,8 3,7.55 3,7V5M4,11V13H6V11H4M3,11C3,10.45 3.45,10 4,10H6C6.55,10 7,10.45 7,11V13C7,13.55 6.55,14 6,14H4C3.45,14 3,13.55 3,13V11M4,17V19H6V17H4M3,17C3,16.45 3.45,16 4,16H6C6.55,16 7,16.45 7,17V19C7,19.55 6.55,20 6,20H4C3.45,20 3,19.55 3,19V17Z",
  },
  {
    id: "2B19EECF-71BF-41F3-B62A-468607BA0B47",
    name: "format-list-checks",
    codepoint: "F755",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M3,5H9V11H3V5M5,7V9H7V7H5M11,7H21V9H11V7M11,15H21V17H11V15M5,20L1.5,16.5L2.91,15.09L5,17.17L9.59,12.59L11,14L5,20Z",
  },
  {
    id: "4C2390EF-6AE7-4868-945B-AACD2E581F46",
    name: "format-page-break",
    codepoint: "F6D6",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Google",
    version: "1.8.36",
    path: "M18,20H6V18H4V20C4,21.1 4.9,22 6,22H18C19.1,22 20,21.1 20,20V18H18V20M14,2H6C4.9,2 4,2.9 4,4V12H6V4H14V8H18V12H20V8L14,2M11,16H8V14H11V16M16,16H13V14H16V16M3,14H6V16H3V14M21,16H18V14H21V16Z",
  },
  {
    id: "70232BC6-D883-48CD-B992-9EE1DABEBFD7",
    name: "format-paint",
    codepoint: "F27C",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Google",
    version: "1.5.54",
    path: "M18,4V3C18,2.45 17.55,2 17,2H5C4.45,2 4,2.45 4,3V7C4,7.55 4.45,8 5,8H17C17.55,8 18,7.55 18,7V6H19V10H9V21C9,21.55 9.45,22 10,22H12C12.55,22 13,21.55 13,21V12H21V4H18Z",
  },
  {
    id: "252574CE-020B-461A-995B-D4BA81741BBC",
    name: "format-paragraph",
    codepoint: "F27D",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M13,4C15.21,4 17,5.79 17,8C17,10.21 15.21,12 13,12H11V18H9V4H13M13,10C14.1,10 15,9.1 15,8C15,6.9 14.1,6 13,6H11V10H13Z",
  },
  {
    id: "9AF465C3-5FEF-48E4-8D38-5A5A3D2A9799",
    name: "format-pilcrow",
    codepoint: "F6D7",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Michael Richins",
    version: "1.8.36",
    path: "M10,11C7.79,11 6,9.21 6,7C6,4.79 7.79,3 10,3H18V5H16V21H14V5H12V21H10V11Z",
  },
  {
    id: "0450C081-EE6B-4CB1-A7F7-B6F0F524CA99",
    name: "format-quote-close",
    codepoint: "F27E",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Google",
    version: "1.5.54",
    path: "M14,17H17L19,13V7H13V13H16M6,17H9L11,13V7H5V13H8L6,17Z",
  },
  {
    id: "CF5D126B-7DC1-4BE7-B5A1-E31B715EDBAA",
    name: "format-quote-open",
    codepoint: "F756",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M10,7L8,11H11V17H5V11L7,7H10M18,7L16,11H19V17H13V11L15,7H18Z",
  },
  {
    id: "99448D5B-50D3-4F49-8E88-DD75F7DFB231",
    name: "format-rotate-90",
    codepoint: "F6A9",
    aliases: ["rotate-90-degrees-ccw", "format-rotate-ninety"],
    tags: ["Text / Content / Format"],
    author: "Google",
    version: "1.7.12",
    path: "M7.34,6.41L0.86,12.9L7.35,19.38L13.84,12.9L7.34,6.41M3.69,12.9L7.35,9.24L11,12.9L7.34,16.56L3.69,12.9M19.36,6.64C17.61,4.88 15.3,4 13,4V0.76L8.76,5L13,9.24V6C14.79,6 16.58,6.68 17.95,8.05C20.68,10.78 20.68,15.22 17.95,17.95C16.58,19.32 14.79,20 13,20C12.03,20 11.06,19.79 10.16,19.39L8.67,20.88C10,21.62 11.5,22 13,22C15.3,22 17.61,21.12 19.36,19.36C22.88,15.85 22.88,10.15 19.36,6.64Z",
  },
  {
    id: "6F0198AB-0903-4B36-AC27-B72EBC7A8A83",
    name: "format-section",
    codepoint: "F69E",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Michael Richins",
    version: "1.7.12",
    path: "M15.67,4.42C14.7,3.84 13.58,3.54 12.45,3.56C10.87,3.56 9.66,4.34 9.66,5.56C9.66,6.96 11,7.47 13,8.14C15.5,8.95 17.4,9.97 17.4,12.38C17.36,13.69 16.69,14.89 15.6,15.61C16.25,16.22 16.61,17.08 16.6,17.97C16.6,20.79 14,21.97 11.5,21.97C10.04,22.03 8.59,21.64 7.35,20.87L8,19.34C9.04,20.05 10.27,20.43 11.53,20.44C13.25,20.44 14.53,19.66 14.53,18.24C14.53,17 13.75,16.31 11.25,15.45C8.5,14.5 6.6,13.5 6.6,11.21C6.67,9.89 7.43,8.69 8.6,8.07C7.97,7.5 7.61,6.67 7.6,5.81C7.6,3.45 9.77,2 12.53,2C13.82,2 15.09,2.29 16.23,2.89L15.67,4.42M11.35,13.42C12.41,13.75 13.44,14.18 14.41,14.71C15.06,14.22 15.43,13.45 15.41,12.64C15.41,11.64 14.77,10.76 13,10.14C11.89,9.77 10.78,9.31 9.72,8.77C8.97,9.22 8.5,10.03 8.5,10.91C8.5,11.88 9.23,12.68 11.35,13.42Z",
  },
  {
    id: "3F6E54F6-CF3E-46C8-BD72-A9BCF6DCF80C",
    name: "format-size",
    codepoint: "F27F",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Google",
    version: "1.5.54",
    path: "M3,12H6V19H9V12H12V9H3M9,4V7H14V19H17V7H22V4H9Z",
  },
  {
    id: "0BE83BB5-3D22-478D-AAC2-F586A4E5FA69",
    name: "format-strikethrough",
    codepoint: "F280",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Google",
    version: "1.5.54",
    path: "M3,14H21V12H3M5,4V7H10V10H14V7H19V4M10,19H14V16H10V19Z",
  },
  {
    id: "CB728339-FA66-440F-9E88-8A6FFE827EA1",
    name: "format-strikethrough-variant",
    codepoint: "F281",
    aliases: ["strikethrough-s"],
    tags: ["Text / Content / Format"],
    author: "Google",
    version: "1.5.54",
    path: "M23,12V14H18.61C19.61,16.14 19.56,22 12.38,22C4.05,22.05 4.37,15.5 4.37,15.5L8.34,15.55C8.37,18.92 11.5,18.92 12.12,18.88C12.76,18.83 15.15,18.84 15.34,16.5C15.42,15.41 14.32,14.58 13.12,14H1V12H23M19.41,7.89L15.43,7.86C15.43,7.86 15.6,5.09 12.15,5.08C8.7,5.06 9,7.28 9,7.56C9.04,7.84 9.34,9.22 12,9.88H5.71C5.71,9.88 2.22,3.15 10.74,2C19.45,0.8 19.43,7.91 19.41,7.89Z",
  },
  {
    id: "4765CE92-9095-4C00-9137-1C35761C7B59",
    name: "format-subscript",
    codepoint: "F282",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M16,7.41L11.41,12L16,16.59L14.59,18L10,13.41L5.41,18L4,16.59L8.59,12L4,7.41L5.41,6L10,10.59L14.59,6L16,7.41M21.85,21.03H16.97V20.03L17.86,19.23C18.62,18.58 19.18,18.04 19.56,17.6C19.93,17.16 20.12,16.75 20.13,16.36C20.14,16.08 20.05,15.85 19.86,15.66C19.68,15.5 19.39,15.38 19,15.38C18.69,15.38 18.42,15.44 18.16,15.56L17.5,15.94L17.05,14.77C17.32,14.56 17.64,14.38 18.03,14.24C18.42,14.1 18.85,14 19.32,14C20.1,14.04 20.7,14.25 21.1,14.66C21.5,15.07 21.72,15.59 21.72,16.23C21.71,16.79 21.53,17.31 21.18,17.78C20.84,18.25 20.42,18.7 19.91,19.14L19.27,19.66V19.68H21.85V21.03Z",
  },
  {
    id: "41BF2594-97C2-481A-AA66-029CE1BF4C2D",
    name: "format-superscript",
    codepoint: "F283",
    aliases: ["exponent"],
    tags: ["Text / Content / Format", "Math"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M16,7.41L11.41,12L16,16.59L14.59,18L10,13.41L5.41,18L4,16.59L8.59,12L4,7.41L5.41,6L10,10.59L14.59,6L16,7.41M21.85,9H16.97V8L17.86,7.18C18.62,6.54 19.18,6 19.56,5.55C19.93,5.11 20.12,4.7 20.13,4.32C20.14,4.04 20.05,3.8 19.86,3.62C19.68,3.43 19.39,3.34 19,3.33C18.69,3.34 18.42,3.4 18.16,3.5L17.5,3.89L17.05,2.72C17.32,2.5 17.64,2.33 18.03,2.19C18.42,2.05 18.85,2 19.32,2C20.1,2 20.7,2.2 21.1,2.61C21.5,3 21.72,3.54 21.72,4.18C21.71,4.74 21.53,5.26 21.18,5.73C20.84,6.21 20.42,6.66 19.91,7.09L19.27,7.61V7.63H21.85V9Z",
  },
  {
    id: "FE7F03F1-79D3-4113-A35E-088C3F2AB8AD",
    name: "format-text",
    codepoint: "F284",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M18.5,4L19.66,8.35L18.7,8.61C18.25,7.74 17.79,6.87 17.26,6.43C16.73,6 16.11,6 15.5,6H13V16.5C13,17 13,17.5 13.33,17.75C13.67,18 14.33,18 15,18V19H9V18C9.67,18 10.33,18 10.67,17.75C11,17.5 11,17 11,16.5V6H8.5C7.89,6 7.27,6 6.74,6.43C6.21,6.87 5.75,7.74 5.3,8.61L4.34,8.35L5.5,4H18.5Z",
  },
  {
    id: "D6B79C3B-22FB-4B52-90B8-6979AB48C3E8",
    name: "format-textdirection-l-to-r",
    codepoint: "F285",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Google",
    version: "1.5.54",
    path: "M21,18L17,14V17H5V19H17V22M9,10V15H11V4H13V15H15V4H17V2H9C6.79,2 5,3.79 5,6C5,8.21 6.79,10 9,10Z",
  },
  {
    id: "C317FCCF-DCDB-4429-B1A7-850FED29F5B3",
    name: "format-textdirection-r-to-l",
    codepoint: "F286",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Google",
    version: "1.5.54",
    path: "M8,17V14L4,18L8,22V19H20V17M10,10V15H12V4H14V15H16V4H18V2H10C7.79,2 6,3.79 6,6C6,8.21 7.79,10 10,10Z",
  },
  {
    id: "4B4B86CC-C989-4629-9B9D-C31243A29DB9",
    name: "format-title",
    codepoint: "F5F4",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Google",
    version: "1.5.54",
    path: "M5,4V7H10.5V19H13.5V7H19V4H5Z",
  },
  {
    id: "DD218F3D-C302-477A-9B9F-482813328DE6",
    name: "format-underline",
    codepoint: "F287",
    aliases: ["format-underlined"],
    tags: ["Text / Content / Format"],
    author: "Google",
    version: "1.5.54",
    path: "M5,21H19V19H5V21M12,17C15.31,17 18,14.31 18,11V3H15.5V11C15.5,12.93 13.93,14.5 12,14.5C10.07,14.5 8.5,12.93 8.5,11V3H6V11C6,14.31 8.69,17 12,17Z",
  },
  {
    id: "723F4461-61B3-4D53-A03D-302F5D9401E1",
    name: "format-vertical-align-bottom",
    codepoint: "F621",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Google",
    version: "1.6.50",
    path: "M16,13H13V3H11V13H8L12,17L16,13M4,19V21H20V19H4Z",
  },
  {
    id: "4C8985BA-B48F-4015-9389-35672ECDE544",
    name: "format-vertical-align-center",
    codepoint: "F622",
    aliases: ["format-vertical-align-centre"],
    tags: ["Text / Content / Format"],
    author: "Google",
    version: "1.6.50",
    path: "M8,19H11V23H13V19H16L12,15L8,19M16,5H13V1H11V5H8L12,9L16,5M4,11V13H20V11H4Z",
  },
  {
    id: "06A3A04F-F7F7-4707-86FC-5DEBA497B79E",
    name: "format-vertical-align-top",
    codepoint: "F623",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Google",
    version: "1.6.50",
    path: "M8,11H11V21H13V11H16L12,7L8,11M4,3V5H20V3H4Z",
  },
  {
    id: "556AFB1F-1857-4CB9-94B8-2E7E8A8DD292",
    name: "format-wrap-inline",
    codepoint: "F288",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Andreas Gohr",
    version: "1.5.54",
    path: "M8,7L13,17H3L8,7M3,3H21V5H3V3M21,15V17H14V15H21M3,19H21V21H3V19Z",
  },
  {
    id: "D5787449-1950-4A7C-8CD9-CABC628AFBCE",
    name: "format-wrap-square",
    codepoint: "F289",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Andreas Gohr",
    version: "1.5.54",
    path: "M12,7L17,17H7L12,7M3,3H21V5H3V3M3,7H6V9H3V7M21,7V9H18V7H21M3,11H6V13H3V11M21,11V13H18V11H21M3,15H6V17H3V15M21,15V17H18V15H21M3,19H21V21H3V19Z",
  },
  {
    id: "4AA96763-2A6C-4BF0-BA64-32AD08B530F6",
    name: "format-wrap-tight",
    codepoint: "F28A",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Andreas Gohr",
    version: "1.5.54",
    path: "M12,7L17,17H7L12,7M3,3H21V5H3V3M3,7H9V9H3V7M21,7V9H15V7H21M3,11H7V13H3V11M21,11V13H17V11H21M3,15H6V17H3V15M21,15V17H18V15H21M3,19H21V21H3V19Z",
  },
  {
    id: "0378C7CD-8331-42A0-9C0F-114960FD5966",
    name: "format-wrap-top-bottom",
    codepoint: "F28B",
    aliases: [],
    tags: ["Text / Content / Format"],
    author: "Andreas Gohr",
    version: "1.5.54",
    path: "M12,7L17,17H7L12,7M3,3H21V5H3V3M3,19H21V21H3V19Z",
  },
  {
    id: "3AC84477-2308-4445-868C-9666AE25B054",
    name: "forum",
    codepoint: "F28C",
    aliases: ["message-group", "question-answer"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M17,12V3C17,2.45 16.55,2 16,2H3C2.45,2 2,2.45 2,3V17L6,13H16C16.55,13 17,12.55 17,12M21,6H19V15H6V17C6,17.55 6.45,18 7,18H18L22,22V7C22,6.45 21.55,6 21,6Z",
  },
  {
    id: "E6469D88-74CE-4242-8226-85BB8F8EFFB0",
    name: "forum-outline",
    codepoint: "F821",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "2.1.19",
    path: "M4,2C2.9,2 2,2.9 2,4V17L6,13H15C16.1,13 17,12.1 17,11V4C17,2.9 16.1,2 15,2H4M4,4H15V11H6L4,13V4M19,6V8H20V18L18,16H8V15H6V16C6,17.1 6.9,18 8,18H18L22,22V8C22,6.9 21.1,6 20,6H19Z",
  },
  {
    id: "EAE07425-A6D5-4B33-A9C5-6D7E9E9E1908",
    name: "forward",
    codepoint: "F28D",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M12,8V4L20,12L12,20V16H4V8H12Z",
  },
  {
    id: "9267CA84-62FD-4346-BCA8-42B4617CCB43",
    name: "fountain",
    codepoint: "F96A",
    aliases: [],
    tags: [],
    author: "Augustin Ursu",
    version: "2.4.85",
    path: "M7.5,2C4.47,2 2,4.46 2,7.5V7.5L2,8H4V7.5C4,5.57 5.57,4 7.5,4C9,4 10.26,4.93 10.76,6.24C10.37,6.08 9.95,6 9.5,6C8.11,6 6.9,6.82 6.34,8L8.08,9C8.29,8.42 8.85,8 9.5,8C10.33,8 11,8.67 11,9.5V11H13V9.5C13,8.67 13.67,8 14.5,8C15.16,8 15.71,8.42 15.92,9L17.66,8C17.1,6.82 15.9,6 14.5,6C14.05,6 13.63,6.08 13.24,6.24C13.74,4.93 15,4 16.5,4C18.43,4 20,5.57 20,7.5V8H22V7.5H22C22,4.46 19.54,2 16.5,2C14.64,2 13,2.93 12,4.34C11,2.93 9.36,2 7.5,2M6,12V14H7.42C7.92,15.15 8.85,16.07 10,16.57C10,17.38 10,18.19 10,19H2C2,19 2.82,20.23 3.41,21.11C3.78,21.67 4.4,22 5.07,22H18.93C19.6,22 20.22,21.67 20.59,21.11L22,19H14C14,18.19 14,17.38 14,16.57C15.15,16.07 16.08,15.15 16.58,14H18V12H6Z",
  },
  {
    id: "54CA035A-3BAB-4349-8FD1-D50A1990D301",
    name: "freebsd",
    codepoint: "F8DF",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Contributors",
    version: "2.3.50",
    path: "M2.69,2C3.54,1.95 6.08,3.16 6.13,3.19C4.84,4 3.74,5.09 2.91,6.38C2.09,4.81 1.34,2.91 2,2.25C2.17,2.08 2.4,2 2.69,2M20.84,2.13C21.25,2.08 21.58,2.14 21.78,2.34C22.85,3.42 19.88,8.15 19.38,8.66C18.87,9.16 17.57,8.7 16.5,7.63C15.43,6.55 14.97,5.26 15.47,4.75C15.88,4.34 19.09,2.3 20.84,2.13M12,2.56C13.29,2.56 14.53,2.82 15.66,3.28C15.17,3.6 14.81,3.85 14.69,3.97C13.7,4.96 14.14,6.83 15.72,8.41C16.7,9.38 17.84,9.97 18.78,9.97C19.46,9.97 19.92,9.68 20.16,9.44C20.33,9.27 20.6,8.88 20.91,8.41C21.42,9.59 21.69,10.88 21.69,12.25C21.69,17.61 17.36,21.97 12,21.97C6.64,21.97 2.31,17.61 2.31,12.25C2.31,6.89 6.64,2.56 12,2.56Z",
  },
  {
    id: "214668FF-C50D-4D69-B916-AE66E73CB3B0",
    name: "fridge",
    codepoint: "F28F",
    aliases: ["kitchen", "refrigerator"],
    tags: ["Home Automation"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M9,21V22H7V21C5.9,21 5,20.1 5,19V4C5,2.9 5.9,2 7,2H17C18.1,2 19,2.9 19,4V19C19,20.1 18.1,21 17,21V22H15V21H9M7,4V9H17V4H7M7,19H17V11H7V19M8,12H10V15H8V12M8,6H10V8H8V6Z",
  },
  {
    id: "8E016660-0C3A-46EA-B3A5-8DC490238EC7",
    name: "fuel",
    codepoint: "F7C9",
    aliases: [],
    tags: [],
    author: "JapanYoshi",
    version: "2.0.46",
    path: "M3,2H6C6.28,2 6.53,2.11 6.71,2.29L8.79,4.38L9.59,3.59C10,3.2 10.5,3 11,3H17C17.5,3 18,3.2 18.41,3.59L19.41,4.59C19.8,5 20,5.5 20,6V19C20,20.1 19.1,21 18,21H8C6.9,21 6,20.1 6,19V13L6,12V8C6,7.5 6.2,7 6.59,6.59L7.38,5.79L5.59,4H3V2M11,5V7H17V5H11M11.41,11L9.41,9H8V10.41L10,12.41V15.59L8,17.59V19H9.41L11.41,17H14.59L16.59,19H18V17.59L16,15.59V12.41L18,10.41V9H16.59L14.59,11H11.41M12,13H14V15H12V13Z",
  },
  {
    id: "A4F7E2E4-704C-4A71-99D5-4BD19AD8E755",
    name: "fullscreen",
    codepoint: "F293",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M5,5H10V7H7V10H5V5M14,5H19V10H17V7H14V5M17,14H19V19H14V17H17V14M10,17V19H5V14H7V17H10Z",
  },
  {
    id: "CE6DC9C1-A636-4B3E-B838-34069330D3B2",
    name: "fullscreen-exit",
    codepoint: "F294",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M14,14H19V16H16V19H14V14M5,14H10V19H8V16H5V14M8,5H10V10H5V8H8V5M19,8V10H14V5H16V8H19Z",
  },
  {
    id: "76B75225-53BF-4523-BD48-CB555FFF0C67",
    name: "function",
    codepoint: "F295",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M15.6,5.29C14.5,5.19 13.53,6 13.43,7.11L13.18,10H16V12H13L12.56,17.07C12.37,19.27 10.43,20.9 8.23,20.7C6.92,20.59 5.82,19.86 5.17,18.83L6.67,17.33C6.91,18.07 7.57,18.64 8.4,18.71C9.5,18.81 10.47,18 10.57,16.89L11,12H8V10H11.17L11.44,6.93C11.63,4.73 13.57,3.1 15.77,3.3C17.08,3.41 18.18,4.14 18.83,5.17L17.33,6.67C17.09,5.93 16.43,5.36 15.6,5.29Z",
  },
  {
    id: "8424F867-9F66-42FB-92D3-91724FB2CA38",
    name: "function-variant",
    codepoint: "F870",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.1.99",
    path: "M12.42,5.29C11.32,5.19 10.35,6 10.25,7.11L10,10H12.82V12H9.82L9.38,17.07C9.18,19.27 7.24,20.9 5.04,20.7C3.79,20.59 2.66,19.9 2,18.83L3.5,17.33C3.83,18.38 4.96,18.97 6,18.63C6.78,18.39 7.33,17.7 7.4,16.89L7.82,12H4.82V10H8L8.27,6.93C8.46,4.73 10.39,3.1 12.6,3.28C13.86,3.39 15,4.09 15.66,5.17L14.16,6.67C13.91,5.9 13.23,5.36 12.42,5.29M22,13.65L20.59,12.24L17.76,15.07L14.93,12.24L13.5,13.65L16.35,16.5L13.5,19.31L14.93,20.72L17.76,17.89L20.59,20.72L22,19.31L19.17,16.5L22,13.65Z",
  },
  {
    id: "5C29EFA9-0FF3-4101-BC87-C9C15ACBA7AB",
    name: "gamepad",
    codepoint: "F296",
    aliases: ["games"],
    tags: ["Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M16.5,9L13.5,12L16.5,15H22V9M9,16.5V22H15V16.5L12,13.5M7.5,9H2V15H7.5L10.5,12M15,7.5V2H9V7.5L12,10.5L15,7.5Z",
  },
  {
    id: "A4DB98F5-FFD6-4F36-BB90-1B06AB202096",
    name: "gamepad-variant",
    codepoint: "F297",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M7,6H17C20.31,6 23,8.69 23,12C23,15.31 20.31,18 17,18C15.22,18 13.63,17.23 12.53,16H11.47C10.37,17.23 8.78,18 7,18C3.69,18 1,15.31 1,12C1,8.69 3.69,6 7,6M6,9V11H4V13H6V15H8V13H10V11H8V9H6M15.5,12C14.67,12 14,12.67 14,13.5C14,14.33 14.67,15 15.5,15C16.33,15 17,14.33 17,13.5C17,12.67 16.33,12 15.5,12M18.5,9C17.67,9 17,9.67 17,10.5C17,11.33 17.67,12 18.5,12C19.33,12 20,11.33 20,10.5C20,9.67 19.33,9 18.5,9Z",
  },
  {
    id: "FC744BA5-2E98-459F-BBD6-60788B23D93E",
    name: "garage",
    codepoint: "F6D8",
    aliases: [],
    tags: ["Home Automation"],
    author: "Alex Efremo",
    version: "1.8.36",
    path: "M19,20H17V11H7V20H5V9L12,5L19,9V20M8,12H16V14H8V12M8,15H16V17H8V15M16,18V20H8V18H16Z",
  },
  {
    id: "03ED4E2F-41CE-47D7-ABB4-C8515C202499",
    name: "garage-alert",
    codepoint: "F871",
    aliases: ["garage-warning"],
    tags: ["Home Automation"],
    author: "Michael Richins",
    version: "2.1.99",
    path: "M17,20H15V11H5V20H3V9L10,5L17,9V20M6,12H14V14H6V12M6,15H14V17H6V15M19,15V10H21V15H19M19,19V17H21V19H19Z",
  },
  {
    id: "6B34986A-5D17-4C64-9840-994B66EC00AB",
    name: "garage-open",
    codepoint: "F6D9",
    aliases: [],
    tags: ["Home Automation"],
    author: "Alex Efremo",
    version: "1.8.36",
    path: "M19,20H17V11H7V20H5V9L12,5L19,9V20M8,12H16V14H8V12Z",
  },
  {
    id: "7CEC48C5-3A70-4BA2-9FB8-A383387DC4A1",
    name: "gas-cylinder",
    codepoint: "F647",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.6.50",
    path: "M16,9V14L16,20C16,21.1 15.1,22 14,22H10C8.9,22 8,21.1 8,20V14L8,9C8,7.14 9.27,5.57 11,5.13V4H9V2H15V4H13V5.13C14.73,5.57 16,7.14 16,9Z",
  },
  {
    id: "50E30598-BCD8-4167-BDAC-FF6971E745D7",
    name: "gas-station",
    codepoint: "F298",
    aliases: ["gas-pump", "petrol-pump", "petrol-station", "local-gas-station"],
    tags: ["Places"],
    author: "Google",
    version: "1.5.54",
    path: "M18,10C17.45,10 17,9.55 17,9C17,8.45 17.45,8 18,8C18.55,8 19,8.45 19,9C19,9.55 18.55,10 18,10M12,10H6V5H12M19.77,7.23L19.78,7.22L16.06,3.5L15,4.56L17.11,6.67C16.17,7 15.5,7.93 15.5,9C15.5,10.38 16.62,11.5 18,11.5C18.36,11.5 18.69,11.42 19,11.29V18.5C19,19.05 18.55,19.5 18,19.5C17.45,19.5 17,19.05 17,18.5V14C17,12.89 16.1,12 15,12H14V5C14,3.89 13.1,3 12,3H6C4.89,3 4,3.89 4,5V21H14V13.5H15.5V18.5C15.5,19.88 16.62,21 18,21C19.38,21 20.5,19.88 20.5,18.5V9C20.5,8.31 20.22,7.68 19.77,7.23Z",
  },
  {
    id: "340B7941-DB9B-40A2-9968-100AB599F204",
    name: "gate",
    codepoint: "F299",
    aliases: [],
    tags: ["Home Automation"],
    author: "Cody",
    version: "1.5.54",
    path: "M9,5V10H7V6H5V10H3V8H1V20H3V18H5V20H7V18H9V20H11V18H13V20H15V18H17V20H19V18H21V20H23V8H21V10H19V6H17V10H15V5H13V10H11V5H9M3,12H5V16H3V12M7,12H9V16H7V12M11,12H13V16H11V12M15,12H17V16H15V12M19,12H21V16H19V12Z",
  },
  {
    id: "01E01742-E5ED-4E63-9F19-48CBE619C7A5",
    name: "gate-and",
    codepoint: "F8E0",
    aliases: ["logic-gate-and"],
    tags: [],
    author: "Nick",
    version: "2.3.50",
    path: "M2,4V20H14C18.42,20 22,16.42 22,12C22,7.58 18.42,4 14,4H2M4,6H14C17.31,6 20,8.69 20,12C20,15.31 17.31,18 14,18H4V6Z",
  },
  {
    id: "FF2BA1EF-7AAE-4271-B799-6A51FE84427E",
    name: "gate-nand",
    codepoint: "F8E1",
    aliases: ["logic-gate-nand"],
    tags: [],
    author: "Nick",
    version: "2.3.50",
    path: "M2,4V20H10C13.43,20 16.5,17.84 17.6,14.6C18,14.8 18.5,15 19,15C20.66,15 22,13.66 22,12C22,10.34 20.66,9 19,9C18.5,9 18.03,9.15 17.6,9.4C16.5,6.16 13.43,4 10,4H2M4,6H10C13.31,6 16,8.69 16,12C16,15.31 13.31,18 10,18H4V6M19,11C19.5,11 20,11.5 20,12C20,12.5 19.5,13 19,13C18.45,13 18,12.55 18,12C18,11.5 18.5,11 19,11Z",
  },
  {
    id: "9BFED3B5-B327-480D-BFCD-18F9CC52D82A",
    name: "gate-nor",
    codepoint: "F8E2",
    aliases: ["logic-gate-nor"],
    tags: [],
    author: "Nick",
    version: "2.3.50",
    path: "M2,4C5,10 5,14 2,20H5C9.4,20 13,17.7 16.6,13.7C17.15,14.5 18.04,15 19,15C20.66,15 22,13.66 22,12C22,10.34 20.66,9 19,9C18.04,9 17.15,9.5 16.6,10.3C13,6.3 9.4,4 5,4H2M5,6C8.8,6 12,8.1 15.3,12C12,15.9 8.8,18 5,18C6.5,14 6.5,10 5,6M19,11C19.5,11 20,11.5 20,12C20,12.5 19.5,13 19,13C18.45,13 18,12.55 18,12C18,11.5 18.5,11 19,11Z",
  },
  {
    id: "3A4475B4-3774-4A2A-B672-59DAF8AE3398",
    name: "gate-not",
    codepoint: "F8E3",
    aliases: ["logic-gate-not"],
    tags: [],
    author: "Nick",
    version: "2.3.50",
    path: "M2,4V20L16.2,13C16.62,14.19 17.74,15 19,15C20.66,15 22,13.66 22,12C22,10.34 20.66,9 19,9C17.74,9 16.62,9.81 16.2,11L2,4M4,7.3L13.7,12L4,16.7V7.3M19,11C19.5,11 20,11.5 20,12C20,12.5 19.5,13 19,13C18.45,13 18,12.55 18,12C18,11.5 18.5,11 19,11Z",
  },
  {
    id: "13B88427-8795-48CF-B647-597997C6C541",
    name: "gate-or",
    codepoint: "F8E4",
    aliases: ["logic-gate-or"],
    tags: [],
    author: "Nick",
    version: "2.3.50",
    path: "M2,4C5,10 5,14 2,20H8C13,20 19,16 22,12C19,8 13,4 8,4H2M5,6H8C11.5,6 16.3,9 19.3,12C16.3,15 11.5,18 8,18H5C6.4,13.9 6.4,10.1 5,6Z",
  },
  {
    id: "DA573FDA-7BEE-4B80-90BA-AA04932B43C6",
    name: "gate-xnor",
    codepoint: "F8E5",
    aliases: ["logic-gate-xnor"],
    tags: [],
    author: "Nick",
    version: "2.3.50",
    path: "M2,4C5,10 5,14 2,20H4C7,14 7,10 4.1,4H2M6,4C9,10 9,14 6,20H9C12.2,20 14.8,16.8 16.7,14C17.28,14.65 18.12,15 19,15C20.66,15 22,13.66 22,12C22,10.34 20.66,9 19,9C18.12,9 17.28,9.35 16.7,10C14.7,7.2 12.2,4 9,4H6M9,6C12,6 14,10 15.5,12C14,14 12,18 9,18C10.6,14 10.6,10 9,6M19,11C19.5,11 20,11.5 20,12C20,12.5 19.5,13 19,13C18.45,13 18,12.55 18,12C18,11.5 18.5,11 19,11Z",
  },
  {
    id: "AFA3ABA2-1237-417E-8277-8509C7A58C1C",
    name: "gate-xor",
    codepoint: "F8E6",
    aliases: ["logic-gate-xor"],
    tags: [],
    author: "Nick",
    version: "2.3.50",
    path: "M2,4C5,10 5,14 2,20H4C7,14 7,10 4.1,4H2M6,4C9,10 9,14 6,20H9C14,20 18,17 22,12C18,7 14,4 9,4H6M9,6C12.8,6 16,8.1 19.3,12C15.9,15.9 12.8,18 9,18C10.5,14 10.5,10 9,6Z",
  },
  {
    id: "EC7B7499-25F1-43D4-9A09-9742F5B6D3F2",
    name: "gauge",
    codepoint: "F29A",
    aliases: ["swap-driving-apps-wheel"],
    tags: ["Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M12,4C16.42,4 20,7.58 20,12C20,14.4 19,16.5 17.3,18C15.9,16.7 14,16 12,16C10,16 8.2,16.7 6.7,18C5,16.5 4,14.4 4,12C4,7.58 7.58,4 12,4M14,5.89C13.62,5.9 13.26,6.15 13.1,6.54L11.81,9.77L11.71,10C11,10.13 10.41,10.6 10.14,11.26C9.73,12.29 10.23,13.45 11.26,13.86C12.29,14.27 13.45,13.77 13.86,12.74C14.12,12.08 14,11.32 13.57,10.76L13.67,10.5L14.96,7.29L14.97,7.26C15.17,6.75 14.92,6.17 14.41,5.96C14.28,5.91 14.15,5.89 14,5.89M10,6C9.45,6 9,6.45 9,7C9,7.55 9.45,8 10,8C10.55,8 11,7.55 11,7C11,6.45 10.55,6 10,6M7,9C6.45,9 6,9.45 6,10C6,10.55 6.45,11 7,11C7.55,11 8,10.55 8,10C8,9.45 7.55,9 7,9M17,9C16.45,9 16,9.45 16,10C16,10.55 16.45,11 17,11C17.55,11 18,10.55 18,10C18,9.45 17.55,9 17,9Z",
  },
  {
    id: "2ED34069-D2CE-427F-8E96-C493C3D9DC5D",
    name: "gauge-empty",
    codepoint: "F872",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "2.1.99",
    path: "M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M12,4C7.58,4 4,7.58 4,12C4,14.4 5,16.5 6.7,18C8.1,16.7 10,16 12,16C14,16 15.8,16.7 17.3,18C19,16.5 20,14.4 20,12C20,7.58 16.42,4 12,4M14,6C14.55,6 15,6.45 15,7C15,7.55 14.55,8 14,8C13.45,8 13,7.55 13,7C13,6.45 13.45,6 14,6M10,6C10.55,6 11,6.45 11,7C11,7.55 10.55,8 10,8C9.45,8 9,7.55 9,7C9,6.45 9.45,6 10,6M6.91,8.94C7.04,8.94 7.16,8.97 7.3,9L10.5,10.32L10.77,10.43C11.33,10 12.09,9.88 12.75,10.15C13.77,10.56 14.27,11.73 13.85,12.75C13.44,13.77 12.27,14.27 11.25,13.85C10.59,13.59 10.12,13 10,12.28L9.77,12.18L6.55,10.88L6.53,10.87C6,10.66 5.77,10.08 5.97,9.56C6.13,9.18 6.5,8.93 6.91,8.94V8.94M17,9C17.55,9 18,9.45 18,10C18,10.55 17.55,11 17,11C16.45,11 16,10.55 16,10C16,9.45 16.45,9 17,9Z",
  },
  {
    id: "3AA721AB-566F-461F-812B-CC6652E9E800",
    name: "gauge-full",
    codepoint: "F873",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "2.1.99",
    path: "M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M12,4C16.42,4 20,7.58 20,12C20,14.4 19,16.5 17.3,18C15.9,16.7 14,16 12,16C10,16 8.2,16.7 6.7,18C5,16.5 4,14.4 4,12C4,7.58 7.58,4 12,4M10,6C9.45,6 9,6.45 9,7C9,7.55 9.45,8 10,8C10.55,8 11,7.55 11,7C11,6.45 10.55,6 10,6M14,6C13.45,6 13,6.45 13,7C13,7.55 13.45,8 14,8C14.55,8 15,7.55 15,7C15,6.45 14.55,6 14,6M17.09,8.94C16.96,8.94 16.84,8.97 16.7,9L13.5,10.32L13.23,10.43C12.67,10 11.91,9.88 11.25,10.15C10.23,10.56 9.73,11.73 10.15,12.75C10.56,13.77 11.73,14.27 12.75,13.85C13.41,13.59 13.88,13 14,12.28L14.23,12.18L17.45,10.88L17.47,10.87C18,10.66 18.23,10.08 18.03,9.56C17.87,9.18 17.5,8.93 17.09,8.94M7,9C6.45,9 6,9.45 6,10C6,10.55 6.45,11 7,11C7.55,11 8,10.55 8,10C8,9.45 7.55,9 7,9Z",
  },
  {
    id: "BFF1F377-BBAF-4354-A914-D0FD1BC9DA22",
    name: "gauge-low",
    codepoint: "F874",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "2.1.99",
    path: "M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M12,4C7.58,4 4,7.58 4,12C4,14.4 5,16.5 6.7,18C8.1,16.7 10,16 12,16C14,16 15.8,16.7 17.3,18C19,16.5 20,14.4 20,12C20,7.58 16.42,4 12,4M10,5.89C10.38,5.9 10.74,6.15 10.9,6.54L12.19,9.77L12.29,10C13,10.13 13.59,10.6 13.86,11.26C14.27,12.29 13.77,13.45 12.74,13.86C11.71,14.27 10.55,13.77 10.14,12.74C9.88,12.08 10,11.32 10.43,10.76L10.33,10.5L9.04,7.29L9.03,7.26C8.83,6.75 9.08,6.17 9.59,5.96C9.72,5.91 9.85,5.89 10,5.89V5.89M14,6C14.55,6 15,6.45 15,7C15,7.55 14.55,8 14,8C13.45,8 13,7.55 13,7C13,6.45 13.45,6 14,6M17,9C17.55,9 18,9.45 18,10C18,10.55 17.55,11 17,11C16.45,11 16,10.55 16,10C16,9.45 16.45,9 17,9M7,9C7.55,9 8,9.45 8,10C8,10.55 7.55,11 7,11C6.45,11 6,10.55 6,10C6,9.45 6.45,9 7,9Z",
  },
  {
    id: "AB600896-534E-4A82-8E7F-99E0F22B54AE",
    name: "gavel",
    codepoint: "F29B",
    aliases: ["court-hammer"],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M2.3,20.28L11.9,10.68L10.5,9.26L9.78,9.97C9.39,10.36 8.76,10.36 8.37,9.97L7.66,9.26C7.27,8.87 7.27,8.24 7.66,7.85L13.32,2.19C13.71,1.8 14.34,1.8 14.73,2.19L15.44,2.9C15.83,3.29 15.83,3.92 15.44,4.31L14.73,5L16.15,6.43C16.54,6.04 17.17,6.04 17.56,6.43C17.95,6.82 17.95,7.46 17.56,7.85L18.97,9.26L19.68,8.55C20.07,8.16 20.71,8.16 21.1,8.55L21.8,9.26C22.19,9.65 22.19,10.29 21.8,10.68L16.15,16.33C15.76,16.72 15.12,16.72 14.73,16.33L14.03,15.63C13.63,15.24 13.63,14.6 14.03,14.21L14.73,13.5L13.32,12.09L3.71,21.7C3.32,22.09 2.69,22.09 2.3,21.7C1.91,21.31 1.91,20.67 2.3,20.28M20,19C21.1,19 22,19.9 22,21V22H12V21C12,19.9 12.9,19 14,19H20Z",
  },
  {
    id: "0441EBEF-476C-420E-A04E-58367F99BD93",
    name: "gender-female",
    codepoint: "F29C",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,4C15.31,4 18,6.69 18,10C18,12.97 15.84,15.44 13,15.92V18H15V20H13V22H11V20H9V18H11V15.92C8.16,15.44 6,12.97 6,10C6,6.69 8.69,4 12,4M12,6C9.79,6 8,7.79 8,10C8,12.21 9.79,14 12,14C14.21,14 16,12.21 16,10C16,7.79 14.21,6 12,6Z",
  },
  {
    id: "78C91AE2-F79B-48EF-9CCD-5E6874BA20CA",
    name: "gender-male",
    codepoint: "F29D",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M9,9C10.29,9 11.5,9.41 12.47,10.11L17.58,5H13V3H21V11H19V6.41L13.89,11.5C14.59,12.5 15,13.7 15,15C15,18.31 12.31,21 9,21C5.69,21 3,18.31 3,15C3,11.69 5.69,9 9,9M9,11C6.79,11 5,12.79 5,15C5,17.21 6.79,19 9,19C11.21,19 13,17.21 13,15C13,12.79 11.21,11 9,11Z",
  },
  {
    id: "9B06F269-893F-4F1C-910D-D26578C6D976",
    name: "gender-male-female",
    codepoint: "F29E",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M17.58,4H14V2H21V9H19V5.41L15.17,9.24C15.69,10.03 16,11 16,12C16,14.42 14.28,16.44 12,16.9V19H14V21H12V23H10V21H8V19H10V16.9C7.72,16.44 6,14.42 6,12C6,9.24 8.24,7 11,7C12,7 12.96,7.3 13.75,7.83L17.58,4M11,9C9.34,9 8,10.34 8,12C8,13.66 9.34,15 11,15C12.66,15 14,13.66 14,12C14,10.34 12.66,9 11,9Z",
  },
  {
    id: "47F759DA-8ECB-4BAA-8102-A843844EEBB3",
    name: "gender-transgender",
    codepoint: "F29F",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M19.58,3H15V1H23V9H21V4.41L16.17,9.24C16.69,10.03 17,11 17,12C17,14.42 15.28,16.44 13,16.9V19H15V21H13V23H11V21H9V19H11V16.9C8.72,16.44 7,14.42 7,12C7,11 7.3,10.04 7.82,9.26L6.64,8.07L5.24,9.46L3.83,8.04L5.23,6.65L3,4.42V8H1V1H8V3H4.41L6.64,5.24L8.08,3.81L9.5,5.23L8.06,6.66L9.23,7.84C10,7.31 11,7 12,7C13,7 13.96,7.3 14.75,7.83L19.58,3M12,9C10.34,9 9,10.34 9,12C9,13.66 10.34,15 12,15C13.66,15 15,13.66 15,12C15,10.34 13.66,9 12,9Z",
  },
  {
    id: "D6664050-0082-4C50-B5AD-D6D0D23B842D",
    name: "gentoo",
    codepoint: "F8E7",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Contributors",
    version: "2.3.50",
    path: "M10.28,2C9.93,2 9.57,2.03 9.23,2.1C5.61,2.76 3.06,5.89 2.85,7.96C2.74,8.97 3.29,9.73 3.59,10.06C4.4,10.97 6.03,11.66 7.07,12.23C5.56,13.5 4.87,14.14 4.19,14.86C3.17,15.93 2.45,17.1 2.45,17.95C2.45,18.22 2.4,19.09 2.76,19.77C2.89,20.03 3.27,20.89 4.41,21.53C5.14,21.94 6.17,22.09 7.19,21.95C10.33,21.5 14.54,18.83 17.55,16.35C19.46,14.77 20.86,13.23 21.26,12.5C21.59,11.87 21.63,10.78 21.44,10.09C20.9,8.14 16.53,4.15 12.96,2.55C12.14,2.18 11.2,2 10.28,2M11.34,4.91C11.59,4.91 11.81,4.94 12,5C13.15,5.3 15.08,6.68 14.91,7.94C14.68,9.6 13.23,10.27 11.56,10.03C10.58,9.9 8.63,8.8 8.78,6.89C8.89,5.4 10.3,4.9 11.34,4.91M11.32,6.65C11.05,6.65 10.84,6.71 10.74,6.87C10.27,7.59 10.5,8.09 10.92,8.42C11.07,8.04 12.71,8.45 12.75,8.79C14.17,7.72 12.36,6.66 11.32,6.65Z",
  },
  {
    id: "FFC2833D-65AB-47BB-AC7C-8CFA41DF9250",
    name: "gesture",
    codepoint: "F7CA",
    aliases: [],
    tags: ["Drawing / Art"],
    author: "Google",
    version: "2.0.46",
    path: "M4.59,6.89C5.29,6.18 6,5.54 6.3,5.67C6.8,5.87 6.3,6.7 6,7.19C5.75,7.61 3.14,11.08 3.14,13.5C3.14,14.78 3.62,15.84 4.5,16.5C5.23,17.04 6.22,17.21 7.12,16.94C8.19,16.63 9.07,15.54 10.18,14.17C11.39,12.68 13,10.73 14.26,10.73C15.89,10.73 15.91,11.74 16,12.5C12.24,13.16 10.64,16.19 10.64,17.89C10.64,19.59 12.08,21 13.85,21C15.5,21 18.14,19.65 18.54,14.88H21V12.38H18.53C18.38,10.73 17.44,8.18 14.5,8.18C12.25,8.18 10.32,10.09 9.56,11C9,11.75 7.5,13.5 7.27,13.74C7,14.04 6.59,14.58 6.16,14.58C5.71,14.58 5.44,13.75 5.8,12.66C6.15,11.57 7.2,9.8 7.65,9.14C8.43,8 8.95,7.22 8.95,5.86C8.95,3.69 7.31,3 6.44,3C5.12,3 3.97,4 3.72,4.25C3.36,4.61 3.06,4.91 2.84,5.18L4.59,6.89M13.88,18.55C13.57,18.55 13.14,18.29 13.14,17.83C13.14,17.23 13.87,15.63 16,15.07C15.71,17.76 14.58,18.55 13.88,18.55Z",
  },
  {
    id: "D02C7FA0-E8E6-48B7-BEB7-4678B8D9DCA1",
    name: "gesture-double-tap",
    codepoint: "F73B",
    aliases: ["interaction-double-tap", "hand-double-tap"],
    tags: [],
    author: "Michael Richins",
    version: "1.9.32",
    path: "M10,9C10,8.45 10.45,8 11,8C11.55,8 12,8.45 12,9V13.47L13.21,13.6L18.15,15.79C18.68,16.03 19,16.56 19,17.14V21.5C18.97,22.32 18.32,22.97 17.5,23H11C10.62,23 10.26,22.85 10,22.57L5.1,18.37L5.84,17.6C6.03,17.39 6.3,17.28 6.58,17.28H6.8L10,19V9M11,5C13.21,5 15,6.79 15,9C15,10.5 14.2,11.77 13,12.46V11.24C13.61,10.69 14,9.89 14,9C14,7.34 12.66,6 11,6C9.34,6 8,7.34 8,9C8,9.89 8.39,10.69 9,11.24V12.46C7.8,11.77 7,10.5 7,9C7,6.79 8.79,5 11,5M11,3C14.31,3 17,5.69 17,9C17,10.7 16.29,12.23 15.16,13.33L14.16,12.88C15.28,11.96 16,10.56 16,9C16,6.24 13.76,4 11,4C8.24,4 6,6.24 6,9C6,11.05 7.23,12.81 9,13.58V14.66C6.67,13.83 5,11.61 5,9C5,5.69 7.69,3 11,3Z",
  },
  {
    id: "92FD3A8C-813E-4AC1-8D0B-85B89747C598",
    name: "gesture-swipe-down",
    codepoint: "F73C",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "1.9.32",
    path: "M10,9C10,8.45 10.45,8 11,8C11.55,8 12,8.45 12,9V13.47L13.21,13.6L18.15,15.79C18.68,16.03 19,16.56 19,17.14V21.5C18.97,22.32 18.32,22.97 17.5,23H11C10.62,23 10.26,22.85 10,22.57L5.1,18.37L5.84,17.6C6.03,17.39 6.3,17.28 6.58,17.28H6.8L10,19V9M1,9L4,12L7,9H5V3H3V9H1Z",
  },
  {
    id: "D0887CD1-2BF1-4A5A-B573-2BA6FF8A6129",
    name: "gesture-swipe-left",
    codepoint: "F73D",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "1.9.32",
    path: "M10,9C10,8.45 10.45,8 11,8C11.55,8 12,8.45 12,9V13.47L13.21,13.6L18.15,15.79C18.68,16.03 19,16.56 19,17.14V21.5C18.97,22.32 18.32,22.97 17.5,23H11C10.62,23 10.26,22.85 10,22.57L5.1,18.37L5.84,17.6C6.03,17.39 6.3,17.28 6.58,17.28H6.8L10,19V9M3,4L6,7V5H12V3H6V1L3,4Z",
  },
  {
    id: "9B3D3150-CF71-473E-AF65-403C389C308A",
    name: "gesture-swipe-right",
    codepoint: "F73E",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "1.9.32",
    path: "M10,9C10,8.45 10.45,8 11,8C11.55,8 12,8.45 12,9V13.47L13.21,13.6L18.15,15.79C18.68,16.03 19,16.56 19,17.14V21.5C18.97,22.32 18.32,22.97 17.5,23H11C10.62,23 10.26,22.85 10,22.57L5.1,18.37L5.84,17.6C6.03,17.39 6.3,17.28 6.58,17.28H6.8L10,19V9M12,4L9,1V3H3V5H9V7L12,4Z",
  },
  {
    id: "CE26D04A-C6AC-4379-AA25-A702F49F1DC2",
    name: "gesture-swipe-up",
    codepoint: "F73F",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "1.9.32",
    path: "M10,9C10,8.45 10.45,8 11,8C11.55,8 12,8.45 12,9V13.47L13.21,13.6L18.15,15.79C18.68,16.03 19,16.56 19,17.14V21.5C18.97,22.32 18.32,22.97 17.5,23H11C10.62,23 10.26,22.85 10,22.57L5.1,18.37L5.84,17.6C6.03,17.39 6.3,17.28 6.58,17.28H6.8L10,19V9M7,6L4,3L1,6H3V12H5V6H7Z",
  },
  {
    id: "D881AFBC-7477-46C2-9269-324676F19E51",
    name: "gesture-tap",
    codepoint: "F740",
    aliases: ["interaction-tap", "hand-tap"],
    tags: [],
    author: "Michael Richins",
    version: "1.9.32",
    path: "M10,9C10,8.45 10.45,8 11,8C11.55,8 12,8.45 12,9V13.47L13.21,13.6L18.15,15.79C18.68,16.03 19,16.56 19,17.14V21.5C18.97,22.32 18.32,22.97 17.5,23H11C10.62,23 10.26,22.85 10,22.57L5.1,18.37L5.84,17.6C6.03,17.39 6.3,17.28 6.58,17.28H6.8L10,19V9M11,5C13.21,5 15,6.79 15,9C15,10.5 14.2,11.77 13,12.46V11.24C13.61,10.69 14,9.89 14,9C14,7.34 12.66,6 11,6C9.34,6 8,7.34 8,9C8,9.89 8.39,10.69 9,11.24V12.46C7.8,11.77 7,10.5 7,9C7,6.79 8.79,5 11,5Z",
  },
  {
    id: "96C02705-84D1-4677-9DDE-CCDE1D43FE11",
    name: "gesture-two-double-tap",
    codepoint: "F741",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "1.9.32",
    path: "M19,15.14V21.5C18.97,22.32 18.32,22.97 17.5,23H11C10.62,23 10.26,22.85 10,22.57L5.1,18.37L5.84,17.6C6.03,17.39 6.3,17.28 6.58,17.28H6.8L10,19V9C10,8.45 10.45,8 11,8C11.55,8 12,8.45 12,9V7C12,6.45 12.45,6 13,6C13.55,6 14,6.45 14,7V12L18.15,13.84C18.66,14.07 19,14.58 19,15.14M13,3C15.21,3 17,4.79 17,7C17,8.5 16.2,9.77 15,10.46V9.24C15.61,8.69 16,7.89 16,7C16,5.34 14.66,4 13,4C11.65,4 10.5,4.9 10.13,6.13C8.9,6.5 8,7.65 8,9C8,9.89 8.39,10.69 9,11.24V12.46C7.8,11.77 7,10.5 7,9C7,7.38 7.97,6 9.35,5.35C10,3.97 11.38,3 13,3M13,1C16.31,1 19,3.69 19,7C19,9.06 17.96,10.88 16.38,11.96L15.26,11.46C16.89,10.64 18,8.95 18,7C18,4.24 15.76,2 13,2C11.11,2 9.46,3.05 8.61,4.61C7.05,5.46 6,7.11 6,9C6,11.05 7.23,12.81 9,13.58V14.66C6.67,13.83 5,11.61 5,9C5,6.83 6.15,4.93 7.88,3.88C8.93,2.15 10.83,1 13,1Z",
  },
  {
    id: "AA47E759-39DE-4A5C-B3CF-FAEB215EAB91",
    name: "gesture-two-tap",
    codepoint: "F742",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "1.9.32",
    path: "M19,15.14V21.5C18.97,22.32 18.32,22.97 17.5,23H11C10.62,23 10.26,22.85 10,22.57L5.1,18.37L5.84,17.6C6.03,17.39 6.3,17.28 6.58,17.28H6.8L10,19V9C10,8.45 10.45,8 11,8C11.55,8 12,8.45 12,9V7C12,6.45 12.45,6 13,6C13.55,6 14,6.45 14,7V12L18.15,13.84C18.66,14.07 19,14.58 19,15.14M15,10.45V9.24L15,9.23C15.23,9.03 15.42,8.79 15.57,8.54C15.84,8.09 16,7.56 16,7C16,5.34 14.66,4 13,4C12.21,4 11.5,4.31 10.95,4.81L10.81,4.95C10.68,5.09 10.56,5.24 10.46,5.4C10.36,5.56 10.27,5.74 10.2,5.92C10.17,6 10.15,6.06 10.13,6.13C8.9,6.5 8,7.65 8,9C8,9.7 8.24,10.34 8.64,10.85C8.74,11 8.87,11.11 9,11.23V11.24L9,12.46V12.46C7.8,11.77 7,10.5 7,9C7,7.38 7.97,6 9.35,5.35C10,3.97 11.38,3 13,3C15.21,3 17,4.79 17,7C17,8.5 16.2,9.77 15,10.46V10.45Z",
  },
  {
    id: "6B39D7DA-255C-4615-84D4-FFCF34D76A4A",
    name: "ghost",
    codepoint: "F2A0",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M12,2C7.03,2 3,6.03 3,11V22L6,19L9,22L12,19L15,22L18,19L21,22V11C21,6.03 16.97,2 12,2M9,8C10.1,8 11,8.9 11,10C11,11.1 10.1,12 9,12C7.9,12 7,11.1 7,10C7,8.9 7.9,8 9,8M15,8C16.1,8 17,8.9 17,10C17,11.1 16.1,12 15,12C13.9,12 13,11.1 13,10C13,8.9 13.9,8 15,8Z",
  },
  {
    id: "5322EB23-9081-4E99-9735-7C31003C0167",
    name: "ghost-off",
    codepoint: "F9F4",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.5.94",
    path: "M2,3.27L3.28,2L22,20.72L20.73,22L17.87,19.13L15,22L12,19L9,22L6,19L3,22V11C3,9.09 3.59,7.33 4.6,5.87L2,3.27M12,2C16.97,2 21,6.03 21,11V17.18L15.7,11.88C16.46,11.59 17,10.86 17,10C17,8.9 16.1,8 15,8C14.14,8 13.41,8.54 13.13,9.3L7.2,3.38C8.59,2.5 10.24,2 12,2M7,10C7,11.1 7.9,12 9,12C9.5,12 9.93,11.83 10.27,11.54L7.46,8.73C7.17,9.07 7,9.5 7,10Z",
  },
  {
    id: "22D0C782-CD05-4FEB-845F-BBA7126C7326",
    name: "gift",
    codepoint: "F2A1",
    aliases: ["donate", "present"],
    tags: ["Shopping"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M22,12V20C22,21.1 21.1,22 20,22H4C2.9,22 2,21.1 2,20V12C1.45,12 1,11.55 1,11V8C1,6.9 1.9,6 3,6H6.17C6.06,5.69 6,5.35 6,5C6,3.34 7.34,2 9,2C10,2 10.88,2.5 11.43,3.24V3.23L12,4L12.57,3.23V3.24C13.12,2.5 14,2 15,2C16.66,2 18,3.34 18,5C18,5.35 17.94,5.69 17.83,6H21C22.1,6 23,6.9 23,8V11C23,11.55 22.55,12 22,12M4,20H11V12H4V20M20,20V12H13V20H20M9,4C8.45,4 8,4.45 8,5C8,5.55 8.45,6 9,6C9.55,6 10,5.55 10,5C10,4.45 9.55,4 9,4M15,4C14.45,4 14,4.45 14,5C14,5.55 14.45,6 15,6C15.55,6 16,5.55 16,5C16,4.45 15.55,4 15,4M3,8V10H11V8H3M13,8V10H21V8H13Z",
  },
  {
    id: "4CB8AF2D-5373-4247-AB9D-3B28B72EB7BC",
    name: "git",
    codepoint: "F2A2",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Cody",
    version: "1.5.54",
    path: "M2.6,10.59L8.38,4.8L10.07,6.5C9.83,7.35 10.22,8.28 11,8.73V14.27C10.4,14.61 10,15.26 10,16C10,17.1 10.9,18 12,18C13.1,18 14,17.1 14,16C14,15.26 13.6,14.61 13,14.27V9.41L15.07,11.5C15,11.65 15,11.82 15,12C15,13.1 15.9,14 17,14C18.1,14 19,13.1 19,12C19,10.9 18.1,10 17,10C16.82,10 16.65,10 16.5,10.07L13.93,7.5C14.19,6.57 13.71,5.55 12.78,5.16C12.35,5 11.9,4.96 11.5,5.07L9.8,3.38L10.59,2.6C11.37,1.81 12.63,1.81 13.41,2.6L21.4,10.59C22.19,11.37 22.19,12.63 21.4,13.41L13.41,21.4C12.63,22.19 11.37,22.19 10.59,21.4L2.6,13.41C1.81,12.63 1.81,11.37 2.6,10.59Z",
  },
  {
    id: "9291BDB1-CE57-4802-8CD2-7AD2ED9D9959",
    name: "glass-cocktail",
    codepoint: "F356",
    aliases: ["local-bar", "cocktail", "martini"],
    tags: ["Food / Drink"],
    author: "Google",
    version: "1.5.54",
    path: "M7.5,7L5.5,5H18.5L16.5,7M11,13V19H6V21H18V19H13V13L21,5V3H3V5L11,13Z",
  },
  {
    id: "CD1215BB-D889-4A86-8944-AF724C71DF21",
    name: "glass-flute",
    codepoint: "F2A5",
    aliases: [],
    tags: ["Food / Drink"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M8,2H16C15.67,5 15.33,8 14.75,9.83C14.17,11.67 13.33,12.33 12.92,14.08C12.5,15.83 12.5,18.67 13.08,20C13.67,21.33 14.83,21.17 15.42,21.25C16,21.33 16,21.67 16,22H8C8,21.67 8,21.33 8.58,21.25C9.17,21.17 10.33,21.33 10.92,20C11.5,18.67 11.5,15.83 11.08,14.08C10.67,12.33 9.83,11.67 9.25,9.83C8.67,8 8.33,5 8,2M10,4C10.07,5.03 10.15,6.07 10.24,7H13.76C13.85,6.07 13.93,5.03 14,4H10Z",
  },
  {
    id: "9081982B-5EB6-47C1-A1F3-A83A0ED1B609",
    name: "glass-mug",
    codepoint: "F2A6",
    aliases: [],
    tags: ["Food / Drink"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M10,4V7H18V4H10M8,2H20L21,2V3L20,4V20L21,21V22H20L8,22H7V21L8,20V18.6L4.2,16.83C3.5,16.5 3,15.82 3,15V8C3,6.9 3.9,6 5,6H8V4L7,3V2H8M5,15L8,16.39V8H5V15Z",
  },
  {
    id: "E26942A0-61AE-4D1A-941C-895D92E94C5D",
    name: "glass-stange",
    codepoint: "F2A7",
    aliases: [],
    tags: ["Food / Drink"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M8,2H16V22H8V2M10,4V7H14V4H10Z",
  },
  {
    id: "43E8B624-633D-472F-991E-4AEDB20A5454",
    name: "glass-tulip",
    codepoint: "F2A8",
    aliases: [],
    tags: ["Food / Drink"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M8,2H16C15.67,2.67 15.33,3.33 15.58,5C15.83,6.67 16.67,9.33 16.25,10.74C15.83,12.14 14.17,12.28 13.33,13.86C12.5,15.44 12.5,18.47 13.08,19.9C13.67,21.33 14.83,21.17 15.42,21.25C16,21.33 16,21.67 16,22H8C8,21.67 8,21.33 8.58,21.25C9.17,21.17 10.33,21.33 10.92,19.9C11.5,18.47 11.5,15.44 10.67,13.86C9.83,12.28 8.17,12.14 7.75,10.74C7.33,9.33 8.17,6.67 8.42,5C8.67,3.33 8.33,2.67 8,2M10,4C10,5.19 9.83,6.17 9.64,7H14.27C14.13,6.17 14,5.19 14,4H10Z",
  },
  {
    id: "0AF778AB-1048-4307-84AD-CB88D259DC02",
    name: "glass-wine",
    codepoint: "F875",
    aliases: [],
    tags: ["Food / Drink"],
    author: "Michael Richins",
    version: "2.1.99",
    path: "M15.5,21.27L14.66,21.18C13.9,21.11 13.25,20.6 13,19.87C12.47,17.91 12.47,15.83 13,13.87C15.32,13.4 17,11.37 17,9C17,7 15,2 15,2H9C9,2 7,7 7,9C7,11.38 8.67,13.42 11,13.9C11.53,15.86 11.53,17.94 11,19.9C10.76,20.62 10.12,21.13 9.37,21.21L8.5,21.3C8.5,21.3 8,21.28 8,22H16C16,21.28 15.5,21.27 15.5,21.27M9.44,7L10.44,4H13.56L14.56,7H9.44Z",
  },
  {
    id: "3E5EE2B1-AE6A-4675-BBAB-1D6B70FBFC36",
    name: "globe-model",
    codepoint: "F8E8",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "2.3.50",
    path: "M17.36,2.64L15.95,4.06C17.26,5.37 18,7.14 18,9C18,12.87 14.87,16 11,16C9.15,16 7.37,15.26 6.06,13.95L4.64,15.36C6.08,16.8 7.97,17.71 10,17.93V20H6V22H16V20H12V17.94C16.55,17.43 20,13.58 20,9C20,6.62 19.05,4.33 17.36,2.64M11,3.5C7.96,3.5 5.5,5.96 5.5,9C5.5,12.04 7.96,14.5 11,14.5C14.04,14.5 16.5,12.04 16.5,9C16.5,5.96 14.04,3.5 11,3.5M11,5.5C12.94,5.5 14.5,7.07 14.5,9C14.5,10.93 12.93,12.5 11,12.5C9.07,12.5 7.5,10.93 7.5,9C7.5,7.07 9.07,5.5 11,5.5Z",
  },
  {
    id: "259F5EC9-395F-40C8-9389-6B6A82D9997C",
    name: "gmail",
    codepoint: "F2AB",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Google",
    version: "1.5.54",
    path: "M20,18H18V9.25L12,13L6,9.25V18H4V6H5.2L12,10.25L18.8,6H20M20,4H4C2.89,4 2,4.89 2,6V18C2,19.1 2.9,20 4,20H20C21.1,20 22,19.1 22,18V6C22,4.89 21.1,4 20,4Z",
  },
  {
    id: "2C4AF25A-8EC5-4B3B-BBCD-60F801F553B8",
    name: "gnome",
    codepoint: "F2AC",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Christopher Schreiner",
    version: "1.5.54",
    path: "M18.42,2C14.26,2 13.5,7.93 15.82,7.93C18.16,7.93 22.58,2 18.42,2M12,2.73C11.92,2.73 11.85,2.73 11.78,2.74C9.44,3.04 10.26,7.12 11.5,7.19C12.72,7.27 14.04,2.73 12,2.73M7.93,4.34C7.81,4.34 7.67,4.37 7.53,4.43C5.65,5.21 7.24,8.41 8.3,8.2C9.27,8 9.39,4.3 7.93,4.34M4.93,6.85C4.77,6.84 4.59,6.9 4.41,7.03C2.9,8.07 4.91,10.58 5.8,10.19C6.57,9.85 6.08,6.89 4.93,6.85M13.29,8.77C10.1,8.8 6.03,10.42 5.32,13.59C4.53,17.11 8.56,22 12.76,22C14.83,22 17.21,20.13 17.66,17.77C18,15.97 13.65,16.69 13.81,17.88C14,19.31 12.76,20 11.55,19.1C7.69,16.16 17.93,14.7 17.25,10.69C17.03,9.39 15.34,8.76 13.29,8.77Z",
  },
  {
    id: "80A4F47A-3512-4C76-AA10-C0232C57E624",
    name: "golf",
    codepoint: "F822",
    aliases: ["golf-course"],
    tags: ["Sport"],
    author: "Google",
    version: "2.1.19",
    path: "M19.5,18C20.33,18 21,18.67 21,19.5C21,20.33 20.33,21 19.5,21C18.67,21 18,20.33 18,19.5C18,18.67 18.67,18 19.5,18M17,5.92L11,9V18.03C13.84,18.19 16,19 16,20C16,21.1 13.31,22 10,22C6.69,22 4,21.1 4,20C4,19.26 5.21,18.62 7,18.27V20H9V2L17,5.92Z",
  },
  {
    id: "9FE486F5-20A0-4CB5-A820-93AD82F52EB6",
    name: "gondola",
    codepoint: "F685",
    aliases: ["cable-car"],
    tags: ["Transportation + Other"],
    author: "Austin Andrews",
    version: "1.7.12",
    path: "M18,10H13V7.59L22.12,6.07L21.88,4.59L16.41,5.5C16.46,5.35 16.5,5.18 16.5,5C16.5,4.17 15.83,3.5 15,3.5C14.17,3.5 13.5,4.17 13.5,5C13.5,5.35 13.63,5.68 13.84,5.93L13,6.07V5H11V6.41L10.41,6.5C10.46,6.35 10.5,6.18 10.5,6C10.5,5.17 9.83,4.5 9,4.5C8.17,4.5 7.5,5.17 7.5,6C7.5,6.36 7.63,6.68 7.83,6.93L1.88,7.93L2.12,9.41L11,7.93V10H6C4.89,10 4,10.9 4,12V18C4,19.1 4.9,20 6,20H18C19.1,20 20,19.1 20,18V12C20,10.9 19.1,10 18,10M6,12H8.25V16H6V12M9.75,16V12H14.25V16H9.75M18,16H15.75V12H18V16Z",
  },
  {
    id: "F787FBCA-3C54-43CC-AE16-E23436AD0720",
    name: "google",
    codepoint: "F2AD",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Google",
    version: "1.5.54",
    path: "M21.35,11.1H12.18V13.83H18.69C18.36,17.64 15.19,19.27 12.19,19.27C8.36,19.27 5,16.25 5,12C5,7.9 8.2,4.73 12.2,4.73C15.29,4.73 17.1,6.7 17.1,6.7L19,4.72C19,4.72 16.56,2 12.1,2C6.42,2 2.03,6.8 2.03,12C2.03,17.05 6.16,22 12.25,22C17.6,22 21.5,18.33 21.5,12.91C21.5,11.76 21.35,11.1 21.35,11.1V11.1Z",
  },
  {
    id: "B328003D-F2FD-4C31-8171-BD6EB5A81A8A",
    name: "google-analytics",
    codepoint: "F7CB",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Google",
    version: "2.0.46",
    path: "M19,3C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H17L15,21V9L15,5C15,3.9 15.9,3 17,3H19M5,21C3.9,21 3,20.1 3,19V17C3,15.9 3.9,15 5,15H9V11C9,9.9 9.9,9 11,9H14.5V21H5Z",
  },
  {
    id: "3DD7794E-8603-49D0-B34E-DD0939225AAF",
    name: "google-assistant",
    codepoint: "F7CC",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Google",
    version: "2.0.46",
    path: "M7,2C3.69,2 1,4.69 1,8C1,11.31 3.69,14 7,14C10.31,14 13,11.31 13,8C13,4.69 10.31,2 7,2M21.5,6C20.67,6 20,6.67 20,7.5C20,8.33 20.67,9 21.5,9C22.33,9 23,8.33 23,7.5C23,6.67 22.33,6 21.5,6M17,8C15.34,8 14,9.34 14,11C14,12.66 15.34,14 17,14C18.66,14 20,12.66 20,11C20,9.34 18.66,8 17,8M17,15C15.07,15 13.5,16.57 13.5,18.5C13.5,20.43 15.07,22 17,22C18.93,22 20.5,20.43 20.5,18.5C20.5,16.57 18.93,15 17,15Z",
  },
  {
    id: "8CC1E909-6274-4738-AF1D-0E2C3239E853",
    name: "google-cardboard",
    codepoint: "F2AE",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Google",
    version: "1.5.54",
    path: "M20.74,6H3.2C2.55,6 2,6.57 2,7.27V17.73C2,18.43 2.55,19 3.23,19H8C8.54,19 9,18.68 9.16,18.21L10.55,14.74C10.79,14.16 11.35,13.75 12,13.75C12.65,13.75 13.21,14.16 13.45,14.74L14.84,18.21C15.03,18.68 15.46,19 15.95,19H20.74C21.45,19 22,18.43 22,17.73V7.27C22,6.57 21.45,6 20.74,6M7.22,14.58C6,14.58 5,13.55 5,12.29C5,11 6,10 7.22,10C8.44,10 9.43,11 9.43,12.29C9.43,13.55 8.44,14.58 7.22,14.58M16.78,14.58C15.56,14.58 14.57,13.55 14.57,12.29C14.57,11.03 15.56,10 16.78,10C18,10 19,11.03 19,12.29C19,13.55 18,14.58 16.78,14.58Z",
  },
  {
    id: "0B7D7D86-21E1-4759-8E4D-5D2BB291BB3F",
    name: "google-chrome",
    codepoint: "F2AF",
    aliases: ["chromecast"],
    tags: ["Brand / Logo"],
    author: "Google",
    version: "1.5.54",
    path: "M12,20L15.46,14H15.45C15.79,13.4 16,12.73 16,12C16,10.8 15.46,9.73 14.62,9H19.41C19.79,9.93 20,10.94 20,12C20,16.42 16.42,20 12,20M4,12C4,10.54 4.39,9.18 5.07,8L8.54,14H8.55C9.24,15.19 10.5,16 12,16C12.45,16 12.88,15.91 13.29,15.77L10.89,19.91C7,19.37 4,16.04 4,12M15,12C15,13.66 13.66,15 12,15C10.34,15 9,13.66 9,12C9,10.34 10.34,9 12,9C13.66,9 15,10.34 15,12M12,4C14.96,4 17.54,5.61 18.92,8H12C10.06,8 8.45,9.38 8.08,11.21L5.7,7.08C7.16,5.21 9.44,4 12,4M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z",
  },
  {
    id: "FAF03601-DED3-4AD2-B252-DF739AC96986",
    name: "google-circles",
    codepoint: "F2B0",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M16.66,15H17C18,15 19,14.8 19.87,14.46C19.17,18.73 15.47,22 11,22C6,22 2,17.97 2,13C2,8.53 5.27,4.83 9.54,4.13C9.2,5 9,6 9,7V7.34C6.68,8.16 5,10.38 5,13C5,16.31 7.69,19 11,19C13.62,19 15.84,17.32 16.66,15M17,10C18.66,10 20,8.66 20,7C20,5.34 18.66,4 17,4C15.34,4 14,5.34 14,7C14,8.66 15.34,10 17,10M17,1C20.31,1 23,3.69 23,7C23,10.31 20.31,13 17,13C13.69,13 11,10.31 11,7C11,3.68 13.69,1 17,1Z",
  },
  {
    id: "073A8D2A-C834-4655-AA4F-792D7ADD7E6E",
    name: "google-circles-communities",
    codepoint: "F2B1",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M15,12C13.89,12 13,12.89 13,14C13,15.1 13.9,16 15,16C16.1,16 17,15.1 17,14C17,12.89 16.1,12 15,12M12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M14,9C14,7.89 13.1,7 12,7C10.89,7 10,7.89 10,9C10,10.1 10.9,11 12,11C13.1,11 14,10.1 14,9M9,12C7.9,12 7,12.9 7,14C7,15.1 7.9,16 9,16C10.1,16 11,15.1 11,14C11,12.89 10.1,12 9,12Z",
  },
  {
    id: "9ABBC701-54DE-48B3-A579-6FB3503F8929",
    name: "google-circles-extended",
    codepoint: "F2B2",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M18,19C16.89,19 16,18.1 16,17C16,15.89 16.89,15 18,15C19.1,15 20,15.9 20,17C20,18.1 19.1,19 18,19M18,13C15.79,13 14,14.79 14,17C14,19.21 15.79,21 18,21C20.21,21 22,19.21 22,17C22,14.79 20.21,13 18,13M12,11.1C10.95,11.1 10.1,11.95 10.1,13C10.1,14.05 10.95,14.9 12,14.9C13.05,14.9 13.9,14.05 13.9,13C13.9,11.95 13.05,11.1 12,11.1M6,19C4.89,19 4,18.1 4,17C4,15.89 4.89,15 6,15C7.1,15 8,15.9 8,17C8,18.1 7.1,19 6,19M6,13C3.79,13 2,14.79 2,17C2,19.21 3.79,21 6,21C8.21,21 10,19.21 10,17C10,14.79 8.21,13 6,13M12,4C13.1,4 14,4.9 14,6C14,7.1 13.1,8 12,8C10.89,8 10,7.1 10,6C10,4.89 10.89,4 12,4M12,10C14.21,10 16,8.21 16,6C16,3.79 14.21,2 12,2C9.79,2 8,3.79 8,6C8,8.21 9.79,10 12,10Z",
  },
  {
    id: "00CC15EA-653E-4F50-B681-3176664F9B3C",
    name: "google-circles-group",
    codepoint: "F2B3",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M5,10C3.9,10 3,10.9 3,12C3,13.11 3.9,14 5,14C6.11,14 7,13.11 7,12C7,10.9 6.1,10 5,10M5,16C2.79,16 1,14.21 1,12C1,9.79 2.79,8 5,8C7.21,8 9,9.79 9,12C9,14.21 7.21,16 5,16M10.5,11H14V8L18,12L14,16V13H10.5V11M5,6C4.55,6 4.11,6.05 3.69,6.14C5.63,3.05 9.08,1 13,1C19.08,1 24,5.92 24,12C24,18.08 19.08,23 13,23C9.08,23 5.63,20.95 3.69,17.86C4.11,17.95 4.55,18 5,18C5.8,18 6.56,17.84 7.25,17.56C8.71,19.07 10.74,20 13,20C17.42,20 21,16.42 21,12C21,7.58 17.42,4 13,4C10.74,4 8.71,4.93 7.25,6.44C6.56,6.16 5.8,6 5,6Z",
  },
  {
    id: "605CAD46-2EA0-47AE-8A41-953C1F27F9CD",
    name: "google-controller",
    codepoint: "F2B4",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M7.97,16L5,19C4.67,19.3 4.23,19.5 3.75,19.5C2.78,19.5 2,18.72 2,17.75V17.5L3,10.12C3.21,7.81 5.14,6 7.5,6H16.5C18.86,6 20.79,7.81 21,10.12L22,17.5V17.75C22,18.72 21.22,19.5 20.25,19.5C19.77,19.5 19.33,19.3 19,19L16.03,16H7.97M7,8V10H5V11H7V13H8V11H10V10H8V8H7M16.5,8C16.09,8 15.75,8.34 15.75,8.75C15.75,9.16 16.09,9.5 16.5,9.5C16.91,9.5 17.25,9.16 17.25,8.75C17.25,8.34 16.91,8 16.5,8M14.75,9.75C14.34,9.75 14,10.09 14,10.5C14,10.91 14.34,11.25 14.75,11.25C15.16,11.25 15.5,10.91 15.5,10.5C15.5,10.09 15.16,9.75 14.75,9.75M18.25,9.75C17.84,9.75 17.5,10.09 17.5,10.5C17.5,10.91 17.84,11.25 18.25,11.25C18.66,11.25 19,10.91 19,10.5C19,10.09 18.66,9.75 18.25,9.75M16.5,11.5C16.09,11.5 15.75,11.84 15.75,12.25C15.75,12.66 16.09,13 16.5,13C16.91,13 17.25,12.66 17.25,12.25C17.25,11.84 16.91,11.5 16.5,11.5Z",
  },
  {
    id: "8C28F332-2037-476E-8FAA-D5E6BC81D8B2",
    name: "google-controller-off",
    codepoint: "F2B5",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M2,5.27L3.28,4L20,20.72L18.73,22L12.73,16H7.97L5,19C4.67,19.3 4.23,19.5 3.75,19.5C2.78,19.5 2,18.72 2,17.75V17.5L3,10.12C3.1,9.09 3.53,8.17 4.19,7.46L2,5.27M5,10V11H7V13H8V11.27L6.73,10H5M16.5,6C18.86,6 20.79,7.81 21,10.12L22,17.5V17.75C22,18.41 21.64,19 21.1,19.28L7.82,6H16.5M16.5,8C16.09,8 15.75,8.34 15.75,8.75C15.75,9.16 16.09,9.5 16.5,9.5C16.91,9.5 17.25,9.16 17.25,8.75C17.25,8.34 16.91,8 16.5,8M14.75,9.75C14.34,9.75 14,10.09 14,10.5C14,10.91 14.34,11.25 14.75,11.25C15.16,11.25 15.5,10.91 15.5,10.5C15.5,10.09 15.16,9.75 14.75,9.75M18.25,9.75C17.84,9.75 17.5,10.09 17.5,10.5C17.5,10.91 17.84,11.25 18.25,11.25C18.66,11.25 19,10.91 19,10.5C19,10.09 18.66,9.75 18.25,9.75M16.5,11.5C16.09,11.5 15.75,11.84 15.75,12.25C15.75,12.66 16.09,13 16.5,13C16.91,13 17.25,12.66 17.25,12.25C17.25,11.84 16.91,11.5 16.5,11.5Z",
  },
  {
    id: "EE98C0AD-0A55-4A6B-BB7A-01CBD3D819A2",
    name: "google-drive",
    codepoint: "F2B6",
    aliases: ["attach-drive"],
    tags: ["Brand / Logo"],
    author: "Google",
    version: "1.5.54",
    path: "M7.71,3.5L1.15,15L4.58,21L11.13,9.5M9.73,15L6.3,21H19.42L22.85,15M22.28,14L15.42,2H8.58L8.57,2L15.43,14H22.28Z",
  },
  {
    id: "8A61F8F2-511B-45E9-9459-27BBD58936F8",
    name: "google-earth",
    codepoint: "F2B7",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Google",
    version: "1.5.54",
    path: "M12,12.14C11.09,10.77 10.14,9.78 9.14,9.19C8.14,8.59 7.27,8.38 6.5,8.55C5.77,8.73 5.14,9.14 4.64,9.8C4.2,10.39 4,11.06 4,11.81V12C4,12.78 4.11,13.58 4.36,14.39C4.45,14.64 4.5,14.64 4.55,14.39C4.67,13.77 4.96,13.31 5.41,13.03C5.87,12.75 6.47,12.76 7.22,13.05C7.97,13.35 8.7,14 9.42,14.95C10.7,16.67 12.2,17.72 13.92,18.09C16.14,18.41 17.81,17.7 18.94,16C19.25,15.39 19.5,14.86 19.64,14.39C19.73,14.08 19.69,14.05 19.5,14.3C19.03,14.92 18.4,15.33 17.6,15.5C16.8,15.7 15.89,15.5 14.86,15C13.83,14.43 12.88,13.5 12,12.14M16.97,8.16C15.41,5.81 13.72,4.5 11.91,4.17C10.47,3.95 8.91,4.45 7.22,5.67C7,5.83 6.9,5.91 6.91,5.93C6.93,5.95 7.06,5.89 7.31,5.77C9.81,4.55 12.22,5.83 14.53,9.61C15.03,10.45 15.55,11.11 16.1,11.58C16.65,12.05 17.16,12.33 17.65,12.42C18.13,12.5 18.57,12.5 18.96,12.38C19.35,12.25 19.7,12.05 20,11.77C20,11.17 19.91,10.5 19.69,9.8C19.19,9.92 18.74,9.88 18.35,9.68C17.96,9.5 17.5,8.97 16.97,8.16M12,2C14.75,2 17.1,3 19.05,4.95C21,6.9 22,9.25 22,12C22,14.75 21,17.1 19.05,19.05C17.1,21 14.75,22 12,22C9.25,22 6.9,21 4.95,19.05C3,17.1 2,14.75 2,12C2,9.25 3,6.9 4.95,4.95C6.9,3 9.25,2 12,2Z",
  },
  {
    id: "0BBD8E67-124A-4788-B44F-9583BC6E7503",
    name: "google-fit",
    codepoint: "F96B",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Google",
    version: "2.4.85",
    path: "M16.5,5C17.9,8.74 17.1,10.94 13,17.74C17.25,13.87 20,11.2 20,8.5C20,6.5 18.5,5 16.5,5M16.5,3C19.58,3 22,5.41 22,8.5C22,12.27 18.6,15.36 13.45,20.03L12,21.35L10.55,20.03C5.4,15.36 2,12.27 2,8.5C2,5.41 4.42,3 7.5,3C9.24,3 10.91,3.81 12,5.08C13.09,3.81 14.76,3 16.5,3Z",
  },
  {
    id: "6A73A89B-2C02-4DB5-89DF-0449750171BC",
    name: "google-glass",
    codepoint: "F2B8",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Google",
    version: "1.5.54",
    path: "M13,11V13.5H18.87C18.26,17 15.5,19.5 12,19.5C7.86,19.5 4.5,16.14 4.5,12C4.5,7.86 7.86,4.5 12,4.5C14.09,4.5 15.9,5.39 17.16,6.84L18.93,5.06C17.24,3.18 14.83,2 12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.5,22 21.5,17.5 21.5,12V11H13Z",
  },
  {
    id: "3EA0D516-133D-4A5E-865B-82B7CC2763D5",
    name: "google-hangouts",
    codepoint: "F2C9",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Google",
    version: "1.5.54",
    path: "M15,11L14,13H12.5L13.5,11H12V8H15M11,11L10,13H8.5L9.5,11H8V8H11M11.5,2C6.81,2 3,5.81 3,10.5C3,15.19 6.81,19 11.5,19H12V22.5C16.86,20.15 20,15 20,10.5C20,5.8 16.19,2 11.5,2Z",
  },
  {
    id: "EEB46F1F-4996-4B65-A1C6-70DC4D38C34E",
    name: "google-home",
    codepoint: "F823",
    aliases: [],
    tags: ["Device / Tech"],
    author: "Google",
    version: "2.1.19",
    path: "M8.06,7.78C7.5,7.78 7.17,7.73 7.08,7.64L6.66,13.73C7.19,14.05 7.88,14.3 8.72,14.5C9.56,14.71 10.78,14.77 12.38,14.67C13.97,14.58 15.63,14.23 17.34,13.64L16.55,4.22C15.67,5.09 14.38,5.91 12.66,6.66C11.13,7.31 9.81,7.69 8.72,7.78H8.06M7.97,5.34C7.28,5.94 7,6.34 7.13,6.56C7.22,6.78 7.7,6.84 8.58,6.75C9.67,6.66 10.91,6.31 12.28,5.72C13.22,5.31 14.03,4.88 14.72,4.41C15.41,3.94 15.88,3.55 16.13,3.23C16.38,2.92 16.47,2.7 16.41,2.58C16.34,2.42 16.03,2.34 15.47,2.34C14.34,2.34 12.94,2.7 11.25,3.42C9.81,4.05 8.72,4.69 7.97,5.34M17.34,2.2C17.41,2.33 17.44,2.47 17.44,2.63L18.61,17C18.61,18.73 18,20.09 16.83,21.07C15.64,22.05 14.03,22.55 12,22.55C10,22.55 8.4,22.04 7.2,21C6,20 5.39,18.64 5.39,16.92L6.09,6.47C6.09,6.22 6.2,5.94 6.42,5.63C6.64,5.31 6.84,5.06 7.03,4.88L7.36,4.59C8.33,3.78 9.5,3.08 10.88,2.5C11.81,2.08 12.73,1.77 13.62,1.57C14.5,1.37 15.3,1.3 16,1.38C16.71,1.46 17.16,1.73 17.34,2.2Z",
  },
  {
    id: "73BACA3B-710C-4F23-9730-D88ADA3EA914",
    name: "google-keep",
    codepoint: "F6DB",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Google",
    version: "1.8.36",
    path: "M4,2H20C21.1,2 22,2.9 22,4V17.33L17.33,22H4C2.9,22 2,21.1 2,20V4C2,2.9 2.9,2 4,2M17,17V20.25L20.25,17H17M10,19H14V18H15V13C16.21,12.09 17,10.64 17,9C17,6.24 14.76,4 12,4C9.24,4 7,6.24 7,9C7,10.64 7.79,12.09 9,13V18H10V19M14,17H10V16H14V17M14,15H10V14H14V15M12,5C14.21,5 16,6.79 16,9C16,10.5 15.2,11.77 14,12.46V13H10V12.46C8.8,11.77 8,10.5 8,9C8,6.79 9.79,5 12,5Z",
  },
  {
    id: "BB7275FF-E0B1-4D63-8EF5-467F23BC5D33",
    name: "google-lens",
    codepoint: "F9F5",
    aliases: [],
    tags: [],
    author: "Google",
    version: "2.5.94",
    path: "M6,2H18C20.21,2 22,3.79 22,6V12H20V6C20,4.9 19.1,4 18,4H6C4.9,4 4,4.9 4,6V18C4,19.1 4.9,20 6,20H12V22H6C3.79,22 2,20.21 2,18V6C2,3.79 3.79,2 6,2M12,8C14.21,8 16,9.79 16,12C16,14.21 14.21,16 12,16C9.79,16 8,14.21 8,12C8,9.79 9.79,8 12,8M18,16C19.1,16 20,16.9 20,18C20,19.1 19.1,20 18,20C16.9,20 16,19.1 16,18C16,16.9 16.9,16 18,16Z",
  },
  {
    id: "21FBF51C-0081-4987-8129-CFB0BB81729F",
    name: "google-maps",
    codepoint: "F5F5",
    aliases: [],
    tags: ["Navigation", "Brand / Logo"],
    author: "Google",
    version: "1.5.54",
    path: "M15.5,4.5C15.5,5.06 15.7,5.54 16.08,5.93C16.45,6.32 16.92,6.5 17.5,6.5C18.05,6.5 18.5,6.32 18.91,5.93C19.3,5.54 19.5,5.06 19.5,4.5C19.5,3.97 19.3,3.5 18.89,3.09C18.5,2.69 18,2.5 17.5,2.5C16.95,2.5 16.5,2.69 16.1,3.09C15.71,3.5 15.5,3.97 15.5,4.5M22,4.5C22,5.5 21.61,6.69 20.86,8.06C20.11,9.44 19.36,10.56 18.61,11.44L17.5,12.75C17.14,12.38 16.72,11.89 16.22,11.3C15.72,10.7 15.05,9.67 14.23,8.2C13.4,6.73 13,5.5 13,4.5C13,3.25 13.42,2.19 14.3,1.31C15.17,0.44 16.23,0 17.5,0C18.73,0 19.8,0.44 20.67,1.31C21.55,2.19 22,3.25 22,4.5M21,11.58V19C21,19.5 20.8,20 20.39,20.39C20,20.8 19.5,21 19,21H5C4.5,21 4,20.8 3.61,20.39C3.2,20 3,19.5 3,19V5C3,4.5 3.2,4 3.61,3.61C4,3.2 4.5,3 5,3H11.2C11.08,3.63 11,4.13 11,4.5C11,5.69 11.44,7.09 12.28,8.7C13.13,10.3 13.84,11.5 14.41,12.21C15,12.95 15.53,13.58 16.03,14.11L17.5,15.7L19,14.11C20.27,12.5 20.94,11.64 21,11.58M9,14.5V15.89H11.25C11,17 10.25,17.53 9,17.53C8.31,17.53 7.73,17.28 7.27,16.78C6.8,16.28 6.56,15.69 6.56,15C6.56,14.31 6.8,13.72 7.27,13.22C7.73,12.72 8.31,12.47 9,12.47C9.66,12.47 10.19,12.67 10.59,13.08L11.67,12.05C10.92,11.36 10.05,11 9.05,11H9C7.91,11 6.97,11.41 6.19,12.19C5.41,12.97 5,13.91 5,15C5,16.09 5.41,17.03 6.19,17.81C6.97,18.59 7.91,19 9,19C10.16,19 11.09,18.63 11.79,17.91C12.5,17.19 12.84,16.25 12.84,15.09C12.84,14.81 12.83,14.61 12.8,14.5H9Z",
  },
  {
    id: "576EFEB3-D7E0-463F-A783-19A0F97D45EE",
    name: "google-nearby",
    codepoint: "F2B9",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M21.36,10.46L13.54,2.64C12.69,1.79 11.31,1.79 10.46,2.64L2.64,10.46C1.79,11.31 1.79,12.69 2.64,13.54L10.46,21.36C11.31,22.21 12.69,22.21 13.54,21.36L21.36,13.54C22.21,12.69 22.21,11.31 21.36,10.46M12,19L5,12L12,5L19,12L12,19M16.5,12L12,16.5L7.5,12L12,7.5L16.5,12Z",
  },

  {
    id: "A4C7D4DF-2B1F-424B-9502-6618F88C9A65",
    name: "google-photos",
    codepoint: "F6DC",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.8.36",
    path: "M10,13C10.55,13 11,13.18 11.41,13.57C11.8,13.96 12,14.44 12,15V22C12,22.17 11.91,22.27 11.72,22.27C11.66,22.27 11.58,22.22 11.5,22.13L7,17.67V13H10M12.5,1.88L17,6.33V11H14C13.45,11 13,10.82 12.59,10.43C12.2,10.04 12,9.56 12,9V2C12,1.83 12.09,1.73 12.28,1.73C12.34,1.73 12.42,1.78 12.5,1.88M22,12C22.17,12 22.27,12.09 22.27,12.28C22.27,12.34 22.22,12.42 22.13,12.5L17.67,17H13V14C13,13.45 13.18,13 13.57,12.59C13.96,12.2 14.44,12 15,12H22M6.33,7H11V10C11,10.55 10.82,11 10.43,11.41C10.04,11.8 9.56,12 9,12H2C1.83,12 1.73,11.91 1.73,11.72C1.73,11.66 1.78,11.58 1.88,11.5L6.33,7Z",
  },
  {
    id: "5FE693A7-2A33-46A5-B502-D42588072E56",
    name: "google-play",
    codepoint: "F2BC",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z",
  },
  {
    id: "0D3A668A-E3B7-4512-B22D-10B13362DC2B",
    name: "google-plus",
    codepoint: "F2BD",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Google",
    version: "1.5.54",
    path: "M23,11H21V9H19V11H17V13H19V15H21V13H23M8,11V13.4H12C11.8,14.4 10.8,16.4 8,16.4C5.6,16.4 3.7,14.4 3.7,12C3.7,9.6 5.6,7.6 8,7.6C9.4,7.6 10.3,8.2 10.8,8.7L12.7,6.9C11.5,5.7 9.9,5 8,5C4.1,5 1,8.1 1,12C1,15.9 4.1,19 8,19C12,19 14.7,16.2 14.7,12.2C14.7,11.7 14.7,11.4 14.6,11H8Z",
  },
  {
    id: "837DFB0D-633B-4667-9C40-272186D68351",
    name: "google-spreadsheet",
    codepoint: "F9F6",
    aliases: [],
    tags: [],
    author: "Google",
    version: "2.5.94",
    path: "M19,11V9H11V5H9V9H5V11H9V19H11V11H19M19,3C19.5,3 20,3.2 20.39,3.61C20.8,4 21,4.5 21,5V19C21,19.5 20.8,20 20.39,20.39C20,20.8 19.5,21 19,21H5C4.5,21 4,20.8 3.61,20.39C3.2,20 3,19.5 3,19V5C3,4.5 3.2,4 3.61,3.61C4,3.2 4.5,3 5,3H19Z",
  },
  {
    id: "DFF485C3-0A13-4546-A267-7687AF1AB82F",
    name: "google-translate",
    codepoint: "F2BF",
    aliases: ["g-translate"],
    tags: ["Brand / Logo"],
    author: "Google",
    version: "1.5.54",
    path: "M20,5H10.88L10,2H4C2.9,2 2,2.9 2,4V17C2,18.1 2.9,19 4,19H11L12,22H20C21.1,22 22,21.1 22,20V7C22,5.9 21.1,5 20,5M7.17,14.59C4.91,14.59 3.08,12.76 3.08,10.5C3.08,8.24 4.91,6.41 7.17,6.41C8.21,6.41 9.16,6.78 9.91,7.5L10,7.54L8.75,8.72L8.69,8.67C8.4,8.4 7.91,8.08 7.17,8.08C5.86,8.08 4.79,9.17 4.79,10.5C4.79,11.83 5.86,12.92 7.17,12.92C8.54,12.92 9.13,12.05 9.29,11.46H7.08V9.91H11.03L11.04,10C11.08,10.19 11.09,10.38 11.09,10.59C11.09,12.94 9.5,14.59 7.17,14.59M13.2,12.88C13.53,13.5 13.94,14.06 14.39,14.58L13.85,15.11L13.2,12.88M13.97,12.12H13L12.67,11.08H16.66C16.66,11.08 16.32,12.39 15.1,13.82C14.58,13.2 14.21,12.59 13.97,12.12M21,20C21,20.55 20.55,21 20,21H13L15,19L14.19,16.23L15.11,15.31L17.79,18L18.5,17.27L15.81,14.59C16.71,13.56 17.41,12.34 17.73,11.08H19V10.04H15.36V9H14.32V10.04H12.36L11.18,6H20C20.55,6 21,6.45 21,7V20Z",
  },
  {
    id: "F10A05F8-FD09-4BDA-B906-747E9A89AB6E",
    name: "gradient",
    codepoint: "F69F",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.7.12",
    path: "M11,9H13V11H11V9M9,11H11V13H9V11M13,11H15V13H13V11M15,9H17V11H15V9M7,9H9V11H7V9M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3M9,18H7V16H9V18M13,18H11V16H13V18M17,18H15V16H17V18M19,11H17V13H19V15H17V13H15V15H13V13H11V15H9V13H7V15H5V13H7V11H5V5H19V11Z",
  },
  {
    id: "50FEA1C7-FB0B-4920-BDA4-D56A87928A75",
    name: "graphql",
    codepoint: "F876",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Michael Richins",
    version: "2.1.99",
    path: "M12,5.37L11.56,5.31L6,14.9C6.24,15.11 6.4,15.38 6.47,15.68H17.53C17.6,15.38 17.76,15.11 18,14.9L12.44,5.31L12,5.37M6.6,16.53L10.88,19.06C11.17,18.79 11.57,18.63 12,18.63C12.43,18.63 12.83,18.79 13.12,19.06L17.4,16.53H6.6M12,22C11.07,22 10.32,21.25 10.32,20.32L10.41,19.76L6.11,17.21C5.8,17.57 5.35,17.79 4.84,17.79C3.91,17.79 3.16,17.04 3.16,16.11C3.16,15.32 3.69,14.66 4.42,14.47V9.36C3.59,9.25 2.95,8.54 2.95,7.68C2.95,6.75 3.7,6 4.63,6C5.18,6 5.66,6.26 5.97,6.66L10.38,4.13L10.32,3.68C10.32,2.75 11.07,2 12,2C12.93,2 13.68,2.75 13.68,3.68L13.62,4.13L18.03,6.66C18.34,6.26 18.82,6 19.37,6C20.3,6 21.05,6.75 21.05,7.68C21.05,8.54 20.41,9.25 19.58,9.36V14.47C20.31,14.66 20.84,15.32 20.84,16.11C20.84,17.04 20.09,17.79 19.16,17.79C18.65,17.79 18.2,17.57 17.89,17.21L13.59,19.76L13.68,20.32C13.68,21.25 12.93,22 12,22M10.8,4.86L6.3,7.44L6.32,7.68C6.32,8.39 5.88,9 5.26,9.25L5.29,14.5L10.8,4.86M13.2,4.86L18.71,14.5L18.74,9.25C18.12,9 17.68,8.39 17.68,7.68L17.7,7.44L13.2,4.86Z",
  },
  {
    id: "137F01F1-86AC-4923-A9D7-C72057367BB7",
    name: "grease-pencil",
    codepoint: "F648",
    aliases: [],
    tags: ["Drawing / Art"],
    author: "Google",
    version: "1.6.50",
    path: "M18.62,1.5C18.11,1.5 17.6,1.69 17.21,2.09L10.75,8.55L14.95,12.74L21.41,6.29C22.2,5.5 22.2,4.24 21.41,3.46L20.04,2.09C19.65,1.69 19.14,1.5 18.62,1.5M9.8,9.5L3.23,16.07L3.93,16.77C3.4,17.24 2.89,17.78 2.38,18.29C1.6,19.08 1.6,20.34 2.38,21.12C3.16,21.9 4.42,21.9 5.21,21.12C5.72,20.63 6.25,20.08 6.73,19.58L7.43,20.27L14,13.7",
  },
  {
    id: "8E839EA1-A50F-41C5-BB89-14904048B885",
    name: "greater-than",
    codepoint: "F96C",
    aliases: [],
    tags: [],
    author: "Nick",
    version: "2.4.85",
    path: "M5.5,4.14L4.5,5.86L15,12L4.5,18.14L5.5,19.86L19,12L5.5,4.14Z",
  },
  {
    id: "62C57FBE-8457-442F-AD8D-510CF2080FFF",
    name: "greater-than-or-equal",
    codepoint: "F96D",
    aliases: [],
    tags: [],
    author: "Nick",
    version: "2.4.85",
    path: "M6.5,2.27L20,10.14L6.5,18L5.5,16.27L16.03,10.14L5.5,4L6.5,2.27M20,20V22H5V20H20Z",
  },
  {
    id: "8D4C203D-A1F0-42DA-997A-AB7BAC63D97B",
    name: "grid",
    codepoint: "F2C1",
    aliases: ["grid-on"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M10,4V8H14V4H10M16,4V8H20V4H16M16,10V14H20V10H16M16,16V20H20V16H16M14,20V16H10V20H14M8,20V16H4V20H8M8,14V10H4V14H8M8,8V4H4V8H8M10,14H14V10H10V14M4,2H20C21.1,2 22,2.9 22,4V20C22,21.1 21.1,22 20,22H4C2.92,22 2,21.1 2,20V4C2,2.9 2.9,2 4,2Z",
  },
  {
    id: "4A3863FA-620C-4564-8A7B-57681117B81D",
    name: "grid-large",
    codepoint: "F757",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M4,2H20C21.1,2 22,2.9 22,4V20C22,21.1 21.1,22 20,22H4C2.92,22 2,21.1 2,20V4C2,2.9 2.9,2 4,2M4,4V11H11V4H4M4,20H11V13H4V20M20,20V13H13V20H20M20,4H13V11H20V4Z",
  },
  {
    id: "4A8DDCEF-7E60-4864-9CC3-64C9A5B0D6D4",
    name: "grid-off",
    codepoint: "F2C2",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M0,2.77L1.28,1.5L22.5,22.72L21.23,24L19.23,22H4C2.92,22 2,21.1 2,20V4.77L0,2.77M10,4V7.68L8,5.68V4H6.32L4.32,2H20C21.1,2 22,2.9 22,4V19.7L20,17.7V16H18.32L16.32,14H20V10H16V13.68L14,11.68V10H12.32L10.32,8H14V4H10M16,4V8H20V4H16M16,20H17.23L16,18.77V20M4,8H5.23L4,6.77V8M10,14H11.23L10,12.77V14M14,20V16.77L13.23,16H10V20H14M8,20V16H4V20H8M8,14V10.77L7.23,10H4V14H8Z",
  },
  {
    id: "D1B31666-9F9A-4CAB-843B-4BFEDBCC5347",
    name: "group",
    codepoint: "F2C3",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M1,1V5H2V19H1V23H5V22H19V23H23V19H22V5H23V1H19V2H5V1M5,4H19V5H20V19H19V20H5V19H4V5H5M6,6V14H9V18H18V9H14V6M8,8H12V12H8M14,11H16V16H11V14H14",
  },
  {
    id: "C4015804-7FF3-4483-94CA-CEB79F7B34BC",
    name: "guitar-acoustic",
    codepoint: "F770",
    aliases: [],
    tags: [],
    author: "JapanYoshi",
    version: "1.9.32",
    path: "M19.59,3H22V5H20.41L16.17,9.24C15.8,8.68 15.32,8.2 14.76,7.83L19.59,3M12,8C14.21,8 16,9.79 16,12C16,13.82 14.77,15.42 13,15.87V16C13,18.76 10.76,21 8,21C5.24,21 3,18.76 3,16C3,13.24 5.24,11 8,11H8.13C8.58,9.24 10.17,8 12,8M12,10.5C11.17,10.5 10.5,11.17 10.5,12C10.5,12.83 11.17,13.5 12,13.5C12.83,13.5 13.5,12.83 13.5,12C13.5,11.17 12.83,10.5 12,10.5M6.94,14.24L6.23,14.94L9.06,17.77L9.77,17.06L6.94,14.24Z",
  },
  {
    id: "C2F16EBD-E72B-45E0-9A34-0BAF7ADB87B3",
    name: "guitar-electric",
    codepoint: "F2C4",
    aliases: [],
    tags: [],
    author: "JapanYoshi",
    version: "1.5.54",
    path: "M19.59,3H22V5H20.41L15.12,10.29L13.71,8.9L19.59,3M12,9C12.26,9 12.5,9.1 12.71,9.3L14.71,11.3C14.89,11.5 15,11.73 15,12L14.9,12.4L10.9,20.4C10.71,20.75 10.36,20.93 10,20.93C9.65,20.93 9.29,20.75 9.11,20.4L7.25,16.7L3.55,14.9C3.18,14.7 3,14.35 3,14C3,13.65 3.18,13.3 3.55,13.1L11.55,9.1C11.69,9 11.84,9 12,9M9.35,11.82L8.65,12.5L11.5,15.35L12.18,14.65L9.35,11.82M7.94,13.23L7.23,13.94L10.06,16.77L10.77,16.06L7.94,13.23Z",
  },
  {
    id: "68377A86-6428-4553-B768-7E9FC306E962",
    name: "guitar-pick",
    codepoint: "F2C5",
    aliases: [],
    tags: [],
    author: "Gabriel",
    version: "1.5.54",
    path: "M19,4.1C18.1,3.3 17,2.8 15.8,2.5C15.5,2.4 13.6,2 12.2,2C12.2,2 12.1,2 12,2C12,2 11.9,2 11.8,2C10.4,2 8.4,2.4 8.1,2.5C7,2.8 5.9,3.3 5,4.1C3,5.9 3,8.7 4,11C5,13.5 6.1,15.7 7.6,17.9C8.8,19.6 10.1,22 12,22C13.9,22 15.2,19.6 16.5,17.9C18,15.8 19.1,13.5 20.1,11C21,8.7 21,5.9 19,4.1Z",
  },
  {
    id: "0FA22632-A0B2-49E0-A779-56022111C9D8",
    name: "guitar-pick-outline",
    codepoint: "F2C6",
    aliases: [],
    tags: [],
    author: "Gabriel",
    version: "1.5.54",
    path: "M19,4.1C18.1,3.3 17,2.8 15.8,2.5C15.5,2.4 13.6,2 12.2,2C12.2,2 12.1,2 12,2C12,2 11.9,2 11.8,2C10.4,2 8.4,2.4 8.1,2.5C7,2.8 5.9,3.3 5,4.1C3,5.9 3,8.7 4,11C5,13.5 6.1,15.7 7.6,17.9C8.8,19.6 10.1,22 12,22C13.9,22 15.2,19.6 16.5,17.9C18,15.8 19.1,13.5 20.1,11C21,8.7 21,5.9 19,4.1M18.2,10.2C17.1,12.9 16.1,14.9 14.8,16.7C14.6,16.9 14.5,17.2 14.3,17.4C13.8,18.2 12.6,20 12,20C12,20 12,20 12,20C11.3,20 10.2,18.3 9.6,17.4C9.4,17.2 9.3,16.9 9.1,16.7C7.9,14.9 6.8,12.9 5.7,10.2C5.5,9.5 4.7,7 6.3,5.5C6.8,5 7.6,4.7 8.6,4.4C9,4.4 10.7,4 11.8,4C11.8,4 12.1,4 12.1,4C13.2,4 14.9,4.3 15.3,4.4C16.3,4.7 17.1,5 17.6,5.5C19.3,7 18.5,9.5 18.2,10.2Z",
  },
  {
    id: "FDDC802D-37F5-4E15-96DA-8A6D553B1D67",
    name: "guy-fawkes-mask",
    codepoint: "F824",
    aliases: [],
    tags: [],
    author: "Augustin Ursu",
    version: "2.1.19",
    path: "M21,13C21,17.97 16.97,22 12,22C7.03,22 3,17.97 3,13L3.03,4.43C5.68,2.88 8.76,2 12.05,2C15.3,2 18.36,2.87 21,4.38V13M13,19.93C16.39,19.44 19,16.5 19,13V5.59C16.9,4.57 14.54,4 12.05,4C9.5,4 7.08,4.6 4.94,5.66L5,13C5,16.5 7.63,19.44 11,19.93V18H13V19.93M11,16H8L6,13L9,14H10L11,13H13L14,14H15L18,13L16,16H13L12,15L11,16M6,9.03C6.64,8.4 7.5,8.05 8.5,8.05C9.45,8.05 10.34,8.4 11,9.03C10.34,9.65 9.45,10 8.5,10C7.5,10 6.64,9.65 6,9.03M13,9.03C13.64,8.4 14.5,8.05 15.5,8.05C16.45,8.05 17.34,8.4 18,9.03C17.34,9.65 16.45,10 15.5,10C14.5,10 13.64,9.65 13,9.03Z",
  },
  {
    id: "F5BC2290-D719-4974-9920-DF8E08E5F955",
    name: "hamburger",
    codepoint: "F684",
    aliases: [],
    tags: ["Food / Drink"],
    author: "JapanYoshi",
    version: "1.7.12",
    path: "M2,16H22V18C22,19.11 21.11,20 20,20H4C2.89,20 2,19.11 2,18V16M6,4H18C20.22,4 22,5.78 22,8V10H2V8C2,5.78 3.78,4 6,4M4,11H15L17,13L19,11H20C21.11,11 22,11.89 22,13C22,14.11 21.11,15 20,15H4C2.89,15 2,14.11 2,13C2,11.89 2.89,11 4,11Z",
  },
  {
    id: "A3F55E77-82C2-48F6-B1B1-92C9259C9C26",
    name: "hammer",
    codepoint: "F8E9",
    aliases: [],
    tags: ["Hardware / Tools"],
    author: "Nick",
    version: "2.3.50",
    path: "M16,5L19,8L18.5,8.5C19.5,9.5 20,10 20.5,9.5L22,11C22,12 20.5,13.5 19.5,13.5L18,12C18.5,11.5 18,11 17,10L16,11L13,8C14.5,6 13,4 9,5C10,4 11,3 12,3C12.5,3 14,3 16,5M2,20L4,22L14,12L12,10L2,20Z",
  },
  {
    id: "C18F21E1-2363-42DD-8FFF-3381AC368C23",
    name: "hand-pointing-right",
    codepoint: "F2C7",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M21,9C21.55,9 22,9.45 22,10C22,10.55 21.55,11 21,11H16.53L16.4,12.21L14.2,17.15C14,17.65 13.47,18 12.86,18H8.5C7.7,18 7,17.27 7,16.5V10C7,9.61 7.16,9.26 7.43,9L11.63,4.1L12.4,4.84C12.6,5.03 12.72,5.29 12.72,5.58L12.69,5.8L11,9H21M2,18V10H5V18H2Z",
  },
  {
    id: "2FB0994B-BBA8-4F59-93AF-87F2065F34EA",
    name: "hanger",
    codepoint: "F2C8",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M20.76,16.34H20.75C21.5,16.77 22,17.58 22,18.5C22,19.88 20.88,21 19.5,21H4.5C3.12,21 2,19.88 2,18.5C2,17.58 2.5,16.77 3.25,16.34H3.24L11,11.86C11,11.86 11,11 12,10C13,10 14,9.1 14,8C14,6.9 13.1,6 12,6C10.9,6 10,6.9 10,8H8C8,5.79 9.79,4 12,4C14.21,4 16,5.79 16,8C16,9.86 14.73,11.42 13,11.87L20.76,16.34M4.5,19V19H19.5V19C19.67,19 19.84,18.91 19.93,18.75C20.07,18.5 20,18.21 19.75,18.07L12,13.59L4.25,18.07C4,18.21 3.93,18.5 4.07,18.75C4.16,18.91 4.33,19 4.5,19Z",
  },
  {
    id: "C0F69308-03DA-446D-9B7F-A5B2B5BF1D90",
    name: "hard-hat",
    codepoint: "F96E",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.4.85",
    path: "M9.87,12.15L9,6.46C10.95,5.84 13.05,5.84 15,6.46L14.13,12.15C14.06,12.64 13.63,13 13.13,13H10.86C10.37,13 9.94,12.64 9.87,12.15M22,16V16C22,15.21 21.53,14.5 20.8,14.17C20.32,11.86 18.96,9.83 17,8.5L15.24,13.34C15.1,13.74 14.72,14 14.3,14H9.7C9.28,14 8.9,13.74 8.76,13.34L7,8.5C5.04,9.83 3.68,11.86 3.2,14.16C2.47,14.5 2,15.2 2,16L8.45,17.84C8.81,17.94 9.18,18 9.55,18H14.43C14.8,18 15.17,17.94 15.53,17.84L22,16Z",
  },
  {
    id: "6CBB2398-E7ED-4A08-8489-1FFF87D0605C",
    name: "harddisk",
    codepoint: "F2CA",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M6,2H18C19.1,2 20,2.9 20,4V20C20,21.1 19.1,22 18,22H6C4.9,22 4,21.1 4,20V4C4,2.9 4.9,2 6,2M12,4C8.69,4 6,6.69 6,10C6,13.31 8.69,16 12.1,16L11.22,13.77C10.95,13.29 11.11,12.68 11.59,12.4L12.45,11.9C12.93,11.63 13.54,11.79 13.82,12.27L15.74,14.69C17.12,13.59 18,11.9 18,10C18,6.69 15.31,4 12,4M12,9C12.55,9 13,9.45 13,10C13,10.55 12.55,11 12,11C11.45,11 11,10.55 11,10C11,9.45 11.45,9 12,9M7,18C6.45,18 6,18.45 6,19C6,19.55 6.45,20 7,20C7.55,20 8,19.55 8,19C8,18.45 7.55,18 7,18M12.09,13.27L14.58,19.58L17.17,18.08L12.95,12.77L12.09,13.27Z",
  },
  {
    id: "51F72F83-1559-4037-8BF9-2D8AE3BCB1A8",
    name: "headphones",
    codepoint: "F2CB",
    aliases: ["headset"],
    tags: ["Audio", "Device / Tech"],
    author: "Google",
    version: "1.5.54",
    path: "M12,1C7,1 3,5 3,10V17C3,18.66 4.34,20 6,20H9V12H5V10C5,6.13 8.13,3 12,3C15.87,3 19,6.13 19,10V12H15V20H18C19.66,20 21,18.66 21,17V10C21,5 16.97,1 12,1Z",
  },
  {
    id: "B14FD2A1-C292-49CC-B0AC-78E22C2BD611",
    name: "headphones-bluetooth",
    codepoint: "F96F",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "2.4.85",
    path: "M8,6C4.69,6 2,8.69 2,12V16.8C2,17.46 2.54,18 3.2,18H6V14H4V12C4,9.79 5.79,8 8,8C10.21,8 12,9.79 12,12V14H10V18H12.8C13.46,18 14,17.46 14,16.8V12C14,8.69 11.31,6 8,6M19,7V10.79L16.71,8.5L16,9.21L18.79,12L16,14.79L16.71,15.5L19,13.21V17H19.5L22.35,14.14L20.21,12L22.35,9.85L19.5,7H19M20,8.91L20.94,9.85L20,10.79V8.91M20,13.21L20.94,14.14L20,15.08V13.21Z",
  },
  {
    id: "5B608320-1BEB-499C-9CAB-0897D3A2D2B6",
    name: "headphones-box",
    codepoint: "F2CC",
    aliases: [],
    tags: ["Audio"],
    author: "Google",
    version: "1.5.54",
    path: "M7.2,18C6.54,18 6,17.46 6,16.8V13.2L6,12C6,8.69 8.69,6 12,6C15.31,6 18,8.69 18,12V13.2L18,16.8C18,17.46 17.46,18 16.8,18H14V14H16V12C16,9.79 14.21,8 12,8C9.79,8 8,9.79 8,12V14H10V18M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3Z",
  },
  {
    id: "678F779A-DE83-4DC0-A49D-657CBAF631F0",
    name: "headphones-off",
    codepoint: "F7CD",
    aliases: [],
    tags: ["Audio", "Device / Tech"],
    author: "GreenTurtwig",
    version: "2.0.46",
    path: "M12,1C16.97,1 21,5.03 21,10V17C21,17.62 20.81,18.19 20.5,18.67L15,13.18V12H19V10C19,6.13 15.87,3 12,3C10,3 8.23,3.82 6.96,5.14L5.55,3.72C7.18,2.04 9.47,1 12,1M2.78,3.5L20.5,21.22L19.23,22.5L16.73,20H15V18.27L9,12.27V20H6C4.34,20 3,18.66 3,17V10C3,8.89 3.2,7.82 3.57,6.84L1.5,4.77L2.78,3.5M5.17,8.44C5.06,8.94 5,9.46 5,10V12H8.73L5.17,8.44Z",
  },
  {
    id: "54A22337-9D03-4F52-8D3E-B2A0A32147B7",
    name: "headphones-settings",
    codepoint: "F2CD",
    aliases: [],
    tags: ["Audio", "Settings"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,1C16.97,1 21,5.03 21,10V17C21,18.66 19.66,20 18,20H15V12H19V10C19,6.13 15.87,3 12,3C8.13,3 5,6.13 5,10V12H9V20H6C4.34,20 3,18.66 3,17V10C3,5.03 7.03,1 12,1M15,24V22H17V24H15M11,24V22H13V24H11M7,24V22H9V24H7Z",
  },
  {
    id: "AFF98802-E02B-4EC8-8AFF-F0F5373D86C5",
    name: "headset",
    codepoint: "F2CE",
    aliases: ["headset-mic"],
    tags: ["Audio", "Device / Tech"],
    author: "Google",
    version: "1.5.54",
    path: "M12,1C7,1 3,5 3,10V17C3,18.66 4.34,20 6,20H9V12H5V10C5,6.13 8.13,3 12,3C15.87,3 19,6.13 19,10V12H15V20H19V21H12V23H18C19.66,23 21,21.66 21,20V10C21,5 16.97,1 12,1Z",
  },
  {
    id: "36F33522-9167-42DD-BA0A-8920F480F38C",
    name: "headset-dock",
    codepoint: "F2CF",
    aliases: [],
    tags: ["Audio"],
    author: "Chris Litherland",
    version: "1.5.54",
    path: "M2,18H9V6.13C7.27,6.57 6,8.14 6,10V11H8V17H6C4.9,17 4,16.1 4,15V10C4,6.69 6.69,4 10,4H11C14.31,4 17,6.69 17,10V12H18V9H20V12C20,13.1 19.1,14 18,14H17V15C17,16.1 16.1,17 15,17H13V11H15V10C15,8.14 13.73,6.57 12,6.13V18H22V20H2V18Z",
  },
  {
    id: "E2A86F6D-6E4D-4C61-B54A-85BEDACA052F",
    name: "headset-off",
    codepoint: "F2D0",
    aliases: [],
    tags: ["Audio", "Device / Tech"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M1.5,4.77L3.57,6.84C3.2,7.82 3,8.89 3,10V20C3,21.66 4.34,23 6,23H12V21H5V20H9V12.27L15,18.27V20H16.73L19.23,22.5L20.5,21.22L2.78,3.5L1.5,4.77M12,1C9.47,1 7.18,2.04 5.55,3.72L6.96,5.14C8.23,3.82 10,3 12,3C15.87,3 19,6.13 19,10V12H15V13.18L20.5,18.67C20.81,18.19 21,17.62 21,17V10C21,5.03 16.97,1 12,1M5,12V10C5,9.46 5.06,8.94 5.17,8.44L8.73,12H5Z",
  },
  {
    id: "32B56DB2-B6BF-4B54-AD0C-9444106B1C1D",
    name: "heart",
    codepoint: "F2D1",
    aliases: ["favorite", "favourite"],
    tags: ["Shape"],
    author: "Google",
    version: "1.5.54",
    path: "M12,21.35L10.55,20.03C5.4,15.36 2,12.27 2,8.5C2,5.41 4.42,3 7.5,3C9.24,3 10.91,3.81 12,5.08C13.09,3.81 14.76,3 16.5,3C19.58,3 22,5.41 22,8.5C22,12.27 18.6,15.36 13.45,20.03L12,21.35Z",
  },
  {
    id: "558E28AE-47E7-4C95-9846-7653C79CBA33",
    name: "heart-box",
    codepoint: "F2D2",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3M12,17L12.72,16.34C15.3,14 17,12.46 17,10.57C17,9.03 15.79,7.82 14.25,7.82C13.38,7.82 12.55,8.23 12,8.87C11.45,8.23 10.62,7.82 9.75,7.82C8.21,7.82 7,9.03 7,10.57C7,12.46 8.7,14 11.28,16.34L12,17Z",
  },
  {
    id: "24811FE6-6C95-4CAB-B708-71862BA40C05",
    name: "heart-box-outline",
    codepoint: "F2D3",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,17L11.28,16.34C8.7,14 7,12.46 7,10.57C7,9.03 8.21,7.82 9.75,7.82C10.62,7.82 11.45,8.23 12,8.87C12.55,8.23 13.38,7.82 14.25,7.82C15.79,7.82 17,9.03 17,10.57C17,12.46 15.3,14 12.72,16.34L12,17M5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3M5,5V19H19V5H5Z",
  },
  {
    id: "64D15AD4-07A4-4D43-8730-6C9860C89B44",
    name: "heart-broken",
    codepoint: "F2D4",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,21.35L10.55,20.03C5.4,15.36 2,12.27 2,8.5C2,5.41 4.42,3 7.5,3C8.17,3 8.82,3.12 9.44,3.33L13,9.35L9,14.35L12,21.35V21.35M16.5,3C19.58,3 22,5.41 22,8.5C22,12.27 18.6,15.36 13.45,20.03L12,21.35L11,14.35L15.5,9.35L12.85,4.27C13.87,3.47 15.17,3 16.5,3Z",
  },
  {
    id: "2EFEF959-D5E7-4E69-863D-4E12C413A6D9",
    name: "heart-circle",
    codepoint: "F970",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "2.4.85",
    path: "M12,2C6.47,2 2,6.5 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M9.75,7.82C10.62,7.82 11.45,8.23 12,8.87C12.55,8.23 13.38,7.82 14.25,7.82C15.79,7.82 17,9.03 17,10.57C17,12.46 15.3,14 12.72,16.34L12,17L11.28,16.34C8.7,14 7,12.46 7,10.57C7,9.03 8.21,7.82 9.75,7.82Z",
  },
  {
    id: "DD5AC3DA-1CA0-4F53-9A50-C095417D7346",
    name: "heart-circle-outline",
    codepoint: "F971",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "2.4.85",
    path: "M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4M9.75,7.82C8.21,7.82 7,9.03 7,10.57C7,12.46 8.7,14 11.28,16.34L12,17L12.72,16.34C15.3,14 17,12.46 17,10.57C17,9.03 15.79,7.82 14.25,7.82C13.38,7.82 12.55,8.23 12,8.87C11.45,8.23 10.62,7.82 9.75,7.82Z",
  },
  {
    id: "1B01BAE0-095E-424E-9552-6ECEF5E4FC62",
    name: "heart-half",
    codepoint: "F6DE",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.8.36",
    path: "M13,7.2V17.74L13,20.44L12,21.35L10.55,20.03C5.4,15.36 2,12.27 2,8.5C2,5.41 4.42,3 7.5,3C10,3 13,5 13,7.2Z",
  },
  {
    id: "0FC24699-3C95-4319-A60B-286B0D328D7A",
    name: "heart-half-full",
    codepoint: "F6DD",
    aliases: [],
    tags: [],
    author: "Case Sandberg",
    version: "1.8.36",
    path: "M16.5,5C15,5 13.58,5.91 13,7.2V17.74C17.25,13.87 20,11.2 20,8.5C20,6.5 18.5,5 16.5,5M16.5,3C19.58,3 22,5.41 22,8.5C22,12.27 18.6,15.36 13.45,20.03L12,21.35L10.55,20.03C5.4,15.36 2,12.27 2,8.5C2,5.41 4.42,3 7.5,3C9.24,3 10.91,3.81 12,5.08C13.09,3.81 14.76,3 16.5,3Z",
  },
  {
    id: "F4384972-741C-4BB6-91BF-9509E75C8AF8",
    name: "heart-half-outline",
    codepoint: "F6DF",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.8.36",
    path: "M4,8.5C4,11.2 6.75,13.87 11,17.74V7.2C10.42,5.91 9,5 7.5,5C5.5,5 4,6.5 4,8.5M13,7.2V17.74L13,20.44L12,21.35L10.55,20.03C5.4,15.36 2,12.27 2,8.5C2,5.41 4.42,3 7.5,3C10,3 13,5 13,7.2Z",
  },
  {
    id: "012A92C0-E5DE-4FB4-9AB1-9BD5F53861E0",
    name: "heart-off",
    codepoint: "F758",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M1,4.27L2.28,3L20,20.72L18.73,22L15.18,18.44L13.45,20.03L12,21.35L10.55,20.03C5.4,15.36 2,12.27 2,8.5C2,7.55 2.23,6.67 2.63,5.9L1,4.27M7.5,3C9.24,3 10.91,3.81 12,5.08C13.09,3.81 14.76,3 16.5,3C19.58,3 22,5.41 22,8.5C22,11.07 20.42,13.32 17.79,15.97L5.27,3.45C5.95,3.16 6.7,3 7.5,3Z",
  },
  {
    id: "9BCD22D2-7304-4BB3-9C41-3431ED13542A",
    name: "heart-outline",
    codepoint: "F2D5",
    aliases: [
      "favorite-border",
      "favourite-border",
      "favorite-outline",
      "favourite-outline",
    ],
    tags: ["Shape"],
    author: "Google",
    version: "1.5.54",
    path: "M12.1,18.55L12,18.65L11.89,18.55C7.14,14.24 4,11.39 4,8.5C4,6.5 5.5,5 7.5,5C9.04,5 10.54,6 11.07,7.36H12.93C13.46,6 14.96,5 16.5,5C18.5,5 20,6.5 20,8.5C20,11.39 16.86,14.24 12.1,18.55M16.5,3C14.76,3 13.09,3.81 12,5.08C10.91,3.81 9.24,3 7.5,3C4.42,3 2,5.41 2,8.5C2,12.27 5.4,15.36 10.55,20.03L12,21.35L13.45,20.03C18.6,15.36 22,12.27 22,8.5C22,5.41 19.58,3 16.5,3Z",
  },
  {
    id: "389486F3-5A73-4C65-8EA6-43D432F6490E",
    name: "heart-pulse",
    codepoint: "F5F6",
    aliases: [],
    tags: ["Medical / Hospital"],
    author: "Google",
    version: "1.5.54",
    path: "M7.5,4C4.46,4 2,6.46 2,9.5C2,10 2.09,10.5 2.22,11H6.3L7.57,7.63C7.87,6.83 9.05,6.75 9.43,7.63L11.5,13L12.09,11.58C12.22,11.25 12.57,11 13,11H21.78C21.91,10.5 22,10 22,9.5C22,6.46 19.54,4 16.5,4C14.64,4 13,4.93 12,6.34C11,4.93 9.36,4 7.5,4V4M3,12.5C2.45,12.5 2,12.95 2,13.5C2,14.05 2.45,14.5 3,14.5H5.44L11,20C12,20.9 12,20.9 13,20L18.56,14.5H21C21.55,14.5 22,14.05 22,13.5C22,12.95 21.55,12.5 21,12.5H13.4L12.47,14.8C12.07,15.81 10.92,15.67 10.55,14.83L8.5,9.5L7.54,11.83C7.39,12.21 7.05,12.5 6.6,12.5H3Z",
  },
  {
    id: "62675A10-D453-40EB-8AED-A789A39EEF11",
    name: "help",
    codepoint: "F2D6",
    aliases: ["question-mark"],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M10,19H13V22H10V19M12,2C17.35,2.22 19.68,7.62 16.5,11.67C15.67,12.67 14.33,13.33 13.67,14.17C13,15 13,16 13,17H10C10,15.33 10,13.92 10.67,12.92C11.33,11.92 12.67,11.33 13.5,10.67C15.92,8.43 15.32,5.26 12,5C10.34,5 9,6.34 9,8H6C6,4.69 8.69,2 12,2Z",
  },
  {
    id: "6EFBBE96-37EA-4372-98CC-9B0D84B92C34",
    name: "help-box",
    codepoint: "F78A",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M11,18H13V16H11V18M12,6C9.79,6 8,7.79 8,10H10C10,8.9 10.9,8 12,8C13.1,8 14,8.9 14,10C14,12 11,11.75 11,15H13C13,12.75 16,12.5 16,10C16,7.79 14.21,6 12,6M5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3Z",
  },
  {
    id: "49B41103-DD15-4FF4-A18A-44D8586704B6",
    name: "help-circle",
    codepoint: "F2D7",
    aliases: ["question-mark-circle"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M15.07,11.25L14.17,12.17C13.45,12.89 13,13.5 13,15H11V14.5C11,13.39 11.45,12.39 12.17,11.67L13.41,10.41C13.78,10.05 14,9.55 14,9C14,7.89 13.1,7 12,7C10.9,7 10,7.9 10,9H8C8,6.79 9.79,5 12,5C14.21,5 16,6.79 16,9C16,9.88 15.64,10.67 15.07,11.25M13,19H11V17H13M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.47 17.5,2 12,2Z",
  },
  {
    id: "60E15D8D-3956-4461-91D8-E8059D02ECE6",
    name: "help-circle-outline",
    codepoint: "F625",
    aliases: ["help-outline"],
    tags: [],
    author: "Google",
    version: "1.6.50",
    path: "M11,18H13V16H11V18M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,6C9.79,6 8,7.79 8,10H10C10,8.9 10.9,8 12,8C13.1,8 14,8.9 14,10C14,12 11,11.75 11,15H13C13,12.75 16,12.5 16,10C16,7.79 14.21,6 12,6Z",
  },
  {
    id: "FE0A3DAC-0D3D-4D49-A869-F78B44B26E35",
    name: "help-network",
    codepoint: "F6F4",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.8.36",
    path: "M17,3C18.1,3 19,3.9 19,5V15C19,16.1 18.1,17 17,17H13V19H14C14.55,19 15,19.45 15,20H22V22H15C15,22.55 14.55,23 14,23H10C9.45,23 9,22.55 9,22H2V20H9C9,19.45 9.45,19 10,19H11V17H7C5.89,17 5,16.1 5,15V5C5,3.9 5.9,3 7,3H17M12.19,5C11.32,5 10.62,5.2 10.08,5.59C9.56,6 9.3,6.57 9.31,7.36L9.32,7.39H11.25C11.26,7.09 11.35,6.86 11.53,6.7C11.71,6.55 11.93,6.47 12.19,6.47C12.5,6.47 12.76,6.57 12.94,6.75C13.12,6.94 13.2,7.2 13.2,7.5C13.2,7.82 13.13,8.09 12.97,8.32C12.83,8.55 12.62,8.75 12.36,8.91C11.85,9.25 11.5,9.55 11.31,9.82C11.11,10.08 11,10.5 11,11H13C13,10.69 13.04,10.44 13.13,10.26C13.22,10.07 13.39,9.9 13.64,9.74C14.09,9.5 14.46,9.21 14.75,8.81C15.04,8.41 15.19,8 15.19,7.5C15.19,6.74 14.92,6.13 14.38,5.68C13.85,5.23 13.12,5 12.19,5M11,12V14H13V12H11Z",
  },
  {
    id: "229D267D-F77F-4F33-ADD4-325647EC2662",
    name: "hexagon",
    codepoint: "F2D8",
    aliases: [],
    tags: ["Shape"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5Z",
  },
  {
    id: "60636193-AC27-470B-BCA5-94CEA29719A8",
    name: "hexagon-multiple",
    codepoint: "F6E0",
    aliases: [],
    tags: ["Shape"],
    author: "Austin Andrews",
    version: "1.8.36",
    path: "M10.25,2C10.44,2 10.61,2.11 10.69,2.26L12.91,6.22L13,6.5L12.91,6.78L10.69,10.74C10.61,10.89 10.44,11 10.25,11H5.75C5.56,11 5.39,10.89 5.31,10.74L3.09,6.78L3,6.5L3.09,6.22L5.31,2.26C5.39,2.11 5.56,2 5.75,2H10.25M10.25,13C10.44,13 10.61,13.11 10.69,13.26L12.91,17.22L13,17.5L12.91,17.78L10.69,21.74C10.61,21.89 10.44,22 10.25,22H5.75C5.56,22 5.39,21.89 5.31,21.74L3.09,17.78L3,17.5L3.09,17.22L5.31,13.26C5.39,13.11 5.56,13 5.75,13H10.25M19.5,7.5C19.69,7.5 19.86,7.61 19.94,7.76L22.16,11.72L22.25,12L22.16,12.28L19.94,16.24C19.86,16.39 19.69,16.5 19.5,16.5H15C14.81,16.5 14.64,16.39 14.56,16.24L12.34,12.28L12.25,12L12.34,11.72L14.56,7.76C14.64,7.61 14.81,7.5 15,7.5H19.5Z",
  },
  {
    id: "0A85BE3F-ACF1-4D93-A66B-34C7F29D10A3",
    name: "hexagon-outline",
    codepoint: "F2D9",
    aliases: [],
    tags: ["Shape"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5M12,4.15L5,8.09V15.91L12,19.85L19,15.91V8.09L12,4.15Z",
  },
  {
    id: "8FC812E7-2B7B-412B-9114-1899203DECC4",
    name: "high-definition",
    codepoint: "F7CE",
    aliases: ["hd"],
    tags: ["Video / Movie"],
    author: "Austin Andrews",
    version: "2.0.46",
    path: "M5,7H7V11H9V7H11V17H9V13H7V17H5V7M13,7H16C17.66,7 19,8.34 19,10V14C19,15.66 17.66,17 16,17H13V7M16,15C16.55,15 17,14.55 17,14V10C17,9.45 16.55,9 16,9H15V15H16Z",
  },
  {
    id: "BD1F0404-AA98-4FCF-8947-D0589C91A610",
    name: "high-definition-box",
    codepoint: "F877",
    aliases: ["hd-box"],
    tags: ["Video / Movie"],
    author: "Google",
    version: "2.1.99",
    path: "M19,3H5C3.89,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3M11,15H9.5V13H7.5V15H6V9H7.5V11.5H9.5V9H11V15M13,9H17C17.55,9 18,9.45 18,10V14C18,14.55 17.55,15 17,15H13V9M14.5,13.5H16.5V10.5H14.5V13.5Z",
  },
  {
    id: "81E5D79D-2ECD-4040-9B07-3A0C19792348",
    name: "highway",
    codepoint: "F5F7",
    aliases: ["autobahn", "motorway"],
    tags: [],
    author: "Christopher Schreiner",
    version: "1.5.54",
    path: "M10,2L8,8H11V2H10M13,2V8H16L14,2H13M2,9V10H4V11H6V10H18L18.06,11H20V10H22V9H2M7,11L3.34,22H11V11H7M13,11V22H20.66L17,11H13Z",
  },
  {
    id: "F1EE1708-7EAF-4929-97AA-D4BAC093D157",
    name: "hinduism",
    codepoint: "F972",
    aliases: ["religion-hindu", "om"],
    tags: ["Religion"],
    author: "Nick",
    version: "2.4.85",
    path: "M15,2L13.5,3.5L15,5L16.5,3.5L15,2M11,3C10,9 17,10 20,6L18,4.5C17,6 13,8 11,3M9,7C7,7 4.5,8.5 4.5,8.5L6,11C7,10 9,9.5 10,10C12,11 9,13 7,12V15.5C10,14 12,16 11,17.5C8,22 3,16 3,13C1,19 6,22 9,22C12,22 14,20 12.5,15H14C12.5,19.5 18,24 21,18C22,16 22,9.5 17,9.5C13,9.5 14,15 10.5,13.5C14,10 12,7 9,7M19,12C22,15 15,21 15,15C15,13 17,10.5 19,12Z",
  },
  {
    id: "55AF2D53-7FAD-4A1D-8440-10301C95D3B8",
    name: "history",
    codepoint: "F2DA",
    aliases: ["recent", "latest", "clock-arrow", "counterclockwise"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M13.5,8H12V13L16.28,15.54L17,14.33L13.5,12.25V8M13,3C8.03,3 4,7.03 4,12H1L4.96,16.03L9,12H6C6,8.13 9.13,5 13,5C16.87,5 20,8.13 20,12C20,15.87 16.87,19 13,19C11.07,19 9.32,18.21 8.06,16.94L6.64,18.36C8.27,20 10.5,21 13,21C17.97,21 22,16.97 22,12C22,7.03 17.97,3 13,3",
  },
  {
    id: "7A41C6CC-578B-4125-9647-548A298D5B3C",
    name: "hockey-puck",
    codepoint: "F878",
    aliases: [],
    tags: ["Sport"],
    author: "Nick",
    version: "2.1.99",
    path: "M12,5C6.5,5 2,6.57 2,8.5C2,10.43 6.5,12 12,12C17.5,12 22,10.43 22,8.5C22,6.57 17.5,5 12,5M2,11.76V16.5C2,18.43 6.5,20 12,20C17.5,20 22,18.43 22,16.5V11.76C21.33,12.22 20.58,12.57 19.73,12.86C17.62,13.6 14.95,14 12,14C9.05,14 6.38,13.6 4.27,12.86C3.42,12.57 2.67,12.22 2,11.76Z",
  },
  {
    id: "1D4E526E-EA07-4493-AF7D-C9B62B4CBC77",
    name: "hockey-sticks",
    codepoint: "F879",
    aliases: [],
    tags: ["Sport"],
    author: "Nick",
    version: "2.1.99",
    path: "M7.58,3L5.05,4.61L9.04,10.87L10.82,8.08L7.58,3M16.43,3L7.5,17H2V21H8.5L18.96,4.61L16.43,3M14.97,14.59L13.19,17.38L15.5,21H22V17H16.5L14.97,14.59Z",
  },
  {
    id: "826E9B16-2A0D-4E8C-9C3A-BBBE3319AE4D",
    name: "hololens",
    codepoint: "F2DB",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,8C12,8 22,8 22,11C22,11 22.09,14.36 21.75,14.25C21,11 12,11 12,11C12,11 3,11 2.25,14.25C1.91,14.36 2,11 2,11C2,8 12,8 12,8M12,12C20,12 20.75,14.25 20.75,14.25C19.75,17.25 19,18 15,18C12,18 13,16.5 12,16.5C11,16.5 12,18 9,18C5,18 4.25,17.25 3.25,14.25C3.25,14.25 4,12 12,12Z",
  },
  {
    id: "5D085274-15B9-42EC-8CCE-2F94C5EC039C",
    name: "home",
    codepoint: "F2DC",
    aliases: ["house"],
    tags: ["Home Automation", "Places"],
    author: "Google",
    version: "1.5.54",
    path: "M10,20V14H14V20H19V12H22L12,3L2,12H5V20H10Z",
  },
  {
    id: "9A7BCD6C-B4FB-4AE5-B22F-C5B8E2FB3B66",
    name: "home-account",
    codepoint: "F825",
    aliases: ["home-user"],
    tags: ["Account / User", "Home Automation"],
    author: "GreenTurtwig",
    version: "2.1.19",
    path: "M12,3L2,12H5V20H19V12H22L12,3M12,8.75C13.24,8.75 14.25,9.76 14.25,11C14.25,12.24 13.24,13.25 12,13.25C10.76,13.25 9.75,12.24 9.75,11C9.75,9.76 10.76,8.75 12,8.75M12,15C13.5,15 16.5,15.75 16.5,17.25V18H7.5V17.25C7.5,15.75 10.5,15 12,15Z",
  },
  {
    id: "A13368F4-66F6-4014-968E-7A7B2D99F038",
    name: "home-alert",
    codepoint: "F87A",
    aliases: ["home-warning"],
    tags: ["Home Automation"],
    author: "Michael Richins",
    version: "2.1.99",
    path: "M12,3L2,12H5V20H19V12H22L12,3M13,18H11V16H13V18M13,14H11V9H13V14Z",
  },
  {
    id: "80923357-29F3-429E-A186-F3561451398C",
    name: "home-assistant",
    codepoint: "F7CF",
    aliases: [],
    tags: ["Brand / Logo", "Home Automation"],
    author: "Contributors",
    version: "2.0.46",
    path: "M21.8,13H20V21H13V17.67L15.79,14.88L16.5,15C17.66,15 18.6,14.06 18.6,12.9C18.6,11.74 17.66,10.8 16.5,10.8C15.34,10.8 14.4,11.74 14.4,12.9L14.5,13.61L13,15.13V9.65C13.66,9.29 14.1,8.6 14.1,7.8C14.1,6.64 13.16,5.7 12,5.7C10.84,5.7 9.9,6.64 9.9,7.8C9.9,8.6 10.34,9.29 11,9.65V15.13L9.5,13.61L9.6,12.9C9.6,11.74 8.66,10.8 7.5,10.8C6.34,10.8 5.4,11.74 5.4,12.9C5.4,14.06 6.34,15 7.5,15L8.21,14.88L11,17.67V21H4V13H2.25C1.83,13 1.42,13 1.42,12.79C1.43,12.57 1.85,12.15 2.28,11.72L11,3C11.33,2.67 11.67,2.33 12,2.33C12.33,2.33 12.67,2.67 13,3L17,7V6H19V9L21.78,11.78C22.18,12.18 22.59,12.59 22.6,12.8C22.6,13 22.2,13 21.8,13M7.5,12C8,12 8.4,12.4 8.4,12.9C8.4,13.4 8,13.8 7.5,13.8C7,13.8 6.6,13.4 6.6,12.9C6.6,12.4 7,12 7.5,12M16.5,12C17,12 17.4,12.4 17.4,12.9C17.4,13.4 17,13.8 16.5,13.8C16,13.8 15.6,13.4 15.6,12.9C15.6,12.4 16,12 16.5,12M12,6.9C12.5,6.9 12.9,7.3 12.9,7.8C12.9,8.3 12.5,8.7 12,8.7C11.5,8.7 11.1,8.3 11.1,7.8C11.1,7.3 11.5,6.9 12,6.9Z",
  },
  {
    id: "FD2567BF-09EC-4871-B3E8-DAE9CDCF3A38",
    name: "home-automation",
    codepoint: "F7D0",
    aliases: [],
    tags: ["Home Automation"],
    author: "GreenTurtwig",
    version: "2.0.46",
    path: "M12,3L2,12H5V20H19V12H22L12,3M12,8.5C14.34,8.5 16.46,9.43 18,10.94L16.8,12.12C15.58,10.91 13.88,10.17 12,10.17C10.12,10.17 8.42,10.91 7.2,12.12L6,10.94C7.54,9.43 9.66,8.5 12,8.5M12,11.83C13.4,11.83 14.67,12.39 15.6,13.3L14.4,14.47C13.79,13.87 12.94,13.5 12,13.5C11.06,13.5 10.21,13.87 9.6,14.47L8.4,13.3C9.33,12.39 10.6,11.83 12,11.83M12,15.17C12.94,15.17 13.7,15.91 13.7,16.83C13.7,17.75 12.94,18.5 12,18.5C11.06,18.5 10.3,17.75 10.3,16.83C10.3,15.91 11.06,15.17 12,15.17Z",
  },
  {
    id: "59CB69E0-6F23-4572-90C7-9B360121C266",
    name: "home-circle",
    codepoint: "F7D1",
    aliases: ["house-circle"],
    tags: ["Home Automation"],
    author: "Contributors",
    version: "2.0.46",
    path: "M19.07,4.93C17.22,3 14.66,1.96 12,2C9.34,1.96 6.79,3 4.94,4.93C3,6.78 1.96,9.34 2,12C1.96,14.66 3,17.21 4.93,19.06C6.78,21 9.34,22.04 12,22C14.66,22.04 17.21,21 19.06,19.07C21,17.22 22.04,14.66 22,12C22.04,9.34 21,6.78 19.07,4.93M17,12V18H13.5V13H10.5V18H7V12H5L12,5L19.5,12H17Z",
  },
  {
    id: "21C7383B-5839-4F3E-A4EC-81A9980F531B",
    name: "home-currency-usd",
    codepoint: "F8AE",
    aliases: [],
    tags: [],
    author: "Nick",
    version: "2.2.43",
    path: "M12,3L22,12H19V20H5V12H2L12,3M9.22,8.93C8.75,9.4 8.5,10.03 8.5,10.75C8.5,12.43 10.54,13.07 11.76,13.46C13.26,13.93 13.47,14.21 13.5,14.25C13.5,15 12.15,15 12,15V15C11.37,15 11.03,14.88 10.86,14.78C10.67,14.67 10.5,14.5 10.5,14H8.5C8.5,15.43 9.24,16.16 9.85,16.5C10.18,16.7 10.57,16.84 11,16.92V18H13V16.91C14.53,16.61 15.5,15.62 15.5,14.25C15.5,12.67 13.88,12.03 12.36,11.55C10.8,11.06 10.53,10.77 10.5,10.75C10.5,10.5 10.57,10.41 10.64,10.34C10.85,10.13 11.36,10 12,10V10C12.68,10 13.5,10.13 13.5,10.75H15.5C15.5,9.34 14.56,8.37 13,8.09V7H11V8.08C10.26,8.21 9.65,8.5 9.22,8.93Z",
  },
  {
    id: "513D2CF1-31F5-4F3B-8543-2499ABB20924",
    name: "home-heart",
    codepoint: "F826",
    aliases: ["family"],
    tags: ["Home Automation"],
    author: "Michael Richins",
    version: "2.1.19",
    path: "M2,12L12,3L22,12H19V20H5V12H2M12,18L12.72,17.34C15.3,15 17,13.46 17,11.57C17,10.03 15.79,8.82 14.25,8.82C13.38,8.82 12.55,9.23 12,9.87C11.45,9.23 10.62,8.82 9.75,8.82C8.21,8.82 7,10.03 7,11.57C7,13.46 8.7,15 11.28,17.34L12,18Z",
  },
  {
    id: "ECB8FF23-47EC-4038-9673-1A3A1619C071",
    name: "home-lock",
    codepoint: "F8EA",
    aliases: [],
    tags: ["Home Automation", "Lock"],
    author: "Nick",
    version: "2.3.50",
    path: "M12,3L2,12H5V20H19V12H22L12,3M12,9C13.66,9 15,10.34 15,12V13H16V17H8V13H9V12C9,10.34 10.34,9 12,9M12,11C11.45,11 11,11.45 11,12V13H13V12C13,11.5 12.6,11 12,11Z",
  },
  {
    id: "0E63785D-BB37-4A60-B09D-F985DC4FAD5F",
    name: "home-lock-open",
    codepoint: "F8EB",
    aliases: [],
    tags: ["Home Automation", "Lock"],
    author: "Nick",
    version: "2.3.50",
    path: "M12,3L2,12H5V20H19V12H22L12,3M12,8C13.66,8 15,9.34 15,11H13C13,10.45 12.55,10 12,10C11.45,10 11,10.45 11,11V13H16V17H8V13H9V11C9,9.34 10.34,8 12,8Z",
  },
  {
    id: "D543BDC6-BC40-4A36-B2F0-60313D8F4EEB",
    name: "home-map-marker",
    codepoint: "F5F8",
    aliases: ["house-map-marker"],
    tags: ["Home Automation", "Navigation"],
    author: "Cody",
    version: "1.5.54",
    path: "M12,3L2,12H5V20H19V12H22L12,3M12,7.7C14.1,7.7 15.8,9.4 15.8,11.5C15.8,14.5 12,18 12,18C12,18 8.2,14.5 8.2,11.5C8.2,9.4 9.9,7.7 12,7.7M12,10C11.17,10 10.5,10.67 10.5,11.5C10.5,12.33 11.17,13 12,13C12.83,13 13.5,12.33 13.5,11.5C13.5,10.67 12.83,10 12,10Z",
  },
  {
    id: "825AF439-6839-48DA-A6D4-B62BB2710103",
    name: "home-minus",
    codepoint: "F973",
    aliases: [],
    tags: ["Home Automation"],
    author: "Peter Noble",
    version: "2.4.85",
    path: "M12,3L2,12H5V20H19V12H22L12,3M16,13V15H8V13H16Z",
  },
  {
    id: "6949FE9A-5B8C-4EDF-B74E-E0268A4F69F1",
    name: "home-modern",
    codepoint: "F2DD",
    aliases: ["house-modern"],
    tags: ["Home Automation"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M6,21V8C6,6.9 6.9,6 8,6L16,3V6C17.1,6 18,6.9 18,8V21H12V16H8V21H6M14,19H16V16H14V19M8,13H10V9H8V13M12,13H16V9H12V13Z",
  },
  {
    id: "B4E2287E-8872-48AD-B765-83D82AF66CA3",
    name: "home-outline",
    codepoint: "F6A0",
    aliases: ["house-outline"],
    tags: ["Home Automation"],
    author: "Austin Andrews",
    version: "1.7.12",
    path: "M9,19V13H11L13,13H15V19H18V10.91L12,4.91L6,10.91V19H9M12,2.09L21.91,12H20V21H13V15H11V21H4V12H2.09L12,2.09Z",
  },
  {
    id: "E844FA32-E45E-4D71-B74C-34DFAD7F6830",
    name: "home-plus",
    codepoint: "F974",
    aliases: [],
    tags: ["Home Automation"],
    author: "Peter Noble",
    version: "2.4.85",
    path: "M12,3L2,12H5V20H19V12H22L12,3M11,10H13V13H16V15H13V18H11V15H8V13H11V10Z",
  },
  {
    id: "7AFA8EEF-6A41-4A7D-97D2-F9F03DB24DB0",
    name: "home-variant",
    codepoint: "F2DE",
    aliases: ["house-variant"],
    tags: ["Home Automation"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M8,20H5V12H2L12,3L22,12H19V20H12V14H8V20M14,14V17H17V14H14Z",
  },
  {
    id: "8A2A8364-B33C-4931-BF78-EB171C569D5F",
    name: "hook",
    codepoint: "F6E1",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "1.8.36",
    path: "M18,6C18,7.82 16.76,9.41 15,9.86V17C15,19.76 12.76,22 10,22C7.24,22 5,19.76 5,17V12L10,17H7C7,18.66 8.34,20 10,20C11.66,20 13,18.66 13,17V9.86C11.23,9.4 10,7.8 10,5.97C10,3.76 11.8,2 14,2C16.22,2 18,3.79 18,6M14,8C15.1,8 16,7.1 16,6C16,4.9 15.1,4 14,4C12.9,4 12,4.9 12,6C12,7.1 12.9,8 14,8Z",
  },
  {
    id: "984487C2-EBB2-474C-8914-046E6BDC6EC6",
    name: "hook-off",
    codepoint: "F6E2",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "1.8.36",
    path: "M13,9.86V11.18L15,13.18V9.86C17.14,9.31 18.43,7.13 17.87,5C17.32,2.85 15.14,1.56 13,2.11C10.86,2.67 9.57,4.85 10.13,7C10.5,8.4 11.59,9.5 13,9.86M14,4C15.1,4 16,4.9 16,6C16,7.1 15.1,8 14,8C12.9,8 12,7.1 12,6C12,4.9 12.9,4 14,4M18.73,22L14.86,18.13C14.21,20.81 11.5,22.46 8.83,21.82C6.6,21.28 5,19.29 5,17V12L10,17H7C7,18.66 8.34,20 10,20C11.66,20 13,18.66 13,17V16.27L2,5.27L3.28,4L13,13.72L15,15.72L20,20.72L18.73,22Z",
  },
  {
    id: "E82A026A-DD54-4C5F-8961-A7C97754CF04",
    name: "hops",
    codepoint: "F2DF",
    aliases: [],
    tags: ["Food / Drink"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M21,12C21,12 12.5,10 12.5,2C12.5,2 21,2 21,12M3,12C3,2 11.5,2 11.5,2C11.5,10 3,12 3,12M12,6.5C12,6.5 13,8.66 15,10.5C14.76,14.16 12,16 12,16C12,16 9.24,14.16 9,10.5C11,8.66 12,6.5 12,6.5M20.75,13.25C20.75,13.25 20,17 18,19C18,19 15.53,17.36 14.33,14.81C15.05,13.58 15.5,12.12 15.75,11.13C17.13,12.18 18.75,13 20.75,13.25M15.5,18.25C14.5,20.25 12,21.75 12,21.75C12,21.75 9.5,20.25 8.5,18.25C8.5,18.25 9.59,17.34 10.35,15.8C10.82,16.35 11.36,16.79 12,17C12.64,16.79 13.18,16.35 13.65,15.8C14.41,17.34 15.5,18.25 15.5,18.25M3.25,13.25C5.25,13 6.87,12.18 8.25,11.13C8.5,12.12 8.95,13.58 9.67,14.81C8.47,17.36 6,19 6,19C4,17 3.25,13.25 3.25,13.25Z",
  },
  {
    id: "83D0E9E7-B196-4515-A9C8-6E6FEB03ADD1",
    name: "hospital",
    codepoint: "F2E0",
    aliases: ["local-hospital"],
    tags: ["Medical / Hospital"],
    author: "Google",
    version: "1.5.54",
    path: "M18,14H14V18H10V14H6V10H10V6H14V10H18M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3Z",
  },
  {
    id: "D4FAA416-4429-451F-B4EE-647CCABDF3EB",
    name: "hospital-building",
    codepoint: "F2E1",
    aliases: [],
    tags: ["Places", "Medical / Hospital"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M2,22V7C2,6.45 2.45,6 3,6H7V2H17V6H21C21.55,6 22,6.45 22,7V22H14V17H10V22H2M9,4V10H11V8H13V10H15V4H13V6H11V4H9M4,20H8V17H4V20M4,15H8V12H4V15M16,20H20V17H16V20M16,15H20V12H16V15M10,15H14V12H10V15Z",
  },
  {
    id: "FA30BC13-BE77-44F6-BEB1-942749E019A7",
    name: "hospital-marker",
    codepoint: "F2E2",
    aliases: [],
    tags: ["Medical / Hospital"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,2C15.86,2 19,5.13 19,9C19,14.25 12,22 12,22C12,22 5,14.25 5,9C5,5.13 8.13,2 12,2M9,6V12H11V10H13V12H15V6H13V8H11V6H9Z",
  },
  {
    id: "832FBA55-F65E-4706-93B1-9018D651CAA3",
    name: "hot-tub",
    codepoint: "F827",
    aliases: [],
    tags: [],
    author: "Google",
    version: "2.1.19",
    path: "M7,4C8.1,4 9,4.9 9,6C9,7.1 8.1,8 7,8C5.9,8 5,7.1 5,6C5,4.9 5.9,4 7,4M11.15,12H22V20C22,21.1 21.1,22 20,22H4C2.9,22 2,21.1 2,20V12H5V11.25C5,10 6,9 7.25,9H7.28C7.62,9 7.95,9.09 8.24,9.23C8.5,9.35 8.74,9.5 8.93,9.73L10.33,11.28C10.56,11.54 10.84,11.78 11.15,12M7,20V14H5V20H7M11,20V14H9V20H11M15,20V14H13V20H15M19,20V14H17V20H19M18.65,5.86C19.68,6.86 20.16,8.21 19.95,9.57L19.89,10H18L18.09,9.41C18.24,8.62 18,7.83 17.42,7.21L17.35,7.15C16.32,6.14 15.85,4.79 16.05,3.43L16.11,3H18L17.91,3.59C17.76,4.38 18,5.17 18.58,5.79L18.65,5.86M14.65,5.86C15.68,6.86 16.16,8.21 15.95,9.57L15.89,10H14L14.09,9.41C14.24,8.62 14,7.83 13.42,7.21L13.35,7.15C12.32,6.14 11.85,4.79 12.05,3.43L12.11,3H14L13.91,3.59C13.76,4.38 14,5.17 14.58,5.79L14.65,5.86Z",
  },
  {
    id: "788D7C34-3E50-468B-A205-D953D844F1B7",
    name: "hulu",
    codepoint: "F828",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Contributors",
    version: "2.1.19",
    path: "M19.5,12.8V22H14.7V13.9C14.7,13.2 14.1,12.6 13.4,12.6H10.5C9.8,12.6 9.2,13.2 9.2,13.9V22H4.5V2H9.3V8.4C9.6,8.3 9.9,8.2 10.2,8.2H15C17.5,8.2 19.5,10.3 19.5,12.8Z",
  },
  {
    id: "B05E458D-886A-491D-9969-156562C52105",
    name: "human",
    codepoint: "F2E6",
    aliases: ["accessibility"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M21,9H15V22H13V16H11V22H9V9H3V7H21M12,2C13.1,2 14,2.9 14,4C14,5.1 13.1,6 12,6C10.89,6 10,5.1 10,4C10,2.89 10.89,2 12,2Z",
  },
  {
    id: "ABBC3761-B437-4800-9C57-BCBE5AC8FA31",
    name: "human-child",
    codepoint: "F2E7",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,2C13.66,2 15,3.34 15,5C15,6.66 13.66,8 12,8C10.34,8 9,6.66 9,5C9,3.34 10.34,2 12,2M11,22H8V16H6V9H18V16H16V22H13V18H11V22Z",
  },
  {
    id: "059421A9-4F27-493A-8835-4B49B5286366",
    name: "human-female",
    codepoint: "F649",
    aliases: ["woman"],
    tags: [],
    author: "Google",
    version: "1.6.50",
    path: "M12,2C13.1,2 14,2.9 14,4C14,5.1 13.1,6 12,6C10.9,6 10,5.1 10,4C10,2.9 10.9,2 12,2M10.5,22V16H7.5L10.09,8.41C10.34,7.59 11.1,7 12,7C12.9,7 13.66,7.59 13.91,8.41L16.5,16H13.5V22H10.5Z",
  },
  {
    id: "1C9856E1-6945-464E-85E7-A46C4A974C9D",
    name: "human-greeting",
    codepoint: "F64A",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.6.50",
    path: "M1.5,4V5.5C1.5,9.65 3.71,13.28 7,15.3V20H22V18C22,15.34 16.67,14 14,14C14,14 13.83,14 13.75,14C9,14 5,10 5,5.5V4M14,4C11.79,4 10,5.79 10,8C10,10.21 11.79,12 14,12C16.21,12 18,10.21 18,8C18,5.79 16.21,4 14,4Z",
  },
  {
    id: "10E7CAB4-7B15-4F73-82B1-E42562B9103C",
    name: "human-handsdown",
    codepoint: "F64B",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.6.50",
    path: "M12,1C10.89,1 10,1.9 10,3C10,4.11 10.89,5 12,5C13.11,5 14,4.11 14,3C14,1.9 13.1,1 12,1M10,6C9.73,6 9.5,6.11 9.31,6.28H9.3L4,11.59L5.42,13L9,9.41V22H11V15H13V22H15V9.41L18.58,13L20,11.59L14.7,6.28C14.5,6.11 14.27,6 14,6",
  },
  {
    id: "FA427178-750A-425C-81F2-B46DDC061771",
    name: "human-handsup",
    codepoint: "F64C",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.6.50",
    path: "M5,1C5,3.7 6.56,6.16 9,7.32V22H11V15H13V22H15V7.31C17.44,6.16 19,3.7 19,1H17C17,3.76 14.76,6 12,6C9.24,6 7,3.76 7,1M12,1C10.89,1 10,1.89 10,3C10,4.11 10.89,5 12,5C13.11,5 14,4.11 14,3C14,1.89 13.11,1 12,1Z",
  },
  {
    id: "1369FF9C-0E57-4644-BE89-7B5EED0131B0",
    name: "human-male",
    codepoint: "F64D",
    aliases: ["man"],
    tags: [],
    author: "Google",
    version: "1.6.50",
    path: "M12,2C13.1,2 14,2.9 14,4C14,5.1 13.1,6 12,6C10.9,6 10,5.1 10,4C10,2.9 10.9,2 12,2M10.5,7H13.5C14.6,7 15.5,7.9 15.5,9V14.5H14V22H10V14.5H8.5V9C8.5,7.9 9.4,7 10.5,7Z",
  },
  {
    id: "0FC16450-7A7E-43C5-AED4-E27C4A6BFF99",
    name: "human-male-female",
    codepoint: "F2E8",
    aliases: ["wc", "man-woman"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M7.5,2C8.6,2 9.5,2.9 9.5,4C9.5,5.1 8.6,6 7.5,6C6.4,6 5.5,5.1 5.5,4C5.5,2.9 6.4,2 7.5,2M6,7H9C10.1,7 11,7.9 11,9V14.5H9.5V22H5.5V14.5H4V9C4,7.9 4.9,7 6,7M16.5,2C17.6,2 18.5,2.9 18.5,4C18.5,5.1 17.6,6 16.5,6C15.4,6 14.5,5.1 14.5,4C14.5,2.9 15.4,2 16.5,2M15,22V16H12L14.59,8.41C14.84,7.59 15.6,7 16.5,7C17.4,7 18.16,7.59 18.41,8.41L21,16H18V22H15Z",
  },
  {
    id: "05DB88BC-FA28-4DF1-8308-541E338E0234",
    name: "human-pregnant",
    codepoint: "F5CF",
    aliases: ["pregnant-woman"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M9,4C9,2.89 9.89,2 11,2C12.11,2 13,2.89 13,4C13,5.11 12.11,6 11,6C9.89,6 9,5.11 9,4M16,13C16,11.66 15.17,10.5 14,10C14,8.34 12.66,7 11,7C9.34,7 8,8.34 8,10V17H10V22H13V17H16V13Z",
  },
  {
    id: "9A2A1178-7E30-49E7-A639-2D16464EA7EA",
    name: "humble-bundle",
    codepoint: "F743",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M16.91,18.12C14.09,18.12 18.43,2.13 18.43,2.13H15.53C15.53,2.13 14.34,5.89 13.55,10.07H11.05C11.11,9.21 11.15,8.34 11.13,7.5C11,0.59 7,1.87 5.18,3.45C3.47,4.95 2.03,7.8 2,10C2.27,10 3.35,10 3.35,10C3.35,10 4.25,5.88 7.07,5.88C9.89,5.88 5.54,21.87 5.54,21.87H8.45C8.45,21.87 9.95,17.59 10.7,12.81L13.09,12.8C12.95,14.04 12.91,15.4 12.93,16.67C13.04,23.56 17.06,22.08 18.86,20.5C20.67,18.92 22,15.58 22,14H20.61C20.62,14.12 19.73,18.12 16.91,18.12V18.12Z",
  },
  {
    id: "C8D5186F-BF39-40DA-9F7A-747DB166EABD",
    name: "ice-cream",
    codepoint: "F829",
    aliases: [],
    tags: ["Food / Drink"],
    author: "Cody",
    version: "2.1.19",
    path: "M12,2C14.21,2 16,3.79 16,6.05C17.14,6.28 18,7.29 18,8.5C18,9.88 16.88,11 15.5,11H8.5C7.12,11 6,9.88 6,8.5C6,7.29 6.86,6.28 8,6C8,3.79 9.79,2 12,2M9,12H15L13,22H11L9,12Z",
  },
  {
    id: "3238BA72-FEE8-4C90-A440-AD701359A7BC",
    name: "image",
    codepoint: "F2E9",
    aliases: ["insert-photo"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M8.5,13.5L11,16.5L14.5,12L19,18H5M21,19V5C21,3.89 20.1,3 19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19Z",
  },
  {
    id: "DD2262AA-A145-4788-899D-46D807B4FC0D",
    name: "image-album",
    codepoint: "F2EA",
    aliases: ["photo-album"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M6,19L9,15.14L11.14,17.72L14.14,13.86L18,19H6M6,4H11V12L8.5,10.5L6,12M18,2H6C4.9,2 4,2.9 4,4V20C4,21.1 4.9,22 6,22H18C19.1,22 20,21.1 20,20V4C20,2.9 19.1,2 18,2Z",
  },
  {
    id: "D23B9039-C6D4-45F8-B625-EEDE883FF5BD",
    name: "image-area",
    codepoint: "F2EB",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M20,5C21.1,5 22,5.9 22,7V17C22,18.1 21.1,19 20,19H4C2.89,19 2,18.1 2,17V7C2,5.89 2.89,5 4,5H20M5,16H19L14.5,10L11,14.5L8.5,11.5L5,16Z",
  },
  {
    id: "3BE3AA75-C604-45F3-9DD3-5E8731201F08",
    name: "image-area-close",
    codepoint: "F2EC",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,23L8,19H16L12,23M20,3C21.1,3 22,3.9 22,5V15C22,16.1 21.1,17 20,17H4C2.9,17 2,16.1 2,15V5C2,3.9 2.9,3 4,3H20M5,14H19L14.5,8L11,12.5L8.5,9.5L5,14Z",
  },
  {
    id: "40DCC37F-8A3F-4C15-97E8-2AB88B4DC756",
    name: "image-broken",
    codepoint: "F2ED",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M19,3C20.1,3 21,3.9 21,5V11H19V13H19L17,13V15H15V17H13V19H11V21H5C3.89,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3H19M21,15V19C21,20.1 20.1,21 19,21H19L15,21V19H17V17H19V15H21M19,8.5C19,8.22 18.78,8 18.5,8H5.5C5.22,8 5,8.22 5,8.5V15.5C5,15.78 5.22,16 5.5,16H11V15H13V13H15V11H17V9H19V8.5Z",
  },
  {
    id: "D243B11E-D824-4185-B14F-B1C53DB11C24",
    name: "image-broken-variant",
    codepoint: "F2EE",
    aliases: ["broken-image"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M21,5V11.59L18,8.58L14,12.59L10,8.59L6,12.59L3,9.58V5C3,3.9 3.9,3 5,3H19C20.1,3 21,3.9 21,5M18,11.42L21,14.43V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V12.42L6,15.41L10,11.41L14,15.41",
  },
  {
    id: "7D3932BA-9061-40D7-B624-044EE7A7B445",
    name: "image-filter-black-white",
    codepoint: "F2F0",
    aliases: ["filter-b-and-w"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M19,19L12,11V19H5L12,11V5H19M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3Z",
  },
  {
    id: "E3745997-1AD2-4D79-83FE-72ADE96E3C69",
    name: "image-filter-center-focus",
    codepoint: "F2F1",
    aliases: ["image-filter-centre-focus"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M12,9C10.34,9 9,10.34 9,12C9,13.66 10.34,15 12,15C13.66,15 15,13.66 15,12C15,10.34 13.66,9 12,9M19,19H15V21H19C20.1,21 21,20.1 21,19V15H19M19,3H15V5H19V9H21V5C21,3.9 20.1,3 19,3M5,5H9V3H5C3.9,3 3,3.9 3,5V9H5M5,15H3V19C3,20.1 3.9,21 5,21H9V19H5V15Z",
  },
  {
    id: "50F3F396-4286-4D09-B726-4F626649BC04",
    name: "image-filter-center-focus-weak",
    codepoint: "F2F2",
    aliases: ["image-filter-centre-focus-weak"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M5,15H3V19C3,20.1 3.9,21 5,21H9V19H5M5,5H9V3H5C3.9,3 3,3.9 3,5V9H5M19,3H15V5H19V9H21V5C21,3.9 20.1,3 19,3M19,19H15V21H19C20.1,21 21,20.1 21,19V15H19M12,8C9.79,8 8,9.79 8,12C8,14.21 9.79,16 12,16C14.21,16 16,14.21 16,12C16,9.79 14.21,8 12,8M12,14C10.9,14 10,13.1 10,12C10,10.9 10.9,10 12,10C13.1,10 14,10.9 14,12C14,13.1 13.1,14 12,14Z",
  },
  {
    id: "882F82B8-EDF8-4F1A-A6BA-9C6DAEDBB259",
    name: "image-filter-drama",
    codepoint: "F2F3",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M19,18H6C3.79,18 2,16.21 2,14C2,11.79 3.79,10 6,10C8.21,10 10,11.79 10,14H12C12,11.24 10.14,8.92 7.6,8.22C8.61,6.88 10.2,6 12,6C15.03,6 17.5,8.47 17.5,11.5V12H19C20.66,12 22,13.34 22,15C22,16.66 20.66,18 19,18M19.35,10.04C18.67,6.59 15.64,4 12,4C9.11,4 6.61,5.64 5.36,8.04C2.35,8.36 0,10.9 0,14C0,17.31 2.69,20 6,20H19C21.76,20 24,17.76 24,15C24,12.36 21.95,10.22 19.35,10.04Z",
  },
  {
    id: "8EC8847F-E96F-4D14-BF88-F4BE47856865",
    name: "image-filter-frames",
    codepoint: "F2F4",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M18,8H6V18H18M20,20H4V6H8.5L12.04,2.5L15.5,6H20M20,4H16L12,0L8,4H4C2.9,4 2,4.9 2,6V20C2,21.1 2.9,22 4,22H20C21.1,22 22,21.1 22,20V6C22,4.9 21.1,4 20,4Z",
  },
  {
    id: "999CF81E-71B7-48E1-8B8F-70FDE391F647",
    name: "image-filter-hdr",
    codepoint: "F2F5",
    aliases: ["mountain", "landscape"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M14,6L10.25,11L13.1,14.8L11.5,16C9.81,13.75 7,10 7,10L1,18H23L14,6Z",
  },
  {
    id: "56164312-7555-4017-8A1A-48954BE7F7C5",
    name: "image-filter-none",
    codepoint: "F2F6",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M21,17H7V3H21M21,1H7C5.9,1 5,1.9 5,3V17C5,18.1 5.9,19 7,19H21C22.1,19 23,18.1 23,17V3C23,1.9 22.1,1 21,1M3,5H1V21C1,22.1 1.9,23 3,23H19V21H3V5Z",
  },
  {
    id: "368537EA-9261-4097-A1FA-D33EE48A7D59",
    name: "image-filter-tilt-shift",
    codepoint: "F2F7",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M5.68,19.74C7.16,20.95 9,21.75 11,21.95V19.93C9.54,19.75 8.21,19.17 7.1,18.31M13,19.93V21.95C15,21.75 16.84,20.95 18.32,19.74L16.89,18.31C15.79,19.17 14.46,19.75 13,19.93M18.31,16.9L19.74,18.33C20.95,16.85 21.75,15 21.95,13H19.93C19.75,14.46 19.17,15.79 18.31,16.9M15,12C15,10.34 13.66,9 12,9C10.34,9 9,10.34 9,12C9,13.66 10.34,15 12,15C13.66,15 15,13.66 15,12M4.07,13H2.05C2.25,15 3.05,16.84 4.26,18.32L5.69,16.89C4.83,15.79 4.25,14.46 4.07,13M5.69,7.1L4.26,5.68C3.05,7.16 2.25,9 2.05,11H4.07C4.25,9.54 4.83,8.21 5.69,7.1M19.93,11H21.95C21.75,9 20.95,7.16 19.74,5.68L18.31,7.1C19.17,8.21 19.75,9.54 19.93,11M18.32,4.26C16.84,3.05 15,2.25 13,2.05V4.07C14.46,4.25 15.79,4.83 16.9,5.69M11,4.07V2.05C9,2.25 7.16,3.05 5.68,4.26L7.1,5.69C8.21,4.83 9.54,4.25 11,4.07Z",
  },
  {
    id: "0E6F8B1C-14D2-4A98-9414-FFC4B2146748",
    name: "image-filter-vintage",
    codepoint: "F2F8",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M12,16C9.79,16 8,14.21 8,12C8,9.79 9.79,8 12,8C14.21,8 16,9.79 16,12C16,14.21 14.21,16 12,16M18.7,12.4C18.42,12.24 18.13,12.11 17.84,12C18.13,11.89 18.42,11.76 18.7,11.6C20.62,10.5 21.69,8.5 21.7,6.41C19.91,5.38 17.63,5.3 15.7,6.41C15.42,6.57 15.16,6.76 14.92,6.95C14.97,6.64 15,6.32 15,6C15,3.78 13.79,1.85 12,0.81C10.21,1.85 9,3.78 9,6C9,6.32 9.03,6.64 9.08,6.95C8.84,6.75 8.58,6.56 8.3,6.4C6.38,5.29 4.1,5.37 2.3,6.4C2.3,8.47 3.37,10.5 5.3,11.59C5.58,11.75 5.87,11.88 6.16,12C5.87,12.1 5.58,12.23 5.3,12.39C3.38,13.5 2.31,15.5 2.3,17.58C4.09,18.61 6.37,18.69 8.3,17.58C8.58,17.42 8.84,17.23 9.08,17.04C9.03,17.36 9,17.68 9,18C9,20.22 10.21,22.15 12,23.19C13.79,22.15 15,20.22 15,18C15,17.68 14.97,17.36 14.92,17.05C15.16,17.25 15.42,17.43 15.7,17.59C17.62,18.7 19.9,18.62 21.7,17.59C21.69,15.5 20.62,13.5 18.7,12.4Z",
  },
  {
    id: "4E0C0467-BF17-4C60-8834-4627DE6D79D5",
    name: "image-move",
    codepoint: "F9F7",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.5.94",
    path: "M15,3H19V0L24,5L19,10V7H15V3M21,11.94V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3H12.06C12,3.33 12,3.67 12,4C12,8.42 15.58,12 20,12C20.33,12 20.67,12 21,11.94M19,18L14.5,12L11,16.5L8.5,13.5L5,18H19Z",
  },
  {
    id: "E7CA4672-9863-4015-B3C5-D2C8DEBD2F2F",
    name: "image-multiple",
    codepoint: "F2F9",
    aliases: ["collections", "photo-library"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M22,16V4C22,2.9 21.1,2 20,2H8C6.9,2 6,2.9 6,4V16C6,17.1 6.9,18 8,18H20C21.1,18 22,17.1 22,16M11,12L13.03,14.71L16,11L20,16H8M2,6V20C2,21.1 2.9,22 4,22H18V20H4V6",
  },
  {
    id: "73924BC5-DB17-49B2-BB88-E40C1E45E010",
    name: "image-off",
    codepoint: "F82A",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "2.1.19",
    path: "M2.28,3L1,4.27L3,6.27V19C3,20.1 3.9,21 5,21H17.73L19.73,23L21,21.72L2.28,3M4.83,3L21,19.17V5C21,3.89 20.1,3 19,3H4.83M8.5,13.5L11,16.5L12,15.25L14.73,18H5L8.5,13.5Z",
  },
  {
    id: "F6A782BB-5FAB-4FC4-A61B-A0F399A0A5AC",
    name: "image-outline",
    codepoint: "F975",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "2.4.85",
    path: "M19,19H5V5H19M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3M13.96,12.29L11.21,15.83L9.25,13.47L6.5,17H17.5L13.96,12.29Z",
  },
  {
    id: "8D6FECF2-E4C4-4858-81E2-502104BE2E55",
    name: "image-plus",
    codepoint: "F87B",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "2.1.99",
    path: "M5,3C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H14.09C14.03,20.67 14,20.34 14,20C14,19.32 14.12,18.64 14.35,18H5L8.5,13.5L11,16.5L14.5,12L16.73,14.97C17.7,14.34 18.84,14 20,14C20.34,14 20.67,14.03 21,14.09V5C21,3.89 20.1,3 19,3H5M19,16V19H16V21H19V24H21V21H24V19H21V16H19Z",
  },
  {
    id: "F00F5E5A-AD8A-440B-9B31-00D266A538A8",
    name: "image-search",
    codepoint: "F976",
    aliases: [],
    tags: [],
    author: "Google",
    version: "2.4.85",
    path: "M15.5,2C18,2 20,4 20,6.5C20,7.38 19.75,8.21 19.31,8.9L22.39,12L21,13.39L17.88,10.32C17.19,10.75 16.37,11 15.5,11C13,11 11,9 11,6.5C11,4 13,2 15.5,2M15.5,4C14.12,4 13,5.12 13,6.5C13,7.88 14.12,9 15.5,9C16.88,9 18,7.88 18,6.5C18,5.12 16.88,4 15.5,4M7.5,14.5L4,19H18L13.5,13L10,17.5L7.5,14.5M20,20C20,21.1 19.1,22 18,22H4C2.9,22 2,21.1 2,20V6C2,4.9 2.9,4 4,4H9.5C9.18,4.77 9,5.61 9,6.5C9,10.09 11.91,13 15.5,13C16.18,13 16.84,12.89 17.46,12.7L20,15.24V20Z",
  },
  {
    id: "A36A87C1-E35B-4BCA-AD53-700F6F937EE8",
    name: "image-search-outline",
    codepoint: "F977",
    aliases: [],
    tags: [],
    author: "Google",
    version: "2.4.85",
    path: "M15.5,9C16.2,9 16.79,8.76 17.27,8.27C17.76,7.79 18,7.2 18,6.5C18,5.83 17.76,5.23 17.27,4.73C16.79,4.23 16.2,4 15.5,4C14.83,4 14.23,4.23 13.73,4.73C13.23,5.23 13,5.83 13,6.5C13,7.2 13.23,7.79 13.73,8.27C14.23,8.76 14.83,9 15.5,9M19.31,8.91L22.41,12L21,13.41L17.86,10.31C17.08,10.78 16.28,11 15.47,11C14.22,11 13.16,10.58 12.3,9.7C11.45,8.83 11,7.77 11,6.5C11,5.27 11.45,4.2 12.33,3.33C13.2,2.45 14.27,2 15.5,2C16.77,2 17.83,2.45 18.7,3.33C19.58,4.2 20,5.27 20,6.5C20,7.33 19.78,8.13 19.31,8.91M16.5,18H5.5L8.25,14.5L10.22,16.83L12.94,13.31L16.5,18M18,13L20,15V20C20,20.55 19.81,21 19.41,21.4C19,21.79 18.53,22 18,22H4C3.45,22 3,21.79 2.6,21.4C2.21,21 2,20.55 2,20V6C2,5.47 2.21,5 2.6,4.59C3,4.19 3.45,4 4,4H9.5C9.2,4.64 9.03,5.31 9,6H4V20H18V13Z",
  },
  {
    id: "FB8BEE36-EF77-4820-92B3-5B4C4291D751",
    name: "import",
    codepoint: "F2FA",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M14,12L10,8V11H2V13H10V16M20,18V6C20,4.89 19.1,4 18,4H6C4.9,4 4,4.9 4,6V9H6V6H18V18H6V15H4V18C4,19.1 4.9,20 6,20H18C19.1,20 20,19.1 20,18Z",
  },
  {
    id: "4DDB79C2-C3AE-41DC-B560-AFBF3F689E86",
    name: "inbox",
    codepoint: "F686",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.7.12",
    path: "M19,15H15C15,16.66 13.66,18 12,18C10.34,18 9,16.66 9,15H5V5H19M19,3H5C3.89,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3Z",
  },
  {
    id: "A20D1ABC-DD99-404B-8BEE-967BB1C636B0",
    name: "inbox-arrow-down",
    codepoint: "F2FB",
    aliases: ["move-to-inbox"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M16,10H14V7H10V10H8L12,14M19,15H15C15,16.66 13.66,18 12,18C10.34,18 9,16.66 9,15H5V5H19M19,3H5C3.89,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3Z",
  },
  {
    id: "5317ED5A-9D37-4C50-AA7D-83491547D214",
    name: "inbox-arrow-up",
    codepoint: "F3D1",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M14,14H10V11H8L12,7L16,11H14V14M16,11M5,15V5H19V15H15C15,16.66 13.66,18 12,18C10.34,18 9,16.66 9,15H5M19,3H5C3.89,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3",
  },
  {
    id: "6FF18A17-48D4-4173-9CBD-8DB77F5A6E2A",
    name: "inbox-multiple",
    codepoint: "F8AF",
    aliases: [],
    tags: [],
    author: "Google",
    version: "2.2.43",
    path: "M19,8V5H5V8H9C9,9.66 10.34,11 12,11C13.66,11 15,9.66 15,8H19M19,3C20.1,3 21,3.9 21,5V12C21,13.1 20.1,14 19,14H5C3.9,14 3,13.1 3,12V5C3,3.9 3.9,3 5,3H19M3,15H9C9,16.66 10.34,18 12,18C13.66,18 15,16.66 15,15H21V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V15Z",
  },
  {
    id: "1350E7BA-9354-4F62-9B21-0238E3DF4D81",
    name: "incognito",
    codepoint: "F5F9",
    aliases: [],
    tags: [],
    author: "Christopher Schreiner",
    version: "1.5.54",
    path: "M12,3C9.31,3 7.41,4.22 7.41,4.22L6,9H18L16.59,4.22C16.59,4.22 14.69,3 12,3M12,11C9.27,11 5.39,11.54 5.13,11.59C4.09,11.87 3.25,12.15 2.59,12.41C1.58,12.75 1,13 1,13H23C23,13 22.42,12.75 21.41,12.41C20.75,12.15 19.89,11.87 18.84,11.59C18.84,11.59 14.82,11 12,11M7.5,14C5.57,14 4,15.57 4,17.5C4,19.43 5.57,21 7.5,21C9.43,21 11,19.43 11,17.5C11,17.34 11,17.18 10.97,17.03C11.29,16.96 11.63,16.9 12,16.91C12.37,16.91 12.71,16.96 13.03,17.03C13,17.18 13,17.34 13,17.5C13,19.43 14.57,21 16.5,21C18.43,21 20,19.43 20,17.5C20,15.57 18.43,14 16.5,14C15.03,14 13.77,14.9 13.25,16.19C12.93,16.09 12.55,16 12,16C11.45,16 11.07,16.09 10.75,16.19C10.23,14.9 8.97,14 7.5,14M7.5,15C8.88,15 10,16.12 10,17.5C10,18.88 8.88,20 7.5,20C6.12,20 5,18.88 5,17.5C5,16.12 6.12,15 7.5,15M16.5,15C17.88,15 19,16.12 19,17.5C19,18.88 17.88,20 16.5,20C15.12,20 14,18.88 14,17.5C14,16.12 15.12,15 16.5,15Z",
  },
  {
    id: "8C4EBD04-376D-41AC-86D3-2BBDD56768C7",
    name: "infinity",
    codepoint: "F6E3",
    aliases: [],
    tags: ["Math"],
    author: "Austin Andrews",
    version: "1.8.36",
    path: "M18.6,6.62C21.58,6.62 24,9 24,12C24,14.96 21.58,17.37 18.6,17.37C17.15,17.37 15.8,16.81 14.78,15.8L12,13.34L9.17,15.85C8.2,16.82 6.84,17.38 5.4,17.38C2.42,17.38 0,14.96 0,12C0,9.04 2.42,6.62 5.4,6.62C6.84,6.62 8.2,7.18 9.22,8.2L12,10.66L14.83,8.15C15.8,7.18 17.16,6.62 18.6,6.62M7.8,14.39L10.5,12L7.84,9.65C7.16,8.97 6.31,8.62 5.4,8.62C3.53,8.62 2,10.13 2,12C2,13.87 3.53,15.38 5.4,15.38C6.31,15.38 7.16,15.03 7.8,14.39M16.2,9.61L13.5,12L16.16,14.35C16.84,15.03 17.7,15.38 18.6,15.38C20.47,15.38 22,13.87 22,12C22,10.13 20.47,8.62 18.6,8.62C17.69,8.62 16.84,8.97 16.2,9.61Z",
  },
  {
    id: "2BC4A4B6-119B-4637-BF3D-1FB9394E1F38",
    name: "information",
    codepoint: "F2FC",
    aliases: ["about"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M13,9H11V7H13M13,17H11V11H13M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z",
  },
  {
    id: "F7C01A96-16E0-44C0-A261-2CF22D056A7F",
    name: "information-outline",
    codepoint: "F2FD",
    aliases: ["info-outline", "about-outline"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M11,17H13V11H11V17Z",
  },
  {
    id: "D991D5FA-BD60-48E1-979D-A103D005725A",
    name: "information-variant",
    codepoint: "F64E",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.6.50",
    path: "M13.5,4C12.67,4 12,4.67 12,5.5C12,6.33 12.67,7 13.5,7C14.33,7 15,6.33 15,5.5C15,4.67 14.33,4 13.5,4M13.14,8.77C11.95,8.87 8.7,11.46 8.7,11.46C8.5,11.61 8.56,11.6 8.72,11.88C8.88,12.15 8.86,12.17 9.05,12.04C9.25,11.91 9.58,11.7 10.13,11.36C12.25,10 10.47,13.14 9.56,18.43C9.2,21.05 11.56,19.7 12.17,19.3C12.77,18.91 14.38,17.8 14.54,17.69C14.76,17.54 14.6,17.42 14.43,17.17C14.31,17 14.19,17.12 14.19,17.12C13.54,17.55 12.35,18.45 12.19,17.88C12,17.31 13.22,13.4 13.89,10.71C14,10.07 14.3,8.67 13.14,8.77Z",
  },
  {
    id: "2AA07220-461B-4070-AA95-17DEFE501444",
    name: "instagram",
    codepoint: "F2FE",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Google",
    version: "1.5.54",
    path: "M7.8,2H16.2C19.4,2 22,4.6 22,7.8V16.2C22,19.4 19.4,22 16.2,22H7.8C4.6,22 2,19.4 2,16.2V7.8C2,4.6 4.6,2 7.8,2M7.6,4C5.61,4 4,5.61 4,7.6V16.4C4,18.39 5.61,20 7.6,20H16.4C18.39,20 20,18.39 20,16.4V7.6C20,5.61 18.39,4 16.4,4H7.6M17.25,5.5C17.94,5.5 18.5,6.06 18.5,6.75C18.5,7.44 17.94,8 17.25,8C16.56,8 16,7.44 16,6.75C16,6.06 16.56,5.5 17.25,5.5M12,7C14.76,7 17,9.24 17,12C17,14.76 14.76,17 12,17C9.24,17 7,14.76 7,12C7,9.24 9.24,7 12,7M12,9C10.34,9 9,10.34 9,12C9,13.66 10.34,15 12,15C13.66,15 15,13.66 15,12C15,10.34 13.66,9 12,9Z",
  },
  {
    id: "2B0100AC-D0EB-4B85-A9AB-EB921C9A65AC",
    name: "invert-colors",
    codepoint: "F301",
    aliases: ["invert-colours"],
    tags: ["Color"],
    author: "Google",
    version: "1.5.54",
    path: "M12,19.58V19.58C10.4,19.58 8.89,18.96 7.76,17.83C6.62,16.69 6,15.19 6,13.58C6,12 6.62,10.47 7.76,9.34L12,5.1M17.66,7.93L12,2.27V2.27L6.34,7.93C3.22,11.05 3.22,16.12 6.34,19.24C7.9,20.8 9.95,21.58 12,21.58C14.05,21.58 16.1,20.8 17.66,19.24C20.78,16.12 20.78,11.05 17.66,7.93Z",
  },
  {
    id: "94C88D65-EE50-4DC5-920D-FA4181DE0413",
    name: "islam",
    codepoint: "F978",
    aliases: ["religion-islamic", "star-and-crescent", "religion-muslim"],
    tags: ["Religion"],
    author: "Nick",
    version: "2.4.85",
    path: "M12.3,2C12.2,2 12.1,2 12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C15,22 16.7,21 18.5,19.5C13,21 8,17 8,12C8,7 13,3 18.5,4.5C16.86,2.86 14.62,1.96 12.3,2M16.8,6.2L15.3,9.7L11.6,10L14.5,12.5L13.6,16L16.8,14L20,16L19,12.5L22,10L18.3,9.7L16.8,6.2Z",
  },
  {
    id: "2C0278A5-D43D-4B8B-8870-878BEAF6BE17",
    name: "jeepney",
    codepoint: "F302",
    aliases: [],
    tags: ["Transportation + Road"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M19,13V7H20V4H4V7H5V13H2C2,13.93 2.5,14.71 3.5,14.93V20C3.5,20.55 3.95,21 4.5,21H5.5C6.05,21 6.5,20.55 6.5,20V19H17.5V20C17.5,20.55 17.95,21 18.5,21H19.5C20.05,21 20.5,20.55 20.5,20V14.93C21.5,14.7 22,13.93 22,13H19M8,15C7.17,15 6.5,14.33 6.5,13.5C6.5,12.67 7.17,12 8,12C8.83,12 9.5,12.67 9.5,13.5C9.5,14.33 8.83,15 8,15M16,15C15.17,15 14.5,14.33 14.5,13.5C14.5,12.67 15.17,12 16,12C16.83,12 17.5,12.67 17.5,13.5C17.5,14.33 16.83,15 16,15M17.5,10.5C15.92,10.18 14.03,10 12,10C9.97,10 8,10.18 6.5,10.5V7H17.5V10.5Z",
  },
  {
    id: "2F0CB359-6C54-4723-9E8D-94481F0A8E30",
    name: "jira",
    codepoint: "F303",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M11.53,2C11.53,4.4 13.5,6.35 15.88,6.35H17.66V8.05C17.66,10.45 19.6,12.39 22,12.4V2.84C22,2.38 21.62,2 21.16,2H11.53M6.77,6.8C6.78,9.19 8.72,11.13 11.11,11.14H12.91V12.86C12.92,15.25 14.86,17.19 17.25,17.2V7.63C17.24,7.17 16.88,6.81 16.42,6.8H6.77M2,11.6C2,14 3.95,15.94 6.35,15.94H8.13V17.66C8.14,20.05 10.08,22 12.47,22V12.43C12.47,11.97 12.09,11.59 11.63,11.59L2,11.6Z",
  },
  {
    id: "3A14C142-9D2F-44BC-882E-333745FACAA3",
    name: "jquery",
    codepoint: "F87C",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Contributors",
    version: "2.1.99",
    path: "M22.88,10.41C20.77,12.18 17.61,11.9 15.84,9.79C14.06,7.67 14.34,4.5 16.45,2.75L16.96,2.37C15.27,4.19 15.16,7.03 16.8,9C18.43,10.94 21.25,11.32 23.34,9.97L22.88,10.41M21.1,14.5C17.93,17.17 13.2,16.76 10.54,13.58C7.87,10.41 8.29,5.68 11.46,3L12.38,2.36C9.96,5.09 9.84,9.26 12.26,12.14C14.68,15 18.8,15.63 21.91,13.72L21.1,14.5M19.97,19.38C15.53,23.11 8.9,22.53 5.17,18.08C1.45,13.64 2.03,7 6.47,3.29L7.58,2.5C4.07,6.3 3.85,12.23 7.28,16.32C10.71,20.4 16.59,21.22 20.96,18.43L19.97,19.38Z",
  },
  {
    id: "B6B10BEF-B1E3-43D7-AAAA-85566157B30B",
    name: "jsfiddle",
    codepoint: "F304",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M16.45,17.5C17.45,17.5 18.3,17.15 19,16.5C19.67,15.8 20,15 20,14C20,13.05 19.66,12.22 18.96,11.53C18.26,10.84 17.41,10.5 16.41,10.5C15.47,10.5 14.64,10.83 13.92,11.5L9.14,15.56C8.7,16 8.17,16.22 7.55,16.22C6.92,16.22 6.39,16 5.95,15.56C5.5,15.13 5.3,14.61 5.3,14C5.3,13.42 5.5,12.91 5.95,12.47C6.39,12.03 6.92,11.81 7.55,11.81C8.14,11.81 8.69,12.03 9.19,12.47L9.94,13.13L10.92,12.23L10.08,11.53C9.39,10.84 8.55,10.5 7.55,10.5C6.58,10.5 5.74,10.84 5.04,11.53C4.34,12.22 4,13.05 4,14C4,15 4.34,15.8 5.04,16.5C5.74,17.15 6.59,17.5 7.59,17.5C8.53,17.5 9.36,17.16 10.08,16.5L14.86,12.42C15.27,12 15.8,11.81 16.45,11.81C17.08,11.81 17.61,12.03 18.05,12.47C18.5,12.91 18.7,13.42 18.7,14C18.7,14.61 18.5,15.13 18.05,15.56C17.61,16 17.08,16.22 16.45,16.22C15.89,16.22 15.34,16 14.81,15.5L14.06,14.86L13.08,15.75L13.92,16.45C14.61,17.14 15.45,17.5 16.45,17.5M19.36,10.03C20.64,10.13 21.73,10.65 22.64,11.6C23.55,12.55 24,13.69 24,15C24,16.38 23.5,17.55 22.5,18.54C21.54,19.5 20.36,20 19,20H6C4.34,20 2.93,19.43 1.76,18.26C0.59,17.09 0,15.67 0,14C0,12.55 0.5,11.23 1.57,10.05C2.62,8.88 3.88,8.22 5.34,8.06C6,6.84 6.92,5.86 8.11,5.11C9.3,4.36 10.59,4 12,4C13.69,4 15.26,4.58 16.71,5.77C18.16,6.95 19.05,8.38 19.36,10.03Z",
  },
  {
    id: "7EF95029-012C-456C-A1E8-BB96961071FD",
    name: "judaism",
    codepoint: "F979",
    aliases: ["jewish", "religion-judaic", "star-of-david", "magen-david"],
    tags: ["Religion"],
    author: "Nick",
    version: "2.4.85",
    path: "M12,2L9.1,7H3.3L6.3,12L3.3,17H9.1L12,22L14.9,17H20.7L17.7,12L20.7,7H14.9L12,2M12,5L13.2,7H10.8L12,5M8.2,8.5L7.1,10.5L5.9,8.5H8.2M10,8.5H14L16,12L14,15.5H10L8,12L10,8.5M18,8.5L16.8,10.5L15.7,8.5H18M7.1,13.5L8.2,15.5H6L7.1,13.5M16.9,13.5L18.1,15.5H15.8L16.9,13.5M13.3,17L12,19L10.8,17H13.3Z",
  },
  {
    id: "85144563-B019-4B8A-AB76-3DE0797D517E",
    name: "karate",
    codepoint: "F82B",
    aliases: ["martial-arts"],
    tags: ["Sport"],
    author: "Michael Richins",
    version: "2.1.19",
    path: "M19,1.27C18.04,0.72 16.82,1.04 16.27,2C15.71,2.95 16.04,4.18 17,4.73C17.95,5.28 19.17,4.96 19.73,4C20.28,3.04 19.95,1.82 19,1.27M21.27,9.34L18.7,13.79L16.96,12.79L18.69,9.79L17.14,8.5L14,13.92V22H12V13.39L2.47,7.89L3.47,6.16L11.27,10.66L13.67,6.5L7.28,4.17L8,2.29L14.73,4.74L15,4.84C15.39,5 15.76,5.15 16.12,5.35L16.96,5.84C17.31,6.04 17.65,6.28 17.96,6.54L18.19,6.74L21.27,9.34Z",
  },
  {
    id: "EEF9C07A-019A-49B4-805D-0DF8601F09DF",
    name: "keg",
    codepoint: "F305",
    aliases: [],
    tags: ["Food / Drink"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M5,22V20H6V16H5V14H6V11H5V7H11V3H10V2H11L13,2H14V3H13V7H19V11H18V14H19V16H18V20H19V22H5M17,9C17,8.45 16.55,8 16,8H14C13.45,8 13,8.45 13,9C13,9.55 13.45,10 14,10H16C16.55,10 17,9.55 17,9Z",
  },
  {
    id: "C4476901-9B29-410C-BCA7-67814F5421B4",
    name: "kettle",
    codepoint: "F5FA",
    aliases: [],
    tags: ["Home Automation", "Food / Drink"],
    author: "Cody",
    version: "1.5.54",
    path: "M12.5,3C7.81,3 4,5.69 4,9V9C4,10.19 4.5,11.34 5.44,12.33C4.53,13.5 4,14.96 4,16.5C4,17.64 4,18.83 4,20C4,21.11 4.89,22 6,22H19C20.11,22 21,21.11 21,20C21,18.85 21,17.61 21,16.5C21,15.28 20.66,14.07 20,13L22,11L19,8L16.9,10.1C15.58,9.38 14.05,9 12.5,9C10.65,9 8.95,9.53 7.55,10.41C7.19,9.97 7,9.5 7,9C7,7.21 9.46,5.75 12.5,5.75V5.75C13.93,5.75 15.3,6.08 16.33,6.67L18.35,4.65C16.77,3.59 14.68,3 12.5,3M12.5,11C12.84,11 13.17,11.04 13.5,11.09C10.39,11.57 8,14.25 8,17.5V20H6V17.5C6,13.91 8.91,11 12.5,11Z",
  },
  {
    id: "D6208581-CF7F-438A-8578-B6ADEE462212",
    name: "key",
    codepoint: "F306",
    aliases: ["vpn-key"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M7,14C5.9,14 5,13.1 5,12C5,10.9 5.9,10 7,10C8.1,10 9,10.9 9,12C9,13.1 8.1,14 7,14M12.65,10C11.83,7.67 9.61,6 7,6C3.69,6 1,8.69 1,12C1,15.31 3.69,18 7,18C9.61,18 11.83,16.33 12.65,14H17V18H21V14H23V10H12.65Z",
  },
  {
    id: "FEEA71CA-4810-46DD-B459-6D9327720D17",
    name: "key-change",
    codepoint: "F307",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M6.5,2C8.46,2 10.13,3.25 10.74,5H22V8H18V11H15V8H10.74C10.13,9.75 8.46,11 6.5,11C4,11 2,9 2,6.5C2,4 4,2 6.5,2M6.5,5C5.67,5 5,5.67 5,6.5C5,7.33 5.67,8 6.5,8C7.33,8 8,7.33 8,6.5C8,5.67 7.33,5 6.5,5M6.5,13C8.46,13 10.13,14.25 10.74,16H22V19H20V22H18V19H16V22H13V19H10.74C10.13,20.75 8.46,22 6.5,22C4,22 2,20 2,17.5C2,15 4,13 6.5,13M6.5,16C5.67,16 5,16.67 5,17.5C5,18.33 5.67,19 6.5,19C7.33,19 8,18.33 8,17.5C8,16.67 7.33,16 6.5,16Z",
  },
  {
    id: "F58302B9-82F4-46AC-9A60-4640CFCE33B2",
    name: "key-minus",
    codepoint: "F308",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M6.5,3C8.46,3 10.13,4.25 10.74,6H22V9H18V12H15V9H10.74C10.13,10.75 8.46,12 6.5,12C4,12 2,10 2,7.5C2,5 4,3 6.5,3M6.5,6C5.67,6 5,6.67 5,7.5C5,8.33 5.67,9 6.5,9C7.33,9 8,8.33 8,7.5C8,6.67 7.33,6 6.5,6M8,17H16V19H8V17Z",
  },
  {
    id: "000AAEC6-5E6C-40F4-B589-AE85920E7EC2",
    name: "key-plus",
    codepoint: "F309",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M6.5,3C8.46,3 10.13,4.25 10.74,6H22V9H18V12H15V9H10.74C10.13,10.75 8.46,12 6.5,12C4,12 2,10 2,7.5C2,5 4,3 6.5,3M6.5,6C5.67,6 5,6.67 5,7.5C5,8.33 5.67,9 6.5,9C7.33,9 8,8.33 8,7.5C8,6.67 7.33,6 6.5,6M8,17H11V14H13V17H16V19H13V22H11V19H8V17Z",
  },
  {
    id: "5A1609F7-424E-417F-B1C4-7EDA3051A4BA",
    name: "key-remove",
    codepoint: "F30A",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M6.5,3C8.46,3 10.13,4.25 10.74,6H22V9H18V12H15V9H10.74C10.13,10.75 8.46,12 6.5,12C4,12 2,10 2,7.5C2,5 4,3 6.5,3M6.5,6C5.67,6 5,6.67 5,7.5C5,8.33 5.67,9 6.5,9C7.33,9 8,8.33 8,7.5C8,6.67 7.33,6 6.5,6M14.59,14L16,15.41L13.41,18L16,20.59L14.59,22L12,19.41L9.41,22L8,20.59L10.59,18L8,15.41L9.41,14L12,16.59L14.59,14Z",
  },
  {
    id: "967692C3-B061-425E-A0E4-FF1F580275E5",
    name: "key-variant",
    codepoint: "F30B",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M22,18V22H18V19H15V16H12L9.74,13.74C9.19,13.91 8.61,14 8,14C4.69,14 2,11.31 2,8C2,4.69 4.69,2 8,2C11.31,2 14,4.69 14,8C14,8.61 13.91,9.19 13.74,9.74L22,18M7,5C5.9,5 5,5.9 5,7C5,8.1 5.9,9 7,9C8.1,9 9,8.1 9,7C9,5.9 8.1,5 7,5Z",
  },
  {
    id: "520C8488-DD34-43E1-AEA0-A188B2DE6B01",
    name: "keyboard",
    codepoint: "F30C",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M19,10H17V8H19M19,13H17V11H19M16,10H14V8H16M16,13H14V11H16M16,17H8V15H16M7,10H5V8H7M7,13H5V11H7M8,11H10V13H8M8,8H10V10H8M11,11H13V13H11M11,8H13V10H11M20,5H4C2.89,5 2,5.89 2,7V17C2,18.1 2.9,19 4,19H20C21.1,19 22,18.1 22,17V7C22,5.89 21.1,5 20,5Z",
  },
  {
    id: "21C8B558-8398-43E8-A79A-8BA99BE693D6",
    name: "keyboard-backspace",
    codepoint: "F30D",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M21,11H6.83L10.41,7.41L9,6L3,12L9,18L10.41,16.58L6.83,13H21V11Z",
  },
  {
    id: "0F441009-7A1F-45BF-A239-B9591B0A5404",
    name: "keyboard-caps",
    codepoint: "F30E",
    aliases: ["keyboard-capslock"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M6,18H18V16H6M12,8.41L16.59,13L18,11.58L12,5.58L6,11.58L7.41,13L12,8.41Z",
  },
  {
    id: "8545C0A1-5625-422F-AF38-624FB54237D3",
    name: "keyboard-close",
    codepoint: "F30F",
    aliases: ["keyboard-hide"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M12,23L16,19H8M19,8H17V6H19M19,11H17V9H19M16,8H14V6H16M16,11H14V9H16M16,15H8V13H16M7,8H5V6H7M7,11H5V9H7M8,9H10V11H8M8,6H10V8H8M11,9H13V11H11M11,6H13V8H11M20,3H4C2.89,3 2,3.89 2,5V15C2,16.1 2.9,17 4,17H20C21.1,17 22,16.1 22,15V5C22,3.89 21.1,3 20,3Z",
  },
  {
    id: "A7DFF78C-C6DD-4BB6-BBFA-A88242516A74",
    name: "keyboard-off",
    codepoint: "F310",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M1,4.27L2.28,3L20,20.72L18.73,22L15.73,19H4C2.89,19 2,18.1 2,17V7C2,6.5 2.18,6.07 2.46,5.73L1,4.27M19,10V8H17V10H19M19,13V11H17V13H19M16,10V8H14V10H16M16,13V11H14V12.18L11.82,10H13V8H11V9.18L9.82,8L6.82,5H20C21.1,5 22,5.9 22,7V17C22,17.86 21.46,18.59 20.7,18.87L14.82,13H16M8,15V17H13.73L11.73,15H8M5,10H6.73L5,8.27V10M7,13V11H5V13H7M8,13H9.73L8,11.27V13Z",
  },
  {
    id: "6E751B9F-72AD-4554-8C62-24E457B80FDB",
    name: "keyboard-outline",
    codepoint: "F97A",
    aliases: [],
    tags: [],
    author: "Google",
    version: "2.4.85",
    path: "M4,5C2.9,5 2,5.9 2,7V17C2,18.1 2.9,19 4,19H20C21.1,19 22,18.1 22,17V7C22,5.9 21.1,5 20,5H4M4,7H20V17H4V7M5,8V10H7V8H5M8,8V10H10V8H8M11,8V10H13V8H11M14,8V10H16V8H14M17,8V10H19V8H17M5,11V13H7V11H5M8,11V13H10V11H8M11,11V13H13V11H11M14,11V13H16V11H14M17,11V13H19V11H17M8,14V16H16V14H8Z",
  },
  {
    id: "7816CE91-EBD1-4136-8523-CF47F677F4C6",
    name: "keyboard-return",
    codepoint: "F311",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M19,7V11H5.83L9.41,7.41L8,6L2,12L8,18L9.41,16.58L5.83,13H21V7H19Z",
  },
  {
    id: "4894BA3C-C713-4ACA-9918-1AF74B5E5427",
    name: "keyboard-settings",
    codepoint: "F9F8",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.5.94",
    path: "M19,10H17V8H19M19,13H17V11H19M16,10H14V8H16M16,13H14V11H16M16,17H8V15H16M7,10H5V8H7M7,13H5V11H7M8,11H10V13H8M8,8H10V10H8M11,11H13V13H11M11,8H13V10H11M20,5H4C2.9,5 2,5.9 2,7V17C2,18.1 2.9,19 4,19H20C21.1,19 22,18.1 22,17V7C22,5.9 21.1,5 20,5M7,22H9V24H7V22M11,22H13V24H11V22M15,22H17V24H15V22Z",
  },
  {
    id: "7D765BD9-7B7E-4288-89E5-4A74E72E1083",
    name: "keyboard-settings-outline",
    codepoint: "F9F9",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.5.94",
    path: "M7,22H9V24H7V22M11,22H13V24H11V22M15,22H17V24H15V22M4,5C2.9,5 2,5.9 2,7V17C2,18.1 2.9,19 4,19H20C21.1,19 22,18.1 22,17V7C22,5.9 21.1,5 20,5H4M4,7H20V17H4V7M5,8V10H7V8H5M8,8V10H10V8H8M11,8V10H13V8H11M14,8V10H16V8H14M17,8V10H19V8H17M5,11V13H7V11H5M8,11V13H10V11H8M11,11V13H13V11H11M14,11V13H16V11H14M17,11V13H19V11H17M8,14V16H16V14H8Z",
  },
  {
    id: "D7C0D37A-BF75-4542-8AFF-614FA0EC498C",
    name: "keyboard-tab",
    codepoint: "F312",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M20,18H22V6H20M11.59,7.41L15.17,11H1V13H15.17L11.59,16.58L13,18L19,12L13,6L11.59,7.41Z",
  },
  {
    id: "BCAA42FF-BF36-42D8-B8FD-5DE2968162D8",
    name: "keyboard-variant",
    codepoint: "F313",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M6,16H18V18H6V16M6,13V15H2V13H6M7,15V13H10V15H7M11,15V13H13V15H11M14,15V13H17V15H14M18,15V13H22V15H18M2,10H5V12H2V10M19,12V10H22V12H19M18,12H16V10H18V12M8,12H6V10H8V12M12,12H9V10H12V12M15,12H13V10H15V12M2,9V7H4V9H2M5,9V7H7V9H5M8,9V7H10V9H8M11,9V7H13V9H11M14,9V7H16V9H14M17,9V7H22V9H17Z",
  },
  {
    id: "D881D589-79F0-4255-B050-13E396293D1F",
    name: "kickstarter",
    codepoint: "F744",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M10.21,9.13L13.5,4.35C14.13,3.45 14.94,3 15.93,3C16.73,3 17.43,3.29 18,3.86C18.61,4.43 18.9,5.11 18.9,5.91C18.9,6.5 18.75,7 18.43,7.47L15.46,11.8L19.1,16.41C19.46,16.87 19.64,17.41 19.64,18C19.64,18.84 19.36,19.54 18.78,20.12C18.21,20.71 17.5,21 16.7,21C15.81,21 15.13,20.71 14.66,20.13L10.21,14.57V17.63C10.21,18.5 10.05,19.19 9.75,19.67C9.2,20.56 8.39,21 7.33,21C6.37,21 5.63,20.68 5.1,20.03C4.6,19.43 4.36,18.63 4.36,17.65V6.27C4.36,5.34 4.61,4.57 5.11,3.96C5.64,3.32 6.37,3 7.3,3C8.18,3 8.92,3.32 9.5,3.96C9.83,4.32 10.04,4.68 10.13,5.04C10.18,5.27 10.21,5.69 10.21,6.3V9.13Z",
  },
  {
    id: "AF35DB46-1B52-4721-8475-F3CD107325B4",
    name: "knife",
    codepoint: "F9FA",
    aliases: [],
    tags: [],
    author: "Augustin Ursu",
    version: "2.5.94",
    path: "M20.62,2C23.97,7.61 12.47,20.15 12.47,20.15L9.6,17.28L4.91,22L2.77,19.86L20.62,2Z",
  },
  {
    id: "D31C18C1-776C-4444-9A12-F2BD366CF929",
    name: "knife-military",
    codepoint: "F9FB",
    aliases: ["dagger"],
    tags: [],
    author: "Cody",
    version: "2.5.94",
    path: "M22,2L17.39,3.75L10.46,10.68L14,14.22L20.92,7.29C22.43,5.78 22,2 22,2M8.33,10L6.92,11.39L8.33,12.8L2.68,18.46L6.21,22L11.87,16.34L13.28,17.76L14.7,16.34L8.33,10Z",
  },
  {
    id: "AD953D07-5F33-439B-895F-7AD5615EA14A",
    name: "kodi",
    codepoint: "F314",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Christopher Schreiner",
    version: "1.5.54",
    path: "M12.03,1C11.82,1 11.6,1.11 11.41,1.31C10.56,2.16 9.72,3 8.88,3.84C8.66,4.06 8.6,4.18 8.38,4.38C8.09,4.62 7.96,4.91 7.97,5.28C8,6.57 8,7.84 8,9.13C8,10.46 8,11.82 8,13.16C8,13.26 8,13.34 8.03,13.44C8.11,13.75 8.31,13.82 8.53,13.59C9.73,12.39 10.8,11.3 12,10.09C13.36,8.73 14.73,7.37 16.09,6C16.5,5.6 16.5,5.15 16.09,4.75C14.94,3.6 13.77,2.47 12.63,1.31C12.43,1.11 12.24,1 12.03,1M18.66,7.66C18.45,7.66 18.25,7.75 18.06,7.94C16.91,9.1 15.75,10.24 14.59,11.41C14.2,11.8 14.2,12.23 14.59,12.63C15.74,13.78 16.88,14.94 18.03,16.09C18.43,16.5 18.85,16.5 19.25,16.09C20.36,15 21.5,13.87 22.59,12.75C22.76,12.58 22.93,12.42 23,12.19V11.88C22.93,11.64 22.76,11.5 22.59,11.31C21.47,10.19 20.37,9.06 19.25,7.94C19.06,7.75 18.86,7.66 18.66,7.66M4.78,8.09C4.65,8.04 4.58,8.14 4.5,8.22C3.35,9.39 2.34,10.43 1.19,11.59C0.93,11.86 0.93,12.24 1.19,12.5C1.81,13.13 2.44,13.75 3.06,14.38C3.6,14.92 4,15.33 4.56,15.88C4.72,16.03 4.86,16 4.94,15.81C5,15.71 5,15.58 5,15.47C5,14.29 5,13.37 5,12.19C5,11 5,9.81 5,8.63C5,8.55 5,8.45 4.97,8.38C4.95,8.25 4.9,8.14 4.78,8.09M12.09,14.25C11.89,14.25 11.66,14.34 11.47,14.53C10.32,15.69 9.18,16.87 8.03,18.03C7.63,18.43 7.63,18.85 8.03,19.25C9.14,20.37 10.26,21.47 11.38,22.59C11.54,22.76 11.71,22.93 11.94,23H12.22C12.44,22.94 12.62,22.79 12.78,22.63C13.9,21.5 15.03,20.38 16.16,19.25C16.55,18.85 16.5,18.4 16.13,18C14.97,16.84 13.84,15.69 12.69,14.53C12.5,14.34 12.3,14.25 12.09,14.25Z",
  },
  {
    id: "C749E06B-E75E-4D9B-97A6-47E9399D01FC",
    name: "label",
    codepoint: "F315",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M17.63,5.84C17.27,5.33 16.67,5 16,5H5C3.9,5 3,5.9 3,7V17C3,18.1 3.9,19 5,19H16C16.67,19 17.27,18.66 17.63,18.15L22,12L17.63,5.84Z",
  },
  {
    id: "91C2FA0C-2273-42F9-ACBF-BD418B8F970D",
    name: "label-outline",
    codepoint: "F316",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M16,17H5V7H16L19.55,12M17.63,5.84C17.27,5.33 16.67,5 16,5H5C3.9,5 3,5.9 3,7V17C3,18.1 3.9,19 5,19H16C16.67,19 17.27,18.66 17.63,18.15L22,12L17.63,5.84Z",
  },
  {
    id: "97AFF594-E421-4757-BE72-1D6C428E27AE",
    name: "ladybug",
    codepoint: "F82C",
    aliases: ["bugfood", "ladybird"],
    tags: ["Nature"],
    author: "Google",
    version: "2.1.19",
    path: "M12,5C12.74,5 13.47,5.1 14.15,5.29L15.78,2.46C16.06,2 16.67,1.82 17.15,2.1C17.63,2.37 17.79,3 17.5,3.46L16,6.07C17.22,6.78 18.23,7.79 18.93,9H5.07C5.77,7.79 6.78,6.78 8,6.07L6.5,3.46C6.21,3 6.37,2.37 6.85,2.1C7.33,1.82 7.94,2 8.22,2.46L9.85,5.29C10.53,5.1 11.26,5 12,5M20,13C20,17.17 16.82,20.59 12.75,20.97V10.5H19.6C19.86,11.29 20,12.13 20,13M4,13C4,12.13 4.14,11.29 4.4,10.5H11.25V20.97C7.18,20.59 4,17.17 4,13Z",
  },
  {
    id: "1815038E-B466-4F5F-91D9-9D03DDA6A9DA",
    name: "lambda",
    codepoint: "F627",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.6.50",
    path: "M6,20L10.16,7.91L9.34,6H8V4H10C10.42,4 10.78,4.26 10.93,4.63L16.66,18H18V20H16C15.57,20 15.21,19.73 15.07,19.36L11.33,10.65L8.12,20H6Z",
  },
  {
    id: "A39CC0FD-32DA-4AB2-8483-9E4C4F03D220",
    name: "lamp",
    codepoint: "F6B4",
    aliases: [],
    tags: ["Home Automation"],
    author: "GreenTurtwig",
    version: "1.7.22",
    path: "M8,2H16L20,14H4L8,2M11,15H13V20H18V22H6V20H11V15Z",
  },
  {
    id: "A20B1B0B-DC60-4ED1-A7E6-F390BA31D613",
    name: "lan",
    codepoint: "F317",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M10,2C8.89,2 8,2.89 8,4V7C8,8.11 8.89,9 10,9H11V11H2V13H6V15H5C3.89,15 3,15.89 3,17V20C3,21.11 3.89,22 5,22H9C10.11,22 11,21.11 11,20V17C11,15.89 10.11,15 9,15H8V13H16V15H15C13.89,15 13,15.89 13,17V20C13,21.11 13.89,22 15,22H19C20.11,22 21,21.11 21,20V17C21,15.89 20.11,15 19,15H18V13H22V11H13V9H14C15.11,9 16,8.11 16,7V4C16,2.89 15.11,2 14,2H10M10,4H14V7H10V4M5,17H9V20H5V17M15,17H19V20H15V17Z",
  },
  {
    id: "B52D6944-3AC2-4113-A91C-199C0CD577A6",
    name: "lan-connect",
    codepoint: "F318",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M4,1C2.89,1 2,1.89 2,3V7C2,8.11 2.89,9 4,9H1V11H13V9H10C11.11,9 12,8.11 12,7V3C12,1.89 11.11,1 10,1H4M4,3H10V7H4V3M3,13V18L3,20H10V18H5V13H3M14,13C12.89,13 12,13.89 12,15V19C12,20.11 12.89,21 14,21H11V23H23V21H20C21.11,21 22,20.11 22,19V15C22,13.89 21.11,13 20,13H14M14,15H20V19H14V15Z",
  },
  {
    id: "10DCD7DC-998B-4631-B8A6-A0D8C93412A3",
    name: "lan-disconnect",
    codepoint: "F319",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M4,1C2.89,1 2,1.89 2,3V7C2,8.11 2.89,9 4,9H1V11H13V9H10C11.11,9 12,8.11 12,7V3C12,1.89 11.11,1 10,1H4M4,3H10V7H4V3M14,13C12.89,13 12,13.89 12,15V19C12,20.11 12.89,21 14,21H11V23H23V21H20C21.11,21 22,20.11 22,19V15C22,13.89 21.11,13 20,13H14M3.88,13.46L2.46,14.88L4.59,17L2.46,19.12L3.88,20.54L6,18.41L8.12,20.54L9.54,19.12L7.41,17L9.54,14.88L8.12,13.46L6,15.59L3.88,13.46M14,15H20V19H14V15Z",
  },
  {
    id: "B5E302E3-DF81-430E-AAE0-4CAF44AFAD00",
    name: "lan-pending",
    codepoint: "F31A",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M4,1C2.89,1 2,1.89 2,3V7C2,8.11 2.89,9 4,9H1V11H13V9H10C11.11,9 12,8.11 12,7V3C12,1.89 11.11,1 10,1H4M4,3H10V7H4V3M3,12V14H5V12H3M14,13C12.89,13 12,13.89 12,15V19C12,20.11 12.89,21 14,21H11V23H23V21H20C21.11,21 22,20.11 22,19V15C22,13.89 21.11,13 20,13H14M3,15V17H5V15H3M14,15H20V19H14V15M3,18V20H5V18H3M6,18V20H8V18H6M9,18V20H11V18H9Z",
  },
  {
    id: "082F25B3-8413-4CC7-B908-8BBD40BB32D8",
    name: "language-c",
    codepoint: "F671",
    aliases: [],
    tags: ["Developer / Languages"],
    author: "Austin Andrews",
    version: "1.6.50",
    path: "M15.45,15.97L15.87,18.41C15.61,18.55 15.19,18.68 14.63,18.8C14.06,18.93 13.39,19 12.62,19C10.41,18.96 8.75,18.3 7.64,17.04C6.5,15.77 5.96,14.16 5.96,12.21C6,9.9 6.68,8.13 8,6.89C9.28,5.64 10.92,5 12.9,5C13.65,5 14.3,5.07 14.84,5.19C15.38,5.31 15.78,5.44 16.04,5.59L15.44,8.08L14.4,7.74C14,7.64 13.53,7.59 13,7.59C11.85,7.58 10.89,7.95 10.14,8.69C9.38,9.42 9,10.54 8.96,12.03C8.97,13.39 9.33,14.45 10.04,15.23C10.75,16 11.74,16.4 13.03,16.41L14.36,16.29C14.79,16.21 15.15,16.1 15.45,15.97Z",
  },
  {
    id: "74446CD2-562D-44E7-AAC1-62D4CCDB9F43",
    name: "language-cpp",
    codepoint: "F672",
    aliases: [],
    tags: ["Developer / Languages"],
    author: "Austin Andrews",
    version: "1.6.50",
    path: "M10.5,15.97L10.91,18.41C10.65,18.55 10.23,18.68 9.67,18.8C9.1,18.93 8.43,19 7.66,19C5.45,18.96 3.79,18.3 2.68,17.04C1.56,15.77 1,14.16 1,12.21C1.05,9.9 1.72,8.13 3,6.89C4.32,5.64 5.96,5 7.94,5C8.69,5 9.34,5.07 9.88,5.19C10.42,5.31 10.82,5.44 11.08,5.59L10.5,8.08L9.44,7.74C9.04,7.64 8.58,7.59 8.05,7.59C6.89,7.58 5.93,7.95 5.18,8.69C4.42,9.42 4.03,10.54 4,12.03C4,13.39 4.37,14.45 5.08,15.23C5.79,16 6.79,16.4 8.07,16.41L9.4,16.29C9.83,16.21 10.19,16.1 10.5,15.97M11,11H13V9H15V11H17V13H15V15H13V13H11V11M18,11H20V9H22V11H24V13H22V15H20V13H18V11Z",
  },
  {
    id: "EFF1E516-3470-456C-AC79-0F9C82C79391",
    name: "language-csharp",
    codepoint: "F31B",
    aliases: [],
    tags: ["Developer / Languages"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M11.5,15.97L11.91,18.41C11.65,18.55 11.23,18.68 10.67,18.8C10.1,18.93 9.43,19 8.66,19C6.45,18.96 4.79,18.3 3.68,17.04C2.56,15.77 2,14.16 2,12.21C2.05,9.9 2.72,8.13 4,6.89C5.32,5.64 6.96,5 8.94,5C9.69,5 10.34,5.07 10.88,5.19C11.42,5.31 11.82,5.44 12.08,5.59L11.5,8.08L10.44,7.74C10.04,7.64 9.58,7.59 9.05,7.59C7.89,7.58 6.93,7.95 6.18,8.69C5.42,9.42 5.03,10.54 5,12.03C5,13.39 5.37,14.45 6.08,15.23C6.79,16 7.79,16.4 9.07,16.41L10.4,16.29C10.83,16.21 11.19,16.1 11.5,15.97M13.89,19L14.5,15H13L13.34,13H14.84L15.16,11H13.66L14,9H15.5L16.11,5H18.11L17.5,9H18.5L19.11,5H21.11L20.5,9H22L21.66,11H20.16L19.84,13H21.34L21,15H19.5L18.89,19H16.89L17.5,15H16.5L15.89,19H13.89M16.84,13H17.84L18.16,11H17.16L16.84,13Z",
  },
  {
    id: "DA72E30D-C562-4E93-B8C8-CAFA686A1D23",
    name: "language-css3",
    codepoint: "F31C",
    aliases: [],
    tags: ["Developer / Languages"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M5,3L4.35,6.34H17.94L17.5,8.5H3.92L3.26,11.83H16.85L16.09,15.64L10.61,17.45L5.86,15.64L6.19,14H2.85L2.06,18L9.91,21L18.96,18L20.16,11.97L20.4,10.76L21.94,3H5Z",
  },
  {
    id: "ACAFCF05-E04D-4212-AB53-C72BD8DB5768",
    name: "language-go",
    codepoint: "F7D2",
    aliases: [],
    tags: ["Developer / Languages"],
    author: "Austin Andrews",
    version: "2.0.46",
    path: "M2.64,10.33L2.62,10.27L2.84,10L2.96,9.92H6.8L6.83,10L6.65,10.26L6.54,10.32L2.64,10.33M1.03,11.31L1,11.26L1.22,10.97L1.34,10.91H6.24L6.29,11L6.21,11.24L6.11,11.31H1.03M3.63,12.3L3.59,12.24L3.75,11.96L3.85,11.9H6L6.07,11.97L6.05,12.22L5.97,12.3H3.63M14.78,10.14L13,10.61C12.81,10.65 12.8,10.66 12.66,10.5C12.5,10.32 12.39,10.21 12.16,10.1C11.5,9.76 10.83,9.86 10.22,10.25C9.5,10.73 9.11,11.42 9.12,12.3C9.13,13.16 9.72,13.87 10.57,14C11.3,14.09 11.91,13.83 12.4,13.28L12.69,12.89H10.62C10.4,12.89 10.35,12.75 10.42,12.57L10.97,11.39C11,11.33 11.08,11.22 11.24,11.22H14.68C14.83,10.72 15.09,10.26 15.43,9.81C16.21,8.78 17.16,8.24 18.43,8C19.5,7.82 20.56,7.93 21.5,8.57C22.34,9.15 22.87,9.93 23,10.96C23.19,12.41 22.76,13.59 21.76,14.61C21.05,15.33 20.18,15.78 19.19,16L18.33,16.08C17.35,16.06 16.46,15.78 15.71,15.13C15.19,14.68 14.83,14.14 14.65,13.5C14.5,13.74 14.38,13.97 14.21,14.2C13.44,15.22 12.43,15.85 11.15,16C10.1,16.16 9.12,15.95 8.26,15.31C7.47,14.71 7,13.91 6.9,12.92C6.76,11.75 7.1,10.7 7.81,9.78C8.57,8.78 9.58,8.15 10.82,7.92C11.82,7.74 12.79,7.86 13.66,8.44C14.23,8.82 14.63,9.34 14.9,9.96C14.94,10.05 14.9,10.11 14.78,10.14M20.89,11.74L20.86,11.38C20.67,10.32 19.69,9.72 18.67,9.95C17.66,10.17 17,10.8 16.79,11.81C16.6,12.65 17,13.5 17.77,13.84C18.36,14.1 18.96,14.06 19.53,13.78C20.37,13.35 20.84,12.66 20.89,11.74Z",
  },
  {
    id: "98D9A5A1-626A-4273-B895-4C838936613C",
    name: "language-html5",
    codepoint: "F31D",
    aliases: [],
    tags: ["Developer / Languages"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,17.56L16.07,16.43L16.62,10.33H9.38L9.2,8.3H16.8L17,6.31H7L7.56,12.32H14.45L14.22,14.9L12,15.5L9.78,14.9L9.64,13.24H7.64L7.93,16.43L12,17.56M4.07,3H19.93L18.5,19.2L12,21L5.5,19.2L4.07,3Z",
  },
  {
    id: "9D3ED5EB-8951-4E75-A623-EEF618ED4172",
    name: "language-javascript",
    codepoint: "F31E",
    aliases: [],
    tags: ["Developer / Languages"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M3,3H21V21H3V3M7.73,18.04C8.13,18.89 8.92,19.59 10.27,19.59C11.77,19.59 12.8,18.79 12.8,17.04V11.26H11.1V17C11.1,17.86 10.75,18.08 10.2,18.08C9.62,18.08 9.38,17.68 9.11,17.21L7.73,18.04M13.71,17.86C14.21,18.84 15.22,19.59 16.8,19.59C18.4,19.59 19.6,18.76 19.6,17.23C19.6,15.82 18.79,15.19 17.35,14.57L16.93,14.39C16.2,14.08 15.89,13.87 15.89,13.37C15.89,12.96 16.2,12.64 16.7,12.64C17.18,12.64 17.5,12.85 17.79,13.37L19.1,12.5C18.55,11.54 17.77,11.17 16.7,11.17C15.19,11.17 14.22,12.13 14.22,13.4C14.22,14.78 15.03,15.43 16.25,15.95L16.67,16.13C17.45,16.47 17.91,16.68 17.91,17.26C17.91,17.74 17.46,18.09 16.76,18.09C15.93,18.09 15.45,17.66 15.09,17.06L13.71,17.86Z",
  },
  {
    id: "0B0DE3A6-7ED1-497C-BAF4-CDAA3F9713C9",
    name: "language-lua",
    codepoint: "F8B0",
    aliases: [],
    tags: ["Developer / Languages"],
    author: "Nick",
    version: "2.2.43",
    path: "M10.5,5C5.81,5 2,8.81 2,13.5C2,18.19 5.81,22 10.5,22C15.19,22 19,18.19 19,13.5C19,8.81 15.19,5 10.5,5M13.5,13C12.12,13 11,11.88 11,10.5C11,9.12 12.12,8 13.5,8C14.88,8 16,9.12 16,10.5C16,11.88 14.88,13 13.5,13M19.5,2C18.12,2 17,3.12 17,4.5C17,5.88 18.12,7 19.5,7C20.88,7 22,5.88 22,4.5C22,3.12 20.88,2 19.5,2",
  },
  {
    id: "2A153653-6727-4DE1-95DC-AC6801A7DC01",
    name: "language-php",
    codepoint: "F31F",
    aliases: [],
    tags: ["Developer / Languages"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,18.08C5.37,18.08 0,15.36 0,12C0,8.64 5.37,5.92 12,5.92C18.63,5.92 24,8.64 24,12C24,15.36 18.63,18.08 12,18.08M6.81,10.13C7.35,10.13 7.72,10.23 7.9,10.44C8.08,10.64 8.12,11 8.03,11.47C7.93,12 7.74,12.34 7.45,12.56C7.17,12.78 6.74,12.89 6.16,12.89H5.29L5.82,10.13H6.81M3.31,15.68H4.75L5.09,13.93H6.32C6.86,13.93 7.3,13.87 7.65,13.76C8,13.64 8.32,13.45 8.61,13.18C8.85,12.96 9.04,12.72 9.19,12.45C9.34,12.19 9.45,11.89 9.5,11.57C9.66,10.79 9.55,10.18 9.17,9.75C8.78,9.31 8.18,9.1 7.35,9.1H4.59L3.31,15.68M10.56,7.35L9.28,13.93H10.7L11.44,10.16H12.58C12.94,10.16 13.18,10.22 13.29,10.34C13.4,10.46 13.42,10.68 13.36,11L12.79,13.93H14.24L14.83,10.86C14.96,10.24 14.86,9.79 14.56,9.5C14.26,9.23 13.71,9.1 12.91,9.1H11.64L12,7.35H10.56M18,10.13C18.55,10.13 18.91,10.23 19.09,10.44C19.27,10.64 19.31,11 19.22,11.47C19.12,12 18.93,12.34 18.65,12.56C18.36,12.78 17.93,12.89 17.35,12.89H16.5L17,10.13H18M14.5,15.68H15.94L16.28,13.93H17.5C18.05,13.93 18.5,13.87 18.85,13.76C19.2,13.64 19.5,13.45 19.8,13.18C20.04,12.96 20.24,12.72 20.38,12.45C20.53,12.19 20.64,11.89 20.7,11.57C20.85,10.79 20.74,10.18 20.36,9.75C20,9.31 19.37,9.1 18.54,9.1H15.79L14.5,15.68Z",
  },
  {
    id: "4E453C2B-40D4-4D60-8EAF-750091283FAC",
    name: "language-python",
    codepoint: "F320",
    aliases: [],
    tags: ["Developer / Languages"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M19.14,7.5C20.72,7.5 22,8.78 22,10.36V14.14C22,15.72 20.72,17 19.14,17H12C12,17.39 12.32,17.96 12.71,17.96H17V19.64C17,21.22 15.72,22.5 14.14,22.5H9.86C8.28,22.5 7,21.22 7,19.64V15.89C7,14.31 8.28,13.04 9.86,13.04H15.11C16.69,13.04 17.96,11.76 17.96,10.18V7.5H19.14M14.86,19.29C14.46,19.29 14.14,19.59 14.14,20.18C14.14,20.77 14.46,20.89 14.86,20.89C15.25,20.89 15.57,20.57 15.57,20.18C15.57,19.59 15.25,19.29 14.86,19.29M4.86,17.5C3.28,17.5 2,16.22 2,14.64V10.86C2,9.28 3.28,8 4.86,8H12C12,7.61 11.68,7.04 11.29,7.04H7V5.36C7,3.78 8.28,2.5 9.86,2.5H14.14C15.72,2.5 17,3.78 17,5.36V9.11C17,10.69 15.72,11.96 14.14,11.96H8.89C7.31,11.96 6.04,13.24 6.04,14.82V17.5H4.86M9.14,5.71C9.54,5.71 9.86,5.41 9.86,4.82C9.86,4.23 9.54,4.11 9.14,4.11C8.75,4.11 8.43,4.23 8.43,4.82C8.43,5.41 8.75,5.71 9.14,5.71Z",
  },
  {
    id: "2F197131-0666-4F07-8BDE-B6FB3C4BB39B",
    name: "language-r",
    codepoint: "F7D3",
    aliases: [],
    tags: ["Developer / Languages"],
    author: "GreenTurtwig",
    version: "2.0.46",
    path: "M12,4.29C6.5,4.29 2,7.29 2,11C2,14.28 5.56,17 10.24,17.58V19.71H13.65V17.59C14.5,17.5 15.29,17.34 16.04,17.11L17.42,19.71H21.28L18.96,15.8C20.83,14.58 22,12.87 22,11C22,7.29 17.5,4.29 12,4.29V4.29M13.53,6.91C17.73,6.91 20.83,8.31 20.83,11.5C20.83,13.21 19.91,14.41 18.41,15.15C18.32,15.1 18.24,15.05 18.19,15C17.83,14.84 17.23,14.66 17.23,14.66C17.23,14.66 20.21,14.44 20.21,11.47C20.21,8.5 17.09,8.45 17.09,8.45H10.24V15.61C7.69,14.87 5.93,13.3 5.93,11.5C5.93,8.96 9.33,6.91 13.53,6.91M13.68,10.89H15.75C15.75,10.89 16.7,10.84 16.7,11.83C16.7,12.8 15.75,12.8 15.75,12.8H13.68V10.89M13.65,15.3H14.57C14.75,15.3 14.84,15.35 15,15.5C15.13,15.6 15.27,15.79 15.39,15.96C14.84,16.03 14.26,16.06 13.65,16.06V15.3Z",
  },
  {
    id: "9F060254-CB0B-4DD9-87C5-BADAE8F2F8C4",
    name: "language-swift",
    codepoint: "F6E4",
    aliases: [],
    tags: ["Developer / Languages"],
    author: "GreenTurtwig",
    version: "1.8.36",
    path: "M17.09,19.72C14.73,21.08 11.5,21.22 8.23,19.82C5.59,18.7 3.4,16.74 2,14.5C2.67,15.05 3.46,15.5 4.3,15.9C7.67,17.47 11.03,17.36 13.4,15.9C10.03,13.31 7.16,9.94 5.03,7.19C4.58,6.74 4.25,6.18 3.91,5.68C12.19,11.73 11.83,13.27 6.32,4.67C11.21,9.61 15.75,12.41 15.75,12.41C15.91,12.5 16,12.57 16.11,12.63C16.21,12.38 16.3,12.12 16.37,11.85C17.16,9 16.26,5.73 14.29,3.04C18.84,5.79 21.54,10.95 20.41,15.28C20.38,15.39 20.35,15.5 20.36,15.67C22.6,18.5 22,21.45 21.71,20.89C20.5,18.5 18.23,19.24 17.09,19.72V19.72Z",
  },
  {
    id: "BFE7B3A3-4B61-4583-B22D-395E1FCE1A07",
    name: "language-typescript",
    codepoint: "F6E5",
    aliases: [],
    tags: ["Developer / Languages"],
    author: "Austin Andrews",
    version: "1.8.36",
    path: "M3,3H21V21H3V3M13.71,17.86C14.21,18.84 15.22,19.59 16.8,19.59C18.4,19.59 19.6,18.76 19.6,17.23C19.6,15.82 18.79,15.19 17.35,14.57L16.93,14.39C16.2,14.08 15.89,13.87 15.89,13.37C15.89,12.96 16.2,12.64 16.7,12.64C17.18,12.64 17.5,12.85 17.79,13.37L19.1,12.5C18.55,11.54 17.77,11.17 16.7,11.17C15.19,11.17 14.22,12.13 14.22,13.4C14.22,14.78 15.03,15.43 16.25,15.95L16.67,16.13C17.45,16.47 17.91,16.68 17.91,17.26C17.91,17.74 17.46,18.09 16.76,18.09C15.93,18.09 15.45,17.66 15.09,17.06L13.71,17.86M13,11.25H8V12.75H9.5V20H11.25V12.75H13V11.25Z",
  },
  {
    id: "A8B6481F-EE91-4F90-81AC-DEB8A096F45A",
    name: "laptop",
    codepoint: "F322",
    aliases: ["computer"],
    tags: ["Device / Tech", "Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M4,6H20V16H4M20,18C21.1,18 22,17.1 22,16V6C22,4.89 21.1,4 20,4H4C2.89,4 2,4.89 2,6V16C2,17.1 2.9,18 4,18H0V20H24V18H20Z",
  },
  {
    id: "70793340-E8F2-43A0-8AB1-0DAB70CC8B9A",
    name: "laptop-chromebook",
    codepoint: "F323",
    aliases: [],
    tags: ["Device / Tech", "Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M20,15H4V5H20M14,18H10V17H14M22,18V3H2V18H0V20H24V18H22Z",
  },
  {
    id: "DC51467E-30C0-4144-9AE6-80762ACA972C",
    name: "laptop-mac",
    codepoint: "F324",
    aliases: [],
    tags: ["Device / Tech", "Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M12,19C11.45,19 11,18.55 11,18C11,17.45 11.45,17 12,17C12.55,17 13,17.45 13,18C13,18.55 12.55,19 12,19M4,5H20V16H4M20,18C21.1,18 22,17.1 22,16V5C22,3.89 21.1,3 20,3H4C2.89,3 2,3.89 2,5V16C2,17.1 2.9,18 4,18H0C0,19.1 0.9,20 2,20H22C23.1,20 24,19.1 24,18H20Z",
  },
  {
    id: "C9A08F85-B996-498D-ADDC-20A9B77B5489",
    name: "laptop-off",
    codepoint: "F6E6",
    aliases: [],
    tags: ["Device / Tech"],
    author: "Michael Richins",
    version: "1.8.36",
    path: "M1,4.27L2.28,3L20,20.72L18.73,22L16.73,20H0V18H4C2.89,18 2,17.1 2,16V6C2,5.78 2.04,5.57 2.1,5.37L1,4.27M4,16H12.73L4,7.27V16M20,16V6H7.82L5.82,4H20C21.1,4 22,4.9 22,6V16C22,17.1 21.1,18 20,18H24V20H21.82L17.82,16H20Z",
  },
  {
    id: "CFF782E5-F36B-4F80-B105-68E6B4B91C64",
    name: "laptop-windows",
    codepoint: "F325",
    aliases: [],
    tags: ["Device / Tech", "Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M3,4H21C21.55,4 22,4.45 22,5V16C22,16.55 21.55,17 21,17H22L24,20V21H0V20L2,17H3C2.45,17 2,16.55 2,16V5C2,4.45 2.45,4 3,4M4,6V15H20V6H4Z",
  },
  {
    id: "65AC32C4-911E-4005-8BD1-663AE0000988",
    name: "lastpass",
    codepoint: "F446",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Michael Richins",
    version: "1.5.54",
    path: "M14,12C14,10.9 14.9,10 16,10C17.1,10 18,10.9 18,12C18,13.1 17.1,14 16,14C14.9,14 14,13.1 14,12M8,12C8,10.9 8.9,10 10,10C11.1,10 12,10.9 12,12C12,13.1 11.1,14 10,14C8.9,14 8,13.1 8,12M2,12C2,10.9 2.9,10 4,10C5.1,10 6,10.9 6,12C6,13.1 5.1,14 4,14C2.9,14 2,13.1 2,12M22,5H20V19H22V5Z",
  },
  {
    id: "ED8AF9CE-E555-49C9-8E7E-F9B85CD94CDF",
    name: "launch",
    codepoint: "F327",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M14,3V5H17.59L7.76,14.83L9.17,16.24L19,6.41V10H21V3M19,19H5V5H12V3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V12H19V19Z",
  },
  {
    id: "B1E2F856-253B-465C-861A-40C5C7D6C8DB",
    name: "lava-lamp",
    codepoint: "F7D4",
    aliases: [],
    tags: ["Home Automation"],
    author: "GreenTurtwig",
    version: "2.0.46",
    path: "M10,3L8,16H16L14,3H10M11.5,5.75C11.91,5.75 12.25,6.09 12.25,6.5C12.25,6.91 11.91,7.25 11.5,7.25C11.09,7.25 10.75,6.91 10.75,6.5C10.75,6.09 11.09,5.75 11.5,5.75M12.5,8.5C13.05,8.5 13.5,8.95 13.5,9.5C13.5,10.05 13.05,10.5 12.5,10.5C11.95,10.5 11.5,10.05 11.5,9.5C11.5,8.95 11.95,8.5 12.5,8.5M11.5,12C12.33,12 13,12.67 13,13.5C13,14.33 12.33,15 11.5,15C10.67,15 10,14.33 10,13.5C10,12.67 10.67,12 11.5,12M8,17L10,19L8,21H16L14,19L16,17H8Z",
  },
  {
    id: "36A9B462-C487-458E-BFB6-2415739BC968",
    name: "layers",
    codepoint: "F328",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M12,16L19.36,10.27L21,9L12,2L3,9L4.63,10.27M12,18.54L4.62,12.81L3,14.07L12,21.07L21,14.07L19.37,12.8L12,18.54Z",
  },
  {
    id: "1ADB303D-B8D9-49EF-8EB0-C02AFD269F02",
    name: "layers-off",
    codepoint: "F329",
    aliases: ["layers-clear"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M3.27,1L2,2.27L6.22,6.5L3,9L4.63,10.27L12,16L14.1,14.37L15.53,15.8L12,18.54L4.63,12.81L3,14.07L12,21.07L16.95,17.22L20.73,21L22,19.73L3.27,1M19.36,10.27L21,9L12,2L9.09,4.27L16.96,12.15L19.36,10.27M19.81,15L21,14.07L19.57,12.64L18.38,13.56L19.81,15Z",
  },
  {
    id: "FAC5EA16-5C62-49FA-8BE4-7D797604A425",
    name: "layers-off-outline",
    codepoint: "F9FC",
    aliases: [],
    tags: [],
    author: "Google",
    version: "2.5.94",
    path: "M12,4.53L10.83,5.44L9.41,4L12,2L21,9L17.28,11.89L15.85,10.47L17.74,9L12,4.53M21,14.07L20.13,14.75L18.7,13.32L19.37,12.8L21,14.07M3.41,0.86L22.14,19.59L20.73,21L16.95,17.22L12,21.07L3,14.07L4.62,12.81L12,18.54L15.5,15.79L14.1,14.37L12,16L3,9L6.22,6.5L2,2.27L3.41,0.86M12,13.47L12.67,12.94L7.65,7.92L6.26,9L12,13.47Z",
  },
  {
    id: "9026C3EC-9903-40FE-B3DF-EDB7FE10191A",
    name: "layers-outline",
    codepoint: "F9FD",
    aliases: [],
    tags: [],
    author: "Google",
    version: "2.5.94",
    path: "M12,18.54L19.37,12.8L21,14.07L12,21.07L3,14.07L4.62,12.81L12,18.54M12,16L3,9L12,2L21,9L12,16M12,4.53L6.26,9L12,13.47L17.74,9L12,4.53Z",
  },
  {
    id: "5EB00CD5-91CA-438E-B569-2D680E6102D6",
    name: "lead-pencil",
    codepoint: "F64F",
    aliases: [],
    tags: ["Drawing / Art"],
    author: "Google",
    version: "1.6.50",
    path: "M16.84,2.73C16.45,2.73 16.07,2.88 15.77,3.17L13.65,5.29L18.95,10.6L21.07,8.5C21.67,7.89 21.67,6.94 21.07,6.36L17.9,3.17C17.6,2.88 17.22,2.73 16.84,2.73M12.94,6L4.84,14.11L7.4,14.39L7.58,16.68L9.86,16.85L10.15,19.41L18.25,11.3M4.25,15.04L2.5,21.73L9.2,19.94L8.96,17.78L6.65,17.61L6.47,15.29",
  },
  {
    id: "30AC82B4-6073-462B-B63E-0F64706AAC2F",
    name: "leaf",
    codepoint: "F32A",
    aliases: [],
    tags: ["Nature"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M17,8C8,10 5.9,16.17 3.82,21.34L5.71,22L6.66,19.7C7.14,19.87 7.64,20 8,20C19,20 22,3 22,3C21,5 14,5.25 9,6.25C4,7.25 2,11.5 2,13.5C2,15.5 3.75,17.25 3.75,17.25C7,8 17,8 17,8Z",
  },
  {
    id: "8A29D85F-1BAD-4610-AF2F-B4AF0F0D2755",
    name: "led-off",
    codepoint: "F32B",
    aliases: [],
    tags: ["Home Automation"],
    author: "Cody",
    version: "1.5.54",
    path: "M12,6C9.79,6 8,7.79 8,10V16H6V18H9V23H11V18H13V23H15V18H18V16H16V10C16,7.79 14.21,6 12,6Z",
  },
  {
    id: "5DACA128-6BEE-424D-83BA-8C94E01F5C0A",
    name: "led-on",
    codepoint: "F32C",
    aliases: [],
    tags: ["Home Automation"],
    author: "Cody",
    version: "1.5.54",
    path: "M11,0V4H13V0H11M18.3,2.29L15.24,5.29L16.64,6.71L19.7,3.71L18.3,2.29M5.71,2.29L4.29,3.71L7.29,6.71L8.71,5.29L5.71,2.29M12,6C9.79,6 8,7.79 8,10V16H6V18H9V23H11V18H13V23H15V18H18V16H16V10C16,7.79 14.21,6 12,6M2,9V11H6V9H2M18,9V11H22V9H18Z",
  },
  {
    id: "423F2C55-8E79-441A-A987-45A97FAA3F53",
    name: "led-outline",
    codepoint: "F32D",
    aliases: [],
    tags: ["Home Automation"],
    author: "Cody",
    version: "1.5.54",
    path: "M12,6C9.79,6 8,7.79 8,10V16H6V18H9V23H11V18H13V23H15V18H18V16H16V10C16,7.79 14.21,6 12,6M12,8C13.1,8 14,8.9 14,10V15H10V10C10,8.9 10.9,8 12,8Z",
  },
  {
    id: "F301BDB9-027C-40D0-A21F-3111A7AB218F",
    name: "led-strip",
    codepoint: "F7D5",
    aliases: [],
    tags: ["Home Automation"],
    author: "GreenTurtwig",
    version: "2.0.46",
    path: "M2.81,8.46L14.83,20.5L15.54,19.78L16.95,21.19L18.36,19.78L16.95,18.36L18.36,16.95L19.78,18.36L21.19,16.95L19.78,15.54L20.5,14.83L8.46,2.81L2.81,8.46M5.64,8.46L8.46,5.64L17.66,14.83L14.83,17.66L5.64,8.46M7.05,8.46L8.46,9.88L9.88,8.46L8.46,7.05L7.05,8.46M9.17,10.59L10.59,12L12,10.59L10.59,9.17L9.17,10.59M11.29,12.71L12.71,14.12L14.12,12.71L12.71,11.29L11.29,12.71M13.41,14.83L14.83,16.24L16.24,14.83L14.83,13.41L13.41,14.83Z",
  },
  {
    id: "BBDD4244-D5C9-4150-9936-31C775AA463F",
    name: "led-variant-off",
    codepoint: "F32E",
    aliases: [],
    tags: ["Home Automation"],
    author: "Cody",
    version: "1.5.54",
    path: "M12,3C10.05,3 8.43,4.4 8.08,6.25L16.82,15H18V13H16V7C16,4.79 14.21,3 12,3M3.28,4L2,5.27L8,11.27V13H6V15H9V21H11V15H11.73L13,16.27V21H15V18.27L18.73,22L20,20.72L15,15.72L8,8.72L3.28,4Z",
  },
  {
    id: "9929F712-7241-468C-B10B-5739356EC85C",
    name: "led-variant-on",
    codepoint: "F32F",
    aliases: [],
    tags: ["Home Automation"],
    author: "Cody",
    version: "1.5.54",
    path: "M12,3C9.79,3 8,4.79 8,7V13H6V15H9V21H11V15H13V21H15V15H18V13H16V7C16,4.79 14.21,3 12,3Z",
  },
  {
    id: "AEACBB35-5466-4C5B-8AA5-B366D0322A27",
    name: "led-variant-outline",
    codepoint: "F330",
    aliases: [],
    tags: ["Home Automation"],
    author: "Cody",
    version: "1.5.54",
    path: "M12,3C9.79,3 8,4.79 8,7V13H6V15H9V21H11V15H13V21H15V15H18V13H16V7C16,4.79 14.21,3 12,3M12,5C13.1,5 14,5.9 14,7V12H10V7C10,5.9 10.9,5 12,5Z",
  },
  {
    id: "098E9BF3-3E1F-43E3-ACFF-2D35123A3186",
    name: "less-than",
    codepoint: "F97B",
    aliases: [],
    tags: [],
    author: "Nick",
    version: "2.4.85",
    path: "M18.5,4.14L19.5,5.86L8.97,12L19.5,18.14L18.5,19.86L5,12L18.5,4.14Z",
  },
  {
    id: "9CA22101-6F3D-4EE1-B9F1-C64CE0EFC911",
    name: "less-than-or-equal",
    codepoint: "F97C",
    aliases: [],
    tags: [],
    author: "Nick",
    version: "2.4.85",
    path: "M18.5,2.27L5,10.14L18.5,18L19.5,16.27L8.97,10.14L19.5,4L18.5,2.27M5,20V22H20V20H5Z",
  },
  {
    id: "45FA5A9C-DFF1-4D7E-B683-DB7DE2BAEFC7",
    name: "library",
    codepoint: "F331",
    aliases: ["local-library"],
    tags: ["Places"],
    author: "Google",
    version: "1.5.54",
    path: "M12,8C13.66,8 15,6.66 15,5C15,3.34 13.66,2 12,2C10.34,2 9,3.34 9,5C9,6.66 10.34,8 12,8M12,11.54C9.64,9.35 6.5,8 3,8V19C6.5,19 9.64,20.35 12,22.54C14.36,20.35 17.5,19 21,19V8C17.5,8 14.36,9.35 12,11.54Z",
  },
  {
    id: "7936EB1E-FCE1-4501-A339-C5EB7E4301E9",
    name: "lifebuoy",
    codepoint: "F87D",
    aliases: ["life-preserver", "support", "help"],
    tags: [],
    author: "Cody",
    version: "2.1.99",
    path: "M19.79,15.41C20.74,13.24 20.74,10.75 19.79,8.59L17.05,9.83C17.65,11.21 17.65,12.78 17.06,14.17L19.79,15.41M15.42,4.21C13.25,3.26 10.76,3.26 8.59,4.21L9.83,6.94C11.22,6.35 12.79,6.35 14.18,6.95L15.42,4.21M4.21,8.58C3.26,10.76 3.26,13.24 4.21,15.42L6.95,14.17C6.35,12.79 6.35,11.21 6.95,9.82L4.21,8.58M8.59,19.79C10.76,20.74 13.25,20.74 15.42,19.78L14.18,17.05C12.8,17.65 11.22,17.65 9.84,17.06L8.59,19.79M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M12,8C9.79,8 8,9.79 8,12C8,14.21 9.79,16 12,16C14.21,16 16,14.21 16,12C16,9.79 14.21,8 12,8Z",
  },
  {
    id: "647E0001-A60B-4D74-B127-BF522712922F",
    name: "light-switch",
    codepoint: "F97D",
    aliases: [],
    tags: ["Home Automation"],
    author: "Google",
    version: "2.4.85",
    path: "M7,1C5.9,1 5,1.9 5,3V21C5,22.1 5.9,23 7,23H17C18.1,23 19,22.1 19,21V3C19,1.9 18.1,1 17,1H7M7,3H17V21H7V3M9,6V18H15V6H9M10,7H14V11H10V7M10,13H14V17H10V13Z",
  },
  {
    id: "ECC94305-DFA6-4D9B-85C8-CC79F3F05FB5",
    name: "lightbulb",
    codepoint: "F335",
    aliases: [],
    tags: ["Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M12,2C8.13,2 5,5.13 5,9C5,11.38 6.19,13.47 8,14.74V17C8,17.55 8.45,18 9,18H15C15.55,18 16,17.55 16,17V14.74C17.81,13.47 19,11.38 19,9C19,5.13 15.87,2 12,2M9,21C9,21.55 9.45,22 10,22H14C14.55,22 15,21.55 15,21V20H9V21Z",
  },
  {
    id: "4B3F67C4-02C3-4083-B47A-645AD24992FA",
    name: "lightbulb-on",
    codepoint: "F6E7",
    aliases: [],
    tags: ["Home Automation"],
    author: "Austin Andrews",
    version: "1.8.36",
    path: "M12,6C15.31,6 18,8.69 18,12C18,14.22 16.79,16.16 15,17.2V19C15,19.55 14.55,20 14,20H10C9.45,20 9,19.55 9,19V17.2C7.21,16.16 6,14.22 6,12C6,8.69 8.69,6 12,6M14,21V22C14,22.55 13.55,23 13,23H11C10.45,23 10,22.55 10,22V21H14M20,11H23V13H20V11M1,11H4V13H1V11M13,1V4H11V1H13M4.92,3.5L7.05,5.64L5.63,7.05L3.5,4.93L4.92,3.5M16.95,5.63L19.07,3.5L20.5,4.93L18.37,7.05L16.95,5.63Z",
  },
  {
    id: "1FDA626F-5858-43AE-92A0-9CCE7168F08F",
    name: "lightbulb-on-outline",
    codepoint: "F6E8",
    aliases: [],
    tags: ["Home Automation"],
    author: "Austin Andrews",
    version: "1.8.36",
    path: "M20,11H23V13H20V11M1,11H4V13H1V11M13,1V4H11V1H13M4.92,3.5L7.05,5.64L5.63,7.05L3.5,4.93L4.92,3.5M16.95,5.63L19.07,3.5L20.5,4.93L18.37,7.05L16.95,5.63M12,6C15.31,6 18,8.69 18,12C18,14.22 16.79,16.16 15,17.2V19C15,19.55 14.55,20 14,20H10C9.45,20 9,19.55 9,19V17.2C7.21,16.16 6,14.22 6,12C6,8.69 8.69,6 12,6M14,21V22C14,22.55 13.55,23 13,23H11C10.45,23 10,22.55 10,22V21H14M11,18H13V15.87C14.73,15.43 16,13.86 16,12C16,9.79 14.21,8 12,8C9.79,8 8,9.79 8,12C8,13.86 9.27,15.43 11,15.87V18Z",
  },
  {
    id: "BF6C3B65-0795-43E0-B373-058414FDD485",
    name: "lightbulb-outline",
    codepoint: "F336",
    aliases: [],
    tags: ["Home Automation"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,2C15.87,2 19,5.13 19,9C19,11.38 17.81,13.47 16,14.74V17C16,17.55 15.55,18 15,18H9C8.45,18 8,17.55 8,17V14.74C6.19,13.47 5,11.38 5,9C5,5.13 8.13,2 12,2M9,21V20H15V21C15,21.55 14.55,22 14,22H10C9.45,22 9,21.55 9,21M12,4C9.24,4 7,6.24 7,9C7,11.05 8.23,12.81 10,13.58V16H14V13.58C15.77,12.81 17,11.05 17,9C17,6.24 14.76,4 12,4Z",
  },
  {
    id: "95534506-8ECD-49B3-9F87-64D52CC874BA",
    name: "lighthouse",
    codepoint: "F9FE",
    aliases: [],
    tags: [],
    author: "Michael Irigoyen",
    version: "2.5.94",
    path: "M8,10V8H9V4H8V3L12,1L16,3V4H15V8H16V10H14.74L8.44,13.64L9,10H8M13,8V4H11V8H13M7,23L7.04,22.76L16.15,17.5L16.67,20.88L13,23H7M8.05,16.17L15.31,12L15.83,15.37L7.43,20.22L8.05,16.17Z",
  },
  {
    id: "85B287CF-D036-4E36-934F-B6FA28892D9C",
    name: "lighthouse-on",
    codepoint: "F9FF",
    aliases: [],
    tags: [],
    author: "Michael Irigoyen",
    version: "2.5.94",
    path: "M1,10V2L10,5V7L1,10M8,10V8H13V4H8V3L12,1L16,3V4H15V8H16V10H14.74L8.44,13.64L9,10H8M7,23L7.04,22.76L16.15,17.5L16.67,20.88L13,23H7M8.05,16.17L15.31,12L15.83,15.37L7.43,20.22L8.05,16.17Z",
  },
  {
    id: "462769C2-0A30-4B31-B66C-55168B10D705",
    name: "link",
    codepoint: "F337",
    aliases: ["insert-link"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M16,6H13V7.9H16C18.26,7.9 20.1,9.73 20.1,12C20.1,14.26 18.26,16.1 16,16.1H13V18H16C19.31,18 22,15.31 22,12C22,8.68 19.31,6 16,6M3.9,12C3.9,9.73 5.74,7.9 8,7.9H11V6H8C4.69,6 2,8.69 2,12C2,15.31 4.69,18 8,18H11V16.1H8C5.74,16.1 3.9,14.26 3.9,12M8,13H16V11H8V13Z",
  },
  {
    id: "0DACA19D-EFEB-4D22-BE20-9E8FB8C1BBEB",
    name: "link-off",
    codepoint: "F338",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M2,5.27L3.28,4L20,20.72L18.73,22L14.73,18H13V16.27L9.73,13H8V11.27L5.5,8.76C4.5,9.5 3.9,10.68 3.9,12C3.9,14.26 5.74,16.1 8,16.1H11V18H8C4.69,18 2,15.31 2,12C2,10.16 2.83,8.5 4.14,7.41L2,5.27M16,6C19.31,6 22,8.69 22,12C22,14.21 20.8,16.15 19,17.19L17.6,15.77C19.07,15.15 20.1,13.7 20.1,12C20.1,9.73 18.26,7.9 16,7.9H13V6H16M8,6H11V7.9H9.72L7.82,6H8M16,11V13H14.82L12.82,11H16Z",
  },
  {
    id: "4D09DDBE-9716-4162-9DA9-B50892241E15",
    name: "link-variant",
    codepoint: "F339",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M10.59,13.41C11,13.8 11,14.44 10.59,14.83C10.2,15.22 9.56,15.22 9.17,14.83C7.22,12.88 7.22,9.71 9.17,7.76V7.76L12.71,4.22C14.66,2.27 17.83,2.27 19.78,4.22C21.73,6.17 21.73,9.34 19.78,11.29L18.29,12.78C18.3,11.96 18.17,11.14 17.89,10.36L18.36,9.88C19.54,8.71 19.54,6.81 18.36,5.64C17.19,4.46 15.29,4.46 14.12,5.64L10.59,9.17C9.41,10.34 9.41,12.24 10.59,13.41M13.41,9.17C13.8,8.78 14.44,8.78 14.83,9.17C16.78,11.12 16.78,14.29 14.83,16.24V16.24L11.29,19.78C9.34,21.73 6.17,21.73 4.22,19.78C2.27,17.83 2.27,14.66 4.22,12.71L5.71,11.22C5.7,12.04 5.83,12.86 6.11,13.65L5.64,14.12C4.46,15.29 4.46,17.19 5.64,18.36C6.81,19.54 8.71,19.54 9.88,18.36L13.41,14.83C14.59,13.66 14.59,11.76 13.41,10.59C13,10.2 13,9.56 13.41,9.17Z",
  },
  {
    id: "BC8F07E8-9157-49BB-B8DF-CCCDB19C5467",
    name: "link-variant-off",
    codepoint: "F33A",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M2,5.27L3.28,4L20,20.72L18.73,22L13.9,17.17L11.29,19.78C9.34,21.73 6.17,21.73 4.22,19.78C2.27,17.83 2.27,14.66 4.22,12.71L5.71,11.22C5.7,12.04 5.83,12.86 6.11,13.65L5.64,14.12C4.46,15.29 4.46,17.19 5.64,18.36C6.81,19.54 8.71,19.54 9.88,18.36L12.5,15.76L10.88,14.15C10.87,14.39 10.77,14.64 10.59,14.83C10.2,15.22 9.56,15.22 9.17,14.83C8.12,13.77 7.63,12.37 7.72,11L2,5.27M12.71,4.22C14.66,2.27 17.83,2.27 19.78,4.22C21.73,6.17 21.73,9.34 19.78,11.29L18.29,12.78C18.3,11.96 18.17,11.14 17.89,10.36L18.36,9.88C19.54,8.71 19.54,6.81 18.36,5.64C17.19,4.46 15.29,4.46 14.12,5.64L10.79,8.97L9.38,7.55L12.71,4.22M13.41,9.17C13.8,8.78 14.44,8.78 14.83,9.17C16.2,10.54 16.61,12.5 16.06,14.23L14.28,12.46C14.23,11.78 13.94,11.11 13.41,10.59C13,10.2 13,9.56 13.41,9.17Z",
  },
  {
    id: "248F9A0F-7732-4FC9-8E64-2E4B47BBFDCD",
    name: "linkedin",
    codepoint: "F33B",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M21,21H17V14.25C17,13.19 15.81,12.31 14.75,12.31C13.69,12.31 13,13.19 13,14.25V21H9V9H13V11C13.66,9.93 15.36,9.24 16.5,9.24C19,9.24 21,11.28 21,13.75V21M7,21H3V9H7V21M5,3C6.1,3 7,3.9 7,5C7,6.1 6.1,7 5,7C3.9,7 3,6.1 3,5C3,3.9 3.9,3 5,3Z",
  },
  {
    id: "A58FE3A3-BC2C-48A4-8146-0D15F1B80128",
    name: "linux",
    codepoint: "F33D",
    aliases: ["tux"],
    tags: ["Animal", "Brand / Logo"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M14.62,8.35C14.2,8.63 12.87,9.39 12.67,9.54C12.28,9.85 11.92,9.83 11.53,9.53C11.33,9.37 10,8.61 9.58,8.34C9.1,8.03 9.13,7.64 9.66,7.42C11.3,6.73 12.94,6.78 14.57,7.45C15.06,7.66 15.08,8.05 14.62,8.35M21.84,15.63C20.91,13.54 19.64,11.64 18,9.97C17.47,9.42 17.14,8.8 16.94,8.09C16.84,7.76 16.77,7.42 16.7,7.08C16.5,6.2 16.41,5.3 16,4.47C15.27,2.89 14,2.07 12.16,2C10.35,2.05 9,2.81 8.21,4.4C8,4.83 7.85,5.28 7.75,5.74C7.58,6.5 7.43,7.29 7.25,8.06C7.1,8.71 6.8,9.27 6.29,9.77C4.68,11.34 3.39,13.14 2.41,15.12C2.27,15.41 2.13,15.7 2.04,16C1.85,16.66 2.33,17.12 3.03,16.96C3.47,16.87 3.91,16.78 4.33,16.65C4.74,16.5 4.9,16.6 5,17C5.65,19.15 7.07,20.66 9.24,21.5C13.36,23.06 18.17,20.84 19.21,16.92C19.28,16.65 19.38,16.55 19.68,16.65C20.14,16.79 20.61,16.89 21.08,17C21.57,17.09 21.93,16.84 22,16.36C22.03,16.1 21.94,15.87 21.84,15.63",
  },
  {
    id: "608E356A-A5F0-4992-BE8D-E99CCC533FC7",
    name: "linux-mint",
    codepoint: "F8EC",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Contributors",
    version: "2.3.50",
    path: "M2,3.23V6.8H3.5C4.59,6.8 4.78,7.53 4.78,8.55V14.86C4.78,18.12 7.65,20.77 11.18,20.77H19.9C21,20.77 22,20.07 22,19V9.2C22,5.93 19.13,3.28 15.6,3.28H11.93V3.27L2,3.23V3.23M6.62,5.46H8.37V14.45C8.37,15.65 9.19,16.59 10.16,16.59L16.13,16.61C17.38,16.61 18.35,15.75 18.35,14.73L18.34,9.96C18.34,9.65 18.24,9.41 18,9.19C17.79,8.96 17.56,8.86 17.25,8.86C16.94,8.86 16.71,8.96 16.5,9.19C16.27,9.41 16.16,9.65 16.16,9.96V14.05H14.31V9.96C14.31,9.65 14.21,9.41 14,9.19C13.77,8.96 13.54,8.86 13.22,8.86C12.92,8.86 12.68,8.96 12.46,9.19C12.24,9.41 12.14,9.65 12.14,9.96V14.05H10.29V9.96C10.29,9.15 10.58,8.44 11.15,7.86C11.72,7.29 12.43,7 13.22,7C14,7 14.68,7.28 15.24,7.82C15.79,7.28 16.47,7 17.25,7C18.05,7 18.76,7.29 19.32,7.86C19.89,8.44 20.19,9.15 20.19,9.96L20.2,15.06C20.11,15.91 19.75,16.67 19.13,17.31V17.31C18.4,18.04 17.5,18.42 16.5,18.42H9.83C9,18.34 8.29,17.95 7.69,17.36C7,16.65 6.62,15.79 6.62,14.79V5.46H6.62Z",
  },
  {
    id: "205A2FF1-8827-4D3D-8580-FF7FFCD5232C",
    name: "loading",
    codepoint: "F771",
    aliases: [],
    tags: [],
    author: "Kateryna Porshnieva",
    version: "1.9.32",
    path: "M12,4V2C6.48,2 2,6.48 2,12H4C4,7.58 7.58,4 12,4Z",
  },
  {
    id: "D711AFDE-2B8D-4932-82AC-A04E7B2810AE",
    name: "lock",
    codepoint: "F33E",
    aliases: ["https"],
    tags: ["Lock", "Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M12,17C13.1,17 14,16.1 14,15C14,13.89 13.1,13 12,13C10.9,13 10,13.9 10,15C10,16.1 10.9,17 12,17M18,8C19.1,8 20,8.9 20,10V20C20,21.1 19.1,22 18,22H6C4.9,22 4,21.1 4,20V10C4,8.89 4.9,8 6,8H7V6C7,3.24 9.24,1 12,1C14.76,1 17,3.24 17,6V8H18M12,3C10.34,3 9,4.34 9,6V8H15V6C15,4.34 13.66,3 12,3Z",
  },
  {
    id: "6AFF2FDC-D4F8-41F6-8B80-908D1AB87424",
    name: "lock-alert",
    codepoint: "F8ED",
    aliases: ["lock-warning"],
    tags: ["Lock"],
    author: "Cody",
    version: "2.3.50",
    path: "M12,1C9.24,1 7,3.24 7,6V8H6C4.9,8 4,8.9 4,10V20C4,21.1 4.9,22 6,22H18C19.1,22 20,21.1 20,20V10C20,8.9 19.1,8 18,8H17V6C17,3.24 14.76,1 12,1M12,2.9C13.71,2.9 15.1,4.29 15.1,6V8H8.9V6C8.9,4.29 10.29,2.9 12,2.9M11,11H13V15H11V11M11,17H13V19H11V17Z",
  },
  {
    id: "C16C2563-9EA4-4545-9CF4-56C5EA9FD9F9",
    name: "lock-clock",
    codepoint: "F97E",
    aliases: ["confidential-mode"],
    tags: ["Lock", "Date / Time"],
    author: "Google",
    version: "2.4.85",
    path: "M8.5,2C6,2 4,4 4,6.5V7C2.89,7 2,7.89 2,9V18C2,19.11 2.89,20 4,20H8.72C10.18,21.29 12.06,22 14,22C18.42,22 22,18.42 22,14C22,9.58 18.42,6 14,6C13.66,6 13.32,6.03 13,6.08C12.76,3.77 10.82,2 8.5,2M8.5,4C9.88,4 11,5.12 11,6.5V7H6V6.5C6,5.12 7.12,4 8.5,4M14,8C17.31,8 20,10.69 20,14C20,17.31 17.31,20 14,20C10.69,20 8,17.31 8,14C8,10.69 10.69,8 14,8M13,10V15L16.64,17.19L17.42,15.9L14.5,14.15V10H13Z",
  },
  {
    id: "E357D5CD-7E42-463B-899A-7D7B038A3E31",
    name: "lock-open",
    codepoint: "F33F",
    aliases: [],
    tags: ["Lock", "Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M18,8C19.1,8 20,8.9 20,10V20C20,21.1 19.1,22 18,22H6C4.89,22 4,21.1 4,20V10C4,8.9 4.9,8 6,8H15V6C15,4.34 13.66,3 12,3C10.34,3 9,4.34 9,6H7C7,3.24 9.24,1 12,1C14.76,1 17,3.24 17,6V8H18M12,17C13.1,17 14,16.1 14,15C14,13.9 13.1,13 12,13C10.9,13 10,13.9 10,15C10,16.1 10.9,17 12,17Z",
  },
  {
    id: "DCE8B967-BCDE-4130-8BF3-DDA78A78326F",
    name: "lock-open-outline",
    codepoint: "F340",
    aliases: [],
    tags: ["Lock", "Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M18,20V10H6V20H18M18,8C19.1,8 20,8.9 20,10V20C20,21.1 19.1,22 18,22H6C4.89,22 4,21.1 4,20V10C4,8.9 4.9,8 6,8H15V6C15,4.34 13.66,3 12,3C10.34,3 9,4.34 9,6H7C7,3.24 9.24,1 12,1C14.76,1 17,3.24 17,6V8H18M12,17C10.9,17 10,16.1 10,15C10,13.9 10.9,13 12,13C13.1,13 14,13.9 14,15C14,16.1 13.1,17 12,17Z",
  },
  {
    id: "86AD97CA-6028-45C2-8C9A-8C4A562A8E49",
    name: "lock-outline",
    codepoint: "F341",
    aliases: [],
    tags: ["Lock", "Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M12,17C10.89,17 10,16.1 10,15C10,13.89 10.89,13 12,13C13.1,13 14,13.9 14,15C14,16.1 13.1,17 12,17M18,20V10H6V20H18M18,8C19.1,8 20,8.9 20,10V20C20,21.1 19.1,22 18,22H6C4.89,22 4,21.1 4,20V10C4,8.89 4.89,8 6,8H7V6C7,3.24 9.24,1 12,1C14.76,1 17,3.24 17,6V8H18M12,3C10.34,3 9,4.34 9,6V8H15V6C15,4.34 13.66,3 12,3Z",
  },
  {
    id: "6921C166-7D1E-44E4-90B9-ADF6668DDFB9",
    name: "lock-pattern",
    codepoint: "F6E9",
    aliases: [],
    tags: [],
    author: "JapanYoshi",
    version: "1.8.36",
    path: "M7,3C9.21,3 11,4.79 11,7C11,8.86 9.73,10.43 8,10.87V13.13C8.37,13.22 8.72,13.37 9.04,13.56L13.56,9.04C13.2,8.44 13,7.75 13,7C13,4.79 14.79,3 17,3C19.21,3 21,4.79 21,7C21,9.21 19.21,11 17,11C16.26,11 15.57,10.8 15,10.45L10.45,15C10.8,15.57 11,16.26 11,17C11,19.21 9.21,21 7,21C4.79,21 3,19.21 3,17C3,15.14 4.27,13.57 6,13.13V10.87C4.27,10.43 3,8.86 3,7C3,4.79 4.79,3 7,3M17,13C19.21,13 21,14.79 21,17C21,19.21 19.21,21 17,21C14.79,21 13,19.21 13,17C13,14.79 14.79,13 17,13M17,15C15.9,15 15,15.9 15,17C15,18.1 15.9,19 17,19C18.1,19 19,18.1 19,17C19,15.9 18.1,15 17,15Z",
  },
  {
    id: "BA4D2E1E-2BCB-4B17-AC02-52C8F34FAEAE",
    name: "lock-plus",
    codepoint: "F5FB",
    aliases: ["enhanced-encryption"],
    tags: ["Lock"],
    author: "Google",
    version: "1.5.54",
    path: "M18,8H17V6C17,3.24 14.76,1 12,1C9.24,1 7,3.24 7,6V8H6C4.9,8 4,8.9 4,10V20C4,21.1 4.9,22 6,22H18C19.1,22 20,21.1 20,20V10C20,8.9 19.1,8 18,8M8.9,6C8.9,4.29 10.29,2.9 12,2.9C13.71,2.9 15.1,4.29 15.1,6V8H8.9V6M16,16H13V19H11V16H8V14H11V11H13V14H16V16Z",
  },
  {
    id: "390C2479-98DD-46FB-AA39-CD816E7982C8",
    name: "lock-question",
    codepoint: "F8EE",
    aliases: ["forgot-password"],
    tags: ["Lock"],
    author: "Cody",
    version: "2.3.50",
    path: "M12,1C9.24,1 7,3.24 7,6V8H6C4.9,8 4,8.9 4,10V20C4,21.1 4.9,22 6,22H18C19.1,22 20,21.1 20,20V10C20,8.9 19.1,8 18,8H17V6C17,3.24 14.76,1 12,1M12,2.9C13.71,2.9 15.1,4.29 15.1,6V8H8.9V6C8.9,4.29 10.29,2.9 12,2.9M12.19,10.5C13.13,10.5 13.88,10.71 14.42,11.12C14.96,11.54 15.23,12.1 15.23,12.8C15.23,13.24 15.08,13.63 14.79,14C14.5,14.36 14.12,14.64 13.66,14.85C13.4,15 13.23,15.15 13.14,15.32C13.05,15.5 13,15.72 13,16H11C11,15.5 11.1,15.16 11.29,14.92C11.5,14.68 11.84,14.4 12.36,14.08C12.62,13.94 12.83,13.76 13,13.54C13.14,13.33 13.22,13.08 13.22,12.8C13.22,12.5 13.13,12.28 12.95,12.11C12.77,11.93 12.5,11.85 12.19,11.85C11.92,11.85 11.7,11.92 11.5,12.06C11.34,12.2 11.24,12.41 11.24,12.69H9.27C9.22,12 9.5,11.4 10.05,11.04C10.59,10.68 11.3,10.5 12.19,10.5M11,17H13V19H11V17Z",
  },
  {
    id: "82312B48-E128-494E-9D84-DAACB41986F4",
    name: "lock-reset",
    codepoint: "F772",
    aliases: ["password-reset"],
    tags: ["Lock"],
    author: "Google",
    version: "1.9.32",
    path: "M12.63,2C18.16,2 22.64,6.5 22.64,12C22.64,17.5 18.16,22 12.63,22C9.12,22 6.05,20.18 4.26,17.43L5.84,16.18C7.25,18.47 9.76,20 12.64,20C17.06,20 20.64,16.42 20.64,12C20.64,7.58 17.06,4 12.64,4C8.56,4 5.2,7.06 4.71,11H7.47L3.73,14.73L0,11H2.69C3.19,5.95 7.45,2 12.63,2M15.59,10.24C16.09,10.25 16.5,10.65 16.5,11.16V15.77C16.5,16.27 16.09,16.69 15.58,16.69H10.05C9.54,16.69 9.13,16.27 9.13,15.77V11.16C9.13,10.65 9.54,10.25 10.04,10.24V9.23C10.04,7.7 11.29,6.46 12.81,6.46C14.34,6.46 15.59,7.7 15.59,9.23V10.24M12.81,7.86C12.06,7.86 11.44,8.47 11.44,9.23V10.24H14.19V9.23C14.19,8.47 13.57,7.86 12.81,7.86Z",
  },
  {
    id: "1D8C9A6B-26F4-45E1-B922-E0BAED0A5FBD",
    name: "lock-smart",
    codepoint: "F8B1",
    aliases: [],
    tags: ["Home Automation"],
    author: "GreenTurtwig",
    version: "2.2.43",
    path: "M12,2C8.69,2 6,4.69 6,8V16C6,19.31 8.69,22 12,22C15.31,22 18,19.31 18,16V8C18,4.69 15.31,2 12,2M8,6H10V8H8V6M11,6H13V8H11V6M14,6H16V8H14V6M8,9H10V11H8V9M11,9H13V11H11V9M14,9H16V11H14V9M8,12H10V14H8V12M11,12H13V14H11V12M14,12H16V14H14V12M12,16C13.1,16 14,16.9 14,18C14,19.1 13.1,20 12,20C10.9,20 10,19.1 10,18C10,16.9 10.9,16 12,16Z",
  },
  {
    id: "B8B0EAF4-369F-412A-A092-4AA85BBE77FD",
    name: "locker",
    codepoint: "F7D6",
    aliases: [],
    tags: [],
    author: "Contributors",
    version: "2.0.46",
    path: "M8,2H16C17.1,2 18,2.9 18,4V20C18,21.1 17.1,22 16,22H8C6.9,22 6,21.1 6,20V4C6,2.9 6.9,2 8,2M8,4V20H16V4H8M10,13H12V17H10V13M10,6H14V7.5H10V6M10,9H14V10.5H10V9Z",
  },
  {
    id: "4A5533A8-402C-45F2-9D7A-A8949C22C33B",
    name: "locker-multiple",
    codepoint: "F7D7",
    aliases: [],
    tags: [],
    author: "Contributors",
    version: "2.0.46",
    path: "M3,2H21C22.1,2 23,2.9 23,4V20C23,21.1 22.1,22 21,22H3C1.9,22 1,21.1 1,20V4C1,2.9 1.9,2 3,2M13,4V20H21V4H13M3,4V20H11V4H3M5,13H7V17H5V13M5,6H9V7.5H5V6M5,9H9V10.5H5V9M15,13H17V17H15V13M15,6H19V7.5H15V6M15,9H19V10.5H15V9Z",
  },
  {
    id: "63D8BFA5-7AE4-4002-A4C2-C464638C38FC",
    name: "login",
    codepoint: "F342",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M10,17.25V14H3V10H10V6.75L15.25,12L10,17.25M8,2H17C18.1,2 19,2.9 19,4V20C19,21.1 18.1,22 17,22H8C6.9,22 6,21.1 6,20V16H8V20H17V4H8V8H6V4C6,2.9 6.9,2 8,2Z",
  },
  {
    id: "B590AA80-D315-4344-8036-8FBC25C87D2C",
    name: "login-variant",
    codepoint: "F5FC",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M19,3H5C3.89,3 3,3.89 3,5V9H5V5H19V19H5V15H3V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3M10.08,15.58L11.5,17L16.5,12L11.5,7L10.08,8.41L12.67,11H3V13H12.67L10.08,15.58Z",
  },
  {
    id: "47DF41F2-49C7-4081-8419-F49C7894E7F1",
    name: "logout",
    codepoint: "F343",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M17,17.25V14H10V10H17V6.75L22.25,12L17,17.25M13,2C14.1,2 15,2.9 15,4V8H13V4H4V20H13V16H15V20C15,21.1 14.1,22 13,22H4C2.9,22 2,21.1 2,20V4C2,2.9 2.9,2 4,2H13Z",
  },
  {
    id: "FD2A4CE0-AD1F-45D4-B487-BB6E57F2143F",
    name: "logout-variant",
    codepoint: "F5FD",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M14.08,15.59L16.67,13H7V11H16.67L14.08,8.41L15.5,7L20.5,12L15.5,17L14.08,15.59M19,3C20.1,3 21,3.9 21,5V9.67L19,7.67V5H5V19H19V16.33L21,14.33V19C21,20.1 20.1,21 19,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H19Z",
  },
  {
    id: "3633613A-B8A7-49D0-8C1B-5415EC76F426",
    name: "looks",
    codepoint: "F344",
    aliases: ["rainbow"],
    tags: ["Weather"],
    author: "Google",
    version: "1.5.54",
    path: "M12,6C5.92,6 1,10.92 1,17H3C3,12.04 7.04,8 12,8C16.96,8 21,12.04 21,17H23C23,10.92 18.08,6 12,6M12,10C8.14,10 5,13.14 5,17H7C7,14.24 9.24,12 12,12C14.76,12 17,14.24 17,17H19C19,13.14 15.86,10 12,10Z",
  },
  {
    id: "235EF258-40BB-47C3-9D5F-1497A7FD34D9",
    name: "lumx",
    codepoint: "F346",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12.35,1.75L20.13,9.53L13.77,15.89L12.35,14.47L17.3,9.53L10.94,3.16L12.35,1.75M15.89,9.53L14.47,10.94L10.23,6.7L5.28,11.65L3.87,10.23L10.23,3.87L15.89,9.53M10.23,8.11L11.65,9.53L6.7,14.47L13.06,20.84L11.65,22.25L3.87,14.47L10.23,8.11M8.11,14.47L9.53,13.06L13.77,17.3L18.72,12.35L20.13,13.77L13.77,20.13L8.11,14.47Z",
  },
  {
    id: "65B3A914-578A-468F-95C1-9C2B6D0C3A52",
    name: "magnet",
    codepoint: "F347",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M3,7V13C3,17.97 7.03,22 12,22C16.97,22 21,17.97 21,13V7H17V13C17,15.76 14.76,18 12,18C9.24,18 7,15.76 7,13V7M17,5H21V2H17M3,5H7V2H3",
  },
  {
    id: "3A386A5A-35AC-4760-9384-33A9A43CF584",
    name: "magnet-on",
    codepoint: "F348",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M3,7V13C3,17.97 7.03,22 12,22C16.97,22 21,17.97 21,13V7H17V13C17,15.76 14.76,18 12,18C9.24,18 7,15.76 7,13V7M17,5H21V2H17M3,5H7V2H3M13,1.5L9,9H11V14.5L15,7H13V1.5Z",
  },
  {
    id: "C2889545-7F08-4AE1-9142-ECF9B79957E1",
    name: "magnify",
    codepoint: "F349",
    aliases: ["search"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M9.5,3C13.09,3 16,5.91 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16C5.91,16 3,13.09 3,9.5C3,5.91 5.91,3 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z",
  },
  {
    id: "C48FDEBE-952C-4B4A-9EB8-47A18186EB0B",
    name: "magnify-close",
    codepoint: "F97F",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.4.85",
    path: "M9,2C12.87,2 16,5.13 16,9C16,10.5 15.5,12 14.61,13.19L15.41,14H16L22,20L20,22L14,16V15.41L13.19,14.61C12,15.5 10.5,16 9,16C5.13,16 2,12.87 2,9C2,5.13 5.13,2 9,2M11.12,5.46L9,7.59L6.88,5.46L5.46,6.88L7.59,9L5.46,11.12L6.88,12.54L9,10.41L11.12,12.54L12.54,11.12L10.41,9L12.54,6.88L11.12,5.46Z",
  },
  {
    id: "36D3966F-BFA2-407B-BF36-D21FBA930930",
    name: "magnify-minus",
    codepoint: "F34A",
    aliases: ["zoom-out"],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M9,2C12.87,2 16,5.13 16,9C16,10.57 15.5,12 14.61,13.19L15.41,14H16L22,20L20,22L14,16V15.41L13.19,14.61C12,15.5 10.57,16 9,16C5.13,16 2,12.87 2,9C2,5.13 5.13,2 9,2M5,8V10H13V8H5Z",
  },
  {
    id: "9E259697-7035-4E17-82D6-431C74215E67",
    name: "magnify-minus-outline",
    codepoint: "F6EB",
    aliases: ["zoom-out-outline"],
    tags: [],
    author: "Google",
    version: "1.8.36",
    path: "M15.5,14H14.71L14.43,13.73C15.41,12.59 16,11.11 16,9.5C16,5.91 13.09,3 9.5,3C5.91,3 3,5.91 3,9.5C3,13.09 5.91,16 9.5,16C11.11,16 12.59,15.41 13.73,14.43L14,14.71V15.5L19,20.5L20.5,19L15.5,14M9.5,14C7,14 5,12 5,9.5C5,7 7,5 9.5,5C12,5 14,7 14,9.5C14,12 12,14 9.5,14M7,9H12V10H7V9Z",
  },
  {
    id: "798F7C9D-2EC7-47EF-8729-845B4E2DDD16",
    name: "magnify-plus",
    codepoint: "F34B",
    aliases: ["zoom-in"],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M9,2C12.87,2 16,5.13 16,9C16,10.57 15.5,12 14.61,13.19L15.41,14H16L22,20L20,22L14,16V15.41L13.19,14.61C12,15.5 10.57,16 9,16C5.13,16 2,12.87 2,9C2,5.13 5.13,2 9,2M8,5V8H5V10H8V13H10V10H13V8H10V5H8Z",
  },
  {
    id: "521EC414-ECAD-435D-BAE3-4CF772659845",
    name: "magnify-plus-outline",
    codepoint: "F6EC",
    aliases: ["zoom-in-outline"],
    tags: [],
    author: "Google",
    version: "1.8.36",
    path: "M15.5,14L20.5,19L19,20.5L14,15.5V14.71L13.73,14.43C12.59,15.41 11.11,16 9.5,16C5.91,16 3,13.09 3,9.5C3,5.91 5.91,3 9.5,3C13.09,3 16,5.91 16,9.5C16,11.11 15.41,12.59 14.43,13.73L14.71,14H15.5M9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14M12,10H10V12H9V10H7V9H9V7H10V9H12V10Z",
  },
  {
    id: "CCEA599C-8CED-4D49-83FB-7AC452AADFA0",
    name: "mailbox",
    codepoint: "F6ED",
    aliases: ["markunread-mailbox"],
    tags: [],
    author: "Google",
    version: "1.8.36",
    path: "M20,6H10V12H8V4H14V0H6V6H4C2.9,6 2,6.9 2,8V20C2,21.1 2.9,22 4,22H20C21.1,22 22,21.1 22,20V8C22,6.9 21.1,6 20,6Z",
  },
  {
    id: "99738FF8-01AE-420D-8481-8B9E1402255B",
    name: "map",
    codepoint: "F34D",
    aliases: [],
    tags: ["Navigation"],
    author: "Google",
    version: "1.5.54",
    path: "M15,19L9,16.89V5L15,7.11M20.5,3C20.44,3 20.39,3 20.34,3L15,5.1L9,3L3.36,4.9C3.15,4.97 3,5.15 3,5.38V20.5C3,20.78 3.22,21 3.5,21C3.55,21 3.61,21 3.66,20.97L9,18.9L15,21L20.64,19.1C20.85,19 21,18.85 21,18.62V3.5C21,3.22 20.78,3 20.5,3Z",
  },
  {
    id: "69651FB0-089C-4D57-8465-46716D86DBCA",
    name: "map-legend",
    codepoint: "FA00",
    aliases: [],
    tags: [],
    author: "Contributors",
    version: "2.5.94",
    path: "M9,3L3.36,4.9C3.15,4.97 3,5.15 3,5.38V20.5C3,20.78 3.22,21 3.5,21L3.66,20.97L9,18.9L15,21L20.64,19.1C20.85,19.03 21,18.85 21,18.62V3.5C21,3.22 20.78,3 20.5,3L20.34,3.03L15,5.1L9,3M8,5.45V17.15L5,18.31V6.46L8,5.45M10,5.47L14,6.87V18.53L10,17.13V5.47M19,5.7V17.54L16,18.55V6.86L19,5.7M7.46,6.3L5.57,6.97V9.12L7.46,8.45V6.3M7.46,9.05L5.57,9.72V11.87L7.46,11.2V9.05M7.46,11.8L5.57,12.47V14.62L7.46,13.95V11.8M7.46,14.55L5.57,15.22V17.37L7.46,16.7V14.55Z",
  },
  {
    id: "379B9D93-434B-46E7-9ABC-CAFAB694B209",
    name: "map-marker",
    codepoint: "F34E",
    aliases: ["location", "address-marker", "location-on", "place", "room"],
    tags: ["Navigation"],
    author: "Google",
    version: "1.5.54",
    path: "M12,11.5C10.62,11.5 9.5,10.38 9.5,9C9.5,7.62 10.62,6.5 12,6.5C13.38,6.5 14.5,7.62 14.5,9C14.5,10.38 13.38,11.5 12,11.5M12,2C8.13,2 5,5.13 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9C19,5.13 15.87,2 12,2Z",
  },
  {
    id: "03F79839-314C-4F29-B3E3-43B97D7F7FA6",
    name: "map-marker-circle",
    codepoint: "F34F",
    aliases: ["explore-nearby"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M12,12.5C11.17,12.5 10.5,11.83 10.5,11C10.5,10.17 11.17,9.5 12,9.5C12.83,9.5 13.5,10.17 13.5,11C13.5,11.83 12.83,12.5 12,12.5M12,7.2C9.9,7.2 8.2,8.9 8.2,11C8.2,14 12,17.5 12,17.5C12,17.5 15.8,14 15.8,11C15.8,8.9 14.1,7.2 12,7.2Z",
  },
  {
    id: "B2FF0F5A-4B2C-480C-9022-D84AD78E72ED",
    name: "map-marker-distance",
    codepoint: "F8EF",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.3.50",
    path: "M6.5,8.11C5.61,8.11 4.89,7.39 4.89,6.5C4.89,5.61 5.61,4.89 6.5,4.89C7.39,4.89 8.11,5.61 8.11,6.5V6.5C8.11,7.39 7.39,8.11 6.5,8.11M6.5,2C4,2 2,4 2,6.5C2,9.87 6.5,14.86 6.5,14.86C6.5,14.86 11,9.87 11,6.5C11,4 9,2 6.5,2M17.5,8.11C16.61,8.11 15.89,7.39 15.89,6.5C15.89,5.61 16.61,4.89 17.5,4.89C18.39,4.89 19.11,5.61 19.11,6.5C19.11,7.39 18.39,8.11 17.5,8.11M17.5,2C15,2 13,4 13,6.5C13,9.87 17.5,14.86 17.5,14.86C17.5,14.86 22,9.87 22,6.5C22,4 20,2 17.5,2M17.5,16C16.23,16 15.1,16.8 14.68,18H9.32C8.77,16.44 7.05,15.62 5.5,16.17C3.93,16.72 3.11,18.44 3.66,20C4.22,21.56 5.93,22.38 7.5,21.83C8.35,21.53 9,20.85 9.32,20H14.69C15.24,21.56 16.96,22.38 18.5,21.83C20.08,21.28 20.9,19.56 20.35,18C19.92,16.8 18.78,16 17.5,16V16M17.5,20.5C16.67,20.5 16,19.83 16,19C16,18.17 16.67,17.5 17.5,17.5C18.33,17.5 19,18.17 19,19C19,19.83 18.33,20.5 17.5,20.5Z",
  },
  {
    id: "34DD1168-3875-4F77-9C0B-5BCFFB80FBBD",
    name: "map-marker-minus",
    codepoint: "F650",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.6.50",
    path: "M9,11.5C10.38,11.5 11.5,10.38 11.5,9C11.5,7.62 10.38,6.5 9,6.5C7.62,6.5 6.5,7.62 6.5,9C6.5,10.38 7.62,11.5 9,11.5M9,2C12.86,2 16,5.13 16,9C16,14.25 9,22 9,22C9,22 2,14.25 2,9C2,5.13 5.13,2 9,2M15,17H23V19H15V17Z",
  },
  {
    id: "6283577D-6B31-4297-8747-4F466580E79A",
    name: "map-marker-multiple",
    codepoint: "F350",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M14,11.5C15.38,11.5 16.5,10.38 16.5,9C16.5,7.62 15.38,6.5 14,6.5C12.62,6.5 11.5,7.62 11.5,9C11.5,10.38 12.62,11.5 14,11.5M14,2C17.86,2 21,5.13 21,9C21,14.25 14,22 14,22C14,22 7,14.25 7,9C7,5.13 10.13,2 14,2M5,9C5,13.5 10.08,19.66 11,20.81L10,22C10,22 3,14.25 3,9C3,5.83 5.11,3.15 8,2.29C6.16,3.94 5,6.33 5,9Z",
  },
  {
    id: "92410469-09D9-4C29-AC79-CD0DF882D05F",
    name: "map-marker-off",
    codepoint: "F351",
    aliases: ["location-off"],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M16.37,16.1L11.75,11.47L11.64,11.36L3.27,3L2,4.27L5.18,7.45C5.06,7.95 5,8.46 5,9C5,14.25 12,22 12,22C12,22 13.67,20.15 15.37,17.65L18.73,21L20,19.72M12,6.5C13.38,6.5 14.5,7.62 14.5,9C14.5,9.73 14.17,10.39 13.67,10.85L17.3,14.5C18.28,12.62 19,10.68 19,9C19,5.13 15.87,2 12,2C10,2 8.24,2.82 6.96,4.14L10.15,7.33C10.61,6.82 11.26,6.5 12,6.5Z",
  },
  {
    id: "DE8F4623-A6D4-4DD4-B61A-5936A0538FD2",
    name: "map-marker-outline",
    codepoint: "F7D8",
    aliases: [],
    tags: [],
    author: "Contributors",
    version: "2.0.46",
    path: "M12,6.5C13.38,6.5 14.5,7.62 14.5,9C14.5,10.38 13.38,11.5 12,11.5C10.62,11.5 9.5,10.38 9.5,9C9.5,7.62 10.62,6.5 12,6.5M12,2C15.87,2 19,5.13 19,9C19,14.25 12,22 12,22C12,22 5,14.25 5,9C5,5.13 8.13,2 12,2M12,4C9.24,4 7,6.24 7,9C7,10 7,12 12,18.71C17,12 17,10 17,9C17,6.24 14.76,4 12,4Z",
  },
  {
    id: "40CBD1A1-11E1-44A6-8627-6F7C658F5E0F",
    name: "map-marker-plus",
    codepoint: "F651",
    aliases: ["add-location"],
    tags: [],
    author: "Cody",
    version: "1.6.50",
    path: "M9,11.5C10.38,11.5 11.5,10.38 11.5,9C11.5,7.62 10.38,6.5 9,6.5C7.62,6.5 6.5,7.62 6.5,9C6.5,10.38 7.62,11.5 9,11.5M9,2C12.86,2 16,5.13 16,9C16,14.25 9,22 9,22C9,22 2,14.25 2,9C2,5.13 5.13,2 9,2M15,17H18V14H20V17H23V19H20V22H18V19H15V17Z",
  },
  {
    id: "8F346B27-607A-4C98-B83E-C32E921D0468",
    name: "map-marker-radius",
    codepoint: "F352",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,2C15.31,2 18,4.66 18,7.95C18,12.41 12,19 12,19C12,19 6,12.41 6,7.95C6,4.66 8.69,2 12,2M12,6C10.9,6 10,6.9 10,8C10,9.1 10.9,10 12,10C13.1,10 14,9.1 14,8C14,6.9 13.1,6 12,6M20,19C20,21.21 16.42,23 12,23C7.58,23 4,21.21 4,19C4,17.71 5.22,16.56 7.11,15.83L7.75,16.74C6.67,17.19 6,17.81 6,18.5C6,19.88 8.69,21 12,21C15.31,21 18,19.88 18,18.5C18,17.81 17.33,17.19 16.25,16.74L16.89,15.83C18.78,16.56 20,17.71 20,19Z",
  },
  {
    id: "3C2F6429-F2F9-49A9-AF23-DD33413D2619",
    name: "map-minus",
    codepoint: "F980",
    aliases: [],
    tags: ["Navigation"],
    author: "Peter Noble",
    version: "2.4.85",
    path: "M9,3L3.36,4.9C3.16,4.97 3,5.15 3,5.38V20.5C3,20.78 3.22,21 3.5,21C3.55,21 3.6,21 3.66,20.97L9,18.9L13,20.3V18.3L9,16.9V5L15,7.1V16H21V3.5C21,3.22 20.78,3 20.5,3H20.34L15,5.1L9,3M15,18V20H23V18H15Z",
  },
  {
    id: "164AE88B-F990-471C-8663-EFDC05BA14F0",
    name: "map-outline",
    codepoint: "F981",
    aliases: [],
    tags: ["Navigation"],
    author: "Google",
    version: "2.4.85",
    path: "M20.5,3L20.34,3.03L15,5.1L9,3L3.36,4.9C3.15,4.97 3,5.15 3,5.38V20.5C3,20.78 3.22,21 3.5,21L3.66,20.97L9,18.9L15,21L20.64,19.1C20.85,19.03 21,18.85 21,18.62V3.5C21,3.22 20.78,3 20.5,3M10,5.47L14,6.87V18.53L10,17.13V5.47M5,6.46L8,5.45V17.15L5,18.31V6.46M19,17.54L16,18.55V6.86L19,5.7V17.54Z",
  },
  {
    id: "3D7A000E-3E94-4B9B-8CAB-2F6923D425B7",
    name: "map-plus",
    codepoint: "F982",
    aliases: [],
    tags: ["Navigation"],
    author: "Peter Noble",
    version: "2.4.85",
    path: "M9,3L3.36,4.9C3.16,4.97 3,5.15 3,5.38V20.5C3,20.78 3.22,21 3.5,21C3.55,21 3.6,21 3.66,20.97L9,18.9L13.16,20.36C13.06,19.92 13,19.46 13,19C13,18.77 13,18.54 13.04,18.3L9,16.9V5L15,7.1V14.56C16.07,13.6 17.47,13 19,13C19.7,13 20.37,13.13 21,13.36V3.5C21,3.22 20.78,3 20.5,3H20.34L15,5.1L9,3M18,15V18H15V20H18V23H20V20H23V18H20V15H18Z",
  },
  {
    id: "6FB911AA-DE27-441D-8C62-CD97ECB99DA7",
    name: "map-search",
    codepoint: "F983",
    aliases: [],
    tags: ["Navigation"],
    author: "GreenTurtwig",
    version: "2.4.85",
    path: "M15.5,12C18,12 20,14 20,16.5C20,17.38 19.75,18.21 19.31,18.9L22.39,22L21,23.39L17.88,20.32C17.19,20.75 16.37,21 15.5,21C13,21 11,19 11,16.5C11,14 13,12 15.5,12M15.5,14C14.12,14 13,15.12 13,16.5C13,17.88 14.12,19 15.5,19C16.88,19 18,17.88 18,16.5C18,15.12 16.88,14 15.5,14M14,6.11L8,4V15.89L9,16.24V16.5C9,17.14 9.09,17.76 9.26,18.34L8,17.9L2.66,19.97L2.5,20C2.22,20 2,19.78 2,19.5V4.38C2,4.15 2.15,3.97 2.36,3.9L8,2L14,4.1L19.34,2H19.5C19.78,2 20,2.22 20,2.5V11.81C18.83,10.69 17.25,10 15.5,10C15,10 14.5,10.06 14,10.17V6.11Z",
  },
  {
    id: "4EDC2B6E-3E09-41BF-B08C-EB75CEBFFB96",
    name: "map-search-outline",
    codepoint: "F984",
    aliases: [],
    tags: ["Navigation"],
    author: "GreenTurtwig",
    version: "2.4.85",
    path: "M15.5,12C18,12 20,14 20,16.5C20,17.38 19.75,18.2 19.31,18.9L22.39,22L21,23.39L17.88,20.32C17.19,20.75 16.37,21 15.5,21C13,21 11,19 11,16.5C11,14 13,12 15.5,12M15.5,14C14.12,14 13,15.12 13,16.5C13,17.88 14.12,19 15.5,19C16.88,19 18,17.88 18,16.5C18,15.12 16.88,14 15.5,14M19.5,2C19.78,2 20,2.22 20,2.5V11.81C19.42,11.26 18.75,10.81 18,10.5V4.7L15,5.86V10C14.3,10.07 13.62,10.24 13,10.5V5.87L9,4.47V16.13H9V16.5C9,17.14 9.09,17.76 9.26,18.34L8,17.9L2.66,19.97L2.5,20C2.22,20 2,19.78 2,19.5V4.38C2,4.15 2.15,3.97 2.36,3.9L8,2L14,4.1L19.34,2.03L19.5,2M4,5.46V17.31L7,16.15V4.45L4,5.46Z",
  },
  {
    id: "4A7710D4-41B8-4D98-A5B9-591943C3B3EF",
    name: "margin",
    codepoint: "F353",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M20,4V9L18.5,7.5L5.5,20.5L3.5,18.5L16.5,5.5L15,4H20M17,20C15.34,20 14,18.66 14,17V15C14,13.34 15.34,12 17,12C18.66,12 20,13.34 20,15V17C20,18.66 18.66,20 17,20M17,14C16.45,14 16,14.45 16,15V17C16,17.55 16.45,18 17,18C17.55,18 18,17.55 18,17V15C18,14.45 17.55,14 17,14M7,12C5.34,12 4,10.66 4,9V7C4,5.34 5.34,4 7,4C8.66,4 10,5.34 10,7V9C10,10.66 8.66,12 7,12M7,6C6.45,6 6,6.45 6,7V9C6,9.55 6.45,10 7,10C7.55,10 8,9.55 8,9V7C8,6.45 7.55,6 7,6Z",
  },
  {
    id: "71E6D8F0-A3D2-43CB-8940-16AA4E1D9825",
    name: "marker",
    codepoint: "F652",
    aliases: ["highlighter"],
    tags: [],
    author: "Google",
    version: "1.6.50",
    path: "M18.5,1.15C17.97,1.15 17.46,1.34 17.07,1.73L11.26,7.55L16.91,13.2L22.73,7.39C23.5,6.61 23.5,5.35 22.73,4.56L19.89,1.73C19.5,1.34 19,1.15 18.5,1.15M10.3,8.5L4.34,14.46C3.56,15.24 3.56,16.5 4.36,17.31C3.14,18.54 1.9,19.77 0.67,21H6.33L7.19,20.14C7.97,20.9 9.22,20.89 10,20.12L15.95,14.16",
  },
  {
    id: "74C5E15E-D227-4272-94E6-EDFDD0F66C9A",
    name: "marker-check",
    codepoint: "F355",
    aliases: ["beenhere"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M10,16L5,11L6.41,9.58L10,13.17L17.59,5.58L19,7M19,1H5C3.89,1 3,1.89 3,3V15.93C3,16.62 3.35,17.23 3.88,17.59L12,23L20.11,17.59C20.64,17.23 21,16.62 21,15.93V3C21,1.89 20.1,1 19,1Z",
  },
  {
    id: "224604D9-8F3D-454A-B11F-D4C00231B15B",
    name: "material-design",
    codepoint: "F985",
    aliases: [],
    tags: [],
    author: "Google",
    version: "2.4.85",
    path: "M21,12C21,9.97 20.33,8.09 19,6.38V17.63C20.33,15.97 21,14.09 21,12M17.63,19H6.38C7.06,19.55 7.95,20 9.05,20.41C10.14,20.8 11.13,21 12,21C12.88,21 13.86,20.8 14.95,20.41C16.05,20 16.94,19.55 17.63,19M11,17L7,9V17H11M17,9L13,17H17V9M12,14.53L15.75,7H8.25L12,14.53M17.63,5C15.97,3.67 14.09,3 12,3C9.91,3 8.03,3.67 6.38,5H17.63M5,17.63V6.38C3.67,8.09 3,9.97 3,12C3,14.09 3.67,15.97 5,17.63M23,12C23,15.03 21.94,17.63 19.78,19.78C17.63,21.94 15.03,23 12,23C8.97,23 6.38,21.94 4.22,19.78C2.06,17.63 1,15.03 1,12C1,8.97 2.06,6.38 4.22,4.22C6.38,2.06 8.97,1 12,1C15.03,1 17.63,2.06 19.78,4.22C21.94,6.38 23,8.97 23,12Z",
  },
  {
    id: "878C7F4D-DAD0-4334-A3AA-695FD3AD5391",
    name: "material-ui",
    codepoint: "F357",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M8,16.61V15.37L14,11.91V7.23L9,10.12L4,7.23V13L3,13.58L2,13V5L3.07,4.38L9,7.81L12.93,5.54L14.93,4.38L16,5V13.06L10.92,16L14.97,18.33L20,15.43V11L21,10.42L22,11V16.58L14.97,20.64L8,16.61M22,9.75L21,10.33L20,9.75V8.58L21,8L22,8.58V9.75Z",
  },
  {
    id: "10E7FA7C-8451-44B9-979F-1916AAC7FE28",
    name: "math-compass",
    codepoint: "F358",
    aliases: [],
    tags: ["Math"],
    author: "Gabriel",
    version: "1.5.54",
    path: "M13,4.2V3C13,2.4 12.6,2 12,2V4.2C9.8,4.6 9,5.7 9,7C9,7.8 9.3,8.5 9.8,9L4,19.9V22L6.2,20L11.6,10C11.7,10 11.9,10 12,10C13.7,10 15,8.7 15,7C15,5.7 14.2,4.6 13,4.2M12.9,7.5C12.7,7.8 12.4,8 12,8C11.4,8 11,7.6 11,7C11,6.8 11.1,6.7 11.1,6.5C11.3,6.2 11.6,6 12,6C12.6,6 13,6.4 13,7C13,7.2 12.9,7.3 12.9,7.5M20,19.9V22H20L17.8,20L13.4,11.8C14.1,11.6 14.7,11.3 15.2,10.9L20,19.9Z",
  },
  {
    id: "5D5ED3F2-71BD-44B6-B4BB-61D73211335F",
    name: "matrix",
    codepoint: "F628",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.6.50",
    path: "M2,2H6V4H4V20H6V22H2V2M20,4H18V2H22V22H18V20H20V4M9,5H10V10H11V11H8V10H9V6L8,6.5V5.5L9,5M15,13H16V18H17V19H14V18H15V14L14,14.5V13.5L15,13M9,13C10.1,13 11,14.34 11,16C11,17.66 10.1,19 9,19C7.9,19 7,17.66 7,16C7,14.34 7.9,13 9,13M9,14C8.45,14 8,14.9 8,16C8,17.1 8.45,18 9,18C9.55,18 10,17.1 10,16C10,14.9 9.55,14 9,14M15,5C16.1,5 17,6.34 17,8C17,9.66 16.1,11 15,11C13.9,11 13,9.66 13,8C13,6.34 13.9,5 15,5M15,6C14.45,6 14,6.9 14,8C14,9.1 14.45,10 15,10C15.55,10 16,9.1 16,8C16,6.9 15.55,6 15,6Z",
  },
  {
    id: "626FA95C-E655-44A6-BA6A-4B60CED44B6D",
    name: "medal",
    codepoint: "F986",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.4.85",
    path: "M20,2H4V4L9.81,8.36C6.14,9.57 4.14,13.53 5.35,17.2C6.56,20.87 10.5,22.87 14.19,21.66C17.86,20.45 19.86,16.5 18.65,12.82C17.95,10.71 16.3,9.05 14.19,8.36L20,4V2M14.94,19.5L12,17.78L9.06,19.5L9.84,16.17L7.25,13.93L10.66,13.64L12,10.5L13.34,13.64L16.75,13.93L14.16,16.17L14.94,19.5Z",
  },
  {
    id: "7F6DF58A-C9A3-4CE7-9664-28C04218C628",
    name: "medical-bag",
    codepoint: "F6EE",
    aliases: ["first-aid-kit"],
    tags: ["Medical / Hospital"],
    author: "Thomas Hunsaker",
    version: "1.8.36",
    path: "M10,3L8,5V7H5C3.85,7 3.12,8 3,9L2,19C1.88,20 2.54,21 4,21H20C21.46,21 22.12,20 22,19L21,9C20.88,8 20.06,7 19,7H16V5L14,3H10M10,5H14V7H10V5M11,10H13V13H16V15H13V18H11V15H8V13H11V10Z",
  },
  {
    id: "E404434E-17DB-4E90-9D97-5355258E1FCF",
    name: "memory",
    codepoint: "F35B",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M17,17H7V7H17M21,11V9H19V7C19,5.89 18.1,5 17,5H15V3H13V5H11V3H9V5H7C5.89,5 5,5.89 5,7V9H3V11H5V13H3V15H5V17C5,18.1 5.9,19 7,19H9V21H11V19H13V21H15V19H17C18.1,19 19,18.1 19,17V15H21V13H19V11M13,13H11V11H13M15,9H9V15H15V9Z",
  },
  {
    id: "0BD2CD08-CCFB-4EC3-B96D-08B0B8230A91",
    name: "menu",
    codepoint: "F35C",
    aliases: ["hamburger-menu"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z",
  },
  {
    id: "624A47B1-947E-45AD-A34F-D5DCC1143C5A",
    name: "menu-down",
    codepoint: "F35D",
    aliases: ["arrow-drop-down"],
    tags: ["Arrow"],
    author: "Google",
    version: "1.5.54",
    path: "M7,10L12,15L17,10H7Z",
  },
  {
    id: "EE6F8AAE-7856-4E4C-AC01-3589A2C66D98",
    name: "menu-down-outline",
    codepoint: "F6B5",
    aliases: [],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.7.22",
    path: "M18,9V10.5L12,16.5L6,10.5V9H18M12,13.67L14.67,11H9.33L12,13.67Z",
  },
  {
    id: "91F83E23-FD44-4277-BD91-037B3D7EB72E",
    name: "menu-left",
    codepoint: "F35E",
    aliases: ["arrow-left"],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M14,7L9,12L14,17V7Z",
  },
  {
    id: "BC54AA3D-A450-4079-B40C-457FAE2211D5",
    name: "menu-left-outline",
    codepoint: "FA01",
    aliases: [],
    tags: [],
    author: "Peter Noble",
    version: "2.5.94",
    path: "M15,18H13.5L7.5,12L13.5,6H15V18M10.33,12L13,14.67V9.33L10.33,12Z",
  },
  {
    id: "51157881-5A20-4D7D-8E5F-FB0E815C9B3D",
    name: "menu-right",
    codepoint: "F35F",
    aliases: ["arrow-right"],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M10,17L15,12L10,7V17Z",
  },
  {
    id: "DFE8FD81-B967-4E07-A1C9-44A608613E26",
    name: "menu-right-outline",
    codepoint: "FA02",
    aliases: [],
    tags: [],
    author: "Peter Noble",
    version: "2.5.94",
    path: "M9,6H10.5L16.5,12L10.5,18H9V6M13.67,12L11,9.33V14.67L13.67,12Z",
  },
  {
    id: "A526C6AC-3E29-49D1-91FA-07F95B470626",
    name: "menu-up",
    codepoint: "F360",
    aliases: ["arrow-drop-up"],
    tags: ["Arrow"],
    author: "Google",
    version: "1.5.54",
    path: "M7,15L12,10L17,15H7Z",
  },
  {
    id: "33B1FB6B-D4F4-4B76-820C-4A2B075DB1B3",
    name: "menu-up-outline",
    codepoint: "F6B6",
    aliases: [],
    tags: ["Arrow"],
    author: "Austin Andrews",
    version: "1.7.22",
    path: "M18,16V14.5L12,8.5L6,14.5V16H18M12,11.33L14.67,14H9.33L12,11.33Z",
  },
  {
    id: "99DA4752-8C79-44D8-8286-6EBD696F0B45",
    name: "message",
    codepoint: "F361",
    aliases: ["chat-bubble"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M20,2H4C2.9,2 2,2.9 2,4V22L6,18H20C21.1,18 22,17.1 22,16V4C22,2.89 21.1,2 20,2Z",
  },
  {
    id: "213A797A-41C0-4804-A5B1-A841898CCC11",
    name: "message-alert",
    codepoint: "F362",
    aliases: ["feedback", "message-warning", "announcement", "sms-failed"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M13,10H11V6H13M13,14H11V12H13M20,2H4C2.9,2 2,2.9 2,4V22L6,18H20C21.1,18 22,17.1 22,16V4C22,2.89 21.1,2 20,2Z",
  },
  {
    id: "3487FE3E-2B9B-4C69-B64C-B3E699E9EC8C",
    name: "message-alert-outline",
    codepoint: "FA03",
    aliases: [
      "announcement-outline",
      "feedback-outline",
      "message-warning-outline",
      "sms-failed-outline",
    ],
    tags: [],
    author: "Colton Wiscombe",
    version: "2.5.94",
    path: "M13,10H11V6H13V10M13,12H11V14H13V12M22,4V16C22,17.1 21.1,18 20,18H6L2,22V4C2,2.9 2.9,2 4,2H20C21.1,2 22,2.9 22,4M20,4H4V17.2L5.2,16H20V4Z",
  },
  {
    id: "1EC9427A-2A02-4F74-9C1B-C4EC5E62B793",
    name: "message-bulleted",
    codepoint: "F6A1",
    aliases: ["speaker-notes"],
    tags: [],
    author: "Google",
    version: "1.7.12",
    path: "M20,2H4C2.9,2 2,2.9 2,4V22L6,18H20C21.1,18 22,17.1 22,16V4C22,2.9 21.1,2 20,2M8,14H6V12H8V14M8,11H6V9H8V11M8,8H6V6H8V8M15,14H10V12H15V14M18,11H10V9H18V11M18,8H10V6H18V8Z",
  },
  {
    id: "5AAB267C-9A9C-4966-862D-A2AC910494E5",
    name: "message-bulleted-off",
    codepoint: "F6A2",
    aliases: ["speaker-notes-off"],
    tags: [],
    author: "Google",
    version: "1.7.12",
    path: "M1.27,1.73L0,3L2,5V22L6,18H15L20.73,23.73L22,22.46L1.27,1.73M8,14H6V12H8V14M6,11V9L8,11H6M20,2H4.08L10,7.92V6H18V8H10.08L11.08,9H18V11H13.08L20.07,18C21.14,17.95 22,17.08 22,16V4C22,2.9 21.1,2 20,2Z",
  },
  {
    id: "6434A4B3-F803-4C8B-A03C-BE39E947166B",
    name: "message-draw",
    codepoint: "F363",
    aliases: ["rate-review"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M18,14H10.5L12.5,12H18M6,14V11.5L12.88,4.64C13.07,4.45 13.39,4.45 13.59,4.64L15.35,6.41C15.55,6.61 15.55,6.92 15.35,7.12L8.47,14M20,2H4C2.9,2 2,2.9 2,4V22L6,18H20C21.1,18 22,17.1 22,16V4C22,2.89 21.1,2 20,2Z",
  },
  {
    id: "C4C9B194-78C3-47FB-ABF6-5129230527AC",
    name: "message-image",
    codepoint: "F364",
    aliases: ["mms"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M5,14L8.5,9.5L11,12.5L14.5,8L19,14M20,2H4C2.9,2 2,2.9 2,4V22L6,18H20C21.1,18 22,17.1 22,16V4C22,2.89 21.1,2 20,2Z",
  },
  {
    id: "2AE3707D-5DE3-41E6-968B-A56D3D9ADD40",
    name: "message-outline",
    codepoint: "F365",
    aliases: ["chat-bubble-outline"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M20,2H4C2.9,2 2,2.9 2,4V22L6,18H20C21.1,18 22,17.1 22,16V4C22,2.9 21.1,2 20,2M20,16H6L4,18V4H20",
  },
  {
    id: "C0B4CC94-B6B5-462F-93C2-98F07093614C",
    name: "message-plus",
    codepoint: "F653",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.6.50",
    path: "M20,2C21.1,2 22,2.9 22,4V16C22,17.1 21.1,18 20,18H6L2,22V4C2,2.89 2.9,2 4,2H20M11,6V9H8V11H11V14H13V11H16V9H13V6H11Z",
  },
  {
    id: "602EE454-C61C-4608-919E-FCCF3B58DE65",
    name: "message-processing",
    codepoint: "F366",
    aliases: ["sms", "textsms"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M17,11H15V9H17M13,11H11V9H13M9,11H7V9H9M20,2H4C2.9,2 2,2.9 2,4V22L6,18H20C21.1,18 22,17.1 22,16V4C22,2.89 21.1,2 20,2Z",
  },
  {
    id: "6657779A-7238-4686-B3D5-1244862D7B2C",
    name: "message-reply",
    codepoint: "F367",
    aliases: ["mode-comment"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M22,4C22,2.89 21.1,2 20,2H4C2.9,2 2,2.9 2,4V16C2,17.1 2.9,18 4,18H18L22,22V4Z",
  },
  {
    id: "FF34C5A8-4433-4B47-A9E5-EB836CFFCEC9",
    name: "message-reply-text",
    codepoint: "F368",
    aliases: ["comment", "insert-comment"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M18,8H6V6H18V8M18,11H6V9H18V11M18,14H6V12H18V14M22,4C22,2.9 21.1,2 20,2H4C2.9,2 2,2.9 2,4V16C2,17.1 2.9,18 4,18H18L22,22V4Z",
  },
  {
    id: "4B15BF16-CD96-4427-9EA4-5A8B09F3A2B6",
    name: "message-settings",
    codepoint: "F6EF",
    aliases: [],
    tags: ["Settings"],
    author: "Michael Richins",
    version: "1.8.36",
    path: "M20,2H4C2.9,2 2,2.9 2,4V22L6,18H20C21.1,18 22,17.1 22,16V4C22,2.9 21.1,2 20,2M11,24H13V22H11V24M7,24H9V22H7V24M15,24H17V22H15V24Z",
  },
  {
    id: "D2AFF074-2CE4-442D-AF1A-64B168BC622A",
    name: "message-text",
    codepoint: "F369",
    aliases: ["chat"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M20,2H4C2.9,2 2,2.9 2,4V22L6,18H20C21.1,18 22,17.1 22,16V4C22,2.9 21.1,2 20,2M6,9H18V11H6M14,14H6V12H14M18,8H6V6H18",
  },
  {
    id: "E8C7D2D2-5B78-40E9-A3E6-51B9C31A43F8",
    name: "message-text-outline",
    codepoint: "F36A",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M20,2C21.1,2 22,2.9 22,4V16C22,17.1 21.1,18 20,18H6L2,22V4C2,2.89 2.9,2 4,2H20M4,4V17.17L5.17,16H20V4H4M6,7H18V9H6V7M6,11H15V13H6V11Z",
  },
  {
    id: "7AEB07C3-0EFC-4D74-BB5B-2EB1288DC27D",
    name: "message-video",
    codepoint: "F36B",
    aliases: ["voice-chat"],
    tags: ["Video / Movie"],
    author: "Google",
    version: "1.5.54",
    path: "M18,14L14,10.8V14H6V6H14V9.2L18,6M20,2H4C2.9,2 2,2.9 2,4V22L6,18H20C21.1,18 22,17.1 22,16V4C22,2.89 21.1,2 20,2Z",
  },
  {
    id: "78644A46-55EA-4208-B3DC-89C79B5F96A5",
    name: "meteor",
    codepoint: "F629",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.6.50",
    path: "M2.8,3L19.67,18.82C19.67,18.82 20,19.27 19.58,19.71C19.17,20.15 18.63,19.77 18.63,19.77L2.8,3M7.81,4.59L20.91,16.64C20.91,16.64 21.23,17.08 20.82,17.5C20.4,17.97 19.86,17.59 19.86,17.59L7.81,4.59M4.29,8L17.39,20.03C17.39,20.03 17.71,20.47 17.3,20.91C16.88,21.36 16.34,21 16.34,21L4.29,8M12.05,5.96L21.2,14.37C21.2,14.37 21.42,14.68 21.13,15C20.85,15.3 20.47,15.03 20.47,15.03L12.05,5.96M5.45,11.91L14.6,20.33C14.6,20.33 14.82,20.64 14.54,20.95C14.25,21.26 13.87,21 13.87,21L5.45,11.91M16.38,7.92L20.55,11.74C20.55,11.74 20.66,11.88 20.5,12.03C20.38,12.17 20.19,12.05 20.19,12.05L16.38,7.92M7.56,16.1L11.74,19.91C11.74,19.91 11.85,20.06 11.7,20.2C11.56,20.35 11.37,20.22 11.37,20.22L7.56,16.1Z",
  },
  {
    id: "13256CBF-E284-4229-AAB9-5612FBADD060",
    name: "metronome",
    codepoint: "F7D9",
    aliases: [],
    tags: [],
    author: "JapanYoshi",
    version: "2.0.46",
    path: "M12,1.75L8.57,2.67L4.06,19.53C4.03,19.68 4,19.84 4,20C4,21.11 4.89,22 6,22H18C19.11,22 20,21.11 20,20C20,19.84 19.97,19.68 19.94,19.53L18.58,14.42L17,16L17.2,17H13.41L16.25,14.16L14.84,12.75L10.59,17H6.8L10.29,4H13.71L15.17,9.43L16.8,7.79L15.43,2.67L12,1.75M11.25,5V14.75L12.75,13.25V5H11.25M19.79,7.8L16.96,10.63L16.25,9.92L14.84,11.34L17.66,14.16L19.08,12.75L18.37,12.04L21.2,9.21L19.79,7.8Z",
  },
  {
    id: "43A2B10E-F7DF-4181-B607-EC2039AFFA0D",
    name: "metronome-tick",
    codepoint: "F7DA",
    aliases: [],
    tags: [],
    author: "JapanYoshi",
    version: "2.0.46",
    path: "M12,1.75L8.57,2.67L4.07,19.5C4.06,19.5 4,19.84 4,20C4,21.11 4.89,22 6,22H18C19.11,22 20,21.11 20,20C20,19.84 19.94,19.5 19.93,19.5L15.43,2.67L12,1.75M10.29,4H13.71L17.2,17H13V12H11V17H6.8L10.29,4M11,5V9H10V11H14V9H13V5H11Z",
  },
  {
    id: "6A3136A3-62AD-4DE6-A783-D9D69AAD8919",
    name: "micro-sd",
    codepoint: "F7DB",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "2.0.46",
    path: "M8,2C6.9,2 6,2.9 6,4V11L4,13V20C4,21.1 4.9,22 6,22H18C19.1,22 20,21.1 20,20V4C20,2.9 19.1,2 18,2H8M9,4H11V8H9V4M12,4H14V8H12V4M15,4H17V8H15V4Z",
  },
  {
    id: "18C99959-2A0E-4095-BAEA-F5B266377648",
    name: "microphone",
    codepoint: "F36C",
    aliases: ["keyboard-voice"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M12,2C13.66,2 15,3.34 15,5V11C15,12.66 13.66,14 12,14C10.34,14 9,12.66 9,11V5C9,3.34 10.34,2 12,2M19,11C19,14.53 16.39,17.44 13,17.93V21H11V17.93C7.61,17.44 5,14.53 5,11H7C7,13.76 9.24,16 12,16C14.76,16 17,13.76 17,11H19Z",
  },
  {
    id: "FFAA9F2E-96F9-43A3-BC4E-F7562703E6A1",
    name: "microphone-minus",
    codepoint: "F8B2",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.2.43",
    path: "M9,2C10.66,2 12,3.34 12,5V11C12,12.66 10.66,14 9,14C7.34,14 6,12.66 6,11V5C6,3.34 7.34,2 9,2M16,11C16,14.5 13.44,17.43 10,17.93V21H8V17.93C4.56,17.43 2,14.5 2,11H4C4,13.76 6.24,16 9,16C11.76,16 14,13.76 14,11H16M15,5H23V7H15V5Z",
  },
  {
    id: "90AD0141-2243-49F0-8B84-FF909244D237",
    name: "microphone-off",
    codepoint: "F36D",
    aliases: ["mic-off"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M19,11C19,12.19 18.66,13.3 18.1,14.28L16.87,13.05C17.14,12.43 17.3,11.74 17.3,11H19M15,11.16L9,5.18V5C9,3.34 10.34,2 12,2C13.66,2 15,3.34 15,5V11L15,11.16M4.27,3L21,19.73L19.73,21L15.54,16.81C14.77,17.27 13.91,17.58 13,17.72V21H11V17.72C7.72,17.23 5,14.41 5,11H6.7C6.7,14 9.24,16.1 12,16.1C12.81,16.1 13.6,15.91 14.31,15.58L12.65,13.92L12,14C10.34,14 9,12.66 9,11V10.28L3,4.27L4.27,3Z",
  },
  {
    id: "E152DB47-F7EE-42A5-A01B-DC5E54A525D8",
    name: "microphone-outline",
    codepoint: "F36E",
    aliases: ["mic-none"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M17.3,11C17.3,14 14.76,16.1 12,16.1C9.24,16.1 6.7,14 6.7,11H5C5,14.41 7.72,17.23 11,17.72V21H13V17.72C16.28,17.23 19,14.41 19,11M10.8,4.9C10.8,4.24 11.34,3.7 12,3.7C12.66,3.7 13.2,4.24 13.2,4.9L13.19,11.1C13.19,11.76 12.66,12.3 12,12.3C11.34,12.3 10.8,11.76 10.8,11.1M12,14C13.66,14 15,12.66 15,11V5C15,3.34 13.66,2 12,2C10.34,2 9,3.34 9,5V11C9,12.66 10.34,14 12,14Z",
  },
  {
    id: "61F84878-9DAD-45D9-8A79-65143EA32F37",
    name: "microphone-plus",
    codepoint: "F8B3",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.2.43",
    path: "M9,2C10.66,2 12,3.34 12,5V11C12,12.66 10.66,14 9,14C7.34,14 6,12.66 6,11V5C6,3.34 7.34,2 9,2M16,11C16,14.5 13.44,17.43 10,17.93V21H8V17.93C4.56,17.43 2,14.5 2,11H4C4,13.76 6.24,16 9,16C11.76,16 14,13.76 14,11H16M15,5H18V2H20V5H23V7H20V10H18V7H15V5Z",
  },
  {
    id: "E8F70177-01CF-4C20-9956-DCA7B331FED6",
    name: "microphone-settings",
    codepoint: "F36F",
    aliases: ["settings-voice"],
    tags: ["Settings"],
    author: "Google",
    version: "1.5.54",
    path: "M19,10H17.3C17.3,13 14.76,15.1 12,15.1C9.24,15.1 6.7,13 6.7,10H5C5,13.41 7.72,16.23 11,16.72V20H13V16.72C16.28,16.23 19,13.41 19,10M15,24H17V22H15M11,24H13V22H11M12,13C13.66,13 15,11.66 15,10V4C15,2.34 13.66,1 12,1C10.34,1 9,2.34 9,4V10C9,11.66 10.34,13 12,13M7,24H9V22H7V24Z",
  },
  {
    id: "5824EE2F-01BA-42E7-A943-B0D1C569B2C5",
    name: "microphone-variant",
    codepoint: "F370",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M9,3C11.21,3 13,4.79 13,7H5C5,4.79 6.79,3 9,3M11.84,9.82L11,18H10V19C10,20.1 10.9,21 12,21C13.1,21 14,20.1 14,19V14C14,11.79 15.79,10 18,10H20L19,11L20,12H18C16.9,12 16,12.9 16,14V19C16,21.21 14.21,23 12,23C9.79,23 8,21.21 8,19V18H7L6.16,9.82C5.67,9.32 5.31,8.7 5.13,8H12.87C12.69,8.7 12.33,9.32 11.84,9.82M9,11C8.45,11 8,11.45 8,12C8,12.55 8.45,13 9,13C9.55,13 10,12.55 10,12C10,11.45 9.55,11 9,11Z",
  },
  {
    id: "B0811263-2D40-44D9-945D-13393A170311",
    name: "microphone-variant-off",
    codepoint: "F371",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M2,5.27L3.28,4L20,20.72L18.73,22L16,19.26C15.86,21.35 14.12,23 12,23C9.79,23 8,21.21 8,19V18H7L6.16,9.82C5.82,9.47 5.53,9.06 5.33,8.6L2,5.27M9,3C11.21,3 13,4.79 13,7H8.82L6.08,4.26C6.81,3.5 7.85,3 9,3M11.84,9.82L11.82,10L9.82,8H12.87C12.69,8.7 12.33,9.32 11.84,9.82M11,18H10V19C10,20.1 10.9,21 12,21C13.1,21 14,20.1 14,19V17.27L11.35,14.62L11,18M18,10H20L19,11L20,12H18C16.9,12 16,12.9 16,14V14.18L14.3,12.5C14.9,11 16.33,10 18,10M8,12C8,12.55 8.45,13 9,13C9.21,13 9.4,12.94 9.56,12.83L8.17,11.44C8.06,11.6 8,11.79 8,12Z",
  },
  {
    id: "CFCFD9FE-AFF3-4D4F-A7C6-A40E0886B064",
    name: "microscope",
    codepoint: "F654",
    aliases: [],
    tags: ["Science"],
    author: "Cody",
    version: "1.6.50",
    path: "M9.46,6.28L11.05,9C8.47,9.26 6.5,11.41 6.5,14C6.5,16.76 8.74,19 11.5,19C13.55,19 15.31,17.77 16.08,16H13.5V14H21.5V16H19.25C18.84,17.57 17.97,18.96 16.79,20H19.5V22H3.5V20H6.21C4.55,18.53 3.5,16.39 3.5,14C3.5,10.37 5.96,7.2 9.46,6.28M12.74,2.07L13.5,3.37L14.36,2.87L17.86,8.93L14.39,10.93L10.89,4.87L11.76,4.37L11,3.07L12.74,2.07Z",
  },
  {
    id: "4636AAFF-A0E5-494C-8630-31142B4A2F48",
    name: "microsoft",
    codepoint: "F372",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M2,3H11V12H2V3M11,22H2V13H11V22M21,3V12H12V3H21M21,22H12V13H21V22Z",
  },
  {
    id: "57B4C4BB-A8D9-409D-A3A4-E512A4E50CA2",
    name: "midi",
    codepoint: "F8F0",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Contributors",
    version: "2.3.50",
    path: "M10,7H12V15H10V7M13,7H19C19.55,7 20,7.45 20,8V14C20,14.55 19.55,15 19,15H13V10H15V13H18V9H13V7M21,7H23V15H21V7M1,7H3L8,7C8.55,7 9,7.45 9,8V15H7V9H6V15H4V9H3V15H1V7M1,16H23V19H1V16Z",
  },
  {
    id: "9AA75C8F-4091-4C92-81A9-DA58CC95E794",
    name: "midi-port",
    codepoint: "F8F1",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "2.3.50",
    path: "M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M20.18,12C20.18,8.18 17.55,4.96 14,4.07V6H10V4.07C6.45,4.96 3.82,8.18 3.82,12C3.82,16.52 7.48,20.18 12,20.18C16.52,20.18 20.18,16.52 20.18,12M7,10.64C7.75,10.64 8.36,11.25 8.36,12C8.36,12.75 7.75,13.36 7,13.36C6.25,13.36 5.64,12.75 5.64,12C5.64,11.25 6.25,10.64 7,10.64M17,10.64C17.75,10.64 18.36,11.25 18.36,12C18.36,12.75 17.75,13.36 17,13.36C16.25,13.36 15.64,12.75 15.64,12C15.64,11.25 16.25,10.64 17,10.64M8.36,14.27C9.12,14.27 9.73,14.88 9.73,15.64C9.73,16.39 9.12,17 8.36,17C7.61,17 7,16.39 7,15.64C7,14.88 7.61,14.27 8.36,14.27M15.64,14.27C16.39,14.27 17,14.88 17,15.64C17,16.39 16.39,17 15.64,17C14.88,17 14.27,16.39 14.27,15.64C14.27,14.88 14.88,14.27 15.64,14.27M12,15.64C12.75,15.64 13.36,16.25 13.36,17C13.36,17.75 12.75,18.36 12,18.36C11.25,18.36 10.64,17.75 10.64,17C10.64,16.25 11.25,15.64 12,15.64Z",
  },
  {
    id: "84402452-AA4A-43D6-A26C-A0946B48310C",
    name: "minecraft",
    codepoint: "F373",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M4,2H20C21.1,2 22,2.9 22,4V20C22,21.1 21.1,22 20,22H4C2.9,22 2,21.1 2,20V4C2,2.9 2.9,2 4,2M6,6V10H10V12H8V18H10V16H14V18H16V12H14V10H18V6H14V10H10V6H6Z",
  },
  {
    id: "A2E311D2-225E-4AD7-948D-D27AD0362D9F",
    name: "mini-sd",
    codepoint: "FA04",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "2.5.94",
    path: "M6,4C4.9,4 4,4.9 4,6V18C4,19.1 4.9,20 6,20H18C19.1,20 20,19.1 20,18V12L18,10V6C18,4.9 17.1,4 16,4H6M7,6H9V10H7V6M10,6H12V10H10V6M13,6H15V10H13V6Z",
  },
  {
    id: "1BFCC4B4-5BA5-4E64-889D-D64B61EA8D81",
    name: "minidisc",
    codepoint: "FA05",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "2.5.94",
    path: "M5,3C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3H5M12,5C15.09,5 17.82,7.04 18.7,10H16C15.45,10 15,10.45 15,11V13C15,13.55 15.45,14 16,14H18.71C17.82,16.97 15.09,19 12,19C8.13,19 5,15.87 5,12C5,8.13 8.13,5 12,5M12,10C10.9,10 10,10.9 10,12C10,13.1 10.9,14 12,14C13.1,14 14,13.1 14,12C14,10.9 13.1,10 12,10Z",
  },
  {
    id: "2CEA6B7B-E7C9-4D52-9D9D-286E50001B70",
    name: "minus",
    codepoint: "F374",
    aliases: ["remove"],
    tags: ["Math"],
    author: "Google",
    version: "1.5.54",
    path: "M19,13H5V11H19V13Z",
  },
  {
    id: "6BFAE994-AF2D-4B04-965D-9734631D5F0D",
    name: "minus-box",
    codepoint: "F375",
    aliases: ["indeterminate-check-box"],
    tags: ["Math"],
    author: "Google",
    version: "1.5.54",
    path: "M17,13H7V11H17M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3Z",
  },
  {
    id: "D37AECEA-5BC3-4C57-8886-BC6C1A86987D",
    name: "minus-box-outline",
    codepoint: "F6F1",
    aliases: ["checkbox-indeterminate-outline"],
    tags: ["Math"],
    author: "Austin Andrews",
    version: "1.8.36",
    path: "M19,19V5H5V19H19M19,3C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.89 3.9,3 5,3H19M17,11V13H7V11H17Z",
  },
  {
    id: "DDEB98E7-E016-44CA-8DE7-A31969C2CC04",
    name: "minus-circle",
    codepoint: "F376",
    aliases: ["do-not-disturb-on", "remove-circle"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M17,13H7V11H17M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z",
  },
  {
    id: "E1568BA6-EA0E-478F-933F-102F76996D6C",
    name: "minus-circle-outline",
    codepoint: "F377",
    aliases: ["remove-circle-outline"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M7,13H17V11H7",
  },
  {
    id: "F48994C7-4A76-43B8-B851-F7389F8B2B59",
    name: "minus-network",
    codepoint: "F378",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M16,11V9H8V11H16M17,3C18.1,3 19,3.9 19,5V15C19,16.1 18.1,17 17,17H13V19H14C14.55,19 15,19.45 15,20H22V22H15C15,22.55 14.55,23 14,23H10C9.45,23 9,22.55 9,22H2V20H9C9,19.45 9.45,19 10,19H11V17H7C5.89,17 5,16.1 5,15V5C5,3.9 5.9,3 7,3H17Z",
  },
  {
    id: "5E441030-6DAA-42F9-AF03-A4EB86AF0A51",
    name: "mixed-reality",
    codepoint: "F87E",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "2.1.99",
    path: "M5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.89,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3M8.25,15H9.75L10.75,11.57V15H12.25V9H10L9,12.43L8,9H5.75V15H7.25V11.57L8.25,15M13.5,9V15H15V13H16.15L17,15H18.5L17.6,12.9C18.1,12.65 18.5,12.1 18.5,11.5V10.5C18.5,9.65 17.85,9 17,9H13.5M15,10.5H17V11.5H15V10.5Z",
  },
  {
    id: "62F96579-80AE-4827-9C18-1C1FD239DE49",
    name: "mixer",
    codepoint: "F7DC",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Contributors",
    version: "2.0.46",
    path: "M5.68,3.96L11.41,11.65C11.55,11.84 11.55,12.1 11.41,12.29L5.65,20L5.5,20.18C4.76,21 3.47,21.07 2.64,20.31C1.85,19.59 1.79,18.37 2.43,17.5L6.56,11.97L2.46,6.47C1.83,5.62 1.88,4.39 2.67,3.67L2.82,3.54C3.73,2.87 5,3.05 5.68,3.96M18.32,3.96C19,3.05 20.27,2.87 21.18,3.54L21.33,3.67C22.12,4.39 22.17,5.61 21.54,6.47L17.44,11.97L21.57,17.5C22.21,18.36 22.15,19.59 21.36,20.31C20.53,21.07 19.24,21 18.5,20.18L18.35,20L12.59,12.29C12.45,12.1 12.45,11.84 12.59,11.65L18.32,3.96Z",
  },
  {
    id: "35091AEB-2AF7-4F92-A249-2955F01404A3",
    name: "monitor",
    codepoint: "F379",
    aliases: ["desktop-windows"],
    tags: ["Device / Tech"],
    author: "Google",
    version: "1.5.54",
    path: "M21,16H3V4H21M21,2H3C1.89,2 1,2.89 1,4V16C1,17.1 1.9,18 3,18H10V20H8V22H16V20H14V18H21C22.1,18 23,17.1 23,16V4C23,2.89 22.1,2 21,2Z",
  },
  {
    id: "B2A9CF60-30E4-46DC-9116-ED206912B156",
    name: "monitor-cellphone",
    codepoint: "F988",
    aliases: ["monitor-mobile-phone", "monitor-smartphone"],
    tags: ["Cellphone / Phone"],
    author: "Google",
    version: "2.4.85",
    path: "M23,11H18C17.45,11 17,11.45 17,12V21C17,21.55 17.45,22 18,22H23C23.55,22 24,21.55 24,21V12C24,11.45 23.55,11 23,11M23,20H18V13H23V20M20,2H2C0.89,2 0,2.89 0,4V16C0,17.1 0.9,18 2,18H9V20H7V22H15V20H13V18H15V16H2V4H20V9H22V4C22,2.89 21.1,2 20,2Z",
  },
  {
    id: "6665F86B-B97E-4AB8-8476-06B045706183",
    name: "monitor-cellphone-star",
    codepoint: "F989",
    aliases: [
      "important-devices",
      "monitor-mobile-phone-star",
      "monitor-smartphone-star",
    ],
    tags: ["Cellphone / Phone"],
    author: "Google",
    version: "2.4.85",
    path: "M23,11H18C17.45,11 17,11.45 17,12V21C17,21.55 17.45,22 18,22H23C23.55,22 24,21.55 24,21V12C24,11.45 23.55,11 23,11M23,20H18V13H23V20M20,2H2C0.89,2 0,2.89 0,4V16C0,17.1 0.9,18 2,18H9V20H7V22H15V20H13V18H15V16H2V4H20V9H22V4C22,2.89 21.1,2 20,2M11.97,9L11,6L10.03,9H7L9.47,10.76L8.53,13.67L11,11.87L13.47,13.67L12.53,10.76L15,9H11.97Z",
  },
  {
    id: "B4B96C77-6C5D-40A5-83E4-548E48CBECED",
    name: "monitor-dashboard",
    codepoint: "FA06",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "2.5.94",
    path: "M21,16V4H3V16H21M21,2C22.1,2 23,2.9 23,4V16C23,17.1 22.1,18 21,18H14V20H16V22H8V20H10V18H3C1.89,18 1,17.1 1,16V4C1,2.89 1.89,2 3,2H21M5,6H14V11H5V6M15,6H19V8H15V6M19,9V14H15V9H19M5,12H9V14H5V12M10,12H14V14H10V12Z",
  },
  {
    id: "7768BF7B-0A52-4492-88BD-5A482E4D61C3",
    name: "monitor-multiple",
    codepoint: "F37A",
    aliases: [],
    tags: ["Device / Tech"],
    author: "Chris Litherland",
    version: "1.5.54",
    path: "M22,17V7H6V17H22M22,5C23.1,5 24,5.9 24,7V17C24,18.11 23.1,19 22,19H16V21H18V23H10V21H12V19H6C4.89,19 4,18.11 4,17V7C4,5.9 4.9,5 6,5H22M2,3V15H0V3C0,1.9 0.9,1 2,1H20V3H2Z",
  },
  {
    id: "6284690E-A12C-4209-A779-18284E241DE3",
    name: "more",
    codepoint: "F37B",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M19,13.5C18.17,13.5 17.5,12.83 17.5,12C17.5,11.17 18.17,10.5 19,10.5C19.83,10.5 20.5,11.17 20.5,12C20.5,12.83 19.83,13.5 19,13.5M14,13.5C13.17,13.5 12.5,12.83 12.5,12C12.5,11.17 13.17,10.5 14,10.5C14.83,10.5 15.5,11.17 15.5,12C15.5,12.83 14.83,13.5 14,13.5M9,13.5C8.17,13.5 7.5,12.83 7.5,12C7.5,11.17 8.17,10.5 9,10.5C9.83,10.5 10.5,11.17 10.5,12C10.5,12.83 9.83,13.5 9,13.5M22,3H7C6.31,3 5.77,3.35 5.41,3.88L0,12L5.41,20.11C5.77,20.64 6.37,21 7.06,21H22C23.1,21 24,20.1 24,19V5C24,3.89 23.1,3 22,3Z",
  },
  {
    id: "D6AADAF8-D44E-44C0-8647-E578B277441D",
    name: "motorbike",
    codepoint: "F37C",
    aliases: ["motorcycle"],
    tags: ["Transportation + Road", "Sport"],
    author: "Chris Litherland",
    version: "1.5.54",
    path: "M16.36,4.27H18.55V2.13H16.36V1.07H18.22C17.89,0.43 17.13,0 16.36,0C15.16,0 14.18,0.96 14.18,2.13C14.18,3.31 15.16,4.27 16.36,4.27M10.04,9.39L13,6.93L17.45,9.6H10.25M19.53,12.05L21.05,10.56C21.93,9.71 21.93,8.43 21.05,7.57L19.2,9.39L13.96,4.27C13.64,3.73 13,3.41 12.33,3.41C11.78,3.41 11.35,3.63 11,3.95L7,7.89C6.65,8.21 6.44,8.64 6.44,9.17V9.71H5.13C4.04,9.71 3.16,10.67 3.16,11.84V12.27C3.5,12.16 3.93,12.16 4.25,12.16C7.09,12.16 9.5,14.4 9.5,17.28C9.5,17.6 9.5,18.03 9.38,18.35H14.5C14.4,18.03 14.4,17.6 14.4,17.28C14.4,14.29 16.69,12.05 19.53,12.05M4.36,19.73C2.84,19.73 1.64,18.56 1.64,17.07C1.64,15.57 2.84,14.4 4.36,14.4C5.89,14.4 7.09,15.57 7.09,17.07C7.09,18.56 5.89,19.73 4.36,19.73M4.36,12.8C1.96,12.8 0,14.72 0,17.07C0,19.41 1.96,21.33 4.36,21.33C6.76,21.33 8.73,19.41 8.73,17.07C8.73,14.72 6.76,12.8 4.36,12.8M19.64,19.73C18.11,19.73 16.91,18.56 16.91,17.07C16.91,15.57 18.11,14.4 19.64,14.4C21.16,14.4 22.36,15.57 22.36,17.07C22.36,18.56 21.16,19.73 19.64,19.73M19.64,12.8C17.24,12.8 15.27,14.72 15.27,17.07C15.27,19.41 17.24,21.33 19.64,21.33C22.04,21.33 24,19.41 24,17.07C24,14.72 22.04,12.8 19.64,12.8Z",
  },
  {
    id: "965CDBD7-9E52-4169-B363-E0428C75C19D",
    name: "mouse",
    codepoint: "F37D",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M11,1.07C7.05,1.56 4,4.92 4,9H11M4,15C4,19.42 7.58,23 12,23C16.42,23 20,19.42 20,15V11H4M13,1.07V9H20C20,4.92 16.94,1.56 13,1.07Z",
  },
  {
    id: "82AF407C-1290-4636-9299-E4FBA02EC25F",
    name: "mouse-bluetooth",
    codepoint: "F98A",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "2.4.85",
    path: "M20,7H20.5L23.35,9.85L21.21,12L23.35,14.14L20.5,17H20V13.21L17.71,15.5L17,14.79L19.79,12L17,9.21L17.71,8.5L20,10.79V7M21,8.91V10.79L21.94,9.85L21,8.91M21,13.21V15.08L21.94,14.14L21,13.21M15,9V10H9V2.07C12.39,2.56 15,5.47 15,9M1,10V9C1,5.47 3.61,2.56 7,2.07V10H1M15,15C15,18.87 11.87,22 8,22C4.13,22 1,18.87 1,15V12H15V15Z",
  },
  {
    id: "2FB92E91-9B25-46BF-85D2-BC0A2DB877B1",
    name: "mouse-off",
    codepoint: "F37E",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M2,5.27L3.28,4L20,20.72L18.73,22L17.5,20.79C16.08,22.16 14.14,23 12,23C7.58,23 4,19.42 4,15V11H7.73L5.73,9H4C4,8.46 4.05,7.93 4.15,7.42L2,5.27M11,1.07V9H10.82L5.79,3.96C7.05,2.4 8.9,1.33 11,1.07M20,11V15C20,15.95 19.83,16.86 19.53,17.71L12.82,11H20M13,1.07C16.94,1.56 20,4.92 20,9H13V1.07Z",
  },
  {
    id: "2E7ADC17-384C-4763-9D52-31AFF16BC864",
    name: "mouse-variant",
    codepoint: "F37F",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M14,7H10V2.1C12.28,2.56 14,4.58 14,7M4,7C4,4.58 5.72,2.56 8,2.1V7H4M14,12C14,14.42 12.28,16.44 10,16.9V18C10,19.66 11.34,21 13,21C14.66,21 16,19.66 16,18V13C16,10.79 17.79,9 20,9H22L21,10L22,11H20C18.9,11 18,11.9 18,13H18V18C18,20.76 15.76,23 13,23C10.24,23 8,20.76 8,18V16.9C5.72,16.44 4,14.42 4,12V9H14V12Z",
  },
  {
    id: "7542DE09-B799-4ED5-8ADB-AE809808FAE1",
    name: "mouse-variant-off",
    codepoint: "F380",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M2,5.27L3.28,4L20,20.72L18.73,22L17.29,20.56C16.42,22 14.82,23 13,23C10.24,23 8,20.76 8,18V16.9C5.72,16.44 4,14.42 4,12V9H5.73L2,5.27M14,7H10V2.1C12.28,2.56 14,4.58 14,7M8,2.1V6.18L5.38,3.55C6.07,2.83 7,2.31 8,2.1M14,12V12.17L10.82,9H14V12M10,16.9V18C10,19.66 11.34,21 13,21C14.28,21 15.37,20.2 15.8,19.07L12.4,15.67C11.74,16.28 10.92,16.71 10,16.9M16,13C16,10.79 17.79,9 20,9H22L21,10L22,11H20C18.9,11 18,11.9 18,13V16.18L16,14.18V13Z",
  },
  {
    id: "4E3B74C0-3E85-4A50-B5FF-3D6AED1CF016",
    name: "move-resize",
    codepoint: "F655",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.6.50",
    path: "M9,1V2H10V5H9V6H12V5H11V2H12V1M9,7C7.89,7 7,7.89 7,9V21C7,22.11 7.89,23 9,23H21C22.11,23 23,22.11 23,21V9C23,7.89 22.11,7 21,7M1,9V12H2V11H5V12H6V9H5V10H2V9M9,9H21V21H9M14,10V11H15V16H11V15H10V18H11V17H15V19H14V20H17V19H16V17H19V18H20V15H19V16H16V11H17V10",
  },
  {
    id: "7A5B3547-16C4-4000-9082-E13A9139C737",
    name: "move-resize-variant",
    codepoint: "F656",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.6.50",
    path: "M1.88,0.46L0.46,1.88L5.59,7H2V9H9V2H7V5.59M11,7V9H21V15H23V9C23,7.9 22.1,7 21,7M7,11V21C7,22.1 7.9,23 9,23H15V21H9V11M15.88,14.46L14.46,15.88L19.6,21H17V23H23V17H21V19.59",
  },
  {
    id: "122C53AA-C8BC-41B3-89B2-B9A9F8BB56DC",
    name: "movie",
    codepoint: "F381",
    aliases: ["slate", "clapperboard", "film", "movie-creation"],
    tags: ["Video / Movie"],
    author: "Google",
    version: "1.5.54",
    path: "M18,4L20,8H17L15,4H13L15,8H12L10,4H8L10,8H7L5,4H4C2.9,4 2,4.9 2,6V18C2,19.1 2.9,20 4,20H20C21.1,20 22,19.1 22,18V4H18Z",
  },
  {
    id: "21D0F9FB-6814-4CE7-B37D-FC97EBF1D0D2",
    name: "movie-roll",
    codepoint: "F7DD",
    aliases: ["film-reel"],
    tags: ["Video / Movie"],
    author: "Contributors",
    version: "2.0.46",
    path: "M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M12,4C10.62,4 9.5,5.12 9.5,6.5C9.5,7.88 10.62,9 12,9C13.38,9 14.5,7.88 14.5,6.5C14.5,5.12 13.38,4 12,4M4.4,9.53C3.97,10.84 4.69,12.25 6,12.68C7.32,13.1 8.73,12.39 9.15,11.07C9.58,9.76 8.86,8.35 7.55,7.92C6.24,7.5 4.82,8.21 4.4,9.53M19.61,9.5C19.18,8.21 17.77,7.5 16.46,7.92C15.14,8.34 14.42,9.75 14.85,11.07C15.28,12.38 16.69,13.1 18,12.67C19.31,12.25 20.03,10.83 19.61,9.5M7.31,18.46C8.42,19.28 10,19.03 10.8,17.91C11.61,16.79 11.36,15.23 10.24,14.42C9.13,13.61 7.56,13.86 6.75,14.97C5.94,16.09 6.19,17.65 7.31,18.46M16.7,18.46C17.82,17.65 18.07,16.09 17.26,14.97C16.45,13.85 14.88,13.6 13.77,14.42C12.65,15.23 12.4,16.79 13.21,17.91C14,19.03 15.59,19.27 16.7,18.46M12,10.5C11.17,10.5 10.5,11.17 10.5,12C10.5,12.83 11.17,13.5 12,13.5C12.83,13.5 13.5,12.83 13.5,12C13.5,11.17 12.83,10.5 12,10.5Z",
  },
  {
    id: "730FEADE-1281-422D-9E31-9DF7D06AD4E3",
    name: "muffin",
    codepoint: "F98B",
    aliases: [],
    tags: ["Food / Drink"],
    author: "Nick",
    version: "2.4.85",
    path: "M16,5C16,5 15,2 12,2C9,2 8,5 8,5C6,5 4,7 4,9C1.3,9 1.3,13 4,13H20C22.7,13 22.7,9 20,9C20,7 18,5 16,5M5,15L7,22H9L8,15H5M10,15L11,22H13L14,15H10M16,15L15,22H17L19,15H16Z",
  },
  {
    id: "489C9004-CF90-483E-83E3-CD40DD5B9ACF",
    name: "multiplication",
    codepoint: "F382",
    aliases: [],
    tags: ["Math"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M11,3H13V10.27L19.29,6.64L20.29,8.37L14,12L20.3,15.64L19.3,17.37L13,13.72V21H11V13.73L4.69,17.36L3.69,15.63L10,12L3.72,8.36L4.72,6.63L11,10.26V3Z",
  },
  {
    id: "38DF4F2F-85CF-4F71-B170-AAAAF25799E0",
    name: "multiplication-box",
    codepoint: "F383",
    aliases: [],
    tags: ["Math"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M19,3C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H19M11,17H13V13.73L15.83,15.36L16.83,13.63L14,12L16.83,10.36L15.83,8.63L13,10.27V7H11V10.27L8.17,8.63L7.17,10.36L10,12L7.17,13.63L8.17,15.36L11,13.73V17Z",
  },
  {
    id: "FCA4F099-5FCB-43DE-8166-2CE30508C1EC",
    name: "mushroom",
    codepoint: "F7DE",
    aliases: [],
    tags: ["Nature", "Food / Drink"],
    author: "Contributors",
    version: "2.0.46",
    path: "M12,2C17.52,2 22,6.48 22,12C22,13.1 21.1,14 20,14H4C2.9,14 2,13.1 2,12C2,6.48 6.48,2 12,2M12,8C13.1,8 14,7.1 14,6C14,4.9 13.1,4 12,4C10.9,4 10,4.9 10,6C10,7.1 10.9,8 12,8M17,12C18.1,12 19,11.1 19,10C19,8.9 18.1,8 17,8C15.9,8 15,8.9 15,10C15,11.1 15.9,12 17,12M7,12C8.1,12 9,11.1 9,10C9,8.9 8.1,8 7,8C5.9,8 5,8.9 5,10C5,11.1 5.9,12 7,12M15,15L16.27,19.45L16.35,20C16.35,21.1 15.45,22 14.35,22H9.65C8.55,22 7.65,21.1 7.65,20L7.73,19.45L9,15H15Z",
  },
  {
    id: "D6C17EB7-0A54-4ECA-81AA-86311E311934",
    name: "mushroom-outline",
    codepoint: "F7DF",
    aliases: [],
    tags: ["Nature", "Food / Drink"],
    author: "Contributors",
    version: "2.0.46",
    path: "M4,12H20C20,8.27 17.44,5.13 14,4.25C13.86,5.24 13,6 12,6C11,6 10.14,5.24 10,4.25C6.56,5.13 4,8.27 4,12M12,2C17.52,2 22,6.48 22,12C22,13.1 21.1,14 20,14H4C2.9,14 2,13.1 2,12C2,6.48 6.48,2 12,2M13.5,17H10.5L9.92,19L9.65,20H14.35L14.08,19L13.5,17M15,15L16,18.5L16.27,19.45L16.35,20C16.35,21.1 15.45,22 14.35,22H9.65L9.17,21.94C8.1,21.66 7.45,20.57 7.73,19.5L8,18.5L9,15H15M16,7C17.1,7 18,7.9 18,9C18,10.1 17.1,11 16,11C14.9,11 14,10.1 14,9C14,7.9 14.9,7 16,7M8,7C9.1,7 10,7.9 10,9C10,10.1 9.1,11 8,11C6.9,11 6,10.1 6,9C6,7.9 6.9,7 8,7Z",
  },
  {
    id: "E7DA3CF2-C345-441D-BFC2-ABC4DB195A6A",
    name: "music",
    codepoint: "F759",
    aliases: [],
    tags: ["Audio"],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M21,3V15.5C21,17.43 19.43,19 17.5,19C15.57,19 14,17.43 14,15.5C14,13.57 15.57,12 17.5,12C18.04,12 18.55,12.12 19,12.34V6.47L9,8.6V17.5C9,19.43 7.43,21 5.5,21C3.57,21 2,19.43 2,17.5C2,15.57 3.57,14 5.5,14C6.04,14 6.55,14.12 7,14.34V6L21,3Z",
  },
  {
    id: "2EDBEBA6-8590-4049-BB28-8959378DC44C",
    name: "music-box",
    codepoint: "F384",
    aliases: [],
    tags: ["Audio"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M16,9H13V14.5C13,15.88 11.88,17 10.5,17C9.12,17 8,15.88 8,14.5C8,13.12 9.12,12 10.5,12C11.07,12 11.58,12.19 12,12.5V7H16M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3Z",
  },
  {
    id: "9E8ADF62-9136-40F3-BED9-54A2934B4B3B",
    name: "music-box-outline",
    codepoint: "F385",
    aliases: [],
    tags: ["Audio"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M16,9H13V14.5C13,15.88 11.88,17 10.5,17C9.12,17 8,15.88 8,14.5C8,13.12 9.12,12 10.5,12C11.07,12 11.58,12.19 12,12.5V7H16V9M19,3C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3H19M5,5V19H19V5H5Z",
  },
  {
    id: "33A79A85-7985-4E08-8AA8-D6242A9C2700",
    name: "music-circle",
    codepoint: "F386",
    aliases: [],
    tags: ["Audio"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M16,9V7H12V12.5C11.58,12.19 11.07,12 10.5,12C9.12,12 8,13.12 8,14.5C8,15.88 9.12,17 10.5,17C11.88,17 13,15.88 13,14.5V9H16M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2Z",
  },
  {
    id: "05F3F5DD-59CC-4FBD-9428-0D0CB125A8AE",
    name: "music-note",
    codepoint: "F387",
    aliases: [],
    tags: ["Audio"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,3V12.26C11.5,12.09 11,12 10.5,12C8,12 6,14 6,16.5C6,19 8,21 10.5,21C13,21 15,19 15,16.5V6H19V3H12Z",
  },
  {
    id: "40A9BA37-B1BD-4869-A3F9-8F534258DB3F",
    name: "music-note-bluetooth",
    codepoint: "F5FE",
    aliases: [],
    tags: ["Audio"],
    author: "Cody",
    version: "1.5.54",
    path: "M10,3V12.26C9.5,12.09 9,12 8.5,12C6,12 4,14 4,16.5C4,19 6,21 8.5,21C11,21 13,19 13,16.5V6H17V3H10M20,7V10.79L17.71,8.5L17,9.21L19.79,12L17,14.79L17.71,15.5L20,13.21V17H20.5L23.35,14.15L21.21,12L23.36,9.85L20.5,7H20M21,8.91L21.94,9.85L21,10.79V8.91M21,13.21L21.94,14.15L21,15.09V13.21Z",
  },
  {
    id: "98CC5D8B-5D4B-4379-8FFF-1C7FEA82672C",
    name: "music-note-bluetooth-off",
    codepoint: "F5FF",
    aliases: [],
    tags: ["Audio"],
    author: "Cody",
    version: "1.5.54",
    path: "M10,3V8.68L13,11.68V6H17V3H10M3.28,4.5L2,5.77L8.26,12.03C5.89,12.15 4,14.1 4,16.5C4,19 6,21 8.5,21C10.9,21 12.85,19.11 12.97,16.74L17.68,21.45L18.96,20.18L13,14.22L10,11.22L3.28,4.5M20,7V10.79L17.71,8.5L17,9.21L19.79,12L17,14.79L17.71,15.5L20,13.21V17H20.5L23.35,14.15L21.21,12L23.36,9.85L20.5,7H20M21,8.91L21.94,9.85L21,10.79V8.91M21,13.21L21.94,14.15L21,15.09V13.21Z",
  },
  {
    id: "44EDC206-CF12-4DA5-8DA6-E72FDC35BBD2",
    name: "music-note-eighth",
    codepoint: "F388",
    aliases: [],
    tags: ["Audio"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,3V12.26C11.5,12.09 11,12 10.5,12C8.54,12 6.9,13.26 6.28,15H3V18H6.28C6.9,19.74 8.54,21 10.5,21C12.46,21 14.1,19.74 14.72,18H19V15H15V6H19V3H12Z",
  },
  {
    id: "2F2FC9A9-FAC3-4736-B8EC-B7DF9548586C",
    name: "music-note-half",
    codepoint: "F389",
    aliases: [],
    tags: ["Audio"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,3V12.26C11.5,12.09 11,12 10.5,12C8.54,12 6.9,13.26 6.28,15H3V18H6.28C6.9,19.74 8.54,21 10.5,21C12.46,21 14.1,19.74 14.72,18H19V15H15V9L15,6V3H12M10.5,14.5C11.6,14.5 12.5,15.4 12.5,16.5C12.5,17.6 11.6,18.5 10.5,18.5C9.4,18.5 8.5,17.6 8.5,16.5C8.5,15.4 9.4,14.5 10.5,14.5Z",
  },
  {
    id: "08305F79-B7E4-4FC9-9B5B-8E76920C3DCC",
    name: "music-note-off",
    codepoint: "F38A",
    aliases: [],
    tags: ["Audio"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,3V8.68L15,11.68V6H19V3H12M5.28,4.5L4,5.77L10.26,12.03C7.89,12.15 6,14.1 6,16.5C6,19 8,21 10.5,21C12.9,21 14.85,19.11 14.97,16.74L19.68,21.45L20.96,20.18L15,14.22L12,11.22L5.28,4.5Z",
  },
  {
    id: "D71DFC98-3401-4268-9956-3EFEEE336235",
    name: "music-note-quarter",
    codepoint: "F38B",
    aliases: [],
    tags: ["Audio"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,3H15V15H19V18H14.72C14.1,19.74 12.46,21 10.5,21C8.54,21 6.9,19.74 6.28,18H3V15H6.28C6.9,13.26 8.54,12 10.5,12C11,12 11.5,12.09 12,12.26V3Z",
  },
  {
    id: "882DF0E2-C223-4B3F-A538-81EC05421BA9",
    name: "music-note-sixteenth",
    codepoint: "F38C",
    aliases: [],
    tags: ["Audio"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,3V12.26C11.5,12.09 11,12 10.5,12C8.54,12 6.9,13.26 6.28,15H3V18H6.28C6.9,19.74 8.54,21 10.5,21C12.46,21 14.1,19.74 14.72,18H19V15H15V10H19V7H15V6H19V3H12Z",
  },
  {
    id: "13454604-C50C-4381-AC96-552848F0DF9E",
    name: "music-note-whole",
    codepoint: "F38D",
    aliases: [],
    tags: ["Audio"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M10.5,12C8.6,12 6.9,13.2 6.26,15H3V18H6.26C6.9,19.8 8.6,21 10.5,21C12.4,21 14.1,19.8 14.74,18H19V15H14.74C14.1,13.2 12.4,12 10.5,12M10.5,14.5C11.6,14.5 12.5,15.4 12.5,16.5C12.5,17.6 11.6,18.5 10.5,18.5C9.4,18.5 8.5,17.6 8.5,16.5C8.5,15.4 9.4,14.5 10.5,14.5Z",
  },
  {
    id: "E9D8BB99-B31B-4940-9EEE-B69569060B0D",
    name: "music-off",
    codepoint: "F75A",
    aliases: [],
    tags: ["Audio"],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M2,5.27L3.28,4L20,20.72L18.73,22L9,12.27V17.5C9,19.43 7.43,21 5.5,21C3.57,21 2,19.43 2,17.5C2,15.57 3.57,14 5.5,14C6.04,14 6.55,14.12 7,14.34V10.27L2,5.27M21,3V15.5C21,16.5 20.57,17.42 19.88,18.06L14.94,13.12C15.58,12.43 16.5,12 17.5,12C18.04,12 18.55,12.12 19,12.34V6.47L10.17,8.35L7.66,5.84L21,3Z",
  },
  {
    id: "001157C4-1AAA-41FF-B204-906ACDB427C3",
    name: "nas",
    codepoint: "F8F2",
    aliases: ["network-attached-storage"],
    tags: [],
    author: "Cody",
    version: "2.3.50",
    path: "M4,5C2.89,5 2,5.89 2,7V17C2,18.11 2.89,19 4,19H20C21.11,19 22,18.11 22,17V7C22,5.89 21.11,5 20,5H4M4.5,7C5.05,7 5.5,7.45 5.5,8C5.5,8.55 5.05,9 4.5,9C3.95,9 3.5,8.55 3.5,8C3.5,7.45 3.95,7 4.5,7M7,7H20V17H7V7M8,8V16H11V8H8M12,8V16H15V8H12M16,8V16H19V8H16M9,9H10V10H9V9M13,9H14V10H13V9M17,9H18V10H17V9Z",
  },
  {
    id: "A69196BD-730F-4684-8604-8668FD60183A",
    name: "nativescript",
    codepoint: "F87F",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Contributors",
    version: "2.1.99",
    path: "M7.5,3H16.5C19,3 21,5 21,7.5V16.5C21,19 19,21 16.5,21H7.5C5,21 3,19 3,16.5V7.5C3,5 5,3 7.5,3M6,13.5V16.5C6,17.33 6.67,18 7.5,18H9V10.5L15,18H16.5C17.33,18 18,17.33 18,16.5V13.5C18,12.67 18.67,12 19.5,12C18.67,12 18,11.33 18,10.5V7.5C18,6.67 17.33,6 16.5,6H15V13.5L9,6H7.5C6.67,6 6,6.67 6,7.5V10.5C6,11.33 5.33,12 4.5,12C5.33,12 6,12.67 6,13.5Z",
  },
  {
    id: "C5FCAD4F-C7E6-4BDB-9F2F-A665CB68B7FD",
    name: "nature",
    codepoint: "F38E",
    aliases: [],
    tags: ["Nature"],
    author: "Google",
    version: "1.5.54",
    path: "M13,16.12C16.47,15.71 19.17,12.76 19.17,9.17C19.17,5.3 16.04,2.17 12.17,2.17C8.3,2.17 5.17,5.3 5.17,9.17C5.17,12.64 7.69,15.5 11,16.06V20H5V22H19V20H13V16.12Z",
  },
  {
    id: "B0635A70-D2A9-41CE-82C6-3FB1D1D353B4",
    name: "nature-people",
    codepoint: "F38F",
    aliases: [],
    tags: ["Account / User"],
    author: "Google",
    version: "1.5.54",
    path: "M4.5,11C5.33,11 6,10.33 6,9.5C6,8.67 5.33,8 4.5,8C3.67,8 3,8.67 3,9.5C3,10.33 3.67,11 4.5,11M22.17,9.17C22.17,5.3 19.04,2.17 15.17,2.17C11.3,2.17 8.17,5.3 8.17,9.17C8.17,12.64 10.69,15.5 14,16.06V20H6V17H7V13C7,12.45 6.55,12 6,12H3C2.45,12 2,12.45 2,13V17H3V22H19V20H16V16.12C19.47,15.71 22.17,12.76 22.17,9.17Z",
  },
  {
    id: "DAAF6988-6EE9-4595-A758-294C83C7304B",
    name: "navigation",
    codepoint: "F390",
    aliases: ["arrow-compass"],
    tags: ["Navigation"],
    author: "Google",
    version: "1.5.54",
    path: "M12,2L4.5,20.29L5.21,21L12,18L18.79,21L19.5,20.29L12,2Z",
  },
  {
    id: "6766F53D-88E4-452A-A222-7F50DDFB757C",
    name: "near-me",
    codepoint: "F5CD",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M21,3L3,10.53V11.5L9.84,14.16L12.5,21H13.46L21,3Z",
  },
  {
    id: "2B76647F-92FE-4F8E-B193-7EC20DADD5D2",
    name: "needle",
    codepoint: "F391",
    aliases: ["syringe"],
    tags: ["Medical / Hospital"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M11.15,15.18L9.73,13.77L11.15,12.35L12.56,13.77L13.97,12.35L12.56,10.94L13.97,9.53L15.39,10.94L16.8,9.53L13.97,6.7L6.9,13.77L9.73,16.6L11.15,15.18M3.08,19L6.2,15.89L4.08,13.77L13.97,3.87L16.1,6L17.5,4.58L16.1,3.16L17.5,1.75L21.75,6L20.34,7.4L18.92,6L17.5,7.4L19.63,9.53L9.73,19.42L7.61,17.3L3.08,21.84V19Z",
  },
  {
    id: "7AEF7097-EC88-4D09-A65E-5244DDA99599",
    name: "netflix",
    codepoint: "F745",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M6.5,2H10.5L13.44,10.83L13.5,2H17.5V22C16.25,21.78 14.87,21.64 13.41,21.58L10.5,13L10.43,21.59C9.03,21.65 7.7,21.79 6.5,22V2Z",
  },
  {
    id: "089C6F75-2FF5-4B48-B4B4-651AEAD3D24F",
    name: "network",
    codepoint: "F6F2",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.8.36",
    path: "M17,3C18.1,3 19,3.9 19,5V15C19,16.1 18.1,17 17,17H13V19H14C14.55,19 15,19.45 15,20H22V22H15C15,22.55 14.55,23 14,23H10C9.45,23 9,22.55 9,22H2V20H9C9,19.45 9.45,19 10,19H11V17H7C5.89,17 5,16.1 5,15V5C5,3.9 5.9,3 7,3H17Z",
  },
  {
    id: "7AEB6E6A-4B4E-42C3-9AB2-1F47FE1BD29B",
    name: "network-strength-1",
    codepoint: "F8F3",
    aliases: [],
    tags: ["Cellphone / Phone"],
    author: "Cody",
    version: "2.3.50",
    path: "M1,21H21V1M19,5.83V19H11V13.83",
  },
  {
    id: "9C2C41A2-7BA9-46C3-B017-941C7B2C2E60",
    name: "network-strength-1-alert",
    codepoint: "F8F4",
    aliases: ["network-strength-1-warning"],
    tags: ["Cellphone / Phone"],
    author: "Cody",
    version: "2.3.50",
    path: "M21,1L1,21H17V19H11V13.83L19,5.83V7H21M19,9V17H21V9M19,19V21H21V19",
  },
  {
    id: "DF3CEC8C-F6B7-467B-833C-92FE260C6A73",
    name: "network-strength-2",
    codepoint: "F8F5",
    aliases: [],
    tags: ["Cellphone / Phone"],
    author: "Cody",
    version: "2.3.50",
    path: "M1,21H21V1M19,5.83V19H13V11.83",
  },
  {
    id: "DB8EEB5C-3705-4DE7-A770-D63ACE14F1BD",
    name: "network-strength-2-alert",
    codepoint: "F8F6",
    aliases: ["network-strength-2-warning"],
    tags: ["Cellphone / Phone"],
    author: "Cody",
    version: "2.3.50",
    path: "M21,1L1,21H17V19H13V11.83L19,5.83V7H21M19,9V17H21V9M19,19V21H21V19",
  },
  {
    id: "7FAA15D1-1E1D-41F5-98F0-1B640DFB0688",
    name: "network-strength-3",
    codepoint: "F8F7",
    aliases: [],
    tags: ["Cellphone / Phone"],
    author: "Cody",
    version: "2.3.50",
    path: "M1,21H21V1M19,5.83V19H16V8.83",
  },
  {
    id: "99771A39-B621-45BA-96BE-7589E5A85B9E",
    name: "network-strength-3-alert",
    codepoint: "F8F8",
    aliases: ["network-strength-3-warning"],
    tags: ["Cellphone / Phone"],
    author: "Cody",
    version: "2.3.50",
    path: "M21,1L1,21H17V19H16V8.83L19,5.83V7H21M19,9V17H21V9M19,19V21H21V19",
  },
  {
    id: "87FF7D68-6F78-44AB-80C4-DC7FE976E3A3",
    name: "network-strength-4",
    codepoint: "F8F9",
    aliases: [],
    tags: ["Cellphone / Phone"],
    author: "Cody",
    version: "2.3.50",
    path: "M1,21H21V1",
  },
  {
    id: "1173684B-E68C-4BE5-BD9C-53C01A619896",
    name: "network-strength-4-alert",
    codepoint: "F8FA",
    aliases: ["network-strength-4-warning"],
    tags: ["Cellphone / Phone"],
    author: "Cody",
    version: "2.3.50",
    path: "M19,17H21V9H19M19,21H21V19H19M1,21H17V7H21V1",
  },
  {
    id: "E3FEE803-9C91-4BAE-9528-D016588E99AD",
    name: "network-strength-off",
    codepoint: "F8FB",
    aliases: [],
    tags: ["Cellphone / Phone"],
    author: "Cody",
    version: "2.3.50",
    path: "M21,1L12.4,9.6L21,18.19M4.77,4.5L3.5,5.77L9.86,12.13L1,21H18.73L20.73,23L22,21.73",
  },
  {
    id: "E7A4CEE7-C6E2-4FD6-B0BF-B3DD131100CB",
    name: "network-strength-off-outline",
    codepoint: "F8FC",
    aliases: [],
    tags: ["Cellphone / Phone"],
    author: "Cody",
    version: "2.3.50",
    path: "M21,1L12.4,9.6L13.85,11.05L19,5.83V16.19L21,18.19M4.77,4.5L3.5,5.77L9.86,12.13L1,21H18.73L20.73,23L22,21.73M11.33,13.6L16.73,19H6",
  },
  {
    id: "5A80D579-DF12-4B68-AAD8-AFE8039E6657",
    name: "network-strength-outline",
    codepoint: "F8FD",
    aliases: ["network-strength-0"],
    tags: ["Cellphone / Phone"],
    author: "Cody",
    version: "2.3.50",
    path: "M1,21H21V1M19,5.83V19H6",
  },
  {
    id: "1ABEE375-A0DC-4262-9CCD-3B9C78B5FE7D",
    name: "new-box",
    codepoint: "F394",
    aliases: ["fiber-new"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M20,4C21.11,4 22,4.89 22,6V18C22,19.11 21.11,20 20,20H4C2.89,20 2,19.11 2,18V6C2,4.89 2.89,4 4,4H20M8.5,15V9H7.25V12.5L4.75,9H3.5V15H4.75V11.5L7.3,15H8.5M13.5,10.26V9H9.5V15H13.5V13.75H11V12.64H13.5V11.38H11V10.26H13.5M20.5,14V9H19.25V13.5H18.13V10H16.88V13.5H15.75V9H14.5V14C14.5,14.55 14.95,15 15.5,15H19.5C20.05,15 20.5,14.55 20.5,14Z",
  },
  {
    id: "EE440B14-2E25-4C8E-99A7-A3C98CBC9151",
    name: "newspaper",
    codepoint: "F395",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M20,11H4V8H20M20,15H13V13H20M20,19H13V17H20M11,19H4V13H11M20.33,4.67L18.67,3L17,4.67L15.33,3L13.67,4.67L12,3L10.33,4.67L8.67,3L7,4.67L5.33,3L3.67,4.67L2,3V19C2,20.1 2.9,21 4,21H20C21.1,21 22,20.1 22,19V3L20.33,4.67Z",
  },
  {
    id: "961106B7-BD56-462C-936C-E2CDC83051B5",
    name: "nfc",
    codepoint: "F396",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M10.59,7.66C10.59,7.66 11.19,7.39 11.57,7.82C11.95,8.26 12.92,9.94 12.92,11.62C12.92,13.3 12.5,15.09 12.05,15.68C11.62,16.28 11.19,16.28 10.86,16.06C10.54,15.85 5.5,12 5.23,11.89C4.95,11.78 4.85,12.05 5.12,13.5C5.39,15 4.95,15.41 4.57,15.47C4.2,15.5 3.06,15.2 3,12.16C2.95,9.13 3.76,8.64 4.14,8.64C4.85,8.64 10.27,13.5 10.64,13.46C10.97,13.41 11.13,11.35 10.5,9.72C9.78,7.96 10.59,7.66 10.59,7.66M19.3,4.63C21.12,8.24 21,11.66 21,12C21,12.34 21.12,15.76 19.3,19.37C19.3,19.37 18.83,19.92 18.12,19.59C17.42,19.26 17.66,18.4 17.66,18.4C17.66,18.4 19.14,15.55 19.1,12.05V12C19.14,8.5 17.66,5.6 17.66,5.6C17.66,5.6 17.42,4.74 18.12,4.41C18.83,4.08 19.3,4.63 19.3,4.63M15.77,6.25C17.26,8.96 17.16,11.66 17.14,12C17.16,12.34 17.26,14.92 15.77,17.85C15.77,17.85 15.3,18.4 14.59,18.07C13.89,17.74 14.13,16.88 14.13,16.88C14.13,16.88 15.09,15.5 15.24,12.05V12C15.14,8.53 14.13,7.23 14.13,7.23C14.13,7.23 13.89,6.36 14.59,6.04C15.3,5.71 15.77,6.25 15.77,6.25Z",
  },
  {
    id: "656C274C-CDC8-4FB6-AFFA-F704784BC997",
    name: "nfc-tap",
    codepoint: "F397",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,10C13.1,10 14,10.9 14,12C14,13.1 13.1,14 12,14C10.9,14 10,13.1 10,12C10,10.9 10.9,10 12,10M4,4H11C12.1,4 13,4.9 13,6V9H11V6H4V11H6V9L9,12L6,15V13H4C2.9,13 2,12.1 2,11V6C2,4.9 2.9,4 4,4M20,20H13C11.9,20 11,19.1 11,18V15H13V18H20V13H18V15L15,12L18,9V11H20C21.1,11 22,11.9 22,13V18C22,19.1 21.1,20 20,20Z",
  },
  {
    id: "4DFF5414-0EA3-4255-BC50-B40B0E3ADB15",
    name: "nfc-variant",
    codepoint: "F398",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M18,6H13C11.9,6 11,6.9 11,8V10.28C10.41,10.62 10,11.26 10,12C10,13.1 10.9,14 12,14C13.11,14 14,13.1 14,12C14,11.26 13.6,10.62 13,10.28V8H16V16H8V8H10V6H8L6,6V18H18M20,20H4V4H20M20,2H4C2.9,2 2,2.9 2,4V20C2,21.1 2.9,22 4,22H20C21.11,22 22,21.1 22,20V4C22,2.89 21.11,2 20,2Z",
  },
  {
    id: "8E7C1B4B-C4E8-4072-9FB7-90E207038FFB",
    name: "ninja",
    codepoint: "F773",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "1.9.32",
    path: "M7.75,13C7.74,12.65 7.9,12.31 8.17,12.08C8.92,12.24 9.62,12.55 10.25,13C10.25,13.68 9.69,14.24 9,14.24C8.31,14.24 7.76,13.69 7.75,13M13.75,13C14.38,12.56 15.08,12.25 15.83,12.09C16.1,12.32 16.26,12.66 16.25,13C16.25,13.7 15.69,14.26 15,14.26C14.31,14.26 13.75,13.7 13.75,13V13M12,9C9.23,8.96 6.5,9.65 4.07,11L4,12C4,13.23 4.29,14.44 4.84,15.54C7.21,15.18 9.6,15 12,15C14.4,15 16.79,15.18 19.16,15.54C19.71,14.44 20,13.23 20,12L19.93,11C17.5,9.65 14.77,8.96 12,9M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2Z",
  },
  {
    id: "D57C5D23-1122-4DEB-BEC4-77D5A4D685FE",
    name: "nintendo-switch",
    codepoint: "F7E0",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "GreenTurtwig",
    version: "2.0.46",
    path: "M10.04,20.4H7.12C6.19,20.4 5.3,20 4.64,19.36C4,18.7 3.6,17.81 3.6,16.88V7.12C3.6,6.19 4,5.3 4.64,4.64C5.3,4 6.19,3.62 7.12,3.62H10.04V20.4M7.12,2C4.29,2 2,4.29 2,7.12V16.88C2,19.71 4.29,22 7.12,22H11.65V2H7.12M5.11,8C5.11,9.04 5.95,9.88 7,9.88C8.03,9.88 8.87,9.04 8.87,8C8.87,6.96 8.03,6.12 7,6.12C5.95,6.12 5.11,6.96 5.11,8M17.61,11C18.72,11 19.62,11.89 19.62,13C19.62,14.12 18.72,15 17.61,15C16.5,15 15.58,14.12 15.58,13C15.58,11.89 16.5,11 17.61,11M16.88,22C19.71,22 22,19.71 22,16.88V7.12C22,4.29 19.71,2 16.88,2H13.65V22H16.88Z",
  },
  {
    id: "46A696BA-7A78-40C1-A685-C9B9851286A6",
    name: "nodejs",
    codepoint: "F399",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Cody",
    version: "1.5.54",
    path: "M12,1.85C11.73,1.85 11.45,1.92 11.22,2.05L3.78,6.35C3.3,6.63 3,7.15 3,7.71V16.29C3,16.85 3.3,17.37 3.78,17.65L5.73,18.77C6.68,19.23 7,19.24 7.44,19.24C8.84,19.24 9.65,18.39 9.65,16.91V8.44C9.65,8.32 9.55,8.22 9.43,8.22H8.5C8.37,8.22 8.27,8.32 8.27,8.44V16.91C8.27,17.57 7.59,18.22 6.5,17.67L4.45,16.5C4.38,16.45 4.34,16.37 4.34,16.29V7.71C4.34,7.62 4.38,7.54 4.45,7.5L11.89,3.21C11.95,3.17 12.05,3.17 12.11,3.21L19.55,7.5C19.62,7.54 19.66,7.62 19.66,7.71V16.29C19.66,16.37 19.62,16.45 19.55,16.5L12.11,20.79C12.05,20.83 11.95,20.83 11.88,20.79L10,19.65C9.92,19.62 9.84,19.61 9.79,19.64C9.26,19.94 9.16,20 8.67,20.15C8.55,20.19 8.36,20.26 8.74,20.47L11.22,21.94C11.46,22.08 11.72,22.15 12,22.15C12.28,22.15 12.54,22.08 12.78,21.94L20.22,17.65C20.7,17.37 21,16.85 21,16.29V7.71C21,7.15 20.7,6.63 20.22,6.35L12.78,2.05C12.55,1.92 12.28,1.85 12,1.85M14,8C11.88,8 10.61,8.89 10.61,10.39C10.61,12 11.87,12.47 13.91,12.67C16.34,12.91 16.53,13.27 16.53,13.75C16.53,14.58 15.86,14.93 14.3,14.93C12.32,14.93 11.9,14.44 11.75,13.46C11.73,13.36 11.64,13.28 11.53,13.28H10.57C10.45,13.28 10.36,13.37 10.36,13.5C10.36,14.74 11.04,16.24 14.3,16.24C16.65,16.24 18,15.31 18,13.69C18,12.08 16.92,11.66 14.63,11.35C12.32,11.05 12.09,10.89 12.09,10.35C12.09,9.9 12.29,9.3 14,9.3C15.5,9.3 16.09,9.63 16.32,10.66C16.34,10.76 16.43,10.83 16.53,10.83H17.5C17.55,10.83 17.61,10.81 17.65,10.76C17.69,10.72 17.72,10.66 17.7,10.6C17.56,8.82 16.38,8 14,8Z",
  },
  {
    id: "A301F5C0-B760-4EA0-B803-DEF84D1B01CD",
    name: "not-equal",
    codepoint: "F98C",
    aliases: [],
    tags: [],
    author: "Nick",
    version: "2.4.85",
    path: "M21,10H9V8H21V10M21,16H9V14H21V16M4,5H6V16H4V5M6,18V20H4V18H6Z",
  },
  {
    id: "AF2B1665-3D54-4017-BF7C-AE03A7C6AA52",
    name: "not-equal-variant",
    codepoint: "F98D",
    aliases: [],
    tags: [],
    author: "Nick",
    version: "2.4.85",
    path: "M14.08,4.61L15.92,5.4L14.8,8H19V10H13.95L12.23,14H19V16H11.38L9.92,19.4L8.08,18.61L9.2,16H5V14H10.06L11.77,10H5V8H12.63L14.08,4.61Z",
  },
  {
    id: "5E1DF73F-AEF5-48F8-B766-419FBB05C5D0",
    name: "note",
    codepoint: "F39A",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M14,10V4.5L19.5,10M5,3C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V9L15,3H5Z",
  },
  {
    id: "0A0E42BA-FE9D-44C6-BF6A-D29D6013F2E0",
    name: "note-multiple",
    codepoint: "F6B7",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.7.22",
    path: "M16,9H21.5L16,3.5V9M7,2H17L23,8V18C23,19.1 22.1,20 21,20H7C5.89,20 5,19.1 5,18V4C5,2.9 5.9,2 7,2M3,6V22H21V24H3C1.9,24 1,23.1 1,22V6H3Z",
  },
  {
    id: "6294246C-A524-4121-B141-5262D89FFD4D",
    name: "note-multiple-outline",
    codepoint: "F6B8",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.7.22",
    path: "M3,6V22H21V24H3C1.9,24 1,23.1 1,22V6H3M16,9H21.5L16,3.5V9M7,2H17L23,8V18C23,19.1 22.1,20 21,20H7C5.89,20 5,19.1 5,18V4C5,2.9 5.9,2 7,2M7,4V18H21V11H14V4H7Z",
  },
  {
    id: "DD6D5075-A7F5-4183-9F99-93C295F18B0B",
    name: "note-outline",
    codepoint: "F39B",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M14,10H19.5L14,4.5V10M5,3H15L21,9V19C21,20.1 20.1,21 19,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3M5,5V19H19V12H12V5H5Z",
  },
  {
    id: "753F2E09-A32F-4790-9C07-7CD9AB69104D",
    name: "note-plus",
    codepoint: "F39C",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M14,10H19.5L14,4.5V10M5,3H15L21,9V19C21,20.1 20.1,21 19,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3M9,18H11V15H14V13H11V10H9V13H6V15H9V18Z",
  },
  {
    id: "706F4C63-412B-44CD-81DE-612D4483D09C",
    name: "note-plus-outline",
    codepoint: "F39D",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M15,10H20.5L15,4.5V10M4,3H16L22,9V19C22,20.1 21.1,21 20,21H4C2.89,21 2,20.1 2,19V5C2,3.89 2.89,3 4,3M4,5V19H20V12H13V5H4M8,17V15H6V13H8V11H10V13H12V15H10V17H8Z",
  },
  {
    id: "2ADC4253-F51B-4BC2-B04C-0DDD139425CF",
    name: "note-text",
    codepoint: "F39E",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M14,10H19.5L14,4.5V10M5,3H15L21,9V19C21,20.1 20.1,21 19,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3M5,12V14H19V12H5M5,16V18H14V16H5Z",
  },
  {
    id: "2D28230E-DAF3-4A49-ACB6-7D9C3E9E6495",
    name: "notebook",
    codepoint: "F82D",
    aliases: [],
    tags: [],
    author: "Contributors",
    version: "2.1.19",
    path: "M3,7V5H5V4C5,2.89 5.9,2 7,2H13V9L15.5,7.5L18,9V2H19C20.05,2 21,2.95 21,4V20C21,21.05 20.05,22 19,22H7C5.95,22 5,21.05 5,20V19H3V17H5V13H3V11H5V7H3M7,11H5V13H7V11M7,7V5H5V7H7M7,19V17H5V19H7Z",
  },
  {
    id: "E758A025-3B14-4A2F-A1D7-2D12C38B47E4",
    name: "notification-clear-all",
    codepoint: "F39F",
    aliases: [],
    tags: ["Notification"],
    author: "Google",
    version: "1.5.54",
    path: "M5,13H19V11H5M3,17H17V15H3M7,7V9H21V7",
  },
  {
    id: "5E072845-A46E-4D62-A65D-28CD7DAD976B",
    name: "npm",
    codepoint: "F6F6",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Case Sandberg",
    version: "1.8.36",
    path: "M4,10V14H6V11H7V14H8V10H4M9,10V15H11V14H13V10H9M12,11V13H11V11H12M14,10V14H16V11H17V14H18V11H19V14H20V10H14M3,9H21V15H12V16H8V15H3V9Z",
  },
  {
    id: "56E79669-E557-4D22-A21D-E07FFDB1C2B6",
    name: "npm-variant-outline",
    codepoint: "F98F",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Contributors",
    version: "2.4.85",
    path: "M3,3V21H21V3H3M6,6H18V18H15V9H12V18H6V6Z",
  },
  {
    id: "DB44684C-B1E7-4039-8BAA-C7C0BC4EB075",
    name: "nuke",
    codepoint: "F6A3",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "1.7.12",
    path: "M14.04,12H10V11H5.5C3.57,11 2,9.43 2,7.5C2,5.57 3.57,4 5.5,4C6.53,4 7.45,4.44 8.09,5.15C8.5,3.35 10.08,2 12,2C13.92,2 15.5,3.35 15.91,5.15C16.55,4.44 17.47,4 18.5,4C20.43,4 22,5.57 22,7.5C22,9.43 20.43,11 18.5,11H14.04V12M10,16.9V15.76H5V13.76H19V15.76H14.04V16.92L20,19.08C20.58,19.29 21,19.84 21,20.5C21,21.33 20.33,22 19.5,22H4.5C3.67,22 3,21.33 3,20.5C3,19.84 3.42,19.29 4,19.08L10,16.9Z",
  },
  {
    id: "5004722B-DE0B-4F37-BCAD-36B46477E80F",
    name: "null",
    codepoint: "F7E1",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "2.0.46",
    path: "M12,2C13.85,2 15.55,2.78 16.9,4.1L18.6,1.93L20.18,3.16L18.2,5.68C19.33,7.41 20,9.6 20,12C20,17.5 16.42,22 12,22C10.15,22 8.45,21.22 7.1,19.9L5.4,22.07L3.82,20.84L5.8,18.32C4.67,16.59 4,14.4 4,12C4,6.5 7.58,2 12,2M12,4C8.69,4 6,7.58 6,12C6,13.73 6.41,15.33 7.11,16.64L15.67,5.67C14.66,4.62 13.38,4 12,4M12,20C15.31,20 18,16.42 18,12C18,10.27 17.59,8.67 16.89,7.36L8.33,18.33C9.34,19.38 10.62,20 12,20Z",
  },
  {
    id: "1293DBCD-E538-4AD1-97C9-3F17BBD28457",
    name: "numeric",
    codepoint: "F3A0",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M4,17V9H2V7H6V17H4M22,15C22,16.11 21.1,17 20,17H16V15H20V13H18V11H20V9H16V7H20C21.1,7 22,7.9 22,9V10.5C22,11.33 21.33,12 20.5,12C21.33,12 22,12.67 22,13.5V15M14,15V17H8V13C8,11.89 8.9,11 10,11H12V9H8V7H12C13.1,7 14,7.9 14,9V11C14,12.11 13.1,13 12,13H10V15H14Z",
  },
  {
    id: "C676CDFC-A808-4BCA-A670-49EE8478ED32",
    name: "numeric-0-box",
    codepoint: "F3A1",
    aliases: ["numeric-zero-box"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M19,3C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3H19M11,7C9.9,7 9,7.9 9,9V15C9,16.1 9.9,17 11,17H13C14.1,17 15,16.1 15,15V9C15,7.9 14.1,7 13,7H11M11,9H13V15H11V9Z",
  },
  {
    id: "B3652E81-9CA5-4B7C-B603-FE94CB2D1323",
    name: "numeric-0-box-multiple-outline",
    codepoint: "F3A2",
    aliases: ["numeric-zero-box-multiple-outline"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M21,17V3H7V17H21M21,1C22.1,1 23,1.9 23,3V17C23,18.1 22.1,19 21,19H7C5.9,19 5,18.1 5,17V3C5,1.9 5.9,1 7,1H21M3,5V21H19V23H3C1.9,23 1,22.1 1,21V5H3M13,5H15C16.1,5 17,5.9 17,7V13C17,14.1 16.1,15 15,15H13C11.9,15 11,14.1 11,13V7C11,5.9 11.9,5 13,5M13,7V13H15V7H13Z",
  },
  {
    id: "1EB53615-9A62-4377-A2D0-246C8F42CAF8",
    name: "numeric-0-box-outline",
    codepoint: "F3A3",
    aliases: ["numeric-zero-box-outline"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M19,19V5H5V19H19M19,3C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3H19M11,7H13C14.1,7 15,7.9 15,9V15C15,16.1 14.1,17 13,17H11C9.9,17 9,16.1 9,15V9C9,7.9 9.9,7 11,7M11,9V15H13V9H11Z",
  },
  {
    id: "0EF5316E-7978-4F6C-B38E-297837B3CFF5",
    name: "numeric-1-box",
    codepoint: "F3A4",
    aliases: ["looks-one", "numeric-one-box"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M14,17H12V9H10V7H14M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3Z",
  },
  {
    id: "55513DD6-D73E-438E-8834-D6761C47BA4B",
    name: "numeric-1-box-multiple-outline",
    codepoint: "F3A5",
    aliases: ["filter-1", "numeric-one-box-multiple-outline"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M21,17H7V3H21M21,1H7C5.9,1 5,1.9 5,3V17C5,18.1 5.9,19 7,19H21C22.1,19 23,18.1 23,17V3C23,1.9 22.1,1 21,1M14,15H16V5H12V7H14M3,5H1V21C1,22.1 1.9,23 3,23H19V21H3V5Z",
  },
  {
    id: "50AEDC65-99B1-45CA-8078-CD6D8633995A",
    name: "numeric-1-box-outline",
    codepoint: "F3A6",
    aliases: ["numeric-one-box-outline"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M19,19H5V5H19M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3M12,17H14V7H10V9H12",
  },
  {
    id: "0F35B058-84BF-42A1-8EC2-4DF8A5F2CB6D",
    name: "numeric-2-box",
    codepoint: "F3A7",
    aliases: ["looks-two", "numeric-two-box"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M15,11C15,12.11 14.1,13 13,13H11V15H15V17H9V13C9,11.89 9.9,11 11,11H13V9H9V7H13C14.1,7 15,7.9 15,9M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3Z",
  },
  {
    id: "989BAC0E-21F6-4AF2-849A-3DA35BA5958F",
    name: "numeric-2-box-multiple-outline",
    codepoint: "F3A8",
    aliases: ["filter-2", "numeric-two-box-multiple-outline"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M17,13H13V11H15C16.1,11 17,10.1 17,9V7C17,5.89 16.1,5 15,5H11V7H15V9H13C11.9,9 11,9.9 11,11V15H17M21,17H7V3H21M21,1H7C5.9,1 5,1.9 5,3V17C5,18.1 5.9,19 7,19H21C22.1,19 23,18.1 23,17V3C23,1.9 22.1,1 21,1M3,5H1V21C1,22.1 1.9,23 3,23H19V21H3V5Z",
  },
  {
    id: "0C255402-1176-46B5-B38C-60118732FCC7",
    name: "numeric-2-box-outline",
    codepoint: "F3A9",
    aliases: ["numeric-two-box-outline"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M15,15H11V13H13C14.1,13 15,12.1 15,11V9C15,7.89 14.1,7 13,7H9V9H13V11H11C9.9,11 9,11.9 9,13V17H15M19,19H5V5H19M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3Z",
  },
  {
    id: "F34D170B-4DF1-470D-ABC4-AE0A93035227",
    name: "numeric-3-box",
    codepoint: "F3AA",
    aliases: ["looks-3", "numeric-three-box"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M15,10.5C15,11.33 14.33,12 13.5,12C14.34,12 15,12.67 15,13.5V15C15,16.11 14.11,17 13,17H9V15H13V13H11V11H13V9H9V7H13C14.11,7 15,7.89 15,9M19,3H5C3.91,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.11,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3Z",
  },
  {
    id: "394B1DFD-7009-4057-AD14-7F7D99B3A658",
    name: "numeric-3-box-multiple-outline",
    codepoint: "F3AB",
    aliases: ["filter-3", "numeric-three-box-multiple-outline"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M17,13V11.5C17,10.67 16.33,10 15.5,10C16.33,10 17,9.33 17,8.5V7C17,5.89 16.1,5 15,5H11V7H15V9H13V11H15V13H11V15H15C16.1,15 17,14.1 17,13M3,5H1V21C1,22.1 1.9,23 3,23H19V21H3M21,17H7V3H21M21,1H7C5.9,1 5,1.9 5,3V17C5,18.1 5.9,19 7,19H21C22.1,19 23,18.1 23,17V3C23,1.9 22.1,1 21,1Z",
  },
  {
    id: "0A0F7443-4234-4990-9C0B-A8AC88F924E5",
    name: "numeric-3-box-outline",
    codepoint: "F3AC",
    aliases: ["numeric-three-box-outline"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M15,15V13.5C15,12.67 14.33,12 13.5,12C14.33,12 15,11.33 15,10.5V9C15,7.89 14.1,7 13,7H9V9H13V11H11V13H13V15H9V17H13C14.1,17 15,16.1 15,15M19,19H5V5H19M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3Z",
  },
  {
    id: "9C9EEFA4-B764-41CE-A679-3927454AE59A",
    name: "numeric-4-box",
    codepoint: "F3AD",
    aliases: ["looks-4", "numeric-four-box"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M15,17H13V13H9V7H11V11H13V7H15M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3Z",
  },
  {
    id: "EB320CFB-296A-4C6F-9585-76CA21DDCD04",
    name: "numeric-4-box-multiple-outline",
    codepoint: "F3AE",
    aliases: ["filter-4", "numeric-four-box-multiple-outline"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M21,17H7V3H21M21,1H7C5.9,1 5,1.9 5,3V17C5,18.1 5.9,19 7,19H21C22.1,19 23,18.1 23,17V3C23,1.9 22.1,1 21,1M15,15H17V5H15V9H13V5H11V11H15M3,5H1V21C1,22.1 1.9,23 3,23H19V21H3V5Z",
  },
  {
    id: "18423C69-0B97-4590-A690-1AAF99615875",
    name: "numeric-4-box-outline",
    codepoint: "F3AF",
    aliases: ["numeric-four-box-outline"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M19,19H5V5H19M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3M13,17H15V7H13V11H11V7H9V13H13",
  },
  {
    id: "1F91841C-B56D-486E-8113-187E28F1E53A",
    name: "numeric-5-box",
    codepoint: "F3B0",
    aliases: ["looks-5", "numeric-five-box"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M15,9H11V11H13C14.1,11 15,11.9 15,13V15C15,16.11 14.1,17 13,17H9V15H13V13H9V7H15M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3Z",
  },
  {
    id: "A39788D6-B09D-42CF-ADC3-7575B14DBE79",
    name: "numeric-5-box-multiple-outline",
    codepoint: "F3B1",
    aliases: ["filter-5", "numeric-five-box-multiple-outline"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M17,13V11C17,9.89 16.1,9 15,9H13V7H17V5H11V11H15V13H11V15H15C16.1,15 17,14.1 17,13M3,5H1V21C1,22.1 1.9,23 3,23H19V21H3M21,17H7V3H21M21,1H7C5.9,1 5,1.9 5,3V17C5,18.1 5.9,19 7,19H21C22.1,19 23,18.1 23,17V3C23,1.9 22.1,1 21,1Z",
  },
  {
    id: "38CB37B2-2BF9-4890-8060-5576DDAE6FC6",
    name: "numeric-5-box-outline",
    codepoint: "F3B2",
    aliases: ["numeric-five-box-outline"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M15,15V13C15,11.89 14.1,11 13,11H11V9H15V7H9V13H13V15H9V17H13C14.1,17 15,16.1 15,15M19,19H5V5H19M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3Z",
  },
  {
    id: "DC1FE999-3DD7-423B-95A5-89005C66875E",
    name: "numeric-6-box",
    codepoint: "F3B3",
    aliases: ["looks-6", "numeric-six-box"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M15,9H11V11H13C14.1,11 15,11.9 15,13V15C15,16.11 14.1,17 13,17H11C9.9,17 9,16.1 9,15V9C9,7.89 9.9,7 11,7H15M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3M11,15H13V13H11V15Z",
  },
  {
    id: "F3AA6A15-D060-40D7-A301-9EB1BAAF2F12",
    name: "numeric-6-box-multiple-outline",
    codepoint: "F3B4",
    aliases: ["filter-6", "numeric-six-box-multiple-outline"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M13,11H15V13H13M13,15H15C16.1,15 17,14.1 17,13V11C17,9.89 16.1,9 15,9H13V7H17V5H13C11.9,5 11,5.9 11,7V13C11,14.11 11.9,15 13,15M21,17H7V3H21M21,1H7C5.9,1 5,1.9 5,3V17C5,18.1 5.9,19 7,19H21C22.1,19 23,18.1 23,17V3C23,1.9 22.1,1 21,1M3,5H1V21C1,22.1 1.9,23 3,23H19V21H3V5Z",
  },
  {
    id: "8ED3719B-D733-46ED-BFCF-0BDE0819F7EF",
    name: "numeric-6-box-outline",
    codepoint: "F3B5",
    aliases: ["numeric-six-box-outline"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M11,13H13V15H11M11,17H13C14.1,17 15,16.1 15,15V13C15,11.89 14.1,11 13,11H11V9H15V7H11C9.9,7 9,7.9 9,9V15C9,16.11 9.9,17 11,17M19,19H5V5H19M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3Z",
  },
  {
    id: "C01DF00A-5B63-4B15-B6A5-FEA9E3E084B1",
    name: "numeric-7-box",
    codepoint: "F3B6",
    aliases: ["numeric-seven-box"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M19,3C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3H19M11,17L15,9V7H9V9H13L9,17H11Z",
  },
  {
    id: "CF43DB99-4419-491B-A5E3-2486A36F24DB",
    name: "numeric-7-box-multiple-outline",
    codepoint: "F3B7",
    aliases: ["filter-7", "numeric-seven-box-multiple-outline"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M13,15L17,7V5H11V7H15L11,15M21,17H7V3H21M21,1H7C5.9,1 5,1.9 5,3V17C5,18.1 5.9,19 7,19H21C22.1,19 23,18.1 23,17V3C23,1.9 22.1,1 21,1M3,5H1V21C1,22.1 1.9,23 3,23H19V21H3V5Z",
  },
  {
    id: "373DD873-E15F-4B7C-8328-76389DC81DB0",
    name: "numeric-7-box-outline",
    codepoint: "F3B8",
    aliases: ["numeric-seven-box-outline"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M11,17L15,9V7H9V9H13L9,17M19,19H5V5H19M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3Z",
  },
  {
    id: "863E0667-F376-4303-9261-CAA4B7F073C6",
    name: "numeric-8-box",
    codepoint: "F3B9",
    aliases: ["numeric-eight-box"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M19,3C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3H19M11,17H13C14.1,17 15,16.1 15,15V13.5C15,12.67 14.33,12 13.5,12C14.33,12 15,11.33 15,10.5V9C15,7.89 14.1,7 13,7H11C9.9,7 9,7.9 9,9V10.5C9,11.33 9.67,12 10.5,12C9.67,12 9,12.67 9,13.5V15C9,16.11 9.9,17 11,17M11,13H13V15H11V13M11,9H13V11H11V9Z",
  },
  {
    id: "869A508B-5F8E-41A7-BCE5-E205FC66C80F",
    name: "numeric-8-box-multiple-outline",
    codepoint: "F3BA",
    aliases: ["filter-8", "numeric-eight-box-multiple-outline"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M13,11H15V13H13M13,7H15V9H13M13,15H15C16.1,15 17,14.1 17,13V11.5C17,10.67 16.33,10 15.5,10C16.33,10 17,9.33 17,8.5V7C17,5.89 16.1,5 15,5H13C11.9,5 11,5.9 11,7V8.5C11,9.33 11.67,10 12.5,10C11.67,10 11,10.67 11,11.5V13C11,14.11 11.9,15 13,15M21,17H7V3H21M21,1H7C5.9,1 5,1.9 5,3V17C5,18.1 5.9,19 7,19H21C22.1,19 23,18.1 23,17V3C23,1.9 22.1,1 21,1M3,5H1V21C1,22.1 1.9,23 3,23H19V21H3V5Z",
  },
  {
    id: "DC2B6D38-A6B3-4171-AAC6-E08EF2C23710",
    name: "numeric-8-box-outline",
    codepoint: "F3BB",
    aliases: ["numeric-eight-box-outline"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M11,13H13V15H11M11,9H13V11H11M11,17H13C14.1,17 15,16.1 15,15V13.5C15,12.67 14.33,12 13.5,12C14.33,12 15,11.33 15,10.5V9C15,7.89 14.1,7 13,7H11C9.9,7 9,7.9 9,9V10.5C9,11.33 9.67,12 10.5,12C9.67,12 9,12.67 9,13.5V15C9,16.11 9.9,17 11,17M19,19H5V5H19M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3Z",
  },
  {
    id: "12DCC44D-8BA2-4D25-A88B-665920C8B730",
    name: "numeric-9-box",
    codepoint: "F3BC",
    aliases: ["numeric-nine-box"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M19,3C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3H19M13,11H11V9H13V11M13,7H11C9.9,7 9,7.9 9,9V11C9,12.11 9.9,13 11,13H13V15H9V17H13C14.1,17 15,16.1 15,15V9C15,7.89 14.1,7 13,7Z",
  },
  {
    id: "A41F44A0-816E-497E-A08C-C9646FE161BE",
    name: "numeric-9-box-multiple-outline",
    codepoint: "F3BD",
    aliases: ["filter-9", "numeric-nine-box-multiple-outline"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M15,9H13V7H15M15,5H13C11.9,5 11,5.9 11,7V9C11,10.11 11.9,11 13,11H15V13H11V15H15C16.1,15 17,14.1 17,13V7C17,5.89 16.1,5 15,5M21,17H7V3H21M21,1H7C5.9,1 5,1.9 5,3V17C5,18.1 5.9,19 7,19H21C22.1,19 23,18.1 23,17V3C23,1.9 22.1,1 21,1M3,5H1V21C1,22.1 1.9,23 3,23H19V21H3V5Z",
  },
  {
    id: "EE2E9486-0C32-4EC9-9D4F-9B8A7287F696",
    name: "numeric-9-box-outline",
    codepoint: "F3BE",
    aliases: ["numeric-nine-box-outline"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M13,11H11V9H13M13,7H11C9.9,7 9,7.9 9,9V11C9,12.11 9.9,13 11,13H13V15H9V17H13C14.1,17 15,16.1 15,15V9C15,7.89 14.1,7 13,7M19,19H5V5H19M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3Z",
  },
  {
    id: "7CF309F0-D751-44A3-A313-BA7F2F8865FD",
    name: "numeric-9-plus-box",
    codepoint: "F3BF",
    aliases: ["numeric-nine-plus-box"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3H19C20.1,3 21,3.9 21,5M19,11H17V9H15V11H13V13H15V15H17V13H19V11M10,7H8C6.9,7 6,7.9 6,9V11C6,12.11 6.9,13 8,13H10V15H6V17H10C11.1,17 12,16.1 12,15V9C12,7.89 11.1,7 10,7M8,9H10V11H8V9Z",
  },
  {
    id: "46A850FC-F6E6-4000-A93F-6B954DA62886",
    name: "numeric-9-plus-box-multiple-outline",
    codepoint: "F3C0",
    aliases: ["filter-9-plus", "numeric-nine-plus-box-multiple-outline"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M21,9H19V7H17V9H15V11H17V13H19V11H21V17H7V3H21M21,1H7C5.9,1 5,1.9 5,3V17C5,18.1 5.9,19 7,19H21C22.1,19 23,18.1 23,17V3C23,1.9 22.1,1 21,1M11,9V8H12V9M14,12V8C14,6.89 13.1,6 12,6H11C9.9,6 9,6.9 9,8V9C9,10.11 9.9,11 11,11H12V12H9V14H12C13.1,14 14,13.1 14,12M3,5H1V21C1,22.1 1.9,23 3,23H19V21H3V5Z",
  },
  {
    id: "C1F38C40-BD01-45FE-A94C-B3C1432707E0",
    name: "numeric-9-plus-box-outline",
    codepoint: "F3C1",
    aliases: ["numeric-nine-plus-box-outline"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M19,11H17V9H15V11H13V13H15V15H17V13H19V19H5V5H19M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3M9,11V10H10V11M12,14V10C12,8.89 11.1,8 10,8H9C7.9,8 7,8.9 7,10V11C7,12.11 7.9,13 9,13H10V14H7V16H10C11.1,16 12,15.1 12,14Z",
  },
  {
    id: "8B702257-4232-459E-BDA8-C4E698DF8E8E",
    name: "nut",
    codepoint: "F6F7",
    aliases: [],
    tags: ["Hardware / Tools"],
    author: "Cody",
    version: "1.8.36",
    path: "M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5M12,7C9.24,7 7,9.24 7,12C7,14.76 9.24,17 12,17C14.76,17 17,14.76 17,12C17,9.24 14.76,7 12,7Z",
  },
  {
    id: "723E0BBB-78CC-4192-98B1-426B17D694B9",
    name: "nutrition",
    codepoint: "F3C2",
    aliases: [],
    tags: ["Food / Drink"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M22,18C22,20.21 20.21,22 18,22H14C11.79,22 10,20.21 10,18V16H22V18M4,3H14C15.1,3 16,3.9 16,5V14H8V19H4C2.9,19 2,18.1 2,17V5C2,3.9 2.9,3 4,3M4,6V8H6V6H4M14,8V6H8V8H14M4,10V12H6V10H4M8,10V12H14V10H8M4,14V16H6V14H4Z",
  },
  {
    id: "A065A53E-118C-424A-8A81-0D300975AB04",
    name: "oar",
    codepoint: "F67B",
    aliases: [],
    tags: [],
    author: "Thomas Hunsaker",
    version: "1.7.12",
    path: "M20.23,15.21C18.77,13.75 14.97,10.2 12.77,11.27L4.5,3L3,4.5L11.28,12.79C10.3,15 13.88,18.62 15.35,20.08C17.11,21.84 18.26,20.92 19.61,19.57C21.1,18.08 21.61,16.61 20.23,15.21Z",
  },
  {
    id: "5E3C88DE-A208-471A-9096-7C7868CC957C",
    name: "octagon",
    codepoint: "F3C3",
    aliases: [],
    tags: ["Shape"],
    author: "Cody",
    version: "1.5.54",
    path: "M15.73,3H8.27L3,8.27V15.73L8.27,21H15.73L21,15.73V8.27",
  },
  {
    id: "3CF63E10-42E7-4E13-8BFF-10E9257953AB",
    name: "octagon-outline",
    codepoint: "F3C4",
    aliases: [],
    tags: ["Shape"],
    author: "Cody",
    version: "1.5.54",
    path: "M8.27,3L3,8.27V15.73L8.27,21H15.73C17.5,19.24 21,15.73 21,15.73V8.27L15.73,3M9.1,5H14.9L19,9.1V14.9L14.9,19H9.1L5,14.9V9.1",
  },
  {
    id: "455C8475-5555-49B7-825B-206581104AB2",
    name: "octagram",
    codepoint: "F6F8",
    aliases: [],
    tags: ["Shape"],
    author: "Austin Andrews",
    version: "1.8.36",
    path: "M2.2,16.06L3.88,12L2.2,7.94L6.26,6.26L7.94,2.2L12,3.88L16.06,2.2L17.74,6.26L21.8,7.94L20.12,12L21.8,16.06L17.74,17.74L16.06,21.8L12,20.12L7.94,21.8L6.26,17.74L2.2,16.06Z",
  },
  {
    id: "8316E0F1-5F66-4C4E-ACA8-EE61AD93A42A",
    name: "octagram-outline",
    codepoint: "F774",
    aliases: [],
    tags: ["Shape"],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M2.2,16.06L3.88,12L2.2,7.94L6.26,6.26L7.94,2.2L12,3.88L16.06,2.2L17.74,6.26L21.8,7.94L20.12,12L21.8,16.06L17.74,17.74L16.06,21.8L12,20.12L7.94,21.8L6.26,17.74L2.2,16.06M4.81,9L6.05,12L4.81,15L7.79,16.21L9,19.19L12,17.95L15,19.19L16.21,16.21L19.19,15L17.95,12L19.19,9L16.21,7.79L15,4.81L12,6.05L9,4.81L7.79,7.79L4.81,9Z",
  },
  {
    id: "8BB24B94-491F-4465-8E87-45FF8FED7C4A",
    name: "odnoklassniki",
    codepoint: "F3C5",
    aliases: ["ok-ru"],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M17.83,12.74C17.55,12.17 16.76,11.69 15.71,12.5C14.28,13.64 12,13.64 12,13.64C12,13.64 9.72,13.64 8.29,12.5C7.24,11.69 6.45,12.17 6.17,12.74C5.67,13.74 6.23,14.23 7.5,15.04C8.59,15.74 10.08,16 11.04,16.1L10.24,16.9C9.1,18.03 8,19.12 7.25,19.88C6.8,20.34 6.8,21.07 7.25,21.5L7.39,21.66C7.84,22.11 8.58,22.11 9.03,21.66L12,18.68C13.15,19.81 14.24,20.9 15,21.66C15.45,22.11 16.18,22.11 16.64,21.66L16.77,21.5C17.23,21.07 17.23,20.34 16.77,19.88L13.79,16.9L13,16.09C13.95,16 15.42,15.73 16.5,15.04C17.77,14.23 18.33,13.74 17.83,12.74M12,4.57C13.38,4.57 14.5,5.69 14.5,7.06C14.5,8.44 13.38,9.55 12,9.55C10.62,9.55 9.5,8.44 9.5,7.06C9.5,5.69 10.62,4.57 12,4.57M12,12.12C14.8,12.12 17.06,9.86 17.06,7.06C17.06,4.27 14.8,2 12,2C9.2,2 6.94,4.27 6.94,7.06C6.94,9.86 9.2,12.12 12,12.12Z",
  },
  {
    id: "C6BEE3A0-C734-48D4-A2E4-622E9B16CA06",
    name: "office-building",
    codepoint: "F990",
    aliases: [],
    tags: ["Places"],
    author: "GreenTurtwig",
    version: "2.4.85",
    path: "M5,3V21H11V17.5H13V21H19V3H5M7,5H9V7H7V5M11,5H13V7H11V5M15,5H17V7H15V5M7,9H9V11H7V9M11,9H13V11H11V9M15,9H17V11H15V9M7,13H9V15H7V13M11,13H13V15H11V13M15,13H17V15H15V13M7,17H9V19H7V17M15,17H17V19H15V17Z",
  },
  {
    id: "DE398350-B7B7-4E6B-AE4C-F99AAE56C7CF",
    name: "oil",
    codepoint: "F3C7",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M22,12.5C22,12.5 24,14.67 24,16C24,17.1 23.1,18 22,18C20.9,18 20,17.1 20,16C20,14.67 22,12.5 22,12.5M6,6H10C10.55,6 11,6.45 11,7C11,7.55 10.55,8 10,8H9V10H11C11.74,10 12.39,10.4 12.73,11L19.24,7.24L22.5,9.13C23,9.4 23.14,10 22.87,10.5C22.59,10.97 22,11.14 21.5,10.86L19.4,9.65L15.75,15.97C15.41,16.58 14.75,17 14,17H5C3.9,17 3,16.1 3,15V12C3,10.9 3.9,10 5,10H7V8H6C5.45,8 5,7.55 5,7C5,6.45 5.45,6 6,6M5,12V15H14L16.06,11.43L12.6,13.43L11.69,12H5M0.38,9.21L2.09,7.5C2.5,7.11 3.11,7.11 3.5,7.5C3.89,7.89 3.89,8.5 3.5,8.91L1.79,10.62C1.4,11 0.77,11 0.38,10.62C0,10.23 0,9.6 0.38,9.21Z",
  },
  {
    id: "A260896B-178E-4E3A-9F2C-793AD68154F4",
    name: "oil-temperature",
    codepoint: "F3C8",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M11.5,1C10.67,1 10,1.67 10,2.5V14.5C9.37,14.97 9,15.71 9,16.5C9,17.88 10.12,19 11.5,19C12.88,19 14,17.88 14,16.5C14,15.71 13.63,15 13,14.5V13H17V11H13V9H17V7H13V5H17V3H13V2.5C13,1.67 12.33,1 11.5,1M0,15V17C0.67,17 0.79,17.21 1.29,17.71C1.79,18.21 2.67,19 4,19C5.33,19 6.21,18.21 6.71,17.71C6.82,17.59 6.91,17.5 7,17.41V15.16C6.21,15.42 5.65,15.93 5.29,16.29C4.79,16.79 4.67,17 4,17C3.33,17 3.21,16.79 2.71,16.29C2.21,15.79 1.33,15 0,15M16,15V17C16.67,17 16.79,17.21 17.29,17.71C17.79,18.21 18.67,19 20,19C21.33,19 22.21,18.21 22.71,17.71C23.21,17.21 23.33,17 24,17V15C22.67,15 21.79,15.79 21.29,16.29C20.79,16.79 20.67,17 20,17C19.33,17 19.21,16.79 18.71,16.29C18.21,15.79 17.33,15 16,15M8,20C6.67,20 5.79,20.79 5.29,21.29C4.79,21.79 4.67,22 4,22C3.33,22 3.21,21.79 2.71,21.29C2.35,20.93 1.79,20.42 1,20.16V22.41C1.09,22.5 1.18,22.59 1.29,22.71C1.79,23.21 2.67,24 4,24C5.33,24 6.21,23.21 6.71,22.71C7.21,22.21 7.33,22 8,22C8.67,22 8.79,22.21 9.29,22.71C9.73,23.14 10.44,23.8 11.5,23.96C11.66,24 11.83,24 12,24C13.33,24 14.21,23.21 14.71,22.71C15.21,22.21 15.33,22 16,22C16.67,22 16.79,22.21 17.29,22.71C17.79,23.21 18.67,24 20,24C21.33,24 22.21,23.21 22.71,22.71C22.82,22.59 22.91,22.5 23,22.41V20.16C22.21,20.42 21.65,20.93 21.29,21.29C20.79,21.79 20.67,22 20,22C19.33,22 19.21,21.79 18.71,21.29C18.21,20.79 17.33,20 16,20C14.67,20 13.79,20.79 13.29,21.29C12.79,21.79 12.67,22 12,22C11.78,22 11.63,21.97 11.5,21.92C11.22,21.82 11.05,21.63 10.71,21.29C10.21,20.79 9.33,20 8,20Z",
  },
  {
    id: "A98F63CB-AB27-4A2D-B76C-6994507BCDBB",
    name: "omega",
    codepoint: "F3C9",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M19.15,19H13.39V16.87C15.5,15.25 16.59,13.24 16.59,10.84C16.59,9.34 16.16,8.16 15.32,7.29C14.47,6.42 13.37,6 12.03,6C10.68,6 9.57,6.42 8.71,7.3C7.84,8.17 7.41,9.37 7.41,10.88C7.41,13.26 8.5,15.26 10.61,16.87V19H4.85V16.87H8.41C6.04,15.32 4.85,13.23 4.85,10.6C4.85,8.5 5.5,6.86 6.81,5.66C8.12,4.45 9.84,3.85 11.97,3.85C14.15,3.85 15.89,4.45 17.19,5.64C18.5,6.83 19.15,8.5 19.15,10.58C19.15,13.21 17.95,15.31 15.55,16.87H19.15V19Z",
  },
  {
    id: "2B9B64C7-B799-45C5-BDCC-BEC3B8672CFE",
    name: "onepassword",
    codepoint: "F880",
    aliases: ["1password"],
    tags: ["Brand / Logo"],
    author: "Michael Richins",
    version: "2.1.99",
    path: "M12,1C5.92,1 1,5.92 1,12C1,18.08 5.92,23 12,23C18.08,23 23,18.08 23,12C23,5.92 18.08,1 12,1M12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20M13,13.5C13,14.13 13.4,14.7 14,14.91V18H10V11.91C10.78,11.64 11.19,10.8 10.93,10C10.78,9.58 10.44,9.24 10,9.09V6H14V12.09C13.4,12.3 13,12.87 13,13.5Z",
  },
  {
    id: "27C36043-E269-4223-ADCE-568B1EFB4623",
    name: "opacity",
    codepoint: "F5CC",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M17.66,8L12,2.35L6.34,8C4.78,9.56 4,11.64 4,13.64C4,15.64 4.78,17.75 6.34,19.31C7.9,20.87 9.95,21.66 12,21.66C14.05,21.66 16.1,20.87 17.66,19.31C19.22,17.75 20,15.64 20,13.64C20,11.64 19.22,9.56 17.66,8M6,14C6,12 6.62,10.73 7.76,9.6L12,5.27L16.24,9.65C17.38,10.77 18,12 18,14H6Z",
  },
  {
    id: "AF69E2E1-8119-49A2-8E24-915E2254522A",
    name: "open-in-app",
    codepoint: "F3CB",
    aliases: ["open-in-browser"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M12,10L8,14H11V20H13V14H16M19,4H5C3.89,4 3,4.9 3,6V18C3,19.1 3.9,20 5,20H9V18H5V8H19V18H15V20H19C20.1,20 21,19.1 21,18V6C21,4.9 20.1,4 19,4Z",
  },
  {
    id: "12B95238-1D74-4C6C-9BBD-C055B4DD0E4D",
    name: "open-in-new",
    codepoint: "F3CC",
    aliases: ["external-link"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M14,3V5H17.59L7.76,14.83L9.17,16.24L19,6.41V10H21V3M19,19H5V5H12V3H5C3.89,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V12H19V19Z",
  },
  {
    id: "C9525FF9-FE74-467C-99CE-F8DD8FE3576C",
    name: "openid",
    codepoint: "F3CD",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Christopher Schreiner",
    version: "1.5.54",
    path: "M14,2L11,3.5V19.94C7,19.5 4,17.46 4,15C4,12.75 6.5,10.85 10,10.22V8.19C4.86,8.88 1,11.66 1,15C1,18.56 5.36,21.5 11,21.94C11.03,21.94 11.06,21.94 11.09,21.94L14,20.5V2M15,8.19V10.22C16.15,10.43 17.18,10.77 18.06,11.22L16.5,12L23,13.5L22.5,9L20.5,10C19,9.12 17.12,8.47 15,8.19Z",
  },
  {
    id: "A0BCE6D1-D558-487E-9629-F7CCC495C27B",
    name: "opera",
    codepoint: "F3CE",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M9.04,17.07C8.04,15.9 7.4,14.16 7.35,12.21V11.79C7.4,9.84 8.04,8.1 9.04,6.93C9.86,5.95 10.93,5.37 12.1,5.37C14.72,5.37 16.84,8.34 16.84,12C16.84,15.66 14.72,18.63 12.1,18.63C10.93,18.63 10.33,18.5 9.04,17.07M12.03,3H12C7.03,3 3,7.03 3,12C3,16.83 6.8,20.77 11.57,21H12C14.3,21 16.4,20.13 18,18.71C19.84,17.06 21,14.67 21,12C21,9.33 19.84,6.94 18,5.29C16.41,3.87 14.32,3 12.03,3Z",
  },
  {
    id: "D672819E-C3D1-49FC-A1E7-9F4732D034DC",
    name: "orbit",
    codepoint: "F018",
    aliases: [],
    tags: ["Science"],
    author: "Roberto Graham",
    version: "1.5.54",
    path: "M8.11,1.75C9.3,1.25 10.62,1 12,1C18.08,1 23,5.92 23,12C23,18.08 18.08,23 12,23C5.92,23 1,18.08 1,12C1,10.62 1.25,9.3 1.72,8.08C2.24,8.61 2.83,8.96 3.45,9.18C3.16,10.07 3,11 3,12C3,16.97 7.03,21 12,21C16.97,21 21,16.97 21,12C21,7.03 16.97,3 12,3C11,3 10.07,3.16 9.18,3.45C8.96,2.83 8.61,2.24 8.11,1.75M4.93,2.93C6.03,2.93 6.93,3.82 6.93,4.93C6.93,6.03 6.03,6.93 4.93,6.93C3.82,6.93 2.93,6.03 2.93,4.93C2.93,3.82 3.82,2.93 4.93,2.93M12,7C14.76,7 17,9.24 17,12C17,14.76 14.76,17 12,17C9.24,17 7,14.76 7,12C7,9.24 9.24,7 12,7Z",
  },
  {
    id: "ADC4F1DD-B840-4C28-8D5C-08F3BE15A424",
    name: "ornament",
    codepoint: "F3CF",
    aliases: [],
    tags: ["Holiday"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,1C13.66,1 15,2.34 15,4V5C15.55,5 16,5.45 16,6V7.07C18.39,8.45 20,11.04 20,14C20,18.42 16.42,22 12,22C7.58,22 4,18.42 4,14C4,11.04 5.61,8.45 8,7.07V6C8,5.45 8.45,5 9,5V4C9,2.34 10.34,1 12,1M12,3C11.45,3 11,3.45 11,4V5H13V4C13,3.45 12.55,3 12,3M12,8C10.22,8 8.63,8.77 7.53,10H16.47C15.37,8.77 13.78,8 12,8M6.34,16H7.59L6,14.43C6.05,15 6.17,15.5 6.34,16M12.59,16L8.59,12H6.41L10.41,16H12.59M17.66,12H16.41L18,13.57C17.95,13 17.83,12.5 17.66,12M11.41,12L15.41,16H17.59L13.59,12H11.41M12,20C13.78,20 15.37,19.23 16.47,18H7.53C8.63,19.23 10.22,20 12,20Z",
  },
  {
    id: "9C3E1D75-FB73-44AA-8BCC-9B30692D8D79",
    name: "ornament-variant",
    codepoint: "F3D0",
    aliases: [],
    tags: ["Holiday"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,1C13.66,1 15,2.34 15,4V5C15.55,5 16,5.45 16,6V7.07C18.39,8.45 20,11.04 20,14C20,18.42 16.42,22 12,22C7.58,22 4,18.42 4,14C4,11.04 5.61,8.45 8,7.07V6C8,5.45 8.45,5 9,5V4C9,2.34 10.34,1 12,1M12,3C11.45,3 11,3.45 11,4V5H13V4C13,3.45 12.55,3 12,3M12,8C10.22,8 8.63,8.77 7.53,10H16.47C15.37,8.77 13.78,8 12,8M12,20C13.78,20 15.37,19.23 16.47,18H7.53C8.63,19.23 10.22,20 12,20M12,12C10.9,12 10,12.9 10,14C10,15.1 10.9,16 12,16C13.1,16 14,15.1 14,14C14,12.9 13.1,12 12,12M18,14C18,13.31 17.88,12.65 17.67,12C16.72,12.19 16,13 16,14C16,15 16.72,15.81 17.67,15.97C17.88,15.35 18,14.69 18,14M6,14C6,14.69 6.12,15.35 6.33,15.97C7.28,15.81 8,15 8,14C8,13 7.28,12.19 6.33,12C6.12,12.65 6,13.31 6,14Z",
  },
  {
    id: "1F963457-7A4F-4BEE-AE9C-0E54CF804DD3",
    name: "owl",
    codepoint: "F3D2",
    aliases: [],
    tags: ["Animal"],
    author: "Cody",
    version: "1.5.54",
    path: "M12,16C12.56,16.84 13.31,17.53 14.2,18L12,20.2L9.8,18C10.69,17.53 11.45,16.84 12,16M17,11.2C15.9,11.2 15,12.1 15,13.2C15,14.3 15.9,15.2 17,15.2C18.1,15.2 19,14.3 19,13.2C19,12.09 18.1,11.2 17,11.2M7,11.2C5.9,11.2 5,12.1 5,13.2C5,14.3 5.9,15.2 7,15.2C8.1,15.2 9,14.3 9,13.2C9,12.09 8.1,11.2 7,11.2M17,8.7C19.21,8.7 21,10.49 21,12.7C21,14.91 19.21,16.7 17,16.7C14.79,16.7 13,14.91 13,12.7C13,10.49 14.79,8.7 17,8.7M7,8.7C9.21,8.7 11,10.49 11,12.7C11,14.91 9.21,16.7 7,16.7C4.79,16.7 3,14.91 3,12.7C3,10.49 4.79,8.7 7,8.7M2.24,1C4,4.7 2.73,7.46 1.55,10.2C1.19,11 1,11.83 1,12.7C1,16.01 3.69,18.7 7,18.7C7.21,18.69 7.42,18.68 7.63,18.65L10.59,21.61L12,23L13.41,21.61L16.37,18.65C16.58,18.68 16.79,18.69 17,18.7C20.31,18.7 23,16.01 23,12.7C23,11.83 22.81,11 22.45,10.2C21.27,7.46 20,4.7 21.76,1C19.12,3.06 15.36,4.69 12,4.7C8.64,4.69 4.88,3.06 2.24,1Z",
  },
  {
    id: "57771FFC-0E2C-40DE-AF7C-F3F51EFFE2C0",
    name: "package",
    codepoint: "F3D3",
    aliases: ["box"],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M5.12,5H18.87L17.93,4H5.93L5.12,5M20.54,5.23C20.83,5.57 21,6 21,6.5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V6.5C3,6 3.17,5.57 3.46,5.23L4.84,3.55C5.12,3.21 5.53,3 6,3H18C18.47,3 18.88,3.21 19.15,3.55L20.54,5.23M6,18H12V15H6V18Z",
  },
  {
    id: "0C18B335-700A-4D68-BF88-C95A69479F2E",
    name: "package-down",
    codepoint: "F3D4",
    aliases: ["archive", "box-down"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M5.12,5L5.93,4H17.93L18.87,5M12,17.5L6.5,12H10V10H14V12H17.5L12,17.5M20.54,5.23L19.15,3.55C18.88,3.21 18.47,3 18,3H6C5.53,3 5.12,3.21 4.84,3.55L3.46,5.23C3.17,5.57 3,6 3,6.5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V6.5C21,6 20.83,5.57 20.54,5.23Z",
  },
  {
    id: "383EF914-6014-473D-8C54-0314432007E3",
    name: "package-up",
    codepoint: "F3D5",
    aliases: ["unarchive", "box-up"],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M20.54,5.23C20.83,5.57 21,6 21,6.5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V6.5C3,6 3.17,5.57 3.46,5.23L4.84,3.55C5.12,3.21 5.53,3 6,3H18C18.47,3 18.88,3.21 19.15,3.55L20.54,5.23M5.12,5H18.87L17.93,4H5.93L5.12,5M12,9.5L6.5,15H10V17H14V15H17.5L12,9.5Z",
  },
  {
    id: "558C8C17-E4E1-4921-874D-F9ACB26C35C8",
    name: "package-variant",
    codepoint: "F3D6",
    aliases: ["box-variant"],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M2,10.96C1.5,10.68 1.35,10.07 1.63,9.59L3.13,7C3.24,6.8 3.41,6.66 3.6,6.58L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.66,6.72 20.82,6.88 20.91,7.08L22.36,9.6C22.64,10.08 22.47,10.69 22,10.96L21,11.54V16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V10.96C2.7,11.13 2.32,11.14 2,10.96M12,4.15V4.15L12,10.85V10.85L17.96,7.5L12,4.15M5,15.91L11,19.29V12.58L5,9.21V15.91M19,15.91V12.69L14,15.59C13.67,15.77 13.3,15.76 13,15.6V19.29L19,15.91M13.85,13.36L20.13,9.73L19.55,8.72L13.27,12.35L13.85,13.36Z",
  },
  {
    id: "290F16B3-147C-446D-B14B-56AECCA76276",
    name: "package-variant-closed",
    codepoint: "F3D7",
    aliases: ["box-variant-closed"],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5M12,4.15L10.11,5.22L16,8.61L17.96,7.5L12,4.15M6.04,7.5L12,10.85L13.96,9.75L8.08,6.35L6.04,7.5M5,15.91L11,19.29V12.58L5,9.21V15.91M19,15.91V9.21L13,12.58V19.29L19,15.91Z",
  },
  {
    id: "DF23FF47-4DD3-4CB3-9BEC-6EE986B0FA65",
    name: "page-first",
    codepoint: "F600",
    aliases: ["first-page"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M18.41,16.59L13.82,12L18.41,7.41L17,6L11,12L17,18L18.41,16.59M6,6H8V18H6V6Z",
  },
  {
    id: "CF9B4635-FE27-4DA5-BE51-F5F4116AFC54",
    name: "page-last",
    codepoint: "F601",
    aliases: ["last-page"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M5.59,7.41L10.18,12L5.59,16.59L7,18L13,12L7,6L5.59,7.41M16,6H18V18H16V6Z",
  },
  {
    id: "39AF8334-4244-49DD-A8A4-D4F638B9D939",
    name: "page-layout-body",
    codepoint: "F6F9",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.8.36",
    path: "M6,2H18C19.1,2 20,2.9 20,4V20C20,21.1 19.1,22 18,22H6C4.9,22 4,21.1 4,20V4C4,2.9 4.9,2 6,2M6,8V16H18V8H6Z",
  },
  {
    id: "74636C38-381A-46B8-97FD-B312735DE60D",
    name: "page-layout-footer",
    codepoint: "F6FA",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.8.36",
    path: "M6,2H18C19.1,2 20,2.9 20,4V20C20,21.1 19.1,22 18,22H6C4.9,22 4,21.1 4,20V4C4,2.9 4.9,2 6,2M6,16V20H18V16H6Z",
  },
  {
    id: "3606AC64-ABC8-4DA6-ACE8-64D58E0B0A46",
    name: "page-layout-header",
    codepoint: "F6FB",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.8.36",
    path: "M6,2H18C19.1,2 20,2.9 20,4V20C20,21.1 19.1,22 18,22H6C4.9,22 4,21.1 4,20V4C4,2.9 4.9,2 6,2M6,4V8H18V4H6Z",
  },
  {
    id: "6E39564D-2B4B-4940-9E74-5274ED12E800",
    name: "page-layout-sidebar-left",
    codepoint: "F6FC",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.8.36",
    path: "M6,2H18C19.1,2 20,2.9 20,4V20C20,21.1 19.1,22 18,22H6C4.9,22 4,21.1 4,20V4C4,2.9 4.9,2 6,2M6,8V16H10V8H6Z",
  },
  {
    id: "29C8714B-1CAD-41B8-829B-2A14F6F87684",
    name: "page-layout-sidebar-right",
    codepoint: "F6FD",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.8.36",
    path: "M6,2H18C19.1,2 20,2.9 20,4V20C20,21.1 19.1,22 18,22H6C4.9,22 4,21.1 4,20V4C4,2.9 4.9,2 6,2M14,8V16H18V8H14Z",
  },
  {
    id: "954CCE2B-7FEE-4F9C-9923-4E1D567607C3",
    name: "palette",
    codepoint: "F3D8",
    aliases: ["color-lens", "colour-lens"],
    tags: ["Color"],
    author: "Google",
    version: "1.5.54",
    path: "M17.5,12C16.67,12 16,11.33 16,10.5C16,9.67 16.67,9 17.5,9C18.33,9 19,9.67 19,10.5C19,11.33 18.33,12 17.5,12M14.5,8C13.67,8 13,7.33 13,6.5C13,5.67 13.67,5 14.5,5C15.33,5 16,5.67 16,6.5C16,7.33 15.33,8 14.5,8M9.5,8C8.67,8 8,7.33 8,6.5C8,5.67 8.67,5 9.5,5C10.33,5 11,5.67 11,6.5C11,7.33 10.33,8 9.5,8M6.5,12C5.67,12 5,11.33 5,10.5C5,9.67 5.67,9 6.5,9C7.33,9 8,9.67 8,10.5C8,11.33 7.33,12 6.5,12M12,3C7.03,3 3,7.03 3,12C3,16.97 7.03,21 12,21C12.83,21 13.5,20.33 13.5,19.5C13.5,19.11 13.35,18.76 13.11,18.5C12.88,18.23 12.73,17.88 12.73,17.5C12.73,16.67 13.4,16 14.23,16H16C18.76,16 21,13.76 21,11C21,6.58 16.97,3 12,3Z",
  },
  {
    id: "3617B5EE-9A4A-4C3C-9C9A-8C69C7569EB4",
    name: "palette-advanced",
    codepoint: "F3D9",
    aliases: [],
    tags: ["Color"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M22,22H10V20H22V22M2,22V20H9V22H2M18,18V10H22V18H18M18,3H22V9H18V3M2,18V3H16V18H2M9,14.56C10.66,14.56 12,13.22 12,11.56C12,9.56 9,6.19 9,6.19C9,6.19 6,9.56 6,11.56C6,13.22 7.34,14.56 9,14.56Z",
  },
  {
    id: "158F8306-CE63-45E8-94E5-58484FF5F050",
    name: "palette-swatch",
    codepoint: "F8B4",
    aliases: ["style"],
    tags: [],
    author: "Google",
    version: "2.2.43",
    path: "M2.53,19.65L3.87,20.21V11.18L1.44,17.04C1.03,18.06 1.5,19.23 2.53,19.65M22.03,15.95L17.07,4C16.76,3.23 16.03,2.77 15.26,2.75C15,2.75 14.73,2.79 14.47,2.9L7.1,5.95C6.35,6.26 5.89,7 5.87,7.75C5.86,8 5.91,8.29 6,8.55L11,20.5C11.29,21.28 12.03,21.74 12.81,21.75C13.07,21.75 13.33,21.7 13.58,21.6L20.94,18.55C21.96,18.13 22.45,16.96 22.03,15.95M7.88,8.75C7.33,8.75 6.88,8.3 6.88,7.75C6.88,7.2 7.33,6.75 7.88,6.75C8.43,6.75 8.88,7.2 8.88,7.75C8.88,8.3 8.43,8.75 7.88,8.75M5.88,19.75C5.88,20.85 6.78,21.75 7.88,21.75H9.33L5.88,13.41V19.75Z",
  },
  {
    id: "A797FE46-DF68-4179-85BE-172BD79F0667",
    name: "panda",
    codepoint: "F3DA",
    aliases: [],
    tags: ["Animal"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,3C13.74,3 15.36,3.5 16.74,4.35C17.38,3.53 18.38,3 19.5,3C21.43,3 23,4.57 23,6.5C23,8 22.05,9.28 20.72,9.78C20.9,10.5 21,11.23 21,12C21,16.97 16.97,21 12,21C7.03,21 3,16.97 3,12C3,11.23 3.1,10.5 3.28,9.78C1.95,9.28 1,8 1,6.5C1,4.57 2.57,3 4.5,3C5.62,3 6.62,3.53 7.26,4.35C8.64,3.5 10.26,3 12,3M12,5C8.13,5 5,8.13 5,12C5,15.87 8.13,19 12,19C15.87,19 19,15.87 19,12C19,8.13 15.87,5 12,5M16.19,10.3C16.55,11.63 16.08,12.91 15.15,13.16C14.21,13.42 13.17,12.54 12.81,11.2C12.45,9.87 12.92,8.59 13.85,8.34C14.79,8.09 15.83,8.96 16.19,10.3M7.81,10.3C8.17,8.96 9.21,8.09 10.15,8.34C11.08,8.59 11.55,9.87 11.19,11.2C10.83,12.54 9.79,13.42 8.85,13.16C7.92,12.91 7.45,11.63 7.81,10.3M12,14C12.6,14 13.13,14.19 13.5,14.5L12.5,15.5C12.5,15.92 12.84,16.25 13.25,16.25C13.66,16.25 14,15.91 14,15.5C14,15.22 14.22,15 14.5,15C14.78,15 15,15.22 15,15.5C15,16.47 14.22,17.25 13.25,17.25C12.76,17.25 12.32,17.05 12,16.72C11.68,17.05 11.24,17.25 10.75,17.25C9.78,17.25 9,16.47 9,15.5C9,15.22 9.22,15 9.5,15C9.78,15 10,15.22 10,15.5C10,15.91 10.34,16.25 10.75,16.25C11.16,16.25 11.5,15.91 11.5,15.5L10.5,14.5C10.87,14.19 11.4,14 12,14Z",
  },
  {
    id: "24BCD03F-8D84-4154-95F5-086230CE3BBA",
    name: "pandora",
    codepoint: "F3DB",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M10,20C10,20.55 9.55,21 9,21H4V3H13.71C17.44,3 20.46,6.02 20.46,9.75C20.46,13.5 17.44,16.5 13.71,16.5H10V20Z",
  },
  {
    id: "4054A322-F348-49BA-B85F-B978EFC1BDAD",
    name: "panorama",
    codepoint: "F3DC",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M8.5,12.5L11,15.5L14.5,11L19,17H5M23,18V6C23,4.9 22.1,4 21,4H3C1.9,4 1,4.9 1,6V18C1,19.1 1.9,20 3,20H21C22.1,20 23,19.1 23,18Z",
  },
  {
    id: "6D0BD840-6985-440A-9C55-782B5C3F4F9C",
    name: "panorama-fisheye",
    codepoint: "F3DD",
    aliases: ["panorama-fish-eye"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2C6.47,2 2,6.47 2,12C2,17.53 6.47,22 12,22C17.53,22 22,17.53 22,12C22,6.47 17.53,2 12,2Z",
  },
  {
    id: "42B1DAD8-8731-49DB-B415-9BFD78A8DDEA",
    name: "panorama-horizontal",
    codepoint: "F3DE",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M21.43,4C21.33,4 21.23,4 21.12,4.06C18.18,5.16 15.09,5.7 12,5.7C8.91,5.7 5.82,5.15 2.88,4.06C2.77,4 2.66,4 2.57,4C2.23,4 2,4.23 2,4.63V19.38C2,19.77 2.23,20 2.57,20C2.67,20 2.77,20 2.88,19.94C5.82,18.84 8.91,18.3 12,18.3C15.09,18.3 18.18,18.85 21.12,19.94C21.23,20 21.33,20 21.43,20C21.76,20 22,19.77 22,19.37V4.63C22,4.23 21.76,4 21.43,4M20,6.54V17.45C17.4,16.68 14.72,16.29 12,16.29C9.28,16.29 6.6,16.68 4,17.45V6.54C6.6,7.31 9.28,7.7 12,7.7C14.72,7.71 17.4,7.32 20,6.54Z",
  },
  {
    id: "7EC1E0AF-1AC5-4CC8-BDCC-5E2D3BF2AC70",
    name: "panorama-vertical",
    codepoint: "F3DF",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M6.54,20C7.31,17.4 7.7,14.72 7.7,12C7.7,9.28 7.31,6.6 6.54,4H17.45C16.68,6.6 16.29,9.28 16.29,12C16.29,14.72 16.68,17.4 17.45,20M19.94,21.12C18.84,18.18 18.3,15.09 18.3,12C18.3,8.91 18.85,5.82 19.94,2.88C20,2.77 20,2.66 20,2.57C20,2.23 19.77,2 19.37,2H4.63C4.23,2 4,2.23 4,2.57C4,2.67 4,2.77 4.06,2.88C5.16,5.82 5.71,8.91 5.71,12C5.71,15.09 5.16,18.18 4.07,21.12C4,21.23 4,21.34 4,21.43C4,21.76 4.23,22 4.63,22H19.38C19.77,22 20,21.76 20,21.43C20,21.33 20,21.23 19.94,21.12Z",
  },
  {
    id: "12D83006-87DE-49CE-B8C3-7D6492934CDA",
    name: "panorama-wide-angle",
    codepoint: "F3E0",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M12,4C9.27,4 6.78,4.24 4.05,4.72L3.12,4.88L2.87,5.78C2.29,7.85 2,9.93 2,12C2,14.07 2.29,16.15 2.87,18.22L3.12,19.11L4.05,19.27C6.78,19.76 9.27,20 12,20C14.73,20 17.22,19.76 19.95,19.28L20.88,19.12L21.13,18.23C21.71,16.15 22,14.07 22,12C22,9.93 21.71,7.85 21.13,5.78L20.88,4.89L19.95,4.73C17.22,4.24 14.73,4 12,4M12,6C14.45,6 16.71,6.2 19.29,6.64C19.76,8.42 20,10.22 20,12C20,13.78 19.76,15.58 19.29,17.36C16.71,17.8 14.45,18 12,18C9.55,18 7.29,17.8 4.71,17.36C4.24,15.58 4,13.78 4,12C4,10.22 4.24,8.42 4.71,6.64C7.29,6.2 9.55,6 12,6Z",
  },
  {
    id: "4E8B4DBC-83EE-4CBD-BEDD-5866DE057324",
    name: "paper-cut-vertical",
    codepoint: "F3E1",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M11.43,3.23L12,4L12.57,3.23V3.24C13.12,2.5 14,2 15,2C16.66,2 18,3.34 18,5C18,5.35 17.94,5.69 17.83,6H20C21.1,6 22,6.9 22,8V20C22,21.1 21.1,22 20,22H4C2.9,22 2,21.1 2,20V8C2,6.9 2.9,6 4,6H6.17C6.06,5.69 6,5.35 6,5C6,3.34 7.34,2 9,2C10,2 10.88,2.5 11.43,3.24V3.23M4,8V20H11C11,19.45 11.45,19 12,19C12.55,19 13,19.45 13,20H20V8H15L14.9,8L17,10.92L15.4,12.1L12.42,8H11.58L8.6,12.1L7,10.92L9.1,8H9L4,8M9,4C8.45,4 8,4.45 8,5C8,5.55 8.45,6 9,6C9.55,6 10,5.55 10,5C10,4.45 9.55,4 9,4M15,4C14.45,4 14,4.45 14,5C14,5.55 14.45,6 15,6C15.55,6 16,5.55 16,5C16,4.45 15.55,4 15,4M12,16C12.55,16 13,16.45 13,17C13,17.55 12.55,18 12,18C11.45,18 11,17.55 11,17C11,16.45 11.45,16 12,16M12,13C12.55,13 13,13.45 13,14C13,14.55 12.55,15 12,15C11.45,15 11,14.55 11,14C11,13.45 11.45,13 12,13M12,10C12.55,10 13,10.45 13,11C13,11.55 12.55,12 12,12C11.45,12 11,11.55 11,11C11,10.45 11.45,10 12,10Z",
  },
  {
    id: "27BCEC7F-ABF8-4506-B339-EE2425E1BAF9",
    name: "paperclip",
    codepoint: "F3E2",
    aliases: ["attachment-vertical", "attach-file"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M16.5,6V17.5C16.5,19.71 14.71,21.5 12.5,21.5C10.29,21.5 8.5,19.71 8.5,17.5V5C8.5,3.62 9.62,2.5 11,2.5C12.38,2.5 13.5,3.62 13.5,5V15.5C13.5,16.05 13.05,16.5 12.5,16.5C11.95,16.5 11.5,16.05 11.5,15.5V6H10V15.5C10,16.88 11.12,18 12.5,18C13.88,18 15,16.88 15,15.5V5C15,2.79 13.21,1 11,1C8.79,1 7,2.79 7,5V17.5C7,20.54 9.46,23 12.5,23C15.54,23 18,20.54 18,17.5V6H16.5Z",
  },
  {
    id: "07C8266A-A135-443C-B2DD-4148CD718C51",
    name: "parking",
    codepoint: "F3E3",
    aliases: ["car-park", "local-parking"],
    tags: ["Places"],
    author: "Google",
    version: "1.5.54",
    path: "M13.2,11H10V7H13.2C14.3,7 15.2,7.9 15.2,9C15.2,10.1 14.3,11 13.2,11M13,3H6V21H10V15H13C16.31,15 19,12.31 19,9C19,5.68 16.31,3 13,3Z",
  },
  {
    id: "31BE5768-FCE0-46D5-A20B-E8CBFED471E0",
    name: "passport",
    codepoint: "F7E2",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "2.0.46",
    path: "M6,2C4.9,2 4,2.9 4,4V20C4,21.1 4.9,22 6,22H18C19.1,22 20,21.1 20,20V4C20,2.9 19.1,2 18,2H6M12,5C14.76,5 17,7.24 17,10C17,12.76 14.76,15 12,15C9.24,15 7,12.76 7,10C7,7.24 9.24,5 12,5M12,6C11.59,6.62 11.25,7.29 11.04,8H12.96C12.75,7.29 12.42,6.62 12,6M10.7,6.22C9.78,6.53 9,7.17 8.54,8H10C10.18,7.38 10.4,6.78 10.7,6.22M13.29,6.22C13.59,6.78 13.82,7.38 14,8H15.46C15,7.17 14.21,6.54 13.29,6.22M8.13,9C8.05,9.32 8,9.65 8,10C8,10.35 8.05,10.68 8.13,11H9.82C9.78,10.67 9.75,10.34 9.75,10C9.75,9.66 9.78,9.33 9.82,9H8.13M10.83,9C10.78,9.32 10.75,9.66 10.75,10C10.75,10.34 10.78,10.67 10.83,11H13.17C13.21,10.67 13.25,10.34 13.25,10C13.25,9.66 13.21,9.32 13.17,9H10.83M14.18,9C14.22,9.33 14.25,9.66 14.25,10C14.25,10.34 14.22,10.67 14.18,11H15.87C15.95,10.68 16,10.35 16,10C16,9.65 15.95,9.32 15.87,9H14.18M8.54,12C9,12.83 9.78,13.46 10.7,13.78C10.4,13.22 10.18,12.63 10,12H8.54M11.04,12C11.25,12.72 11.59,13.38 12,14C12.42,13.38 12.75,12.72 12.96,12H11.04M14,12C13.82,12.63 13.59,13.22 13.29,13.78C14.21,13.46 15,12.83 15.46,12H14M7,17H17V19H7V17Z",
  },
  {
    id: "9B72D845-E704-489C-A447-D02306AF5228",
    name: "patreon",
    codepoint: "F881",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Contributors",
    version: "2.1.99",
    path: "M14.73,3C18.45,3 21.47,6.03 21.47,9.76C21.47,13.47 18.45,16.5 14.73,16.5C11,16.5 7.97,13.47 7.97,9.76C7.97,6.03 11,3 14.73,3M2.7,21V3H6V21H2.7Z",
  },
  {
    id: "2A1F0831-13CA-4419-BBD7-1F1FAF62A32B",
    name: "pause",
    codepoint: "F3E4",
    aliases: [],
    tags: ["Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M14,19H18V5H14M6,19H10V5H6V19Z",
  },
  {
    id: "7AA13CBC-D472-4462-8263-88DA2BDCD6BB",
    name: "pause-circle",
    codepoint: "F3E5",
    aliases: ["pause-circle-filled"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M15,16H13V8H15M11,16H9V8H11M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z",
  },
  {
    id: "6F271406-B475-45D0-9B37-EF3DBE7D0DAA",
    name: "pause-circle-outline",
    codepoint: "F3E6",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M13,16V8H15V16H13M9,16V8H11V16H9M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M12,4C7.58,4 4,7.58 4,12C4,16.42 7.58,20 12,20C16.42,20 20,16.42 20,12C20,7.58 16.42,4 12,4Z",
  },
  {
    id: "D0A95719-9B9F-4E86-A6E5-8013C1A6D4A7",
    name: "pause-octagon",
    codepoint: "F3E7",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M15.73,3L21,8.27V15.73L15.73,21H8.27L3,15.73V8.27L8.27,3H15.73M15,16V8H13V16H15M11,16V8H9V16H11Z",
  },
  {
    id: "95AA0ED2-4221-4123-B3BF-9FACF3702CA4",
    name: "pause-octagon-outline",
    codepoint: "F3E8",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M15,16H13V8H15V16M11,16H9V8H11V16M15.73,3L21,8.27V15.73L15.73,21H8.27L3,15.73V8.27L8.27,3H15.73M14.9,5H9.1L5,9.1V14.9L9.1,19H14.9L19,14.9V9.1L14.9,5Z",
  },
  {
    id: "802EBFA2-6D86-4E93-BEBF-7F69F6C98C01",
    name: "paw",
    codepoint: "F3E9",
    aliases: ["pets"],
    tags: ["Animal", "Nature"],
    author: "Cody",
    version: "1.5.54",
    path: "M8.35,3C9.53,2.83 10.78,4.12 11.14,5.9C11.5,7.67 10.85,9.25 9.67,9.43C8.5,9.61 7.24,8.32 6.87,6.54C6.5,4.77 7.17,3.19 8.35,3M15.5,3C16.69,3.19 17.35,4.77 17,6.54C16.62,8.32 15.37,9.61 14.19,9.43C13,9.25 12.35,7.67 12.72,5.9C13.08,4.12 14.33,2.83 15.5,3M3,7.6C4.14,7.11 5.69,8 6.5,9.55C7.26,11.13 7,12.79 5.87,13.28C4.74,13.77 3.2,12.89 2.41,11.32C1.62,9.75 1.9,8.08 3,7.6M21,7.6C22.1,8.08 22.38,9.75 21.59,11.32C20.8,12.89 19.26,13.77 18.13,13.28C17,12.79 16.74,11.13 17.5,9.55C18.31,8 19.86,7.11 21,7.6M19.33,18.38C19.37,19.32 18.65,20.36 17.79,20.75C16,21.57 13.88,19.87 11.89,19.87C9.9,19.87 7.76,21.64 6,20.75C5,20.26 4.31,18.96 4.44,17.88C4.62,16.39 6.41,15.59 7.47,14.5C8.88,13.09 9.88,10.44 11.89,10.44C13.89,10.44 14.95,13.05 16.3,14.5C17.41,15.72 19.26,16.75 19.33,18.38Z",
  },
  {
    id: "039D7C7E-AB09-4364-B08D-1FC120442AFE",
    name: "paw-off",
    codepoint: "F657",
    aliases: [],
    tags: ["Animal"],
    author: "Cody",
    version: "1.6.50",
    path: "M2,4.27L3.28,3L21.5,21.22L20.23,22.5L18.23,20.5C18.09,20.6 17.94,20.68 17.79,20.75C16,21.57 13.88,19.87 11.89,19.87C9.9,19.87 7.76,21.64 6,20.75C5,20.26 4.31,18.96 4.44,17.88C4.62,16.39 6.41,15.59 7.47,14.5C8.21,13.77 8.84,12.69 9.55,11.82L2,4.27M8.35,3C9.53,2.83 10.78,4.12 11.14,5.9C11.32,6.75 11.26,7.56 11,8.19L7.03,4.2C7.29,3.55 7.75,3.1 8.35,3M15.5,3C16.69,3.19 17.35,4.77 17,6.54C16.62,8.32 15.37,9.61 14.19,9.43C13,9.25 12.35,7.67 12.72,5.9C13.08,4.12 14.33,2.83 15.5,3M3,7.6C4.14,7.11 5.69,8 6.5,9.55C7.26,11.13 7,12.79 5.87,13.28C4.74,13.77 3.2,12.89 2.41,11.32C1.62,9.75 1.9,8.08 3,7.6M21,7.6C22.1,8.08 22.38,9.75 21.59,11.32C20.8,12.89 19.26,13.77 18.13,13.28C17,12.79 16.74,11.13 17.5,9.55C18.31,8 19.86,7.11 21,7.6Z",
  },
  {
    id: "7E574E80-7DB1-4722-9BC4-60F53509AACD",
    name: "peace",
    codepoint: "F883",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.1.99",
    path: "M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M11,14.41V19.93C9.58,19.75 8.23,19.19 7.1,18.31L11,14.41M13,14.41L16.9,18.31C15.77,19.19 14.42,19.75 13,19.93V14.41M4,12C4,7.97 7,4.57 11,4.07V11.59L5.69,16.9C4.59,15.5 4,13.78 4,12M18.31,16.9L13,11.59V4.07C17,4.57 20,7.97 20,12C20,13.78 19.41,15.5 18.31,16.9Z",
  },
  {
    id: "054B1710-EE28-4AA8-9D7E-705B5703E33E",
    name: "pen",
    codepoint: "F3EA",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M20.71,7.04C20.37,7.38 20.04,7.71 20.03,8.04C20,8.36 20.34,8.69 20.66,9C21.14,9.5 21.61,9.95 21.59,10.44C21.57,10.93 21.06,11.44 20.55,11.94L16.42,16.08L15,14.66L19.25,10.42L18.29,9.46L16.87,10.87L13.12,7.12L16.96,3.29C17.35,2.9 18,2.9 18.37,3.29L20.71,5.63C21.1,6 21.1,6.65 20.71,7.04M3,17.25L12.56,7.68L16.31,11.43L6.75,21H3V17.25Z",
  },
  {
    id: "BB27CE6C-769A-4C0C-A53C-F1B10B9C4423",
    name: "pencil",
    codepoint: "F3EB",
    aliases: ["edit", "create", "mode-edit"],
    tags: ["Drawing / Art", "Edit / Modify"],
    author: "Google",
    version: "1.5.54",
    path: "M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z",
  },
  {
    id: "56CC04F4-4E58-434D-962A-C824F5959D20",
    name: "pencil-box",
    codepoint: "F3EC",
    aliases: [],
    tags: ["Drawing / Art"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M19,3C20.1,3 21,3.9 21,5V19C21,20.11 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3H19M16.7,9.35C16.92,9.14 16.92,8.79 16.7,8.58L15.42,7.3C15.21,7.08 14.86,7.08 14.65,7.3L13.65,8.3L15.7,10.35L16.7,9.35M7,14.94V17H9.06L15.12,10.94L13.06,8.88L7,14.94Z",
  },
  {
    id: "48A9B269-08B8-4DCB-85F1-68F2334DC004",
    name: "pencil-box-outline",
    codepoint: "F3ED",
    aliases: [],
    tags: ["Drawing / Art"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M19,19V5H5V19H19M19,3C20.1,3 21,3.9 21,5V19C21,20.11 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3H19M16.7,9.35L15.7,10.35L13.65,8.3L14.65,7.3C14.86,7.08 15.21,7.08 15.42,7.3L16.7,8.58C16.92,8.79 16.92,9.14 16.7,9.35M7,14.94L13.06,8.88L15.12,10.94L9.06,17H7V14.94Z",
  },
  {
    id: "F5C5B903-7160-4B46-AC15-28C965289469",
    name: "pencil-circle",
    codepoint: "F6FE",
    aliases: [],
    tags: ["Drawing / Art"],
    author: "GreenTurtwig",
    version: "1.8.36",
    path: "M12,2C6.47,2 2,6.47 2,12C2,17.53 6.47,22 12,22C17.53,22 22,17.53 22,12C22,6.47 17.53,2 12,2M15.1,7.07C15.24,7.07 15.38,7.12 15.5,7.23L16.77,8.5C17,8.72 17,9.07 16.77,9.28L15.77,10.28L13.72,8.23L14.72,7.23C14.82,7.12 14.96,7.07 15.1,7.07M13.13,8.81L15.19,10.87L9.13,16.93H7.07V14.87L13.13,8.81Z",
  },
  {
    id: "5D68DE43-969F-40BE-8A2D-F5C25F2B0853",
    name: "pencil-circle-outline",
    codepoint: "F775",
    aliases: [],
    tags: ["Drawing / Art"],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M7,14.94L13.06,8.88L15.12,10.94L9.06,17H7V14.94M12,20C16.42,20 20,16.42 20,12C20,7.58 16.42,4 12,4C7.58,4 4,7.58 4,12C4,16.42 7.58,20 12,20M16.7,9.35L15.7,10.35L13.65,8.3L14.65,7.3C14.86,7.08 15.21,7.08 15.42,7.3L16.7,8.58C16.92,8.79 16.92,9.14 16.7,9.35M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2",
  },
  {
    id: "33BBFD25-1E97-49AA-BA9A-0B42369DF4A6",
    name: "pencil-lock",
    codepoint: "F3EE",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M5.5,2C4.12,2 3,3.12 3,4.5V5C2.45,5 2,5.45 2,6V10C2,10.55 2.45,11 3,11H8C8.55,11 9,10.55 9,10V6C9,5.45 8.55,5 8,5V4.5C8,3.12 6.88,2 5.5,2M5.5,3C6.33,3 7,3.67 7,4.5V5H4V4.5C4,3.67 4.67,3 5.5,3M19.66,3C19.4,3 19.16,3.09 18.97,3.28L17.13,5.13L20.88,8.88L22.72,7.03C23.11,6.64 23.11,6 22.72,5.63L20.38,3.28C20.18,3.09 19.91,3 19.66,3M16.06,6.19L5,17.25V21H8.75L19.81,9.94L16.06,6.19Z",
  },
  {
    id: "AEB0F9CD-B3FF-4F64-9D6E-4916D5C720C3",
    name: "pencil-off",
    codepoint: "F3EF",
    aliases: ["edit-off"],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M18.66,2C18.4,2 18.16,2.09 17.97,2.28L16.13,4.13L19.88,7.88L21.72,6.03C22.11,5.64 22.11,5 21.72,4.63L19.38,2.28C19.18,2.09 18.91,2 18.66,2M3.28,4L2,5.28L8.5,11.75L4,16.25V20H7.75L12.25,15.5L18.72,22L20,20.72L13.5,14.25L9.75,10.5L3.28,4M15.06,5.19L11.03,9.22L14.78,12.97L18.81,8.94L15.06,5.19Z",
  },
  {
    id: "A1E0EA60-79AF-42FD-966D-485276671F9C",
    name: "pentagon",
    codepoint: "F6FF",
    aliases: [],
    tags: ["Shape"],
    author: "Michael Irigoyen",
    version: "1.8.36",
    path: "M12,2.5L2,9.8L5.8,21.5H18.2L22,9.8L12,2.5Z",
  },
  {
    id: "7251D20A-5A23-456D-9A68-0107EF2BF01B",
    name: "pentagon-outline",
    codepoint: "F700",
    aliases: [],
    tags: ["Shape"],
    author: "Michael Irigoyen",
    version: "1.8.36",
    path: "M12,5L19.6,10.5L16.7,19.4H7.3L4.4,10.5L12,5M12,2.5L2,9.8L5.8,21.5H18.1L22,9.8L12,2.5Z",
  },
  {
    id: "3AB307BF-41D9-4CA4-9D44-58C82304C7BB",
    name: "percent",
    codepoint: "F3F0",
    aliases: [],
    tags: ["Math"],
    author: "Cody",
    version: "1.5.54",
    path: "M18.5,3.5L3.5,18.5L5.5,20.5L20.5,5.5M7,4C5.34,4 4,5.34 4,7C4,8.66 5.34,10 7,10C8.66,10 10,8.66 10,7C10,5.34 8.66,4 7,4M17,14C15.34,14 14,15.34 14,17C14,18.66 15.34,20 17,20C18.66,20 20,18.66 20,17C20,15.34 18.66,14 17,14Z",
  },
  {
    id: "1DB2BD6D-830D-4A4F-8E04-94D14901895A",
    name: "periodic-table",
    codepoint: "F8B5",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "2.2.43",
    path: "M2,4V6H4V4H2M20,4V6H22V4H20M2,7V9H4V7H2M5,7V9H7V7H5M14,7V9H16V7H14M17,7V9H19V7H17M20,7V9H22V7H20M2,10V12H4V10H2M5,10V12H7V10H5M8,10V12H10V10H8M11,10V12H13V10H11M14,10V12H16V10H14M17,10V12H19V10H17M20,10V12H22V10H20M2,13V15H4V13H2M5,13V15H7V13H5M8,13V15H10V13H8M11,13V15H13V13H11M14,13V15H16V13H14M17,13V15H19V13H17M20,13V15H22V13H20M5,17V19H7V17H5M8,17V19H10V17H8M11,17V19H13V17H11M14,17V19H16V17H14M17,17V19H19V17H17Z",
  },
  {
    id: "71BD315A-B0C1-4B8B-93CB-2A952C3A7C16",
    name: "pharmacy",
    codepoint: "F3F1",
    aliases: ["chemist", "local-pharmacy"],
    tags: ["Medical / Hospital"],
    author: "Google",
    version: "1.5.54",
    path: "M16,14H13V17H11V14H8V12H11V9H13V12H16M21,5H18.35L19.5,1.85L17.15,1L15.69,5H3V7L5,13L3,19V21H21V19L19,13L21,7V5Z",
  },
  {
    id: "B5BA809F-FCE8-476C-8388-6A9CFFF73015",
    name: "phone",
    codepoint: "F3F2",
    aliases: ["call", "local-phone", "telephone"],
    tags: ["Cellphone / Phone"],
    author: "Google",
    version: "1.5.54",
    path: "M6.62,10.79C8.06,13.62 10.38,15.94 13.21,17.38L15.41,15.18C15.69,14.9 16.08,14.82 16.43,14.93C17.55,15.3 18.75,15.5 20,15.5C20.55,15.5 21,15.95 21,16.5V20C21,20.55 20.55,21 20,21C10.61,21 3,13.39 3,4C3,3.45 3.45,3 4,3H7.5C8.05,3 8.5,3.45 8.5,4C8.5,5.25 8.7,6.45 9.07,7.57C9.18,7.92 9.1,8.31 8.82,8.59L6.62,10.79Z",
  },
  {
    id: "34F52268-8571-4501-93C1-D4BF606BB10E",
    name: "phone-bluetooth",
    codepoint: "F3F3",
    aliases: ["phone-bluetooth-speaker", "telephone-bluetooth"],
    tags: ["Cellphone / Phone"],
    author: "Google",
    version: "1.5.54",
    path: "M20,15.5C18.75,15.5 17.55,15.3 16.43,14.93C16.08,14.82 15.69,14.9 15.41,15.18L13.21,17.38C10.38,15.94 8.06,13.62 6.62,10.79L8.82,8.59C9.1,8.31 9.18,7.92 9.07,7.57C8.7,6.45 8.5,5.25 8.5,4C8.5,3.45 8.05,3 7.5,3H4C3.45,3 3,3.45 3,4C3,13.39 10.61,21 20,21C20.55,21 21,20.55 21,20V16.5C21,15.95 20.55,15.5 20,15.5M18,7.21L18.94,8.14L18,9.08M18,2.91L18.94,3.85L18,4.79M14.71,9.5L17,7.21V11H17.5L20.35,8.14L18.21,6L20.35,3.85L17.5,1H17V4.79L14.71,2.5L14,3.21L16.79,6L14,8.79L14.71,9.5Z",
  },
  {
    id: "A9ED94F7-0ADB-4CB3-AAF1-35B87D9B7724",
    name: "phone-classic",
    codepoint: "F602",
    aliases: [],
    tags: ["Cellphone / Phone"],
    author: "Cody",
    version: "1.5.54",
    path: "M12,3C7.46,3 3.34,4.78 0.29,7.67C0.11,7.85 0,8.1 0,8.38C0,8.66 0.11,8.91 0.29,9.09L2.77,11.57C2.95,11.75 3.2,11.86 3.5,11.86C3.75,11.86 4,11.75 4.18,11.58C4.97,10.84 5.87,10.22 6.84,9.73C7.17,9.57 7.4,9.23 7.4,8.83V5.73C8.85,5.25 10.39,5 12,5C13.59,5 15.14,5.25 16.59,5.72V8.82C16.59,9.21 16.82,9.56 17.15,9.72C18.13,10.21 19,10.84 19.82,11.57C20,11.75 20.25,11.85 20.5,11.85C20.8,11.85 21.05,11.74 21.23,11.56L23.71,9.08C23.89,8.9 24,8.65 24,8.37C24,8.09 23.88,7.85 23.7,7.67C20.65,4.78 16.53,3 12,3M9,7V10C9,10 3,15 3,18V22H21V18C21,15 15,10 15,10V7H13V9H11V7H9M12,12C14.21,12 16,13.79 16,16C16,18.21 14.21,20 12,20C9.79,20 8,18.21 8,16C8,13.79 9.79,12 12,12M12,13.5C10.62,13.5 9.5,14.62 9.5,16C9.5,17.38 10.62,18.5 12,18.5C13.38,18.5 14.5,17.38 14.5,16C14.5,14.62 13.38,13.5 12,13.5Z",
  },
  {
    id: "5EF77B27-31D7-47F8-8D72-8BC040CD154E",
    name: "phone-forward",
    codepoint: "F3F4",
    aliases: ["phone-forwarded", "telephone-forward"],
    tags: ["Cellphone / Phone"],
    author: "Google",
    version: "1.5.54",
    path: "M20,15.5C18.75,15.5 17.55,15.3 16.43,14.93C16.08,14.82 15.69,14.9 15.41,15.18L13.21,17.38C10.38,15.94 8.06,13.62 6.62,10.79L8.82,8.59C9.1,8.31 9.18,7.92 9.07,7.57C8.7,6.45 8.5,5.25 8.5,4C8.5,3.45 8.05,3 7.5,3H4C3.45,3 3,3.45 3,4C3,13.39 10.61,21 20,21C20.55,21 21,20.55 21,20V16.5C21,15.95 20.55,15.5 20,15.5M18,11L23,6L18,1V4H14V8H18V11Z",
  },
  {
    id: "2018B4C8-A296-4D62-A30A-85F988B206EA",
    name: "phone-hangup",
    codepoint: "F3F5",
    aliases: ["call-end", "telephone-hangup"],
    tags: ["Cellphone / Phone"],
    author: "Google",
    version: "1.5.54",
    path: "M12,9C10.4,9 8.85,9.25 7.4,9.72V12.82C7.4,13.22 7.17,13.56 6.84,13.72C5.86,14.21 4.97,14.84 4.17,15.57C4,15.75 3.75,15.86 3.5,15.86C3.2,15.86 2.95,15.74 2.77,15.56L0.29,13.08C0.11,12.9 0,12.65 0,12.38C0,12.1 0.11,11.85 0.29,11.67C3.34,8.77 7.46,7 12,7C16.54,7 20.66,8.77 23.71,11.67C23.89,11.85 24,12.1 24,12.38C24,12.65 23.89,12.9 23.71,13.08L21.23,15.56C21.05,15.74 20.8,15.86 20.5,15.86C20.25,15.86 20,15.75 19.82,15.57C19.03,14.84 18.14,14.21 17.16,13.72C16.83,13.56 16.6,13.22 16.6,12.82V9.72C15.15,9.25 13.6,9 12,9Z",
  },
  {
    id: "F9BA7066-C1F8-4B19-9860-37BDCEB6F11C",
    name: "phone-in-talk",
    codepoint: "F3F6",
    aliases: ["telephone-in-talk"],
    tags: ["Cellphone / Phone"],
    author: "Google",
    version: "1.5.54",
    path: "M15,12H17C17,9.24 14.76,7 12,7V9C13.66,9 15,10.34 15,12M19,12H21C21,7 16.97,3 12,3V5C15.86,5 19,8.13 19,12M20,15.5C18.75,15.5 17.55,15.3 16.43,14.93C16.08,14.82 15.69,14.9 15.41,15.18L13.21,17.38C10.38,15.94 8.06,13.62 6.62,10.79L8.82,8.59C9.1,8.31 9.18,7.92 9.07,7.57C8.7,6.45 8.5,5.25 8.5,4C8.5,3.45 8.05,3 7.5,3H4C3.45,3 3,3.45 3,4C3,13.39 10.61,21 20,21C20.55,21 21,20.55 21,20V16.5C21,15.95 20.55,15.5 20,15.5Z",
  },
  {
    id: "AA8EEDF8-EB34-46C5-8117-9258E1349197",
    name: "phone-incoming",
    codepoint: "F3F7",
    aliases: ["telephone-incoming"],
    tags: ["Cellphone / Phone"],
    author: "Cody",
    version: "1.5.54",
    path: "M4,3C3.45,3 3,3.45 3,4C3,13.39 10.61,21 20,21C20.55,21 21,20.55 21,20V16.5C21,15.95 20.55,15.5 20,15.5C18.75,15.5 17.55,15.3 16.43,14.93C16.08,14.82 15.69,14.9 15.41,15.17L13.21,17.37C10.38,15.93 8.06,13.62 6.62,10.78L8.82,8.57C9.1,8.31 9.18,7.92 9.07,7.57C8.7,6.45 8.5,5.25 8.5,4C8.5,3.45 8.05,3 7.5,3H4M19,11V9.5H15.5L21,4L20,3L14.5,8.5V5H13V11H19Z",
  },
  {
    id: "B87821E3-2131-4C50-BB88-880BE6D0066F",
    name: "phone-log",
    codepoint: "F3F9",
    aliases: [],
    tags: ["Cellphone / Phone"],
    author: "Cody",
    version: "1.5.54",
    path: "M20,15.5C20.55,15.5 21,15.95 21,16.5V20C21,20.55 20.55,21 20,21C10.61,21 3,13.39 3,4C3,3.45 3.45,3 4,3H7.5C8.05,3 8.5,3.45 8.5,4C8.5,5.24 8.7,6.45 9.07,7.57C9.18,7.92 9.1,8.31 8.82,8.58L6.62,10.79C8.06,13.62 10.38,15.94 13.21,17.38L15.41,15.18C15.69,14.9 16.08,14.82 16.43,14.93C17.55,15.3 18.75,15.5 20,15.5M12,3H14V5H12M15,3H21V5H15M12,6H14V8H12M15,6H21V8H15M12,9H14V11H12M15,9H21V11H15",
  },
  {
    id: "7F431DF5-245C-4572-962C-CC57177BD8D0",
    name: "phone-minus",
    codepoint: "F658",
    aliases: [],
    tags: ["Cellphone / Phone"],
    author: "Google",
    version: "1.6.50",
    path: "M4,3C3.45,3 3,3.45 3,4C3,13.39 10.61,21 20,21C20.55,21 21,20.55 21,20V16.5C21,15.95 20.55,15.5 20,15.5C18.76,15.5 17.55,15.3 16.43,14.93C16.08,14.82 15.69,14.9 15.41,15.18L13.21,17.38C10.38,15.94 8.07,13.62 6.62,10.79L8.82,8.58C9.1,8.31 9.18,7.92 9.07,7.57C8.7,6.45 8.5,5.24 8.5,4C8.5,3.45 8.05,3 7.5,3M13,6V8H21V6",
  },
  {
    id: "BF6662C4-D1D0-42E6-8C0A-B071F12975F2",
    name: "phone-missed",
    codepoint: "F3FA",
    aliases: [],
    tags: ["Cellphone / Phone"],
    author: "Google",
    version: "1.5.54",
    path: "M23.71,16.67C20.66,13.77 16.54,12 12,12C7.46,12 3.34,13.77 0.29,16.67C0.11,16.85 0,17.1 0,17.38C0,17.65 0.11,17.9 0.29,18.08L2.77,20.56C2.95,20.74 3.2,20.86 3.5,20.86C3.75,20.86 4,20.75 4.18,20.57C4.97,19.83 5.86,19.21 6.84,18.72C7.17,18.56 7.4,18.22 7.4,17.82V14.72C8.85,14.25 10.39,14 12,14C13.6,14 15.15,14.25 16.6,14.72V17.82C16.6,18.22 16.83,18.56 17.16,18.72C18.14,19.21 19.03,19.83 19.82,20.57C20,20.75 20.25,20.86 20.5,20.86C20.8,20.86 21.05,20.74 21.23,20.56L23.71,18.08C23.89,17.9 24,17.65 24,17.38C24,17.1 23.89,16.85 23.71,16.67M6.5,5.5L12,11L19,4L18,3L12,9L7.5,4.5H11V3H5V9H6.5V5.5Z",
  },
  {
    id: "52280181-270B-4624-97FE-F46126C65BE7",
    name: "phone-outgoing",
    codepoint: "F3FB",
    aliases: [],
    tags: ["Cellphone / Phone"],
    author: "Cody",
    version: "1.5.54",
    path: "M4,3C3.45,3 3,3.45 3,4C3,13.39 10.61,21 20,21C20.55,21 21,20.55 21,20V16.5C21,15.95 20.55,15.5 20,15.5C18.75,15.5 17.55,15.3 16.43,14.93C16.08,14.82 15.69,14.9 15.41,15.17L13.21,17.37C10.38,15.93 8.06,13.62 6.62,10.78L8.82,8.57C9.1,8.31 9.18,7.92 9.07,7.57C8.7,6.45 8.5,5.25 8.5,4C8.5,3.45 8.05,3 7.5,3H4M15,3V4.5H18.5L13,10L14,11L19.5,5.5V9H21V3H15Z",
  },
  {
    id: "1ABFB2C1-72CB-46C7-8E8B-B8A24C0285EA",
    name: "phone-paused",
    codepoint: "F3FC",
    aliases: [],
    tags: ["Cellphone / Phone"],
    author: "Google",
    version: "1.5.54",
    path: "M19,10H21V3H19M20,15.5C18.75,15.5 17.55,15.3 16.43,14.93C16.08,14.82 15.69,14.9 15.41,15.18L13.21,17.38C10.38,15.94 8.06,13.62 6.62,10.79L8.82,8.59C9.1,8.31 9.18,7.92 9.07,7.57C8.7,6.45 8.5,5.25 8.5,4C8.5,3.45 8.05,3 7.5,3H4C3.45,3 3,3.45 3,4C3,13.39 10.61,21 20,21C20.55,21 21,20.55 21,20V16.5C21,15.95 20.55,15.5 20,15.5M17,3H15V10H17V3Z",
  },
  {
    id: "E58A5CD8-2D42-4A3A-BCC2-70870B43752C",
    name: "phone-plus",
    codepoint: "F659",
    aliases: ["add-call"],
    tags: ["Cellphone / Phone"],
    author: "Google",
    version: "1.6.50",
    path: "M4,3C3.45,3 3,3.45 3,4C3,13.39 10.61,21 20,21C20.55,21 21,20.55 21,20V16.5C21,15.95 20.55,15.5 20,15.5C18.76,15.5 17.55,15.3 16.43,14.93C16.08,14.82 15.69,14.9 15.41,15.18L13.21,17.38C10.38,15.94 8.07,13.62 6.62,10.79L8.82,8.58C9.1,8.31 9.18,7.92 9.07,7.57C8.7,6.45 8.5,5.24 8.5,4C8.5,3.45 8.05,3 7.5,3M16,3V6H13V8H16V11H18V8H21V6H18V3",
  },
  {
    id: "B0FC2BB4-6C44-42CA-8F90-52CBCD0F1AD4",
    name: "phone-return",
    codepoint: "F82E",
    aliases: [],
    tags: ["Cellphone / Phone"],
    author: "Michael Richins",
    version: "2.1.19",
    path: "M21,6V11H19.5V7.5H13.87L16.3,9.93L15.24,11L11,6.75L15.24,2.5L16.3,3.57L13.87,6H21M8.82,8.58C9.08,8.32 9.17,7.93 9.06,7.58C8.69,6.42 8.5,5.22 8.5,4C8.5,3.45 8.05,3 7.5,3H4C3.45,3 3,3.45 3,4C3,13.39 10.61,21 20,21C20.55,21 21,20.55 21,20V16.5C21,15.95 20.55,15.5 20,15.5C18.79,15.5 17.58,15.31 16.43,14.93C16.08,14.82 15.69,14.91 15.43,15.17L13.23,17.37C10.39,15.92 8.09,13.62 6.64,10.78L8.82,8.58Z",
  },
  {
    id: "48667BD8-2891-45D0-92E9-F4FF292527A4",
    name: "phone-rotate-landscape",
    codepoint: "F884",
    aliases: [],
    tags: ["Cellphone / Phone"],
    author: "Michael Richins",
    version: "2.1.99",
    path: "M9,1H3C1.9,1 1,1.9 1,3V16C1,17.1 1.9,18 3,18H9C10.1,18 11,17.1 11,16V3C11,1.9 10.1,1 9,1M9,15H3V3H9V15M21,13H13V15H21V21H9V20H6V21C6,22.1 6.9,23 8,23H21C22.1,23 23,22.1 23,21V15C23,13.9 22.1,13 21,13M23,10L19,8L20.91,7.09C19.74,4.31 17,2.5 14,2.5V1C18.97,1 23,5.03 23,10Z",
  },
  {
    id: "B839A0B6-9E89-40C2-811F-2253514267C9",
    name: "phone-rotate-portrait",
    codepoint: "F885",
    aliases: [],
    tags: ["Cellphone / Phone"],
    author: "Michael Richins",
    version: "2.1.99",
    path: "M9,1H3C1.9,1 1,1.9 1,3V16C1,17.1 1.9,18 3,18H4V15H3V3H9V11H11V3C11,1.9 10.1,1 9,1M23,21V15C23,13.9 22.1,13 21,13H8C6.9,13 6,13.9 6,15V21C6,22.1 6.9,23 8,23H21C22.1,23 23,22.1 23,21M9,21V15H21V21H9M23,10H21.5C21.5,7 19.69,4.27 16.92,3.09L16,5L14,1C18.97,1 23,5.03 23,10Z",
  },
  {
    id: "C9E81E97-C4DA-4612-AC4D-0F81C7986CD8",
    name: "phone-settings",
    codepoint: "F3FD",
    aliases: ["settings-phone"],
    tags: ["Settings", "Cellphone / Phone"],
    author: "Google",
    version: "1.5.54",
    path: "M19,11H21V9H19M20,15.5C18.75,15.5 17.55,15.3 16.43,14.93C16.08,14.82 15.69,14.9 15.41,15.18L13.21,17.38C10.38,15.94 8.06,13.62 6.62,10.79L8.82,8.59C9.1,8.31 9.18,7.92 9.07,7.57C8.7,6.45 8.5,5.25 8.5,4C8.5,3.45 8.05,3 7.5,3H4C3.45,3 3,3.45 3,4C3,13.39 10.61,21 20,21C20.55,21 21,20.55 21,20V16.5C21,15.95 20.55,15.5 20,15.5M17,9H15V11H17M13,9H11V11H13V9Z",
  },
  {
    id: "43DAD9DC-C484-452A-9450-1F9C83C6B50E",
    name: "phone-voip",
    codepoint: "F3FE",
    aliases: [],
    tags: ["Cellphone / Phone"],
    author: "Cody",
    version: "1.5.54",
    path: "M13,17V19H14C14.55,19 15,19.45 15,20H22V22H15C15,22.55 14.55,23 14,23H10C9.45,23 9,22.55 9,22H2V20H9C9,19.45 9.45,19 10,19H11V17H13M23.7,7.67C23.88,7.85 24,8.09 24,8.37C24,8.65 23.89,8.9 23.71,9.08L21.23,11.56C21.05,11.74 20.8,11.85 20.5,11.85C20.25,11.85 20,11.75 19.82,11.57C19,10.84 18.13,10.21 17.15,9.72C16.82,9.56 16.59,9.21 16.59,8.82V5.72C15.14,5.25 13.59,5 12,5C10.4,5 8.85,5.25 7.4,5.73V8.83C7.4,9.23 7.17,9.57 6.84,9.73C5.87,10.22 4.97,10.84 4.18,11.58C4,11.75 3.75,11.86 3.5,11.86C3.2,11.86 2.95,11.75 2.77,11.57L0.29,9.09C0.11,8.91 0,8.66 0,8.38C0,8.1 0.11,7.85 0.29,7.67C3.34,4.78 7.46,3 12,3C16.53,3 20.65,4.78 23.7,7.67M11,10V15H10V10H11M12,10H15V13H13V15H12V10M14,12V11H13V12H14Z",
  },
  {
    id: "0E3F11DA-8458-4A89-BB7B-D3A6972D3E30",
    name: "pi",
    codepoint: "F3FF",
    aliases: [],
    tags: ["Math"],
    author: "Cody",
    version: "1.5.54",
    path: "M4,5V7H6V19H8V7H14V16C14,17.66 15.34,19 17,19C18.66,19 20,17.66 20,16H18C18,16.55 17.55,17 17,17C16.45,17 16,16.55 16,16V7H18V5",
  },
  {
    id: "7C14B1F3-D836-42D6-AC5F-9FD31ADEBFFD",
    name: "pi-box",
    codepoint: "F400",
    aliases: [],
    tags: ["Math"],
    author: "Cody",
    version: "1.5.54",
    path: "M5,3C3.89,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3M6,7H17V9H15V14C15,14.55 15.45,15 16,15C16.55,15 17,14.55 17,14H19C19,15.66 17.66,17 16,17C14.34,17 13,15.66 13,14V9H10V17H8V9H6",
  },
  {
    id: "E7651219-1BF9-4D06-9B4A-7599A2E0A407",
    name: "piano",
    codepoint: "F67C",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.7.12",
    path: "M4,3H20C21.1,3 22,3.9 22,5V19C22,20.1 21.1,21 20,21H4C2.9,21 2,20.1 2,19V5C2,3.9 2.9,3 4,3M4,5V19H8V13H6.75V5H4M9,19H15V13H13.75V5H10.25V13H9V19M16,19H20V5H17.25V13H16V19Z",
  },
  {
    id: "A4DE211E-02E2-4514-9059-17AEFADA22F7",
    name: "pickaxe",
    codepoint: "F8B6",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.2.43",
    path: "M14.79,10.62L3.5,21.9L2.1,20.5L13.38,9.21L14.79,10.62M19.27,7.73L19.86,7.14L19.07,6.35L19.71,5.71L18.29,4.29L17.65,4.93L16.86,4.14L16.27,4.73C14.53,3.31 12.57,2.17 10.47,1.37L9.64,3.16C11.39,4.08 13,5.19 14.5,6.5L14,7L17,10L17.5,9.5C18.81,11 19.92,12.61 20.84,14.36L22.63,13.53C21.83,11.43 20.69,9.47 19.27,7.73Z",
  },
  {
    id: "68AE7D9F-95E4-4AAC-B39F-748FD8677ACF",
    name: "pier",
    codepoint: "F886",
    aliases: [],
    tags: ["Places"],
    author: "Michael Irigoyen",
    version: "2.1.99",
    path: "M20,18C18.6,18 17.2,17.5 16,16.7C13.6,18.4 10.4,18.4 8,16.7C6.8,17.5 5.4,18 4,18H2V20H4C5.4,20 6.7,19.6 8,19C10.5,20.3 13.5,20.3 16,19C17.3,19.6 18.6,20 20,20H22V18H20M20,13H19V16.9C18.3,16.8 17.6,16.6 17,16.2V13H12V17C11.3,17 10.7,16.9 10,16.7V13H5V16.9C4.7,17 4.3,17 4,17H3V13H2V11H3V9H5V11H10V9H12V11H17V9H19V11H20V13Z",
  },
  {
    id: "547D5950-A129-411D-92AF-B8477D21230D",
    name: "pier-crane",
    codepoint: "F887",
    aliases: [],
    tags: [],
    author: "Michael Irigoyen",
    version: "2.1.99",
    path: "M20,20C18.61,20 17.22,19.53 16,18.67C13.56,20.38 10.44,20.38 8,18.67C6.78,19.53 5.39,20 4,20H2V22H4C5.37,22 6.74,21.65 8,21C10.5,22.3 13.5,22.3 16,21C17.26,21.65 18.62,22 20,22H22V20H20M20,4V3C20,2.45 19.55,2 19,2H9V1H6V2H5V4H6V13H5V11H3V13H2V15H3V19H4C4.33,19 4.67,18.97 5,18.92V15H10V18.65C10.65,18.85 11.33,18.95 12,18.95V18.92L12,15H13V13H12V11H10V13H9V4H17V8.62C16.53,8.79 16.19,9.23 16.19,9.76C16.19,10.2 16.43,10.6 16.8,10.82V12H17.42C17.76,12 18.03,12.28 18.03,12.62C18.03,12.96 17.76,13.24 17.42,13.24C17.2,13.24 17,13.12 16.88,12.93C16.71,12.64 16.34,12.54 16.05,12.71C15.75,12.87 15.65,13.25 15.82,13.55C16.15,14.11 16.76,14.47 17.42,14.47C18.43,14.47 19.26,13.64 19.26,12.62C19.26,11.84 18.76,11.14 18.03,10.88V10.82C18.41,10.6 18.65,10.2 18.65,9.76C18.65,9.3 18.38,8.91 18,8.7V4H20M8,11.66L7,12.66V11.24L8,10.24V11.66M8,8.71L7,9.71V8.29L8,7.29V8.71M7,6.71V5.29L8,4.29V5.71L7,6.71Z",
  },
  {
    id: "5E4A3F96-7779-44C8-86EF-948EDBD53C20",
    name: "pig",
    codepoint: "F401",
    aliases: [],
    tags: ["Animal", "Agriculture"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M9.5,9C8.67,9 8,9.67 8,10.5C8,11.33 8.67,12 9.5,12C10.33,12 11,11.33 11,10.5C11,9.67 10.33,9 9.5,9M14.5,9C13.67,9 13,9.67 13,10.5C13,11.33 13.67,12 14.5,12C15.33,12 16,11.33 16,10.5C16,9.67 15.33,9 14.5,9M12,4L12.68,4.03C13.62,3.24 14.82,2.59 15.72,2.35C17.59,1.85 20.88,2.23 21.31,3.83C21.62,5 20.6,6.45 19.03,7.38C20.26,8.92 21,10.87 21,13C21,17.97 16.97,22 12,22C7.03,22 3,17.97 3,13C3,10.87 3.74,8.92 4.97,7.38C3.4,6.45 2.38,5 2.69,3.83C3.12,2.23 6.41,1.85 8.28,2.35C9.18,2.59 10.38,3.24 11.32,4.03L12,4M10,16C10.55,16 11,16.45 11,17C11,17.55 10.55,18 10,18C9.45,18 9,17.55 9,17C9,16.45 9.45,16 10,16M14,16C14.55,16 15,16.45 15,17C15,17.55 14.55,18 14,18C13.45,18 13,17.55 13,17C13,16.45 13.45,16 14,16M12,13C9.24,13 7,15.34 7,17C7,18.66 9.24,20 12,20C14.76,20 17,18.66 17,17C17,15.34 14.76,13 12,13M7.76,4.28C7.31,4.16 4.59,4.35 4.59,4.35C4.59,4.35 6.8,6.1 7.24,6.22C7.69,6.34 9.77,6.43 9.91,5.9C10.06,5.36 8.2,4.4 7.76,4.28M16.24,4.28C15.8,4.4 13.94,5.36 14.09,5.9C14.23,6.43 16.31,6.34 16.76,6.22C17.2,6.1 19.41,4.35 19.41,4.35C19.41,4.35 16.69,4.16 16.24,4.28Z",
  },
  {
    id: "6487E4ED-C501-416C-9DCE-1B7C1F676050",
    name: "pill",
    codepoint: "F402",
    aliases: ["medicine", "capsule"],
    tags: ["Medical / Hospital"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M4.22,11.29L11.29,4.22C13.64,1.88 17.43,1.88 19.78,4.22C22.12,6.56 22.12,10.36 19.78,12.71L12.71,19.78C10.36,22.12 6.56,22.12 4.22,19.78C1.88,17.43 1.88,13.64 4.22,11.29M5.64,12.71C4.59,13.75 4.24,15.24 4.6,16.57L10.59,10.59L14.83,14.83L18.36,11.29C19.93,9.73 19.93,7.2 18.36,5.64C16.8,4.07 14.27,4.07 12.71,5.64L5.64,12.71Z",
  },
  {
    id: "AD451D24-BA4B-466E-8146-D3FBBDA6E275",
    name: "pillar",
    codepoint: "F701",
    aliases: ["historic", "column"],
    tags: [],
    author: "GreenTurtwig",
    version: "1.8.36",
    path: "M6,5H18C18.55,5 19,5.45 19,6C19,6.55 18.55,7 18,7H6C5.45,7 5,6.55 5,6C5,5.45 5.45,5 6,5M21,2V4H3V2H21M15,8H17V22H15V8M7,8H9V22H7V8M11,8H13V22H11V8Z",
  },
  {
    id: "B1337135-0E57-465F-8C0C-E658C9981A19",
    name: "pin",
    codepoint: "F403",
    aliases: ["keep"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M16,12V4H17V2H7V4H8V12L6,14V16H11.2V22H12.8V16H18V14L16,12Z",
  },
  {
    id: "8C59FE68-D89C-4A86-8E01-5C8109D1B028",
    name: "pin-off",
    codepoint: "F404",
    aliases: ["keep-off"],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M2,5.27L3.28,4L20,20.72L18.73,22L12.8,16.07V22H11.2V16H6V14L8,12V11.27L2,5.27M16,12L18,14V16H17.82L8,6.18V4H7V2H17V4H16V12Z",
  },
  {
    id: "0ED785A3-7387-4989-BF3A-11F2F53C81B5",
    name: "pin-off-outline",
    codepoint: "F92F",
    aliases: ["keep-off-outline"],
    tags: [],
    author: "Contributors",
    version: "2.3.54",
    path: "M8,6.2V4H7V2H17V4H16V12L18,14V16H17.8L14,12.2V4H10V8.2L8,6.2M20,20.7L18.7,22L12.8,16.1V22H11.2V16H6V14L8,12V11.3L2,5.3L3.3,4L20,20.7M8.8,14H10.6L9.7,13.1L8.8,14Z",
  },
  {
    id: "BF736212-EE8D-49D0-8C8B-63A463488E88",
    name: "pin-outline",
    codepoint: "F930",
    aliases: ["keep-outline"],
    tags: [],
    author: "Google",
    version: "2.3.54",
    path: "M16,12V4H17V2H7V4H8V12L6,14V16H11.2V22H12.8V16H18V14L16,12M8.8,14L10,12.8V4H14V12.8L15.2,14H8.8Z",
  },
  {
    id: "F053196C-66BC-4D0D-B75F-24773CA618E5",
    name: "pine-tree",
    codepoint: "F405",
    aliases: [],
    tags: ["Holiday", "Nature"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M10,21V18H3L8,13H5L10,8H7L12,3L17,8H14L19,13H16L21,18H14V21H10Z",
  },
  {
    id: "A8F37CBB-10AA-42DE-9CD6-BDCE10C2AF8C",
    name: "pine-tree-box",
    codepoint: "F406",
    aliases: [],
    tags: ["Holiday", "Nature"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M4,2H20C21.1,2 22,2.9 22,4V20C22,21.1 21.1,22 20,22H4C2.9,22 2,21.1 2,20V4C2,2.9 2.9,2 4,2M11,19H13V17H18L14,13H17L13,9H16L12,5L8,9H11L7,13H10L6,17H11V19Z",
  },
  {
    id: "6BAC7A7E-340B-474D-8448-2DEC0FE66146",
    name: "pinterest",
    codepoint: "F407",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M9.04,21.54C10,21.83 10.97,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2C6.48,2 2,6.48 2,12C2,16.25 4.67,19.9 8.44,21.34C8.35,20.56 8.26,19.27 8.44,18.38L9.59,13.44C9.59,13.44 9.3,12.86 9.3,11.94C9.3,10.56 10.16,9.53 11.14,9.53C12,9.53 12.4,10.16 12.4,10.97C12.4,11.83 11.83,13.06 11.54,14.24C11.37,15.22 12.06,16.08 13.06,16.08C14.84,16.08 16.22,14.18 16.22,11.5C16.22,9.1 14.5,7.46 12.03,7.46C9.21,7.46 7.55,9.56 7.55,11.77C7.55,12.63 7.83,13.5 8.29,14.07C8.38,14.13 8.38,14.21 8.35,14.36L8.06,15.45C8.06,15.62 7.95,15.68 7.78,15.56C6.5,15 5.76,13.18 5.76,11.71C5.76,8.55 8,5.68 12.32,5.68C15.76,5.68 18.44,8.15 18.44,11.43C18.44,14.87 16.31,17.63 13.26,17.63C12.29,17.63 11.34,17.11 11,16.5L10.33,18.87C10.1,19.73 9.47,20.88 9.04,21.57V21.54Z",
  },
  {
    id: "840AF950-F514-452B-AD1F-18EC878CB1F8",
    name: "pipe",
    codepoint: "F7E4",
    aliases: [],
    tags: ["Home Automation"],
    author: "Michael Richins",
    version: "2.0.46",
    path: "M22,14H20V16H14V13H16V11H14V6C14,4.9 13.1,4 12,4H4V2H2V10H4V8H10V11H8V13H10V18C10,19.1 10.9,20 12,20H20V22H22",
  },
  {
    id: "01D59BE4-7863-471D-840D-8C810F934344",
    name: "pipe-disconnected",
    codepoint: "F7E5",
    aliases: [],
    tags: ["Home Automation"],
    author: "Michael Richins",
    version: "2.0.46",
    path: "M16,9V11H8V9H10V8H4V10H2V2H4V4H12C13.1,4 14,4.9 14,6V9H16M10,15V18C10,19.1 10.9,20 12,20H20V22H22V14H20V16H14V15H16V13H8V15H10Z",
  },
  {
    id: "A39D910A-D5C9-4A9D-86CF-F61A60486758",
    name: "pipe-leak",
    codepoint: "F888",
    aliases: [],
    tags: ["Home Automation"],
    author: "GreenTurtwig",
    version: "2.1.99",
    path: "M2,5V13H4V11H10L12,9L10,7H4V5H2M20,5V7H12L14,9L12,11H20V13H22V5H20M12,13C12,13 10,15.17 10,16.5C10,17.6 10.9,18.5 12,18.5C13.1,18.5 14,17.6 14,16.5C14,15.17 12,13 12,13Z",
  },
  {
    id: "5CDFFABD-F3B4-4E4D-97A3-F8B1AE403809",
    name: "pirate",
    codepoint: "FA07",
    aliases: [],
    tags: [],
    author: "Michael Irigoyen",
    version: "2.5.94",
    path: "M8.2,12.1C7.9,12.3 7.7,12.7 7.8,13C7.8,13.7 8.5,14.2 9.1,14.2C9.7,14.2 10.3,13.7 10.3,13C9.7,12.6 9,12.3 8.2,12.1M22,11L23,7C23,7 21,7 18,5C15,3 15,1 12,1C9,1 9,3 6,5C3,7 1,7 1,7L2,11H2.1C2,11.3 2,11.7 2,12C2,15.5 3.8,18.6 6.5,20.4L6,21.3C12.4,25.4 18,21.3 18,21.3L17.5,20.4C20.2,18.6 22,15.5 22,12C22,11.7 22,11.3 22,11M11.3,4.5L9.9,3.1L10.6,2.4L12,3.8L13.4,2.4L14.1,3.1L12.7,4.5L14.1,5.9L13.4,6.6L12,5.2L10.6,6.6L9.9,5.9L11.3,4.5M9.3,8.5C10.3,8.2 11.3,8 12,8C14.2,8 17.9,9.6 19.8,10.4C19.9,10.7 19.9,11 19.9,11.3L9.3,8.5M13.6,19.1C12.9,19.5 12.2,19.8 11.4,19.9C10.9,19.5 10.9,18.7 11.4,18.3C11.8,17.9 12.7,17.7 13.2,18.2C13.5,18.3 13.6,18.8 13.6,19.1M20,13.4C19.5,15.5 18.2,17.4 16.5,18.6L15,16H9L7.5,18.6C5.4,17.2 4,14.8 4,12C4,11.5 4.1,11 4.2,10.5C4.7,10.3 5.3,10 6,9.7L13.1,11.6V14C13.1,14.5 13.5,15 14.1,15H16.1C16.6,15 17.1,14.6 17.1,14V12.6L20,13.4Z",
  },
  {
    id: "34C9947D-5943-4C3E-9E7A-2CD95061222B",
    name: "pistol",
    codepoint: "F702",
    aliases: ["gun"],
    tags: [],
    author: "Michael Richins",
    version: "1.8.36",
    path: "M7,5H23V9H22V10H16C15.45,10 15,10.45 15,11V12C15,13.1 14.1,14 13,14H9.62C9.24,14 8.89,14.22 8.72,14.56L6.27,19.45C6.1,19.79 5.76,20 5.38,20H2C2,20 -1,20 3,14C3,14 6,10 2,10V5H3L3.5,4H6.5L7,5M14,12V11C14,10.45 13.55,10 13,10H12C12,10 11,11 12,12C10.9,12 10,11.1 10,10C9.45,10 9,10.45 9,11V12C9,12.55 9.45,13 10,13H13C13.55,13 14,12.55 14,12Z",
  },
  {
    id: "212476A4-B98A-4A84-BE27-37F28847A7D2",
    name: "piston",
    codepoint: "F889",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.1.99",
    path: "M13,16.18C13.5,16.35 13.9,16.63 14.23,17H15V21H14.21C13.89,21.35 13.5,21.63 13,21.8C11.85,22.22 10.58,21.87 9.78,21H9V17H9.77C10.1,16.63 10.5,16.35 11,16.18V12H13V16.18M12,20C12.55,20 13,19.55 13,19C13,18.45 12.55,18 12,18C11.45,18 11,18.45 11,19C11,19.55 11.45,20 12,20M17,4H15V5H17V11H7V5H9V4H7V2H17V4M12,9C12.55,9 13,8.55 13,8C13,7.45 12.55,7 12,7C11.45,7 11,7.45 11,8C11,8.55 11.45,9 12,9Z",
  },
  {
    id: "E617E8BD-2C63-4E59-B1F4-EB3F9F3916D3",
    name: "pizza",
    codepoint: "F409",
    aliases: ["pizzeria", "local-pizza"],
    tags: ["Food / Drink", "Places"],
    author: "Google",
    version: "1.5.54",
    path: "M12,15C10.9,15 10,14.1 10,13C10,11.89 10.9,11 12,11C13.1,11 14,11.9 14,13C14,14.1 13.1,15 12,15M7,7C7,5.89 7.89,5 9,5C10.1,5 11,5.9 11,7C11,8.1 10.1,9 9,9C7.89,9 7,8.1 7,7M12,2C8.43,2 5.23,3.54 3,6L12,22L21,6C18.78,3.54 15.57,2 12,2Z",
  },
  {
    id: "90AD6D2A-7986-49D0-8DA5-DC92F9F92A15",
    name: "play",
    codepoint: "F40A",
    aliases: ["play-arrow"],
    tags: ["Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M8,5.14V19.14L19,12.14L8,5.14Z",
  },
  {
    id: "D0431F42-A1C2-409B-9D44-2EDDEF3F9AB3",
    name: "play-box-outline",
    codepoint: "F40B",
    aliases: ["slideshow"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M19,19H5V5H19M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3M10,8V16L15,12L10,8Z",
  },
  {
    id: "79F68E60-010F-4A8E-8E30-06CB64A5DBF6",
    name: "play-circle",
    codepoint: "F40C",
    aliases: ["play-circle-filled"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M10,16.5V7.5L16,12M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z",
  },
  {
    id: "E0C875C2-16F3-4C92-BABF-DAB2D08258DC",
    name: "play-circle-outline",
    codepoint: "F40D",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M10,16.5L16,12L10,7.5V16.5Z",
  },
  {
    id: "5B10237B-B7AA-4B35-B8C0-C97747F1E3E7",
    name: "play-network",
    codepoint: "F88A",
    aliases: ["media-network"],
    tags: [],
    author: "Michael Richins",
    version: "2.1.99",
    path: "M15,20C15,19.45 14.55,19 14,19H13V17H17C18.1,17 19,16.1 19,15V5C19,3.9 18.1,3 17,3H7C5.9,3 5,3.9 5,5V15C5,16.1 5.9,17 7,17H11V19H10C9.45,19 9,19.45 9,20H2V22H9C9,22.55 9.45,23 10,23H14C14.55,23 15,22.55 15,22H22V20H15M10,14V6L15,10L10,14Z",
  },
  {
    id: "93DAA69E-9A21-4D5A-B6B1-0AF0A24B7FEB",
    name: "play-pause",
    codepoint: "F40E",
    aliases: [],
    tags: ["Home Automation"],
    author: "Cody",
    version: "1.5.54",
    path: "M3,5V19L11,12M13,19H16V5H13M18,5V19H21V5",
  },
  {
    id: "FEB9507A-DA7D-4CB3-918A-E64BBB9D4CC9",
    name: "play-protected-content",
    codepoint: "F40F",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M2,5V18H11V16H4V7H17V11H19V5H2M9,9V14L12.5,11.5L9,9M21.04,11.67L16.09,16.62L13.96,14.5L12.55,15.91L16.09,19.45L22.45,13.09L21.04,11.67Z",
  },
  {
    id: "72410FAF-5315-452B-ACE1-C0FEB3B897F8",
    name: "play-speed",
    codepoint: "F8FE",
    aliases: [],
    tags: [],
    author: "Google",
    version: "2.3.50",
    path: "M13,2.05V4.05C17.39,4.59 20.5,8.58 19.96,12.97C19.5,16.61 16.64,19.5 13,19.93V21.93C18.5,21.38 22.5,16.5 21.95,11C21.5,6.25 17.73,2.5 13,2.03V2.05M5.67,19.74C7.18,21 9.04,21.79 11,22V20C9.58,19.82 8.23,19.25 7.1,18.37L5.67,19.74M7.1,5.74C8.22,4.84 9.57,4.26 11,4.06V2.06C9.05,2.25 7.19,3 5.67,4.26L7.1,5.74M5.69,7.1L4.26,5.67C3,7.19 2.25,9.04 2.05,11H4.05C4.24,9.58 4.8,8.23 5.69,7.1M4.06,13H2.06C2.26,14.96 3.03,16.81 4.27,18.33L5.69,16.9C4.81,15.77 4.24,14.42 4.06,13M10,16.5L16,12L10,7.5V16.5Z",
  },
  {
    id: "F3E26F6E-9F9A-490B-A28A-1BD32A60D143",
    name: "playlist-check",
    codepoint: "F5C7",
    aliases: ["subscriptions", "playlist-add-check"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M14,10H2V12H14V10M14,6H2V8H14V6M2,16H10V14H2V16M21.5,11.5L23,13L16,20L11.5,15.5L13,14L16,17L21.5,11.5Z",
  },
  {
    id: "EBBE4C11-9C6D-40AA-844A-167B274A4E81",
    name: "playlist-edit",
    codepoint: "F8FF",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "2.3.50",
    path: "M2,6V8H14V6H2M2,10V12H14V10H2M20.04,10.13C19.9,10.13 19.76,10.19 19.65,10.3L18.65,11.3L20.7,13.35L21.7,12.35C21.92,12.14 21.92,11.79 21.7,11.58L20.42,10.3C20.31,10.19 20.18,10.13 20.04,10.13M18.07,11.88L12,17.94V20H14.06L20.12,13.93L18.07,11.88M2,14V16H10V14H2Z",
  },
  {
    id: "1D472295-8F79-4F51-B68A-63A2CD2DF634",
    name: "playlist-minus",
    codepoint: "F410",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M2,16H10V14H2M12,14V16H22V14M14,6H2V8H14M14,10H2V12H14V10Z",
  },
  {
    id: "313918D8-1CB9-40FC-B24F-3A974F1A6EAF",
    name: "playlist-play",
    codepoint: "F411",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M19,9H2V11H19V9M19,5H2V7H19V5M2,15H15V13H2V15M17,13V19L22,16L17,13Z",
  },
  {
    id: "350D7B60-3F36-4FB0-9959-B90625F5267C",
    name: "playlist-plus",
    codepoint: "F412",
    aliases: ["playlist-add"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M2,16H10V14H2M18,14V10H16V14H12V16H16V20H18V16H22V14M14,6H2V8H14M14,10H2V12H14V10Z",
  },
  {
    id: "526856F3-6DF1-454A-B905-3DA120370563",
    name: "playlist-remove",
    codepoint: "F413",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M2,6V8H14V6H2M2,10V12H11V10H2M14.17,10.76L12.76,12.17L15.59,15L12.76,17.83L14.17,19.24L17,16.41L19.83,19.24L21.24,17.83L18.41,15L21.24,12.17L19.83,10.76L17,13.59L14.17,10.76M2,14V16H11V14H2Z",
  },
  {
    id: "D390D1E2-571E-49DB-BBB9-9D3821EAF819",
    name: "plex",
    codepoint: "F6B9",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Christopher Schreiner",
    version: "1.7.22",
    path: "M4,2C2.89,2 2,2.89 2,4V20C2,21.11 2.89,22 4,22H20C21.11,22 22,21.11 22,20V4C22,2.89 21.11,2 20,2H4M8.56,6H12.06L15.5,12L12.06,18H8.56L12,12L8.56,6Z",
  },
  {
    id: "2DE4F8E6-F25C-4FCA-8405-109FA8918B78",
    name: "plus",
    codepoint: "F415",
    aliases: ["add"],
    tags: ["Math"],
    author: "Google",
    version: "1.5.54",
    path: "M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z",
  },
  {
    id: "87EE041D-81D2-4F1A-A757-F76E9D8686EF",
    name: "plus-box",
    codepoint: "F416",
    aliases: ["add-box"],
    tags: ["Math"],
    author: "Google",
    version: "1.5.54",
    path: "M17,13H13V17H11V13H7V11H11V7H13V11H17M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3Z",
  },
  {
    id: "75A7BDE6-40BC-4938-AFCD-D4DDF1B65B2A",
    name: "plus-box-outline",
    codepoint: "F703",
    aliases: [],
    tags: ["Math"],
    author: "Michael Irigoyen",
    version: "1.8.36",
    path: "M19,19V5H5V19H19M19,3C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.89 3.9,3 5,3H19M11,7H13V11H17V13H13V17H11V13H7V11H11V7Z",
  },
  {
    id: "0F76DADF-2A8D-4C1F-B43E-DC3C6D282BBF",
    name: "plus-circle",
    codepoint: "F417",
    aliases: ["add-circle"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M17,13H13V17H11V13H7V11H11V7H13V11H17M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z",
  },
  {
    id: "0C5565E9-9E74-4E50-BF9E-6F904BB83E52",
    name: "plus-circle-multiple-outline",
    codepoint: "F418",
    aliases: ["control-point-duplicate"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M16,8H14V11H11V13H14V16H16V13H19V11H16M2,12C2,9.21 3.64,6.8 6,5.68V3.5C2.5,4.76 0,8.09 0,12C0,15.91 2.5,19.24 6,20.5V18.32C3.64,17.2 2,14.79 2,12M15,3C10.04,3 6,7.04 6,12C6,16.96 10.04,21 15,21C19.96,21 24,16.96 24,12C24,7.04 19.96,3 15,3M15,19C11.14,19 8,15.86 8,12C8,8.14 11.14,5 15,5C18.86,5 22,8.14 22,12C22,15.86 18.86,19 15,19Z",
  },
  {
    id: "EFB8C700-D60B-4995-B8DE-F3A3E2DA75F3",
    name: "plus-circle-outline",
    codepoint: "F419",
    aliases: ["add-circle-outline", "control-point", "circles-add"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M13,7H11V11H7V13H11V17H13V13H17V11H13V7Z",
  },
  {
    id: "34BDA78C-9BF6-441A-9924-E8619719C333",
    name: "plus-minus",
    codepoint: "F991",
    aliases: [],
    tags: [],
    author: "Nick",
    version: "2.4.85",
    path: "M11,4V9H6V11H11V16H13V11H18V9H13V4H11M6,18V20H18V18H6Z",
  },
  {
    id: "C8A8A7E4-7745-4CA1-A99B-724C2471CAF5",
    name: "plus-minus-box",
    codepoint: "F992",
    aliases: [],
    tags: [],
    author: "Nick",
    version: "2.4.85",
    path: "M5,3C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3H5M11,6H13V9H16V11H13V14H11V11H8V9H11V6M8,16H16V18H8V16Z",
  },
  {
    id: "14F6A9EC-BD40-4181-B084-05A9FCFA3973",
    name: "plus-network",
    codepoint: "F41A",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M16,11V9H13V6H11V9H8V11H11V14H13V11H16M17,3C18.1,3 19,3.9 19,5V15C19,16.1 18.1,17 17,17H13V19H14C14.55,19 15,19.45 15,20H22V22H15C15,22.55 14.55,23 14,23H10C9.45,23 9,22.55 9,22H2V20H9C9,19.45 9.45,19 10,19H11V17H7C5.89,17 5,16.1 5,15V5C5,3.9 5.9,3 7,3H17Z",
  },
  {
    id: "E67044BA-8025-4D61-916C-56DF4D6FFE6D",
    name: "plus-one",
    codepoint: "F41B",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M10,8V12H14V14H10V18H8V14H4V12H8V8H10M14.5,6.08L19,5V18H17V7.4L14.5,7.9V6.08Z",
  },
  {
    id: "680B6AD6-C9AD-44D1-9228-EDDB8C242343",
    name: "plus-outline",
    codepoint: "F704",
    aliases: [],
    tags: [],
    author: "Michael Irigoyen",
    version: "1.8.36",
    path: "M4,9H9V4H15V9H20V15H15V20H9V15H4V9M11,13V18H13V13H18V11H13V6H11V11H6V13H11Z",
  },
  {
    id: "56B37BA8-E973-4B53-812A-7F47BCFF217A",
    name: "podcast",
    codepoint: "F993",
    aliases: [],
    tags: [],
    author: "Google",
    version: "2.4.85",
    path: "M17,18.25V21.5H7V18.25C7,16.87 9.24,15.75 12,15.75C14.76,15.75 17,16.87 17,18.25M12,5.5C15.59,5.5 18.5,8.41 18.5,12C18.5,13.25 18.15,14.42 17.54,15.41L16,14.04C16.32,13.43 16.5,12.73 16.5,12C16.5,9.5 14.5,7.5 12,7.5C9.5,7.5 7.5,9.5 7.5,12C7.5,12.73 7.68,13.43 8,14.04L6.46,15.41C5.85,14.42 5.5,13.25 5.5,12C5.5,8.41 8.41,5.5 12,5.5M12,1.5C17.8,1.5 22.5,6.2 22.5,12C22.5,14.28 21.77,16.39 20.54,18.11L19.04,16.76C19.96,15.4 20.5,13.76 20.5,12C20.5,7.31 16.69,3.5 12,3.5C7.31,3.5 3.5,7.31 3.5,12C3.5,13.76 4.04,15.4 4.96,16.76L3.46,18.11C2.23,16.39 1.5,14.28 1.5,12C1.5,6.2 6.2,1.5 12,1.5M12,9.5C13.38,9.5 14.5,10.62 14.5,12C14.5,13.38 13.38,14.5 12,14.5C10.62,14.5 9.5,13.38 9.5,12C9.5,10.62 10.62,9.5 12,9.5Z",
  },
  {
    id: "48329A9B-7B16-469C-9D64-B2E9381620BF",
    name: "pokeball",
    codepoint: "F41D",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M12,4C7.92,4 4.55,7.05 4.06,11H8.13C8.57,9.27 10.14,8 12,8C13.86,8 15.43,9.27 15.87,11H19.94C19.45,7.05 16.08,4 12,4M12,20C16.08,20 19.45,16.95 19.94,13H15.87C15.43,14.73 13.86,16 12,16C10.14,16 8.57,14.73 8.13,13H4.06C4.55,16.95 7.92,20 12,20M12,10C10.9,10 10,10.9 10,12C10,13.1 10.9,14 12,14C13.1,14 14,13.1 14,12C14,10.9 13.1,10 12,10Z",
  },
  {
    id: "A1D5B3DC-2A72-4548-AB36-985E98BB6FCE",
    name: "pokemon-go",
    codepoint: "FA08",
    aliases: [],
    tags: [],
    author: "Contributors",
    version: "2.5.94",
    path: "M12,2C15.87,2 19,5.13 19,9C19,10.4 18.59,11.71 17.88,12.8L12,22.21L6.12,12.8C5.41,11.71 5,10.4 5,9C5,5.13 8.13,2 12,2M12,3.5C9.3,3.5 7.06,5.44 6.59,8H9.17C9.58,6.83 10.69,6 12,6C13.31,6 14.42,6.83 14.83,8H17.41C16.94,5.44 14.7,3.5 12,3.5M12,12C10.69,12 9.58,11.17 9.17,10H6.59C6.72,10.69 6.97,11.34 7.34,11.91V11.91L7.38,12C8.36,13.5 10.06,14.5 12,14.5C13.94,14.5 15.64,13.5 16.62,12L16.66,11.91V11.91C17.03,11.34 17.28,10.69 17.41,10H14.83C14.42,11.17 13.31,12 12,12M12,7.5C11.17,7.5 10.5,8.17 10.5,9C10.5,9.83 11.17,10.5 12,10.5C12.83,10.5 13.5,9.83 13.5,9C13.5,8.17 12.83,7.5 12,7.5Z",
  },
  {
    id: "D73F724D-EEE6-43EC-BA3A-E185ABD7A258",
    name: "poker-chip",
    codepoint: "F82F",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.1.19",
    path: "M23,12C23,18.08 18.08,23 12,23C5.92,23 1,18.08 1,12C1,5.92 5.92,1 12,1C18.08,1 23,5.92 23,12M13,4.06C15.13,4.33 17.07,5.45 18.37,7.16L20.11,6.16C18.45,3.82 15.86,2.3 13,2V4.06M3.89,6.16L5.63,7.16C6.93,5.45 8.87,4.33 11,4.06V2C8.14,2.3 5.55,3.82 3.89,6.16M2.89,16.1L4.62,15.1C3.79,13.12 3.79,10.88 4.62,8.9L2.89,7.9C1.7,10.5 1.7,13.5 2.89,16.1M11,19.94C8.87,19.67 6.93,18.55 5.63,16.84L3.89,17.84C5.55,20.18 8.14,21.7 11,22V19.94M20.11,17.84L18.37,16.84C17.07,18.55 15.13,19.67 13,19.94V21.94C15.85,21.65 18.44,20.16 20.11,17.84M21.11,16.1C22.3,13.5 22.3,10.5 21.11,7.9L19.38,8.9C20.21,10.88 20.21,13.12 19.38,15.1L21.11,16.1M15,12L12,7L9,12L12,17L15,12Z",
  },
  {
    id: "8408CE08-26C2-49B9-95CE-C5A9AAF4455E",
    name: "polaroid",
    codepoint: "F41E",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M6,3H18C19.1,3 20,3.9 20,5V19C20,20.1 19.1,21 18,21H6C4.9,21 4,20.1 4,19V5C4,3.9 4.9,3 6,3M6,5V17H18V5H6Z",
  },
  {
    id: "C4A1DAE5-04E0-47EF-84D8-CB81FA58EF87",
    name: "poll",
    codepoint: "F41F",
    aliases: ["bar-chart"],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M3,22V8H7V22H3M10,22V2H14V22H10M17,22V14H21V22H17Z",
  },
  {
    id: "5FFF2FB6-08B2-4860-ACCF-72D614641882",
    name: "poll-box",
    codepoint: "F420",
    aliases: ["assessment", "insert-chart"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M17,17H15V13H17M13,17H11V7H13M9,17H7V10H9M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3Z",
  },
  {
    id: "528FF16A-C55C-43F9-8E0B-3879A209AEDE",
    name: "polymer",
    codepoint: "F421",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Google",
    version: "1.5.54",
    path: "M19,4H15L7.1,16.63L4.5,12L9,4H5L0.5,12L5,20H9L16.89,7.37L19.5,12L15,20H19L23.5,12L19,4Z",
  },
  {
    id: "F42C2F0C-BEFC-46EB-A46C-665032BD6641",
    name: "pool",
    codepoint: "F606",
    aliases: ["swimming-pool"],
    tags: ["Places"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M2,15C3.67,14.25 5.33,13.5 7,13.17V5C7,3.34 8.34,2 10,2C11.31,2 12.42,2.83 12.83,4H10C9.45,4 9,4.45 9,5V6H14V5C14,3.34 15.34,2 17,2C18.31,2 19.42,2.83 19.83,4H17C16.45,4 16,4.45 16,5V14.94C18,14.62 20,13 22,13V15C19.78,15 17.56,17 15.33,17C13.11,17 10.89,15 8.67,15C6.44,15 4.22,16 2,17V15M14,8H9V10H14V8M14,12H9V13C10.67,13.16 12.33,14.31 14,14.79V12M2,19C4.22,18 6.44,17 8.67,17C10.89,17 13.11,19 15.33,19C17.56,19 19.78,17 22,17V19C19.78,19 17.56,21 15.33,21C13.11,21 10.89,19 8.67,19C6.44,19 4.22,20 2,21V19Z",
  },
  {
    id: "3401BCC7-DECF-4A92-9B6C-34AF063B2FED",
    name: "popcorn",
    codepoint: "F422",
    aliases: [],
    tags: ["Food / Drink"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M7,22H4.75C4.75,22 4,22 3.81,20.65L2.04,3.81L2,3.5C2,2.67 2.9,2 4,2C5.1,2 6,2.67 6,3.5C6,2.67 6.9,2 8,2C9.1,2 10,2.67 10,3.5C10,2.67 10.9,2 12,2C13.09,2 14,2.66 14,3.5V3.5C14,2.67 14.9,2 16,2C17.1,2 18,2.67 18,3.5C18,2.67 18.9,2 20,2C21.1,2 22,2.67 22,3.5L21.96,3.81L20.19,20.65C20,22 19.25,22 19.25,22H17L16.5,22H13.75L10.25,22H7.5L7,22M17.85,4.93C17.55,4.39 16.84,4 16,4C15.19,4 14.36,4.36 14,4.87L13.78,20H16.66L17.85,4.93M10,4.87C9.64,4.36 8.81,4 8,4C7.16,4 6.45,4.39 6.15,4.93L7.34,20H10.22L10,4.87Z",
  },
  {
    id: "444286FD-F41C-4945-BF9D-7C2913EC663E",
    name: "pot",
    codepoint: "F65A",
    aliases: [],
    tags: ["Food / Drink"],
    author: "Cody",
    version: "1.6.50",
    path: "M19,19C19,20.1 18.1,21 17,21H7C5.9,21 5,20.1 5,19V13H3V10H21V13H19V19M6,6H8V8H6V6M11,6H13V8H11V6M16,6H18V8H16V6M18,3H20V5H18V3M13,3H15V5H13V3M8,3H10V5H8V3Z",
  },
  {
    id: "C264A721-9CFD-4AE5-BD97-404E7DCDC6C2",
    name: "pot-mix",
    codepoint: "F65B",
    aliases: [],
    tags: ["Food / Drink"],
    author: "Cody",
    version: "1.6.50",
    path: "M19,19C19,20.1 18.1,21 17,21H7C5.9,21 5,20.1 5,19V13H3V10H14L18,3.07L19.73,4.07L16.31,10H21V13H19V19Z",
  },
  {
    id: "9344AA1D-FF8B-432F-A314-C416DFA37F12",
    name: "pound",
    codepoint: "F423",
    aliases: ["hashtag"],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M5.41,21L6.12,17H2.12L2.47,15H6.47L7.53,9H3.53L3.88,7H7.88L8.59,3H10.59L9.88,7H15.88L16.59,3H18.59L17.88,7H21.88L21.53,9H17.53L16.47,15H20.47L20.12,17H16.12L15.41,21H13.41L14.12,17H8.12L7.41,21H5.41M9.53,9L8.47,15H14.47L15.53,9H9.53Z",
  },
  {
    id: "597DF175-F0F5-4892-9F13-EA712DBC947E",
    name: "pound-box",
    codepoint: "F424",
    aliases: ["hashtag-box"],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M3,5C3,3.9 3.9,3 5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.89,21 3,20.1 3,19V5M7,18H9L9.35,16H13.35L13,18H15L15.35,16H17.35L17.71,14H15.71L16.41,10H18.41L18.76,8H16.76L17.12,6H15.12L14.76,8H10.76L11.12,6H9.12L8.76,8H6.76L6.41,10H8.41L7.71,14H5.71L5.35,16H7.35L7,18M10.41,10H14.41L13.71,14H9.71L10.41,10Z",
  },
  {
    id: "C945D203-9737-4C25-87CA-29D97B862DD2",
    name: "power",
    codepoint: "F425",
    aliases: ["power-settings-new", "shutdown"],
    tags: ["Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M16.56,5.44L15.11,6.89C16.84,7.94 18,9.83 18,12C18,15.31 15.31,18 12,18C8.69,18 6,15.31 6,12C6,9.83 7.16,7.94 8.88,6.88L7.44,5.44C5.36,6.88 4,9.28 4,12C4,16.42 7.58,20 12,20C16.42,20 20,16.42 20,12C20,9.28 18.64,6.88 16.56,5.44M13,3H11V13H13",
  },
  {
    id: "DD119EDC-92B2-48F6-8014-73AD2AB65DA7",
    name: "power-cycle",
    codepoint: "F900",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.3.50",
    path: "M12,3C7.03,3 3,7.03 3,12C3,16.97 7.03,21 12,21C16.97,21 21,16.97 21,12C21,7.03 16.97,3 12,3M12,19C8.13,19 5,15.87 5,12C5,8.13 8.13,5 12,5C15.87,5 19,8.13 19,12C19,15.87 15.87,19 12,19M13,17H11V7H13V17Z",
  },
  {
    id: "39D3928C-2739-4A57-A81C-3DF67328A160",
    name: "power-off",
    codepoint: "F901",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.3.50",
    path: "M12,3C7.03,3 3,7.03 3,12C3,16.97 7.03,21 12,21C16.97,21 21,16.97 21,12C21,7.03 16.97,3 12,3M12,19C8.13,19 5,15.87 5,12C5,8.13 8.13,5 12,5C15.87,5 19,8.13 19,12C19,15.87 15.87,19 12,19Z",
  },
  {
    id: "566141F9-DB64-4210-8384-EB77CFA9E8A0",
    name: "power-on",
    codepoint: "F902",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.3.50",
    path: "M11,3H13V21H11V3Z",
  },
  {
    id: "60E77DB8-2D58-462F-8512-41D9E0E42795",
    name: "power-plug",
    codepoint: "F6A4",
    aliases: [],
    tags: ["Home Automation"],
    author: "Google",
    version: "1.7.12",
    path: "M16,7V3H14V7H10V3H8V7H8C7,7 6,8 6,9V14.5L9.5,18V21H14.5V18L18,14.5V9C18,8 17,7 16,7Z",
  },
  {
    id: "ACF38F54-4726-4F8F-9916-8C582137FA69",
    name: "power-plug-off",
    codepoint: "F6A5",
    aliases: ["power-off"],
    tags: ["Home Automation"],
    author: "Cody",
    version: "1.7.12",
    path: "M8,3V6.18C11.1,9.23 14.1,12.3 17.2,15.3C17.4,15 17.8,14.8 18,14.4V8.8C18,7.68 16.7,7.16 16,6.84V3H14V7H10V3H8M3.28,4C2.85,4.42 2.43,4.85 2,5.27L6,9.27V14.5C7.17,15.65 8.33,16.83 9.5,18V21H14.5V18C14.72,17.73 14.95,18.33 15.17,18.44C16.37,19.64 17.47,20.84 18.67,22.04C19.17,21.64 19.57,21.14 19.97,20.74C14.37,15.14 8.77,9.64 3.27,4.04L3.28,4Z",
  },
  {
    id: "B5587844-E70A-4F55-A2DA-CE85D8F79689",
    name: "power-settings",
    codepoint: "F426",
    aliases: ["settings-power"],
    tags: ["Settings"],
    author: "Google",
    version: "1.5.54",
    path: "M15,24H17V22H15M16.56,4.44L15.11,5.89C16.84,6.94 18,8.83 18,11C18,14.31 15.31,17 12,17C8.69,17 6,14.31 6,11C6,8.83 7.16,6.94 8.88,5.88L7.44,4.44C5.36,5.88 4,8.28 4,11C4,15.42 7.58,19 12,19C16.42,19 20,15.42 20,11C20,8.28 18.64,5.88 16.56,4.44M13,2H11V12H13M11,24H13V22H11M7,24H9V22H7V24Z",
  },
  {
    id: "AA011772-1BE4-4E00-A838-9D0D1DCA2773",
    name: "power-sleep",
    codepoint: "F903",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.3.50",
    path: "M18.73,18C15.4,21.69 9.71,22 6,18.64C2.33,15.31 2.04,9.62 5.37,5.93C6.9,4.25 9,3.2 11.27,3C7.96,6.7 8.27,12.39 12,15.71C13.63,17.19 15.78,18 18,18C18.25,18 18.5,18 18.73,18Z",
  },
  {
    id: "175A9E67-3723-4D49-85EC-8D34B4BA0C14",
    name: "power-socket",
    codepoint: "F427",
    aliases: ["plug-socket"],
    tags: ["Home Automation"],
    author: "Cody",
    version: "1.5.54",
    path: "M15,15H17V11H15M7,15H9V11H7M11,13H13V9H11M8.83,7H15.2L19,10.8V17H5V10.8M8,5L3,10V19H21V10L16,5H8Z",
  },
  {
    id: "CFCF8409-65AC-4E1C-885B-107F9D8B4413",
    name: "power-socket-au",
    codepoint: "F904",
    aliases: [
      "plug-socket-au",
      "power-socket-type-i",
      "power-socket-cn",
      "power-socket-ar",
      "power-socket-nz",
      "power-socket-pg",
      "power-socket-australia",
      "power-socket-china",
      "power-socket-argentina",
      "power-socket-new-zealand",
      "power-socket-papua-new-guinea",
    ],
    tags: [],
    author: "GreenTurtwig",
    version: "2.3.50",
    path: "M4.22,2C2.99,2 2,2.99 2,4.22V19.78C2,21 3,22 4.22,22H19.78C21.01,22 22,21.01 22,19.78V4.22C22,3 21,2 19.78,2H4.22M12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4M8.27,7.54L6.27,11L8,12L10,8.54L8.27,7.54M15.73,7.54L14,8.54L16,12L17.73,11L15.73,7.54M11,14V18H13V14H11Z",
  },
  {
    id: "07F4FD1C-A171-4088-BE30-53758CFF45E5",
    name: "power-socket-eu",
    codepoint: "F7E6",
    aliases: ["plug-socket-eu", "power-socket-europe"],
    tags: ["Home Automation"],
    author: "GreenTurtwig",
    version: "2.0.46",
    path: "M7.5,10.5C8.33,10.5 9,11.17 9,12C9,12.83 8.33,13.5 7.5,13.5C6.66,13.5 6,12.83 6,12C6,11.17 6.67,10.5 7.5,10.5M16.5,10.5C17.33,10.5 18,11.17 18,12C18,12.83 17.33,13.5 16.5,13.5C15.67,13.5 15,12.83 15,12C15,11.17 15.67,10.5 16.5,10.5M4.22,2H19.78C21,2 22,3 22,4.22V19.78C22,21.01 21.01,22 19.78,22H4.22C3,22 2,21 2,19.78V4.22C2,2.99 2.99,2 4.22,2M12,4C7.58,4 4,7.58 4,12C4,16.42 7.58,20 12,20C16.42,20 20,16.42 20,12C20,7.58 16.42,4 12,4Z",
  },
  {
    id: "E9F0AC95-A660-4FB1-BE5D-20153B709E15",
    name: "power-socket-uk",
    codepoint: "F7E7",
    aliases: [
      "plug-socket-uk",
      "power-socket-type-g",
      "power-socket-ie",
      "power-socket-hk",
      "power-socket-my",
      "power-socket-cy",
      "power-socket-mt",
      "power-socket-sg",
      "power-socket-united-kingdom",
      "power-socket-ireland",
      "power-socket-hong-kong",
      "power-socket-malaysia",
      "power-socket-cyprus",
      "power-socket-malta",
      "power-socket-singapore",
    ],
    tags: ["Home Automation"],
    author: "GreenTurtwig",
    version: "2.0.46",
    path: "M14.5,13.75H18V16H14.5V13.75M6,13.75H9.5V16H6V13.75M11,6H13V10H11V6M4.22,2C2.99,2 2,2.99 2,4.22V19.78C2,21 3,22 4.22,22H19.78C21.01,22 22,21.01 22,19.78V4.22C22,3 21,2 19.78,2H4.22M12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4Z",
  },
  {
    id: "C4F7F8FF-3465-4F85-B615-B852A6919100",
    name: "power-socket-us",
    codepoint: "F7E8",
    aliases: [
      "plug-socket-us",
      "power-socket-jp",
      "power-socket-ca",
      "power-socket-mx",
      "power-socket-type-b",
      "power-socket-united-states",
      "power-socket-japan",
      "power-socket-canada",
      "power-socket-mexico",
    ],
    tags: ["Home Automation"],
    author: "GreenTurtwig",
    version: "2.0.46",
    path: "M8,7H10V12H8V7M4.22,2H19.78C21,2 22,3 22,4.22V19.78C22,21.01 21.01,22 19.78,22H4.22C3,22 2,21 2,19.78V4.22C2,2.99 2.99,2 4.22,2M12,4C7.58,4 4,7.58 4,12C4,16.42 7.58,20 12,20C16.42,20 20,16.42 20,12C20,7.58 16.42,4 12,4M14,7.5H16V11.5H14V7.5M10.5,16.25C10.5,15.42 11.17,14.75 12,14.75C12.83,14.75 13.5,15.42 13.5,16.25V17H10.5V16.25Z",
  },
  {
    id: "3AC74CF9-0EC1-475D-A164-7C9CA0D48B58",
    name: "power-standby",
    codepoint: "F905",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.3.50",
    path: "M13,3H11V13H13V3M17.83,5.17L16.41,6.59C18.05,7.91 19,9.9 19,12C19,15.87 15.87,19 12,19C8.14,19 5,15.88 5,12C5,9.91 5.95,7.91 7.58,6.58L6.17,5.17C2.38,8.39 1.92,14.07 5.14,17.86C8.36,21.64 14.04,22.1 17.83,18.88C19.85,17.17 21,14.65 21,12C21,9.37 19.84,6.87 17.83,5.17Z",
  },
  {
    id: "2DB269A5-0CD6-4139-8C24-A4A1F7D96596",
    name: "powershell",
    codepoint: "FA09",
    aliases: [],
    tags: [],
    author: "Contributors",
    version: "2.5.94",
    path: "M21.83,4C22.32,4 22.63,4.4 22.5,4.89L19.34,19.11C19.23,19.6 18.75,20 18.26,20H2.17C1.68,20 1.37,19.6 1.5,19.11L4.66,4.89C4.77,4.4 5.25,4 5.74,4H21.83M15.83,16H11.83C11.37,16 11,16.38 11,16.84C11,17.31 11.37,17.69 11.83,17.69H15.83C16.3,17.69 16.68,17.31 16.68,16.84C16.68,16.38 16.3,16 15.83,16M5.78,16.28C5.38,16.56 5.29,17.11 5.57,17.5C5.85,17.92 6.41,18 6.81,17.73C14.16,12.56 14.21,12.5 14.26,12.47C14.44,12.31 14.53,12.09 14.54,11.87C14.55,11.67 14.5,11.5 14.38,11.31L9.46,6.03C9.13,5.67 8.57,5.65 8.21,6C7.85,6.32 7.83,6.88 8.16,7.24L12.31,11.68L5.78,16.28Z",
  },
  {
    id: "DEF7F9EA-ACA8-452E-B587-6524BE7D67EE",
    name: "prescription",
    codepoint: "F705",
    aliases: [],
    tags: ["Medical / Hospital"],
    author: "Roberto Graham",
    version: "1.8.36",
    path: "M4,4V10L4,14H6V10H8L13.41,15.41L9.83,19L11.24,20.41L14.83,16.83L18.41,20.41L19.82,19L16.24,15.41L19.82,11.83L18.41,10.41L14.83,14L10.83,10H11C12.66,10 14,8.66 14,7C14,5.34 12.66,4 11,4H4M6,6H11C11.55,6 12,6.45 12,7C12,7.55 11.55,8 11,8H6V6Z",
  },
  {
    id: "DAEB5F87-858A-4677-B023-C9EC71F99F6C",
    name: "presentation",
    codepoint: "F428",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M2,3H10C10,1.9 10.9,1 12,1C13.1,1 14,1.9 14,3H22V5H21V16H15.25L17,22H15L13.25,16H10.75L9,22H7L8.75,16H3V5H2V3M5,5V14H19V5H5Z",
  },
  {
    id: "E182F4B3-B2B0-41CD-90DC-5ADFBE25DA90",
    name: "presentation-play",
    codepoint: "F429",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M2,3H10C10,1.9 10.9,1 12,1C13.1,1 14,1.9 14,3H22V5H21V16H15.25L17,22H15L13.25,16H10.75L9,22H7L8.75,16H3V5H2V3M5,5V14H19V5H5M11.85,11.85C11.76,11.94 11.64,12 11.5,12C11.22,12 11,11.78 11,11.5V7.5C11,7.22 11.22,7 11.5,7C11.64,7 11.76,7.06 11.85,7.15L13.25,8.54C13.57,8.86 13.89,9.18 13.89,9.5C13.89,9.82 13.57,10.14 13.25,10.46L11.85,11.85Z",
  },
  {
    id: "7365D689-4C10-4EBA-AD9A-09189B8091EE",
    name: "printer",
    codepoint: "F42A",
    aliases: ["local-printshop", "local-print-shop"],
    tags: ["Printer", "Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M18,3H6V7H18M19,12C18.45,12 18,11.55 18,11C18,10.45 18.45,10 19,10C19.55,10 20,10.45 20,11C20,11.55 19.55,12 19,12M16,19H8V14H16M19,8H5C3.34,8 2,9.34 2,11V17H6V21H18V17H22V11C22,9.34 20.66,8 19,8Z",
  },
  {
    id: "86A3D6B7-6C8B-4883-B51B-753DEF0F4A62",
    name: "printer-3d",
    codepoint: "F42B",
    aliases: [],
    tags: ["Printer", "Home Automation"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M19,6C19.55,6 20,5.55 20,5C20,4.45 19.55,4 19,4C18.45,4 18,4.45 18,5C18,5.55 18.45,6 19,6M19,2C20.66,2 22,3.34 22,5V11H18V7H6V11H2V5C2,3.34 3.34,2 5,2H19M18,18.25C18,18.63 17.79,18.96 17.47,19.13L12.57,21.82C12.4,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L6.53,19.13C6.21,18.96 6,18.63 6,18.25V13C6,12.62 6.21,12.29 6.53,12.12L11.43,9.68C11.59,9.56 11.79,9.5 12,9.5C12.21,9.5 12.4,9.56 12.57,9.68L17.47,12.12C17.79,12.29 18,12.62 18,13V18.25M12,11.65L9.04,13L12,14.6L14.96,13L12,11.65M8,17.66L11,19.29V16.33L8,14.71V17.66M16,17.66V14.71L13,16.33V19.29L16,17.66Z",
  },
  {
    id: "DD64AF52-2610-43D3-A992-9F3FCCB4A576",
    name: "printer-alert",
    codepoint: "F42C",
    aliases: ["printer-warning"],
    tags: ["Printer", "Home Automation"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M14,4V8H6V4H14M15,13C15.55,13 16,12.55 16,12C16,11.45 15.55,11 15,11C14.45,11 14,11.45 14,12C14,12.55 14.45,13 15,13M13,19V15H7V19H13M15,9C16.66,9 18,10.34 18,12V17H15V21H5V17H2V12C2,10.34 3.34,9 5,9H15M22,7V12H20V7H22M22,14V16H20V14H22Z",
  },
  {
    id: "33E4D9A3-F8C1-4C58-9E88-977AE4F4E4CA",
    name: "printer-settings",
    codepoint: "F706",
    aliases: [],
    tags: ["Settings", "Printer"],
    author: "Cody",
    version: "1.8.36",
    path: "M18,2V6H6V2H18M19,11C19.55,11 20,10.55 20,10C20,9.45 19.55,9 19,9C18.45,9 18,9.45 18,10C18,10.55 18.45,11 19,11M16,18V13H8V18H16M19,7C20.66,7 22,8.34 22,10V16H18V20H6V16H2V10C2,8.34 3.34,7 5,7H19M15,24V22H17V24H15M11,24V22H13V24H11M7,24V22H9V24H7Z",
  },
  {
    id: "E9B8B42B-CA7D-4499-B610-CABBDCF51C0E",
    name: "printer-wireless",
    codepoint: "FA0A",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.5.94",
    path: "M4.93,3.92L6.34,5.33C9.46,2.2 14.53,2.2 17.66,5.33L19.07,3.92C15.17,0 8.84,0 4.93,3.92M7.76,6.75L9.17,8.16C10.73,6.6 13.26,6.6 14.83,8.16L16.24,6.75C13.9,4.41 10.1,4.41 7.76,6.75M19,14C18.45,14 18,13.55 18,13C18,12.45 18.45,12 19,12C19.55,12 20,12.45 20,13C20,13.55 19.55,14 19,14M16,20H8V15H16V20M19,10H5C3.34,10 2,11.34 2,13V18H6V22H18V18H22V13C22,11.34 20.66,10 19,10Z",
  },
  {
    id: "FA96A5AC-D499-4C13-93C7-7A422A5DE4B7",
    name: "priority-high",
    codepoint: "F603",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M14,19H22V17H14V19M14,13.5H22V11.5H14V13.5M14,8H22V6H14V8M2,12.5C2,8.92 4.92,6 8.5,6H9V4L12,7L9,10V8H8.5C6,8 4,10 4,12.5C4,15 6,17 8.5,17H12V19H8.5C4.92,19 2,16.08 2,12.5Z",
  },
  {
    id: "DFC698A7-3040-48F4-A341-C1E667A4FE22",
    name: "priority-low",
    codepoint: "F604",
    aliases: ["low-priority"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M14,5H22V7H14V5M14,10.5H22V12.5H14V10.5M14,16H22V18H14V16M2,11.5C2,15.08 4.92,18 8.5,18H9V20L12,17L9,14V16H8.5C6,16 4,14 4,11.5C4,9 6,7 8.5,7H12V5H8.5C4.92,5 2,7.92 2,11.5Z",
  },
  {
    id: "53EA516B-544D-4DC3-90BD-3A5C4838923C",
    name: "professional-hexagon",
    codepoint: "F42D",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5M5,9V15H6.25V13H7C8.1,13 9,12.1 9,11C9,9.9 8.1,9 7,9H5M6.25,12V10H6.75C7.3,10 7.75,10.45 7.75,11C7.75,11.55 7.3,12 6.75,12H6.25M9.75,9V15H11V13H11.75L12.41,15H13.73L12.94,12.61C13.43,12.25 13.75,11.66 13.75,11C13.75,9.9 12.85,9 11.75,9H9.75M11,12V10H11.5C12.05,10 12.5,10.45 12.5,11C12.5,11.55 12.05,12 11.5,12H11M17,9C15.62,9 14.5,10.34 14.5,12C14.5,13.66 15.62,15 17,15C18.38,15 19.5,13.66 19.5,12C19.5,10.34 18.38,9 17,9M17,10.25C17.76,10.25 18.38,11.03 18.38,12C18.38,12.97 17.76,13.75 17,13.75C16.24,13.75 15.63,12.97 15.63,12C15.63,11.03 16.24,10.25 17,10.25Z",
  },
  {
    id: "943E027B-964A-4CE2-BDD7-44A9703A73B1",
    name: "progress-check",
    codepoint: "F994",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "2.4.85",
    path: "M13,2.03V2.05L13,4.05C17.39,4.59 20.5,8.58 19.96,12.97C19.5,16.61 16.64,19.5 13,19.93V21.93C18.5,21.38 22.5,16.5 21.95,11C21.5,6.25 17.73,2.5 13,2.03M11,2.06C9.05,2.25 7.19,3 5.67,4.26L7.1,5.74C8.22,4.84 9.57,4.26 11,4.06V2.06M4.26,5.67C3,7.19 2.25,9.04 2.05,11H4.05C4.24,9.58 4.8,8.23 5.69,7.1L4.26,5.67M15.5,8.5L10.62,13.38L8.5,11.26L7.44,12.32L10.62,15.5L16.56,9.56L15.5,8.5M2.06,13C2.26,14.96 3.03,16.81 4.27,18.33L5.69,16.9C4.81,15.77 4.24,14.42 4.06,13H2.06M7.1,18.37L5.67,19.74C7.18,21 9.04,21.79 11,22V20C9.58,19.82 8.23,19.25 7.1,18.37Z",
  },
  {
    id: "D7A33F97-FA45-4719-901A-A1F91E671FC2",
    name: "progress-clock",
    codepoint: "F995",
    aliases: [],
    tags: ["Date / Time"],
    author: "Peter Noble",
    version: "2.4.85",
    path: "M13,2.03V2.05L13,4.05C17.39,4.59 20.5,8.58 19.96,12.97C19.5,16.61 16.64,19.5 13,19.93V21.93C18.5,21.38 22.5,16.5 21.95,11C21.5,6.25 17.73,2.5 13,2.03M11,2.06C9.05,2.25 7.19,3 5.67,4.26L7.1,5.74C8.22,4.84 9.57,4.26 11,4.06V2.06M4.26,5.67C3,7.19 2.25,9.04 2.05,11H4.05C4.24,9.58 4.8,8.23 5.69,7.1L4.26,5.67M2.06,13C2.26,14.96 3.03,16.81 4.27,18.33L5.69,16.9C4.81,15.77 4.24,14.42 4.06,13H2.06M7.1,18.37L5.67,19.74C7.18,21 9.04,21.79 11,22V20C9.58,19.82 8.23,19.25 7.1,18.37M12.5,7V12.25L17,14.92L16.25,16.15L11,13V7H12.5Z",
  },
  {
    id: "9D94B21B-52A0-4F73-AEFB-85FEA76C8624",
    name: "progress-download",
    codepoint: "F996",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "2.4.85",
    path: "M13,2.03C17.73,2.5 21.5,6.25 21.95,11C22.5,16.5 18.5,21.38 13,21.93V19.93C16.64,19.5 19.5,16.61 19.96,12.97C20.5,8.58 17.39,4.59 13,4.05V2.05L13,2.03M11,2.06V4.06C9.57,4.26 8.22,4.84 7.1,5.74L5.67,4.26C7.19,3 9.05,2.25 11,2.06M4.26,5.67L5.69,7.1C4.8,8.23 4.24,9.58 4.05,11H2.05C2.25,9.04 3,7.19 4.26,5.67M2.06,13H4.06C4.24,14.42 4.81,15.77 5.69,16.9L4.27,18.33C3.03,16.81 2.26,14.96 2.06,13M7.1,18.37C8.23,19.25 9.58,19.82 11,20V22C9.04,21.79 7.18,21 5.67,19.74L7.1,18.37M12,16.5L7.5,12H11V8H13V12H16.5L12,16.5Z",
  },
  {
    id: "699B5A10-1C4C-448C-A3F4-36A3CACD82EA",
    name: "progress-upload",
    codepoint: "F997",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "2.4.85",
    path: "M13,2.03C17.73,2.5 21.5,6.25 21.95,11C22.5,16.5 18.5,21.38 13,21.93V19.93C16.64,19.5 19.5,16.61 19.96,12.97C20.5,8.58 17.39,4.59 13,4.05V2.05L13,2.03M11,2.06V4.06C9.57,4.26 8.22,4.84 7.1,5.74L5.67,4.26C7.19,3 9.05,2.25 11,2.06M4.26,5.67L5.69,7.1C4.8,8.23 4.24,9.58 4.05,11H2.05C2.25,9.04 3,7.19 4.26,5.67M2.06,13H4.06C4.24,14.42 4.81,15.77 5.69,16.9L4.27,18.33C3.03,16.81 2.26,14.96 2.06,13M7.1,18.37C8.23,19.25 9.58,19.82 11,20V22C9.04,21.79 7.18,21 5.67,19.74L7.1,18.37M12,7.5L7.5,12H11V16H13V12H16.5L12,7.5Z",
  },
  {
    id: "D23095BD-C1C0-4FED-B114-CE9CF9DD5DB6",
    name: "projector",
    codepoint: "F42E",
    aliases: [],
    tags: ["Device / Tech", "Home Automation"],
    author: "Cody",
    version: "1.5.54",
    path: "M16,6C14.87,6 13.77,6.35 12.84,7H4C2.89,7 2,7.89 2,9V15C2,16.11 2.89,17 4,17H5V18C5,18.55 5.45,19 6,19H8C8.55,19 9,18.55 9,18V17H15V18C15,18.55 15.45,19 16,19H18C18.55,19 19,18.55 19,18V17H20C21.11,17 22,16.11 22,15V9C22,7.89 21.11,7 20,7H19.15C18.23,6.35 17.13,6 16,6M16,7.5C17.93,7.5 19.5,9.07 19.5,11C19.5,12.93 17.93,14.5 16,14.5C14.07,14.5 12.5,12.93 12.5,11C12.5,9.07 14.07,7.5 16,7.5M4,9H8V10H4V9M16,9C14.9,9 14,9.9 14,11C14,12.1 14.9,13 16,13C17.1,13 18,12.1 18,11C18,9.9 17.1,9 16,9M4,11H8V12H4V11M4,13H8V14H4V13Z",
  },
  {
    id: "A152DD64-B013-4AE7-B89F-49FC90B2E471",
    name: "projector-screen",
    codepoint: "F42F",
    aliases: [],
    tags: ["Device / Tech", "Home Automation"],
    author: "Cody",
    version: "1.5.54",
    path: "M4,2C3.45,2 3,2.45 3,3V4C3,4.55 3.45,5 4,5H5V14H11V16.59L6.79,20.79L8.21,22.21L11,19.41V22H13V19.41L15.79,22.21L17.21,20.79L13,16.59V14H19V5H20C20.55,5 21,4.55 21,4V3C21,2.45 20.55,2 20,2H4Z",
  },
  {
    id: "7E1AC29D-46E3-4C7C-9A00-D8803E502795",
    name: "publish",
    codepoint: "F6A6",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.7.12",
    path: "M5,4V6H19V4H5M5,14H9V20H15V14H19L12,7L5,14Z",
  },
  {
    id: "2A0F7B5D-5D23-4E76-B97D-9D2281D3C4EA",
    name: "pulse",
    codepoint: "F430",
    aliases: [],
    tags: ["Medical / Hospital"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M3,13H5.79L10.1,4.79L11.28,13.75L14.5,9.66L17.83,13H21V15H17L14.67,12.67L9.92,18.73L8.94,11.31L7,15H3V13Z",
  },
  {
    id: "0773D18C-C6A2-41B5-9685-F3E0507E1770",
    name: "puzzle",
    codepoint: "F431",
    aliases: ["extension"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M20.5,11H19V7C19,5.89 18.1,5 17,5H13V3.5C13,2.12 11.88,1 10.5,1C9.12,1 8,2.12 8,3.5V5H4C2.9,5 2,5.9 2,7V10.8H3.5C5,10.8 6.2,12 6.2,13.5C6.2,15 5,16.2 3.5,16.2H2V20C2,21.1 2.9,22 4,22H7.8V20.5C7.8,19 9,17.8 10.5,17.8C12,17.8 13.2,19 13.2,20.5V22H17C18.1,22 19,21.1 19,20V16H20.5C21.88,16 23,14.88 23,13.5C23,12.12 21.88,11 20.5,11Z",
  },
  {
    id: "1F897ED3-17CC-43F5-9A0B-F7804A8DFABF",
    name: "qi",
    codepoint: "F998",
    aliases: [],
    tags: [],
    author: "Contributors",
    version: "2.4.85",
    path: "M12.09,6.56V14.64C12.09,14.72 12,14.79 11.94,14.79C9.62,14.79 7.75,12.91 7.75,10.6C7.75,8.28 9.62,6.4 11.94,6.4C12,6.4 12.09,6.47 12.09,6.56M12.09,17.86V20.29C12.06,21.69 13.12,22.87 14.5,23C14.66,23 14.78,22.89 14.79,22.73V4.47C14.78,4.3 14.68,4.15 14.5,4.09C10.92,2.67 6.86,4.44 5.44,8.03C4,11.63 5.79,15.69 9.38,17.11C10.16,17.42 11,17.58 11.81,17.6C11.95,17.59 12.07,17.71 12.08,17.87M16.19,5.5V15.72C16.19,16 16.19,16.2 16.46,16V16C19.42,13.5 19.81,9.09 17.33,6.13C17.07,5.81 16.77,5.5 16.46,5.26C16.19,5.05 16.19,5.26 16.19,5.53M14.79,2.43C14.79,1.66 15.42,1.03 16.19,1.03C16.96,1.03 17.59,1.66 17.59,2.43C17.59,3.2 16.96,3.83 16.19,3.83V3.83C15.42,3.83 14.79,3.2 14.79,2.43",
  },
  {
    id: "6EAADAE4-30AE-4F69-888F-364BBAFFF5E7",
    name: "qqchat",
    codepoint: "F605",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M3.18,13.54C3.76,12.16 4.57,11.14 5.17,10.92C5.16,10.12 5.31,9.62 5.56,9.22C5.56,9.19 5.5,8.86 5.72,8.45C5.87,4.85 8.21,2 12,2C15.79,2 18.13,4.85 18.28,8.45C18.5,8.86 18.44,9.19 18.44,9.22C18.69,9.62 18.84,10.12 18.83,10.92C19.43,11.14 20.24,12.16 20.82,13.55C21.57,15.31 21.69,17 21.09,17.3C20.68,17.5 20.03,17 19.42,16.12C19.18,17.1 18.58,18 17.73,18.71C18.63,19.04 19.21,19.58 19.21,20.19C19.21,21.19 17.63,22 15.69,22C13.93,22 12.5,21.34 12.21,20.5H11.79C11.5,21.34 10.07,22 8.31,22C6.37,22 4.79,21.19 4.79,20.19C4.79,19.58 5.37,19.04 6.27,18.71C5.42,18 4.82,17.1 4.58,16.12C3.97,17 3.32,17.5 2.91,17.3C2.31,17 2.43,15.31 3.18,13.54Z",
  },
  {
    id: "779E7DDE-0ACE-4752-9966-22761E2A128A",
    name: "qrcode",
    codepoint: "F432",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M3,11H5V13H3V11M11,5H13V9H11V5M9,11H13V15H11V13H9V11M15,11H17V13H19V11H21V13H19V15H21V19H19V21H17V19H13V21H11V17H15V15H17V13H15V11M19,19V15H17V19H19M15,3H21V9H15V3M17,5V7H19V5H17M3,3H9V9H3V3M5,5V7H7V5H5M3,15H9V21H3V15M5,17V19H7V17H5Z",
  },
  {
    id: "603BF7E7-03A6-4141-8A50-CA124B62C621",
    name: "qrcode-edit",
    codepoint: "F8B7",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.2.43",
    path: "M5,5H7V7H5V5M1,1H11V11H1V1M3,3V9H9V3H3M5,17H7V19H5V17M1,13H11V23H1V13M3,15V21H9V15H3M13,13H17V15H19V13H23V15H19V17H23V23H19V21H15V23H13V21H15V19H13V13M21,21V19H19V21H21M19,17H17V15H15V19H19V17M22.7,3.35L21.7,4.35L19.65,2.35L20.65,1.35C20.85,1.14 21.19,1.13 21.42,1.35L22.7,2.58C22.91,2.78 22.92,3.12 22.7,3.35M13,8.94L19.07,2.88L21.12,4.93L15.06,11H13V8.94Z",
  },
  {
    id: "C8A7580B-5288-4A60-8033-797EB07A05AC",
    name: "qrcode-scan",
    codepoint: "F433",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M4,4H10V10H4V4M20,4V10H14V4H20M14,15H16V13H14V11H16V13H18V11H20V13H18V15H20V18H18V20H16V18H13V20H11V16H14V15M16,15V18H18V15H16M4,20V14H10V20H4M6,6V8H8V6H6M16,6V8H18V6H16M6,16V18H8V16H6M4,11H6V13H4V11M9,11H13V15H11V13H9V11M11,6H13V10H11V6M2,2V6H0V2C0,0.9 0.9,0 2,0H6V2H2M22,0C23.1,0 24,0.9 24,2V6H22V2H18V0H22M2,18V22H6V24H2C0.9,24 0,23.1 0,22V18H2M22,22V18H24V22C24,23.1 23.1,24 22,24H18V22H22Z",
  },
  {
    id: "E81082B7-E851-4407-B0D2-08CC105C6A5D",
    name: "quadcopter",
    codepoint: "F434",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M5.5,1C8,1 10,3 10,5.5C10,6.38 9.75,7.2 9.31,7.9L9.41,8H14.59L14.69,7.9C14.25,7.2 14,6.38 14,5.5C14,3 16,1 18.5,1C21,1 23,3 23,5.5C23,8 21,10 18.5,10C17.62,10 16.8,9.75 16.1,9.31L15,10.41V13.59L16.1,14.69C16.8,14.25 17.62,14 18.5,14C21,14 23,16 23,18.5C23,21 21,23 18.5,23C16,23 14,21 14,18.5C14,17.62 14.25,16.8 14.69,16.1L14.59,16H9.41L9.31,16.1C9.75,16.8 10,17.62 10,18.5C10,21 8,23 5.5,23C3,23 1,21 1,18.5C1,16 3,14 5.5,14C6.38,14 7.2,14.25 7.9,14.69L9,13.59V10.41L7.9,9.31C7.2,9.75 6.38,10 5.5,10C3,10 1,8 1,5.5C1,3 3,1 5.5,1M5.5,3C4.12,3 3,4.12 3,5.5C3,6.88 4.12,8 5.5,8C6.88,8 8,6.88 8,5.5C8,4.12 6.88,3 5.5,3M5.5,16C4.12,16 3,17.12 3,18.5C3,19.88 4.12,21 5.5,21C6.88,21 8,19.88 8,18.5C8,17.12 6.88,16 5.5,16M18.5,3C17.12,3 16,4.12 16,5.5C16,6.88 17.12,8 18.5,8C19.88,8 21,6.88 21,5.5C21,4.12 19.88,3 18.5,3M18.5,16C17.12,16 16,17.12 16,18.5C16,19.88 17.12,21 18.5,21C19.88,21 21,19.88 21,18.5C21,17.12 19.88,16 18.5,16M3.91,17.25L5.04,17.91C5.17,17.81 5.33,17.75 5.5,17.75C5.91,17.75 6.25,18.09 6.25,18.5L6.24,18.6L7.37,19.25L7.09,19.75L5.96,19.09C5.83,19.19 5.67,19.25 5.5,19.25C5.09,19.25 4.75,18.91 4.75,18.5L4.76,18.4L3.63,17.75L3.91,17.25M3.63,6.25L4.76,5.6L4.75,5.5C4.75,5.09 5.09,4.75 5.5,4.75C5.67,4.75 5.83,4.81 5.96,4.91L7.09,4.25L7.37,4.75L6.24,5.4L6.25,5.5C6.25,5.91 5.91,6.25 5.5,6.25C5.33,6.25 5.17,6.19 5.04,6.09L3.91,6.75L3.63,6.25M16.91,4.25L18.04,4.91C18.17,4.81 18.33,4.75 18.5,4.75C18.91,4.75 19.25,5.09 19.25,5.5L19.24,5.6L20.37,6.25L20.09,6.75L18.96,6.09C18.83,6.19 18.67,6.25 18.5,6.25C18.09,6.25 17.75,5.91 17.75,5.5L17.76,5.4L16.63,4.75L16.91,4.25M16.63,19.25L17.75,18.5C17.75,18.09 18.09,17.75 18.5,17.75C18.67,17.75 18.83,17.81 18.96,17.91L20.09,17.25L20.37,17.75L19.25,18.5C19.25,18.91 18.91,19.25 18.5,19.25C18.33,19.25 18.17,19.19 18.04,19.09L16.91,19.75L16.63,19.25Z",
  },
  {
    id: "C07BA504-080D-4B47-AD4D-7F772E5C92F3",
    name: "quality-high",
    codepoint: "F435",
    aliases: ["high-quality"],
    tags: ["Video / Movie"],
    author: "Google",
    version: "1.5.54",
    path: "M14.5,13.5H16.5V10.5H14.5M18,14C18,14.55 17.55,15 17,15H16.25V16.5H14.75V15H14C13.45,15 13,14.55 13,14V10C13,9.45 13.45,9 14,9H17C17.55,9 18,9.45 18,10M11,15H9.5V13H7.5V15H6V9H7.5V11.5H9.5V9H11M19,4H5C3.89,4 3,4.89 3,6V18C3,19.1 3.9,20 5,20H19C20.1,20 21,19.1 21,18V6C21,4.89 20.1,4 19,4Z",
  },
  {
    id: "51E44ABD-8132-4758-905E-4F46784ED768",
    name: "quality-low",
    codepoint: "FA0B",
    aliases: [],
    tags: [],
    author: "Michael Irigoyen",
    version: "2.5.94",
    path: "M14.5,13.5H16.5V10.5H14.5M18,14C18,14.6 17.6,15 17,15H16.25V16.5H14.75V15H14C13.4,15 13,14.6 13,14V10C13,9.4 13.4,9 14,9H17C17.6,9 18,9.4 18,10M19,4H5C3.9,4 3,4.9 3,6V18C3,19.1 3.9,20 5,20H19C20.1,20 21,19.1 21,18V6C21,4.9 20.1,4 19,4M11,13.5V15H6V9H7.5V13.5H11Z",
  },
  {
    id: "C987C0CA-2D23-427B-8F9C-F3E10B32156C",
    name: "quality-medium",
    codepoint: "FA0C",
    aliases: [],
    tags: [],
    author: "Michael Irigoyen",
    version: "2.5.94",
    path: "M21,6V18C21,19.1 20.1,20 19,20H5C3.9,20 3,19.1 3,18V6C3,4.9 3.9,4 5,4H19C20.1,4 21,4.9 21,6M12,10C12,9.5 11.5,9 11,9H6.5C6,9 5.5,9.5 5.5,10V15H7V10.5H8V14H9.5V10.5H10.5V15H12V10M14.5,9C13.95,9 13.5,9.45 13.5,10V14C13.5,14.55 13.95,15 14.5,15H15.5V16.5H16.75V15H17.5C18.05,15 18.5,14.55 18.5,14V10C18.5,9.45 18.05,9 17.5,9H14.5M15,10.5H17V13.5H15V10.5Z",
  },
  {
    id: "1D7338F8-4F44-43E3-906B-571178E63E49",
    name: "rabbit",
    codepoint: "F906",
    aliases: ["bunny"],
    tags: ["Animal"],
    author: "Augustin Ursu",
    version: "2.3.50",
    path: "M18.05,21L15.32,16.26C15.32,14.53 14.25,13.42 12.95,13.42C12.05,13.42 11.27,13.92 10.87,14.66C11.2,14.47 11.59,14.37 12,14.37C13.3,14.37 14.36,15.43 14.36,16.73C14.36,18.04 13.31,19.11 12,19.11H15.3V21H6.79C6.55,21 6.3,20.91 6.12,20.72C5.75,20.35 5.75,19.75 6.12,19.38V19.38L6.62,18.88C6.28,18.73 6,18.5 5.72,18.26C5.5,18.76 5,19.11 4.42,19.11C3.64,19.11 3,18.47 3,17.68C3,16.9 3.64,16.26 4.42,16.26L4.89,16.34V14.37C4.89,11.75 7,9.63 9.63,9.63H9.65C11.77,9.64 13.42,10.47 13.42,9.16C13.42,8.23 13.62,7.86 13.96,7.34C13.23,7 12.4,6.79 11.53,6.79C11,6.79 10.58,6.37 10.58,5.84C10.58,5.41 10.86,5.05 11.25,4.93L10.58,4.89C10.06,4.89 9.63,4.47 9.63,3.95C9.63,3.42 10.06,3 10.58,3H11.53C13.63,3 15.47,4.15 16.46,5.85L16.74,5.84C17.45,5.84 18.11,6.07 18.65,6.45L19.1,6.83C21.27,8.78 21,10.1 21,10.11C21,11.39 19.94,12.44 18.65,12.44L18.16,12.39V12.47C18.16,13.58 17.68,14.57 16.93,15.27L20.24,21H18.05M18.16,7.74C17.63,7.74 17.21,8.16 17.21,8.68C17.21,9.21 17.63,9.63 18.16,9.63C18.68,9.63 19.11,9.21 19.11,8.68C19.11,8.16 18.68,7.74 18.16,7.74Z",
  },
  {
    id: "73BD6C2A-0D5B-4DF6-9FA3-EC489AFBF947",
    name: "radar",
    codepoint: "F437",
    aliases: ["track-changes"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M19.07,4.93L17.66,6.34C19.1,7.79 20,9.79 20,12C20,16.42 16.42,20 12,20C7.58,20 4,16.42 4,12C4,7.92 7.05,4.56 11,4.07V6.09C8.16,6.57 6,9.03 6,12C6,15.31 8.69,18 12,18C15.31,18 18,15.31 18,12C18,10.34 17.33,8.84 16.24,7.76L14.83,9.17C15.55,9.9 16,10.9 16,12C16,14.21 14.21,16 12,16C9.79,16 8,14.21 8,12C8,10.14 9.28,8.59 11,8.14V10.28C10.4,10.63 10,11.26 10,12C10,13.1 10.9,14 12,14C13.1,14 14,13.1 14,12C14,11.26 13.6,10.62 13,10.28V2H12C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,9.24 20.88,6.74 19.07,4.93Z",
  },
  {
    id: "BFFA61BF-959B-4E15-BE31-4D9AFB5E3FDF",
    name: "radiator",
    codepoint: "F438",
    aliases: [],
    tags: ["Home Automation"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M7.95,3L6.53,5.19L7.95,7.4H7.94L5.95,10.5L4.22,9.6L5.64,7.39L4.22,5.19L6.22,2.09L7.95,3M13.95,2.89L12.53,5.1L13.95,7.3L13.94,7.31L11.95,10.4L10.22,9.5L11.64,7.3L10.22,5.1L12.22,2L13.95,2.89M20,2.89L18.56,5.1L20,7.3V7.31L18,10.4L16.25,9.5L17.67,7.3L16.25,5.1L18.25,2L20,2.89M2,22V14C2,12.9 2.9,12 4,12H20C21.1,12 22,12.9 22,14V22H20V20H4V22H2M6,14C5.45,14 5,14.45 5,15V17C5,17.55 5.45,18 6,18C6.55,18 7,17.55 7,17V15C7,14.45 6.55,14 6,14M10,14C9.45,14 9,14.45 9,15V17C9,17.55 9.45,18 10,18C10.55,18 11,17.55 11,17V15C11,14.45 10.55,14 10,14M14,14C13.45,14 13,14.45 13,15V17C13,17.55 13.45,18 14,18C14.55,18 15,17.55 15,17V15C15,14.45 14.55,14 14,14M18,14C17.45,14 17,14.45 17,15V17C17,17.55 17.45,18 18,18C18.55,18 19,17.55 19,17V15C19,14.45 18.55,14 18,14Z",
  },
  {
    id: "2FA21C1E-99C3-4C9B-AF46-8DF6B9F2A8FC",
    name: "radio",
    codepoint: "F439",
    aliases: [],
    tags: ["Audio"],
    author: "Google",
    version: "1.5.54",
    path: "M20,6C21.1,6 22,6.9 22,8V20C22,21.1 21.1,22 20,22H4C2.9,22 2,21.1 2,20V8C2,7.15 2.53,6.42 3.28,6.13L15.71,1L16.47,2.83L8.83,6H20M20,8H4V12H16V10H18V12H20V8M7,14C5.34,14 4,15.34 4,17C4,18.66 5.34,20 7,20C8.66,20 10,18.66 10,17C10,15.34 8.66,14 7,14Z",
  },
  {
    id: "6EE69D5F-CF42-4257-B974-470E397E0DC1",
    name: "radio-handheld",
    codepoint: "F43A",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M9,2C8.45,2 8,2.45 8,3C8,8.67 8,14.33 8,20C8,21.11 8.89,22 10,22H15C16.11,22 17,21.11 17,20V9C17,7.89 16.11,7 15,7H10V3C10,2.45 9.55,2 9,2M10,9H15V13H10V9Z",
  },
  {
    id: "8E5FC366-E9F8-40ED-A16D-CD6C87B0C5B1",
    name: "radio-tower",
    codepoint: "F43B",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,10C13.1,10 14,10.9 14,12C14,12.5 13.82,12.94 13.53,13.29L16.7,22H14.57L12,14.93L9.43,22H7.3L10.47,13.29C10.18,12.94 10,12.5 10,12C10,10.9 10.9,10 12,10M12,8C9.79,8 8,9.79 8,12C8,12.5 8.1,13 8.28,13.46L7.4,15.86C6.53,14.81 6,13.47 6,12C6,8.69 8.69,6 12,6C15.31,6 18,8.69 18,12C18,13.47 17.47,14.81 16.6,15.86L15.72,13.46C15.9,13 16,12.5 16,12C16,9.79 14.21,8 12,8M12,4C7.58,4 4,7.58 4,12C4,14.36 5,16.5 6.64,17.94L5.92,19.94C3.54,18.11 2,15.23 2,12C2,6.48 6.48,2 12,2C17.52,2 22,6.48 22,12C22,15.23 20.46,18.11 18.08,19.94L17.36,17.94C19,16.5 20,14.36 20,12C20,7.58 16.42,4 12,4Z",
  },
  {
    id: "D70016AF-1FEE-4E66-8D51-3DE1BAAC0031",
    name: "radioactive",
    codepoint: "F43C",
    aliases: [],
    tags: ["Science"],
    author: "Yasmina Lembachar",
    version: "1.5.54",
    path: "M12,10C13.1,10 14,10.9 14,12C14,13.1 13.1,14 12,14C10.9,14 10,13.1 10,12C10,10.9 10.9,10 12,10M12,22C10.05,22 8.22,21.44 6.69,20.47L10,15.47C10.6,15.81 11.28,16 12,16C12.72,16 13.4,15.81 14,15.47L17.31,20.47C15.78,21.44 13.95,22 12,22M2,12C2,7.86 4.5,4.3 8.11,2.78L10.34,8.36C8.96,9 8,10.38 8,12H2M16,12C16,10.38 15.04,9 13.66,8.36L15.89,2.78C19.5,4.3 22,7.86 22,12H16Z",
  },
  {
    id: "10BF2326-3190-4C27-9040-E2F8F4961238",
    name: "radiobox-blank",
    codepoint: "F43D",
    aliases: ["radio-button-unchecked"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z",
  },
  {
    id: "BA101E5E-CDA9-45AA-B249-BD176AF11D95",
    name: "radiobox-marked",
    codepoint: "F43E",
    aliases: ["radio-button-checked"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M12,7C9.24,7 7,9.24 7,12C7,14.76 9.24,17 12,17C14.76,17 17,14.76 17,12C17,9.24 14.76,7 12,7Z",
  },
  {
    id: "935371AF-0FF0-4D1E-86F8-DB6E5C5510F9",
    name: "ray-end",
    codepoint: "F440",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M20,9C18.69,9 17.58,9.83 17.17,11H2V13H17.17C17.58,14.17 18.69,15 20,15C21.66,15 23,13.66 23,12C23,10.34 21.66,9 20,9Z",
  },
  {
    id: "16DEE563-B4C3-4B6D-A47F-B23151965007",
    name: "ray-end-arrow",
    codepoint: "F441",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M1,12L5,16V13H17.17C17.58,14.17 18.69,15 20,15C21.66,15 23,13.66 23,12C23,10.34 21.66,9 20,9C18.69,9 17.58,9.83 17.17,11H5V8L1,12Z",
  },
  {
    id: "932F0926-4F5D-4ACA-B4E3-461837361212",
    name: "ray-start",
    codepoint: "F442",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M4,9C5.31,9 6.42,9.83 6.83,11H22V13H6.83C6.42,14.17 5.31,15 4,15C2.34,15 1,13.66 1,12C1,10.34 2.34,9 4,9Z",
  },
  {
    id: "5D6F58F7-61B8-4461-B284-4B0D6B031CA2",
    name: "ray-start-arrow",
    codepoint: "F443",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M23,12L19,16V13H6.83C6.42,14.17 5.31,15 4,15C2.34,15 1,13.66 1,12C1,10.34 2.34,9 4,9C5.31,9 6.42,9.83 6.83,11H19V8L23,12Z",
  },
  {
    id: "0C572F61-2EF1-4F4D-9B53-8FE285BC0BFB",
    name: "ray-start-end",
    codepoint: "F444",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M4,9C5.31,9 6.42,9.83 6.83,11H17.17C17.58,9.83 18.69,9 20,9C21.66,9 23,10.34 23,12C23,13.66 21.66,15 20,15C18.69,15 17.58,14.17 17.17,13H6.83C6.42,14.17 5.31,15 4,15C2.34,15 1,13.66 1,12C1,10.34 2.34,9 4,9Z",
  },
  {
    id: "B391C303-5456-4746-83DD-7862952E281E",
    name: "ray-vertex",
    codepoint: "F445",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M2,11H9.17C9.58,9.83 10.69,9 12,9C13.31,9 14.42,9.83 14.83,11H22V13H14.83C14.42,14.17 13.31,15 12,15C10.69,15 9.58,14.17 9.17,13H2V11Z",
  },
  {
    id: "F13DC81C-DF03-4A33-99D6-489FBDB5B29C",
    name: "react",
    codepoint: "F707",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.8.36",
    path: "M12,10.11C13.03,10.11 13.87,10.95 13.87,12C13.87,13 13.03,13.85 12,13.85C10.97,13.85 10.13,13 10.13,12C10.13,10.95 10.97,10.11 12,10.11M7.37,20C8,20.38 9.38,19.8 10.97,18.3C10.45,17.71 9.94,17.07 9.46,16.4C8.64,16.32 7.83,16.2 7.06,16.04C6.55,18.18 6.74,19.65 7.37,20M8.08,14.26L7.79,13.75C7.68,14.04 7.57,14.33 7.5,14.61C7.77,14.67 8.07,14.72 8.38,14.77C8.28,14.6 8.18,14.43 8.08,14.26M14.62,13.5L15.43,12L14.62,10.5C14.32,9.97 14,9.5 13.71,9.03C13.17,9 12.6,9 12,9C11.4,9 10.83,9 10.29,9.03C10,9.5 9.68,9.97 9.38,10.5L8.57,12L9.38,13.5C9.68,14.03 10,14.5 10.29,14.97C10.83,15 11.4,15 12,15C12.6,15 13.17,15 13.71,14.97C14,14.5 14.32,14.03 14.62,13.5M12,6.78C11.81,7 11.61,7.23 11.41,7.5C11.61,7.5 11.8,7.5 12,7.5C12.2,7.5 12.39,7.5 12.59,7.5C12.39,7.23 12.19,7 12,6.78M12,17.22C12.19,17 12.39,16.77 12.59,16.5C12.39,16.5 12.2,16.5 12,16.5C11.8,16.5 11.61,16.5 11.41,16.5C11.61,16.77 11.81,17 12,17.22M16.62,4C16,3.62 14.62,4.2 13.03,5.7C13.55,6.29 14.06,6.93 14.54,7.6C15.36,7.68 16.17,7.8 16.94,7.96C17.45,5.82 17.26,4.35 16.62,4M15.92,9.74L16.21,10.25C16.32,9.96 16.43,9.67 16.5,9.39C16.23,9.33 15.93,9.28 15.62,9.23C15.72,9.4 15.82,9.57 15.92,9.74M17.37,2.69C18.84,3.53 19,5.74 18.38,8.32C20.92,9.07 22.75,10.31 22.75,12C22.75,13.69 20.92,14.93 18.38,15.68C19,18.26 18.84,20.47 17.37,21.31C15.91,22.15 13.92,21.19 12,19.36C10.08,21.19 8.09,22.15 6.62,21.31C5.16,20.47 5,18.26 5.62,15.68C3.08,14.93 1.25,13.69 1.25,12C1.25,10.31 3.08,9.07 5.62,8.32C5,5.74 5.16,3.53 6.62,2.69C8.09,1.85 10.08,2.81 12,4.64C13.92,2.81 15.91,1.85 17.37,2.69M17.08,12C17.42,12.75 17.72,13.5 17.97,14.26C20.07,13.63 21.25,12.73 21.25,12C21.25,11.27 20.07,10.37 17.97,9.74C17.72,10.5 17.42,11.25 17.08,12M6.92,12C6.58,11.25 6.28,10.5 6.03,9.74C3.93,10.37 2.75,11.27 2.75,12C2.75,12.73 3.93,13.63 6.03,14.26C6.28,13.5 6.58,12.75 6.92,12M15.92,14.26C15.82,14.43 15.72,14.6 15.62,14.77C15.93,14.72 16.23,14.67 16.5,14.61C16.43,14.33 16.32,14.04 16.21,13.75L15.92,14.26M13.03,18.3C14.62,19.8 16,20.38 16.62,20C17.26,19.65 17.45,18.18 16.94,16.04C16.17,16.2 15.36,16.32 14.54,16.4C14.06,17.07 13.55,17.71 13.03,18.3M8.08,9.74C8.18,9.57 8.28,9.4 8.38,9.23C8.07,9.28 7.77,9.33 7.5,9.39C7.57,9.67 7.68,9.96 7.79,10.25L8.08,9.74M10.97,5.7C9.38,4.2 8,3.62 7.37,4C6.74,4.35 6.55,5.82 7.06,7.96C7.83,7.8 8.64,7.68 9.46,7.6C9.94,6.93 10.45,6.29 10.97,5.7Z",
  },
  {
    id: "36EB4754-ADCF-47B6-9863-4EFFB819FC93",
    name: "read",
    codepoint: "F447",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M21.59,11.59L23,13L13.5,22.5L8.42,17.41L9.83,16L13.5,19.68L21.59,11.59M4,16V3H6L9,3C11.21,3 13,4.79 13,7C13,8.54 12.13,9.88 10.85,10.55L14,16H12L9.11,11H6V16H4M6,9H9C10.1,9 11,8.1 11,7C11,5.9 10.1,5 9,5H6V9Z",
  },
  {
    id: "80E9E435-2478-4B48-99B8-D8BEF353AE5F",
    name: "receipt",
    codepoint: "F449",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M3,22L4.5,20.5L6,22L7.5,20.5L9,22L10.5,20.5L12,22L13.5,20.5L15,22L16.5,20.5L18,22L19.5,20.5L21,22V2L19.5,3.5L18,2L16.5,3.5L15,2L13.5,3.5L12,2L10.5,3.5L9,2L7.5,3.5L6,2L4.5,3.5L3,2M18,9H6V7H18M18,13H6V11H18M18,17H6V15H18V17Z",
  },
  {
    id: "F84F1E59-868C-42CE-80EA-159588E83462",
    name: "record",
    codepoint: "F44A",
    aliases: ["fiber-manual-record"],
    tags: ["Home Automation"],
    author: "Cody",
    version: "1.5.54",
    path: "M19,12C19,15.86 15.86,19 12,19C8.14,19 5,15.86 5,12C5,8.14 8.14,5 12,5C15.86,5 19,8.14 19,12Z",
  },
  {
    id: "E62E5C13-5DC0-4881-BBD6-EFDEF13B73BB",
    name: "record-player",
    codepoint: "F999",
    aliases: [],
    tags: ["Home Automation"],
    author: "Austin Andrews",
    version: "2.4.85",
    path: "M5,17.5C5,17.78 4.78,18 4.5,18H3.5C3.22,18 3,17.78 3,17.5V17H2C1.45,17 1,16.55 1,16V13C1,12.45 1.45,12 2,12H19V10H7L6,11V9C6,8.45 6.45,8 7,8H19V7H21V8C21.55,8 22,8.45 22,9V10H21V12H22C22.55,12 23,12.45 23,13V16C23,16.55 22.55,17 22,17H21V17.5C21,17.78 20.78,18 20.5,18H19.5C19.22,18 19,17.78 19,17.5V17H5V17.5M3,14V15H5V14H3M6,14V15H8V14H6M20.5,13.5C19.95,13.5 19.5,13.95 19.5,14.5C19.5,15.05 19.95,15.5 20.5,15.5C21.05,15.5 21.5,15.05 21.5,14.5C21.5,13.95 21.05,13.5 20.5,13.5Z",
  },
  {
    id: "8C452244-41D8-46F9-AF74-665F62EF5E50",
    name: "record-rec",
    codepoint: "F44B",
    aliases: [],
    tags: ["Home Automation"],
    author: "Cody",
    version: "1.5.54",
    path: "M12.5,5C8.36,5 5,8.36 5,12.5C5,16.64 8.36,20 12.5,20C16.64,20 20,16.64 20,12.5C20,8.36 16.64,5 12.5,5M7,10H9C9.55,10 10,10.45 10,11V12C10,12.5 9.62,12.9 9.14,12.97L10.31,15H9.15L8,13V15H7M12,10H14V11H12V12H14V13H12V14H14V15H12C11.45,15 11,14.55 11,14V11C11,10.45 11.45,10 12,10M16,10H18V11H16V14H18V15H16C15.45,15 15,14.55 15,14V11C15,10.45 15.45,10 16,10M8,11V12H9V11",
  },
  {
    id: "93C67522-76EA-4A1D-8C9D-29B0901BE55A",
    name: "recycle",
    codepoint: "F44C",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M21.82,15.42L19.32,19.75C18.83,20.61 17.92,21.06 17,21H15V23L12.5,18.5L15,14V16H17.82L15.6,12.15L19.93,9.65L21.73,12.77C22.25,13.54 22.32,14.57 21.82,15.42M9.21,3.06H14.21C15.19,3.06 16.04,3.63 16.45,4.45L17.45,6.19L19.18,5.19L16.54,9.6L11.39,9.69L13.12,8.69L11.71,6.24L9.5,10.09L5.16,7.59L6.96,4.47C7.37,3.64 8.22,3.06 9.21,3.06M5.05,19.76L2.55,15.43C2.06,14.58 2.13,13.56 2.64,12.79L3.64,11.06L1.91,10.06L7.05,10.14L9.7,14.56L7.97,13.56L6.56,16H11V21H7.4C6.47,21.07 5.55,20.61 5.05,19.76Z",
  },
  {
    id: "8CDBB9B4-921B-47CC-9A06-D0F391666654",
    name: "reddit",
    codepoint: "F44D",
    aliases: [],
    tags: ["Social Media", "Brand / Logo"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M22,11.5C22,10.1 20.9,9 19.5,9C18.9,9 18.3,9.2 17.9,9.6C16.4,8.7 14.6,8.1 12.5,8L13.6,4L17,5C17,6.1 17.9,7 19,7C20.1,7 21,6.1 21,5C21,3.9 20.1,3 19,3C18.3,3 17.6,3.4 17.3,4L13.3,3C13,2.9 12.8,3.1 12.7,3.4L11.5,8C9.5,8.1 7.6,8.7 6.1,9.6C5.7,9.2 5.1,9 4.5,9C3.1,9 2,10.1 2,11.5C2,12.4 2.4,13.1 3.1,13.6L3,14.5C3,18.1 7,21 12,21C17,21 21,18.1 21,14.5L20.9,13.6C21.6,13.1 22,12.4 22,11.5M9,11.8C9.7,11.8 10.2,12.4 10.2,13C10.2,13.6 9.7,14.2 9,14.2C8.3,14.2 7.8,13.7 7.8,13C7.8,12.3 8.3,11.8 9,11.8M15.8,17.2C14,18.3 10,18.3 8.2,17.2C8,17 7.9,16.7 8.1,16.5C8.3,16.3 8.6,16.2 8.8,16.4C10,17.3 14,17.3 15.2,16.4C15.4,16.2 15.7,16.3 15.9,16.5C16.1,16.7 16,17 15.8,17.2M15,14.2C14.3,14.2 13.8,13.6 13.8,13C13.8,12.3 14.4,11.8 15,11.8C15.7,11.8 16.2,12.4 16.2,13C16.2,13.7 15.7,14.2 15,14.2Z",
  },
  {
    id: "7061BAB7-4413-4666-A919-9DD8C4F405F9",
    name: "redo",
    codepoint: "F44E",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M18.4,10.6C16.55,9 14.15,8 11.5,8C6.85,8 2.92,11.03 1.54,15.22L3.9,16C4.95,12.81 7.95,10.5 11.5,10.5C13.45,10.5 15.23,11.22 16.62,12.38L13,16H22V7L18.4,10.6Z",
  },
  {
    id: "72717CF3-6D1D-4032-9799-1F553CAD067E",
    name: "redo-variant",
    codepoint: "F44F",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M10.5,7C6.91,7 4,9.91 4,13.5C4,17.09 6.91,20 10.5,20H14V18H10.5C8,18 6,16 6,13.5C6,11 8,9 10.5,9H16.17L13.09,12.09L14.5,13.5L20,8L14.5,2.5L13.08,3.91L16.17,7H10.5M18,18H16V20H18V18Z",
  },
  {
    id: "345B3651-D634-4069-8D6F-CB4A2CAD63B9",
    name: "reflect-horizontal",
    codepoint: "FA0D",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "2.5.94",
    path: "M22,20H14C13.45,20 13,19.55 13,19V4.97C13,4.5 13.31,4.12 13.74,4C14.19,3.88 14.65,4.08 14.87,4.47L22.89,18.5C23.07,18.81 23.07,19.19 22.89,19.5C22.71,19.81 22.38,20 22,20M2,20C1.62,20 1.29,19.81 1.11,19.5C0.93,19.19 0.93,18.81 1.11,18.5L9.13,4.47C9.35,4.08 9.81,3.88 10.26,4C10.69,4.12 11,4.5 11,4.97V19C11,19.55 10.55,20 10,20H2M9,18V8.74L3.71,18H9Z",
  },
  {
    id: "998E1E1F-98A2-4DA8-9FAD-E31C2677B8D6",
    name: "reflect-vertical",
    codepoint: "FA0E",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "2.5.94",
    path: "M18,23H6C5.61,23 5.26,22.79 5.09,22.45C4.92,22.11 4.96,21.7 5.19,21.4L11.2,13.38C11.58,12.87 12.42,12.87 12.8,13.38L18.81,21.4C19.04,21.7 19.08,22.11 18.91,22.45C18.74,22.79 18.39,23 18,23M18,1C18.39,1 18.74,1.21 18.91,1.55C19.08,1.89 19.04,2.3 18.81,2.6L12.8,10.62C12.42,11.13 11.58,11.13 11.2,10.62L5.19,2.6C4.96,2.3 4.92,1.89 5.09,1.55C5.26,1.21 5.61,1 6,1H18M8,3L12,8.35L16,3H8Z",
  },
  {
    id: "AD3C7A2B-0B64-4183-9452-C96EAAF3E08E",
    name: "refresh",
    codepoint: "F450",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M17.65,6.35C16.2,4.9 14.21,4 12,4C7.58,4 4,7.58 4,12C4,16.42 7.58,20 12,20C15.73,20 18.84,17.45 19.73,14H17.65C16.83,16.33 14.61,18 12,18C8.69,18 6,15.31 6,12C6,8.69 8.69,6 12,6C13.66,6 15.14,6.69 16.22,7.78L13,11H20V4L17.65,6.35Z",
  },
  {
    id: "3313CE4A-E2EF-4E46-8110-C0BF297D0C16",
    name: "regex",
    codepoint: "F451",
    aliases: [],
    tags: [],
    author: "Doug C. Hardester",
    version: "1.5.54",
    path: "M16,16.92C15.67,16.97 15.34,17 15,17C14.66,17 14.33,16.97 14,16.92V13.41L11.5,15.89C11,15.5 10.5,15 10.11,14.5L12.59,12H9.08C9.03,11.67 9,11.34 9,11C9,10.66 9.03,10.33 9.08,10H12.59L10.11,7.5C10.3,7.25 10.5,7 10.76,6.76V6.76C11,6.5 11.25,6.3 11.5,6.11L14,8.59V5.08C14.33,5.03 14.66,5 15,5C15.34,5 15.67,5.03 16,5.08V8.59L18.5,6.11C19,6.5 19.5,7 19.89,7.5L17.41,10H20.92C20.97,10.33 21,10.66 21,11C21,11.34 20.97,11.67 20.92,12H17.41L19.89,14.5C19.7,14.75 19.5,15 19.24,15.24V15.24C19,15.5 18.75,15.7 18.5,15.89L16,13.41V16.92H16V16.92M5,19C5,17.9 5.9,17 7,17C8.1,17 9,17.9 9,19C9,20.1 8.1,21 7,21C5.9,21 5,20.1 5,19H5Z",
  },
  {
    id: "912AD329-9B77-4959-9407-0F64BABFAC7D",
    name: "relative-scale",
    codepoint: "F452",
    aliases: ["image-aspect-ratio"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M20,18H4V6H20M20,4H4C2.89,4 2,4.89 2,6V18C2,19.1 2.9,20 4,20H20C21.1,20 22,19.1 22,18V6C22,4.89 21.1,4 20,4M12,10H10V12H12M8,10H6V12H8M16,14H14V16H16M16,10H14V12H16V10Z",
  },
  {
    id: "8E25B2CE-4DAF-4BD1-9D3F-27F86DA55D21",
    name: "reload",
    codepoint: "F453",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M19,12H22.32L17.37,16.95L12.42,12H16.97C17,10.46 16.42,8.93 15.24,7.75C12.9,5.41 9.1,5.41 6.76,7.75C4.42,10.09 4.42,13.9 6.76,16.24C8.6,18.08 11.36,18.47 13.58,17.41L15.05,18.88C12,20.69 8,20.29 5.34,17.65C2.22,14.53 2.23,9.47 5.35,6.35C8.5,3.22 13.53,3.21 16.66,6.34C18.22,7.9 19,9.95 19,12Z",
  },
  {
    id: "1BD93F0A-87D1-4B55-A0EF-D9F05A8B3826",
    name: "reminder",
    codepoint: "F88B",
    aliases: [],
    tags: [],
    author: "Google",
    version: "2.1.99",
    path: "M7.25,3C7.9,3 8.5,3.21 9,3.56V3C9,1.9 9.9,1 11,1C12.1,1 13,1.9 13,3V3.57C13.5,3.22 14.1,3 14.75,3C16.41,3 17.75,4.34 17.75,6C17.75,7.58 16.54,8.87 15,9H13V10H14.24L14.72,10.13L19.31,12.42C20.13,12.73 20.53,13.34 20.53,14.25L20.5,14.39V14.53L19.5,21.28C19.44,21.75 19.22,22.16 18.84,22.5C18.47,22.84 18.05,23 17.58,23H10C9.45,23 9,22.81 8.58,22.41L2,15.84L3.05,14.77C3.33,14.5 3.69,14.34 4.13,14.34H4.45L9,15.33V10L9,9H7V9C5.46,8.86 4.25,7.57 4.25,6C4.25,4.34 5.59,3 7.25,3M9,6C9,5.03 8.22,4.25 7.25,4.25C6.28,4.25 5.5,5.03 5.5,6C5.5,6.88 6.15,7.61 7,7.73V7.75H9V6M15,7.75V7.74C15.85,7.62 16.5,6.89 16.5,6C16.5,5.04 15.72,4.26 14.75,4.26C13.78,4.26 13,5.04 13,6V7.75H15Z",
  },
  {
    id: "49C7BBC2-6C7F-442E-A6EE-B58AB758A8D4",
    name: "remote",
    codepoint: "F454",
    aliases: ["settings-remote"],
    tags: ["Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M12,0C8.96,0 6.21,1.23 4.22,3.22L5.63,4.63C7.26,3 9.5,2 12,2C14.5,2 16.74,3 18.36,4.64L19.77,3.23C17.79,1.23 15.04,0 12,0M7.05,6.05L8.46,7.46C9.37,6.56 10.62,6 12,6C13.38,6 14.63,6.56 15.54,7.46L16.95,6.05C15.68,4.78 13.93,4 12,4C10.07,4 8.32,4.78 7.05,6.05M12,15C10.9,15 10,14.1 10,13C10,11.9 10.9,11 12,11C13.1,11 14,11.9 14,13C14,14.1 13.1,15 12,15M15,9H9C8.45,9 8,9.45 8,10V22C8,22.55 8.45,23 9,23H15C15.55,23 16,22.55 16,22V10C16,9.45 15.55,9 15,9Z",
  },
  {
    id: "A237199B-0B22-475F-93D1-DB45FA4D3205",
    name: "remote-desktop",
    codepoint: "F8B8",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "2.2.43",
    path: "M3,2C1.9,2 1,2.9 1,4V16C1,17.11 1.9,18 3,18H10V20H8V22H16V20H14V18H21C22.1,18 23,17.1 23,16V4C23,2.9 22.1,2 21,2M3,4H21V16H3M15,5L11.5,8.5L15,12L16.4,10.6L14.3,8.5L16.4,6.4M9,8L7.6,9.4L9.7,11.5L7.6,13.6L9,15L12.5,11.5",
  },
  {
    id: "1DFADA84-47E4-40EF-B1F8-D0A34D1482BA",
    name: "rename-box",
    codepoint: "F455",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M18,17H10.5L12.5,15H18M6,17V14.5L13.88,6.65C14.07,6.45 14.39,6.45 14.59,6.65L16.35,8.41C16.55,8.61 16.55,8.92 16.35,9.12L8.47,17M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3Z",
  },
  {
    id: "08CB23B7-EC19-4FE5-9CBB-C308CC89C10B",
    name: "reorder-horizontal",
    codepoint: "F687",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.7.12",
    path: "M3,15H21V13H3V15M3,19H21V17H3V19M3,11H21V9H3V11M3,5V7H21V5H3Z",
  },
  {
    id: "F189DB12-9323-47A1-89C9-451EF2A886CB",
    name: "reorder-vertical",
    codepoint: "F688",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.7.12",
    path: "M9,3V21H11V3H9M5,3V21H7V3H5M13,3V21H15V3H13M19,3H17V21H19V3Z",
  },
  {
    id: "9AEE0CB7-46B9-414F-A8A8-AFB127CB7057",
    name: "repeat",
    codepoint: "F456",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M17,17H7V14L3,18L7,22V19H19V13H17M7,7H17V10L21,6L17,2V5H5V11H7V7Z",
  },
  {
    id: "06540FC6-0AF2-40C7-895A-B8C98BD143D1",
    name: "repeat-off",
    codepoint: "F457",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M2,5.27L3.28,4L20,20.72L18.73,22L15.73,19H7V22L3,18L7,14V17H13.73L7,10.27V11H5V8.27L2,5.27M17,13H19V17.18L17,15.18V13M17,5V2L21,6L17,10V7H8.82L6.82,5H17Z",
  },
  {
    id: "D27E266C-5F69-4E4F-9DE3-65A47B5208F5",
    name: "repeat-once",
    codepoint: "F458",
    aliases: ["repeat-one"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M13,15V9H12L10,10V11H11.5V15M17,17H7V14L3,18L7,22V19H19V13H17M7,7H17V10L21,6L17,2V5H5V11H7V7Z",
  },
  {
    id: "A15D2CB0-E938-4894-8BF3-BC6C628E6433",
    name: "replay",
    codepoint: "F459",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M12,5V1L7,6L12,11V7C15.31,7 18,9.69 18,13C18,16.31 15.31,19 12,19C8.69,19 6,16.31 6,13H4C4,17.42 7.58,21 12,21C16.42,21 20,17.42 20,13C20,8.58 16.42,5 12,5Z",
  },
  {
    id: "CC3BEE2C-0FEA-46D2-BC53-F7D248AAF47C",
    name: "reply",
    codepoint: "F45A",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M10,9V5L3,12L10,19V14.9C15,14.9 18.5,16.5 21,20C20,15 17,10 10,9Z",
  },
  {
    id: "0BDA0697-946D-4B4C-AD02-2FC6ECA4A528",
    name: "reply-all",
    codepoint: "F45B",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M13,9V5L6,12L13,19V14.9C18,14.9 21.5,16.5 24,20C23,15 20,10 13,9M7,8V5L0,12L7,19V16L3,12L7,8Z",
  },
  {
    id: "A522A51F-EE61-473F-97D6-9D5106FD11CA",
    name: "reproduction",
    codepoint: "F45C",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12.72,13.15L13.62,12.26C13.6,11 14.31,9.44 15.62,8.14C17.57,6.18 20.11,5.55 21.28,6.72C22.45,7.89 21.82,10.43 19.86,12.38C18.56,13.69 17,14.4 15.74,14.38L14.85,15.28C14.5,15.61 14,15.66 13.6,15.41C12.76,15.71 12,16.08 11.56,16.8C11.03,17.68 11.03,19.1 10.47,19.95C9.91,20.81 8.79,21.1 7.61,21.1C6.43,21.1 5,21 3.95,19.5L6.43,19.92C7,20 8.5,19.39 9.05,18.54C9.61,17.68 9.61,16.27 10.14,15.38C10.61,14.6 11.5,14.23 12.43,13.91C12.42,13.64 12.5,13.36 12.72,13.15M7,2C9.76,2 12,4.24 12,7C12,9.76 9.76,12 7,12C4.24,12 2,9.76 2,7C2,4.24 4.24,2 7,2M7,4C5.34,4 4,5.34 4,7C4,8.66 5.34,10 7,10C8.66,10 10,8.66 10,7C10,5.34 8.66,4 7,4Z",
  },
  {
    id: "84916A68-B413-4D71-B4E7-5FD64914B354",
    name: "resize-bottom-right",
    codepoint: "F45D",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M22,22H20V20H22V22M22,18H20V16H22V18M18,22H16V20H18V22M18,18H16V16H18V18M14,22H12V20H14V22M22,14H20V12H22V14Z",
  },
  {
    id: "0C72C131-779D-460F-A059-B9DF2B79E40C",
    name: "responsive",
    codepoint: "F45E",
    aliases: [],
    tags: [],
    author: "Gabriel",
    version: "1.5.54",
    path: "M4,6V16H9V12C9,10.9 9.9,10 11,10H16C17.1,10 18,10.9 18,12V16H20V6H4M0,20V18H4C2.9,18 2,17.1 2,16V6C2,4.9 2.9,4 4,4H20C21.1,4 22,4.9 22,6V16C22,17.1 21.1,18 20,18H24V20H18V20C18,21.11 17.1,22 16,22H11C9.9,22 9,21.1 9,20H9L0,20M11.5,20C11.22,20 11,20.22 11,20.5C11,20.78 11.22,21 11.5,21C11.78,21 12,20.78 12,20.5C12,20.22 11.78,20 11.5,20M15.5,20C15.22,20 15,20.22 15,20.5C15,20.78 15.22,21 15.5,21C15.78,21 16,20.78 16,20.5C16,20.22 15.78,20 15.5,20M13,20V21H14V20H13M11,12V19H16V12H11Z",
  },
  {
    id: "15954B5D-3ADA-4B6B-BE15-F95B6A5D4659",
    name: "restart",
    codepoint: "F708",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.8.36",
    path: "M11,4C13.05,4 15.09,4.77 16.65,6.33C19.78,9.46 19.77,14.5 16.64,17.64C14.81,19.5 12.3,20.24 9.91,19.92L10.44,17.96C12.15,18.12 13.93,17.54 15.24,16.23C17.58,13.89 17.58,10.09 15.24,7.75C14.06,6.57 12.53,6 11,6V10.58L6.04,5.63L11,0.68V4M5.34,17.65C2.7,15 2.3,11 4.11,7.94L5.59,9.41C4.5,11.64 4.91,14.39 6.75,16.23C7.27,16.75 7.87,17.16 8.5,17.45L8,19.4C7,19 6.12,18.43 5.34,17.65Z",
  },
  {
    id: "FF1CAAB4-2192-442F-88F1-08DEB67E21F0",
    name: "restore",
    codepoint: "F99A",
    aliases: [],
    tags: [],
    author: "Google",
    version: "2.4.85",
    path: "M13,3C8.03,3 4,7.03 4,12H1L4.89,15.89L4.96,16.03L9,12H6C6,8.13 9.13,5 13,5C16.87,5 20,8.13 20,12C20,15.87 16.87,19 13,19C11.07,19 9.32,18.21 8.06,16.94L6.64,18.36C8.27,20 10.5,21 13,21C17.97,21 22,16.97 22,12C22,7.03 17.97,3 13,3Z",
  },
  {
    id: "28BCDF41-AA93-4C25-B87A-95A3F5DD8805",
    name: "rewind",
    codepoint: "F45F",
    aliases: ["fast-rewind"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M11.5,12L20,18V6M11,18V6L2.5,12L11,18Z",
  },
  {
    id: "61E83433-F6D1-442D-9EDE-EDEF27AB789D",
    name: "rewind-outline",
    codepoint: "F709",
    aliases: [],
    tags: [],
    author: "Michael Irigoyen",
    version: "1.8.36",
    path: "M10,9.9L7,12L10,14.1V9.9M19,9.9L16,12L19,14.1V9.9M12,6V18L3.5,12L12,6M21,6V18L12.5,12L21,6Z",
  },
  {
    id: "68CFD178-A6FE-4DB5-9C39-FCA6A3EA83A5",
    name: "rhombus",
    codepoint: "F70A",
    aliases: ["diamond"],
    tags: ["Shape"],
    author: "Michael Irigoyen",
    version: "1.8.36",
    path: "M21.5,10.8L13.2,2.5C12.5,1.8 11.5,1.8 10.8,2.5L2.5,10.8C1.8,11.5 1.8,12.5 2.5,13.2L10.8,21.5C11.5,22.2 12.5,22.2 13.2,21.5L21.5,13.2C22.1,12.5 22.1,11.5 21.5,10.8Z",
  },
  {
    id: "F6FA48B9-85C9-4287-8883-6A549AC290D2",
    name: "rhombus-medium",
    codepoint: "FA0F",
    aliases: [],
    tags: [],
    author: "Michael Irigoyen",
    version: "2.5.94",
    path: "M17.23,11.34L12.68,6.79C12.3,6.4 11.75,6.4 11.36,6.79L6.81,11.34C6.42,11.73 6.42,12.28 6.81,12.66L11.36,17.21C11.75,17.6 12.3,17.6 12.68,17.21L17.23,12.66C17.56,12.27 17.56,11.73 17.23,11.34Z",
  },
  {
    id: "101A7558-A38E-48E8-93EA-A21F37238E78",
    name: "rhombus-outline",
    codepoint: "F70B",
    aliases: ["diamond-outline"],
    tags: ["Shape"],
    author: "Michael Irigoyen",
    version: "1.8.36",
    path: "M21.5,10.8L13.2,2.5C12.5,1.8 11.5,1.8 10.8,2.5L2.5,10.8C1.8,11.5 1.8,12.5 2.5,13.2L10.8,21.5C11.5,22.2 12.5,22.2 13.2,21.5L21.5,13.2C22.1,12.5 22.1,11.5 21.5,10.8M20.3,12L12,20.3L3.7,12L12,3.7L20.3,12Z",
  },
  {
    id: "A19BB3EC-ED3D-41C6-9088-ACB372959E01",
    name: "rhombus-split",
    codepoint: "FA10",
    aliases: [],
    tags: [],
    author: "Michael Irigoyen",
    version: "2.5.94",
    path: "M7.36,5.94L10.8,2.5C11.5,1.8 12.5,1.8 13.2,2.5L16.64,5.94L12,10.59L7.36,5.94M18.06,7.36L13.41,12L18.06,16.64L21.5,13.2C22.1,12.5 22.1,11.5 21.5,10.8L18.06,7.36M5.94,16.64L10.59,12L5.94,7.36L2.5,10.8C1.8,11.5 1.8,12.5 2.5,13.2L5.94,16.64M12,13.41L7.36,18.06L10.8,21.5C11.5,22.2 12.5,22.2 13.2,21.5L16.64,18.06L12,13.41Z",
  },
  {
    id: "1C09CB9B-162B-486B-966C-1FCB18C0F633",
    name: "ribbon",
    codepoint: "F460",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M13.41,19.31L16.59,22.5L18,21.07L14.83,17.9M15.54,11.53H15.53L12,15.07L8.47,11.53H8.46V11.53C7.56,10.63 7,9.38 7,8C7,5.24 9.24,3 12,3C14.76,3 17,5.24 17,8C17,9.38 16.44,10.63 15.54,11.53M16.9,13C18.2,11.73 19,9.96 19,8C19,4.13 15.87,1 12,1C8.13,1 5,4.13 5,8C5,9.96 5.81,11.73 7.1,13V13L10.59,16.5L6,21.07L7.41,22.5L16.9,13Z",
  },
  {
    id: "B90B4B7C-9FDD-427A-834C-F3DFB5EC1823",
    name: "rice",
    codepoint: "F7E9",
    aliases: [],
    tags: ["Food / Drink"],
    author: "Colton Wiscombe",
    version: "2.0.46",
    path: "M22,11H19.7C19.4,9.9 18.9,8.8 18.2,8L21.6,2.6L19.9,1.5L16.7,6.6C16.3,6.3 16,6.1 15.5,5.9L16.4,2.3L14.5,1.8L13.7,5.2C13.1,5.1 12.6,5 12,5C8.3,5 5.2,7.6 4.3,11H2C2,15.1 4.5,18.6 8,20.2V22H16V20.2C19.5,18.6 22,15.1 22,11M12,7C14.6,7 16.8,8.7 17.6,11H6.4C7.2,8.7 9.4,7 12,7Z",
  },
  {
    id: "7D845AED-5EA2-44C0-8F38-6A2C4E08C8A3",
    name: "ring",
    codepoint: "F7EA",
    aliases: [],
    tags: [],
    author: "Colton Wiscombe",
    version: "2.0.46",
    path: "M12,10L8,4.4L9.6,2H14.4L16,4.4L12,10M15.5,6.8L14.3,8.5C16.5,9.4 18,11.5 18,14C18,17.31 15.31,20 12,20C8.69,20 6,17.31 6,14C6,11.5 7.5,9.4 9.7,8.5L8.5,6.8C5.8,8.1 4,10.8 4,14C4,18.42 7.58,22 12,22C16.42,22 20,18.42 20,14C20,10.8 18.2,8.1 15.5,6.8Z",
  },
  {
    id: "2AA1C93A-17BE-4BB6-A85C-C477A4FF1069",
    name: "road",
    codepoint: "F461",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M11,16H13V20H11M11,10H13V14H11M11,4H13V8H11M4,22H20V2H4V22Z",
  },
  {
    id: "0BBDD64A-3C67-43DD-9B3A-580E12DDA2D7",
    name: "road-variant",
    codepoint: "F462",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M18.1,4.8C18,4.3 17.6,4 17.1,4H13L13.2,7H10.8L11,4H6.8C6.3,4 5.9,4.4 5.8,4.8L3.1,18.8C3,19.4 3.5,20 4.1,20H10L10.3,15H13.7L14,20H19.8C20.4,20 20.9,19.4 20.8,18.8L18.1,4.8M10.4,13L10.6,9H13.2L13.4,13H10.4Z",
  },
  {
    id: "EC6C8D3D-0315-4C3A-B37A-97411758DF34",
    name: "robot",
    codepoint: "F6A8",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "1.7.12",
    path: "M12,2C13.1,2 14,2.9 14,4C14,4.74 13.6,5.39 13,5.73V7H14C17.87,7 21,10.13 21,14H22C22.55,14 23,14.45 23,15V18C23,18.55 22.55,19 22,19H21V20C21,21.1 20.1,22 19,22H5C3.9,22 3,21.1 3,20V19H2C1.45,19 1,18.55 1,18V15C1,14.45 1.45,14 2,14H3C3,10.13 6.13,7 10,7H11V5.73C10.4,5.39 10,4.74 10,4C10,2.9 10.9,2 12,2M7.5,13C6.12,13 5,14.12 5,15.5C5,16.88 6.12,18 7.5,18C8.88,18 10,16.88 10,15.5C10,14.12 8.88,13 7.5,13M16.5,13C15.12,13 14,14.12 14,15.5C14,16.88 15.12,18 16.5,18C17.88,18 19,16.88 19,15.5C19,14.12 17.88,13 16.5,13Z",
  },
  {
    id: "E091C285-7AA8-4907-9398-EBFDAC7A179D",
    name: "robot-vacuum",
    codepoint: "F70C",
    aliases: ["roomba"],
    tags: ["Device / Tech", "Home Automation"],
    author: "Roberto Graham",
    version: "1.8.36",
    path: "M12,2C14.65,2 17.19,3.06 19.07,4.93L17.65,6.35C16.15,4.85 14.12,4 12,4C9.88,4 7.84,4.84 6.35,6.35L4.93,4.93C6.81,3.06 9.35,2 12,2M3.66,6.5L5.11,7.94C4.39,9.17 4,10.57 4,12C4,16.42 7.58,20 12,20C16.42,20 20,16.42 20,12C20,10.57 19.61,9.17 18.88,7.94L20.34,6.5C21.42,8.12 22,10.04 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,10.04 2.58,8.12 3.66,6.5M12,6C15.31,6 18,8.69 18,12C18,13.59 17.37,15.12 16.24,16.24L14.83,14.83C14.08,15.58 13.06,16 12,16C10.94,16 9.92,15.58 9.17,14.83L7.76,16.24C6.63,15.12 6,13.59 6,12C6,8.69 8.69,6 12,6M12,8C11.45,8 11,8.45 11,9C11,9.55 11.45,10 12,10C12.55,10 13,9.55 13,9C13,8.45 12.55,8 12,8Z",
  },
  {
    id: "C7938632-FA58-4686-9B82-5E9CCDD0EC83",
    name: "robot-vacuum-variant",
    codepoint: "F907",
    aliases: ["neato"],
    tags: ["Home Automation"],
    author: "GreenTurtwig",
    version: "2.3.50",
    path: "M5,3C3.9,3 3,3.9 3,5V7H5V5H19V7H21V5C21,3.9 20.1,3 19,3H5M8,7V9H16V7H8M3,9V12C3,16.97 7.03,21 12,21C16.97,21 21,16.97 21,12V9H19V12C19,15.87 15.87,19 12,19C8.13,19 5,15.87 5,12V9H3M12,12C10.62,12 9.5,13.12 9.5,14.5C9.5,15.88 10.62,17 12,17C13.38,17 14.5,15.88 14.5,14.5C14.5,13.12 13.38,12 12,12Z",
  },
  {
    id: "96BE0E43-42AB-4F93-8045-0C7B61BF69CC",
    name: "rocket",
    codepoint: "F463",
    aliases: [],
    tags: ["Transportation + Flying"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M2.81,14.12L5.64,11.29L8.17,10.79C11.39,6.41 17.55,4.22 19.78,4.22C19.78,6.45 17.59,12.61 13.21,15.83L12.71,18.36L9.88,21.19L9.17,17.66C7.76,17.66 7.76,17.66 7.05,16.95C6.34,16.24 6.34,16.24 6.34,14.83L2.81,14.12M5.64,16.95L7.05,18.36L4.39,21.03H2.97V19.61L5.64,16.95M4.22,15.54L5.46,15.71L3,18.16V16.74L4.22,15.54M8.29,18.54L8.46,19.78L7.26,21H5.84L8.29,18.54M13,9.5C12.17,9.5 11.5,10.17 11.5,11C11.5,11.83 12.17,12.5 13,12.5C13.83,12.5 14.5,11.83 14.5,11C14.5,10.17 13.83,9.5 13,9.5Z",
  },
  {
    id: "C525BD2B-2BA8-4158-AC0A-FAEE9E353047",
    name: "room-service",
    codepoint: "F88C",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.1.99",
    path: "M2,17H22V19H2V17M13.84,7.79C13.94,7.54 14,7.27 14,7C14,5.9 13.1,5 12,5C10.9,5 10,5.9 10,7C10,7.27 10.06,7.54 10.16,7.79C6.2,8.61 3.27,11.97 3,16H21C20.73,11.97 17.8,8.61 13.84,7.79Z",
  },
  {
    id: "D09D0551-14A0-470B-A24C-0AC38F739FFA",
    name: "rotate-3d",
    codepoint: "F464",
    aliases: ["3d-rotation"],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,5C16.97,5 21,7.69 21,11C21,12.68 19.96,14.2 18.29,15.29C19.36,14.42 20,13.32 20,12.13C20,9.29 16.42,7 12,7V10L8,6L12,2V5M12,19C7.03,19 3,16.31 3,13C3,11.32 4.04,9.8 5.71,8.71C4.64,9.58 4,10.68 4,11.88C4,14.71 7.58,17 12,17V14L16,18L12,22V19Z",
  },
  {
    id: "1E960D83-0632-47D2-8CC9-D8A137887BAB",
    name: "rotate-left",
    codepoint: "F465",
    aliases: ["arrow-rotate-left"],
    tags: ["Arrow"],
    author: "Google",
    version: "1.5.54",
    path: "M13,4.07V1L8.45,5.55L13,10V6.09C15.84,6.57 18,9.03 18,12C18,14.97 15.84,17.43 13,17.91V19.93C16.95,19.44 20,16.08 20,12C20,7.92 16.95,4.56 13,4.07M7.1,18.32C8.26,19.22 9.61,19.76 11,19.93V17.9C10.13,17.75 9.29,17.41 8.54,16.87L7.1,18.32M6.09,13H4.07C4.24,14.39 4.79,15.73 5.69,16.89L7.1,15.47C6.58,14.72 6.23,13.88 6.09,13M7.11,8.53L5.7,7.11C4.8,8.27 4.24,9.61 4.07,11H6.09C6.23,10.13 6.58,9.28 7.11,8.53Z",
  },
  {
    id: "CC6E0E23-9F7B-40F5-B00F-0690A5F7B400",
    name: "rotate-left-variant",
    codepoint: "F466",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M4,2H7C8.1,2 9,2.9 9,4V20C9,21.1 8.1,22 7,22H4C2.9,22 2,21.1 2,20V4C2,2.9 2.9,2 4,2M20,15C21.1,15 22,15.9 22,17V20C22,21.1 21.1,22 20,22H11V15H20M14,4C18.42,4 22,7.58 22,12L21.94,13H19.92L20,12C20,8.69 17.31,6 14,6V9L10,5L14,1V4Z",
  },
  {
    id: "5324E881-FACF-4CAC-9118-FD963EDCDD27",
    name: "rotate-right",
    codepoint: "F467",
    aliases: ["arrow-rotate-right"],
    tags: ["Arrow"],
    author: "Google",
    version: "1.5.54",
    path: "M16.89,15.5L18.31,16.89C19.21,15.73 19.76,14.39 19.93,13H17.91C17.77,13.87 17.43,14.72 16.89,15.5M13,17.9V19.92C14.39,19.75 15.74,19.21 16.9,18.31L15.46,16.87C14.71,17.41 13.87,17.76 13,17.9M19.93,11C19.76,9.61 19.21,8.27 18.31,7.11L16.89,8.53C17.43,9.28 17.77,10.13 17.91,11M15.55,5.55L11,1V4.07C7.06,4.56 4,7.92 4,12C4,16.08 7.05,19.44 11,19.93V17.91C8.16,17.43 6,14.97 6,12C6,9.03 8.16,6.57 11,6.09V10L15.55,5.55Z",
  },
  {
    id: "02105B39-715B-4989-93DC-1DDC338A4552",
    name: "rotate-right-variant",
    codepoint: "F468",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M10,4V1L14,5L10,9V6C6.69,6 4,8.69 4,12L4.08,13H2.06L2,12C2,7.58 5.58,4 10,4M17,2H20C21.1,2 22,2.9 22,4V20C22,21.1 21.1,22 20,22H17C15.9,22 15,21.1 15,20V4C15,2.9 15.9,2 17,2M4,15H13V22H4C2.9,22 2,21.1 2,20V17C2,15.9 2.9,15 4,15Z",
  },
  {
    id: "FEBD153A-F07E-4329-A727-D75F13F3133D",
    name: "rounded-corner",
    codepoint: "F607",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M19,19H21V21H19V19M19,17H21V15H19V17M3,13H5V11H3V13M3,17H5V15H3V17M3,9H5V7H3V9M3,5H5V3H3V5M7,5H9V3H7V5M15,21H17V19H15V21M11,21H13V19H11V21M15,21H17V19H15V21M7,21H9V19H7V21M3,21H5V19H3V21M21,8C21,5.24 18.76,3 16,3H11V5H16C17.66,5 19,6.34 19,8V13H21V8Z",
  },
  {
    id: "3244EAC8-8349-4CFB-BE35-A0812368CEDA",
    name: "router-wireless",
    codepoint: "F469",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M4,13H20C20.55,13 21,13.45 21,14V18C21,18.55 20.55,19 20,19H4C3.45,19 3,18.55 3,18V14C3,13.45 3.45,13 4,13M9,17H10V15H9V17M5,15V17H7V15H5M19,6.93L17.6,8.34C16.15,6.89 14.15,6 11.93,6C9.72,6 7.72,6.89 6.27,8.34L4.87,6.93C6.68,5.12 9.18,4 11.93,4C14.69,4 17.19,5.12 19,6.93M16.17,9.76L14.77,11.17C14.04,10.45 13.04,10 11.93,10C10.82,10 9.82,10.45 9.1,11.17L7.7,9.76C8.78,8.67 10.28,8 11.93,8C13.58,8 15.08,8.67 16.17,9.76Z",
  },
  {
    id: "4E7234E7-AB5F-491D-BA6F-674B3BAD9027",
    name: "routes",
    codepoint: "F46A",
    aliases: ["sign-routes"],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M11,10H5L3,8L5,6H11V3L12,2L13,3V4H19L21,6L19,8H13V10H19L21,12L19,14H13V20C14.1,20 15,20.9 15,22H9C9,20.9 9.9,20 11,20V10Z",
  },
  {
    id: "72F11BA0-1557-4500-8235-2E3F2346FE69",
    name: "rowing",
    codepoint: "F608",
    aliases: [],
    tags: ["Sport"],
    author: "Google",
    version: "1.5.54",
    path: "M8.5,14.5L4,19L5.5,20.5L9,17H11L8.5,14.5M15,1C13.9,1 13,1.9 13,3C13,4.1 13.9,5 15,5C16.1,5 17,4.1 17,3C17,1.9 16.1,1 15,1M21,21L18,24L15,21V19.5L7.91,12.41C7.6,12.46 7.3,12.5 7,12.5V10.32C8.66,10.35 10.61,9.45 11.67,8.28L13.07,6.73C13.26,6.5 13.5,6.35 13.76,6.23C14.05,6.09 14.38,6 14.72,6H14.75C16,6 17,7 17,8.26V14C17,14.85 16.65,15.62 16.08,16.17L12.5,12.59V10.32C11.87,10.84 11.07,11.34 10.21,11.71L16.5,18H18L21,21Z",
  },
  {
    id: "9E877D76-9BC5-496D-99E4-1E6029DE1B4D",
    name: "rss",
    codepoint: "F46B",
    aliases: ["rss-feed"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M6.18,15.64C7.38,15.64 8.36,16.62 8.36,17.82C8.36,19 7.38,20 6.18,20C5,20 4,19 4,17.82C4,16.62 4.98,15.64 6.18,15.64M4,4.44C12.59,4.44 19.56,11.41 19.56,20H16.73C16.73,12.97 11.03,7.27 4,7.27V4.44M4,10.1C9.47,10.1 13.9,14.53 13.9,20H11.07C11.07,16.1 7.9,12.93 4,12.93V10.1Z",
  },
  {
    id: "649343BD-3C91-43EA-9000-AE10520CAA2D",
    name: "rss-box",
    codepoint: "F46C",
    aliases: [],
    tags: [],
    author: "Gabriel",
    version: "1.5.54",
    path: "M5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3M7.5,15C6.67,15 6,15.67 6,16.5C6,17.33 6.67,18 7.5,18C8.33,18 9,17.33 9,16.5C9,15.67 8.33,15 7.5,15M6,10V12C9.31,12 12,14.69 12,18H14C14,13.58 10.42,10 6,10M6,6V8C11.52,8 16,12.48 16,18H18C18,11.37 12.63,6 6,6Z",
  },
  {
    id: "66A2EA92-0743-4740-B3F2-254C38E9027F",
    name: "ruler",
    codepoint: "F46D",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M1.39,18.36L3.16,16.6L4.58,18L5.64,16.95L4.22,15.54L5.64,14.12L8.11,16.6L9.17,15.54L6.7,13.06L8.11,11.65L9.53,13.06L10.59,12L9.17,10.59L10.59,9.17L13.06,11.65L14.12,10.59L11.65,8.11L13.06,6.7L14.47,8.11L15.54,7.05L14.12,5.64L15.54,4.22L18,6.7L19.07,5.64L16.6,3.16L18.36,1.39L22.61,5.64L5.64,22.61L1.39,18.36Z",
  },
  {
    id: "2A869029-60EB-4965-9BE4-9B3DB964C707",
    name: "run",
    codepoint: "F70D",
    aliases: ["directions-run"],
    tags: ["Sport"],
    author: "Google",
    version: "1.8.36",
    path: "M13.5,5.5C14.59,5.5 15.5,4.58 15.5,3.5C15.5,2.38 14.59,1.5 13.5,1.5C12.39,1.5 11.5,2.38 11.5,3.5C11.5,4.58 12.39,5.5 13.5,5.5M9.89,19.38L10.89,15L13,17V23H15V15.5L12.89,13.5L13.5,10.5C14.79,12 16.79,13 19,13V11C17.09,11 15.5,10 14.69,8.58L13.69,7C13.29,6.38 12.69,6 12,6C11.69,6 11.5,6.08 11.19,6.08L6,8.28V13H8V9.58L9.79,8.88L8.19,17L3.29,16L2.89,18L9.89,19.38Z",
  },
  {
    id: "D541EB73-227A-419B-A5F7-7242EB02D916",
    name: "run-fast",
    codepoint: "F46E",
    aliases: [],
    tags: ["Home Automation", "Sport"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M16.5,5.5C17.6,5.5 18.5,4.6 18.5,3.5C18.5,2.4 17.6,1.5 16.5,1.5C15.4,1.5 14.5,2.4 14.5,3.5C14.5,4.6 15.4,5.5 16.5,5.5M12.9,19.4L13.9,15L16,17V23H18V15.5L15.9,13.5L16.5,10.5C17.89,12.09 19.89,13 22,13V11C20.24,11.03 18.6,10.11 17.7,8.6L16.7,7C16.34,6.4 15.7,6 15,6C14.7,6 14.5,6.1 14.2,6.1L9,8.3V13H11V9.6L12.8,8.9L11.2,17L6.3,16L5.9,18L12.9,19.4M4,9C3.45,9 3,8.55 3,8C3,7.45 3.45,7 4,7H7V9H4M5,5C4.45,5 4,4.55 4,4C4,3.45 4.45,3 5,3H10V5H5M3,13C2.45,13 2,12.55 2,12C2,11.45 2.45,11 3,11H7V13H3Z",
  },
  {
    id: "688543EC-EC01-474C-883C-C2EA2EDE75BF",
    name: "sale",
    codepoint: "F46F",
    aliases: ["discount"],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M18.65,2.85L19.26,6.71L22.77,8.5L21,12L22.78,15.5L19.24,17.29L18.63,21.15L14.74,20.54L11.97,23.3L9.19,20.5L5.33,21.14L4.71,17.25L1.22,15.47L3,11.97L1.23,8.5L4.74,6.69L5.35,2.86L9.22,3.5L12,0.69L14.77,3.46L18.65,2.85M9.5,7C8.67,7 8,7.67 8,8.5C8,9.33 8.67,10 9.5,10C10.33,10 11,9.33 11,8.5C11,7.67 10.33,7 9.5,7M14.5,14C13.67,14 13,14.67 13,15.5C13,16.33 13.67,17 14.5,17C15.33,17 16,16.33 16,15.5C16,14.67 15.33,14 14.5,14M8.41,17L17,8.41L15.59,7L7,15.59L8.41,17Z",
  },
  {
    id: "D7963D7C-396F-45DB-A5D7-AA18AE32FE53",
    name: "salesforce",
    codepoint: "F88D",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Contributors",
    version: "2.1.99",
    path: "M18.38,6.37C17.68,6.37 17.07,6.58 16.47,6.78C15.77,5.57 14.46,4.77 13.05,4.77C11.95,4.77 10.95,5.27 10.24,5.97C9.44,4.97 8.23,4.26 6.83,4.26C4.5,4.26 2.5,6.17 2.5,8.5C2.5,9.09 2.71,9.69 2.91,10.29C1.8,10.9 1,12.1 1,13.5C1,15.5 2.61,17.22 4.62,17.22C4.92,17.22 5.22,17.22 5.42,17.12C5.82,18.63 7.33,19.74 9.14,19.74C10.84,19.74 12.25,18.73 12.75,17.32C13.26,17.53 13.76,17.73 14.26,17.73C15.57,17.73 16.77,17 17.37,15.92C17.68,16 18,16 18.28,16C20.89,16 23,13.91 23,11.2C23.1,8.5 21,6.37 18.38,6.37Z",
  },
  {
    id: "2AFE6E3E-61AB-48D2-A333-E5324AD534CD",
    name: "sass",
    codepoint: "F7EB",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "2.0.46",
    path: "M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M10,15.33C10.16,15.87 10.14,16.37 10,16.83C10,16.88 9.96,16.93 9.94,17C9.92,17 9.9,17.07 9.87,17.12C9.76,17.36 9.6,17.59 9.41,17.79C8.83,18.43 8,18.67 7.67,18.47C7.29,18.25 7.5,17.35 8.16,16.64C8.88,15.88 9.92,15.38 9.92,15.38V15.38L10,15.33M18.27,6.28C17.82,4.5 14.87,3.92 12.09,4.91C10.43,5.5 8.63,6.42 7.34,7.63C5.81,9.07 5.56,10.32 5.66,10.84C6,12.68 8.54,13.89 9.58,14.78V14.79C9.28,14.94 7.04,16.07 6.5,17.23C5.96,18.45 6.6,19.33 7,19.45C8.34,19.81 9.69,19.16 10.41,18.07C11.11,17.03 11.06,15.68 10.75,15C11.17,14.9 11.66,14.85 12.28,14.92C14.04,15.13 14.38,16.22 14.31,16.68C14.25,17.14 13.88,17.39 13.76,17.47C13.64,17.54 13.6,17.57 13.61,17.63C13.62,17.71 13.68,17.71 13.78,17.69C13.93,17.66 14.71,17.32 14.74,16.47C14.78,15.39 13.75,14.19 11.93,14.22C11.18,14.24 10.71,14.31 10.37,14.44L10.29,14.35C9.16,13.15 7.08,12.3 7.17,10.68C7.2,10.09 7.4,8.55 11.17,6.67C14.25,5.13 16.72,5.55 17.15,6.5C17.76,7.83 15.83,10.32 12.63,10.68C11.41,10.82 10.76,10.34 10.6,10.17C10.43,10 10.41,9.97 10.35,10C10.24,10.07 10.31,10.23 10.35,10.33C10.44,10.58 10.84,11 11.5,11.24C12.09,11.43 13.53,11.54 15.26,10.87C17.2,10.12 18.72,8.03 18.27,6.28Z",
  },
  {
    id: "D77BED79-19CC-45A9-9940-5EB621E95C11",
    name: "satellite",
    codepoint: "F470",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M5,18L8.5,13.5L11,16.5L14.5,12L19,18M5,12V10C7.76,10 10,7.76 10,5H12C12,8.87 8.87,12 5,12M5,5H8C8,6.66 6.66,8 5,8M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3Z",
  },
  {
    id: "9627DDC0-A33C-4B0E-A14F-915809E377AA",
    name: "satellite-uplink",
    codepoint: "F908",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "2.3.50",
    path: "M11.86,2L11.34,3.93C15.75,4.78 19.2,8.23 20.05,12.65L22,12.13C20.95,7.03 16.96,3.04 11.86,2M10.82,5.86L10.3,7.81C13.34,8.27 15.72,10.65 16.18,13.68L18.12,13.16C17.46,9.44 14.55,6.5 10.82,5.86M3.72,9.69C3.25,10.73 3,11.86 3,13C3,14.95 3.71,16.82 5,18.28V22H8V20.41C8.95,20.8 9.97,21 11,21C12.14,21 13.27,20.75 14.3,20.28L3.72,9.69M9.79,9.76L9.26,11.72C10.92,11.72 12.26,13.06 12.26,14.72L14.23,14.2C14,11.86 12.13,10 9.79,9.76Z",
  },
  {
    id: "3945E491-7E92-4A9F-BD2A-C436200B3716",
    name: "satellite-variant",
    codepoint: "F471",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M11.62,1L17.28,6.67L15.16,8.79L13.04,6.67L11.62,8.09L13.95,10.41L12.79,11.58L13.24,12.04C14.17,11.61 15.31,11.77 16.07,12.54L12.54,16.07C11.77,15.31 11.61,14.17 12.04,13.24L11.58,12.79L10.41,13.95L8.09,11.62L6.67,13.04L8.79,15.16L6.67,17.28L1,11.62L3.14,9.5L5.26,11.62L6.67,10.21L3.84,7.38C3.06,6.6 3.06,5.33 3.84,4.55L4.55,3.84C5.33,3.06 6.6,3.06 7.38,3.84L10.21,6.67L11.62,5.26L9.5,3.14L11.62,1M18,14C18,16.21 16.21,18 14,18V16C15.1,16 16,15.1 16,14H18M22,14C22,18.42 18.42,22 14,22V20C17.31,20 20,17.31 20,14H22Z",
  },
  {
    id: "191AE0C8-5DBD-4B51-8D52-2872CA89E376",
    name: "sausage",
    codepoint: "F8B9",
    aliases: [],
    tags: ["Food / Drink"],
    author: "Nick",
    version: "2.2.43",
    path: "M3.5,3H9.5L7.96,5.32C9.16,5.87 10,7.09 10,8.5C10,11.54 12.46,14 15.5,14C16.91,14 18.13,14.84 18.68,16.04L21,14.5V20.5L18.68,18.96C18.13,20.16 16.91,21 15.5,21C8.6,21 3,15.4 3,8.5C3,7.09 3.84,5.87 5.04,5.32L3.5,3Z",
  },
  {
    id: "64F494E1-5B39-488D-B46E-0FC1B9567478",
    name: "saxophone",
    codepoint: "F609",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M4,2C3.45,2 3,2.45 3,3C3,3.55 3.45,4 4,4C5.66,4 7,5.34 7,7V8.66L7,15.5C7,19.1 9.9,22 13.5,22C17.1,22 20,19.1 20,15.5V13C20.55,13 21,12.55 21,12C21,11.45 20.55,11 20,11H14C13.45,11 13,11.45 13,12C13,12.55 13.45,13 14,13V15C14,15.55 13.55,16 13,16C12.45,16 12,15.55 12,15V11C12.55,11 13,10.55 13,10C13,9.45 12.55,9 12,9V8C12.55,8 13,7.55 13,7C13,6.45 12.55,6 12,6V5.5C12,3.57 10.43,2 8.5,2H4Z",
  },
  {
    id: "3FE1D769-A292-44DB-BB8A-E60F3A020D2A",
    name: "scale",
    codepoint: "F472",
    aliases: [],
    tags: ["Food / Drink"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M8.46,15.06L7.05,16.47L5.68,15.1C4.82,16.21 4.24,17.54 4.06,19H6V21H2V20C2,15.16 5.44,11.13 10,10.2V8.2L2,5V3H22V5L14,8.2V10.2C18.56,11.13 22,15.16 22,20V21H18V19H19.94C19.76,17.54 19.18,16.21 18.32,15.1L16.95,16.47L15.54,15.06L16.91,13.68C15.8,12.82 14.46,12.24 13,12.06V14H11V12.06C9.54,12.24 8.2,12.82 7.09,13.68L8.46,15.06M12,18C13.1,18 14,18.9 14,20C14,21.1 13.1,22 12,22C11.68,22 11.38,21.93 11.12,21.79L7.27,20L11.12,18.21C11.38,18.07 11.68,18 12,18Z",
  },
  {
    id: "82048BA4-F949-4572-B59B-23197F9B36D6",
    name: "scale-balance",
    codepoint: "F5D1",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M12,3C10.73,3 9.6,3.8 9.18,5H3V7H4.95L2,14C1.53,16 3,17 5.5,17C8,17 9.56,16 9,14L6.05,7H9.17C9.5,7.85 10.15,8.5 11,8.83V20H2V22H22V20H13V8.82C13.85,8.5 14.5,7.85 14.82,7H17.95L15,14C14.53,16 16,17 18.5,17C21,17 22.56,16 22,14L19.05,7H21V5H14.83C14.4,3.8 13.27,3 12,3M12,5C12.55,5 13,5.45 13,6C13,6.55 12.55,7 12,7C11.45,7 11,6.55 11,6C11,5.45 11.45,5 12,5M5.5,10.25L7,14H4L5.5,10.25M18.5,10.25L20,14H17L18.5,10.25Z",
  },
  {
    id: "F4501EC3-6AB0-4A69-B840-F07DDFC45A19",
    name: "scale-bathroom",
    codepoint: "F473",
    aliases: [],
    tags: ["Home Automation"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M5,2H19C20.1,2 21,2.9 21,4V20C21,21.1 20.1,22 19,22H5C3.9,22 3,21.1 3,20V4C3,2.9 3.9,2 5,2M12,4C9.79,4 8,5.79 8,8H11.26L10.85,5.23L12.9,8H16C16,5.79 14.21,4 12,4M5,10V20H19V10H5Z",
  },
  {
    id: "BE9A1BD3-1DF7-407F-98B7-24070994D472",
    name: "scanner",
    codepoint: "F6AA",
    aliases: [],
    tags: ["Device / Tech"],
    author: "Google",
    version: "1.7.12",
    path: "M4.2,10.7L19.8,5L20.5,6.9L6.4,12H19C20.1,12 21,12.9 21,14V18C21,19.1 20.1,20 19,20H5C3.9,20 3,19.1 3,18V12.5C3,11.7 3.5,10.9 4.2,10.7M17,17H19V15H17V17M5,17H15V15H5V17Z",
  },
  {
    id: "B2E1C852-B55A-40D0-969B-0CD7389660A4",
    name: "scanner-off",
    codepoint: "F909",
    aliases: [],
    tags: ["Device / Tech"],
    author: "GreenTurtwig",
    version: "2.3.50",
    path: "M2,5.27L3.28,4L20,20.72L18.73,22L16.73,20H5C3.9,20 3,19.1 3,18V12.5C3,11.7 3.5,10.9 4.2,10.7L6.57,9.84L2,5.27M6.4,12H8.73L8.11,11.38L6.4,12M5,15V17H13.73L11.73,15H5M19.8,5L20.5,6.9L11.85,10.03L10.3,8.47L19.8,5M19,12C20.1,12 21,12.9 21,14V18C21,18.34 20.91,18.66 20.76,18.94L19,17.18V15H16.82L13.82,12H19Z",
  },
  {
    id: "A671C11E-0A75-4F41-AA32-EAA99955DEDE",
    name: "school",
    codepoint: "F474",
    aliases: ["graduation-cap"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M12,3L1,9L12,15L21,10.09V17H23V9M5,13.18V17.18L12,21L19,17.18V13.18L12,17L5,13.18Z",
  },
  {
    id: "913EA106-BCB3-410B-A5F4-6FAAA1B79880",
    name: "screen-rotation",
    codepoint: "F475",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M7.5,21.5C4.25,19.94 1.91,16.76 1.55,13H0.05C0.56,19.16 5.71,24 12,24L12.66,23.97L8.85,20.16M14.83,21.19L2.81,9.17L9.17,2.81L21.19,14.83M10.23,1.75C9.64,1.16 8.69,1.16 8.11,1.75L1.75,8.11C1.16,8.7 1.16,9.65 1.75,10.23L13.77,22.25C14.36,22.84 15.31,22.84 15.89,22.25L22.25,15.89C22.84,15.3 22.84,14.35 22.25,13.77L10.23,1.75M16.5,2.5C19.75,4.07 22.09,7.24 22.45,11H23.95C23.44,4.84 18.29,0 12,0L11.34,0.03L15.15,3.84L16.5,2.5Z",
  },
  {
    id: "0C15E49D-5D29-4A3D-803B-0B9695295E04",
    name: "screen-rotation-lock",
    codepoint: "F476",
    aliases: ["screen-lock-rotation"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M16.8,2.5C16.8,1.56 17.56,0.8 18.5,0.8C19.44,0.8 20.2,1.56 20.2,2.5V3H16.8V2.5M16,9H21C21.55,9 22,8.55 22,8V4C22,3.45 21.55,3 21,3V2.5C21,1.12 19.88,0 18.5,0C17.12,0 16,1.12 16,2.5V3C15.45,3 15,3.45 15,4V8C15,8.55 15.45,9 16,9M8.47,20.5C5.2,18.94 2.86,15.76 2.5,12H1C1.5,18.16 6.66,23 12.95,23L13.61,22.97L9.8,19.15L8.47,20.5M23.25,12.77L20.68,10.2L19.27,11.61L21.5,13.83L15.83,19.5L4.5,8.17L10.17,2.5L12.27,4.61L13.68,3.2L11.23,0.75C10.64,0.16 9.69,0.16 9.11,0.75L2.75,7.11C2.16,7.7 2.16,8.65 2.75,9.23L14.77,21.25C15.36,21.84 16.31,21.84 16.89,21.25L23.25,14.89C23.84,14.3 23.84,13.35 23.25,12.77Z",
  },
  {
    id: "2F75C2DC-FAAD-4D59-BAAB-3922EF9AF376",
    name: "screwdriver",
    codepoint: "F477",
    aliases: [],
    tags: ["Hardware / Tools"],
    author: "Cody",
    version: "1.5.54",
    path: "M18,1.83C17.5,1.83 17,2 16.59,2.41C13.72,5.28 8,11 8,11L9.5,12.5L6,16H4L2,20L4,22L8,20V18L11.5,14.5L13,16C13,16 18.72,10.28 21.59,7.41C22.21,6.5 22.37,5.37 21.59,4.59L19.41,2.41C19,2 18.5,1.83 18,1.83M18,4L20,6L13,13L11,11L18,4Z",
  },
  {
    id: "6E18A0EA-1F19-47E3-83DD-25732C1D318D",
    name: "script",
    codepoint: "F478",
    aliases: ["scroll"],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M14,20C15.1,20 16,19.1 16,18V5H9C8.45,5 8,5.45 8,6V16H5V5C5,3.34 6.34,2 8,2H19C20.66,2 22,3.34 22,5V6H18V18L18,19C18,20.66 16.66,22 15,22H5C3.34,22 2,20.66 2,19V18H12C12,19.1 12.9,20 14,20Z",
  },
  {
    id: "68B68EDB-6CDA-4488-A213-5E6DF4146EA6",
    name: "sd",
    codepoint: "F479",
    aliases: ["sd-card", "sd-storage"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M18,8H16V4H18M15,8H13V4H15M12,8H10V4H12M18,2H10L4,8V20C4,21.1 4.9,22 6,22H18C19.1,22 20,21.1 20,20V4C20,2.9 19.1,2 18,2Z",
  },
  {
    id: "82C413A0-A055-4527-87B7-F977B6CD3F74",
    name: "seal",
    codepoint: "F47A",
    aliases: ["ribbon"],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M20.39,19.37L16.38,18L15,22L11.92,16L9,22L7.62,18L3.61,19.37L6.53,13.37C5.57,12.17 5,10.65 5,9C5,5.13 8.13,2 12,2C15.87,2 19,5.13 19,9C19,10.65 18.43,12.17 17.47,13.37L20.39,19.37M7,9L9.69,10.34L9.5,13.34L12,11.68L14.5,13.33L14.33,10.34L17,9L14.32,7.65L14.5,4.67L12,6.31L9.5,4.65L9.67,7.66L7,9Z",
  },
  {
    id: "F6E7F332-1625-4A46-8E10-B6DEC4059E7E",
    name: "search-web",
    codepoint: "F70E",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "1.8.36",
    path: "M15.5,14L20.5,19L19,20.5L14,15.5V14.71L13.73,14.43C12.59,15.41 11.11,16 9.5,16C5.91,16 3,13.09 3,9.5C3,5.91 5.91,3 9.5,3C13.09,3 16,5.91 16,9.5C16,11.11 15.41,12.59 14.43,13.73L14.71,14H15.5M9.5,4.5L8.95,4.53C8.71,5.05 8.34,5.93 8.07,7H10.93C10.66,5.93 10.29,5.05 10.05,4.53C9.87,4.5 9.69,4.5 9.5,4.5M13.83,7C13.24,5.97 12.29,5.17 11.15,4.78C11.39,5.31 11.7,6.08 11.93,7H13.83M5.17,7H7.07C7.3,6.08 7.61,5.31 7.85,4.78C6.71,5.17 5.76,5.97 5.17,7M4.5,9.5C4.5,10 4.58,10.53 4.73,11H6.87L6.75,9.5L6.87,8H4.73C4.58,8.47 4.5,9 4.5,9.5M14.27,11C14.42,10.53 14.5,10 14.5,9.5C14.5,9 14.42,8.47 14.27,8H12.13C12.21,8.5 12.25,9 12.25,9.5C12.25,10 12.21,10.5 12.13,11H14.27M7.87,8L7.75,9.5L7.87,11H11.13C11.21,10.5 11.25,10 11.25,9.5C11.25,9 11.21,8.5 11.13,8H7.87M9.5,14.5C9.68,14.5 9.86,14.5 10.03,14.47C10.28,13.95 10.66,13.07 10.93,12H8.07C8.34,13.07 8.72,13.95 8.97,14.47L9.5,14.5M13.83,12H11.93C11.7,12.92 11.39,13.69 11.15,14.22C12.29,13.83 13.24,13.03 13.83,12M5.17,12C5.76,13.03 6.71,13.83 7.85,14.22C7.61,13.69 7.3,12.92 7.07,12H5.17Z",
  },
  {
    id: "FDDF112E-DFF5-4D31-9821-69902F92E6CF",
    name: "seat-flat",
    codepoint: "F47B",
    aliases: ["airline-seat-flat"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M22,11V13H9V7H18C20.21,7 22,8.79 22,11M2,14V16H8V18H16V16H22V14M7.14,12.1C8.3,10.91 8.28,9 7.1,7.86C5.91,6.7 4,6.72 2.86,7.9C1.7,9.09 1.72,11 2.9,12.14C4.09,13.3 6,13.28 7.14,12.1Z",
  },
  {
    id: "22BC78FF-895C-497C-B6F0-143F60901C20",
    name: "seat-flat-angled",
    codepoint: "F47C",
    aliases: ["airline-seat-flat-angled"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M22.25,14.29L21.56,16.18L9.2,11.71L11.28,6.05L19.84,9.14C21.94,9.9 23,12.2 22.25,14.29M1.5,12.14L8,14.5V19H16V17.37L20.5,19L21.21,17.11L2.19,10.25M7.3,10.2C8.79,9.5 9.42,7.69 8.71,6.2C8,4.71 6.2,4.08 4.7,4.8C3.21,5.5 2.58,7.3 3.3,8.8C4,10.29 5.8,10.92 7.3,10.2Z",
  },
  {
    id: "A8F9F185-D2AE-4DEE-845C-3C74801E2CD0",
    name: "seat-individual-suite",
    codepoint: "F47D",
    aliases: ["airline-seat-individual-suite"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M7,13C8.66,13 10,11.66 10,10C10,8.34 8.66,7 7,7C5.34,7 4,8.34 4,10C4,11.66 5.34,13 7,13M19,7H11V14H3V7H1V17H23V11C23,8.79 21.21,7 19,7Z",
  },
  {
    id: "F73EE06A-6898-40A7-9B0E-784A4280C075",
    name: "seat-legroom-extra",
    codepoint: "F47E",
    aliases: ["airline-seat-legroom-extra"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M4,12V3H2V12C2,14.76 4.24,17 7,17H13V15H7C5.34,15 4,13.66 4,12M22.83,17.24C22.45,16.5 21.54,16.27 20.8,16.61L19.71,17.11L16.3,10.13C15.96,9.45 15.27,9 14.5,9H11V3H5V11C5,12.66 6.34,14 8,14H15L18.41,21L22.13,19.3C22.9,18.94 23.23,18 22.83,17.24Z",
  },
  {
    id: "1FC39B1E-567E-452C-B923-581F9A90F06D",
    name: "seat-legroom-normal",
    codepoint: "F47F",
    aliases: ["airline-seat-legroom-normal"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M5,12V3H3V12C3,14.76 5.24,17 8,17H14V15H8C6.34,15 5,13.66 5,12M20.5,18H19V11C19,9.9 18.1,9 17,9H12V3H6V11C6,12.66 7.34,14 9,14H16V21H20.5C21.33,21 22,20.33 22,19.5C22,18.67 21.33,18 20.5,18Z",
  },
  {
    id: "4306743D-7833-44E7-88AB-659DD694C8B0",
    name: "seat-legroom-reduced",
    codepoint: "F480",
    aliases: ["airline-seat-legroom-reduced"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M19.97,19.2C20.15,20.16 19.42,21 18.5,21H14V18L15,14H9C7.34,14 6,12.66 6,11V3H12V9H17C18.1,9 19,9.9 19,11L17,18H18.44C19.17,18 19.83,18.5 19.97,19.2M5,12V3H3V12C3,14.76 5.24,17 8,17H12V15H8C6.34,15 5,13.66 5,12Z",
  },
  {
    id: "EB83D5D9-0439-476C-9BFD-04B5D6789940",
    name: "seat-recline-extra",
    codepoint: "F481",
    aliases: ["airline-seat-recline-extra"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M5.35,5.64C4.45,5 4.23,3.76 4.86,2.85C5.5,1.95 6.74,1.73 7.65,2.36C8.55,3 8.77,4.24 8.14,5.15C7.5,6.05 6.26,6.27 5.35,5.64M16,19H8.93C7.45,19 6.19,17.92 5.97,16.46L4,7H2L4,16.76C4.37,19.2 6.47,21 8.94,21H16M16.23,15H11.35L10.32,10.9C11.9,11.79 13.6,12.44 15.47,12.12V10C13.84,10.3 12.03,9.72 10.78,8.74L9.14,7.47C8.91,7.29 8.65,7.17 8.38,7.09C8.06,7 7.72,6.97 7.39,7.03H7.37C6.14,7.25 5.32,8.42 5.53,9.64L6.88,15.56C7.16,17 8.39,18 9.83,18H16.68L20.5,21L22,19.5",
  },
  {
    id: "B6642D7A-EE36-4C22-945E-88A218708CB6",
    name: "seat-recline-normal",
    codepoint: "F482",
    aliases: ["airline-seat-recline-normal"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M7.59,5.41C6.81,4.63 6.81,3.36 7.59,2.58C8.37,1.8 9.64,1.8 10.42,2.58C11.2,3.36 11.2,4.63 10.42,5.41C9.63,6.2 8.37,6.2 7.59,5.41M6,16V7H4V16C4,18.76 6.24,21 9,21H15V19H9C7.34,19 6,17.66 6,16M20,20.07L14.93,15H11.5V11.32C12.9,12.47 15.1,13.5 17,13.5V11.32C15.34,11.34 13.39,10.45 12.33,9.28L10.93,7.73C10.74,7.5 10.5,7.35 10.24,7.23C9.95,7.09 9.62,7 9.28,7H9.25C8,7 7,8 7,9.25V15C7,16.66 8.34,18 10,18H15.07L18.57,21.5",
  },
  {
    id: "E74ADD51-598F-4194-868C-3A9F7B62BCFA",
    name: "security-account-outline",
    codepoint: "FA11",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "2.5.94",
    path: "M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5L12,1M12,3.18L19,6.3V11.22C19,12.92 18.5,14.65 17.65,16.17C16,14.94 13.26,14.5 12,14.5C10.74,14.5 8,14.94 6.35,16.17C5.5,14.65 5,12.92 5,11.22V6.3L12,3.18M12,6C10.07,6 8.5,7.57 8.5,9.5C8.5,11.43 10.07,13 12,13C13.93,13 15.5,11.43 15.5,9.5C15.5,7.57 13.93,6 12,6M12,8C12.83,8 13.5,8.67 13.5,9.5C13.5,10.33 12.83,11 12,11C11.17,11 10.5,10.33 10.5,9.5C10.5,8.67 11.17,8 12,8M12,16.5C13.57,16.5 15.64,17.11 16.53,17.84C15.29,19.38 13.7,20.55 12,21C10.3,20.55 8.71,19.38 7.47,17.84C8.37,17.11 10.43,16.5 12,16.5Z",
  },
  {
    id: "C9FA8517-7CD1-4AB7-86AD-0A2BF1016466",
    name: "security-network",
    codepoint: "F484",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M13,18H14C14.55,18 15,18.45 15,19H22V21H15C15,21.55 14.55,22 14,22H10C9.45,22 9,21.55 9,21H2V19H9C9,18.45 9.45,18 10,18H11V16.34C8.07,15.13 6,12 6,8.67V4.67L12,2L18,4.67V8.67C18,12 15.93,15.13 13,16.34V18M12,4L8,5.69V9H12V4M12,9V15C13.91,14.53 16,12.06 16,10V9H12Z",
  },
  {
    id: "B350D031-599B-4BB7-9D21-EC955B7FEF43",
    name: "select",
    codepoint: "F485",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M4,3H5V5H3V4C3,3.45 3.45,3 4,3M20,3C20.55,3 21,3.45 21,4V5H19V3H20M15,5V3H17V5H15M11,5V3H13V5H11M7,5V3H9V5H7M21,20C21,20.55 20.55,21 20,21H19V19H21V20M15,21V19H17V21H15M11,21V19H13V21H11M7,21V19H9V21H7M4,21C3.45,21 3,20.55 3,20V19H5V21H4M3,15H5V17H3V15M21,15V17H19V15H21M3,11H5V13H3V11M21,11V13H19V11H21M3,7H5V9H3V7M21,7V9H19V7H21Z",
  },
  {
    id: "7C2879B0-6BFE-42A3-9EDF-4A42AC3C9D70",
    name: "select-all",
    codepoint: "F486",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M9,9H15V15H9M7,17H17V7H7M15,5H17V3H15M15,21H17V19H15M19,17H21V15H19M19,9H21V7H19M19,21C20.1,21 21,20.1 21,19H19M19,13H21V11H19M11,21H13V19H11M9,3H7V5H9M3,17H5V15H3M5,21V19H3C3,20.1 3.9,21 5,21M19,3V5H21C21,3.9 20.1,3 19,3M13,3H11V5H13M3,9H5V7H3M7,21H9V19H7M3,13H5V11H3M3,5H5V3C3.9,3 3,3.9 3,5Z",
  },
  {
    id: "DAA46B9D-9215-4BF8-BDA7-52E575817ABC",
    name: "select-inverse",
    codepoint: "F487",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M5,3H7V5H9V3H11V5H13V3H15V5H17V3H19V5H21V7H19V9H21V11H19V13H21V15H19V17H21V19H19V21H17V19H15V21H13V19H11V21H9V19H7V21H5V19H3V17H5V15H3V13H5V11H3V9H5V7H3V5H5V3Z",
  },
  {
    id: "B2C462E1-44F0-456A-8A73-919DB480D978",
    name: "select-off",
    codepoint: "F488",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M1,4.27L2.28,3L21,21.72L19.73,23L17,20.27V21H15V19H15.73L5,8.27V9H3V7H3.73L1,4.27M20,3C20.55,3 21,3.45 21,4V5H19V3H20M15,5V3H17V5H15M11,5V3H13V5H11M7,5V3H9V5H7M11,21V19H13V21H11M7,21V19H9V21H7M4,21C3.45,21 3,20.55 3,20V19H5V21H4M3,15H5V17H3V15M21,15V17H19V15H21M3,11H5V13H3V11M21,11V13H19V11H21M21,7V9H19V7H21Z",
  },
  {
    id: "33A5D3FF-E2A7-4E3A-95B5-86D4C6604911",
    name: "selection",
    codepoint: "F489",
    aliases: [],
    tags: [],
    author: "Doug C. Hardester",
    version: "1.5.54",
    path: "M2,4C2,2.89 2.9,2 4,2H7V4H4V7H2V4M22,4V7H20V4H17V2H20C21.1,2 22,2.9 22,4M20,20V17H22V20C22,21.11 21.1,22 20,22H17V20H20M2,20V17H4V20H7V22H4C2.9,22 2,21.1 2,20M10,2H14V4H10V2M10,20H14V22H10V20M20,10H22V14H20V10M2,10H4V14H2V10Z",
  },
  {
    id: "DE8BF55F-05A8-4CB8-86FC-63D6EAC57A6C",
    name: "selection-off",
    codepoint: "F776",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M0.5,3.77L1.78,2.5L21.5,22.22L20.23,23.5L18.73,22H17V20.27L3.73,7H2V5.27L0.5,3.77M4,2H7V4H5.82L3.83,2H4M22,4V7H20V4H17V2H20C21.1,2 22,2.9 22,4M20,17H22V20L22,20.17L20,18.18V17M2,20V17H4V20H7V22H4C2.9,22 2,21.1 2,20M10,2H14V4H10V2M10,20H14V22H10V20M20,10H22V14H20V10M2,10H4V14H2V10Z",
  },
  {
    id: "6791A1E4-DBF8-471C-AA27-0D4540A23678",
    name: "send",
    codepoint: "F48A",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M2,21L23,12L2,3V10L17,12L2,14V21Z",
  },
  {
    id: "5D18BB49-3214-49C0-BD5C-B4581172C650",
    name: "serial-port",
    codepoint: "F65C",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.6.50",
    path: "M7,3H17V5H19V8H16V14H8V8H5V5H7V3M17,9H19V14H17V9M11,15H13V22H11V15M5,9H7V14H5V9Z",
  },
  {
    id: "692F85E2-79A8-4207-ACF7-DEC8D675BE38",
    name: "server",
    codepoint: "F48B",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M4,1H20C20.55,1 21,1.45 21,2V6C21,6.55 20.55,7 20,7H4C3.45,7 3,6.55 3,6V2C3,1.45 3.45,1 4,1M4,9H20C20.55,9 21,9.45 21,10V14C21,14.55 20.55,15 20,15H4C3.45,15 3,14.55 3,14V10C3,9.45 3.45,9 4,9M4,17H20C20.55,17 21,17.45 21,18V22C21,22.55 20.55,23 20,23H4C3.45,23 3,22.55 3,22V18C3,17.45 3.45,17 4,17M9,5H10V3H9V5M9,13H10V11H9V13M9,21H10V19H9V21M5,3V5H7V3H5M5,11V13H7V11H5M5,19V21H7V19H5Z",
  },
  {
    id: "09F53FF1-31D7-44CA-A00E-8CDDF55DB716",
    name: "server-minus",
    codepoint: "F48C",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M4,4H20C20.55,4 21,4.45 21,5V9C21,9.55 20.55,10 20,10H4C3.45,10 3,9.55 3,9V5C3,4.45 3.45,4 4,4M9,8H10V6H9V8M5,6V8H7V6H5M8,16H16V18H8V16Z",
  },
  {
    id: "21F268BE-CC44-49CE-B59A-121D073ADBA5",
    name: "server-network",
    codepoint: "F48D",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M13,18H14C14.55,18 15,18.45 15,19H22V21H15C15,21.55 14.55,22 14,22H10C9.45,22 9,21.55 9,21H2V19H9C9,18.45 9.45,18 10,18H11V16H4C3.45,16 3,15.55 3,15V11C3,10.45 3.45,10 4,10H20C20.55,10 21,10.45 21,11V15C21,15.55 20.55,16 20,16H13V18M4,2H20C20.55,2 21,2.45 21,3V7C21,7.55 20.55,8 20,8H4C3.45,8 3,7.55 3,7V3C3,2.45 3.45,2 4,2M9,6H10V4H9V6M9,14H10V12H9V14M5,4V6H7V4H5M5,12V14H7V12H5Z",
  },
  {
    id: "E01B3638-DE80-4D1E-93D1-1A0C5E9AFCF4",
    name: "server-network-off",
    codepoint: "F48E",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M13,18H14C14.55,18 15,18.45 15,19H15.73L13,16.27V18M22,19V20.18L20.82,19H22M21,21.72L19.73,23L17.73,21H15C15,21.55 14.55,22 14,22H10C9.45,22 9,21.55 9,21H2V19H9C9,18.45 9.45,18 10,18H11V16H4C3.45,16 3,15.55 3,15V11C3,10.45 3.45,10 4,10H6.73L4.73,8H4C3.45,8 3,7.55 3,7V6.27L1,4.27L2.28,3L21,21.72M4,2H20C20.55,2 21,2.45 21,3V7C21,7.55 20.55,8 20,8H9.82L7,5.18V4H5.82L3.84,2C3.89,2 3.94,2 4,2M20,10C20.55,10 21,10.45 21,11V15C21,15.55 20.55,16 20,16H17.82L11.82,10H20M9,6H10V4H9V6M9,14H10V13.27L9,12.27V14M5,12V14H7V12H5Z",
  },
  {
    id: "578A1213-5F0D-4C6B-A929-9157D126A9F8",
    name: "server-off",
    codepoint: "F48F",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M4,1H20C20.55,1 21,1.45 21,2V6C21,6.55 20.55,7 20,7H8.82L6.82,5H7V3H5V3.18L3.21,1.39C3.39,1.15 3.68,1 4,1M22,22.72L20.73,24L19.73,23H4C3.45,23 3,22.55 3,22V18C3,17.45 3.45,17 4,17H13.73L11.73,15H4C3.45,15 3,14.55 3,14V10C3,9.45 3.45,9 4,9H5.73L3.68,6.95C3.38,6.85 3.15,6.62 3.05,6.32L1,4.27L2.28,3L22,22.72M20,9C20.55,9 21,9.45 21,10V14C21,14.55 20.55,15 20,15H16.82L10.82,9H20M20,17C20.55,17 21,17.45 21,18V19.18L18.82,17H20M9,5H10V3H9V5M9,13H9.73L9,12.27V13M9,21H10V19H9V21M5,11V13H7V11H5M5,19V21H7V19H5Z",
  },
  {
    id: "99AC1D59-A2F0-4B53-872D-0374D0804E0A",
    name: "server-plus",
    codepoint: "F490",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M4,4H20C20.55,4 21,4.45 21,5V9C21,9.55 20.55,10 20,10H4C3.45,10 3,9.55 3,9V5C3,4.45 3.45,4 4,4M9,8H10V6H9V8M5,6V8H7V6H5M8,16H11V13H13V16H16V18H13V21H11V18H8V16Z",
  },
  {
    id: "C7C1A659-403B-44E0-9EF5-94B5C722CAFD",
    name: "server-remove",
    codepoint: "F491",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M4,4H20C20.55,4 21,4.45 21,5V9C21,9.55 20.55,10 20,10H4C3.45,10 3,9.55 3,9V5C3,4.45 3.45,4 4,4M9,8H10V6H9V8M5,6V8H7V6H5M10.59,17L8,14.41L9.41,13L12,15.59L14.59,13L16,14.41L13.41,17L16,19.59L14.59,21L12,18.41L9.41,21L8,19.59L10.59,17Z",
  },
  {
    id: "E42A523C-D28D-4AAB-8A86-4816DD872B78",
    name: "server-security",
    codepoint: "F492",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M3,1H19C19.55,1 20,1.45 20,2V6C20,6.55 19.55,7 19,7H3C2.45,7 2,6.55 2,6V2C2,1.45 2.45,1 3,1M3,9H19C19.55,9 20,9.45 20,10V10.67L17.5,9.56L11,12.44V15H3C2.45,15 2,14.55 2,14V10C2,9.45 2.45,9 3,9M3,17H11C11.06,19.25 12,21.4 13.46,23H3C2.45,23 2,22.55 2,22V18C2,17.45 2.45,17 3,17M8,5H9V3H8V5M8,13H9V11H8V13M8,21H9V19H8V21M4,3V5H6V3H4M4,11V13H6V11H4M4,19V21H6V19H4M17.5,12L22,14V17C22,19.78 20.08,22.37 17.5,23C14.92,22.37 13,19.78 13,17V14L17.5,12M17.5,13.94L15,15.06V17.72C15,19.26 16.07,20.7 17.5,21.06V13.94Z",
  },
  {
    id: "501D1421-A50E-470A-A05B-87864461C4ED",
    name: "set-all",
    codepoint: "F777",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.9.32",
    path: "M9,5C10.04,5 11.06,5.24 12,5.68C12.94,5.24 13.96,5 15,5C18.87,5 22,8.13 22,12C22,15.87 18.87,19 15,19C13.96,19 12.94,18.76 12,18.32C11.06,18.76 10.04,19 9,19C5.13,19 2,15.87 2,12C2,8.13 5.13,5 9,5M8.5,12C8.5,13.87 9.29,15.56 10.56,16.75L11.56,16.29C10.31,15.29 9.5,13.74 9.5,12C9.5,10.26 10.31,8.71 11.56,7.71L10.56,7.25C9.29,8.44 8.5,10.13 8.5,12M15.5,12C15.5,10.13 14.71,8.44 13.44,7.25L12.44,7.71C13.69,8.71 14.5,10.26 14.5,12C14.5,13.74 13.69,15.29 12.44,16.29L13.44,16.75C14.71,15.56 15.5,13.87 15.5,12Z",
  },
  {
    id: "0267D77C-9968-45EF-87FC-CD3368D56383",
    name: "set-center",
    codepoint: "F778",
    aliases: ["set-centre"],
    tags: [],
    author: "Cody",
    version: "1.9.32",
    path: "M9,5C5.13,5 2,8.13 2,12C2,15.87 5.13,19 9,19C10.04,19 11.06,18.76 12,18.32C12.94,18.76 13.96,19 15,19C18.87,19 22,15.87 22,12C22,8.13 18.87,5 15,5C13.96,5 12.94,5.24 12,5.68C11.06,5.24 10.04,5 9,5M9,7C9.34,7 9.67,7.03 10,7.1C8.72,8.41 8,10.17 8,12C8,13.83 8.72,15.59 10,16.89C9.67,16.96 9.34,17 9,17C6.24,17 4,14.76 4,12C4,9.24 6.24,7 9,7M15,7C17.76,7 20,9.24 20,12C20,14.76 17.76,17 15,17C14.66,17 14.33,16.97 14,16.9C15.28,15.59 16,13.83 16,12C16,10.17 15.28,8.41 14,7.11C14.33,7.04 14.66,7 15,7Z",
  },
  {
    id: "614D2F8D-5170-4FE8-87C7-419903F205CB",
    name: "set-center-right",
    codepoint: "F779",
    aliases: ["set-centre-right"],
    tags: [],
    author: "Cody",
    version: "1.9.32",
    path: "M15,19C13.96,19 12.94,18.76 12,18.32C11.06,18.76 10.04,19 9,19C5.13,19 2,15.87 2,12C2,8.13 5.13,5 9,5C10.04,5 11.06,5.24 12,5.68C12.94,5.24 13.96,5 15,5C18.87,5 22,8.13 22,12C22,15.87 18.87,19 15,19M9,17L10,16.89C8.72,15.59 8,13.83 8,12C8,10.17 8.72,8.41 10,7.1L9,7C6.24,7 4,9.24 4,12C4,14.76 6.24,17 9,17M15.5,12C15.5,10.13 14.71,8.44 13.44,7.25L12.44,7.71C13.69,8.71 14.5,10.26 14.5,12C14.5,13.74 13.69,15.29 12.44,16.29L13.44,16.75C14.71,15.56 15.5,13.87 15.5,12Z",
  },
  {
    id: "FB4645C1-DF04-49E0-BA0B-7C02C87AF3A9",
    name: "set-left",
    codepoint: "F77A",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.9.32",
    path: "M9,5C5.13,5 2,8.13 2,12C2,15.87 5.13,19 9,19C10.04,19 11.06,18.76 12,18.32C12.94,18.76 13.96,19 15,19C18.87,19 22,15.87 22,12C22,8.13 18.87,5 15,5C13.96,5 12.94,5.24 12,5.68C11.06,5.24 10.04,5 9,5M15,7C17.76,7 20,9.24 20,12C20,14.76 17.76,17 15,17C14.66,17 14.33,16.97 14,16.9C15.28,15.59 16,13.83 16,12C16,10.17 15.28,8.41 14,7.11C14.33,7.04 14.66,7 15,7M12,8C13.26,8.95 14,10.43 14,12C14,13.57 13.26,15.05 12,16C10.74,15.05 10,13.57 10,12C10,10.43 10.74,8.95 12,8Z",
  },
  {
    id: "9C04991C-6A68-4634-885F-A4D6E2816AFF",
    name: "set-left-center",
    codepoint: "F77B",
    aliases: ["set-left-centre"],
    tags: [],
    author: "Cody",
    version: "1.9.32",
    path: "M9,5C10.04,5 11.06,5.24 12,5.68C12.94,5.24 13.96,5 15,5C18.87,5 22,8.13 22,12C22,15.87 18.87,19 15,19C13.96,19 12.94,18.76 12,18.32C11.06,18.76 10.04,19 9,19C5.13,19 2,15.87 2,12C2,8.13 5.13,5 9,5M15,7L14,7.11C15.28,8.41 16,10.17 16,12C16,13.83 15.28,15.59 14,16.9L15,17C17.76,17 20,14.76 20,12C20,9.24 17.76,7 15,7M8.5,12C8.5,13.87 9.29,15.56 10.56,16.75L11.56,16.29C10.31,15.29 9.5,13.74 9.5,12C9.5,10.26 10.31,8.71 11.56,7.71L10.56,7.25C9.29,8.44 8.5,10.13 8.5,12Z",
  },
  {
    id: "E1BE2EC4-D5D5-475C-A562-9855DA1612FB",
    name: "set-left-right",
    codepoint: "F77C",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.9.32",
    path: "M9,5C10.04,5 11.06,5.24 12,5.68C12.94,5.24 13.96,5 15,5C18.87,5 22,8.13 22,12C22,15.87 18.87,19 15,19C13.96,19 12.94,18.76 12,18.32C11.06,18.76 10.04,19 9,19C5.13,19 2,15.87 2,12C2,8.13 5.13,5 9,5M9,12C9,14.22 10.21,16.16 12,17.2C13.79,16.16 15,14.22 15,12C15,9.78 13.79,7.84 12,6.8C10.21,7.84 9,9.78 9,12Z",
  },
  {
    id: "9674B809-B544-45E8-BBD8-4E8D9E1A966E",
    name: "set-none",
    codepoint: "F77D",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.9.32",
    path: "M9,5C5.13,5 2,8.13 2,12C2,15.87 5.13,19 9,19C10.04,19 11.06,18.76 12,18.32C12.94,18.76 13.96,19 15,19C18.87,19 22,15.87 22,12C22,8.13 18.87,5 15,5C13.96,5 12.94,5.24 12,5.68C11.06,5.24 10.04,5 9,5M9,7C9.34,7 9.67,7.03 10,7.1C8.72,8.41 8,10.17 8,12C8,13.83 8.72,15.59 10,16.89C9.67,16.96 9.34,17 9,17C6.24,17 4,14.76 4,12C4,9.24 6.24,7 9,7M15,7C17.76,7 20,9.24 20,12C20,14.76 17.76,17 15,17C14.66,17 14.33,16.97 14,16.9C15.28,15.59 16,13.83 16,12C16,10.17 15.28,8.41 14,7.11C14.33,7.04 14.66,7 15,7M12,8C13.26,8.95 14,10.43 14,12C14,13.57 13.26,15.05 12,16C10.74,15.05 10,13.57 10,12C10,10.43 10.74,8.95 12,8Z",
  },
  {
    id: "27D4B799-E231-49DF-AB06-0201493C83E9",
    name: "set-right",
    codepoint: "F77E",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.9.32",
    path: "M15,19C13.96,19 12.94,18.76 12,18.32C11.06,18.76 10.04,19 9,19C5.13,19 2,15.87 2,12C2,8.13 5.13,5 9,5C10.04,5 11.06,5.24 12,5.68C12.94,5.24 13.96,5 15,5C18.87,5 22,8.13 22,12C22,15.87 18.87,19 15,19M9,17L10,16.89C8.72,15.59 8,13.83 8,12C8,10.17 8.72,8.41 10,7.1L9,7C6.24,7 4,9.24 4,12C4,14.76 6.24,17 9,17M12,16C13.26,15.05 14,13.57 14,12C14,10.43 13.26,8.95 12,8C10.74,8.95 10,10.43 10,12C10,13.57 10.74,15.05 12,16Z",
  },
  {
    id: "944304C3-3513-4544-8DC2-B14307049311",
    name: "set-top-box",
    codepoint: "F99E",
    aliases: [],
    tags: ["Home Automation"],
    author: "Austin Andrews",
    version: "2.4.85",
    path: "M5,15.5C5,15.78 4.78,16 4.5,16H3.5C3.22,16 3,15.78 3,15.5V15H2C1.45,15 1,14.55 1,14V11C1,10.45 1.45,10 2,10H22C22.55,10 23,10.45 23,11V14C23,14.55 22.55,15 22,15H21V15.5C21,15.78 20.78,16 20.5,16H19.5C19.22,16 19,15.78 19,15.5V15H5V15.5M3,12V13H5V12H3M6,12V13H8V12H6M20.5,11.5C19.95,11.5 19.5,11.95 19.5,12.5C19.5,13.05 19.95,13.5 20.5,13.5C21.05,13.5 21.5,13.05 21.5,12.5C21.5,11.95 21.05,11.5 20.5,11.5Z",
  },
  {
    id: "D29B92ED-BC81-44F0-8031-2E48A90ABAD8",
    name: "settings-outline",
    codepoint: "F8BA",
    aliases: ["cog-outline", "gear-outline"],
    tags: ["Settings"],
    author: "Michael Irigoyen",
    version: "2.2.43",
    path: "M19.43,12.97L21.54,14.63C21.73,14.78 21.78,15.05 21.66,15.27L19.66,18.73C19.54,18.95 19.27,19.03 19.05,18.95L16.56,17.94C16.04,18.34 15.5,18.67 14.87,18.93L14.5,21.58C14.46,21.82 14.25,22 14,22H10C9.75,22 9.54,21.82 9.5,21.58L9.13,18.93C8.5,18.68 7.96,18.34 7.44,17.94L4.95,18.95C4.73,19.03 4.46,18.95 4.34,18.73L2.34,15.27C2.21,15.05 2.27,14.78 2.46,14.63L4.57,12.97L4.5,12L4.57,11L2.46,9.37C2.27,9.22 2.21,8.95 2.34,8.73L4.34,5.27C4.46,5.05 4.73,4.96 4.95,5.05L7.44,6.05C7.96,5.66 8.5,5.32 9.13,5.07L9.5,2.42C9.54,2.18 9.75,2 10,2H14C14.25,2 14.46,2.18 14.5,2.42L14.87,5.07C15.5,5.32 16.04,5.66 16.56,6.05L19.05,5.05C19.27,4.96 19.54,5.05 19.66,5.27L21.66,8.73C21.78,8.95 21.73,9.22 21.54,9.37L19.43,11L19.5,12L19.43,12.97M6.5,12C6.5,12.58 6.59,13.13 6.75,13.66L4.68,15.36L5.43,16.66L7.95,15.72C8.69,16.53 9.68,17.12 10.8,17.37L11.24,20H12.74L13.18,17.37C14.3,17.13 15.3,16.54 16.05,15.73L18.56,16.67L19.31,15.37L17.24,13.67C17.41,13.14 17.5,12.58 17.5,12C17.5,11.43 17.41,10.87 17.25,10.35L19.31,8.66L18.56,7.36L16.06,8.29C15.31,7.47 14.31,6.88 13.19,6.63L12.75,4H11.25L10.81,6.63C9.69,6.88 8.69,7.47 7.94,8.29L5.44,7.35L4.69,8.65L6.75,10.35C6.59,10.87 6.5,11.43 6.5,12M12,8.5C13.93,8.5 15.5,10.07 15.5,12C15.5,13.93 13.93,15.5 12,15.5C10.07,15.5 8.5,13.93 8.5,12C8.5,10.07 10.07,8.5 12,8.5M12,10.5C11.17,10.5 10.5,11.17 10.5,12C10.5,12.83 11.17,13.5 12,13.5C12.83,13.5 13.5,12.83 13.5,12C13.5,11.17 12.83,10.5 12,10.5Z",
  },
  {
    id: "B29246C8-6014-4019-8CCC-F803DBC0FA95",
    name: "shape",
    codepoint: "F830",
    aliases: ["category"],
    tags: ["Shape"],
    author: "Google",
    version: "2.1.19",
    path: "M11,13.5V21.5H3V13.5H11M12,2L17.5,11H6.5L12,2M17.5,13C20,13 22,15 22,17.5C22,20 20,22 17.5,22C15,22 13,20 13,17.5C13,15 15,13 17.5,13Z",
  },
  {
    id: "C989421F-7F77-45D9-9BB4-97D3DE8C8FB4",
    name: "shape-circle-plus",
    codepoint: "F65D",
    aliases: [],
    tags: ["Shape"],
    author: "Kai Faust",
    version: "1.6.50",
    path: "M11,19C14.31,19 17,16.31 17,13H19C19,17.42 15.42,21 11,21C6.58,21 3,17.42 3,13C3,8.58 6.58,5 11,5V7C7.69,7 5,9.69 5,13C5,16.31 7.69,19 11,19M19,5H22V7H19V10H17V7H14V5H17V2H19V5Z",
  },
  {
    id: "FC3A1E7D-F8CD-443E-A685-9C7F0FA9FC10",
    name: "shape-outline",
    codepoint: "F831",
    aliases: ["theme"],
    tags: ["Shape"],
    author: "Google",
    version: "2.1.19",
    path: "M11,13.5V21.5H3V13.5H11M9,15.5H5V19.5H9V15.5M12,2L17.5,11H6.5L12,2M12,5.86L10.08,9H13.92L12,5.86M17.5,13C20,13 22,15 22,17.5C22,20 20,22 17.5,22C15,22 13,20 13,17.5C13,15 15,13 17.5,13M17.5,15C16.12,15 15,16.12 15,17.5C15,18.88 16.12,20 17.5,20C18.88,20 20,18.88 20,17.5C20,16.12 18.88,15 17.5,15Z",
  },
  {
    id: "C91D9DCD-5ADA-4D48-857C-39D38CD37A6B",
    name: "shape-plus",
    codepoint: "F495",
    aliases: [],
    tags: ["Shape"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M2,2H11V11H2V2M17.5,2C20,2 22,4 22,6.5C22,9 20,11 17.5,11C15,11 13,9 13,6.5C13,4 15,2 17.5,2M6.5,14L11,22H2L6.5,14M19,17H22V19H19V22H17V19H14V17H17V14H19V17Z",
  },
  {
    id: "CFE631FF-AAD1-49D9-BA22-84BAC90B8787",
    name: "shape-polygon-plus",
    codepoint: "F65E",
    aliases: [],
    tags: ["Shape"],
    author: "Kai Faust",
    version: "1.6.50",
    path: "M17,15.7V13H19V17L10,21L3,14L7,5H11V7H8.3L5.4,13.6L10.4,18.6L17,15.7M22,5V7H19V10H17V7H14V5H17V2H19V5H22Z",
  },
  {
    id: "C92D4248-E908-4B39-A6D0-296E6FB5FFE1",
    name: "shape-rectangle-plus",
    codepoint: "F65F",
    aliases: [],
    tags: ["Shape"],
    author: "Kai Faust",
    version: "1.6.50",
    path: "M19,6H22V8H19V11H17V8H14V6H17V3H19V6M17,17V14H19V19H3V6H11V8H5V17H17Z",
  },
  {
    id: "56A31026-C5C6-45D5-A9D4-1C660357F430",
    name: "shape-square-plus",
    codepoint: "F660",
    aliases: [],
    tags: ["Shape"],
    author: "Kai Faust",
    version: "1.6.50",
    path: "M19,5H22V7H19V10H17V7H14V5H17V2H19V5M17,19V13H19V21H3V5H11V7H5V19H17Z",
  },
  {
    id: "F0053E35-64B2-45D5-92D6-EE9F8A8839A1",
    name: "share",
    codepoint: "F496",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M21,11L14,4V8C7,9 4,14 3,19C5.5,15.5 9,13.9 14,13.9V18L21,11Z",
  },
  {
    id: "B8DDA534-033E-42FF-9F81-62EC636DD3C6",
    name: "share-outline",
    codepoint: "F931",
    aliases: [],
    tags: [],
    author: "Nick",
    version: "2.3.54",
    path: "M14,4V8C7,9 4,14 3,19C5.5,15.5 9,13.9 14,13.9V18L21,11L14,4M16,8.83L18.17,11L16,13.17V11.9H14C11.93,11.9 10.07,12.28 8.34,12.85C9.74,11.46 11.54,10.37 14.28,10L16,9.73V8.83Z",
  },
  {
    id: "C25D5913-39C7-4215-B372-88F90EE2B6E5",
    name: "share-variant",
    codepoint: "F497",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M18,16.08C17.24,16.08 16.56,16.38 16.04,16.85L8.91,12.7C8.96,12.47 9,12.24 9,12C9,11.76 8.96,11.53 8.91,11.3L15.96,7.19C16.5,7.69 17.21,8 18,8C19.66,8 21,6.66 21,5C21,3.34 19.66,2 18,2C16.34,2 15,3.34 15,5C15,5.24 15.04,5.47 15.09,5.7L8.04,9.81C7.5,9.31 6.79,9 6,9C4.34,9 3,10.34 3,12C3,13.66 4.34,15 6,15C6.79,15 7.5,14.69 8.04,14.19L15.16,18.34C15.11,18.55 15.08,18.77 15.08,19C15.08,20.61 16.39,21.91 18,21.91C19.61,21.91 20.92,20.61 20.92,19C20.92,17.39 19.61,16.08 18,16.08Z",
  },
  {
    id: "A3709A80-3219-4E83-9D4F-EF74F31EEAAE",
    name: "shield",
    codepoint: "F498",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5L12,1Z",
  },
  {
    id: "9E908727-9325-4FC6-B8B8-C5CA52A7A827",
    name: "shield-half-full",
    codepoint: "F77F",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "1.9.32",
    path: "M21,11C21,16.55 17.16,21.74 12,23C6.84,21.74 3,16.55 3,11V5L12,1L21,5V11M12,21C15.75,20 19,15.54 19,11.22V6.3L12,3.18V21Z",
  },
  {
    id: "A8FF94DD-6BA5-4DBA-AE23-59BB22DD733B",
    name: "shield-outline",
    codepoint: "F499",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M21,11C21,16.55 17.16,21.74 12,23C6.84,21.74 3,16.55 3,11V5L12,1L21,5V11M12,21C15.75,20 19,15.54 19,11.22V6.3L12,3.18L5,6.3V11.22C5,15.54 8.25,20 12,21Z",
  },
  {
    id: "1F35A20C-CF6C-4C2A-9A72-82269F4ECCF7",
    name: "ship-wheel",
    codepoint: "F832",
    aliases: ["voyager"],
    tags: ["Transportation + Water"],
    author: "Google",
    version: "2.1.19",
    path: "M2,11L4.05,11.1C4.3,8.83 5.5,6.85 7.25,5.56L6.13,3.84C5.86,3.36 6,2.75 6.5,2.47C7,2.2 7.59,2.36 7.87,2.84L8.8,4.66C9.78,4.24 10.86,4 12,4C13.14,4 14.22,4.24 15.2,4.66L16.13,2.84C16.41,2.36 17,2.2 17.5,2.47C18,2.75 18.14,3.36 17.87,3.84L16.75,5.56C18.5,6.85 19.7,8.83 19.95,11.1L22,11C22.55,11 23,11.45 23,12C23,12.55 22.55,13 22,13L19.95,12.9C19.7,15.17 18.5,17.15 16.75,18.44L17.87,20.16C18.14,20.64 18,21.25 17.5,21.53C17,21.8 16.41,21.64 16.13,21.16L15.2,19.34C14.22,19.76 13.14,20 12,20C10.86,20 9.78,19.76 8.8,19.34L7.87,21.16C7.59,21.64 7,21.8 6.5,21.53C6,21.25 5.86,20.64 6.13,20.16L7.25,18.44C5.5,17.15 4.3,15.17 4.05,12.9L2,13C1.45,13 1,12.55 1,12C1,11.45 1.45,11 2,11M9.07,11.35C9.2,10.74 9.53,10.2 10,9.79L8.34,7.25C7.11,8.19 6.27,9.6 6.05,11.2L9.07,11.35M12,9C12.32,9 12.62,9.05 12.9,9.14L14.28,6.45C13.58,6.16 12.81,6 12,6C11.19,6 10.42,6.16 9.72,6.45L11.1,9.14C11.38,9.05 11.68,9 12,9M14.93,11.35L17.95,11.2C17.73,9.6 16.89,8.19 15.66,7.25L14,9.79C14.47,10.2 14.8,10.74 14.93,11.35M14.93,12.65C14.8,13.26 14.47,13.8 14,14.21L15.66,16.75C16.89,15.81 17.73,14.4 17.95,12.8L14.93,12.65M12,15C11.68,15 11.38,14.95 11.09,14.86L9.72,17.55C10.42,17.84 11.19,18 12,18C12.81,18 13.58,17.84 14.28,17.55L12.91,14.86C12.62,14.95 12.32,15 12,15M9.07,12.65L6.05,12.8C6.27,14.4 7.11,15.81 8.34,16.75L10,14.21C9.53,13.8 9.2,13.26 9.07,12.65Z",
  },
  {
    id: "7A5ED547-B142-4921-8050-647B2B9F4DC0",
    name: "shopping",
    codepoint: "F49A",
    aliases: ["local-mall"],
    tags: ["Shopping"],
    author: "Google",
    version: "1.5.54",
    path: "M12,13C9.24,13 7,10.76 7,8H9C9,9.66 10.34,11 12,11C13.66,11 15,9.66 15,8H17C17,10.76 14.76,13 12,13M12,3C13.66,3 15,4.34 15,6H9C9,4.34 10.34,3 12,3M19,6H17C17,3.24 14.76,1 12,1C9.24,1 7,3.24 7,6H5C3.89,6 3,6.89 3,8V20C3,21.1 3.9,22 5,22H19C20.1,22 21,21.1 21,20V8C21,6.89 20.1,6 19,6Z",
  },
  {
    id: "E3FDDEB1-6D36-4E18-914E-06E2887E7D96",
    name: "shopping-music",
    codepoint: "F49B",
    aliases: [],
    tags: ["Shopping"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,3C10.34,3 9,4.34 9,6H15C15,4.34 13.66,3 12,3M19,6C20.1,6 21,6.9 21,8V20C21,21.1 20.1,22 19,22H5C3.89,22 3,21.1 3,20V8C3,6.89 3.89,6 5,6H7C7,3.24 9.24,1 12,1C14.76,1 17,3.24 17,6H19M9,19L16.5,14L9,10V19Z",
  },
  {
    id: "16D35D19-90C2-42DD-9E83-8F47E21A53DF",
    name: "shovel",
    codepoint: "F70F",
    aliases: [],
    tags: ["Hardware / Tools"],
    author: "Michael Richins",
    version: "1.8.36",
    path: "M15.1,1.81L12.27,4.64C11.5,5.42 11.5,6.69 12.27,7.47L13.68,8.88L9.13,13.43L6.31,10.6L4.89,12C-0.06,17 3.5,20.5 3.5,20.5C3.5,20.5 7,24 12,19.09L13.41,17.68L10.61,14.88L15.15,10.34L16.54,11.73C17.32,12.5 18.59,12.5 19.37,11.73L22.2,8.9L15.1,1.81M17.93,10.28L16.55,8.9L15.11,7.46L13.71,6.06L15.12,4.65L19.35,8.88L17.93,10.28Z",
  },
  {
    id: "01E7F800-E769-4A3F-9A30-D1B8E96F617B",
    name: "shovel-off",
    codepoint: "F710",
    aliases: [],
    tags: ["Hardware / Tools"],
    author: "Michael Richins",
    version: "1.8.36",
    path: "M15.1,1.81L12.27,4.65C11.5,5.43 11.5,6.69 12.27,7.47L13.68,8.89L13,9.62L14.44,11.06L15.17,10.33L16.56,11.72C17.34,12.5 18.61,12.5 19.39,11.72L22.22,8.88L15.1,1.81M17.93,10.28L13.7,6.06L15.11,4.65L19.34,8.88L17.93,10.28M20.7,20.24L19.29,21.65L11.5,13.88L10.5,14.88L13.33,17.69L12,19.09C7,24 3.5,20.5 3.5,20.5C3.5,20.5 -0.06,17 4.89,12L6.31,10.6L9.13,13.43L10.13,12.43L2.35,4.68L3.77,3.26L20.7,20.24Z",
  },
  {
    id: "1F29D513-0EFE-454A-B766-579A010C51B6",
    name: "shower",
    codepoint: "F99F",
    aliases: [],
    tags: ["Home Automation"],
    author: "Augustin Ursu",
    version: "2.4.85",
    path: "M21,14V15C21,16.91 19.93,18.57 18.35,19.41L19,22H17L16.5,20C16.33,20 16.17,20 16,20H8C7.83,20 7.67,20 7.5,20L7,22H5L5.65,19.41C4.07,18.57 3,16.91 3,15V14H2V12H20V5C20,4.45 19.55,4 19,4C18.5,4 18.12,4.34 18,4.79C18.63,5.33 19,6.13 19,7H13C13,5.34 14.34,4 16,4C16.06,4 16.11,4 16.17,4C16.58,2.84 17.69,2 19,2C20.66,2 22,3.34 22,5V14H21V14M19,14H5V15C5,16.66 6.34,18 8,18H16C17.66,18 19,16.66 19,15V14Z",
  },
  {
    id: "F0E6B2EB-7E10-42C8-AEF1-84A461E1E2B3",
    name: "shower-head",
    codepoint: "F9A0",
    aliases: [],
    tags: ["Home Automation"],
    author: "Augustin Ursu",
    version: "2.4.85",
    path: "M20,20C20.55,20 21,20.45 21,21C21,21.55 20.55,22 20,22C19.45,22 19,21.55 19,21C19,20.45 19.45,20 20,20M16,20C16.55,20 17,20.45 17,21C17,21.55 16.55,22 16,22C15.45,22 15,21.55 15,21C15,20.45 15.45,20 16,20M12,20C12.55,20 13,20.45 13,21C13,21.55 12.55,22 12,22C11.45,22 11,21.55 11,21C11,20.45 11.45,20 12,20M8,20C8.55,20 9,20.45 9,21C9,21.55 8.55,22 8,22C7.45,22 7,21.55 7,21C7,20.45 7.45,20 8,20M4,20C4.55,20 5,20.45 5,21C5,21.55 4.55,22 4,22C3.45,22 3,21.55 3,21C3,20.45 3.45,20 4,20M6,17C6.55,17 7,17.45 7,18C7,18.55 6.55,19 6,19H6C5.45,19 5,18.55 5,18C5,17.45 5.45,17 6,17H6M10,17C10.55,17 11,17.45 11,18C11,18.55 10.55,19 10,19C9.45,19 9,18.55 9,18C9,17.45 9.45,17 10,17M14,17C14.55,17 15,17.45 15,18C15,18.55 14.55,19 14,19C13.45,19 13,18.55 13,18C13,17.45 13.45,17 14,17M18,17C18.55,17 19,17.45 19,18C19,18.55 18.55,19 18,19C17.45,19 17,18.55 17,18C17,17.45 17.45,17 18,17M8,14C8.55,14 9,14.45 9,15C9,15.55 8.55,16 8,16C7.45,16 7,15.55 7,15C7,14.45 7.45,14 8,14M12,14C12.55,14 13,14.45 13,15C13,15.55 12.55,16 12,16C11.45,16 11,15.55 11,15C11,14.45 11.45,14 12,14M16,14C16.55,14 17,14.45 17,15C17,15.55 16.55,16 16,16C15.45,16 15,15.55 15,15C15,14.45 15.45,14 16,14M19,12H5V10H19V12M17.92,9H6.08C6.5,6.5 8.5,4.5 11,4.08V2H13V4.08C15.5,4.5 17.5,6.5 17.92,9Z",
  },
  {
    id: "BCE4CF23-0A2B-430F-89C9-7597F1132919",
    name: "shredder",
    codepoint: "F49C",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M6,3V7H8V5H16V7H18V3H6M5,8C3.34,8 2,9.34 2,11V17H5V14H19V17H22V11C22,9.34 20.66,8 19,8H5M18,10C18.55,10 19,10.45 19,11C19,11.55 18.55,12 18,12C17.45,12 17,11.55 17,11C17,10.45 17.45,10 18,10M7,16V21H9V16H7M11,16V20H13V16H11M15,16V21H17V16H15Z",
  },
  {
    id: "99537665-2115-40D6-9725-0F4B4730C99A",
    name: "shuffle",
    codepoint: "F49D",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M14.83,13.41L13.42,14.82L16.55,17.95L14.5,20H20V14.5L17.96,16.54L14.83,13.41M14.5,4L16.54,6.04L4,18.59L5.41,20L17.96,7.46L20,9.5V4M10.59,9.17L5.41,4L4,5.41L9.17,10.58L10.59,9.17Z",
  },
  {
    id: "DAA3B240-E394-46A8-83FE-6EE6712BF806",
    name: "shuffle-disabled",
    codepoint: "F49E",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M16,4.5V7H5V9H16V11.5L19.5,8M16,12.5V15H5V17H16V19.5L19.5,16",
  },
  {
    id: "84D958BE-5145-4490-BA8F-D00E6870CC9D",
    name: "shuffle-variant",
    codepoint: "F49F",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M17,3L22.25,7.5L17,12L22.25,16.5L17,21V18H14.26L11.44,15.18L13.56,13.06L15.5,15H17V12L17,9H15.5L6.5,18H2V15H5.26L14.26,6H17V3M2,6H6.5L9.32,8.82L7.2,10.94L5.26,9H2V6Z",
  },
  {
    id: "59A98F47-9067-492A-8454-42BEFA2391C1",
    name: "sigma",
    codepoint: "F4A0",
    aliases: ["summation"],
    tags: ["Math"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M5,4H18V9H17L16,6H10.06L13.65,11.13L9.54,17H16L17,15H18V20H5L10.6,12L5,4Z",
  },
  {
    id: "DD1EAF89-C6AC-4E61-BF78-93425B16DD24",
    name: "sigma-lower",
    codepoint: "F62B",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.6.50",
    path: "M19,12C19,16.42 15.64,20 11.5,20C7.36,20 4,16.42 4,12C4,7.58 7.36,4 11.5,4H20V6H16.46C18,7.47 19,9.61 19,12M11.5,6C8.46,6 6,8.69 6,12C6,15.31 8.46,18 11.5,18C14.54,18 17,15.31 17,12C17,8.69 14.54,6 11.5,6Z",
  },
  {
    id: "159F7B23-A336-4F8C-A3BB-D8AB143D6661",
    name: "sign-caution",
    codepoint: "F4A1",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M2,3H22V13H18V21H16V13H8V21H6V13H2V3M18.97,11L20,9.97V7.15L16.15,11H18.97M13.32,11L19.32,5H16.5L10.5,11H13.32M7.66,11L13.66,5H10.83L4.83,11H7.66M5.18,5L4,6.18V9L8,5H5.18Z",
  },
  {
    id: "93E3355E-36F9-4B26-A337-C5F794D98941",
    name: "sign-direction",
    codepoint: "F780",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M11,12H3.5L6,9.5L3.5,7H11V3L12,2L13,3V7H18L20.5,9.5L18,12H13V20C14.1,20 15,20.9 15,22H9C9,20.9 9.9,20 11,20V12Z",
  },
  {
    id: "6AC6C6C2-8925-4ECC-BD95-6B961B2CD0A5",
    name: "sign-text",
    codepoint: "F781",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M11,3L12,2L13,3V5H20C20.55,5 21,5.45 21,6V16C21,16.55 20.55,17 20,17H13V20C14.1,20 15,20.9 15,22H9C9,20.9 9.9,20 11,20V17H4C3.45,17 3,16.55 3,16V6C3,5.45 3.45,5 4,5H11V3M6,8V10H18V8H6M6,12V14H13V12H6Z",
  },
  {
    id: "7099FDF8-B653-4C49-BE2B-5B96147A709D",
    name: "signal",
    codepoint: "F4A2",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M3,21H6V18H3M8,21H11V14H8M13,21H16V9H13M18,21H21V3H18V21Z",
  },
  {
    id: "C281EBBF-23FD-4F0A-8908-BFBA18F75FDD",
    name: "signal-2g",
    codepoint: "F711",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "1.8.36",
    path: "M11,19.5H2V13.5C2,11.84 3.34,10.5 5,10.5H8V7.5H2V4.5H8C9.66,4.5 11,5.84 11,7.5V10.5C11,12.16 9.66,13.5 8,13.5H5V16.5H11M22,10.5H17.5V13.5H19V16.5H16V7.5H22V4.5H16C14.34,4.5 13,5.84 13,7.5V16.5C13,18.16 14.34,19.5 16,19.5H19C20.66,19.5 22,18.16 22,16.5",
  },
  {
    id: "F0ACC092-8F79-43C9-9F8F-72E41AE557F2",
    name: "signal-3g",
    codepoint: "F712",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "1.8.36",
    path: "M11,16.5V14.25C11,13 10,12 8.75,12C10,12 11,11 11,9.75V7.5C11,5.84 9.66,4.5 8,4.5H2V7.5H8V10.5H5V13.5H8V16.5H2V19.5H8C9.66,19.5 11,18.16 11,16.5M22,16.5V10.5H17.5V13.5H19V16.5H16V7.5H22V4.5H16C14.34,4.5 13,5.84 13,7.5V16.5C13,18.16 14.34,19.5 16,19.5H19C20.66,19.5 22,18.16 22,16.5Z",
  },
  {
    id: "7D633D1D-C265-4D2F-860E-43263B34A06F",
    name: "signal-4g",
    codepoint: "F713",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "1.8.36",
    path: "M22,16.5V10.5H17.5V13.5H19V16.5H16V7.5H22V4.5H16C14.34,4.5 13,5.84 13,7.5V16.5C13,18.16 14.34,19.5 16,19.5H19C20.66,19.5 22,18.16 22,16.5M8,19.5H11V4.5H8V10.5H5V4.5H2V13.5H8V19.5Z",
  },
  {
    id: "F5CC42C0-FA38-488C-AD3F-DCF5329DFBB8",
    name: "signal-cellular-1",
    codepoint: "F8BB",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.2.43",
    path: "M19.5,5.5V18.5H17.5V5.5H19.5M12.5,10.5V18.5H10.5V10.5H12.5M21,4H16V20H21V4M14,9H9V20H14V9M7,14H2V20H7V14Z",
  },
  {
    id: "5E21DB8A-BFFC-4038-8EBF-D3E462A43CD9",
    name: "signal-cellular-2",
    codepoint: "F8BC",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.2.43",
    path: "M19.5,5.5V18.5H17.5V5.5H19.5M21,4H16V20H21V4M14,9H9V20H14V9M7,14H2V20H7V14Z",
  },
  {
    id: "85A2D38F-5AB3-430C-9794-032E991A4956",
    name: "signal-cellular-3",
    codepoint: "F8BD",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.2.43",
    path: "M21,4H16V20H21V4M14,9H9V20H14V9M7,14H2V20H7V14Z",
  },
  {
    id: "AA11AD00-4A6D-4D7F-911C-137CDDCF34B6",
    name: "signal-cellular-outline",
    codepoint: "F8BE",
    aliases: ["signal-cellular-0"],
    tags: [],
    author: "Michael Richins",
    version: "2.2.43",
    path: "M19.5,5.5V18.5H17.5V5.5H19.5M12.5,10.5V18.5H10.5V10.5H12.5M5.5,15.5V18.5H3.5V15.5H5.5M21,4H16V20H21V4M14,9H9V20H14V9M7,14H2V20H7V14Z",
  },
  {
    id: "A960C38F-7EFE-4FE6-94AB-C7B0CD07DD50",
    name: "signal-hspa",
    codepoint: "F714",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "1.8.36",
    path: "M10.5,10.5H13.5V4.5H16.5V19.5H13.5V13.5H10.5V19.5H7.5V4.5H10.5V10.5Z",
  },
  {
    id: "CDCB7012-AD69-4B80-A64E-FDA1375271AD",
    name: "signal-hspa-plus",
    codepoint: "F715",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "1.8.36",
    path: "M19,8V11H22V14H19V17H16V14H13V11H16V8H19M5,10.5H8V4.5H11V19.5H8V13.5H5V19.5H2V4.5H5V10.5Z",
  },
  {
    id: "9DAFE242-BF4B-43F8-8A6E-89EBB0EEDCAA",
    name: "signal-off",
    codepoint: "F782",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "1.9.32",
    path: "M18,3V16.18L21,19.18V3H18M4.28,5L3,6.27L10.73,14H8V21H11V14.27L13,16.27V21H16V19.27L19.73,23L21,21.72L4.28,5M13,9V11.18L16,14.18V9H13M3,18V21H6V18H3Z",
  },
  {
    id: "F4D628E8-ADAA-48B7-9ED2-83560FF4583F",
    name: "signal-variant",
    codepoint: "F60A",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M4,6V4H4.1C12.9,4 20,11.1 20,19.9V20H18V19.9C18,12.2 11.8,6 4,6M4,10V8C10.63,8 16,13.37 16,20H14C14,14.48 9.52,10 4,10M4,14V12C8.42,12 12,15.58 12,20H10C10,16.69 7.31,14 4,14M4,16C6.21,16 8,17.79 8,20H4V16Z",
  },
  {
    id: "F7C26535-863F-4295-9E48-9847B740FEE7",
    name: "silverware",
    codepoint: "F4A3",
    aliases: ["local-dining", "restaurant-menu", "local-restaurant"],
    tags: ["Food / Drink"],
    author: "Google",
    version: "1.5.54",
    path: "M8.1,13.34L3.91,9.16C2.35,7.59 2.35,5.06 3.91,3.5L10.93,10.5L8.1,13.34M14.88,11.53L13.41,13L20.29,19.88L18.88,21.29L12,14.41L5.12,21.29L3.71,19.88L13.47,10.12C12.76,8.59 13.26,6.44 14.85,4.85C16.76,2.93 19.5,2.57 20.96,4.03C22.43,5.5 22.07,8.24 20.15,10.15C18.56,11.74 16.41,12.24 14.88,11.53Z",
  },
  {
    id: "7B00A99C-3766-4939-993F-657333EE430B",
    name: "silverware-fork",
    codepoint: "F4A4",
    aliases: [],
    tags: ["Food / Drink"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M5.12,21.29L3.71,19.88L13.36,10.22L13.16,10C12.38,9.23 12.38,7.97 13.16,7.19L17.5,2.82L18.43,3.74L15.19,7L16.15,7.94L19.39,4.69L20.31,5.61L17.06,8.85L18,9.81L21.26,6.56L22.18,7.5L17.81,11.84C17.03,12.62 15.77,12.62 15,11.84L14.78,11.64L5.12,21.29Z",
  },
  {
    id: "5FCBB812-F381-4E83-B60E-E126992910FB",
    name: "silverware-spoon",
    codepoint: "F4A5",
    aliases: [],
    tags: ["Food / Drink"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M14.88,11.53L5.12,21.29L3.71,19.88L13.47,10.12C12.76,8.59 13.26,6.44 14.85,4.85C16.76,2.93 19.5,2.57 20.96,4.03C22.43,5.5 22.07,8.24 20.15,10.15C18.56,11.74 16.41,12.24 14.88,11.53Z",
  },
  {
    id: "A91FC6E1-2613-41E7-A8CA-58740B3322DA",
    name: "silverware-variant",
    codepoint: "F4A6",
    aliases: [],
    tags: ["Food / Drink", "Places"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M8.1,13.34L3.91,9.16C2.35,7.59 2.35,5.06 3.91,3.5L10.93,10.5L8.1,13.34M13.41,13L20.29,19.88L18.88,21.29L12,14.41L5.12,21.29L3.71,19.88L13.36,10.22L13.16,10C12.38,9.23 12.38,7.97 13.16,7.19L17.5,2.82L18.43,3.74L15.19,7L16.15,7.94L19.39,4.69L20.31,5.61L17.06,8.85L18,9.81L21.26,6.56L22.18,7.5L17.81,11.84C17.03,12.62 15.77,12.62 15,11.84L14.78,11.64L13.41,13Z",
  },
  {
    id: "93020F21-A0FE-427D-8685-B74EE39B9921",
    name: "sim",
    codepoint: "F4A7",
    aliases: ["sim-card"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M20,4C20,2.9 19.1,2 18,2H10L4,8V20C4,21.1 4.9,22 6,22H18C19.11,22 20,21.1 20,20V4M9,19H7V17H9V19M17,19H15V17H17V19M9,15H7V11H9V15M13,19H11V15H13V19M13,13H11V11H13V13M17,15H15V11H17V15Z",
  },
  {
    id: "43CD286A-D183-474F-9B8A-93D43A355117",
    name: "sim-alert",
    codepoint: "F4A8",
    aliases: ["sim-warning", "sim-card-alert"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M13,13H11V8H13M13,17H11V15H13M18,2H10L4,8V20C4,21.1 4.9,22 6,22H18C19.1,22 20,21.1 20,20V4C20,2.9 19.1,2 18,2Z",
  },
  {
    id: "65B6C060-C1A9-4049-A6B6-FEAC02A899D3",
    name: "sim-off",
    codepoint: "F4A9",
    aliases: ["signal-cellular-no-sim"],
    tags: ["Cellphone / Phone"],
    author: "Google",
    version: "1.5.54",
    path: "M19,5C19,3.9 18.1,3 17,3H10L7.66,5.34L19,16.68V5M3.65,3.88L2.38,5.15L5,7.77V19C5,20.1 5.9,21 7,21H17C17.36,21 17.68,20.9 17.97,20.74L19.85,22.62L21.12,21.35L3.65,3.88Z",
  },
  {
    id: "673CE0A7-8AA2-4BFD-9308-B51589FBF520",
    name: "sitemap",
    codepoint: "F4AA",
    aliases: ["workflow", "flowchart"],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M9,2V8H11V11H5C3.89,11 3,11.89 3,13V16H1V22H7V16H5V13H11V16H9V22H15V16H13V13H19V16H17V22H23V16H21V13C21,11.89 20.11,11 19,11H13V8H15V2H9Z",
  },
  {
    id: "45260E4C-E8EB-4E35-85A8-F19A91FE1A2C",
    name: "skip-backward",
    codepoint: "F4AB",
    aliases: ["title-backward", "previous-title"],
    tags: ["Home Automation"],
    author: "Cody",
    version: "1.5.54",
    path: "M20,5V19L13,12M6,5V19H4V5M13,5V19L6,12",
  },
  {
    id: "760EA0AB-7906-4FA4-86E0-CD18A4073302",
    name: "skip-forward",
    codepoint: "F4AC",
    aliases: ["title-forward", "next-title"],
    tags: ["Home Automation"],
    author: "Cody",
    version: "1.5.54",
    path: "M4,5V19L11,12M18,5V19H20V5M11,5V19L18,12",
  },
  {
    id: "D2F19A25-4EF4-41A7-A91A-C03C77E32186",
    name: "skip-next",
    codepoint: "F4AD",
    aliases: [],
    tags: ["Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M16,18H18V6H16M6,18L14.5,12L6,6V18Z",
  },
  {
    id: "0D688B5D-27F8-47CF-9234-87DB3F25D28E",
    name: "skip-next-circle",
    codepoint: "F661",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.6.50",
    path: "M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M8,8L13,12L8,16M14,8H16V16H14",
  },
  {
    id: "5AE3DE91-B2E8-48DD-A170-1F26E391F830",
    name: "skip-next-circle-outline",
    codepoint: "F662",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.6.50",
    path: "M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4M8,8V16L13,12M14,8V16H16V8",
  },
  {
    id: "8D8B924F-0AD5-4458-9BCE-0A5887D935B6",
    name: "skip-previous",
    codepoint: "F4AE",
    aliases: [],
    tags: ["Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M6,18V6H8V18H6M9.5,12L18,6V18L9.5,12Z",
  },
  {
    id: "3584845F-971C-45BB-8184-CFEBE0044474",
    name: "skip-previous-circle",
    codepoint: "F663",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.6.50",
    path: "M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M8,8H10V16H8M16,8V16L11,12",
  },
  {
    id: "FF83529F-FAA5-4FAD-9EE8-9F9A74409F93",
    name: "skip-previous-circle-outline",
    codepoint: "F664",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.6.50",
    path: "M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M12,4C7.59,4 4,7.59 4,12C4,16.41 7.59,20 12,20C16.41,20 20,16.41 20,12C20,7.59 16.41,4 12,4M16,8V16L11,12M10,8V16H8V8",
  },
  {
    id: "AD1B00BA-C98D-4961-A444-9484EF434BEC",
    name: "skull",
    codepoint: "F68B",
    aliases: [],
    tags: [],
    author: "JapanYoshi",
    version: "1.7.12",
    path: "M12,2C7.03,2 3,6.03 3,11C3,14.03 4.53,16.82 7,18.47V22H9V19H11V22H13V19H15V22H17V18.46C19.47,16.81 21,14 21,11C21,6.03 16.97,2 12,2M8,11C9.1,11 10,11.9 10,13C10,14.1 9.1,15 8,15C6.9,15 6,14.1 6,13C6,11.9 6.9,11 8,11M16,11C17.1,11 18,11.9 18,13C18,14.1 17.1,15 16,15C14.9,15 14,14.1 14,13C14,11.9 14.9,11 16,11M12,14L13.5,17H10.5L12,14Z",
  },
  {
    id: "07E9D89D-2D58-40C6-9D41-49722CFC0DAE",
    name: "skype",
    codepoint: "F4AF",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M18,6C20.07,8.04 20.85,10.89 20.36,13.55C20.77,14.27 21,15.11 21,16C21,18.76 18.76,21 16,21C15.11,21 14.27,20.77 13.55,20.36C10.89,20.85 8.04,20.07 6,18C3.93,15.96 3.15,13.11 3.64,10.45C3.23,9.73 3,8.89 3,8C3,5.24 5.24,3 8,3C8.89,3 9.73,3.23 10.45,3.64C13.11,3.15 15.96,3.93 18,6M12.04,17.16C14.91,17.16 16.34,15.78 16.34,13.92C16.34,12.73 15.78,11.46 13.61,10.97L11.62,10.53C10.86,10.36 10,10.13 10,9.42C10,8.7 10.6,8.2 11.7,8.2C13.93,8.2 13.72,9.73 14.83,9.73C15.41,9.73 15.91,9.39 15.91,8.8C15.91,7.43 13.72,6.4 11.86,6.4C9.85,6.4 7.7,7.26 7.7,9.54C7.7,10.64 8.09,11.81 10.25,12.35L12.94,13.03C13.75,13.23 13.95,13.68 13.95,14.1C13.95,14.78 13.27,15.45 12.04,15.45C9.63,15.45 9.96,13.6 8.67,13.6C8.09,13.6 7.67,14 7.67,14.57C7.67,15.68 9,17.16 12.04,17.16Z",
  },
  {
    id: "813333B0-4A34-4AC6-819C-0FBEABC06246",
    name: "skype-business",
    codepoint: "F4B0",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12.03,16.53C9.37,16.53 8.18,15.22 8.18,14.24C8.18,13.74 8.55,13.38 9.06,13.38C10.2,13.38 9.91,15 12.03,15C13.12,15 13.73,14.43 13.73,13.82C13.73,13.46 13.55,13.06 12.83,12.88L10.46,12.29C8.55,11.81 8.2,10.78 8.2,9.81C8.2,7.79 10.1,7.03 11.88,7.03C13.5,7.03 15.46,7.94 15.46,9.15C15.46,9.67 15,9.97 14.5,9.97C13.5,9.97 13.7,8.62 11.74,8.62C10.77,8.62 10.23,9.06 10.23,9.69C10.23,10.32 11,10.5 11.66,10.68L13.42,11.07C15.34,11.5 15.83,12.62 15.83,13.67C15.83,15.31 14.57,16.53 12.03,16.53M18,6C20.07,8.04 20.85,10.89 20.36,13.55C20.77,14.27 21,15.11 21,16C21,18.76 18.76,21 16,21C15.11,21 14.27,20.77 13.55,20.36C10.89,20.85 8.04,20.07 6,18C3.93,15.96 3.15,13.11 3.64,10.45C3.23,9.73 3,8.89 3,8C3,5.24 5.24,3 8,3C8.89,3 9.73,3.23 10.45,3.64C13.11,3.15 15.96,3.93 18,6M8,5C6.34,5 5,6.34 5,8C5,8.79 5.3,9.5 5.8,10.04C5.1,12.28 5.63,14.82 7.4,16.6C9.18,18.37 11.72,18.9 13.96,18.2C14.5,18.7 15.21,19 16,19C17.66,19 19,17.66 19,16C19,15.21 18.7,14.5 18.2,13.96C18.9,11.72 18.37,9.18 16.6,7.4C14.82,5.63 12.28,5.1 10.04,5.8C9.5,5.3 8.79,5 8,5Z",
  },
  {
    id: "EA0E061F-B48E-4443-BBE8-6080C2258730",
    name: "slack",
    codepoint: "F4B1",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M10.23,11.16L12.91,10.27L13.77,12.84L11.09,13.73L10.23,11.16M17.69,13.71C18.23,13.53 18.5,12.94 18.34,12.4C18.16,11.86 17.57,11.56 17.03,11.75L15.73,12.18L14.87,9.61L16.17,9.17C16.71,9 17,8.4 16.82,7.86C16.64,7.32 16.05,7 15.5,7.21L14.21,7.64L13.76,6.3C13.58,5.76 13,5.46 12.45,5.65C11.91,5.83 11.62,6.42 11.8,6.96L12.25,8.3L9.57,9.19L9.12,7.85C8.94,7.31 8.36,7 7.81,7.2C7.27,7.38 7,7.97 7.16,8.5L7.61,9.85L6.31,10.29C5.77,10.47 5.5,11.06 5.66,11.6C5.8,12 6.19,12.3 6.61,12.31L6.97,12.25L8.27,11.82L9.13,14.39L7.83,14.83C7.29,15 7,15.6 7.18,16.14C7.32,16.56 7.71,16.84 8.13,16.85L8.5,16.79L9.79,16.36L10.24,17.7C10.38,18.13 10.77,18.4 11.19,18.41L11.55,18.35C12.09,18.17 12.38,17.59 12.2,17.04L11.75,15.7L14.43,14.81L14.88,16.15C15,16.57 15.41,16.84 15.83,16.85L16.19,16.8C16.73,16.62 17,16.03 16.84,15.5L16.39,14.15L17.69,13.71M21.17,9.25C23.23,16.12 21.62,19.1 14.75,21.17C7.88,23.23 4.9,21.62 2.83,14.75C0.77,7.88 2.38,4.9 9.25,2.83C16.12,0.77 19.1,2.38 21.17,9.25Z",
  },
  {
    id: "C9CF20D8-55F4-4997-8019-F8056ED86702",
    name: "sleep",
    codepoint: "F4B2",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M23,12H17V10L20.39,6H17V4H23V6L19.62,10H23V12M15,16H9V14L12.39,10H9V8H15V10L11.62,14H15V16M7,20H1V18L4.39,14H1V12H7V14L3.62,18H7V20Z",
  },
  {
    id: "0801B02C-2187-40D1-8A03-D521D0214662",
    name: "sleep-off",
    codepoint: "F4B3",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M2,5.27L3.28,4L20,20.72L18.73,22L12.73,16H9V14L9.79,13.06L2,5.27M23,12H17V10L20.39,6H17V4H23V6L19.62,10H23V12M9.82,8H15V10L13.54,11.72L9.82,8M7,20H1V18L4.39,14H1V12H7V14L3.62,18H7V20Z",
  },
  {
    id: "1DDC71A0-A86A-4E8F-BF1D-CD33C0B0BEA4",
    name: "smoke-detector",
    codepoint: "F392",
    aliases: ["nest-protect"],
    tags: ["Device / Tech", "Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M12,18C15.31,18 18,15.31 18,12C18,8.68 15.31,6 12,6C8.68,6 6,8.68 6,12C6,15.31 8.69,18 12,18M19,3C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H19M8,12C8,9.79 9.79,8 12,8C14.21,8 16,9.79 16,12C16,14.21 14.21,16 12,16C9.79,16 8,14.21 8,12Z",
  },
  {
    id: "20A9F2BB-C53E-410E-A433-4CEE2305AD49",
    name: "smoking",
    codepoint: "F4B4",
    aliases: ["cigarette", "smoking-area", "smoking-rooms"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M2,16H17V19H2V16M20.5,16H22V19H20.5V16M18,16H19.5V19H18V16M18.85,7.73C19.47,7.12 19.85,6.28 19.85,5.35C19.85,3.5 18.35,2 16.5,2V3.5C17.5,3.5 18.35,4.33 18.35,5.35C18.35,6.37 17.5,7.2 16.5,7.2V8.7C18.74,8.7 20.5,10.53 20.5,12.77V15H22V12.76C22,10.54 20.72,8.62 18.85,7.73M16.03,10.2H14.5C13.5,10.2 12.65,9.22 12.65,8.2C12.65,7.18 13.5,6.45 14.5,6.45V4.95C12.65,4.95 11.15,6.45 11.15,8.3C11.15,10.15 12.65,11.65 14.5,11.65H16.03C17.08,11.65 18,12.39 18,13.7V15H19.5V13.36C19.5,11.55 17.9,10.2 16.03,10.2Z",
  },
  {
    id: "5F974B83-AEEC-4C52-B281-1A8663B70027",
    name: "smoking-off",
    codepoint: "F4B5",
    aliases: ["no-smoking", "cigarette-off", "smoke-free"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M2,6L9,13H2V16H12L19,23L20.25,21.75L3.25,4.75L2,6M20.5,13H22V16H20.5V13M18,13H19.5V16H18V13M18.85,4.88C19.47,4.27 19.85,3.43 19.85,2.5H18.35C18.35,3.5 17.5,4.35 16.5,4.35V5.85C18.74,5.85 20.5,7.68 20.5,9.92V12H22V9.92C22,7.69 20.72,5.77 18.85,4.88M14.5,8.7H16.03C17.08,8.7 18,9.44 18,10.75V12H19.5V10.41C19.5,8.61 17.9,7.25 16.03,7.25H14.5C13.5,7.25 12.65,6.27 12.65,5.25C12.65,4.23 13.5,3.5 14.5,3.5V2C12.65,2 11.15,3.5 11.15,5.35C11.15,7.2 12.65,8.7 14.5,8.7M17,15.93V13H14.07L17,15.93Z",
  },
  {
    id: "6DA57C23-2ADA-4CA1-8D1D-AFBBFA59C4FA",
    name: "snapchat",
    codepoint: "F4B6",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,20.45C10.81,20.45 10.1,19.94 9.47,19.5C9,19.18 8.58,18.87 8.08,18.79C6.93,18.73 6.59,18.79 5.97,18.9C5.86,18.9 5.73,18.87 5.68,18.69C5.5,17.94 5.45,17.73 5.32,17.71C4,17.5 3.19,17.2 3.03,16.83C3,16.6 3.07,16.5 3.18,16.5C4.25,16.31 5.2,15.75 6,14.81C6.63,14.09 6.93,13.39 6.96,13.32C7.12,13 7.15,12.72 7.06,12.5C6.89,12.09 6.31,11.91 5.68,11.7C5.34,11.57 4.79,11.29 4.86,10.9C4.92,10.62 5.29,10.42 5.81,10.46C6.16,10.62 6.46,10.7 6.73,10.7C7.06,10.7 7.21,10.58 7.25,10.54C7.14,8.78 7.05,7.25 7.44,6.38C8.61,3.76 11.08,3.55 12,3.55C12.92,3.55 15.39,3.76 16.56,6.38C16.95,7.25 16.86,8.78 16.75,10.54C16.79,10.58 16.94,10.7 17.27,10.7C17.54,10.7 17.84,10.62 18.19,10.46C18.71,10.42 19.08,10.62 19.14,10.9C19.21,11.29 18.66,11.57 18.32,11.7C17.69,11.91 17.11,12.09 16.94,12.5C16.85,12.72 16.88,13 17.04,13.32C17.07,13.39 17.37,14.09 18,14.81C18.8,15.75 19.75,16.31 20.82,16.5C20.93,16.5 21,16.6 20.97,16.83C20.81,17.2 20,17.5 18.68,17.71C18.55,17.73 18.5,17.94 18.32,18.69C18.27,18.87 18.14,18.9 18.03,18.9C17.41,18.79 17.07,18.73 15.92,18.79C15.42,18.87 15,19.18 14.53,19.5C13.9,19.94 13.19,20.45 12,20.45Z",
  },
  {
    id: "5675A747-D467-473E-9A1D-1C61E1B5C619",
    name: "snowflake",
    codepoint: "F716",
    aliases: [],
    tags: ["Weather", "Holiday"],
    author: "Google",
    version: "1.8.36",
    path: "M20.79,13.95L18.46,14.57L16.46,13.44V10.56L18.46,9.43L20.79,10.05L21.31,8.12L19.54,7.65L20,5.88L18.07,5.36L17.45,7.69L15.45,8.82L13,7.38V5.12L14.71,3.41L13.29,2L12,3.29L10.71,2L9.29,3.41L11,5.12V7.38L8.5,8.82L6.5,7.69L5.92,5.36L4,5.88L4.47,7.65L2.7,8.12L3.22,10.05L5.55,9.43L7.55,10.56V13.45L5.55,14.58L3.22,13.96L2.7,15.89L4.47,16.36L4,18.12L5.93,18.64L6.55,16.31L8.55,15.18L11,16.62V18.88L9.29,20.59L10.71,22L12,20.71L13.29,22L14.7,20.59L13,18.88V16.62L15.5,15.17L17.5,16.3L18.12,18.63L20,18.12L19.53,16.35L21.3,15.88L20.79,13.95M9.5,10.56L12,9.11L14.5,10.56V13.44L12,14.89L9.5,13.44V10.56Z",
  },
  {
    id: "06497E01-D87F-479B-90DC-B4E33497C8D8",
    name: "snowman",
    codepoint: "F4B7",
    aliases: [],
    tags: ["Holiday"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M17,17C17,19.76 14.76,22 12,22C9.24,22 7,19.76 7,17C7,15.5 7.65,14.17 8.69,13.25C8.26,12.61 8,11.83 8,11C8,10.86 8,10.73 8,10.59L5.04,8.87L4.83,8.71L2.29,9.39L2.03,8.43L4.24,7.84L2.26,6.69L2.76,5.82L4.74,6.97L4.15,4.75L5.11,4.5L5.8,7.04L6.04,7.14L8.73,8.69C9.11,8.15 9.62,7.71 10.22,7.42C9.5,6.87 9,6 9,5C9,3.34 10.34,2 12,2C13.66,2 15,3.34 15,5C15,6 14.5,6.87 13.78,7.42C14.38,7.71 14.89,8.15 15.27,8.69L17.96,7.14L18.2,7.04L18.89,4.5L19.85,4.75L19.26,6.97L21.24,5.82L21.74,6.69L19.76,7.84L21.97,8.43L21.71,9.39L19.17,8.71L18.96,8.87L16,10.59V11C16,11.83 15.74,12.61 15.31,13.25C16.35,14.17 17,15.5 17,17Z",
  },
  {
    id: "B4AFB6A4-C315-4B06-AE4D-AC633F3ED0A7",
    name: "soccer",
    codepoint: "F4B8",
    aliases: ["football"],
    tags: ["Sport"],
    author: "Christopher Schreiner",
    version: "1.5.54",
    path: "M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M12,3C13.76,3 15.4,3.53 16.78,4.41L16.5,5H13L12,5L10.28,4.16L10.63,3.13C11.08,3.05 11.53,3 12,3M9.53,3.38L9.19,4.41L6.63,5.69L5.38,5.94C6.5,4.73 7.92,3.84 9.53,3.38M13,6H16L18.69,9.59L17.44,12.16L14.81,12.78L11.53,8.94L13,6M6.16,6.66L7,10L5.78,13.06L3.22,13.94C3.08,13.31 3,12.67 3,12C3,10.1 3.59,8.36 4.59,6.91L6.16,6.66M20.56,9.22C20.85,10.09 21,11.03 21,12C21,13.44 20.63,14.79 20.03,16H19L18.16,12.66L19.66,9.66L20.56,9.22M8,10H11L13.81,13.28L12,16L8.84,16.78L6.53,13.69L8,10M12,17L15,19L14.13,20.72C13.44,20.88 12.73,21 12,21C10.25,21 8.63,20.5 7.25,19.63L8.41,17.91L12,17M19,17H19.5C18.5,18.5 17,19.67 15.31,20.34L16,19L19,17Z",
  },
  {
    id: "C24D4262-700B-46E1-82C1-01449C16205E",
    name: "soccer-field",
    codepoint: "F833",
    aliases: ["football-pitch"],
    tags: ["Sport"],
    author: "GreenTurtwig",
    version: "2.1.19",
    path: "M4,4C2.89,4 2,4.89 2,6V18C2,19.1 2.9,20 4,20H20C21.1,20 22,19.1 22,18V6C22,4.89 21.1,4 20,4H4M4,6H11V8.13C9.24,8.59 8,10.18 8,12C8,13.82 9.24,15.41 11,15.87V18H4V16H7V8H4V6M13,6H20V8H17V16H20V18H13V15.87C14.76,15.41 16,13.82 16,12C16,10.18 14.76,8.59 13,8.13V6M4,10H5V14H4V10M19,10H20V14H19V10M13,10.27C13.62,10.63 14,11.29 14,12C14,12.71 13.62,13.37 13,13.73V10.27M11,10.27V13.73C10.38,13.37 10,12.71 10,12C10,11.29 10.38,10.63 11,10.27Z",
  },
  {
    id: "5560ABF9-E635-4D73-A39B-5404443F099F",
    name: "sofa",
    codepoint: "F4B9",
    aliases: ["couch"],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M7,6H9C10.1,6 11,6.9 11,8V12H5V8C5,6.9 5.9,6 7,6M15,6H17C18.1,6 19,6.9 19,8V12H13V8C13,6.9 13.9,6 15,6M1,9H2C2.55,9 3,9.45 3,10V12C3,13.1 3.9,14 5,14H19C20.1,14 21,13.1 21,12V11L21,10C21,9.45 21.45,9 22,9H23C23.55,9 24,9.45 24,10V19H21V17H3V19H0V10C0,9.45 0.45,9 1,9Z",
  },
  {
    id: "F0E0017F-DD8C-4811-9428-613238CA66A4",
    name: "solid",
    codepoint: "F68C",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.7.12",
    path: "M0,0H24V24H0",
  },
  {
    id: "3052FDE9-791A-43E8-ACF4-A5EB7DF8296F",
    name: "sort",
    codepoint: "F4BA",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M10,13V11H18V13H10M10,19V17H14V19H10M10,7V5H22V7H10M6,17H8.5L5,20.5L1.5,17H4V7H1.5L5,3.5L8.5,7H6V17Z",
  },
  {
    id: "F36D1111-54BF-4BB8-AE34-DE4809105551",
    name: "sort-ascending",
    codepoint: "F4BC",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M10,11V13H18V11H10M10,5V7H14V5H10M10,17V19H22V17H10M6,7H8.5L5,3.5L1.5,7H4V20H6V7Z",
  },
  {
    id: "F0028BDF-0589-400F-8596-100CCB029D6E",
    name: "sort-descending",
    codepoint: "F4BD",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M10,13V11H18V13H10M10,19V17H14V19H10M10,7V5H22V7H10M6,17H8.5L5,20.5L1.5,17H4V4H6V17Z",
  },
  {
    id: "9E32B54D-9759-4233-B358-C00A11300713",
    name: "sort-variant",
    codepoint: "F4BF",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M3,13H15V11H3M3,6V8H21V6M3,18H9V16H3V18Z",
  },
  {
    id: "5952089F-872D-454C-AD1F-18B205938245",
    name: "soundcloud",
    codepoint: "F4C0",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M11.56,8.87V17H20.32V17C22.17,16.87 23,15.73 23,14.33C23,12.85 21.88,11.66 20.38,11.66C20,11.66 19.68,11.74 19.35,11.88C19.11,9.54 17.12,7.71 14.67,7.71C13.5,7.71 12.39,8.15 11.56,8.87M10.68,9.89C10.38,9.71 10.06,9.57 9.71,9.5V17H11.1V9.34C10.95,9.5 10.81,9.7 10.68,9.89M8.33,9.35V17H9.25V9.38C9.06,9.35 8.87,9.34 8.67,9.34C8.55,9.34 8.44,9.34 8.33,9.35M6.5,10V17H7.41V9.54C7.08,9.65 6.77,9.81 6.5,10M4.83,12.5C4.77,12.5 4.71,12.44 4.64,12.41V17H5.56V10.86C5.19,11.34 4.94,11.91 4.83,12.5M2.79,12.22V16.91C3,16.97 3.24,17 3.5,17H3.72V12.14C3.64,12.13 3.56,12.12 3.5,12.12C3.24,12.12 3,12.16 2.79,12.22M1,14.56C1,15.31 1.34,15.97 1.87,16.42V12.71C1.34,13.15 1,13.82 1,14.56Z",
  },
  {
    id: "AADA1B60-0161-4417-9726-75AFB5C7AC31",
    name: "source-branch",
    codepoint: "F62C",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.6.50",
    path: "M13,14C9.64,14 8.54,15.35 8.18,16.24C9.25,16.7 10,17.76 10,19C10,20.66 8.66,22 7,22C5.34,22 4,20.66 4,19C4,17.69 4.83,16.58 6,16.17V7.83C4.83,7.42 4,6.31 4,5C4,3.34 5.34,2 7,2C8.66,2 10,3.34 10,5C10,6.31 9.17,7.42 8,7.83V13.12C8.88,12.47 10.16,12 12,12C14.67,12 15.56,10.66 15.85,9.77C14.77,9.32 14,8.25 14,7C14,5.34 15.34,4 17,4C18.66,4 20,5.34 20,7C20,8.34 19.12,9.5 17.91,9.86C17.65,11.29 16.68,14 13,14M7,18C6.45,18 6,18.45 6,19C6,19.55 6.45,20 7,20C7.55,20 8,19.55 8,19C8,18.45 7.55,18 7,18M7,4C6.45,4 6,4.45 6,5C6,5.55 6.45,6 7,6C7.55,6 8,5.55 8,5C8,4.45 7.55,4 7,4M17,6C16.45,6 16,6.45 16,7C16,7.55 16.45,8 17,8C17.55,8 18,7.55 18,7C18,6.45 17.55,6 17,6Z",
  },
  {
    id: "B0400135-C84A-47D8-AD30-B6BD8292E6A4",
    name: "source-commit",
    codepoint: "F717",
    aliases: [],
    tags: [],
    author: "Case Sandberg",
    version: "1.8.36",
    path: "M17,12C17,14.42 15.28,16.44 13,16.9V21H11V16.9C8.72,16.44 7,14.42 7,12C7,9.58 8.72,7.56 11,7.1V3H13V7.1C15.28,7.56 17,9.58 17,12M12,9C10.34,9 9,10.34 9,12C9,13.66 10.34,15 12,15C13.66,15 15,13.66 15,12C15,10.34 13.66,9 12,9Z",
  },
  {
    id: "5558E497-77AD-48F4-9456-E6D6B4CA991B",
    name: "source-commit-end",
    codepoint: "F718",
    aliases: [],
    tags: [],
    author: "Case Sandberg",
    version: "1.8.36",
    path: "M17,12C17,14.76 14.76,17 12,17C9.24,17 7,14.76 7,12C7,9.58 8.72,7.56 11,7.1V3H13V7.1C15.28,7.56 17,9.58 17,12M12,9C10.34,9 9,10.34 9,12C9,13.66 10.34,15 12,15C13.66,15 15,13.66 15,12C15,10.34 13.66,9 12,9Z",
  },
  {
    id: "5681B6C8-CC7F-42B0-9B6F-B53D9A72D12F",
    name: "source-commit-end-local",
    codepoint: "F719",
    aliases: [],
    tags: [],
    author: "Case Sandberg",
    version: "1.8.36",
    path: "M12,7C14.76,7 17,9.24 17,12C17,14.76 14.76,17 12,17C9.24,17 7,14.76 7,12C7,9.24 9.24,7 12,7M12,9C10.34,9 9,10.34 9,12C9,13.66 10.34,15 12,15C13.66,15 15,13.66 15,12C15,10.34 13.66,9 12,9M11,5V3H13V5H11Z",
  },
  {
    id: "DF889541-FEF0-42C0-BF6E-E29D4503C3FB",
    name: "source-commit-local",
    codepoint: "F71A",
    aliases: [],
    tags: [],
    author: "Case Sandberg",
    version: "1.8.36",
    path: "M12,7C14.76,7 17,9.24 17,12C17,14.76 14.76,17 12,17C9.24,17 7,14.76 7,12C7,9.24 9.24,7 12,7M12,9C10.34,9 9,10.34 9,12C9,13.66 10.34,15 12,15C13.66,15 15,13.66 15,12C15,10.34 13.66,9 12,9M11,5V3H13V5H11M11,21V19H13V21H11Z",
  },
  {
    id: "42A5B80B-C7A6-42F4-8437-458F504B7AF5",
    name: "source-commit-next-local",
    codepoint: "F71B",
    aliases: [],
    tags: [],
    author: "Case Sandberg",
    version: "1.8.36",
    path: "M17,12C17,14.76 14.76,17 12,17C9.24,17 7,14.76 7,12C7,9.58 8.72,7.56 11,7.1V3H13V7.1C15.28,7.56 17,9.58 17,12M12,9C10.34,9 9,10.34 9,12C9,13.66 10.34,15 12,15C13.66,15 15,13.66 15,12C15,10.34 13.66,9 12,9M11,21V19H13V21H11Z",
  },
  {
    id: "6647D5DC-4BF4-47FB-9B11-F1ABB94B3769",
    name: "source-commit-start",
    codepoint: "F71C",
    aliases: [],
    tags: [],
    author: "Case Sandberg",
    version: "1.8.36",
    path: "M12,7C14.76,7 17,9.24 17,12C17,14.42 15.28,16.44 13,16.9V21H11V16.9C8.72,16.44 7,14.42 7,12C7,9.24 9.24,7 12,7M12,9C10.34,9 9,10.34 9,12C9,13.66 10.34,15 12,15C13.66,15 15,13.66 15,12C15,10.34 13.66,9 12,9Z",
  },
  {
    id: "64F8200C-7866-46A6-9E8B-1CAF621517CC",
    name: "source-commit-start-next-local",
    codepoint: "F71D",
    aliases: [],
    tags: [],
    author: "Case Sandberg",
    version: "1.8.36",
    path: "M12,7C14.76,7 17,9.24 17,12C17,14.76 14.76,17 12,17C9.24,17 7,14.76 7,12C7,9.24 9.24,7 12,7M12,9C10.34,9 9,10.34 9,12C9,13.66 10.34,15 12,15C13.66,15 15,13.66 15,12C15,10.34 13.66,9 12,9M11,21V19H13V21H11Z",
  },
  {
    id: "F2A480EB-B06A-4472-88B9-C881754675FE",
    name: "source-fork",
    codepoint: "F4C1",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M6,2C7.66,2 9,3.34 9,5C9,6.28 8.19,7.38 7.06,7.81C7.15,8.27 7.39,8.83 8,9.63C9,10.92 11,12.83 12,14.17C13,12.83 15,10.92 16,9.63C16.61,8.83 16.85,8.27 16.94,7.81C15.81,7.38 15,6.28 15,5C15,3.34 16.34,2 18,2C19.66,2 21,3.34 21,5C21,6.32 20.14,7.45 18.95,7.85C18.87,8.37 18.64,9 18,9.83C17,11.17 15,13.08 14,14.38C13.39,15.17 13.15,15.73 13.06,16.19C14.19,16.62 15,17.72 15,19C15,20.66 13.66,22 12,22C10.34,22 9,20.66 9,19C9,17.72 9.81,16.62 10.94,16.19C10.85,15.73 10.61,15.17 10,14.38C9,13.08 7,11.17 6,9.83C5.36,9 5.13,8.37 5.05,7.85C3.86,7.45 3,6.32 3,5C3,3.34 4.34,2 6,2M6,4C5.45,4 5,4.45 5,5C5,5.55 5.45,6 6,6C6.55,6 7,5.55 7,5C7,4.45 6.55,4 6,4M18,4C17.45,4 17,4.45 17,5C17,5.55 17.45,6 18,6C18.55,6 19,5.55 19,5C19,4.45 18.55,4 18,4M12,18C11.45,18 11,18.45 11,19C11,19.55 11.45,20 12,20C12.55,20 13,19.55 13,19C13,18.45 12.55,18 12,18Z",
  },
  {
    id: "C4A094D6-A68C-41F8-A2EC-C87997DACE70",
    name: "source-merge",
    codepoint: "F62D",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.6.50",
    path: "M7,3C8.66,3 10,4.34 10,6C10,7.29 9.19,8.39 8.04,8.81C8.58,13.81 13.08,14.77 15.19,14.96C15.61,13.81 16.71,13 18,13C19.66,13 21,14.34 21,16C21,17.66 19.66,19 18,19C16.69,19 15.57,18.16 15.16,17C10.91,16.8 9.44,15.19 8,13.39V15.17C9.17,15.58 10,16.69 10,18C10,19.66 8.66,21 7,21C5.34,21 4,19.66 4,18C4,16.69 4.83,15.58 6,15.17V8.83C4.83,8.42 4,7.31 4,6C4,4.34 5.34,3 7,3M7,5C6.45,5 6,5.45 6,6C6,6.55 6.45,7 7,7C7.55,7 8,6.55 8,6C8,5.45 7.55,5 7,5M7,17C6.45,17 6,17.45 6,18C6,18.55 6.45,19 7,19C7.55,19 8,18.55 8,18C8,17.45 7.55,17 7,17M18,15C17.45,15 17,15.45 17,16C17,16.55 17.45,17 18,17C18.55,17 19,16.55 19,16C19,15.45 18.55,15 18,15Z",
  },
  {
    id: "6555FD23-E5EE-4F40-91CF-B72476ADED54",
    name: "source-pull",
    codepoint: "F4C2",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M6,3C7.66,3 9,4.34 9,6C9,7.31 8.17,8.42 7,8.83V15.17C8.17,15.58 9,16.69 9,18C9,19.66 7.66,21 6,21C4.34,21 3,19.66 3,18C3,16.69 3.83,15.58 5,15.17V8.83C3.83,8.42 3,7.31 3,6C3,4.34 4.34,3 6,3M6,5C5.45,5 5,5.45 5,6C5,6.55 5.45,7 6,7C6.55,7 7,6.55 7,6C7,5.45 6.55,5 6,5M6,17C5.45,17 5,17.45 5,18C5,18.55 5.45,19 6,19C6.55,19 7,18.55 7,18C7,17.45 6.55,17 6,17M21,18C21,19.66 19.66,21 18,21C16.34,21 15,19.66 15,18C15,16.69 15.83,15.58 17,15.17V7H15V10.25L10.75,6L15,1.75V5H17C18.1,5 19,5.9 19,7V15.17C20.17,15.58 21,16.69 21,18M18,17C17.45,17 17,17.45 17,18C17,18.55 17.45,19 18,19C18.55,19 19,18.55 19,18C19,17.45 18.55,17 18,17Z",
  },
  {
    id: "62A5E551-73E0-4C84-89E4-C0F34BDACEFA",
    name: "soy-sauce",
    codepoint: "F7ED",
    aliases: ["soya-sauce"],
    tags: ["Food / Drink"],
    author: "Colton Wiscombe",
    version: "2.0.46",
    path: "M13.9,7.5C13.9,6.8 14.1,6.3 14.2,6H14.8L15.7,3.5H16.5V2H7.5V3.5H8.3L9.2,6H9.8C10,6.3 10.1,6.8 10.1,7.5C10.1,8.8 6,13.7 6,17.6V19.6C6,21 8.7,21.9 12,21.9C15.3,21.9 18,21 18,19.6V17.6C18,13.7 13.9,8.8 13.9,7.5M12,15C10.9,15 10,14.1 10,13C10,11.9 10.9,11 12,11C13.1,11 14,11.9 14,13C14,14.1 13.1,15 12,15Z",
  },
  {
    id: "43C37FC5-E271-40FA-BB50-C139DDD5B15B",
    name: "speaker",
    codepoint: "F4C3",
    aliases: [],
    tags: ["Audio", "Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M12,12C10.34,12 9,13.34 9,15C9,16.66 10.34,18 12,18C13.66,18 15,16.66 15,15C15,13.34 13.66,12 12,12M12,20C9.24,20 7,17.76 7,15C7,12.24 9.24,10 12,10C14.76,10 17,12.24 17,15C17,17.76 14.76,20 12,20M12,4C13.1,4 14,4.9 14,6C14,7.1 13.1,8 12,8C10.89,8 10,7.1 10,6C10,4.89 10.89,4 12,4M17,2H7C5.89,2 5,2.89 5,4V20C5,21.1 5.9,22 7,22H17C18.1,22 19,21.1 19,20V4C19,2.89 18.1,2 17,2Z",
  },
  {
    id: "E9F560A8-FFD9-44CD-8736-00C627756591",
    name: "speaker-bluetooth",
    codepoint: "F9A1",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "2.4.85",
    path: "M4,3C2.9,3 2,3.9 2,5V19C2,20.1 2.9,21 4,21H12C13.1,21 14,20.1 14,19V5C14,3.9 13.1,3 12,3H4M8,5C9.1,5 10,5.9 10,7C10,8.1 9.1,9 8,9C6.9,9 6,8.1 6,7C6,5.9 6.9,5 8,5M19,7V10.79L16.71,8.5L16,9.21L18.79,12L16,14.79L16.71,15.5L19,13.21V17H19.5L22.35,14.14L20.21,12L22.35,9.85L19.5,7H19M20,8.91L20.94,9.85L20,10.79V8.91M8,11C10.21,11 12,12.79 12,15C12,17.21 10.21,19 8,19C5.79,19 4,17.21 4,15C4,12.79 5.79,11 8,11M8,13C6.9,13 6,13.9 6,15C6,16.1 6.9,17 8,17C9.1,17 10,16.1 10,15C10,13.9 9.1,13 8,13M20,13.21L20.94,14.14L20,15.08V13.21Z",
  },
  {
    id: "9B55ECCE-270B-4A52-9A96-80BEECAD1E0B",
    name: "speaker-off",
    codepoint: "F4C4",
    aliases: [],
    tags: ["Audio", "Home Automation"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M2,5.27L3.28,4L21,21.72L19.73,23L18.27,21.54C17.93,21.83 17.5,22 17,22H7C5.89,22 5,21.1 5,20V8.27L2,5.27M12,18C10.34,18 9,16.66 9,15C9,14.24 9.28,13.54 9.75,13L8.33,11.6C7.5,12.5 7,13.69 7,15C7,17.76 9.24,20 12,20C13.31,20 14.5,19.5 15.4,18.67L14,17.25C13.45,17.72 12.76,18 12,18M17,15C17,12.24 14.76,10 12,10H11.82L5.12,3.3C5.41,2.54 6.14,2 7,2H17C18.1,2 19,2.9 19,4V17.18L17,15.17V15M12,4C10.89,4 10,4.89 10,6C10,7.1 10.9,8 12,8C13.1,8 14,7.1 14,6C14,4.89 13.1,4 12,4Z",
  },
  {
    id: "F9EA980F-2C75-48DE-9D56-9A15CFE52865",
    name: "speaker-wireless",
    codepoint: "F71E",
    aliases: [],
    tags: ["Audio", "Home Automation"],
    author: "Cody",
    version: "1.8.36",
    path: "M20.07,19.07L18.66,17.66C20.11,16.22 21,14.21 21,12C21,9.78 20.11,7.78 18.66,6.34L20.07,4.93C21.88,6.74 23,9.24 23,12C23,14.76 21.88,17.26 20.07,19.07M17.24,16.24L15.83,14.83C16.55,14.11 17,13.11 17,12C17,10.89 16.55,9.89 15.83,9.17L17.24,7.76C18.33,8.85 19,10.35 19,12C19,13.65 18.33,15.15 17.24,16.24M4,3H12C13.1,3 14,3.9 14,5V19C14,20.1 13.1,21 12,21H4C2.9,21 2,20.1 2,19V5C2,3.9 2.9,3 4,3M8,5C6.9,5 6,5.9 6,7C6,8.1 6.9,9 8,9C9.1,9 10,8.1 10,7C10,5.9 9.1,5 8,5M8,11C5.79,11 4,12.79 4,15C4,17.21 5.79,19 8,19C10.21,19 12,17.21 12,15C12,12.79 10.21,11 8,11M8,13C9.1,13 10,13.9 10,15C10,16.1 9.1,17 8,17C6.9,17 6,16.1 6,15C6,13.9 6.9,13 8,13Z",
  },
  {
    id: "F0EE6F6A-2B43-4880-8DC9-6E7515B3BEDE",
    name: "speedometer",
    codepoint: "F4C5",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,16C10.34,16 9,14.66 9,13C9,11.88 9.61,10.9 10.5,10.39L20.21,4.77L14.68,14.35C14.18,15.33 13.17,16 12,16M12,3C13.81,3 15.5,3.5 16.97,4.32L14.87,5.53C14,5.19 13,5 12,5C7.58,5 4,8.58 4,13C4,15.21 4.89,17.21 6.34,18.65H6.35C6.74,19.04 6.74,19.67 6.35,20.06C5.96,20.45 5.32,20.45 4.93,20.07V20.07C3.12,18.26 2,15.76 2,13C2,7.48 6.48,3 12,3M22,13C22,15.76 20.88,18.26 19.07,20.07V20.07C18.68,20.45 18.05,20.45 17.66,20.06C17.27,19.67 17.27,19.04 17.66,18.65V18.65C19.11,17.2 20,15.21 20,13C20,12 19.81,11 19.46,10.1L20.67,8C21.5,9.5 22,11.18 22,13Z",
  },
  {
    id: "72253002-9545-40A4-95A4-49401269B553",
    name: "spellcheck",
    codepoint: "F4C6",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M21.59,11.59L13.5,19.68L9.83,16L8.42,17.41L13.5,22.5L23,13M6.43,11L8.5,5.5L10.57,11M12.45,16H14.54L9.43,3H7.57L2.46,16H4.55L5.67,13H11.31L12.45,16Z",
  },
  {
    id: "51C1DE39-1C25-49B7-A295-DD13B874C48B",
    name: "spotify",
    codepoint: "F4C7",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M17.9,10.9C14.7,9 9.35,8.8 6.3,9.75C5.8,9.9 5.3,9.6 5.15,9.15C5,8.65 5.3,8.15 5.75,8C9.3,6.95 15.15,7.15 18.85,9.35C19.3,9.6 19.45,10.2 19.2,10.65C18.95,11 18.35,11.15 17.9,10.9M17.8,13.7C17.55,14.05 17.1,14.2 16.75,13.95C14.05,12.3 9.95,11.8 6.8,12.8C6.4,12.9 5.95,12.7 5.85,12.3C5.75,11.9 5.95,11.45 6.35,11.35C10,10.25 14.5,10.8 17.6,12.7C17.9,12.85 18.05,13.35 17.8,13.7M16.6,16.45C16.4,16.75 16.05,16.85 15.75,16.65C13.4,15.2 10.45,14.9 6.95,15.7C6.6,15.8 6.3,15.55 6.2,15.25C6.1,14.9 6.35,14.6 6.65,14.5C10.45,13.65 13.75,14 16.35,15.6C16.7,15.75 16.75,16.15 16.6,16.45M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z",
  },
  {
    id: "A4956491-730F-4BC9-A6C1-03AF3C54C134",
    name: "spotlight",
    codepoint: "F4C8",
    aliases: [],
    tags: ["Home Automation"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M2,6L7.09,8.55C6.4,9.5 6,10.71 6,12C6,13.29 6.4,14.5 7.09,15.45L2,18V6M6,3H18L15.45,7.09C14.5,6.4 13.29,6 12,6C10.71,6 9.5,6.4 8.55,7.09L6,3M22,6V18L16.91,15.45C17.6,14.5 18,13.29 18,12C18,10.71 17.6,9.5 16.91,8.55L22,6M18,21H6L8.55,16.91C9.5,17.6 10.71,18 12,18C13.29,18 14.5,17.6 15.45,16.91L18,21M12,8C14.21,8 16,9.79 16,12C16,14.21 14.21,16 12,16C9.79,16 8,14.21 8,12C8,9.79 9.79,8 12,8M12,10C10.9,10 10,10.9 10,12C10,13.1 10.9,14 12,14C13.1,14 14,13.1 14,12C14,10.9 13.1,10 12,10Z",
  },
  {
    id: "13AE04D2-BB67-4CA4-89F6-11C88C2A217E",
    name: "spotlight-beam",
    codepoint: "F4C9",
    aliases: [],
    tags: ["Home Automation"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M9,16.5L9.91,15.59L15.13,20.8L14.21,21.71L9,16.5M15.5,10L16.41,9.09L21.63,14.3L20.71,15.21L15.5,10M6.72,2.72L10.15,6.15L6.15,10.15L2.72,6.72C1.94,5.94 1.94,4.67 2.72,3.89L3.89,2.72C4.67,1.94 5.94,1.94 6.72,2.72M14.57,7.5L15.28,8.21L8.21,15.28L7.5,14.57L6.64,11.07L11.07,6.64L14.57,7.5Z",
  },
  {
    id: "0CDAFE95-E28B-4A8D-9634-C6BBB99EE598",
    name: "spray",
    codepoint: "F665",
    aliases: ["paint", "aerosol"],
    tags: [],
    author: "Austin Andrews",
    version: "1.6.50",
    path: "M10,4H12V6H10V4M7,3H9V5H7V3M7,6H9V8H7V6M6,8V10H4V8H6M6,5V7H4V5H6M6,2V4H4V2H6M13,22C11.9,22 11,21.1 11,20V10C11,8.9 11.9,8 13,8V7H14V4H17V7H18V8C19.1,8 20,8.9 20,10V20C20,21.1 19.1,22 18,22H13M13,10V20H18V10H13Z",
  },
  {
    id: "5659F8EC-377D-41D2-AB3A-52DC40815DC7",
    name: "square",
    codepoint: "F763",
    aliases: [],
    tags: ["Shape"],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M3,3V21H21V3",
  },
  {
    id: "22469E65-F1CB-408D-B6B5-1E599A85E368",
    name: "square-edit-outline",
    codepoint: "F90B",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "2.3.50",
    path: "M5,3C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V12H19V19H5V5H12V3H5M17.78,4C17.61,4 17.43,4.07 17.3,4.2L16.08,5.41L18.58,7.91L19.8,6.7C20.06,6.44 20.06,6 19.8,5.75L18.25,4.2C18.12,4.07 17.95,4 17.78,4M15.37,6.12L8,13.5V16H10.5L17.87,8.62L15.37,6.12Z",
  },
  {
    id: "0267FB77-EB23-41D4-92B4-FF65796BDF40",
    name: "square-medium",
    codepoint: "FA12",
    aliases: [],
    tags: [],
    author: "Michael Irigoyen",
    version: "2.5.94",
    path: "M16,8H8V16H16V8Z",
  },
  {
    id: "1EC70A02-36D5-4C3B-A721-018653864C6D",
    name: "square-medium-outline",
    codepoint: "FA13",
    aliases: [],
    tags: [],
    author: "Michael Irigoyen",
    version: "2.5.94",
    path: "M14,10V14H10V10H14M16,8H8V16H16V8Z",
  },
  {
    id: "5ED659B5-F175-445F-950D-0B4DDAB3F8B3",
    name: "square-outline",
    codepoint: "F762",
    aliases: [],
    tags: ["Shape"],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M3,3H21V21H3V3M5,5V19H19V5H5Z",
  },
  {
    id: "D0835CDD-0255-4A0D-B86F-DAB300C5ADCC",
    name: "square-root",
    codepoint: "F783",
    aliases: [],
    tags: ["Math"],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M11.76,16.83L14.59,14L11.76,11.17L13.17,9.76L16,12.59L18.83,9.76L20.24,11.17L17.41,14L20.24,16.83L18.83,18.24L16,15.41L13.17,18.24L11.76,16.83M2,11H5V11H5L7.29,16.4L10,6H22V8H11.55L8.68,19H6.22L3.68,13H2V11Z",
  },
  {
    id: "4DD48496-5BE6-4866-A298-1D9D399651B0",
    name: "square-root-box",
    codepoint: "F9A2",
    aliases: [],
    tags: [],
    author: "Nick",
    version: "2.4.85",
    path: "M5,3C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3H5M11.24,6H19V8H12.76L10,18H8L6.25,12H5V10H7.75L9,14.28L11.24,6V6M14,10.59L15.79,12.38L17.59,10.59L19,12L17.21,13.79L19,15.59L17.59,17L15.79,15.21L14,17L12.59,15.59L14.38,13.79L12.59,12L14,10.59Z",
  },
  {
    id: "E4490267-ACAE-4E86-8747-8D2D620DC707",
    name: "square-small",
    codepoint: "FA14",
    aliases: [],
    tags: [],
    author: "Michael Irigoyen",
    version: "2.5.94",
    path: "M10,14V10H14V14H10Z",
  },
  {
    id: "EC87D6AA-77FC-462A-82AC-715550CD98AB",
    name: "ssh",
    codepoint: "F8BF",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "2.2.43",
    path: "M4.5,9C3.9,9 3.5,9.5 3.5,10V11.75C3.5,12.25 3.9,12.75 4.5,12.75H7V13.5H3.5V15H7.5C8.1,15 8.5,14.5 8.5,14V12.25C8.5,11.75 8.1,11.25 7.5,11.25H5V10.5H8.5V9H4.5M10.5,9C9.9,9 9.5,9.5 9.5,10V11.75C9.5,12.25 9.9,12.75 10.5,12.75H13V13.5H9.5V15H13.5C14.1,15 14.5,14.5 14.5,14V12.25C14.5,11.75 14.1,11.25 13.5,11.25H11V10.5H14.5V9H10.5M15.5,9V15H17V12.5H19V15H20.5V9H19V11H17V9H15.5Z",
  },
  {
    id: "D76A8752-ED97-4E90-95EC-B1D6E81ABA9E",
    name: "stack-exchange",
    codepoint: "F60B",
    aliases: ["stackexchange"],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M4,14.04V11H20V14.04H4M4,10V7H20V10H4M17.46,2C18.86,2 20,3.18 20,4.63V6H4V4.63C4,3.18 5.14,2 6.54,2H17.46M4,15H20V16.35C20,17.81 18.86,19 17.46,19H16.5L13,22V19H6.54C5.14,19 4,17.81 4,16.35V15Z",
  },
  {
    id: "72E7037B-1C3B-44BB-A9EC-FC2D6B3EA745",
    name: "stack-overflow",
    codepoint: "F4CC",
    aliases: ["stackoverflow"],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M17.36,20.2V14.82H19.15V22H3V14.82H4.8V20.2H17.36M6.77,14.32L7.14,12.56L15.93,14.41L15.56,16.17L6.77,14.32M7.93,10.11L8.69,8.5L16.83,12.28L16.07,13.9L7.93,10.11M10.19,6.12L11.34,4.74L18.24,10.5L17.09,11.87L10.19,6.12M14.64,1.87L20,9.08L18.56,10.15L13.2,2.94L14.64,1.87M6.59,18.41V16.61H15.57V18.41H6.59Z",
  },
  {
    id: "0407BE27-099D-4170-BA1C-A87A4239F9DA",
    name: "stadium",
    codepoint: "F71F",
    aliases: ["arena"],
    tags: ["Places", "Sport"],
    author: "Alex Efremo",
    version: "1.8.36",
    path: "M5,3H7L10,5L7,7V8.33C8.47,8.12 10.18,8 12,8C13.82,8 15.53,8.12 17,8.33V3H19L22,5L19,7V8.71C20.85,9.17 22,9.8 22,10.5C22,11.88 17.5,13 12,13C6.5,13 2,11.88 2,10.5C2,9.8 3.15,9.17 5,8.71V3M12,9.5C8.69,9.5 7,9.67 7,10.5C7,11.33 8.69,11.5 12,11.5C15.31,11.5 17,11.33 17,10.5C17,9.67 15.31,9.5 12,9.5M12,14.75C15.81,14.75 19.2,14.08 21.4,13.05L20,21H15V19C15,17.9 14.1,17 13,17H11C9.9,17 9,17.9 9,19V21H4L2.6,13.05C4.8,14.08 8.19,14.75 12,14.75Z",
  },
  {
    id: "D5BBEF8B-FC7A-4FA5-9DA6-4D970AC6A530",
    name: "stairs",
    codepoint: "F4CD",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M15,5V9H11V13H7V17H3V20H10V16H14V12H18V8H22V5H15Z",
  },
  {
    id: "DAA79A7B-03FB-431A-85DD-AB9749783DC0",
    name: "standard-definition",
    codepoint: "F7EE",
    aliases: [],
    tags: ["Video / Movie"],
    author: "Austin Andrews",
    version: "2.0.46",
    path: "M13,7H16C17.66,7 19,8.34 19,10V14C19,15.66 17.66,17 16,17H13V7M16,15C16.55,15 17,14.55 17,14V10C17,9.45 16.55,9 16,9H15V15H16M7,7H11V9H7V11H9C10.1,11 11,11.9 11,13V15C11,16.1 10.1,17 9,17H5V15H9V13H7C5.9,13 5,12.1 5,11V9C5,7.9 5.9,7 7,7Z",
  },
  {
    id: "53D81A11-D8FF-46F4-A0CB-B7F668BA720D",
    name: "star",
    codepoint: "F4CE",
    aliases: ["grade", "star-rate"],
    tags: ["Shape"],
    author: "Google",
    version: "1.5.54",
    path: "M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z",
  },
  {
    id: "76D19C8B-0302-436A-A19F-5AC5EE8AC88C",
    name: "star-circle",
    codepoint: "F4CF",
    aliases: ["stars"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M16.23,18L12,15.45L7.77,18L8.89,13.19L5.16,9.96L10.08,9.54L12,5L13.92,9.53L18.84,9.95L15.11,13.18L16.23,18M12,2C6.47,2 2,6.5 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z",
  },
  {
    id: "9E034CD9-F400-4D4A-A2CB-6030313F2CED",
    name: "star-circle-outline",
    codepoint: "F9A3",
    aliases: ["feature-highlight"],
    tags: [],
    author: "Google",
    version: "2.4.85",
    path: "M8.58,17.25L9.5,13.36L6.5,10.78L10.45,10.41L12,6.8L13.55,10.45L17.5,10.78L14.5,13.36L15.42,17.25L12,15.19L8.58,17.25M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M12,4C7.58,4 4,7.58 4,12C4,16.42 7.58,20 12,20C16.42,20 20,16.42 20,12C20,7.58 16.42,4 12,4Z",
  },
  {
    id: "20FBE06D-72C3-4E1C-945D-C7E69DC0736D",
    name: "star-face",
    codepoint: "F9A4",
    aliases: [],
    tags: [],
    author: "Google",
    version: "2.4.85",
    path: "M12,2.5L8.42,8.06L2,9.74L6.2,14.88L5.82,21.5L12,19.09L18.18,21.5L17.8,14.88L22,9.74L15.58,8.06L12,2.5M9.38,10.5C10,10.5 10.5,11 10.5,11.63C10.5,12.25 10,12.75 9.38,12.75C8.75,12.75 8.25,12.25 8.25,11.63C8.25,11 8.75,10.5 9.38,10.5M14.63,10.5C15.25,10.5 15.75,11 15.75,11.63C15.75,12.25 15.25,12.75 14.63,12.75C14,12.75 13.5,12.25 13.5,11.63C13.5,11 14,10.5 14.63,10.5M9,15H15C14.5,16.21 13.31,17 12,17C10.69,17 9.5,16.21 9,15Z",
  },
  {
    id: "52E97617-C7F4-45D0-98E0-E9B4407EC179",
    name: "star-half",
    codepoint: "F4D0",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M12,15.4V6.1L13.71,10.13L18.09,10.5L14.77,13.39L15.76,17.67M22,9.24L14.81,8.63L12,2L9.19,8.63L2,9.24L7.45,13.97L5.82,21L12,17.27L18.18,21L16.54,13.97L22,9.24Z",
  },
  {
    id: "3CE96C58-D12F-474D-916F-D0509E3BA408",
    name: "star-off",
    codepoint: "F4D1",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M2,5.27L3.28,4L20,20.72L18.73,22L17.05,20.31L12,17.27L5.82,21L7.45,13.97L2,9.24L5.66,8.93L2,5.27M12,2L14.81,8.62L22,9.24L16.54,13.97L16.77,14.95L9.56,7.74L12,2Z",
  },
  {
    id: "D443AD2F-291D-496E-ACD2-109891446FF2",
    name: "star-outline",
    codepoint: "F4D2",
    aliases: ["star-border"],
    tags: ["Shape"],
    author: "Google",
    version: "1.5.54",
    path: "M12,15.39L8.24,17.66L9.23,13.38L5.91,10.5L10.29,10.13L12,6.09L13.71,10.13L18.09,10.5L14.77,13.38L15.76,17.66M22,9.24L14.81,8.63L12,2L9.19,8.63L2,9.24L7.45,13.97L5.82,21L12,17.27L18.18,21L16.54,13.97L22,9.24Z",
  },
  {
    id: "FBD721A3-7CD8-4769-902C-2B434CA107EE",
    name: "steam",
    codepoint: "F4D3",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C7.4,22 3.55,18.92 2.36,14.73L6.19,16.31C6.45,17.6 7.6,18.58 8.97,18.58C10.53,18.58 11.8,17.31 11.8,15.75V15.62L15.2,13.19H15.28C17.36,13.19 19.05,11.5 19.05,9.42C19.05,7.34 17.36,5.65 15.28,5.65C13.2,5.65 11.5,7.34 11.5,9.42V9.47L9.13,12.93L8.97,12.92C8.38,12.92 7.83,13.1 7.38,13.41L2,11.2C2.43,6.05 6.73,2 12,2M8.28,17.17C9.08,17.5 10,17.13 10.33,16.33C10.66,15.53 10.28,14.62 9.5,14.29L8.22,13.76C8.71,13.58 9.26,13.57 9.78,13.79C10.31,14 10.72,14.41 10.93,14.94C11.15,15.46 11.15,16.04 10.93,16.56C10.5,17.64 9.23,18.16 8.15,17.71C7.65,17.5 7.27,17.12 7.06,16.67L8.28,17.17M17.8,9.42C17.8,10.81 16.67,11.94 15.28,11.94C13.9,11.94 12.77,10.81 12.77,9.42C12.77,8.04 13.9,6.91 15.28,6.91C16.67,6.91 17.8,8.04 17.8,9.42M13.4,9.42C13.4,10.46 14.24,11.31 15.29,11.31C16.33,11.31 17.17,10.46 17.17,9.42C17.17,8.38 16.33,7.53 15.29,7.53C14.24,7.53 13.4,8.38 13.4,9.42Z",
  },
  {
    id: "A2FE9DC5-BC17-4265-9D2C-4CA20135C4BB",
    name: "steering",
    codepoint: "F4D4",
    aliases: ["search-hands-free"],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M13,19.92C14.8,19.7 16.35,18.95 17.65,17.65C18.95,16.35 19.7,14.8 19.92,13H16.92C16.7,14 16.24,14.84 15.54,15.54C14.84,16.24 14,16.7 13,16.92V19.92M10,8H14L17,11H19.92C19.67,9.05 18.79,7.38 17.27,6C15.76,4.66 14,4 12,4C10,4 8.24,4.66 6.73,6C5.21,7.38 4.33,9.05 4.08,11H7L10,8M11,19.92V16.92C10,16.7 9.16,16.24 8.46,15.54C7.76,14.84 7.3,14 7.08,13H4.08C4.3,14.77 5.05,16.3 6.35,17.6C7.65,18.9 9.2,19.67 11,19.92M12,2C14.75,2 17.1,3 19.05,4.95C21,6.9 22,9.25 22,12C22,14.75 21,17.1 19.05,19.05C17.1,21 14.75,22 12,22C9.25,22 6.9,21 4.95,19.05C3,17.1 2,14.75 2,12C2,9.25 3,6.9 4.95,4.95C6.9,3 9.25,2 12,2Z",
  },
  {
    id: "1489D950-AD3A-47BD-A0CD-2E0A33943F54",
    name: "steering-off",
    codepoint: "F90D",
    aliases: ["search-hands-free-off"],
    tags: [],
    author: "Contributors",
    version: "2.3.50",
    path: "M2,5.27L3.28,4L20,20.72L18.73,22L17.25,20.5C15.7,21.5 13.95,22 12,22C9.25,22 6.9,21 4.95,19.05C3,17.1 2,14.75 2,12C2,10.05 2.5,8.3 3.5,6.75L2,5.27M13,19.92C14,19.8 14.93,19.5 15.78,19.05L13.5,16.78C13.34,16.84 13.16,16.88 13,16.92V19.92M4.08,11H7L7.37,10.63L4.96,8.23C4.5,9.08 4.21,10 4.08,11M19.92,13H16.92C16.8,13.54 16.6,14.05 16.33,14.5L9.91,8.09L10,8H14L17,11H19.92C19.67,9.05 18.79,7.38 17.27,6C15.76,4.66 14,4 12,4C10.26,4 8.71,4.5 7.34,5.5L5.91,4.09C7.66,2.71 9.69,2 12,2C14.75,2 17.1,3 19.05,4.95C21,6.9 22,9.25 22,12C22,14.31 21.29,16.34 19.91,18.09L18.5,16.67C19.28,15.59 19.76,14.36 19.92,13M11,19.92V16.92C10,16.7 9.16,16.24 8.46,15.54C7.76,14.84 7.3,14 7.08,13H4.08C4.3,14.77 5.05,16.3 6.35,17.6C7.65,18.9 9.2,19.67 11,19.92Z",
  },
  {
    id: "3056B0E6-E30C-4F6D-8647-AC5559FD7DCF",
    name: "step-backward",
    codepoint: "F4D5",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M19,5V19H16V5M14,5V19L3,12",
  },
  {
    id: "9815CAC2-7390-4AE1-AE72-2B49546987EC",
    name: "step-backward-2",
    codepoint: "F4D6",
    aliases: ["frame-backward"],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M17,5H14V19H17V5M12,5L1,12L12,19V5M22,5H19V19H22V5Z",
  },
  {
    id: "6773EDAB-CBAA-4C56-80D6-E029EB45115E",
    name: "step-forward",
    codepoint: "F4D7",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M5,5V19H8V5M10,5V19L21,12",
  },
  {
    id: "890D584F-45C1-4D2C-96C0-373465DB6477",
    name: "step-forward-2",
    codepoint: "F4D8",
    aliases: ["frame-forward"],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M7,5H10V19H7V5M12,5L23,12L12,19V5M2,5H5V19H2V5Z",
  },
  {
    id: "641202BA-294A-4A0F-851D-FB83FEC9D7EE",
    name: "stethoscope",
    codepoint: "F4D9",
    aliases: [],
    tags: ["Medical / Hospital"],
    author: "Cody",
    version: "1.5.54",
    path: "M19,8C19.56,8 20,8.43 20,9C20,9.55 19.55,10 19,10C18.43,10 18,9.55 18,9C18,8.43 18.43,8 19,8M2,2V11C2,13.96 4.19,16.5 7.14,16.91C7.76,19.92 10.42,22 13.5,22C17.09,22 20,19.09 20,15.5V11.81C21.16,11.39 22,10.29 22,9C22,7.34 20.66,6 19,6C17.34,6 16,7.34 16,9C16,10.29 16.84,11.4 18,11.81V15.41C18,17.91 16,19.91 13.5,19.91C11.5,19.91 9.82,18.7 9.22,16.9C12,16.3 14,13.8 14,11V2H10V5H12V11C12,13.21 10.21,15 8,15C5.79,15 4,13.21 4,11V5H6V2H2Z",
  },
  {
    id: "F4C92E8A-A238-4F7C-B2FC-CBA914C5CE04",
    name: "sticker",
    codepoint: "F5D0",
    aliases: [],
    tags: [],
    author: "Christopher Schreiner",
    version: "1.5.54",
    path: "M12.12,18.46L18.3,12.28C16.94,12.59 15.31,13.2 14.07,14.46C13.04,15.5 12.39,16.83 12.12,18.46M20.75,10H21.05C21.44,10 21.79,10.27 21.93,10.64C22.07,11 22,11.43 21.7,11.71L11.7,21.71C11.5,21.9 11.26,22 11,22L10.64,21.93C10.27,21.79 10,21.44 10,21.05C9.84,17.66 10.73,14.96 12.66,13.03C15.5,10.2 19.62,10 20.75,10M12,2C16.5,2 20.34,5 21.58,9.11L20,9H19.42C18.24,6.07 15.36,4 12,4C7.58,4 4,7.58 4,12C4,15.36 6.07,18.24 9,19.42C8.97,20.13 9,20.85 9.11,21.57C5,20.33 2,16.5 2,12C2,6.47 6.5,2 12,2Z",
  },
  {
    id: "9E28CC83-5155-4620-80C1-62875D117A79",
    name: "sticker-emoji",
    codepoint: "F784",
    aliases: [],
    tags: ["Emoji"],
    author: "Google",
    version: "1.9.32",
    path: "M5.5,2C3.56,2 2,3.56 2,5.5V18.5C2,20.44 3.56,22 5.5,22H16L22,16V5.5C22,3.56 20.44,2 18.5,2H5.5M5.75,4H18.25C19.22,4 20,4.78 20,5.75V15H18.5C16.56,15 15,16.56 15,18.5V20H5.75C4.78,20 4,19.22 4,18.25V5.75C4,4.78 4.78,4 5.75,4M14.44,6.77C14.28,6.77 14.12,6.79 13.97,6.83C13.03,7.09 12.5,8.05 12.74,9C12.79,9.15 12.86,9.3 12.95,9.44L16.18,8.56C16.18,8.39 16.16,8.22 16.12,8.05C15.91,7.3 15.22,6.77 14.44,6.77M8.17,8.5C8,8.5 7.85,8.5 7.7,8.55C6.77,8.81 6.22,9.77 6.47,10.7C6.5,10.86 6.59,11 6.68,11.16L9.91,10.28C9.91,10.11 9.89,9.94 9.85,9.78C9.64,9 8.95,8.5 8.17,8.5M16.72,11.26L7.59,13.77C8.91,15.3 11,15.94 12.95,15.41C14.9,14.87 16.36,13.25 16.72,11.26Z",
  },
  {
    id: "3C90040A-0B3F-4849-B21D-E16240D7A699",
    name: "stocking",
    codepoint: "F4DA",
    aliases: [],
    tags: ["Holiday"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M17,2C18.1,2 19,2.9 19,4V7C19,8.1 18.1,9 17,9V17C17,17.85 16.5,18.57 15.74,18.86L9.5,21.77C8.5,22.24 7.29,21.81 6.83,20.81L6,19C5.5,18 5.95,16.8 6.95,16.34L10,14.91V9C8.9,9 8,8.1 8,7V4C8,2.9 8.9,2 10,2H17M10,4V7H17V4H10Z",
  },
  {
    id: "F1057179-EA45-4D87-A14D-D05442C06503",
    name: "stop",
    codepoint: "F4DB",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M18,18H6V6H18V18Z",
  },
  {
    id: "EC57EC60-1C8E-45CE-BF4A-D019AFD1F148",
    name: "stop-circle",
    codepoint: "F666",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.6.50",
    path: "M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M9,9H15V15H9",
  },
  {
    id: "B343DEEB-A0ED-41BF-8C86-37D04A1040A6",
    name: "stop-circle-outline",
    codepoint: "F667",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.6.50",
    path: "M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4M9,9V15H15V9",
  },
  {
    id: "3C3AEDE0-B6DA-4CB9-A686-869634678D5D",
    name: "store",
    codepoint: "F4DC",
    aliases: ["shop", "store-mall-directory"],
    tags: ["Places"],
    author: "Google",
    version: "1.5.54",
    path: "M12,18H6V14H12M21,14V12L20,7H4L3,12V14H4V20H14V14H18V20H20V14M20,4H4V6H20V4Z",
  },
  {
    id: "417393DA-3C7F-4BF2-9283-AB1429FFA068",
    name: "store-24-hour",
    codepoint: "F4DD",
    aliases: ["local-convenience-store", "shop-24-hour"],
    tags: ["Places"],
    author: "Google",
    version: "1.5.54",
    path: "M16,12H15V10H13V7H14V9H15V7H16M11,10H9V11H11V12H8V9H10V8H8V7H11M19,7V4H5V7H2V20H10V16H14V20H22V7H19Z",
  },
  {
    id: "18EF6E1E-8EF9-4A62-AAB9-6E8BE591408A",
    name: "stove",
    codepoint: "F4DE",
    aliases: ["cooker", "oven"],
    tags: ["Food / Drink", "Home Automation"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M6,14H8L11,17H9L6,14M4,4H5V3C5,2.45 5.45,2 6,2H10C10.55,2 11,2.45 11,3V4H13V3C13,2.45 13.45,2 14,2H18C18.55,2 19,2.45 19,3V4H20C21.1,4 22,4.9 22,6V19C22,20.1 21.1,21 20,21V22H17V21H7V22H4V21C2.9,21 2,20.1 2,19V6C2,4.9 2.9,4 4,4M18,7C18.55,7 19,7.45 19,8C19,8.55 18.55,9 18,9C17.45,9 17,8.55 17,8C17,7.45 17.45,7 18,7M14,7C14.55,7 15,7.45 15,8C15,8.55 14.55,9 14,9C13.45,9 13,8.55 13,8C13,7.45 13.45,7 14,7M20,6H4V10H20V6M4,19H20V12H4V19M6,7C6.55,7 7,7.45 7,8C7,8.55 6.55,9 6,9C5.45,9 5,8.55 5,8C5,7.45 5.45,7 6,7M13,14H15L18,17H16L13,14Z",
  },
  {
    id: "FC46F7BD-E8E2-452C-868C-E168E13B278D",
    name: "subdirectory-arrow-left",
    codepoint: "F60C",
    aliases: [],
    tags: ["Arrow"],
    author: "Google",
    version: "1.5.54",
    path: "M11,9L12.42,10.42L8.83,14H18V4H20V16H8.83L12.42,19.58L11,21L5,15L11,9Z",
  },
  {
    id: "AFD661FE-31E3-4BB5-8977-10113C7AC3F4",
    name: "subdirectory-arrow-right",
    codepoint: "F60D",
    aliases: [],
    tags: ["Arrow"],
    author: "Google",
    version: "1.5.54",
    path: "M19,15L13,21L11.58,19.58L15.17,16H4V4H6V14H15.17L11.58,10.42L13,9L19,15Z",
  },
  {
    id: "9808EEC5-35FB-45B1-AFCB-065E9CF469E4",
    name: "subtitles",
    codepoint: "FA15",
    aliases: [],
    tags: [],
    author: "Google",
    version: "2.5.94",
    path: "M20,4H4C2.9,4 2,4.9 2,6V18C2,19.1 2.9,20 4,20H20C21.1,20 22,19.1 22,18V6C22,4.9 21.1,4 20,4M4,12H8V14H4V12M14,18H4V16H14V18M20,18H16V16H20V18M20,14H10V12H20V14Z",
  },
  {
    id: "451E9683-F30C-4B0A-95EE-5AD92B012F26",
    name: "subtitles-outline",
    codepoint: "FA16",
    aliases: [],
    tags: [],
    author: "Google",
    version: "2.5.94",
    path: "M20,4C21.1,4 22,4.9 22,6V18C22,19.1 21.1,20 20,20H4C2.9,20 2,19.1 2,18V6C2,4.9 2.9,4 4,4H20M20,18V6H4V18H20M6,10H8V12H6V10M6,14H14V16H6V14M16,14H18V16H16V14M10,10H18V12H10V10Z",
  },
  {
    id: "769FB684-BA81-4E2A-B623-4C8B6F3DCD2C",
    name: "subway",
    codepoint: "F6AB",
    aliases: ["metro", "tube", "underground"],
    tags: ["Transportation + Other"],
    author: "Google",
    version: "1.7.12",
    path: "M8.5,15C9.05,15 9.5,15.45 9.5,16C9.5,16.55 9.05,17 8.5,17C7.95,17 7.5,16.55 7.5,16C7.5,15.45 7.95,15 8.5,15M7,9H17V14H7V9M15.5,15C16.05,15 16.5,15.45 16.5,16C16.5,16.55 16.05,17 15.5,17C14.95,17 14.5,16.55 14.5,16C14.5,15.45 14.95,15 15.5,15M18,15.88V9C18,6.38 15.32,6 12,6C9,6 6,6.37 6,9V15.88C6,17.33 7.17,18.5 8.62,18.5L7.5,19.62V20H9.17L10.67,18.5H13.5L15,20H16.5V19.62L15.37,18.5C16.82,18.5 18,17.33 18,15.88M17.8,2.8C20.47,3.84 22,6.05 22,8.86V22H2V8.86C2,6.05 3.53,3.84 6.2,2.8C8,2.09 10.14,2 12,2C13.86,2 16,2.09 17.8,2.8Z",
  },
  {
    id: "EBD55581-BE34-4D0D-A151-974FD5FD7D92",
    name: "subway-variant",
    codepoint: "F4DF",
    aliases: [
      "metro-variant",
      "tube-variant",
      "underground-variant",
      "directions-subway",
      "directions-transit",
    ],
    tags: ["Transportation + Other"],
    author: "Google",
    version: "1.5.54",
    path: "M18,11H13V6H18M16.5,17C15.67,17 15,16.33 15,15.5C15,14.67 15.67,14 16.5,14C17.33,14 18,14.67 18,15.5C18,16.33 17.33,17 16.5,17M11,11H6V6H11M7.5,17C6.67,17 6,16.33 6,15.5C6,14.67 6.67,14 7.5,14C8.33,14 9,14.67 9,15.5C9,16.33 8.33,17 7.5,17M12,2C7.58,2 4,2.5 4,6V15.5C4,17.43 5.57,19 7.5,19L6,20.5V21H18V20.5L16.5,19C18.43,19 20,17.43 20,15.5V6C20,2.5 16.42,2 12,2Z",
  },
  {
    id: "052D93D8-A1F1-450C-99F3-AEEE07D77CF4",
    name: "summit",
    codepoint: "F785",
    aliases: ["peak"],
    tags: [],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M15,3H17L22,5L17,7V10.17L22,21H2L8,13L11.5,17.7L15,10.17V3Z",
  },
  {
    id: "E52FC33A-09BD-4B34-AF94-92C891020CDC",
    name: "sunglasses",
    codepoint: "F4E0",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M7,17H4C2.38,17 0.96,15.74 0.76,14.14L0.26,11.15C0.15,10.3 0.39,9.5 0.91,8.92C1.43,8.34 2.19,8 3,8H9C9.83,8 10.58,8.35 11.06,8.96C11.17,9.11 11.27,9.27 11.35,9.45C11.78,9.36 12.22,9.36 12.64,9.45C12.72,9.27 12.82,9.11 12.94,8.96C13.41,8.35 14.16,8 15,8H21C21.81,8 22.57,8.34 23.09,8.92C23.6,9.5 23.84,10.3 23.74,11.11L23.23,14.18C23.04,15.74 21.61,17 20,17H17C15.44,17 13.92,15.81 13.54,14.3L12.64,11.59C12.26,11.31 11.73,11.31 11.35,11.59L10.43,14.37C10.07,15.82 8.56,17 7,17Z",
  },
  {
    id: "AB38BBD9-58A6-4D21-8A76-8940B7717550",
    name: "surround-sound",
    codepoint: "F5C5",
    aliases: [],
    tags: ["Audio"],
    author: "Google",
    version: "1.5.54",
    path: "M20,4H4C2.9,4 2,4.9 2,6V18C2,19.1 2.9,20 4,20H20C21.1,20 22,19.1 22,18V6C22,4.9 21.1,4 20,4M7.76,16.24L6.35,17.65C4.78,16.1 4,14.05 4,12C4,9.95 4.78,7.9 6.34,6.34L7.75,7.75C6.59,8.93 6,10.46 6,12C6,13.54 6.59,15.07 7.76,16.24M12,16C9.79,16 8,14.21 8,12C8,9.79 9.79,8 12,8C14.21,8 16,9.79 16,12C16,14.21 14.21,16 12,16M17.66,17.66L16.25,16.25C17.41,15.07 18,13.54 18,12C18,10.46 17.41,8.93 16.24,7.76L17.65,6.35C19.22,7.9 20,9.95 20,12C20,14.05 19.22,16.1 17.66,17.66M12,10C10.9,10 10,10.9 10,12C10,13.1 10.9,14 12,14C13.1,14 14,13.1 14,12C14,10.9 13.1,10 12,10Z",
  },
  {
    id: "13009B66-7459-4C86-8EB0-3CAED977BB98",
    name: "surround-sound-2-0",
    codepoint: "F7EF",
    aliases: ["stereo"],
    tags: ["Audio"],
    author: "Austin Andrews",
    version: "2.0.46",
    path: "M17,7H19C20.1,7 21,7.9 21,9V15C21,16.1 20.1,17 19,17H17C15.9,17 15,16.1 15,15V9C15,7.9 15.9,7 17,7M17,9V15H19V9H17M9,17H3V15L7,9H3V7H7C8.1,7 9,7.9 9,9C9,9.42 8.87,9.81 8.65,10.13L5.41,15H9V17M12,17C11.45,17 11,16.55 11,16C11,15.45 11.45,15 12,15C12.55,15 13,15.45 13,16C13,16.55 12.55,17 12,17Z",
  },
  {
    id: "4B744BE0-A739-44FF-ADA6-CFC9BC520B1D",
    name: "surround-sound-3-1",
    codepoint: "F7F0",
    aliases: [],
    tags: ["Audio"],
    author: "Austin Andrews",
    version: "2.0.46",
    path: "M13,17C12.45,17 12,16.55 12,16C12,15.45 12.45,15 13,15C13.55,15 14,15.45 14,16C14,16.55 13.55,17 13,17M19,7V15H20V17H16V15H17V9H16L17,7H19M4,7H8C9.1,7 10,7.9 10,9V15C10,16.1 9.1,17 8,17H4V15H8V13H5V11H8V9H4V7Z",
  },
  {
    id: "CFD48DE8-0DA8-455C-9C4C-337EDC54D7C0",
    name: "surround-sound-5-1",
    codepoint: "F7F1",
    aliases: [],
    tags: ["Audio"],
    author: "Austin Andrews",
    version: "2.0.46",
    path: "M13,17C12.45,17 12,16.55 12,16C12,15.45 12.45,15 13,15C13.55,15 14,15.45 14,16C14,16.55 13.55,17 13,17M19,7V15H20V17H16V15H17V9H16L17,7H19M6,13C4.9,13 4,12.1 4,11V7H10V9H6V11H8C9.1,11 10,11.9 10,13V15C10,16.1 9.1,17 8,17H4V15H8V13H6Z",
  },
  {
    id: "BC85CD47-E52C-4A7D-8E05-DD45596C5822",
    name: "surround-sound-7-1",
    codepoint: "F7F2",
    aliases: [],
    tags: ["Audio"],
    author: "Austin Andrews",
    version: "2.0.46",
    path: "M12,17C11.45,17 11,16.55 11,16C11,15.45 11.45,15 12,15C12.55,15 13,15.45 13,16C13,16.55 12.55,17 12,17M18,7V15H19V17H15V15H16V9H15L16,7H18M11,7L8,17H6L8.4,9H5V7H11Z",
  },
  {
    id: "5E34C73B-E200-4BD3-A10E-A00D1D47BFF4",
    name: "svg",
    codepoint: "F720",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.8.36",
    path: "M5.13,10.71H8.87L6.22,8.06C5.21,8.06 4.39,7.24 4.39,6.22C4.39,5.21 5.21,4.39 6.22,4.39C7.24,4.39 8.06,5.21 8.06,6.22L10.71,8.87V5.13C10,4.41 10,3.25 10.71,2.54C11.42,1.82 12.58,1.82 13.29,2.54C14,3.25 14,4.41 13.29,5.13V8.87L15.95,6.22C15.95,5.21 16.76,4.39 17.78,4.39C18.79,4.39 19.61,5.21 19.61,6.22C19.61,7.24 18.79,8.06 17.78,8.06L15.13,10.71H18.87C19.59,10 20.75,10 21.46,10.71C22.18,11.42 22.18,12.58 21.46,13.29C20.75,14 19.59,14 18.87,13.29H15.13L17.78,15.95C18.79,15.95 19.61,16.76 19.61,17.78C19.61,18.79 18.79,19.61 17.78,19.61C16.76,19.61 15.95,18.79 15.95,17.78L13.29,15.13V18.87C14,19.59 14,20.75 13.29,21.46C12.58,22.18 11.42,22.18 10.71,21.46C10,20.75 10,19.59 10.71,18.87V15.13L8.06,17.78C8.06,18.79 7.24,19.61 6.22,19.61C5.21,19.61 4.39,18.79 4.39,17.78C4.39,16.76 5.21,15.95 6.22,15.95L8.87,13.29H5.13C4.41,14 3.25,14 2.54,13.29C1.82,12.58 1.82,11.42 2.54,10.71C3.25,10 4.41,10 5.13,10.71Z",
  },
  {
    id: "D1E543C5-6ECA-43AA-B04D-438319BC5562",
    name: "swap-horizontal",
    codepoint: "F4E1",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M21,9L17,5V8H10V10H17V13M7,11L3,15L7,19V16H14V14H7V11Z",
  },
  {
    id: "23A48C18-9950-436D-9948-29EE7EE13054",
    name: "swap-horizontal-variant",
    codepoint: "F8C0",
    aliases: [],
    tags: [],
    author: "Google",
    version: "2.2.43",
    path: "M4,6L8,10V7H16C17.1,7 18,7.9 18,9C18,10.1 17.1,11 16,11H8C5.79,11 4,12.79 4,15C4,17.21 5.79,19 8,19H16V22L20,18L16,14V17H8C6.9,17 6,16.1 6,15C6,13.9 6.9,13 8,13H16C18.21,13 20,11.21 20,9C20,6.79 18.21,5 16,5H8V2L4,6Z",
  },
  {
    id: "DA7FB76D-58FA-4AED-9DF9-033E994AE000",
    name: "swap-vertical",
    codepoint: "F4E2",
    aliases: ["import-export"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M9,3L5,7H8V14H10V7H13M16,17V10H14V17H11L15,21L19,17H16Z",
  },
  {
    id: "FC1C62DB-A06D-48F8-962F-F60FE41E4F65",
    name: "swap-vertical-variant",
    codepoint: "F8C1",
    aliases: ["swap-calls"],
    tags: [],
    author: "Google",
    version: "2.2.43",
    path: "M18,4L14,8H17V16C17,17.1 16.1,18 15,18C13.9,18 13,17.1 13,16V8C13,5.79 11.21,4 9,4C6.79,4 5,5.79 5,8V16H2L6,20L10,16H7V8C7,6.9 7.9,6 9,6C10.1,6 11,6.9 11,8V16C11,18.21 12.79,20 15,20C17.21,20 19,18.21 19,16V8H22L18,4Z",
  },
  {
    id: "668BF75C-2B3B-46CB-8731-AE6BF10244BD",
    name: "swim",
    codepoint: "F4E3",
    aliases: [],
    tags: ["Sport"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M2,18C4.22,17 6.44,16 8.67,16C10.89,16 13.11,18 15.33,18C17.56,18 19.78,16 22,16V19C19.78,19 17.56,21 15.33,21C13.11,21 10.89,19 8.67,19C6.44,19 4.22,20 2,21V18M8.67,13C7.89,13 7.12,13.12 6.35,13.32L11.27,9.88L10.23,8.64C10.09,8.47 10,8.24 10,8C10,7.66 10.17,7.35 10.44,7.17L16.16,3.17L17.31,4.8L12.47,8.19L17.7,14.42C16.91,14.75 16.12,15 15.33,15C13.11,15 10.89,13 8.67,13M18,7C19.1,7 20,7.9 20,9C20,10.1 19.1,11 18,11C16.9,11 16,10.1 16,9C16,7.9 16.9,7 18,7Z",
  },
  {
    id: "A2ED8CF0-EAE1-4B83-9469-448260288DDE",
    name: "switch",
    codepoint: "F4E4",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M13,18H14C14.55,18 15,18.45 15,19H22V21H15C15,21.55 14.55,22 14,22H10C9.45,22 9,21.55 9,21H2V19H9C9,18.45 9.45,18 10,18H11V16H8C7.45,16 7,15.55 7,15V3C7,2.45 7.45,2 8,2H16C16.55,2 17,2.45 17,3V15C17,15.55 16.55,16 16,16H13V18M13,6H14V4H13V6M9,4V6H11V4H9M9,8V10H11V8H9M9,12V14H11V12H9Z",
  },
  {
    id: "D73618B2-062C-40B2-BF8D-43DC48809F9B",
    name: "sword",
    codepoint: "F4E5",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M6.92,5H5L14,14L15,13.06M19.96,19.12L19.12,19.96C18.73,20.35 18.1,20.35 17.71,19.96L14.59,16.84L11.91,19.5L10.5,18.09L11.92,16.67L3,7.75V3H7.75L16.67,11.92L18.09,10.5L19.5,11.91L16.83,14.58L19.95,17.7C20.35,18.1 20.35,18.73 19.96,19.12Z",
  },
  {
    id: "37B336A5-5827-4929-93B5-C12373966731",
    name: "sword-cross",
    codepoint: "F786",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "1.9.32",
    path: "M6.2,2.44L18.1,14.34L20.22,12.22L21.63,13.63L19.16,16.1L22.34,19.28C22.73,19.67 22.73,20.3 22.34,20.69L21.63,21.4C21.24,21.79 20.61,21.79 20.22,21.4L17,18.23L14.56,20.7L13.15,19.29L15.27,17.17L3.37,5.27V2.44H6.2M15.89,10L20.63,5.26V2.44H17.8L13.06,7.18L15.89,10M10.94,15L8.11,12.13L5.9,14.34L3.78,12.22L2.37,13.63L4.84,16.1L1.66,19.29C1.27,19.68 1.27,20.31 1.66,20.7L2.37,21.41C2.76,21.8 3.39,21.8 3.78,21.41L7,18.23L9.44,20.7L10.85,19.29L8.73,17.17L10.94,15Z",
  },
  {
    id: "E8CE455E-8C08-48F4-B989-8D91E185E8AE",
    name: "sync",
    codepoint: "F4E6",
    aliases: ["loop"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M12,18C8.69,18 6,15.31 6,12C6,11 6.25,10.03 6.7,9.2L5.24,7.74C4.46,8.97 4,10.43 4,12C4,16.42 7.58,20 12,20V23L16,19L12,15M12,4V1L8,5L12,9V6C15.31,6 18,8.69 18,12C18,13 17.75,13.97 17.3,14.8L18.76,16.26C19.54,15.03 20,13.57 20,12C20,7.58 16.42,4 12,4Z",
  },
  {
    id: "66A07118-4C78-44D0-8B73-930144C74BD1",
    name: "sync-alert",
    codepoint: "F4E7",
    aliases: ["sync-warning", "sync-problem"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M11,13H13V7H11M21,4H15V10L17.24,7.76C18.32,8.85 19,10.34 19,12C19,14.61 17.33,16.83 15,17.65V19.74C18.45,18.85 21,15.73 21,12C21,9.79 20.09,7.8 18.64,6.36M11,17H13V15H11M3,12C3,14.21 3.91,16.2 5.36,17.64L3,20H9V14L6.76,16.24C5.68,15.15 5,13.66 5,12C5,9.39 6.67,7.17 9,6.35V4.26C5.55,5.15 3,8.27 3,12Z",
  },
  {
    id: "538457F5-44DB-404B-92FE-5FB8597B258E",
    name: "sync-off",
    codepoint: "F4E8",
    aliases: ["sync-disabled"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M20,4H14V10L16.24,7.76C17.32,8.85 18,10.34 18,12C18,13 17.75,13.94 17.32,14.77L18.78,16.23C19.55,15 20,13.56 20,12C20,9.79 19.09,7.8 17.64,6.36L20,4M2.86,5.41L5.22,7.77C4.45,9 4,10.44 4,12C4,14.21 4.91,16.2 6.36,17.64L4,20H10V14L7.76,16.24C6.68,15.15 6,13.66 6,12C6,11 6.25,10.06 6.68,9.23L14.76,17.31C14.5,17.44 14.26,17.56 14,17.65V19.74C14.79,19.53 15.54,19.2 16.22,18.78L18.58,21.14L19.85,19.87L4.14,4.14L2.86,5.41M10,6.35V4.26C9.2,4.47 8.45,4.8 7.77,5.22L9.23,6.68C9.5,6.56 9.73,6.44 10,6.35Z",
  },
  {
    id: "76D6AAA9-7D7F-4C7A-818E-D9947744A23C",
    name: "tab",
    codepoint: "F4E9",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M21,3H3C1.9,3 1,3.9 1,5V19C1,20.1 1.9,21 3,21H21C22.1,21 23,20.1 23,19V5C23,3.9 22.1,3 21,3M21,19H3V5H13V9H21V19Z",
  },
  {
    id: "9E23B225-E972-4369-A94A-C2AAF4C93870",
    name: "tab-plus",
    codepoint: "F75B",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M3,3C1.9,3 1,3.9 1,5V19C1,20.1 1.9,21 3,21H21C22.1,21 23,20.1 23,19V5C23,3.9 22.1,3 21,3H3M3,5H13V9H21V19H3V5M10,10V13H7V15H10V18H12V15H15V13H12V10H10Z",
  },
  {
    id: "9A9059F0-CADA-47EF-82DC-4B1FB2B9E4C5",
    name: "tab-unselected",
    codepoint: "F4EA",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M1,9H3V7H1V9M1,13H3V11H1V13M1,5H3V3C1.9,3 1,3.9 1,5M9,21H11V19H9V21M1,17H3V15H1V17M3,21V19H1C1,20.1 1.9,21 3,21M21,3H13V9H23V5C23,3.9 22.1,3 21,3M21,17H23V15H21V17M9,5H11V3H9V5M5,21H7V19H5V21M5,5H7V3H5V5M21,21C22.1,21 23,20.1 23,19H21V21M21,13H23V11H21V13M13,21H15V19H13V21M17,21H19V19H17V21Z",
  },
  {
    id: "984D8348-AB61-4DD8-838C-3F2542577F73",
    name: "table",
    codepoint: "F4EB",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M5,4H19C20.1,4 21,4.9 21,6V18C21,19.1 20.1,20 19,20H5C3.9,20 3,19.1 3,18V6C3,4.9 3.9,4 5,4M5,8V12H11V8H5M13,8V12H19V8H13M5,14V18H11V14H5M13,14V18H19V14H13Z",
  },
  {
    id: "4AB13D38-7B5C-49E6-B41C-C48C0F8E7DA3",
    name: "table-border",
    codepoint: "FA17",
    aliases: [],
    tags: [],
    author: "Michael Irigoyen",
    version: "2.5.94",
    path: "M21,19C21,19.55 20.55,20 20,20H19V18H21V19M15,20V18H17V20H15M11,20V18H13V20H11M7,20V18H9V20H7M4,20C3.45,20 3,19.55 3,19V18H5V20H4M19,4H5C3.9,4 3,4.9 3,6V8H5L11,8H13L19,8H21V6C21,4.89 20.11,4 19,4M5,14H3V16H5V14M5,10H3V12H5V10M21,10H19V12H21V10M21,14H19V16H21V14M11,16V14H13V16H11M11,12V10H13V12H11",
  },
  {
    id: "D45D7513-AA4C-43CA-8435-CA6AD2B7F868",
    name: "table-column",
    codepoint: "F834",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "2.1.19",
    path: "M8,2H16C17.1,2 18,2.9 18,4V20C18,21.1 17.1,22 16,22H8C6.9,22 6,21.1 6,20V4C6,2.9 6.9,2 8,2M8,10V14H16V10H8M8,16V20H16V16H8M8,4V8H16V4H8Z",
  },
  {
    id: "0EB91CE4-3223-4799-9BB7-3BA0C923BC40",
    name: "table-column-plus-after",
    codepoint: "F4EC",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M11,2C12.1,2 13,2.9 13,4V20C13,21.1 12.1,22 11,22H2V2H11M4,10V14H11V10H4M4,16V20H11V16H4M4,4V8H11V4H4M15,11H18V8H20V11H23V13H20V16H18V13H15V11Z",
  },
  {
    id: "67B4875F-B08F-4006-AFE1-9C243F8B873A",
    name: "table-column-plus-before",
    codepoint: "F4ED",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M13,2C11.9,2 11,2.9 11,4V20C11,21.1 11.9,22 13,22H22V2H13M20,10V14H13V10H20M20,16V20H13V16H20M20,4V8H13V4H20M9,11H6V8H4V11H1V13H4V16H6V13H9V11Z",
  },
  {
    id: "455B9D6F-1842-434F-8C31-16F68A2C1BA9",
    name: "table-column-remove",
    codepoint: "F4EE",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M4,2H11C12.1,2 13,2.9 13,4V20C13,21.1 12.1,22 11,22H4C2.9,22 2,21.1 2,20V4C2,2.9 2.9,2 4,2M4,10V14H11V10H4M4,16V20H11V16H4M4,4V8H11V4H4M17.59,12L15,9.41L16.41,8L19,10.59L21.59,8L23,9.41L20.41,12L23,14.59L21.59,16L19,13.41L16.41,16L15,14.59L17.59,12Z",
  },
  {
    id: "2343FF2B-E5D3-4BEC-90EA-FB3F5291D4B0",
    name: "table-column-width",
    codepoint: "F4EF",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M5,8H19C20.1,8 21,8.9 21,10V20C21,21.1 20.1,22 19,22H5C3.9,22 3,21.1 3,20V10C3,8.9 3.9,8 5,8M5,12V15H11V12H5M13,12V15H19V12H13M5,17V20H11V17H5M13,17V20H19V17H13M11,2H21V6H19V4H13V6H11V2Z",
  },
  {
    id: "DDC0FFBC-73D2-49E8-8B8C-22D65A5719A6",
    name: "table-edit",
    codepoint: "F4F0",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M21.7,13.35L20.7,14.35L18.65,12.3L19.65,11.3C19.86,11.08 20.21,11.08 20.42,11.3L21.7,12.58C21.92,12.79 21.92,13.14 21.7,13.35M12,18.94L18.07,12.88L20.12,14.93L14.06,21H12V18.94M4,2H18C19.1,2 20,2.9 20,4V8.17L16.17,12H12V16.17L10.17,18H4C2.9,18 2,17.1 2,16V4C2,2.9 2.9,2 4,2M4,6V10H10V6H4M12,6V10H18V6H12M4,12V16H10V12H4Z",
  },
  {
    id: "99BE0AB4-A123-4745-839F-DC355DA8C3D4",
    name: "table-large",
    codepoint: "F4F1",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M4,3H20C21.1,3 22,3.9 22,5V20C22,21.1 21.1,22 20,22H4C2.9,22 2,21.1 2,20V5C2,3.9 2.9,3 4,3M4,7V10H8V7H4M10,7V10H14V7H10M20,10V7H16V10H20M4,12V15H8V12H4M4,20H8V17H4V20M10,12V15H14V12H10M10,20H14V17H10V20M20,20V17H16V20H20M20,12H16V15H20V12Z",
  },
  {
    id: "BE891E33-2018-4619-BF4C-C006B4063785",
    name: "table-merge-cells",
    codepoint: "F9A5",
    aliases: [],
    tags: [],
    author: "Michael Irigoyen",
    version: "2.4.85",
    path: "M5,10H3V6C3,4.9 3.9,4 5,4H11V6H5V10M19,18H13V20H19C20.1,20 21,19.1 21,18V14H19V18M5,18V14H3V18C3,19.1 3.9,20 5,20H11V18H5M19,4H13V6H19V10H21V6C21,4.9 20.1,4 19,4M8,13V15L11,12L8,9V11H3V13H8M16,11V9L13,12L16,15V13H21V11H16Z",
  },
  {
    id: "70A0953D-9FEF-4858-8ACB-A90C5613360A",
    name: "table-of-contents",
    codepoint: "F835",
    aliases: ["toc"],
    tags: [],
    author: "Google",
    version: "2.1.19",
    path: "M3,9H17V7H3V9M3,13H17V11H3V13M3,17H17V15H3V17M19,17H21V15H19V17M19,7V9H21V7H19M19,13H21V11H19V13Z",
  },
  {
    id: "8EA23E11-D670-4D09-8AA6-7DAFBEAA54FD",
    name: "table-row",
    codepoint: "F836",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "2.1.19",
    path: "M22,14C22,15.1 21.1,16 20,16H4C2.9,16 2,15.1 2,14V10C2,8.9 2.9,8 4,8H20C21.1,8 22,8.9 22,10V14M4,14H8V10H4V14M10,14H14V10H10V14M16,14H20V10H16V14Z",
  },
  {
    id: "5B9A6186-2C24-4D16-9FE4-F0E23C8E5B5F",
    name: "table-row-height",
    codepoint: "F4F2",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M3,5H15C16.1,5 17,5.9 17,7V17C17,18.1 16.1,19 15,19H3C1.9,19 1,18.1 1,17V7C1,5.9 1.9,5 3,5M3,9V12H8V9H3M10,9V12H15V9H10M3,14V17H8V14H3M10,14V17H15V14H10M23,14V7H19V9H21V12H19V14H23Z",
  },
  {
    id: "0B2B45F7-3597-4049-9643-9E972826F67C",
    name: "table-row-plus-after",
    codepoint: "F4F3",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M22,10C22,11.1 21.1,12 20,12H4C2.9,12 2,11.1 2,10V3H4V5H8V3H10V5H14V3H16V5H20V3H22V10M4,10H8V7H4V10M10,10H14V7H10V10M20,10V7H16V10H20M11,14H13V17H16V19H13V22H11V19H8V17H11V14Z",
  },
  {
    id: "784BF375-370F-4DAE-985D-7BEF2FDA6951",
    name: "table-row-plus-before",
    codepoint: "F4F4",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M22,14C22,12.9 21.1,12 20,12H4C2.9,12 2,12.9 2,14V21H4V19H8V21H10V19H14V21H16V19H20V21H22V14M4,14H8V17H4V14M10,14H14V17H10V14M20,14V17H16V14H20M11,10H13V7H16V5H13V2H11V5H8V7H11V10Z",
  },
  {
    id: "017D1949-234A-4C27-A653-FF0EAF33AD92",
    name: "table-row-remove",
    codepoint: "F4F5",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M9.41,13L12,15.59L14.59,13L16,14.41L13.41,17L16,19.59L14.59,21L12,18.41L9.41,21L8,19.59L10.59,17L8,14.41L9.41,13M22,9C22,10.1 21.1,11 20,11H4C2.9,11 2,10.1 2,9V6C2,4.9 2.9,4 4,4H20C21.1,4 22,4.9 22,6V9M4,9H8V6H4V9M10,9H14V6H10V9M16,9H20V6H16V9Z",
  },
  {
    id: "6053118D-7921-45FC-BC83-9F08BF2AE6DF",
    name: "table-search",
    codepoint: "F90E",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.3.50",
    path: "M19.3,17.89C20.62,15.79 20,13 17.89,11.68C15.79,10.36 13,11 11.68,13.09C10.36,15.2 11,18 13.09,19.3C14.56,20.22 16.42,20.22 17.89,19.3L21,22.39L22.39,21L19.3,17.89M17.3,17.27C16.32,18.25 14.74,18.24 13.76,17.27C12.79,16.29 12.79,14.71 13.77,13.73C14.74,12.76 16.32,12.76 17.3,13.73C18.26,14.72 18.25,16.3 17.27,17.27H17.3M19,4H5C3.9,4 3,4.9 3,6V18C3,19.1 3.9,20 5,20H10.81C10.25,19.42 9.8,18.74 9.5,18H5V14H9.18C9.34,13.29 9.61,12.61 10,12H5V8H11V10.81C11.58,10.25 12.26,9.8 13,9.5V8H19V10C19.4,10.25 19.77,10.55 20.1,10.88C20.44,11.22 20.74,11.59 21,12V6C21,4.9 20.1,4 19,4Z",
  },
  {
    id: "B506843C-4832-4F30-8266-9B02632AB582",
    name: "table-settings",
    codepoint: "F837",
    aliases: [],
    tags: ["Settings"],
    author: "Contributors",
    version: "2.1.19",
    path: "M7,22H9V24H7V22M11,22H13V24H11V22M15,22H17V24H15V22M5,4H19C20.1,4 21,4.9 21,6V18C21,19.1 20.1,20 19,20H5C3.9,20 3,19.1 3,18V6C3,4.9 3.9,4 5,4M5,8V12H11V8H5M13,8V12H19V8H13M5,14V18H11V14H5M13,14V18H19V14H13Z",
  },
  {
    id: "703B639C-E17D-40F1-8025-2B2950B1961D",
    name: "tablet",
    codepoint: "F4F6",
    aliases: [],
    tags: ["Device / Tech"],
    author: "Google",
    version: "1.5.54",
    path: "M19,18H5V6H19M21,4H3C1.89,4 1,4.89 1,6V18C1,19.1 1.9,20 3,20H21C22.1,20 23,19.1 23,18V6C23,4.89 22.1,4 21,4Z",
  },
  {
    id: "179831B0-F175-4694-9313-3B745C133F96",
    name: "tablet-android",
    codepoint: "F4F7",
    aliases: [],
    tags: ["Device / Tech"],
    author: "Google",
    version: "1.5.54",
    path: "M19.25,19H4.75V3H19.25M14,22H10V21H14M18,0H6C4.34,0 3,1.34 3,3V21C3,22.66 4.34,24 6,24H18C19.66,24 21,22.66 21,21V3C21,1.34 19.66,0 18,0Z",
  },
  {
    id: "804E3CCD-99B5-4F54-898A-9477D69E6951",
    name: "tablet-cellphone",
    codepoint: "F9A6",
    aliases: ["mobile-devices", "tablet-mobile-phone", "tablet-smartphone"],
    tags: ["Cellphone / Phone"],
    author: "Google",
    version: "2.4.85",
    path: "M3,4H20C21.1,4 22,4.9 22,6V8H18V6H5V18H14V20H3C1.9,20 1,19.1 1,18V6C1,4.9 1.9,4 3,4M17,10H23C23.55,10 24,10.45 24,11V21C24,21.55 23.55,22 23,22H17C16.45,22 16,21.55 16,21V11C16,10.45 16.45,10 17,10M18,12V19H22V12H18Z",
  },
  {
    id: "A7147BE3-0B04-4B61-94F3-48B0D9C5551E",
    name: "tablet-ipad",
    codepoint: "F4F8",
    aliases: ["tablet-mac"],
    tags: ["Device / Tech"],
    author: "Google",
    version: "1.5.54",
    path: "M19,19H4V3H19M11.5,23C10.67,23 10,22.33 10,21.5C10,20.67 10.67,20 11.5,20C12.33,20 13,20.67 13,21.5C13,22.33 12.33,23 11.5,23M18.5,0H4.5C3.12,0 2,1.12 2,2.5V21.5C2,22.88 3.12,24 4.5,24H18.5C19.88,24 21,22.88 21,21.5V2.5C21,1.12 19.88,0 18.5,0Z",
  },
  {
    id: "9E259FF6-513C-44B0-BB10-7F930DFA47DD",
    name: "taco",
    codepoint: "F761",
    aliases: [],
    tags: ["Food / Drink"],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M19,18H5C2.79,18 1,16.21 1,14C1,9.58 4.58,6 9,6C10.06,6 11.07,6.21 12,6.58C12.93,6.21 13.94,6 15,6C19.42,6 23,9.58 23,14C23,16.21 21.21,18 19,18M3,14C3,15.1 3.9,16 5,16C6.1,16 7,15.1 7,14C7,11.63 8.03,9.5 9.67,8.04L9,8C5.69,8 3,10.69 3,14M19,16C20.1,16 21,15.1 21,14C21,10.69 18.31,8 15,8C11.69,8 9,10.69 9,14C9,14.73 8.81,15.41 8.46,16H19Z",
  },
  {
    id: "0BE85AB2-0D51-411C-B119-789E9E317216",
    name: "tag",
    codepoint: "F4F9",
    aliases: ["local-offer"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M5.5,7C4.67,7 4,6.33 4,5.5C4,4.67 4.67,4 5.5,4C6.33,4 7,4.67 7,5.5C7,6.33 6.33,7 5.5,7M21.41,11.58L12.41,2.58C12.05,2.22 11.55,2 11,2H4C2.89,2 2,2.89 2,4V11C2,11.55 2.22,12.05 2.59,12.41L11.58,21.41C11.95,21.77 12.45,22 13,22C13.55,22 14.05,21.77 14.41,21.41L21.41,14.41C21.78,14.05 22,13.55 22,13C22,12.44 21.77,11.94 21.41,11.58Z",
  },
  {
    id: "5DCE0F4D-F740-4D9A-AC93-281D3477E9AF",
    name: "tag-faces",
    codepoint: "F4FA",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M15,18C11.68,18 9,15.31 9,12C9,8.68 11.68,6 15,6C18.31,6 21,8.69 21,12C21,15.31 18.31,18 15,18M4,13C3.45,13 3,12.55 3,12C3,11.45 3.45,11 4,11C4.55,11 5,11.45 5,12C5,12.55 4.55,13 4,13M22,3H7.63C6.97,3 6.38,3.32 6,3.81L0,12L6,20.18C6.38,20.68 6.97,21 7.63,21H22C23.1,21 24,20.1 24,19V5C24,3.89 23.1,3 22,3M13,11C13.55,11 14,10.55 14,10C14,9.45 13.55,9 13,9C12.45,9 12,9.45 12,10C12,10.55 12.45,11 13,11M15,16C16.86,16 18.35,14.72 18.8,13H11.2C11.65,14.72 13.14,16 15,16M17,11C17.55,11 18,10.55 18,10C18,9.45 17.55,9 17,9C16.45,9 16,9.45 16,10C16,10.55 16.45,11 17,11Z",
  },
  {
    id: "2D9E735C-EA23-4EB2-9AC4-C92D69218577",
    name: "tag-heart",
    codepoint: "F68A",
    aliases: ["loyalty"],
    tags: [],
    author: "Google",
    version: "1.7.12",
    path: "M21.41,11.58L12.41,2.58C12.05,2.22 11.55,2 11,2H4C2.9,2 2,2.9 2,4V11C2,11.55 2.22,12.05 2.59,12.42L11.59,21.42C11.95,21.78 12.45,22 13,22C13.55,22 14.05,21.78 14.41,21.41L21.41,14.41C21.78,14.05 22,13.55 22,13C22,12.45 21.77,11.94 21.41,11.58M5.5,7C4.67,7 4,6.33 4,5.5C4,4.67 4.67,4 5.5,4C6.33,4 7,4.67 7,5.5C7,6.33 6.33,7 5.5,7M17.27,15.27L13,19.54L8.73,15.27C8.28,14.81 8,14.19 8,13.5C8,12.12 9.12,11 10.5,11C11.19,11 11.82,11.28 12.27,11.74L13,12.46L13.73,11.73C14.18,11.28 14.81,11 15.5,11C16.88,11 18,12.12 18,13.5C18,14.19 17.72,14.82 17.27,15.27Z",
  },
  {
    id: "1F2E41E2-6509-4C1B-B95B-145C9A8375DA",
    name: "tag-minus",
    codepoint: "F90F",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "2.3.50",
    path: "M21.41,11.58L12.41,2.58C12.04,2.21 11.53,2 11,2H4C2.9,2 2,2.9 2,4V11C2,11.53 2.21,12.04 2.59,12.41L3,12.81C3.9,12.27 4.94,12 6,12C9.31,12 12,14.69 12,18C12,19.06 11.72,20.09 11.18,21L11.58,21.4C11.95,21.78 12.47,22 13,22C13.53,22 14.04,21.79 14.41,21.41L21.41,14.41C21.79,14.04 22,13.53 22,13C22,12.47 21.79,11.96 21.41,11.58M5.5,7C4.67,7 4,6.33 4,5.5C4,4.67 4.67,4 5.5,4C6.33,4 7,4.67 7,5.5C7,6.33 6.33,7 5.5,7M10,19H2V17H10V19Z",
  },
  {
    id: "408AB5A3-F100-4175-96CD-8602BE101150",
    name: "tag-multiple",
    codepoint: "F4FB",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M5.5,9C6.33,9 7,8.33 7,7.5C7,6.67 6.33,6 5.5,6C4.67,6 4,6.67 4,7.5C4,8.33 4.67,9 5.5,9M17.41,11.58C17.77,11.94 18,12.44 18,13C18,13.55 17.78,14.05 17.41,14.41L12.41,19.41C12.05,19.77 11.55,20 11,20C10.45,20 9.95,19.78 9.58,19.41L2.59,12.42C2.22,12.05 2,11.55 2,11V6C2,4.89 2.89,4 4,4H9C9.55,4 10.05,4.22 10.41,4.58L17.41,11.58M13.54,5.71L14.54,4.71L21.41,11.58C21.78,11.94 22,12.45 22,13C22,13.55 21.78,14.05 21.42,14.41L16.04,19.79L15.04,18.79L20.75,13L13.54,5.71Z",
  },
  {
    id: "2022546E-45D4-4AC5-B24F-6D6AAEA0F452",
    name: "tag-outline",
    codepoint: "F4FC",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M5.5,7C6.33,7 7,6.33 7,5.5C7,4.67 6.33,4 5.5,4C4.67,4 4,4.67 4,5.5C4,6.33 4.67,7 5.5,7M21.41,11.58C21.77,11.94 22,12.44 22,13C22,13.55 21.78,14.05 21.41,14.41L14.41,21.41C14.05,21.77 13.55,22 13,22C12.45,22 11.95,21.77 11.58,21.41L2.59,12.41C2.22,12.05 2,11.55 2,11V4C2,2.89 2.89,2 4,2H11C11.55,2 12.05,2.22 12.41,2.58L21.41,11.58M13,20L20,13L11.5,4.5L4.5,11.5L13,20Z",
  },
  {
    id: "83C0C7C5-26FF-4EF7-A05B-B05472FC40FC",
    name: "tag-plus",
    codepoint: "F721",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "1.8.36",
    path: "M21.41,11.58L12.41,2.58C12.04,2.21 11.53,2 11,2H4C2.9,2 2,2.9 2,4V11C2,11.53 2.21,12.04 2.59,12.41L3,12.81C3.9,12.27 4.94,12 6,12C9.31,12 12,14.69 12,18C12,19.06 11.72,20.09 11.18,21L11.58,21.4C11.95,21.78 12.47,22 13,22C13.53,22 14.04,21.79 14.41,21.41L21.41,14.41C21.79,14.04 22,13.53 22,13C22,12.47 21.79,11.96 21.41,11.58M5.5,7C4.67,7 4,6.33 4,5.5C4,4.67 4.67,4 5.5,4C6.33,4 7,4.67 7,5.5C7,6.33 6.33,7 5.5,7M10,19H7V22H5V19H2V17H5V14H7V17H10V19Z",
  },
  {
    id: "E90C088F-8DFD-4B7D-962C-BE2DD9DB61BD",
    name: "tag-remove",
    codepoint: "F722",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "1.8.36",
    path: "M21.41,11.58L12.41,2.58C12.04,2.21 11.53,2 11,2H4C2.9,2 2,2.9 2,4V11C2,11.53 2.21,12.04 2.59,12.41L3,12.81C3.9,12.27 4.94,12 6,12C9.31,12 12,14.69 12,18C12,19.06 11.72,20.09 11.18,21L11.58,21.4C11.95,21.78 12.47,22 13,22C13.53,22 14.04,21.79 14.41,21.41L21.41,14.41C21.79,14.04 22,13.53 22,13C22,12.47 21.79,11.96 21.41,11.58M5.5,7C4.67,7 4,6.33 4,5.5C4,4.67 4.67,4 5.5,4C6.33,4 7,4.67 7,5.5C7,6.33 6.33,7 5.5,7M8.12,21.54L6,19.41L3.88,21.54L2.46,20.12L4.59,18L2.46,15.88L3.87,14.47L6,16.59L8.12,14.47L9.53,15.88L7.41,18L9.53,20.12L8.12,21.54Z",
  },
  {
    id: "8ED927D3-84B9-43D1-82B4-3859653006D6",
    name: "tag-text-outline",
    codepoint: "F4FD",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M5.5,7C6.33,7 7,6.33 7,5.5C7,4.67 6.33,4 5.5,4C4.67,4 4,4.67 4,5.5C4,6.33 4.67,7 5.5,7M21.41,11.58C21.77,11.94 22,12.44 22,13C22,13.55 21.78,14.05 21.41,14.41L14.41,21.41C14.05,21.77 13.55,22 13,22C12.45,22 11.95,21.77 11.58,21.41L2.59,12.41C2.22,12.05 2,11.55 2,11V4C2,2.89 2.89,2 4,2H11C11.55,2 12.05,2.22 12.41,2.58L21.41,11.58M13,20L20,13L11.5,4.5L4.5,11.5L13,20M10.09,8.91L11.5,7.5L17,13L15.59,14.41L10.09,8.91M7.59,11.41L9,10L13,14L11.59,15.41L7.59,11.41Z",
  },
  {
    id: "363D29C5-9F0F-43EA-BE7E-D1C2C1418517",
    name: "target",
    codepoint: "F4FE",
    aliases: [],
    tags: [],
    author: "Doug C. Hardester",
    version: "1.5.54",
    path: "M11,2V4.07C7.38,4.53 4.53,7.38 4.07,11H2V13H4.07C4.53,16.62 7.38,19.47 11,19.93V22H13V19.93C16.62,19.47 19.47,16.62 19.93,13H22V11H19.93C19.47,7.38 16.62,4.53 13,4.07V2M11,6.08V8H13V6.09C15.5,6.5 17.5,8.5 17.92,11H16V13H17.91C17.5,15.5 15.5,17.5 13,17.92V16H11V17.91C8.5,17.5 6.5,15.5 6.08,13H8V11H6.09C6.5,8.5 8.5,6.5 11,6.08M12,11C11.45,11 11,11.45 11,12C11,12.55 11.45,13 12,13C12.55,13 13,12.55 13,12C13,11.45 12.55,11 12,11Z",
  },
  {
    id: "32F3835A-EBD0-4927-9497-6F67F7075EAF",
    name: "taxi",
    codepoint: "F4FF",
    aliases: ["local-taxi"],
    tags: ["Transportation + Road"],
    author: "Google",
    version: "1.5.54",
    path: "M5,11L6.5,6.5H17.5L19,11M17.5,16C16.67,16 16,15.33 16,14.5C16,13.67 16.67,13 17.5,13C18.33,13 19,13.67 19,14.5C19,15.33 18.33,16 17.5,16M6.5,16C5.67,16 5,15.33 5,14.5C5,13.67 5.67,13 6.5,13C7.33,13 8,13.67 8,14.5C8,15.33 7.33,16 6.5,16M18.92,6C18.72,5.42 18.16,5 17.5,5H15V3H9V5H6.5C5.84,5 5.28,5.42 5.08,6L3,12V20C3,20.55 3.45,21 4,21H5C5.55,21 6,20.55 6,20V19H18V20C18,20.55 18.45,21 19,21H20C20.55,21 21,20.55 21,20V12L18.92,6Z",
  },
  {
    id: "A989F68B-23B9-4B50-BE4D-E3DF6E9420C9",
    name: "teach",
    codepoint: "F88F",
    aliases: ["teacher", "teaching"],
    tags: [],
    author: "Michael Richins",
    version: "2.1.99",
    path: "M20,17C21.1,17 22,16.1 22,15V4C22,2.9 21.1,2 20,2H9.46C9.81,2.61 10,3.3 10,4H20V15H11V17M15,7V9H9V22H7V16H5V22H3V14H1.5V9C1.5,7.9 2.4,7 3.5,7H15M8,4C8,5.1 7.1,6 6,6C4.9,6 4,5.1 4,4C4,2.9 4.9,2 6,2C7.1,2 8,2.9 8,4Z",
  },
  {
    id: "3335C183-CD35-4D66-87AB-C5E3A7FCAFBF",
    name: "teamviewer",
    codepoint: "F500",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M19,3C20.1,3 21,3.9 21,5V19C21,20.11 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3H19M12,5C8.13,5 5,8.13 5,12C5,15.87 8.13,19 12,19C15.87,19 19,15.87 19,12C19,8.13 15.87,5 12,5M7,12L10,9V11H14V9L17,12L14,15V13H10V15L7,12Z",
  },
  {
    id: "47F1C290-ED78-4459-B33C-6E2ACC867CC6",
    name: "telegram",
    codepoint: "F501",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M9.78,18.65L10.06,14.42L17.74,7.5C18.08,7.19 17.67,7.04 17.22,7.31L7.74,13.3L3.64,12C2.76,11.75 2.75,11.14 3.84,10.7L19.81,4.54C20.54,4.21 21.24,4.72 20.96,5.84L18.24,18.65C18.05,19.56 17.5,19.78 16.74,19.36L12.6,16.3L10.61,18.23C10.38,18.46 10.19,18.65 9.78,18.65Z",
  },
  {
    id: "1B699A99-578E-450C-9523-934F4D281F72",
    name: "television",
    codepoint: "F502",
    aliases: ["tv"],
    tags: ["Device / Tech", "Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M21,17H3V5H21M21,3H3C1.9,3 1,3.9 1,5V17C1,18.1 1.9,19 3,19H8V21H16V19H21C22.1,19 23,18.1 23,17V5C23,3.9 22.1,3 21,3Z",
  },
  {
    id: "CB446614-AE63-403E-BBF8-0B0ED3E367AE",
    name: "television-box",
    codepoint: "F838",
    aliases: ["tv-box", "tv-guide"],
    tags: [],
    author: "Google",
    version: "2.1.19",
    path: "M5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3M16,16L19,8H16.5L15,12.5L13.5,8H5V10H8V16H10V10H11.77L14,16H16Z",
  },
  {
    id: "EB7FD483-EAF9-4FEE-8B82-25186D26827A",
    name: "television-classic",
    codepoint: "F7F3",
    aliases: ["tv-classic"],
    tags: ["Device / Tech", "Home Automation"],
    author: "GreenTurtwig",
    version: "2.0.46",
    path: "M8.16,3L6.75,4.41L9.34,7H4C2.89,7 2,7.89 2,9V19C2,20.11 2.89,21 4,21H20C21.11,21 22,20.11 22,19V9C22,7.89 21.11,7 20,7H14.66L17.25,4.41L15.84,3L12,6.84L8.16,3M4,9H17V19H4V9M19.5,9C20.05,9 20.5,9.45 20.5,10C20.5,10.55 20.05,11 19.5,11C18.95,11 18.5,10.55 18.5,10C18.5,9.45 18.95,9 19.5,9M19.5,12C20.05,12 20.5,12.45 20.5,13C20.5,13.55 20.05,14 19.5,14C18.95,14 18.5,13.55 18.5,13C18.5,12.45 18.95,12 19.5,12Z",
  },
  {
    id: "C8E89001-2566-4676-B12B-7AAFAFCA0276",
    name: "television-classic-off",
    codepoint: "F839",
    aliases: ["tv-classic-off"],
    tags: ["Device / Tech", "Home Automation"],
    author: "Austin Andrews",
    version: "2.1.19",
    path: "M2,5.27L3.28,4L21,21.72L19.73,23L17.73,21H4C2.89,21 2,20.11 2,19V9C2,8 2.76,7.14 3.75,7L2,5.27M8.16,3L12,6.84L15.84,3L17.25,4.41L14.66,7H20C21.11,7 22,7.89 22,9V19C22,19.34 21.92,19.66 21.77,19.94L17,15.18V9H10.82L8.82,7H9.34L6.75,4.41L8.16,3M4,9V19H15.73L5.73,9H4M19.5,9C18.95,9 18.5,9.45 18.5,10C18.5,10.55 18.95,11 19.5,11C20.05,11 20.5,10.55 20.5,10C20.5,9.45 20.05,9 19.5,9M19.5,12C18.95,12 18.5,12.45 18.5,13C18.5,13.55 18.95,14 19.5,14C20.05,14 20.5,13.55 20.5,13C20.5,12.45 20.05,12 19.5,12Z",
  },
  {
    id: "6E5CAF6F-F00B-4613-B520-BDC1E5DD2832",
    name: "television-guide",
    codepoint: "F503",
    aliases: [],
    tags: ["Device / Tech", "Home Automation"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M21,17V5H3V17H21M21,3C22.1,3 23,3.9 23,5V17C23,18.1 22.1,19 21,19H16V21H8V19H3C1.9,19 1,18.1 1,17V5C1,3.9 1.9,3 3,3H21M5,7H11V11H5V7M5,13H11V15H5V13M13,7H19V9H13V7M13,11H19V15H13V11Z",
  },
  {
    id: "9E9D949B-13EC-43FB-9068-2BED76224BD8",
    name: "television-off",
    codepoint: "F83A",
    aliases: ["tv-off"],
    tags: ["Device / Tech", "Home Automation"],
    author: "Austin Andrews",
    version: "2.1.19",
    path: "M0.5,2.77L1.78,1.5L21,20.72L19.73,22L16.73,19H16V21H8V19H3C1.9,19 1,18.1 1,17V5C1,4.5 1.17,4.07 1.46,3.73L0.5,2.77M21,17V5H7.82L5.82,3H21C22.1,3 23,3.9 23,5V17C23,17.85 22.45,18.59 21.7,18.87L19.82,17H21M3,17H14.73L3,5.27V17Z",
  },
  {
    id: "A94E333D-F8C5-4726-B81A-6DDF4CC37FD0",
    name: "temperature-celsius",
    codepoint: "F504",
    aliases: ["temperature-centigrade"],
    tags: ["Weather"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M16.5,5C18.05,5 19.5,5.47 20.69,6.28L19.53,9.17C18.73,8.44 17.67,8 16.5,8C14,8 12,10 12,12.5C12,15 14,17 16.5,17C17.53,17 18.47,16.66 19.23,16.08L20.37,18.93C19.24,19.61 17.92,20 16.5,20C12.36,20 9,16.64 9,12.5C9,8.36 12.36,5 16.5,5M6,3C7.66,3 9,4.34 9,6C9,7.66 7.66,9 6,9C4.34,9 3,7.66 3,6C3,4.34 4.34,3 6,3M6,5C5.45,5 5,5.45 5,6C5,6.55 5.45,7 6,7C6.55,7 7,6.55 7,6C7,5.45 6.55,5 6,5Z",
  },
  {
    id: "9A1DF8BB-627A-47C9-B609-BAC145D320DF",
    name: "temperature-fahrenheit",
    codepoint: "F505",
    aliases: [],
    tags: ["Weather"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M11,20V5H20V8H14V11H19V14H14V20H11M6,3C7.66,3 9,4.34 9,6C9,7.66 7.66,9 6,9C4.34,9 3,7.66 3,6C3,4.34 4.34,3 6,3M6,5C5.45,5 5,5.45 5,6C5,6.55 5.45,7 6,7C6.55,7 7,6.55 7,6C7,5.45 6.55,5 6,5Z",
  },
  {
    id: "DF9D47EE-157B-4E1E-85CE-A043E5F2AE51",
    name: "temperature-kelvin",
    codepoint: "F506",
    aliases: [],
    tags: ["Weather"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M7,5H10V11L15,5H19L13.88,10.78L19,20H15.38L11.76,13.17L10,15.15V20H7V5Z",
  },
  {
    id: "DE92B1F1-31FB-4551-84A2-32F5B5D842EC",
    name: "tennis",
    codepoint: "F507",
    aliases: [],
    tags: ["Sport"],
    author: "Google",
    version: "1.5.54",
    path: "M12,2C14.5,2 16.75,2.9 18.5,4.4C16.36,6.23 15,8.96 15,12C15,15.04 16.36,17.77 18.5,19.6C16.75,21.1 14.5,22 12,22C9.5,22 7.25,21.1 5.5,19.6C7.64,17.77 9,15.04 9,12C9,8.96 7.64,6.23 5.5,4.4C7.25,2.9 9.5,2 12,2M22,12C22,14.32 21.21,16.45 19.88,18.15C18.12,16.68 17,14.47 17,12C17,9.53 18.12,7.32 19.88,5.85C21.21,7.55 22,9.68 22,12M2,12C2,9.68 2.79,7.55 4.12,5.85C5.88,7.32 7,9.53 7,12C7,14.47 5.88,16.68 4.12,18.15C2.79,16.45 2,14.32 2,12Z",
  },
  {
    id: "688277DE-082A-4BE2-8E59-129245E02DD7",
    name: "tent",
    codepoint: "F508",
    aliases: ["camping"],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M4,6C4,7.19 4.39,8.27 5,9C3.34,9 2,7.66 2,6C2,4.34 3.34,3 5,3C4.39,3.73 4,4.81 4,6M2,21V19H4.76L12,4.78L19.24,19H22V21H2M12,9.19L7,19H17L12,9.19Z",
  },
  {
    id: "1F98A781-6023-4368-AC06-5A421D166FCC",
    name: "terrain",
    codepoint: "F509",
    aliases: [],
    tags: ["Nature"],
    author: "Google",
    version: "1.5.54",
    path: "M14,6L10.25,11L13.1,14.8L11.5,16C9.81,13.75 7,10 7,10L1,18H23L14,6Z",
  },
  {
    id: "0B88F54B-7522-4D7D-85EC-3C0C3E7D36FE",
    name: "test-tube",
    codepoint: "F668",
    aliases: [],
    tags: ["Science"],
    author: "Kai Faust",
    version: "1.6.50",
    path: "M7,2V4H8V18C8,20.21 9.79,22 12,22C14.21,22 16,20.21 16,18V4H17V2H7M11,16C10.4,16 10,15.6 10,15C10,14.4 10.4,14 11,14C11.6,14 12,14.4 12,15C12,15.6 11.6,16 11,16M13,12C12.4,12 12,11.6 12,11C12,10.4 12.4,10 13,10C13.6,10 14,10.4 14,11C14,11.6 13.6,12 13,12M14,7H10V4H14V7Z",
  },
  {
    id: "A6F17875-0B9B-467B-85F5-4C4804D3A367",
    name: "test-tube-empty",
    codepoint: "F910",
    aliases: [],
    tags: ["Science"],
    author: "Austin Andrews",
    version: "2.3.50",
    path: "M7,2H17V4H16V18C16,20.21 14.21,22 12,22C9.79,22 8,20.21 8,18V4H7V2M14,4H10V18C10,19.1 10.9,20 12,20C13.1,20 14,19.1 14,18V4Z",
  },
  {
    id: "8B2E6A86-9CC3-4F9B-8B77-F5DD9BAE7898",
    name: "test-tube-off",
    codepoint: "F911",
    aliases: [],
    tags: ["Science"],
    author: "Austin Andrews",
    version: "2.3.50",
    path: "M2,5.27L3.28,4L20,20.72L18.73,22L15.84,19.11C15.36,20.77 13.82,22 12,22C9.79,22 8,20.21 8,18V11.27L2,5.27M7,2H17V4H16V14.18L13.63,11.81C13.86,11.63 14,11.35 14,11C14,10.4 13.6,10 13,10C12.65,10 12.37,10.14 12.19,10.37L8,6.18V4H7V2M11,16C11.5,16 11.88,15.71 12,15.24L10.76,14C10.29,14.12 10,14.5 10,15C10,15.6 10.4,16 11,16M14,7V4H10V7H14Z",
  },
  {
    id: "E56EAB24-6D70-49E0-BEC8-D9164A93CB63",
    name: "text",
    codepoint: "F9A7",
    aliases: ["notes"],
    tags: [],
    author: "Google",
    version: "2.4.85",
    path: "M21,6V8H3V6H21M3,18H12V16H3V18M3,13H21V11H3V13Z",
  },
  {
    id: "4595BB97-16B7-4B19-8AC5-9C33167A6D20",
    name: "text-shadow",
    codepoint: "F669",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.6.50",
    path: "M3,3H16V6H11V18H8V6H3V3M12,7H14V9H12V7M15,7H17V9H15V7M18,7H20V9H18V7M12,10H14V12H12V10M12,13H14V15H12V13M12,16H14V18H12V16M12,19H14V21H12V19Z",
  },
  {
    id: "F80F249A-898B-4690-888A-EC11F79B4E56",
    name: "text-short",
    codepoint: "F9A8",
    aliases: [],
    tags: [],
    author: "Google",
    version: "2.4.85",
    path: "M4,9H20V11H4V9M4,13H14V15H4V13Z",
  },
  {
    id: "CA8CE1CF-1F6E-4B8B-9972-B3F36E865E67",
    name: "text-subject",
    codepoint: "F9A9",
    aliases: [],
    tags: [],
    author: "Google",
    version: "2.4.85",
    path: "M4,5H20V7H4V5M4,9H20V11H4V9M4,13H20V15H4V13M4,17H14V19H4V17Z",
  },
  {
    id: "5B1FA77D-0384-4931-AFD8-C4FF5D73D372",
    name: "text-to-speech",
    codepoint: "F50A",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M8,7C9.1,7 10,7.9 10,9V14C10,15.1 9.1,16 8,16C6.9,16 6,15.1 6,14V9C6,7.9 6.9,7 8,7M14,14C14,16.97 11.84,19.44 9,19.92V22H7V19.92C4.16,19.44 2,16.97 2,14H4C4,16.21 5.79,18 8,18C10.21,18 12,16.21 12,14H14M21.41,9.41L17.17,13.66L18.18,10H14C12.9,10 12,9.1 12,8V4C12,2.9 12.9,2 14,2H20C21.1,2 22,2.9 22,4V8C22,8.55 21.78,9.05 21.41,9.41Z",
  },
  {
    id: "1AE8F7A9-5454-44D2-B16D-1D383E33978D",
    name: "text-to-speech-off",
    codepoint: "F50B",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M2,5.27L3.28,4L20,20.72L18.73,22L13.38,16.65C12.55,18.35 10.93,19.59 9,19.92V22H7V19.92C4.16,19.44 2,16.97 2,14H4C4,16.21 5.79,18 8,18C9.82,18 11.36,16.78 11.84,15.11L10,13.27V14C10,15.1 9.1,16 8,16C6.9,16 6,15.1 6,14V9.27L2,5.27M21.41,9.41L17.17,13.66L18.18,10H14C12.9,10 12,9.1 12,8V4C12,2.9 12.9,2 14,2H20C21.1,2 22,2.9 22,4V8C22,8.55 21.78,9.05 21.41,9.41Z",
  },
  {
    id: "E3A06403-51B5-4D00-9349-53517553A324",
    name: "texture",
    codepoint: "F50C",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M9.29,21H12.12L21,12.12V9.29M19,21C19.55,21 20.05,20.78 20.41,20.41C20.78,20.05 21,19.55 21,19V17L17,21M5,3C3.9,3 3,3.9 3,5V7L7,3M11.88,3L3,11.88V14.71L14.71,3M19.5,3.08L3.08,19.5C3.17,19.85 3.35,20.16 3.59,20.41C3.84,20.65 4.15,20.83 4.5,20.92L20.93,4.5C20.74,3.8 20.2,3.26 19.5,3.08Z",
  },
  {
    id: "37350655-CB4D-4D9F-8C90-B8049CA0E48E",
    name: "theater",
    codepoint: "F50D",
    aliases: ["cinema", "theatre"],
    tags: ["Places"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M4,15H6C7.1,15 8,15.9 8,17V19H9V17C9,15.9 9.9,15 11,15H13C14.1,15 15,15.9 15,17V19H16V17C16,15.9 16.9,15 18,15H20C21.1,15 22,15.9 22,17V19H23V22H1V19H2V17C2,15.9 2.9,15 4,15M11,7L15,10L11,13V7M4,2H20C21.1,2 22,2.9 22,4V13.54C21.41,13.19 20.73,13 20,13V4H4V13C3.27,13 2.59,13.19 2,13.54V4C2,2.9 2.9,2 4,2Z",
  },
  {
    id: "AE66BEF4-7040-4A15-8BF3-639B116853CC",
    name: "theme-light-dark",
    codepoint: "F50E",
    aliases: ["sun-moon-stars"],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M7.5,2C5.71,3.15 4.5,5.18 4.5,7.5C4.5,9.82 5.71,11.85 7.53,13C4.46,13 2,10.54 2,7.5C2,4.46 4.46,2 7.5,2M19.07,3.5L20.5,4.93L4.93,20.5L3.5,19.07L19.07,3.5M12.89,5.93L11.41,5L9.97,6L10.39,4.3L9,3.24L10.75,3.12L11.33,1.47L12,3.1L13.73,3.13L12.38,4.26L12.89,5.93M9.59,9.54L8.43,8.81L7.31,9.59L7.65,8.27L6.56,7.44L7.92,7.35L8.37,6.06L8.88,7.33L10.24,7.36L9.19,8.23L9.59,9.54M19,13.5C19,16.54 16.54,19 13.5,19C12.28,19 11.15,18.6 10.24,17.93L17.93,10.24C18.6,11.15 19,12.28 19,13.5M14.6,20.08L17.37,18.93L17.13,22.28L14.6,20.08M18.93,17.38L20.08,14.61L22.28,17.15L18.93,17.38M20.08,12.42L18.94,9.64L22.28,9.88L20.08,12.42M9.63,18.93L12.4,20.08L9.87,22.27L9.63,18.93Z",
  },
  {
    id: "F41863ED-B66A-4FF4-B436-0876C8D3665B",
    name: "thermometer",
    codepoint: "F50F",
    aliases: [],
    tags: ["Weather", "Home Automation"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M17,17C17,19.76 14.76,22 12,22C9.24,22 7,19.76 7,17C7,15.36 7.79,13.91 9,13V5C9,3.34 10.34,2 12,2C13.66,2 15,3.34 15,5V13C16.21,13.91 17,15.36 17,17M11,8V14.17C9.83,14.58 9,15.69 9,17C9,18.66 10.34,20 12,20C13.66,20 15,18.66 15,17C15,15.69 14.17,14.58 13,14.17V8H11Z",
  },
  {
    id: "A9FC898C-8CC5-44F2-822D-05C5625E95C8",
    name: "thermometer-lines",
    codepoint: "F510",
    aliases: [],
    tags: ["Weather"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M17,3H21V5H17V3M17,7H21V9H17V7M17,11H21V13H17.75L17,12.1V11M21,15V17H19C19,16.31 18.9,15.63 18.71,15H21M17,17C17,19.76 14.76,22 12,22C9.24,22 7,19.76 7,17C7,15.36 7.79,13.91 9,13V5C9,3.34 10.34,2 12,2C13.66,2 15,3.34 15,5V13C16.21,13.91 17,15.36 17,17M11,8V14.17C9.83,14.58 9,15.69 9,17C9,18.66 10.34,20 12,20C13.66,20 15,18.66 15,17C15,15.69 14.17,14.58 13,14.17V8H11M7,3V5H3V3H7M7,7V9H3V7H7M7,11V12.1L6.25,13H3V11H7M3,15H5.29C5.1,15.63 5,16.31 5,17H3V15Z",
  },
  {
    id: "628D16E2-7E57-43CA-8451-012B8AB852DA",
    name: "thermostat",
    codepoint: "F393",
    aliases: ["nest"],
    tags: ["Device / Tech", "Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M16.95,16.95L14.83,14.83C15.55,14.1 16,13.1 16,12C16,11.26 15.79,10.57 15.43,10L17.6,7.81C18.5,9 19,10.43 19,12C19,13.93 18.22,15.68 16.95,16.95M12,5C13.57,5 15,5.5 16.19,6.4L14,8.56C13.43,8.21 12.74,8 12,8C9.79,8 8,9.79 8,12C8,13.1 8.45,14.1 9.17,14.83L7.05,16.95C5.78,15.68 5,13.93 5,12C5,8.13 8.13,5 12,5M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.47 17.5,2 12,2Z",
  },
  {
    id: "E0A6898F-3F08-4E13-8B61-DA63E5CBF949",
    name: "thermostat-box",
    codepoint: "F890",
    aliases: [],
    tags: ["Home Automation"],
    author: "GreenTurtwig",
    version: "2.1.99",
    path: "M5,3C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3H5M12,5C13.57,5 15,5.5 16.19,6.4L14,8.56C13.43,8.21 12.74,8 12,8C9.79,8 8,9.79 8,12C8,13.1 8.45,14.1 9.17,14.83L7.05,16.95C5.78,15.68 5,13.93 5,12C5,8.13 8.13,5 12,5M17.6,7.81C18.5,9 19,10.43 19,12C19,13.93 18.22,15.68 16.95,16.95L14.83,14.83C15.55,14.1 16,13.1 16,12C16,11.26 15.79,10.57 15.43,10L17.6,7.81Z",
  },
  {
    id: "46ACA864-4B1C-4DBD-94FB-7A0D6B9A500E",
    name: "thought-bubble",
    codepoint: "F7F5",
    aliases: ["comic-bubble"],
    tags: [],
    author: "Austin Andrews",
    version: "2.0.46",
    path: "M3.5,19C4.33,19 5,19.67 5,20.5C5,21.33 4.33,22 3.5,22C2.67,22 2,21.33 2,20.5C2,19.67 2.67,19 3.5,19M8.5,16C9.88,16 11,17.12 11,18.5C11,19.88 9.88,21 8.5,21C7.12,21 6,19.88 6,18.5C6,17.12 7.12,16 8.5,16M14.5,15C13.31,15 12.23,14.5 11.5,13.65C10.77,14.5 9.69,15 8.5,15C6.54,15 4.91,13.59 4.57,11.74C3.07,11.16 2,9.7 2,8C2,5.79 3.79,4 6,4C6.26,4 6.5,4.03 6.77,4.07C7.5,3.41 8.45,3 9.5,3C10.69,3 11.77,3.5 12.5,4.35C13.23,3.5 14.31,3 15.5,3C17.46,3 19.09,4.41 19.43,6.26C20.93,6.84 22,8.3 22,10C22,12.21 20.21,14 18,14L17.23,13.93C16.5,14.59 15.55,15 14.5,15Z",
  },
  {
    id: "2C82E0CA-9872-431C-8739-0EA33825EBF7",
    name: "thought-bubble-outline",
    codepoint: "F7F6",
    aliases: ["comic-thought-bubble-outline"],
    tags: [],
    author: "Austin Andrews",
    version: "2.0.46",
    path: "M3.5,19C4.33,19 5,19.67 5,20.5C5,21.33 4.33,22 3.5,22C2.67,22 2,21.33 2,20.5C2,19.67 2.67,19 3.5,19M8.5,16C9.88,16 11,17.12 11,18.5C11,19.88 9.88,21 8.5,21C7.12,21 6,19.88 6,18.5C6,17.12 7.12,16 8.5,16M14.5,15C13.31,15 12.23,14.5 11.5,13.65C10.77,14.5 9.69,15 8.5,15C6.54,15 4.91,13.59 4.57,11.74C3.07,11.16 2,9.7 2,8C2,5.79 3.79,4 6,4L6.77,4.07C7.5,3.41 8.45,3 9.5,3C10.69,3 11.77,3.5 12.5,4.35C13.23,3.5 14.31,3 15.5,3C17.46,3 19.09,4.41 19.43,6.26C20.93,6.84 22,8.3 22,10C22,12.21 20.21,14 18,14L17.23,13.93C16.5,14.59 15.55,15 14.5,15M6,6C4.9,6 4,6.9 4,8C4,9.1 4.9,10 6,10C6.33,10 6.64,9.92 6.92,9.78C6.66,10.12 6.5,10.54 6.5,11C6.5,12.1 7.4,13 8.5,13C9.1,13 9.64,12.73 10,12.31V12.31L11.47,10.63L13,12.34V12.34C13.38,12.74 13.91,13 14.5,13C15.5,13 16.33,12.26 16.5,11.3C16.84,11.73 17.39,12 18,12C19.1,12 20,11.1 20,10C20,8.9 19.1,8 18,8C17.67,8 17.36,8.08 17.08,8.22C17.34,7.88 17.5,7.46 17.5,7C17.5,5.9 16.6,5 15.5,5C14.91,5 14.38,5.26 14,5.66L12.47,7.37L11,5.69V5.69C10.64,5.27 10.1,5 9.5,5C8.5,5 7.67,5.74 7.5,6.7C7.16,6.27 6.61,6 6,6M8.5,17.5C7.95,17.5 7.5,17.95 7.5,18.5C7.5,19.05 7.95,19.5 8.5,19.5C9.05,19.5 9.5,19.05 9.5,18.5C9.5,17.95 9.05,17.5 8.5,17.5Z",
  },
  {
    id: "83D606E3-69A1-4583-854D-5C44477D038D",
    name: "thumb-down",
    codepoint: "F511",
    aliases: ["dislike", "thumbs-down"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M19,15H23V3H19M15,3H6C5.17,3 4.46,3.5 4.16,4.22L1.14,11.27C1.05,11.5 1,11.74 1,12V14C1,15.1 1.9,16 3,16H9.31L8.36,20.57C8.34,20.67 8.33,20.77 8.33,20.88C8.33,21.3 8.5,21.67 8.77,21.94L9.83,23L16.41,16.41C16.78,16.05 17,15.55 17,15V5C17,3.89 16.1,3 15,3Z",
  },
  {
    id: "00EE8027-00FE-43B8-ACEC-7779E39D6E29",
    name: "thumb-down-outline",
    codepoint: "F512",
    aliases: ["dislike-outline", "thumbs-down-outline"],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M19,15V3H23V15H19M15,3C16.1,3 17,3.9 17,5V15C17,15.55 16.78,16.05 16.41,16.41L9.83,23L8.77,21.94C8.5,21.67 8.33,21.3 8.33,20.88L8.36,20.57L9.31,16H3C1.89,16 1,15.1 1,14V12C1,11.74 1.05,11.5 1.14,11.27L4.16,4.22C4.46,3.5 5.17,3 6,3H15M15,5H5.97L3,12V14H11.78L10.65,19.32L15,14.97V5Z",
  },
  {
    id: "C32E4FC9-F3DC-4C67-81FB-62648E3F1AB5",
    name: "thumb-up",
    codepoint: "F513",
    aliases: ["like", "thumbs-up"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M23,10C23,8.89 22.1,8 21,8H14.68L15.64,3.43C15.66,3.33 15.67,3.22 15.67,3.11C15.67,2.7 15.5,2.32 15.23,2.05L14.17,1L7.59,7.58C7.22,7.95 7,8.45 7,9V19C7,20.1 7.9,21 9,21H18C18.83,21 19.54,20.5 19.84,19.78L22.86,12.73C22.95,12.5 23,12.26 23,12V10M1,21H5V9H1V21Z",
  },
  {
    id: "BFA3B3A3-0D00-459A-8BDB-DAC2D4233023",
    name: "thumb-up-outline",
    codepoint: "F514",
    aliases: ["like-outline", "thumbs-up-outline"],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M5,9V21H1V9H5M9,21C7.9,21 7,20.1 7,19V9C7,8.45 7.22,7.95 7.59,7.59L14.17,1L15.23,2.06C15.5,2.33 15.67,2.7 15.67,3.11L15.64,3.43L14.69,8H21C22.11,8 23,8.9 23,10V12C23,12.26 22.95,12.5 22.86,12.73L19.84,19.78C19.54,20.5 18.83,21 18,21H9M9,19H18.03L21,12V10H12.21L13.34,4.68L9,9.03V19Z",
  },
  {
    id: "C38D6CEC-4D8E-44DB-B704-9A76552733D4",
    name: "thumbs-up-down",
    codepoint: "F515",
    aliases: ["like-dislike"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M22.5,10H15.75C15.13,10 14.6,10.38 14.37,10.91L12.11,16.2C12.04,16.37 12,16.56 12,16.75V18C12,18.55 12.45,19 13,19H18.18L17.5,22.18V22.42C17.5,22.73 17.63,23 17.83,23.22L18.62,24L23.56,19.06C23.83,18.79 24,18.41 24,18V11.5C24,10.67 23.33,10 22.5,10M12,6C12,5.45 11.55,5 11,5H5.82L6.5,1.82V1.59C6.5,1.28 6.37,1 6.17,0.79L5.38,0L0.44,4.94C0.17,5.21 0,5.59 0,6V12.5C0,13.33 0.67,14 1.5,14H8.25C8.87,14 9.4,13.62 9.63,13.09L11.89,7.8C11.96,7.63 12,7.44 12,7.25V6Z",
  },
  {
    id: "18F55984-07FD-4630-BB11-8285F83AA838",
    name: "ticket",
    codepoint: "F516",
    aliases: ["local-activity", "local-play", "local-attraction"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M15.58,16.8L12,14.5L8.42,16.8L9.5,12.68L6.21,10L10.46,9.74L12,5.8L13.54,9.74L17.79,10L14.5,12.68M20,12C20,10.89 20.9,10 22,10V6C22,4.89 21.1,4 20,4H4C2.9,4 2,4.9 2,6V10C3.11,10 4,10.9 4,12C4,13.1 3.1,14 2,14V18C2,19.1 2.9,20 4,20H20C21.1,20 22,19.1 22,18V14C20.9,14 20,13.1 20,12Z",
  },
  {
    id: "DE2E8A6C-33F1-4148-A228-C512C26B3159",
    name: "ticket-account",
    codepoint: "F517",
    aliases: ["ticket-user"],
    tags: ["Account / User"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M20,12C20,13.1 20.9,14 22,14V18C22,19.1 21.1,20 20,20H4C2.9,20 2,19.1 2,18V14C3.11,14 4,13.1 4,12C4,10.9 3.1,10 2,10V6C2,4.89 2.9,4 4,4H20C21.1,4 22,4.9 22,6V10C20.9,10 20,10.9 20,12M16.5,16.25C16.5,14.75 13.5,14 12,14C10.5,14 7.5,14.75 7.5,16.25V17H16.5V16.25M12,12.25C13.24,12.25 14.25,11.24 14.25,10C14.25,8.76 13.24,7.75 12,7.75C10.76,7.75 9.75,8.76 9.75,10C9.75,11.24 10.76,12.25 12,12.25Z",
  },
  {
    id: "F19DA1EC-CBDA-456E-BC19-F03C635C886F",
    name: "ticket-confirmation",
    codepoint: "F518",
    aliases: ["confirmation-number"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M13,8.5H11V6.5H13V8.5M13,13H11V11H13V13M13,17.5H11V15.5H13V17.5M22,10V6C22,4.89 21.1,4 20,4H4C2.9,4 2,4.9 2,6V10C3.11,10 4,10.9 4,12C4,13.1 3.1,14 2,14V18C2,19.1 2.9,20 4,20H20C21.1,20 22,19.1 22,18V14C20.9,14 20,13.1 20,12C20,10.9 20.9,10 22,10Z",
  },
  {
    id: "6D7F0E99-A86F-4AAB-A468-F1D3214E1B60",
    name: "ticket-outline",
    codepoint: "F912",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "2.3.50",
    path: "M4,4C2.9,4 2,4.9 2,6V10C3.1,10 4,10.9 4,12C4,13.1 3.1,14 2,14V18C2,19.1 2.9,20 4,20H20C21.1,20 22,19.1 22,18V14C20.9,14 20,13.1 20,12C20,10.9 20.9,10 22,10V6C22,4.9 21.1,4 20,4H4M4,6H20V8.54C18.76,9.25 18,10.57 18,12C18,13.43 18.76,14.75 20,15.46V18H4V15.46C5.24,14.75 6,13.43 6,12C6,10.57 5.24,9.25 4,8.54V6Z",
  },
  {
    id: "297864D0-935F-4EF0-9A2C-28F018544581",
    name: "ticket-percent",
    codepoint: "F723",
    aliases: ["coupon", "voucher"],
    tags: [],
    author: "GreenTurtwig",
    version: "1.8.36",
    path: "M4,4C2.9,4 2,4.9 2,6V10C3.11,10 4,10.9 4,12C4,13.1 3.1,14 2,14V18C2,19.1 2.9,20 4,20H20C21.1,20 22,19.1 22,18V14C20.9,14 20,13.1 20,12C20,10.89 20.9,10 22,10V6C22,4.89 21.1,4 20,4H4M15.5,7L17,8.5L8.5,17L7,15.5L15.5,7M8.81,7.04C9.79,7.04 10.58,7.83 10.58,8.81C10.58,9.79 9.79,10.58 8.81,10.58C7.83,10.58 7.04,9.79 7.04,8.81C7.04,7.83 7.83,7.04 8.81,7.04M15.19,13.42C16.17,13.42 16.96,14.21 16.96,15.19C16.96,16.17 16.17,16.96 15.19,16.96C14.21,16.96 13.42,16.17 13.42,15.19C13.42,14.21 14.21,13.42 15.19,13.42Z",
  },
  {
    id: "475062F1-407D-43B6-8FBF-1E0D4C7D690C",
    name: "tie",
    codepoint: "F519",
    aliases: [],
    tags: ["Clothing"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M6,2L10,6L7,17L12,22L17,17L14,6L18,2Z",
  },
  {
    id: "708986EE-2BC9-401D-8ACD-0BC5A3E20EA3",
    name: "tilde",
    codepoint: "F724",
    aliases: [],
    tags: [],
    author: "Michael Irigoyen",
    version: "1.8.36",
    path: "M2,15C2,15 2,9 8,9C12,9 12.5,12.5 15.5,12.5C19.5,12.5 19.5,9 19.5,9H22C22,9 22,15 16,15C12,15 10.5,11.5 8.5,11.5C4.5,11.5 4.5,15 4.5,15H2",
  },
  {
    id: "348DB89A-B4E2-4CB9-A7A4-B86973243ADE",
    name: "timelapse",
    codepoint: "F51A",
    aliases: [],
    tags: ["Date / Time"],
    author: "Google",
    version: "1.5.54",
    path: "M12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M16.24,7.76C15.07,6.58 13.53,6 12,6V12L7.76,16.24C10.1,18.58 13.9,18.58 16.24,16.24C18.59,13.9 18.59,10.1 16.24,7.76Z",
  },
  {
    id: "017E0965-CD2E-4B39-B0C5-410335848B12",
    name: "timer",
    codepoint: "F51B",
    aliases: ["stopwatch"],
    tags: ["Date / Time"],
    author: "Google",
    version: "1.5.54",
    path: "M12,20C8.13,20 5,16.87 5,13C5,9.13 8.13,6 12,6C15.87,6 19,9.13 19,13C19,16.87 15.87,20 12,20M19.03,7.39L20.45,5.97C20,5.46 19.55,5 19.04,4.56L17.62,6C16.07,4.74 14.12,4 12,4C7.03,4 3,8.03 3,13C3,17.97 7.03,22 12,22C17,22 21,17.97 21,13C21,10.88 20.26,8.93 19.03,7.39M11,14H13V8H11M15,1H9V3H15V1Z",
  },
  {
    id: "BDC89918-A38F-41C6-997E-DE9F779D4435",
    name: "timer-10",
    codepoint: "F51C",
    aliases: ["timer-ten"],
    tags: ["Date / Time"],
    author: "Google",
    version: "1.5.54",
    path: "M12.9,13.22C12.9,13.82 12.86,14.33 12.78,14.75C12.7,15.17 12.58,15.5 12.42,15.77C12.26,16.03 12.06,16.22 11.83,16.34C11.6,16.46 11.32,16.5 11,16.5C10.71,16.5 10.43,16.46 10.19,16.34C9.95,16.22 9.75,16.03 9.59,15.77C9.43,15.5 9.3,15.17 9.21,14.75C9.12,14.33 9.08,13.82 9.08,13.22V10.72C9.08,10.12 9.12,9.61 9.21,9.2C9.3,8.79 9.42,8.46 9.59,8.2C9.75,7.95 9.95,7.77 10.19,7.65C10.43,7.54 10.7,7.5 11,7.5C11.31,7.5 11.58,7.54 11.81,7.65C12.05,7.76 12.25,7.94 12.41,8.2C12.57,8.45 12.7,8.78 12.78,9.19C12.86,9.6 12.91,10.11 12.91,10.71V13.22M13.82,7.05C13.5,6.65 13.07,6.35 12.59,6.17C12.12,6 11.58,5.9 11,5.9C10.42,5.9 9.89,6 9.41,6.17C8.93,6.35 8.5,6.64 8.18,7.05C7.84,7.46 7.58,8 7.39,8.64C7.21,9.29 7.11,10.09 7.11,11.03V12.95C7.11,13.89 7.2,14.69 7.39,15.34C7.58,16 7.84,16.53 8.19,16.94C8.53,17.35 8.94,17.65 9.42,17.83C9.9,18 10.43,18.11 11,18.11C11.6,18.11 12.13,18 12.6,17.83C13.08,17.65 13.5,17.35 13.82,16.94C14.16,16.53 14.42,16 14.6,15.34C14.78,14.69 14.88,13.89 14.88,12.95V11.03C14.88,10.09 14.79,9.29 14.6,8.64C14.42,8 14.16,7.45 13.82,7.05M23.78,14.37C23.64,14.09 23.43,13.84 23.15,13.63C22.87,13.42 22.54,13.24 22.14,13.1C21.74,12.96 21.29,12.83 20.79,12.72C20.44,12.65 20.15,12.57 19.92,12.5C19.69,12.41 19.5,12.33 19.37,12.24C19.23,12.15 19.14,12.05 19.09,11.94C19.04,11.83 19,11.7 19,11.55C19,11.41 19.04,11.27 19.1,11.14C19.16,11 19.25,10.89 19.37,10.8C19.5,10.7 19.64,10.62 19.82,10.56C20,10.5 20.22,10.47 20.46,10.47C20.71,10.47 20.93,10.5 21.12,10.58C21.31,10.65 21.47,10.75 21.6,10.87C21.73,11 21.82,11.13 21.89,11.29C21.95,11.45 22,11.61 22,11.78H23.94C23.94,11.39 23.86,11.03 23.7,10.69C23.54,10.35 23.31,10.06 23,9.81C22.71,9.56 22.35,9.37 21.92,9.22C21.5,9.07 21,9 20.46,9C19.95,9 19.5,9.07 19.07,9.21C18.66,9.35 18.3,9.54 18,9.78C17.72,10 17.5,10.3 17.34,10.62C17.18,10.94 17.11,11.27 17.11,11.63C17.11,12 17.19,12.32 17.34,12.59C17.5,12.87 17.7,13.11 18,13.32C18.25,13.53 18.58,13.7 18.96,13.85C19.34,14 19.77,14.11 20.23,14.21C20.62,14.29 20.94,14.38 21.18,14.47C21.42,14.56 21.61,14.66 21.75,14.76C21.88,14.86 21.97,15 22,15.1C22.07,15.22 22.09,15.35 22.09,15.5C22.09,15.81 21.96,16.06 21.69,16.26C21.42,16.46 21.03,16.55 20.5,16.55C20.3,16.55 20.09,16.53 19.88,16.47C19.67,16.42 19.5,16.34 19.32,16.23C19.15,16.12 19,15.97 18.91,15.79C18.8,15.61 18.74,15.38 18.73,15.12H16.84C16.84,15.5 16.92,15.83 17.08,16.17C17.24,16.5 17.47,16.82 17.78,17.1C18.09,17.37 18.47,17.59 18.93,17.76C19.39,17.93 19.91,18 20.5,18C21.04,18 21.5,17.95 21.95,17.82C22.38,17.69 22.75,17.5 23.06,17.28C23.37,17.05 23.6,16.77 23.77,16.45C23.94,16.13 24,15.78 24,15.39C24,15 23.93,14.65 23.78,14.37M0,7.72V9.4L3,8.4V18H5V6H4.75L0,7.72Z",
  },
  {
    id: "3DEFEFB6-57CE-4C82-9D0C-16DBDBEF5950",
    name: "timer-3",
    codepoint: "F51D",
    aliases: ["timer-three"],
    tags: ["Date / Time"],
    author: "Google",
    version: "1.5.54",
    path: "M20.87,14.37C20.73,14.09 20.5,13.84 20.24,13.63C19.96,13.42 19.63,13.24 19.23,13.1C18.83,12.96 18.38,12.83 17.88,12.72C17.53,12.65 17.24,12.57 17,12.5C16.78,12.41 16.6,12.33 16.46,12.24C16.32,12.15 16.23,12.05 16.18,11.94C16.13,11.83 16.1,11.7 16.1,11.55C16.1,11.4 16.13,11.27 16.19,11.14C16.25,11 16.34,10.89 16.46,10.8C16.58,10.7 16.73,10.62 16.91,10.56C17.09,10.5 17.31,10.47 17.55,10.47C17.8,10.47 18,10.5 18.21,10.58C18.4,10.65 18.56,10.75 18.69,10.87C18.82,11 18.91,11.13 19,11.29C19.04,11.45 19.08,11.61 19.08,11.78H21.03C21.03,11.39 20.95,11.03 20.79,10.69C20.63,10.35 20.4,10.06 20.1,9.81C19.8,9.56 19.44,9.37 19,9.22C18.58,9.07 18.09,9 17.55,9C17.04,9 16.57,9.07 16.16,9.21C15.75,9.35 15.39,9.54 15.1,9.78C14.81,10 14.59,10.3 14.43,10.62C14.27,10.94 14.2,11.27 14.2,11.63C14.2,12 14.28,12.31 14.43,12.59C14.58,12.87 14.8,13.11 15.07,13.32C15.34,13.53 15.67,13.7 16.05,13.85C16.43,14 16.86,14.11 17.32,14.21C17.71,14.29 18.03,14.38 18.27,14.47C18.5,14.56 18.7,14.66 18.84,14.76C18.97,14.86 19.06,15 19.11,15.1C19.16,15.22 19.18,15.35 19.18,15.5C19.18,15.81 19.05,16.06 18.78,16.26C18.5,16.46 18.12,16.55 17.61,16.55C17.39,16.55 17.18,16.53 16.97,16.47C16.76,16.42 16.57,16.34 16.41,16.23C16.24,16.12 16.11,15.97 16,15.79C15.89,15.61 15.83,15.38 15.82,15.12H13.93C13.93,15.5 14,15.83 14.17,16.17C14.33,16.5 14.56,16.82 14.87,17.1C15.18,17.37 15.56,17.59 16,17.76C16.5,17.93 17,18 17.6,18C18.13,18 18.61,17.95 19.04,17.82C19.47,17.69 19.84,17.5 20.15,17.28C20.46,17.05 20.69,16.77 20.86,16.45C21.03,16.13 21.11,15.78 21.11,15.39C21.09,15 21,14.65 20.87,14.37M11.61,12.97C11.45,12.73 11.25,12.5 11,12.32C10.74,12.13 10.43,11.97 10.06,11.84C10.36,11.7 10.63,11.54 10.86,11.34C11.09,11.14 11.28,10.93 11.43,10.7C11.58,10.47 11.7,10.24 11.77,10C11.85,9.75 11.88,9.5 11.88,9.26C11.88,8.71 11.79,8.22 11.6,7.8C11.42,7.38 11.16,7.03 10.82,6.74C10.5,6.46 10.09,6.24 9.62,6.1C9.17,5.97 8.65,5.9 8.09,5.9C7.54,5.9 7.03,6 6.57,6.14C6.1,6.31 5.7,6.54 5.37,6.83C5.04,7.12 4.77,7.46 4.59,7.86C4.39,8.25 4.3,8.69 4.3,9.15H6.28C6.28,8.89 6.33,8.66 6.42,8.46C6.5,8.26 6.64,8.08 6.8,7.94C6.97,7.8 7.16,7.69 7.38,7.61C7.6,7.53 7.84,7.5 8.11,7.5C8.72,7.5 9.17,7.65 9.47,7.96C9.77,8.27 9.91,8.71 9.91,9.28C9.91,9.55 9.87,9.8 9.79,10C9.71,10.24 9.58,10.43 9.41,10.59C9.24,10.75 9.03,10.87 8.78,10.96C8.53,11.05 8.23,11.09 7.89,11.09H6.72V12.66H7.9C8.24,12.66 8.54,12.7 8.81,12.77C9.08,12.85 9.31,12.96 9.5,13.12C9.69,13.28 9.84,13.5 9.94,13.73C10.04,13.97 10.1,14.27 10.1,14.6C10.1,15.22 9.92,15.69 9.57,16C9.22,16.35 8.73,16.5 8.12,16.5C7.83,16.5 7.56,16.47 7.32,16.38C7.08,16.3 6.88,16.18 6.71,16C6.54,15.86 6.41,15.68 6.32,15.46C6.23,15.24 6.18,15 6.18,14.74H4.19C4.19,15.29 4.3,15.77 4.5,16.19C4.72,16.61 5,16.96 5.37,17.24C5.73,17.5 6.14,17.73 6.61,17.87C7.08,18 7.57,18.08 8.09,18.08C8.66,18.08 9.18,18 9.67,17.85C10.16,17.7 10.58,17.47 10.93,17.17C11.29,16.87 11.57,16.5 11.77,16.07C11.97,15.64 12.07,15.14 12.07,14.59C12.07,14.3 12.03,14 11.96,13.73C11.88,13.5 11.77,13.22 11.61,12.97Z",
  },
  {
    id: "BE74C70B-7E47-4E25-957C-C83CFEB73D6D",
    name: "timer-off",
    codepoint: "F51E",
    aliases: ["stopwatch-off"],
    tags: ["Date / Time"],
    author: "Google",
    version: "1.5.54",
    path: "M12,20C8.13,20 5,16.87 5,13C5,11.72 5.35,10.5 5.95,9.5L15.5,19.04C14.5,19.65 13.28,20 12,20M3,4L1.75,5.27L4.5,8.03C3.55,9.45 3,11.16 3,13C3,17.97 7.03,22 12,22C13.84,22 15.55,21.45 17,20.5L19.5,23L20.75,21.73L13.04,14L3,4M11,9.44L13,11.44V8H11M15,1H9V3H15M19.04,4.55L17.62,5.97C16.07,4.74 14.12,4 12,4C10.17,4 8.47,4.55 7.05,5.5L8.5,6.94C9.53,6.35 10.73,6 12,6C15.87,6 19,9.13 19,13C19,14.27 18.65,15.47 18.06,16.5L19.5,17.94C20.45,16.53 21,14.83 21,13C21,10.88 20.26,8.93 19.03,7.39L20.45,5.97L19.04,4.55Z",
  },
  {
    id: "64EFBA89-F8CB-4193-8656-A83CCBC66A76",
    name: "timer-sand",
    codepoint: "F51F",
    aliases: ["hourglass"],
    tags: ["Date / Time"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M6,2H18V8H18V8L14,12L18,16V16H18V22H6V16H6V16L10,12L6,8V8H6V2M16,16.5L12,12.5L8,16.5V20H16V16.5M12,11.5L16,7.5V4H8V7.5L12,11.5M10,6H14V6.75L12,8.75L10,6.75V6Z",
  },
  {
    id: "DD31FFF2-A93B-41F5-BA6C-1732E8A8DEFF",
    name: "timer-sand-empty",
    codepoint: "F6AC",
    aliases: ["hourglass-empty"],
    tags: ["Date / Time"],
    author: "Google",
    version: "1.7.12",
    path: "M6,2V8H6V8L10,12L6,16V16H6V22H18V16H18V16L14,12L18,8V8H18V2H6M16,16.5V20H8V16.5L12,12.5L16,16.5M12,11.5L8,7.5V4H16V7.5L12,11.5Z",
  },
  {
    id: "E603301B-7DF4-43C2-9035-0DDB2A50B88E",
    name: "timer-sand-full",
    codepoint: "F78B",
    aliases: ["hourglass-full"],
    tags: ["Date / Time"],
    author: "Google",
    version: "1.9.32",
    path: "M6,2V8H6V8L10,12L6,16V16H6V22H18V16H18V16L14,12L18,8V8H18V2H6Z",
  },
  {
    id: "F06ED6E0-0EB1-4B39-8E85-1A82A273F473",
    name: "timetable",
    codepoint: "F520",
    aliases: [],
    tags: ["Date / Time"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M14,12H15.5V14.82L17.94,16.23L17.19,17.53L14,15.69V12M4,2H18C19.1,2 20,2.9 20,4V10.1C21.24,11.36 22,13.09 22,15C22,18.87 18.87,22 15,22C13.09,22 11.36,21.24 10.1,20H4C2.9,20 2,19.1 2,18V4C2,2.9 2.9,2 4,2M4,15V18H8.67C8.24,17.09 8,16.07 8,15H4M4,8H10V5H4V8M18,8V5H12V8H18M4,13H8.29C8.63,11.85 9.26,10.82 10.1,10H4V13M15,10.15C12.32,10.15 10.15,12.32 10.15,15C10.15,17.68 12.32,19.85 15,19.85C17.68,19.85 19.85,17.68 19.85,15C19.85,12.32 17.68,10.15 15,10.15Z",
  },
  {
    id: "D1AD4F4E-3CFE-4F51-932D-D3942A26C418",
    name: "toggle-switch",
    codepoint: "F521",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M17,7H7C4.24,7 2,9.24 2,12C2,14.76 4.24,17 7,17H17C19.76,17 22,14.76 22,12C22,9.24 19.76,7 17,7M17,15C15.34,15 14,13.66 14,12C14,10.34 15.34,9 17,9C18.66,9 20,10.34 20,12C20,13.66 18.66,15 17,15Z",
  },
  {
    id: "A54ADA14-0917-432E-9288-3364FBAEBCE2",
    name: "toggle-switch-off",
    codepoint: "F522",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M17,7H7C4.24,7 2,9.24 2,12C2,14.76 4.24,17 7,17H17C19.76,17 22,14.76 22,12C22,9.24 19.76,7 17,7M7,15C5.34,15 4,13.66 4,12C4,10.34 5.34,9 7,9C8.66,9 10,10.34 10,12C10,13.66 8.66,15 7,15Z",
  },
  {
    id: "1DCEDC73-941F-4412-B0B7-B7042888F91A",
    name: "toggle-switch-off-outline",
    codepoint: "FA18",
    aliases: [],
    tags: [],
    author: "Google",
    version: "2.5.94",
    path: "M7,10C8.1,10 9,10.9 9,12C9,13.1 8.1,14 7,14C5.9,14 5,13.1 5,12C5,10.9 5.9,10 7,10M17,7C19.76,7 22,9.24 22,12C22,14.76 19.76,17 17,17H7C4.24,17 2,14.76 2,12C2,9.24 4.24,7 7,7H17M7,9C5.34,9 4,10.34 4,12C4,13.66 5.34,15 7,15H17C18.66,15 20,13.66 20,12C20,10.34 18.66,9 17,9H7Z",
  },
  {
    id: "2645C66C-41C1-4536-9BB5-4530B8C8E89B",
    name: "toggle-switch-outline",
    codepoint: "FA19",
    aliases: [],
    tags: [],
    author: "Google",
    version: "2.5.94",
    path: "M17,10C18.1,10 19,10.9 19,12C19,13.1 18.1,14 17,14C15.9,14 15,13.1 15,12C15,10.9 15.9,10 17,10M17,7C19.76,7 22,9.24 22,12C22,14.76 19.76,17 17,17H7C4.24,17 2,14.76 2,12C2,9.24 4.24,7 7,7H17M7,9C5.34,9 4,10.34 4,12C4,13.66 5.34,15 7,15H17C18.66,15 20,13.66 20,12C20,10.34 18.66,9 17,9H7Z",
  },
  {
    id: "5A1815F9-FC9E-4420-B723-AF4B324262A4",
    name: "toilet",
    codepoint: "F9AA",
    aliases: [],
    tags: ["Home Automation"],
    author: "Augustin Ursu",
    version: "2.4.85",
    path: "M9,22H17V19.5C19.41,17.87 21,15.12 21,12V4C21,2.9 20.1,2 19,2H15C13.89,2 13,2.9 13,4V12H3C3,15.09 5,18 9,19.5V22M5.29,14H18.71C18.14,15.91 16.77,17.5 15,18.33V20H11V18.33C9,18 5.86,15.91 5.29,14M15,4H19V12H15V4M16,5V8H18V5H16Z",
  },
  {
    id: "79D1B3B8-FC3E-4978-AA8E-C78A1360B880",
    name: "toolbox",
    codepoint: "F9AB",
    aliases: [],
    tags: [],
    author: "Google",
    version: "2.4.85",
    path: "M9,5V6H15V5H9M22,18C22,18.53 21.79,19 21.4,19.41C21,19.81 20.55,20 20,20H4C3.45,20 3,19.81 2.6,19.41C2.21,19 2,18.53 2,18V14H7V15H9V14H15V15H17V14H22V18M4.5,7.22C4.84,6.41 5.45,6 6.33,6H7V5C7,4.45 7.18,4 7.57,3.59C7.96,3.2 8.44,3 9,3H15C15.56,3 16.04,3.2 16.43,3.59C16.82,4 17,4.45 17,5V6H17.67C18.55,6 19.16,6.41 19.5,7.22L21.58,12H17V11H15V12H9V11H7V12H2.42L4.5,7.22Z",
  },
  {
    id: "F016813A-4390-482A-8FFF-D081FDD21362",
    name: "toolbox-outline",
    codepoint: "F9AC",
    aliases: ["service-toolbox"],
    tags: [],
    author: "Google",
    version: "2.4.85",
    path: "M20,18V14H17V15H15V14H9V15H7V14H4V18H20M6.33,8L4.59,12H7V11H9V12H15V11H17V12H19.41L17.67,8H6.33M9,5V6H15V5H9M21.84,12.61C21.94,12.83 22,13.09 22,13.41V18C22,18.53 21.79,19 21.4,19.41C21,19.81 20.55,20 20,20H4C3.45,20 3,19.81 2.6,19.41C2.21,19 2,18.53 2,18V13.41C2,13.09 2.06,12.83 2.16,12.61L4.5,7.22C4.84,6.41 5.45,6 6.33,6H7V5C7,4.45 7.18,4 7.57,3.59C7.96,3.2 8.44,3 9,3H15C15.56,3 16.04,3.2 16.43,3.59C16.82,4 17,4.45 17,5V6H17.67C18.55,6 19.16,6.41 19.5,7.22L21.84,12.61Z",
  },
  {
    id: "D6AD70EE-33F4-4C3A-8ED1-3CD3236222F8",
    name: "tooltip",
    codepoint: "F523",
    aliases: [],
    tags: ["Tooltip"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M4,2H20C21.1,2 22,2.9 22,4V16C22,17.1 21.1,18 20,18H16L12,22L8,18H4C2.9,18 2,17.1 2,16V4C2,2.9 2.9,2 4,2Z",
  },
  {
    id: "C1684CDD-9C71-4A10-B3BA-5B26706B3B28",
    name: "tooltip-edit",
    codepoint: "F524",
    aliases: [],
    tags: ["Tooltip"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M4,2H20C21.1,2 22,2.9 22,4V16C22,17.1 21.1,18 20,18H16L12,22L8,18H4C2.9,18 2,17.1 2,16V4C2,2.9 2.9,2 4,2M18,14V12H12.5L10.5,14H18M6,14H8.5L15.35,7.12C15.55,6.93 15.55,6.61 15.35,6.41L13.59,4.65C13.39,4.45 13.07,4.45 12.88,4.65L6,11.53V14Z",
  },
  {
    id: "1DF33E50-EBEA-4A62-8455-84C28271C8D2",
    name: "tooltip-image",
    codepoint: "F525",
    aliases: [],
    tags: ["Tooltip"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M4,2H20C21.1,2 22,2.9 22,4V16C22,17.1 21.1,18 20,18H16L12,22L8,18H4C2.9,18 2,17.1 2,16V4C2,2.9 2.9,2 4,2M19,15V7L15,11L13,9L7,15H19M7,5C5.9,5 5,5.9 5,7C5,8.1 5.9,9 7,9C8.1,9 9,8.1 9,7C9,5.9 8.1,5 7,5Z",
  },
  {
    id: "C14A3C70-357F-4AE8-963C-B45ED543A4DB",
    name: "tooltip-outline",
    codepoint: "F526",
    aliases: [],
    tags: ["Tooltip"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M4,2H20C21.1,2 22,2.9 22,4V16C22,17.1 21.1,18 20,18H16L12,22L8,18H4C2.9,18 2,17.1 2,16V4C2,2.9 2.9,2 4,2M4,4V16H8.83L12,19.17L15.17,16H20V4H4Z",
  },
  {
    id: "CAA5F3A3-2044-48AC-94CA-04899F9459ED",
    name: "tooltip-outline-plus",
    codepoint: "F527",
    aliases: [],
    tags: ["Tooltip"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M4,2H20C21.1,2 22,2.9 22,4V16C22,17.1 21.1,18 20,18H16L12,22L8,18H4C2.9,18 2,17.1 2,16V4C2,2.9 2.9,2 4,2M4,4V16H8.83L12,19.17L15.17,16H20V4H4M11,6H13V9H16V11H13V14H11V11H8V9H11V6Z",
  },
  {
    id: "B608ACE2-279D-4C66-9169-32BD86BDF5F3",
    name: "tooltip-text",
    codepoint: "F528",
    aliases: [],
    tags: ["Tooltip"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M4,2H20C21.1,2 22,2.9 22,4V16C22,17.1 21.1,18 20,18H16L12,22L8,18H4C2.9,18 2,17.1 2,16V4C2,2.9 2.9,2 4,2M5,5V7H19V5H5M5,9V11H15V9H5M5,13V15H17V13H5Z",
  },
  {
    id: "486D33E1-B181-40D4-B088-BBB49221B91F",
    name: "tooth",
    codepoint: "F8C2",
    aliases: [],
    tags: [],
    author: "Christopher Schreiner",
    version: "2.2.43",
    path: "M7,2C4,2 2,5 2,8C2,10.11 3,13 4,14C5,15 6,22 8,22C12.54,22 10,15 12,15C14,15 11.46,22 16,22C18,22 19,15 20,14C21,13 22,10.11 22,8C22,5 20,2 17,2C14,2 14,3 12,3C10,3 10,2 7,2Z",
  },
  {
    id: "BFD05B50-CF42-49C4-B76D-447DB0AEFEEE",
    name: "tooth-outline",
    codepoint: "F529",
    aliases: [],
    tags: [],
    author: "Christopher Schreiner",
    version: "1.5.54",
    path: "M7,2C4,2 2,5 2,8C2,10.11 3,13 4,14C5,15 6,22 8,22C12.54,22 10,15 12,15C14,15 11.46,22 16,22C18,22 19,15 20,14C21,13 22,10.11 22,8C22,5 20,2 17,2C14,2 14,3 12,3C10,3 10,2 7,2M7,4C9,4 10,5 12,5C14,5 15,4 17,4C18.67,4 20,6 20,8C20,9.75 19.14,12.11 18.19,13.06C17.33,13.92 16.06,19.94 15.5,19.94C15.29,19.94 15,18.88 15,17.59C15,15.55 14.43,13 12,13C9.57,13 9,15.55 9,17.59C9,18.88 8.71,19.94 8.5,19.94C7.94,19.94 6.67,13.92 5.81,13.06C4.86,12.11 4,9.75 4,8C4,6 5.33,4 7,4Z",
  },
  {
    id: "E2623132-7507-4FFD-8382-E192DDC62D17",
    name: "tournament",
    codepoint: "F9AD",
    aliases: ["bracket"],
    tags: [],
    author: "GreenTurtwig",
    version: "2.4.85",
    path: "M2,2V4H7V8H2V10H7C8.11,10 9,9.11 9,8V7H14V17H9V16C9,14.89 8.11,14 7,14H2V16H7V20H2V22H7C8.11,22 9,21.11 9,20V19H14C15.11,19 16,18.11 16,17V13H22V11H16V7C16,5.89 15.11,5 14,5H9V4C9,2.89 8.11,2 7,2H2Z",
  },
  {
    id: "70D21CFE-DC3C-4615-9524-4CD2F2FDC44E",
    name: "tower-beach",
    codepoint: "F680",
    aliases: [],
    tags: [],
    author: "Thomas Hunsaker",
    version: "1.7.12",
    path: "M17,4V8H18V10H17.64L21,23H18.93L18.37,20.83L12,17.15L5.63,20.83L5.07,23H3L6.36,10H6V8H7V4H6V3L18,1V4H17M7.28,14.43L6.33,18.12L10,16L7.28,14.43M15.57,10H8.43L7.8,12.42L12,14.85L16.2,12.42L15.57,10M17.67,18.12L16.72,14.43L14,16L17.67,18.12Z",
  },
  {
    id: "11E0C03B-7522-4247-B0D3-F04AE1ECB166",
    name: "tower-fire",
    codepoint: "F681",
    aliases: [],
    tags: [],
    author: "Thomas Hunsaker",
    version: "1.7.12",
    path: "M17,4V8H18V10H17.64L21,23H18.93L18.37,20.83L12,17.15L5.63,20.83L5.07,23H3L6.36,10H6V8H7V4H6V3L12,1L18,3V4H17M7.28,14.43L6.33,18.12L10,16L7.28,14.43M15.57,10H8.43L7.8,12.42L12,14.85L16.2,12.42L15.57,10M17.67,18.12L16.72,14.43L14,16L17.67,18.12Z",
  },
  {
    id: "6BF0AEDF-F822-460F-8CEB-AEF0D83815F5",
    name: "track-light",
    codepoint: "F913",
    aliases: [],
    tags: ["Home Automation"],
    author: "GreenTurtwig",
    version: "2.3.50",
    path: "M6,1V3H9V6.4L4.11,4.38L1.43,10.84L6.97,13.14L11.94,16.82L13.79,17.59L17.62,8.35L15.77,7.58L11,6.87V3H14V1H6M21.81,6.29L19.5,7.25L20.26,9.1L22.57,8.14L21.81,6.29M19.78,13.57L19,15.42L21.79,16.57L22.55,14.72L19.78,13.57M16.19,18.93L14.34,19.69L15.3,22L17.15,21.23L16.19,18.93Z",
  },
  {
    id: "C06AFD8C-C769-41B1-8E5C-355CE5DBEE8E",
    name: "trackpad",
    codepoint: "F7F7",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "2.0.46",
    path: "M4,3H20C21.1,3 22,3.9 22,5V19C22,20.1 21.1,21 20,21H4C2.9,21 2,20.1 2,19V5C2,3.9 2.9,3 4,3M4,5V13H20V5H4M4,19H11V15H4V19M20,19V15H13V19H20Z",
  },
  {
    id: "92AB470E-CDB3-43F8-A299-D32C94043D83",
    name: "trackpad-lock",
    codepoint: "F932",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "2.3.54",
    path: "M3,1C1.89,1 1,1.89 1,3V17C1,18.11 1.89,19 3,19H14V17H12V13H16.68C17.5,12.35 18.47,12 19.5,12C20,12 20.5,12.09 21,12.26V3C21,1.89 20.11,1 19,1H3M3,3H19V11H3V3M3,13H10V17H3V13M19.5,14C18.12,14 17,15.12 17,16.5V17C16.45,17 16,17.45 16,18V22C16,22.55 16.45,23 17,23H22C22.55,23 23,22.55 23,22V18C23,17.45 22.55,17 22,17V16.5C22,15.12 20.88,14 19.5,14M19.5,15C20.33,15 21,15.67 21,16.5V17H18V16.5C18,15.67 18.67,15 19.5,15Z",
  },
  {
    id: "D5993895-5ECF-4B4A-8C84-7E3D9C1F6ADB",
    name: "tractor",
    codepoint: "F891",
    aliases: [],
    tags: ["Agriculture", "Transportation + Road"],
    author: "GreenTurtwig",
    version: "2.1.99",
    path: "M5,4V11.26C3.2,11.9 2,13.6 2,15.5C2,18 4,20 6.5,20C8.79,20 10.71,18.28 10.97,16H15.17C15.06,16.32 15,16.66 15,17C15,18.66 16.34,20 18,20C19.66,20 21,18.66 21,17C21,16.66 20.94,16.32 20.82,16H22V13C22,11.89 21.11,11 20,11H15.04L13.65,4H5M7,6H12L13,11V14H10.74C10.16,12.38 8.71,11.23 7,11.03V6M6.5,13.25C7.74,13.25 8.75,14.26 8.75,15.5C8.75,16.74 7.74,17.75 6.5,17.75C5.26,17.75 4.25,16.74 4.25,15.5C4.25,14.26 5.26,13.25 6.5,13.25M18,15.5C18.83,15.5 19.5,16.17 19.5,17C19.5,17.83 18.83,18.5 18,18.5C17.17,18.5 16.5,17.83 16.5,17C16.5,16.17 17.17,15.5 18,15.5Z",
  },
  {
    id: "073B4489-5787-432C-9D10-50B270182D34",
    name: "traffic-light",
    codepoint: "F52B",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M12,9C10.9,9 10,8.1 10,7C10,5.89 10.9,5 12,5C13.11,5 14,5.89 14,7C14,8.1 13.1,9 12,9M12,14C10.9,14 10,13.1 10,12C10,10.89 10.9,10 12,10C13.11,10 14,10.89 14,12C14,13.1 13.1,14 12,14M12,19C10.9,19 10,18.1 10,17C10,15.89 10.9,15 12,15C13.11,15 14,15.89 14,17C14,18.1 13.1,19 12,19M20,10H17V8.86C18.72,8.41 20,6.86 20,5H17V4C17,3.45 16.55,3 16,3H8C7.45,3 7,3.45 7,4V5H4C4,6.86 5.28,8.41 7,8.86V10H4C4,11.86 5.28,13.41 7,13.86V15H4C4,16.86 5.28,18.41 7,18.86V20C7,20.55 7.45,21 8,21H16C16.55,21 17,20.55 17,20V18.86C18.72,18.41 20,16.86 20,15H17V13.86C18.72,13.41 20,11.86 20,10Z",
  },
  {
    id: "B6E1232A-3A43-4200-BE34-1BC436B34BF1",
    name: "train",
    codepoint: "F52C",
    aliases: ["directions-railway"],
    tags: ["Navigation", "Transportation + Other"],
    author: "Google",
    version: "1.5.54",
    path: "M12,2C8,2 4,2.5 4,6V15.5C4,17.43 5.57,19 7.5,19L6,20.5V21H8.23L10.23,19H14L16,21H18V20.5L16.5,19C18.43,19 20,17.43 20,15.5V6C20,2.5 16.42,2 12,2M7.5,17C6.67,17 6,16.33 6,15.5C6,14.67 6.67,14 7.5,14C8.33,14 9,14.67 9,15.5C9,16.33 8.33,17 7.5,17M11,10H6V6H11V10M13,10V6H18V10H13M16.5,17C15.67,17 15,16.33 15,15.5C15,14.67 15.67,14 16.5,14C17.33,14 18,14.67 18,15.5C18,16.33 17.33,17 16.5,17Z",
  },
  {
    id: "C0A4E604-3829-4605-A7BC-CA0BFF138B18",
    name: "train-variant",
    codepoint: "F8C3",
    aliases: [],
    tags: ["Transportation + Other"],
    author: "Google",
    version: "2.2.43",
    path: "M18,10H6V5H18M12,17C10.89,17 10,16.1 10,15C10,13.89 10.89,13 12,13C13.1,13 14,13.9 14,15C14,16.1 13.1,17 12,17M4,15.5C4,17.43 5.57,19 7.5,19L6,20.5V21H18V20.5L16.5,19C18.43,19 20,17.43 20,15.5V5C20,1.5 16.42,1 12,1C7.58,1 4,1.5 4,5V15.5Z",
  },
  {
    id: "13AE3C37-5323-4FE6-86F7-3B30B635969F",
    name: "tram",
    codepoint: "F52D",
    aliases: [],
    tags: ["Navigation", "Transportation + Other"],
    author: "Google",
    version: "1.5.54",
    path: "M19,16.94V8.5C19,5.71 16.39,5.1 13,5L13.75,3.5H17V2H7V3.5H11.75L11,5C7.86,5.11 5,5.73 5,8.5V16.94C5,18.39 6.19,19.6 7.59,19.91L6,21.5V22H8.23L10.23,20H14L16,22H18V21.5L16.5,20H16.42C18.11,20 19,18.63 19,16.94M12,18.5C11.17,18.5 10.5,17.83 10.5,17C10.5,16.17 11.17,15.5 12,15.5C12.83,15.5 13.5,16.17 13.5,17C13.5,17.83 12.83,18.5 12,18.5M17,14H7V9H17V14Z",
  },
  {
    id: "6DD88A18-582D-400D-A5AB-12996F26A05D",
    name: "transcribe",
    codepoint: "F52E",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M20,5C21.1,5 22,5.9 22,7V17C22,18.1 21.1,19 20,19H4C2.89,19 2,18.1 2,17V7C2,5.89 2.89,5 4,5H20M18,17V15H12.5L10.5,17H18M6,17H8.5L15.35,10.12C15.55,9.93 15.55,9.61 15.35,9.41L13.59,7.65C13.39,7.45 13.07,7.45 12.88,7.65L6,14.53V17Z",
  },
  {
    id: "2D2FB32D-B253-4D3E-BA04-7AD5D5FE2C2E",
    name: "transcribe-close",
    codepoint: "F52F",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,23L8,19H16L12,23M20,3C21.1,3 22,3.9 22,5V15C22,16.1 21.1,17 20,17H4C2.9,17 2,16.1 2,15V5C2,3.9 2.9,3 4,3H20M18,15V13H12.5L10.5,15H18M6,15H8.5L15.35,8.12C15.55,7.93 15.55,7.61 15.35,7.42L13.59,5.65C13.39,5.45 13.07,5.45 12.88,5.65L6,12.53V15Z",
  },
  {
    id: "D2895587-8DBA-4EDC-8624-3A32C20AB638",
    name: "transfer",
    codepoint: "F530",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M3,8H5V16H3V8M7,8H9V16H7V8M11,8H13V16H11V8M15,19.25V4.75L22.25,12L15,19.25Z",
  },
  {
    id: "CE6451FA-EF46-40B4-B87B-BCF93DDE6E54",
    name: "transit-transfer",
    codepoint: "F6AD",
    aliases: ["transfer-within-a-station"],
    tags: [],
    author: "Google",
    version: "1.7.12",
    path: "M16.5,15.5H22V17H16.5V18.75L14,16.25L16.5,13.75V15.5M19.5,19.75V18L22,20.5L19.5,23V21.25H14V19.75H19.5M9.5,5.5C8.4,5.5 7.5,4.6 7.5,3.5C7.5,2.4 8.4,1.5 9.5,1.5C10.6,1.5 11.5,2.4 11.5,3.5C11.5,4.6 10.6,5.5 9.5,5.5M5.75,8.9L4,9.65V13H2V8.3L7.25,6.15C7.5,6.05 7.75,6 8,6C8.7,6 9.35,6.35 9.7,6.95L10.65,8.55C11.55,10 13.15,11 15,11V13C12.8,13 10.85,12 9.55,10.4L8.95,13.4L11,15.45V23H9V17L6.85,15L5.1,23H3L5.75,8.9Z",
  },
  {
    id: "2650CA0F-8423-4DE2-A821-9D7D1E5547C0",
    name: "transition",
    codepoint: "F914",
    aliases: ["animation", "motion", "translate"],
    tags: [],
    author: "Google",
    version: "2.3.50",
    path: "M15,2C18.87,2 22,5.13 22,9C22,11.71 20.46,14.05 18.22,15.22C17.55,16.5 16.5,17.55 15.22,18.22C14.05,20.46 11.71,22 9,22C5.13,22 2,18.87 2,15C2,12.29 3.54,9.95 5.78,8.78C6.45,7.5 7.5,6.45 8.78,5.78C9.95,3.54 12.29,2 15,2M12,19C8.13,19 5,15.87 5,12C4.37,12.84 4,13.87 4,15C4,17.76 6.24,20 9,20C10.13,20 11.16,19.63 12,19M15,16C11.13,16 8,12.87 8,9H8C7.37,9.84 7,10.87 7,12C7,14.76 9.24,17 12,17C13.13,17 14.16,16.63 15,16V16M15,4C13.87,4 12.84,4.37 12,5V5C15.87,5 19,8.13 19,12H19C19.63,11.16 20,10.13 20,9C20,6.24 17.76,4 15,4M10,9C10,11.76 12.24,14 15,14C15.6,14 16.17,13.9 16.7,13.7C16.9,13.17 17,12.6 17,12C17,9.24 14.76,7 12,7C11.4,7 10.83,7.1 10.3,7.3C10.1,7.83 10,8.4 10,9Z",
  },
  {
    id: "D254EE82-37CA-4897-BE12-6FD0ED708E38",
    name: "transition-masked",
    codepoint: "F915",
    aliases: ["masked-transitions"],
    tags: [],
    author: "Google",
    version: "2.3.50",
    path: "M15,2C16.94,2 18.59,2.7 19.95,4.05C21.3,5.41 22,7.06 22,9C22,10.56 21.5,11.96 20.58,13.2C19.64,14.43 18.44,15.27 16.97,15.7L17,15.38V15C17,12.81 16.23,10.93 14.65,9.35C13.07,7.77 11.19,7 9,7H8.63L8.3,7.03C8.73,5.56 9.57,4.36 10.8,3.42C12.04,2.5 13.44,2 15,2M9,8C12.87,8 16,11.13 16,15C16,18.87 12.87,22 9,22C5.13,22 2,18.87 2,15C2,11.13 5.13,8 9,8M9,10C6.24,10 4,12.24 4,15C4,17.76 6.24,20 9,20C11.76,20 14,17.76 14,15C14,12.24 11.76,10 9,10Z",
  },
  {
    id: "4486DD26-4110-457E-BBD7-B5D19DF72E4E",
    name: "translate",
    codepoint: "F5CA",
    aliases: ["language"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M12.87,15.07L10.33,12.56L10.36,12.53C12.1,10.59 13.34,8.36 14.07,6H17V4H10V2H8V4H1V6H12.17C11.5,7.92 10.44,9.75 9,11.35C8.07,10.32 7.3,9.19 6.69,8H4.69C5.42,9.63 6.42,11.17 7.67,12.56L2.58,17.58L4,19L9,14L12.11,17.11L12.87,15.07M18.5,10H16.5L12,22H14L15.12,19H19.87L21,22H23L18.5,10M15.88,17L17.5,12.67L19.12,17H15.88Z",
  },
  {
    id: "A0678E6D-C3D3-42AB-B9E7-C1B12D368B70",
    name: "treasure-chest",
    codepoint: "F725",
    aliases: [],
    tags: [],
    author: "Alex Efremo",
    version: "1.8.36",
    path: "M5,4H19C20.66,4 22,5.34 22,7V11H15V10H9V11H2V7C2,5.34 3.34,4 5,4M11,11H13V13H11V11M2,12H9V13L11,15H13L15,13V12H22V20H2V12Z",
  },
  {
    id: "58E298BD-F32E-420D-9E55-BDB44D583AB7",
    name: "tree",
    codepoint: "F531",
    aliases: [],
    tags: ["Nature"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M11,21V16.74C10.53,16.91 10.03,17 9.5,17C7,17 5,15 5,12.5C5,11.23 5.5,10.09 6.36,9.27C6.13,8.73 6,8.13 6,7.5C6,5 8,3 10.5,3C12.06,3 13.44,3.8 14.25,5C14.33,5 14.41,5 14.5,5C17.54,5 20,7.46 20,10.5C20,13.54 17.54,16 14.5,16C14,16 13.5,15.93 13,15.79V21H11Z",
  },
  {
    id: "25CA8276-A876-459D-B203-C81C58F88342",
    name: "trello",
    codepoint: "F532",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M19.5,2H4.5C3.12,2 2,3.12 2,4.5V19.5C2,20.88 3.12,22 4.5,22H19.5C20.88,22 22,20.88 22,19.5V4.5C22,3.12 20.88,2 19.5,2M10.7,17.2C10.7,17.86 10.16,18.4 9.5,18.4H5.8C5.14,18.4 4.6,17.86 4.6,17.2V5.8C4.6,5.14 5.14,4.6 5.8,4.6H9.5C10.16,4.6 10.7,5.14 10.7,5.8V17.2M19.4,12.2C19.4,12.86 18.86,13.4 18.2,13.4H14.5C13.84,13.4 13.3,12.86 13.3,12.2V5.8C13.3,5.14 13.84,4.6 14.5,4.6H18.2C18.86,4.6 19.4,5.14 19.4,5.8V12.2Z",
  },
  {
    id: "ACC5BB4D-9439-472F-9DD5-F026FF36D023",
    name: "trending-down",
    codepoint: "F533",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M16,18L18.29,15.71L13.41,10.83L9.41,14.83L2,7.41L3.41,6L9.41,12L13.41,8L19.71,14.29L22,12V18H16Z",
  },
  {
    id: "A39F489B-ABB1-4420-A6DC-20AF0E2CF6DA",
    name: "trending-neutral",
    codepoint: "F534",
    aliases: ["trending-flat"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M22,12L18,8V11H3V13H18V16L22,12Z",
  },
  {
    id: "4277434D-74AD-48E7-9C5F-BB7226C4FC39",
    name: "trending-up",
    codepoint: "F535",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M16,6L18.29,8.29L13.41,13.17L9.41,9.17L2,16.59L3.41,18L9.41,12L13.41,16L19.71,9.71L22,12V6H16Z",
  },
  {
    id: "78EC62FE-EC63-407F-BCF3-92C441398DDA",
    name: "triangle",
    codepoint: "F536",
    aliases: [],
    tags: ["Shape"],
    author: "Cody",
    version: "1.5.54",
    path: "M1,21H23L12,2",
  },
  {
    id: "74A6BF3E-CEC2-40C3-A900-109D5E05E218",
    name: "triangle-outline",
    codepoint: "F537",
    aliases: [],
    tags: ["Shape"],
    author: "Cody",
    version: "1.5.54",
    path: "M12,2L1,21H23M12,6L19.53,19H4.47",
  },
  {
    id: "0B9368A1-FC31-4D0D-8909-C2D44DCC0B83",
    name: "trophy",
    codepoint: "F538",
    aliases: ["achievement"],
    tags: [],
    author: "Doug C. Hardester",
    version: "1.5.54",
    path: "M20.2,2H19.5H18C17.1,2 16,3 16,4H8C8,3 6.9,2 6,2H4.5H3.8H2V11C2,12 3,13 4,13H6.2C6.6,15 7.9,16.7 11,17V19.1C8.8,19.3 8,20.4 8,21.7V22H16V21.7C16,20.4 15.2,19.3 13,19.1V17C16.1,16.7 17.4,15 17.8,13H20C21,13 22,12 22,11V2H20.2M4,11V4H6V6V11C5.1,11 4.3,11 4,11M20,11C19.7,11 18.9,11 18,11V6V4H20V11Z",
  },
  {
    id: "39F70CE8-5C56-4AAB-A4F7-93F871B1CB96",
    name: "trophy-award",
    codepoint: "F539",
    aliases: ["achievement-award"],
    tags: [],
    author: "Doug C. Hardester",
    version: "1.5.54",
    path: "M15.2,10.7L16.6,16L12,12.2L7.4,16L8.8,10.8L4.6,7.3L10,7L12,2L14,7L19.4,7.3L15.2,10.7M14,19.1H13V16L12,15L11,16V19.1H10C8.9,19.1 8,20 8,21.1V22.1H16V21.1C16,20 15.1,19.1 14,19.1Z",
  },
  {
    id: "D7B01958-C212-49B9-B58B-146B4017348C",
    name: "trophy-outline",
    codepoint: "F53A",
    aliases: ["achievement-outline"],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M2,2V11C2,12 3,13 4,13H6.2C6.6,15 7.9,16.7 11,17V19.1C8.8,19.3 8,20.4 8,21.7V22H16V21.7C16,20.4 15.2,19.3 13,19.1V17C16.1,16.7 17.4,15 17.8,13H20C21,13 22,12 22,11V2H18C17.1,2 16,3 16,4H8C8,3 6.9,2 6,2H2M4,4H6V6L6,11H4V4M18,4H20V11H18V6L18,4M8,6H16V11.5C16,13.43 15.42,15 12,15C8.59,15 8,13.43 8,11.5V6Z",
  },
  {
    id: "C6664923-EE26-4175-90CB-AD87B517F2FF",
    name: "trophy-variant",
    codepoint: "F53B",
    aliases: ["achievement-variant"],
    tags: [],
    author: "Doug C. Hardester",
    version: "1.5.54",
    path: "M20.2,4H20H17V2H7V4H4.5H3.8H2V11C2,12 3,13 4,13H7.2C7.6,14.9 8.6,16.6 11,16.9V19C8,19.2 8,20.3 8,21.6V22H16V21.7C16,20.4 16,19.3 13,19.1V17C15.5,16.7 16.5,15 16.8,13.1H20C21,13.1 22,12.1 22,11.1V4H20.2M4,11V6H7V8V11C5.6,11 4.4,11 4,11M20,11C19.6,11 18.4,11 17,11V6H18H20V11Z",
  },
  {
    id: "C3A5133F-0462-40DB-863A-3659FC5DFE0E",
    name: "trophy-variant-outline",
    codepoint: "F53C",
    aliases: ["achievement-variant-outline"],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M7,2V4H2V11C2,12 3,13 4,13H7.2C7.6,14.9 8.6,16.6 11,16.9V19C8,19.2 8,20.3 8,21.6V22H16V21.7C16,20.4 16,19.3 13,19.1V17C15.5,16.7 16.5,15 16.8,13.1H20C21,13.1 22,12.1 22,11.1V4H17V2H7M9,4H15V12C15,13.66 13.66,15 12,15C10,15 9,13.66 9,12V4M4,6H7V8L7,11H4V6M17,6H20V11H17V6Z",
  },
  {
    id: "A0B91DEA-DB9A-4737-B2F4-26B805B88648",
    name: "truck",
    codepoint: "F53D",
    aliases: ["lorry", "local-shipping"],
    tags: ["Transportation + Road"],
    author: "Google",
    version: "1.5.54",
    path: "M18,18.5C17.17,18.5 16.5,17.83 16.5,17C16.5,16.17 17.17,15.5 18,15.5C18.83,15.5 19.5,16.17 19.5,17C19.5,17.83 18.83,18.5 18,18.5M19.5,9.5L21.46,12H17V9.5M6,18.5C5.17,18.5 4.5,17.83 4.5,17C4.5,16.17 5.17,15.5 6,15.5C6.83,15.5 7.5,16.17 7.5,17C7.5,17.83 6.83,18.5 6,18.5M20,8H17V4H3C1.89,4 1,4.89 1,6V17H3C3,18.66 4.34,20 6,20C7.66,20 9,18.66 9,17H15C15,18.66 16.34,20 18,20C19.66,20 21,18.66 21,17H23V12L20,8Z",
  },
  {
    id: "D0EB091D-C62C-4A93-9AE4-AE942F5738C7",
    name: "truck-delivery",
    codepoint: "F53E",
    aliases: ["lorry-delivery"],
    tags: ["Transportation + Road"],
    author: "Cody",
    version: "1.5.54",
    path: "M3,4C1.9,4 1,4.9 1,6V17H3C3,18.66 4.34,20 6,20C7.66,20 9,18.66 9,17H15C15,18.66 16.34,20 18,20C19.66,20 21,18.66 21,17H23V12L20,8H17V4M10,6L14,10L10,14V11H4V9H10M17,9.5H19.5L21.47,12H17M6,15.5C6.83,15.5 7.5,16.17 7.5,17C7.5,17.83 6.83,18.5 6,18.5C5.17,18.5 4.5,17.83 4.5,17C4.5,16.17 5.17,15.5 6,15.5M18,15.5C18.83,15.5 19.5,16.17 19.5,17C19.5,17.83 18.83,18.5 18,18.5C17.17,18.5 16.5,17.83 16.5,17C16.5,16.17 17.17,15.5 18,15.5Z",
  },
  {
    id: "401AC514-6441-4DDC-80DC-48CF851C5B5E",
    name: "truck-fast",
    codepoint: "F787",
    aliases: ["lorry-fast"],
    tags: ["Transportation + Road"],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M3,13.5L2.25,12H7.5L6.9,10.5H2L1.25,9H9.05L8.45,7.5H1.11L0.25,6H4C4,4.9 4.9,4 6,4H18V8H21L24,12V17H22C22,18.66 20.66,20 19,20C17.34,20 16,18.66 16,17H12C12,18.66 10.66,20 9,20C7.34,20 6,18.66 6,17H4V13.5H3M19,18.5C19.83,18.5 20.5,17.83 20.5,17C20.5,16.17 19.83,15.5 19,15.5C18.17,15.5 17.5,16.17 17.5,17C17.5,17.83 18.17,18.5 19,18.5M20.5,9.5H18V12H22.46L20.5,9.5M9,18.5C9.83,18.5 10.5,17.83 10.5,17C10.5,16.17 9.83,15.5 9,15.5C8.17,15.5 7.5,16.17 7.5,17C7.5,17.83 8.17,18.5 9,18.5Z",
  },
  {
    id: "6F488FA3-B882-443D-8619-0124217E267C",
    name: "truck-trailer",
    codepoint: "F726",
    aliases: [],
    tags: ["Transportation + Road"],
    author: "Michael Richins",
    version: "1.8.36",
    path: "M22,15V17H10C10,18.66 8.66,20 7,20C5.34,20 4,18.66 4,17H2V6C2,4.9 2.9,4 4,4H17C18.1,4 19,4.9 19,6V15H22M7,16C6.45,16 6,16.45 6,17C6,17.55 6.45,18 7,18C7.55,18 8,17.55 8,17C8,16.45 7.55,16 7,16Z",
  },
  {
    id: "6B67D149-AE33-40CF-997F-C57A7ECB8D42",
    name: "tshirt-crew",
    codepoint: "F53F",
    aliases: [],
    tags: ["Clothing"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M16,21H8C7.45,21 7,20.55 7,20V12.07L5.7,13.12C5.31,13.5 4.68,13.5 4.29,13.12L1.46,10.29C1.07,9.9 1.07,9.27 1.46,8.88L7.34,3H9C9,4.1 10.34,5 12,5C13.66,5 15,4.1 15,3H16.66L22.54,8.88C22.93,9.27 22.93,9.9 22.54,10.29L19.71,13.12C19.32,13.5 18.69,13.5 18.3,13.12L17,12.07V20C17,20.55 16.55,21 16,21M20.42,9.58L16.11,5.28C15.8,5.63 15.43,5.94 15,6.2C14.16,6.7 13.13,7 12,7C10.3,7 8.79,6.32 7.89,5.28L3.58,9.58L5,11L8,9H9V19H15V9H16L19,11L20.42,9.58Z",
  },
  {
    id: "94791D5D-EEC5-4562-98DD-DF285E972EC8",
    name: "tshirt-v",
    codepoint: "F540",
    aliases: [],
    tags: ["Clothing"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M16,21H8C7.45,21 7,20.55 7,20V12.07L5.7,13.12C5.31,13.5 4.68,13.5 4.29,13.12L1.46,10.29C1.07,9.9 1.07,9.27 1.46,8.88L7.34,3H9C9,4.1 10,6 12,7.25C14,6 15,4.1 15,3H16.66L22.54,8.88C22.93,9.27 22.93,9.9 22.54,10.29L19.71,13.12C19.32,13.5 18.69,13.5 18.3,13.12L17,12.07V20C17,20.55 16.55,21 16,21M20.42,9.58L16.11,5.28C15,7 14,8.25 12,9.25C10,8.25 9,7 7.89,5.28L3.58,9.58L5,11L8,9H9V19H15V9H16L19,11L20.42,9.58Z",
  },
  {
    id: "7796F195-34DA-4CAA-8F58-1179343EFB18",
    name: "tumble-dryer",
    codepoint: "F916",
    aliases: [],
    tags: ["Home Automation"],
    author: "GreenTurtwig",
    version: "2.3.50",
    path: "M6,2H18C19.1,2 20,2.9 20,4V20C20,21.1 19.1,22 18,22H6C4.9,22 4,21.1 4,20V4C4,2.9 4.9,2 6,2M7,4C6.45,4 6,4.45 6,5C6,5.55 6.45,6 7,6C7.55,6 8,5.55 8,5C8,4.45 7.55,4 7,4M10,4C9.45,4 9,4.45 9,5C9,5.55 9.45,6 10,6C10.55,6 11,5.55 11,5C11,4.45 10.55,4 10,4M12,8C8.69,8 6,10.69 6,14C6,17.31 8.69,20 12,20C15.31,20 18,17.31 18,14C18,10.69 15.31,8 12,8M8.11,10.5H10C9.76,11.88 10,12.67 10.58,13.29C11.68,14.36 12.16,15.71 11.89,17.5H10C10.24,16.12 10,15.33 9.42,14.71C8.32,13.64 7.85,12.29 8.11,10.5M12.11,10.5H14C13.76,11.88 14,12.67 14.58,13.29C15.68,14.36 16.16,15.71 15.89,17.5H14C14.24,16.12 14,15.33 13.42,14.71C12.32,13.64 11.85,12.29 12.11,10.5Z",
  },
  {
    id: "B1F7C2ED-4017-4162-A4C7-31D8761D8DC3",
    name: "tune",
    codepoint: "F62E",
    aliases: ["mixer-settings", "equaliser"],
    tags: ["Settings"],
    author: "Google",
    version: "1.6.50",
    path: "M3,17V19H9V17H3M3,5V7H13V5H3M13,21V19H21V17H13V15H11V21H13M7,9V11H3V13H7V15H9V9H7M21,13V11H11V13H21M15,9H17V7H21V5H17V3H15V9Z",
  },
  {
    id: "AB147073-9D20-4DA1-A108-3856FC1764C1",
    name: "tune-vertical",
    codepoint: "F66A",
    aliases: ["equaliser-vertical", "instant-mix"],
    tags: ["Settings"],
    author: "Cody",
    version: "1.6.50",
    path: "M5,3V12H3V14H5V21H7V14H9V12H7V3M11,3V8H9V10H11V21H13V10H15V8H13V3M17,3V14H15V16H17V21H19V16H21V14H19V3",
  },
  {
    id: "8BA5EB2D-7C4F-4336-8994-20CAA433BB26",
    name: "twitch",
    codepoint: "F543",
    aliases: [],
    tags: ["Social Media", "Brand / Logo"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M4,2H22V14L17,19H13L10,22H7V19H2V6L4,2M20,13V4H6V16H9V19L12,16H17L20,13M15,7H17V12H15V7M12,7V12H10V7H12Z",
  },
  {
    id: "A95F7C7C-DE85-4564-BA65-DEDCF3BE105A",
    name: "twitter",
    codepoint: "F544",
    aliases: [],
    tags: ["Brand / Logo", "Social Media"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M22.46,6C21.69,6.35 20.86,6.58 20,6.69C20.88,6.16 21.56,5.32 21.88,4.31C21.05,4.81 20.13,5.16 19.16,5.36C18.37,4.5 17.26,4 16,4C13.65,4 11.73,5.92 11.73,8.29C11.73,8.63 11.77,8.96 11.84,9.27C8.28,9.09 5.11,7.38 3,4.79C2.63,5.42 2.42,6.16 2.42,6.94C2.42,8.43 3.17,9.75 4.33,10.5C3.62,10.5 2.96,10.3 2.38,10C2.38,10 2.38,10 2.38,10.03C2.38,12.11 3.86,13.85 5.82,14.24C5.46,14.34 5.08,14.39 4.69,14.39C4.42,14.39 4.15,14.36 3.89,14.31C4.43,16 6,17.26 7.89,17.29C6.43,18.45 4.58,19.13 2.56,19.13C2.22,19.13 1.88,19.11 1.54,19.07C3.44,20.29 5.7,21 8.12,21C16,21 20.33,14.46 20.33,8.79C20.33,8.6 20.33,8.42 20.32,8.23C21.16,7.63 21.88,6.87 22.46,6Z",
  },
  {
    id: "2788034C-2A06-46C0-82B9-A34CB23C88E0",
    name: "twitter-retweet",
    codepoint: "F547",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M6,5.75L10.25,10H7V16H13.5L15.5,18H7C5.9,18 5,17.1 5,16V10H1.75L6,5.75M18,18.25L13.75,14H17V8H10.5L8.5,6H17C18.1,6 19,6.9 19,8V14H22.25L18,18.25Z",
  },
  {
    id: "B4BC8D17-225E-44B1-A44F-3A6DC21C9A7B",
    name: "two-factor-authentication",
    codepoint: "F9AE",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "2.4.85",
    path: "M2,7V9H6V11H4C2.9,11 2,11.9 2,13V17H8V15H4V13H6C7.1,13 8,12.1 8,11V9C8,7.89 7.1,7 6,7H2M9,7V17H11V13H14V11H11V9H15V7H9M18,7C16.9,7 16,7.9 16,9V17H18V14H20V17H22V9C22,7.9 21.1,7 20,7H18M18,9H20V12H18V9Z",
  },
  {
    id: "D0B38B4B-389B-49A8-9797-BE1092231DE9",
    name: "ubuntu",
    codepoint: "F548",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2C17.52,2 22,6.48 22,12M14.34,7.74C14.92,8.07 15.65,7.87 16,7.3C16.31,6.73 16.12,6 15.54,5.66C14.97,5.33 14.23,5.5 13.9,6.1C13.57,6.67 13.77,7.41 14.34,7.74M11.88,15.5C11.35,15.5 10.85,15.39 10.41,15.18L9.57,16.68C10.27,17 11.05,17.22 11.88,17.22C12.37,17.22 12.83,17.15 13.28,17.03C13.36,16.54 13.64,16.1 14.1,15.84C14.56,15.57 15.08,15.55 15.54,15.72C16.43,14.85 17,13.66 17.09,12.33L15.38,12.31C15.22,14.1 13.72,15.5 11.88,15.5M11.88,8.5C13.72,8.5 15.22,9.89 15.38,11.69L17.09,11.66C17,10.34 16.43,9.15 15.54,8.28C15.08,8.45 14.55,8.42 14.1,8.16C13.64,7.9 13.36,7.45 13.28,6.97C12.83,6.85 12.37,6.78 11.88,6.78C11.05,6.78 10.27,6.97 9.57,7.32L10.41,8.82C10.85,8.61 11.35,8.5 11.88,8.5M8.37,12C8.37,10.81 8.96,9.76 9.86,9.13L9,7.65C7.94,8.36 7.15,9.43 6.83,10.69C7.21,11 7.45,11.47 7.45,12C7.45,12.53 7.21,13 6.83,13.31C7.15,14.56 7.94,15.64 9,16.34L9.86,14.87C8.96,14.24 8.37,13.19 8.37,12M14.34,16.26C13.77,16.59 13.57,17.32 13.9,17.9C14.23,18.47 14.97,18.67 15.54,18.34C16.12,18 16.31,17.27 16,16.7C15.65,16.12 14.92,15.93 14.34,16.26M5.76,10.8C5.1,10.8 4.56,11.34 4.56,12C4.56,12.66 5.1,13.2 5.76,13.2C6.43,13.2 6.96,12.66 6.96,12C6.96,11.34 6.43,10.8 5.76,10.8Z",
  },
  {
    id: "A7C08392-F82F-4910-8D0F-6A1907AE19E3",
    name: "ultra-high-definition",
    codepoint: "F7F8",
    aliases: ["uhd"],
    tags: ["Video / Movie"],
    author: "Austin Andrews",
    version: "2.0.46",
    path: "M9,7H11V11H13V7H15V17H13V13H11V17H9V7M17,7H20C21.66,7 23,8.34 23,10V14C23,15.66 21.66,17 20,17H17V7M20,15C20.55,15 21,14.55 21,14V10C21,9.45 20.55,9 20,9H19V15H20M7,14C7,15.66 5.66,17 4,17C2.34,17 1,15.66 1,14V7H3V14C3,14.55 3.45,15 4,15C4.55,15 5,14.55 5,14V7H7V14Z",
  },
  {
    id: "EB029748-89CF-4E75-BBC9-9747BEF7AE29",
    name: "umbraco",
    codepoint: "F549",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M8.6,8.6L7.17,8.38C6.5,11.67 6.46,14.24 7.61,15.5C8.6,16.61 11.89,16.61 11.89,16.61C11.89,16.61 15.29,16.61 16.28,15.5C17.43,14.24 17.38,11.67 16.72,8.38L15.29,8.6C15.29,8.6 16.54,13.88 14.69,14.69C13.81,15.07 11.89,15.07 11.89,15.07C11.89,15.07 10.08,15.07 9.2,14.69C7.35,13.88 8.6,8.6 8.6,8.6M12,3C16.97,3 21,7.03 21,12C21,16.97 16.97,21 12,21C7.03,21 3,16.97 3,12C3,7.03 7.03,3 12,3Z",
  },
  {
    id: "6E7A679E-94FE-4BBD-931F-59B9F25B54EE",
    name: "umbrella",
    codepoint: "F54A",
    aliases: [],
    tags: ["Weather"],
    author: "Cody",
    version: "1.5.54",
    path: "M12,2C16.97,2 21,6.03 21,11H13V19C13,20.66 11.66,22 10,22C8.34,22 7,20.66 7,19V18H9V19C9,19.55 9.45,20 10,20C10.55,20 11,19.55 11,19V11H3C3,6.03 7.03,2 12,2Z",
  },
  {
    id: "591C025F-58CC-4E5D-9D63-FB43A8B7BA78",
    name: "umbrella-closed",
    codepoint: "F9AF",
    aliases: [],
    tags: ["Weather"],
    author: "Cody",
    version: "2.4.85",
    path: "M12,1.53L17.5,15H13V19C13,20.66 11.66,22 10,22C8.34,22 7,20.66 7,19V18H9V19C9,19.55 9.45,20 10,20C10.55,20 11,19.55 11,19V15H6.5L12,1.53Z",
  },
  {
    id: "7E42C11A-74C3-4C0F-BE6B-9794F343925A",
    name: "umbrella-outline",
    codepoint: "F54B",
    aliases: [],
    tags: ["Weather"],
    author: "Cody",
    version: "1.5.54",
    path: "M12,4C8.9,4 6.18,6.03 5.3,9H18.7C17.82,6.04 15.09,4 12,4M12,2C16.97,2 21,6.03 21,11H13V19C13,20.66 11.66,22 10,22C8.34,22 7,20.66 7,19V18H9V19C9,19.55 9.45,20 10,20C10.55,20 11,19.55 11,19V11H3C3,6.03 7.03,2 12,2Z",
  },
  {
    id: "C9D6F6DE-E9F7-4AC9-B9F1-41160A4C2B0E",
    name: "undo",
    codepoint: "F54C",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M12.5,8C9.85,8 7.45,9 5.6,10.6L2,7V16H11L7.38,12.38C8.77,11.22 10.54,10.5 12.5,10.5C16.04,10.5 19.05,12.81 20.1,16L22.47,15.22C21.08,11.03 17.15,8 12.5,8Z",
  },
  {
    id: "C262C766-4474-4BC5-AE66-23E5735F86F1",
    name: "undo-variant",
    codepoint: "F54D",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M13.5,7C17.09,7 20,9.91 20,13.5C20,17.09 17.09,20 13.5,20H10V18H13.5C16,18 18,16 18,13.5C18,11 16,9 13.5,9H7.83L10.91,12.09L9.5,13.5L4,8L9.5,2.5L10.92,3.91L7.83,7H13.5M6,18H8V20H6V18Z",
  },
  {
    id: "E533CB7E-48C2-4D9D-B935-B51C918703C0",
    name: "unfold-less-horizontal",
    codepoint: "F54E",
    aliases: ["chevron-down-up", "collapse-horizontal"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M16.59,5.41L15.17,4L12,7.17L8.83,4L7.41,5.41L12,10M7.41,18.59L8.83,20L12,16.83L15.17,20L16.58,18.59L12,14L7.41,18.59Z",
  },
  {
    id: "E4DFDADF-60F8-4E90-A501-38381F4346A0",
    name: "unfold-less-vertical",
    codepoint: "F75F",
    aliases: ["chevron-right-left", "collapse-vertical"],
    tags: [],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M5.41,7.41L10,12L5.41,16.59L4,15.17L7.17,12L4,8.83L5.41,7.41M18.59,16.59L14,12L18.59,7.42L20,8.83L16.83,12L20,15.17L18.59,16.59Z",
  },
  {
    id: "E85F4170-11D3-4757-8247-17EBD07A08D4",
    name: "unfold-more-horizontal",
    codepoint: "F54F",
    aliases: ["chevron-up-down", "expand-horizontal"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z",
  },
  {
    id: "AE8D43D2-00EC-46D9-A21C-4D0024A539D7",
    name: "unfold-more-vertical",
    codepoint: "F760",
    aliases: ["chevron-left-right", "expand-vertical"],
    tags: [],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M18.17,12L15,8.83L16.41,7.41L21,12L16.41,16.58L15,15.17L18.17,12M5.83,12L9,15.17L7.59,16.59L3,12L7.59,7.42L9,8.83L5.83,12Z",
  },
  {
    id: "87E56CEE-67B1-427E-9A28-303F8B6D29A7",
    name: "ungroup",
    codepoint: "F550",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M2,2H6V3H13V2H17V6H16V9H18V8H22V12H21V18H22V22H18V21H12V22H8V18H9V16H6V17H2V13H3V6H2V2M18,12V11H16V13H17V17H13V16H11V18H12V19H18V18H19V12H18M13,6V5H6V6H5V13H6V14H9V12H8V8H12V9H14V6H13M12,12H11V14H13V13H14V11H12V12Z",
  },
  {
    id: "50CFC57C-9C70-4953-BDC4-F6340EB7A243",
    name: "unity",
    codepoint: "F6AE",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.7.12",
    path: "M9.11,17H6.5L1.59,12L6.5,7H9.11L10.42,4.74L17.21,3L19.08,9.74L17.77,12L19.08,14.26L17.21,21L10.42,19.26L9.11,17M9.25,16.75L14.38,18.13L11.42,13H5.5L9.25,16.75M16.12,17.13L17.5,12L16.12,6.87L13.15,12L16.12,17.13M9.25,7.25L5.5,11H11.42L14.38,5.87L9.25,7.25Z",
  },
  {
    id: "4AC79EF3-5BCA-41EC-976E-CB821416A905",
    name: "unreal",
    codepoint: "F9B0",
    aliases: ["unreal-engine"],
    tags: ["Brand / Logo"],
    author: "Contributors",
    version: "2.4.85",
    path: "M2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2C6.48,2 2,6.48 2,12M5.24,18.76C3.43,16.95 2.44,14.55 2.44,12C2.44,9.45 3.43,7.05 5.24,5.24C7.05,3.43 9.45,2.44 12,2.44C14.55,2.44 16.95,3.43 18.76,5.24C20.57,7.05 21.56,9.45 21.56,12C21.56,14.55 20.57,16.95 18.76,18.76C16.95,20.57 14.55,21.56 12,21.56C9.45,21.56 7.05,20.57 5.24,18.76M6.35,9.5C4.34,11.79 4.73,13.68 4.73,13.68C4.73,13.68 5.28,12.38 6.61,11C7.25,10.37 7.72,10.15 8.04,10.15C8.4,10.15 8.57,10.41 8.57,10.65V15.29C8.57,15.75 8.27,15.85 8,15.84C7.77,15.84 7.55,15.76 7.55,15.76C8.92,17.73 12.19,18 12.19,18L13.63,16.5H13.67L15,17.63C17.39,16.21 18.55,13.58 18.55,13.58C17.5,14.7 16.79,14.97 16.39,14.96C16.03,14.96 15.88,14.75 15.88,14.75C15.87,14.65 15.82,8.9 15.89,8.9C16.31,8.13 17.63,6.56 17.63,6.56C15.16,7.05 13.81,8.66 13.81,8.66C13.41,8.35 12.59,8.4 12.59,8.4C12.97,8.61 13.35,9.21 13.35,9.72V14.65C13.35,14.65 12.5,15.38 11.88,15.38C11.5,15.38 11.27,15.17 11.14,15C11.05,14.88 11,14.79 11,14.79V8.69C10.93,8.75 10.82,8.8 10.71,8.8C10.57,8.79 10.43,8.73 10.34,8.53C10.26,8.38 10.22,8.15 10.22,7.83C10.22,6.7 11.5,5.96 11.5,5.96C9.87,6.39 8.36,7.22 6.35,9.5",
  },
  {
    id: "BC7B3CEA-B4D3-4F52-8378-5ACF408A3D9B",
    name: "untappd",
    codepoint: "F551",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M14.41,4C14.41,4 14.94,4.39 14.97,4.71C14.97,4.81 14.73,4.85 14.68,4.93C14.62,5 14.7,5.15 14.65,5.21C14.59,5.26 14.5,5.26 14.41,5.41C14.33,5.56 12.07,10.09 11.73,10.63C11.59,11.03 11.47,12.46 11.37,12.66C11.26,12.85 6.34,19.84 6.16,20.05C5.67,20.63 4.31,20.3 3.28,19.56C2.3,18.86 1.74,17.7 2.11,17.16C2.27,16.93 7.15,9.92 7.29,9.75C7.44,9.58 8.75,9 9.07,8.71C9.47,8.22 12.96,4.54 13.07,4.42C13.18,4.3 13.15,4.2 13.18,4.13C13.22,4.06 13.38,4.08 13.43,4C13.5,3.93 13.39,3.71 13.5,3.68C13.59,3.64 13.96,3.67 14.41,4M10.85,4.44L11.74,5.37L10.26,6.94L9.46,5.37C9.38,5.22 9.28,5.22 9.22,5.17C9.17,5.11 9.24,4.97 9.19,4.89C9.13,4.81 8.9,4.83 8.9,4.73C8.9,4.62 9.05,4.28 9.5,3.96C9.5,3.96 10.06,3.6 10.37,3.68C10.47,3.71 10.43,3.95 10.5,4C10.54,4.1 10.7,4.08 10.73,4.15C10.77,4.21 10.73,4.32 10.85,4.44M21.92,17.15C22.29,17.81 21.53,19 20.5,19.7C19.5,20.39 18.21,20.54 17.83,20C17.66,19.78 12.67,12.82 12.56,12.62C12.45,12.43 12.32,11 12.18,10.59L12.15,10.55C12.45,10 13.07,8.77 13.73,7.47C14.3,8.06 14.75,8.56 14.88,8.72C15.21,9 16.53,9.58 16.68,9.75C16.82,9.92 21.78,16.91 21.92,17.15Z",
  },
  {
    id: "1B274396-AAE7-4CD8-8D57-27E31D915F68",
    name: "update",
    codepoint: "F6AF",
    aliases: ["clockwise", "clock-arrow"],
    tags: [],
    author: "Google",
    version: "1.7.12",
    path: "M21,10.12H14.22L16.96,7.3C14.23,4.6 9.81,4.5 7.08,7.2C4.35,9.91 4.35,14.28 7.08,17C9.81,19.7 14.23,19.7 16.96,17C18.32,15.65 19,14.08 19,12.1H21C21,14.08 20.12,16.65 18.36,18.39C14.85,21.87 9.15,21.87 5.64,18.39C2.14,14.92 2.11,9.28 5.62,5.81C9.13,2.34 14.76,2.34 18.27,5.81L21,3V10.12M12.5,8V12.25L16,14.33L15.28,15.54L11,13V8H12.5Z",
  },
  {
    id: "08F8FCE9-67A0-4696-9B83-0B1F11EA959E",
    name: "upload",
    codepoint: "F552",
    aliases: ["file-upload"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M9,16V10H5L12,3L19,10H15V16H9M5,20V18H19V20H5Z",
  },
  {
    id: "2B1A438E-4795-43D1-B4FD-3997C8E1BA9F",
    name: "upload-multiple",
    codepoint: "F83C",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.1.19",
    path: "M9,14V8H5L12,1L19,8H15V14H9M5,18V16H19V18H5M19,20H5V22H19V20Z",
  },
  {
    id: "B473675B-DF1E-4450-B85E-786B483C9FA4",
    name: "upload-network",
    codepoint: "F6F5",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.8.36",
    path: "M17,3C18.1,3 19,3.9 19,5V15C19,16.1 18.1,17 17,17H13V19H14C14.55,19 15,19.45 15,20H22V22H15C15,22.55 14.55,23 14,23H10C9.45,23 9,22.55 9,22H2V20H9C9,19.45 9.45,19 10,19H11V17H7C5.89,17 5,16.1 5,15V5C5,3.9 5.9,3 7,3H17M12,5.5L7.5,10H11V14H13V10H16.5L12,5.5Z",
  },
  {
    id: "25033E0B-3AD4-414D-9972-559F2690FC1D",
    name: "usb",
    codepoint: "F553",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M15,7V11H16V13H13V5H15L12,1L9,5H11V13H8V10.93C8.7,10.56 9.2,9.85 9.2,9C9.2,7.78 8.21,6.8 7,6.8C5.78,6.8 4.8,7.78 4.8,9C4.8,9.85 5.3,10.56 6,10.93V13C6,14.1 6.9,15 8,15H11V18.05C10.29,18.41 9.8,19.15 9.8,20C9.8,21.22 10.78,22.2 12,22.2C13.22,22.2 14.2,21.22 14.2,20C14.2,19.15 13.71,18.41 13,18.05V15H16C17.1,15 18,14.1 18,13V11H19V7H15Z",
  },
  {
    id: "293262AA-69E7-4D04-B441-AAA13D22C63C",
    name: "van-passenger",
    codepoint: "F7F9",
    aliases: [],
    tags: ["Transportation + Road"],
    author: "GreenTurtwig",
    version: "2.0.46",
    path: "M3,7C1.89,7 1,7.89 1,9V17H3C3,18.66 4.34,20 6,20C7.66,20 9,18.66 9,17H15C15,18.66 16.34,20 18,20C19.66,20 21,18.66 21,17H23V13C23,11.89 22.11,11 21,11L18,7H3M3,8.5H7V11H3V8.5M9,8.5H13V11H9V8.5M15,8.5H17.5L19.46,11H15V8.5M6,15.5C6.83,15.5 7.5,16.17 7.5,17C7.5,17.83 6.83,18.5 6,18.5C5.17,18.5 4.5,17.83 4.5,17C4.5,16.17 5.17,15.5 6,15.5M18,15.5C18.83,15.5 19.5,16.17 19.5,17C19.5,17.83 18.83,18.5 18,18.5C17.17,18.5 16.5,17.83 16.5,17C16.5,16.17 17.17,15.5 18,15.5Z",
  },
  {
    id: "517A8F96-14C9-4FAB-8AC2-27321C91E1BF",
    name: "van-utility",
    codepoint: "F7FA",
    aliases: ["van-candy"],
    tags: ["Transportation + Road"],
    author: "GreenTurtwig",
    version: "2.0.46",
    path: "M3,7C1.89,7 1,7.89 1,9V17H3C3,18.66 4.34,20 6,20C7.66,20 9,18.66 9,17H15C15,18.66 16.34,20 18,20C19.66,20 21,18.66 21,17H23V13C23,11.89 22.11,11 21,11L18,7H3M15,8.5H17.5L19.46,11H15V8.5M6,15.5C6.83,15.5 7.5,16.17 7.5,17C7.5,17.83 6.83,18.5 6,18.5C5.17,18.5 4.5,17.83 4.5,17C4.5,16.17 5.17,15.5 6,15.5M18,15.5C18.83,15.5 19.5,16.17 19.5,17C19.5,17.83 18.83,18.5 18,18.5C17.17,18.5 16.5,17.83 16.5,17C16.5,16.17 17.17,15.5 18,15.5Z",
  },
  {
    id: "437A175D-CA2F-44C9-9FA0-A59A43E7C590",
    name: "vanish",
    codepoint: "F7FB",
    aliases: [],
    tags: [],
    author: "Contributors",
    version: "2.0.46",
    path: "M16,13V11H21V13H16M14.83,7.76L17.66,4.93L19.07,6.34L16.24,9.17L14.83,7.76M11,16H13V21H11V16M11,3H13V8H11V3M4.93,17.66L7.76,14.83L9.17,16.24L6.34,19.07L4.93,17.66M4.93,6.34L6.34,4.93L9.17,7.76L7.76,9.17L4.93,6.34M8,13H3V11H8V13M19.07,17.66L17.66,19.07L14.83,16.24L16.24,14.83L19.07,17.66Z",
  },
  {
    id: "576A1B80-550B-46BD-90A6-A497D8A29BC5",
    name: "vector-arrange-above",
    codepoint: "F554",
    aliases: [],
    tags: ["Vector", "Arrange"],
    author: "Cody",
    version: "1.5.54",
    path: "M3,1C1.89,1 1,1.89 1,3V14C1,15.11 1.89,16 3,16C6.67,16 10.33,16 14,16C15.11,16 16,15.11 16,14C16,10.33 16,6.67 16,3C16,1.89 15.11,1 14,1H3M3,3H14V14H3V3M18,7V9H20V20H9V18H7V20C7,21.11 7.89,22 9,22H20C21.11,22 22,21.11 22,20V9C22,7.89 21.11,7 20,7H18Z",
  },
  {
    id: "C2EC8280-2EFC-44F4-BA6D-89DE72F06CA3",
    name: "vector-arrange-below",
    codepoint: "F555",
    aliases: [],
    tags: ["Vector", "Arrange"],
    author: "Cody",
    version: "1.5.54",
    path: "M20,22C21.11,22 22,21.11 22,20V9C22,7.89 21.11,7 20,7C16.33,7 12.67,7 9,7C7.89,7 7,7.89 7,9C7,12.67 7,16.33 7,20C7,21.11 7.89,22 9,22H20M20,20H9V9H20V20M5,16V14H3V3H14V5H16V3C16,1.89 15.11,1 14,1H3C1.89,1 1,1.89 1,3V14C1,15.11 1.89,16 3,16H5Z",
  },
  {
    id: "5C73E245-C6D4-42F0-A5D6-C14F53982661",
    name: "vector-circle",
    codepoint: "F556",
    aliases: [],
    tags: ["Vector"],
    author: "Cody",
    version: "1.5.54",
    path: "M9,2V4.06C6.72,4.92 4.92,6.72 4.05,9H2V15H4.06C4.92,17.28 6.72,19.09 9,19.95V22H15V19.94C17.28,19.08 19.09,17.28 19.95,15H22V9H19.94C19.08,6.72 17.28,4.92 15,4.05V2M11,4H13V6H11M9,6.25V8H15V6.25C16.18,6.86 17.14,7.82 17.75,9H16V15H17.75C17.14,16.18 16.18,17.14 15,17.75V16H9V17.75C7.82,17.14 6.86,16.18 6.25,15H8V9H6.25C6.86,7.82 7.82,6.86 9,6.25M4,11H6V13H4M18,11H20V13H18M11,18H13V20H11",
  },
  {
    id: "D5741976-7530-4859-97C1-F170BCE7C8B3",
    name: "vector-circle-variant",
    codepoint: "F557",
    aliases: [],
    tags: ["Vector"],
    author: "Cody",
    version: "1.5.54",
    path: "M22,9H19.97C18.7,5.41 15.31,3 11.5,3C6.53,3 2.5,7.03 2.5,12C2.5,17 6.53,21 11.5,21C15.31,21 18.7,18.6 20,15H22M20,11V13H18V11M17.82,15C16.66,17.44 14.2,19 11.5,19C7.64,19 4.5,15.87 4.5,12C4.5,8.14 7.64,5 11.5,5C14.2,5 16.66,6.57 17.81,9H16V15",
  },
  {
    id: "7845F254-C78F-44D3-84E3-421B0B2AFF31",
    name: "vector-combine",
    codepoint: "F558",
    aliases: [],
    tags: ["Vector"],
    author: "Cody",
    version: "1.5.54",
    path: "M3,1C1.89,1 1,1.89 1,3V14C1,15.11 1.89,16 3,16C4.33,16 7,16 7,16C7,16 7,18.67 7,20C7,21.11 7.89,22 9,22H20C21.11,22 22,21.11 22,20V9C22,7.89 21.11,7 20,7C18.67,7 16,7 16,7C16,7 16,4.33 16,3C16,1.89 15.11,1 14,1H3M3,3H14C14,4.33 14,7 14,7H9C7.89,7 7,7.89 7,9V14C7,14 4.33,14 3,14V3M9,9H14V14H9V9M16,9C16,9 18.67,9 20,9V20H9C9,18.67 9,16 9,16H14C15.11,16 16,15.11 16,14V9Z",
  },
  {
    id: "546B7A4F-6D63-46CD-B74D-DEF09CE8D8FB",
    name: "vector-curve",
    codepoint: "F559",
    aliases: ["bezier"],
    tags: ["Vector"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M18.5,2C19.33,2 20,2.67 20,3.5C20,4.33 19.33,5 18.5,5C18.27,5 18.05,4.95 17.85,4.85L14.16,8.55L14.5,9C16.69,7.74 19.26,7 22,7L23,7.03V9.04L22,9C19.42,9 17,9.75 15,11.04C15,13.23 13.23,15 11.04,15C9.75,17 9,19.42 9,22L9.04,23H7.03L7,22C7,19.26 7.74,16.69 9,14.5L8.55,14.16L4.85,17.85C4.95,18.05 5,18.27 5,18.5C5,19.33 4.33,20 3.5,20C2.67,20 2,19.33 2,18.5C2,17.67 2.67,17 3.5,17C3.73,17 3.95,17.05 4.15,17.15L7.84,13.45C7.31,12.78 7,11.92 7,11C7,8.79 8.79,7 11,7C11.92,7 12.78,7.31 13.45,7.84L17.15,4.15C17.05,3.95 17,3.73 17,3.5C17,2.67 17.67,2 18.5,2M11,9C9.9,9 9,9.9 9,11C9,12.1 9.9,13 11,13C12.1,13 13,12.1 13,11C13,9.9 12.1,9 11,9Z",
  },
  {
    id: "C4CA626C-23C3-495A-A73B-4B55A6FBC1F9",
    name: "vector-difference",
    codepoint: "F55A",
    aliases: [],
    tags: ["Vector"],
    author: "Cody",
    version: "1.5.54",
    path: "M3,1C1.89,1 1,1.89 1,3V14C1,15.11 1.89,16 3,16H5V14H3V3H14V5H16V3C16,1.89 15.11,1 14,1H3M9,7C7.89,7 7,7.89 7,9V11H9V9H11V7H9M13,7V9H14V10H16V7H13M18,7V9H20V20H9V18H7V20C7,21.11 7.89,22 9,22H20C21.11,22 22,21.11 22,20V9C22,7.89 21.11,7 20,7H18M14,12V14H12V16H14C15.11,16 16,15.11 16,14V12H14M7,13V16H10V14H9V13H7Z",
  },
  {
    id: "9D39AD1D-F643-43EF-B55B-6CF2EC4637EC",
    name: "vector-difference-ab",
    codepoint: "F55B",
    aliases: [],
    tags: ["Vector"],
    author: "Cody",
    version: "1.5.54",
    path: "M3,1C1.89,1 1,1.89 1,3V5H3V3H5V1H3M7,1V3H10V1H7M12,1V3H14V5H16V3C16,1.89 15.11,1 14,1H12M1,7V10H3V7H1M14,7C14,7 14,11.67 14,14C11.67,14 7,14 7,14C7,14 7,18 7,20C7,21.11 7.89,22 9,22H20C21.11,22 22,21.11 22,20V9C22,7.89 21.11,7 20,7C18,7 14,7 14,7M16,9H20V20H9V16H14C15.11,16 16,15.11 16,14V9M1,12V14C1,15.11 1.89,16 3,16H5V14H3V12H1Z",
  },
  {
    id: "A327D00A-F451-4B88-AEBA-EA87016806CB",
    name: "vector-difference-ba",
    codepoint: "F55C",
    aliases: [],
    tags: ["Vector"],
    author: "Cody",
    version: "1.5.54",
    path: "M20,22C21.11,22 22,21.11 22,20V18H20V20H18V22H20M16,22V20H13V22H16M11,22V20H9V18H7V20C7,21.11 7.89,22 9,22H11M22,16V13H20V16H22M9,16C9,16 9,11.33 9,9C11.33,9 16,9 16,9C16,9 16,5 16,3C16,1.89 15.11,1 14,1H3C1.89,1 1,1.89 1,3V14C1,15.11 1.89,16 3,16C5,16 9,16 9,16M7,14H3V3H14V7H9C7.89,7 7,7.89 7,9V14M22,11V9C22,7.89 21.11,7 20,7H18V9H20V11H22Z",
  },
  {
    id: "EE98FF75-8AAA-4912-AFDE-6D5290FD6800",
    name: "vector-ellipse",
    codepoint: "F892",
    aliases: [],
    tags: ["Vector"],
    author: "Austin Andrews",
    version: "2.1.99",
    path: "M23,9V15H20.35C19.38,17.12 17.43,18.78 15,19.54V22H9V19.54C5.5,18.45 3,15.5 3,12C3,7.58 7.03,4 12,4C15.78,4 19,6.07 20.35,9H23M17,15V9H18.06C16.85,7.21 14.59,6 12,6C8.13,6 5,8.69 5,12C5,14.39 6.64,16.46 9,17.42V16H15V17.42C16.29,16.9 17.35,16.05 18.06,15H17M19,13H21V11H19V13M11,20H13V18H11V20Z",
  },
  {
    id: "DACB8CA9-A0A9-4766-B1A3-EC334425514A",
    name: "vector-intersection",
    codepoint: "F55D",
    aliases: [],
    tags: ["Vector"],
    author: "Cody",
    version: "1.5.54",
    path: "M3.14,1C1.96,1 1,1.96 1,3.14V5H3V3H5V1H3.14M7,1V3H10V1H7M12,1V3H14V5H16V3.14C16,1.96 15.04,1 13.86,1H12M1,7V10H3V7H1M9,7C7.89,7 7,7.89 7,9C7,11.33 7,16 7,16C7,16 11.57,16 13.86,16C15.04,16 16,15.04 16,13.86C16,11.57 16,7 16,7C16,7 11.33,7 9,7M18,7V9H20V11H22V9C22,7.89 21.11,7 20,7H18M9,9H14V14H9V9M1,12V13.86C1,15.04 1.96,16 3.14,16H5V14H3V12H1M20,13V16H22V13H20M7,18V20C7,21.11 7.89,22 9,22H11V20H9V18H7M20,18V20H18V22H20C21.11,22 22,21.11 22,20V18H20M13,20V22H16V20H13Z",
  },
  {
    id: "8C2D4FBB-00B1-4815-971F-03F0788093C2",
    name: "vector-line",
    codepoint: "F55E",
    aliases: [],
    tags: ["Vector"],
    author: "Cody",
    version: "1.5.54",
    path: "M15,3V7.59L7.59,15H3V21H9V16.42L16.42,9H21V3M17,5H19V7H17M5,17H7V19H5",
  },
  {
    id: "C8B18CF5-BD7E-41FC-A653-6B46D85F982A",
    name: "vector-point",
    codepoint: "F55F",
    aliases: [],
    tags: ["Vector"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,20L7,22L12,11L17,22L12,20M8,2H16V5H22V7H16V10H8V7H2V5H8V2M10,4V8H14V4H10Z",
  },
  {
    id: "6CD0A5FB-8FB8-45E7-9955-A876E4B2ABB4",
    name: "vector-polygon",
    codepoint: "F560",
    aliases: [],
    tags: ["Vector"],
    author: "Cody",
    version: "1.5.54",
    path: "M2,2V8H4.28L5.57,16H4V22H10V20.06L15,20.05V22H21V16H19.17L20,9H22V3H16V6.53L14.8,8H9.59L8,5.82V2M4,4H6V6H4M18,5H20V7H18M6.31,8H7.11L9,10.59V14H15V10.91L16.57,9H18L17.16,16H15V18.06H10V16H7.6M11,10H13V12H11M6,18H8V20H6M17,18H19V20H17",
  },
  {
    id: "1D1C3847-C645-42AE-A93C-DE1E64685762",
    name: "vector-polyline",
    codepoint: "F561",
    aliases: [],
    tags: ["Vector"],
    author: "Cody",
    version: "1.5.54",
    path: "M16,2V8H17.08L14.95,13H14.26L12,9.97V5H6V11H6.91L4.88,16H2V22H8V16H7.04L9.07,11H10.27L12,13.32V19H18V13H17.12L19.25,8H22V2M18,4H20V6H18M8,7H10V9H8M14,15H16V17H14M4,18H6V20H4",
  },
  {
    id: "1B112A31-E2A7-4BAD-B1F1-5289B8811F08",
    name: "vector-radius",
    codepoint: "F749",
    aliases: [],
    tags: ["Vector"],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M2,4H4V2H10V4C15.52,4 20,8.48 20,14H22V20H20V22H18V20H16V14H18C18,9.58 14.42,6 10,6V8H4V6H2V4M18,16V18H20V16H18M6,4V6H8V4H6Z",
  },
  {
    id: "2A12555B-0CBC-4FC9-9F86-88F7785B3B2C",
    name: "vector-rectangle",
    codepoint: "F5C6",
    aliases: [],
    tags: ["Vector"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M2,4H8V6H16V4H22V10H20V14H22V20H16V18H8V20H2V14H4V10H2V4M16,10V8H8V10H6V14H8V16H16V14H18V10H16M4,6V8H6V6H4M18,6V8H20V6H18M4,16V18H6V16H4M18,16V18H20V16H18Z",
  },
  {
    id: "B7C380C9-13D8-4A0E-8EEC-1B4FB23F1FB9",
    name: "vector-selection",
    codepoint: "F562",
    aliases: [],
    tags: ["Vector"],
    author: "Cody",
    version: "1.5.54",
    path: "M3,1H5V3H3V5H1V3C1,1.9 1.9,1 3,1M14,1C15.1,1 16,1.9 16,3V5H14V3H12V1H14M20,7C21.1,7 22,7.9 22,9V11H20V9H18V7H20M22,20C22,21.1 21.1,22 20,22H18V20H20V18H22V20M20,13H22V16H20V13M13,9V7H16V10H14V9H13M13,22V20H16V22H13M9,22C7.9,22 7,21.1 7,20V18H9V20H11V22H9M7,16V13H9V14H10V16H7M7,3V1H10V3H7M3,16C1.9,16 1,15.1 1,14V12H3V14H5V16H3M1,7H3V10H1V7M9,7H11V9H9V11H7V9C7,7.9 7.9,7 9,7M16,14C16,15.1 15.1,16 14,16H12V14H14V12H16V14Z",
  },
  {
    id: "039be9b8-08ad-11e4-bf19-842b2b6cfe1b",
    name: "vector-square",
    codepoint: "F001",
    aliases: ["mdi"],
    tags: ["Vector"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M2,2H8V4H16V2H22V8H20V16H22V22H16V20H8V22H2V16H4V8H2V2M16,8V6H8V8H6V16H8V18H16V16H18V8H16M4,4V6H6V4H4M18,4V6H20V4H18M4,18V20H6V18H4M18,18V20H20V18H18Z",
  },
  {
    id: "CE6EAE27-922A-48B9-83AF-5C333B20724F",
    name: "vector-triangle",
    codepoint: "F563",
    aliases: [],
    tags: ["Vector"],
    author: "Cody",
    version: "1.5.54",
    path: "M9,3V9H9.73L5.79,16H2V22H8V20H16V22H22V16H18.21L14.27,9H15V3M11,5H13V7H11M12,9.04L16,16.15V18H8V16.15M4,18H6V20H4M18,18H20V20H18",
  },
  {
    id: "2FD284B6-3DC1-4733-B08E-BAD459E87B87",
    name: "vector-union",
    codepoint: "F564",
    aliases: [],
    tags: ["Vector"],
    author: "Cody",
    version: "1.5.54",
    path: "M3,1C1.89,1 1,1.89 1,3V14C1,15.11 1.89,16 3,16H7V20C7,21.11 7.89,22 9,22H20C21.11,22 22,21.11 22,20V9C22,7.89 21.11,7 20,7H16V3C16,1.89 15.11,1 14,1H3M3,3H14V9H20V20H9V14H3V3Z",
  },
  {
    id: "551637A8-2091-4439-9710-71199B7AC0C1",
    name: "vhs",
    codepoint: "FA1A",
    aliases: ["video-home-system", "vhs-cassette", "vhs-tape"],
    tags: [],
    author: "GreenTurtwig",
    version: "2.5.94",
    path: "M4,6C2.9,6 2,6.9 2,8V16C2,17.1 2.9,18 4,18H20C21.1,18 22,17.1 22,16V8C22,6.9 21.1,6 20,6H4M4.54,10H7V14H4.54C4.19,13.39 4,12.7 4,12C4,11.3 4.19,10.61 4.54,10M9,10H15V14H9V10M17,10H19.46C19.81,10.61 20,11.3 20,12C20,12.7 19.81,13.39 19.46,14H17V10Z",
  },
  {
    id: "68E64FD4-A020-4DEF-B2CB-5EA5BAA80E42",
    name: "vibrate",
    codepoint: "F566",
    aliases: ["vibration"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M16,19H8V5H16M16.5,3H7.5C6.67,3 6,3.67 6,4.5V19.5C6,20.33 6.67,21 7.5,21H16.5C17.33,21 18,20.33 18,19.5V4.5C18,3.67 17.33,3 16.5,3M19,17H21V7H19M22,9V15H24V9M3,17H5V7H3M0,15H2V9H0V15Z",
  },
  {
    id: "B1337ECC-EF1F-481B-9E75-6A8DB7A01BB9",
    name: "video",
    codepoint: "F567",
    aliases: ["videocam"],
    tags: ["Video / Movie", "Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M17,10.5V7C17,6.45 16.55,6 16,6H4C3.45,6 3,6.45 3,7V17C3,17.55 3.45,18 4,18H16C16.55,18 17,17.55 17,17V13.5L21,17.5V6.5L17,10.5Z",
  },
  {
    id: "3F4D3E00-72CA-4167-A269-F9DD1A94540D",
    name: "video-3d",
    codepoint: "F7FC",
    aliases: [],
    tags: ["Video / Movie", "Video / Movie"],
    author: "Austin Andrews",
    version: "2.0.46",
    path: "M5,7H9C10.1,7 11,7.9 11,9V15C11,16.1 10.1,17 9,17H5V15H9V13H6V11H9V9H5V7M13,7H16C17.66,7 19,8.34 19,10V14C19,15.66 17.66,17 16,17H13V7M16,15C16.55,15 17,14.55 17,14V10C17,9.45 16.55,9 16,9H15V15H16Z",
  },
  {
    id: "FD1999E4-4780-48E5-8F18-606871BA0581",
    name: "video-4k-box",
    codepoint: "F83D",
    aliases: ["4k"],
    tags: [],
    author: "Google",
    version: "2.1.19",
    path: "M5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3M18.09,15L16.08,12L18.09,9H16.36L14.39,12V9H12.89V15H14.39V12L16.36,15H18.09M11.86,13.5V12H10.88V9H9.38V12H7.88V9H6.38V13.5H9.38V15H10.88V13.5H11.86Z",
  },
  {
    id: "F02BE782-F323-40E5-B245-DF7B6AFB2B15",
    name: "video-account",
    codepoint: "F918",
    aliases: ["video-user"],
    tags: ["Account / User", "Video / Movie"],
    author: "Google",
    version: "2.3.50",
    path: "M17,10.5L21,6.5V17.5L17,13.5V17C17,17.55 16.55,18 16,18H4C3.45,18 3,17.55 3,17V7C3,6.45 3.45,6 4,6H16C16.55,6 17,6.45 17,7V10.5M14,16V15C14,13.67 11.33,13 10,13C8.67,13 6,13.67 6,15V16H14M10,8C8.9,8 8,8.9 8,10C8,11.1 8.9,12 10,12C11.1,12 12,11.1 12,10C12,8.9 11.1,8 10,8Z",
  },
  {
    id: "1A06058D-FA25-4AAE-A7C8-225CD0D79F06",
    name: "video-image",
    codepoint: "F919",
    aliases: [],
    tags: ["Video / Movie"],
    author: "Google",
    version: "2.3.50",
    path: "M17,10.5L21,6.5V17.5L17,13.5V17C17,17.55 16.55,18 16,18H4C3.45,18 3,17.55 3,17V7C3,6.45 3.45,6 4,6H16C16.55,6 17,6.45 17,7V10.5M10.91,9.55L9.2,11.82L10.5,13.55L9.77,14.09L7.73,11.36L5,15H15L10.91,9.55Z",
  },
  {
    id: "D7B7AA15-66CB-4AA5-AD75-E96B78B89AB9",
    name: "video-input-antenna",
    codepoint: "F83E",
    aliases: ["settings-input-antenna"],
    tags: [],
    author: "Google",
    version: "2.1.19",
    path: "M12,5C8.13,5 5,8.13 5,12H7C7,9.24 9.24,7 12,7C14.76,7 17,9.24 17,12H19C19,8.13 15.87,5 12,5M13,14.29C13.88,13.9 14.5,13.03 14.5,12C14.5,10.62 13.38,9.5 12,9.5C10.62,9.5 9.5,10.62 9.5,12C9.5,13 10.12,13.9 11,14.29V17.59L7.59,21L9,22.41L12,19.41L15,22.41L16.41,21L13,17.59V14.29M12,1C5.92,1 1,5.92 1,12H3C3,7.03 7.03,3 12,3C16.97,3 21,7.03 21,12H23C23,5.92 18.08,1 12,1Z",
  },
  {
    id: "55F413A7-319D-4419-87D4-97FF9ED96791",
    name: "video-input-component",
    codepoint: "F83F",
    aliases: [
      "video-input-composite",
      "settings-input-component",
      "settings-input-composite",
      "video-input-ypbpr",
      "rca",
    ],
    tags: [],
    author: "Google",
    version: "2.1.19",
    path: "M5,2C5,1.45 4.55,1 4,1C3.45,1 3,1.45 3,2V6H1V12H7V6H5V2M9,16C9,17.3 9.84,18.4 11,18.82V23H13V18.82C14.16,18.41 15,17.31 15,16V14H9V16M1,16C1,17.3 1.84,18.4 3,18.82V23H5V18.82C6.16,18.4 7,17.3 7,16V14H1V16M21,6V2C21,1.45 20.55,1 20,1C19.45,1 19,1.45 19,2V6H17V12H23V6H21M13,2C13,1.45 12.55,1 12,1C11.45,1 11,1.45 11,2V6H9V12H15V6H13V2M17,16C17,17.3 17.84,18.4 19,18.82V23H21V18.82C22.16,18.41 23,17.31 23,16V14H17V16Z",
  },
  {
    id: "D371C4A6-40A8-4C03-95DA-2ACF2A5ABC4B",
    name: "video-input-hdmi",
    codepoint: "F840",
    aliases: ["settings-input-hdmi"],
    tags: [],
    author: "Google",
    version: "2.1.19",
    path: "M18,7V4C18,2.9 17.1,2 16,2H8C6.9,2 6,2.9 6,4V7H5V13L8,19V22H16V19L19,13V7H18M8,4H16V7H14V5H13V7H11V5H10V7H8V4Z",
  },
  {
    id: "EA3FB3E6-9696-4F01-AD34-5253E19EA34C",
    name: "video-input-svideo",
    codepoint: "F841",
    aliases: ["settings-input-svideo"],
    tags: [],
    author: "Google",
    version: "2.1.19",
    path: "M8,11.5C8,10.67 7.33,10 6.5,10C5.67,10 5,10.67 5,11.5C5,12.33 5.67,13 6.5,13C7.33,13 8,12.33 8,11.5M15,6.5C15,5.67 14.33,5 13.5,5H10.5C9.67,5 9,5.67 9,6.5C9,7.33 9.67,8 10.5,8H13.5C14.33,8 15,7.33 15,6.5M8.5,15C7.67,15 7,15.67 7,16.5C7,17.33 7.67,18 8.5,18C9.33,18 10,17.33 10,16.5C10,15.67 9.33,15 8.5,15M12,1C5.92,1 1,5.92 1,12C1,18.08 5.92,23 12,23C18.08,23 23,18.08 23,12C23,5.92 18.08,1 12,1M12,21C7.04,21 3,16.96 3,12C3,7.04 7.04,3 12,3C16.96,3 21,7.04 21,12C21,16.96 16.96,21 12,21M17.5,10C16.67,10 16,10.67 16,11.5C16,12.33 16.67,13 17.5,13C18.33,13 19,12.33 19,11.5C19,10.67 18.33,10 17.5,10M15.5,15C14.67,15 14,15.67 14,16.5C14,17.33 14.67,18 15.5,18C16.33,18 17,17.33 17,16.5C17,15.67 16.33,15 15.5,15Z",
  },
  {
    id: "9453CFB6-B0CA-469B-87A0-48C51EA1B64D",
    name: "video-minus",
    codepoint: "F9B1",
    aliases: [],
    tags: ["Video / Movie"],
    author: "Google",
    version: "2.4.85",
    path: "M17,10.5V7C17,6.45 16.55,6 16,6H4C3.45,6 3,6.45 3,7V17C3,17.55 3.45,18 4,18H16C16.55,18 17,17.55 17,17V13.5L21,17.5V6.5L17,10.5M14,13H6V11H14V13Z",
  },
  {
    id: "F4C3A814-205E-4F0A-9B3D-34B5777A4237",
    name: "video-off",
    codepoint: "F568",
    aliases: ["videocam-off"],
    tags: ["Video / Movie", "Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M3.27,2L2,3.27L4.73,6H4C3.45,6 3,6.45 3,7V17C3,17.55 3.45,18 4,18H16C16.2,18 16.39,17.92 16.54,17.82L19.73,21L21,19.73M21,6.5L17,10.5V7C17,6.45 16.55,6 16,6H9.82L21,17.18V6.5Z",
  },
  {
    id: "7C399890-F840-44F0-834E-409C1D9F1337",
    name: "video-plus",
    codepoint: "F9B2",
    aliases: ["video-call"],
    tags: ["Video / Movie"],
    author: "Google",
    version: "2.4.85",
    path: "M17,10.5V7C17,6.45 16.55,6 16,6H4C3.45,6 3,6.45 3,7V17C3,17.55 3.45,18 4,18H16C16.55,18 17,17.55 17,17V13.5L21,17.5V6.5L17,10.5M14,13H11V16H9V13H6V11H9V8H11V11H14V13Z",
  },
  {
    id: "DF10672F-0064-47B8-A327-797095F0F6A1",
    name: "video-stabilization",
    codepoint: "F91A",
    aliases: ["video-stabilisation"],
    tags: [],
    author: "Google",
    version: "2.3.50",
    path: "M4,4H20C21.1,4 22,4.9 22,6V18C22,19.1 21.1,20 20,20H4C2.9,20 2,19.1 2,18V6C2,4.9 2.9,4 4,4M4,6V18H20V6H4M7.24,6.58L18.83,9.69L16.76,17.42L5.17,14.31L7.24,6.58Z",
  },
  {
    id: "465D18D8-ABEA-4D2B-8A05-C6555C36803F",
    name: "video-switch",
    codepoint: "F569",
    aliases: ["switch-video"],
    tags: ["Video / Movie"],
    author: "Google",
    version: "1.5.54",
    path: "M13,15.5V13H7V15.5L3.5,12L7,8.5V11H13V8.5L16.5,12M18,9.5V6C18,5.45 17.55,5 17,5H3C2.45,5 2,5.45 2,6V18C2,18.55 2.45,19 3,19H17C17.55,19 18,18.55 18,18V14.5L22,18.5V5.5L18,9.5Z",
  },
  {
    id: "1A8E4CC1-97A7-4593-BE20-0E9C5686C2D3",
    name: "video-vintage",
    codepoint: "FA1B",
    aliases: ["video-film", "video-classic"],
    tags: [],
    author: "Contributors",
    version: "2.5.94",
    path: "M18,14.5V11C18,10.45 17.55,10 17,10H16C18.24,8.39 18.76,5.27 17.15,3C15.54,0.78 12.42,0.26 10.17,1.87C9.5,2.35 8.96,3 8.6,3.73C6.25,2.28 3.17,3 1.72,5.37C0.28,7.72 1,10.8 3.36,12.25C3.57,12.37 3.78,12.5 4,12.58V21C4,21.55 4.45,22 5,22H17C17.55,22 18,21.55 18,21V17.5L22,21.5V10.5L18,14.5M13,4C14.1,4 15,4.9 15,6C15,7.1 14.1,8 13,8C11.9,8 11,7.1 11,6C11,4.9 11.9,4 13,4M6,6C7.1,6 8,6.9 8,8C8,9.1 7.1,10 6,10C4.9,10 4,9.1 4,8C4,6.9 4.9,6 6,6Z",
  },
  {
    id: "E0B1CD58-0403-430F-AA9A-30B9E0122314",
    name: "view-agenda",
    codepoint: "F56A",
    aliases: [],
    tags: ["View"],
    author: "Google",
    version: "1.5.54",
    path: "M20,3H3C2.45,3 2,3.45 2,4V10C2,10.55 2.45,11 3,11H20C20.55,11 21,10.55 21,10V4C21,3.45 20.55,3 20,3M20,13H3C2.45,13 2,13.45 2,14V20C2,20.55 2.45,21 3,21H20C20.55,21 21,20.55 21,20V14C21,13.45 20.55,13 20,13Z",
  },
  {
    id: "B3E07750-AF3A-49FA-BA72-7CE5D4A3C7AB",
    name: "view-array",
    codepoint: "F56B",
    aliases: [],
    tags: ["View"],
    author: "Google",
    version: "1.5.54",
    path: "M8,18H17V5H8M18,5V18H21V5M4,18H7V5H4V18Z",
  },
  {
    id: "99C269BA-B1CD-4BC0-9BCC-7C5D95F881AC",
    name: "view-carousel",
    codepoint: "F56C",
    aliases: [],
    tags: ["View"],
    author: "Google",
    version: "1.5.54",
    path: "M18,6V17H22V6M2,17H6V6H2M7,19H17V4H7V19Z",
  },
  {
    id: "163CB77E-4663-4F8E-B73E-20FCC5C5BED3",
    name: "view-column",
    codepoint: "F56D",
    aliases: [],
    tags: ["View"],
    author: "Google",
    version: "1.5.54",
    path: "M16,5V18H21V5M4,18H9V5H4M10,18H15V5H10V18Z",
  },
  {
    id: "B6D8B213-DC5F-40D3-97E4-EFA9B499A19D",
    name: "view-dashboard",
    codepoint: "F56E",
    aliases: [],
    tags: ["View"],
    author: "Google",
    version: "1.5.54",
    path: "M13,3V9H21V3M13,21H21V11H13M3,21H11V15H3M3,13H11V3H3V13Z",
  },
  {
    id: "B44B2BB0-0BF9-42B7-BF70-ECC7FF102520",
    name: "view-dashboard-outline",
    codepoint: "FA1C",
    aliases: [],
    tags: [],
    author: "Google",
    version: "2.5.94",
    path: "M19,5V7H15V5H19M9,5V11H5V5H9M19,13V19H15V13H19M9,17V19H5V17H9M21,3H13V9H21V3M11,3H3V13H11V3M21,11H13V21H21V11M11,15H3V21H11V15Z",
  },
  {
    id: "26B319A5-9CF7-4637-94A2-DB633BD22ABA",
    name: "view-dashboard-variant",
    codepoint: "F842",
    aliases: [],
    tags: ["View"],
    author: "Google",
    version: "2.1.19",
    path: "M2,5V19H8V5H2M9,5V10H15V5H9M16,5V14H22V5H16M9,11V19H15V11H9M16,15V19H22V15H16Z",
  },
  {
    id: "AD31242E-143E-475E-822B-E363C9E9F2F4",
    name: "view-day",
    codepoint: "F56F",
    aliases: [],
    tags: ["View"],
    author: "Google",
    version: "1.5.54",
    path: "M2,3V6H21V3M20,8H3C2.45,8 2,8.45 2,9V15C2,15.55 2.45,16 3,16H20C20.55,16 21,15.55 21,15V9C21,8.45 20.55,8 20,8M2,21H21V18H2V21Z",
  },
  {
    id: "E788F50B-B654-4AEC-ACD7-6E9F5AE8B789",
    name: "view-grid",
    codepoint: "F570",
    aliases: [],
    tags: ["View"],
    author: "Cody",
    version: "1.5.54",
    path: "M3,11H11V3H3M3,21H11V13H3M13,21H21V13H13M13,3V11H21V3",
  },
  {
    id: "86DC0560-F109-4301-ACC7-46A6F74F441A",
    name: "view-headline",
    codepoint: "F571",
    aliases: [],
    tags: ["View"],
    author: "Google",
    version: "1.5.54",
    path: "M4,5V7H21V5M4,11H21V9H4M4,19H21V17H4M4,15H21V13H4V15Z",
  },
  {
    id: "D9FCEB1D-004D-442E-A979-320101768F99",
    name: "view-list",
    codepoint: "F572",
    aliases: [],
    tags: ["View"],
    author: "Google",
    version: "1.5.54",
    path: "M9,5V9H21V5M9,19H21V15H9M9,14H21V10H9M4,9H8V5H4M4,19H8V15H4M4,14H8V10H4V14Z",
  },
  {
    id: "467C52AB-0DEA-43AF-BAE4-76FD66D6C7F0",
    name: "view-module",
    codepoint: "F573",
    aliases: [],
    tags: ["View"],
    author: "Google",
    version: "1.5.54",
    path: "M16,5V11H21V5M10,11H15V5H10M16,18H21V12H16M10,18H15V12H10M4,18H9V12H4M4,11H9V5H4V11Z",
  },
  {
    id: "A085C7C7-F5C5-441C-84C0-05EB3B6A8767",
    name: "view-parallel",
    codepoint: "F727",
    aliases: [],
    tags: ["View"],
    author: "Michael Irigoyen",
    version: "1.8.36",
    path: "M4,21V3H8V21H4M10,21V3H14V21H10M16,21V3H20V21H16Z",
  },
  {
    id: "F3640F38-D10F-42C8-8A68-751D965B1F65",
    name: "view-quilt",
    codepoint: "F574",
    aliases: [],
    tags: ["View"],
    author: "Google",
    version: "1.5.54",
    path: "M10,5V11H21V5M16,18H21V12H16M4,18H9V5H4M10,18H15V12H10V18Z",
  },
  {
    id: "350F115F-0C20-4AB3-8206-81D2A25A2EF4",
    name: "view-sequential",
    codepoint: "F728",
    aliases: [],
    tags: ["View"],
    author: "Michael Irigoyen",
    version: "1.8.36",
    path: "M3,4H21V8H3V4M3,10H21V14H3V10M3,16H21V20H3V16Z",
  },
  {
    id: "1B42A4BC-3B55-4C21-BDEF-94DC970012F9",
    name: "view-stream",
    codepoint: "F575",
    aliases: [],
    tags: ["View"],
    author: "Google",
    version: "1.5.54",
    path: "M4,5V11H21V5M4,18H21V12H4V18Z",
  },
  {
    id: "8ED74862-BA7D-43FC-91EA-283D655B451F",
    name: "view-week",
    codepoint: "F576",
    aliases: [],
    tags: ["View"],
    author: "Google",
    version: "1.5.54",
    path: "M13,5H10C9.45,5 9,5.45 9,6V18C9,18.55 9.45,19 10,19H13C13.55,19 14,18.55 14,18V6C14,5.45 13.55,5 13,5M20,5H17C16.45,5 16,5.45 16,6V18C16,18.55 16.45,19 17,19H20C20.55,19 21,18.55 21,18V6C21,5.45 20.55,5 20,5M6,5H3C2.45,5 2,5.45 2,6V18C2,18.55 2.45,19 3,19H6C6.55,19 7,18.55 7,18V6C7,5.45 6.55,5 6,5Z",
  },
  {
    id: "0FF21C45-66B4-492A-829C-9F46778323A9",
    name: "vimeo",
    codepoint: "F577",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M22,7.42C21.91,9.37 20.55,12.04 17.92,15.44C15.2,19 12.9,20.75 11,20.75C9.85,20.75 8.86,19.67 8.05,17.5C7.5,15.54 7,13.56 6.44,11.58C5.84,9.42 5.2,8.34 4.5,8.34C4.36,8.34 3.84,8.66 2.94,9.29L2,8.07C3,7.2 3.96,6.33 4.92,5.46C6.24,4.32 7.23,3.72 7.88,3.66C9.44,3.5 10.4,4.58 10.76,6.86C11.15,9.33 11.42,10.86 11.57,11.46C12,13.5 12.5,14.5 13.05,14.5C13.47,14.5 14.1,13.86 14.94,12.53C15.78,11.21 16.23,10.2 16.29,9.5C16.41,8.36 15.96,7.79 14.94,7.79C14.46,7.79 13.97,7.9 13.46,8.12C14.44,4.89 16.32,3.32 19.09,3.41C21.15,3.47 22.12,4.81 22,7.42Z",
  },
  {
    id: "D6702650-990F-416E-BF27-F6F2B86BFB8D",
    name: "violin",
    codepoint: "F60F",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M11,2C10.45,2 10,2.45 10,3V5L10,9C10,9.28 10.22,9.5 10.5,9.5H12C12.28,9.5 12.5,9.72 12.5,10C12.5,10.28 12.28,10.5 12,10.5H10.5C9.73,10.5 9,9.77 9,9V5.16C7.27,5.6 6,7.13 6,9V10.5C7.38,10.5 8.5,11.62 8.5,13C8.5,14.38 7.38,15.5 6,15.5V17C6,19.77 8.23,22 11,22H13C15.77,22 18,19.77 18,17V15.5C16.62,15.5 15.5,14.38 15.5,13C15.5,11.62 16.62,10.5 18,10.5V9C18,6.78 16.22,5 14,5V3C14,2.45 13.55,2 13,2H11M10.75,16.5H13.25L12.75,20H11.25L10.75,16.5Z",
  },
  {
    id: "AE3F0BAE-DE0A-4BFE-82B6-3268D1B21006",
    name: "virtual-reality",
    codepoint: "F893",
    aliases: ["vr"],
    tags: [],
    author: "GreenTurtwig",
    version: "2.1.99",
    path: "M5,3C3.89,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3H5M6,9H7.5L8.5,12.43L9.5,9H11L9.25,15H7.75L6,9M13,9H16.5C17.35,9 18,9.65 18,10.5V11.5C18,12.1 17.6,12.65 17.1,12.9L18,15H16.5L15.65,13H14.5V15H13V9M14.5,10.5V11.5H16.5V10.5H14.5Z",
  },
  {
    id: "9098736F-D298-4724-AE04-6BEA124F3854",
    name: "vk",
    codepoint: "F579",
    aliases: ["vkontakte"],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M20.8,7.74C20.93,7.32 20.8,7 20.18,7H18.16C17.64,7 17.41,7.27 17.28,7.57C17.28,7.57 16.25,10.08 14.79,11.72C14.31,12.19 14.1,12.34 13.84,12.34C13.71,12.34 13.5,12.19 13.5,11.76V7.74C13.5,7.23 13.38,7 12.95,7H9.76C9.44,7 9.25,7.24 9.25,7.47C9.25,7.95 10,8.07 10.05,9.44V12.42C10.05,13.08 9.93,13.2 9.68,13.2C9,13.2 7.32,10.67 6.33,7.79C6.13,7.23 5.94,7 5.42,7H3.39C2.82,7 2.7,7.27 2.7,7.57C2.7,8.11 3.39,10.77 5.9,14.29C7.57,16.7 9.93,18 12.08,18C13.37,18 13.53,17.71 13.53,17.21V15.39C13.53,14.82 13.65,14.7 14.06,14.7C14.36,14.7 14.87,14.85 16.07,16C17.45,17.38 17.67,18 18.45,18H20.47C21.05,18 21.34,17.71 21.18,17.14C21,16.57 20.34,15.74 19.47,14.76C19,14.21 18.29,13.61 18.07,13.3C17.77,12.92 17.86,12.75 18.07,12.4C18.07,12.4 20.54,8.93 20.8,7.74Z",
  },
  {
    id: "3695CD89-BCB2-4D10-A8C5-9190F31F7C92",
    name: "vlc",
    codepoint: "F57C",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Christopher Schreiner",
    version: "1.5.54",
    path: "M12,1C11.58,1 11.19,1.23 11,1.75L9.88,4.88C10.36,5.4 11.28,5.5 12,5.5C12.72,5.5 13.64,5.4 14.13,4.88L13,1.75C12.82,1.25 12.42,1 12,1M8.44,8.91L7,12.91C8.07,14.27 10.26,14.5 12,14.5C13.74,14.5 15.93,14.27 17,12.91L15.56,8.91C14.76,9.83 13.24,10 12,10C10.76,10 9.24,9.83 8.44,8.91M5.44,15C4.62,15 3.76,15.65 3.53,16.44L2.06,21.56C1.84,22.35 2.3,23 3.13,23H20.88C21.7,23 22.16,22.35 21.94,21.56L20.47,16.44C20.24,15.65 19.38,15 18.56,15H17.75L18.09,15.97C18.21,16.29 18.29,16.69 18.09,16.97C16.84,18.7 14.14,19 12,19C9.86,19 7.16,18.7 5.91,16.97C5.71,16.69 5.79,16.29 5.91,15.97L6.25,15H5.44Z",
  },
  {
    id: "04CEF7C6-E77F-4A66-89F3-2F5B544C482B",
    name: "voicemail",
    codepoint: "F57D",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M18.5,15C16.57,15 15,13.43 15,11.5C15,9.57 16.57,8 18.5,8C20.43,8 22,9.57 22,11.5C22,13.43 20.43,15 18.5,15M5.5,15C3.57,15 2,13.43 2,11.5C2,9.57 3.57,8 5.5,8C7.43,8 9,9.57 9,11.5C9,13.43 7.43,15 5.5,15M18.5,6C15.46,6 13,8.46 13,11.5C13,12.83 13.47,14.05 14.26,15H9.74C10.53,14.05 11,12.83 11,11.5C11,8.46 8.54,6 5.5,6C2.46,6 0,8.46 0,11.5C0,14.54 2.46,17 5.5,17H18.5C21.54,17 24,14.54 24,11.5C24,8.46 21.54,6 18.5,6Z",
  },
  {
    id: "3978DABC-FC98-4D3E-A971-88716AD5D600",
    name: "volleyball",
    codepoint: "F9B3",
    aliases: [],
    tags: ["Sport"],
    author: "Augustin Ursu",
    version: "2.4.85",
    path: "M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M13.6,20.35C15.96,18.04 17.69,15.08 18.5,11.76C17.84,11.62 17.18,11.54 16.5,11.5C15.56,15.11 13.41,18.22 10.5,20.37C11,20.45 11.5,20.5 12,20.5C12.55,20.5 13.08,20.45 13.6,20.35M9.23,20.04C12.23,18.07 14.5,15.05 15.46,11.5C14.71,11.55 13.97,11.65 13.27,11.81C12.18,14.89 9.97,17.44 7.13,18.97C7.77,19.42 8.5,19.78 9.23,20.04M20.5,12.37C20.16,12.23 19.81,12.11 19.46,12C18.76,14.9 17.39,17.53 15.54,19.73C18.36,18.44 20.35,15.64 20.5,12.37M3.56,11.04C3.5,11.35 3.5,11.68 3.5,12C3.5,14.5 4.57,16.73 6.27,18.28C6.86,18 7.41,17.66 7.94,17.29C6.08,15.54 4.58,13.41 3.56,11.04M5.33,6.74C4.73,7.5 4.26,8.35 3.95,9.28C4.92,12.13 6.58,14.66 8.74,16.67C9.25,16.24 9.72,15.77 10.15,15.26C7.74,13.03 6,10.08 5.33,6.74M8.04,4.5C7.36,4.85 6.73,5.3 6.18,5.82C6.71,9.21 8.37,12.23 10.77,14.47C11.17,13.91 11.5,13.32 11.82,12.7C9.68,10.56 8.28,7.69 8.04,4.5M19.96,9.03C18.7,8.68 17.37,8.5 16,8.5C14.1,8.5 12.28,8.85 10.61,9.5C10.96,10.1 11.35,10.67 11.8,11.2C13.12,10.75 14.53,10.5 16,10.5C17.57,10.5 19.08,10.78 20.47,11.29C20.4,10.5 20.23,9.74 19.96,9.03M17.54,5.57C17.03,5.5 16.5,5.5 16,5.5C13.69,5.5 11.47,5.94 9.44,6.73C9.62,7.38 9.86,8 10.14,8.61C11.96,7.89 13.93,7.5 16,7.5C17.18,7.5 18.32,7.63 19.42,7.87C18.93,7 18.29,6.21 17.54,5.57M16,4.5C14.79,3.87 13.44,3.5 12,3.5C10.95,3.5 9.94,3.7 9,4.05C9.04,4.63 9.11,5.2 9.21,5.75C11.31,4.95 13.6,4.5 16,4.5Z",
  },
  {
    id: "CE6E08CF-2476-4BBB-AF91-6D081F1CBEF9",
    name: "volume-high",
    codepoint: "F57E",
    aliases: ["audio", "speaker", "speakerphone"],
    tags: ["Audio", "Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M14,3.23V5.29C16.89,6.15 19,8.83 19,12C19,15.17 16.89,17.84 14,18.7V20.77C18,19.86 21,16.28 21,12C21,7.72 18,4.14 14,3.23M16.5,12C16.5,10.23 15.5,8.71 14,7.97V16C15.5,15.29 16.5,13.76 16.5,12M3,9V15H7L12,20V4L7,9H3Z",
  },
  {
    id: "213621FE-E003-4B40-9385-B9BCE19DB035",
    name: "volume-low",
    codepoint: "F57F",
    aliases: ["audio", "speaker"],
    tags: ["Audio", "Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M7,9V15H11L16,20V4L11,9H7Z",
  },
  {
    id: "0E37E506-8AD8-42C7-87E4-F8A2AEE03972",
    name: "volume-medium",
    codepoint: "F580",
    aliases: ["audio", "speaker"],
    tags: ["Audio", "Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M5,9V15H9L14,20V4L9,9M18.5,12C18.5,10.23 17.5,8.71 16,7.97V16C17.5,15.29 18.5,13.76 18.5,12Z",
  },
  {
    id: "D8BFD10F-6D55-4EE1-8D30-5B5CB064CBBF",
    name: "volume-minus",
    codepoint: "F75D",
    aliases: [],
    tags: ["Audio", "Home Automation"],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M3,9H7L12,4V20L7,15H3V9M14,11H22V13H14V11Z",
  },
  {
    id: "A78C1259-0DB5-4793-9EA9-DD69FEB337A8",
    name: "volume-mute",
    codepoint: "F75E",
    aliases: [],
    tags: ["Audio"],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M3,9H7L12,4V20L7,15H3V9M16.59,12L14,9.41L15.41,8L18,10.59L20.59,8L22,9.41L19.41,12L22,14.59L20.59,16L18,13.41L15.41,16L14,14.59L16.59,12Z",
  },
  {
    id: "74834C94-6AE1-493B-A9FB-4EE2A8FD989C",
    name: "volume-off",
    codepoint: "F581",
    aliases: ["mute", "audio-off", "speaker-off", "speakerphone-off"],
    tags: ["Audio", "Home Automation"],
    author: "Google",
    version: "1.5.54",
    path: "M12,4L9.91,6.09L12,8.18M4.27,3L3,4.27L7.73,9H3V15H7L12,20V13.27L16.25,17.53C15.58,18.04 14.83,18.46 14,18.7V20.77C15.38,20.45 16.63,19.82 17.68,18.96L19.73,21L21,19.73L12,10.73M19,12C19,12.94 18.8,13.82 18.46,14.64L19.97,16.15C20.62,14.91 21,13.5 21,12C21,7.72 18,4.14 14,3.23V5.29C16.89,6.15 19,8.83 19,12M16.5,12C16.5,10.23 15.5,8.71 14,7.97V10.18L16.45,12.63C16.5,12.43 16.5,12.21 16.5,12Z",
  },
  {
    id: "DECF3A51-F972-4D34-815D-D103BCE3888B",
    name: "volume-plus",
    codepoint: "F75C",
    aliases: [],
    tags: ["Audio", "Home Automation"],
    author: "Austin Andrews",
    version: "1.9.32",
    path: "M3,9H7L12,4V20L7,15H3V9M14,11H17V8H19V11H22V13H19V16H17V13H14V11Z",
  },
  {
    id: "61CDB722-3238-4F21-9A3F-77DC47A51755",
    name: "vote",
    codepoint: "FA1E",
    aliases: ["how-to-vote"],
    tags: [],
    author: "Google",
    version: "2.5.94",
    path: "M18,13H17.32L15.32,15H17.23L19,17H5L6.78,15H8.83L6.83,13H6L3,16V20C3,21.1 3.9,22 5,22H19C20.1,22 21,21.1 21,20V16L18,13M17,7.95L12.05,12.9L8.5,9.36L13.46,4.41L17,7.95M12.76,2.29L6.39,8.66C6,9.05 6,9.68 6.39,10.07L11.34,15C11.73,15.41 12.36,15.41 12.75,15L19.11,8.66C19.5,8.27 19.5,7.64 19.11,7.25L14.16,2.3C13.78,1.9 13.15,1.9 12.76,2.29Z",
  },
  {
    id: "392D2435-0B0E-4CDA-A542-FAB319411B8A",
    name: "vote-outline",
    codepoint: "FA1F",
    aliases: ["how-to-vote-outline"],
    tags: [],
    author: "Google",
    version: "2.5.94",
    path: "M18,13L21,16V20C21,21.11 20.1,22 19,22H5C3.89,22 3,21.1 3,20V16L6,13H6.83L8.83,15H6.78L5,17H19L17.23,15H15.32L17.32,13H18M19,20V19H5V20H19M11.34,15L6.39,10.07C6,9.68 6,9.05 6.39,8.66L12.76,2.29C13.15,1.9 13.78,1.9 14.16,2.3L19.11,7.25C19.5,7.64 19.5,8.27 19.11,8.66L12.75,15C12.36,15.41 11.73,15.41 11.34,15M13.46,4.41L8.5,9.36L12.05,12.9L17,7.95L13.46,4.41Z",
  },
  {
    id: "A9EE1532-2932-4F71-95DC-1EFB56BA4DFC",
    name: "vpn",
    codepoint: "F582",
    aliases: ["virtual-private-network"],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M9,5H15L12,8L9,5M10.5,14.66C10.2,15 10,15.5 10,16C10,17.1 10.9,18 12,18C13.1,18 14,17.1 14,16C14,15.45 13.78,14.95 13.41,14.59L14.83,13.17C15.55,13.9 16,14.9 16,16C16,18.21 14.21,20 12,20C9.79,20 8,18.21 8,16C8,14.93 8.42,13.96 9.1,13.25L9.09,13.24L16.17,6.17V6.17C16.89,5.45 17.89,5 19,5C21.21,5 23,6.79 23,9C23,11.21 21.21,13 19,13C17.9,13 16.9,12.55 16.17,11.83L17.59,10.41C17.95,10.78 18.45,11 19,11C20.1,11 21,10.1 21,9C21,7.9 20.1,7 19,7C18.45,7 17.95,7.22 17.59,7.59L10.5,14.66M6.41,7.59C6.05,7.22 5.55,7 5,7C3.9,7 3,7.9 3,9C3,10.1 3.9,11 5,11C5.55,11 6.05,10.78 6.41,10.41L7.83,11.83C7.1,12.55 6.1,13 5,13C2.79,13 1,11.21 1,9C1,6.79 2.79,5 5,5C6.11,5 7.11,5.45 7.83,6.17V6.17L10.59,8.93L9.17,10.35L6.41,7.59Z",
  },
  {
    id: "CB3BC222-1858-41C6-A488-0C2BB1FB2EA8",
    name: "vuejs",
    codepoint: "F843",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "2.1.19",
    path: "M2,3H5.5L12,15L18.5,3H22L12,21L2,3M6.5,3H9.5L12,7.58L14.5,3H17.5L12,13.08L6.5,3Z",
  },
  {
    id: "DA42DA16-21E0-4A08-89E4-F634EBBCF85A",
    name: "walk",
    codepoint: "F583",
    aliases: ["directions-walk"],
    tags: ["Sport"],
    author: "Google",
    version: "1.5.54",
    path: "M14.12,10H19V8.2H15.38L13.38,4.87C13.08,4.37 12.54,4.03 11.92,4.03C11.74,4.03 11.58,4.06 11.42,4.11L6,5.8V11H7.8V7.33L9.91,6.67L6,22H7.8L10.67,13.89L13,17V22H14.8V15.59L12.31,11.05L13.04,8.18M14,3.8C15,3.8 15.8,3 15.8,2C15.8,1 15,0.2 14,0.2C13,0.2 12.2,1 12.2,2C12.2,3 13,3.8 14,3.8Z",
  },
  {
    id: "5DAB0112-3768-4ADC-8796-A88B4473FE56",
    name: "wall",
    codepoint: "F7FD",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "2.0.46",
    path: "M3,16H12V21H3V16M2,10H8V15H2V10M9,10H15V15H9V10M16,10H22V15H16V10M13,16H21V21H13V16M3,4H11V9H3V4M12,4H21V9H12V4Z",
  },
  {
    id: "EABFE131-4690-406C-9042-EFCA33E97A00",
    name: "wall-sconce",
    codepoint: "F91B",
    aliases: [],
    tags: ["Home Automation"],
    author: "GreenTurtwig",
    version: "2.3.50",
    path: "M11,4L7,13H19L15,4H11M4,14V22H6V19H14V14H12V17H6V14H4Z",
  },
  {
    id: "4F0EF72A-F2A8-4BFA-9E6F-279E159FC888",
    name: "wall-sconce-flat",
    codepoint: "F91C",
    aliases: [],
    tags: ["Home Automation"],
    author: "GreenTurtwig",
    version: "2.3.50",
    path: "M5,5V11H19V5H5M5.27,13.32L3.5,15.09L4.91,16.5L6.68,14.73L5.27,13.32M18.73,13.32L17.32,14.73L19.09,16.5L20.5,15.09L18.73,13.32M11,16V19H13V16H11Z",
  },
  {
    id: "C5ABA786-D897-4770-AA78-CE4CB2A9230E",
    name: "wallet",
    codepoint: "F584",
    aliases: ["account-balance-wallet"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M21,18V19C21,20.1 20.1,21 19,21H5C3.89,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3H19C20.1,3 21,3.9 21,5V6H12C10.89,6 10,6.9 10,8V16C10,17.1 10.9,18 12,18M12,16H22V8H12M16,13.5C15.17,13.5 14.5,12.83 14.5,12C14.5,11.17 15.17,10.5 16,10.5C16.83,10.5 17.5,11.17 17.5,12C17.5,12.83 16.83,13.5 16,13.5Z",
  },
  {
    id: "0D4DD4F1-0915-4D3D-8F21-A96C2DDAF6E0",
    name: "wallet-giftcard",
    codepoint: "F585",
    aliases: ["card-giftcard", "redeem"],
    tags: ["Shopping"],
    author: "Google",
    version: "1.5.54",
    path: "M20,14H4V8H9.08L7,10.83L8.62,12L11,8.76L12,7.4L13,8.76L15.38,12L17,10.83L14.92,8H20M20,19H4V17H20M9,4C9.55,4 10,4.45 10,5C10,5.55 9.55,6 9,6C8.45,6 8,5.55 8,5C8,4.45 8.45,4 9,4M15,4C15.55,4 16,4.45 16,5C16,5.55 15.55,6 15,6C14.45,6 14,5.55 14,5C14,4.45 14.45,4 15,4M20,6H17.82C17.93,5.69 18,5.35 18,5C18,3.34 16.66,2 15,2C13.95,2 13.04,2.54 12.5,3.35L12,4L11.5,3.34C10.96,2.54 10.05,2 9,2C7.34,2 6,3.34 6,5C6,5.35 6.07,5.69 6.18,6H4C2.89,6 2,6.89 2,8V19C2,20.11 2.89,21 4,21H20C21.11,21 22,20.11 22,19V8C22,6.89 21.11,6 20,6Z",
  },
  {
    id: "BBE325B3-416A-4160-8E95-162B076B8839",
    name: "wallet-membership",
    codepoint: "F586",
    aliases: ["card-membership"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M20,10H4V4H20M20,15H4V13H20M20,2H4C2.89,2 2,2.89 2,4V15C2,16.11 2.89,17 4,17H8V22L12,20L16,22V17H20C21.11,17 22,16.11 22,15V4C22,2.89 21.11,2 20,2Z",
  },
  {
    id: "790A03D3-B40A-468A-A6D6-CA3679FDBD8D",
    name: "wallet-travel",
    codepoint: "F587",
    aliases: ["card-travel"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M20,14H4V8H7V10H9V8H15V10H17V8H20M20,19H4V17H20M9,4H15V6H9M20,6H17V4C17,2.89 16.11,2 15,2H9C7.89,2 7,2.89 7,4V6H4C2.89,6 2,6.89 2,8V19C2,20.11 2.89,21 4,21H20C21.11,21 22,20.11 22,19V8C22,6.89 21.11,6 20,6Z",
  },
  {
    id: "0E468855-81AF-4CA1-ACF0-D166D07F188C",
    name: "wan",
    codepoint: "F588",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M12,2C7.58,2 4,5.58 4,10C4,14.03 7,17.42 11,17.93V19H10C9.45,19 9,19.45 9,20H2V22H9C9,22.55 9.45,23 10,23H14C14.55,23 15,22.55 15,22H22V20H15C15,19.45 14.55,19 14,19H13V17.93C17,17.43 20,14.03 20,10C20,5.58 16.42,2 12,2M12,4C12,4 12.74,5.28 13.26,7H10.74C11.26,5.28 12,4 12,4M9.77,4.43C9.5,4.93 9.09,5.84 8.74,7H6.81C7.5,5.84 8.5,4.93 9.77,4.43M14.23,4.44C15.5,4.94 16.5,5.84 17.19,7H15.26C14.91,5.84 14.5,4.93 14.23,4.44M6.09,9H8.32C8.28,9.33 8.25,9.66 8.25,10C8.25,10.34 8.28,10.67 8.32,11H6.09C6.03,10.67 6,10.34 6,10C6,9.66 6.03,9.33 6.09,9M10.32,9H13.68C13.72,9.33 13.75,9.66 13.75,10C13.75,10.34 13.72,10.67 13.68,11H10.32C10.28,10.67 10.25,10.34 10.25,10C10.25,9.66 10.28,9.33 10.32,9M15.68,9H17.91C17.97,9.33 18,9.66 18,10C18,10.34 17.97,10.67 17.91,11H15.68C15.72,10.67 15.75,10.34 15.75,10C15.75,9.66 15.72,9.33 15.68,9M6.81,13H8.74C9.09,14.16 9.5,15.07 9.77,15.56C8.5,15.06 7.5,14.16 6.81,13M10.74,13H13.26C12.74,14.72 12,16 12,16C12,16 11.26,14.72 10.74,13M15.26,13H17.19C16.5,14.16 15.5,15.07 14.23,15.57C14.5,15.07 14.91,14.16 15.26,13Z",
  },
  {
    id: "42C06A23-81D5-4EF6-8CFA-B4FBF66E7B17",
    name: "washing-machine",
    codepoint: "F729",
    aliases: ["laundrette", "local-laundry-service"],
    tags: ["Home Automation"],
    author: "Google",
    version: "1.8.36",
    path: "M14.83,11.17C16.39,12.73 16.39,15.27 14.83,16.83C13.27,18.39 10.73,18.39 9.17,16.83L14.83,11.17M6,2H18C19.1,2 20,2.9 20,4V20C20,21.1 19.1,22 18,22H6C4.9,22 4,21.1 4,20V4C4,2.9 4.9,2 6,2M7,4C6.45,4 6,4.45 6,5C6,5.55 6.45,6 7,6C7.55,6 8,5.55 8,5C8,4.45 7.55,4 7,4M10,4C9.45,4 9,4.45 9,5C9,5.55 9.45,6 10,6C10.55,6 11,5.55 11,5C11,4.45 10.55,4 10,4M12,8C8.69,8 6,10.69 6,14C6,17.31 8.69,20 12,20C15.31,20 18,17.31 18,14C18,10.69 15.31,8 12,8Z",
  },
  {
    id: "3389F6CD-3E46-47DE-B26A-341C1B65D6BF",
    name: "watch",
    codepoint: "F589",
    aliases: [],
    tags: ["Device / Tech"],
    author: "Google",
    version: "1.5.54",
    path: "M6,12C6,8.69 8.69,6 12,6C15.31,6 18,8.69 18,12C18,15.31 15.31,18 12,18C8.69,18 6,15.31 6,12M20,12C20,9.45 18.81,7.19 16.95,5.73L16,0H8L7.05,5.73C5.19,7.19 4,9.45 4,12C4,14.54 5.19,16.81 7.05,18.27L8,24H16L16.95,18.27C18.81,16.81 20,14.54 20,12Z",
  },
  {
    id: "4FAFD079-50D1-4FD3-9427-CF0C08148D84",
    name: "watch-export",
    codepoint: "F58A",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M14,11H19L16.5,8.5L17.92,7.08L22.84,12L17.92,16.92L16.5,15.5L19,13H14V11M12,18C8.69,18 6,15.31 6,12C6,8.69 8.69,6 12,6C13.4,6 14.69,6.5 15.71,7.29L17.13,5.87L16.95,5.73L16,0H8L7.05,5.73C5.19,7.19 4,9.46 4,12C4,14.55 5.19,16.81 7.05,18.27L8,24H16L16.95,18.27L17.13,18.13L15.71,16.71C14.69,17.5 13.4,18 12,18Z",
  },
  {
    id: "8213DABD-5CCB-415F-9457-A0A68B0F8179",
    name: "watch-export-variant",
    codepoint: "F894",
    aliases: [],
    tags: [],
    author: "Contributors",
    version: "2.1.99",
    path: "M14,11H19L16.5,8.5L17.92,7.08L22.84,12L17.92,16.92L16.5,15.5L19,13H14V11M8,0H16L16.83,5H17C17.28,5 17.54,5.06 17.78,5.16L15.94,7H7V17H15.94L17.78,18.84C17.54,18.94 17.28,19 17,19H16.83L16,24H8L7.17,19H7C5.9,19 5,18.1 5,17V7C5,5.89 5.9,5 7,5H7.17L8,0Z",
  },
  {
    id: "0D93B47F-C9F9-4C87-B63C-656184A87C74",
    name: "watch-import",
    codepoint: "F58B",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M2,11H7L4.5,8.5L5.92,7.08L10.84,12L5.92,16.92L4.5,15.5L7,13H2V11M12,18C15.31,18 18,15.31 18,12C18,8.69 15.31,6 12,6C10.6,6 9.31,6.5 8.29,7.29L6.87,5.87L7.05,5.73L8,0H16L16.95,5.73C18.81,7.19 20,9.45 20,12C20,14.54 18.81,16.81 16.95,18.27L16,24H8L7.05,18.27L6.87,18.13L8.29,16.71C9.31,17.5 10.6,18 12,18Z",
  },
  {
    id: "383F089B-340D-43BD-A64C-4F81B8DF2A1F",
    name: "watch-import-variant",
    codepoint: "F895",
    aliases: [],
    tags: [],
    author: "Contributors",
    version: "2.1.99",
    path: "M1,11H6L3.5,8.5L4.92,7.08L9.84,12L4.92,16.92L3.5,15.5L6,13H1V11M8,0H16L16.83,5H17C18.1,5 19,5.9 19,7V17C19,18.11 18.1,19 17,19H16.83L16,24H8L7.17,19H7C6.46,19 6,18.79 5.62,18.44L7.06,17H17V7H7.06L5.62,5.56C6,5.21 6.46,5 7,5H7.17L8,0Z",
  },
  {
    id: "B6ADE62B-5D0C-4D24-87F4-9D8A0F1C7A04",
    name: "watch-variant",
    codepoint: "F896",
    aliases: [],
    tags: ["Device / Tech"],
    author: "GreenTurtwig",
    version: "2.1.99",
    path: "M8,0L7.17,5H7C5.9,5 5,5.9 5,7V17C5,18.11 5.9,19 7,19H7.17L8,24H16L16.83,19H17C18.1,19 19,18.1 19,17V7C19,5.89 18.1,5 17,5H16.83L16,0H8M7,7H17V17H7V7Z",
  },
  {
    id: "AE556BFC-A1A0-4B42-9123-B48DC7A3CBF3",
    name: "watch-vibrate",
    codepoint: "F6B0",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "1.7.12",
    path: "M3,17V7H5V17H3M19,17V7H21V17H19M22,9H24V15H22V9M0,15V9H2V15H0M17.96,11.97C17.96,13.87 17.07,15.57 15.68,16.67L14.97,20.95H9L8.27,16.67C6.88,15.57 6,13.87 6,11.97C6,10.07 6.88,8.37 8.27,7.28L9,3H14.97L15.68,7.28C17.07,8.37 17.96,10.07 17.96,11.97M7.5,11.97C7.5,14.45 9.5,16.46 11.97,16.46C14.46,16.46 16.46,14.46 16.46,11.97C16.46,9.5 14.45,7.5 11.97,7.5C9.5,7.5 7.5,9.5 7.5,11.97Z",
  },
  {
    id: "17EEE663-92E4-4AB1-87FE-94F2CD296C4B",
    name: "water",
    codepoint: "F58C",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M12,20C8.69,20 6,17.31 6,14C6,10 12,3.25 12,3.25C12,3.25 18,10 18,14C18,17.31 15.31,20 12,20Z",
  },
  {
    id: "6C9777A0-967D-4242-91B2-E4D6B5596498",
    name: "water-off",
    codepoint: "F58D",
    aliases: ["format-color-reset"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M17.12,17.12L12.5,12.5L5.27,5.27L4,6.55L7.32,9.87C6.55,11.32 6,12.79 6,14C6,17.31 8.69,20 12,20C13.5,20 14.9,19.43 15.96,18.5L18.59,21.13L19.86,19.86L17.12,17.12M18,14C18,10 12,3.2 12,3.2C12,3.2 10.67,4.71 9.27,6.72L17.86,15.31C17.95,14.89 18,14.45 18,14Z",
  },
  {
    id: "2CE24A47-D798-4FFD-A53D-65FE9D452E2F",
    name: "water-percent",
    codepoint: "F58E",
    aliases: ["humidity"],
    tags: ["Weather", "Home Automation"],
    author: "Cody",
    version: "1.5.54",
    path: "M12,3.25C12,3.25 6,10 6,14C6,17.32 8.69,20 12,20C15.31,20 18,17.31 18,14C18,10 12,3.25 12,3.25M14.47,9.97L15.53,11.03L9.53,17.03L8.47,15.97M9.75,10C10.44,10 11,10.56 11,11.25C11,11.94 10.44,12.5 9.75,12.5C9.06,12.5 8.5,11.94 8.5,11.25C8.5,10.56 9.06,10 9.75,10M14.25,14.5C14.94,14.5 15.5,15.06 15.5,15.75C15.5,16.44 14.94,17 14.25,17C13.56,17 13,16.44 13,15.75C13,15.06 13.56,14.5 14.25,14.5Z",
  },
  {
    id: "06862D93-608A-4B21-9193-83FA8C6BBDCD",
    name: "water-pump",
    codepoint: "F58F",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M19,14.5C19,14.5 21,16.67 21,18C21,19.1 20.1,20 19,20C17.9,20 17,19.1 17,18C17,16.67 19,14.5 19,14.5M5,18V9C3.9,9 3,8.1 3,7C3,5.9 3.9,5 5,5V4C5,2.9 5.9,2 7,2H9C10.1,2 11,2.9 11,4V5H19C20.1,5 21,5.9 21,7V9L21,11C21.55,11 22,11.45 22,12C22,12.55 21.55,13 21,13H17C16.45,13 16,12.55 16,12C16,11.45 16.45,11 17,11V9H11V18H12C13.1,18 14,18.9 14,20V22H2V20C2,18.9 2.9,18 4,18H5Z",
  },
  {
    id: "20907A4A-11CA-447E-A4F5-D0F0901D197E",
    name: "watermark",
    codepoint: "F612",
    aliases: ["branding-watermark"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M21,3H3C1.9,3 1,3.9 1,5V19C1,20.1 1.9,21 3,21H21C22.1,21 23,20.1 23,19V5C23,3.9 22.1,3 21,3M21,19H12V13H21V19Z",
  },
  {
    id: "547979BF-6FF4-4CFF-BD55-1E5793C9DAA3",
    name: "waves",
    codepoint: "F78C",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.9.32",
    path: "M2,18C4.22,17 6.44,16 8.67,16C10.89,16 13.11,18 15.33,18C17.56,18 19.78,16 22,16V19C19.78,19 17.56,21 15.33,21C13.11,21 10.89,19 8.67,19C6.44,19 4.22,20 2,21V18M2,12C4.22,11 6.44,10 8.67,10C10.89,10 13.11,12 15.33,12C17.56,12 19.78,10 22,10V13C19.78,13 17.56,15 15.33,15C13.11,15 10.89,13 8.67,13C6.44,13 4.22,14 2,15V12M2,6C4.22,5 6.44,4 8.67,4C10.89,4 13.11,6 15.33,6C17.56,6 19.78,4 22,4V7C19.78,7 17.56,9 15.33,9C13.11,9 10.89,7 8.67,7C6.44,7 4.22,8 2,9V6Z",
  },
  {
    id: "9286B6B3-09EE-4465-9A70-D7874E26F3DF",
    name: "weather-cloudy",
    codepoint: "F590",
    aliases: [],
    tags: ["Weather"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M6,19C3.24,19 1,16.76 1,14C1,11.24 3.24,9 6,9C7,6.65 9.3,5 12,5C15.43,5 18.24,7.66 18.5,11.03L19,11C21.21,11 23,12.79 23,15C23,17.21 21.21,19 19,19H6M19,13H17V12C17,9.24 14.76,7 12,7C9.5,7 7.45,8.82 7.06,11.19C6.73,11.07 6.37,11 6,11C4.34,11 3,12.34 3,14C3,15.66 4.34,17 6,17H19C20.1,17 21,16.1 21,15C21,13.9 20.1,13 19,13Z",
  },
  {
    id: "9E1AC9CA-0FA4-44C6-BA5D-2EB3CED4899D",
    name: "weather-fog",
    codepoint: "F591",
    aliases: [],
    tags: ["Weather"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M3,15H13C13.55,15 14,15.45 14,16C14,16.55 13.55,17 13,17H3C2.45,17 2,16.55 2,16C2,15.45 2.45,15 3,15M16,15H21C21.55,15 22,15.45 22,16C22,16.55 21.55,17 21,17H16C15.45,17 15,16.55 15,16C15,15.45 15.45,15 16,15M1,12C1,9.24 3.24,7 6,7C7,4.65 9.3,3 12,3C15.43,3 18.24,5.66 18.5,9.03L19,9C21.19,9 22.97,10.76 23,13H21C21,11.9 20.1,11 19,11H17V10C17,7.24 14.76,5 12,5C9.5,5 7.45,6.82 7.06,9.19C6.73,9.07 6.37,9 6,9C4.34,9 3,10.34 3,12C3,12.35 3.06,12.69 3.17,13H1.1L1,12M3,19H5C5.55,19 6,19.45 6,20C6,20.55 5.55,21 5,21H3C2.45,21 2,20.55 2,20C2,19.45 2.45,19 3,19M8,19H21C21.55,19 22,19.45 22,20C22,20.55 21.55,21 21,21H8C7.45,21 7,20.55 7,20C7,19.45 7.45,19 8,19Z",
  },
  {
    id: "BED775CF-13BD-4D5A-A06F-7B026E820CB1",
    name: "weather-hail",
    codepoint: "F592",
    aliases: [],
    tags: ["Weather"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M6,14C6.55,14 7,14.45 7,15C7,15.55 6.55,16 6,16C3.24,16 1,13.76 1,11C1,8.24 3.24,6 6,6C7,3.65 9.3,2 12,2C15.43,2 18.24,4.66 18.5,8.03L19,8C21.21,8 23,9.79 23,12C23,14.21 21.21,16 19,16H18C17.45,16 17,15.55 17,15C17,14.45 17.45,14 18,14H19C20.1,14 21,13.1 21,12C21,10.9 20.1,10 19,10H17V9C17,6.24 14.76,4 12,4C9.5,4 7.45,5.82 7.06,8.19C6.73,8.07 6.37,8 6,8C4.34,8 3,9.34 3,11C3,12.66 4.34,14 6,14M10,18C11.1,18 12,18.9 12,20C12,21.1 11.1,22 10,22C8.9,22 8,21.1 8,20C8,18.9 8.9,18 10,18M14.5,16C15.33,16 16,16.67 16,17.5C16,18.33 15.33,19 14.5,19C13.67,19 13,18.33 13,17.5C13,16.67 13.67,16 14.5,16M10.5,12C11.33,12 12,12.67 12,13.5C12,14.33 11.33,15 10.5,15C9.67,15 9,14.33 9,13.5C9,12.67 9.67,12 10.5,12Z",
  },
  {
    id: "880967C4-85F9-4953-A6D0-73C9370BC987",
    name: "weather-hurricane",
    codepoint: "F897",
    aliases: [],
    tags: ["Weather"],
    author: "Michael Richins",
    version: "2.1.99",
    path: "M15,6.79C16.86,7.86 18,9.85 18,12C18,22 6,22 6,22C7.25,21.06 8.38,19.95 9.34,18.71C9.38,18.66 9.41,18.61 9.44,18.55C9.69,18.06 9.5,17.46 9,17.21C7.14,16.14 6,14.15 6,12C6,2 18,2 18,2C16.75,2.94 15.62,4.05 14.66,5.29C14.62,5.34 14.59,5.39 14.56,5.45C14.31,5.94 14.5,6.54 15,6.79M12,14C13.1,14 14,13.1 14,12C14,10.9 13.1,10 12,10C10.9,10 10,10.9 10,12C10,13.1 10.9,14 12,14Z",
  },
  {
    id: "6AF7BD8A-088F-4B07-806D-7456EB382D76",
    name: "weather-lightning",
    codepoint: "F593",
    aliases: [],
    tags: ["Weather"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M6,16C3.24,16 1,13.76 1,11C1,8.24 3.24,6 6,6C7,3.65 9.3,2 12,2C15.43,2 18.24,4.66 18.5,8.03L19,8C21.21,8 23,9.79 23,12C23,14.21 21.21,16 19,16H18C17.45,16 17,15.55 17,15C17,14.45 17.45,14 18,14H19C20.1,14 21,13.1 21,12C21,10.9 20.1,10 19,10H17V9C17,6.24 14.76,4 12,4C9.5,4 7.45,5.82 7.06,8.19C6.73,8.07 6.37,8 6,8C4.34,8 3,9.34 3,11C3,12.66 4.34,14 6,14H7C7.55,14 8,14.45 8,15C8,15.55 7.55,16 7,16H6M12,11H15L13,15H15L11.25,22L12,17H9.5L12,11Z",
  },
  {
    id: "F69033FD-E6F0-48E7-ADA7-7CDF71B1673C",
    name: "weather-lightning-rainy",
    codepoint: "F67D",
    aliases: [],
    tags: ["Weather"],
    author: "Austin Andrews",
    version: "1.7.12",
    path: "M4.5,13.59C5,13.87 5.14,14.5 4.87,14.96C4.59,15.44 4,15.6 3.5,15.33V15.33C2,14.47 1,12.85 1,11C1,8.24 3.24,6 6,6C7,3.65 9.3,2 12,2C15.43,2 18.24,4.66 18.5,8.03L19,8C21.21,8 23,9.79 23,12C23,14.21 21.21,16 19,16C18.45,16 18,15.55 18,15C18,14.45 18.45,14 19,14C20.1,14 21,13.1 21,12C21,10.9 20.1,10 19,10H17V9C17,6.24 14.76,4 12,4C9.5,4 7.45,5.82 7.06,8.19C6.73,8.07 6.37,8 6,8C4.34,8 3,9.34 3,11C3,12.11 3.6,13.08 4.5,13.6V13.59M9.5,11H12.5L10.5,15H12.5L8.75,22L9.5,17H7L9.5,11M17.5,18.67C17.5,19.96 16.5,21 15.25,21C14,21 13,19.96 13,18.67C13,17.12 15.25,14.5 15.25,14.5C15.25,14.5 17.5,17.12 17.5,18.67Z",
  },
  {
    id: "1C3BA3AB-E86E-481B-A3C2-867B37A6E55A",
    name: "weather-night",
    codepoint: "F594",
    aliases: ["moon-and-stars", "night-sky"],
    tags: ["Weather"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M17.75,4.09L15.22,6.03L16.13,9.09L13.5,7.28L10.87,9.09L11.78,6.03L9.25,4.09L12.44,4L13.5,1L14.56,4L17.75,4.09M21.25,11L19.61,12.25L20.2,14.23L18.5,13.06L16.8,14.23L17.39,12.25L15.75,11L17.81,10.95L18.5,9L19.19,10.95L21.25,11M18.97,15.95C19.8,15.87 20.69,17.05 20.16,17.8C19.84,18.25 19.5,18.67 19.08,19.07C15.17,23 8.84,23 4.94,19.07C1.03,15.17 1.03,8.83 4.94,4.93C5.34,4.53 5.76,4.17 6.21,3.85C6.96,3.32 8.14,4.21 8.06,5.04C7.79,7.9 8.75,10.87 10.95,13.06C13.14,15.26 16.1,16.22 18.97,15.95M17.33,17.97C14.5,17.81 11.7,16.64 9.53,14.5C7.36,12.31 6.2,9.5 6.04,6.68C3.23,9.82 3.34,14.64 6.35,17.66C9.37,20.67 14.19,20.78 17.33,17.97Z",
  },
  {
    id: "220955AA-770D-4884-A2ED-F21D2DC2CCDA",
    name: "weather-pouring",
    codepoint: "F596",
    aliases: [],
    tags: ["Weather"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M9,12C9.53,12.14 9.85,12.69 9.71,13.22L8.41,18.05C8.27,18.59 7.72,18.9 7.19,18.76C6.65,18.62 6.34,18.07 6.5,17.54L7.78,12.71C7.92,12.17 8.47,11.86 9,12M13,12C13.53,12.14 13.85,12.69 13.71,13.22L11.64,20.95C11.5,21.5 10.95,21.8 10.41,21.66C9.88,21.5 9.56,20.97 9.7,20.43L11.78,12.71C11.92,12.17 12.47,11.86 13,12M17,12C17.53,12.14 17.85,12.69 17.71,13.22L16.41,18.05C16.27,18.59 15.72,18.9 15.19,18.76C14.65,18.62 14.34,18.07 14.5,17.54L15.78,12.71C15.92,12.17 16.47,11.86 17,12M17,10V9C17,6.24 14.76,4 12,4C9.5,4 7.45,5.82 7.06,8.19C6.73,8.07 6.37,8 6,8C4.34,8 3,9.34 3,11C3,12.11 3.6,13.08 4.5,13.6V13.59C5,13.87 5.14,14.5 4.87,14.96C4.59,15.43 4,15.6 3.5,15.32V15.33C2,14.47 1,12.85 1,11C1,8.24 3.24,6 6,6C7,3.65 9.3,2 12,2C15.43,2 18.24,4.66 18.5,8.03L19,8C21.21,8 23,9.79 23,12C23,13.5 22.2,14.77 21,15.46V15.46C20.5,15.73 19.91,15.57 19.63,15.09C19.36,14.61 19.5,14 20,13.72V13.73C20.6,13.39 21,12.74 21,12C21,10.9 20.1,10 19,10H17Z",
  },
  {
    id: "45EF5E01-7499-4964-A897-5602F45A822E",
    name: "weather-rainy",
    codepoint: "F597",
    aliases: [],
    tags: ["Weather"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M6,14C6.55,14 7,14.45 7,15C7,15.55 6.55,16 6,16C3.24,16 1,13.76 1,11C1,8.24 3.24,6 6,6C7,3.65 9.3,2 12,2C15.43,2 18.24,4.66 18.5,8.03L19,8C21.21,8 23,9.79 23,12C23,14.21 21.21,16 19,16H18C17.45,16 17,15.55 17,15C17,14.45 17.45,14 18,14H19C20.1,14 21,13.1 21,12C21,10.9 20.1,10 19,10H17V9C17,6.24 14.76,4 12,4C9.5,4 7.45,5.82 7.06,8.19C6.73,8.07 6.37,8 6,8C4.34,8 3,9.34 3,11C3,12.66 4.34,14 6,14M14.83,15.67C16.39,17.23 16.39,19.5 14.83,21.08C14.05,21.86 13,22 12,22C11,22 9.95,21.86 9.17,21.08C7.61,19.5 7.61,17.23 9.17,15.67L12,11L14.83,15.67M13.41,16.69L12,14.25L10.59,16.69C9.8,17.5 9.8,18.7 10.59,19.5C11,19.93 11.5,20 12,20C12.5,20 13,19.93 13.41,19.5C14.2,18.7 14.2,17.5 13.41,16.69Z",
  },
  {
    id: "88999373-43C5-4851-BBCF-5335D8DFBDA0",
    name: "weather-snowy",
    codepoint: "F598",
    aliases: [],
    tags: ["Weather"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M6,14C6.55,14 7,14.45 7,15C7,15.55 6.55,16 6,16C3.24,16 1,13.76 1,11C1,8.24 3.24,6 6,6C7,3.65 9.3,2 12,2C15.43,2 18.24,4.66 18.5,8.03L19,8C21.21,8 23,9.79 23,12C23,14.21 21.21,16 19,16H18C17.45,16 17,15.55 17,15C17,14.45 17.45,14 18,14H19C20.1,14 21,13.1 21,12C21,10.9 20.1,10 19,10H17V9C17,6.24 14.76,4 12,4C9.5,4 7.45,5.82 7.06,8.19C6.73,8.07 6.37,8 6,8C4.34,8 3,9.34 3,11C3,12.66 4.34,14 6,14M7.88,18.07L10.07,17.5L8.46,15.88C8.07,15.5 8.07,14.86 8.46,14.46C8.85,14.07 9.5,14.07 9.88,14.46L11.5,16.07L12.07,13.88C12.21,13.34 12.76,13.03 13.29,13.17C13.83,13.31 14.14,13.86 14,14.4L13.41,16.59L15.6,16C16.14,15.86 16.69,16.17 16.83,16.71C16.97,17.24 16.66,17.79 16.12,17.93L13.93,18.5L15.54,20.12C15.93,20.5 15.93,21.15 15.54,21.54C15.15,21.93 14.5,21.93 14.12,21.54L12.5,19.93L11.93,22.12C11.79,22.66 11.24,22.97 10.71,22.83C10.17,22.69 9.86,22.14 10,21.6L10.59,19.41L8.4,20C7.86,20.14 7.31,19.83 7.17,19.29C7.03,18.76 7.34,18.21 7.88,18.07Z",
  },
  {
    id: "0938BCD1-BCF8-4439-B6B3-A590150878BC",
    name: "weather-snowy-rainy",
    codepoint: "F67E",
    aliases: [],
    tags: ["Weather"],
    author: "Austin Andrews",
    version: "1.7.12",
    path: "M18.5,18.67C18.5,19.96 17.5,21 16.25,21C15,21 14,19.96 14,18.67C14,17.12 16.25,14.5 16.25,14.5C16.25,14.5 18.5,17.12 18.5,18.67M4,17.36C3.86,16.82 4.18,16.25 4.73,16.11L7,15.5L5.33,13.86C4.93,13.46 4.93,12.81 5.33,12.4C5.73,12 6.4,12 6.79,12.4L8.45,14.05L9.04,11.8C9.18,11.24 9.75,10.92 10.29,11.07C10.85,11.21 11.17,11.78 11,12.33L10.42,14.58L12.67,14C13.22,13.83 13.79,14.15 13.93,14.71C14.08,15.25 13.76,15.82 13.2,15.96L10.95,16.55L12.6,18.21C13,18.6 13,19.27 12.6,19.67C12.2,20.07 11.54,20.07 11.15,19.67L9.5,18L8.89,20.27C8.75,20.83 8.18,21.14 7.64,21C7.08,20.86 6.77,20.29 6.91,19.74L7.5,17.5L5.26,18.09C4.71,18.23 4.14,17.92 4,17.36M1,11C1,8.24 3.24,6 6,6C7,3.65 9.3,2 12,2C15.43,2 18.24,4.66 18.5,8.03L19,8C21.21,8 23,9.79 23,12C23,14.21 21.21,16 19,16C18.45,16 18,15.55 18,15C18,14.45 18.45,14 19,14C20.1,14 21,13.1 21,12C21,10.9 20.1,10 19,10H17V9C17,6.24 14.76,4 12,4C9.5,4 7.45,5.82 7.06,8.19C6.73,8.07 6.37,8 6,8C4.34,8 3,9.34 3,11C3,11.85 3.35,12.61 3.91,13.16C4.27,13.55 4.26,14.16 3.88,14.54C3.5,14.93 2.85,14.93 2.47,14.54C1.56,13.63 1,12.38 1,11Z",
  },
  {
    id: "7F85265E-304C-4575-A73F-F0FCF0CA951B",
    name: "weather-sunny",
    codepoint: "F599",
    aliases: [],
    tags: ["Weather"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,7C14.76,7 17,9.24 17,12C17,14.76 14.76,17 12,17C9.24,17 7,14.76 7,12C7,9.24 9.24,7 12,7M12,9C10.34,9 9,10.34 9,12C9,13.66 10.34,15 12,15C13.66,15 15,13.66 15,12C15,10.34 13.66,9 12,9M12,2L14.39,5.42C13.65,5.15 12.84,5 12,5C11.16,5 10.35,5.15 9.61,5.42L12,2M3.34,7L7.5,6.65C6.9,7.16 6.36,7.78 5.94,8.5C5.5,9.24 5.25,10 5.11,10.79L3.34,7M3.36,17L5.12,13.23C5.26,14 5.53,14.78 5.95,15.5C6.37,16.24 6.91,16.86 7.5,17.37L3.36,17M20.65,7L18.88,10.79C18.74,10 18.47,9.23 18.05,8.5C17.63,7.78 17.1,7.15 16.5,6.64L20.65,7M20.64,17L16.5,17.36C17.09,16.85 17.62,16.22 18.04,15.5C18.46,14.77 18.73,14 18.87,13.21L20.64,17M12,22L9.59,18.56C10.33,18.83 11.14,19 12,19C12.82,19 13.63,18.83 14.37,18.56L12,22Z",
  },
  {
    id: "5EF29669-A342-46D1-AE1B-47917E44311D",
    name: "weather-sunset",
    codepoint: "F59A",
    aliases: [],
    tags: ["Weather"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M3,12H7C7,9.24 9.24,7 12,7C14.76,7 17,9.24 17,12H21C21.55,12 22,12.45 22,13C22,13.55 21.55,14 21,14H3C2.45,14 2,13.55 2,13C2,12.45 2.45,12 3,12M5,16H19C19.55,16 20,16.45 20,17C20,17.55 19.55,18 19,18H5C4.45,18 4,17.55 4,17C4,16.45 4.45,16 5,16M17,20C17.55,20 18,20.45 18,21C18,21.55 17.55,22 17,22H7C6.45,22 6,21.55 6,21C6,20.45 6.45,20 7,20H17M15,12C15,10.34 13.66,9 12,9C10.34,9 9,10.34 9,12H15M12,2L14.39,5.42C13.65,5.15 12.84,5 12,5C11.16,5 10.35,5.15 9.61,5.42L12,2M3.34,7L7.5,6.65C6.9,7.16 6.36,7.78 5.94,8.5C5.5,9.24 5.25,10 5.11,10.79L3.34,7M20.65,7L18.88,10.79C18.74,10 18.47,9.23 18.05,8.5C17.63,7.78 17.1,7.15 16.5,6.64L20.65,7Z",
  },
  {
    id: "032B7D10-9218-4B71-B190-C486832BEF61",
    name: "weather-sunset-down",
    codepoint: "F59B",
    aliases: [],
    tags: ["Weather"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M3,12H7C7,9.24 9.24,7 12,7C14.76,7 17,9.24 17,12H21C21.55,12 22,12.45 22,13C22,13.55 21.55,14 21,14H3C2.45,14 2,13.55 2,13C2,12.45 2.45,12 3,12M15,12C15,10.34 13.66,9 12,9C10.34,9 9,10.34 9,12H15M12,2L14.39,5.42C13.65,5.15 12.84,5 12,5C11.16,5 10.35,5.15 9.61,5.42L12,2M3.34,7L7.5,6.65C6.9,7.16 6.36,7.78 5.94,8.5C5.5,9.24 5.25,10 5.11,10.79L3.34,7M20.65,7L18.88,10.79C18.74,10 18.47,9.23 18.05,8.5C17.63,7.78 17.1,7.15 16.5,6.64L20.65,7M12.71,20.71L15.82,17.6C16.21,17.21 16.21,16.57 15.82,16.18C15.43,15.79 14.8,15.79 14.41,16.18L12,18.59L9.59,16.18C9.2,15.79 8.57,15.79 8.18,16.18C7.79,16.57 7.79,17.21 8.18,17.6L11.29,20.71C11.5,20.9 11.74,21 12,21C12.26,21 12.5,20.9 12.71,20.71Z",
  },
  {
    id: "AC82F126-0773-44CE-A004-77E7DDD130C9",
    name: "weather-sunset-up",
    codepoint: "F59C",
    aliases: [],
    tags: ["Weather"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M3,12H7C7,9.24 9.24,7 12,7C14.76,7 17,9.24 17,12H21C21.55,12 22,12.45 22,13C22,13.55 21.55,14 21,14H3C2.45,14 2,13.55 2,13C2,12.45 2.45,12 3,12M15,12C15,10.34 13.66,9 12,9C10.34,9 9,10.34 9,12H15M12,2L14.39,5.42C13.65,5.15 12.84,5 12,5C11.16,5 10.35,5.15 9.61,5.42L12,2M3.34,7L7.5,6.65C6.9,7.16 6.36,7.78 5.94,8.5C5.5,9.24 5.25,10 5.11,10.79L3.34,7M20.65,7L18.88,10.79C18.74,10 18.47,9.23 18.05,8.5C17.63,7.78 17.1,7.15 16.5,6.64L20.65,7M12.71,16.3L15.82,19.41C16.21,19.8 16.21,20.43 15.82,20.82C15.43,21.21 14.8,21.21 14.41,20.82L12,18.41L9.59,20.82C9.2,21.21 8.57,21.21 8.18,20.82C7.79,20.43 7.79,19.8 8.18,19.41L11.29,16.3C11.5,16.1 11.74,16 12,16C12.26,16 12.5,16.1 12.71,16.3Z",
  },
  {
    id: "7544E7E7-02F7-405C-9ADB-2E2540B07343",
    name: "weather-windy",
    codepoint: "F59D",
    aliases: [],
    tags: ["Weather"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M4,10C3.45,10 3,9.55 3,9C3,8.45 3.45,8 4,8H12C13.1,8 14,7.1 14,6C14,4.9 13.1,4 12,4C11.45,4 10.95,4.22 10.59,4.59C10.2,5 9.56,5 9.17,4.59C8.78,4.2 8.78,3.56 9.17,3.17C9.9,2.45 10.9,2 12,2C14.21,2 16,3.79 16,6C16,8.21 14.21,10 12,10H4M19,12C19.55,12 20,11.55 20,11C20,10.45 19.55,10 19,10C18.72,10 18.47,10.11 18.29,10.29C17.9,10.68 17.27,10.68 16.88,10.29C16.5,9.9 16.5,9.27 16.88,8.88C17.42,8.34 18.17,8 19,8C20.66,8 22,9.34 22,11C22,12.66 20.66,14 19,14H5C4.45,14 4,13.55 4,13C4,12.45 4.45,12 5,12H19M18,18H4C3.45,18 3,17.55 3,17C3,16.45 3.45,16 4,16H18C19.66,16 21,17.34 21,19C21,20.66 19.66,22 18,22C17.17,22 16.42,21.66 15.88,21.12C15.5,20.73 15.5,20.1 15.88,19.71C16.27,19.32 16.9,19.32 17.29,19.71C17.47,19.89 17.72,20 18,20C18.55,20 19,19.55 19,19C19,18.45 18.55,18 18,18Z",
  },
  {
    id: "454DE99F-BA48-4A7B-A2C6-C0E162065D10",
    name: "weather-windy-variant",
    codepoint: "F59E",
    aliases: [],
    tags: ["Weather"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M6,6L6.69,6.06C7.32,3.72 9.46,2 12,2C15.04,2 17.5,4.46 17.5,7.5L17.42,8.45C17.88,8.16 18.42,8 19,8C20.66,8 22,9.34 22,11C22,12.66 20.66,14 19,14H6C3.79,14 2,12.21 2,10C2,7.79 3.79,6 6,6M6,8C4.9,8 4,8.9 4,10C4,11.1 4.9,12 6,12H19C19.55,12 20,11.55 20,11C20,10.45 19.55,10 19,10H15.5V7.5C15.5,5.57 13.93,4 12,4C10.07,4 8.5,5.57 8.5,7.5V8H6M18,18H4C3.45,18 3,17.55 3,17C3,16.45 3.45,16 4,16H18C19.66,16 21,17.34 21,19C21,20.66 19.66,22 18,22C17.17,22 16.42,21.66 15.88,21.12C15.5,20.73 15.5,20.1 15.88,19.71C16.27,19.32 16.9,19.32 17.29,19.71C17.47,19.89 17.72,20 18,20C18.55,20 19,19.55 19,19C19,18.45 18.55,18 18,18Z",
  },
  {
    id: "DA9C32CA-8C31-4462-B123-479169C31587",
    name: "web",
    codepoint: "F59F",
    aliases: ["language"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M16.36,14C16.44,13.34 16.5,12.68 16.5,12C16.5,11.32 16.44,10.66 16.36,10H19.74C19.9,10.64 20,11.31 20,12C20,12.69 19.9,13.36 19.74,14M14.59,19.56C15.19,18.45 15.65,17.25 15.97,16H18.92C17.96,17.65 16.43,18.93 14.59,19.56M14.34,14H9.66C9.56,13.34 9.5,12.68 9.5,12C9.5,11.32 9.56,10.65 9.66,10H14.34C14.43,10.65 14.5,11.32 14.5,12C14.5,12.68 14.43,13.34 14.34,14M12,19.96C11.17,18.76 10.5,17.43 10.09,16H13.91C13.5,17.43 12.83,18.76 12,19.96M8,8H5.08C6.03,6.34 7.57,5.06 9.4,4.44C8.8,5.55 8.35,6.75 8,8M5.08,16H8C8.35,17.25 8.8,18.45 9.4,19.56C7.57,18.93 6.03,17.65 5.08,16M4.26,14C4.1,13.36 4,12.69 4,12C4,11.31 4.1,10.64 4.26,10H7.64C7.56,10.66 7.5,11.32 7.5,12C7.5,12.68 7.56,13.34 7.64,14M12,4.03C12.83,5.23 13.5,6.57 13.91,8H10.09C10.5,6.57 11.17,5.23 12,4.03M18.92,8H15.97C15.65,6.75 15.19,5.55 14.59,4.44C16.43,5.07 17.96,6.34 18.92,8M12,2C6.47,2 2,6.5 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z",
  },
  {
    id: "03483AFB-9D53-4E10-B00C-1095C1873276",
    name: "webcam",
    codepoint: "F5A0",
    aliases: [],
    tags: ["Video / Movie", "Home Automation"],
    author: "Chris Litherland",
    version: "1.5.54",
    path: "M12,2C15.87,2 19,5.13 19,9C19,12.87 15.87,16 12,16C8.13,16 5,12.87 5,9C5,5.13 8.13,2 12,2M12,4C9.24,4 7,6.24 7,9C7,11.76 9.24,14 12,14C14.76,14 17,11.76 17,9C17,6.24 14.76,4 12,4M12,6C13.66,6 15,7.34 15,9C15,10.66 13.66,12 12,12C10.34,12 9,10.66 9,9C9,7.34 10.34,6 12,6M6,22C4.9,22 4,21.1 4,20C4,19.62 4.1,19.27 4.29,18.97L6.11,15.81C7.69,17.17 9.75,18 12,18C14.25,18 16.31,17.17 17.89,15.81L19.71,18.97C19.9,19.27 20,19.62 20,20C20,21.1 19.1,22 18,22H6Z",
  },
  {
    id: "5B415522-B2A4-4D34-BEE3-D81D607BBD0B",
    name: "webhook",
    codepoint: "F62F",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.6.50",
    path: "M10.46,19C9,21.07 6.15,21.59 4.09,20.15C2.04,18.71 1.56,15.84 3,13.75C3.87,12.5 5.21,11.83 6.58,11.77L6.63,13.2C5.72,13.27 4.84,13.74 4.27,14.56C3.27,16 3.58,17.94 4.95,18.91C6.33,19.87 8.26,19.5 9.26,18.07C9.57,17.62 9.75,17.13 9.82,16.63V15.62L15.4,15.58L15.47,15.47C16,14.55 17.15,14.23 18.05,14.75C18.95,15.27 19.26,16.43 18.73,17.35C18.2,18.26 17.04,18.58 16.14,18.06C15.73,17.83 15.44,17.46 15.31,17.04L11.24,17.06C11.13,17.73 10.87,18.38 10.46,19M17.74,11.86C20.27,12.17 22.07,14.44 21.76,16.93C21.45,19.43 19.15,21.2 16.62,20.89C15.13,20.71 13.9,19.86 13.19,18.68L14.43,17.96C14.92,18.73 15.75,19.28 16.75,19.41C18.5,19.62 20.05,18.43 20.26,16.76C20.47,15.09 19.23,13.56 17.5,13.35C16.96,13.29 16.44,13.36 15.97,13.53L15.12,13.97L12.54,9.2H12.32C11.26,9.16 10.44,8.29 10.47,7.25C10.5,6.21 11.4,5.4 12.45,5.44C13.5,5.5 14.33,6.35 14.3,7.39C14.28,7.83 14.11,8.23 13.84,8.54L15.74,12.05C16.36,11.85 17.04,11.78 17.74,11.86M8.25,9.14C7.25,6.79 8.31,4.1 10.62,3.12C12.94,2.14 15.62,3.25 16.62,5.6C17.21,6.97 17.09,8.47 16.42,9.67L15.18,8.95C15.6,8.14 15.67,7.15 15.27,6.22C14.59,4.62 12.78,3.85 11.23,4.5C9.67,5.16 8.97,7 9.65,8.6C9.93,9.26 10.4,9.77 10.97,10.11L11.36,10.32L8.29,15.31C8.32,15.36 8.36,15.42 8.39,15.5C8.88,16.41 8.54,17.56 7.62,18.05C6.71,18.54 5.56,18.18 5.06,17.24C4.57,16.31 4.91,15.16 5.83,14.67C6.22,14.46 6.65,14.41 7.06,14.5L9.37,10.73C8.9,10.3 8.5,9.76 8.25,9.14Z",
  },
  {
    id: "65235220-D361-4E99-BEC6-E62B231E4384",
    name: "webpack",
    codepoint: "F72A",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.8.36",
    path: "M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5M12,4.15L5,8.09V15.91L12,19.85L19,15.91V8.09L12,4.15M12,6.23L16.9,9.06L12,11.89L7.1,9.06L12,6.23M17,14.89L13,17.2V13.62L17,11.31V14.89M11,17.2L7,14.89V11.31L11,13.62V17.2Z",
  },
  {
    id: "31CBB823-2223-40D5-BCF7-470F91159757",
    name: "wechat",
    codepoint: "F611",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Christopher Schreiner",
    version: "1.5.54",
    path: "M9.5,4C5.36,4 2,6.69 2,10C2,11.89 3.08,13.56 4.78,14.66L4,17L6.5,15.5C7.39,15.81 8.37,16 9.41,16C9.15,15.37 9,14.7 9,14C9,10.69 12.13,8 16,8C16.19,8 16.38,8 16.56,8.03C15.54,5.69 12.78,4 9.5,4M6.5,6.5C7.05,6.5 7.5,6.95 7.5,7.5C7.5,8.05 7.05,8.5 6.5,8.5C5.95,8.5 5.5,8.05 5.5,7.5C5.5,6.95 5.95,6.5 6.5,6.5M11.5,6.5C12.05,6.5 12.5,6.95 12.5,7.5C12.5,8.05 12.05,8.5 11.5,8.5C10.95,8.5 10.5,8.05 10.5,7.5C10.5,6.95 10.95,6.5 11.5,6.5M16,9C12.69,9 10,11.24 10,14C10,16.76 12.69,19 16,19C16.67,19 17.31,18.92 17.91,18.75L20,20L19.38,18.13C20.95,17.22 22,15.71 22,14C22,11.24 19.31,9 16,9M14,11.5C14.55,11.5 15,11.95 15,12.5C15,13.05 14.55,13.5 14,13.5C13.45,13.5 13,13.05 13,12.5C13,11.95 13.45,11.5 14,11.5M18,11.5C18.55,11.5 19,11.95 19,12.5C19,13.05 18.55,13.5 18,13.5C17.45,13.5 17,13.05 17,12.5C17,11.95 17.45,11.5 18,11.5Z",
  },
  {
    id: "F5DECC39-2E4C-4574-B141-832DFBA8CB43",
    name: "weight",
    codepoint: "F5A1",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,3C14.21,3 16,4.79 16,7C16,7.73 15.81,8.41 15.46,9H18C18.95,9 19.75,9.67 19.95,10.56C21.96,18.57 22,18.78 22,19C22,20.1 21.1,21 20,21H4C2.9,21 2,20.1 2,19C2,18.78 2.04,18.57 4.05,10.56C4.25,9.67 5.05,9 6,9H8.54C8.19,8.41 8,7.73 8,7C8,4.79 9.79,3 12,3M12,5C10.9,5 10,5.9 10,7C10,8.1 10.9,9 12,9C13.1,9 14,8.1 14,7C14,5.9 13.1,5 12,5Z",
  },
  {
    id: "5EDFF36D-4C8E-4B8D-BE3F-76C27DB804DF",
    name: "weight-kilogram",
    codepoint: "F5A2",
    aliases: ["weight-kg"],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,3C14.21,3 16,4.79 16,7C16,7.73 15.81,8.41 15.46,9H18C18.95,9 19.75,9.67 19.95,10.56C21.96,18.57 22,18.78 22,19C22,20.1 21.1,21 20,21H4C2.9,21 2,20.1 2,19C2,18.78 2.04,18.57 4.05,10.56C4.25,9.67 5.05,9 6,9H8.54C8.19,8.41 8,7.73 8,7C8,4.79 9.79,3 12,3M12,5C10.9,5 10,5.9 10,7C10,8.1 10.9,9 12,9C13.1,9 14,8.1 14,7C14,5.9 13.1,5 12,5M6,11V19H8V16.5L9,17.5V19H11V17L9,15L11,13V11H9V12.5L8,13.5V11H6M15,11C13.89,11 13,11.89 13,13V17C13,18.11 13.89,19 15,19H18V14H16V17H15V13H18V11H15Z",
  },
  {
    id: "47B5C7D8-105F-4420-B911-50693081EA76",
    name: "weight-pound",
    codepoint: "F9B4",
    aliases: ["weight-lb"],
    tags: [],
    author: "JapanYoshi",
    version: "2.4.85",
    path: "M12,3C14.21,3 16,4.79 16,7C16,7.73 15.81,8.41 15.46,9H18C18.95,9 19.75,9.67 19.95,10.56C21.96,18.57 22,18.78 22,19C22,20.1 21.1,21 20,21H4C2.9,21 2,20.1 2,19C2,18.78 2.04,18.57 4.05,10.56C4.25,9.67 5.05,9 6,9H8.54C8.19,8.41 8,7.73 8,7C8,4.79 9.79,3 12,3M12,5C10.9,5 10,5.9 10,7C10,8.1 10.9,9 12,9C13.1,9 14,8.1 14,7C14,5.9 13.1,5 12,5M6,11V19H11V17H8V11H6M13,11V19H16C17.11,19 18,18.11 18,17V16.5C18,15.93 17.75,15.38 17.32,15C17.75,14.62 18,14.07 18,13.5V13C18,11.89 17.11,11 16,11H13M15,13H16V14H15V13M15,16H16V17H15V16Z",
  },
  {
    id: "C58497CE-5E84-483C-9C85-3007ADF9BC9A",
    name: "whatsapp",
    codepoint: "F5A3",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M16.75,13.96C17,14.09 17.16,14.16 17.21,14.26C17.27,14.37 17.25,14.87 17,15.44C16.8,16 15.76,16.54 15.3,16.56C14.84,16.58 14.83,16.92 12.34,15.83C9.85,14.74 8.35,12.08 8.23,11.91C8.11,11.74 7.27,10.53 7.31,9.3C7.36,8.08 8,7.5 8.26,7.26C8.5,7 8.77,6.97 8.94,7H9.41C9.56,7 9.77,6.94 9.96,7.45L10.65,9.32C10.71,9.45 10.75,9.6 10.66,9.76L10.39,10.17L10,10.59C9.88,10.71 9.74,10.84 9.88,11.09C10,11.35 10.5,12.18 11.2,12.87C12.11,13.75 12.91,14.04 13.15,14.17C13.39,14.31 13.54,14.29 13.69,14.13L14.5,13.19C14.69,12.94 14.85,13 15.08,13.08L16.75,13.96M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C10.03,22 8.2,21.43 6.65,20.45L2,22L3.55,17.35C2.57,15.8 2,13.97 2,12C2,6.48 6.48,2 12,2M12,4C7.58,4 4,7.58 4,12C4,13.72 4.54,15.31 5.46,16.61L4.5,19.5L7.39,18.54C8.69,19.46 10.28,20 12,20C16.42,20 20,16.42 20,12C20,7.58 16.42,4 12,4Z",
  },
  {
    id: "FB4E1390-EFB1-4364-B6EE-F936C5715163",
    name: "wheelchair-accessibility",
    codepoint: "F5A4",
    aliases: ["accessible"],
    tags: [],
    author: "Doug C. Hardester",
    version: "1.5.54",
    path: "M18.4,11.2L14.3,11.4L16.6,8.8C16.8,8.5 16.9,8 16.8,7.5C16.7,7.2 16.6,6.9 16.3,6.7L10.9,3.5C10.5,3.2 9.9,3.3 9.5,3.6L6.8,6.1C6.3,6.6 6.2,7.3 6.7,7.8C7.1,8.3 7.9,8.3 8.4,7.9L10.4,6.1L12.3,7.2L8.1,11.5C8,11.6 8,11.7 7.9,11.7C7.4,11.9 6.9,12.1 6.5,12.4L8,13.9C8.5,13.7 9,13.5 9.5,13.5C11.4,13.5 13,15.1 13,17C13,17.6 12.9,18.1 12.6,18.5L14.1,20C14.7,19.1 15,18.1 15,17C15,15.8 14.6,14.6 13.9,13.7L17.2,13.4L17,18.2C16.9,18.9 17.4,19.4 18.1,19.5H18.2C18.8,19.5 19.3,19 19.4,18.4L19.6,12.5C19.6,12.2 19.5,11.8 19.3,11.6C19,11.3 18.7,11.2 18.4,11.2M18,5.5C19.1,5.5 20,4.6 20,3.5C20,2.4 19.1,1.5 18,1.5C16.9,1.5 16,2.4 16,3.5C16,4.6 16.9,5.5 18,5.5M12.5,21.6C11.6,22.2 10.6,22.5 9.5,22.5C6.5,22.5 4,20 4,17C4,15.9 4.3,14.9 4.9,14L6.4,15.5C6.2,16 6,16.5 6,17C6,18.9 7.6,20.5 9.5,20.5C10.1,20.5 10.6,20.4 11,20.1L12.5,21.6Z",
  },
  {
    id: "2DADA4F6-D9AD-454D-BC75-1D8DE507FA82",
    name: "whistle",
    codepoint: "F9B5",
    aliases: [],
    tags: [],
    author: "Michael Richins",
    version: "2.4.85",
    path: "M8.5,9C4.91,9 2,11.91 2,15.5C2,19.09 4.91,22 8.5,22C12.09,22 15,19.09 15,15.5V13.91L22,12V9H11V11H9V9H8.5M11,2V7H9V2H11M6.35,7.28C5.68,7.44 5.04,7.68 4.43,8L2.14,4.88L3.76,3.7L6.35,7.28M17.86,4.88L16.32,7H13.85L16.24,3.7L17.86,4.88Z",
  },
  {
    id: "2FE12EF0-B5CE-4ADB-9B1B-3F796F0EDE0E",
    name: "white-balance-auto",
    codepoint: "F5A5",
    aliases: ["wb-auto"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M10.3,16L9.6,14H6.4L5.7,16H3.8L7,7H9L12.2,16M22,7L20.8,13.29L19.3,7H17.7L16.21,13.29L15,7H14.24C12.77,5.17 10.5,4 8,4C3.58,4 0,7.58 0,12C0,16.42 3.58,20 8,20C11.13,20 13.84,18.19 15.15,15.57L15.25,16H17L18.5,9.9L20,16H21.75L23.8,7M6.85,12.65H9.15L8,9L6.85,12.65Z",
  },
  {
    id: "4464050A-1A97-46CF-BBA5-CE52D600CB45",
    name: "white-balance-incandescent",
    codepoint: "F5A6",
    aliases: ["wb-incandescent"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M17.24,18.15L19.04,19.95L20.45,18.53L18.66,16.74M20,12.5H23V10.5H20M15,6.31V1.5H9V6.31C7.21,7.35 6,9.28 6,11.5C6,14.81 8.69,17.5 12,17.5C15.31,17.5 18,14.81 18,11.5C18,9.28 16.79,7.35 15,6.31M4,10.5H1V12.5H4M11,22.45C11.32,22.45 13,22.45 13,22.45V19.5H11M3.55,18.53L4.96,19.95L6.76,18.15L5.34,16.74L3.55,18.53Z",
  },
  {
    id: "E88B06D9-C60D-4084-9AE9-742266F0E8FB",
    name: "white-balance-iridescent",
    codepoint: "F5A7",
    aliases: ["wb-iridescent"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M4.96,19.95L6.76,18.15L5.34,16.74L3.55,18.53M3.55,4.46L5.34,6.26L6.76,4.84L4.96,3.05M20.45,18.53L18.66,16.74L17.24,18.15L19.04,19.95M13,22.45V19.5H11V22.45C11.32,22.45 13,22.45 13,22.45M19.04,3.05L17.24,4.84L18.66,6.26L20.45,4.46M11,3.5H13V0.55H11M5,14.5H19V8.5H5V14.5Z",
  },
  {
    id: "7DCAB3C3-C32F-483D-98F1-1728919AA17B",
    name: "white-balance-sunny",
    codepoint: "F5A8",
    aliases: ["wb-sunny"],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M3.55,18.54L4.96,19.95L6.76,18.16L5.34,16.74M11,22.45C11.32,22.45 13,22.45 13,22.45V19.5H11M12,5.5C8.69,5.5 6,8.19 6,11.5C6,14.81 8.69,17.5 12,17.5C15.31,17.5 18,14.81 18,11.5C18,8.18 15.31,5.5 12,5.5M20,12.5H23V10.5H20M17.24,18.16L19.04,19.95L20.45,18.54L18.66,16.74M20.45,4.46L19.04,3.05L17.24,4.84L18.66,6.26M13,0.55H11V3.5H13M4,10.5H1V12.5H4M6.76,4.84L4.96,3.05L3.55,4.46L5.34,6.26L6.76,4.84Z",
  },
  {
    id: "419C0A49-C751-4204-8C82-7E43B0896BD9",
    name: "widgets",
    codepoint: "F72B",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.8.36",
    path: "M3,3H11V7.34L16.66,1.69L22.31,7.34L16.66,13H21V21H13V13H16.66L11,7.34V11H3V3M3,13H11V21H3V13Z",
  },
  {
    id: "E77CF681-7DD0-4EDF-AA35-0DB80790BC03",
    name: "wifi",
    codepoint: "F5A9",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12,21L15.6,16.2C14.6,15.45 13.35,15 12,15C10.65,15 9.4,15.45 8.4,16.2L12,21M12,3C7.95,3 4.21,4.34 1.2,6.6L3,9C5.5,7.12 8.62,6 12,6C15.38,6 18.5,7.12 21,9L22.8,6.6C19.79,4.34 16.05,3 12,3M12,9C9.3,9 6.81,9.89 4.8,11.4L6.6,13.8C8.1,12.67 9.97,12 12,12C14.03,12 15.9,12.67 17.4,13.8L19.2,11.4C17.19,9.89 14.7,9 12,9Z",
  },
  {
    id: "A7CAE187-B853-41DD-9D8D-FB9A28C3F764",
    name: "wifi-off",
    codepoint: "F5AA",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "1.5.54",
    path: "M2.28,3L1,4.27L2.47,5.74C2.04,6 1.61,6.29 1.2,6.6L3,9C3.53,8.6 4.08,8.25 4.66,7.93L6.89,10.16C6.15,10.5 5.44,10.91 4.8,11.4L6.6,13.8C7.38,13.22 8.26,12.77 9.2,12.47L11.75,15C10.5,15.07 9.34,15.5 8.4,16.2L12,21L14.46,17.73L17.74,21L19,19.72M12,3C9.85,3 7.8,3.38 5.9,4.07L8.29,6.47C9.5,6.16 10.72,6 12,6C15.38,6 18.5,7.11 21,9L22.8,6.6C19.79,4.34 16.06,3 12,3M12,9C11.62,9 11.25,9 10.88,9.05L14.07,12.25C15.29,12.53 16.43,13.07 17.4,13.8L19.2,11.4C17.2,9.89 14.7,9 12,9Z",
  },
  {
    id: "E4665C87-DB69-45CC-B922-1FCB0F0A54A3",
    name: "wifi-strength-1",
    codepoint: "F91E",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "2.3.50",
    path: "M12,3C7.79,3 3.7,4.41 0.38,7C4.41,12.06 7.89,16.37 12,21.5C16.08,16.42 20.24,11.24 23.65,7C20.32,4.41 16.22,3 12,3M12,5C15.07,5 18.09,5.86 20.71,7.45L15.61,13.81C14.5,13.28 13.25,13 12,13C10.75,13 9.5,13.28 8.39,13.8L3.27,7.44C5.91,5.85 8.93,5 12,5Z",
  },
  {
    id: "31F993F8-3BC0-4818-AE1C-91DF005766F3",
    name: "wifi-strength-1-alert",
    codepoint: "F91F",
    aliases: ["wifi-strength-1-warning"],
    tags: [],
    author: "Cody",
    version: "2.3.50",
    path: "M12,3C7.79,3 3.7,4.41 0.38,7C4.41,12.06 7.89,16.37 12,21.5C14.45,18.45 16.68,15.68 19,12.78V9.59L15.61,13.81C14.5,13.28 13.25,13 12,13C10.75,13 9.5,13.28 8.39,13.8L3.27,7.44C5.91,5.85 8.93,5 12,5C15.07,5 18.09,5.86 20.71,7.45L20.27,8H22.84C23.09,7.7 23.41,7.29 23.65,7C20.32,4.41 16.22,3 12,3M21,10V18H23V10M21,20V22H23V20",
  },
  {
    id: "035F0E2C-C952-40AB-BC29-B8CE120C389D",
    name: "wifi-strength-1-lock",
    codepoint: "F920",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "2.3.50",
    path: "M12,3C16.22,3 20.32,4.41 23.65,7L21.54,9.62L20.5,9.5C19.93,9.5 19.37,9.6 18.83,9.79L20.71,7.45C18.08,5.86 15.07,5 12,5C8.92,5 5.91,5.85 3.27,7.44L8.39,13.8C9.5,13.28 10.75,13 12,13C13.23,13 14.44,13.28 15.55,13.79L15.5,14.5V17.14L12,21.5L0.38,7C3.7,4.42 7.79,3 12,3M23,16C23.5,16 24,16.5 24,17V21C24,21.5 23.5,22 23,22H18C17.5,22 17,21.5 17,21V17C17,16.5 17.5,16 18,16V14.5C18,13.1 19.1,12 20.5,12C21.9,12 23,13.1 23,14.5V16M22,16V14.5C22,13.7 21.3,13 20.5,13C19.7,13 19,13.7 19,14.5V16H22Z",
  },
  {
    id: "92D075FB-99D3-4926-A4E9-F25EAB70E78E",
    name: "wifi-strength-2",
    codepoint: "F921",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "2.3.50",
    path: "M12,3C7.79,3 3.7,4.41 0.38,7C4.41,12.06 7.89,16.37 12,21.5C16.08,16.42 20.24,11.24 23.65,7C20.32,4.41 16.22,3 12,3M12,5C15.07,5 18.09,5.86 20.71,7.45L17.5,11.43C16.26,10.74 14.37,10 12,10C9.62,10 7.74,10.75 6.5,11.43L3.27,7.44C5.91,5.85 8.93,5 12,5Z",
  },
  {
    id: "38D73A8E-CEA5-4E6F-960B-BD2A0D482D9F",
    name: "wifi-strength-2-alert",
    codepoint: "F922",
    aliases: ["wifi-strength-2-warning"],
    tags: [],
    author: "Cody",
    version: "2.3.50",
    path: "M12,3C7.79,3 3.7,4.41 0.38,7C4.41,12.06 7.89,16.37 12,21.5C14.45,18.45 16.68,15.68 19,12.78V9.59L17.5,11.43C16.26,10.74 14.37,10 12,10C9.62,10 7.74,10.75 6.5,11.43L3.27,7.44C5.91,5.85 8.93,5 12,5C15.07,5 18.09,5.86 20.71,7.45L20.27,8H22.84C23.09,7.7 23.41,7.29 23.65,7C20.32,4.41 16.22,3 12,3M21,10V18H23V10M21,20V22H23V20",
  },
  {
    id: "CD7B760F-1A3C-4DDE-AB00-9EF11DF12073",
    name: "wifi-strength-2-lock",
    codepoint: "F923",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "2.3.50",
    path: "M12,3C7.79,3 3.7,4.42 0.38,7C4.42,12.06 7.89,16.37 12,21.5C13.23,19.97 14.29,18.66 15.5,17.14V14.5C15.5,13.24 16,12 16.84,11.1C15.62,10.53 14,10 12,10C9.62,10 7.74,10.75 6.5,11.43L3.27,7.44C5.91,5.85 8.92,5 12,5C15.07,5 18.08,5.86 20.71,7.45L18.83,9.79C19.37,9.6 19.93,9.5 20.5,9.5C20.85,9.5 21.2,9.54 21.54,9.62C22.2,8.8 23.03,7.76 23.65,7C20.32,4.41 16.22,3 12,3M20.5,12C19.1,12 18,13.1 18,14.5V16C17.5,16 17,16.5 17,17V21C17,21.5 17.5,22 18,22H23C23.5,22 24,21.5 24,21V17C24,16.5 23.5,16 23,16V14.5C23,13.1 21.9,12 20.5,12M20.5,13C21.3,13 22,13.7 22,14.5V16H19V14.5C19,13.7 19.7,13 20.5,13Z",
  },
  {
    id: "736B9B99-3A60-4BCA-A79A-40DE34D17F43",
    name: "wifi-strength-3",
    codepoint: "F924",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "2.3.50",
    path: "M12,3C7.79,3 3.7,4.41 0.38,7C4.41,12.06 7.89,16.37 12,21.5C16.08,16.42 20.24,11.24 23.65,7C20.32,4.41 16.22,3 12,3M12,5C15.07,5 18.09,5.86 20.71,7.45L18.77,9.88C17.26,9 14.88,8 12,8C9,8 6.68,9 5.21,9.84L3.27,7.44C5.91,5.85 8.93,5 12,5Z",
  },
  {
    id: "780617FD-FBFA-4F88-98CA-2DEA43409312",
    name: "wifi-strength-3-alert",
    codepoint: "F925",
    aliases: ["wifi-strength-3-warning"],
    tags: [],
    author: "Cody",
    version: "2.3.50",
    path: "M12,3C7.79,3 3.7,4.41 0.38,7C4.41,12.06 7.89,16.37 12,21.5C14.45,18.45 16.68,15.68 19,12.78V9.59L18.77,9.88C17.26,9 14.88,8 12,8C9,8 6.68,9 5.21,9.84L3.27,7.44C5.91,5.85 8.93,5 12,5C15.07,5 18.09,5.86 20.71,7.45L20.27,8H22.84C23.09,7.7 23.41,7.29 23.65,7C20.32,4.41 16.22,3 12,3M21,10V18H23V10M21,20V22H23V20",
  },
  {
    id: "CD4F72AA-B86D-4133-8EB8-145F457A1F06",
    name: "wifi-strength-3-lock",
    codepoint: "F926",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "2.3.50",
    path: "M12,3C7.79,3 3.7,4.42 0.38,7C4.42,12.06 7.89,16.37 12,21.5C13.23,19.97 14.29,18.66 15.5,17.14V14.5C15.5,12.44 16.77,10.59 18.69,9.84C17.19,8.96 14.84,8 12,8C9,8 6.68,9 5.2,9.84L3.27,7.44C5.91,5.85 8.92,5 12,5C15.07,5 18.08,5.86 20.71,7.45L18.84,9.79C19.37,9.6 19.93,9.5 20.5,9.5C20.85,9.5 21.2,9.54 21.54,9.62C22.2,8.8 23.03,7.76 23.65,7C20.32,4.41 16.22,3 12,3M20.5,12C19.1,12 18,13.1 18,14.5V16C17.5,16 17,16.5 17,17V21C17,21.5 17.5,22 18,22H23C23.5,22 24,21.5 24,21V17C24,16.5 23.5,16 23,16V14.5C23,13.1 21.9,12 20.5,12M20.5,13C21.3,13 22,13.7 22,14.5V16H19V14.5C19,13.7 19.7,13 20.5,13Z",
  },
  {
    id: "41B86B22-7245-4A97-9BAA-3E9EBD44CEB0",
    name: "wifi-strength-4",
    codepoint: "F927",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "2.3.50",
    path: "M12,3C7.79,3 3.7,4.41 0.38,7C4.41,12.06 7.89,16.37 12,21.5C16.08,16.42 20.24,11.24 23.65,7C20.32,4.41 16.22,3 12,3Z",
  },
  {
    id: "B37308A1-15BE-4F23-82F4-B360C8BA63C1",
    name: "wifi-strength-4-alert",
    codepoint: "F928",
    aliases: ["wifi-strength-4-warning"],
    tags: [],
    author: "Cody",
    version: "2.3.50",
    path: "M12,3C7.79,3 3.7,4.41 0.38,7C4.41,12.06 7.89,16.37 12,21.5C14.45,18.45 16.68,15.68 19,12.78V8H22.84C23.09,7.7 23.41,7.29 23.65,7C20.32,4.41 16.22,3 12,3M21,10V18H23V10M21,20V22H23V20",
  },
  {
    id: "11518A63-4E2B-477D-8D93-9B6C708DE5E1",
    name: "wifi-strength-4-lock",
    codepoint: "F929",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "2.3.50",
    path: "M12,3C7.79,3 3.7,4.42 0.38,7C4.42,12.06 7.89,16.37 12,21.5C13.23,19.97 14.29,18.66 15.5,17.14V14.5C15.5,11.74 17.74,9.5 20.5,9.5C20.85,9.5 21.2,9.54 21.54,9.62C22.2,8.8 23.03,7.76 23.65,7C20.32,4.41 16.22,3 12,3M20.5,12C19.1,12 18,13.1 18,14.5V16C17.5,16 17,16.5 17,17V21C17,21.5 17.5,22 18,22H23C23.5,22 24,21.5 24,21V17C24,16.5 23.5,16 23,16V14.5C23,13.1 21.9,12 20.5,12M20.5,13C21.3,13 22,13.7 22,14.5V16H19V14.5C19,13.7 19.7,13 20.5,13Z",
  },
  {
    id: "50E531C4-A82A-4F0C-A8BB-A2208B546E81",
    name: "wifi-strength-alert-outline",
    codepoint: "F92A",
    aliases: [
      "wifi-strength-warning-outline",
      "wifi-strength-0-alert",
      "wifi-strength-0-warning",
    ],
    tags: [],
    author: "Cody",
    version: "2.3.50",
    path: "M12,3C7.79,3 3.7,4.41 0.38,7H0.36C4.24,11.83 8.13,16.66 12,21.5C14.34,18.59 16.67,15.68 19,12.78V9.59L12,18.3L3.27,7.44C5.9,5.85 8.92,5 12,5C15.07,5 18.09,5.86 20.71,7.45L20.27,8H22.84C23.11,7.67 23.37,7.33 23.64,7H23.65C20.32,4.41 16.22,3 12,3M21,10V18H23V10M21,20V22H23V20",
  },
  {
    id: "718740BB-FC95-47E4-856B-0A469966C8DD",
    name: "wifi-strength-lock-outline",
    codepoint: "F92B",
    aliases: ["wifi-strength-0-lock"],
    tags: [],
    author: "Cody",
    version: "2.3.50",
    path: "M12,3C7.79,3 3.7,4.42 0.38,7C4.61,12.3 8.16,16.7 12,21.5C13.21,20 14.29,18.65 15.5,17.14V14.5C15.5,14.3 15.5,14.09 15.54,13.89L12,18.3L3.27,7.44C5.91,5.85 8.92,5 12,5C15.07,5 18.08,5.86 20.71,7.45L18.83,9.79C19.37,9.6 19.93,9.5 20.5,9.5C20.85,9.5 21.2,9.54 21.55,9.62C22.21,8.79 23,7.77 23.65,7C20.32,4.41 16.22,3 12,3M20.5,12C19.1,12 18,13.1 18,14.5V16C17.5,16 17,16.5 17,17V21C17,21.5 17.5,22 18,22H23C23.5,22 24,21.5 24,21V17C24,16.5 23.5,16 23,16V14.5C23,13.1 21.9,12 20.5,12M20.5,13C21.3,13 22,13.7 22,14.5V16H19V14.5C19,13.7 19.7,13 20.5,13Z",
  },
  {
    id: "122332EC-08DD-438C-BD47-AB332E1E04F6",
    name: "wifi-strength-off",
    codepoint: "F92C",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "2.3.50",
    path: "M3.27,1.44L2,2.72L4.05,4.77C2.75,5.37 1.5,6.11 0.38,7C4.41,12.06 12,21.5 12,21.5L15.91,16.63L19.23,19.95L20.5,18.68M12,3C10.6,3 9.21,3.17 7.86,3.5L18.18,13.81C20,11.5 22.05,9 23.65,7C20.32,4.41 16.22,3 12,3Z",
  },
  {
    id: "E4D2EA69-5F99-4D0B-BC12-BD22A2835B19",
    name: "wifi-strength-off-outline",
    codepoint: "F92D",
    aliases: [],
    tags: [],
    author: "Cody",
    version: "2.3.50",
    path: "M3.27,1.44L2,2.72L4.05,4.77C2.75,5.37 1.5,6.11 0.38,7C4.2,11.8 8.14,16.67 12,21.5L15.91,16.63L19.23,19.95L20.5,18.68C14.87,13.04 3.27,1.44 3.27,1.44M12,3C10.6,3 9.21,3.17 7.86,3.5L9.56,5.19C10.37,5.07 11.18,5 12,5C15.07,5 18.09,5.86 20.71,7.45L16.76,12.38L18.18,13.8C20.08,11.43 22,9 23.65,7C20.32,4.41 16.22,3 12,3M5.57,6.29L14.5,15.21L12,18.3L3.27,7.44C4,7 4.78,6.61 5.57,6.29Z",
  },
  {
    id: "0DAAFF13-5A8D-44C3-AE46-9DDE62493C60",
    name: "wifi-strength-outline",
    codepoint: "F92E",
    aliases: ["wifi-strength-0"],
    tags: [],
    author: "Cody",
    version: "2.3.50",
    path: "M12,3C7.79,3 3.7,4.41 0.38,7H0.36C4.24,11.83 8.13,16.66 12,21.5C15.89,16.66 19.77,11.83 23.64,7H23.65C20.32,4.41 16.22,3 12,3M12,5C15.07,5 18.09,5.86 20.71,7.45L12,18.3L3.27,7.44C5.9,5.85 8.92,5 12,5Z",
  },
  {
    id: "19DE621D-F082-42B5-9FD3-FEF8D84A2BB9",
    name: "wikipedia",
    codepoint: "F5AC",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M14.97,18.95L12.41,12.92C11.39,14.91 10.27,17 9.31,18.95C9.3,18.96 8.84,18.95 8.84,18.95C7.37,15.5 5.85,12.1 4.37,8.68C4.03,7.84 2.83,6.5 2,6.5C2,6.4 2,6.18 2,6.05H7.06V6.5C6.46,6.5 5.44,6.9 5.7,7.55C6.42,9.09 8.94,15.06 9.63,16.58C10.1,15.64 11.43,13.16 12,12.11C11.55,11.23 10.13,7.93 9.71,7.11C9.39,6.57 8.58,6.5 7.96,6.5C7.96,6.35 7.97,6.25 7.96,6.06L12.42,6.07V6.47C11.81,6.5 11.24,6.71 11.5,7.29C12.1,8.53 12.45,9.42 13,10.57C13.17,10.23 14.07,8.38 14.5,7.41C14.76,6.76 14.37,6.5 13.29,6.5C13.3,6.38 13.3,6.17 13.3,6.07C14.69,6.06 16.78,6.06 17.15,6.05V6.47C16.44,6.5 15.71,6.88 15.33,7.46L13.5,11.3C13.68,11.81 15.46,15.76 15.65,16.2L19.5,7.37C19.2,6.65 18.34,6.5 18,6.5C18,6.37 18,6.2 18,6.05L22,6.08V6.1L22,6.5C21.12,6.5 20.57,7 20.25,7.75C19.45,9.54 17,15.24 15.4,18.95C15.4,18.95 14.97,18.95 14.97,18.95Z",
  },
  {
    id: "0CB92EB7-2EE0-401C-9113-7D52E78DB51E",
    name: "window-close",
    codepoint: "F5AD",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M13.46,12L19,17.54V19H17.54L12,13.46L6.46,19H5V17.54L10.54,12L5,6.46V5H6.46L12,10.54L17.54,5H19V6.46L13.46,12Z",
  },
  {
    id: "42DDDE71-7AA4-4A61-98F5-2A3B0AD486FF",
    name: "window-closed",
    codepoint: "F5AE",
    aliases: [],
    tags: ["Home Automation"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M6,11H10V9H14V11H18V4H6V11M18,13H6V20H18V13M6,2H18C19.1,2 20,2.9 20,4V20C20,21.1 19.1,22 18,22H6C4.9,22 4,21.1 4,20V4C4,2.9 4.9,2 6,2Z",
  },
  {
    id: "AB365770-45CF-44AC-941E-8E1396FAF428",
    name: "window-maximize",
    codepoint: "F5AF",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M4,4H20V20H4V4M6,8V18H18V8H6Z",
  },
  {
    id: "C329F2CA-AC52-45CD-87D7-253AB115D47F",
    name: "window-minimize",
    codepoint: "F5B0",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M20,14H4V10H20",
  },
  {
    id: "5617DB90-FDD7-4909-B322-D1EC44EB1372",
    name: "window-open",
    codepoint: "F5B1",
    aliases: [],
    tags: ["Home Automation"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M6,8H10V6H14V8H18V4H6V8M18,10H6V15H18V10M6,20H18V17H6V20M6,2H18C19.1,2 20,2.9 20,4V20C20,21.1 19.1,22 18,22H6C4.9,22 4,21.1 4,20V4C4,2.9 4.9,2 6,2Z",
  },
  {
    id: "405C8463-0E67-48A3-B824-7C5E74423125",
    name: "window-restore",
    codepoint: "F5B2",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M4,8H8V4H20V16H16V20H4V8M16,8V14H18V6H10V8H16M6,12V18H14V12H6Z",
  },
  {
    id: "0059A2CA-E266-4A57-9EE8-4520B7330D5C",
    name: "wordpress",
    codepoint: "F5B4",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M3.42,12C3.42,10.76 3.69,9.58 4.16,8.5L8.26,19.72C5.39,18.33 3.42,15.4 3.42,12M17.79,11.57C17.79,12.3 17.5,13.15 17.14,14.34L16.28,17.2L13.18,8L14.16,7.9C14.63,7.84 14.57,7.16 14.11,7.19C14.11,7.19 12.72,7.3 11.82,7.3L9.56,7.19C9.1,7.16 9.05,7.87 9.5,7.9L10.41,8L11.75,11.64L9.87,17.27L6.74,8L7.73,7.9C8.19,7.84 8.13,7.16 7.67,7.19C7.67,7.19 6.28,7.3 5.38,7.3L4.83,7.29C6.37,4.96 9,3.42 12,3.42C14.23,3.42 16.27,4.28 17.79,5.67H17.68C16.84,5.67 16.24,6.4 16.24,7.19C16.24,7.9 16.65,8.5 17.08,9.2C17.41,9.77 17.79,10.5 17.79,11.57M12.15,12.75L14.79,19.97L14.85,20.09C13.96,20.41 13,20.58 12,20.58C11.16,20.58 10.35,20.46 9.58,20.23L12.15,12.75M19.53,7.88C20.2,9.11 20.58,10.5 20.58,12C20.58,15.16 18.86,17.93 16.31,19.41L18.93,11.84C19.42,10.62 19.59,9.64 19.59,8.77L19.53,7.88M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M12,21.54C17.26,21.54 21.54,17.26 21.54,12C21.54,6.74 17.26,2.46 12,2.46C6.74,2.46 2.46,6.74 2.46,12C2.46,17.26 6.74,21.54 12,21.54Z",
  },
  {
    id: "79D47101-F8CB-496B-99B0-957DADED5D44",
    name: "wrap",
    codepoint: "F5B6",
    aliases: [],
    tags: [],
    author: "Doug C. Hardester",
    version: "1.5.54",
    path: "M21,5H3V7H21V5M3,19H10V17H3V19M3,13H18C19,13 20,13.43 20,15C20,16.57 19,17 18,17H16V15L12,18L16,21V19H18C20.95,19 22,17.73 22,15C22,12.28 21,11 18,11H3V13Z",
  },
  {
    id: "CACAAE64-D38D-423E-8C84-68EFF0EA0F8A",
    name: "wrench",
    codepoint: "F5B7",
    aliases: ["build"],
    tags: ["Hardware / Tools"],
    author: "Google",
    version: "1.5.54",
    path: "M22.7,19L13.6,9.9C14.5,7.6 14,4.9 12.1,3C10.1,1 7.1,0.6 4.7,1.7L9,6L6,9L1.6,4.7C0.4,7.1 0.9,10.1 2.9,12.1C4.8,14 7.5,14.5 9.8,13.6L18.9,22.7C19.3,23.1 19.9,23.1 20.3,22.7L22.6,20.4C23.1,20 23.1,19.3 22.7,19Z",
  },
  {
    id: "958B8A8B-A4D7-45A4-8C80-39F7140443C0",
    name: "xamarin",
    codepoint: "F844",
    aliases: ["microsoft-xamarin"],
    tags: ["Brand / Logo"],
    author: "Augustin Ursu",
    version: "2.1.19",
    path: "M22.75,11.07C22.91,11.35 23,11.67 23,12C23,12.33 22.91,12.65 22.75,12.93L18.08,21C17.72,21.62 17.06,22 16.35,22H7.65C6.94,22 6.28,21.62 5.92,21L1.25,12.93C1.09,12.65 1,12.33 1,12C1,11.67 1.09,11.35 1.25,11.07L5.92,3C6.28,2.38 6.94,2 7.65,2H16.35C17.06,2 17.72,2.38 18.08,3L22.75,11.07M12,12V11.9L9.42,7.1L9.25,7H7.66L7.5,7.1V7.3L10,12L7.5,16.7V16.9L7.66,17H9.25L9.42,16.9L12,12.1V12L12.03,12.1L14.58,16.9L14.75,17H16.34L16.5,16.9V16.7L14,12L16.5,7.3V7.1L16.34,7H14.75L14.58,7.1L12.03,11.9L12,12Z",
  },
  {
    id: "7016027D-C32A-4462-A9E5-98132FA518B4",
    name: "xamarin-outline",
    codepoint: "F845",
    aliases: ["microsoft-xamarin-outline"],
    tags: ["Brand / Logo"],
    author: "Augustin Ursu",
    version: "2.1.19",
    path: "M12,12L12.03,11.9L14.58,7.1L14.75,7H16.34L16.5,7.1V7.3L14,12L16.5,16.7V16.9L16.34,17H14.75L14.58,16.9L12.03,12.1L12,12V12.1L9.42,16.9L9.25,17H7.66L7.5,16.9V16.7L10,12L7.5,7.3V7.1L7.66,7H9.25L9.42,7.1L12,11.9V12M22.75,11.07C22.91,11.35 23,11.67 23,12C23,12.33 22.91,12.65 22.75,12.93L18.08,21C17.72,21.62 17.06,22 16.35,22H7.65C6.94,22 6.28,21.62 5.92,21L1.25,12.93C1.09,12.65 1,12.33 1,12C1,11.67 1.09,11.35 1.25,11.07L5.92,3C6.28,2.38 6.94,2 7.65,2H16.35C17.06,2 17.72,2.38 18.08,3L22.75,11.07M20.8,11.25L16.97,4.8C16.68,4.3 16.14,4 15.56,4H8.44C7.86,4 7.32,4.3 7.03,4.8L3.2,11.25C3.07,11.5 3,11.74 3,12C3,12.26 3.07,12.5 3.2,12.75L7.03,19.2C7.32,19.7 7.86,20 8.44,20H15.56C16.14,20 16.68,19.7 16.97,19.2L20.8,12.75C20.93,12.5 21,12.26 21,12C21,11.74 20.93,11.5 20.8,11.25Z",
  },
  {
    id: "496476A3-F614-4925-90E6-3BB83C1C4E37",
    name: "xing",
    codepoint: "F5BD",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Cody",
    version: "1.5.54",
    path: "M17.67,2C17.24,2 17.05,2.27 16.9,2.55C16.9,2.55 10.68,13.57 10.5,13.93L14.58,21.45C14.72,21.71 14.94,22 15.38,22H18.26C18.44,22 18.57,21.93 18.64,21.82C18.72,21.69 18.72,21.53 18.64,21.37L14.57,13.92L20.96,2.63C21.04,2.47 21.04,2.31 20.97,2.18C20.89,2.07 20.76,2 20.58,2M5.55,5.95C5.38,5.95 5.23,6 5.16,6.13C5.08,6.26 5.09,6.41 5.18,6.57L7.12,9.97L4.06,15.37C4,15.53 4,15.69 4.06,15.82C4.13,15.94 4.26,16 4.43,16H7.32C7.75,16 7.96,15.72 8.11,15.45C8.11,15.45 11.1,10.16 11.22,9.95L9.24,6.5C9.1,6.24 8.88,5.95 8.43,5.95",
  },
  {
    id: "994C18D8-DAF1-4311-A30B-CD93F5ADC233",
    name: "xml",
    codepoint: "F5C0",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M12.89,3L14.85,3.4L11.11,21L9.15,20.6L12.89,3M19.59,12L16,8.41V5.58L22.42,12L16,18.41V15.58L19.59,12M1.58,12L8,5.58V8.41L4.41,12L8,15.58V18.41L1.58,12Z",
  },
  {
    id: "F2F74E7E-9EC8-4748-AF3B-A14D6158770D",
    name: "xmpp",
    codepoint: "F7FE",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Contributors",
    version: "2.0.46",
    path: "M12,15.4C9.75,13.09 8,9.54 8,6C2,4 8,6 2,4C2,9.65 6.33,14.11 10.55,16.66C9.38,17.5 8.15,18 7,18C7,19 7,18 7,19C8.2,19 10.03,18.46 12,17.46C13.97,18.46 15.8,19 17,19C17,18 17,19 17,18C15.85,18 14.62,17.5 13.45,16.66C17.66,14.11 22,9.65 22,4C16,6 22,4 16,6C16,9.54 14.25,13.09 12,15.4Z",
  },
  {
    id: "17C0DA66-AB24-4935-A928-26BE13FDC3C0",
    name: "yeast",
    codepoint: "F5C1",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.5.54",
    path: "M18,14C20.21,14 22,15.79 22,18C22,20.21 20.21,22 18,22C15.79,22 14,20.21 14,18L14.09,17.15C14.05,16.45 13.92,15.84 13.55,15.5C13.35,15.3 13.07,15.19 12.75,15.13C11.79,15.68 10.68,16 9.5,16C5.91,16 3,13.09 3,9.5C3,5.91 5.91,3 9.5,3C13.09,3 16,5.91 16,9.5C16,10.68 15.68,11.79 15.13,12.75C15.19,13.07 15.3,13.35 15.5,13.55C15.84,13.92 16.45,14.05 17.15,14.09L18,14M7.5,10C8.33,10 9,10.67 9,11.5C9,12.33 8.33,13 7.5,13C6.67,13 6,12.33 6,11.5C6,10.67 6.67,10 7.5,10M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z",
  },
  {
    id: "068670F6-B9DF-40C5-8C50-C9A3953F6201",
    name: "yin-yang",
    codepoint: "F67F",
    aliases: [],
    tags: [],
    author: "Austin Andrews",
    version: "1.7.12",
    path: "M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M12,4C7.58,4 4,7.58 4,12C4,16.42 7.58,20 12,20C9.79,20 8,18.21 8,16C8,13.79 9.79,12 12,12C14.21,12 16,10.21 16,8C16,5.79 14.21,4 12,4M12,6.5C12.83,6.5 13.5,7.17 13.5,8C13.5,8.83 12.83,9.5 12,9.5C11.17,9.5 10.5,8.83 10.5,8C10.5,7.17 11.17,6.5 12,6.5M12,14.5C11.17,14.5 10.5,15.17 10.5,16C10.5,16.83 11.17,17.5 12,17.5C12.83,17.5 13.5,16.83 13.5,16C13.5,15.17 12.83,14.5 12,14.5Z",
  },
  {
    id: "0A078909-90AF-41F5-8E76-CAB565D49AAA",
    name: "youtube",
    codepoint: "F5C3",
    aliases: ["video-youtube", "youtube-play"],
    tags: ["Brand / Logo", "Social Media"],
    author: "Google",
    version: "1.5.54",
    path: "M10,15L15.19,12L10,9V15M21.56,7.17C21.69,7.64 21.78,8.27 21.84,9.07C21.91,9.87 21.94,10.56 21.94,11.16L22,12C22,14.19 21.84,15.8 21.56,16.83C21.31,17.73 20.73,18.31 19.83,18.56C19.36,18.69 18.5,18.78 17.18,18.84C15.88,18.91 14.69,18.94 13.59,18.94L12,19C7.81,19 5.2,18.84 4.17,18.56C3.27,18.31 2.69,17.73 2.44,16.83C2.31,16.36 2.22,15.73 2.16,14.93C2.09,14.13 2.06,13.44 2.06,12.84L2,12C2,9.81 2.16,8.2 2.44,7.17C2.69,6.27 3.27,5.69 4.17,5.44C4.64,5.31 5.5,5.22 6.82,5.16C8.12,5.09 9.31,5.06 10.41,5.06L12,5C16.19,5 18.8,5.16 19.83,5.44C20.73,5.69 21.31,6.27 21.56,7.17Z",
  },
  {
    id: "9C80F67A-8A15-4109-BA37-7B92FE1F67DB",
    name: "youtube-gaming",
    codepoint: "F847",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Google",
    version: "2.1.19",
    path: "M6,3.54C5.81,3.54 5.63,3.62 5.46,3.71L0.55,6.5C0.21,6.7 0,7.06 0,7.45V13.68C0,14.07 0.21,14.43 0.55,14.63L11.46,20.83C11.63,20.92 11.81,21 12,21C12.19,21 12.37,20.92 12.54,20.83L23.45,14.63C23.79,14.44 24,14.08 24,13.69V7.45C24,7.06 23.79,6.7 23.45,6.5L18.54,3.71C18.37,3.62 18.19,3.54 18,3.54C17.81,3.54 17.63,3.62 17.46,3.71L12.54,6.5C12.21,6.7 11.8,6.7 11.46,6.5L6.54,3.71C6.37,3.62 6.19,3.54 6,3.54M18.14,4.09L23.46,7.09L18.14,10.23V4.09Z",
  },
  {
    id: "011BAC94-8FD5-4335-AFF3-120C04299E78",
    name: "youtube-tv",
    codepoint: "F448",
    aliases: [],
    tags: ["Brand / Logo"],
    author: "Google",
    version: "1.5.54",
    path: "M2.5,4.5H21.5C22.34,4.5 23,5.15 23,6V17.5C23,18.35 22.34,19 21.5,19H2.5C1.65,19 1,18.35 1,17.5V6C1,5.15 1.65,4.5 2.5,4.5M9.71,8.5V15L15.42,11.7L9.71,8.5M17.25,21H6.65C6.35,21 6.15,20.8 6.15,20.5C6.15,20.2 6.35,20 6.65,20H17.35C17.65,20 17.85,20.2 17.85,20.5C17.85,20.8 17.55,21 17.25,21Z",
  },
  {
    id: "00A83C35-A726-464B-ACEE-F0D690045C25",
    name: "zip-box",
    codepoint: "F5C4",
    aliases: [],
    tags: [],
    author: "Google",
    version: "1.5.54",
    path: "M14,17H12V15H10V13H12V15H14M14,9H12V11H14V13H12V11H10V9H12V7H10V5H12V7H14M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3Z",
  },
  {
    id: "775EA566-CF0B-473E-B43E-59319FC83D38",
    name: "zip-disk",
    codepoint: "FA22",
    aliases: [],
    tags: [],
    author: "GreenTurtwig",
    version: "2.5.94",
    path: "M7,3L3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5L17,3V5C17,5.55 16.55,6 16,6H10C9.45,6 9,5.55 9,5V3H7M8,10H16C16.55,10 17,10.45 17,11V19H7V11C7,10.45 7.45,10 8,10Z",
  },
];
